// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
[class^=ant-]::-ms-clear,
[class*= ant-]::-ms-clear,
[class^=ant-] input::-ms-clear,
[class*= ant-] input::-ms-clear,
[class^=ant-] input::-ms-reveal,
[class*= ant-] input::-ms-reveal {
  display: none;
}
/* stylelint-disable at-rule-no-unknown */
html,
body {
  width: 100%;
  height: 100%;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@-ms-viewport {
  width: device-width;
}
body {
  margin: 0;
  color: #495561;
  font-size: 15px;
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  font-variant: tabular-nums;
  line-height: 1.5;
  background-color: #eef1f4;
  font-feature-settings: 'tnum';
}
[tabindex='-1']:focus {
  outline: none !important;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: #323945;
  font-weight: 500;
}
p {
  margin-top: 0;
  margin-bottom: 1em;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  border-bottom: 0;
  cursor: help;
}
address {
  margin-bottom: 1em;
  font-style: normal;
  line-height: inherit;
}
input[type='text'],
input[type='password'],
input[type='number'],
textarea {
  -webkit-appearance: none;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1em;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 500;
}
dd {
  margin-bottom: 0.5em;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1em;
}
dfn {
  font-style: italic;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: #0e68f9;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: #388bff;
}
a:active {
  color: #024bd4;
}
a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}
a:focus {
  text-decoration: none;
  outline: 0;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
pre,
code,
kbd,
samp {
  font-size: 1em;
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
}
pre {
  margin-top: 0;
  margin-bottom: 1em;
  overflow: auto;
}
figure {
  margin: 0 0 1em;
}
img {
  vertical-align: middle;
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
a,
area,
button,
[role='button'],
input:not([type='range']),
label,
select,
summary,
textarea {
  touch-action: manipulation;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75em;
  padding-bottom: 0.3em;
  color: rgba(0, 0, 0, 0.45);
  text-align: left;
  caption-side: bottom;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type='radio'],
input[type='checkbox'] {
  box-sizing: border-box;
  padding: 0;
}
input[type='date'],
input[type='time'],
input[type='datetime-local'],
input[type='month'] {
  -webkit-appearance: listbox;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0.5em;
  padding: 0;
  color: inherit;
  font-size: 1.5em;
  line-height: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}
[type='search'] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
[type='search']::-webkit-search-cancel-button,
[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
mark {
  padding: 0.2em;
  background-color: #feffe6;
}
::selection {
  color: #fff;
  background: #0e68f9;
}
.clearfix::before {
  display: table;
  content: '';
}
.clearfix::after {
  display: table;
  clear: both;
  content: '';
}
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.anticon > * {
  line-height: 1;
}
.anticon svg {
  display: inline-block;
}
.anticon::before {
  display: none;
}
.anticon .anticon-icon {
  display: block;
}
.anticon[tabindex] {
  cursor: pointer;
}
.anticon-spin::before {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}
.anticon-spin {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}
.ant-fade-enter,
.ant-fade-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-fade-enter.ant-fade-enter-active,
.ant-fade-appear.ant-fade-appear-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}
.ant-fade-leave.ant-fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-fade-enter,
.ant-fade-appear {
  opacity: 0;
  animation-timing-function: linear;
}
.ant-fade-leave {
  animation-timing-function: linear;
}
@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ant-move-up-enter,
.ant-move-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-up-enter.ant-move-up-enter-active,
.ant-move-up-appear.ant-move-up-appear-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}
.ant-move-up-leave.ant-move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-up-enter,
.ant-move-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.ant-move-down-enter,
.ant-move-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-down-enter.ant-move-down-enter-active,
.ant-move-down-appear.ant-move-down-appear-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}
.ant-move-down-leave.ant-move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-down-enter,
.ant-move-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.ant-move-left-enter,
.ant-move-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-left-enter.ant-move-left-enter-active,
.ant-move-left-appear.ant-move-left-appear-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}
.ant-move-left-leave.ant-move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-left-enter,
.ant-move-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.ant-move-right-enter,
.ant-move-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-move-right-enter.ant-move-right-enter-active,
.ant-move-right-appear.ant-move-right-appear-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}
.ant-move-right-leave.ant-move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-move-right-enter,
.ant-move-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
@keyframes antMoveDownIn {
  0% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveDownOut {
  0% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateY(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveLeftIn {
  0% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveLeftOut {
  0% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveRightIn {
  0% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveRightOut {
  0% {
    transform: translateX(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes antMoveUpIn {
  0% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
}
@keyframes antMoveUpOut {
  0% {
    transform: translateY(0%);
    transform-origin: 0 0;
    opacity: 1;
  }
  100% {
    transform: translateY(-100%);
    transform-origin: 0 0;
    opacity: 0;
  }
}
@keyframes loadingCircle {
  100% {
    transform: rotate(360deg);
  }
}
[ant-click-animating='true'],
[ant-click-animating-without-extra-node='true'] {
  position: relative;
}
html {
  --antd-wave-shadow-color: #0e68f9;
  --scroll-bar: 0;
}
[ant-click-animating-without-extra-node='true']::after,
.ant-click-animating-node {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  border-radius: inherit;
  box-shadow: 0 0 0 0 #0e68f9;
  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);
  opacity: 0.2;
  animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1);
  animation-fill-mode: forwards;
  content: '';
  pointer-events: none;
}
@keyframes waveEffect {
  100% {
    box-shadow: 0 0 0 #0e68f9;
    box-shadow: 0 0 0 6px var(--antd-wave-shadow-color);
  }
}
@keyframes fadeEffect {
  100% {
    opacity: 0;
  }
}
.ant-slide-up-enter,
.ant-slide-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-up-enter.ant-slide-up-enter-active,
.ant-slide-up-appear.ant-slide-up-appear-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}
.ant-slide-up-leave.ant-slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-up-enter,
.ant-slide-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.ant-slide-down-enter,
.ant-slide-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-down-enter.ant-slide-down-enter-active,
.ant-slide-down-appear.ant-slide-down-appear-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}
.ant-slide-down-leave.ant-slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-down-enter,
.ant-slide-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.ant-slide-left-enter,
.ant-slide-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-left-enter.ant-slide-left-enter-active,
.ant-slide-left-appear.ant-slide-left-appear-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}
.ant-slide-left-leave.ant-slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-left-enter,
.ant-slide-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.ant-slide-right-enter,
.ant-slide-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-slide-right-enter.ant-slide-right-enter-active,
.ant-slide-right-appear.ant-slide-right-appear-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}
.ant-slide-right-leave.ant-slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-slide-right-enter,
.ant-slide-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.ant-slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
@keyframes antSlideUpIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antSlideUpOut {
  0% {
    transform: scaleY(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
@keyframes antSlideDownIn {
  0% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes antSlideDownOut {
  0% {
    transform: scaleY(1);
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    transform: scaleY(0.8);
    transform-origin: 100% 100%;
    opacity: 0;
  }
}
@keyframes antSlideLeftIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
}
@keyframes antSlideLeftOut {
  0% {
    transform: scaleX(1);
    transform-origin: 0% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(0.8);
    transform-origin: 0% 0%;
    opacity: 0;
  }
}
@keyframes antSlideRightIn {
  0% {
    transform: scaleX(0.8);
    transform-origin: 100% 0%;
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
}
@keyframes antSlideRightOut {
  0% {
    transform: scaleX(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleX(0.8);
    transform-origin: 100% 0%;
    opacity: 0;
  }
}
.ant-zoom-enter,
.ant-zoom-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-enter.ant-zoom-enter-active,
.ant-zoom-appear.ant-zoom-appear-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}
.ant-zoom-leave.ant-zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-enter,
.ant-zoom-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-enter-prepare,
.ant-zoom-appear-prepare {
  transform: none;
}
.ant-zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-big-enter,
.ant-zoom-big-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-enter.ant-zoom-big-enter-active,
.ant-zoom-big-appear.ant-zoom-big-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.ant-zoom-big-leave.ant-zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-big-enter,
.ant-zoom-big-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-big-enter-prepare,
.ant-zoom-big-appear-prepare {
  transform: none;
}
.ant-zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-big-fast-enter,
.ant-zoom-big-fast-appear {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-big-fast-enter.ant-zoom-big-fast-enter-active,
.ant-zoom-big-fast-appear.ant-zoom-big-fast-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.ant-zoom-big-fast-leave.ant-zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-big-fast-enter,
.ant-zoom-big-fast-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-big-fast-enter-prepare,
.ant-zoom-big-fast-appear-prepare {
  transform: none;
}
.ant-zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-up-enter,
.ant-zoom-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-up-enter.ant-zoom-up-enter-active,
.ant-zoom-up-appear.ant-zoom-up-appear-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}
.ant-zoom-up-leave.ant-zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-up-enter,
.ant-zoom-up-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-up-enter-prepare,
.ant-zoom-up-appear-prepare {
  transform: none;
}
.ant-zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-down-enter,
.ant-zoom-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-down-enter.ant-zoom-down-enter-active,
.ant-zoom-down-appear.ant-zoom-down-appear-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}
.ant-zoom-down-leave.ant-zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-down-enter,
.ant-zoom-down-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-down-enter-prepare,
.ant-zoom-down-appear-prepare {
  transform: none;
}
.ant-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-left-enter,
.ant-zoom-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-left-enter.ant-zoom-left-enter-active,
.ant-zoom-left-appear.ant-zoom-left-appear-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}
.ant-zoom-left-leave.ant-zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-left-enter,
.ant-zoom-left-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-left-enter-prepare,
.ant-zoom-left-appear-prepare {
  transform: none;
}
.ant-zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-zoom-right-enter,
.ant-zoom-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.ant-zoom-right-enter.ant-zoom-right-enter-active,
.ant-zoom-right-appear.ant-zoom-right-appear-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}
.ant-zoom-right-leave.ant-zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.ant-zoom-right-enter,
.ant-zoom-right-appear {
  transform: scale(0);
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.ant-zoom-right-enter-prepare,
.ant-zoom-right-appear-prepare {
  transform: none;
}
.ant-zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
@keyframes antZoomIn {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.2);
    opacity: 0;
  }
}
@keyframes antZoomBigIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}
@keyframes antZoomUpIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 0%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 0%;
  }
}
@keyframes antZoomUpOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 0%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 50% 0%;
    opacity: 0;
  }
}
@keyframes antZoomLeftIn {
  0% {
    transform: scale(0.8);
    transform-origin: 0% 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 0% 50%;
  }
}
@keyframes antZoomLeftOut {
  0% {
    transform: scale(1);
    transform-origin: 0% 50%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 0% 50%;
    opacity: 0;
  }
}
@keyframes antZoomRightIn {
  0% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
}
@keyframes antZoomRightOut {
  0% {
    transform: scale(1);
    transform-origin: 100% 50%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 100% 50%;
    opacity: 0;
  }
}
@keyframes antZoomDownIn {
  0% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  100% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
}
@keyframes antZoomDownOut {
  0% {
    transform: scale(1);
    transform-origin: 50% 100%;
  }
  100% {
    transform: scale(0.8);
    transform-origin: 50% 100%;
    opacity: 0;
  }
}
.ant-motion-collapse-legacy {
  overflow: hidden;
}
.ant-motion-collapse-legacy-active {
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
.ant-motion-collapse {
  overflow: hidden;
  transition: height 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
.pf-theme a {
  color: #0e68f9;
}
.pf-theme a:active,
.pf-theme a:focus,
.pf-theme a:hover {
  color: #6ea6ff;
}
.pf-theme *::selection {
  background-color: #b3daff;
  color: inherit;
}
.pf-theme *::-moz-selection {
  background-color: #b3daff;
  color: inherit;
}
a:focus {
  text-decoration: none;
}
.pf-content {
  width: calc(100% - 48px);
  max-width: 991px;
  margin: 24px;
}
.screen-xl .pf-content {
  margin: 24px auto;
}
.pf-content--full-width {
  max-width: 100%;
}
.pf-layout-without-sidebar {
  width: 100%;
  max-width: 1600px;
  padding: 24px 24px;
  margin: 0 auto;
}
.pf-content,
.accounts-layout {
  container: accounts-layout / inline-size;
  max-width: 1600px;
}
.pf-content .ant-card,
.accounts-layout .ant-card {
  box-shadow: none;
}
.container {
  max-width: 1278px;
  margin: 0 auto;
}
.highcharts-xaxis .highcharts-axis-line {
  stroke: #f3f6fb;
}
.background-white {
  background-color: white;
}
.background-purple {
  background-color: #e8e5ff;
}
.color-purple {
  color: #9c75f6;
}
.color-pink {
  color: #d830d0;
}
.color-pink-hover:hover {
  color: #d830d0;
}
.background-orange {
  background-color: #ffc82c;
}
.background-orange-hover:hover {
  background-color: #ffc82c;
}
.border-orange {
  border-color: #f5c12d;
}
.color-light-green {
  color: #00cf83;
}
.background-light-green {
  background-color: #00cf83;
}
.background-grey-3b {
  background-color: rgba(249, 250, 252, 0.58);
}
.background-grey-4 {
  background-color: #f4f7fc;
}
.background-grey-4b {
  background-color: #f5f6f8;
}
.background-grey-4c {
  background-color: #eef3f7;
}
.background-grey-4d {
  background-color: #eff3f7;
}
.background-grey-6a {
  background-color: #d5dbe4;
}
.background-grey-6a-hover:hover {
  background-color: #d5dbe4;
}
.background-light-blue {
  background-color: #ebf3ff;
}
.background-light-blue-hover:hover {
  background-color: #ebf3ff;
}
.background-projects-ab {
  background-color: #e3efed;
}
.background-projects-conjoint {
  background-color: #f7ecde;
}
.background-projects-maxdiff {
  background-color: #c9e6f1;
}
.background-projects-vw {
  background-color: #e7e1f3;
}
.color-placeholder-grey-7::placeholder {
  color: #bfc8d5;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.vertical-align-middle {
  vertical-align: middle;
}
.vertical-align-baseline {
  vertical-align: baseline;
}
.margin-no-top {
  margin-top: 0;
}
.margin-no-bottom {
  margin-bottom: 0;
}
.border-none {
  border: none;
}
.box-shadow-none {
  box-shadow: none;
}
.box-shadow-none-important {
  box-shadow: none !important;
}
.box-shadow-none--override {
  box-shadow: none !important;
}
.margin-xxs {
  margin: 5px;
}
.margin-horizontal-xxs {
  margin-left: 5px;
  margin-right: 5px;
}
.margin-vertical-xxs {
  margin-top: 5px;
  margin-bottom: 5px;
}
.margin-top-xxs {
  margin-top: 5px;
}
.margin-btm-xxs {
  margin-bottom: 5px;
}
.margin-left-xxs {
  margin-left: 5px;
}
.margin-right-xxs {
  margin-right: 5px;
}
.margin-xs {
  margin: 8px;
}
.margin-horizontal-xs {
  margin-left: 8px;
  margin-right: 8px;
}
.margin-vertical-xs {
  margin-top: 8px;
  margin-bottom: 8px;
}
.margin-top-xs {
  margin-top: 8px;
}
.margin-btm-xs {
  margin-bottom: 8px;
}
.margin-left-xs {
  margin-left: 8px;
}
.margin-right-xs {
  margin-right: 8px;
}
.margin-sm {
  margin: 12px;
}
.margin-horizontal-sm {
  margin-left: 12px;
  margin-right: 12px;
}
.margin-vertical-sm {
  margin-top: 12px;
  margin-bottom: 12px;
}
.margin-top-sm {
  margin-top: 12px;
}
.margin-btm-sm {
  margin-bottom: 12px;
}
.margin-left-sm {
  margin-left: 12px;
}
.margin-right-sm {
  margin-right: 12px;
}
.margin-md {
  margin: 16px;
}
.margin-horizontal-md {
  margin-left: 16px;
  margin-right: 16px;
}
.margin-vertical-md {
  margin-top: 16px;
  margin-bottom: 16px;
}
.margin-top-md {
  margin-top: 16px;
}
.margin-btm-md {
  margin-bottom: 16px;
}
.margin-left-md {
  margin-left: 16px;
}
.margin-right-md {
  margin-right: 16px;
}
.margin-lg {
  margin: 24px;
}
.margin-horizontal-lg {
  margin-left: 24px;
  margin-right: 24px;
}
.margin-vertical-lg {
  margin-top: 24px;
  margin-bottom: 24px;
}
.margin-top-lg {
  margin-top: 24px;
}
.margin-btm-lg {
  margin-bottom: 24px;
}
.margin-left-lg {
  margin-left: 24px;
}
.margin-right-lg {
  margin-right: 24px;
}
.margin-xl {
  margin: 36px;
}
.margin-horizontal-xl {
  margin-left: 36px;
  margin-right: 36px;
}
.margin-vertical-xl {
  margin-top: 36px;
  margin-bottom: 36px;
}
.margin-top-xl {
  margin-top: 36px;
}
.margin-btm-xl {
  margin-bottom: 36px;
}
.margin-left-xl {
  margin-left: 36px;
}
.margin-right-xl {
  margin-right: 36px;
}
.margin-none {
  margin: 0;
}
.margin-horizontal-none {
  margin-left: 0;
  margin-right: 0;
}
.margin-vertical-none {
  margin-top: 0;
  margin-bottom: 0;
}
.margin-top-none {
  margin-top: 0;
}
.margin-btm-none {
  margin-bottom: 0;
}
.margin-left-none {
  margin-left: 0;
}
.margin-right-none {
  margin-right: 0;
}
.margin-auto {
  margin: auto;
}
.margin-horizontal-auto {
  margin-left: auto;
  margin-right: auto;
}
.margin-vertical-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.margin-top-auto {
  margin-top: auto;
}
.margin-btm-auto {
  margin-bottom: auto;
}
.margin-left-auto {
  margin-left: auto;
}
.margin-right-auto {
  margin-right: auto;
}
.padding-xxs {
  padding: 5px;
}
.padding-horizontal-xxs {
  padding-left: 5px;
  padding-right: 5px;
}
.padding-vertical-xxs {
  padding-top: 5px;
  padding-bottom: 5px;
}
.padding-top-xxs {
  padding-top: 5px;
}
.padding-btm-xxs {
  padding-bottom: 5px;
}
.padding-left-xxs {
  padding-left: 5px;
}
.padding-right-xxs {
  padding-right: 5px;
}
.padding-xs {
  padding: 8px;
}
.padding-horizontal-xs {
  padding-left: 8px;
  padding-right: 8px;
}
.padding-vertical-xs {
  padding-top: 8px;
  padding-bottom: 8px;
}
.padding-top-xs {
  padding-top: 8px;
}
.padding-btm-xs {
  padding-bottom: 8px;
}
.padding-left-xs {
  padding-left: 8px;
}
.padding-right-xs {
  padding-right: 8px;
}
.padding-sm {
  padding: 12px;
}
.padding-horizontal-sm {
  padding-left: 12px;
  padding-right: 12px;
}
.padding-vertical-sm {
  padding-top: 12px;
  padding-bottom: 12px;
}
.padding-top-sm {
  padding-top: 12px;
}
.padding-btm-sm {
  padding-bottom: 12px;
}
.padding-left-sm {
  padding-left: 12px;
}
.padding-right-sm {
  padding-right: 12px;
}
.padding-md {
  padding: 16px;
}
.padding-horizontal-md {
  padding-left: 16px;
  padding-right: 16px;
}
.padding-vertical-md {
  padding-top: 16px;
  padding-bottom: 16px;
}
.padding-top-md {
  padding-top: 16px;
}
.padding-btm-md {
  padding-bottom: 16px;
}
.padding-left-md {
  padding-left: 16px;
}
.padding-right-md {
  padding-right: 16px;
}
.padding-lg {
  padding: 24px;
}
.padding-horizontal-lg {
  padding-left: 24px;
  padding-right: 24px;
}
.padding-vertical-lg {
  padding-top: 24px;
  padding-bottom: 24px;
}
.padding-top-lg {
  padding-top: 24px;
}
.padding-btm-lg {
  padding-bottom: 24px;
}
.padding-left-lg {
  padding-left: 24px;
}
.padding-right-lg {
  padding-right: 24px;
}
.padding-xl {
  padding: 36px;
}
.padding-horizontal-xl {
  padding-left: 36px;
  padding-right: 36px;
}
.padding-vertical-xl {
  padding-top: 36px;
  padding-bottom: 36px;
}
.padding-top-xl {
  padding-top: 36px;
}
.padding-btm-xl {
  padding-bottom: 36px;
}
.padding-left-xl {
  padding-left: 36px;
}
.padding-right-xl {
  padding-right: 36px;
}
.padding-none {
  padding: 0;
}
.padding-horizontal-none {
  padding-left: 0;
  padding-right: 0;
}
.padding-vertical-none {
  padding-top: 0;
  padding-bottom: 0;
}
.padding-top-none {
  padding-top: 0;
}
.padding-btm-none {
  padding-bottom: 0;
}
.padding-left-none {
  padding-left: 0;
}
.padding-right-none {
  padding-right: 0;
}
.background-primary-1 {
  background-color: #e6f4ff;
}
.ant-alert.margin-md {
  margin-bottom: 16px;
}
.ant-alert.margin-lg {
  margin-bottom: 24px;
}
.screen-xl .margin-md-btm--xl {
  margin-bottom: 16px;
}
.screen-xl .margin-lg-btm--xl {
  margin-bottom: 24px;
}
.btn-container--lg {
  padding: 24px 0;
}
.btn-container--center {
  text-align: center;
}
.primary-text-color {
  color: #0e68f9;
}
.fs-16 {
  font-size: 16px;
}
.font-roboto {
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
}
.font-bold {
  font-weight: bold;
}
.font-italic {
  font-style: italic;
}
.fw-300 {
  font-weight: 300;
}
.fw-400 {
  font-weight: 400;
}
.fw-700 {
  font-weight: 700;
}
.tt-cap {
  text-transform: capitalize;
}
.h-full {
  height: 100%;
}
.h-full--2-headers {
  min-height: 0 !important;
  height: calc(100vh - 153px);
}
.pf-announcement-visible .h-full--2-headers {
  height: calc(100vh - 183px);
}
.h-auto {
  height: auto !important;
}
.h-max-full {
  max-height: 100%;
}
.w-full {
  width: 100%;
}
.w-half {
  width: 50%;
}
.w-max-full {
  max-width: 100%;
}
.w-auto {
  width: auto;
}
.w-min-auto {
  min-width: auto;
}
.w-min-none {
  min-width: 0;
}
.discount-coupon__link {
  display: inline-block;
  font-size: 13px;
  margin-bottom: 8px;
}
.pf-subheading {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 24px;
}
.screen-xs .hide-xs {
  display: none;
}
.screen-sm .hide-sm {
  display: none;
}
.screen-md .hide-md {
  display: none;
}
.screen-lg .hide-lg {
  display: none;
}
.screen-xl .hide-xl {
  display: none;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.pf-theme .is-disabled--low-opacity {
  opacity: 0.3;
}
.pf-theme .text-xs {
  font-size: 11px;
}
.pf-theme .flex {
  display: flex;
}
.pf-theme .inline-flex {
  display: inline-flex;
}
.pf-theme .flex-1 {
  flex: 1;
}
.pf-theme .flex-grow-1 {
  flex-grow: 1;
}
.pf-theme .flex-grow-2 {
  flex-grow: 2;
}
.pf-theme .flex-justify--space-between {
  justify-content: space-between;
}
.pf-theme .flex-justify--center {
  justify-content: center;
}
.pf-theme .flex-justify--end {
  justify-content: flex-end;
}
.pf-theme .flex-align-items--center {
  align-items: center;
}
.pf-theme .flex-align-items--start {
  align-items: flex-start;
}
.pf-theme .flex-align-items--end {
  align-items: flex-end;
}
.pf-theme .flex-direction--column {
  flex-direction: column;
}
.pf-theme .grid {
  display: grid;
}
.pf-theme .text-xxs {
  font-size: 8px;
}
.pf-theme .text-xs {
  font-size: 11px;
}
.pf-theme .text-sm {
  font-size: 13px;
}
.pf-theme .text-sm-2 {
  font-size: 14px;
}
.pf-theme .text-base {
  font-size: 15px;
}
.pf-theme .title--md {
  font-size: 18px;
}
.pf-theme .title--lg {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1;
}
.pf-theme .title--xl {
  font-size: 26px;
}
.pf-theme .isHidden {
  display: none;
}
.pf-theme .isVisible {
  display: block;
}
.pf-theme .color-radical-red {
  color: #fb3b71;
}
.pf-theme .color-white {
  color: #ffffff;
}
.pf-theme .color-green-1b {
  color: #d0fef0;
}
.pf-theme .background-green-1b {
  background-color: #d0fef0;
}
.pf-theme .color-white-hover:hover,
.pf-theme .color-white-hover:focus {
  color: #ffffff;
}
.pf-theme .background-color-grey {
  background-color: #747b8c;
}
.pf-theme .background-color-white {
  background-color: #fff;
}
.pf-theme .leading-none {
  line-height: 1;
}
.placeholder-style-italics::placeholder {
  font-style: italic;
}
.list-style-none {
  list-style: none;
}
.relative {
  position: relative;
}
.overflow-auto {
  overflow: auto;
}
.overflow-visible {
  overflow: visible;
}
.content-fit {
  width: fit-content;
}
.line-height-26 {
  line-height: 26px;
}
.visibility-hidden {
  visibility: hidden;
}
.visibility-visible {
  visibility: visible;
}
.ant-btn {
  line-height: 1.5;
  position: relative;
  display: inline-block;
  font-weight: 300;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  border: 1px solid transparent;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  padding: 3.8px 15px;
  font-size: 15px;
  border-radius: 4px;
  color: #323945;
  border-color: #f0f0f0;
  background: #fff;
}
.ant-btn > .anticon {
  line-height: 1;
}
.ant-btn,
.ant-btn:active,
.ant-btn:focus {
  outline: 0;
}
.ant-btn:not([disabled]):hover {
  text-decoration: none;
}
.ant-btn:not([disabled]):active {
  outline: 0;
  box-shadow: none;
}
.ant-btn[disabled] {
  cursor: not-allowed;
}
.ant-btn[disabled] > * {
  pointer-events: none;
}
.ant-btn-lg {
  height: 40px;
  padding: 5.5px 15px;
  font-size: 18px;
  border-radius: 4px;
}
.ant-btn-sm {
  height: 24px;
  padding: 0.5px 7px;
  font-size: 14px;
  border-radius: 4px;
}
.ant-btn > a:only-child {
  color: currentColor;
}
.ant-btn > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:hover,
.ant-btn:focus {
  color: #388bff;
  border-color: #388bff;
  background: #fff;
}
.ant-btn:hover > a:only-child,
.ant-btn:focus > a:only-child {
  color: currentColor;
}
.ant-btn:hover > a:only-child::after,
.ant-btn:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:active {
  color: #024bd4;
  border-color: #024bd4;
  background: #fff;
}
.ant-btn:active > a:only-child {
  color: currentColor;
}
.ant-btn:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn[disabled],
.ant-btn[disabled]:hover,
.ant-btn[disabled]:focus,
.ant-btn[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn[disabled] > a:only-child,
.ant-btn[disabled]:hover > a:only-child,
.ant-btn[disabled]:focus > a:only-child,
.ant-btn[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn[disabled] > a:only-child::after,
.ant-btn[disabled]:hover > a:only-child::after,
.ant-btn[disabled]:focus > a:only-child::after,
.ant-btn[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn:hover,
.ant-btn:focus,
.ant-btn:active {
  text-decoration: none;
  background: #fff;
}
.ant-btn > span {
  display: inline-block;
}
.ant-btn-primary {
  color: #fff;
  border-color: #0e68f9;
  background: #0e68f9;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-primary > a:only-child {
  color: currentColor;
}
.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  color: #fff;
  border-color: #388bff;
  background: #388bff;
}
.ant-btn-primary:hover > a:only-child,
.ant-btn-primary:focus > a:only-child {
  color: currentColor;
}
.ant-btn-primary:hover > a:only-child::after,
.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary:active {
  color: #fff;
  border-color: #024bd4;
  background: #024bd4;
}
.ant-btn-primary:active > a:only-child {
  color: currentColor;
}
.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus,
.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-primary[disabled] > a:only-child,
.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-primary[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child) {
  border-right-color: #388bff;
  border-left-color: #388bff;
}
.ant-btn-group .ant-btn-primary:not(:first-child):not(:last-child):disabled {
  border-color: #f0f0f0;
}
.ant-btn-group .ant-btn-primary:first-child:not(:last-child) {
  border-right-color: #388bff;
}
.ant-btn-group .ant-btn-primary:first-child:not(:last-child)[disabled] {
  border-right-color: #f0f0f0;
}
.ant-btn-group .ant-btn-primary:last-child:not(:first-child),
.ant-btn-group .ant-btn-primary + .ant-btn-primary {
  border-left-color: #388bff;
}
.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],
.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {
  border-left-color: #f0f0f0;
}
.ant-btn-ghost {
  color: #495561;
  border-color: #d9d9d9;
  background: transparent;
}
.ant-btn-ghost > a:only-child {
  color: currentColor;
}
.ant-btn-ghost > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost:hover,
.ant-btn-ghost:focus {
  color: #388bff;
  border-color: #388bff;
  background: transparent;
}
.ant-btn-ghost:hover > a:only-child,
.ant-btn-ghost:focus > a:only-child {
  color: currentColor;
}
.ant-btn-ghost:hover > a:only-child::after,
.ant-btn-ghost:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost:active {
  color: #024bd4;
  border-color: #024bd4;
  background: transparent;
}
.ant-btn-ghost:active > a:only-child {
  color: currentColor;
}
.ant-btn-ghost:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-ghost[disabled],
.ant-btn-ghost[disabled]:hover,
.ant-btn-ghost[disabled]:focus,
.ant-btn-ghost[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-ghost[disabled] > a:only-child,
.ant-btn-ghost[disabled]:hover > a:only-child,
.ant-btn-ghost[disabled]:focus > a:only-child,
.ant-btn-ghost[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-ghost[disabled] > a:only-child::after,
.ant-btn-ghost[disabled]:hover > a:only-child::after,
.ant-btn-ghost[disabled]:focus > a:only-child::after,
.ant-btn-ghost[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed {
  color: #323945;
  border-color: #f0f0f0;
  background: #fff;
  border-style: dashed;
}
.ant-btn-dashed > a:only-child {
  color: currentColor;
}
.ant-btn-dashed > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed:hover,
.ant-btn-dashed:focus {
  color: #388bff;
  border-color: #388bff;
  background: #fff;
}
.ant-btn-dashed:hover > a:only-child,
.ant-btn-dashed:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dashed:hover > a:only-child::after,
.ant-btn-dashed:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed:active {
  color: #024bd4;
  border-color: #024bd4;
  background: #fff;
}
.ant-btn-dashed:active > a:only-child {
  color: currentColor;
}
.ant-btn-dashed:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dashed[disabled],
.ant-btn-dashed[disabled]:hover,
.ant-btn-dashed[disabled]:focus,
.ant-btn-dashed[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dashed[disabled] > a:only-child,
.ant-btn-dashed[disabled]:hover > a:only-child,
.ant-btn-dashed[disabled]:focus > a:only-child,
.ant-btn-dashed[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dashed[disabled] > a:only-child::after,
.ant-btn-dashed[disabled]:hover > a:only-child::after,
.ant-btn-dashed[disabled]:focus > a:only-child::after,
.ant-btn-dashed[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger {
  color: #f1565d;
  border-color: #f5f5f5;
  background: #f5f5f5;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-danger > a:only-child {
  color: currentColor;
}
.ant-btn-danger > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger:hover,
.ant-btn-danger:focus {
  color: #f1565d;
  border-color: #fff0f0;
  background: #fff0f0;
}
.ant-btn-danger:hover > a:only-child,
.ant-btn-danger:focus > a:only-child {
  color: currentColor;
}
.ant-btn-danger:hover > a:only-child::after,
.ant-btn-danger:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger:active {
  color: #f1565d;
  border-color: #cfc2c3;
  background: #cfc2c3;
}
.ant-btn-danger:active > a:only-child {
  color: currentColor;
}
.ant-btn-danger:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-danger[disabled],
.ant-btn-danger[disabled]:hover,
.ant-btn-danger[disabled]:focus,
.ant-btn-danger[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-danger[disabled] > a:only-child,
.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-danger[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-danger[disabled] > a:only-child::after,
.ant-btn-danger[disabled]:hover > a:only-child::after,
.ant-btn-danger[disabled]:focus > a:only-child::after,
.ant-btn-danger[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link {
  color: #0e68f9;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-link > a:only-child {
  color: currentColor;
}
.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:hover,
.ant-btn-link:focus {
  color: #388bff;
  border-color: #388bff;
  background: transparent;
}
.ant-btn-link:hover > a:only-child,
.ant-btn-link:focus > a:only-child {
  color: currentColor;
}
.ant-btn-link:hover > a:only-child::after,
.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:active {
  color: #024bd4;
  border-color: #024bd4;
  background: transparent;
}
.ant-btn-link:active > a:only-child {
  color: currentColor;
}
.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link[disabled],
.ant-btn-link[disabled]:hover,
.ant-btn-link[disabled]:focus,
.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-link[disabled] > a:only-child,
.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-link[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-link:hover {
  background: transparent;
}
.ant-btn-link:hover,
.ant-btn-link:focus,
.ant-btn-link:active {
  border-color: transparent;
}
.ant-btn-link[disabled],
.ant-btn-link[disabled]:hover,
.ant-btn-link[disabled]:focus,
.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-link[disabled] > a:only-child,
.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-link[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text {
  color: #495561;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-text > a:only-child {
  color: currentColor;
}
.ant-btn-text > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text:hover,
.ant-btn-text:focus {
  color: #388bff;
  border-color: #388bff;
  background: transparent;
}
.ant-btn-text:hover > a:only-child,
.ant-btn-text:focus > a:only-child {
  color: currentColor;
}
.ant-btn-text:hover > a:only-child::after,
.ant-btn-text:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text:active {
  color: #024bd4;
  border-color: #024bd4;
  background: transparent;
}
.ant-btn-text:active > a:only-child {
  color: currentColor;
}
.ant-btn-text:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text[disabled],
.ant-btn-text[disabled]:hover,
.ant-btn-text[disabled]:focus,
.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-text[disabled] > a:only-child,
.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-text[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-text:hover,
.ant-btn-text:focus {
  color: #495561;
  background: rgba(0, 0, 0, 0.018);
  border-color: transparent;
}
.ant-btn-text:active {
  color: #495561;
  background: rgba(0, 0, 0, 0.028);
  border-color: transparent;
}
.ant-btn-text[disabled],
.ant-btn-text[disabled]:hover,
.ant-btn-text[disabled]:focus,
.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-text[disabled] > a:only-child,
.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-text[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous {
  color: #f1565d;
  border-color: #f1565d;
  background: #fff;
}
.ant-btn-dangerous > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous:hover,
.ant-btn-dangerous:focus {
  color: #ff8587;
  border-color: #ff8587;
  background: #fff;
}
.ant-btn-dangerous:hover > a:only-child,
.ant-btn-dangerous:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous:hover > a:only-child::after,
.ant-btn-dangerous:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous:active {
  color: #cc3f4b;
  border-color: #cc3f4b;
  background: #fff;
}
.ant-btn-dangerous:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous[disabled],
.ant-btn-dangerous[disabled]:hover,
.ant-btn-dangerous[disabled]:focus,
.ant-btn-dangerous[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous[disabled] > a:only-child,
.ant-btn-dangerous[disabled]:hover > a:only-child,
.ant-btn-dangerous[disabled]:focus > a:only-child,
.ant-btn-dangerous[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous[disabled] > a:only-child::after,
.ant-btn-dangerous[disabled]:hover > a:only-child::after,
.ant-btn-dangerous[disabled]:focus > a:only-child::after,
.ant-btn-dangerous[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary {
  color: #f1565d;
  border-color: #f5f5f5;
  background: #f5f5f5;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-dangerous.ant-btn-primary > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary:hover,
.ant-btn-dangerous.ant-btn-primary:focus {
  color: #f1565d;
  border-color: #fff0f0;
  background: #fff0f0;
}
.ant-btn-dangerous.ant-btn-primary:hover > a:only-child,
.ant-btn-dangerous.ant-btn-primary:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-primary:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary:active {
  color: #f1565d;
  border-color: #cfc2c3;
  background: #cfc2c3;
}
.ant-btn-dangerous.ant-btn-primary:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-primary[disabled],
.ant-btn-dangerous.ant-btn-primary[disabled]:hover,
.ant-btn-dangerous.ant-btn-primary[disabled]:focus,
.ant-btn-dangerous.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link {
  color: #f1565d;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:hover,
.ant-btn-dangerous.ant-btn-link:focus {
  color: #388bff;
  border-color: #388bff;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:active {
  color: #024bd4;
  border-color: #024bd4;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link[disabled],
.ant-btn-dangerous.ant-btn-link[disabled]:hover,
.ant-btn-dangerous.ant-btn-link[disabled]:focus,
.ant-btn-dangerous.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:hover,
.ant-btn-dangerous.ant-btn-link:focus {
  color: #ff8587;
  border-color: transparent;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link:active {
  color: #cc3f4b;
  border-color: transparent;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-link[disabled],
.ant-btn-dangerous.ant-btn-link[disabled]:hover,
.ant-btn-dangerous.ant-btn-link[disabled]:focus,
.ant-btn-dangerous.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text {
  color: #f1565d;
  border-color: transparent;
  background: transparent;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-text > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:hover,
.ant-btn-dangerous.ant-btn-text:focus {
  color: #388bff;
  border-color: #388bff;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:active {
  color: #024bd4;
  border-color: #024bd4;
  background: transparent;
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text[disabled],
.ant-btn-dangerous.ant-btn-text[disabled]:hover,
.ant-btn-dangerous.ant-btn-text[disabled]:focus,
.ant-btn-dangerous.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:hover,
.ant-btn-dangerous.ant-btn-text:focus {
  color: #ff8587;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.018);
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text:active {
  color: #cc3f4b;
  border-color: transparent;
  background: rgba(0, 0, 0, 0.028);
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-dangerous.ant-btn-text[disabled],
.ant-btn-dangerous.ant-btn-text[disabled]:hover,
.ant-btn-dangerous.ant-btn-text[disabled]:focus,
.ant-btn-dangerous.ant-btn-text[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: transparent;
  background: transparent;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-dangerous.ant-btn-text[disabled] > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:hover > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:focus > a:only-child::after,
.ant-btn-dangerous.ant-btn-text[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-icon-only {
  width: 32px;
  height: 32px;
  padding: 2.3px 0;
  font-size: 17px;
  border-radius: 4px;
  vertical-align: -3px;
}
.ant-btn-icon-only > * {
  font-size: 17px;
}
.ant-btn-icon-only.ant-btn-lg {
  width: 40px;
  height: 40px;
  padding: 4px 0;
  font-size: 20px;
  border-radius: 4px;
}
.ant-btn-icon-only.ant-btn-lg > * {
  font-size: 20px;
}
.ant-btn-icon-only.ant-btn-sm {
  width: 24px;
  height: 24px;
  padding: 0 0;
  font-size: 15px;
  border-radius: 4px;
}
.ant-btn-icon-only.ant-btn-sm > * {
  font-size: 15px;
}
.ant-btn-icon-only > .anticon {
  display: flex;
  justify-content: center;
}
.ant-btn-round {
  height: 32px;
  padding: 3.8px 16px;
  font-size: 15px;
  border-radius: 32px;
}
.ant-btn-round.ant-btn-lg {
  height: 40px;
  padding: 5.5px 20px;
  font-size: 18px;
  border-radius: 40px;
}
.ant-btn-round.ant-btn-sm {
  height: 24px;
  padding: 0 12px;
  font-size: 15px;
  border-radius: 24px;
}
.ant-btn-round.ant-btn-icon-only {
  width: auto;
}
.ant-btn-circle {
  min-width: 32px;
  padding-right: 0;
  padding-left: 0;
  text-align: center;
  border-radius: 50%;
}
.ant-btn-circle.ant-btn-lg {
  min-width: 40px;
  border-radius: 50%;
}
.ant-btn-circle.ant-btn-sm {
  min-width: 24px;
  border-radius: 50%;
}
.ant-btn::before {
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  z-index: 1;
  display: none;
  background: #fff;
  border-radius: inherit;
  opacity: 0.35;
  transition: opacity 0.2s;
  content: '';
  pointer-events: none;
}
.ant-btn .anticon {
  transition: margin-left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-btn .anticon.anticon-plus > svg,
.ant-btn .anticon.anticon-minus > svg {
  shape-rendering: optimizeSpeed;
}
.ant-btn.ant-btn-loading {
  position: relative;
}
.ant-btn.ant-btn-loading:not([disabled]) {
  pointer-events: none;
}
.ant-btn.ant-btn-loading::before {
  display: block;
}
.ant-btn > .ant-btn-loading-icon {
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 8px;
  animation: none;
}
.ant-btn > .ant-btn-loading-icon .anticon svg {
  animation: loadingCircle 1s infinite linear;
}
.ant-btn > .ant-btn-loading-icon:only-child .anticon {
  padding-right: 0;
}
.ant-btn-group {
  position: relative;
  display: inline-flex;
}
.ant-btn-group > .ant-btn,
.ant-btn-group > span > .ant-btn {
  position: relative;
}
.ant-btn-group > .ant-btn:hover,
.ant-btn-group > span > .ant-btn:hover,
.ant-btn-group > .ant-btn:focus,
.ant-btn-group > span > .ant-btn:focus,
.ant-btn-group > .ant-btn:active,
.ant-btn-group > span > .ant-btn:active {
  z-index: 2;
}
.ant-btn-group > .ant-btn[disabled],
.ant-btn-group > span > .ant-btn[disabled] {
  z-index: 0;
}
.ant-btn-group .ant-btn-icon-only {
  font-size: 15px;
}
.ant-btn-group-lg > .ant-btn,
.ant-btn-group-lg > span > .ant-btn {
  height: 40px;
  padding: 5.5px 15px;
  font-size: 18px;
  border-radius: 0;
}
.ant-btn-group-lg .ant-btn.ant-btn-icon-only {
  width: 40px;
  height: 40px;
  padding-right: 0;
  padding-left: 0;
}
.ant-btn-group-sm > .ant-btn,
.ant-btn-group-sm > span > .ant-btn {
  height: 24px;
  padding: 0 7px;
  font-size: 15px;
  border-radius: 0;
}
.ant-btn-group-sm > .ant-btn > .anticon,
.ant-btn-group-sm > span > .ant-btn > .anticon {
  font-size: 15px;
}
.ant-btn-group-sm .ant-btn.ant-btn-icon-only {
  width: 24px;
  height: 24px;
  padding-right: 0;
  padding-left: 0;
}
.ant-btn-group .ant-btn + .ant-btn,
.ant-btn + .ant-btn-group,
.ant-btn-group span + .ant-btn,
.ant-btn-group .ant-btn + span,
.ant-btn-group > span + span,
.ant-btn-group + .ant-btn,
.ant-btn-group + .ant-btn-group {
  margin-left: -1px;
}
.ant-btn-group .ant-btn-primary + .ant-btn:not(.ant-btn-primary):not([disabled]) {
  border-left-color: transparent;
}
.ant-btn-group .ant-btn {
  border-radius: 0;
}
.ant-btn-group > .ant-btn:first-child,
.ant-btn-group > span:first-child > .ant-btn {
  margin-left: 0;
}
.ant-btn-group > .ant-btn:only-child {
  border-radius: 4px;
}
.ant-btn-group > span:only-child > .ant-btn {
  border-radius: 4px;
}
.ant-btn-group > .ant-btn:first-child:not(:last-child),
.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-btn-group > .ant-btn:last-child:not(:first-child),
.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:only-child {
  border-radius: 4px;
}
.ant-btn-group-sm > span:only-child > .ant-btn {
  border-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),
.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),
.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-btn-group > .ant-btn-group {
  float: left;
}
.ant-btn-group > .ant-btn-group:not(:first-child):not(:last-child) > .ant-btn {
  border-radius: 0;
}
.ant-btn-group > .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  padding-right: 8px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-btn-group > .ant-btn-group:last-child:not(:first-child) > .ant-btn:first-child {
  padding-left: 8px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-btn-rtl.ant-btn-group .ant-btn + .ant-btn,
.ant-btn-rtl.ant-btn + .ant-btn-group,
.ant-btn-rtl.ant-btn-group span + .ant-btn,
.ant-btn-rtl.ant-btn-group .ant-btn + span,
.ant-btn-rtl.ant-btn-group > span + span,
.ant-btn-rtl.ant-btn-group + .ant-btn,
.ant-btn-rtl.ant-btn-group + .ant-btn-group,
.ant-btn-group-rtl.ant-btn-group .ant-btn + .ant-btn,
.ant-btn-group-rtl.ant-btn + .ant-btn-group,
.ant-btn-group-rtl.ant-btn-group span + .ant-btn,
.ant-btn-group-rtl.ant-btn-group .ant-btn + span,
.ant-btn-group-rtl.ant-btn-group > span + span,
.ant-btn-group-rtl.ant-btn-group + .ant-btn,
.ant-btn-group-rtl.ant-btn-group + .ant-btn-group {
  margin-right: -1px;
  margin-left: auto;
}
.ant-btn-group.ant-btn-group-rtl {
  direction: rtl;
}
.ant-btn-group-rtl.ant-btn-group > .ant-btn:first-child:not(:last-child),
.ant-btn-group-rtl.ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
}
.ant-btn-group-rtl.ant-btn-group > .ant-btn:last-child:not(:first-child),
.ant-btn-group-rtl.ant-btn-group > span:last-child:not(:first-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 4px;
}
.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:first-child:not(:last-child),
.ant-btn-group-rtl.ant-btn-group-sm > span:first-child:not(:last-child) > .ant-btn {
  border-top-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 0;
}
.ant-btn-group-rtl.ant-btn-group-sm > .ant-btn:last-child:not(:first-child),
.ant-btn-group-rtl.ant-btn-group-sm > span:last-child:not(:first-child) > .ant-btn {
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 4px;
}
.ant-btn:focus > span,
.ant-btn:active > span {
  position: relative;
}
.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 8px;
}
.ant-btn.ant-btn-background-ghost {
  color: #fff;
  border-color: #fff;
}
.ant-btn.ant-btn-background-ghost,
.ant-btn.ant-btn-background-ghost:hover,
.ant-btn.ant-btn-background-ghost:active,
.ant-btn.ant-btn-background-ghost:focus {
  background: transparent;
}
.ant-btn-background-ghost.ant-btn-primary {
  color: #0e68f9;
  border-color: #0e68f9;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-primary > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary:hover,
.ant-btn-background-ghost.ant-btn-primary:focus {
  color: #388bff;
  border-color: #388bff;
}
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary:active {
  color: #024bd4;
  border-color: #024bd4;
}
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-primary[disabled],
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-primary[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger {
  color: #d9d9d9;
  border-color: #d9d9d9;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-danger > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger:hover,
.ant-btn-background-ghost.ant-btn-danger:focus {
  color: #e6d8d8;
  border-color: #e6d8d8;
}
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger:active {
  color: #b3a8a8;
  border-color: #b3a8a8;
}
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-danger[disabled],
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-danger[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-danger[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous {
  color: #d9d9d9;
  border-color: #d9d9d9;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous:hover,
.ant-btn-background-ghost.ant-btn-dangerous:focus {
  color: #e6d8d8;
  border-color: #e6d8d8;
}
.ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous:active {
  color: #b3a8a8;
  border-color: #b3a8a8;
}
.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous[disabled],
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link {
  color: #d9d9d9;
  border-color: transparent;
  text-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus {
  color: #e6d8d8;
  border-color: transparent;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active {
  color: #b3a8a8;
  border-color: transparent;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled],
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child {
  color: currentColor;
}
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled] > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:hover > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:focus > a:only-child::after,
.ant-btn-background-ghost.ant-btn-dangerous.ant-btn-link[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.ant-btn-two-chinese-chars::first-letter {
  letter-spacing: 0.34em;
}
.ant-btn-two-chinese-chars > *:not(.anticon) {
  margin-right: -0.34em;
  letter-spacing: 0.34em;
}
.ant-btn-block {
  width: 100%;
}
.ant-btn:empty {
  display: inline-block;
  width: 0;
  visibility: hidden;
  content: '\\a0';
}
a.ant-btn {
  padding-top: 0.01px !important;
  line-height: 30px;
}
a.ant-btn-lg {
  line-height: 38px;
}
a.ant-btn-sm {
  line-height: 22px;
}
.ant-btn-rtl {
  direction: rtl;
}
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child),
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary {
  border-right-color: #388bff;
  border-left-color: #f0f0f0;
}
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary:last-child:not(:first-child)[disabled],
.ant-btn-group-rtl.ant-btn-group .ant-btn-primary + .ant-btn-primary[disabled] {
  border-right-color: #f0f0f0;
  border-left-color: #388bff;
}
.ant-btn-rtl.ant-btn > .ant-btn-loading-icon .anticon {
  padding-right: 0;
  padding-left: 8px;
}
.ant-btn > .ant-btn-loading-icon:only-child .anticon {
  padding-right: 0;
  padding-left: 0;
}
.ant-btn-rtl.ant-btn > .anticon + span,
.ant-btn-rtl.ant-btn > span + .anticon {
  margin-right: 8px;
  margin-left: 0;
}
.pf-theme .ant-btn {
  font-size: 16px;
  text-shadow: none !important;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.pf-theme .ant-btn:after {
  content: none !important;
}
.pf-theme .ant-btn:first-letter {
  text-transform: capitalize;
}
.pf-theme .ant-btn.full-width {
  width: 100%;
}
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost) {
  box-shadow: 0 5px 10px 0 rgba(14, 104, 249, 0.3);
}
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost).disabled,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost)[disabled],
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost).disabled:hover,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost)[disabled]:hover,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost).disabled:focus,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost)[disabled]:focus,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost).disabled:active,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost)[disabled]:active,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost).disabled.active,
.pf-theme .ant-btn-primary:not(.ant-btn-background-ghost)[disabled].active {
  box-shadow: none;
}
.pf-theme .ant-btn-basic,
.pf-theme .ant-btn-business,
.pf-theme .ant-btn-enterprise {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: 150ms;
}
.pf-theme .ant-btn-basic.disabled,
.pf-theme .ant-btn-business.disabled,
.pf-theme .ant-btn-enterprise.disabled,
.pf-theme .ant-btn-basic[disabled],
.pf-theme .ant-btn-business[disabled],
.pf-theme .ant-btn-enterprise[disabled],
.pf-theme .ant-btn-basic.disabled:hover,
.pf-theme .ant-btn-business.disabled:hover,
.pf-theme .ant-btn-enterprise.disabled:hover,
.pf-theme .ant-btn-basic[disabled]:hover,
.pf-theme .ant-btn-business[disabled]:hover,
.pf-theme .ant-btn-enterprise[disabled]:hover,
.pf-theme .ant-btn-basic.disabled:focus,
.pf-theme .ant-btn-business.disabled:focus,
.pf-theme .ant-btn-enterprise.disabled:focus,
.pf-theme .ant-btn-basic[disabled]:focus,
.pf-theme .ant-btn-business[disabled]:focus,
.pf-theme .ant-btn-enterprise[disabled]:focus,
.pf-theme .ant-btn-basic.disabled:active,
.pf-theme .ant-btn-business.disabled:active,
.pf-theme .ant-btn-enterprise.disabled:active,
.pf-theme .ant-btn-basic[disabled]:active,
.pf-theme .ant-btn-business[disabled]:active,
.pf-theme .ant-btn-enterprise[disabled]:active,
.pf-theme .ant-btn-basic.disabled.active,
.pf-theme .ant-btn-business.disabled.active,
.pf-theme .ant-btn-enterprise.disabled.active,
.pf-theme .ant-btn-basic[disabled].active,
.pf-theme .ant-btn-business[disabled].active,
.pf-theme .ant-btn-enterprise[disabled].active {
  box-shadow: none;
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}
.pf-theme .ant-btn-upgrade {
  color: #fb3b71;
  background-color: white;
  text-transform: uppercase;
  height: 36px;
  line-height: 35px;
  border-color: transparent !important;
  box-shadow: none !important;
  font-weight: bold !important;
  padding: 8px 0 !important;
  font-size: 14px;
}
.pf-theme .ant-btn-surveys-link {
  color: #8f98a9;
  border: 1px solid #8f98a9;
  font-size: 14px !important;
  font-weight: 500;
}
.pf-theme .ant-btn-surveys-link:active,
.pf-theme .ant-btn-surveys-link:focus,
.pf-theme .ant-btn-surveys-link:hover {
  background-color: #fb3b71;
  border-color: #fb3b71;
  color: white;
  -o-box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);
  -moz-box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);
  -webkit-box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);
  box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);
}
.pf-theme .ant-btn-basic {
  color: #0e68f9;
  background-color: white;
  border-color: transparent;
}
.pf-theme .ant-btn-business {
  color: white !important;
  background-color: #707afe;
  border-color: transparent;
}
.pf-theme .ant-btn-business:active,
.pf-theme .ant-btn-business:focus,
.pf-theme .ant-btn-business:hover {
  color: white;
  background-color: #707afe;
}
.pf-theme .ant-btn-enterprise,
.pf-theme .ant-btn-elite {
  color: white !important;
  background-color: #31df80;
  border-color: transparent;
}
.pf-theme .ant-btn-enterprise:active,
.pf-theme .ant-btn-elite:active,
.pf-theme .ant-btn-enterprise:focus,
.pf-theme .ant-btn-elite:focus,
.pf-theme .ant-btn-enterprise:hover,
.pf-theme .ant-btn-elite:hover {
  color: white;
  background-color: #31df80;
}
.pf-theme .ant-btn-enterprise.ant-btn-enterprise--active,
.pf-theme .ant-btn-elite.ant-btn-enterprise--active,
.pf-theme .ant-btn-enterprise.ant-btn-elite--active,
.pf-theme .ant-btn-elite.ant-btn-elite--active {
  background-color: #f1565d;
}
.pf-theme .ant-btn-sm {
  font-size: 14px;
}
.pf-theme .ant-btn.ant-btn-link {
  color: #0e68f9;
  border: 0;
  font-weight: 400;
  padding: 0;
}
.pf-theme .ant-btn.ant-btn-link:active,
.pf-theme .ant-btn.ant-btn-link:focus,
.pf-theme .ant-btn.ant-btn-link:hover {
  color: #388bff !important;
}
.pf-theme .ant-btn .anticon {
  vertical-align: 0;
}
.pf-theme .ant-btn-white {
  color: #388bff;
  background-color: white;
}
.pf-theme .ant-btn-white:hover,
.pf-theme .ant-btn-white:focus {
  background-color: #e6f4ff;
}
.pf-theme .ant-btn-white:active,
.pf-theme .ant-btn-white.active {
  background-color: #e6f4ff;
}
.pf-theme .ant-btn-no-border {
  border: none;
}
.pf-theme .ant-btn.ant-btn-auto {
  height: auto;
}
.pf-theme .ant-btn.ant-btn-round {
  -webkit-border-radius: 16px;
  -moz-border-radius: 16px;
  border-radius: 16px;
}
.pf-theme .ant-btn.ant-btn.ant-btn-icon-only {
  padding: 0;
}
.pf-theme .ant-btn.ant-btn-no-radius {
  border-radius: 0;
}
.pf-theme .ant-button-group {
  -webkit-box-shadow: 0 2px 10px 0 rgba(48, 48, 146, 0.13);
  -moz-box-shadow: 0 2px 10px 0 rgba(48, 48, 146, 0.13);
  box-shadow: 0 2px 10px 0 rgba(48, 48, 146, 0.13);
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}
.pf-theme .ant-button-group > .ant-radio-button-wrapper {
  height: 42px;
  line-height: 42px;
  border-color: #f3f6fb;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.pf-theme .ant-button-group > .ant-radio-button-wrapper:before {
  background-color: #f3f6fb;
}
.pf-theme .ant-button-group .ant-radio-button-wrapper-checked.ant-radio-button-wrapper:before {
  background-color: #b3daff !important;
  opacity: 1;
}
.pf-theme .ant-button-group .ant-radio-button-wrapper-checked {
  font-weight: bold;
  color: #0e68f9 !important;
  background-color: #e6f4ff !important;
  border-color: #b3daff !important;
}
.pf-btn-secondary:hover,
.pf-btn-secondary:focus {
  color: #ff668c;
  border-color: #ff668c;
  background: #fff;
}
.pf-btn-secondary:hover > a:only-child,
.pf-btn-secondary:focus > a:only-child {
  color: currentColor;
}
.pf-btn-secondary:hover > a:only-child::after,
.pf-btn-secondary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.pf-btn-secondary:active,
.pf-btn-secondary.active {
  color: #d4285f;
  border-color: #d4285f;
  background: #fff;
}
.pf-btn-secondary:active > a:only-child,
.pf-btn-secondary.active > a:only-child {
  color: currentColor;
}
.pf-btn-secondary:active > a:only-child::after,
.pf-btn-secondary.active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.pf-btn-secondary.ant-btn-primary {
  color: white;
  border-color: #fb3b71;
  background: #fb3b71;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);
}
.pf-btn-secondary.ant-btn-primary > a:only-child {
  color: currentColor;
}
.pf-btn-secondary.ant-btn-primary > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.pf-btn-secondary.ant-btn-primary:hover,
.pf-btn-secondary.ant-btn-primary:focus {
  color: white;
  border-color: #ff668c;
  background: #ff668c;
}
.pf-btn-secondary.ant-btn-primary:hover > a:only-child,
.pf-btn-secondary.ant-btn-primary:focus > a:only-child {
  color: currentColor;
}
.pf-btn-secondary.ant-btn-primary:hover > a:only-child::after,
.pf-btn-secondary.ant-btn-primary:focus > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.pf-btn-secondary.ant-btn-primary:active {
  color: white;
  border-color: #d4285f;
  background: #d4285f;
}
.pf-btn-secondary.ant-btn-primary:active > a:only-child {
  color: currentColor;
}
.pf-btn-secondary.ant-btn-primary:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.pf-btn-secondary.ant-btn-primary[disabled],
.pf-btn-secondary.ant-btn-primary[disabled]:hover,
.pf-btn-secondary.ant-btn-primary[disabled]:focus,
.pf-btn-secondary.ant-btn-primary[disabled]:active {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  background: #f5f5f5;
  text-shadow: none;
  box-shadow: none;
}
.pf-btn-secondary.ant-btn-primary[disabled] > a:only-child,
.pf-btn-secondary.ant-btn-primary[disabled]:hover > a:only-child,
.pf-btn-secondary.ant-btn-primary[disabled]:focus > a:only-child,
.pf-btn-secondary.ant-btn-primary[disabled]:active > a:only-child {
  color: currentColor;
}
.pf-btn-secondary.ant-btn-primary[disabled] > a:only-child::after,
.pf-btn-secondary.ant-btn-primary[disabled]:hover > a:only-child::after,
.pf-btn-secondary.ant-btn-primary[disabled]:focus > a:only-child::after,
.pf-btn-secondary.ant-btn-primary[disabled]:active > a:only-child::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: transparent;
  content: '';
}
.pf-btn-secondary.ant-btn-clicked:after {
  border-color: #ff668c;
}
.pf-btn {
  height: 36px;
  border: 0;
}
.pf-btn-group {
  display: block;
  margin: 40px auto 70px;
  text-align: center;
}
.pf-btn-group__btn-wrapper {
  display: inline-block;
  position: relative;
}
.pf-btn-group__bonus-label {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  color: white;
  padding: 4px;
  font-size: 13px;
  background-color: #31315c;
  display: none;
  font-weight: 100;
  -webkit-transform: translateY(100%);
  -moz-transform: translateY(100%);
  -ms-transform: translateY(100%);
  -o-transform: translateY(100%);
  transform: translateY(100%);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.pf-btn-group__bonus-label--short {
  width: 90%;
}
.pf-btn-group__bonus-label--active {
  display: block;
}
.pf-btn--group-btn {
  text-transform: capitalize;
  border-radius: 0 !important;
  background-color: white;
  color: #31315c;
  border-radius: 0;
}
.pf-btn--group-btn:active,
.pf-btn--group-btn:focus,
.pf-btn--group-btn:hover {
  -webkit-transform: translate(0);
  -moz-transform: translate(0);
  -ms-transform: translate(0);
  -o-transform: translate(0);
  transform: translate(0);
  outline: none;
}
.pf-btn--group-btn-active {
  color: white !important;
  background-color: #fb3b71 !important;
}
.pf-btn--group-btn-first {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
}
.pf-btn--group-btn-last {
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
}
.ant-radio-button-wrapper-border-none .ant-radio-button-wrapper {
  border: 0;
}
.service-card-btn {
  color: #0e68f9;
  background-color: white;
  padding: 6px 14px;
  border-radius: 4px;
  transition: all 0.3s linear;
}
.service-card-btn.service-card-btn-hover {
  color: white;
  background-color: #0e68f9;
}
.form-actions-container {
  border-top: 1px solid #eef1f4;
  padding-top: 24px;
  margin-top: -24px;
}
.field-explain-label {
  font-size: 12px;
  position: relative;
  top: -14px;
}
.ant-form-item-line-height-clear .ant-legacy-form-item-control {
  line-height: 1;
}
.team-information-form.ant-legacy-form-vertical .ant-legacy-form-item,
.personal-information-form.ant-legacy-form-vertical .ant-legacy-form-item,
.password-form.ant-legacy-form-vertical .ant-legacy-form-item {
  padding-bottom: 0;
}
.team-information-form .ant-legacy-form-item,
.personal-information-form .ant-legacy-form-item,
.password-form .ant-legacy-form-item {
  margin-bottom: 18px;
}
.team-information-form .ant-legacy-form-item-label,
.personal-information-form .ant-legacy-form-item-label,
.password-form .ant-legacy-form-item-label {
  line-height: 1;
  padding-bottom: 6px;
}
.team-information-form .ant-input,
.personal-information-form .ant-input,
.password-form .ant-input {
  font-size: 14px;
  height: 40px;
  font-weight: bold;
  border-color: #e7ebef;
}
.team-information-form .ant-input:hover,
.personal-information-form .ant-input:hover,
.password-form .ant-input:hover,
.team-information-form .ant-input:focus,
.personal-information-form .ant-input:focus,
.password-form .ant-input:focus,
.team-information-form .ant-input:active,
.personal-information-form .ant-input:active,
.password-form .ant-input:active {
  border-color: #e0e6ed !important;
  box-shadow: none !important;
}
.team-information-form .ant-input::placeholder,
.personal-information-form .ant-input::placeholder,
.password-form .ant-input::placeholder {
  color: #bfc8d5;
  font-weight: normal;
}
.password-form .ant-legacy-form-item-required span::after {
  display: inline-block;
  margin-right: 4px;
  color: #323945;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
.pf-theme .ant-input-search {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  overflow: hidden;
}
.pf-theme .ant-input-search .ant-input-wrapper {
  background: transparent !important;
}
.pf-theme .ant-input-search .ant-input-group-addon {
  background-color: transparent !important;
  width: 0;
}
.pf-theme .ant-input-search .ant-input {
  border: 0 !important;
  background-color: #f9fafc;
  height: 38px;
}
.pf-theme .ant-input-search .ant-input:active,
.pf-theme .ant-input-search .ant-input:focus,
.pf-theme .ant-input-search .ant-input:hover {
  box-shadow: none !important;
}
.pf-theme .ant-input-search .ant-input::placeholder {
  color: #323945;
}
.pf-theme .ant-input-search .ant-input-search-button {
  background: transparent;
  border: none;
  box-shadow: none !important;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 100;
}
.pf-theme .ant-input-search .anticon-search::before {
  font-family: 'icomoon';
  content: '\\E670';
  display: block;
  font-size: 14px;
  font-weight: bold;
  color: #323945;
}
.pf-theme .ant-input-search .anticon-search svg {
  display: none;
}
.pf-theme .ant-input {
  line-height: 1.5;
  border-radius: 4px;
}
.pf-theme .ant-input.ant-input-sm {
  padding-top: 1px;
  padding-bottom: 1px;
  height: 24px;
}
.pf-theme .ant-input.StripeElement--focus,
.pf-theme .ant-input:focus {
  color: #323945;
  border-color: #0e68f9;
  outline: 0;
  box-shadow: 1px 1px 2px 0 rgba(191, 200, 213, 0.8) inset;
}
.pf-theme .ant-input-shadow-none {
  box-shadow: 0 0 0 transparent;
}
.pf-theme .ant-input-shadow-none:focus {
  box-shadow: 0 0 0 transparent;
}
.pf-theme .ant-input-question::placeholder,
.pf-theme .ant-input-answer::placeholder {
  font-weight: normal;
  color: #5c6776;
}
.pf-theme .ant-input.StripeElement--focus,
.pf-theme .ant-input:hover {
  border-color: #0e68f9;
}
.pf-theme .has-error .ant-input {
  border-color: #f1565d;
  outline: 0;
  box-shadow: 0 0 2px 0 rgba(191, 200, 213, 0.2);
}
.pf-theme .has-error .ant-input.StripeElement--focus,
.pf-theme .has-error .ant-input:focus {
  border-color: #f1565d;
  outline: 0;
  box-shadow: 0 0 2px 0 rgba(191, 200, 213, 0.2);
}
.pf-theme .ant-checkbox-inner {
  border-radius: 4px;
  border-color: #e7ebef;
}
.pf-theme .ant-checkbox-dark {
  color: #323945;
}
.pf-theme .ant-checkbox-dark .ant-checkbox-inner {
  border-color: #323945;
}
.pf-theme .ant-checkbox-indeterminate .ant-checkbox-inner::after {
  height: 2.5px;
}
.pf-theme .ant-radio .ant-radio-inner {
  border-color: #323945;
}
.pf-theme .ant-radio-checked .ant-radio-inner {
  border-color: #0e68f9;
}
.pf-theme .ant-radio-checked .ant-radio-inner:after {
  background-color: #0e68f9;
}
.pf-theme .ant-radio-inner {
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
.pf-theme .ant-time-picker-clock-icon {
  color: #323945 !important;
  font-size: 16px;
  margin-top: -2px;
}
.pf-theme .ant-calendar-picker-container,
.pf-theme .ant-time-picker-panel {
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  color: #323945;
}
.pf-theme .ant-input-number.ant-input-dollar-decoration {
  padding-left: 12px;
  position: relative;
}
.pf-theme .ant-input-number.ant-input-dollar-decoration:before {
  content: '\$';
  position: absolute;
  left: 11px;
  top: 8px;
  z-index: 1;
}
.pf-theme .ant-input-number.ant-input-number-hide-arrows .ant-input-number-handler-wrap {
  display: none !important;
}
.link-settings-input input,
input.link-settings-input {
  height: 40px;
}
.link-settings-input input::placeholder,
input.link-settings-input::placeholder {
  color: #bfc8d5;
}
[data-slate-node='element'][dir='rtl'] {
  direction: ltr;
}
p[data-slate-node='element'] {
  margin-bottom: 0;
}
.ant-input-search-white .ant-input {
  background-color: white !important;
}
.pf-radio-btn {
  outline-offset: 0.15rem;
}
.pf-radio-btn-input {
  visibility: hidden;
}
.pf-radio-btn-input-wrapper {
  background-color: white;
  border: 1px solid #323945;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: inline-block;
  position: relative;
}
.pf-radio-btn-input-wrapper.pf-radio-btn-input-wrapper-checked {
  border: 2px solid #0e68f9;
}
.pf-radio-btn-input-wrapper.pf-radio-btn-input-wrapper-checked:after {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  background: #0e68f9;
  border-radius: 50%;
  z-index: 10;
  animation-fill-mode: both;
  content: '';
}
.placeholder-grey-7::placeholder {
  color: #bfc8d5;
}
.placeholder-grey-8::placeholder {
  color: #8f98a9;
}
.pf-theme .ant-card {
  box-shadow: 0 1px 6px 0 rgba(50, 57, 69, 0.1);
  border-radius: 4px;
  overflow: hidden;
}
.pf-theme .ant-card.inner-card {
  border: 1px solid #f5f7f9;
}
.pf-theme .ant-card.inner-card:before {
  height: 0;
}
.pf-theme .ant-card.inner-card .ant-card-head-title {
  font-size: 26px;
}
.pf-theme .ant-card.inner-card .ant-card-wider-padding {
  padding: 0;
}
.pf-theme .ant-card-padding-none .ant-card-body {
  padding: 0;
}
.pf-theme .ant-card-padding-sm .ant-card-body {
  padding: 12px;
}
.pf-theme .ant-card .inner-card__label {
  font-size: 18px;
  font-weight: 500;
  color: #6b7179;
}
.pf-theme .ant-card .inner-card__footer {
  margin-top: 12px;
  border: 0;
}
.pf-theme .ant-card .inner-card--with-icon {
  position: relative;
}
.pf-theme .ant-card .inner-card--with-icon:before {
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-top: 36px solid #0e68f9;
  border-left: 36px solid #fff;
}
.pf-theme .ant-card .inner-card--with-icon:after {
  position: absolute;
  top: 3px;
  right: 4px;
  font-size: 12px;
  font-family: 'anticon';
  content: '\\e660';
  color: #fff;
}
.pf-theme .ant-card.questionnaire-card .ant-card-body {
  padding-top: 14px;
  padding-bottom: 14px;
}
.pf-theme .ant-card.questionnaire-card.ant-card-padding-none .ant-card-body {
  padding-bottom: 0 !important;
}
.pf-theme .ant-card.crosstab-card .ant-card-body {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 42px;
}
.pf-theme .ant-card-head-wrapper {
  align-items: center;
}
.pf-theme .ant-card-head-title {
  color: #323945;
  font-weight: 400;
  font-size: 26px;
  line-height: 1;
  padding: 24px 0;
}
.pf-theme .ant-card-head {
  padding: 0 24px;
  border-bottom: 0;
}
.pf-theme .ant-card-body {
  padding: 24px;
}
.pf-theme .ant-card__main-alert {
  margin-top: -24px;
}
.pf-theme .ant-card-footer {
  border-top: 1px solid #eef1f4;
  margin: 0 -24px;
  padding: 24px 36px 0 36px;
}
.pf-theme .card-payment-method {
  margin: 12px 0 24px;
}
.pf-theme .card-payment-method .ant-card-head {
  padding: 0 16px;
}
.pf-theme .card-payment-method .ant-card-body {
  padding: 0 16px 16px;
}
.pf-theme .card-payment-method .ant-card-head-title {
  font-size: 15px;
  cursor: pointer;
  padding: 16px 0;
}
.pf-theme .card-payment-method .ant-card-head-title span {
  font-size: 15px;
}
.pf-theme .card-payment-method .ant-card-extra {
  font-size: 11px;
  color: #0e68f9;
}
.pf-theme .card-payment-method__flex-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 12px;
}
.pf-theme .card-payment-method--is-active .ant-card-head-title {
  color: #0e68f9;
}
.pf-theme .card-payment-method--is-active.ant-card {
  border-color: #0e68f9;
}
.pf-theme .card-payment-method--is-active .ant-card-body {
  display: block;
}
.pf-theme .card-payment-method--is-hidden .ant-card-body {
  display: none;
}
.pf-theme .ant-card-grey {
  background-color: #fafafa;
}
.pf-theme .ant-card-resizable {
  height: calc(100% - 24px) !important;
}
.pf-theme .ant-card-no-shadow {
  -webkit-box-shadow: 0;
  -moz-box-shadow: 0;
  box-shadow: 0;
}
.piped-attribute-wrapper {
  display: inline-block;
  position: relative;
  height: 16px;
}
.piped-attribute-wrapper:before {
  content: '';
  position: absolute;
  top: 0;
  left: -2px;
  right: 0;
  height: 1px;
  z-index: 0;
  border: 1px solid #e7ebef;
  background-color: #f9fafc;
  padding: 2px 6px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  height: 20px;
}
.piped-attribute-wrapper {
  display: inline-flex;
}
.piped-attribute {
  display: inline-block;
  color: #5c6776;
  z-index: 2;
  font-weight: 400;
  margin: 0 4px;
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
}
.piped-attribute-normal-text {
  display: inline-flex;
}
.pf-new-theme .crosstabs-page .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  top: 10px;
}
.crosstabs-page .ant-collapse-header {
  margin-left: 0 !important;
}
.pf-new-theme .crosstabs-page .ant-card.ant-card-padding-none.questionnaire-card .ant-card-body {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.question-answers-divider {
  position: relative;
}
.question-answers-divider::before {
  content: '';
  position: absolute;
  top: -30px;
  left: -42px;
  width: calc(100% + 42px);
  height: 1px;
  background-color: #f3f6fb;
  z-index: 1;
}
.question-answers-divider::after {
  content: '';
  position: absolute;
  top: 0;
  left: -42px;
  width: calc(100% + 42px);
  height: 1px;
  background-color: #f3f6fb;
  z-index: 1;
}
.answer-divider-btm {
  position: relative;
}
.answer-divider-btm::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: -82px;
  width: calc(100% + 107px);
  height: 1px;
  background-color: #f3f6fb;
  z-index: 1;
}
.ant-alert {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  word-wrap: break-word;
  border-radius: 4px;
}
.ant-alert-content {
  flex: 1;
  min-width: 0;
}
.ant-alert-icon {
  margin-right: 8px;
}
.ant-alert-description {
  display: none;
  font-size: 15px;
  line-height: 23px;
}
.ant-alert-success {
  background-color: #edfcf2;
  border: 1px solid #b6e3c8;
}
.ant-alert-success .ant-alert-icon {
  color: #3dbd7d;
}
.ant-alert-info {
  background-color: #e6f9ff;
  border: 1px solid #8cdbff;
}
.ant-alert-info .ant-alert-icon {
  color: #108ee9;
}
.ant-alert-warning {
  background-color: #fffef0;
  border: 1px solid #fff2a6;
}
.ant-alert-warning .ant-alert-icon {
  color: #ffca2b;
}
.ant-alert-error {
  background-color: #fff1f0;
  border: 1px solid #ffd8d6;
}
.ant-alert-error .ant-alert-icon {
  color: #f1565d;
}
.ant-alert-error .ant-alert-description > pre {
  margin: 0;
  padding: 0;
}
.ant-alert-action {
  margin-left: 8px;
}
.ant-alert-close-icon {
  margin-left: 8px;
  padding: 0;
  overflow: hidden;
  font-size: 12px;
  line-height: 12px;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}
.ant-alert-close-icon .anticon-close {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}
.ant-alert-close-icon .anticon-close:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-alert-close-text {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}
.ant-alert-close-text:hover {
  color: rgba(0, 0, 0, 0.75);
}
.ant-alert-with-description {
  align-items: flex-start;
  padding: 15px 15px 15px 24px;
}
.ant-alert-with-description.ant-alert-no-icon {
  padding: 15px 15px;
}
.ant-alert-with-description .ant-alert-icon {
  margin-right: 15px;
  font-size: 24px;
}
.ant-alert-with-description .ant-alert-message {
  display: block;
  margin-bottom: 4px;
  color: #323945;
  font-size: 17px;
}
.ant-alert-message {
  color: #323945;
}
.ant-alert-with-description .ant-alert-description {
  display: block;
}
.ant-alert.ant-alert-motion-leave {
  overflow: hidden;
  opacity: 1;
  transition: max-height 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-top 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), padding-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), margin-bottom 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-alert.ant-alert-motion-leave-active {
  max-height: 0;
  margin-bottom: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}
.ant-alert-banner {
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
}
.ant-alert.ant-alert-rtl {
  direction: rtl;
}
.ant-alert-rtl.ant-alert.ant-alert-no-icon {
  padding: 8px 15px;
}
.ant-alert-rtl .ant-alert-icon {
  margin-right: auto;
  margin-left: 8px;
}
.ant-alert-rtl .ant-alert-action {
  margin-right: 8px;
  margin-left: auto;
}
.ant-alert-rtl .ant-alert-close-icon {
  margin-right: 8px;
  margin-left: auto;
}
.ant-alert-rtl.ant-alert-with-description .ant-alert-icon {
  margin-right: auto;
  margin-left: 15px;
}
.pf-theme .ant-alert:not(.default-alert) {
  background-color: #ffffff;
  padding-right: 32px;
}
.pf-theme .ant-alert:not(.default-alert):before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  display: block;
  width: 5px;
  background-color: #323945;
  height: 100%;
}
.pf-theme .ant-alert-default:not(.default-alert) {
  border: 1px solid #eef1f4;
}
.pf-theme .ant-alert-default:not(.default-alert) .ant-alert-message,
.pf-theme .ant-alert-default:not(.default-alert) .ant-alert-icon {
  color: #74859b;
}
.pf-theme .ant-alert-default:not(.default-alert):before {
  background-color: #495561;
}
.pf-theme .ant-alert-success:not(.default-alert) {
  border: 1px solid #3dbd7d;
  background-color: #ffffff;
}
.pf-theme .ant-alert-success:not(.default-alert) .ant-alert-message,
.pf-theme .ant-alert-success:not(.default-alert) .ant-alert-icon,
.pf-theme .ant-alert-success:not(.default-alert) a {
  color: #3dbd7d;
}
.pf-theme .ant-alert-success:not(.default-alert):before {
  background-color: #3dbd7d;
}
.pf-theme .ant-alert-info:not(.default-alert) {
  border: 1px solid #108ee9;
  background-color: #ffffff;
}
.pf-theme .ant-alert-info:not(.default-alert) .ant-alert-message,
.pf-theme .ant-alert-info:not(.default-alert) .ant-alert-icon,
.pf-theme .ant-alert-info:not(.default-alert) a {
  color: #108ee9;
}
.pf-theme .ant-alert-info:not(.default-alert):before {
  background-color: #108ee9;
}
.pf-theme .ant-alert-warning:not(.default-alert) {
  border: 1px solid #ffca2b;
  background-color: #ffffff;
}
.pf-theme .ant-alert-warning:not(.default-alert) .ant-alert-message,
.pf-theme .ant-alert-warning:not(.default-alert) .ant-alert-icon,
.pf-theme .ant-alert-warning:not(.default-alert) a {
  color: #ffca2b;
}
.pf-theme .ant-alert-warning:not(.default-alert):before {
  background-color: #ffca2b;
}
.pf-theme .ant-alert-error:not(.default-alert) {
  border: 1px solid #f1565d;
  background-color: #ffffff;
}
.pf-theme .ant-alert-error:not(.default-alert) .ant-alert-message,
.pf-theme .ant-alert-error:not(.default-alert) .ant-alert-icon,
.pf-theme .ant-alert-error:not(.default-alert) a {
  color: #f1565d;
}
.pf-theme .ant-alert-error:not(.default-alert):before {
  background-color: #f1565d;
}
.pf-theme .ant-alert-with-description .ant-alert-description {
  color: #323945;
  line-height: 18px;
}
.pf-theme .ant-alert.no-side-border {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}
.pf-theme .ant-alert.no-border-bottom {
  border-bottom: 0;
}
.pf-theme .ant-alert.no-border-top {
  border-top: 0;
}
.pf-theme .ant-alert.no-indicator:before {
  display: none;
}
.pf-theme .ant-alert.warning-batch-text {
  border: none;
  font-size: 12px;
  line-height: 14px;
  padding: 8px;
  background-color: #fef9d3;
}
.pf-theme .ant-alert.warning-batch-text .ant-alert-icon {
  margin-right: 4px;
}
.pf-theme .ant-alert.warning-batch-text .ant-alert-close-icon {
  font-size: 10px;
  line-height: 10px;
}
.pf-theme .ant-alert.info-checkout-peeq-message {
  border: none;
  border-radius: 4px;
  font-size: 12px;
  line-height: 16px;
  padding: 8px;
  background-color: #ECF3FE;
  align-items: flex-start;
}
.pf-theme .ant-alert.info-checkout-peeq-message .ant-alert-icon {
  margin-right: 8px;
  color: #0e68f9;
  margin-top: 1px;
}
.pf-theme .ant-alert-banner {
  border-radius: 0;
  border: 0;
  margin-bottom: 0;
}
.pf-theme .ant-alert-banner:before {
  display: none;
}
.ant-pagination {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
}
.ant-pagination ul,
.ant-pagination ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-pagination::after {
  display: block;
  clear: both;
  height: 0;
  overflow: hidden;
  visibility: hidden;
  content: ' ';
}
.ant-pagination-total-text {
  display: inline-block;
  height: 32px;
  margin-right: 8px;
  line-height: 30px;
  vertical-align: middle;
}
.ant-pagination-item {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  margin-right: 8px;
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: 0;
  cursor: pointer;
  user-select: none;
}
.ant-pagination-item a {
  display: block;
  padding: 0 6px;
  color: #495561;
  transition: none;
}
.ant-pagination-item a:hover {
  text-decoration: none;
}
.ant-pagination-item:focus-visible,
.ant-pagination-item:hover {
  border-color: #0e68f9;
  transition: all 0.3s;
}
.ant-pagination-item:focus-visible a,
.ant-pagination-item:hover a {
  color: #0e68f9;
}
.ant-pagination-item-active {
  font-weight: 500;
  background: #fff;
  border-color: #0e68f9;
}
.ant-pagination-item-active a {
  color: #0e68f9;
}
.ant-pagination-item-active:focus-visible,
.ant-pagination-item-active:hover {
  border-color: #388bff;
}
.ant-pagination-item-active:focus-visible a,
.ant-pagination-item-active:hover a {
  color: #388bff;
}
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  outline: 0;
}
.ant-pagination-jump-prev .ant-pagination-item-container,
.ant-pagination-jump-next .ant-pagination-item-container {
  position: relative;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  color: #0e68f9;
  font-size: 12px;
  letter-spacing: -1px;
  opacity: 0;
  transition: all 0.2s;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon-svg,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon-svg {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  margin: auto;
  color: rgba(0, 0, 0, 0.25);
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 2px;
  text-align: center;
  text-indent: 0.13em;
  opacity: 1;
  transition: all 0.2s;
}
.ant-pagination-jump-prev:focus-visible .ant-pagination-item-link-icon,
.ant-pagination-jump-next:focus-visible .ant-pagination-item-link-icon,
.ant-pagination-jump-prev:hover .ant-pagination-item-link-icon,
.ant-pagination-jump-next:hover .ant-pagination-item-link-icon {
  opacity: 1;
}
.ant-pagination-jump-prev:focus-visible .ant-pagination-item-ellipsis,
.ant-pagination-jump-next:focus-visible .ant-pagination-item-ellipsis,
.ant-pagination-jump-prev:hover .ant-pagination-item-ellipsis,
.ant-pagination-jump-next:hover .ant-pagination-item-ellipsis {
  opacity: 0;
}
.ant-pagination-prev,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  margin-right: 8px;
}
.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-jump-prev,
.ant-pagination-jump-next {
  display: inline-block;
  min-width: 32px;
  height: 32px;
  color: #495561;
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  line-height: 32px;
  text-align: center;
  vertical-align: middle;
  list-style: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-pagination-prev,
.ant-pagination-next {
  font-family: Arial, Helvetica, sans-serif;
  outline: 0;
}
.ant-pagination-prev button,
.ant-pagination-next button {
  color: #495561;
  cursor: pointer;
  user-select: none;
}
.ant-pagination-prev:hover button,
.ant-pagination-next:hover button {
  border-color: #388bff;
}
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s;
}
.ant-pagination-prev:focus-visible .ant-pagination-item-link,
.ant-pagination-next:focus-visible .ant-pagination-item-link,
.ant-pagination-prev:hover .ant-pagination-item-link,
.ant-pagination-next:hover .ant-pagination-item-link {
  color: #0e68f9;
  border-color: #0e68f9;
}
.ant-pagination-disabled,
.ant-pagination-disabled:hover,
.ant-pagination-disabled:focus-visible {
  cursor: not-allowed;
}
.ant-pagination-disabled .ant-pagination-item-link,
.ant-pagination-disabled:hover .ant-pagination-item-link,
.ant-pagination-disabled:focus-visible .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination-slash {
  margin: 0 10px 0 5px;
}
.ant-pagination-options {
  display: inline-block;
  margin-left: 16px;
  vertical-align: middle;
}
@media all and (-ms-high-contrast: none) {
  .ant-pagination-options *::-ms-backdrop,
  .ant-pagination-options {
    vertical-align: top;
  }
}
.ant-pagination-options-size-changer.ant-select {
  display: inline-block;
  width: auto;
}
.ant-pagination-options-quick-jumper {
  display: inline-block;
  height: 32px;
  margin-left: 8px;
  line-height: 32px;
  vertical-align: top;
}
.ant-pagination-options-quick-jumper input {
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 4px 11px;
  color: #495561;
  font-size: 15px;
  line-height: 1.5;
  background-color: #fff;
  background-image: none;
  border: 1px solid #bfc8d5;
  border-radius: 4px;
  transition: all 0.3s;
  width: 50px;
  height: 32px;
  margin: 0 8px;
}
.ant-pagination-options-quick-jumper input::-moz-placeholder {
  opacity: 1;
}
.ant-pagination-options-quick-jumper input::placeholder {
  color: #bfbfbf;
}
.ant-pagination-options-quick-jumper input:placeholder-shown {
  text-overflow: ellipsis;
}
.ant-pagination-options-quick-jumper input:hover {
  border-color: #0e68f9;
  border-right-width: 1px !important;
}
.ant-pagination-options-quick-jumper input:focus,
.ant-pagination-options-quick-jumper input-focused {
  border-color: #388bff;
  border-right-width: 1px !important;
  outline: 0;
  box-shadow: 0 0 2px 0 rgba(14, 104, 249, 0.2);
}
.ant-pagination-options-quick-jumper input-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #bfc8d5;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input-disabled:hover {
  border-color: #bfc8d5;
  border-right-width: 1px !important;
}
.ant-pagination-options-quick-jumper input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
  border-color: #bfc8d5;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 1;
}
.ant-pagination-options-quick-jumper input[disabled]:hover {
  border-color: #bfc8d5;
  border-right-width: 1px !important;
}
.ant-pagination-options-quick-jumper input-borderless,
.ant-pagination-options-quick-jumper input-borderless:hover,
.ant-pagination-options-quick-jumper input-borderless:focus,
.ant-pagination-options-quick-jumper input-borderless-focused,
.ant-pagination-options-quick-jumper input-borderless-disabled,
.ant-pagination-options-quick-jumper input-borderless[disabled] {
  background-color: transparent;
  border: none;
  box-shadow: none;
}
textarea.ant-pagination-options-quick-jumper input {
  max-width: 100%;
  height: auto;
  min-height: 32px;
  line-height: 1.5;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
}
.ant-pagination-options-quick-jumper input-lg {
  padding: 6px 11px;
  font-size: 17px;
}
.ant-pagination-options-quick-jumper input-sm {
  padding: 1px 7px;
}
.ant-pagination-simple .ant-pagination-prev,
.ant-pagination-simple .ant-pagination-next {
  height: 24px;
  line-height: 24px;
  vertical-align: top;
}
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link {
  height: 24px;
  background-color: transparent;
  border: 0;
}
.ant-pagination-simple .ant-pagination-prev .ant-pagination-item-link::after,
.ant-pagination-simple .ant-pagination-next .ant-pagination-item-link::after {
  height: 24px;
  line-height: 24px;
}
.ant-pagination-simple .ant-pagination-simple-pager {
  display: inline-block;
  height: 24px;
  margin-right: 8px;
}
.ant-pagination-simple .ant-pagination-simple-pager input {
  box-sizing: border-box;
  height: 100%;
  margin-right: 8px;
  padding: 0 6px;
  text-align: center;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.3s;
}
.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #0e68f9;
}
.ant-pagination-simple .ant-pagination-simple-pager input[disabled] {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination.mini .ant-pagination-total-text,
.ant-pagination.mini .ant-pagination-simple-pager {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-item {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 22px;
}
.ant-pagination.mini .ant-pagination-item:not(.ant-pagination-item-active) {
  background: transparent;
  border-color: transparent;
}
.ant-pagination.mini .ant-pagination-prev,
.ant-pagination.mini .ant-pagination-next {
  min-width: 24px;
  height: 24px;
  margin: 0;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link,
.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link {
  background: transparent;
  border-color: transparent;
}
.ant-pagination.mini .ant-pagination-prev .ant-pagination-item-link::after,
.ant-pagination.mini .ant-pagination-next .ant-pagination-item-link::after {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-jump-prev,
.ant-pagination.mini .ant-pagination-jump-next {
  height: 24px;
  margin-right: 0;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-options {
  margin-left: 2px;
}
.ant-pagination.mini .ant-pagination-options-size-changer {
  top: 0px;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper {
  height: 24px;
  line-height: 24px;
}
.ant-pagination.mini .ant-pagination-options-quick-jumper input {
  padding: 1px 7px;
  width: 44px;
  height: 24px;
}
.ant-pagination.ant-pagination-disabled {
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item {
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item a {
  color: rgba(0, 0, 0, 0.25);
  background: transparent;
  border: none;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {
  background: #e6e6e6;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
  color: rgba(0, 0, 0, 0.25);
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  color: rgba(0, 0, 0, 0.25);
  background: #f5f5f5;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-pagination-simple.ant-pagination.ant-pagination-disabled .ant-pagination-item-link {
  background: transparent;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-link-icon {
  opacity: 0;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-ellipsis {
  opacity: 1;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-simple-pager {
  color: rgba(0, 0, 0, 0.25);
}
@media only screen and (max-width: 1199px) {
  .ant-pagination-item-after-jump-prev,
  .ant-pagination-item-before-jump-next {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .ant-pagination-options {
    display: none;
  }
}
.ant-pagination-rtl .ant-pagination-total-text {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl .ant-pagination-item,
.ant-pagination-rtl .ant-pagination-prev,
.ant-pagination-rtl .ant-pagination-jump-prev,
.ant-pagination-rtl .ant-pagination-jump-next {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl .ant-pagination-slash {
  margin: 0 5px 0 10px;
}
.ant-pagination-rtl .ant-pagination-options {
  margin-right: 16px;
  margin-left: 0;
}
.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-size-changer.ant-select {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl .ant-pagination-options .ant-pagination-options-quick-jumper {
  margin-left: 0;
}
.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl.ant-pagination-simple .ant-pagination-simple-pager input {
  margin-right: 0;
  margin-left: 8px;
}
.ant-pagination-rtl.ant-pagination.mini .ant-pagination-options {
  margin-right: 2px;
  margin-left: 0;
}
.pf-theme .ant-pagination.ant-table-pagination {
  float: none;
  display: flex;
  justify-content: center;
  min-height: 44px;
  padding: 36px 24px;
}
.pf-theme .ant-pagination-item-active {
  background-color: #0e68f9;
}
.pf-theme .ant-pagination-item-active a {
  color: #ffffff;
}
.pf-theme .ant-pagination-item-active:focus a,
.pf-theme .ant-pagination-item-active:hover a {
  color: #ffffff;
}
.pf-theme .ant-pagination .ant-pagination-total-text {
  position: absolute;
  bottom: 0;
  font-size: 13px;
  margin: 0;
}
.ant-table.ant-table-middle {
  font-size: 15px;
}
.ant-table.ant-table-middle .ant-table-title,
.ant-table.ant-table-middle .ant-table-footer,
.ant-table.ant-table-middle .ant-table-thead > tr > th,
.ant-table.ant-table-middle .ant-table-tbody > tr > td,
.ant-table.ant-table-middle tfoot > tr > th,
.ant-table.ant-table-middle tfoot > tr > td {
  padding: 12px 8px;
}
.ant-table.ant-table-middle .ant-table-filter-trigger {
  margin-right: -4px;
}
.ant-table.ant-table-middle .ant-table-expanded-row-fixed {
  margin: -12px -8px;
}
.ant-table.ant-table-middle .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -12px -8px -12px 25px;
}
.ant-table.ant-table-small {
  font-size: 15px;
}
.ant-table.ant-table-small .ant-table-title,
.ant-table.ant-table-small .ant-table-footer,
.ant-table.ant-table-small .ant-table-thead > tr > th,
.ant-table.ant-table-small .ant-table-tbody > tr > td,
.ant-table.ant-table-small tfoot > tr > th,
.ant-table.ant-table-small tfoot > tr > td {
  padding: 8px 8px;
}
.ant-table.ant-table-small .ant-table-filter-trigger {
  margin-right: -4px;
}
.ant-table.ant-table-small .ant-table-expanded-row-fixed {
  margin: -8px -8px;
}
.ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
  margin: -8px -8px -8px 25px;
}
.ant-table-small .ant-table-thead > tr > th {
  background-color: #f0f0f0;
}
.ant-table-small .ant-table-selection-column {
  width: 46px;
  min-width: 46px;
}
.ant-table.ant-table-bordered > .ant-table-title {
  border: 1px solid #f0f0f0;
  border-bottom: 0;
}
.ant-table.ant-table-bordered > .ant-table-container {
  border-left: 1px solid #f0f0f0;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > td,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > td {
  border-right: 1px solid #f0f0f0;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr:not(:last-child) > th,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr:not(:last-child) > th {
  border-bottom: 1px solid #f0f0f0;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > th::before,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > th::before,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > th::before,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > th::before {
  background-color: transparent !important;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > thead > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tfoot > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tfoot > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tfoot > tr > .ant-table-cell-fix-right-first::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tfoot > tr > .ant-table-cell-fix-right-first::after {
  border-right: 1px solid #f0f0f0;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -16px -17px;
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed::after,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-summary > table > tbody > tr > td > .ant-table-expanded-row-fixed::after {
  position: absolute;
  top: 0;
  right: 1px;
  bottom: 0;
  border-right: 1px solid #f0f0f0;
  content: '';
}
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table,
.ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table {
  border-top: 1px solid #f0f0f0;
}
.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-expanded-row > td,
.ant-table.ant-table-bordered.ant-table-scroll-horizontal > .ant-table-container > .ant-table-body > table > tbody > tr.ant-table-placeholder > td {
  border-right: 0;
}
.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered.ant-table-middle > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -12px -9px;
}
.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-content > table > tbody > tr > td > .ant-table-expanded-row-fixed,
.ant-table.ant-table-bordered.ant-table-small > .ant-table-container > .ant-table-body > table > tbody > tr > td > .ant-table-expanded-row-fixed {
  margin: -8px -9px;
}
.ant-table.ant-table-bordered > .ant-table-footer {
  border: 1px solid #f0f0f0;
  border-top: 0;
}
.ant-table-cell .ant-table-container:first-child {
  border-top: 0;
}
.ant-table-cell-scrollbar {
  box-shadow: 0 1px 0 1px #f0f0f0;
}
.ant-table-wrapper {
  clear: both;
  max-width: 100%;
}
.ant-table-wrapper::before {
  display: table;
  content: '';
}
.ant-table-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-table-wrapper::before {
  display: table;
  content: '';
}
.ant-table-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-table {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  font-size: 15px;
  background: #fff;
  border-radius: 4px;
}
.ant-table table {
  width: 100%;
  text-align: left;
  border-radius: 4px 4px 0 0;
  border-collapse: separate;
  border-spacing: 0;
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > td,
.ant-table tfoot > tr > th,
.ant-table tfoot > tr > td {
  position: relative;
  padding: 16px 16px;
  overflow-wrap: break-word;
}
.ant-table-cell-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: keep-all;
}
.ant-table-cell-ellipsis.ant-table-cell-fix-left-last,
.ant-table-cell-ellipsis.ant-table-cell-fix-right-first {
  overflow: visible;
}
.ant-table-cell-ellipsis.ant-table-cell-fix-left-last .ant-table-cell-content,
.ant-table-cell-ellipsis.ant-table-cell-fix-right-first .ant-table-cell-content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ant-table-cell-ellipsis .ant-table-column-title {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: keep-all;
}
.ant-table-title {
  padding: 16px 16px;
}
.ant-table-footer {
  padding: 16px 16px;
  color: #323945;
  background: #fafafa;
}
.ant-table-thead > tr > th {
  position: relative;
  color: #323945;
  font-weight: 500;
  text-align: left;
  background: #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s ease;
}
.ant-table-thead > tr > th[colspan]:not([colspan='1']) {
  text-align: center;
}
.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  position: absolute;
  top: 50%;
  right: 0;
  width: 1px;
  height: 1.6em;
  background-color: rgba(0, 0, 0, 0.06);
  transform: translateY(-50%);
  transition: background-color 0.3s;
  content: '';
}
.ant-table-thead > tr:not(:last-child) > th[colspan] {
  border-bottom: 0;
}
.ant-table-tbody > tr > td {
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.3s;
}
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table {
  margin: -16px -16px -16px 33px;
}
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td {
  border-bottom: 0;
}
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:first-child,
.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child,
.ant-table-tbody > tr > td > .ant-table-expanded-row-fixed > .ant-table-wrapper:only-child .ant-table-tbody > tr:last-child > td:last-child {
  border-radius: 0;
}
.ant-table-tbody > tr.ant-table-row:hover > td {
  background: #e6f4ff;
}
.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #fafafa;
  border-color: rgba(0, 0, 0, 0.03);
}
.ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: #f5f5f5;
}
.ant-table-summary {
  position: relative;
  z-index: 2;
  background: #fff;
}
div.ant-table-summary {
  box-shadow: 0 -1px 0 #f0f0f0;
}
.ant-table-summary > tr > th,
.ant-table-summary > tr > td {
  border-bottom: 1px solid #f0f0f0;
}
.ant-table-pagination.ant-pagination {
  margin: 16px 0;
}
.ant-table-pagination {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
}
.ant-table-pagination > * {
  flex: none;
}
.ant-table-pagination-left {
  justify-content: flex-start;
}
.ant-table-pagination-center {
  justify-content: center;
}
.ant-table-pagination-right {
  justify-content: flex-end;
}
.ant-table-thead th.ant-table-column-has-sorters {
  cursor: pointer;
  transition: all 0.3s;
}
.ant-table-thead th.ant-table-column-has-sorters:hover {
  background: rgba(0, 0, 0, 0.04);
}
.ant-table-thead th.ant-table-column-has-sorters:hover::before {
  background-color: transparent !important;
}
.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-left:hover,
.ant-table-thead th.ant-table-column-has-sorters.ant-table-cell-fix-right:hover {
  background: #f5f5f5;
}
.ant-table-thead th.ant-table-column-sort {
  background: #f5f5f5;
}
.ant-table-thead th.ant-table-column-sort::before {
  background-color: transparent !important;
}
td.ant-table-column-sort {
  background: #fafafa;
}
.ant-table-column-title {
  position: relative;
  z-index: 1;
  flex: 1;
}
.ant-table-column-sorters {
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: space-between;
}
.ant-table-column-sorters::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
}
.ant-table-column-sorter {
  color: #bfbfbf;
  font-size: 0;
  transition: color 0.3s;
}
.ant-table-column-sorter-inner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.ant-table-column-sorter-up,
.ant-table-column-sorter-down {
  font-size: 11px;
}
.ant-table-column-sorter-up.active,
.ant-table-column-sorter-down.active {
  color: #0e68f9;
}
.ant-table-column-sorter-up + .ant-table-column-sorter-down {
  margin-top: -0.3em;
}
.ant-table-column-sorters:hover .ant-table-column-sorter {
  color: #a6a6a6;
}
.ant-table-filter-column {
  display: flex;
  justify-content: space-between;
}
.ant-table-filter-trigger {
  position: relative;
  display: flex;
  align-items: center;
  margin: -4px -8px -4px 4px;
  padding: 0 4px;
  color: #bfbfbf;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-table-filter-trigger:hover {
  color: rgba(0, 0, 0, 0.45);
  background: rgba(0, 0, 0, 0.04);
}
.ant-table-filter-trigger.active {
  color: #0e68f9;
}
.ant-table-filter-dropdown {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  min-width: 120px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 264px;
  overflow-x: hidden;
  border: 0;
  box-shadow: none;
}
.ant-table-filter-dropdown-submenu > ul {
  max-height: calc(100vh - 130px);
  overflow-x: hidden;
  overflow-y: auto;
}
.ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {
  padding-left: 8px;
}
.ant-table-filter-dropdown-btns {
  display: flex;
  justify-content: space-between;
  padding: 7px 8px 7px 3px;
  overflow: hidden;
  background-color: inherit;
  border-top: 1px solid #f0f0f0;
}
.ant-table-selection-col {
  width: 32px;
}
.ant-table-bordered .ant-table-selection-col {
  width: 50px;
}
table tr th.ant-table-selection-column,
table tr td.ant-table-selection-column {
  padding-right: 8px;
  padding-left: 8px;
  text-align: center;
}
table tr th.ant-table-selection-column .ant-radio-wrapper,
table tr td.ant-table-selection-column .ant-radio-wrapper {
  margin-right: 0;
}
table tr th.ant-table-selection-column::after {
  background-color: transparent !important;
}
.ant-table-selection {
  position: relative;
  display: inline-flex;
  flex-direction: column;
}
.ant-table-selection-extra {
  position: absolute;
  top: 0;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s;
  margin-inline-start: 100%;
  padding-inline-start: 4px;
}
.ant-table-selection-extra .anticon {
  color: #bfbfbf;
  font-size: 10px;
}
.ant-table-selection-extra .anticon:hover {
  color: #a6a6a6;
}
.ant-table-expand-icon-col {
  width: 48px;
}
.ant-table-row-expand-icon-cell {
  text-align: center;
}
.ant-table-row-indent {
  float: left;
  height: 1px;
}
.ant-table-row-expand-icon {
  color: #0e68f9;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s;
  position: relative;
  display: inline-flex;
  float: left;
  box-sizing: border-box;
  width: 17px;
  height: 17px;
  padding: 0;
  color: inherit;
  line-height: 17px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  outline: none;
  transform: scale(0.94117647);
  transition: all 0.3s;
  user-select: none;
}
.ant-table-row-expand-icon:focus,
.ant-table-row-expand-icon:hover {
  color: #388bff;
}
.ant-table-row-expand-icon:active {
  color: #024bd4;
}
.ant-table-row-expand-icon:focus,
.ant-table-row-expand-icon:hover,
.ant-table-row-expand-icon:active {
  border-color: currentColor;
}
.ant-table-row-expand-icon::before,
.ant-table-row-expand-icon::after {
  position: absolute;
  background: currentColor;
  transition: transform 0.3s ease-out;
  content: '';
}
.ant-table-row-expand-icon::before {
  top: 7px;
  right: 3px;
  left: 3px;
  height: 1px;
}
.ant-table-row-expand-icon::after {
  top: 3px;
  bottom: 3px;
  left: 7px;
  width: 1px;
  transform: rotate(90deg);
}
.ant-table-row-expand-icon-collapsed::before {
  transform: rotate(-180deg);
}
.ant-table-row-expand-icon-collapsed::after {
  transform: rotate(0deg);
}
.ant-table-row-expand-icon-spaced {
  background: transparent;
  border: 0;
  visibility: hidden;
}
.ant-table-row-expand-icon-spaced::before,
.ant-table-row-expand-icon-spaced::after {
  display: none;
  content: none;
}
.ant-table-row-indent + .ant-table-row-expand-icon {
  margin-top: 2.75px;
  margin-right: 8px;
}
tr.ant-table-expanded-row > td,
tr.ant-table-expanded-row:hover > td {
  background: #fbfbfb;
}
tr.ant-table-expanded-row .ant-descriptions-view {
  display: flex;
}
tr.ant-table-expanded-row .ant-descriptions-view table {
  flex: auto;
  width: auto;
}
.ant-table .ant-table-expanded-row-fixed {
  position: relative;
  margin: -16px -16px;
  padding: 16px 16px;
}
.ant-table-tbody > tr.ant-table-placeholder {
  text-align: center;
}
.ant-table-empty .ant-table-tbody > tr.ant-table-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-table-tbody > tr.ant-table-placeholder:hover > td {
  background: #fff;
}
.ant-table-cell-fix-left,
.ant-table-cell-fix-right {
  position: -webkit-sticky !important;
  position: sticky !important;
  z-index: 2;
  background: #fff;
}
.ant-table-cell-fix-left-first::after,
.ant-table-cell-fix-left-last::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: -1px;
  width: 30px;
  transform: translateX(100%);
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
}
.ant-table-cell-fix-right-first::after,
.ant-table-cell-fix-right-last::after {
  position: absolute;
  top: 0;
  bottom: -1px;
  left: 0;
  width: 30px;
  transform: translateX(-100%);
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
}
.ant-table .ant-table-container::before,
.ant-table .ant-table-container::after {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 30px;
  transition: box-shadow 0.3s;
  content: '';
  pointer-events: none;
}
.ant-table .ant-table-container::before {
  left: 0;
}
.ant-table .ant-table-container::after {
  right: 0;
}
.ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container {
  position: relative;
}
.ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-ping-left .ant-table-cell-fix-left-first::after,
.ant-table-ping-left .ant-table-cell-fix-left-last::after {
  box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-ping-left .ant-table-cell-fix-left-last::before {
  background-color: transparent !important;
}
.ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container {
  position: relative;
}
.ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container::after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-ping-right .ant-table-cell-fix-right-first::after,
.ant-table-ping-right .ant-table-cell-fix-right-last::after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.15);
}
.ant-table-sticky-holder {
  position: sticky;
  z-index: 3;
  background: #fff;
}
.ant-table-sticky-scroll {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
  opacity: 0.6;
}
.ant-table-sticky-scroll:hover {
  transform-origin: center bottom;
}
.ant-table-sticky-scroll-bar {
  height: 8px;
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}
.ant-table-sticky-scroll-bar:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.ant-table-sticky-scroll-bar-active {
  background-color: rgba(0, 0, 0, 0.8);
}
@media all and (-ms-high-contrast: none) {
  .ant-table-ping-left .ant-table-cell-fix-left-last::after {
    box-shadow: none !important;
  }
  .ant-table-ping-right .ant-table-cell-fix-right-first::after {
    box-shadow: none !important;
  }
}
.ant-table {
  /* title + table */
  /* table */
  /* table + footer */
}
.ant-table-title {
  border-radius: 4px 4px 0 0;
}
.ant-table-title + .ant-table-container {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.ant-table-title + .ant-table-container table > thead > tr:first-child th:first-child {
  border-radius: 0;
}
.ant-table-title + .ant-table-container table > thead > tr:first-child th:last-child {
  border-radius: 0;
}
.ant-table-container {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.ant-table-container table > thead > tr:first-child th:first-child {
  border-top-left-radius: 4px;
}
.ant-table-container table > thead > tr:first-child th:last-child {
  border-top-right-radius: 4px;
}
.ant-table-footer {
  border-radius: 0 0 4px 4px;
}
.ant-table-wrapper-rtl {
  direction: rtl;
}
.ant-table-rtl {
  direction: rtl;
}
.ant-table-wrapper-rtl .ant-table table {
  text-align: right;
}
.ant-table-wrapper-rtl .ant-table-thead > tr > th[colspan]:not([colspan='1']) {
  text-align: center;
}
.ant-table-wrapper-rtl .ant-table-thead > tr > th {
  text-align: right;
}
.ant-table-tbody > tr .ant-table-wrapper:only-child .ant-table.ant-table-rtl {
  margin: -16px 33px -16px -16px;
}
.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-left {
  justify-content: flex-end;
}
.ant-table-wrapper.ant-table-wrapper-rtl .ant-table-pagination-right {
  justify-content: flex-start;
}
.ant-table-wrapper-rtl .ant-table-column-sorter {
  margin-right: 8px;
  margin-left: 0;
}
.ant-table-wrapper-rtl .ant-table-filter-column-title {
  padding: 16px 16px 16px 2.3em;
}
.ant-table-rtl .ant-table-thead tr th.ant-table-column-has-sorters .ant-table-filter-column-title {
  padding: 0 0 0 2.3em;
}
.ant-table-wrapper-rtl .ant-table-filter-trigger-container {
  right: auto;
  left: 0;
}
.ant-dropdown-rtl .ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-dropdown-rtl .ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span,
.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown .ant-checkbox-wrapper + span,
.ant-dropdown-menu-submenu-rtl.ant-table-filter-dropdown-submenu .ant-checkbox-wrapper + span {
  padding-right: 8px;
  padding-left: 0;
}
.ant-table-wrapper-rtl .ant-table-selection {
  text-align: center;
}
.ant-table-wrapper-rtl .ant-table-row-indent {
  float: right;
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon {
  float: right;
}
.ant-table-wrapper-rtl .ant-table-row-indent + .ant-table-row-expand-icon {
  margin-right: 0;
  margin-left: 8px;
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon::after {
  transform: rotate(-90deg);
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed::before {
  transform: rotate(180deg);
}
.ant-table-wrapper-rtl .ant-table-row-expand-icon-collapsed::after {
  transform: rotate(0deg);
}
.pf-theme .ant-table-body-w-full .ant-table-body {
  margin: 0 !important;
}
.pf-theme .ant-table-small-text td,
.pf-theme .ant-table-small-text th {
  font-size: 12px !important;
}
.pf-theme .ant-table-wrapper.without-hover .ant-table tr.ant-table-row > td {
  background: unset;
}
.pf-theme .ant-table-wrapper.without-hover .ant-table tr.ant-table-row > td {
  border-left: 0;
}
.pf-theme .ant-table-wrapper.without-hover .ant-table:not(.ant-table-bordered) tr.ant-table-row > td {
  border-left: 1px solid #f0f0f0;
}
.pf-theme .ant-table-wrapper.without-hover .ant-table:not(.ant-table-bordered) tr.ant-table-row:hover > td {
  border-left: 1px solid #f0f0f0;
}
.pf-theme .force-background-transparent .ant-table {
  background: transparent !important;
}
.pf-theme .ant-table-thead > tr > th {
  border-right: 0;
  font-weight: 700;
  color: #323945;
  background-color: #eef3f7;
}
.pf-theme .ant-table-thead > tr > th:last-child {
  border-right: 1px solid #f0f0f0;
}
.pf-theme .ant-table-thead > tr.ant-table-row-hover:first-child,
.pf-theme .ant-table-tbody > tr.ant-table-row-hover:first-child,
.pf-theme .ant-table-thead > tr > td:first-child,
.pf-theme .ant-table-tbody > tr > td:first-child {
  border-left: 3px solid transparent;
}
.pf-theme .ant-table-thead > tr:hover > td,
.pf-theme .ant-table-tbody > tr:hover > td {
  background: #ffffff;
}
.pf-theme .ant-table-thead > tr:hover > td:first-child,
.pf-theme .ant-table-tbody > tr:hover > td:first-child {
  border-left-color: #0e68f9;
}
.pf-theme .ant-table-thead > tr.no-hover-effects:hover > td:first-child,
.pf-theme .ant-table-tbody > tr.no-hover-effects:hover > td:first-child {
  border-left-color: transparent;
}
.pf-theme .ant-table-thead > tr.active-row > td,
.pf-theme .ant-table-tbody > tr.active-row > td {
  background: #d5f1e3;
}
.pf-theme .ant-table-thead > tr.active-row > td:first-child,
.pf-theme .ant-table-tbody > tr.active-row > td:first-child {
  border-left-color: #3dbd7d;
  font-weight: 700;
}
.pf-theme .ant-table-thead > tr.active-row:hover > td:first-child,
.pf-theme .ant-table-tbody > tr.active-row:hover > td:first-child {
  border-left-color: #319664;
}
.pf-theme .ant-table-small {
  font-size: 13px;
}
.pf-theme .ant-loop-merge-table [data-testid='dropdown-actions'] {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 16px;
  min-width: 16px;
  height: 16px;
  line-height: 1;
  padding: 0;
  vertical-align: middle;
}
.pf-theme .ant-loop-merge-table .ant-table-thead .ant-table-cell {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pf-theme .ant-loop-merge-table .ant-table-cell {
  background-color: transparent !important;
}
.pf-theme .ant-loop-merge-table .ant-table-cell.ant-table-cell-fix-left,
.pf-theme .ant-loop-merge-table .ant-table-cell.ant-table-cell-fix-right {
  background-color: #f9fafc !important;
}
.pf-theme .ant-loop-merge-table .ant-table-bordered .ant-table-container {
  border-radius: 8px;
}
.pf-theme .ant-loop-merge-table .ant-table-bordered tbody tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
.pf-theme .ant-loop-merge-table .ant-table-bordered tbody tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}
.pf-theme .questionnaire-group.background-grey-1 .ant-loop-merge-table .ant-table-cell.ant-table-cell-fix-left,
.pf-theme .questionnaire-group.background-grey-1 .ant-loop-merge-table .ant-table-cell.ant-table-cell-fix-right {
  background-color: #ffffff !important;
}
.results-question-table {
  background-color: #f9fafc;
}
.results-question-table .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.results-question-table .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.results-question-table .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.results-question-table .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: unset;
  border-left: 0;
}
.results-question-table tr > td:first-child {
  border-right: 1px solid #e7ebef;
}
.results-question-table .ant-table-thead {
  background-color: white;
}
.results-question-table .ant-table-column-title {
  color: #8f98a9;
  font-weight: 500;
}
.questionnaire-card .matrix-table-cells {
  background-color: #f9fafc !important;
}
.questionnaire-card:hover .matrix-table-cells {
  background-color: white !important;
}
.questionnaire-card .matrix-table-cells--active {
  background-color: white !important;
}
.matrix-reorder-arrows {
  opacity: 0;
  pointer-events: none;
}
.matrix-reorder-container:hover > .matrix-reorder-arrows {
  opacity: 1;
  pointer-events: auto;
}
.matrix-table-header-cell {
  overflow: visible !important;
}
.matrix-table-header-cell:has(.drag-guide-left),
.matrix-table-header-cell:has(.drag-guide-right) {
  z-index: 5 !important;
}
body.is-dragging-matrix-column .ant-table-cell-fix-left,
body.is-dragging-matrix-column .ant-table-cell-fix-right {
  pointer-events: none;
}
.matrix-reorder-container {
  overflow: visible;
}
.ant-select:not(.ant-select-disabled) .ant-select-selector:focus .ant-select-selector-selected-value {
  color: #0e68f9;
}
.ant-select-search--inline .ant-select-search__field {
  color: #323945;
}
.pf-theme .ant-dropdown-trigger {
  border-color: #8f98a9;
}
.pf-theme .ant-dropdown-menu-item-active {
  background-color: #fb3b71;
}
.pf-theme .ant-dropdown-menu-item-active a {
  color: white;
  transition: none;
}
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-radius: 4px;
}
.ant-select:not(.ant-select-customize-input).ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
  border-color: #e7ebef;
}
.ant-select-arrow {
  width: auto;
  height: auto;
  margin-top: -10px;
}
.ant-select-selection-placeholder {
  position: absolute;
  top: 50%;
  right: 9px;
  left: 0;
  max-width: 100%;
  height: 20px;
  overflow: hidden;
  color: #bfbfbf;
  line-height: 20px;
  white-space: nowrap;
  text-align: left;
  text-overflow: ellipsis;
  transform: translateY(-50%);
}
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 1.5;
  padding-left: 11px;
}
.ant-select-single .ant-select-selector::after {
  content: none;
}
.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 20px 0 11px;
}
.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-placeholder {
  line-height: 1.5;
  color: #5c6776;
}
.pf-select.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  display: block;
  box-sizing: border-box;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-top-width: 1.02px;
  border-radius: 4px;
  outline: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
}
.pf-select.ant-select.pf-select-grey-dark .ant-select-selector {
  background-color: #f3f6fb;
  color: #5c6776;
  border: none;
}
.pf-select.ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 40px;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
  border-color: #e7ebef;
}
.pf-select.ant-select.ant-select-single.pf-select--short {
  height: 32px !important;
}
.pf-select.ant-select.ant-select-single.pf-select--short .ant-select-selector,
.pf-select.ant-select.ant-select-single.pf-select--short .ant-select-selection-item {
  padding: 0 5px 0 0;
  height: 32px !important;
  line-height: 32px !important;
  color: #323945;
}
.pf-select.ant-select.ant-select-single.pf-select--short .ant-select-selector-selected-value {
  padding-right: 10px;
}
.pf-select.ant-select.ant-select-single.pf-select--height-20 {
  height: 20px !important;
}
.pf-select.ant-select.ant-select-single.pf-select--height-20 .ant-select-selector,
.pf-select.ant-select.ant-select-single.pf-select--height-20 .ant-select-selection-item {
  padding: 0 5px 0 0;
  height: 20px !important;
  line-height: 20px !important;
  color: #323945;
}
.pf-select.ant-select.ant-select-single.pf-select--height-20 .ant-select-selector-selected-value {
  padding-right: 10px;
}
.pf-select.ant-select.ant-select-single.pf-select-button-dropdown:not(.ant-select-customize-input) .ant-select-selector {
  background-color: #0e68f9;
  border: 0;
}
.pf-select.ant-select.ant-select-single.pf-select-button-dropdown .ant-select-selection-placeholder {
  color: white !important;
  font-weight: bold;
}
.pf-select.ant-select.ant-select-single.pf-select-button-dropdown .ant-select-selector-selected-value,
.pf-select.ant-select.ant-select-single.pf-select-button-dropdown .ant-select-arrow {
  color: white !important;
}
.pf-select.ant-select.ant-select-disabled.ant-select-single .ant-select-selector,
.pf-select.ant-select.ant-select-disabled .ant-select-selector {
  border-color: #e7ebef;
  background-color: transparent;
}
.pf-select.ant-select.ant-select-disabled.ant-select-single .ant-select-selector .ant-select-selector-selected-value,
.pf-select.ant-select.ant-select-disabled .ant-select-selector .ant-select-selector-selected-value,
.pf-select.ant-select.ant-select-disabled.ant-select-single .ant-select-selector .ant-select-selection-item,
.pf-select.ant-select.ant-select-disabled .ant-select-selector .ant-select-selection-item {
  color: #bfc8d5 !important;
}
.pf-select.ant-select.ant-select-disabled.ant-select-single .ant-select-arrow,
.pf-select.ant-select.ant-select-disabled .ant-select-arrow {
  color: #bfc8d5 !important;
}
#carry-forward-panel .pf-select.ant-select.ant-select-disabled.ant-select-single .ant-select-selector,
#carry-forward-panel .pf-select.ant-select.ant-select-disabled .ant-select-selector {
  border-color: #e7ebef !important;
  background-color: #ffffff !important;
}
.pf-select:not(.pf-select-rule-operator) .ant-select-selector .ant-select-selector-selected-value {
  color: #323945;
}
.pf-select:not(.ant-select-disabled) .ant-select-selector:focus .ant-select-selector-selected-value {
  color: #323945;
}
.pf-select.pf-select--no-placeholder.ant-select-open .ant-select-selector .ant-select-selector-selected-value {
  color: #ffffff !important;
}
.pf-select.pf-select--no-padded-arrow .ant-select-selection-item {
  width: calc(100% - 45px);
}
.pf-select.pf-select--no-arrow .ant-select-selection-placeholder {
  padding-right: 0;
}
.pf-select.pf-select--no-arrow .ant-select-arrow {
  display: none;
}
.pf-select.pf-select--transparent.ant-select-disabled .ant-select-selector {
  background: transparent !important;
}
.pf-select.pf-select--green.pf-select--highlighted.ant-select {
  border-color: #323945 !important;
}
.pf-select.pf-select--green.pf-select--highlighted.ant-select .ant-select-selection-item {
  color: #323945 !important;
}
.pf-select.pf-select--green.pf-select--highlighted.ant-select .ant-select-arrow {
  color: #323945 !important;
}
.pf-select.pf-select--green .ant-select-selector {
  color: #323945 !important;
  background: #d0fef0 !important;
  border: 0 !important;
}
.pf-select.pf-select--green .ant-select-selection-placeholder {
  color: #323945 !important;
}
.pf-select.pf-select--green ~ div .ant-select-item-option.ant-select-item-option-active {
  background-color: #e6fff7 !important;
}
.pf-select.pf-select--green .ant-select-selection-placeholder {
  color: #bfc8d5 !important;
}
.pf-select.pf-select--flex-dropdown + div .ant-select-dropdown {
  width: initial !important;
  max-width: 320px;
  min-width: 120px;
}
.pf-select .ant-select-selection-item {
  line-height: 40px;
  padding-right: 30px;
  font-weight: bold;
}
.pf-select .ant-select-selector-selected-value {
  padding-right: 30px;
  font-weight: bold;
}
.pf-select .ant-select-selector-selected-value .pf-select--ellipsis-content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pf-select.ant-select-single.ant-select-open .ant-select-selection-item {
  color: #323945;
}
.pf-select.pf-select--max-width {
  max-width: 220px;
}
.pf-select.pf-select--small {
  height: 30px;
  font-size: 12px;
}
.pf-select.pf-select--small .ant-select-selection-item,
.pf-select.pf-select--small.ant-select-single,
.pf-select.pf-select--small .ant-select-selector {
  height: 30px !important;
  line-height: 30px !important;
}
.pf-select.pf-select--small .ant-select-selector-selected-value {
  padding-right: 10px;
}
.pf-select.pf-select--small .ant-select-arrow {
  font-size: 16px;
  margin-top: -7px;
}
.pf-select .ant-select-arrow {
  font-size: 18px;
  margin-top: -9px;
  color: #323945;
}
.pf-select .ant-select-selection-item {
  display: flex !important;
  align-items: center;
}
.pf-select.selected-item-block .ant-select-selector-selected-value {
  display: block !important;
}
.pf-select.pf-select--placeholder-grey-8 .ant-select-selection-placeholder {
  color: #8f98a9 !important;
}
.pf-select.pf-select--placeholder-grey-10 .ant-select-selection-placeholder {
  color: #323945 !important;
}
.pf-select.pf-select--placeholder-grey-7 .ant-select-selection-placeholder {
  color: #bfc8d5 !important;
}
.pf-select .ant-select-selection-placeholder {
  color: #bfc8d5 !important;
}
.pf-select.pf-select--highlight-options .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background: #ecf3fe !important;
  border-radius: 4px;
  margin: 0 4px;
  padding-left: 8px;
  color: #0e68f9;
}
.pf-select.pf-select--highlight-options .ant-select-dropdown {
  border-radius: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.pf-select.pf-select--highlight-selected .ant-select-selection-item {
  color: #0e68f9;
}
.pf-select.pf-select--highlight-selected .ant-select-arrow {
  color: #0e68f9 !important;
}
.pf-select.pf-select-question-type .ant-select-item-option-content {
  display: flex !important;
  align-items: center !important;
}
.pf-select-border-grey-4 .ant-select-selector {
  border-color: #f3f6fb;
}
.ant-select-item-option.ant-select-item-option-active {
  background-color: #e6f4ff !important;
}
.pf-select-grey .ant-select-selector {
  background-color: #f9fafc;
  color: #5c6776;
  border: none;
}
.pf-select--borderless .ant-select-selector {
  border: none !important;
  box-shadow: none !important;
}
.pf-select--borderless .ant-select-selection-item {
  margin-right: 8px !important;
  margin-left: 0;
}
.pf-select--borderless .ant-select-arrow {
  right: -4px;
}
.pf-select--text-normal .ant-select-selector-selected-value {
  font-weight: normal;
}
.pf-select-rule-operator.pf-select.ant-select.ant-select-single.pf-select--short {
  height: 34px;
}
.pf-select-rule-operator.pf-select.ant-select.ant-select-single.pf-select--short .ant-select-selector {
  background: transparent;
  border: none !important;
}
.pf-select-rule-operator .ant-select-arrow {
  right: -1px;
  top: 16px;
}
.pf-select-rule-operator .ant-select-selection-item {
  color: #323945;
  font-weight: bold;
  padding-right: 4px !important;
  text-align: center;
  display: block !important;
  width: 100%;
}
.ant-select.pf-select-rule-operator:not(.ant-select-disabled):not(.pf-select--green) .ant-select-selector:focus .ant-select-selection-item,
.ant-select.pf-select-inline-rule-operator:not(.ant-select-disabled):not(.pf-select--green) .ant-select-selector:focus .ant-select-selection-item {
  color: #9c75f6 !important;
}
.pf-select--highlighted.ant-select {
  border-color: #9c75f6 !important;
}
.pf-select--highlighted.ant-select .ant-select-selection-item {
  color: #9c75f6 !important;
}
.pf-select--highlighted.ant-select .ant-select-arrow {
  color: #9c75f6 !important;
}
.pf-select.ant-select-single.pf-select--short.pf-select-inline-rule-operator .ant-select-selector {
  border-color: #e0e6ed;
  padding: 0 5px 0 3px;
}
.pf-select.ant-select-single.pf-select--short.pf-select-inline-rule-operator .ant-select-selection-item {
  margin-right: 11px;
  padding: 0 5px 0 3px;
}
.pf-select.ant-select-single.pf-select--short.pf-select-inline-rule-operator .ant-select-arrow {
  right: 3px;
}
.pf-select-button-dropdown-menu li {
  height: 40px !important;
  line-height: 32px !important;
}
.pf-select-option {
  white-space: normal;
}
.pf-select-text-wrapper {
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ant-select-item-option-content {
  flex: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.pf-select-text {
  white-space: nowrap;
  overflow: hidden;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.ant-select.transparent-disable.ant-select-disabled .ant-select-selector,
.ant-select.transparent-disable.ant-select-disabled:hover .ant-select-selector {
  color: #bfc8d5;
  background: transparent;
}
.pf-timepicker {
  border-color: #e7ebef !important;
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
.pf-timepicker input {
  height: 30px !important;
  border-color: #e7ebef !important;
}
.pf-datetimepicker {
  -webkit-border-radius: 4px !important;
  -moz-border-radius: 4px !important;
  border-radius: 4px !important;
  border-color: #e7ebef !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
.pf-datetimepicker input {
  color: #323945;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  border-color: #e7ebef;
}
.pf-datetimepicker input::placeholder {
  color: #bfc8d5;
  font-weight: normal;
}
.pf-datetimepicker input:hover {
  border-color: #e7ebef !important;
}
.pf-datetimepicker.pf-datetimepicker-disabled .icon {
  color: #bfc8d5 !important;
}
.pf-datetimepicker.pf-datetimepicker-disabled .ant-time-picker-icon svg {
  opacity: 0.2;
}
.pf-datetimepicker.pf-datetimepicker-disabled input {
  color: #bfc8d5;
  background-color: transparent;
  border-color: #f9fafc;
}
.ant-select-item-option.ant-select-item-option-selected {
  background-color: transparent !important;
}
.ant-select-dropdown-menu--hidden {
  display: none !important;
}
.link-settings-timepicker {
  width: 120px;
}
.link-settings-timepicker .ant-time-picker-panel-input-wrap {
  width: 120px !important;
  max-width: initial !important;
}
.link-settings-timepicker .ant-time-picker-panel-select li {
  padding-left: 20px !important;
}
.link-settings-timepicker .ant-time-picker-panel-select,
.link-settings-timepicker .ant-time-picker-panel-select ul,
.link-settings-timepicker .ant-time-picker-panel-select li {
  width: 60px !important;
}
.link-settings-datepicker {
  width: 100%;
}
.link-settings-datepicker .ant-picker-panel-container {
  width: calc(100% - 48px);
}
.link-settings-datepicker .ant-picker-panel,
.link-settings-datepicker .ant-picker-date-panel,
.link-settings-datepicker .ant-picker-year-panel,
.link-settings-datepicker .ant-picker-month-panel,
.link-settings-datepicker .ant-picker-decade-panel,
.link-settings-datepicker .ant-picker-date-panel .ant-picker-content {
  width: 100%;
}
.pf-select--tags .ant-select-selection__choice {
  background-color: #d8e8fe !important;
  padding-left: 16px;
  padding-right: 32px;
}
.pf-select--tags .ant-select-selector,
.pf-select--tags .ant-select-open .ant-select-selector {
  border-color: #e7ebef;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
.pf-select--tags .ant-select-selection__choice__content {
  color: #323945 !important;
}
.pf-select--tags .ant-select-selection__choice__remove {
  color: #0e68f9 !important;
  font-size: 14px !important;
  padding-right: 5px;
}
.pf-select--tags .ant-select-selection-placeholder {
  margin-left: 2px !important;
  color: #8f98a9;
}
.pf-select--tags .ant-select-search__field {
  color: #323945;
  padding-left: 0 !important;
  text-indent: 2px !important;
  min-width: 25px !important;
}
.pf-select--tags .ant-select-selector--multiple .ant-select-selection-item {
  margin-left: 8px !important;
}
.pf-select--tags .ant-select-selection__choice__remove {
  width: 20px;
  height: 100%;
}
.pf-select--tags .ant-select-selection__choice__remove i {
  display: none;
}
.pf-select--tags .ant-select-selection__choice__remove:after {
  content: '\\e5cd';
  font-family: 'icomoon';
  font-size: 18px;
  display: block;
  position: relative;
  font-weight: normal;
}
.pf-range-datepicker .ant-picker-range {
  visibility: hidden !important;
  pointer-events: none;
}
.pf-select--multiple-values.ant-select {
  line-height: 27px;
  max-width: 100%;
  min-width: 0;
}
.pf-select--multiple-values .ant-select-selector {
  width: 100%;
  height: 32px !important;
  min-height: 32px !important;
  overflow: hidden;
}
.pf-select--multiple-values .ant-select-selection-overflow {
  flex-wrap: nowrap;
  overflow: hidden;
}
.pf-select--multiple-values .ant-select-selection-overflow-item {
  min-width: 0;
}
.pf-select--multiple-values .ant-select-selection-overflow-item-rest .ant-select-selection-item {
  background-color: transparent !important;
  line-height: 27px !important;
  padding: 0px !important;
  height: auto !important;
  margin-left: 5px;
}
.pf-select--multiple-values .ant-select-selection-overflow-item-rest .ant-select-selection-item-content {
  color: #8f98a9;
}
.pf-select--multiple-values .ant-select-selection-overflow-item-rest .ant-select-selection-item-content::before {
  content: '(';
}
.pf-select--multiple-values .ant-select-selection-overflow-item-rest .ant-select-selection-item-content::after {
  content: ')';
}
.pf-theme .ant-modal .ant-alert-default {
  border-top: 0;
}
.pf-theme .ant-modal .ant-modal-header {
  padding: 24px;
}
.pf-theme .ant-modal .ant-modal-title {
  font-size: 24px;
}
.pf-theme .confirm-modal .ant-modal-content {
  border-radius: 4px;
  padding: 16px;
}
.pf-theme .confirm-modal .ant-modal-header {
  border-bottom: 0;
  padding: 0;
}
.pf-theme .confirm-modal .ant-modal-body {
  padding: 0;
}
.pf-theme .confirm-modal .ant-modal-footer {
  border-top: 0;
  padding: 0;
}
.pf-theme .confirm-modal .ant-modal-close {
  margin-right: 8px;
  margin-top: 4px;
}
.pf-theme .confirm-modal .ant-modal-footer {
  margin-top: 24px;
}
@media only screen and (max-width: 992px) {
  .pf-theme .ant-modal {
    width: auto !important;
    margin: 10px !important;
  }
  .pf-theme .ant-modal.terms-modal {
    width: calc(100vw - 20px) !important;
    margin: 10px !important;
  }
}
.pf-theme .modal-no-footer-border .ant-modal-footer {
  border: 0;
}
.pf-theme .modal-cancel-btn {
  color: #323945;
  border-color: #e0e6ed;
}
.pf-theme .modal-cancel-btn:hover {
  color: #323945 !important;
  border-color: #e0e6ed !important;
}
.pf-theme .ant-modal-close-x {
  width: 30px !important;
  padding-top: 8px !important;
  height: 30px !important;
}
.pf-theme .ant-modal.fullscreen {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  top: 0;
}
.pf-theme .ant-modal.fullscreen .ant-modal-content {
  width: 100%;
  height: 100%;
  padding: 0;
}
.pf-theme .ant-modal.fullscreen .ant-modal-body {
  padding: 0;
}
.pf-theme .ant-modal-border-radius-level-3 {
  border-radius: 12px;
  overflow: hidden;
}
.pf-theme .ant-modal-border-radius-level-3 .ant-modal-body {
  border-radius: 12px;
  overflow: hidden;
}
.pf-theme .ant-modal-no-padding .ant-modal-content {
  padding: 0;
}
.add-question-modal .ant-modal-content {
  padding: 20px 16px !important;
  border-radius: 8px;
}
.add-question-modal .ant-modal-close {
  position: absolute;
  right: 14px;
  top: 13px;
}
.ant-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1030;
  font-weight: normal;
  white-space: normal;
  text-align: left;
  cursor: auto;
  user-select: text;
}
.ant-popover::after {
  position: absolute;
  background: rgba(255, 255, 255, 0.01);
  content: '';
}
.ant-popover-hidden {
  display: none;
}
.ant-popover-placement-top,
.ant-popover-placement-topLeft,
.ant-popover-placement-topRight {
  padding-bottom: 10px;
}
.ant-popover-placement-right,
.ant-popover-placement-rightTop,
.ant-popover-placement-rightBottom {
  padding-left: 10px;
}
.ant-popover-placement-bottom,
.ant-popover-placement-bottomLeft,
.ant-popover-placement-bottomRight {
  padding-top: 10px;
}
.ant-popover-placement-left,
.ant-popover-placement-leftTop,
.ant-popover-placement-leftBottom {
  padding-right: 10px;
}
.ant-popover-inner {
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 4px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15) \\9;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ant-popover {
    /* IE10+ */
  }
  .ant-popover-inner {
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  }
}
.ant-popover-title {
  min-width: 177px;
  min-height: 32px;
  margin: 0;
  padding: 5px 16px 4px;
  color: #323945;
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
}
.ant-popover-inner-content {
  padding: 12px 16px;
  color: #323945;
}
.ant-popover-message {
  position: relative;
  padding: 4px 0 12px;
  color: #323945;
  font-size: 15px;
}
.ant-popover-message > .anticon {
  position: absolute;
  top: 7.75px;
  color: #ffca2b;
  font-size: 15px;
}
.ant-popover-message-title {
  padding-left: 23px;
}
.ant-popover-buttons {
  margin-bottom: 4px;
  text-align: right;
}
.ant-popover-buttons button {
  margin-left: 8px;
}
.ant-popover-arrow {
  position: absolute;
  display: block;
  width: 8.48528137px;
  height: 8.48528137px;
  overflow: hidden;
  background: transparent;
  pointer-events: none;
}
.ant-popover-arrow-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 6px;
  height: 6px;
  margin: auto;
  background-color: #fff;
  content: '';
  pointer-events: auto;
}
.ant-popover-placement-top .ant-popover-arrow,
.ant-popover-placement-topLeft .ant-popover-arrow,
.ant-popover-placement-topRight .ant-popover-arrow {
  bottom: 1.51471863px;
}
.ant-popover-placement-top .ant-popover-arrow-content,
.ant-popover-placement-topLeft .ant-popover-arrow-content,
.ant-popover-placement-topRight .ant-popover-arrow-content {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateY(-4.24264069px) rotate(45deg);
}
.ant-popover-placement-top .ant-popover-arrow {
  left: 50%;
  transform: translateX(-50%);
}
.ant-popover-placement-topLeft .ant-popover-arrow {
  left: 16px;
}
.ant-popover-placement-topRight .ant-popover-arrow {
  right: 16px;
}
.ant-popover-placement-right .ant-popover-arrow,
.ant-popover-placement-rightTop .ant-popover-arrow,
.ant-popover-placement-rightBottom .ant-popover-arrow {
  left: 1.51471863px;
}
.ant-popover-placement-right .ant-popover-arrow-content,
.ant-popover-placement-rightTop .ant-popover-arrow-content,
.ant-popover-placement-rightBottom .ant-popover-arrow-content {
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(4.24264069px) rotate(45deg);
}
.ant-popover-placement-right .ant-popover-arrow {
  top: 50%;
  transform: translateY(-50%);
}
.ant-popover-placement-rightTop .ant-popover-arrow {
  top: 12px;
}
.ant-popover-placement-rightBottom .ant-popover-arrow {
  bottom: 12px;
}
.ant-popover-placement-bottom .ant-popover-arrow,
.ant-popover-placement-bottomLeft .ant-popover-arrow,
.ant-popover-placement-bottomRight .ant-popover-arrow {
  top: 1.51471863px;
}
.ant-popover-placement-bottom .ant-popover-arrow-content,
.ant-popover-placement-bottomLeft .ant-popover-arrow-content,
.ant-popover-placement-bottomRight .ant-popover-arrow-content {
  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);
  transform: translateY(4.24264069px) rotate(45deg);
}
.ant-popover-placement-bottom .ant-popover-arrow {
  left: 50%;
  transform: translateX(-50%);
}
.ant-popover-placement-bottomLeft .ant-popover-arrow {
  left: 16px;
}
.ant-popover-placement-bottomRight .ant-popover-arrow {
  right: 16px;
}
.ant-popover-placement-left .ant-popover-arrow,
.ant-popover-placement-leftTop .ant-popover-arrow,
.ant-popover-placement-leftBottom .ant-popover-arrow {
  right: 1.51471863px;
}
.ant-popover-placement-left .ant-popover-arrow-content,
.ant-popover-placement-leftTop .ant-popover-arrow-content,
.ant-popover-placement-leftBottom .ant-popover-arrow-content {
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
  transform: translateX(-4.24264069px) rotate(45deg);
}
.ant-popover-placement-left .ant-popover-arrow {
  top: 50%;
  transform: translateY(-50%);
}
.ant-popover-placement-leftTop .ant-popover-arrow {
  top: 12px;
}
.ant-popover-placement-leftBottom .ant-popover-arrow {
  bottom: 12px;
}
.ant-popover-pink .ant-popover-inner {
  background-color: #eb2f96;
}
.ant-popover-pink .ant-popover-arrow-content {
  background-color: #eb2f96;
}
.ant-popover-magenta .ant-popover-inner {
  background-color: #fb3b71;
}
.ant-popover-magenta .ant-popover-arrow-content {
  background-color: #fb3b71;
}
.ant-popover-red .ant-popover-inner {
  background-color: #f5222d;
}
.ant-popover-red .ant-popover-arrow-content {
  background-color: #f5222d;
}
.ant-popover-volcano .ant-popover-inner {
  background-color: #fa541c;
}
.ant-popover-volcano .ant-popover-arrow-content {
  background-color: #fa541c;
}
.ant-popover-orange .ant-popover-inner {
  background-color: #fa8c16;
}
.ant-popover-orange .ant-popover-arrow-content {
  background-color: #fa8c16;
}
.ant-popover-yellow .ant-popover-inner {
  background-color: #fadb14;
}
.ant-popover-yellow .ant-popover-arrow-content {
  background-color: #fadb14;
}
.ant-popover-gold .ant-popover-inner {
  background-color: #faad14;
}
.ant-popover-gold .ant-popover-arrow-content {
  background-color: #faad14;
}
.ant-popover-cyan .ant-popover-inner {
  background-color: #13c2c2;
}
.ant-popover-cyan .ant-popover-arrow-content {
  background-color: #13c2c2;
}
.ant-popover-lime .ant-popover-inner {
  background-color: #a0d911;
}
.ant-popover-lime .ant-popover-arrow-content {
  background-color: #a0d911;
}
.ant-popover-green .ant-popover-inner {
  background-color: #52c41a;
}
.ant-popover-green .ant-popover-arrow-content {
  background-color: #52c41a;
}
.ant-popover-blue .ant-popover-inner {
  background-color: #0e68f9;
}
.ant-popover-blue .ant-popover-arrow-content {
  background-color: #0e68f9;
}
.ant-popover-geekblue .ant-popover-inner {
  background-color: #2f54eb;
}
.ant-popover-geekblue .ant-popover-arrow-content {
  background-color: #2f54eb;
}
.ant-popover-purple .ant-popover-inner {
  background-color: #722ed1;
}
.ant-popover-purple .ant-popover-arrow-content {
  background-color: #722ed1;
}
.ant-popover-rtl {
  direction: rtl;
  text-align: right;
}
.ant-popover-rtl .ant-popover-message-title {
  padding-right: 23px;
  padding-left: 16px;
}
.ant-popover-rtl .ant-popover-buttons {
  text-align: left;
}
.ant-popover-rtl .ant-popover-buttons button {
  margin-right: 8px;
  margin-left: 0;
}
.pf-theme .ant-tooltip {
  max-width: 300px;
}
.pf-theme .ant-popover-inner-content {
  color: #323945;
  font-size: 15px;
}
.pf-theme .ant-popover-message-title {
  padding-left: 0;
}
.pf-theme .ant-popover-message > .anticon {
  display: none;
}
.pf-theme .ant-popover:not(.original-padding) .ant-popover-inner-content {
  padding: 12px 24px;
}
.pf-theme .ant-popover-buttons {
  text-align: justify;
}
.pf-theme .ant-popover-buttons .ant-btn {
  width: 45%;
  display: inline-block;
}
.pf-theme .overlay-sm.ant-popover .ant-popover-inner-content {
  padding: 12px 12px;
  line-height: 1;
}
.tooltip-with-big-arrow .ant-tooltip-arrow {
  width: 17px;
  height: 22px;
}
.tooltip-with-big-arrow .ant-tooltip-arrow-content {
  width: 22px;
  height: 22px;
  border-radius: 3px;
}
.tooltip-translations-upgrade .ant-tooltip-arrow {
  z-index: 100;
}
.tooltip-translations-upgrade.ant-tooltip-placement-right .ant-tooltip-arrow {
  left: -16px !important;
}
.tooltip-translations-upgrade .ant-tooltip-arrow-content {
  box-shadow: none;
}
.ant-spin {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: absolute;
  display: none;
  color: #0e68f9;
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-spin-spinning {
  position: static;
  display: inline-block;
  opacity: 1;
}
.ant-spin-nested-loading {
  position: relative;
}
.ant-spin-nested-loading > div > .ant-spin {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: block;
  width: 100%;
  height: 100%;
  max-height: 400px;
}
.ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px;
}
.ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  position: absolute;
  top: 50%;
  width: 100%;
  padding-top: 4.5px;
  text-shadow: 0 1px 2px #fff;
}
.ant-spin-nested-loading > div > .ant-spin.ant-spin-show-text .ant-spin-dot {
  margin-top: -20px;
}
.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-dot {
  margin: -7px;
}
.ant-spin-nested-loading > div > .ant-spin-sm .ant-spin-text {
  padding-top: 1.5px;
}
.ant-spin-nested-loading > div > .ant-spin-sm.ant-spin-show-text .ant-spin-dot {
  margin-top: -17px;
}
.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-dot {
  margin: -16px;
}
.ant-spin-nested-loading > div > .ant-spin-lg .ant-spin-text {
  padding-top: 10.5px;
}
.ant-spin-nested-loading > div > .ant-spin-lg.ant-spin-show-text .ant-spin-dot {
  margin-top: -26px;
}
.ant-spin-container {
  position: relative;
  transition: opacity 0.3s;
}
.ant-spin-container::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: none \\9;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0;
  transition: all 0.3s;
  content: '';
  pointer-events: none;
}
.ant-spin-blur {
  clear: both;
  overflow: hidden;
  opacity: 0.5;
  user-select: none;
  pointer-events: none;
}
.ant-spin-blur::after {
  opacity: 0.4;
  pointer-events: auto;
}
.ant-spin-tip {
  color: rgba(0, 0, 0, 0.45);
}
.ant-spin-dot {
  position: relative;
  display: inline-block;
  font-size: 20px;
  width: 1em;
  height: 1em;
}
.ant-spin-dot-item {
  position: absolute;
  display: block;
  width: 9px;
  height: 9px;
  background-color: #0e68f9;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: antSpinMove 1s infinite linear alternate;
}
.ant-spin-dot-item:nth-child(1) {
  top: 0;
  left: 0;
}
.ant-spin-dot-item:nth-child(2) {
  top: 0;
  right: 0;
  animation-delay: 0.4s;
}
.ant-spin-dot-item:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}
.ant-spin-dot-item:nth-child(4) {
  bottom: 0;
  left: 0;
  animation-delay: 1.2s;
}
.ant-spin-dot-spin {
  transform: rotate(45deg);
  animation: antRotate 1.2s infinite linear;
}
.ant-spin-sm .ant-spin-dot {
  font-size: 14px;
}
.ant-spin-sm .ant-spin-dot i {
  width: 6px;
  height: 6px;
}
.ant-spin-lg .ant-spin-dot {
  font-size: 32px;
}
.ant-spin-lg .ant-spin-dot i {
  width: 14px;
  height: 14px;
}
.ant-spin.ant-spin-show-text .ant-spin-text {
  display: block;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ */
  .ant-spin-blur {
    background: #fff;
    opacity: 0.5;
  }
}
@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
@keyframes antRotate {
  to {
    transform: rotate(405deg);
  }
}
.ant-spin-rtl {
  direction: rtl;
}
.ant-spin-rtl .ant-spin-dot-spin {
  transform: rotate(-45deg);
  animation-name: antRotateRtl;
}
@keyframes antRotateRtl {
  to {
    transform: rotate(-405deg);
  }
}
.pf-theme .ant-spin.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
}
.pf-theme .ant-spin.center-blur {
  opacity: 0.5;
}
.pf-theme .ant-spin-nested-loading .ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: auto;
}
.pficon-spin {
  animation-name: spin;
  animation-duration: 1250ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.pf-theme .list-item {
  transition: 300ms;
  position: relative;
  border-radius: 4px;
  border: 1px solid #f4f6f8;
  padding: 24px;
  overflow: hidden;
  opacity: 0.7;
}
.pf-theme .list-item:before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  display: block;
  width: 5px;
  height: 100%;
  background-color: #f4f6f8;
  transition: 300ms;
}
.pf-theme .list-item.list-item--selectable {
  cursor: pointer;
}
.pf-theme .list-item.list-item--active {
  opacity: 1;
}
.pf-theme .list-item.list-item--active:not(.list-item--selected):hover {
  border: 1px solid #0e68f9;
}
.pf-theme .list-item.list-item--active:not(.list-item--selected):hover:before {
  background-color: #0e68f9;
}
.pf-theme .list-item.list-item--selected.list-item--selectable {
  color: #fff;
  box-shadow: 0 5px 10px 0 rgba(14, 104, 249, 0.3);
  background-color: #0e68f9;
  border-color: #0e68f9;
}
.pf-theme .list-item.list-item--selected.list-item--selectable:before {
  background-color: #0e68f9;
}
.pf-theme .list-item.list-item--disabled {
  background-color: #f0f0f0;
}
.pf-theme .narrow-table .ant-table-thead > tr > th,
.pf-theme .narrow-table .ant-table-tbody > tr > td {
  padding: 4px 16px;
}
.pf-theme .border-grey-4 .ant-list-item {
  border-color: #f3f6fb;
}
.ant-upload {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  outline: 0;
}
.ant-upload p {
  margin: 0;
}
.ant-upload-btn {
  display: block;
  width: 100%;
  outline: none;
}
.ant-upload input[type='file'] {
  cursor: pointer;
}
.ant-upload.ant-upload-select {
  display: inline-block;
}
.ant-upload.ant-upload-disabled {
  cursor: not-allowed;
}
.ant-upload.ant-upload-select-picture-card {
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s;
}
.ant-upload.ant-upload-select-picture-card > .ant-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}
.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #0e68f9;
}
.ant-upload-disabled.ant-upload.ant-upload-select-picture-card:hover {
  border-color: #d9d9d9;
}
.ant-upload.ant-upload-drag {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s;
}
.ant-upload.ant-upload-drag .ant-upload {
  padding: 16px 0;
}
.ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border-color: #024bd4;
}
.ant-upload.ant-upload-drag.ant-upload-disabled {
  cursor: not-allowed;
}
.ant-upload.ant-upload-drag .ant-upload-btn {
  display: table;
  height: 100%;
}
.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: table-cell;
  vertical-align: middle;
}
.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #388bff;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  margin-bottom: 20px;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  color: #388bff;
  font-size: 48px;
}
.ant-upload.ant-upload-drag p.ant-upload-text {
  margin: 0 0 4px;
  color: #323945;
  font-size: 17px;
}
.ant-upload.ant-upload-drag p.ant-upload-hint {
  color: rgba(0, 0, 0, 0.45);
  font-size: 15px;
}
.ant-upload.ant-upload-drag .anticon-plus {
  color: rgba(0, 0, 0, 0.25);
  font-size: 30px;
  transition: all 0.3s;
}
.ant-upload.ant-upload-drag .anticon-plus:hover {
  color: rgba(0, 0, 0, 0.45);
}
.ant-upload.ant-upload-drag:hover .anticon-plus {
  color: rgba(0, 0, 0, 0.45);
}
.ant-upload-picture-card-wrapper {
  display: inline-block;
  width: 100%;
}
.ant-upload-picture-card-wrapper::before {
  display: table;
  content: '';
}
.ant-upload-picture-card-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-picture-card-wrapper::before {
  display: table;
  content: '';
}
.ant-upload-picture-card-wrapper::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-list {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #495561;
  font-size: 15px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: 'tnum';
  line-height: 1.5;
}
.ant-upload-list::before {
  display: table;
  content: '';
}
.ant-upload-list::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-list::before {
  display: table;
  content: '';
}
.ant-upload-list::after {
  display: table;
  clear: both;
  content: '';
}
.ant-upload-list-item {
  position: relative;
  height: 22.5px;
  margin-top: 8px;
  font-size: 15px;
}
.ant-upload-list-item-name {
  display: inline-block;
  width: 100%;
  padding-left: 23px;
  overflow: hidden;
  line-height: 1.5;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-upload-list-item-card-actions {
  position: absolute;
  right: 0;
}
.ant-upload-list-item-card-actions-btn {
  opacity: 0;
}
.ant-upload-list-item-card-actions-btn.ant-btn-sm {
  height: 20px;
  line-height: 1;
}
.ant-upload-list-item-card-actions.picture {
  top: 22px;
  line-height: 0;
}
.ant-upload-list-item-card-actions-btn:focus,
.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}
.ant-upload-list-item-card-actions .anticon {
  color: rgba(0, 0, 0, 0.45);
}
.ant-upload-list-item-info {
  height: 100%;
  padding: 0 4px;
  transition: background-color 0.3s;
}
.ant-upload-list-item-info > span {
  display: block;
  width: 100%;
  height: 100%;
}
.ant-upload-list-item-info .anticon-loading .anticon,
.ant-upload-list-item-info .ant-upload-text-icon .anticon {
  position: absolute;
  top: 5.5px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 15px;
}
.ant-upload-list-item .anticon-close {
  position: absolute;
  top: 6px;
  right: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  line-height: 0;
  cursor: pointer;
  opacity: 0;
  transition: all 0.3s;
}
.ant-upload-list-item .anticon-close:hover {
  color: #495561;
}
.ant-upload-list-item:hover .ant-upload-list-item-info {
  background-color: #f5f5f5;
}
.ant-upload-list-item:hover .anticon-close {
  opacity: 1;
}
.ant-upload-list-item:hover .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}
.ant-upload-list-item-error,
.ant-upload-list-item-error .ant-upload-text-icon > .anticon,
.ant-upload-list-item-error .ant-upload-list-item-name {
  color: #f1565d;
}
.ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  color: #f1565d;
}
.ant-upload-list-item-error .ant-upload-list-item-card-actions-btn {
  opacity: 1;
}
.ant-upload-list-item-progress {
  position: absolute;
  bottom: -12px;
  width: 100%;
  padding-left: 27px;
  font-size: 15px;
  line-height: 0;
}
.ant-upload-list-picture .ant-upload-list-item,
.ant-upload-list-picture-card .ant-upload-list-item {
  position: relative;
  height: 66px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.ant-upload-list-picture .ant-upload-list-item:hover,
.ant-upload-list-picture-card .ant-upload-list-item:hover {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-error,
.ant-upload-list-picture-card .ant-upload-list-item-error {
  border-color: #f1565d;
}
.ant-upload-list-picture .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item-info {
  padding: 0;
}
.ant-upload-list-picture .ant-upload-list-item:hover .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info {
  background: transparent;
}
.ant-upload-list-picture .ant-upload-list-item-uploading,
.ant-upload-list-picture-card .ant-upload-list-item-uploading {
  border-style: dashed;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  width: 48px;
  height: 48px;
  line-height: 54px;
  text-align: center;
  opacity: 0.8;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail .anticon,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail .anticon {
  font-size: 26px;
}
.ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#e6f7ff'],
.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#e6f7ff'] {
  fill: #fff1f0;
}
.ant-upload-list-picture .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#1890ff'],
.ant-upload-list-picture-card .ant-upload-list-item-error .ant-upload-list-item-thumbnail .anticon svg path[fill='#1890ff'] {
  fill: #f1565d;
}
.ant-upload-list-picture .ant-upload-list-item-icon,
.ant-upload-list-picture-card .ant-upload-list-item-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 26px;
  transform: translate(-50%, -50%);
}
.ant-upload-list-picture .ant-upload-list-item-icon .anticon,
.ant-upload-list-picture-card .ant-upload-list-item-icon .anticon {
  font-size: 26px;
}
.ant-upload-list-picture .ant-upload-list-item-image,
.ant-upload-list-picture-card .ant-upload-list-item-image {
  max-width: 100%;
}
.ant-upload-list-picture .ant-upload-list-item-thumbnail img,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  display: block;
  width: 48px;
  height: 48px;
  overflow: hidden;
}
.ant-upload-list-picture .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 0 0 8px;
  padding-right: 8px;
  padding-left: 48px;
  overflow: hidden;
  line-height: 44px;
  white-space: nowrap;
  text-overflow: ellipsis;
  transition: all 0.3s;
}
.ant-upload-list-picture .ant-upload-list-item-uploading .ant-upload-list-item-name,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-name {
  line-height: 28px;
}
.ant-upload-list-picture .ant-upload-list-item-progress,
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 14px;
  width: calc(100% - 24px);
  margin-top: 0;
  padding-left: 56px;
}
.ant-upload-list-picture .anticon-close,
.ant-upload-list-picture-card .anticon-close {
  position: absolute;
  top: 8px;
  right: 8px;
  line-height: 1;
  opacity: 1;
}
.ant-upload-list-picture-card-container {
  display: inline-block;
  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  vertical-align: top;
}
.ant-upload-list-picture-card.ant-upload-list::after {
  display: none;
}
.ant-upload-list-picture-card .ant-upload-list-item {
  height: 100%;
  margin: 0;
}
.ant-upload-list-picture-card .ant-upload-list-item-info {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.ant-upload-list-picture-card .ant-upload-list-item-info::before {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 0.3s;
  content: ' ';
}
.ant-upload-list-picture-card .ant-upload-list-item:hover .ant-upload-list-item-info::before {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  white-space: nowrap;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {
  z-index: 10;
  width: 16px;
  margin: 0 4px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download:hover,
.ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete:hover {
  color: #fff;
}
.ant-upload-list-picture-card .ant-upload-list-item-info:hover + .ant-upload-list-item-actions,
.ant-upload-list-picture-card .ant-upload-list-item-actions:hover {
  opacity: 1;
}
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  position: static;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.ant-upload-list-picture-card .ant-upload-list-item-name {
  display: none;
  margin: 8px 0 0;
  padding: 0;
  line-height: 1.5;
  text-align: center;
}
.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  position: absolute;
  bottom: 10px;
  display: block;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading.ant-upload-list-item {
  background-color: #fafafa;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info {
  height: auto;
}
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info::before,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-eye,
.ant-upload-list-picture-card .ant-upload-list-item-uploading .ant-upload-list-item-info .anticon-delete {
  display: none;
}
.ant-upload-list-picture-card .ant-upload-list-item-progress {
  bottom: 32px;
  width: calc(100% - 14px);
  padding-left: 0;
}
.ant-upload-list-text-container,
.ant-upload-list-picture-container {
  transition: opacity 0.3s, height 0.3s;
}
.ant-upload-list-text-container::before,
.ant-upload-list-picture-container::before {
  display: table;
  width: 0;
  height: 0;
  content: '';
}
.ant-upload-list-text-container .ant-upload-span,
.ant-upload-list-picture-container .ant-upload-span {
  display: block;
  flex: auto;
}
.ant-upload-list-text .ant-upload-span,
.ant-upload-list-picture .ant-upload-span {
  display: flex;
  align-items: center;
}
.ant-upload-list-text .ant-upload-span > *,
.ant-upload-list-picture .ant-upload-span > * {
  flex: none;
}
.ant-upload-list-text .ant-upload-list-item-name,
.ant-upload-list-picture .ant-upload-list-item-name {
  flex: auto;
  padding: 0 8px;
}
.ant-upload-list-text .ant-upload-list-item-card-actions,
.ant-upload-list-picture .ant-upload-list-item-card-actions {
  position: static;
}
.ant-upload-list-text .ant-upload-text-icon .anticon {
  position: static;
}
.ant-upload-list .ant-upload-animate-inline-appear,
.ant-upload-list .ant-upload-animate-inline-enter,
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-duration: 0.3s;
  animation-fill-mode: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.ant-upload-list .ant-upload-animate-inline-appear,
.ant-upload-list .ant-upload-animate-inline-enter {
  animation-name: uploadAnimateInlineIn;
}
.ant-upload-list .ant-upload-animate-inline-leave {
  animation-name: uploadAnimateInlineOut;
}
@keyframes uploadAnimateInlineIn {
  from {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
@keyframes uploadAnimateInlineOut {
  to {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }
}
.ant-upload-rtl {
  direction: rtl;
}
.ant-upload-rtl.ant-upload.ant-upload-select-picture-card {
  margin-right: auto;
  margin-left: 8px;
}
.ant-upload-list-rtl {
  direction: rtl;
}
.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-1 {
  padding-right: 22px;
  padding-left: 14px;
}
.ant-upload-list-rtl .ant-upload-list-item-list-type-text:hover .ant-upload-list-item-name-icon-count-2 {
  padding-right: 22px;
  padding-left: 28px;
}
.ant-upload-list-rtl .ant-upload-list-item-name {
  padding-right: 23px;
  padding-left: 0;
}
.ant-upload-list-rtl .ant-upload-list-item-name-icon-count-1 {
  padding-left: 14px;
}
.ant-upload-list-rtl .ant-upload-list-item-card-actions {
  right: auto;
  left: 0;
}
.ant-upload-list-rtl .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}
.ant-upload-list-rtl .ant-upload-list-item-info {
  padding: 0 4px 0 12px;
}
.ant-upload-list-rtl .ant-upload-list-item .anticon-close {
  right: auto;
  left: 4px;
}
.ant-upload-list-rtl .ant-upload-list-item-error .ant-upload-list-item-card-actions .anticon {
  padding-right: 0;
  padding-left: 5px;
}
.ant-upload-list-rtl .ant-upload-list-item-progress {
  padding-right: 27px;
  padding-left: 0;
}
.ant-upload-list-picture .ant-upload-list-item-info,
.ant-upload-list-picture-card .ant-upload-list-item-info {
  padding: 0;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  right: 8px;
  left: auto;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-icon,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-icon {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name {
  margin: 0 8px 0 0;
  padding-right: 48px;
  padding-left: 8px;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-1,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-1 {
  padding-right: 48px;
  padding-left: 18px;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-name-icon-count-2,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-name-icon-count-2 {
  padding-right: 48px;
  padding-left: 36px;
}
.ant-upload-list-rtl.ant-upload-list-picture .ant-upload-list-item-progress,
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-progress {
  padding-right: 0;
  padding-left: 0;
}
.ant-upload-list-rtl.ant-upload-list-picture .anticon-close,
.ant-upload-list-rtl.ant-upload-list-picture-card .anticon-close {
  right: auto;
  left: 8px;
}
.ant-upload-list-rtl .ant-upload-list-picture-card-container {
  margin: 0 0 8px 8px;
}
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-actions {
  right: 50%;
  left: auto;
  transform: translate(50%, -50%);
}
.ant-upload-list-rtl.ant-upload-list-picture-card .ant-upload-list-item-file + .ant-upload-list-item-name {
  margin: 8px 0 0;
  padding: 0;
}
.pf-theme .ant-upload.ant-upload-drag {
  padding: 0;
  border: 1px dashed #e8e8e8;
  background: #f9fafc;
  opacity: 1;
}
.pf-theme .ant-upload.ant-upload-drag .ant-upload-btn {
  padding: 24px 36px;
}
.pf-theme .ant-upload.ant-upload-drag:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  pointer-events: none;
  background: #0e68f9;
  transition: 300ms;
}
.pf-theme .ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled) {
  border: 1px dashed #0e68f9;
}
.pf-theme .ant-upload.ant-upload-drag.ant-upload-drag-hover:not(.ant-upload-disabled):after {
  opacity: 0.4;
}
.pf-theme .ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border: 1px dashed #0e68f9;
}
.pf-theme .ant-upload.ant-upload-drag p.ant-upload-drag-icon {
  margin-bottom: 0px;
}
.pf-theme .ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
  font-size: 48px;
  color: #0e68f9;
}
.pf-theme .ant-upload.ant-upload-drag p.ant-upload-text {
  font-size: 18px;
  margin: 0 0 10px;
  color: #6b7179;
}
.pf-theme .ant-upload.ant-upload-drag p.ant-upload-hint {
  font-size: 13px;
  color: #bfc8d5;
}
.pf-theme .ant-upload.ant-upload-drag .anticon-plus {
  font-size: 30px;
  transition: all 0.3s;
  color: rgba(0, 0, 0, 0.25);
}
.pf-theme .ant-upload.ant-upload-drag .anticon-plus:hover {
  color: rgba(0, 0, 0, 0.45);
}
.pf-theme .ant-upload.ant-upload-drag:hover .anticon-plus {
  color: rgba(0, 0, 0, 0.45);
}
.pf-theme .ant-upload.ant-upload-drag.ant-upload-disabled {
  opacity: 0.7;
}
.pricing-plans-wrapper {
  background: linear-gradient(176.41deg, #f9f9f9 5.69%, #f5fff7 96.39%) !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
@container accounts-layout (width < 625px) {
  .pricing-plans-wrapper {
    display: block;
  }
}
.no-plan-container {
  max-width: 625px;
  padding: 56px 74px;
  border: 1px solid #03dfb91a;
  box-shadow: 0px 14px 24px 0px #20e3c21a;
}
@container accounts-layout (width < 625px) {
  .no-plan-container {
    padding: 28px 37px;
  }
}
.no-plan-container .heading {
  font-family: Poppins;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  margin: 0;
}
.no-plan-container .heading .discount {
  color: #22a875;
}
.no-plan-container .description {
  font-family: Poppins;
  font-weight: 400;
  font-size: 14px;
  line-height: 23px;
  letter-spacing: 0%;
  margin: 24px 0 32px;
}
.no-plan-container .description strong {
  font-weight: 700;
}
.no-plan-container .underline {
  position: relative;
  white-space: nowrap;
}
.no-plan-container .underline svg {
  position: absolute;
  top: calc(100% - 0.1em);
  left: -0.25em;
}
.no-plan-container .benefits-grid {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  gap: 15px;
  margin: 24px 0 32px;
}
.no-plan-container .benefits-grid li {
  width: 148px;
  height: 138px;
  border-radius: 4px;
  padding: 24px;
  margin: 0;
  background: #b0b0b017;
}
.no-plan-container a {
  font-family: Poppins;
  font-weight: 600;
}
.no-plan-container .contact-sales {
  background-color: #03dfb9;
}
.no-plan-container .contact-sales:hover {
  background-color: #07f8cf;
}
.plan-container {
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  text-align: center;
  width: 100%;
}
.plan-container header {
  max-width: 524px;
  margin: 65px 0 50px;
}
.plan-container header h3 {
  font-family: Poppins;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0;
  margin: 16px;
}
.plan-container header .description {
  font-family: Poppins;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  margin: 0;
  padding: 0;
}
.plan-container .plans-grid {
  font-family: Poppins;
  list-style: none;
  padding: 1em 0 0;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  max-width: 100%;
  min-height: 450px;
  overflow-x: auto;
}
.plan-container .plans-grid .plans-grid-item {
  flex: 0 0 251px;
  border-radius: 4px;
  padding: 40px 24px;
  margin: 0;
  background: #fff;
  font-size: 13px;
  border: 1px solid #eff3f7;
}
.plan-container .plans-grid .plans-grid-item:not(:hover) a {
  display: none;
}
.plan-container .plans-grid .plans-grid-item .discount-rate {
  font-size: 40px;
  line-height: 1;
  display: block;
  letter-spacing: 0;
}
.plan-container .plans-grid .plans-grid-item .discount-label {
  font-size: 21px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
}
.plan-container .plans-grid .plans-grid-item .credits-amount {
  font-size: 25px;
  font-weight: 600;
  display: block;
}
.plan-container .plans-grid .plans-grid-item.current-plan {
  position: relative;
}
.plan-container .plans-grid .plans-grid-item.current-plan .badge {
  border: 1px solid #b3f0e5;
  background-color: #ebfbf8;
}
.plan-container .plans-grid .plans-grid-item.current-plan .expiration-note {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  color: #5e6775;
  font-size: 12px;
  line-height: 16px;
  font-family: Roboto;
  margin-top: 8px;
}
.plan-container .plans-grid .plans-grid-item.next-plan {
  border-color: #b3f0e5;
  position: relative;
  flex-basis: 286px;
  padding: 45px 30px 55px;
}
.plan-container .plans-grid .plans-grid-item.next-plan:hover {
  padding-bottom: 30px;
}
.plan-container .plans-grid .plans-grid-item.next-plan .discount-rate {
  position: relative;
  font-size: 45px;
}
.plan-container .plans-grid .plans-grid-item.next-plan .discount-rate svg {
  position: absolute;
  transform: translate(-140%, -50%);
}
.plan-container .plans-grid .plans-grid-item.next-plan .discount-label {
  font-size: 24px;
}
.plan-container .plans-grid .plans-grid-item.next-plan .credits-amount {
  font-size: 28px;
}
.plan-container .plans-grid .plans-grid-item.next-plan .badge {
  border: 1px solid #ffc00033;
  background-color: #fff;
  box-shadow: 0px 4px 4px 0px #ffc0001a;
  padding: 0 8px;
}
.plan-container .plans-grid .plans-grid-item .badge {
  font-family: Roboto;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 0;
  position: absolute;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  height: 24px;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px;
  white-space: nowrap;
}
.plan-container a {
  font-family: Poppins;
  font-weight: 600;
}
.plan-container .contact-sales {
  background-color: #03dfb9;
}
.plan-container .contact-sales:hover {
  background-color: #07f8cf;
}
.pf-theme .invite-member-card {
  height: 200px;
  margin-bottom: 24px;
  border: 1px dashed rgba(34, 168, 117, 0.4);
}
.pf-theme .invite-member-card .invite-members-btn-circle {
  background-color: #d5ffe8;
  color: #22a875;
  width: 46px;
  height: 46px;
  border-radius: 46px;
  display: block;
  margin: 0 auto;
  border: none;
  font-size: 20px;
  margin-bottom: 12px;
}
.pf-theme .invite-member-card.invite-card-disabled {
  opacity: 0.4;
}
.pf-theme .pending-member-card {
  border-color: transparent;
  height: 200px;
  text-align: center;
  margin-bottom: 24px;
  box-shadow: none;
}
.pf-theme .pending-member-card.pending-member-card-disabled {
  opacity: 0.4;
}
.pf-theme .pending-member-card.pending-member-card-disabled .remove-invitation {
  cursor: not-allowed;
}
.pf-theme .pending-member-card .label {
  line-height: 1;
  width: 150px;
  height: 48px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #22a875;
  position: absolute;
  top: 32%;
  left: 50%;
  transform: translate(-50%, 0);
}
.pf-theme .pending-member-card .ant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.pf-theme .pending-member-card .ant-avatar-string {
  line-height: 40px;
}
.pf-theme .pending-member-card .ant-card-cover {
  padding-top: 22px;
}
.pf-theme .pending-member-card .ant-card-meta {
  padding-bottom: 10px;
}
.pf-theme .pending-member-card .ant-card-body {
  padding: 24px 16px;
}
.pf-theme .pending-member-card .ant-card-meta-detail > div:not(:last-child) {
  margin: 0;
}
.pf-theme .pending-member-card .ant-card-meta-title {
  font-size: 14px;
  color: #ffffff;
}
.pf-theme .pending-member-card .ant-card-meta-description {
  font-size: 11px;
  color: #687280;
}
.pf-theme .pending-member-card .remove-invitation {
  display: block;
  cursor: pointer;
  width: 100px;
  height: 32px;
  font-size: 11px;
  color: #0e68f9;
  padding: 8px 10px;
}
.pf-theme .team-member-card {
  height: 200px;
  text-align: center;
  margin-bottom: 24px;
  box-shadow: none;
}
.pf-theme .team-member-card.team-member-card-disabled {
  pointer-events: none;
  opacity: 0.4;
}
.pf-theme .team-member-card.team-member-card-disabled .ant-card-actions li span:hover {
  cursor: not-allowed;
  color: inherit;
}
.pf-theme .team-member-card.team-member-card-disabled .ant-card-actions:hover {
  cursor: not-allowed;
}
.pf-theme .team-member-card .ant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.pf-theme .team-member-card .ant-card-cover {
  padding-top: 22px;
}
.pf-theme .team-member-card .ant-tag {
  min-width: 102px;
  border: none;
  background-color: transparent;
  color: #323945;
  font-size: 10px;
}
.pf-theme .team-member-card .ant-tag:hover {
  cursor: default;
}
.pf-theme .team-member-card .ant-card-meta {
  padding-bottom: 10px;
}
.pf-theme .team-member-card .ant-card-body {
  padding: 11px 16px;
}
.pf-theme .team-member-card .ant-card-meta-detail > div:not(:last-child) {
  margin: 0;
}
.pf-theme .team-member-card .ant-avatar-string {
  line-height: 40px;
}
.pf-theme .team-member-card .ant-card-meta-title {
  font-size: 14px;
  color: #323945;
}
.pf-theme .team-member-card .ant-card-meta-description {
  font-size: 11px;
  color: #8f98a9;
}
.pf-theme .team-member-card .ant-card-actions {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #f3f6fb;
}
.pf-theme .team-member-card .ant-card-actions:hover {
  cursor: pointer;
}
.pf-theme .team-member-card .ant-card-actions > li {
  padding: 7px 0;
  margin: 0;
}
.pf-theme .team-member-card .ant-card-actions > li:not(:last-child) {
  border-color: #e0e6ed;
}
.pf-theme .team-member-card .team-members-card__link {
  padding-left: 5px;
}
.pf-theme .team-member-card:hover {
  cursor: default;
}
.pf-theme .team-members-invite-form-icon {
  position: relative;
  top: 7px;
  font-size: 28px;
  color: #0e68f9;
  transition: 300ms;
  cursor: pointer;
}
.pf-theme .team-members-invite-form-icon--disabled {
  color: #6b7179;
  opacity: 0.7;
}
.pf-theme .team-members-invite-form-icon--delete-icon {
  color: #6b7179;
  opacity: 0.7;
}
.pf-theme .team-members-invite-form-icon--delete-icon:hover {
  opacity: 1;
  color: #0e68f9;
}
.pf-theme .account-card {
  height: 418px;
  text-align: center;
  margin-bottom: 24px;
  box-shadow: none;
  border-radius: 10px;
  overflow: hidden;
}
.pf-theme .account-card.account-selected {
  border-color: rgba(34, 168, 117, 0.4);
  pointer-events: none;
}
.pf-theme .account-card.account-selected .ant-card-actions {
  background-color: #d5ffe8;
}
.pf-theme .account-card.account-selected .ant-card-actions li span {
  color: #22a875;
}
.pf-theme .account-card.account-card-disabled {
  opacity: 0.4;
}
.pf-theme .account-card.account-card-disabled .ant-card-actions li span:hover {
  cursor: not-allowed;
  color: inherit;
}
.pf-theme .account-card.account-card-disabled .ant-card-actions:hover {
  cursor: not-allowed;
}
.pf-theme .account-card.account-card-condensed {
  height: 200px;
}
.pf-theme .account-card.account-card-condensed .ant-card-cover {
  padding-top: 24px;
}
.pf-theme .account-card .ant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.pf-theme .account-card .ant-card-cover {
  padding-top: 44px;
}
.pf-theme .account-card .ant-tag {
  min-width: 102px;
  border: none;
  background-color: transparent;
  color: #9254de;
  font-size: 11px;
}
.pf-theme .account-card .ant-tag:hover {
  cursor: default;
}
.pf-theme .account-card .ant-card-meta {
  padding-bottom: 10px;
}
.pf-theme .account-card .ant-card-body {
  padding: 10px 24px 24px;
}
.pf-theme .account-card .ant-card-meta-detail > div:not(:last-child) {
  margin: 0;
}
.pf-theme .account-card .ant-avatar-string {
  line-height: 90px;
}
.pf-theme .account-card .ant-card-meta-title {
  font-size: 14px;
}
.pf-theme .account-card .ant-card-meta-description {
  font-size: 12px;
  color: #bfc8d5;
}
.pf-theme .account-card .ant-card-actions {
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: #ebf1f6;
  border: none;
  border-radius: 0px 0px 9px 9px;
}
.pf-theme .account-card .ant-card-actions:hover {
  cursor: pointer;
}
.pf-theme .account-card .ant-card-actions > li {
  margin: 0;
  padding: 7px 0;
}
.pf-theme .account-card .ant-card-actions > li span {
  font-weight: 500;
}
.pf-theme .account-card .ant-card-actions span {
  display: inline-block;
  padding-left: 5px;
}
.pf-theme .account-card:hover {
  box-shadow: 0 1px 6px 0 rgba(50, 57, 69, 0.1);
  cursor: default;
}
.pf-theme .account-card .list-members {
  padding-top: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pf-theme .account-card .members {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-block;
  margin: 0;
  background-color: #bfc8d5;
}
.pf-theme .account-card .members + .members {
  margin-left: -20px;
}
.pf-theme .account-card .members .ant-avatar-string {
  line-height: 44px;
}
.pf-theme .account-card .label {
  cursor: pointer;
  font-size: 13px;
  color: #388bff;
}
.modal-create-survey .ant-modal-title {
  text-align: center;
  font-size: 18px !important;
}
.modal-create-survey .ant-modal-content {
  padding-bottom: 12px !important;
}
.modal-create-survey.modal-create-survey-researcher {
  margin: 0 auto !important;
}
.modal-create-survey.modal-create-survey-researcher .ant-modal-content {
  border: 1px solid white;
  padding: 52px 72px 72px !important;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  background-color: rgba(255, 255, 255, 0.3);
}
.modal-create-survey.modal-create-survey-researcher .ant-modal-footer {
  border: 0;
  padding-top: 8px !important;
}
.modal-create-survey .ant-modal-footer {
  padding-top: 12px !important;
}
.modal-create-survey__item-img {
  width: auto;
  height: 120px;
  display: block;
  margin: 0 auto;
}
.modal-create-survey__selection {
  height: 60px;
  display: flex;
  flex-direction: column;
  background-color: transparent;
  flex: 1;
  justify-self: flex-end;
  justify-content: flex-end;
  text-align: center;
  padding: 10px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.modal-create-survey__card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: 1px solid transparent;
}
.modal-create-survey__card .ant-card-body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.modal-create-survey__card:hover {
  background-color: white;
  border-color: #0e68f9;
}
.modal-create-survey__tutorial {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.modal-create-survey__tutorial-item {
  width: 30%;
  height: auto;
  background-color: #f9fafc;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  overflow: hidden;
}
.modal-create-survey__tutorial-item-img-wrapper {
  position: relative;
  background-color: #ebf3ff;
  padding: 8px;
}
.modal-create-survey__tutorial-item-img {
  height: 120px;
  width: auto;
  display: block;
  margin: 0 auto;
}
.modal-create-survey__tutorial-step-number {
  width: 12px;
  height: 12px;
  line-height: 12px;
  border: 6px solid #f9fafc;
  background-color: #0e68f9;
  color: white;
  padding: 4px;
  display: block;
  text-align: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  position: absolute;
  bottom: -16px;
  left: 10px;
  font-size: 12px;
  -webkit-box-sizing: content-box;
  -moz-box-sizing: content-box;
  box-sizing: content-box;
}
.modal-create-survey__back-button {
  position: absolute;
  left: 24px;
  top: 7px;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
.modal-create-survey__back-button-icon {
  font-size: 13px;
}
.create-survey-button__img {
  width: 154px;
  height: auto;
  display: block;
  position: relative;
  left: 50%;
  margin-left: -91px;
}
.modal-create-survey-backdrop-btn {
  position: fixed;
  top: 14px;
  right: 18px;
  z-index: 1100;
}
.create-survey-modal-open.create-survey-modal-open-regular .ant-modal-mask,
.create-survey-modal-open.create-survey-modal-open-distribution .ant-modal-mask,
.create-survey-modal-open.create-survey-modal-open-peeq .ant-modal-mask {
  background-color: white !important;
}
.create-survey-modal-open.create-survey-modal-open-regular .create-survey-wrap.ant-modal-wrap {
  background: linear-gradient(132deg, rgba(194, 213, 248, 0.3), rgba(209, 219, 244, 0.3), rgba(186, 200, 255, 0.3), rgba(131, 172, 248, 0.3));
}
.create-survey-modal-open.create-survey-modal-open-distribution .create-survey-wrap.ant-modal-wrap {
  background: linear-gradient(45deg, rgba(143, 145, 247, 0.58), rgba(216, 241, 245, 0.5), rgba(190, 234, 233, 0.43), rgba(122, 212, 199, 0.5));
}
.create-survey-modal-open.create-survey-modal-open-peeq .create-survey-wrap.ant-modal-wrap {
  background: linear-gradient(45deg, rgba(87, 35, 98, 0.1), rgba(136, 59, 149, 0.1));
}
.create-survey-modal-open .create-survey-wrap.ant-modal-wrap {
  background-size: 800% 800% !important;
  -webkit-animation: gradient 30s ease infinite;
  -moz-animation: gradient 30s ease infinite;
  -o-animation: gradient 30s ease infinite;
  animation: gradient 30s ease infinite;
}
.create-survey-modal-open .upload-modal-wrap.ant-modal-wrap {
  background-color: rgba(255, 255, 255, 0.3);
}
.create-survey-card {
  background-color: rgba(255, 255, 255, 0.4);
  transition: background-color 0.3s linear;
}
.create-survey-card:hover {
  background-color: white;
}
.create-survey-card.create-survey-card-selected {
  background-color: white;
}
@keyframes gradient {
  0% {
    background-position: 0 7%;
  }
  50% {
    background-position: 100% 94%;
  }
  100% {
    background-position: 0 7%;
  }
}
.ant-modal-mask {
  transition: all 0.15s linear;
}
.create-survey-wrap {
  display: block !important;
  pointer-events: none !important;
  opacity: 0 !important;
  transition: all 0.1s linear;
}
.create-survey-wrap .ant-modal,
.create-survey-wrap .ant-modal-content {
  pointer-events: none !important;
}
.create-survey-modal-open .ant-modal-mask {
  opacity: 1 !important;
}
.create-survey-modal-open .create-survey-wrap {
  pointer-events: all !important;
  opacity: 1 !important;
}
.create-survey-modal-open .create-survey-wrap .ant-modal,
.create-survey-modal-open .create-survey-wrap .ant-modal-content {
  pointer-events: all !important;
}
.ant-menu-item-danger.ant-menu-item {
  color: #f1565d;
}
.ant-menu-item-danger.ant-menu-item:hover,
.ant-menu-item-danger.ant-menu-item-active {
  color: #f1565d;
}
.ant-menu-item-danger.ant-menu-item:active {
  background: #fff1f0;
}
.ant-menu-item-danger.ant-menu-item-selected {
  color: #f1565d;
}
.ant-menu-item-danger.ant-menu-item-selected > a,
.ant-menu-item-danger.ant-menu-item-selected > a:hover {
  color: #f1565d;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  background-color: #fff1f0;
}
.ant-menu-inline .ant-menu-item-danger.ant-menu-item::after {
  border-right-color: #f1565d;
}
.ant-menu-dark .ant-menu-item-danger.ant-menu-item,
.ant-menu-dark .ant-menu-item-danger.ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-danger.ant-menu-item > a {
  color: #f1565d;
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-danger.ant-menu-item-selected {
  color: #fff;
  background-color: #f1565d;
}
.ant-menu {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-variant: tabular-nums;
  line-height: 1.5;
  font-feature-settings: 'tnum';
  margin-bottom: 0;
  padding-left: 0;
  color: #495561;
  font-size: 15px;
  line-height: 0;
  text-align: left;
  list-style: none;
  background: #fff;
  outline: none;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  transition: background 0.3s, width 0.3s cubic-bezier(0.2, 0, 0, 1) 0s;
}
.ant-menu::before {
  display: table;
  content: '';
}
.ant-menu::after {
  display: table;
  clear: both;
  content: '';
}
.ant-menu::before {
  display: table;
  content: '';
}
.ant-menu::after {
  display: table;
  clear: both;
  content: '';
}
.ant-menu.ant-menu-root:focus-visible {
  box-shadow: 0 0 0 2px rgba(14, 104, 249, 0.2);
}
.ant-menu ul,
.ant-menu ol {
  margin: 0;
  padding: 0;
  list-style: none;
}
.ant-menu-overflow {
  display: flex;
}
.ant-menu-overflow-item {
  flex: none;
}
.ant-menu-hidden,
.ant-menu-submenu-hidden {
  display: none;
}
.ant-menu-item-group-title {
  height: 1.5;
  padding: 8px 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 15px;
  line-height: 1.5;
  transition: all 0.3s;
}
.ant-menu-horizontal .ant-menu-submenu {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu,
.ant-menu-submenu-inline {
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-selected {
  color: #0e68f9;
}
.ant-menu-item:active,
.ant-menu-submenu-title:active {
  background: #e6f4ff;
}
.ant-menu-submenu .ant-menu-sub {
  cursor: initial;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-title-content {
  transition: color 0.3s;
}
.ant-menu-item a {
  color: #495561;
}
.ant-menu-item a:hover {
  color: #0e68f9;
}
.ant-menu-item a::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  content: '';
}
.ant-menu-item > .ant-badge a {
  color: #495561;
}
.ant-menu-item > .ant-badge a:hover {
  color: #0e68f9;
}
.ant-menu-item-divider {
  height: 1px;
  overflow: hidden;
  line-height: 0;
  background-color: #f0f0f0;
}
.ant-menu-horizontal .ant-menu-item,
.ant-menu-horizontal .ant-menu-submenu {
  margin-top: -1px;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu .ant-menu-submenu-title:hover {
  background-color: transparent;
}
.ant-menu-item-selected {
  color: #0e68f9;
}
.ant-menu-item-selected a,
.ant-menu-item-selected a:hover {
  color: #0e68f9;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #e6f4ff;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 1px solid #f0f0f0;
}
.ant-menu-vertical-right {
  border-left: 1px solid #f0f0f0;
}
.ant-menu-vertical.ant-menu-sub,
.ant-menu-vertical-left.ant-menu-sub,
.ant-menu-vertical-right.ant-menu-sub {
  min-width: 160px;
  max-height: calc(100vh - 100px);
  padding: 0;
  overflow: hidden;
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub:not([class*='-active']),
.ant-menu-vertical-left.ant-menu-sub:not([class*='-active']),
.ant-menu-vertical-right.ant-menu-sub:not([class*='-active']) {
  overflow-x: hidden;
  overflow-y: auto;
}
.ant-menu-vertical.ant-menu-sub .ant-menu-item,
.ant-menu-vertical-left.ant-menu-sub .ant-menu-item,
.ant-menu-vertical-right.ant-menu-sub .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub .ant-menu-item::after,
.ant-menu-vertical-left.ant-menu-sub .ant-menu-item::after,
.ant-menu-vertical-right.ant-menu-sub .ant-menu-item::after {
  border-right: 0;
}
.ant-menu-vertical.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,
.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,
.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,
.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {
  transform-origin: 0 0;
}
.ant-menu-horizontal.ant-menu-sub {
  min-width: 114px;
}
.ant-menu-horizontal .ant-menu-item,
.ant-menu-horizontal .ant-menu-submenu-title {
  transition: border-color 0.3s, background 0.3s;
}
.ant-menu-item,
.ant-menu-submenu-title {
  position: relative;
  display: block;
  margin: 0;
  padding: 0 20px;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-item .ant-menu-item-icon,
.ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu-item .anticon,
.ant-menu-submenu-title .anticon {
  min-width: 14px;
  font-size: 15px;
  transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s;
}
.ant-menu-item .ant-menu-item-icon + span,
.ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu-item .anticon + span,
.ant-menu-submenu-title .anticon + span {
  margin-left: 10px;
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;
}
.ant-menu-item .ant-menu-item-icon.svg,
.ant-menu-submenu-title .ant-menu-item-icon.svg {
  vertical-align: -0.125em;
}
.ant-menu-item.ant-menu-item-only-child > .anticon,
.ant-menu-submenu-title.ant-menu-item-only-child > .anticon,
.ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon,
.ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon {
  margin-right: 0;
}
.ant-menu-item:focus-visible,
.ant-menu-submenu-title:focus-visible {
  box-shadow: 0 0 0 2px rgba(14, 104, 249, 0.2);
}
.ant-menu > .ant-menu-item-divider {
  height: 1px;
  margin: 1px 0;
  padding: 0;
  overflow: hidden;
  line-height: 0;
  background-color: #f0f0f0;
}
.ant-menu-submenu-popup {
  position: absolute;
  z-index: 1050;
  background: transparent;
  border-radius: 4px;
  box-shadow: none;
  transform-origin: 0 0;
}
.ant-menu-submenu-popup::before {
  position: absolute;
  top: -7px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 0.0001;
  content: ' ';
}
.ant-menu-submenu-placement-rightTop::before {
  top: 0;
  left: -7px;
}
.ant-menu-submenu > .ant-menu {
  background-color: #fff;
  border-radius: 4px;
}
.ant-menu-submenu > .ant-menu-submenu-title::after {
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-popup > .ant-menu {
  background-color: #fff;
}
.ant-menu-submenu-expand-icon,
.ant-menu-submenu-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  color: #495561;
  transform: translateY(-50%);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-submenu-arrow::before,
.ant-menu-submenu-arrow::after {
  position: absolute;
  width: 6px;
  height: 1.5px;
  background-color: currentColor;
  border-radius: 2px;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: '';
}
.ant-menu-submenu-arrow::before {
  transform: rotate(45deg) translateY(-2.5px);
}
.ant-menu-submenu-arrow::after {
  transform: rotate(-45deg) translateY(2.5px);
}
.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon,
.ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  color: #0e68f9;
}
.ant-menu-inline-collapsed .ant-menu-submenu-arrow::before,
.ant-menu-submenu-inline .ant-menu-submenu-arrow::before {
  transform: rotate(-45deg) translateX(2.5px);
}
.ant-menu-inline-collapsed .ant-menu-submenu-arrow::after,
.ant-menu-submenu-inline .ant-menu-submenu-arrow::after {
  transform: rotate(45deg) translateX(-2.5px);
}
.ant-menu-submenu-horizontal .ant-menu-submenu-arrow {
  display: none;
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  transform: translateY(-2px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  transform: rotate(-45deg) translateX(-2.5px);
}
.ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {
  transform: rotate(45deg) translateX(2.5px);
}
.ant-menu-vertical .ant-menu-submenu-selected,
.ant-menu-vertical-left .ant-menu-submenu-selected,
.ant-menu-vertical-right .ant-menu-submenu-selected {
  color: #0e68f9;
}
.ant-menu-horizontal {
  line-height: 46px;
  border: 0;
  border-bottom: 1px solid #f0f0f0;
  box-shadow: none;
}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu {
  margin-top: -1px;
  margin-bottom: 0;
  padding: 0 20px;
}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {
  color: #0e68f9;
}
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {
  border-bottom: 2px solid #0e68f9;
}
.ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  position: relative;
  top: 1px;
  display: inline-block;
  vertical-align: bottom;
}
.ant-menu-horizontal > .ant-menu-item::after,
.ant-menu-horizontal > .ant-menu-submenu::after {
  position: absolute;
  right: 20px;
  bottom: 0;
  left: 20px;
  border-bottom: 2px solid transparent;
  transition: border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  content: '';
}
.ant-menu-horizontal > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0;
}
.ant-menu-horizontal > .ant-menu-item a {
  color: #495561;
}
.ant-menu-horizontal > .ant-menu-item a:hover {
  color: #0e68f9;
}
.ant-menu-horizontal > .ant-menu-item a::before {
  bottom: -2px;
}
.ant-menu-horizontal > .ant-menu-item-selected a {
  color: #0e68f9;
}
.ant-menu-horizontal::after {
  display: block;
  clear: both;
  height: 0;
  content: '\\20';
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item {
  position: relative;
}
.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-right: 3px solid #0e68f9;
  transform: scaleY(0.0001);
  opacity: 0;
  transition: transform 0.15s cubic-bezier(0.215, 0.61, 0.355, 1), opacity 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  content: '';
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  height: 70px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding: 0 16px;
  overflow: hidden;
  line-height: 70px;
  text-overflow: ellipsis;
}
.ant-menu-vertical .ant-menu-submenu,
.ant-menu-vertical-left .ant-menu-submenu,
.ant-menu-vertical-right .ant-menu-submenu,
.ant-menu-inline .ant-menu-submenu {
  padding-bottom: 0.02px;
}
.ant-menu-vertical .ant-menu-item:not(:last-child),
.ant-menu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 8px;
}
.ant-menu-vertical > .ant-menu-item,
.ant-menu-vertical-left > .ant-menu-item,
.ant-menu-vertical-right > .ant-menu-item,
.ant-menu-inline > .ant-menu-item,
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 70px;
  line-height: 70px;
}
.ant-menu-vertical .ant-menu-item-group-list .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 34px;
}
.ant-menu-inline {
  width: 100%;
}
.ant-menu-inline .ant-menu-selected::after,
.ant-menu-inline .ant-menu-item-selected::after {
  transform: scaleY(1);
  opacity: 1;
  transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title {
  width: calc(100% + 1px);
}
.ant-menu-inline .ant-menu-item-group-list .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 34px;
}
.ant-menu-inline.ant-menu-root .ant-menu-item,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  display: flex;
  align-items: center;
  transition: border-color 0.3s, background 0.3s, padding 0.1s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.ant-menu-inline.ant-menu-root .ant-menu-item > .ant-menu-title-content,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > .ant-menu-title-content {
  flex: auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ant-menu-inline.ant-menu-root .ant-menu-item > *,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title > * {
  flex: none;
}
.ant-menu.ant-menu-inline-collapsed {
  width: 80px;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  left: 0;
  padding: 0 calc(50% - 17px / 2);
  text-overflow: clip;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-submenu-arrow,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon {
  margin: 0;
  font-size: 17px;
  line-height: 70px;
}
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .ant-menu-item-icon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item .anticon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-item .anticon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-item-group > .ant-menu-item-group-list > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span,
.ant-menu.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title .anticon + span {
  display: inline-block;
  opacity: 0;
}
.ant-menu.ant-menu-inline-collapsed .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed .anticon {
  display: inline-block;
}
.ant-menu.ant-menu-inline-collapsed-tooltip {
  pointer-events: none;
}
.ant-menu.ant-menu-inline-collapsed-tooltip .ant-menu-item-icon,
.ant-menu.ant-menu-inline-collapsed-tooltip .anticon {
  display: none;
}
.ant-menu.ant-menu-inline-collapsed-tooltip a {
  color: rgba(255, 255, 255, 0.85);
}
.ant-menu.ant-menu-inline-collapsed .ant-menu-item-group-title {
  padding-right: 4px;
  padding-left: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ant-menu-item-group-list {
  margin: 0;
  padding: 0;
}
.ant-menu-item-group-list .ant-menu-item,
.ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 16px 0 28px;
}
.ant-menu-root.ant-menu-vertical,
.ant-menu-root.ant-menu-vertical-left,
.ant-menu-root.ant-menu-vertical-right,
.ant-menu-root.ant-menu-inline {
  box-shadow: none;
}
.ant-menu-root.ant-menu-inline-collapsed .ant-menu-item > .ant-menu-inline-collapsed-noicon,
.ant-menu-root.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-submenu-title > .ant-menu-inline-collapsed-noicon {
  font-size: 17px;
  text-align: center;
}
.ant-menu-sub.ant-menu-inline {
  padding: 0;
  background: #fafafa;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item,
.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 70px;
  line-height: 70px;
  list-style-position: inside;
  list-style-type: disc;
}
.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-left: 32px;
}
.ant-menu-item-disabled,
.ant-menu-submenu-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  background: none;
  cursor: not-allowed;
}
.ant-menu-item-disabled::after,
.ant-menu-submenu-disabled::after {
  border-color: transparent !important;
}
.ant-menu-item-disabled a,
.ant-menu-submenu-disabled a {
  color: rgba(0, 0, 0, 0.25) !important;
  pointer-events: none;
}
.ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
}
.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  background: rgba(0, 0, 0, 0.25) !important;
}
.ant-layout-header .ant-menu {
  line-height: inherit;
}
.ant-menu-light .ant-menu-item:hover,
.ant-menu-light .ant-menu-item-active,
.ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-light .ant-menu-submenu-active,
.ant-menu-light .ant-menu-submenu-title:hover {
  color: #0e68f9;
}
.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-menu.ant-menu-dark .ant-menu-sub {
  color: rgba(255, 255, 255, 0.65);
  background: #001529;
}
.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow {
  opacity: 0.45;
  transition: all 0.3s;
}
.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu.ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  background: #fff;
}
.ant-menu-dark.ant-menu-submenu-popup {
  background: transparent;
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  background: #000c17;
}
.ant-menu-dark.ant-menu-horizontal {
  border-bottom: 0;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,
.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {
  top: 0;
  margin-top: 0;
  padding: 0 20px;
  border-color: #001529;
  border-bottom: 0;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item:hover {
  background-color: #0e68f9;
}
.ant-menu-dark.ant-menu-horizontal > .ant-menu-item > a::before {
  bottom: 0;
}
.ant-menu-dark .ant-menu-item,
.ant-menu-dark .ant-menu-item-group-title,
.ant-menu-dark .ant-menu-item > a,
.ant-menu-dark .ant-menu-item > span > a {
  color: rgba(255, 255, 255, 0.65);
}
.ant-menu-dark.ant-menu-inline,
.ant-menu-dark.ant-menu-vertical,
.ant-menu-dark.ant-menu-vertical-left,
.ant-menu-dark.ant-menu-vertical-right {
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-vertical .ant-menu-item,
.ant-menu-dark.ant-menu-vertical-left .ant-menu-item,
.ant-menu-dark.ant-menu-vertical-right .ant-menu-item {
  left: 0;
  margin-left: 0;
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-dark.ant-menu-vertical-right .ant-menu-item::after {
  border-right: 0;
}
.ant-menu-dark.ant-menu-inline .ant-menu-item,
.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
  width: 100%;
}
.ant-menu-dark .ant-menu-item:hover,
.ant-menu-dark .ant-menu-item-active,
.ant-menu-dark .ant-menu-submenu-active,
.ant-menu-dark .ant-menu-submenu-open,
.ant-menu-dark .ant-menu-submenu-selected,
.ant-menu-dark .ant-menu-submenu-title:hover {
  color: #fff;
  background-color: transparent;
}
.ant-menu-dark .ant-menu-item:hover > a,
.ant-menu-dark .ant-menu-item-active > a,
.ant-menu-dark .ant-menu-submenu-active > a,
.ant-menu-dark .ant-menu-submenu-open > a,
.ant-menu-dark .ant-menu-submenu-selected > a,
.ant-menu-dark .ant-menu-submenu-title:hover > a,
.ant-menu-dark .ant-menu-item:hover > span > a,
.ant-menu-dark .ant-menu-item-active > span > a,
.ant-menu-dark .ant-menu-submenu-active > span > a,
.ant-menu-dark .ant-menu-submenu-open > span > a,
.ant-menu-dark .ant-menu-submenu-selected > span > a,
.ant-menu-dark .ant-menu-submenu-title:hover > span > a {
  color: #fff;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow {
  opacity: 1;
}
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-item:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-active > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-title:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before {
  background: #fff;
}
.ant-menu-dark .ant-menu-item:hover {
  background-color: transparent;
}
.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: #0e68f9;
}
.ant-menu-dark .ant-menu-item-selected {
  color: #fff;
  border-right: 0;
}
.ant-menu-dark .ant-menu-item-selected::after {
  border-right: 0;
}
.ant-menu-dark .ant-menu-item-selected > a,
.ant-menu-dark .ant-menu-item-selected > span > a,
.ant-menu-dark .ant-menu-item-selected > a:hover,
.ant-menu-dark .ant-menu-item-selected > span > a:hover {
  color: #fff;
}
.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon,
.ant-menu-dark .ant-menu-item-selected .anticon {
  color: #fff;
}
.ant-menu-dark .ant-menu-item-selected .ant-menu-item-icon + span,
.ant-menu-dark .ant-menu-item-selected .anticon + span {
  color: #fff;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  background-color: #0e68f9;
}
.ant-menu-dark .ant-menu-item-disabled,
.ant-menu-dark .ant-menu-submenu-disabled,
.ant-menu-dark .ant-menu-item-disabled > a,
.ant-menu-dark .ant-menu-submenu-disabled > a,
.ant-menu-dark .ant-menu-item-disabled > span > a,
.ant-menu-dark .ant-menu-submenu-disabled > span > a {
  color: rgba(255, 255, 255, 0.35) !important;
  opacity: 0.8;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title {
  color: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::before,
.ant-menu-dark .ant-menu-item-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after,
.ant-menu-dark .ant-menu-submenu-disabled > .ant-menu-submenu-title > .ant-menu-submenu-arrow::after {
  background: rgba(255, 255, 255, 0.35) !important;
}
.ant-menu.ant-menu-rtl {
  direction: rtl;
  text-align: right;
}
.ant-menu-rtl .ant-menu-item-group-title {
  text-align: right;
}
.ant-menu-rtl.ant-menu-inline,
.ant-menu-rtl.ant-menu-vertical {
  border-right: none;
  border-left: 1px solid #f0f0f0;
}
.ant-menu-rtl.ant-menu-dark.ant-menu-inline,
.ant-menu-rtl.ant-menu-dark.ant-menu-vertical {
  border-left: none;
}
.ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical.ant-menu-sub > .ant-menu-submenu,
.ant-menu-rtl.ant-menu-vertical-left.ant-menu-sub > .ant-menu-submenu,
.ant-menu-rtl.ant-menu-vertical-right.ant-menu-sub > .ant-menu-submenu {
  transform-origin: top right;
}
.ant-menu-rtl .ant-menu-item .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-submenu-title .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-item .anticon,
.ant-menu-rtl .ant-menu-submenu-title .anticon {
  margin-right: auto;
  margin-left: 10px;
}
.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .ant-menu-item-icon,
.ant-menu-rtl .ant-menu-item.ant-menu-item-only-child > .anticon,
.ant-menu-rtl .ant-menu-submenu-title.ant-menu-item-only-child > .anticon {
  margin-left: 0;
}
.ant-menu-submenu-rtl.ant-menu-submenu-popup {
  transform-origin: 100% 0;
}
.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow,
.ant-menu-rtl .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  right: auto;
  left: 16px;
}
.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::before,
.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::before {
  transform: rotate(-45deg) translateY(-2px);
}
.ant-menu-rtl .ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-rtl .ant-menu-submenu-vertical-left > .ant-menu-submenu-title .ant-menu-submenu-arrow::after,
.ant-menu-rtl .ant-menu-submenu-vertical-right > .ant-menu-submenu-title .ant-menu-submenu-arrow::after {
  transform: rotate(45deg) translateY(2px);
}
.ant-menu-rtl.ant-menu-vertical .ant-menu-item::after,
.ant-menu-rtl.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-rtl.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-rtl.ant-menu-inline .ant-menu-item::after {
  right: auto;
  left: 0;
}
.ant-menu-rtl.ant-menu-vertical .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-left .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical-right .ant-menu-item,
.ant-menu-rtl.ant-menu-inline .ant-menu-item,
.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-rtl.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-rtl.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {
  text-align: right;
}
.ant-menu-rtl.ant-menu-inline .ant-menu-submenu-title {
  padding-right: 0;
  padding-left: 34px;
}
.ant-menu-rtl.ant-menu-vertical .ant-menu-submenu-title {
  padding-right: 16px;
  padding-left: 34px;
}
.ant-menu-rtl.ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title {
  padding: 0 calc(50% - 17px / 2);
}
.ant-menu-rtl .ant-menu-item-group-list .ant-menu-item,
.ant-menu-rtl .ant-menu-item-group-list .ant-menu-submenu-title {
  padding: 0 28px 0 16px;
}
.ant-menu-sub.ant-menu-inline {
  border: 0;
}
.ant-menu-rtl.ant-menu-sub.ant-menu-inline .ant-menu-item-group-title {
  padding-right: 32px;
  padding-left: 0;
}
.ant-menu-item {
  border-bottom: 1px solid rgba(34, 38, 60, 0.08);
  padding: 0 12px !important;
}
.ant-menu-item-selected {
  background: transparent !important;
  font-weight: 700;
}
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  margin-top: 0;
  margin-bottom: 0;
}
.ant-menu-vertical .ant-menu-item:not(:last-child),
.ant-menu-vertical-left .ant-menu-item:not(:last-child),
.ant-menu-vertical-right .ant-menu-item:not(:last-child),
.ant-menu-inline .ant-menu-item:not(:last-child) {
  margin-bottom: 0;
}
.ant-menu.ant-menu-vertical {
  border: 0;
}
.menu {
  width: 226px;
  border-radius: 10px;
  overflow: hidden;
  -webkit-box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.pf-theme .ant-dropdown .ant-menu {
  width: 226px;
  overflow: hidden;
  border: none;
}
.pf-theme .ant-dropdown .ant-menu-item {
  padding: 0 12px !important;
  height: 36px !important;
  line-height: 36px !important;
  border: 0;
  transition: none;
  margin: 0;
  font-size: 15px;
}
.pf-theme .ant-dropdown .ant-menu-item a {
  color: #323945;
  transition: none;
}
.pf-theme .ant-dropdown .ant-menu-item:hover {
  color: white !important;
}
.pf-theme .ant-dropdown .ant-menu-item:active,
.pf-theme .ant-dropdown .ant-menu-item:focus,
.pf-theme .ant-dropdown .ant-menu-item:hover {
  background-color: #e6f4ff !important;
}
.pf-theme .ant-dropdown .ant-menu-item:active a,
.pf-theme .ant-dropdown .ant-menu-item:focus a,
.pf-theme .ant-dropdown .ant-menu-item:hover a {
  color: #0e68f9 !important;
}
.pf-theme .ant-dropdown .ant-menu-item:last-child {
  border-top: 1px solid #e1e6ec;
}
.pf-theme .ant-dropdown .ant-dropdown-menu-item-short {
  height: 32px !important;
  line-height: 32px !important;
  margin: 3px 0;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.pf-theme .rule-submenu-list.ant-dropdown-menu-submenu ul {
  max-width: 320px;
  max-height: 326px;
  overflow: auto;
}
.pf-theme .rule-submenu-list.ant-dropdown-menu-submenu li {
  overflow: hidden;
  text-overflow: ellipsis;
}
.pf-theme .rule-submenu-list-visibility.ant-dropdown-menu-submenu ul {
  max-width: 285px;
}
.pf-theme .rule-submenu-list-grouped.ant-dropdown-menu-submenu ul {
  min-width: 280px;
  max-height: 426px;
}
.pf-theme .ant-dropdown-menu-green .ant-dropdown-menu-item-active {
  background-color: #d0fef0 !important;
  color: #323945 !important;
}
.pf-theme .ant-dropdown-menu-green .ant-dropdown-menu-submenu-active:hover .ant-dropdown-menu-submenu-title:hover {
  background-color: #d0fef0 !important;
}
main .ant-dropdown-menu,
aside .ant-dropdown-menu {
  padding: 6px 8px !important;
}
.account-settings__item {
  color: #323945;
}
.account-settings__item.ant-menu-item-active a,
.account-settings__item.ant-menu-item-active:active a,
.account-settings__item.ant-menu-item-active:focus a,
.account-settings__item.ant-menu-item-active:hover a {
  color: #0e68f9;
}
.account-settings__item.ant-menu-item-selected a,
.account-settings__item .ant-menu-item-selected:active a,
.account-settings__item.ant-menu-item-selected:focus a,
.account-settings__item.ant-menu-item-selected:hover a {
  color: #0e68f9;
}
.pf-new-theme .recall-container .ant-menu {
  padding-right: 0 !important;
}
.ant-menu-sub[id*='loop-merge-popup'] li,
.ant-menu-sub[id*='recall-questions'] li {
  height: auto !important;
  overflow: visible !important;
  border: 0 !important;
  padding: 2px 8px !important;
  font-weight: normal !important;
}
.ant-menu-sub[id*='loop-merge-popup'] li:active,
.ant-menu-sub[id*='recall-questions'] li:active,
.ant-menu-sub[id*='loop-merge-popup'] li:focus,
.ant-menu-sub[id*='recall-questions'] li:focus,
.ant-menu-sub[id*='loop-merge-popup'] li:hover,
.ant-menu-sub[id*='recall-questions'] li:hover {
  color: inherit !important;
}
.ant-menu-sub[id*='loop-merge-popup'] .ant-menu-vertical > .ant-menu-item,
.ant-menu-sub[id*='recall-questions'] .ant-menu-vertical > .ant-menu-item {
  line-height: 30px !important;
  height: 32px !important;
}
.radius-label {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.radius-slider-wrapper {
  display: inline-flex;
  flex-direction: row;
  width: 150px;
}
.radius-slider-wrapper .ant-slider-handle {
  background-color: #0e68f9 !important;
  margin-top: -6px !important;
  border: 0 !important;
}
.radius-slider-wrapper .ant-slider-rail {
  background-color: #bfc8d5 !important;
}
.radius-slider-wrapper .ant-slider-track {
  background-color: #0e68f9 !important;
}
.radius-slider-wrapper .ant-slider-track,
.radius-slider-wrapper .ant-slider-rail {
  height: 2px;
}
.radius-slider {
  flex: 1;
  height: 8px !important;
}
.radius-slider-input.ant-input-number {
  width: 50px !important;
  border: 0 !important;
}
.radius-map-search {
  text-indent: 10px;
  z-index: 50;
  width: 100% !important;
  margin-left: 0 !important;
  margin-bottom: 12px;
  left: initial !important;
  background-color: #f3f6fb !important;
  position: relative !important;
  height: 38px !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
.radius-map-search::placeholder {
  color: #5c6776 !important;
}
.radius-map-search:focus,
.radius-map-search:active {
  border-color: #40a9ff;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}
.logic-tooltip {
  padding-top: 0;
  max-width: unset;
}
.logic-tooltip .ant-tooltip-arrow {
  top: -12px !important;
}
.logic-tooltip .ant-tooltip-inner {
  line-height: 1;
  padding-top: 0;
  padding-bottom: 0;
  min-height: initial;
  font-size: 12px;
  border-radius: 4px;
}
.logic-path-preview {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
.logic-path-preview .node rect,
.logic-path-preview .node polygon,
.logic-path-preview .node circle,
.logic-path-preview .node ellipse {
  fill: #ececff;
  stroke: #9370db;
  stroke-width: 1px;
}
.logic-path-preview .node text {
  fill: #323945;
  font-weight: bold;
}
.logic-path-preview .node .question-index {
  font-size: 12px;
  font-weight: bold;
}
.logic-path-preview .node .question-text {
  font-size: 12px;
  font-weight: 400;
}
.logic-path-preview .node.node-hidden rect,
.logic-path-preview .node.node-hidden polygon,
.logic-path-preview .node.node-hidden circle,
.logic-path-preview .node.node-hidden ellipse {
  fill: #f3f6fb;
  stroke: #e0e6ed;
  stroke-width: 1px;
}
.logic-path-preview .node.node-hidden text {
  fill: #bfc8d5;
  font-weight: bold;
}
.logic-path-preview .node.node-display-logic rect,
.logic-path-preview .node.node-display-logic polygon,
.logic-path-preview .node.node-display-logic circle,
.logic-path-preview .node.node-display-logic ellipse {
  stroke-dasharray: 3, 3;
}
.logic-path-preview .node.clickable rect,
.logic-path-preview .node.clickable polygon,
.logic-path-preview .node.clickable circle,
.logic-path-preview .node.clickable ellipse {
  cursor: pointer;
}
.logic-path-preview .node.clickable text,
.logic-path-preview .node.clickable div {
  cursor: pointer;
  user-select: none;
}
.logic-path-preview .node.clickable:hover:not(.node-logic-icon-hover) rect,
.logic-path-preview .node.clickable:hover:not(.node-logic-icon-hover) polygon,
.logic-path-preview .node.clickable:hover:not(.node-logic-icon-hover) circle,
.logic-path-preview .node.clickable:hover:not(.node-logic-icon-hover) ellipse {
  stroke-width: 2px;
}
.logic-path-preview .node .display-logic-action,
.logic-path-preview .node .hidden-logic-action {
  display: flex;
}
.logic-path-preview .node .node-logic-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.logic-path-preview .node .node-logic-icon-purple {
  background-color: #dedeff;
}
.logic-path-preview .node .node-logic-icon-purple:hover {
  background-color: #d6d6fb;
}
.logic-path-preview .edgePath path.path {
  stroke: #9370db;
  fill: #9370db;
  stroke-width: 1px;
}
.logic-path-preview .edgePath.dashed {
  stroke-dasharray: 5, 5;
}
.logic-path-preview .arrowhead {
  stroke: #9370db;
  fill: #9370db;
  stroke-width: 1.5px;
}
.logic-path-preview .node-label {
  padding: 10px;
  position: relative;
}
.logic-path-actions {
  position: absolute;
  top: 5px;
  right: 10px;
  width: 24px;
}
.logic-path-actions button {
  width: 24px;
  height: 24px;
  border: 1px solid #9370db;
  opacity: 1;
}
.logic-path-actions button:active,
.logic-path-actions button:focus,
.logic-path-actions button:hover {
  border-color: #9370db;
}
.logic-path-actions button:hover {
  opacity: 0.7;
}
.pf-new-theme .logic-path-actions .ant-btn {
  color: #9370db;
  font-size: 12px;
}
.logic-path-info {
  position: absolute;
  top: 5px;
  left: 10px;
}
.logic-path-info-item {
  background-color: #eff3f7;
  border-radius: 36px;
}
.grippy {
  position: relative;
  height: 0px;
  font-size: 12px;
  color: #323945;
  cursor: move;
  z-index: 2;
  top: 7px;
  left: 8px;
  transition: left 0.25s;
}
.grippy div {
  display: flex;
  align-items: center;
  height: 52px;
  width: 35px;
  padding: 0 10px 0 18px;
}
.drag-card.drag-guide-bottom:after,
.drag-card.drag-guide-top:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: #323945;
}
.drag-card.drag-guide-bottom:after {
  bottom: -1px;
  transform: translateY(50%);
}
.drag-card.drag-guide-top:after {
  top: -1px;
  transform: translateY(-50%);
}
.drag-card:hover + .add-question__button-wrapper .add-question__button {
  display: inline-block !important;
}
.drag-card.group-active.drag-type-group:not(.reset-grippy) > .grippy {
  top: 7px;
  left: -10px;
}
.drag-card.drag-type-question,
.drag-card.drag-type-screening-question,
.drag-card.drag-type-question-group-only {
  transition: all 0.3s;
}
.drag-card.drag-type-question .grippy,
.drag-card.drag-type-screening-question .grippy,
.drag-card.drag-type-question-group-only .grippy {
  top: 3px;
  left: 0;
}
.drag-card.drag-type-question .ant-collapse-content-box > .ant-divider-horizontal,
.drag-card.drag-type-screening-question .ant-collapse-content-box > .ant-divider-horizontal,
.drag-card.drag-type-question-group-only .ant-collapse-content-box > .ant-divider-horizontal {
  width: calc(100% + 24px);
  margin-left: -24px;
}
.drag-card.drag-type-screening-question .grippy {
  top: 16px;
}
.drag-card.group-active.drag-type-question:not(.reset-grippy) .grippy,
.drag-card.group-active.drag-type-question-group-only:not(.reset-grippy) .grippy {
  top: 3px;
  left: -20px;
}
.drag-card.group-active.drag-type-screening-question:not(.reset-grippy) .grippy {
  top: 16px;
  left: -20px;
}
.drag-card.drag-type-group .drag-type-question.group-active .grippy {
  left: -28px;
}
.drag-card.drag-type-group-property > .grippy {
  top: 18px;
  left: 8px;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.drag-card.drag-type-group-property > .grippy.cursor-disabled {
  pointer-events: none;
}
.drag-card.drag-type-group-property > .grippy:not(.cursor-disabled):hover,
.drag-card.drag-type-group-property:hover:not(:has(.drag-card:hover)) > .grippy:not(.cursor-disabled),
.drag-card.drag-type-group-property:focus-within:not(:has(.drag-card:focus-within)) > .grippy:not(.cursor-disabled) {
  opacity: 1;
}
.drag-card.drag-type-attribute-level > .grippy {
  top: 4px;
  left: -42px;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.drag-card.drag-type-attribute-level > .grippy.cursor-disabled {
  pointer-events: none;
}
.drag-card.drag-type-attribute-level > .grippy div {
  height: 30px;
  width: 35px;
  padding: 0 10px 0 18px;
}
.drag-card.drag-type-attribute-level > .grippy:not(.cursor-disabled):hover,
.drag-card.drag-type-attribute-level:hover > .grippy:not(.cursor-disabled),
.drag-card.drag-type-attribute-level:focus-within > .grippy:not(.cursor-disabled) {
  opacity: 1;
}
.is-drop-active.group-active .drop-box {
  background-color: #fafafa;
}
.is-drop-active .drop-box {
  background-color: #f3f6fb;
}
.ant-collapse-inactive-arrow .ant-collapse-arrow {
  color: #bfc8d5 !important;
}
.questionnaire-card {
  transition: margin-left 0.3s, background-color 0.2s;
}
.questionnaire-card.questionnaire-card-hidden:before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 3;
  border-radius: inherit;
}
.questionnaire-card.questionnaire-card-hidden > * {
  position: relative;
}
.questionnaire-card .ant-collapse-arrow,
.questionnaire-card .keep-opaque-element {
  position: relative;
  z-index: 4;
}
.questionnaire-group {
  transition: margin-left 0.3s, background-color 0.3s;
}
.questionnaire-group .ant-collapse-borderless {
  background-color: transparent !important;
}
.questionnaire-group .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  cursor: default;
}
.group-active .questionnaire-group .ant-collapse-content {
  overflow: visible;
}
.questionnaire-group .ant-collapse-content {
  overflow: visible;
}
.pf-new-theme .questionnaire-group .questionnnaire-card {
  background-color: #f5f7fa;
}
.pf-new-theme .questionnaire-group.dragging {
  opacity: 0.2;
}
.pf-new-theme .questionnaire-group .dragging .questionnaire-card {
  opacity: 0.2;
}
.pf-new-theme .questionnaire-group .group-active .questionnnaire-card {
  background-color: #fff;
}
.questionnaire-group.questionnaire-group-hidden:before {
  transition: all 0.3s;
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 4;
  bottom: 8px;
}
.questionnaire-group.questionnaire-group-hidden.margin-left-negative-md:before {
  left: -16px;
}
.questionnaire-group.questionnaire-group-hidden > * {
  position: relative;
}
.questionnaire-group .ant-collapse-arrow,
.questionnaire-group .keep-opaque-element {
  position: relative;
  z-index: 4;
}
.questionnaire-group .questionnaire-card .ant-collapse-arrow,
.questionnaire-group .attribute-group-card .ant-collapse-arrow {
  z-index: 3;
}
.pf-ant-collapse.ant-collapse-question {
  padding-left: 24px;
}
.move-questions-modal .ant-checkbox {
  display: inline-block;
}
.move-questions-modal .checked {
  background-color: #ebf3ff;
}
.move-questions-modal .ant-checkbox-wrapper.checked {
  background-color: #ebf3ff;
}
.move-questions-modal .pf-select .ant-select-selector-placeholder {
  color: #323945 !important;
}
.pf-new-theme .move-questions-modal .ant-modal-body {
  padding: 0;
}
.pf-new-theme .drilldown-manually-modal .ant-modal-body {
  padding: 0;
}
.pf-new-theme .drilldown-manually-modal .ant-modal-content {
  padding: 16px;
}
.pf-new-theme .drilldown-manually-modal.ant-modal .ant-modal-header {
  padding-bottom: 8px;
}
.drilldown-manually-modal .ant-input:hover,
.drilldown-manually-modal .ant-input:focus {
  border-color: #e7ebef;
  box-shadow: none;
}
.node-type-select.ant-select-disabled .ant-select-selector,
.conjoint-select.ant-select-disabled .ant-select-selector,
.matrix-select.ant-select-disabled .ant-select-selector,
.abType-select.ant-select-disabled .ant-select-selector {
  background-color: white;
  border: 1px solid #e7ebef;
}
.node-type-select.ant-select-disabled .ant-select-selector-selected-value,
.conjoint-select.ant-select-disabled .ant-select-selector-selected-value,
.matrix-select.ant-select-disabled .ant-select-selector-selected-value,
.abType-select.ant-select-disabled .ant-select-selector-selected-value {
  color: #bfc8d5 !important;
}
.node-type-select.ant-select-disabled .ant-select-arrow,
.conjoint-select.ant-select-disabled .ant-select-arrow,
.matrix-select.ant-select-disabled .ant-select-arrow,
.abType-select.ant-select-disabled .ant-select-arrow {
  color: #bfc8d5 !important;
}
.node-type-select .ant-select-selection-item .opacity-40 {
  opacity: 1;
}
.node-type-select.custom-question-select.ant-select.ant-select-single {
  height: 32px;
}
.node-type-select.custom-question-select.ant-select.ant-select-single .ant-select-selector {
  height: 32px;
}
.node-type-select.custom-question-select.ant-select.ant-select-single .ant-select-selection-item {
  line-height: 30px;
}
.conjoint-select.ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height: 30px;
}
.conjoint-select.ant-select.ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item {
  color: #323945;
  font-weight: 400;
}
.questions-setting-shuffling .ant-select-disabled .ant-select-selector {
  background-color: white;
  border: 1px solid #e7ebef;
}
.questions-setting-shuffling .ant-select-disabled .ant-select-selector-selected-value {
  color: #bfc8d5 !important;
}
.questions-setting-shuffling .ant-select-disabled .ant-select-arrow {
  color: #bfc8d5 !important;
}
.add-question-img-wrapper {
  width: 341px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.add-question-img-wrapper img {
  width: 100%;
  height: 100%;
}
.pf-theme .color-light-green:focus {
  color: #00cf83;
}
.force-background-grey-1 {
  background-color: #ffffff !important;
  background: #ffffff !important;
}
.force-background-grey-2 {
  background-color: #fafafa !important;
  background: #fafafa !important;
}
.force-background-transparent {
  background-color: transparent !important;
  background: transparent !important;
}
.force-text-weight-regular {
  font-weight: normal !important;
}
.force-text-weight-500 {
  font-weight: 500;
}
.force-text-weight-700 {
  font-weight: 700;
}
.force-border-right-grey-4 {
  border-right: 1px solid #f3f6fb !important;
}
.force-border-right-grey-6 {
  border-right: 1px solid #e0e6ed !important;
}
.force-border-right-none {
  border-right: 0px !important;
}
.force-border-bottom-grey-4 {
  border-bottom: 1px solid #f3f6fb !important;
}
.force-border-bottom-transparent {
  border-bottom: 1px solid transparent !important;
}
.pf-theme .table-node .ant-table-tbody > tr > td:first-child {
  border-left: none;
}
.table-node .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: transparent;
}
.table-node .ant-table-header-column {
  width: 100%;
}
.table-node textarea.ant-input {
  min-height: 0;
}
.table-node textarea.ant-input:focus {
  box-shadow: none;
}
.table-node .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
  width: 0;
}
.table-node.table-node--hide .ant-table-content {
  overflow: hidden !important;
}
.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(
    .ant-table-row-selected
  ) > td {
  background: transparent;
}
.input-auto-sizer {
  display: inline-grid;
  font-size: 12px;
}
.input-auto-sizer::after,
.input-auto-sizer input {
  width: auto;
  min-width: 1em;
  grid-area:  1 / 2;
  font: inherit;
  padding: 0;
  margin: 0;
  resize: none;
  background: none;
  appearance: none;
  border: none;
  outline: none;
}
.input-auto-sizer::after {
  content: attr(data-value) ' ';
  visibility: hidden;
  white-space: pre-wrap;
}
.group-same-page-border {
  border: 1px solid #2e69f080;
  border-style: dashed;
}
.group-same-page-label {
  background-color: #2e69f0;
  width: 117px;
  left: 25px;
  position: relative;
}
.group-active .group-same-page-label {
  left: 23px;
}
.group-same-page.drag-type-group:not(.reset-grippy) > .grippy {
  top: 27px !important;
}
.group-loop-and-merge-label {
  background-color: #f3f6fb;
  width: 105px;
  left: 25px;
  position: relative;
}
.group-active .group-loop-and-merge-label {
  left: 23px;
}
.group-loop-and-merge.drag-type-group:not(.reset-grippy) > .grippy {
  top: 27px !important;
}
.screening-details {
  position: absolute;
  z-index: 5;
  right: 0;
  bottom: 0;
  width: 100%;
  min-height: 200px;
  max-width: 390px;
  height: auto;
  overflow: auto;
  background-color: white;
  color: #323945;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 8px 0 rgba(92, 103, 118, 0.2);
  -moz-box-shadow: 0 4px 8px 0 rgba(92, 103, 118, 0.2);
  box-shadow: 0 4px 8px 0 rgba(92, 103, 118, 0.2);
}
.screening-details-header {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 32px;
  background-color: #e7ebef;
  padding: 0 16px;
  z-index: 1000;
  text-indent: -1px;
}
.screening-details-content {
  padding: 16px;
}
.screening-details-close {
  border: 0;
  padding: 0;
  margin-right: -3px;
}
.screening-details-row {
  margin-bottom: 7px;
}
.screening-details-item {
  position: relative;
  display: flex;
  align-items: center;
}
.screening-details-item:before {
  content: ' ';
  display: block;
  width: 8px;
  height: 8px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #61a8ff;
  margin-right: 8px;
}
.screening-details-item.screening-details-item--no:before {
  background-color: #ffc28a;
}
.screening-details-bar-wrapper {
  margin: 0 4px;
}
.screening-details-bar {
  width: 100%;
}
.screening-details-bar.screening-details-bar--reverse {
  direction: rtl;
}
.screening-details-bar .ant-progress-bg {
  background-color: #eef3f7;
}
.screening-details-bar.screening-details-bar--orange .ant-progress-bg {
  background-color: #ffc28a;
}
.screening-details-bar.screening-details-bar--blue .ant-progress-bg {
  background-color: #61a8ff;
}
.screening-details-bar-number {
  position: absolute;
  z-index: 1;
  top: -10px;
  right: 0;
}
.screening-details-bar-number.screening-details-bar-number--reverse {
  left: 2px;
  right: initial;
}
.screening-details-secondary {
  color: #bfc8d5;
}
.screening-details-answer-index {
  width: 30px;
}
.ant-tag-no-hover {
  opacity: 1!important;
}
.icon-disabled.icon-ab-group .path1::before {
  color: #e7ebef;
}
.icon-disabled.icon-ab-group .path2::before {
  color: #8f98a9;
}
.icon-disabled.icon-conjoint .path1::before {
  color: #e7ebef;
}
.icon-disabled.icon-conjoint .path2::before {
  color: #8f98a9;
}
.icon-disabled.icon-maxdiff-group .path1::before {
  color: #e7ebef;
}
.icon-disabled.icon-maxdiff-group .path2::before,
.icon-disabled.icon-maxdiff-group .path3::before {
  color: #8f98a9;
}
.icon-disabled.icon-van-westendorp-group .path1::before {
  color: #e7ebef;
}
.icon-disabled.icon-van-westendorp-group .path2::before,
.icon-disabled.icon-van-westendorp-group .path3::before,
.icon-disabled.icon-van-westendorp-group .path4::before,
.icon-disabled.icon-van-westendorp-group .path5::before,
.icon-disabled.icon-van-westendorp-group .path6::before {
  color: #8f98a9;
}
.icon-disabled.icon-screening::before {
  background-color: #bfc8d5;
  border-radius: 4px;
}
.icon-disabled.icon-question-group::before {
  background-color: #bfc8d5;
  border-radius: 4px;
}
.icon-disabled.icon-loop-merge-boxed::before {
  background-color: #bfc8d5;
  border-radius: 4px;
}
.audience-template-card:hover .display-container {
  display: none;
}
.audience-template-card:hover .hover-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.audience-template-card:hover .hover-container .template-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2em;
  max-height: 2.4em;
  text-overflow: ellipsis;
}
.audience-template-card .hover-container {
  display: none;
}
.pf-new-theme {
  /* Firefox */
}
.pf-new-theme .surveys-filters-sider-mobile-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  z-index: 1000;
  width: 0;
  transition: width 0.3s linear;
  overflow: hidden;
}
.pf-new-theme .surveys-filters-sider-mobile-wrapper.surveys-filters-sider-mobile-wrapper--open {
  width: 262px;
}
.pf-new-theme .surveys-filters-sider-mobile {
  background-color: white;
  position: absolute;
  width: 262px;
  height: 100%;
  overflow: auto;
  left: 0;
  top: 0;
}
@media (max-width: 470px) {
  .pf-new-theme .survey-name-title {
    width: 100px;
  }
}
.pf-new-theme .ant-menu-inline-collapsed-tooltip {
  display: none;
}
.pf-new-theme .ant-modal-close {
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.pf-new-theme body.accessible-on .outline-blue:focus,
.pf-new-theme body.accessible-on .ant-modal-close:focus {
  outline: #175aa5 solid 2px;
  outline-offset: 1px;
}
.pf-new-theme .integration-help .ant-collapse-item .ant-collapse-content {
  border-radius: 0;
}
.pf-new-theme .integration-help .ant-collapse-content-box {
  padding: 8px 16px;
  background-color: #f9fafc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  line-height: 1.5;
}
.pf-new-theme .integration-help .ant-collapse-content-box li {
  margin: 5px 0;
}
.pf-new-theme .integration-help .integration-form {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.pf-new-theme .pf-tabs .ant-tabs-nav-list {
  width: 100%;
}
.pf-new-theme .pf-tabs .ant-tabs-nav-list .ant-tabs-tab {
  flex: 1;
  justify-content: center;
  color: #323945;
}
.pf-new-theme .pf-tabs .ant-tabs-nav-list .ant-tabs-tab:hover {
  color: inherit;
}
.pf-new-theme .pf-tabs .ant-tabs-nav-list .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #0e68f9;
}
.pf-new-theme .pf-tabs .ant-tabs-nav-list .ant-tabs-ink-bar {
  background-color: #0e68f9;
}
.pf-new-theme .pf-tabs .ant-tabs-nav-list .ant-tabs-tab + .ant-tabs-tab {
  margin-left: 0;
}
.pf-new-theme .animated-box {
  --border-size: 2px;
  --border-angle: 0turn;
  background-image: conic-gradient(from var(--border-angle), white, white 50%, white), conic-gradient(from var(--border-angle), transparent 10%, #eff5ff, #c9deff, #17dcff, #0e68f9);
  background-size: calc(100% - (var(--border-size) * 2)) calc(100% - (var(--border-size) * 2)), cover;
  background-position: center center;
  background-repeat: no-repeat;
  animation: bg-spin 4s linear infinite;
}
@keyframes bg-spin {
  to {
    --border-angle: 1turn;
  }
}
@property --border-angle {
  syntax: '<angle>';
  inherits: true;
  initial-value: 0turn;
}
.pf-new-theme .pf-line-loader {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  perspective: 800px;
}
.pf-new-theme .pf-line-loader-inner {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.pf-new-theme .pf-line-loader-inner.one {
  left: 0%;
  top: 0%;
  animation: rotate-one 1s linear infinite;
  border-bottom: 3px solid #8f98a9;
}
.pf-new-theme .pf-line-loader-inner.two {
  right: 0%;
  top: 0%;
  animation: rotate-two 1s linear infinite;
  border-right: 3px solid #8f98a9;
}
.pf-new-theme .pf-line-loader-inner.three {
  right: 0%;
  bottom: 0%;
  animation: rotate-three 1s linear infinite;
  border-top: 3px solid #8f98a9;
}
@keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}
@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}
@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}
.pf-new-theme .pf-ai-prompt-area {
  -webkit-background-size: 400% 400% !important;
  background-size: 400% 400% !important;
  background: linear-gradient(68deg, #f4e2fd, #e1e8fe, #f4e2fd, #e1e8fe);
  animation: gradient 8s linear infinite;
  -webkit-animation-direction: alternate;
  -moz-animation-direction: alternate;
  -o-animation-direction: alternate;
  animation-direction: alternate;
}
.pf-new-theme .bar-chart {
  height: 100px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.pf-new-theme .bar-chart > div {
  background-color: #509ee3;
  box-sizing: border-box;
  position: relative;
  color: transparent;
  z-index: 10;
}
.pf-new-theme .bar-chart > div::before {
  content: ' ';
  display: block;
  position: absolute;
  z-index: 10;
  left: 0;
  bottom: 0;
  height: 166px;
  width: 1px;
  background-color: #e7ebef;
}
.pf-new-theme .bar-chart > div:after {
  display: none !important;
}
.pf-new-theme .bar-chart > div:first-child {
  opacity: 0.25;
}
.pf-new-theme .bar-chart > div:first-child:after {
  content: '';
  display: inline-block;
  position: absolute;
  background-color: white;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  background-color: #fff;
  border-bottom: 40px solid #509ee3;
  border-right: 70px solid transparent;
}
.pf-new-theme .bar-chart > div:nth-child(2) {
  opacity: 0.2;
}
.pf-new-theme .bar-chart > div:nth-child(2):after {
  content: '';
  display: inline-block;
  position: absolute;
  background-color: white;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  background-color: #fff;
  border-bottom: 60px solid #509ee3;
  border-right: 70px solid transparent;
}
.pf-new-theme .bar-chart > div:nth-child(3) {
  opacity: 0.17;
}
.pf-new-theme .bar-chart > div:nth-child(3):after {
  content: '';
  display: inline-block;
  position: absolute;
  background-color: white;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  background-color: #fff;
  border-bottom: 40px solid #509ee3;
  border-right: 70px solid transparent;
}
.pf-new-theme .bar-chart > div:nth-child(4) {
  opacity: 0.14;
}
.pf-new-theme .bar-chart > div:nth-child(5) {
  opacity: 0.1;
}
.pf-new-theme .bar-chart > div:nth-child(6) {
  opacity: 0.05;
}
.pf-new-theme .survey-summary-stats {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: white;
}
.pf-new-theme .survey-summary-stats-bg {
  background: #e4eafd;
}
.pf-new-theme .survey-summary-stats-bg.survey-summary-stats-bg--dlink {
  background: linear-gradient(323.86deg, #ffffff 15.95%, rgba(216, 238, 215, 0.26) 91.98%);
}
.pf-new-theme .survey-summary-stats-bg.survey-summary-stats-bg--peeq {
  background: linear-gradient(323.86deg, #ffffff 15.95%, rgba(210, 202, 241, 0.16) 91.98%);
}
.pf-new-theme .survey-summary-stats-hide-desktop {
  display: none;
}
.pf-new-theme .survey-summary-stats__entry {
  display: flex;
  flex-direction: column;
}
.pf-new-theme .survey-summary-stats__entry-title {
  margin-bottom: 5px;
}
.pf-new-theme .survey-summary-stats__stat-linkShare {
  width: 100%;
}
.pf-new-theme .survey-summary-stats__stat-linkShare .survey-social-share {
  width: 100%;
}
.pf-new-theme .survey-end-page-urls-tooltip .ant-tooltip-inner {
  padding: 0 !important;
}
.pf-new-theme .survey-end-page-urls-tooltip .ant-tooltip-arrow-content {
  background-color: #eff3f7 !important;
}
.pf-new-theme .survey-end-page-urls-tooltip {
  text-align: left;
}
.pf-new-theme .survey-end-page-urls-tooltip__section {
  padding: 12px 8px;
  background-image: linear-gradient(to right, #eff3f7, #eff3f7);
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: calc(100% - 16px) 1px;
}
.pf-new-theme .survey-end-page-urls-tooltip__section:first-child {
  padding-top: 8px;
}
.pf-new-theme .survey-end-page-urls-tooltip__section:not(:has(~ .survey-end-page-urls-tooltip__section)) {
  padding-bottom: 8px;
}
.pf-new-theme .survey-end-page-urls-tooltip__label {
  margin-bottom: 4px;
}
.pf-new-theme .survey-end-page-urls-tooltip__url {
  word-break: break-all;
}
.pf-new-theme .survey-end-page-urls-tooltip__footer {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px;
  background-color: #eff3f7;
}
.pf-new-theme .survey-end-page-urls-tooltip__footer-icon {
  flex-shrink: 0;
  margin-top: 2px;
}
@media (max-width: 992px) {
  .pf-new-theme .survey-summary-stats__stat-surveyLink {
    width: calc(100% - 88px);
  }
  .pf-new-theme .survey-summary-stats__cards-row {
    flex-direction: column;
  }
  .pf-new-theme .survey-summary-stats__cards-row .ant-col {
    max-width: 100% !important;
  }
  .pf-new-theme .survey-summary-stats__entry-title {
    margin-bottom: 0;
  }
  .pf-new-theme .survey-summary-stats__entry {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .pf-new-theme .survey-summary-stats-hide-desktop {
    display: inline-block;
  }
  .pf-new-theme .survey-summary-stats .ant-layout-content {
    width: 100% !important;
  }
  .pf-new-theme .survey-summary-stats .ant-layout-sider {
    width: 100% !important;
    max-width: 100% !important;
    min-width: initial !important;
    flex: 0 0 100% !important;
    padding-bottom: 0 !important;
    min-height: initial !important;
  }
  .pf-new-theme .survey-summary-stats .ant-layout.ant-layout-has-sider {
    flex-direction: column;
  }
}
.pf-new-theme .services-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-column-gap: 0;
  grid-row-gap: 16px;
  width: 100%;
}
.pf-new-theme .services-grid-card-title {
  font-size: 18px;
  line-height: 20px;
}
.pf-new-theme .services-grid-img {
  width: auto;
  height: 90px;
}
@media (min-width: 400px) {
  .pf-new-theme .services-grid-img {
    height: 130px;
  }
}
@media (min-width: 768px) {
  .pf-new-theme .services-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    max-width: 1000px;
  }
  .pf-new-theme .services-grid-card-title {
    font-size: 24px;
    line-height: 28px;
  }
  .pf-new-theme .services-grid-img {
    width: auto;
    height: 150px;
  }
}
@media (min-width: 1000px) {
  .pf-new-theme .services-grid-img {
    height: 220px;
  }
}
.pf-new-theme .new-folder-input input {
  background-color: transparent;
}
.pf-new-theme .transition-normal {
  transition: all 0.2s;
}
.pf-new-theme .fade-out {
  opacity: 0;
}
.pf-new-theme .pf-header {
  transition: margin 0.25s ease-in-out;
}
.pf-new-theme .hide-header .pf-header {
  margin-top: -56px;
}
.pf-new-theme .h-full--2-headers {
  transition: max-height 0.25s ease-in-out;
}
.pf-new-theme .hide-header .h-full--2-headers {
  height: 100vh;
  max-height: calc(100vh - 98px);
}
.pf-new-theme .ant-card-padding-none .ant-card-body {
  padding: 0;
}
.pf-new-theme .radio-button-big .ant-radio-inner {
  width: 20px;
  height: 20px;
}
.pf-new-theme .radio-button-big .ant-radio::after {
  animation: none;
}
.pf-new-theme .radio-button-big .ant-radio.ant-radio-checked .ant-radio-inner {
  border-width: 2px;
  transition: none;
  animation: none;
}
.pf-new-theme .radio-button-big .ant-radio.ant-radio-checked .ant-radio-inner::after {
  width: 10px;
  height: 10px;
  transition: none;
  animation: none;
}
.pf-new-theme .radio-button-big .ant-radio .ant-radio-inner::after {
  transition: none;
  animation: none;
}
.pf-new-theme .budget-form .ant-legacy-form-item-label {
  line-height: 1.1;
  display: flex;
  align-items: center;
  height: 40px;
}
.pf-new-theme .budget-form .ant-legacy-form-item-label label:after {
  display: none;
}
.pf-new-theme .budget-form span.ant-radio + span {
  padding-left: 6px !important;
}
.pf-new-theme .budget-form .ant-form-item {
  margin-bottom: 0;
}
.pf-new-theme .budget-form .ant-radio-checked .ant-radio-inner {
  border-color: #0e68f9;
}
.pf-new-theme .budget-form .ant-radio-checked .ant-radio-inner:after {
  background-color: #0e68f9;
}
.pf-new-theme .budget-form .ant-calendar-picker-input {
  border: none;
}
.pf-new-theme .budget-form .ant-calendar-picker-input::placeholder {
  color: #323945;
}
.pf-new-theme .budget-form .ant-table-thead > tr > th,
.pf-new-theme .budget-form .ant-table-tbody > tr > td {
  padding: 8px;
  background-color: white;
}
.pf-new-theme .budget-form .ant-table-column-title {
  font-weight: normal;
  font-size: 14px;
}
.pf-new-theme .budget-form .ant-table-thead > tr > th:last-child {
  border-right: 0;
}
.pf-new-theme .budget-form .ant-table-tbody > tr > td {
  border-bottom: 0;
}
.pf-new-theme .budget-form .ant-table-thead > tr > th,
.pf-new-theme .budget-form .ant-table-tbody > tr > td {
  padding: 8px !important;
}
.pf-new-theme .budget-form .ant-table-tbody > tr > td.padding-none {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.pf-new-theme .budget-form .ant-table-tbody > tr:first-child > td.padding-none {
  padding-top: 4px !important;
}
.pf-new-theme .budget-table .ant-table-body > table {
  border-color: #e0e6ed;
}
.pf-new-theme .budget-table .ant-table-thead > tr > th:first-child,
.pf-new-theme .budget-table .ant-table-tbody > tr > td:first-child,
.pf-new-theme .budget-table .ant-table-thead > tr:hover > td:first-child,
.pf-new-theme .budget-table .ant-table-tbody > tr:hover > td:first-child {
  border-left: 1px solid #e0e6ed;
}
.pf-new-theme .budget-table .ant-table-tbody > tr > td,
.pf-new-theme .budget-table .ant-table-thead > tr > th {
  border-color: #e0e6ed;
}
.pf-new-theme .budget-table .ant-table-thead > tr > th {
  background-color: #f9fafc;
  border-right: 1px solid #e0e6ed;
}
.pf-new-theme .budget-table .ant-table-thead > tr > th,
.pf-new-theme .budget-table .ant-table-tbody > tr > td {
  padding: 14px;
}
.pf-new-theme .budget-table .ant-table.ant-table-bordered > .ant-table-container {
  border-left: none;
}
.pf-new-theme .crosstab-preview-table {
  max-width: 100%;
}
.pf-new-theme .crosstab-preview-table .ant-table {
  font-size: 12px;
  line-height: 14px;
}
.pf-new-theme .crosstab-preview-table .ant-table .ant-table-header {
  background: #ffffff;
}
.pf-new-theme .crosstab-preview-table tr,
.pf-new-theme .crosstab-preview-table td {
  pointer-events: none;
}
.pf-new-theme .crosstab-preview-table td {
  background-color: white !important;
}
.pf-new-theme .crosstab-preview-table .ant-table-row > td:not(.crosstab-row-header):not(.border-cross-header-inner),
.pf-new-theme .crosstab-preview-table .ant-table-thead > tr > th:not(.crosstab-row-header):not(.border-cross-header-inner) {
  min-width: 200px;
}
.pf-new-theme .crosstab-preview-table .ant-table-body > table {
  border-color: #e0e6ed;
}
.pf-new-theme .crosstab-preview-table .ant-table-tbody > tr > td,
.pf-new-theme .crosstab-preview-table .ant-table-thead > tr > th {
  border-color: #e0e6ed;
  padding: 8px;
}
.pf-new-theme .crosstab-preview-table .ant-table-thead > tr > th {
  background-color: #f9fafc;
  border-right: 1px solid #e0e6ed;
  vertical-align: top;
}
.pf-new-theme .crosstab-preview-table .ant-table-thead tr > th.border-cross-header-inner:not(
        .border-cross-header-inner-last-child
      ) {
  border-right: none !important;
}
.pf-new-theme .crosstab-preview-table .crosstab-row-header {
  color: #323945;
  background-color: #f9fafc;
  font-weight: bold;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: break-word;
}
.pf-new-theme .crosstab-preview-table tr > th.border-cross-header-outer {
  border-bottom: none !important;
}
.pf-new-theme .crosstab-preview-table tr > th.border-cross-header-outer,
.pf-new-theme .crosstab-preview-table tr > th.border-cross-header-inner {
  background: #f9fafc;
}
.pf-new-theme .ant-select.ant-select-single.crosstabs-select-language {
  height: 24px;
}
.pf-new-theme .ant-select.ant-select-single.crosstabs-select-language .ant-select-selector {
  height: 24px;
}
.pf-new-theme .ant-input-number.text-weight-bold input {
  font-weight: bold;
}
.pf-new-theme .ant-input-number.w-full {
  width: 100% !important;
}
.pf-new-theme .h-full--3-headers {
  height: calc(100vh - 98px);
}
.pf-new-theme .pf-announcement-visible .h-full--3-headers {
  height: calc(100vh - 98px - 30px);
}
.pf-new-theme .h-full--4-headers {
  height: calc(100vh - 140px);
}
.pf-new-theme .pf-announcement-visible .h-full--4-headers {
  height: calc(100vh - 140px - 30px);
}
.pf-new-theme .h-full--4-headers-AI {
  height: calc(100vh - 147px);
}
.pf-new-theme .pf-announcement-visible .h-full--4-headers-AI {
  height: calc(100vh - 147px - 30px);
}
.pf-new-theme .h-full--5-headers {
  min-height: calc(100vh - 107px);
}
.pf-new-theme .pf-announcement-visible .h-full--5-headers {
  height: calc(100vh - 107px - 30px);
}
.pf-new-theme .h-full--6-headers {
  max-width: calc(100% - 385px);
}
.pf-new-theme .h-full--crosstab-headers {
  height: calc(100vh - 113px);
}
.pf-new-theme .pf-announcement-visible .h-full--crosstab-headers {
  height: calc(100vh - 113px - 30px);
}
.pf-new-theme .border-radius-pill .ant-form-item-control {
  line-height: 1.5;
}
.pf-new-theme .targeting-card .ant-card-body {
  padding: 16px 16px 12px;
}
.pf-new-theme .targeting-card .ant-card-body .ant-divider-horizontal.w-full {
  margin-left: -16px;
  width: calc(100% + 32px);
}
.pf-new-theme .targeting-card .ant-switch-small {
  min-width: 20px;
  width: 20px;
  height: 10px;
  line-height: 10px;
}
.pf-new-theme .targeting-card .ant-switch-small .ant-switch-handle {
  top: 1px;
  left: 1px;
  width: 8px;
  height: 8px;
}
.pf-new-theme .targeting-card .ant-switch-small.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 8px - 1px);
}
.pf-new-theme .targeting-card-slim .ant-card-body {
  padding-top: 16px;
  padding-bottom: 16px;
}
.pf-new-theme .ant-card.ant-card-padding-none.questionnaire-card .ant-collapse-content.ant-collapse-content-active {
  overflow: visible;
}
.pf-new-theme .ant-card.ant-card-padding-none.questionnaire-card .ant-collapse-content.ant-collapse-content-active .ant-collapse-content-box {
  overflow: visible;
}
.pf-new-theme .ant-card.ant-card-padding-none.questionnaire-card .ant-card-body {
  padding-top: 12px !important;
  padding-bottom: 16px !important;
}
.pf-new-theme .pf-custom-list .ant-list-header {
  padding-top: 0;
  padding-bottom: 8px;
}
.pf-new-theme .pf-custom-list .ant-list-header,
.pf-new-theme .pf-custom-list .ant-list-item {
  border: none;
}
.pf-new-theme .terms-modal .ant-collapse .ant-collapse-content {
  overflow: visible;
}
.pf-new-theme .pf-ant-collapse .ant-collapse-item {
  border: none;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header {
  padding: 0 18px 0 0;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-icon-position-right > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  right: 0;
  font-size: 10px;
  color: #323945;
  margin-top: 1px;
}
.pf-new-theme .pf-ant-collapse .ant-collapse-content-box {
  padding: 0;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-question {
  border: 0;
  background-color: transparent;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-question .ant-collapse-header {
  margin-left: 18px;
  cursor: unset !important;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-question .ant-collapse-content-box > footer > section,
.pf-new-theme .pf-ant-collapse.ant-collapse-question .ant-collapse-content-box > div:not(.ant-divider-horizontal) {
  margin-left: 18px;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-question .ant-collapse-arrow {
  left: -5px;
  top: 15px;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-question .ant-collapse-content {
  border: 0;
}
.pf-new-theme .pf-ant-collapse.ant-collapse-header-padding-lg .ant-collapse-arrow,
.pf-new-theme .pf-ant-collapse.ant-collapse-header-padding-lg .ant-collapse-header {
  padding-left: 24px !important;
}
.pf-new-theme .select-language-dropdown {
  width: 144px !important;
}
.pf-new-theme .survey-header .ant-select:not(.ant-select-customize-input).ant-select-focused:not(.ant-select-disabled) .ant-select-selector {
  border: 1px solid transparent;
  box-shadow: none;
}
.pf-new-theme .survey-header .ant-select .ant-select-selector {
  border: 1px solid transparent;
  box-shadow: none;
  padding: 0 3px 0 0;
}
.pf-new-theme .survey-header .ant-select .ant-select-selector .ant-select-selection-item {
  margin-right: 0px;
  margin-left: 3px;
  line-height: 24px;
}
.pf-new-theme .survey-header .ant-select .ant-select-selector .ant-select-selection-search {
  left: 3px;
  right: 15px;
}
.pf-new-theme .survey-header .ant-select.ant-select-single {
  height: 26px;
}
.pf-new-theme .survey-header .ant-select.ant-select-single .ant-select-selection-search-input,
.pf-new-theme .survey-header .ant-select.ant-select-single .ant-select-selector {
  background: transparent;
  height: 26px;
}
.pf-new-theme .survey-header .ant-select.ant-select-single.ant-select-open .ant-select-selection-item {
  color: #bfc8d5;
}
.pf-new-theme .survey-header .ant-select .ant-select-open .ant-select-selector {
  border: 1px solid #bfc8d5;
}
.pf-new-theme .survey-header .ant-input-number-focused {
  background: #e7ebef;
}
.pf-new-theme .survey-header .ant-input-number-input {
  padding-left: 5px;
  padding-right: 5px;
}
.pf-new-theme .survey-header .ant-legacy-form-item-label > label {
  color: #5c6776;
}
.pf-new-theme .survey-header .ant-legacy-form-item-label > label::after {
  margin-right: 4px;
}
.pf-new-theme .checkbox-border-inherit:not(:hover):not(:focus):not(
    .ant-checkbox-wrapper-checked
  ) .ant-checkbox-inner {
  border-color: inherit;
}
.pf-new-theme .ant-divider-horizontal {
  height: 1px;
  border-top: none;
  top: 0;
}
.pf-new-theme .ant-divider {
  background: #e8e8e8;
}
.pf-new-theme .ant-divider-vertical {
  width: 1px;
  border-top: 0;
  border-left: 0;
}
.pf-new-theme .ant-legacy-form-item-label > label {
  color: rgba(0, 0, 0, 0.85);
}
.pf-new-theme .add-question__button {
  display: none;
  padding: 2px 3px !important;
}
.pf-new-theme .add-question__button.add-question__button--active,
.pf-new-theme .add-question__button:hover {
  display: inline-block;
}
.pf-new-theme .active-menu-on-question .add-question__button {
  display: inline-block;
}
.pf-new-theme .add-question__button-wrapper {
  position: relative;
  top: -12px;
  height: 12px;
  pointer-events: none;
  z-index: 3;
}
.pf-new-theme .add-question__button-wrapper > * {
  pointer-events: auto;
}
.pf-new-theme .add-question__button-wrapper .add-question__button {
  margin-top: 0;
  top: auto;
  transform: none;
}
.pf-new-theme .questionnaire-node--group .add-question__button-wrapper {
  top: -21px;
}
.pf-new-theme .questionnaire-node--group .questionnaire-node .add-question__button-wrapper {
  top: -12px;
}
.pf-new-theme .drag-card:has(+ .add-question__button-wrapper) .questionnaire-card {
  margin-bottom: 0;
}
.pf-new-theme .questionnaire-node {
  position: relative;
}
.pf-new-theme .questionnaire-node:has(> .drag-card:hover),
.pf-new-theme .questionnaire-node:has(.add-question__button:hover),
.pf-new-theme .questionnaire-node:has(.active-menu-on-question) {
  z-index: 2;
}
.pf-new-theme .questionnaire-card {
  position: relative;
}
.pf-new-theme .survey-preview {
  min-height: 500px;
}
.pf-new-theme .survey-preview__copy-clipboard:hover .survey-preview__clipboard-tooltip--hidden {
  display: block !important;
}
.pf-new-theme .survey-preview__clipboard-tooltip {
  position: absolute;
  top: -20px;
  left: 0;
  width: auto;
  border: 1px solid;
  z-index: 5;
}
.pf-new-theme .survey-preview__clipboard-tooltip--hidden {
  display: none;
}
.pf-new-theme a.disabled-link {
  pointer-events: none;
  cursor: not-allowed;
}
.pf-new-theme .add-question-img-wrapper {
  width: 397px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.pf-new-theme .add-question-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.pf-new-theme .ant-popconfirm .ant-popover-inner {
  border-radius: 8px;
}
.pf-new-theme .ant-popconfirm .ant-popover-inner-content {
  border-radius: 8px;
  box-shadow: 0px 4px 12px 0px #5c677614, 0px 2px 6px 0px #87919e33;
  font-size: 12px;
}
.pf-new-theme .tooltip-light .ant-tooltip-arrow:before {
  background-color: white;
}
.pf-new-theme .tooltip-light .ant-tooltip-arrow .ant-tooltip-arrow-content {
  background-color: white;
}
.pf-new-theme .tooltip-light .ant-tooltip-inner {
  line-height: 16px;
  min-height: initial;
  background-color: white !important;
  color: #323945 !important;
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #5c677614, 0px 2px 6px 0px #87919e33;
  font-size: 12px;
}
.pf-new-theme .tooltip-light.tooltip-padding-sm .ant-tooltip-inner {
  padding: 12px;
}
.pf-new-theme .tooltip-light.tooltip-light--green .ant-tooltip-arrow:before {
  background-color: #dbf8f0;
}
.pf-new-theme .tooltip-light.tooltip-light--green .ant-tooltip-arrow .ant-tooltip-arrow-content {
  background-color: #dbf8f0;
}
.pf-new-theme .tooltip-light.tooltip-light--green .ant-tooltip-inner {
  background-color: #dbf8f0 !important;
}
.pf-new-theme .notification-light.ant-notification-notice {
  width: 433px;
  padding: 0;
}
.pf-new-theme .notification-light .ant-notification-notice-message {
  margin-bottom: 0;
}
.pf-new-theme .notification-light .ant-notification-notice-close {
  top: 4px;
  right: 7px;
  color: #323945;
}
.pf-new-theme .notification-light .ant-notification-notice-close .icon {
  font-size: 12px;
}
.pf-new-theme .ant-notification-notice.notification-close-dark .ant-notification-notice-close,
.pf-new-theme .ant-notification-notice.notification-close-dark .ant-notification-notice-close:hover,
.pf-new-theme .ant-notification-notice.notification-close-dark .ant-notification-notice-close:focus,
.pf-new-theme .ant-notification-notice.notification-close-dark .ant-notification-notice-close:active {
  color: #323945;
}
.pf-new-theme .ant-layout-sider-zero-width-trigger {
  text-decoration: none;
  outline: none;
  position: absolute;
  left: -34px;
  top: 0;
  background-color: white;
  border-radius: 3px 0 0 3px;
  width: 34px;
  height: 62px;
  line-height: 62px;
  box-shadow: -2px 1px 3px 0px #ebedf1;
  font-size: 18px;
  padding: 0;
}
.pf-new-theme .ant-layout-sider-zero-width-trigger span {
  line-height: 62px;
}
.pf-new-theme .ant-tabs-tab {
  padding: 12px 16px;
}
.pf-new-theme .ant-tabs-tab [aria-disabled='false'] {
  cursor: pointer;
}
.pf-new-theme .ant-tabs-tab [aria-disabled='true'] {
  cursor: not-allowed;
}
.pf-new-theme .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #0e68f9;
  font-weight: 500;
}
.pf-new-theme .logic-tab-bar,
.pf-new-theme .crosstabs-tab-bar {
  background-color: white;
}
.pf-new-theme .logic-tab-bar .ant-tabs-top-bar,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-top-bar {
  margin: 0;
  text-align: center;
  height: 49px;
}
.pf-new-theme .logic-tab-bar .ant-tabs-tab:hover,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-tab:hover,
.pf-new-theme .logic-tab-bar .ant-tabs-tab:focus,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-tab:focus,
.pf-new-theme .logic-tab-bar .ant-tabs-tab:active,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-tab:active {
  color: #0e68f9;
}
.pf-new-theme .logic-tab-bar .ant-tabs-tab,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-tab {
  color: #323945;
  padding: 14px 16px;
}
.pf-new-theme .logic-tab-bar .ant-tabs-tab-active .ant-tabs-tab-btn,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #0e68f9;
  font-weight: bold;
}
.pf-new-theme .logic-tab-bar > .ant-tabs-nav .ant-tabs-nav-wrap,
.pf-new-theme .crosstabs-tab-bar > .ant-tabs-nav .ant-tabs-nav-wrap {
  justify-content: center;
}
.pf-new-theme .logic-tab-bar .ant-tabs-ink-bar,
.pf-new-theme .crosstabs-tab-bar .ant-tabs-ink-bar {
  background-color: #0e68f9;
}
.pf-new-theme .logic-tab-bar .ant-tabs-nav {
  height: 49px;
  margin-bottom: 0;
}
.pf-new-theme .logic-tab-bar .ant-tabs-nav::before {
  border-color: #f3f6fb;
}
.pf-new-theme .pf-skeleton.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title,
.pf-new-theme .pf-skeleton.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li {
  background: linear-gradient(90deg, rgba(207, 216, 220, 0.2) 25%, rgba(207, 216, 220, 0.4) 37%, rgba(207, 216, 220, 0.2) 63%);
  background-size: 400% 100%;
}
.pf-new-theme .pf-skeleton-theme-list.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title {
  margin: 4px 0;
  height: 40px;
  background: linear-gradient(90deg, #f9fafc 25%, rgba(207, 216, 220, 0.4) 37%, #f9fafc 63%);
  background-size: 400% 100%;
}
.pf-new-theme .border-radius-no-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.pf-new-theme .border-left-purple-6-opacity {
  border-left: 1px solid rgba(156, 117, 246, 0.14);
}
.pf-new-theme .add-language-menu {
  width: 227px;
  max-height: 187px;
  overflow: hidden;
  overflow-y: scroll;
}
.pf-new-theme .add-language-search {
  position: relative;
  background: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.pf-new-theme .add-language-search.ant-select-open {
  box-shadow: 0px 4px 8px 0px #eef3f7;
}
.pf-new-theme .add-language-search .ant-select-selection-search {
  background-color: #eef3f7;
  border-radius: 4px;
}
.pf-new-theme .add-language-search.ant-select-open:after {
  background: #fff;
  display: block;
  content: '';
  font-size: 0;
  height: 12px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -12px;
  z-index: 10;
}
.pf-new-theme .add-language-search input {
  padding: 0;
}
.pf-new-theme .add-language-search.ant-select {
  font-size: 12px;
  color: #323945;
}
.pf-new-theme .add-language-search.ant-select.ant-select-focused .ant-select-selector {
  border-color: #e7ebef;
  box-shadow: none;
}
.pf-new-theme .add-language-search.ant-select.ant-select-single {
  height: auto;
}
.pf-new-theme .add-language-search.ant-select.ant-select-open.ant-select-single {
  height: 45px;
}
.pf-new-theme .add-language-search.ant-select .ant-select-selection-item {
  line-height: 30px;
}
.pf-new-theme .add-language-search .ant-select-selector {
  background-color: #eef3f7;
  border: none;
  box-shadow: none;
  position: relative;
  height: 40px;
}
.pf-new-theme .add-language-search .ant-select-selection-search {
  border-radius: 4px;
  left: 0;
  right: 0;
  background-color: transparent;
  box-shadow: none;
}
.pf-new-theme .add-language-search .ant-select-selection-search input {
  margin-top: 5px;
}
.pf-new-theme .add-language-search .ant-select-selection-placeholder {
  top: 21px;
  color: #8f98a9;
}
.pf-new-theme .add-language-search .ant-select-selection-search-input {
  padding-left: 8px;
}
.pf-new-theme .add-language-search.ant-select-open .ant-select-selector {
  background-color: #fff;
  padding: 12px 6px 12px;
  height: 42px;
}
.pf-new-theme .add-language-search.ant-select-open .ant-select-selection-search {
  right: 6px;
  left: 6px;
  top: 12px;
  bottom: 0px;
  background-color: #eef3f7;
}
.pf-new-theme .add-language-search.ant-select-open .ant-select-selection-placeholder {
  top: 28px;
  left: 3px;
}
.pf-new-theme .add-language-search.ant-select-open .ant-select-selection-search-input {
  padding-left: 8px;
}
.pf-new-theme .add-language-search.ant-select-single .ant-select-selection-item {
  margin-right: 11px;
}
.pf-new-theme .add-language-search [aria-controls] {
  cursor: default;
}
.pf-new-theme .add-language-search.ant-select-open .ant-select-arrow {
  margin-top: 0;
}
.pf-new-theme .add-language-search .ant-select-arrow {
  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  margin-top: -5px;
}
.pf-new-theme .add-language-select-menu {
  padding: 8px 4px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  box-shadow: 0px 4px 8px 0px #eef3f7;
}
.pf-new-theme .add-language-select-menu .ant-select-dropdown-menu {
  max-height: 238px;
}
.pf-new-theme .add-language-select-menu .ant-select-item-option {
  height: 30px;
  font-size: 12px;
  line-height: 14px;
  border-bottom: 0;
  padding: 8px 12px !important;
  border-radius: 2px;
  text-align: left;
  color: #323945;
}
.pf-new-theme .add-language-select-menu .ant-select-item-option.ant-select-item-option-active {
  color: #323945;
}
.pf-new-theme .add-language-select-menu .ant-select-item-option-disabled {
  height: auto;
}
.pf-new-theme .add-language-pop-over .ant-select-dropdown {
  left: 0px !important;
  top: 54px !important;
}
.pf-new-theme .add-language-pop-over .ant-popover-inner-content {
  padding: 0px !important;
}
.pf-new-theme .add-language-pop-over .ant-popover-inner {
  background-color: transparent !important;
  box-shadow: none;
}
.pf-new-theme .format-tooltip-pop-over .ant-popover-inner-content {
  padding: 0px !important;
}
.pf-new-theme .format-tooltip-pop-over .ant-popover-arrow {
  display: none;
}
.pf-new-theme .format-tooltip-pop-over .ant-popover-inner {
  background-color: transparent !important;
  box-shadow: none;
}
.pf-new-theme .color-picker-pop-over .ant-popover-inner-content {
  padding: 0px !important;
}
.pf-new-theme .color-picker-pop-over .ant-popover-arrow {
  display: none;
}
.pf-new-theme .color-picker-pop-over .ant-popover-inner {
  background-color: transparent !important;
  box-shadow: none;
}
.pf-new-theme .questionnaire-card .icon-google-translate {
  width: 14px;
  height: 14px;
  font-size: 14px;
  position: relative;
}
.pf-new-theme .questionnaire-card .icon-google-translate:before {
  background-color: #4a8af4;
  border-radius: 26px;
  color: #e0e6ed;
  position: absolute;
  width: 13px;
  height: 13px;
}
.pf-new-theme .icon-google-translate-disabled:before {
  background-color: #e0e6ed;
  color: #bfc8d5;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-ink-bar {
  display: none !important;
}
.pf-new-theme .ant-tabs-languages.ant-tabs {
  height: 32px;
  margin: 0;
  border: 0;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-nav {
  z-index: 0;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-nav .ant-tabs-tab:first-child .language-tab:before {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-nav .ant-tabs-tab:last-child .language-tab:before {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.pf-new-theme .ant-tabs-languages .language-tab {
  position: relative;
}
.pf-new-theme .ant-tabs-languages .language-tab:before {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  content: '';
  box-shadow: 0px 2px 4px 0px #eef3f7;
  z-index: -1;
}
.pf-new-theme .ant-tabs-languages .language-tab.language-tab--selected:before {
  box-shadow: none;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-tab {
  padding: 0;
  transition: none;
  margin: 0;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-tab:before {
  display: none;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-nav-container,
.pf-new-theme .ant-tabs-languages .ant-tabs-nav-scroll {
  height: 36px;
}
.pf-new-theme .ant-tabs-languages .ant-tabs-tab-prev,
.pf-new-theme .ant-tabs-languages .ant-tabs-tab-next {
  line-height: 0;
  width: 28px;
  height: 34px;
}
.pf-new-theme .translate-openEnded-checkbox .ant-checkbox,
.pf-new-theme .nested-quotas-checkbox .ant-checkbox {
  top: 0px;
}
.pf-new-theme .save-translations-btn.ant-btn-primary[disabled],
.pf-new-theme .save-translations-btn.ant-btn-primary[disabled]:hover,
.pf-new-theme .save-translations-btn.ant-btn-primary[disabled]:focus,
.pf-new-theme .save-translations-btn.ant-btn-primary[disabled]:active,
.pf-new-theme .save-translations-btn.ant-btn-primary[disabled].active {
  color: #fff;
  background-color: #0e68f9;
  border-color: #0e68f9;
  border-top-color: #0e68f9;
  border-right-color: #0e68f9;
  border-bottom-color: #0e68f9;
  border-left-color: #0e68f9;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.pf-new-theme .questionnaire-card .crosstab-add-actions {
  transition: opacity 1350ms;
  opacity: 1;
}
.pf-new-theme .questionnaire-card-container .crosstabs-add-buttons {
  display: none;
}
.pf-new-theme .questionnaire-card-container:hover .crosstabs-add-buttons {
  display: block;
}
.pf-new-theme .questionnaire-card-container.crosstab-guide-bottom:after,
.pf-new-theme .questionnaire-card-container.crosstab-guide-top:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 3px;
  border-right: 4px solid #ffffff;
  border-left: 4px solid #ffffff;
  background: #c2a3ff;
}
.pf-new-theme .questionnaire-card-container.crosstab-guide-bottom:after {
  bottom: -1px;
  transform: translateY(50%);
}
.pf-new-theme .questionnaire-card-container.crosstab-guide-top:after {
  top: -1px;
  transform: translateY(-50%);
}
.pf-new-theme .resize-handle {
  width: 40px;
  height: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  cursor: grab;
  background-color: #bfc8d5;
  padding: 20px auto;
  margin: 10px auto;
}
.pf-new-theme .react-draggable-transparent-selection {
  cursor: grabbing !important;
}
.pf-new-theme .ant-modal.no-body-padding .ant-modal-body {
  padding: 0;
}
.pf-new-theme .ant-modal.equal-paddings .ant-modal-content {
  padding-bottom: 24px;
}
.pf-new-theme .elite-form-frame {
  width: 100%;
  border: 0;
  margin: 0;
  padding: 0;
  height: calc(100vh - 62px);
}
.pf-new-theme .template-preview-questions .ant-collapse-header {
  padding-left: 0 !important;
}
.pf-new-theme .template-preview-questions [data-slate-editor] {
  cursor: default;
}
.pf-new-theme .piped-question {
  position: relative;
  display: inline-block;
  color: #9c75f6;
  z-index: 5;
  border: 1px solid #e7ebef;
  background-color: #f9fafc;
  font-size: 12px;
  padding: 0 6px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  top: -2px;
}
.pf-new-theme .help-tooltip {
  width: 230px;
  z-index: 1100;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  padding: 14px;
}
.pf-new-theme .help-tooltip svg {
  margin-right: -2px;
}
.pf-new-theme .margin-2lg {
  margin: 28px;
}
.pf-new-theme .margin-horizontal-2lg {
  margin-left: 28px;
  margin-right: 28px;
}
.pf-new-theme .margin-vertical-2lg {
  margin-top: 28px;
  margin-bottom: 28px;
}
.pf-new-theme .margin-top-2lg {
  margin-top: 28px;
}
.pf-new-theme .margin-btm-2lg {
  margin-bottom: 28px;
}
.pf-new-theme .margin-left-2lg {
  margin-left: 28px;
}
.pf-new-theme .margin-right-2lg {
  margin-right: 28px;
}
.pf-new-theme .margin-negative-2lg {
  margin: -28px;
}
.pf-new-theme .margin-horizontal-negative-2lg {
  margin-left: -28px;
  margin-right: -28px;
}
.pf-new-theme .margin-vertical-negative-2lg {
  margin-top: -28px;
  margin-bottom: -28px;
}
.pf-new-theme .margin-top-negative-2lg {
  margin-top: -28px;
}
.pf-new-theme .margin-btm-negative-2lg {
  margin-bottom: -28px;
}
.pf-new-theme .margin-left-negative-2lg {
  margin-left: -28px;
}
.pf-new-theme .margin-right-negative-2lg {
  margin-right: -28px;
}
.pf-new-theme .padding-2lg {
  padding: 28px;
}
.pf-new-theme .padding-horizontal-2lg {
  padding-left: 28px;
  padding-right: 28px;
}
.pf-new-theme .padding-vertical-2lg {
  padding-top: 28px;
  padding-bottom: 28px;
}
.pf-new-theme .padding-top-2lg {
  padding-top: 28px;
}
.pf-new-theme .padding-btm-2lg {
  padding-bottom: 28px;
}
.pf-new-theme .padding-left-2lg {
  padding-left: 28px;
}
.pf-new-theme .padding-right-2lg {
  padding-right: 28px;
}
.pf-new-theme .margin-2lg-important {
  margin: 28px !important;
}
.pf-new-theme .margin-horizontal-2lg-important {
  margin-left: 28px !important;
  margin-right: 28px !important;
}
.pf-new-theme .margin-vertical-2lg-important {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}
.pf-new-theme .margin-top-2lg-important {
  margin-top: 28px !important;
}
.pf-new-theme .margin-btm-2lg-important {
  margin-bottom: 28px !important;
}
.pf-new-theme .margin-left-2lg-important {
  margin-left: 28px !important;
}
.pf-new-theme .margin-right-2lg-important {
  margin-right: 28px !important;
}
.pf-new-theme .margin-negative-2lg-important {
  margin: -28px !important;
}
.pf-new-theme .margin-horizontal-negative-2lg-important {
  margin-left: -28px !important;
  margin-right: -28px !important;
}
.pf-new-theme .margin-vertical-negative-2lg-important {
  margin-top: -28px !important;
  margin-bottom: -28px !important;
}
.pf-new-theme .margin-top-negative-2lg-important {
  margin-top: -28px !important;
}
.pf-new-theme .margin-btm-negative-2lg-important {
  margin-bottom: -28px !important;
}
.pf-new-theme .margin-left-negative-2lg-important {
  margin-left: -28px !important;
}
.pf-new-theme .margin-right-negative-2lg-important {
  margin-right: -28px !important;
}
.pf-new-theme .padding-2lg-important {
  padding: 28px !important;
}
.pf-new-theme .padding-horizontal-2lg-important {
  padding-left: 28px !important;
  padding-right: 28px !important;
}
.pf-new-theme .padding-vertical-2lg-important {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}
.pf-new-theme .padding-top-2lg-important {
  padding-top: 28px !important;
}
.pf-new-theme .padding-btm-2lg-important {
  padding-bottom: 28px !important;
}
.pf-new-theme .padding-left-2lg-important {
  padding-left: 28px !important;
}
.pf-new-theme .padding-right-2lg-important {
  padding-right: 28px !important;
}
.pf-new-theme .ant-collapse {
  line-height: 1.5;
  border-radius: 4px;
}
.pf-new-theme .ant-card {
  line-height: 1.5;
  overflow: visible;
}
.pf-new-theme .ant-collapse-arrow {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  left: 16px;
  display: inline-block;
  font-size: 12px;
  transform: translateY(-50%);
}
.pf-new-theme .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  position: relative;
  padding: 12px 16px;
  padding-left: 40px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  cursor: pointer;
  transition: all 0.3s;
}
.pf-new-theme .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  display: inline-block;
  font-size: 12px;
  transform: translateY(-50%);
}
.pf-new-theme .ant-collapse-borderless {
  background-color: #ffffff;
}
.pf-new-theme .ant-badge {
  color: inherit;
}
.pf-new-theme .preview-item .preview-arrow {
  color: transparent;
}
.pf-new-theme .preview-item:hover .preview-arrow {
  color: inherit;
}
.pf-new-theme .ant-breadcrumb-flex-spans {
  display: flex;
}
.pf-new-theme .ant-breadcrumb-flex-spans > span {
  display: flex;
}
.pf-new-theme .pf-modal-alert-wrapper .ant-modal-content {
  border-radius: 4px;
  padding-top: 18px;
  padding-bottom: 14px;
}
.pf-new-theme .pf-modal-alert-wrapper .ant-modal-close {
  position: absolute;
  z-index: 2;
  top: 50%;
  right: 8px;
  transform: translate3d(0, -50%, 0);
}
.pf-new-theme .ant-checkbox-custom-padding .ant-checkbox + span {
  padding: 0 0 0 5px;
}
.pf-new-theme .button-disabled-with-tooltip.ant-tooltip-disabled-compatible-wrapper {
  display: flex !important;
  align-items: center;
  width: 24px;
  height: 24px;
  position: relative;
  top: 1px;
  left: -6px;
}
.pf-new-theme .import-from-library-menu-item.ant-dropdown-menu-item-active button {
  color: #0e68f9;
  border-color: #0e68f9;
}
.pf-new-theme .pf-dropdown-select-menu.ant-dropdown-menu {
  padding: 8px;
  box-shadow: 0px 4px 8px rgba(238, 243, 247, 0.4);
  border-radius: 4px;
}
.pf-new-theme .pf-dropdown-select-menu.ant-dropdown-menu .ant-dropdown-menu-item-active {
  border-radius: 4px;
  background-color: #e6f4ff;
  color: #0e68f9;
}
.pf-new-theme .recall-container .ant-menu {
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;
}
.pf-new-theme .recall-container .ant-menu-sub.ant-menu-inline {
  background: transparent;
}
.pf-new-theme .recall-container .ant-menu-item,
.pf-new-theme .recall-container .ant-menu [role='menuitem'] {
  padding: 6px 0 !important;
  border: 0;
  transition: none;
  margin: 0 !important;
  font-size: 15px;
  line-height: 1.4;
  height: auto;
}
.pf-new-theme .recall-container .ant-menu-item a,
.pf-new-theme .recall-container .ant-menu [role='menuitem'] a {
  color: #323945;
  transition: none;
}
.pf-new-theme input.hide-number-arrows::-webkit-outer-spin-button,
.pf-new-theme input.hide-number-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.pf-new-theme input.hide-number-arrows[type='number'] {
  -moz-appearance: textfield;
}
.pf-new-theme .dropdown-menu-grouped-actions-divider {
  margin: 4px -8px;
}
@-moz-keyframes rotate360 {
  to {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotate360 {
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}
@keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}
.pf-new-theme .visualize-data-spinner {
  -webkit-animation: 1s rotate360 infinite linear;
  -moz-animation: 1s rotate360 infinite linear;
  -ms-animation: 1s rotate360 infinite linear;
  animation: 1s rotate360 infinite linear;
}
.pf-new-theme .dropdown-menu-pop-over .ant-popover-inner-content {
  width: 240px;
  font-size: 12px;
}
.pf-new-theme .dropdown-menu-pop-over .ant-popover-arrow {
  display: none;
}
.pf-new-theme .popover-300-width .ant-popover-inner-content {
  width: 300px;
  padding: 12px !important;
}
.pf-new-theme .pf-wizard-select {
  height: 48px !important;
  line-height: 48px;
  box-shadow: none;
}
.pf-new-theme .pf-wizard-select .ant-select-selection-search-input {
  font-weight: bold;
}
.pf-new-theme .pf-wizard-select .ant-select-selector,
.pf-new-theme .pf-wizard-select .ant-select-selection-item {
  height: 46px !important;
  border-color: transparent !important;
}
.pf-new-theme .pf-wizard-select.ant-select-open {
  border: 1px solid #0e68f9 !important;
}
.pf-new-theme .pf-wizard-input-number.ant-input-number-focused {
  border: 1px solid #0e68f9 !important;
  box-shadow: none;
}
.pf-new-theme #create-survey-terms-body::before {
  line-height: 42px;
}
.pf-new-theme .highcharts-credits {
  display: none;
}
.pf-new-theme .integration-form-dataset-location .ant-select-selection-item {
  align-self: center;
}
@media (min-width: 1600px) {
  .pf-new-theme .ant-col-offset-4-xl {
    margin-left: 16.66666667%;
  }
}
.pf-new-theme .purple-indicator {
  width: 16px;
  height: 16px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}
.pf-new-theme .purple-indicator::after,
.pf-new-theme .purple-indicator::before {
  content: '';
  visibility: hidden;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #9679ee;
  position: absolute;
  left: 0;
  top: 0;
  animation: pulse 2s linear infinite;
}
.pf-new-theme .purple-indicator::after {
  animation-delay: 1s;
}
.pf-new-theme .orange-indicator {
  width: 16px;
  height: 16px;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
}
.pf-new-theme .orange-indicator::after,
.pf-new-theme .orange-indicator::before {
  content: '';
  visibility: hidden;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #cd8831;
  position: absolute;
  left: 0;
  top: 0;
  animation: pulse 2s linear infinite;
}
.pf-new-theme .orange-indicator::after {
  animation-delay: 1s;
}
@keyframes pulse {
  0% {
    transform: scale(0);
    opacity: 1;
    visibility: visible;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
.pf-new-theme .ant-tooltip-no-arrow .peeq-price-calculator .ant-tooltip-arrow {
  display: block;
}
.pf-new-theme .ant-tooltip-rounded .peeq-price-calculator .ant-tooltip-inner {
  line-height: 1;
  min-height: initial;
  background-color: #323945 !important;
  color: #ffffff !important;
  border-radius: 4px;
  padding: 6px 8px;
}
.pf-new-theme .feasibility-button-peeq-ir-input .ant-input-number-input {
  height: 28px;
  padding: 0;
}
.pf-new-theme .peeq-price-calculator .ant-input-number-input {
  height: 28px;
  padding: 0;
}
.pf-new-theme .peeq-price-calculator.ant-collapse-item > .ant-collapse-header {
  cursor: default;
}
@media (max-width: 1000px) {
  .pf-new-theme .ant-btn.mobile-button-wrap {
    white-space: normal;
    height: auto;
  }
}
.pf-new-theme .page-content-vertical-size {
  min-height: calc(100vh - 52px);
}
@media (min-width: 800px) {
  .pf-new-theme .page-content-vertical-size {
    height: calc(100vh - 52px);
  }
}
.pf-new-theme .pf-announcement-visible .page-content-vertical-size {
  min-height: calc(100vh - 52px - 30px);
}
@media (min-width: 800px) {
  .pf-new-theme .pf-announcement-visible .page-content-vertical-size {
    height: calc(100vh - 52px - 30px);
  }
}
.pf-new-theme .page-content-vertical-size-3rd-party-results {
  height: calc(100vh - 104px);
}
.pf-new-theme .peeq-total-responses .ant-input-number-input {
  height: 26px;
}
.pf-new-theme .audience-rename-modal .ant-modal-footer {
  display: flex;
  justify-content: space-between;
}
.pf-new-theme .audience-template-modal {
  max-width: 360px;
}
.pf-new-theme .audience-template-modal input {
  background: #eff3f7;
  border: none;
}
.pf-new-theme .audience-template-modal .ant-modal-footer {
  display: flex;
  justify-content: flex-end;
}
.pf-new-theme .ant-input-number-focused.ant-input-number-focused-no-shadow {
  box-shadow: none;
}
.pf-new-theme .ant-input-number-sm.padding-none input {
  padding: 0;
}
.pf-new-theme .card-nesting-quotas:hover {
  cursor: pointer;
  border-radius: 3px;
  border: 1px solid #eff3f7;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.102);
}
.pf-new-theme .pause-edit-modal .ant-modal-content,
.pf-new-theme .edit-survey-adl-modal .ant-modal-content {
  padding: 16px;
}
.pf-new-theme .pause-edit-modal .ant-modal-close,
.pf-new-theme .edit-survey-adl-modal .ant-modal-close {
  top: 7px;
  right: 9px;
}
.pf-new-theme .pause-edit-modal .ant-modal-body,
.pf-new-theme .edit-survey-adl-modal .ant-modal-body {
  padding-top: 0;
  padding-bottom: 0;
}
.pf-new-theme .pause-edit-modal .ant-modal-footer,
.pf-new-theme .edit-survey-adl-modal .ant-modal-footer {
  padding-top: 40px;
  border-top: none;
}
.pf-new-theme .add-rule-button-with-tooltip button {
  padding: 0;
  font-weight: 600;
}
.pf-new-theme .loop-and-merge-submenu-list .ant-dropdown-menu-submenu-title,
.pf-new-theme .loop-and-merge-submenu-list-item {
  color: #323945 !important;
  border-radius: 4px;
  margin: 4px;
  padding-left: 6px;
}
.pf-new-theme .loop-and-merge-submenu-list .ant-dropdown-menu-submenu-title:hover,
.pf-new-theme .loop-and-merge-submenu-list-item:hover {
  background-color: #e6f4ff;
}
.pf-new-theme .loop-and-merge-submenu-list-disabled .ant-dropdown-menu-submenu-title,
.pf-new-theme .loop-and-merge-submenu-list-disabled .ant-dropdown-menu-submenu-title:hover,
.pf-new-theme .loop-and-merge-submenu-list-disabled-item,
.pf-new-theme .loop-and-merge-submenu-list-disabled-item:hover {
  color: #8f98a9 !important;
  background-color: white;
  cursor: not-allowed;
}
.pf-new-theme .loop-and-merge-submenu-list-popup-container ul {
  max-height: 326px;
  overflow-y: auto;
}
.pf-new-theme .background-new-yellow-4,
.pf-new-theme .background-new-yellow-4-hover:hover {
  background-color: #fbe58c;
}
.pf-new-theme .border-new-yellow-4,
.pf-new-theme .border-new-yellow-4-hover:hover {
  border-color: #fbe58c;
}
.pf-new-theme .color-new-green-7 {
  color: #4ca55e;
}
.pf-new-theme .background-new-green-7 {
  background-color: #4ca55e;
}
.pf-new-theme .peeq-criteria-collapse {
  height: calc(100vh - 200px);
}
.pf-new-theme .peeq-criteria-collapse .ant-collapse-item {
  border-color: #f3f6fb;
}
.pf-new-theme .peeq-criteria-collapse .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}
.pf-new-theme .peeq-criteria-collapse .ant-collapse-content-box label:last-child {
  border: none;
}
.pf-new-theme .peeq-criteria-collapse .ant-collapse-content-box .ant-checkbox {
  top: 4px;
}
.pf-new-theme .peeq-criteria-main-list .ant-collapse-item {
  background-color: #fff;
  border-color: #f3f6fb;
  margin-bottom: 24px;
}
.pf-new-theme .peeq-criteria-main-list .ant-collapse-content-box label:last-child {
  border: none;
}
.pf-new-theme .peeq-criteria-main-list .ant-collapse-arrow {
  top: 22px;
}
.pf-new-theme .targeting-peeq-card .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}
.pf-new-theme .targeting-peeq-card .ant-switch-checked {
  background-color: #381581;
}
.pf-new-theme .targeting-peeq-card .ant-switch-checked:focus {
  box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.8);
}
.pf-new-theme .targeting-peeq-card .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    ) .ant-select-selector {
  box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.55);
}
.pf-new-theme .targeting-peeq-card .ant-input-number-focused {
  box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.8);
}
.pf-new-theme .targeting-peeq-card .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: #f7f0ff !important;
}
.pf-new-theme .peeq-criteria-modal .ant-modal-content {
  padding: 0;
}
.pf-new-theme .peeq-criteria-modal .ant-modal-body {
  padding-top: 0;
  padding-bottom: 0;
}
.pf-new-theme .peeq-criteria-modal .ant-modal-body .items-list {
  overflow-y: scroll;
}
.pf-new-theme .peeq-criteria-modal .ant-modal-close {
  top: 7px;
  right: 6px;
}
.pf-new-theme .peeq-radio-include-exclude .ant-radio-button-wrapper {
  font-size: 10px;
  text-transform: uppercase;
  color: #323945;
  box-shadow: none;
}
.pf-new-theme .peeq-radio-include-exclude .ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px;
}
.pf-new-theme .peeq-radio-include-exclude .ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0;
}
.pf-new-theme .peeq-radio-include-exclude .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  background-color: #0e68f9;
  color: #fff;
  border-color: #0e68f9;
}
.pf-new-theme .peeq-radio-include-exclude .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):before {
  background-color: #0e68f9;
}
.pf-new-theme .background-purple-light {
  background-color: #f0eafd;
}
.pf-new-theme .background-purple-light-hover:hover {
  background-color: #ded5f0;
}
.pf-new-theme .background-purple-dark {
  background-color: #381581;
}
.pf-new-theme .background-purple-dark-important,
.pf-new-theme .background-purple-dark-important:hover {
  background-color: #381581;
}
.pf-new-theme .color-purple-light {
  color: #f0eafd;
}
.pf-new-theme .color-purple-light-hover:hover {
  color: #f0eafd;
}
.pf-new-theme .color-purple-dark {
  color: #381581;
}
.pf-new-theme .color-purple-dark-hover:hover {
  color: #381581;
}
.pf-new-theme .color-purple-sq {
  color: #6e3ae6;
}
.pf-new-theme .border-purple-light {
  border: 1px solid #f0eafd;
}
.pf-new-theme .border-purple-dark {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-hover:hover {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-active:active {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-focus:focus {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-important {
  border: 1px solid #381581 !important;
}
.pf-new-theme .border-purple-dark-dashed {
  border: 1px dashed #381581;
}
.pf-new-theme .border-left-purple-dark {
  border-left: 5px solid #381581 !important;
}
.pf-new-theme .ant-checkbox-purple-dark.ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border-color: #c2a3ff;
}
.pf-new-theme .ant-checkbox-purple-dark .ant-checkbox:hover .ant-checkbox-inner {
  border-color: #c2a3ff;
}
.pf-new-theme .ant-checkbox-purple-dark .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #e0e6ed;
}
.pf-new-theme .ant-checkbox-purple-dark .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background-color: #3c2b82;
  border-color: #3c2b82;
}
.pf-new-theme .ant-checkbox-purple-dark .ant-checkbox-checked::after {
  border: 1px solid #281d5c;
}
.pf-new-theme .ant-radio-purple-dark .ant-radio-inner {
  border-color: #381581;
}
.pf-new-theme .ant-radio-purple-dark .ant-radio-inner:after {
  background-color: #381581;
}
.pf-new-theme .ant-radio-purple-dark .ant-radio-checked:after {
  border-color: #381581;
}
.pf-new-theme .ant-switch-purple-dark.ant-switch-checked {
  background-color: #381581;
}
.pf-new-theme .ant-switch-purple-dark.ant-switch-checked:focus {
  box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.8);
}
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-ink-bar {
  background: #381581;
}
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-tab {
  padding: 8px 0 12px;
}
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-tab:hover {
  color: #5840a8;
}
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-tab:first-child {
  padding-left: 0px;
}
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-tab-btn:focus,
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-tab-btn:active {
  color: #5840a8;
}
.pf-new-theme .ant-tabs-purple-dark .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #381581;
}
.pf-new-theme .peeq-custom-question-modal .ant-modal-content {
  padding: 0;
}
.pf-new-theme .peeq-custom-question-modal .ant-modal-body {
  padding-top: 0;
  padding-bottom: 0;
}
.pf-new-theme .peeq-custom-question-modal .ant-collapse-question {
  padding-left: 0;
}
.pf-new-theme .peeq-custom-question-modal .ant-collapse-question .ant-collapse-header {
  margin-left: 0;
  padding: 0;
}
.pf-new-theme .peeq-custom-question-modal .ant-collapse-question .ant-collapse-header .padding-horizontal-md {
  padding: 0;
}
.pf-new-theme .peeq-custom-question-modal .ant-collapse-question .ant-collapse-content-box > div:not(.ant-divider-horizontal) {
  margin-left: 0;
}
.pf-new-theme .audience-remove-criterion-modal .ant-modal-content,
.pf-new-theme .clear-revision-modal .ant-modal-content,
.pf-new-theme .peeq-pause-edit-modal .ant-modal-content,
.pf-new-theme .peeq-remove-criterion-modal .ant-modal-content {
  padding: 16px;
}
.pf-new-theme .audience-remove-criterion-modal .ant-modal-close,
.pf-new-theme .clear-revision-modal .ant-modal-close,
.pf-new-theme .peeq-pause-edit-modal .ant-modal-close,
.pf-new-theme .peeq-remove-criterion-modal .ant-modal-close {
  top: 7px;
  right: 9px;
}
.pf-new-theme .audience-remove-criterion-modal .ant-modal-body,
.pf-new-theme .clear-revision-modal .ant-modal-body,
.pf-new-theme .peeq-pause-edit-modal .ant-modal-body,
.pf-new-theme .peeq-remove-criterion-modal .ant-modal-body {
  padding-top: 0;
  padding-bottom: 0;
}
.pf-new-theme .audience-remove-criterion-modal .ant-modal-footer,
.pf-new-theme .clear-revision-modal .ant-modal-footer,
.pf-new-theme .peeq-pause-edit-modal .ant-modal-footer,
.pf-new-theme .peeq-remove-criterion-modal .ant-modal-footer {
  padding-top: 40px;
  border-top: none;
}
.pf-new-theme .select-country-templates .ant-select-selection-search {
  top: 3px;
}
.pf-new-theme .dot {
  content: " ";
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #323945;
  border-radius: 4px;
  z-index: 100;
}
.pf-new-theme .questionnaire-revisions .empty-menu .ant-menu-submenu-arrow {
  display: none;
}
.pf-new-theme .questionnaire-revisions .ant-menu-item {
  overflow: visible!important;
}
.pf-new-theme .questionnaire-revisions .ant-layout-sider-children {
  overflow: auto;
}
.pf-new-theme .questionnaire-revisions .ant-menu-title-content,
.pf-new-theme .questionnaire-revisions .ant-menu-submenu-arrow {
  font-size: 12px;
  color: #323945 !important;
}
.pf-new-theme .questionnaire-revisions .ant-menu-submenu {
  margin-top: 10px;
}
.pf-new-theme .questionnaire-revisions .ant-menu-item::after {
  content: none;
}
.pf-new-theme .questionnaire-revisions .ant-menu-item-selected {
  font-weight: 500!important;
}
.pf-new-theme .questionnaire-revisions .ant-menu-item-active,
.pf-new-theme .questionnaire-revisions .is-revision-in-preview .revision-selected {
  background-color: #e0e6ed !important;
}
.pf-new-theme .questionnaire-revisions .ant-menu-sub.ant-menu-inline > .ant-menu-item,
.pf-new-theme .questionnaire-revisions .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: initial;
  line-height: initial;
  color: #323945 !important;
}
.pf-new-theme .questionnaire-revisions .ant-menu-light .ant-menu-item:hover,
.pf-new-theme .questionnaire-revisions .ant-menu-light .ant-menu-item-active,
.pf-new-theme .questionnaire-revisions .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.pf-new-theme .questionnaire-revisions .ant-menu-light .ant-menu-submenu-active,
.pf-new-theme .questionnaire-revisions .ant-menu-light .ant-menu-submenu-title:hover {
  color: #323945 !important;
}
.pf-new-theme .questionnaire-revisions .ant-menu-sub.ant-menu-inline {
  background-color: transparent!important;
}
.pf-new-theme .questionnaire-revisions .milestone-dot {
  position: relative;
}
.pf-new-theme .questionnaire-revisions .milestone-dot::before {
  content: " ";
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #323945;
  border-radius: 4px;
  z-index: 100;
  top: 49%;
  transform: translate3d(0, -25%, 0);
  left: 13px;
}
.pf-new-theme .questionnaire-revisions .milestone-dot.milestione-dot--inactive::before {
  background-color: #bfc8d5;
}
.pf-new-theme .questionnaire-revisions .ant-menu-submenu-title {
  position: relative;
  padding-left: 32px!important;
}
.pf-new-theme .questionnaire-revisions .ant-menu-submenu-title::before {
  content: " ";
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #323945;
  border-radius: 4px;
  z-index: 100;
  top: 50%;
  transform: translate3d(0, -25%, 0);
  left: 13px;
}
.pf-new-theme .questionnaire-revisions-inner {
  position: relative;
}
.pf-new-theme .questionnaire-revisions-inner.questionnaire-revisions-inner--loaded::before {
  content: " ";
  display: block;
  position: absolute;
  top: 66px;
  left: 15px;
  z-index: 10;
  background-color: #bfc8d5;
  width: 1px;
  height: calc(100% - 95px);
}
.pf-new-theme .revision-item {
  padding-left: 20px;
}
.pf-new-theme .revision-item::before {
  content: " ";
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #323945;
  border-radius: 4px;
  z-index: 100;
  top: 21px;
  left: 13px;
  background-color: #bfc8d5;
}
.pf-new-theme .survey-special-actions {
  position: sticky;
  top: -16px;
  z-index: 50;
  left: 0;
  background-color: #f3f6fb;
}
.pf-new-theme .survey-special-actions::before {
  content: " ";
  position: absolute;
  display: block;
  top: 0;
  left: -20px;
  width: 20px;
  height: 100%;
  z-index: inherit;
  background-color: #f3f6fb;
}
@keyframes move {
  0% {
    transform: translate3d(-20%, 0, 0);
  }
  30% {
    transform: translate3d(0, 40%, 0);
  }
  50% {
    transform: translate3d(0, -40%, 0);
  }
  60% {
    transform: translate3d(20%, 0, 0);
  }
  80% {
    transform: translate3d(20%, -20%, 0);
  }
  100% {
    transform: translate3d(30%, 50%, 0);
  }
}
@keyframes glow {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes aiBuilderColor {
  0% {
    background: linear-gradient(0deg, #fb60c6, #8618ca);
  }
  50% {
    background: linear-gradient(0deg, #81267e, #1a2769);
  }
  75% {
    background: linear-gradient(0deg, #ce1d1d, #fb60c6);
  }
  100% {
    background: linear-gradient(0deg, #8618ca, #ce1d1d);
  }
  0% {
    background: linear-gradient(0deg, #fb60c6, #8618ca);
  }
  50% {
    background: linear-gradient(0deg, #81267e, #1a2769);
  }
  75% {
    background: linear-gradient(0deg, #ce1d1d, #fb60c6);
  }
  100% {
    background: linear-gradient(0deg, #8618ca, #ce1d1d);
  }
}
@-moz-keyframes aiBuilderColor {
  0% {
    background: linear-gradient(0deg, #fb60c6, #8618ca);
  }
  50% {
    background: linear-gradient(0deg, #81267e, #1a2769);
  }
  75% {
    background: linear-gradient(0deg, #ce1d1d, #fb60c6);
  }
  100% {
    background: linear-gradient(0deg, #8618ca, #ce1d1d);
  }
  0% {
    background: linear-gradient(0deg, #fb60c6, #8618ca);
  }
  50% {
    background: linear-gradient(0deg, #81267e, #1a2769);
  }
  75% {
    background: linear-gradient(0deg, #ce1d1d, #fb60c6);
  }
  100% {
    background: linear-gradient(0deg, #8618ca, #ce1d1d);
  }
}
@keyframes aiBuilderColor {
  0% {
    background: linear-gradient(0deg, #fb60c6, #8618ca);
  }
  50% {
    background: linear-gradient(0deg, #81267e, #1a2769);
  }
  75% {
    background: linear-gradient(0deg, #ce1d1d, #fb60c6);
  }
  100% {
    background: linear-gradient(0deg, #8618ca, #ce1d1d);
  }
  0% {
    background: linear-gradient(0deg, #fb60c6, #8618ca);
  }
  50% {
    background: linear-gradient(0deg, #81267e, #1a2769);
  }
  75% {
    background: linear-gradient(0deg, #ce1d1d, #fb60c6);
  }
  100% {
    background: linear-gradient(0deg, #8618ca, #ce1d1d);
  }
}
@-webkit-keyframes aiBuilderColor {
  0% {
    background-position: 92% 0%;
  }
  50% {
    background-position: 9% 100%;
  }
  100% {
    background-position: 92% 0%;
  }
  0% {
    background-position: 92% 0%;
  }
  50% {
    background-position: 9% 100%;
  }
  100% {
    background-position: 92% 0%;
  }
}
@-moz-keyframes aiBuilderColor {
  0% {
    background-position: 92% 0%;
  }
  50% {
    background-position: 9% 100%;
  }
  100% {
    background-position: 92% 0%;
  }
  0% {
    background-position: 92% 0%;
  }
  50% {
    background-position: 9% 100%;
  }
  100% {
    background-position: 92% 0%;
  }
}
@keyframes aiBuilderColor {
  0% {
    background-position: 92% 0%;
  }
  50% {
    background-position: 9% 100%;
  }
  100% {
    background-position: 92% 0%;
  }
  0% {
    background-position: 92% 0%;
  }
  50% {
    background-position: 9% 100%;
  }
  100% {
    background-position: 92% 0%;
  }
}
@keyframes gradientLeft {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes gradientRight {
  0% {
    background-position: 50% 00%;
  }
  50% {
    background-position: 50% 100%;
  }
  100% {
    background-position: 50% 0%;
  }
  0% {
    background-position: 50% 00%;
  }
  50% {
    background-position: 50% 100%;
  }
  100% {
    background-position: 50% 0%;
  }
}
.pf-new-theme .pf-ai-actions-dropdown .ant-dropdown-menu-item {
  width: 100%;
  font-size: 14px;
}
.pf-new-theme .pf-ai-actions-dropdown .ant-dropdown-menu-item .ant-dropdown-menu-title-content {
  width: 100%;
  font-size: 14px;
}
.pf-new-theme .pf-ai-actions-dropdown .ant-dropdown-menu-item .icon {
  font-size: 16px;
  width: 16px;
  text-align: center;
}
.pf-new-theme .pf-ai-actions-dropdown .margin-right-xxs {
  margin-right: 8px !important;
}
.pf-new-theme .pf-ai-actions-dropdown .ant-dropdown-menu-title-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pf-new-theme .pf-ai-actions-dropdown.ant-dropdown-menu {
  border: 1px solid #bb43b50f;
  padding: 12px !important;
  background: linear-gradient(90deg, #f2f5fe 3.61%, #f9f4fd 38.2%, #fafbfd 54.38%, #f8fafc 74.27%, #f9f2fc 102.96%);
}
.pf-new-theme .pf-ai-actions-dropdown .ant-dropdown-menu-item-active {
  background-color: white;
  color: #d830d0;
}
.pf-new-theme .pf-ai-actions-dropdown .ant-dropdown-menu-title-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pf-new-theme .pf-ai-actions-dropdown.ant-dropdown-menu {
  border: 1px solid #bb43b50f;
  padding: 12px !important;
  background: linear-gradient(90deg, #f2f5fe 3.61%, #f9f4fd 38.2%, #fafbfd 54.38%, #f8fafc 74.27%, #f9f2fc 102.96%);
}
.pf-new-theme .AI-builder {
  max-width: 460px !important;
  min-width: auto !important;
}
.pf-new-theme .AI-builder .ai-chat .message {
  font-size: 14px;
  line-height: 20px;
}
.pf-new-theme .AI-builder .user-message {
  max-width: 360px;
}
.pf-new-theme .ai-icon {
  font-size: 16px;
}
.pf-new-theme .ask-ai-button,
.pf-new-theme .ask-ai-button:hover {
  background: linear-gradient(0deg, rgba(93, 39, 126, 0.5), rgba(93, 39, 126, 0.5)), radial-gradient(119.92% 499.26% at 8.17% 126.47%, #fb60c6 0%, #8618ca 87%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
}
.pf-new-theme .ai-message-loader {
  border: 3px solid white;
  height: 15px;
  border-radius: 6px;
  background-image: linear-gradient(0.25turn, var(--loader-color-1), var(--loader-color-2), var(--loader-color-3), var(--loader-color-4), var(--loader-color-5));
  animation: ai-gradient-color-rotation 1s linear infinite alternate;
}
@keyframes ai-gradient-color-rotation {
  to {
    --loader-color-1: #1e0564b2;
    --loader-color-2: #840db1b2;
    --loader-color-3: #ef2789b2;
    --loader-color-4: #f1f4ffb2;
    --loader-color-5: #7496fcb2;
  }
}
@property --loader-color-1 {
  syntax: '<color>';
  inherits: false;
  initial-value: #7496fcb2;
}
@property --loader-color-2 {
  syntax: '<color>';
  inherits: false;
  initial-value: #f1f4ffb2;
}
@property --loader-color-3 {
  syntax: '<color>';
  inherits: false;
  initial-value: #ef2789b2;
}
@property --loader-color-4 {
  syntax: '<color>';
  inherits: false;
  initial-value: #840db1b2;
}
@property --loader-color-5 {
  syntax: '<color>';
  inherits: false;
  initial-value: #1e0564b2;
}
.pf-new-theme .ai-builder-anim-bg-wrapper {
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, #351356, #2b1356);
  overflow: hidden;
  position: absolute !important;
  z-index: 0;
  top: 0;
  left: 0;
  pointer-events: none;
}
.pf-new-theme .ai-builder-anim-bg-wrapper.ai-builder-anim-bg-wrapper--bright {
  background: linear-gradient(0deg, #b735ad, #8623bd);
}
@keyframes gradientScale {
  70% {
    transform: scale(1.2) translate(50px);
  }
}
@keyframes gradientScale2 {
  0% {
    transform: scale(1) translate3d(0, 30%, 0);
  }
  30% {
    transform: scale(1.3) translate3d(20%, 0, 0);
  }
  60% {
    transform: scale(1.1) translate3d(0, -30%, 0);
  }
  80% {
    transform: scale(1.2) translate3d(-20px, -10%, 0);
  }
  100% {
    transform: scale(1) translate3d(0, 30%, 0);
  }
}
.pf-new-theme .ai-builder-anim-bg-btn-bright {
  position: absolute !important;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  filter: blur(20px);
}
.pf-new-theme .ai-builder-anim-bg-btn-bright span {
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  animation: gradientScale 2s infinite;
}
.pf-new-theme .ai-builder-anim-bg-btn-bright span:nth-child(1) {
  height: 90%;
  width: 80%;
  background-color: #ff00eb;
  left: -5%;
  top: 0;
}
.pf-new-theme .ai-builder-anim-bg-btn-bright span:nth-child(2) {
  height: 80%;
  width: 70%;
  background-color: #8623bd;
  left: 48%;
  top: 8%;
  animation-delay: 4s;
}
.pf-new-theme .ai-builder-anim-bg-btn-bright span:nth-child(3) {
  height: 65%;
  width: 80%;
  background-color: #ac5050;
  left: 25%;
  top: 30%;
  animation-delay: 0.3s;
}
.pf-new-theme .ai-builder-anim-bg-btn-bright span:nth-child(4) {
  height: 50%;
  width: 75%;
  background-color: #1ba8e9;
  left: 20%;
  top: 20%;
  animation-delay: 1.2s;
}
.pf-new-theme .ai-builder-anim-bg-btn {
  position: absolute !important;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  filter: blur(20px);
}
.pf-new-theme .ai-builder-anim-bg-btn span {
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  animation: gradientScale 2s infinite;
}
.pf-new-theme .ai-builder-anim-bg-btn span:nth-child(1) {
  height: 90%;
  width: 80%;
  background-color: #ff057c;
  left: -5%;
  top: 0;
}
.pf-new-theme .ai-builder-anim-bg-btn span:nth-child(2) {
  height: 80%;
  width: 70%;
  background-color: #ff057c;
  left: 48%;
  top: 8%;
  animation-delay: 4s;
}
.pf-new-theme .ai-builder-anim-bg-btn span:nth-child(3) {
  height: 65%;
  width: 80%;
  background-color: #1619b9;
  left: 25%;
  top: 30%;
  animation-delay: 0.3s;
}
.pf-new-theme .ai-builder-anim-bg-btn span:nth-child(4) {
  height: 50%;
  width: 75%;
  background-color: #1ba8e9;
  left: 20%;
  top: 20%;
  animation-delay: 1.2s;
}
.pf-new-theme .ai-builder-anim-bg-header {
  position: absolute !important;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  filter: blur(20px);
}
.pf-new-theme .ai-builder-anim-bg-header span {
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  animation: gradientScale2 8s infinite;
}
.pf-new-theme .ai-builder-anim-bg-header span:nth-child(1) {
  height: 90%;
  width: 30%;
  background-color: #8433de;
  left: 15%;
  top: 0;
}
.pf-new-theme .ai-builder-anim-bg-header span:nth-child(2) {
  height: 80%;
  width: 50%;
  background-color: #8a22da;
  left: 48%;
  top: 8%;
  animation-delay: 4s;
}
.pf-new-theme .ai-builder-anim-bg-header span:nth-child(3) {
  height: 65%;
  width: 50%;
  background-color: #ff057c;
  left: 25%;
  top: 30%;
  animation-delay: 0.3s;
}
.pf-new-theme .ai-builder-anim-bg-header span:nth-child(4) {
  height: 50%;
  width: 50%;
  background-color: #180b34;
  left: 20%;
  top: 20%;
  animation-delay: 1.2s;
}
.pf-new-theme .ai-button-border-animation {
  border: 2px solid transparent !important;
  background-image: linear-gradient(white, white), conic-gradient(from var(--border-angle), transparent, transparent, rgba(216, 48, 208, 0.4), transparent, transparent) !important;
  background-clip: padding-box, border-box !important;
  background-origin: padding-box, border-box !important;
  animation: border-rotation 2s linear infinite !important;
}
@keyframes border-rotation {
  from {
    --border-angle: 0deg;
  }
  to {
    --border-angle: 360deg;
  }
}
@property --border-angle {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}
.pf-new-theme .questionaire-card-conversational {
  background: #eef2ff;
  background: linear-gradient(90deg, #eef2ff 0%, #f8effd 31%, #ecf1fc 78%, #f8f9fc 93%, #f7eefa 100%);
}
.pf-new-theme .questionnaire-card-modified {
  border-inline-start: 2px solid #ffa257 !important;
}
.pf-new-theme .questionnaire-card-modified-icon {
  top: 0.4rem;
  left: 0.4rem;
  position: absolute;
  font-size: 0.5rem;
  color: #ffa257;
}
.pf-new-theme .ant-collapse-conversational .ant-collapse-content-box {
  margin: 16px 16px 20px 0;
}
.pf-new-theme .ant-collapse-conversational .ant-collapse-header {
  display: flex;
}
.pf-new-theme .ant-collapse-conversational .ant-collapse-header > span {
  position: relative;
  top: 4px;
}
.pf-new-theme .conversational-icon-wrapper {
  position: relative;
  width: 15px;
  height: 15px;
  border-radius: 4px;
  display: inline-block;
  background: linear-gradient(0deg, #b735ad, #8623bd);
}
.pf-new-theme .conversational-icon-wrapper > span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
}
.pf-new-theme .feedback-modal .ant-modal-content {
  padding: 16px;
  width: 370px;
}
.pf-new-theme .feedback-modal .ant-modal-close {
  top: 9px;
  right: 9px;
}
.pf-new-theme .hover-actions-overlay {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
}
.pf-new-theme .hover-actions-field--visible .hover-actions-overlay {
  opacity: 1 !important;
  pointer-events: auto;
}
.pf-new-theme .question-answer .position-relative > .hover-actions-overlay,
.pf-new-theme .question-answer .hover-actions-input-group__input > .hover-actions-overlay {
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 14px;
}
.pf-new-theme .hover-actions-input-group {
  min-width: 0;
  flex: 1 1 0%;
  width: 100%;
  align-items: stretch;
}
.pf-new-theme .hover-actions-input-group__input {
  min-width: 0;
  flex: 1 1 0%;
  box-sizing: border-box;
}
.pf-new-theme .hover-actions-input-group__input > .question-answer-input {
  width: 100%;
  min-width: 0 !important;
  max-width: 100%;
  min-height: 32px;
  box-sizing: border-box;
}
.pf-new-theme .hover-actions-input-group__input > .question-answer-input > div {
  width: 100%;
  min-width: 0;
}
.pf-new-theme .hover-actions-input-group__input > .question-answer-input .formatted-editor {
  width: 100%;
  min-width: 0 !important;
  max-width: 100%;
}
.pf-new-theme .hover-actions-input-group--has-side-action > .hover-actions-side-overlay {
  flex-shrink: 0;
  align-self: stretch;
}
.pf-new-theme .hover-actions-side-overlay {
  opacity: 0;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: stretch;
  width: 0;
  min-width: 0;
  max-width: 0;
  margin-left: 0;
  overflow: hidden;
  border-radius: 4px;
  box-sizing: border-box;
}
.pf-new-theme .hover-actions-side-overlay--visible {
  opacity: 1;
  pointer-events: auto;
  width: 24px;
  min-width: 24px;
  max-width: 24px;
  margin-left: 4px;
}
.pf-new-theme .question-answer:hover .hover-actions-input-group__input--answer-hover,
.pf-new-theme .question-answer.hover-actions-field--visible .hover-actions-input-group__input--answer-hover {
  background-color: #f4f7fc;
  border-radius: 4px;
}
.pf-new-theme .question-answer .hover-actions-input-group__input--answer-hover > .question-answer-input.background-grey-4-hover,
.pf-new-theme .question-answer:hover .hover-actions-input-group__input--answer-hover > .question-answer-input.background-grey-4-hover,
.pf-new-theme .question-answer.hover-actions-field--visible .hover-actions-input-group__input--answer-hover > .question-answer-input.background-grey-4-hover {
  background-color: transparent !important;
}
.pf-new-theme .question-answer .question-answer-input.background-grey-4-hover:hover,
.pf-new-theme .question-answer:hover :not(.hover-actions-input-group__input--answer-hover) > .question-answer-input.background-grey-4-hover,
.pf-new-theme .question-answer.hover-actions-field--visible :not(.hover-actions-input-group__input--answer-hover) > .question-answer-input.background-grey-4-hover,
.pf-new-theme .question-answer:hover .hover-actions-side-overlay.hover-actions-side-overlay--visible,
.pf-new-theme .question-answer.hover-actions-field--visible .hover-actions-side-overlay.hover-actions-side-overlay--visible,
.pf-new-theme .hover-actions-side-overlay.hover-actions-side-overlay--visible:hover {
  background-color: #f4f7fc;
}
.pf-new-theme .hover-actions-side-overlay .ant-btn {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.pf-new-theme .hover-actions-side-overlay .ant-btn:hover,
.pf-new-theme .hover-actions-side-overlay .ant-btn:focus,
.pf-new-theme .hover-actions-side-overlay .ant-btn:active {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.pf-new-theme .hover-actions-side-overlay .ant-btn.color-blue-6-hover:hover:not([disabled]),
.pf-new-theme .hover-actions-side-overlay .ant-btn.color-blue-6-hover:focus:not([disabled]),
.pf-new-theme .hover-actions-side-overlay .ant-btn.color-blue-6-hover:active:not([disabled]) {
  color: #323945 !important;
}
.pf-new-theme .hover-actions-side-overlay .ant-btn[disabled],
.pf-new-theme .hover-actions-side-overlay .ant-btn[disabled]:hover,
.pf-new-theme .hover-actions-side-overlay .ant-btn[disabled]:focus,
.pf-new-theme .hover-actions-side-overlay .ant-btn[disabled]:active {
  color: #bfc8d5 !important;
  background: transparent !important;
  background-color: transparent !important;
}
.pf-new-theme .hover-actions-side-overlay .ant-btn .icon,
.pf-new-theme .hover-actions-side-overlay .ant-btn .anticon {
  color: inherit !important;
}
.pf-new-theme .hover-actions-side-overlay .question-answer-delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 24px;
  height: auto;
  min-height: 32px;
  padding-left: 4px;
  padding-right: 4px;
  margin-left: 0;
  margin-right: 0;
}
.pf-new-theme .hover-actions-side-overlay .hover-actions-restore-icon {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.pf-new-theme .hover-actions-side-overlay .ant-tooltip-disabled-compatible-wrapper.question-answer-delete-btn > .ant-btn {
  padding: 0;
  height: auto;
  min-height: 32px;
}
.pf-new-theme .hover-actions-overlay--empty-answer {
  right: 16px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
}
.pf-new-theme .hover-actions-overlay--prompt {
  top: 4px;
  right: 10px;
}
.pf-new-theme .hover-actions-field--visible .hover-actions-overlay--prompt {
  z-index: 20;
}
.pf-new-theme .hover-actions-field--visible .question-prompt-input {
  background-color: #f4f7fc;
}
.pf-new-theme .question-answer-actions {
  gap: 12px;
  top: -2px;
  position: relative;
}
.pf-new-theme .question-answer-dropdown-actions {
  gap: 10px;
}
.pf-new-theme .question-answer-action-indicator-slot {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu {
  padding: 6px 0 !important;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.full-size-link {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item button.ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item .ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item .padding-horizontal-xxs,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu-title button.ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu-title .ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu-title .padding-horizontal-xxs {
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .margin-right-xxs {
  margin-right: 12px !important;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .icon + .margin-left-xxs,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .anticon + .margin-left-xxs {
  margin-left: 12px !important;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .dropdown-menu-grouped-actions-divider {
  margin: 6px 0;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu-expand-icon {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 8px;
  flex-shrink: 0;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .ant-dropdown-menu-submenu-title,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .ant-dropdown-menu-submenu-title,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .qa-dropdown-submenu-trigger-inner,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .qa-dropdown-submenu-trigger-inner {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 32px;
  min-height: 32px;
  margin: 0;
  padding: 0 !important;
  background-color: transparent !important;
  border-radius: 4px;
  transition: none;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .ant-dropdown-menu-submenu-title .ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .ant-dropdown-menu-submenu-title .ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .qa-dropdown-submenu-trigger-inner .ant-btn,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .qa-dropdown-submenu-trigger-inner .ant-btn {
  flex: 1;
  min-width: 0;
  width: auto;
  height: 32px;
  line-height: 32px;
  pointer-events: none;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .ant-dropdown-menu-submenu-title .qa-dropdown-submenu-title-content,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .ant-dropdown-menu-submenu-title .qa-dropdown-submenu-title-content,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .qa-dropdown-submenu-trigger-inner .qa-dropdown-submenu-title-content,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .qa-dropdown-submenu-trigger-inner .qa-dropdown-submenu-title-content {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  height: 100%;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled {
  cursor: not-allowed;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title:hover,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title:hover,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover {
  background-color: transparent !important;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title:hover .ant-dropdown-menu-submenu-arrow-icon,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title:hover .ant-dropdown-menu-submenu-arrow-icon,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover .ant-dropdown-menu-submenu-arrow-icon,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled:hover .ant-dropdown-menu-submenu-arrow-icon {
  color: rgba(0, 0, 0, 0.25);
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.ant-dropdown-menu-item-active:not(:hover) {
  background-color: transparent !important;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item:hover:not(.ant-dropdown-menu-item-disabled) > .qa-dropdown-submenu-trigger-inner .ant-btn:not([disabled]) {
  color: #0e68f9;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item:hover:not(.ant-dropdown-menu-item-disabled) > .qa-dropdown-submenu-trigger-inner .ant-dropdown-menu-submenu-expand-icon,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item:hover:not(.ant-dropdown-menu-item-disabled) > .qa-dropdown-submenu-trigger-inner .ant-dropdown-menu-submenu-expand-icon .icon {
  color: #0e68f9;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.ant-dropdown-menu-item-disabled.ant-dropdown-menu-item-active,
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.ant-dropdown-menu-item-disabled:hover {
  background-color: transparent !important;
}
.pf-new-theme .qa-dropdown-menu.ant-dropdown-menu.qa-dropdown-menu--single-item .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item {
  min-width: 168px;
}
.pf-new-theme .qa-dropdown-submenu-popup-panel .pf-ai-actions-dropdown.ant-dropdown-menu {
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.pf-new-theme .qa-dropdown-submenu-popup-panel .pf-ai-actions-dropdown.ant-dropdown-menu .margin-right-xxs {
  margin-right: 8px !important;
}
.pf-new-theme .qa-dropdown-submenu-popup-panel .qa-dropdown-submenu.ant-dropdown-menu {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 0;
  padding-right: 0;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
}
.pf-new-theme .qa-dropdown-submenu.ant-dropdown-menu-submenu-popup ul.ant-dropdown-menu {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .qa-dropdown-submenu.ant-dropdown-menu-submenu-popup .ant-dropdown-menu-item.full-size-link {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
}
.pf-new-theme .qa-dropdown-submenu.ant-dropdown-menu-submenu-popup .margin-right-xxs {
  margin-right: 12px !important;
}
.pf-new-theme .qa-dropdown-submenu.ant-dropdown-menu-submenu ul.ant-dropdown-menu {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .qa-dropdown-submenu.ant-dropdown-menu-submenu .ant-dropdown-menu-item.full-size-link {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 8px;
  padding-right: 8px;
}
.pf-new-theme .qa-dropdown-submenu.ant-dropdown-menu-submenu .margin-right-xxs {
  margin-right: 12px !important;
}
.pf-new-theme .matrix-cell-actions {
  flex-shrink: 0;
  padding-left: 6px;
  padding-right: 6px;
}
.pf-new-theme .matrix-cell-actions-row {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  margin-left: auto;
}
.pf-new-theme .matrix-cell-actions-row .matrix-cell-actions {
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .matrix-cell-actions-row .question-answer-actions {
  align-items: center;
}
.pf-new-theme .matrix-cell-actions-row > .ant-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  height: 20px;
  padding: 0;
  line-height: 1;
}
.pf-new-theme .matrix-row-actions-group {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 2px;
}
.pf-new-theme .matrix-row-actions-group .matrix-cell-actions {
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .matrix-row-actions-group .question-answer-actions {
  align-items: center;
}
.pf-new-theme .matrix-row-actions-group > .ant-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  height: 20px;
  padding: 0;
  line-height: 1;
}
.pf-new-theme .matrix-column-actions-group {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  min-width: 0;
  padding: 0;
  box-sizing: border-box;
  margin-left: 7px !important;
}
.pf-new-theme .matrix-column-actions-group .matrix-cell-actions {
  padding: 0;
}
.pf-new-theme .matrix-column-actions-group .question-answer-actions {
  align-items: center;
}
.pf-new-theme .matrix-column-actions-group [data-testid='dropdown-actions'] {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 16px;
  min-width: 16px;
  height: 16px;
  line-height: 1;
  padding: 0;
  vertical-align: middle;
}
.pf-new-theme .matrix-column-actions-group > .ant-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 14px;
  height: 20px;
  padding: 0;
  line-height: 1;
}
.pf-new-theme .matrix-corner-required-toggle {
  align-items: flex-end;
  padding-bottom: 6px;
  box-sizing: border-box;
}
.pf-new-theme .matrix-table-corner-header-cell {
  vertical-align: bottom !important;
}
.pf-new-theme .question-answer-actions {
  justify-content: flex-end;
}
.pf-new-theme .matrix-bipolar-row-actions-cell {
  width: var(--matrix-row-actions-width, 34px) !important;
  min-width: var(--matrix-row-actions-width, 34px) !important;
  max-width: var(--matrix-row-actions-width, 34px) !important;
  white-space: nowrap;
  padding: 4px 8px !important;
  border-left: 1px solid #f3f6fb;
  overflow: visible;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
}
.pf-new-theme .matrix-bipolar-row-actions-cell .matrix-bipolar-row-actions-content,
.pf-new-theme .matrix-bipolar-row-actions-cell .matrix-row-actions-group,
.pf-new-theme .matrix-bipolar-row-actions-cell .matrix-cell-actions-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.pf-new-theme .matrix-bipolar-row-actions-cell .ant-btn.margin-horizontal-xs {
  margin-left: 0;
  margin-right: 0;
}
.pf-new-theme .matrix-bipolar-row-actions-cell .matrix-cell-actions {
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .matrix-bipolar-row-actions-cell .question-answer-actions {
  align-items: center;
}
.pf-new-theme .matrix-bipolar-row-actions-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 2px;
}
.pf-new-theme .matrix-table-row-label-cell {
  padding: 12px 12px 12px 6px !important;
  box-sizing: border-box;
}
.pf-new-theme .matrix-table-column-header-cell {
  padding: 0 !important;
  box-sizing: border-box;
}
.pf-new-theme .matrix-column-header-content {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding-left: 12px;
  padding-right: 7px;
}
.pf-new-theme .matrix-column-header-content > * + * {
  margin-left: 12px;
}
.pf-new-theme .matrix-header-content,
.pf-new-theme .matrix-table-body-cell-content {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.pf-new-theme .matrix-header-content > * + *,
.pf-new-theme .matrix-table-body-cell-content > * + * {
  margin-left: 12px;
}
.pf-new-theme .matrix-adjacent-required-toggle {
  padding: 2px 0 0 0 !important;
}
.pf-new-theme .table-node .matrix-table-cells.ant-table-cell,
.pf-new-theme .table-node .ant-table-thead > tr > th.matrix-table-cells,
.pf-new-theme .table-node .ant-table-tbody > tr > td.matrix-table-cells {
  border-color: #f3f6fb !important;
}
.pf-new-theme .table-node .ant-table-thead > tr > th.matrix-table-column-header-cell {
  padding: 0 !important;
}
.pf-new-theme .matrix-reorder-container {
  box-sizing: border-box;
  max-width: 100%;
}
.pf-new-theme .matrix-reorder-container--column {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .question-answer-actions-column {
  margin-left: 12px;
  flex-shrink: 0;
  position: relative;
}
.pf-new-theme .drag-card.drag-type-answer .grippy.answer-grippy {
  position: static;
  top: auto;
  left: auto;
  height: auto;
  width: 24px;
  flex-shrink: 0;
  transform: none;
  margin-right: 4px;
  transition: opacity 0.15s ease;
  border: none;
  background: transparent;
  padding: 0;
  cursor: grab;
  opacity: 0;
  pointer-events: none;
}
.pf-new-theme .drag-card.drag-type-answer .grippy.answer-grippy div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: 0;
}
.pf-new-theme .drag-card.drag-type-answer:hover .grippy.answer-grippy:not(.cursor-disabled),
.pf-new-theme .drag-card.drag-type-answer:focus-within .grippy.answer-grippy:not(.cursor-disabled) {
  opacity: 1;
  pointer-events: auto;
}
.pf-new-theme .drag-card.drag-type-answer .answer-drag-content {
  min-width: 0;
}
.pf-new-theme .answer-grippy--hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: 0;
  border: 0;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
}
.pf-new-theme .drag-card.drag-type-matrix-row .matrix-row-grippy {
  position: static;
  top: auto;
  left: auto;
  height: auto;
  width: 24px;
  flex-shrink: 0;
  transform: none;
  margin-right: 4px;
  transition: opacity 0.15s ease;
  border: none;
  background: transparent;
  padding: 0;
  cursor: grab;
  opacity: 0;
  pointer-events: none;
}
.pf-new-theme .drag-card.drag-type-matrix-row .matrix-row-grippy div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: 0;
}
.pf-new-theme .drag-card.drag-type-matrix-row:hover .matrix-row-grippy:not(.cursor-disabled),
.pf-new-theme .drag-card.drag-type-matrix-row:focus-within .matrix-row-grippy:not(.cursor-disabled) {
  opacity: 1;
  pointer-events: auto;
}
.pf-new-theme .drag-card.drag-type-matrix-row .matrix-option-drag-content {
  min-width: 0;
}
.pf-new-theme .drag-card.drag-type-matrix-column .matrix-column-grippy {
  position: static;
  top: auto;
  left: auto;
  height: auto;
  width: 24px;
  flex-shrink: 0;
  transform: none;
  margin-bottom: 4px;
  transition: opacity 0.15s ease;
  border: none;
  background: transparent;
  padding: 0;
  cursor: grab;
  opacity: 0;
  pointer-events: none;
}
.pf-new-theme .drag-card.drag-type-matrix-column .matrix-column-grippy div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  padding: 0;
  transform: rotate(90deg);
}
.pf-new-theme .drag-card.drag-type-matrix-column:hover .matrix-column-grippy:not(.cursor-disabled),
.pf-new-theme .drag-card.drag-type-matrix-column:focus-within .matrix-column-grippy:not(.cursor-disabled) {
  opacity: 1;
  pointer-events: auto;
}
.pf-new-theme .drag-card.drag-type-matrix-column .matrix-option-drag-content {
  min-width: 0;
  max-width: 100%;
}
.pf-new-theme .drag-card.drag-guide-left:after,
.pf-new-theme .drag-card.drag-guide-right:after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #323945;
  z-index: 1;
  pointer-events: none;
}
.pf-new-theme .drag-card.drag-guide-left:after {
  left: 0;
}
.pf-new-theme .drag-card.drag-guide-right:after {
  right: 0;
}
.pf-new-theme * {
  -webkit-font-smoothing: antialiased;
}
.pf-new-theme .color-brand {
  color:  #e44044;
}
.pf-new-theme .color-brand-important {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-hover:hover {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-hover:hover {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-hover.active-hover {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-hover.active-hover {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-hover:focus {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-hover:focus {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-hover.active-focus {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-hover.active-focus {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-focus:focus {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-focus:focus {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-focus.active-focus {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-focus.active-focus {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-placeholder::placeholder {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-placeholder::placeholder {
  color:  #e44044 !important;
}
.pf-new-theme .color-brand-placeholder.active-placeholder {
  color:  #e44044;
}
.pf-new-theme .color-brand-important-placeholder.active-placeholder {
  color:  #e44044 !important;
}
.pf-new-theme .color-hover-parent:hover .color-brand-hover {
  color:  #e44044;
}
.pf-new-theme .color-hover-parent:hover .color-brand-important-hover {
  color:  #e44044 !important;
}
.pf-new-theme .background-brand {
  background:  #e44044;
}
.pf-new-theme .background-brand-important {
  background:  #e44044 !important;
}
.pf-new-theme .background-brand-hover:hover {
  background:  #e44044;
}
.pf-new-theme .background-brand-important-hover:hover {
  background:  #e44044 !important;
}
.pf-new-theme .background-brand-hover.active-hover {
  background:  #e44044;
}
.pf-new-theme .background-brand-important-hover.active-hover {
  background:  #e44044 !important;
}
.pf-new-theme .background-brand-hover:focus {
  background:  #e44044;
}
.pf-new-theme .background-brand-important-hover:focus {
  background:  #e44044 !important;
}
.pf-new-theme .background-brand-hover.active-focus {
  background:  #e44044;
}
.pf-new-theme .background-brand-important-hover.active-focus {
  background:  #e44044 !important;
}
.pf-new-theme .background-brand-focus:focus {
  background:  #e44044;
}
.pf-new-theme .background-brand-important-focus:focus {
  background:  #e44044 !important;
}
.pf-new-theme .background-brand-focus.active-focus {
  background:  #e44044;
}
.pf-new-theme .background-brand-important-focus.active-focus {
  background:  #e44044 !important;
}
.pf-new-theme .border-brand {
  border: 1px solid #e44044;
}
.pf-new-theme .border-brand-important {
  border: 1px solid #e44044 !important;
}
.pf-new-theme .border-brand-hover:hover {
  border: 1px solid #e44044;
}
.pf-new-theme .border-brand-important-hover:hover {
  border: 1px solid #e44044 !important;
}
.pf-new-theme .border-brand-focus:focus {
  border: 1px solid #e44044;
}
.pf-new-theme .border-brand-important-focus:focus {
  border: 1px solid #e44044 !important;
}
.pf-new-theme .border-top-brand {
  border-top: 1px solid #e44044;
}
.pf-new-theme .border-top-brand-important {
  border-top: 1px solid #e44044 !important;
}
.pf-new-theme .border-top-brand-hover:hover {
  border-top: 1px solid #e44044;
}
.pf-new-theme .border-top-brand-important-hover:hover {
  border-top: 1px solid #e44044 !important;
}
.pf-new-theme .border-right-brand {
  border-right: 1px solid #e44044;
}
.pf-new-theme .border-right-brand-important {
  border-right: 1px solid #e44044 !important;
}
.pf-new-theme .border-right-brand-hover:hover {
  border-right: 1px solid #e44044;
}
.pf-new-theme .border-right-brand-important-hover:hover {
  border-right: 1px solid #e44044 !important;
}
.pf-new-theme .border-bottom-brand {
  border-bottom: 1px solid #e44044;
}
.pf-new-theme .border-bottom-brand-important {
  border-bottom: 1px solid #e44044 !important;
}
.pf-new-theme .border-bottom-brand-hover:hover {
  border-bottom: 1px solid #e44044;
}
.pf-new-theme .border-bottom-brand-important-hover:hover {
  border-bottom: 1px solid #e44044 !important;
}
.pf-new-theme .border-left-brand {
  border-left: 1px solid #e44044;
}
.pf-new-theme .border-left-brand-important {
  border-left: 1px solid #e44044 !important;
}
.pf-new-theme .border-left-brand-hover:hover {
  border-left: 1px solid #e44044;
}
.pf-new-theme .border-left-brand-important-hover:hover {
  border-left: 1px solid #e44044 !important;
}
.pf-new-theme .border-color-brand {
  border-color:  #e44044;
}
.pf-new-theme .border-color-brand-important {
  border-color:  #e44044 !important;
}
.pf-new-theme .border-color-brand-hover:hover {
  border-color:  #e44044;
}
.pf-new-theme .border-color-brand-important-hover:hover {
  border-color:  #e44044 !important;
}
.pf-new-theme .color-transparent {
  color:  transparent;
}
.pf-new-theme .color-transparent-important {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-hover:hover {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-hover:hover {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-hover.active-hover {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-hover.active-hover {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-hover:focus {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-hover:focus {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-hover.active-focus {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-hover.active-focus {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-focus:focus {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-focus:focus {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-focus.active-focus {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-focus.active-focus {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-placeholder::placeholder {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-placeholder::placeholder {
  color:  transparent !important;
}
.pf-new-theme .color-transparent-placeholder.active-placeholder {
  color:  transparent;
}
.pf-new-theme .color-transparent-important-placeholder.active-placeholder {
  color:  transparent !important;
}
.pf-new-theme .color-hover-parent:hover .color-transparent-hover {
  color:  transparent;
}
.pf-new-theme .color-hover-parent:hover .color-transparent-important-hover {
  color:  transparent !important;
}
.pf-new-theme .background-transparent {
  background:  transparent;
}
.pf-new-theme .background-transparent-important {
  background:  transparent !important;
}
.pf-new-theme .background-transparent-hover:hover {
  background:  transparent;
}
.pf-new-theme .background-transparent-important-hover:hover {
  background:  transparent !important;
}
.pf-new-theme .background-transparent-hover.active-hover {
  background:  transparent;
}
.pf-new-theme .background-transparent-important-hover.active-hover {
  background:  transparent !important;
}
.pf-new-theme .background-transparent-hover:focus {
  background:  transparent;
}
.pf-new-theme .background-transparent-important-hover:focus {
  background:  transparent !important;
}
.pf-new-theme .background-transparent-hover.active-focus {
  background:  transparent;
}
.pf-new-theme .background-transparent-important-hover.active-focus {
  background:  transparent !important;
}
.pf-new-theme .background-transparent-focus:focus {
  background:  transparent;
}
.pf-new-theme .background-transparent-important-focus:focus {
  background:  transparent !important;
}
.pf-new-theme .background-transparent-focus.active-focus {
  background:  transparent;
}
.pf-new-theme .background-transparent-important-focus.active-focus {
  background:  transparent !important;
}
.pf-new-theme .border-transparent {
  border: 1px solid transparent;
}
.pf-new-theme .border-transparent-important {
  border: 1px solid transparent !important;
}
.pf-new-theme .border-transparent-hover:hover {
  border: 1px solid transparent;
}
.pf-new-theme .border-transparent-important-hover:hover {
  border: 1px solid transparent !important;
}
.pf-new-theme .border-transparent-focus:focus {
  border: 1px solid transparent;
}
.pf-new-theme .border-transparent-important-focus:focus {
  border: 1px solid transparent !important;
}
.pf-new-theme .border-top-transparent {
  border-top: 1px solid transparent;
}
.pf-new-theme .border-top-transparent-important {
  border-top: 1px solid transparent !important;
}
.pf-new-theme .border-top-transparent-hover:hover {
  border-top: 1px solid transparent;
}
.pf-new-theme .border-top-transparent-important-hover:hover {
  border-top: 1px solid transparent !important;
}
.pf-new-theme .border-right-transparent {
  border-right: 1px solid transparent;
}
.pf-new-theme .border-right-transparent-important {
  border-right: 1px solid transparent !important;
}
.pf-new-theme .border-right-transparent-hover:hover {
  border-right: 1px solid transparent;
}
.pf-new-theme .border-right-transparent-important-hover:hover {
  border-right: 1px solid transparent !important;
}
.pf-new-theme .border-bottom-transparent {
  border-bottom: 1px solid transparent;
}
.pf-new-theme .border-bottom-transparent-important {
  border-bottom: 1px solid transparent !important;
}
.pf-new-theme .border-bottom-transparent-hover:hover {
  border-bottom: 1px solid transparent;
}
.pf-new-theme .border-bottom-transparent-important-hover:hover {
  border-bottom: 1px solid transparent !important;
}
.pf-new-theme .border-left-transparent {
  border-left: 1px solid transparent;
}
.pf-new-theme .border-left-transparent-important {
  border-left: 1px solid transparent !important;
}
.pf-new-theme .border-left-transparent-hover:hover {
  border-left: 1px solid transparent;
}
.pf-new-theme .border-left-transparent-important-hover:hover {
  border-left: 1px solid transparent !important;
}
.pf-new-theme .border-color-transparent {
  border-color:  transparent;
}
.pf-new-theme .border-color-transparent-important {
  border-color:  transparent !important;
}
.pf-new-theme .border-color-transparent-hover:hover {
  border-color:  transparent;
}
.pf-new-theme .border-color-transparent-important-hover:hover {
  border-color:  transparent !important;
}
.pf-new-theme .color-malachite {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-hover:hover {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-hover:hover {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-hover.active-hover {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-hover.active-hover {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-hover:focus {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-hover:focus {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-hover.active-focus {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-hover.active-focus {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-focus:focus {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-focus:focus {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-focus.active-focus {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-focus.active-focus {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-placeholder::placeholder {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-placeholder::placeholder {
  color:  #13ce66 !important;
}
.pf-new-theme .color-malachite-placeholder.active-placeholder {
  color:  #13ce66;
}
.pf-new-theme .color-malachite-important-placeholder.active-placeholder {
  color:  #13ce66 !important;
}
.pf-new-theme .color-hover-parent:hover .color-malachite-hover {
  color:  #13ce66;
}
.pf-new-theme .color-hover-parent:hover .color-malachite-important-hover {
  color:  #13ce66 !important;
}
.pf-new-theme .background-malachite {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important {
  background:  #13ce66 !important;
}
.pf-new-theme .background-malachite-hover:hover {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important-hover:hover {
  background:  #13ce66 !important;
}
.pf-new-theme .background-malachite-hover.active-hover {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important-hover.active-hover {
  background:  #13ce66 !important;
}
.pf-new-theme .background-malachite-hover:focus {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important-hover:focus {
  background:  #13ce66 !important;
}
.pf-new-theme .background-malachite-hover.active-focus {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important-hover.active-focus {
  background:  #13ce66 !important;
}
.pf-new-theme .background-malachite-focus:focus {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important-focus:focus {
  background:  #13ce66 !important;
}
.pf-new-theme .background-malachite-focus.active-focus {
  background:  #13ce66;
}
.pf-new-theme .background-malachite-important-focus.active-focus {
  background:  #13ce66 !important;
}
.pf-new-theme .border-malachite {
  border: 1px solid #13ce66;
}
.pf-new-theme .border-malachite-important {
  border: 1px solid #13ce66 !important;
}
.pf-new-theme .border-malachite-hover:hover {
  border: 1px solid #13ce66;
}
.pf-new-theme .border-malachite-important-hover:hover {
  border: 1px solid #13ce66 !important;
}
.pf-new-theme .border-malachite-focus:focus {
  border: 1px solid #13ce66;
}
.pf-new-theme .border-malachite-important-focus:focus {
  border: 1px solid #13ce66 !important;
}
.pf-new-theme .border-top-malachite {
  border-top: 1px solid #13ce66;
}
.pf-new-theme .border-top-malachite-important {
  border-top: 1px solid #13ce66 !important;
}
.pf-new-theme .border-top-malachite-hover:hover {
  border-top: 1px solid #13ce66;
}
.pf-new-theme .border-top-malachite-important-hover:hover {
  border-top: 1px solid #13ce66 !important;
}
.pf-new-theme .border-right-malachite {
  border-right: 1px solid #13ce66;
}
.pf-new-theme .border-right-malachite-important {
  border-right: 1px solid #13ce66 !important;
}
.pf-new-theme .border-right-malachite-hover:hover {
  border-right: 1px solid #13ce66;
}
.pf-new-theme .border-right-malachite-important-hover:hover {
  border-right: 1px solid #13ce66 !important;
}
.pf-new-theme .border-bottom-malachite {
  border-bottom: 1px solid #13ce66;
}
.pf-new-theme .border-bottom-malachite-important {
  border-bottom: 1px solid #13ce66 !important;
}
.pf-new-theme .border-bottom-malachite-hover:hover {
  border-bottom: 1px solid #13ce66;
}
.pf-new-theme .border-bottom-malachite-important-hover:hover {
  border-bottom: 1px solid #13ce66 !important;
}
.pf-new-theme .border-left-malachite {
  border-left: 1px solid #13ce66;
}
.pf-new-theme .border-left-malachite-important {
  border-left: 1px solid #13ce66 !important;
}
.pf-new-theme .border-left-malachite-hover:hover {
  border-left: 1px solid #13ce66;
}
.pf-new-theme .border-left-malachite-important-hover:hover {
  border-left: 1px solid #13ce66 !important;
}
.pf-new-theme .border-color-malachite {
  border-color:  #13ce66;
}
.pf-new-theme .border-color-malachite-important {
  border-color:  #13ce66 !important;
}
.pf-new-theme .border-color-malachite-hover:hover {
  border-color:  #13ce66;
}
.pf-new-theme .border-color-malachite-important-hover:hover {
  border-color:  #13ce66 !important;
}
.pf-new-theme .color-guest {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-hover:hover {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-hover:hover {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-hover.active-hover {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-hover.active-hover {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-hover:focus {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-hover:focus {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-hover.active-focus {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-hover.active-focus {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-focus:focus {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-focus:focus {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-focus.active-focus {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-focus.active-focus {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-placeholder::placeholder {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-placeholder::placeholder {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-guest-placeholder.active-placeholder {
  color:  #e5fcf1;
}
.pf-new-theme .color-guest-important-placeholder.active-placeholder {
  color:  #e5fcf1 !important;
}
.pf-new-theme .color-hover-parent:hover .color-guest-hover {
  color:  #e5fcf1;
}
.pf-new-theme .color-hover-parent:hover .color-guest-important-hover {
  color:  #e5fcf1 !important;
}
.pf-new-theme .background-guest {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important {
  background:  #e5fcf1 !important;
}
.pf-new-theme .background-guest-hover:hover {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important-hover:hover {
  background:  #e5fcf1 !important;
}
.pf-new-theme .background-guest-hover.active-hover {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important-hover.active-hover {
  background:  #e5fcf1 !important;
}
.pf-new-theme .background-guest-hover:focus {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important-hover:focus {
  background:  #e5fcf1 !important;
}
.pf-new-theme .background-guest-hover.active-focus {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important-hover.active-focus {
  background:  #e5fcf1 !important;
}
.pf-new-theme .background-guest-focus:focus {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important-focus:focus {
  background:  #e5fcf1 !important;
}
.pf-new-theme .background-guest-focus.active-focus {
  background:  #e5fcf1;
}
.pf-new-theme .background-guest-important-focus.active-focus {
  background:  #e5fcf1 !important;
}
.pf-new-theme .border-guest {
  border: 1px solid #e5fcf1;
}
.pf-new-theme .border-guest-important {
  border: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-guest-hover:hover {
  border: 1px solid #e5fcf1;
}
.pf-new-theme .border-guest-important-hover:hover {
  border: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-guest-focus:focus {
  border: 1px solid #e5fcf1;
}
.pf-new-theme .border-guest-important-focus:focus {
  border: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-top-guest {
  border-top: 1px solid #e5fcf1;
}
.pf-new-theme .border-top-guest-important {
  border-top: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-top-guest-hover:hover {
  border-top: 1px solid #e5fcf1;
}
.pf-new-theme .border-top-guest-important-hover:hover {
  border-top: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-right-guest {
  border-right: 1px solid #e5fcf1;
}
.pf-new-theme .border-right-guest-important {
  border-right: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-right-guest-hover:hover {
  border-right: 1px solid #e5fcf1;
}
.pf-new-theme .border-right-guest-important-hover:hover {
  border-right: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-bottom-guest {
  border-bottom: 1px solid #e5fcf1;
}
.pf-new-theme .border-bottom-guest-important {
  border-bottom: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-bottom-guest-hover:hover {
  border-bottom: 1px solid #e5fcf1;
}
.pf-new-theme .border-bottom-guest-important-hover:hover {
  border-bottom: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-left-guest {
  border-left: 1px solid #e5fcf1;
}
.pf-new-theme .border-left-guest-important {
  border-left: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-left-guest-hover:hover {
  border-left: 1px solid #e5fcf1;
}
.pf-new-theme .border-left-guest-important-hover:hover {
  border-left: 1px solid #e5fcf1 !important;
}
.pf-new-theme .border-color-guest {
  border-color:  #e5fcf1;
}
.pf-new-theme .border-color-guest-important {
  border-color:  #e5fcf1 !important;
}
.pf-new-theme .border-color-guest-hover:hover {
  border-color:  #e5fcf1;
}
.pf-new-theme .border-color-guest-important-hover:hover {
  border-color:  #e5fcf1 !important;
}
.pf-new-theme .color-purple-dark {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-hover:hover {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-hover:hover {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-hover.active-hover {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-hover.active-hover {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-hover:focus {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-hover:focus {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-hover.active-focus {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-hover.active-focus {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-focus:focus {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-focus:focus {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-focus.active-focus {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-focus.active-focus {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-placeholder::placeholder {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-placeholder::placeholder {
  color:  #381581 !important;
}
.pf-new-theme .color-purple-dark-placeholder.active-placeholder {
  color:  #381581;
}
.pf-new-theme .color-purple-dark-important-placeholder.active-placeholder {
  color:  #381581 !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-dark-hover {
  color:  #381581;
}
.pf-new-theme .color-hover-parent:hover .color-purple-dark-important-hover {
  color:  #381581 !important;
}
.pf-new-theme .background-purple-dark {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important {
  background:  #381581 !important;
}
.pf-new-theme .background-purple-dark-hover:hover {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important-hover:hover {
  background:  #381581 !important;
}
.pf-new-theme .background-purple-dark-hover.active-hover {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important-hover.active-hover {
  background:  #381581 !important;
}
.pf-new-theme .background-purple-dark-hover:focus {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important-hover:focus {
  background:  #381581 !important;
}
.pf-new-theme .background-purple-dark-hover.active-focus {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important-hover.active-focus {
  background:  #381581 !important;
}
.pf-new-theme .background-purple-dark-focus:focus {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important-focus:focus {
  background:  #381581 !important;
}
.pf-new-theme .background-purple-dark-focus.active-focus {
  background:  #381581;
}
.pf-new-theme .background-purple-dark-important-focus.active-focus {
  background:  #381581 !important;
}
.pf-new-theme .border-purple-dark {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-important {
  border: 1px solid #381581 !important;
}
.pf-new-theme .border-purple-dark-hover:hover {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-important-hover:hover {
  border: 1px solid #381581 !important;
}
.pf-new-theme .border-purple-dark-focus:focus {
  border: 1px solid #381581;
}
.pf-new-theme .border-purple-dark-important-focus:focus {
  border: 1px solid #381581 !important;
}
.pf-new-theme .border-top-purple-dark {
  border-top: 1px solid #381581;
}
.pf-new-theme .border-top-purple-dark-important {
  border-top: 1px solid #381581 !important;
}
.pf-new-theme .border-top-purple-dark-hover:hover {
  border-top: 1px solid #381581;
}
.pf-new-theme .border-top-purple-dark-important-hover:hover {
  border-top: 1px solid #381581 !important;
}
.pf-new-theme .border-right-purple-dark {
  border-right: 1px solid #381581;
}
.pf-new-theme .border-right-purple-dark-important {
  border-right: 1px solid #381581 !important;
}
.pf-new-theme .border-right-purple-dark-hover:hover {
  border-right: 1px solid #381581;
}
.pf-new-theme .border-right-purple-dark-important-hover:hover {
  border-right: 1px solid #381581 !important;
}
.pf-new-theme .border-bottom-purple-dark {
  border-bottom: 1px solid #381581;
}
.pf-new-theme .border-bottom-purple-dark-important {
  border-bottom: 1px solid #381581 !important;
}
.pf-new-theme .border-bottom-purple-dark-hover:hover {
  border-bottom: 1px solid #381581;
}
.pf-new-theme .border-bottom-purple-dark-important-hover:hover {
  border-bottom: 1px solid #381581 !important;
}
.pf-new-theme .border-left-purple-dark {
  border-left: 1px solid #381581;
}
.pf-new-theme .border-left-purple-dark-important {
  border-left: 1px solid #381581 !important;
}
.pf-new-theme .border-left-purple-dark-hover:hover {
  border-left: 1px solid #381581;
}
.pf-new-theme .border-left-purple-dark-important-hover:hover {
  border-left: 1px solid #381581 !important;
}
.pf-new-theme .border-color-purple-dark {
  border-color:  #381581;
}
.pf-new-theme .border-color-purple-dark-important {
  border-color:  #381581 !important;
}
.pf-new-theme .border-color-purple-dark-hover:hover {
  border-color:  #381581;
}
.pf-new-theme .border-color-purple-dark-important-hover:hover {
  border-color:  #381581 !important;
}
.pf-new-theme .color-grey-10 {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9 {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8 {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7 {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6 {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5 {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4 {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3 {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2 {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1 {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-hover:hover {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-hover:hover {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-hover:hover {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-hover:hover {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-hover:hover {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-hover:hover {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-hover:hover {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-hover:hover {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-hover:hover {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-hover:hover {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-hover:hover {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-hover:hover {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-hover:hover {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-hover:hover {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-hover:hover {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-hover:hover {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-hover:hover {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-hover:hover {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-hover:hover {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-hover:hover {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-hover.active-hover {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-hover.active-hover {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-hover.active-hover {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-hover.active-hover {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-hover.active-hover {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-hover.active-hover {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-hover.active-hover {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-hover.active-hover {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-hover.active-hover {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-hover.active-hover {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-hover.active-hover {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-hover.active-hover {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-hover.active-hover {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-hover.active-hover {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-hover.active-hover {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-hover.active-hover {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-hover.active-hover {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-hover.active-hover {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-hover.active-hover {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-hover.active-hover {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-hover:focus {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-hover:focus {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-hover:focus {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-hover:focus {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-hover:focus {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-hover:focus {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-hover:focus {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-hover:focus {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-hover:focus {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-hover:focus {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-hover:focus {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-hover:focus {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-hover:focus {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-hover:focus {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-hover:focus {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-hover:focus {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-hover:focus {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-hover:focus {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-hover:focus {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-hover:focus {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-hover.active-focus {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-hover.active-focus {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-hover.active-focus {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-hover.active-focus {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-hover.active-focus {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-hover.active-focus {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-hover.active-focus {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-hover.active-focus {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-hover.active-focus {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-hover.active-focus {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-hover.active-focus {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-hover.active-focus {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-hover.active-focus {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-hover.active-focus {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-hover.active-focus {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-hover.active-focus {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-hover.active-focus {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-hover.active-focus {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-hover.active-focus {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-hover.active-focus {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-focus:focus {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-focus:focus {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-focus:focus {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-focus:focus {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-focus:focus {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-focus:focus {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-focus:focus {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-focus:focus {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-focus:focus {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-focus:focus {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-focus:focus {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-focus:focus {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-focus:focus {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-focus:focus {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-focus:focus {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-focus:focus {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-focus:focus {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-focus:focus {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-focus:focus {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-focus:focus {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-focus.active-focus {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-focus.active-focus {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-focus.active-focus {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-focus.active-focus {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-focus.active-focus {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-focus.active-focus {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-focus.active-focus {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-focus.active-focus {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-focus.active-focus {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-focus.active-focus {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-focus.active-focus {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-focus.active-focus {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-focus.active-focus {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-focus.active-focus {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-focus.active-focus {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-focus.active-focus {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-focus.active-focus {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-focus.active-focus {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-focus.active-focus {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-focus.active-focus {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-placeholder::placeholder {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-placeholder::placeholder {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-placeholder::placeholder {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-placeholder::placeholder {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-placeholder::placeholder {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-placeholder::placeholder {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-placeholder::placeholder {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-placeholder::placeholder {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-placeholder::placeholder {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-placeholder::placeholder {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-placeholder::placeholder {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-placeholder::placeholder {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-placeholder::placeholder {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-placeholder::placeholder {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-placeholder::placeholder {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-placeholder::placeholder {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-placeholder::placeholder {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-placeholder::placeholder {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-placeholder::placeholder {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-placeholder::placeholder {
  color:  #ffffff !important;
}
.pf-new-theme .color-grey-10-placeholder.active-placeholder {
  color:  #323945;
}
.pf-new-theme .color-grey-10-important-placeholder.active-placeholder {
  color:  #323945 !important;
}
.pf-new-theme .color-grey-9-placeholder.active-placeholder {
  color:  #5c6776;
}
.pf-new-theme .color-grey-9-important-placeholder.active-placeholder {
  color:  #5c6776 !important;
}
.pf-new-theme .color-grey-8-placeholder.active-placeholder {
  color:  #8f98a9;
}
.pf-new-theme .color-grey-8-important-placeholder.active-placeholder {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-grey-7-placeholder.active-placeholder {
  color:  #bfc8d5;
}
.pf-new-theme .color-grey-7-important-placeholder.active-placeholder {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-grey-6-placeholder.active-placeholder {
  color:  #e0e6ed;
}
.pf-new-theme .color-grey-6-important-placeholder.active-placeholder {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-grey-5-placeholder.active-placeholder {
  color:  #e7ebef;
}
.pf-new-theme .color-grey-5-important-placeholder.active-placeholder {
  color:  #e7ebef !important;
}
.pf-new-theme .color-grey-4-placeholder.active-placeholder {
  color:  #f3f6fb;
}
.pf-new-theme .color-grey-4-important-placeholder.active-placeholder {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-grey-3-placeholder.active-placeholder {
  color:  #f9fafc;
}
.pf-new-theme .color-grey-3-important-placeholder.active-placeholder {
  color:  #f9fafc !important;
}
.pf-new-theme .color-grey-2-placeholder.active-placeholder {
  color:  #fafafa;
}
.pf-new-theme .color-grey-2-important-placeholder.active-placeholder {
  color:  #fafafa !important;
}
.pf-new-theme .color-grey-1-placeholder.active-placeholder {
  color:  #ffffff;
}
.pf-new-theme .color-grey-1-important-placeholder.active-placeholder {
  color:  #ffffff !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-10-hover {
  color:  #323945;
}
.pf-new-theme .color-hover-parent:hover .color-grey-10-important-hover {
  color:  #323945 !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-9-hover {
  color:  #5c6776;
}
.pf-new-theme .color-hover-parent:hover .color-grey-9-important-hover {
  color:  #5c6776 !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-8-hover {
  color:  #8f98a9;
}
.pf-new-theme .color-hover-parent:hover .color-grey-8-important-hover {
  color:  #8f98a9 !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-7-hover {
  color:  #bfc8d5;
}
.pf-new-theme .color-hover-parent:hover .color-grey-7-important-hover {
  color:  #bfc8d5 !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-6-hover {
  color:  #e0e6ed;
}
.pf-new-theme .color-hover-parent:hover .color-grey-6-important-hover {
  color:  #e0e6ed !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-5-hover {
  color:  #e7ebef;
}
.pf-new-theme .color-hover-parent:hover .color-grey-5-important-hover {
  color:  #e7ebef !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-4-hover {
  color:  #f3f6fb;
}
.pf-new-theme .color-hover-parent:hover .color-grey-4-important-hover {
  color:  #f3f6fb !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-3-hover {
  color:  #f9fafc;
}
.pf-new-theme .color-hover-parent:hover .color-grey-3-important-hover {
  color:  #f9fafc !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-2-hover {
  color:  #fafafa;
}
.pf-new-theme .color-hover-parent:hover .color-grey-2-important-hover {
  color:  #fafafa !important;
}
.pf-new-theme .color-hover-parent:hover .color-grey-1-hover {
  color:  #ffffff;
}
.pf-new-theme .color-hover-parent:hover .color-grey-1-important-hover {
  color:  #ffffff !important;
}
.pf-new-theme .background-grey-10 {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9 {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8 {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7 {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6 {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5 {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4 {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3 {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2 {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1 {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important {
  background:  #ffffff !important;
}
.pf-new-theme .background-grey-10-hover:hover {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important-hover:hover {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9-hover:hover {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important-hover:hover {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8-hover:hover {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important-hover:hover {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7-hover:hover {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important-hover:hover {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6-hover:hover {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important-hover:hover {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5-hover:hover {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important-hover:hover {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4-hover:hover {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important-hover:hover {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3-hover:hover {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important-hover:hover {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2-hover:hover {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important-hover:hover {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1-hover:hover {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important-hover:hover {
  background:  #ffffff !important;
}
.pf-new-theme .background-grey-10-hover.active-hover {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important-hover.active-hover {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9-hover.active-hover {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important-hover.active-hover {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8-hover.active-hover {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important-hover.active-hover {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7-hover.active-hover {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important-hover.active-hover {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6-hover.active-hover {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important-hover.active-hover {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5-hover.active-hover {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important-hover.active-hover {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4-hover.active-hover {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important-hover.active-hover {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3-hover.active-hover {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important-hover.active-hover {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2-hover.active-hover {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important-hover.active-hover {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1-hover.active-hover {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important-hover.active-hover {
  background:  #ffffff !important;
}
.pf-new-theme .background-grey-10-hover:focus {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important-hover:focus {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9-hover:focus {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important-hover:focus {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8-hover:focus {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important-hover:focus {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7-hover:focus {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important-hover:focus {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6-hover:focus {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important-hover:focus {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5-hover:focus {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important-hover:focus {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4-hover:focus {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important-hover:focus {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3-hover:focus {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important-hover:focus {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2-hover:focus {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important-hover:focus {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1-hover:focus {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important-hover:focus {
  background:  #ffffff !important;
}
.pf-new-theme .background-grey-10-hover.active-focus {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important-hover.active-focus {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9-hover.active-focus {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important-hover.active-focus {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8-hover.active-focus {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important-hover.active-focus {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7-hover.active-focus {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important-hover.active-focus {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6-hover.active-focus {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important-hover.active-focus {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5-hover.active-focus {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important-hover.active-focus {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4-hover.active-focus {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important-hover.active-focus {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3-hover.active-focus {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important-hover.active-focus {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2-hover.active-focus {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important-hover.active-focus {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1-hover.active-focus {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important-hover.active-focus {
  background:  #ffffff !important;
}
.pf-new-theme .background-grey-10-focus:focus {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important-focus:focus {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9-focus:focus {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important-focus:focus {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8-focus:focus {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important-focus:focus {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7-focus:focus {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important-focus:focus {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6-focus:focus {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important-focus:focus {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5-focus:focus {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important-focus:focus {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4-focus:focus {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important-focus:focus {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3-focus:focus {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important-focus:focus {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2-focus:focus {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important-focus:focus {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1-focus:focus {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important-focus:focus {
  background:  #ffffff !important;
}
.pf-new-theme .background-grey-10-focus.active-focus {
  background:  #323945;
}
.pf-new-theme .background-grey-10-important-focus.active-focus {
  background:  #323945 !important;
}
.pf-new-theme .background-grey-9-focus.active-focus {
  background:  #5c6776;
}
.pf-new-theme .background-grey-9-important-focus.active-focus {
  background:  #5c6776 !important;
}
.pf-new-theme .background-grey-8-focus.active-focus {
  background:  #8f98a9;
}
.pf-new-theme .background-grey-8-important-focus.active-focus {
  background:  #8f98a9 !important;
}
.pf-new-theme .background-grey-7-focus.active-focus {
  background:  #bfc8d5;
}
.pf-new-theme .background-grey-7-important-focus.active-focus {
  background:  #bfc8d5 !important;
}
.pf-new-theme .background-grey-6-focus.active-focus {
  background:  #e0e6ed;
}
.pf-new-theme .background-grey-6-important-focus.active-focus {
  background:  #e0e6ed !important;
}
.pf-new-theme .background-grey-5-focus.active-focus {
  background:  #e7ebef;
}
.pf-new-theme .background-grey-5-important-focus.active-focus {
  background:  #e7ebef !important;
}
.pf-new-theme .background-grey-4-focus.active-focus {
  background:  #f3f6fb;
}
.pf-new-theme .background-grey-4-important-focus.active-focus {
  background:  #f3f6fb !important;
}
.pf-new-theme .background-grey-3-focus.active-focus {
  background:  #f9fafc;
}
.pf-new-theme .background-grey-3-important-focus.active-focus {
  background:  #f9fafc !important;
}
.pf-new-theme .background-grey-2-focus.active-focus {
  background:  #fafafa;
}
.pf-new-theme .background-grey-2-important-focus.active-focus {
  background:  #fafafa !important;
}
.pf-new-theme .background-grey-1-focus.active-focus {
  background:  #ffffff;
}
.pf-new-theme .background-grey-1-important-focus.active-focus {
  background:  #ffffff !important;
}
.pf-new-theme .border-grey-10 {
  border: 1px solid #323945;
}
.pf-new-theme .border-grey-10-important {
  border: 1px solid #323945 !important;
}
.pf-new-theme .border-grey-9 {
  border: 1px solid #5c6776;
}
.pf-new-theme .border-grey-9-important {
  border: 1px solid #5c6776 !important;
}
.pf-new-theme .border-grey-8 {
  border: 1px solid #8f98a9;
}
.pf-new-theme .border-grey-8-important {
  border: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-grey-7 {
  border: 1px solid #bfc8d5;
}
.pf-new-theme .border-grey-7-important {
  border: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-grey-6 {
  border: 1px solid #e0e6ed;
}
.pf-new-theme .border-grey-6-important {
  border: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-grey-5 {
  border: 1px solid #e7ebef;
}
.pf-new-theme .border-grey-5-important {
  border: 1px solid #e7ebef !important;
}
.pf-new-theme .border-grey-4 {
  border: 1px solid #f3f6fb;
}
.pf-new-theme .border-grey-4-important {
  border: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-grey-3 {
  border: 1px solid #f9fafc;
}
.pf-new-theme .border-grey-3-important {
  border: 1px solid #f9fafc !important;
}
.pf-new-theme .border-grey-2 {
  border: 1px solid #fafafa;
}
.pf-new-theme .border-grey-2-important {
  border: 1px solid #fafafa !important;
}
.pf-new-theme .border-grey-1 {
  border: 1px solid #ffffff;
}
.pf-new-theme .border-grey-1-important {
  border: 1px solid #ffffff !important;
}
.pf-new-theme .border-grey-10-hover:hover {
  border: 1px solid #323945;
}
.pf-new-theme .border-grey-10-important-hover:hover {
  border: 1px solid #323945 !important;
}
.pf-new-theme .border-grey-9-hover:hover {
  border: 1px solid #5c6776;
}
.pf-new-theme .border-grey-9-important-hover:hover {
  border: 1px solid #5c6776 !important;
}
.pf-new-theme .border-grey-8-hover:hover {
  border: 1px solid #8f98a9;
}
.pf-new-theme .border-grey-8-important-hover:hover {
  border: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-grey-7-hover:hover {
  border: 1px solid #bfc8d5;
}
.pf-new-theme .border-grey-7-important-hover:hover {
  border: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-grey-6-hover:hover {
  border: 1px solid #e0e6ed;
}
.pf-new-theme .border-grey-6-important-hover:hover {
  border: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-grey-5-hover:hover {
  border: 1px solid #e7ebef;
}
.pf-new-theme .border-grey-5-important-hover:hover {
  border: 1px solid #e7ebef !important;
}
.pf-new-theme .border-grey-4-hover:hover {
  border: 1px solid #f3f6fb;
}
.pf-new-theme .border-grey-4-important-hover:hover {
  border: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-grey-3-hover:hover {
  border: 1px solid #f9fafc;
}
.pf-new-theme .border-grey-3-important-hover:hover {
  border: 1px solid #f9fafc !important;
}
.pf-new-theme .border-grey-2-hover:hover {
  border: 1px solid #fafafa;
}
.pf-new-theme .border-grey-2-important-hover:hover {
  border: 1px solid #fafafa !important;
}
.pf-new-theme .border-grey-1-hover:hover {
  border: 1px solid #ffffff;
}
.pf-new-theme .border-grey-1-important-hover:hover {
  border: 1px solid #ffffff !important;
}
.pf-new-theme .border-grey-10-focus:focus {
  border: 1px solid #323945;
}
.pf-new-theme .border-grey-10-important-focus:focus {
  border: 1px solid #323945 !important;
}
.pf-new-theme .border-grey-9-focus:focus {
  border: 1px solid #5c6776;
}
.pf-new-theme .border-grey-9-important-focus:focus {
  border: 1px solid #5c6776 !important;
}
.pf-new-theme .border-grey-8-focus:focus {
  border: 1px solid #8f98a9;
}
.pf-new-theme .border-grey-8-important-focus:focus {
  border: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-grey-7-focus:focus {
  border: 1px solid #bfc8d5;
}
.pf-new-theme .border-grey-7-important-focus:focus {
  border: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-grey-6-focus:focus {
  border: 1px solid #e0e6ed;
}
.pf-new-theme .border-grey-6-important-focus:focus {
  border: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-grey-5-focus:focus {
  border: 1px solid #e7ebef;
}
.pf-new-theme .border-grey-5-important-focus:focus {
  border: 1px solid #e7ebef !important;
}
.pf-new-theme .border-grey-4-focus:focus {
  border: 1px solid #f3f6fb;
}
.pf-new-theme .border-grey-4-important-focus:focus {
  border: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-grey-3-focus:focus {
  border: 1px solid #f9fafc;
}
.pf-new-theme .border-grey-3-important-focus:focus {
  border: 1px solid #f9fafc !important;
}
.pf-new-theme .border-grey-2-focus:focus {
  border: 1px solid #fafafa;
}
.pf-new-theme .border-grey-2-important-focus:focus {
  border: 1px solid #fafafa !important;
}
.pf-new-theme .border-grey-1-focus:focus {
  border: 1px solid #ffffff;
}
.pf-new-theme .border-grey-1-important-focus:focus {
  border: 1px solid #ffffff !important;
}
.pf-new-theme .border-top-grey-10 {
  border-top: 1px solid #323945;
}
.pf-new-theme .border-top-grey-10-important {
  border-top: 1px solid #323945 !important;
}
.pf-new-theme .border-top-grey-9 {
  border-top: 1px solid #5c6776;
}
.pf-new-theme .border-top-grey-9-important {
  border-top: 1px solid #5c6776 !important;
}
.pf-new-theme .border-top-grey-8 {
  border-top: 1px solid #8f98a9;
}
.pf-new-theme .border-top-grey-8-important {
  border-top: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-top-grey-7 {
  border-top: 1px solid #bfc8d5;
}
.pf-new-theme .border-top-grey-7-important {
  border-top: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-top-grey-6 {
  border-top: 1px solid #e0e6ed;
}
.pf-new-theme .border-top-grey-6-important {
  border-top: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-top-grey-5 {
  border-top: 1px solid #e7ebef;
}
.pf-new-theme .border-top-grey-5-important {
  border-top: 1px solid #e7ebef !important;
}
.pf-new-theme .border-top-grey-4 {
  border-top: 1px solid #f3f6fb;
}
.pf-new-theme .border-top-grey-4-important {
  border-top: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-top-grey-3 {
  border-top: 1px solid #f9fafc;
}
.pf-new-theme .border-top-grey-3-important {
  border-top: 1px solid #f9fafc !important;
}
.pf-new-theme .border-top-grey-2 {
  border-top: 1px solid #fafafa;
}
.pf-new-theme .border-top-grey-2-important {
  border-top: 1px solid #fafafa !important;
}
.pf-new-theme .border-top-grey-1 {
  border-top: 1px solid #ffffff;
}
.pf-new-theme .border-top-grey-1-important {
  border-top: 1px solid #ffffff !important;
}
.pf-new-theme .border-top-grey-10-hover:hover {
  border-top: 1px solid #323945;
}
.pf-new-theme .border-top-grey-10-important-hover:hover {
  border-top: 1px solid #323945 !important;
}
.pf-new-theme .border-top-grey-9-hover:hover {
  border-top: 1px solid #5c6776;
}
.pf-new-theme .border-top-grey-9-important-hover:hover {
  border-top: 1px solid #5c6776 !important;
}
.pf-new-theme .border-top-grey-8-hover:hover {
  border-top: 1px solid #8f98a9;
}
.pf-new-theme .border-top-grey-8-important-hover:hover {
  border-top: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-top-grey-7-hover:hover {
  border-top: 1px solid #bfc8d5;
}
.pf-new-theme .border-top-grey-7-important-hover:hover {
  border-top: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-top-grey-6-hover:hover {
  border-top: 1px solid #e0e6ed;
}
.pf-new-theme .border-top-grey-6-important-hover:hover {
  border-top: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-top-grey-5-hover:hover {
  border-top: 1px solid #e7ebef;
}
.pf-new-theme .border-top-grey-5-important-hover:hover {
  border-top: 1px solid #e7ebef !important;
}
.pf-new-theme .border-top-grey-4-hover:hover {
  border-top: 1px solid #f3f6fb;
}
.pf-new-theme .border-top-grey-4-important-hover:hover {
  border-top: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-top-grey-3-hover:hover {
  border-top: 1px solid #f9fafc;
}
.pf-new-theme .border-top-grey-3-important-hover:hover {
  border-top: 1px solid #f9fafc !important;
}
.pf-new-theme .border-top-grey-2-hover:hover {
  border-top: 1px solid #fafafa;
}
.pf-new-theme .border-top-grey-2-important-hover:hover {
  border-top: 1px solid #fafafa !important;
}
.pf-new-theme .border-top-grey-1-hover:hover {
  border-top: 1px solid #ffffff;
}
.pf-new-theme .border-top-grey-1-important-hover:hover {
  border-top: 1px solid #ffffff !important;
}
.pf-new-theme .border-right-grey-10 {
  border-right: 1px solid #323945;
}
.pf-new-theme .border-right-grey-10-important {
  border-right: 1px solid #323945 !important;
}
.pf-new-theme .border-right-grey-9 {
  border-right: 1px solid #5c6776;
}
.pf-new-theme .border-right-grey-9-important {
  border-right: 1px solid #5c6776 !important;
}
.pf-new-theme .border-right-grey-8 {
  border-right: 1px solid #8f98a9;
}
.pf-new-theme .border-right-grey-8-important {
  border-right: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-right-grey-7 {
  border-right: 1px solid #bfc8d5;
}
.pf-new-theme .border-right-grey-7-important {
  border-right: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-right-grey-6 {
  border-right: 1px solid #e0e6ed;
}
.pf-new-theme .border-right-grey-6-important {
  border-right: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-right-grey-5 {
  border-right: 1px solid #e7ebef;
}
.pf-new-theme .border-right-grey-5-important {
  border-right: 1px solid #e7ebef !important;
}
.pf-new-theme .border-right-grey-4 {
  border-right: 1px solid #f3f6fb;
}
.pf-new-theme .border-right-grey-4-important {
  border-right: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-right-grey-3 {
  border-right: 1px solid #f9fafc;
}
.pf-new-theme .border-right-grey-3-important {
  border-right: 1px solid #f9fafc !important;
}
.pf-new-theme .border-right-grey-2 {
  border-right: 1px solid #fafafa;
}
.pf-new-theme .border-right-grey-2-important {
  border-right: 1px solid #fafafa !important;
}
.pf-new-theme .border-right-grey-1 {
  border-right: 1px solid #ffffff;
}
.pf-new-theme .border-right-grey-1-important {
  border-right: 1px solid #ffffff !important;
}
.pf-new-theme .border-right-grey-10-hover:hover {
  border-right: 1px solid #323945;
}
.pf-new-theme .border-right-grey-10-important-hover:hover {
  border-right: 1px solid #323945 !important;
}
.pf-new-theme .border-right-grey-9-hover:hover {
  border-right: 1px solid #5c6776;
}
.pf-new-theme .border-right-grey-9-important-hover:hover {
  border-right: 1px solid #5c6776 !important;
}
.pf-new-theme .border-right-grey-8-hover:hover {
  border-right: 1px solid #8f98a9;
}
.pf-new-theme .border-right-grey-8-important-hover:hover {
  border-right: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-right-grey-7-hover:hover {
  border-right: 1px solid #bfc8d5;
}
.pf-new-theme .border-right-grey-7-important-hover:hover {
  border-right: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-right-grey-6-hover:hover {
  border-right: 1px solid #e0e6ed;
}
.pf-new-theme .border-right-grey-6-important-hover:hover {
  border-right: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-right-grey-5-hover:hover {
  border-right: 1px solid #e7ebef;
}
.pf-new-theme .border-right-grey-5-important-hover:hover {
  border-right: 1px solid #e7ebef !important;
}
.pf-new-theme .border-right-grey-4-hover:hover {
  border-right: 1px solid #f3f6fb;
}
.pf-new-theme .border-right-grey-4-important-hover:hover {
  border-right: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-right-grey-3-hover:hover {
  border-right: 1px solid #f9fafc;
}
.pf-new-theme .border-right-grey-3-important-hover:hover {
  border-right: 1px solid #f9fafc !important;
}
.pf-new-theme .border-right-grey-2-hover:hover {
  border-right: 1px solid #fafafa;
}
.pf-new-theme .border-right-grey-2-important-hover:hover {
  border-right: 1px solid #fafafa !important;
}
.pf-new-theme .border-right-grey-1-hover:hover {
  border-right: 1px solid #ffffff;
}
.pf-new-theme .border-right-grey-1-important-hover:hover {
  border-right: 1px solid #ffffff !important;
}
.pf-new-theme .border-bottom-grey-10 {
  border-bottom: 1px solid #323945;
}
.pf-new-theme .border-bottom-grey-10-important {
  border-bottom: 1px solid #323945 !important;
}
.pf-new-theme .border-bottom-grey-9 {
  border-bottom: 1px solid #5c6776;
}
.pf-new-theme .border-bottom-grey-9-important {
  border-bottom: 1px solid #5c6776 !important;
}
.pf-new-theme .border-bottom-grey-8 {
  border-bottom: 1px solid #8f98a9;
}
.pf-new-theme .border-bottom-grey-8-important {
  border-bottom: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-bottom-grey-7 {
  border-bottom: 1px solid #bfc8d5;
}
.pf-new-theme .border-bottom-grey-7-important {
  border-bottom: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-bottom-grey-6 {
  border-bottom: 1px solid #e0e6ed;
}
.pf-new-theme .border-bottom-grey-6-important {
  border-bottom: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-bottom-grey-5 {
  border-bottom: 1px solid #e7ebef;
}
.pf-new-theme .border-bottom-grey-5-important {
  border-bottom: 1px solid #e7ebef !important;
}
.pf-new-theme .border-bottom-grey-4 {
  border-bottom: 1px solid #f3f6fb;
}
.pf-new-theme .border-bottom-grey-4-important {
  border-bottom: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-bottom-grey-3 {
  border-bottom: 1px solid #f9fafc;
}
.pf-new-theme .border-bottom-grey-3-important {
  border-bottom: 1px solid #f9fafc !important;
}
.pf-new-theme .border-bottom-grey-2 {
  border-bottom: 1px solid #fafafa;
}
.pf-new-theme .border-bottom-grey-2-important {
  border-bottom: 1px solid #fafafa !important;
}
.pf-new-theme .border-bottom-grey-1 {
  border-bottom: 1px solid #ffffff;
}
.pf-new-theme .border-bottom-grey-1-important {
  border-bottom: 1px solid #ffffff !important;
}
.pf-new-theme .border-bottom-grey-10-hover:hover {
  border-bottom: 1px solid #323945;
}
.pf-new-theme .border-bottom-grey-10-important-hover:hover {
  border-bottom: 1px solid #323945 !important;
}
.pf-new-theme .border-bottom-grey-9-hover:hover {
  border-bottom: 1px solid #5c6776;
}
.pf-new-theme .border-bottom-grey-9-important-hover:hover {
  border-bottom: 1px solid #5c6776 !important;
}
.pf-new-theme .border-bottom-grey-8-hover:hover {
  border-bottom: 1px solid #8f98a9;
}
.pf-new-theme .border-bottom-grey-8-important-hover:hover {
  border-bottom: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-bottom-grey-7-hover:hover {
  border-bottom: 1px solid #bfc8d5;
}
.pf-new-theme .border-bottom-grey-7-important-hover:hover {
  border-bottom: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-bottom-grey-6-hover:hover {
  border-bottom: 1px solid #e0e6ed;
}
.pf-new-theme .border-bottom-grey-6-important-hover:hover {
  border-bottom: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-bottom-grey-5-hover:hover {
  border-bottom: 1px solid #e7ebef;
}
.pf-new-theme .border-bottom-grey-5-important-hover:hover {
  border-bottom: 1px solid #e7ebef !important;
}
.pf-new-theme .border-bottom-grey-4-hover:hover {
  border-bottom: 1px solid #f3f6fb;
}
.pf-new-theme .border-bottom-grey-4-important-hover:hover {
  border-bottom: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-bottom-grey-3-hover:hover {
  border-bottom: 1px solid #f9fafc;
}
.pf-new-theme .border-bottom-grey-3-important-hover:hover {
  border-bottom: 1px solid #f9fafc !important;
}
.pf-new-theme .border-bottom-grey-2-hover:hover {
  border-bottom: 1px solid #fafafa;
}
.pf-new-theme .border-bottom-grey-2-important-hover:hover {
  border-bottom: 1px solid #fafafa !important;
}
.pf-new-theme .border-bottom-grey-1-hover:hover {
  border-bottom: 1px solid #ffffff;
}
.pf-new-theme .border-bottom-grey-1-important-hover:hover {
  border-bottom: 1px solid #ffffff !important;
}
.pf-new-theme .border-left-grey-10 {
  border-left: 1px solid #323945;
}
.pf-new-theme .border-left-grey-10-important {
  border-left: 1px solid #323945 !important;
}
.pf-new-theme .border-left-grey-9 {
  border-left: 1px solid #5c6776;
}
.pf-new-theme .border-left-grey-9-important {
  border-left: 1px solid #5c6776 !important;
}
.pf-new-theme .border-left-grey-8 {
  border-left: 1px solid #8f98a9;
}
.pf-new-theme .border-left-grey-8-important {
  border-left: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-left-grey-7 {
  border-left: 1px solid #bfc8d5;
}
.pf-new-theme .border-left-grey-7-important {
  border-left: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-left-grey-6 {
  border-left: 1px solid #e0e6ed;
}
.pf-new-theme .border-left-grey-6-important {
  border-left: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-left-grey-5 {
  border-left: 1px solid #e7ebef;
}
.pf-new-theme .border-left-grey-5-important {
  border-left: 1px solid #e7ebef !important;
}
.pf-new-theme .border-left-grey-4 {
  border-left: 1px solid #f3f6fb;
}
.pf-new-theme .border-left-grey-4-important {
  border-left: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-left-grey-3 {
  border-left: 1px solid #f9fafc;
}
.pf-new-theme .border-left-grey-3-important {
  border-left: 1px solid #f9fafc !important;
}
.pf-new-theme .border-left-grey-2 {
  border-left: 1px solid #fafafa;
}
.pf-new-theme .border-left-grey-2-important {
  border-left: 1px solid #fafafa !important;
}
.pf-new-theme .border-left-grey-1 {
  border-left: 1px solid #ffffff;
}
.pf-new-theme .border-left-grey-1-important {
  border-left: 1px solid #ffffff !important;
}
.pf-new-theme .border-left-grey-10-hover:hover {
  border-left: 1px solid #323945;
}
.pf-new-theme .border-left-grey-10-important-hover:hover {
  border-left: 1px solid #323945 !important;
}
.pf-new-theme .border-left-grey-9-hover:hover {
  border-left: 1px solid #5c6776;
}
.pf-new-theme .border-left-grey-9-important-hover:hover {
  border-left: 1px solid #5c6776 !important;
}
.pf-new-theme .border-left-grey-8-hover:hover {
  border-left: 1px solid #8f98a9;
}
.pf-new-theme .border-left-grey-8-important-hover:hover {
  border-left: 1px solid #8f98a9 !important;
}
.pf-new-theme .border-left-grey-7-hover:hover {
  border-left: 1px solid #bfc8d5;
}
.pf-new-theme .border-left-grey-7-important-hover:hover {
  border-left: 1px solid #bfc8d5 !important;
}
.pf-new-theme .border-left-grey-6-hover:hover {
  border-left: 1px solid #e0e6ed;
}
.pf-new-theme .border-left-grey-6-important-hover:hover {
  border-left: 1px solid #e0e6ed !important;
}
.pf-new-theme .border-left-grey-5-hover:hover {
  border-left: 1px solid #e7ebef;
}
.pf-new-theme .border-left-grey-5-important-hover:hover {
  border-left: 1px solid #e7ebef !important;
}
.pf-new-theme .border-left-grey-4-hover:hover {
  border-left: 1px solid #f3f6fb;
}
.pf-new-theme .border-left-grey-4-important-hover:hover {
  border-left: 1px solid #f3f6fb !important;
}
.pf-new-theme .border-left-grey-3-hover:hover {
  border-left: 1px solid #f9fafc;
}
.pf-new-theme .border-left-grey-3-important-hover:hover {
  border-left: 1px solid #f9fafc !important;
}
.pf-new-theme .border-left-grey-2-hover:hover {
  border-left: 1px solid #fafafa;
}
.pf-new-theme .border-left-grey-2-important-hover:hover {
  border-left: 1px solid #fafafa !important;
}
.pf-new-theme .border-left-grey-1-hover:hover {
  border-left: 1px solid #ffffff;
}
.pf-new-theme .border-left-grey-1-important-hover:hover {
  border-left: 1px solid #ffffff !important;
}
.pf-new-theme .border-color-grey-10 {
  border-color:  #323945;
}
.pf-new-theme .border-color-grey-10-important {
  border-color:  #323945 !important;
}
.pf-new-theme .border-color-grey-9 {
  border-color:  #5c6776;
}
.pf-new-theme .border-color-grey-9-important {
  border-color:  #5c6776 !important;
}
.pf-new-theme .border-color-grey-8 {
  border-color:  #8f98a9;
}
.pf-new-theme .border-color-grey-8-important {
  border-color:  #8f98a9 !important;
}
.pf-new-theme .border-color-grey-7 {
  border-color:  #bfc8d5;
}
.pf-new-theme .border-color-grey-7-important {
  border-color:  #bfc8d5 !important;
}
.pf-new-theme .border-color-grey-6 {
  border-color:  #e0e6ed;
}
.pf-new-theme .border-color-grey-6-important {
  border-color:  #e0e6ed !important;
}
.pf-new-theme .border-color-grey-5 {
  border-color:  #e7ebef;
}
.pf-new-theme .border-color-grey-5-important {
  border-color:  #e7ebef !important;
}
.pf-new-theme .border-color-grey-4 {
  border-color:  #f3f6fb;
}
.pf-new-theme .border-color-grey-4-important {
  border-color:  #f3f6fb !important;
}
.pf-new-theme .border-color-grey-3 {
  border-color:  #f9fafc;
}
.pf-new-theme .border-color-grey-3-important {
  border-color:  #f9fafc !important;
}
.pf-new-theme .border-color-grey-2 {
  border-color:  #fafafa;
}
.pf-new-theme .border-color-grey-2-important {
  border-color:  #fafafa !important;
}
.pf-new-theme .border-color-grey-1 {
  border-color:  #ffffff;
}
.pf-new-theme .border-color-grey-1-important {
  border-color:  #ffffff !important;
}
.pf-new-theme .border-color-grey-10-hover:hover {
  border-color:  #323945;
}
.pf-new-theme .border-color-grey-10-important-hover:hover {
  border-color:  #323945 !important;
}
.pf-new-theme .border-color-grey-9-hover:hover {
  border-color:  #5c6776;
}
.pf-new-theme .border-color-grey-9-important-hover:hover {
  border-color:  #5c6776 !important;
}
.pf-new-theme .border-color-grey-8-hover:hover {
  border-color:  #8f98a9;
}
.pf-new-theme .border-color-grey-8-important-hover:hover {
  border-color:  #8f98a9 !important;
}
.pf-new-theme .border-color-grey-7-hover:hover {
  border-color:  #bfc8d5;
}
.pf-new-theme .border-color-grey-7-important-hover:hover {
  border-color:  #bfc8d5 !important;
}
.pf-new-theme .border-color-grey-6-hover:hover {
  border-color:  #e0e6ed;
}
.pf-new-theme .border-color-grey-6-important-hover:hover {
  border-color:  #e0e6ed !important;
}
.pf-new-theme .border-color-grey-5-hover:hover {
  border-color:  #e7ebef;
}
.pf-new-theme .border-color-grey-5-important-hover:hover {
  border-color:  #e7ebef !important;
}
.pf-new-theme .border-color-grey-4-hover:hover {
  border-color:  #f3f6fb;
}
.pf-new-theme .border-color-grey-4-important-hover:hover {
  border-color:  #f3f6fb !important;
}
.pf-new-theme .border-color-grey-3-hover:hover {
  border-color:  #f9fafc;
}
.pf-new-theme .border-color-grey-3-important-hover:hover {
  border-color:  #f9fafc !important;
}
.pf-new-theme .border-color-grey-2-hover:hover {
  border-color:  #fafafa;
}
.pf-new-theme .border-color-grey-2-important-hover:hover {
  border-color:  #fafafa !important;
}
.pf-new-theme .border-color-grey-1-hover:hover {
  border-color:  #ffffff;
}
.pf-new-theme .border-color-grey-1-important-hover:hover {
  border-color:  #ffffff !important;
}
.pf-new-theme .color-blue-10 {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9 {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8 {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7 {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6 {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5 {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4 {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3 {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2 {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1 {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-hover:hover {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-hover:hover {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-hover:hover {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-hover:hover {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-hover:hover {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-hover:hover {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-hover:hover {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-hover:hover {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-hover:hover {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-hover:hover {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-hover:hover {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-hover:hover {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-hover:hover {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-hover:hover {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-hover:hover {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-hover:hover {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-hover:hover {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-hover:hover {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-hover:hover {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-hover:hover {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-hover.active-hover {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-hover.active-hover {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-hover.active-hover {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-hover.active-hover {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-hover.active-hover {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-hover.active-hover {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-hover.active-hover {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-hover.active-hover {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-hover.active-hover {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-hover.active-hover {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-hover.active-hover {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-hover.active-hover {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-hover.active-hover {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-hover.active-hover {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-hover.active-hover {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-hover.active-hover {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-hover.active-hover {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-hover.active-hover {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-hover.active-hover {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-hover.active-hover {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-hover:focus {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-hover:focus {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-hover:focus {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-hover:focus {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-hover:focus {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-hover:focus {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-hover:focus {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-hover:focus {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-hover:focus {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-hover:focus {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-hover:focus {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-hover:focus {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-hover:focus {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-hover:focus {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-hover:focus {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-hover:focus {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-hover:focus {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-hover:focus {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-hover:focus {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-hover:focus {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-hover.active-focus {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-hover.active-focus {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-hover.active-focus {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-hover.active-focus {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-hover.active-focus {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-hover.active-focus {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-hover.active-focus {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-hover.active-focus {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-hover.active-focus {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-hover.active-focus {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-hover.active-focus {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-hover.active-focus {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-hover.active-focus {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-hover.active-focus {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-hover.active-focus {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-hover.active-focus {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-hover.active-focus {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-hover.active-focus {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-hover.active-focus {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-hover.active-focus {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-focus:focus {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-focus:focus {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-focus:focus {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-focus:focus {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-focus:focus {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-focus:focus {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-focus:focus {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-focus:focus {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-focus:focus {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-focus:focus {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-focus:focus {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-focus:focus {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-focus:focus {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-focus:focus {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-focus:focus {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-focus:focus {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-focus:focus {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-focus:focus {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-focus:focus {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-focus:focus {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-focus.active-focus {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-focus.active-focus {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-focus.active-focus {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-focus.active-focus {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-focus.active-focus {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-focus.active-focus {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-focus.active-focus {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-focus.active-focus {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-focus.active-focus {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-focus.active-focus {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-focus.active-focus {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-focus.active-focus {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-focus.active-focus {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-focus.active-focus {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-focus.active-focus {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-focus.active-focus {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-focus.active-focus {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-focus.active-focus {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-focus.active-focus {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-focus.active-focus {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-placeholder::placeholder {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-placeholder::placeholder {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-placeholder::placeholder {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-placeholder::placeholder {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-placeholder::placeholder {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-placeholder::placeholder {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-placeholder::placeholder {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-placeholder::placeholder {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-placeholder::placeholder {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-placeholder::placeholder {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-placeholder::placeholder {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-placeholder::placeholder {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-placeholder::placeholder {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-placeholder::placeholder {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-placeholder::placeholder {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-placeholder::placeholder {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-placeholder::placeholder {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-placeholder::placeholder {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-placeholder::placeholder {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-placeholder::placeholder {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-blue-10-placeholder.active-placeholder {
  color:  #001861;
}
.pf-new-theme .color-blue-10-important-placeholder.active-placeholder {
  color:  #001861 !important;
}
.pf-new-theme .color-blue-9-placeholder.active-placeholder {
  color:  #002687;
}
.pf-new-theme .color-blue-9-important-placeholder.active-placeholder {
  color:  #002687 !important;
}
.pf-new-theme .color-blue-8-placeholder.active-placeholder {
  color:  #0037ad;
}
.pf-new-theme .color-blue-8-important-placeholder.active-placeholder {
  color:  #0037ad !important;
}
.pf-new-theme .color-blue-7-placeholder.active-placeholder {
  color:  #024bd4;
}
.pf-new-theme .color-blue-7-important-placeholder.active-placeholder {
  color:  #024bd4 !important;
}
.pf-new-theme .color-blue-6-placeholder.active-placeholder {
  color:  #0e68f9;
}
.pf-new-theme .color-blue-6-important-placeholder.active-placeholder {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-blue-5-placeholder.active-placeholder {
  color:  #388bff;
}
.pf-new-theme .color-blue-5-important-placeholder.active-placeholder {
  color:  #388bff !important;
}
.pf-new-theme .color-blue-4-placeholder.active-placeholder {
  color:  #61a8ff;
}
.pf-new-theme .color-blue-4-important-placeholder.active-placeholder {
  color:  #61a8ff !important;
}
.pf-new-theme .color-blue-3-placeholder.active-placeholder {
  color:  #8ac2ff;
}
.pf-new-theme .color-blue-3-important-placeholder.active-placeholder {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-blue-2-placeholder.active-placeholder {
  color:  #b3daff;
}
.pf-new-theme .color-blue-2-important-placeholder.active-placeholder {
  color:  #b3daff !important;
}
.pf-new-theme .color-blue-1-placeholder.active-placeholder {
  color:  #e6f4ff;
}
.pf-new-theme .color-blue-1-important-placeholder.active-placeholder {
  color:  #e6f4ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-10-hover {
  color:  #001861;
}
.pf-new-theme .color-hover-parent:hover .color-blue-10-important-hover {
  color:  #001861 !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-9-hover {
  color:  #002687;
}
.pf-new-theme .color-hover-parent:hover .color-blue-9-important-hover {
  color:  #002687 !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-8-hover {
  color:  #0037ad;
}
.pf-new-theme .color-hover-parent:hover .color-blue-8-important-hover {
  color:  #0037ad !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-7-hover {
  color:  #024bd4;
}
.pf-new-theme .color-hover-parent:hover .color-blue-7-important-hover {
  color:  #024bd4 !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-6-hover {
  color:  #0e68f9;
}
.pf-new-theme .color-hover-parent:hover .color-blue-6-important-hover {
  color:  #0e68f9 !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-5-hover {
  color:  #388bff;
}
.pf-new-theme .color-hover-parent:hover .color-blue-5-important-hover {
  color:  #388bff !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-4-hover {
  color:  #61a8ff;
}
.pf-new-theme .color-hover-parent:hover .color-blue-4-important-hover {
  color:  #61a8ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-3-hover {
  color:  #8ac2ff;
}
.pf-new-theme .color-hover-parent:hover .color-blue-3-important-hover {
  color:  #8ac2ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-2-hover {
  color:  #b3daff;
}
.pf-new-theme .color-hover-parent:hover .color-blue-2-important-hover {
  color:  #b3daff !important;
}
.pf-new-theme .color-hover-parent:hover .color-blue-1-hover {
  color:  #e6f4ff;
}
.pf-new-theme .color-hover-parent:hover .color-blue-1-important-hover {
  color:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10 {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9 {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8 {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7 {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6 {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5 {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4 {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3 {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2 {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1 {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important {
  background:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10-hover:hover {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important-hover:hover {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9-hover:hover {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important-hover:hover {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8-hover:hover {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important-hover:hover {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7-hover:hover {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important-hover:hover {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6-hover:hover {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important-hover:hover {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5-hover:hover {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important-hover:hover {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4-hover:hover {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important-hover:hover {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3-hover:hover {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important-hover:hover {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2-hover:hover {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important-hover:hover {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1-hover:hover {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important-hover:hover {
  background:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10-hover.active-hover {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important-hover.active-hover {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9-hover.active-hover {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important-hover.active-hover {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8-hover.active-hover {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important-hover.active-hover {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7-hover.active-hover {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important-hover.active-hover {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6-hover.active-hover {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important-hover.active-hover {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5-hover.active-hover {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important-hover.active-hover {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4-hover.active-hover {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important-hover.active-hover {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3-hover.active-hover {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important-hover.active-hover {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2-hover.active-hover {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important-hover.active-hover {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1-hover.active-hover {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important-hover.active-hover {
  background:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10-hover:focus {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important-hover:focus {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9-hover:focus {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important-hover:focus {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8-hover:focus {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important-hover:focus {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7-hover:focus {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important-hover:focus {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6-hover:focus {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important-hover:focus {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5-hover:focus {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important-hover:focus {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4-hover:focus {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important-hover:focus {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3-hover:focus {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important-hover:focus {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2-hover:focus {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important-hover:focus {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1-hover:focus {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important-hover:focus {
  background:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10-hover.active-focus {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important-hover.active-focus {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9-hover.active-focus {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important-hover.active-focus {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8-hover.active-focus {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important-hover.active-focus {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7-hover.active-focus {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important-hover.active-focus {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6-hover.active-focus {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important-hover.active-focus {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5-hover.active-focus {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important-hover.active-focus {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4-hover.active-focus {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important-hover.active-focus {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3-hover.active-focus {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important-hover.active-focus {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2-hover.active-focus {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important-hover.active-focus {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1-hover.active-focus {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important-hover.active-focus {
  background:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10-focus:focus {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important-focus:focus {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9-focus:focus {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important-focus:focus {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8-focus:focus {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important-focus:focus {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7-focus:focus {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important-focus:focus {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6-focus:focus {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important-focus:focus {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5-focus:focus {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important-focus:focus {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4-focus:focus {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important-focus:focus {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3-focus:focus {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important-focus:focus {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2-focus:focus {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important-focus:focus {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1-focus:focus {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important-focus:focus {
  background:  #e6f4ff !important;
}
.pf-new-theme .background-blue-10-focus.active-focus {
  background:  #001861;
}
.pf-new-theme .background-blue-10-important-focus.active-focus {
  background:  #001861 !important;
}
.pf-new-theme .background-blue-9-focus.active-focus {
  background:  #002687;
}
.pf-new-theme .background-blue-9-important-focus.active-focus {
  background:  #002687 !important;
}
.pf-new-theme .background-blue-8-focus.active-focus {
  background:  #0037ad;
}
.pf-new-theme .background-blue-8-important-focus.active-focus {
  background:  #0037ad !important;
}
.pf-new-theme .background-blue-7-focus.active-focus {
  background:  #024bd4;
}
.pf-new-theme .background-blue-7-important-focus.active-focus {
  background:  #024bd4 !important;
}
.pf-new-theme .background-blue-6-focus.active-focus {
  background:  #0e68f9;
}
.pf-new-theme .background-blue-6-important-focus.active-focus {
  background:  #0e68f9 !important;
}
.pf-new-theme .background-blue-5-focus.active-focus {
  background:  #388bff;
}
.pf-new-theme .background-blue-5-important-focus.active-focus {
  background:  #388bff !important;
}
.pf-new-theme .background-blue-4-focus.active-focus {
  background:  #61a8ff;
}
.pf-new-theme .background-blue-4-important-focus.active-focus {
  background:  #61a8ff !important;
}
.pf-new-theme .background-blue-3-focus.active-focus {
  background:  #8ac2ff;
}
.pf-new-theme .background-blue-3-important-focus.active-focus {
  background:  #8ac2ff !important;
}
.pf-new-theme .background-blue-2-focus.active-focus {
  background:  #b3daff;
}
.pf-new-theme .background-blue-2-important-focus.active-focus {
  background:  #b3daff !important;
}
.pf-new-theme .background-blue-1-focus.active-focus {
  background:  #e6f4ff;
}
.pf-new-theme .background-blue-1-important-focus.active-focus {
  background:  #e6f4ff !important;
}
.pf-new-theme .border-blue-10 {
  border: 1px solid #001861;
}
.pf-new-theme .border-blue-10-important {
  border: 1px solid #001861 !important;
}
.pf-new-theme .border-blue-9 {
  border: 1px solid #002687;
}
.pf-new-theme .border-blue-9-important {
  border: 1px solid #002687 !important;
}
.pf-new-theme .border-blue-8 {
  border: 1px solid #0037ad;
}
.pf-new-theme .border-blue-8-important {
  border: 1px solid #0037ad !important;
}
.pf-new-theme .border-blue-7 {
  border: 1px solid #024bd4;
}
.pf-new-theme .border-blue-7-important {
  border: 1px solid #024bd4 !important;
}
.pf-new-theme .border-blue-6 {
  border: 1px solid #0e68f9;
}
.pf-new-theme .border-blue-6-important {
  border: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-blue-5 {
  border: 1px solid #388bff;
}
.pf-new-theme .border-blue-5-important {
  border: 1px solid #388bff !important;
}
.pf-new-theme .border-blue-4 {
  border: 1px solid #61a8ff;
}
.pf-new-theme .border-blue-4-important {
  border: 1px solid #61a8ff !important;
}
.pf-new-theme .border-blue-3 {
  border: 1px solid #8ac2ff;
}
.pf-new-theme .border-blue-3-important {
  border: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-blue-2 {
  border: 1px solid #b3daff;
}
.pf-new-theme .border-blue-2-important {
  border: 1px solid #b3daff !important;
}
.pf-new-theme .border-blue-1 {
  border: 1px solid #e6f4ff;
}
.pf-new-theme .border-blue-1-important {
  border: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-blue-10-hover:hover {
  border: 1px solid #001861;
}
.pf-new-theme .border-blue-10-important-hover:hover {
  border: 1px solid #001861 !important;
}
.pf-new-theme .border-blue-9-hover:hover {
  border: 1px solid #002687;
}
.pf-new-theme .border-blue-9-important-hover:hover {
  border: 1px solid #002687 !important;
}
.pf-new-theme .border-blue-8-hover:hover {
  border: 1px solid #0037ad;
}
.pf-new-theme .border-blue-8-important-hover:hover {
  border: 1px solid #0037ad !important;
}
.pf-new-theme .border-blue-7-hover:hover {
  border: 1px solid #024bd4;
}
.pf-new-theme .border-blue-7-important-hover:hover {
  border: 1px solid #024bd4 !important;
}
.pf-new-theme .border-blue-6-hover:hover {
  border: 1px solid #0e68f9;
}
.pf-new-theme .border-blue-6-important-hover:hover {
  border: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-blue-5-hover:hover {
  border: 1px solid #388bff;
}
.pf-new-theme .border-blue-5-important-hover:hover {
  border: 1px solid #388bff !important;
}
.pf-new-theme .border-blue-4-hover:hover {
  border: 1px solid #61a8ff;
}
.pf-new-theme .border-blue-4-important-hover:hover {
  border: 1px solid #61a8ff !important;
}
.pf-new-theme .border-blue-3-hover:hover {
  border: 1px solid #8ac2ff;
}
.pf-new-theme .border-blue-3-important-hover:hover {
  border: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-blue-2-hover:hover {
  border: 1px solid #b3daff;
}
.pf-new-theme .border-blue-2-important-hover:hover {
  border: 1px solid #b3daff !important;
}
.pf-new-theme .border-blue-1-hover:hover {
  border: 1px solid #e6f4ff;
}
.pf-new-theme .border-blue-1-important-hover:hover {
  border: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-blue-10-focus:focus {
  border: 1px solid #001861;
}
.pf-new-theme .border-blue-10-important-focus:focus {
  border: 1px solid #001861 !important;
}
.pf-new-theme .border-blue-9-focus:focus {
  border: 1px solid #002687;
}
.pf-new-theme .border-blue-9-important-focus:focus {
  border: 1px solid #002687 !important;
}
.pf-new-theme .border-blue-8-focus:focus {
  border: 1px solid #0037ad;
}
.pf-new-theme .border-blue-8-important-focus:focus {
  border: 1px solid #0037ad !important;
}
.pf-new-theme .border-blue-7-focus:focus {
  border: 1px solid #024bd4;
}
.pf-new-theme .border-blue-7-important-focus:focus {
  border: 1px solid #024bd4 !important;
}
.pf-new-theme .border-blue-6-focus:focus {
  border: 1px solid #0e68f9;
}
.pf-new-theme .border-blue-6-important-focus:focus {
  border: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-blue-5-focus:focus {
  border: 1px solid #388bff;
}
.pf-new-theme .border-blue-5-important-focus:focus {
  border: 1px solid #388bff !important;
}
.pf-new-theme .border-blue-4-focus:focus {
  border: 1px solid #61a8ff;
}
.pf-new-theme .border-blue-4-important-focus:focus {
  border: 1px solid #61a8ff !important;
}
.pf-new-theme .border-blue-3-focus:focus {
  border: 1px solid #8ac2ff;
}
.pf-new-theme .border-blue-3-important-focus:focus {
  border: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-blue-2-focus:focus {
  border: 1px solid #b3daff;
}
.pf-new-theme .border-blue-2-important-focus:focus {
  border: 1px solid #b3daff !important;
}
.pf-new-theme .border-blue-1-focus:focus {
  border: 1px solid #e6f4ff;
}
.pf-new-theme .border-blue-1-important-focus:focus {
  border: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-top-blue-10 {
  border-top: 1px solid #001861;
}
.pf-new-theme .border-top-blue-10-important {
  border-top: 1px solid #001861 !important;
}
.pf-new-theme .border-top-blue-9 {
  border-top: 1px solid #002687;
}
.pf-new-theme .border-top-blue-9-important {
  border-top: 1px solid #002687 !important;
}
.pf-new-theme .border-top-blue-8 {
  border-top: 1px solid #0037ad;
}
.pf-new-theme .border-top-blue-8-important {
  border-top: 1px solid #0037ad !important;
}
.pf-new-theme .border-top-blue-7 {
  border-top: 1px solid #024bd4;
}
.pf-new-theme .border-top-blue-7-important {
  border-top: 1px solid #024bd4 !important;
}
.pf-new-theme .border-top-blue-6 {
  border-top: 1px solid #0e68f9;
}
.pf-new-theme .border-top-blue-6-important {
  border-top: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-top-blue-5 {
  border-top: 1px solid #388bff;
}
.pf-new-theme .border-top-blue-5-important {
  border-top: 1px solid #388bff !important;
}
.pf-new-theme .border-top-blue-4 {
  border-top: 1px solid #61a8ff;
}
.pf-new-theme .border-top-blue-4-important {
  border-top: 1px solid #61a8ff !important;
}
.pf-new-theme .border-top-blue-3 {
  border-top: 1px solid #8ac2ff;
}
.pf-new-theme .border-top-blue-3-important {
  border-top: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-top-blue-2 {
  border-top: 1px solid #b3daff;
}
.pf-new-theme .border-top-blue-2-important {
  border-top: 1px solid #b3daff !important;
}
.pf-new-theme .border-top-blue-1 {
  border-top: 1px solid #e6f4ff;
}
.pf-new-theme .border-top-blue-1-important {
  border-top: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-top-blue-10-hover:hover {
  border-top: 1px solid #001861;
}
.pf-new-theme .border-top-blue-10-important-hover:hover {
  border-top: 1px solid #001861 !important;
}
.pf-new-theme .border-top-blue-9-hover:hover {
  border-top: 1px solid #002687;
}
.pf-new-theme .border-top-blue-9-important-hover:hover {
  border-top: 1px solid #002687 !important;
}
.pf-new-theme .border-top-blue-8-hover:hover {
  border-top: 1px solid #0037ad;
}
.pf-new-theme .border-top-blue-8-important-hover:hover {
  border-top: 1px solid #0037ad !important;
}
.pf-new-theme .border-top-blue-7-hover:hover {
  border-top: 1px solid #024bd4;
}
.pf-new-theme .border-top-blue-7-important-hover:hover {
  border-top: 1px solid #024bd4 !important;
}
.pf-new-theme .border-top-blue-6-hover:hover {
  border-top: 1px solid #0e68f9;
}
.pf-new-theme .border-top-blue-6-important-hover:hover {
  border-top: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-top-blue-5-hover:hover {
  border-top: 1px solid #388bff;
}
.pf-new-theme .border-top-blue-5-important-hover:hover {
  border-top: 1px solid #388bff !important;
}
.pf-new-theme .border-top-blue-4-hover:hover {
  border-top: 1px solid #61a8ff;
}
.pf-new-theme .border-top-blue-4-important-hover:hover {
  border-top: 1px solid #61a8ff !important;
}
.pf-new-theme .border-top-blue-3-hover:hover {
  border-top: 1px solid #8ac2ff;
}
.pf-new-theme .border-top-blue-3-important-hover:hover {
  border-top: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-top-blue-2-hover:hover {
  border-top: 1px solid #b3daff;
}
.pf-new-theme .border-top-blue-2-important-hover:hover {
  border-top: 1px solid #b3daff !important;
}
.pf-new-theme .border-top-blue-1-hover:hover {
  border-top: 1px solid #e6f4ff;
}
.pf-new-theme .border-top-blue-1-important-hover:hover {
  border-top: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-right-blue-10 {
  border-right: 1px solid #001861;
}
.pf-new-theme .border-right-blue-10-important {
  border-right: 1px solid #001861 !important;
}
.pf-new-theme .border-right-blue-9 {
  border-right: 1px solid #002687;
}
.pf-new-theme .border-right-blue-9-important {
  border-right: 1px solid #002687 !important;
}
.pf-new-theme .border-right-blue-8 {
  border-right: 1px solid #0037ad;
}
.pf-new-theme .border-right-blue-8-important {
  border-right: 1px solid #0037ad !important;
}
.pf-new-theme .border-right-blue-7 {
  border-right: 1px solid #024bd4;
}
.pf-new-theme .border-right-blue-7-important {
  border-right: 1px solid #024bd4 !important;
}
.pf-new-theme .border-right-blue-6 {
  border-right: 1px solid #0e68f9;
}
.pf-new-theme .border-right-blue-6-important {
  border-right: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-right-blue-5 {
  border-right: 1px solid #388bff;
}
.pf-new-theme .border-right-blue-5-important {
  border-right: 1px solid #388bff !important;
}
.pf-new-theme .border-right-blue-4 {
  border-right: 1px solid #61a8ff;
}
.pf-new-theme .border-right-blue-4-important {
  border-right: 1px solid #61a8ff !important;
}
.pf-new-theme .border-right-blue-3 {
  border-right: 1px solid #8ac2ff;
}
.pf-new-theme .border-right-blue-3-important {
  border-right: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-right-blue-2 {
  border-right: 1px solid #b3daff;
}
.pf-new-theme .border-right-blue-2-important {
  border-right: 1px solid #b3daff !important;
}
.pf-new-theme .border-right-blue-1 {
  border-right: 1px solid #e6f4ff;
}
.pf-new-theme .border-right-blue-1-important {
  border-right: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-right-blue-10-hover:hover {
  border-right: 1px solid #001861;
}
.pf-new-theme .border-right-blue-10-important-hover:hover {
  border-right: 1px solid #001861 !important;
}
.pf-new-theme .border-right-blue-9-hover:hover {
  border-right: 1px solid #002687;
}
.pf-new-theme .border-right-blue-9-important-hover:hover {
  border-right: 1px solid #002687 !important;
}
.pf-new-theme .border-right-blue-8-hover:hover {
  border-right: 1px solid #0037ad;
}
.pf-new-theme .border-right-blue-8-important-hover:hover {
  border-right: 1px solid #0037ad !important;
}
.pf-new-theme .border-right-blue-7-hover:hover {
  border-right: 1px solid #024bd4;
}
.pf-new-theme .border-right-blue-7-important-hover:hover {
  border-right: 1px solid #024bd4 !important;
}
.pf-new-theme .border-right-blue-6-hover:hover {
  border-right: 1px solid #0e68f9;
}
.pf-new-theme .border-right-blue-6-important-hover:hover {
  border-right: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-right-blue-5-hover:hover {
  border-right: 1px solid #388bff;
}
.pf-new-theme .border-right-blue-5-important-hover:hover {
  border-right: 1px solid #388bff !important;
}
.pf-new-theme .border-right-blue-4-hover:hover {
  border-right: 1px solid #61a8ff;
}
.pf-new-theme .border-right-blue-4-important-hover:hover {
  border-right: 1px solid #61a8ff !important;
}
.pf-new-theme .border-right-blue-3-hover:hover {
  border-right: 1px solid #8ac2ff;
}
.pf-new-theme .border-right-blue-3-important-hover:hover {
  border-right: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-right-blue-2-hover:hover {
  border-right: 1px solid #b3daff;
}
.pf-new-theme .border-right-blue-2-important-hover:hover {
  border-right: 1px solid #b3daff !important;
}
.pf-new-theme .border-right-blue-1-hover:hover {
  border-right: 1px solid #e6f4ff;
}
.pf-new-theme .border-right-blue-1-important-hover:hover {
  border-right: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-bottom-blue-10 {
  border-bottom: 1px solid #001861;
}
.pf-new-theme .border-bottom-blue-10-important {
  border-bottom: 1px solid #001861 !important;
}
.pf-new-theme .border-bottom-blue-9 {
  border-bottom: 1px solid #002687;
}
.pf-new-theme .border-bottom-blue-9-important {
  border-bottom: 1px solid #002687 !important;
}
.pf-new-theme .border-bottom-blue-8 {
  border-bottom: 1px solid #0037ad;
}
.pf-new-theme .border-bottom-blue-8-important {
  border-bottom: 1px solid #0037ad !important;
}
.pf-new-theme .border-bottom-blue-7 {
  border-bottom: 1px solid #024bd4;
}
.pf-new-theme .border-bottom-blue-7-important {
  border-bottom: 1px solid #024bd4 !important;
}
.pf-new-theme .border-bottom-blue-6 {
  border-bottom: 1px solid #0e68f9;
}
.pf-new-theme .border-bottom-blue-6-important {
  border-bottom: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-bottom-blue-5 {
  border-bottom: 1px solid #388bff;
}
.pf-new-theme .border-bottom-blue-5-important {
  border-bottom: 1px solid #388bff !important;
}
.pf-new-theme .border-bottom-blue-4 {
  border-bottom: 1px solid #61a8ff;
}
.pf-new-theme .border-bottom-blue-4-important {
  border-bottom: 1px solid #61a8ff !important;
}
.pf-new-theme .border-bottom-blue-3 {
  border-bottom: 1px solid #8ac2ff;
}
.pf-new-theme .border-bottom-blue-3-important {
  border-bottom: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-bottom-blue-2 {
  border-bottom: 1px solid #b3daff;
}
.pf-new-theme .border-bottom-blue-2-important {
  border-bottom: 1px solid #b3daff !important;
}
.pf-new-theme .border-bottom-blue-1 {
  border-bottom: 1px solid #e6f4ff;
}
.pf-new-theme .border-bottom-blue-1-important {
  border-bottom: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-bottom-blue-10-hover:hover {
  border-bottom: 1px solid #001861;
}
.pf-new-theme .border-bottom-blue-10-important-hover:hover {
  border-bottom: 1px solid #001861 !important;
}
.pf-new-theme .border-bottom-blue-9-hover:hover {
  border-bottom: 1px solid #002687;
}
.pf-new-theme .border-bottom-blue-9-important-hover:hover {
  border-bottom: 1px solid #002687 !important;
}
.pf-new-theme .border-bottom-blue-8-hover:hover {
  border-bottom: 1px solid #0037ad;
}
.pf-new-theme .border-bottom-blue-8-important-hover:hover {
  border-bottom: 1px solid #0037ad !important;
}
.pf-new-theme .border-bottom-blue-7-hover:hover {
  border-bottom: 1px solid #024bd4;
}
.pf-new-theme .border-bottom-blue-7-important-hover:hover {
  border-bottom: 1px solid #024bd4 !important;
}
.pf-new-theme .border-bottom-blue-6-hover:hover {
  border-bottom: 1px solid #0e68f9;
}
.pf-new-theme .border-bottom-blue-6-important-hover:hover {
  border-bottom: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-bottom-blue-5-hover:hover {
  border-bottom: 1px solid #388bff;
}
.pf-new-theme .border-bottom-blue-5-important-hover:hover {
  border-bottom: 1px solid #388bff !important;
}
.pf-new-theme .border-bottom-blue-4-hover:hover {
  border-bottom: 1px solid #61a8ff;
}
.pf-new-theme .border-bottom-blue-4-important-hover:hover {
  border-bottom: 1px solid #61a8ff !important;
}
.pf-new-theme .border-bottom-blue-3-hover:hover {
  border-bottom: 1px solid #8ac2ff;
}
.pf-new-theme .border-bottom-blue-3-important-hover:hover {
  border-bottom: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-bottom-blue-2-hover:hover {
  border-bottom: 1px solid #b3daff;
}
.pf-new-theme .border-bottom-blue-2-important-hover:hover {
  border-bottom: 1px solid #b3daff !important;
}
.pf-new-theme .border-bottom-blue-1-hover:hover {
  border-bottom: 1px solid #e6f4ff;
}
.pf-new-theme .border-bottom-blue-1-important-hover:hover {
  border-bottom: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-left-blue-10 {
  border-left: 1px solid #001861;
}
.pf-new-theme .border-left-blue-10-important {
  border-left: 1px solid #001861 !important;
}
.pf-new-theme .border-left-blue-9 {
  border-left: 1px solid #002687;
}
.pf-new-theme .border-left-blue-9-important {
  border-left: 1px solid #002687 !important;
}
.pf-new-theme .border-left-blue-8 {
  border-left: 1px solid #0037ad;
}
.pf-new-theme .border-left-blue-8-important {
  border-left: 1px solid #0037ad !important;
}
.pf-new-theme .border-left-blue-7 {
  border-left: 1px solid #024bd4;
}
.pf-new-theme .border-left-blue-7-important {
  border-left: 1px solid #024bd4 !important;
}
.pf-new-theme .border-left-blue-6 {
  border-left: 1px solid #0e68f9;
}
.pf-new-theme .border-left-blue-6-important {
  border-left: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-left-blue-5 {
  border-left: 1px solid #388bff;
}
.pf-new-theme .border-left-blue-5-important {
  border-left: 1px solid #388bff !important;
}
.pf-new-theme .border-left-blue-4 {
  border-left: 1px solid #61a8ff;
}
.pf-new-theme .border-left-blue-4-important {
  border-left: 1px solid #61a8ff !important;
}
.pf-new-theme .border-left-blue-3 {
  border-left: 1px solid #8ac2ff;
}
.pf-new-theme .border-left-blue-3-important {
  border-left: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-left-blue-2 {
  border-left: 1px solid #b3daff;
}
.pf-new-theme .border-left-blue-2-important {
  border-left: 1px solid #b3daff !important;
}
.pf-new-theme .border-left-blue-1 {
  border-left: 1px solid #e6f4ff;
}
.pf-new-theme .border-left-blue-1-important {
  border-left: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-left-blue-10-hover:hover {
  border-left: 1px solid #001861;
}
.pf-new-theme .border-left-blue-10-important-hover:hover {
  border-left: 1px solid #001861 !important;
}
.pf-new-theme .border-left-blue-9-hover:hover {
  border-left: 1px solid #002687;
}
.pf-new-theme .border-left-blue-9-important-hover:hover {
  border-left: 1px solid #002687 !important;
}
.pf-new-theme .border-left-blue-8-hover:hover {
  border-left: 1px solid #0037ad;
}
.pf-new-theme .border-left-blue-8-important-hover:hover {
  border-left: 1px solid #0037ad !important;
}
.pf-new-theme .border-left-blue-7-hover:hover {
  border-left: 1px solid #024bd4;
}
.pf-new-theme .border-left-blue-7-important-hover:hover {
  border-left: 1px solid #024bd4 !important;
}
.pf-new-theme .border-left-blue-6-hover:hover {
  border-left: 1px solid #0e68f9;
}
.pf-new-theme .border-left-blue-6-important-hover:hover {
  border-left: 1px solid #0e68f9 !important;
}
.pf-new-theme .border-left-blue-5-hover:hover {
  border-left: 1px solid #388bff;
}
.pf-new-theme .border-left-blue-5-important-hover:hover {
  border-left: 1px solid #388bff !important;
}
.pf-new-theme .border-left-blue-4-hover:hover {
  border-left: 1px solid #61a8ff;
}
.pf-new-theme .border-left-blue-4-important-hover:hover {
  border-left: 1px solid #61a8ff !important;
}
.pf-new-theme .border-left-blue-3-hover:hover {
  border-left: 1px solid #8ac2ff;
}
.pf-new-theme .border-left-blue-3-important-hover:hover {
  border-left: 1px solid #8ac2ff !important;
}
.pf-new-theme .border-left-blue-2-hover:hover {
  border-left: 1px solid #b3daff;
}
.pf-new-theme .border-left-blue-2-important-hover:hover {
  border-left: 1px solid #b3daff !important;
}
.pf-new-theme .border-left-blue-1-hover:hover {
  border-left: 1px solid #e6f4ff;
}
.pf-new-theme .border-left-blue-1-important-hover:hover {
  border-left: 1px solid #e6f4ff !important;
}
.pf-new-theme .border-color-blue-10 {
  border-color:  #001861;
}
.pf-new-theme .border-color-blue-10-important {
  border-color:  #001861 !important;
}
.pf-new-theme .border-color-blue-9 {
  border-color:  #002687;
}
.pf-new-theme .border-color-blue-9-important {
  border-color:  #002687 !important;
}
.pf-new-theme .border-color-blue-8 {
  border-color:  #0037ad;
}
.pf-new-theme .border-color-blue-8-important {
  border-color:  #0037ad !important;
}
.pf-new-theme .border-color-blue-7 {
  border-color:  #024bd4;
}
.pf-new-theme .border-color-blue-7-important {
  border-color:  #024bd4 !important;
}
.pf-new-theme .border-color-blue-6 {
  border-color:  #0e68f9;
}
.pf-new-theme .border-color-blue-6-important {
  border-color:  #0e68f9 !important;
}
.pf-new-theme .border-color-blue-5 {
  border-color:  #388bff;
}
.pf-new-theme .border-color-blue-5-important {
  border-color:  #388bff !important;
}
.pf-new-theme .border-color-blue-4 {
  border-color:  #61a8ff;
}
.pf-new-theme .border-color-blue-4-important {
  border-color:  #61a8ff !important;
}
.pf-new-theme .border-color-blue-3 {
  border-color:  #8ac2ff;
}
.pf-new-theme .border-color-blue-3-important {
  border-color:  #8ac2ff !important;
}
.pf-new-theme .border-color-blue-2 {
  border-color:  #b3daff;
}
.pf-new-theme .border-color-blue-2-important {
  border-color:  #b3daff !important;
}
.pf-new-theme .border-color-blue-1 {
  border-color:  #e6f4ff;
}
.pf-new-theme .border-color-blue-1-important {
  border-color:  #e6f4ff !important;
}
.pf-new-theme .border-color-blue-10-hover:hover {
  border-color:  #001861;
}
.pf-new-theme .border-color-blue-10-important-hover:hover {
  border-color:  #001861 !important;
}
.pf-new-theme .border-color-blue-9-hover:hover {
  border-color:  #002687;
}
.pf-new-theme .border-color-blue-9-important-hover:hover {
  border-color:  #002687 !important;
}
.pf-new-theme .border-color-blue-8-hover:hover {
  border-color:  #0037ad;
}
.pf-new-theme .border-color-blue-8-important-hover:hover {
  border-color:  #0037ad !important;
}
.pf-new-theme .border-color-blue-7-hover:hover {
  border-color:  #024bd4;
}
.pf-new-theme .border-color-blue-7-important-hover:hover {
  border-color:  #024bd4 !important;
}
.pf-new-theme .border-color-blue-6-hover:hover {
  border-color:  #0e68f9;
}
.pf-new-theme .border-color-blue-6-important-hover:hover {
  border-color:  #0e68f9 !important;
}
.pf-new-theme .border-color-blue-5-hover:hover {
  border-color:  #388bff;
}
.pf-new-theme .border-color-blue-5-important-hover:hover {
  border-color:  #388bff !important;
}
.pf-new-theme .border-color-blue-4-hover:hover {
  border-color:  #61a8ff;
}
.pf-new-theme .border-color-blue-4-important-hover:hover {
  border-color:  #61a8ff !important;
}
.pf-new-theme .border-color-blue-3-hover:hover {
  border-color:  #8ac2ff;
}
.pf-new-theme .border-color-blue-3-important-hover:hover {
  border-color:  #8ac2ff !important;
}
.pf-new-theme .border-color-blue-2-hover:hover {
  border-color:  #b3daff;
}
.pf-new-theme .border-color-blue-2-important-hover:hover {
  border-color:  #b3daff !important;
}
.pf-new-theme .border-color-blue-1-hover:hover {
  border-color:  #e6f4ff;
}
.pf-new-theme .border-color-blue-1-important-hover:hover {
  border-color:  #e6f4ff !important;
}
.pf-new-theme .color-purple-10 {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9 {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8 {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7 {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6 {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5 {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4 {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3 {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2 {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1 {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-hover:hover {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-hover:hover {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-hover:hover {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-hover:hover {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-hover:hover {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-hover:hover {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-hover:hover {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-hover:hover {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-hover:hover {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-hover:hover {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-hover:hover {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-hover:hover {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-hover:hover {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-hover:hover {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-hover:hover {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-hover:hover {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-hover:hover {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-hover:hover {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-hover:hover {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-hover:hover {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-hover.active-hover {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-hover.active-hover {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-hover.active-hover {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-hover.active-hover {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-hover.active-hover {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-hover.active-hover {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-hover.active-hover {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-hover.active-hover {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-hover.active-hover {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-hover.active-hover {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-hover.active-hover {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-hover.active-hover {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-hover.active-hover {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-hover.active-hover {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-hover.active-hover {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-hover.active-hover {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-hover.active-hover {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-hover.active-hover {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-hover.active-hover {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-hover.active-hover {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-hover:focus {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-hover:focus {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-hover:focus {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-hover:focus {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-hover:focus {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-hover:focus {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-hover:focus {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-hover:focus {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-hover:focus {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-hover:focus {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-hover:focus {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-hover:focus {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-hover:focus {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-hover:focus {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-hover:focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-hover:focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-hover:focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-hover:focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-hover:focus {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-hover:focus {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-hover.active-focus {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-hover.active-focus {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-hover.active-focus {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-hover.active-focus {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-hover.active-focus {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-hover.active-focus {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-hover.active-focus {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-hover.active-focus {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-hover.active-focus {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-hover.active-focus {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-hover.active-focus {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-hover.active-focus {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-hover.active-focus {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-hover.active-focus {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-hover.active-focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-hover.active-focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-hover.active-focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-hover.active-focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-hover.active-focus {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-hover.active-focus {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-focus:focus {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-focus:focus {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-focus:focus {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-focus:focus {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-focus:focus {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-focus:focus {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-focus:focus {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-focus:focus {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-focus:focus {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-focus:focus {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-focus:focus {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-focus:focus {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-focus:focus {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-focus:focus {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-focus:focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-focus:focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-focus:focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-focus:focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-focus:focus {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-focus:focus {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-focus.active-focus {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-focus.active-focus {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-focus.active-focus {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-focus.active-focus {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-focus.active-focus {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-focus.active-focus {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-focus.active-focus {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-focus.active-focus {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-focus.active-focus {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-focus.active-focus {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-focus.active-focus {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-focus.active-focus {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-focus.active-focus {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-focus.active-focus {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-focus.active-focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-focus.active-focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-focus.active-focus {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-focus.active-focus {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-focus.active-focus {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-focus.active-focus {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-placeholder::placeholder {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-placeholder::placeholder {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-placeholder::placeholder {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-placeholder::placeholder {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-placeholder::placeholder {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-placeholder::placeholder {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-placeholder::placeholder {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-placeholder::placeholder {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-placeholder::placeholder {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-placeholder::placeholder {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-placeholder::placeholder {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-placeholder::placeholder {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-placeholder::placeholder {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-placeholder::placeholder {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-placeholder::placeholder {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-placeholder::placeholder {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-placeholder::placeholder {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-placeholder::placeholder {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-placeholder::placeholder {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-placeholder::placeholder {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-purple-10-placeholder.active-placeholder {
  color:  #281d5c;
}
.pf-new-theme .color-purple-10-important-placeholder.active-placeholder {
  color:  #281d5c !important;
}
.pf-new-theme .color-purple-9-placeholder.active-placeholder {
  color:  #3c2b82;
}
.pf-new-theme .color-purple-9-important-placeholder.active-placeholder {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-purple-8-placeholder.active-placeholder {
  color:  #5840a8;
}
.pf-new-theme .color-purple-8-important-placeholder.active-placeholder {
  color:  #5840a8 !important;
}
.pf-new-theme .color-purple-7-placeholder.active-placeholder {
  color:  #7859cf;
}
.pf-new-theme .color-purple-7-important-placeholder.active-placeholder {
  color:  #7859cf !important;
}
.pf-new-theme .color-purple-6-placeholder.active-placeholder {
  color:  #9c75f6;
}
.pf-new-theme .color-purple-6-important-placeholder.active-placeholder {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-purple-5-placeholder.active-placeholder {
  color:  #c2a3ff;
}
.pf-new-theme .color-purple-5-important-placeholder.active-placeholder {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-purple-4-placeholder.active-placeholder {
  color:  #dfccff;
}
.pf-new-theme .color-purple-4-important-placeholder.active-placeholder {
  color:  #dfccff !important;
}
.pf-new-theme .color-purple-3-placeholder.active-placeholder {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-3-important-placeholder.active-placeholder {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-2-placeholder.active-placeholder {
  color:  #f6f0ff;
}
.pf-new-theme .color-purple-2-important-placeholder.active-placeholder {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-purple-1-placeholder.active-placeholder {
  color:  #f7f0ff;
}
.pf-new-theme .color-purple-1-important-placeholder.active-placeholder {
  color:  #f7f0ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-10-hover {
  color:  #281d5c;
}
.pf-new-theme .color-hover-parent:hover .color-purple-10-important-hover {
  color:  #281d5c !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-9-hover {
  color:  #3c2b82;
}
.pf-new-theme .color-hover-parent:hover .color-purple-9-important-hover {
  color:  #3c2b82 !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-8-hover {
  color:  #5840a8;
}
.pf-new-theme .color-hover-parent:hover .color-purple-8-important-hover {
  color:  #5840a8 !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-7-hover {
  color:  #7859cf;
}
.pf-new-theme .color-hover-parent:hover .color-purple-7-important-hover {
  color:  #7859cf !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-6-hover {
  color:  #9c75f6;
}
.pf-new-theme .color-hover-parent:hover .color-purple-6-important-hover {
  color:  #9c75f6 !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-5-hover {
  color:  #c2a3ff;
}
.pf-new-theme .color-hover-parent:hover .color-purple-5-important-hover {
  color:  #c2a3ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-4-hover {
  color:  #dfccff;
}
.pf-new-theme .color-hover-parent:hover .color-purple-4-important-hover {
  color:  #dfccff !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-3-hover {
  color:  #f6f0ff;
}
.pf-new-theme .color-hover-parent:hover .color-purple-3-important-hover {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-2-hover {
  color:  #f6f0ff;
}
.pf-new-theme .color-hover-parent:hover .color-purple-2-important-hover {
  color:  #f6f0ff !important;
}
.pf-new-theme .color-hover-parent:hover .color-purple-1-hover {
  color:  #f7f0ff;
}
.pf-new-theme .color-hover-parent:hover .color-purple-1-important-hover {
  color:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10 {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9 {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8 {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7 {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6 {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5 {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4 {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3 {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2 {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1 {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important {
  background:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10-hover:hover {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important-hover:hover {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9-hover:hover {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important-hover:hover {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8-hover:hover {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important-hover:hover {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7-hover:hover {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important-hover:hover {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6-hover:hover {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important-hover:hover {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5-hover:hover {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important-hover:hover {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4-hover:hover {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important-hover:hover {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3-hover:hover {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important-hover:hover {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2-hover:hover {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important-hover:hover {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1-hover:hover {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important-hover:hover {
  background:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10-hover.active-hover {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important-hover.active-hover {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9-hover.active-hover {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important-hover.active-hover {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8-hover.active-hover {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important-hover.active-hover {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7-hover.active-hover {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important-hover.active-hover {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6-hover.active-hover {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important-hover.active-hover {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5-hover.active-hover {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important-hover.active-hover {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4-hover.active-hover {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important-hover.active-hover {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3-hover.active-hover {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important-hover.active-hover {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2-hover.active-hover {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important-hover.active-hover {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1-hover.active-hover {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important-hover.active-hover {
  background:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10-hover:focus {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important-hover:focus {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9-hover:focus {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important-hover:focus {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8-hover:focus {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important-hover:focus {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7-hover:focus {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important-hover:focus {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6-hover:focus {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important-hover:focus {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5-hover:focus {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important-hover:focus {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4-hover:focus {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important-hover:focus {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3-hover:focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important-hover:focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2-hover:focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important-hover:focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1-hover:focus {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important-hover:focus {
  background:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10-hover.active-focus {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important-hover.active-focus {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9-hover.active-focus {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important-hover.active-focus {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8-hover.active-focus {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important-hover.active-focus {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7-hover.active-focus {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important-hover.active-focus {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6-hover.active-focus {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important-hover.active-focus {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5-hover.active-focus {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important-hover.active-focus {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4-hover.active-focus {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important-hover.active-focus {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3-hover.active-focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important-hover.active-focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2-hover.active-focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important-hover.active-focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1-hover.active-focus {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important-hover.active-focus {
  background:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10-focus:focus {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important-focus:focus {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9-focus:focus {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important-focus:focus {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8-focus:focus {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important-focus:focus {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7-focus:focus {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important-focus:focus {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6-focus:focus {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important-focus:focus {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5-focus:focus {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important-focus:focus {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4-focus:focus {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important-focus:focus {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3-focus:focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important-focus:focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2-focus:focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important-focus:focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1-focus:focus {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important-focus:focus {
  background:  #f7f0ff !important;
}
.pf-new-theme .background-purple-10-focus.active-focus {
  background:  #281d5c;
}
.pf-new-theme .background-purple-10-important-focus.active-focus {
  background:  #281d5c !important;
}
.pf-new-theme .background-purple-9-focus.active-focus {
  background:  #3c2b82;
}
.pf-new-theme .background-purple-9-important-focus.active-focus {
  background:  #3c2b82 !important;
}
.pf-new-theme .background-purple-8-focus.active-focus {
  background:  #5840a8;
}
.pf-new-theme .background-purple-8-important-focus.active-focus {
  background:  #5840a8 !important;
}
.pf-new-theme .background-purple-7-focus.active-focus {
  background:  #7859cf;
}
.pf-new-theme .background-purple-7-important-focus.active-focus {
  background:  #7859cf !important;
}
.pf-new-theme .background-purple-6-focus.active-focus {
  background:  #9c75f6;
}
.pf-new-theme .background-purple-6-important-focus.active-focus {
  background:  #9c75f6 !important;
}
.pf-new-theme .background-purple-5-focus.active-focus {
  background:  #c2a3ff;
}
.pf-new-theme .background-purple-5-important-focus.active-focus {
  background:  #c2a3ff !important;
}
.pf-new-theme .background-purple-4-focus.active-focus {
  background:  #dfccff;
}
.pf-new-theme .background-purple-4-important-focus.active-focus {
  background:  #dfccff !important;
}
.pf-new-theme .background-purple-3-focus.active-focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-3-important-focus.active-focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-2-focus.active-focus {
  background:  #f6f0ff;
}
.pf-new-theme .background-purple-2-important-focus.active-focus {
  background:  #f6f0ff !important;
}
.pf-new-theme .background-purple-1-focus.active-focus {
  background:  #f7f0ff;
}
.pf-new-theme .background-purple-1-important-focus.active-focus {
  background:  #f7f0ff !important;
}
.pf-new-theme .border-purple-10 {
  border: 1px solid #281d5c;
}
.pf-new-theme .border-purple-10-important {
  border: 1px solid #281d5c !important;
}
.pf-new-theme .border-purple-9 {
  border: 1px solid #3c2b82;
}
.pf-new-theme .border-purple-9-important {
  border: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-purple-8 {
  border: 1px solid #5840a8;
}
.pf-new-theme .border-purple-8-important {
  border: 1px solid #5840a8 !important;
}
.pf-new-theme .border-purple-7 {
  border: 1px solid #7859cf;
}
.pf-new-theme .border-purple-7-important {
  border: 1px solid #7859cf !important;
}
.pf-new-theme .border-purple-6 {
  border: 1px solid #9c75f6;
}
.pf-new-theme .border-purple-6-important {
  border: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-purple-5 {
  border: 1px solid #c2a3ff;
}
.pf-new-theme .border-purple-5-important {
  border: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-purple-4 {
  border: 1px solid #dfccff;
}
.pf-new-theme .border-purple-4-important {
  border: 1px solid #dfccff !important;
}
.pf-new-theme .border-purple-3 {
  border: 1px solid #f6f0ff;
}
.pf-new-theme .border-purple-3-important {
  border: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-purple-2 {
  border: 1px solid #f6f0ff;
}
.pf-new-theme .border-purple-2-important {
  border: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-purple-1 {
  border: 1px solid #f7f0ff;
}
.pf-new-theme .border-purple-1-important {
  border: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-purple-10-hover:hover {
  border: 1px solid #281d5c;
}
.pf-new-theme .border-purple-10-important-hover:hover {
  border: 1px solid #281d5c !important;
}
.pf-new-theme .border-purple-9-hover:hover {
  border: 1px solid #3c2b82;
}
.pf-new-theme .border-purple-9-important-hover:hover {
  border: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-purple-8-hover:hover {
  border: 1px solid #5840a8;
}
.pf-new-theme .border-purple-8-important-hover:hover {
  border: 1px solid #5840a8 !important;
}
.pf-new-theme .border-purple-7-hover:hover {
  border: 1px solid #7859cf;
}
.pf-new-theme .border-purple-7-important-hover:hover {
  border: 1px solid #7859cf !important;
}
.pf-new-theme .border-purple-6-hover:hover {
  border: 1px solid #9c75f6;
}
.pf-new-theme .border-purple-6-important-hover:hover {
  border: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-purple-5-hover:hover {
  border: 1px solid #c2a3ff;
}
.pf-new-theme .border-purple-5-important-hover:hover {
  border: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-purple-4-hover:hover {
  border: 1px solid #dfccff;
}
.pf-new-theme .border-purple-4-important-hover:hover {
  border: 1px solid #dfccff !important;
}
.pf-new-theme .border-purple-3-hover:hover {
  border: 1px solid #f6f0ff;
}
.pf-new-theme .border-purple-3-important-hover:hover {
  border: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-purple-2-hover:hover {
  border: 1px solid #f6f0ff;
}
.pf-new-theme .border-purple-2-important-hover:hover {
  border: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-purple-1-hover:hover {
  border: 1px solid #f7f0ff;
}
.pf-new-theme .border-purple-1-important-hover:hover {
  border: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-purple-10-focus:focus {
  border: 1px solid #281d5c;
}
.pf-new-theme .border-purple-10-important-focus:focus {
  border: 1px solid #281d5c !important;
}
.pf-new-theme .border-purple-9-focus:focus {
  border: 1px solid #3c2b82;
}
.pf-new-theme .border-purple-9-important-focus:focus {
  border: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-purple-8-focus:focus {
  border: 1px solid #5840a8;
}
.pf-new-theme .border-purple-8-important-focus:focus {
  border: 1px solid #5840a8 !important;
}
.pf-new-theme .border-purple-7-focus:focus {
  border: 1px solid #7859cf;
}
.pf-new-theme .border-purple-7-important-focus:focus {
  border: 1px solid #7859cf !important;
}
.pf-new-theme .border-purple-6-focus:focus {
  border: 1px solid #9c75f6;
}
.pf-new-theme .border-purple-6-important-focus:focus {
  border: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-purple-5-focus:focus {
  border: 1px solid #c2a3ff;
}
.pf-new-theme .border-purple-5-important-focus:focus {
  border: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-purple-4-focus:focus {
  border: 1px solid #dfccff;
}
.pf-new-theme .border-purple-4-important-focus:focus {
  border: 1px solid #dfccff !important;
}
.pf-new-theme .border-purple-3-focus:focus {
  border: 1px solid #f6f0ff;
}
.pf-new-theme .border-purple-3-important-focus:focus {
  border: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-purple-2-focus:focus {
  border: 1px solid #f6f0ff;
}
.pf-new-theme .border-purple-2-important-focus:focus {
  border: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-purple-1-focus:focus {
  border: 1px solid #f7f0ff;
}
.pf-new-theme .border-purple-1-important-focus:focus {
  border: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-top-purple-10 {
  border-top: 1px solid #281d5c;
}
.pf-new-theme .border-top-purple-10-important {
  border-top: 1px solid #281d5c !important;
}
.pf-new-theme .border-top-purple-9 {
  border-top: 1px solid #3c2b82;
}
.pf-new-theme .border-top-purple-9-important {
  border-top: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-top-purple-8 {
  border-top: 1px solid #5840a8;
}
.pf-new-theme .border-top-purple-8-important {
  border-top: 1px solid #5840a8 !important;
}
.pf-new-theme .border-top-purple-7 {
  border-top: 1px solid #7859cf;
}
.pf-new-theme .border-top-purple-7-important {
  border-top: 1px solid #7859cf !important;
}
.pf-new-theme .border-top-purple-6 {
  border-top: 1px solid #9c75f6;
}
.pf-new-theme .border-top-purple-6-important {
  border-top: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-top-purple-5 {
  border-top: 1px solid #c2a3ff;
}
.pf-new-theme .border-top-purple-5-important {
  border-top: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-top-purple-4 {
  border-top: 1px solid #dfccff;
}
.pf-new-theme .border-top-purple-4-important {
  border-top: 1px solid #dfccff !important;
}
.pf-new-theme .border-top-purple-3 {
  border-top: 1px solid #f6f0ff;
}
.pf-new-theme .border-top-purple-3-important {
  border-top: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-top-purple-2 {
  border-top: 1px solid #f6f0ff;
}
.pf-new-theme .border-top-purple-2-important {
  border-top: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-top-purple-1 {
  border-top: 1px solid #f7f0ff;
}
.pf-new-theme .border-top-purple-1-important {
  border-top: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-top-purple-10-hover:hover {
  border-top: 1px solid #281d5c;
}
.pf-new-theme .border-top-purple-10-important-hover:hover {
  border-top: 1px solid #281d5c !important;
}
.pf-new-theme .border-top-purple-9-hover:hover {
  border-top: 1px solid #3c2b82;
}
.pf-new-theme .border-top-purple-9-important-hover:hover {
  border-top: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-top-purple-8-hover:hover {
  border-top: 1px solid #5840a8;
}
.pf-new-theme .border-top-purple-8-important-hover:hover {
  border-top: 1px solid #5840a8 !important;
}
.pf-new-theme .border-top-purple-7-hover:hover {
  border-top: 1px solid #7859cf;
}
.pf-new-theme .border-top-purple-7-important-hover:hover {
  border-top: 1px solid #7859cf !important;
}
.pf-new-theme .border-top-purple-6-hover:hover {
  border-top: 1px solid #9c75f6;
}
.pf-new-theme .border-top-purple-6-important-hover:hover {
  border-top: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-top-purple-5-hover:hover {
  border-top: 1px solid #c2a3ff;
}
.pf-new-theme .border-top-purple-5-important-hover:hover {
  border-top: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-top-purple-4-hover:hover {
  border-top: 1px solid #dfccff;
}
.pf-new-theme .border-top-purple-4-important-hover:hover {
  border-top: 1px solid #dfccff !important;
}
.pf-new-theme .border-top-purple-3-hover:hover {
  border-top: 1px solid #f6f0ff;
}
.pf-new-theme .border-top-purple-3-important-hover:hover {
  border-top: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-top-purple-2-hover:hover {
  border-top: 1px solid #f6f0ff;
}
.pf-new-theme .border-top-purple-2-important-hover:hover {
  border-top: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-top-purple-1-hover:hover {
  border-top: 1px solid #f7f0ff;
}
.pf-new-theme .border-top-purple-1-important-hover:hover {
  border-top: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-right-purple-10 {
  border-right: 1px solid #281d5c;
}
.pf-new-theme .border-right-purple-10-important {
  border-right: 1px solid #281d5c !important;
}
.pf-new-theme .border-right-purple-9 {
  border-right: 1px solid #3c2b82;
}
.pf-new-theme .border-right-purple-9-important {
  border-right: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-right-purple-8 {
  border-right: 1px solid #5840a8;
}
.pf-new-theme .border-right-purple-8-important {
  border-right: 1px solid #5840a8 !important;
}
.pf-new-theme .border-right-purple-7 {
  border-right: 1px solid #7859cf;
}
.pf-new-theme .border-right-purple-7-important {
  border-right: 1px solid #7859cf !important;
}
.pf-new-theme .border-right-purple-6 {
  border-right: 1px solid #9c75f6;
}
.pf-new-theme .border-right-purple-6-important {
  border-right: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-right-purple-5 {
  border-right: 1px solid #c2a3ff;
}
.pf-new-theme .border-right-purple-5-important {
  border-right: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-right-purple-4 {
  border-right: 1px solid #dfccff;
}
.pf-new-theme .border-right-purple-4-important {
  border-right: 1px solid #dfccff !important;
}
.pf-new-theme .border-right-purple-3 {
  border-right: 1px solid #f6f0ff;
}
.pf-new-theme .border-right-purple-3-important {
  border-right: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-right-purple-2 {
  border-right: 1px solid #f6f0ff;
}
.pf-new-theme .border-right-purple-2-important {
  border-right: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-right-purple-1 {
  border-right: 1px solid #f7f0ff;
}
.pf-new-theme .border-right-purple-1-important {
  border-right: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-right-purple-10-hover:hover {
  border-right: 1px solid #281d5c;
}
.pf-new-theme .border-right-purple-10-important-hover:hover {
  border-right: 1px solid #281d5c !important;
}
.pf-new-theme .border-right-purple-9-hover:hover {
  border-right: 1px solid #3c2b82;
}
.pf-new-theme .border-right-purple-9-important-hover:hover {
  border-right: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-right-purple-8-hover:hover {
  border-right: 1px solid #5840a8;
}
.pf-new-theme .border-right-purple-8-important-hover:hover {
  border-right: 1px solid #5840a8 !important;
}
.pf-new-theme .border-right-purple-7-hover:hover {
  border-right: 1px solid #7859cf;
}
.pf-new-theme .border-right-purple-7-important-hover:hover {
  border-right: 1px solid #7859cf !important;
}
.pf-new-theme .border-right-purple-6-hover:hover {
  border-right: 1px solid #9c75f6;
}
.pf-new-theme .border-right-purple-6-important-hover:hover {
  border-right: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-right-purple-5-hover:hover {
  border-right: 1px solid #c2a3ff;
}
.pf-new-theme .border-right-purple-5-important-hover:hover {
  border-right: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-right-purple-4-hover:hover {
  border-right: 1px solid #dfccff;
}
.pf-new-theme .border-right-purple-4-important-hover:hover {
  border-right: 1px solid #dfccff !important;
}
.pf-new-theme .border-right-purple-3-hover:hover {
  border-right: 1px solid #f6f0ff;
}
.pf-new-theme .border-right-purple-3-important-hover:hover {
  border-right: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-right-purple-2-hover:hover {
  border-right: 1px solid #f6f0ff;
}
.pf-new-theme .border-right-purple-2-important-hover:hover {
  border-right: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-right-purple-1-hover:hover {
  border-right: 1px solid #f7f0ff;
}
.pf-new-theme .border-right-purple-1-important-hover:hover {
  border-right: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-bottom-purple-10 {
  border-bottom: 1px solid #281d5c;
}
.pf-new-theme .border-bottom-purple-10-important {
  border-bottom: 1px solid #281d5c !important;
}
.pf-new-theme .border-bottom-purple-9 {
  border-bottom: 1px solid #3c2b82;
}
.pf-new-theme .border-bottom-purple-9-important {
  border-bottom: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-bottom-purple-8 {
  border-bottom: 1px solid #5840a8;
}
.pf-new-theme .border-bottom-purple-8-important {
  border-bottom: 1px solid #5840a8 !important;
}
.pf-new-theme .border-bottom-purple-7 {
  border-bottom: 1px solid #7859cf;
}
.pf-new-theme .border-bottom-purple-7-important {
  border-bottom: 1px solid #7859cf !important;
}
.pf-new-theme .border-bottom-purple-6 {
  border-bottom: 1px solid #9c75f6;
}
.pf-new-theme .border-bottom-purple-6-important {
  border-bottom: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-bottom-purple-5 {
  border-bottom: 1px solid #c2a3ff;
}
.pf-new-theme .border-bottom-purple-5-important {
  border-bottom: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-bottom-purple-4 {
  border-bottom: 1px solid #dfccff;
}
.pf-new-theme .border-bottom-purple-4-important {
  border-bottom: 1px solid #dfccff !important;
}
.pf-new-theme .border-bottom-purple-3 {
  border-bottom: 1px solid #f6f0ff;
}
.pf-new-theme .border-bottom-purple-3-important {
  border-bottom: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-bottom-purple-2 {
  border-bottom: 1px solid #f6f0ff;
}
.pf-new-theme .border-bottom-purple-2-important {
  border-bottom: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-bottom-purple-1 {
  border-bottom: 1px solid #f7f0ff;
}
.pf-new-theme .border-bottom-purple-1-important {
  border-bottom: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-bottom-purple-10-hover:hover {
  border-bottom: 1px solid #281d5c;
}
.pf-new-theme .border-bottom-purple-10-important-hover:hover {
  border-bottom: 1px solid #281d5c !important;
}
.pf-new-theme .border-bottom-purple-9-hover:hover {
  border-bottom: 1px solid #3c2b82;
}
.pf-new-theme .border-bottom-purple-9-important-hover:hover {
  border-bottom: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-bottom-purple-8-hover:hover {
  border-bottom: 1px solid #5840a8;
}
.pf-new-theme .border-bottom-purple-8-important-hover:hover {
  border-bottom: 1px solid #5840a8 !important;
}
.pf-new-theme .border-bottom-purple-7-hover:hover {
  border-bottom: 1px solid #7859cf;
}
.pf-new-theme .border-bottom-purple-7-important-hover:hover {
  border-bottom: 1px solid #7859cf !important;
}
.pf-new-theme .border-bottom-purple-6-hover:hover {
  border-bottom: 1px solid #9c75f6;
}
.pf-new-theme .border-bottom-purple-6-important-hover:hover {
  border-bottom: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-bottom-purple-5-hover:hover {
  border-bottom: 1px solid #c2a3ff;
}
.pf-new-theme .border-bottom-purple-5-important-hover:hover {
  border-bottom: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-bottom-purple-4-hover:hover {
  border-bottom: 1px solid #dfccff;
}
.pf-new-theme .border-bottom-purple-4-important-hover:hover {
  border-bottom: 1px solid #dfccff !important;
}
.pf-new-theme .border-bottom-purple-3-hover:hover {
  border-bottom: 1px solid #f6f0ff;
}
.pf-new-theme .border-bottom-purple-3-important-hover:hover {
  border-bottom: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-bottom-purple-2-hover:hover {
  border-bottom: 1px solid #f6f0ff;
}
.pf-new-theme .border-bottom-purple-2-important-hover:hover {
  border-bottom: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-bottom-purple-1-hover:hover {
  border-bottom: 1px solid #f7f0ff;
}
.pf-new-theme .border-bottom-purple-1-important-hover:hover {
  border-bottom: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-left-purple-10 {
  border-left: 1px solid #281d5c;
}
.pf-new-theme .border-left-purple-10-important {
  border-left: 1px solid #281d5c !important;
}
.pf-new-theme .border-left-purple-9 {
  border-left: 1px solid #3c2b82;
}
.pf-new-theme .border-left-purple-9-important {
  border-left: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-left-purple-8 {
  border-left: 1px solid #5840a8;
}
.pf-new-theme .border-left-purple-8-important {
  border-left: 1px solid #5840a8 !important;
}
.pf-new-theme .border-left-purple-7 {
  border-left: 1px solid #7859cf;
}
.pf-new-theme .border-left-purple-7-important {
  border-left: 1px solid #7859cf !important;
}
.pf-new-theme .border-left-purple-6 {
  border-left: 1px solid #9c75f6;
}
.pf-new-theme .border-left-purple-6-important {
  border-left: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-left-purple-5 {
  border-left: 1px solid #c2a3ff;
}
.pf-new-theme .border-left-purple-5-important {
  border-left: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-left-purple-4 {
  border-left: 1px solid #dfccff;
}
.pf-new-theme .border-left-purple-4-important {
  border-left: 1px solid #dfccff !important;
}
.pf-new-theme .border-left-purple-3 {
  border-left: 1px solid #f6f0ff;
}
.pf-new-theme .border-left-purple-3-important {
  border-left: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-left-purple-2 {
  border-left: 1px solid #f6f0ff;
}
.pf-new-theme .border-left-purple-2-important {
  border-left: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-left-purple-1 {
  border-left: 1px solid #f7f0ff;
}
.pf-new-theme .border-left-purple-1-important {
  border-left: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-left-purple-10-hover:hover {
  border-left: 1px solid #281d5c;
}
.pf-new-theme .border-left-purple-10-important-hover:hover {
  border-left: 1px solid #281d5c !important;
}
.pf-new-theme .border-left-purple-9-hover:hover {
  border-left: 1px solid #3c2b82;
}
.pf-new-theme .border-left-purple-9-important-hover:hover {
  border-left: 1px solid #3c2b82 !important;
}
.pf-new-theme .border-left-purple-8-hover:hover {
  border-left: 1px solid #5840a8;
}
.pf-new-theme .border-left-purple-8-important-hover:hover {
  border-left: 1px solid #5840a8 !important;
}
.pf-new-theme .border-left-purple-7-hover:hover {
  border-left: 1px solid #7859cf;
}
.pf-new-theme .border-left-purple-7-important-hover:hover {
  border-left: 1px solid #7859cf !important;
}
.pf-new-theme .border-left-purple-6-hover:hover {
  border-left: 1px solid #9c75f6;
}
.pf-new-theme .border-left-purple-6-important-hover:hover {
  border-left: 1px solid #9c75f6 !important;
}
.pf-new-theme .border-left-purple-5-hover:hover {
  border-left: 1px solid #c2a3ff;
}
.pf-new-theme .border-left-purple-5-important-hover:hover {
  border-left: 1px solid #c2a3ff !important;
}
.pf-new-theme .border-left-purple-4-hover:hover {
  border-left: 1px solid #dfccff;
}
.pf-new-theme .border-left-purple-4-important-hover:hover {
  border-left: 1px solid #dfccff !important;
}
.pf-new-theme .border-left-purple-3-hover:hover {
  border-left: 1px solid #f6f0ff;
}
.pf-new-theme .border-left-purple-3-important-hover:hover {
  border-left: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-left-purple-2-hover:hover {
  border-left: 1px solid #f6f0ff;
}
.pf-new-theme .border-left-purple-2-important-hover:hover {
  border-left: 1px solid #f6f0ff !important;
}
.pf-new-theme .border-left-purple-1-hover:hover {
  border-left: 1px solid #f7f0ff;
}
.pf-new-theme .border-left-purple-1-important-hover:hover {
  border-left: 1px solid #f7f0ff !important;
}
.pf-new-theme .border-color-purple-10 {
  border-color:  #281d5c;
}
.pf-new-theme .border-color-purple-10-important {
  border-color:  #281d5c !important;
}
.pf-new-theme .border-color-purple-9 {
  border-color:  #3c2b82;
}
.pf-new-theme .border-color-purple-9-important {
  border-color:  #3c2b82 !important;
}
.pf-new-theme .border-color-purple-8 {
  border-color:  #5840a8;
}
.pf-new-theme .border-color-purple-8-important {
  border-color:  #5840a8 !important;
}
.pf-new-theme .border-color-purple-7 {
  border-color:  #7859cf;
}
.pf-new-theme .border-color-purple-7-important {
  border-color:  #7859cf !important;
}
.pf-new-theme .border-color-purple-6 {
  border-color:  #9c75f6;
}
.pf-new-theme .border-color-purple-6-important {
  border-color:  #9c75f6 !important;
}
.pf-new-theme .border-color-purple-5 {
  border-color:  #c2a3ff;
}
.pf-new-theme .border-color-purple-5-important {
  border-color:  #c2a3ff !important;
}
.pf-new-theme .border-color-purple-4 {
  border-color:  #dfccff;
}
.pf-new-theme .border-color-purple-4-important {
  border-color:  #dfccff !important;
}
.pf-new-theme .border-color-purple-3 {
  border-color:  #f6f0ff;
}
.pf-new-theme .border-color-purple-3-important {
  border-color:  #f6f0ff !important;
}
.pf-new-theme .border-color-purple-2 {
  border-color:  #f6f0ff;
}
.pf-new-theme .border-color-purple-2-important {
  border-color:  #f6f0ff !important;
}
.pf-new-theme .border-color-purple-1 {
  border-color:  #f7f0ff;
}
.pf-new-theme .border-color-purple-1-important {
  border-color:  #f7f0ff !important;
}
.pf-new-theme .border-color-purple-10-hover:hover {
  border-color:  #281d5c;
}
.pf-new-theme .border-color-purple-10-important-hover:hover {
  border-color:  #281d5c !important;
}
.pf-new-theme .border-color-purple-9-hover:hover {
  border-color:  #3c2b82;
}
.pf-new-theme .border-color-purple-9-important-hover:hover {
  border-color:  #3c2b82 !important;
}
.pf-new-theme .border-color-purple-8-hover:hover {
  border-color:  #5840a8;
}
.pf-new-theme .border-color-purple-8-important-hover:hover {
  border-color:  #5840a8 !important;
}
.pf-new-theme .border-color-purple-7-hover:hover {
  border-color:  #7859cf;
}
.pf-new-theme .border-color-purple-7-important-hover:hover {
  border-color:  #7859cf !important;
}
.pf-new-theme .border-color-purple-6-hover:hover {
  border-color:  #9c75f6;
}
.pf-new-theme .border-color-purple-6-important-hover:hover {
  border-color:  #9c75f6 !important;
}
.pf-new-theme .border-color-purple-5-hover:hover {
  border-color:  #c2a3ff;
}
.pf-new-theme .border-color-purple-5-important-hover:hover {
  border-color:  #c2a3ff !important;
}
.pf-new-theme .border-color-purple-4-hover:hover {
  border-color:  #dfccff;
}
.pf-new-theme .border-color-purple-4-important-hover:hover {
  border-color:  #dfccff !important;
}
.pf-new-theme .border-color-purple-3-hover:hover {
  border-color:  #f6f0ff;
}
.pf-new-theme .border-color-purple-3-important-hover:hover {
  border-color:  #f6f0ff !important;
}
.pf-new-theme .border-color-purple-2-hover:hover {
  border-color:  #f6f0ff;
}
.pf-new-theme .border-color-purple-2-important-hover:hover {
  border-color:  #f6f0ff !important;
}
.pf-new-theme .border-color-purple-1-hover:hover {
  border-color:  #f7f0ff;
}
.pf-new-theme .border-color-purple-1-important-hover:hover {
  border-color:  #f7f0ff !important;
}
.pf-new-theme .color-green-10 {
  color:  #004543;
}
.pf-new-theme .color-green-10-important {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9 {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8 {
  color:  #009183;
}
.pf-new-theme .color-green-8-important {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7 {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6 {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5 {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4 {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3 {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2 {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1 {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-hover:hover {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-hover:hover {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-hover:hover {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-hover:hover {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-hover:hover {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-hover:hover {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-hover:hover {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-hover:hover {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-hover:hover {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-hover:hover {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-hover:hover {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-hover:hover {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-hover:hover {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-hover:hover {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-hover:hover {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-hover:hover {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-hover:hover {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-hover:hover {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-hover:hover {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-hover:hover {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-hover.active-hover {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-hover.active-hover {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-hover.active-hover {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-hover.active-hover {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-hover.active-hover {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-hover.active-hover {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-hover.active-hover {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-hover.active-hover {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-hover.active-hover {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-hover.active-hover {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-hover.active-hover {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-hover.active-hover {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-hover.active-hover {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-hover.active-hover {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-hover.active-hover {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-hover.active-hover {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-hover.active-hover {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-hover.active-hover {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-hover.active-hover {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-hover.active-hover {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-hover:focus {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-hover:focus {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-hover:focus {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-hover:focus {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-hover:focus {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-hover:focus {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-hover:focus {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-hover:focus {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-hover:focus {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-hover:focus {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-hover:focus {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-hover:focus {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-hover:focus {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-hover:focus {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-hover:focus {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-hover:focus {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-hover:focus {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-hover:focus {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-hover:focus {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-hover:focus {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-hover.active-focus {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-hover.active-focus {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-hover.active-focus {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-hover.active-focus {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-hover.active-focus {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-hover.active-focus {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-hover.active-focus {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-hover.active-focus {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-hover.active-focus {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-hover.active-focus {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-hover.active-focus {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-hover.active-focus {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-hover.active-focus {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-hover.active-focus {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-hover.active-focus {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-hover.active-focus {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-hover.active-focus {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-hover.active-focus {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-hover.active-focus {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-hover.active-focus {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-focus:focus {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-focus:focus {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-focus:focus {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-focus:focus {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-focus:focus {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-focus:focus {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-focus:focus {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-focus:focus {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-focus:focus {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-focus:focus {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-focus:focus {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-focus:focus {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-focus:focus {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-focus:focus {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-focus:focus {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-focus:focus {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-focus:focus {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-focus:focus {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-focus:focus {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-focus:focus {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-focus.active-focus {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-focus.active-focus {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-focus.active-focus {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-focus.active-focus {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-focus.active-focus {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-focus.active-focus {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-focus.active-focus {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-focus.active-focus {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-focus.active-focus {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-focus.active-focus {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-focus.active-focus {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-focus.active-focus {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-focus.active-focus {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-focus.active-focus {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-focus.active-focus {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-focus.active-focus {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-focus.active-focus {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-focus.active-focus {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-focus.active-focus {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-focus.active-focus {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-placeholder::placeholder {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-placeholder::placeholder {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-placeholder::placeholder {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-placeholder::placeholder {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-placeholder::placeholder {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-placeholder::placeholder {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-placeholder::placeholder {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-placeholder::placeholder {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-placeholder::placeholder {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-placeholder::placeholder {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-placeholder::placeholder {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-placeholder::placeholder {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-placeholder::placeholder {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-placeholder::placeholder {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-placeholder::placeholder {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-placeholder::placeholder {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-placeholder::placeholder {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-placeholder::placeholder {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-placeholder::placeholder {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-placeholder::placeholder {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-green-10-placeholder.active-placeholder {
  color:  #004543;
}
.pf-new-theme .color-green-10-important-placeholder.active-placeholder {
  color:  #004543 !important;
}
.pf-new-theme .color-green-9-placeholder.active-placeholder {
  color:  #006b64;
}
.pf-new-theme .color-green-9-important-placeholder.active-placeholder {
  color:  #006b64 !important;
}
.pf-new-theme .color-green-8-placeholder.active-placeholder {
  color:  #009183;
}
.pf-new-theme .color-green-8-important-placeholder.active-placeholder {
  color:  #009183 !important;
}
.pf-new-theme .color-green-7-placeholder.active-placeholder {
  color:  #00b89f;
}
.pf-new-theme .color-green-7-important-placeholder.active-placeholder {
  color:  #00b89f !important;
}
.pf-new-theme .color-green-6-placeholder.active-placeholder {
  color:  #03dfb9;
}
.pf-new-theme .color-green-6-important-placeholder.active-placeholder {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-green-5-placeholder.active-placeholder {
  color:  #28ebc4;
}
.pf-new-theme .color-green-5-important-placeholder.active-placeholder {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-green-4-placeholder.active-placeholder {
  color:  #52f7d1;
}
.pf-new-theme .color-green-4-important-placeholder.active-placeholder {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-green-3-placeholder.active-placeholder {
  color:  #7dffdc;
}
.pf-new-theme .color-green-3-important-placeholder.active-placeholder {
  color:  #7dffdc !important;
}
.pf-new-theme .color-green-2-placeholder.active-placeholder {
  color:  #a6ffe4;
}
.pf-new-theme .color-green-2-important-placeholder.active-placeholder {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-green-1-placeholder.active-placeholder {
  color:  #e6fff7;
}
.pf-new-theme .color-green-1-important-placeholder.active-placeholder {
  color:  #e6fff7 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-10-hover {
  color:  #004543;
}
.pf-new-theme .color-hover-parent:hover .color-green-10-important-hover {
  color:  #004543 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-9-hover {
  color:  #006b64;
}
.pf-new-theme .color-hover-parent:hover .color-green-9-important-hover {
  color:  #006b64 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-8-hover {
  color:  #009183;
}
.pf-new-theme .color-hover-parent:hover .color-green-8-important-hover {
  color:  #009183 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-7-hover {
  color:  #00b89f;
}
.pf-new-theme .color-hover-parent:hover .color-green-7-important-hover {
  color:  #00b89f !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-6-hover {
  color:  #03dfb9;
}
.pf-new-theme .color-hover-parent:hover .color-green-6-important-hover {
  color:  #03dfb9 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-5-hover {
  color:  #28ebc4;
}
.pf-new-theme .color-hover-parent:hover .color-green-5-important-hover {
  color:  #28ebc4 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-4-hover {
  color:  #52f7d1;
}
.pf-new-theme .color-hover-parent:hover .color-green-4-important-hover {
  color:  #52f7d1 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-3-hover {
  color:  #7dffdc;
}
.pf-new-theme .color-hover-parent:hover .color-green-3-important-hover {
  color:  #7dffdc !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-2-hover {
  color:  #a6ffe4;
}
.pf-new-theme .color-hover-parent:hover .color-green-2-important-hover {
  color:  #a6ffe4 !important;
}
.pf-new-theme .color-hover-parent:hover .color-green-1-hover {
  color:  #e6fff7;
}
.pf-new-theme .color-hover-parent:hover .color-green-1-important-hover {
  color:  #e6fff7 !important;
}
.pf-new-theme .background-green-10 {
  background:  #004543;
}
.pf-new-theme .background-green-10-important {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9 {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8 {
  background:  #009183;
}
.pf-new-theme .background-green-8-important {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7 {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6 {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5 {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4 {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3 {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2 {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1 {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important {
  background:  #e6fff7 !important;
}
.pf-new-theme .background-green-10-hover:hover {
  background:  #004543;
}
.pf-new-theme .background-green-10-important-hover:hover {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9-hover:hover {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important-hover:hover {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8-hover:hover {
  background:  #009183;
}
.pf-new-theme .background-green-8-important-hover:hover {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7-hover:hover {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important-hover:hover {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6-hover:hover {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important-hover:hover {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5-hover:hover {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important-hover:hover {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4-hover:hover {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important-hover:hover {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3-hover:hover {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important-hover:hover {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2-hover:hover {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important-hover:hover {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1-hover:hover {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important-hover:hover {
  background:  #e6fff7 !important;
}
.pf-new-theme .background-green-10-hover.active-hover {
  background:  #004543;
}
.pf-new-theme .background-green-10-important-hover.active-hover {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9-hover.active-hover {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important-hover.active-hover {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8-hover.active-hover {
  background:  #009183;
}
.pf-new-theme .background-green-8-important-hover.active-hover {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7-hover.active-hover {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important-hover.active-hover {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6-hover.active-hover {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important-hover.active-hover {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5-hover.active-hover {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important-hover.active-hover {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4-hover.active-hover {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important-hover.active-hover {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3-hover.active-hover {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important-hover.active-hover {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2-hover.active-hover {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important-hover.active-hover {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1-hover.active-hover {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important-hover.active-hover {
  background:  #e6fff7 !important;
}
.pf-new-theme .background-green-10-hover:focus {
  background:  #004543;
}
.pf-new-theme .background-green-10-important-hover:focus {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9-hover:focus {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important-hover:focus {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8-hover:focus {
  background:  #009183;
}
.pf-new-theme .background-green-8-important-hover:focus {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7-hover:focus {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important-hover:focus {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6-hover:focus {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important-hover:focus {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5-hover:focus {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important-hover:focus {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4-hover:focus {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important-hover:focus {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3-hover:focus {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important-hover:focus {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2-hover:focus {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important-hover:focus {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1-hover:focus {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important-hover:focus {
  background:  #e6fff7 !important;
}
.pf-new-theme .background-green-10-hover.active-focus {
  background:  #004543;
}
.pf-new-theme .background-green-10-important-hover.active-focus {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9-hover.active-focus {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important-hover.active-focus {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8-hover.active-focus {
  background:  #009183;
}
.pf-new-theme .background-green-8-important-hover.active-focus {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7-hover.active-focus {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important-hover.active-focus {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6-hover.active-focus {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important-hover.active-focus {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5-hover.active-focus {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important-hover.active-focus {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4-hover.active-focus {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important-hover.active-focus {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3-hover.active-focus {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important-hover.active-focus {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2-hover.active-focus {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important-hover.active-focus {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1-hover.active-focus {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important-hover.active-focus {
  background:  #e6fff7 !important;
}
.pf-new-theme .background-green-10-focus:focus {
  background:  #004543;
}
.pf-new-theme .background-green-10-important-focus:focus {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9-focus:focus {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important-focus:focus {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8-focus:focus {
  background:  #009183;
}
.pf-new-theme .background-green-8-important-focus:focus {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7-focus:focus {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important-focus:focus {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6-focus:focus {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important-focus:focus {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5-focus:focus {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important-focus:focus {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4-focus:focus {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important-focus:focus {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3-focus:focus {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important-focus:focus {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2-focus:focus {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important-focus:focus {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1-focus:focus {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important-focus:focus {
  background:  #e6fff7 !important;
}
.pf-new-theme .background-green-10-focus.active-focus {
  background:  #004543;
}
.pf-new-theme .background-green-10-important-focus.active-focus {
  background:  #004543 !important;
}
.pf-new-theme .background-green-9-focus.active-focus {
  background:  #006b64;
}
.pf-new-theme .background-green-9-important-focus.active-focus {
  background:  #006b64 !important;
}
.pf-new-theme .background-green-8-focus.active-focus {
  background:  #009183;
}
.pf-new-theme .background-green-8-important-focus.active-focus {
  background:  #009183 !important;
}
.pf-new-theme .background-green-7-focus.active-focus {
  background:  #00b89f;
}
.pf-new-theme .background-green-7-important-focus.active-focus {
  background:  #00b89f !important;
}
.pf-new-theme .background-green-6-focus.active-focus {
  background:  #03dfb9;
}
.pf-new-theme .background-green-6-important-focus.active-focus {
  background:  #03dfb9 !important;
}
.pf-new-theme .background-green-5-focus.active-focus {
  background:  #28ebc4;
}
.pf-new-theme .background-green-5-important-focus.active-focus {
  background:  #28ebc4 !important;
}
.pf-new-theme .background-green-4-focus.active-focus {
  background:  #52f7d1;
}
.pf-new-theme .background-green-4-important-focus.active-focus {
  background:  #52f7d1 !important;
}
.pf-new-theme .background-green-3-focus.active-focus {
  background:  #7dffdc;
}
.pf-new-theme .background-green-3-important-focus.active-focus {
  background:  #7dffdc !important;
}
.pf-new-theme .background-green-2-focus.active-focus {
  background:  #a6ffe4;
}
.pf-new-theme .background-green-2-important-focus.active-focus {
  background:  #a6ffe4 !important;
}
.pf-new-theme .background-green-1-focus.active-focus {
  background:  #e6fff7;
}
.pf-new-theme .background-green-1-important-focus.active-focus {
  background:  #e6fff7 !important;
}
.pf-new-theme .border-green-10 {
  border: 1px solid #004543;
}
.pf-new-theme .border-green-10-important {
  border: 1px solid #004543 !important;
}
.pf-new-theme .border-green-9 {
  border: 1px solid #006b64;
}
.pf-new-theme .border-green-9-important {
  border: 1px solid #006b64 !important;
}
.pf-new-theme .border-green-8 {
  border: 1px solid #009183;
}
.pf-new-theme .border-green-8-important {
  border: 1px solid #009183 !important;
}
.pf-new-theme .border-green-7 {
  border: 1px solid #00b89f;
}
.pf-new-theme .border-green-7-important {
  border: 1px solid #00b89f !important;
}
.pf-new-theme .border-green-6 {
  border: 1px solid #03dfb9;
}
.pf-new-theme .border-green-6-important {
  border: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-green-5 {
  border: 1px solid #28ebc4;
}
.pf-new-theme .border-green-5-important {
  border: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-green-4 {
  border: 1px solid #52f7d1;
}
.pf-new-theme .border-green-4-important {
  border: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-green-3 {
  border: 1px solid #7dffdc;
}
.pf-new-theme .border-green-3-important {
  border: 1px solid #7dffdc !important;
}
.pf-new-theme .border-green-2 {
  border: 1px solid #a6ffe4;
}
.pf-new-theme .border-green-2-important {
  border: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-green-1 {
  border: 1px solid #e6fff7;
}
.pf-new-theme .border-green-1-important {
  border: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-green-10-hover:hover {
  border: 1px solid #004543;
}
.pf-new-theme .border-green-10-important-hover:hover {
  border: 1px solid #004543 !important;
}
.pf-new-theme .border-green-9-hover:hover {
  border: 1px solid #006b64;
}
.pf-new-theme .border-green-9-important-hover:hover {
  border: 1px solid #006b64 !important;
}
.pf-new-theme .border-green-8-hover:hover {
  border: 1px solid #009183;
}
.pf-new-theme .border-green-8-important-hover:hover {
  border: 1px solid #009183 !important;
}
.pf-new-theme .border-green-7-hover:hover {
  border: 1px solid #00b89f;
}
.pf-new-theme .border-green-7-important-hover:hover {
  border: 1px solid #00b89f !important;
}
.pf-new-theme .border-green-6-hover:hover {
  border: 1px solid #03dfb9;
}
.pf-new-theme .border-green-6-important-hover:hover {
  border: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-green-5-hover:hover {
  border: 1px solid #28ebc4;
}
.pf-new-theme .border-green-5-important-hover:hover {
  border: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-green-4-hover:hover {
  border: 1px solid #52f7d1;
}
.pf-new-theme .border-green-4-important-hover:hover {
  border: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-green-3-hover:hover {
  border: 1px solid #7dffdc;
}
.pf-new-theme .border-green-3-important-hover:hover {
  border: 1px solid #7dffdc !important;
}
.pf-new-theme .border-green-2-hover:hover {
  border: 1px solid #a6ffe4;
}
.pf-new-theme .border-green-2-important-hover:hover {
  border: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-green-1-hover:hover {
  border: 1px solid #e6fff7;
}
.pf-new-theme .border-green-1-important-hover:hover {
  border: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-green-10-focus:focus {
  border: 1px solid #004543;
}
.pf-new-theme .border-green-10-important-focus:focus {
  border: 1px solid #004543 !important;
}
.pf-new-theme .border-green-9-focus:focus {
  border: 1px solid #006b64;
}
.pf-new-theme .border-green-9-important-focus:focus {
  border: 1px solid #006b64 !important;
}
.pf-new-theme .border-green-8-focus:focus {
  border: 1px solid #009183;
}
.pf-new-theme .border-green-8-important-focus:focus {
  border: 1px solid #009183 !important;
}
.pf-new-theme .border-green-7-focus:focus {
  border: 1px solid #00b89f;
}
.pf-new-theme .border-green-7-important-focus:focus {
  border: 1px solid #00b89f !important;
}
.pf-new-theme .border-green-6-focus:focus {
  border: 1px solid #03dfb9;
}
.pf-new-theme .border-green-6-important-focus:focus {
  border: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-green-5-focus:focus {
  border: 1px solid #28ebc4;
}
.pf-new-theme .border-green-5-important-focus:focus {
  border: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-green-4-focus:focus {
  border: 1px solid #52f7d1;
}
.pf-new-theme .border-green-4-important-focus:focus {
  border: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-green-3-focus:focus {
  border: 1px solid #7dffdc;
}
.pf-new-theme .border-green-3-important-focus:focus {
  border: 1px solid #7dffdc !important;
}
.pf-new-theme .border-green-2-focus:focus {
  border: 1px solid #a6ffe4;
}
.pf-new-theme .border-green-2-important-focus:focus {
  border: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-green-1-focus:focus {
  border: 1px solid #e6fff7;
}
.pf-new-theme .border-green-1-important-focus:focus {
  border: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-top-green-10 {
  border-top: 1px solid #004543;
}
.pf-new-theme .border-top-green-10-important {
  border-top: 1px solid #004543 !important;
}
.pf-new-theme .border-top-green-9 {
  border-top: 1px solid #006b64;
}
.pf-new-theme .border-top-green-9-important {
  border-top: 1px solid #006b64 !important;
}
.pf-new-theme .border-top-green-8 {
  border-top: 1px solid #009183;
}
.pf-new-theme .border-top-green-8-important {
  border-top: 1px solid #009183 !important;
}
.pf-new-theme .border-top-green-7 {
  border-top: 1px solid #00b89f;
}
.pf-new-theme .border-top-green-7-important {
  border-top: 1px solid #00b89f !important;
}
.pf-new-theme .border-top-green-6 {
  border-top: 1px solid #03dfb9;
}
.pf-new-theme .border-top-green-6-important {
  border-top: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-top-green-5 {
  border-top: 1px solid #28ebc4;
}
.pf-new-theme .border-top-green-5-important {
  border-top: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-top-green-4 {
  border-top: 1px solid #52f7d1;
}
.pf-new-theme .border-top-green-4-important {
  border-top: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-top-green-3 {
  border-top: 1px solid #7dffdc;
}
.pf-new-theme .border-top-green-3-important {
  border-top: 1px solid #7dffdc !important;
}
.pf-new-theme .border-top-green-2 {
  border-top: 1px solid #a6ffe4;
}
.pf-new-theme .border-top-green-2-important {
  border-top: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-top-green-1 {
  border-top: 1px solid #e6fff7;
}
.pf-new-theme .border-top-green-1-important {
  border-top: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-top-green-10-hover:hover {
  border-top: 1px solid #004543;
}
.pf-new-theme .border-top-green-10-important-hover:hover {
  border-top: 1px solid #004543 !important;
}
.pf-new-theme .border-top-green-9-hover:hover {
  border-top: 1px solid #006b64;
}
.pf-new-theme .border-top-green-9-important-hover:hover {
  border-top: 1px solid #006b64 !important;
}
.pf-new-theme .border-top-green-8-hover:hover {
  border-top: 1px solid #009183;
}
.pf-new-theme .border-top-green-8-important-hover:hover {
  border-top: 1px solid #009183 !important;
}
.pf-new-theme .border-top-green-7-hover:hover {
  border-top: 1px solid #00b89f;
}
.pf-new-theme .border-top-green-7-important-hover:hover {
  border-top: 1px solid #00b89f !important;
}
.pf-new-theme .border-top-green-6-hover:hover {
  border-top: 1px solid #03dfb9;
}
.pf-new-theme .border-top-green-6-important-hover:hover {
  border-top: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-top-green-5-hover:hover {
  border-top: 1px solid #28ebc4;
}
.pf-new-theme .border-top-green-5-important-hover:hover {
  border-top: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-top-green-4-hover:hover {
  border-top: 1px solid #52f7d1;
}
.pf-new-theme .border-top-green-4-important-hover:hover {
  border-top: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-top-green-3-hover:hover {
  border-top: 1px solid #7dffdc;
}
.pf-new-theme .border-top-green-3-important-hover:hover {
  border-top: 1px solid #7dffdc !important;
}
.pf-new-theme .border-top-green-2-hover:hover {
  border-top: 1px solid #a6ffe4;
}
.pf-new-theme .border-top-green-2-important-hover:hover {
  border-top: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-top-green-1-hover:hover {
  border-top: 1px solid #e6fff7;
}
.pf-new-theme .border-top-green-1-important-hover:hover {
  border-top: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-right-green-10 {
  border-right: 1px solid #004543;
}
.pf-new-theme .border-right-green-10-important {
  border-right: 1px solid #004543 !important;
}
.pf-new-theme .border-right-green-9 {
  border-right: 1px solid #006b64;
}
.pf-new-theme .border-right-green-9-important {
  border-right: 1px solid #006b64 !important;
}
.pf-new-theme .border-right-green-8 {
  border-right: 1px solid #009183;
}
.pf-new-theme .border-right-green-8-important {
  border-right: 1px solid #009183 !important;
}
.pf-new-theme .border-right-green-7 {
  border-right: 1px solid #00b89f;
}
.pf-new-theme .border-right-green-7-important {
  border-right: 1px solid #00b89f !important;
}
.pf-new-theme .border-right-green-6 {
  border-right: 1px solid #03dfb9;
}
.pf-new-theme .border-right-green-6-important {
  border-right: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-right-green-5 {
  border-right: 1px solid #28ebc4;
}
.pf-new-theme .border-right-green-5-important {
  border-right: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-right-green-4 {
  border-right: 1px solid #52f7d1;
}
.pf-new-theme .border-right-green-4-important {
  border-right: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-right-green-3 {
  border-right: 1px solid #7dffdc;
}
.pf-new-theme .border-right-green-3-important {
  border-right: 1px solid #7dffdc !important;
}
.pf-new-theme .border-right-green-2 {
  border-right: 1px solid #a6ffe4;
}
.pf-new-theme .border-right-green-2-important {
  border-right: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-right-green-1 {
  border-right: 1px solid #e6fff7;
}
.pf-new-theme .border-right-green-1-important {
  border-right: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-right-green-10-hover:hover {
  border-right: 1px solid #004543;
}
.pf-new-theme .border-right-green-10-important-hover:hover {
  border-right: 1px solid #004543 !important;
}
.pf-new-theme .border-right-green-9-hover:hover {
  border-right: 1px solid #006b64;
}
.pf-new-theme .border-right-green-9-important-hover:hover {
  border-right: 1px solid #006b64 !important;
}
.pf-new-theme .border-right-green-8-hover:hover {
  border-right: 1px solid #009183;
}
.pf-new-theme .border-right-green-8-important-hover:hover {
  border-right: 1px solid #009183 !important;
}
.pf-new-theme .border-right-green-7-hover:hover {
  border-right: 1px solid #00b89f;
}
.pf-new-theme .border-right-green-7-important-hover:hover {
  border-right: 1px solid #00b89f !important;
}
.pf-new-theme .border-right-green-6-hover:hover {
  border-right: 1px solid #03dfb9;
}
.pf-new-theme .border-right-green-6-important-hover:hover {
  border-right: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-right-green-5-hover:hover {
  border-right: 1px solid #28ebc4;
}
.pf-new-theme .border-right-green-5-important-hover:hover {
  border-right: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-right-green-4-hover:hover {
  border-right: 1px solid #52f7d1;
}
.pf-new-theme .border-right-green-4-important-hover:hover {
  border-right: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-right-green-3-hover:hover {
  border-right: 1px solid #7dffdc;
}
.pf-new-theme .border-right-green-3-important-hover:hover {
  border-right: 1px solid #7dffdc !important;
}
.pf-new-theme .border-right-green-2-hover:hover {
  border-right: 1px solid #a6ffe4;
}
.pf-new-theme .border-right-green-2-important-hover:hover {
  border-right: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-right-green-1-hover:hover {
  border-right: 1px solid #e6fff7;
}
.pf-new-theme .border-right-green-1-important-hover:hover {
  border-right: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-bottom-green-10 {
  border-bottom: 1px solid #004543;
}
.pf-new-theme .border-bottom-green-10-important {
  border-bottom: 1px solid #004543 !important;
}
.pf-new-theme .border-bottom-green-9 {
  border-bottom: 1px solid #006b64;
}
.pf-new-theme .border-bottom-green-9-important {
  border-bottom: 1px solid #006b64 !important;
}
.pf-new-theme .border-bottom-green-8 {
  border-bottom: 1px solid #009183;
}
.pf-new-theme .border-bottom-green-8-important {
  border-bottom: 1px solid #009183 !important;
}
.pf-new-theme .border-bottom-green-7 {
  border-bottom: 1px solid #00b89f;
}
.pf-new-theme .border-bottom-green-7-important {
  border-bottom: 1px solid #00b89f !important;
}
.pf-new-theme .border-bottom-green-6 {
  border-bottom: 1px solid #03dfb9;
}
.pf-new-theme .border-bottom-green-6-important {
  border-bottom: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-bottom-green-5 {
  border-bottom: 1px solid #28ebc4;
}
.pf-new-theme .border-bottom-green-5-important {
  border-bottom: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-bottom-green-4 {
  border-bottom: 1px solid #52f7d1;
}
.pf-new-theme .border-bottom-green-4-important {
  border-bottom: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-bottom-green-3 {
  border-bottom: 1px solid #7dffdc;
}
.pf-new-theme .border-bottom-green-3-important {
  border-bottom: 1px solid #7dffdc !important;
}
.pf-new-theme .border-bottom-green-2 {
  border-bottom: 1px solid #a6ffe4;
}
.pf-new-theme .border-bottom-green-2-important {
  border-bottom: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-bottom-green-1 {
  border-bottom: 1px solid #e6fff7;
}
.pf-new-theme .border-bottom-green-1-important {
  border-bottom: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-bottom-green-10-hover:hover {
  border-bottom: 1px solid #004543;
}
.pf-new-theme .border-bottom-green-10-important-hover:hover {
  border-bottom: 1px solid #004543 !important;
}
.pf-new-theme .border-bottom-green-9-hover:hover {
  border-bottom: 1px solid #006b64;
}
.pf-new-theme .border-bottom-green-9-important-hover:hover {
  border-bottom: 1px solid #006b64 !important;
}
.pf-new-theme .border-bottom-green-8-hover:hover {
  border-bottom: 1px solid #009183;
}
.pf-new-theme .border-bottom-green-8-important-hover:hover {
  border-bottom: 1px solid #009183 !important;
}
.pf-new-theme .border-bottom-green-7-hover:hover {
  border-bottom: 1px solid #00b89f;
}
.pf-new-theme .border-bottom-green-7-important-hover:hover {
  border-bottom: 1px solid #00b89f !important;
}
.pf-new-theme .border-bottom-green-6-hover:hover {
  border-bottom: 1px solid #03dfb9;
}
.pf-new-theme .border-bottom-green-6-important-hover:hover {
  border-bottom: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-bottom-green-5-hover:hover {
  border-bottom: 1px solid #28ebc4;
}
.pf-new-theme .border-bottom-green-5-important-hover:hover {
  border-bottom: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-bottom-green-4-hover:hover {
  border-bottom: 1px solid #52f7d1;
}
.pf-new-theme .border-bottom-green-4-important-hover:hover {
  border-bottom: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-bottom-green-3-hover:hover {
  border-bottom: 1px solid #7dffdc;
}
.pf-new-theme .border-bottom-green-3-important-hover:hover {
  border-bottom: 1px solid #7dffdc !important;
}
.pf-new-theme .border-bottom-green-2-hover:hover {
  border-bottom: 1px solid #a6ffe4;
}
.pf-new-theme .border-bottom-green-2-important-hover:hover {
  border-bottom: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-bottom-green-1-hover:hover {
  border-bottom: 1px solid #e6fff7;
}
.pf-new-theme .border-bottom-green-1-important-hover:hover {
  border-bottom: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-left-green-10 {
  border-left: 1px solid #004543;
}
.pf-new-theme .border-left-green-10-important {
  border-left: 1px solid #004543 !important;
}
.pf-new-theme .border-left-green-9 {
  border-left: 1px solid #006b64;
}
.pf-new-theme .border-left-green-9-important {
  border-left: 1px solid #006b64 !important;
}
.pf-new-theme .border-left-green-8 {
  border-left: 1px solid #009183;
}
.pf-new-theme .border-left-green-8-important {
  border-left: 1px solid #009183 !important;
}
.pf-new-theme .border-left-green-7 {
  border-left: 1px solid #00b89f;
}
.pf-new-theme .border-left-green-7-important {
  border-left: 1px solid #00b89f !important;
}
.pf-new-theme .border-left-green-6 {
  border-left: 1px solid #03dfb9;
}
.pf-new-theme .border-left-green-6-important {
  border-left: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-left-green-5 {
  border-left: 1px solid #28ebc4;
}
.pf-new-theme .border-left-green-5-important {
  border-left: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-left-green-4 {
  border-left: 1px solid #52f7d1;
}
.pf-new-theme .border-left-green-4-important {
  border-left: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-left-green-3 {
  border-left: 1px solid #7dffdc;
}
.pf-new-theme .border-left-green-3-important {
  border-left: 1px solid #7dffdc !important;
}
.pf-new-theme .border-left-green-2 {
  border-left: 1px solid #a6ffe4;
}
.pf-new-theme .border-left-green-2-important {
  border-left: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-left-green-1 {
  border-left: 1px solid #e6fff7;
}
.pf-new-theme .border-left-green-1-important {
  border-left: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-left-green-10-hover:hover {
  border-left: 1px solid #004543;
}
.pf-new-theme .border-left-green-10-important-hover:hover {
  border-left: 1px solid #004543 !important;
}
.pf-new-theme .border-left-green-9-hover:hover {
  border-left: 1px solid #006b64;
}
.pf-new-theme .border-left-green-9-important-hover:hover {
  border-left: 1px solid #006b64 !important;
}
.pf-new-theme .border-left-green-8-hover:hover {
  border-left: 1px solid #009183;
}
.pf-new-theme .border-left-green-8-important-hover:hover {
  border-left: 1px solid #009183 !important;
}
.pf-new-theme .border-left-green-7-hover:hover {
  border-left: 1px solid #00b89f;
}
.pf-new-theme .border-left-green-7-important-hover:hover {
  border-left: 1px solid #00b89f !important;
}
.pf-new-theme .border-left-green-6-hover:hover {
  border-left: 1px solid #03dfb9;
}
.pf-new-theme .border-left-green-6-important-hover:hover {
  border-left: 1px solid #03dfb9 !important;
}
.pf-new-theme .border-left-green-5-hover:hover {
  border-left: 1px solid #28ebc4;
}
.pf-new-theme .border-left-green-5-important-hover:hover {
  border-left: 1px solid #28ebc4 !important;
}
.pf-new-theme .border-left-green-4-hover:hover {
  border-left: 1px solid #52f7d1;
}
.pf-new-theme .border-left-green-4-important-hover:hover {
  border-left: 1px solid #52f7d1 !important;
}
.pf-new-theme .border-left-green-3-hover:hover {
  border-left: 1px solid #7dffdc;
}
.pf-new-theme .border-left-green-3-important-hover:hover {
  border-left: 1px solid #7dffdc !important;
}
.pf-new-theme .border-left-green-2-hover:hover {
  border-left: 1px solid #a6ffe4;
}
.pf-new-theme .border-left-green-2-important-hover:hover {
  border-left: 1px solid #a6ffe4 !important;
}
.pf-new-theme .border-left-green-1-hover:hover {
  border-left: 1px solid #e6fff7;
}
.pf-new-theme .border-left-green-1-important-hover:hover {
  border-left: 1px solid #e6fff7 !important;
}
.pf-new-theme .border-color-green-10 {
  border-color:  #004543;
}
.pf-new-theme .border-color-green-10-important {
  border-color:  #004543 !important;
}
.pf-new-theme .border-color-green-9 {
  border-color:  #006b64;
}
.pf-new-theme .border-color-green-9-important {
  border-color:  #006b64 !important;
}
.pf-new-theme .border-color-green-8 {
  border-color:  #009183;
}
.pf-new-theme .border-color-green-8-important {
  border-color:  #009183 !important;
}
.pf-new-theme .border-color-green-7 {
  border-color:  #00b89f;
}
.pf-new-theme .border-color-green-7-important {
  border-color:  #00b89f !important;
}
.pf-new-theme .border-color-green-6 {
  border-color:  #03dfb9;
}
.pf-new-theme .border-color-green-6-important {
  border-color:  #03dfb9 !important;
}
.pf-new-theme .border-color-green-5 {
  border-color:  #28ebc4;
}
.pf-new-theme .border-color-green-5-important {
  border-color:  #28ebc4 !important;
}
.pf-new-theme .border-color-green-4 {
  border-color:  #52f7d1;
}
.pf-new-theme .border-color-green-4-important {
  border-color:  #52f7d1 !important;
}
.pf-new-theme .border-color-green-3 {
  border-color:  #7dffdc;
}
.pf-new-theme .border-color-green-3-important {
  border-color:  #7dffdc !important;
}
.pf-new-theme .border-color-green-2 {
  border-color:  #a6ffe4;
}
.pf-new-theme .border-color-green-2-important {
  border-color:  #a6ffe4 !important;
}
.pf-new-theme .border-color-green-1 {
  border-color:  #e6fff7;
}
.pf-new-theme .border-color-green-1-important {
  border-color:  #e6fff7 !important;
}
.pf-new-theme .border-color-green-10-hover:hover {
  border-color:  #004543;
}
.pf-new-theme .border-color-green-10-important-hover:hover {
  border-color:  #004543 !important;
}
.pf-new-theme .border-color-green-9-hover:hover {
  border-color:  #006b64;
}
.pf-new-theme .border-color-green-9-important-hover:hover {
  border-color:  #006b64 !important;
}
.pf-new-theme .border-color-green-8-hover:hover {
  border-color:  #009183;
}
.pf-new-theme .border-color-green-8-important-hover:hover {
  border-color:  #009183 !important;
}
.pf-new-theme .border-color-green-7-hover:hover {
  border-color:  #00b89f;
}
.pf-new-theme .border-color-green-7-important-hover:hover {
  border-color:  #00b89f !important;
}
.pf-new-theme .border-color-green-6-hover:hover {
  border-color:  #03dfb9;
}
.pf-new-theme .border-color-green-6-important-hover:hover {
  border-color:  #03dfb9 !important;
}
.pf-new-theme .border-color-green-5-hover:hover {
  border-color:  #28ebc4;
}
.pf-new-theme .border-color-green-5-important-hover:hover {
  border-color:  #28ebc4 !important;
}
.pf-new-theme .border-color-green-4-hover:hover {
  border-color:  #52f7d1;
}
.pf-new-theme .border-color-green-4-important-hover:hover {
  border-color:  #52f7d1 !important;
}
.pf-new-theme .border-color-green-3-hover:hover {
  border-color:  #7dffdc;
}
.pf-new-theme .border-color-green-3-important-hover:hover {
  border-color:  #7dffdc !important;
}
.pf-new-theme .border-color-green-2-hover:hover {
  border-color:  #a6ffe4;
}
.pf-new-theme .border-color-green-2-important-hover:hover {
  border-color:  #a6ffe4 !important;
}
.pf-new-theme .border-color-green-1-hover:hover {
  border-color:  #e6fff7;
}
.pf-new-theme .border-color-green-1-important-hover:hover {
  border-color:  #e6fff7 !important;
}
.pf-new-theme .color-light-green-10 {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9 {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8 {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7 {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6 {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5 {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4 {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3 {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2 {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1 {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-hover:hover {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-hover:hover {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-hover:hover {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-hover:hover {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-hover:hover {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-hover:hover {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-hover:hover {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-hover:hover {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-hover:hover {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-hover:hover {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-hover:hover {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-hover:hover {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-hover:hover {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-hover:hover {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-hover:hover {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-hover:hover {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-hover:hover {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-hover:hover {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-hover:hover {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-hover:hover {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-hover.active-hover {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-hover.active-hover {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-hover.active-hover {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-hover.active-hover {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-hover.active-hover {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-hover.active-hover {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-hover.active-hover {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-hover.active-hover {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-hover.active-hover {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-hover.active-hover {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-hover.active-hover {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-hover.active-hover {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-hover.active-hover {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-hover.active-hover {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-hover.active-hover {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-hover.active-hover {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-hover.active-hover {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-hover.active-hover {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-hover.active-hover {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-hover.active-hover {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-hover:focus {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-hover:focus {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-hover:focus {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-hover:focus {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-hover:focus {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-hover:focus {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-hover:focus {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-hover:focus {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-hover:focus {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-hover:focus {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-hover:focus {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-hover:focus {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-hover:focus {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-hover:focus {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-hover:focus {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-hover:focus {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-hover:focus {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-hover:focus {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-hover:focus {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-hover:focus {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-hover.active-focus {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-hover.active-focus {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-hover.active-focus {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-hover.active-focus {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-hover.active-focus {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-hover.active-focus {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-hover.active-focus {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-hover.active-focus {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-hover.active-focus {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-hover.active-focus {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-hover.active-focus {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-hover.active-focus {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-hover.active-focus {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-hover.active-focus {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-hover.active-focus {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-hover.active-focus {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-hover.active-focus {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-hover.active-focus {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-hover.active-focus {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-hover.active-focus {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-focus:focus {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-focus:focus {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-focus:focus {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-focus:focus {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-focus:focus {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-focus:focus {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-focus:focus {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-focus:focus {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-focus:focus {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-focus:focus {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-focus:focus {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-focus:focus {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-focus:focus {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-focus:focus {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-focus:focus {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-focus:focus {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-focus:focus {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-focus:focus {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-focus:focus {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-focus:focus {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-focus.active-focus {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-focus.active-focus {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-focus.active-focus {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-focus.active-focus {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-focus.active-focus {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-focus.active-focus {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-focus.active-focus {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-focus.active-focus {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-focus.active-focus {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-focus.active-focus {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-focus.active-focus {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-focus.active-focus {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-focus.active-focus {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-focus.active-focus {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-focus.active-focus {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-focus.active-focus {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-focus.active-focus {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-focus.active-focus {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-focus.active-focus {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-focus.active-focus {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-placeholder::placeholder {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-placeholder::placeholder {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-placeholder::placeholder {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-placeholder::placeholder {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-placeholder::placeholder {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-placeholder::placeholder {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-placeholder::placeholder {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-placeholder::placeholder {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-placeholder::placeholder {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-placeholder::placeholder {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-placeholder::placeholder {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-placeholder::placeholder {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-placeholder::placeholder {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-placeholder::placeholder {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-placeholder::placeholder {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-placeholder::placeholder {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-placeholder::placeholder {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-placeholder::placeholder {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-placeholder::placeholder {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-placeholder::placeholder {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-light-green-10-placeholder.active-placeholder {
  color:  #003629;
}
.pf-new-theme .color-light-green-10-important-placeholder.active-placeholder {
  color:  #003629 !important;
}
.pf-new-theme .color-light-green-9-placeholder.active-placeholder {
  color:  #005c43;
}
.pf-new-theme .color-light-green-9-important-placeholder.active-placeholder {
  color:  #005c43 !important;
}
.pf-new-theme .color-light-green-8-placeholder.active-placeholder {
  color:  #00825b;
}
.pf-new-theme .color-light-green-8-important-placeholder.active-placeholder {
  color:  #00825b !important;
}
.pf-new-theme .color-light-green-7-placeholder.active-placeholder {
  color:  #00a870;
}
.pf-new-theme .color-light-green-7-important-placeholder.active-placeholder {
  color:  #00a870 !important;
}
.pf-new-theme .color-light-green-6-placeholder.active-placeholder {
  color:  #00cf83;
}
.pf-new-theme .color-light-green-6-important-placeholder.active-placeholder {
  color:  #00cf83 !important;
}
.pf-new-theme .color-light-green-5-placeholder.active-placeholder {
  color:  #23db92;
}
.pf-new-theme .color-light-green-5-important-placeholder.active-placeholder {
  color:  #23db92 !important;
}
.pf-new-theme .color-light-green-4-placeholder.active-placeholder {
  color:  #4ae8a4;
}
.pf-new-theme .color-light-green-4-important-placeholder.active-placeholder {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-light-green-3-placeholder.active-placeholder {
  color:  #76f5b9;
}
.pf-new-theme .color-light-green-3-important-placeholder.active-placeholder {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-light-green-2-placeholder.active-placeholder {
  color:  #a3ffd1;
}
.pf-new-theme .color-light-green-2-important-placeholder.active-placeholder {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-light-green-1-placeholder.active-placeholder {
  color:  #e6fff1;
}
.pf-new-theme .color-light-green-1-important-placeholder.active-placeholder {
  color:  #e6fff1 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-10-hover {
  color:  #003629;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-10-important-hover {
  color:  #003629 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-9-hover {
  color:  #005c43;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-9-important-hover {
  color:  #005c43 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-8-hover {
  color:  #00825b;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-8-important-hover {
  color:  #00825b !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-7-hover {
  color:  #00a870;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-7-important-hover {
  color:  #00a870 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-6-hover {
  color:  #00cf83;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-6-important-hover {
  color:  #00cf83 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-5-hover {
  color:  #23db92;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-5-important-hover {
  color:  #23db92 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-4-hover {
  color:  #4ae8a4;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-4-important-hover {
  color:  #4ae8a4 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-3-hover {
  color:  #76f5b9;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-3-important-hover {
  color:  #76f5b9 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-2-hover {
  color:  #a3ffd1;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-2-important-hover {
  color:  #a3ffd1 !important;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-1-hover {
  color:  #e6fff1;
}
.pf-new-theme .color-hover-parent:hover .color-light-green-1-important-hover {
  color:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10 {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9 {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8 {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7 {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6 {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5 {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4 {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3 {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2 {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1 {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important {
  background:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10-hover:hover {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important-hover:hover {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9-hover:hover {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important-hover:hover {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8-hover:hover {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important-hover:hover {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7-hover:hover {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important-hover:hover {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6-hover:hover {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important-hover:hover {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5-hover:hover {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important-hover:hover {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4-hover:hover {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important-hover:hover {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3-hover:hover {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important-hover:hover {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2-hover:hover {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important-hover:hover {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1-hover:hover {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important-hover:hover {
  background:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10-hover.active-hover {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important-hover.active-hover {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9-hover.active-hover {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important-hover.active-hover {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8-hover.active-hover {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important-hover.active-hover {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7-hover.active-hover {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important-hover.active-hover {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6-hover.active-hover {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important-hover.active-hover {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5-hover.active-hover {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important-hover.active-hover {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4-hover.active-hover {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important-hover.active-hover {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3-hover.active-hover {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important-hover.active-hover {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2-hover.active-hover {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important-hover.active-hover {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1-hover.active-hover {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important-hover.active-hover {
  background:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10-hover:focus {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important-hover:focus {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9-hover:focus {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important-hover:focus {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8-hover:focus {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important-hover:focus {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7-hover:focus {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important-hover:focus {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6-hover:focus {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important-hover:focus {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5-hover:focus {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important-hover:focus {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4-hover:focus {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important-hover:focus {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3-hover:focus {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important-hover:focus {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2-hover:focus {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important-hover:focus {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1-hover:focus {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important-hover:focus {
  background:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10-hover.active-focus {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important-hover.active-focus {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9-hover.active-focus {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important-hover.active-focus {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8-hover.active-focus {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important-hover.active-focus {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7-hover.active-focus {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important-hover.active-focus {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6-hover.active-focus {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important-hover.active-focus {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5-hover.active-focus {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important-hover.active-focus {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4-hover.active-focus {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important-hover.active-focus {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3-hover.active-focus {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important-hover.active-focus {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2-hover.active-focus {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important-hover.active-focus {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1-hover.active-focus {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important-hover.active-focus {
  background:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10-focus:focus {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important-focus:focus {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9-focus:focus {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important-focus:focus {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8-focus:focus {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important-focus:focus {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7-focus:focus {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important-focus:focus {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6-focus:focus {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important-focus:focus {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5-focus:focus {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important-focus:focus {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4-focus:focus {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important-focus:focus {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3-focus:focus {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important-focus:focus {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2-focus:focus {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important-focus:focus {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1-focus:focus {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important-focus:focus {
  background:  #e6fff1 !important;
}
.pf-new-theme .background-light-green-10-focus.active-focus {
  background:  #003629;
}
.pf-new-theme .background-light-green-10-important-focus.active-focus {
  background:  #003629 !important;
}
.pf-new-theme .background-light-green-9-focus.active-focus {
  background:  #005c43;
}
.pf-new-theme .background-light-green-9-important-focus.active-focus {
  background:  #005c43 !important;
}
.pf-new-theme .background-light-green-8-focus.active-focus {
  background:  #00825b;
}
.pf-new-theme .background-light-green-8-important-focus.active-focus {
  background:  #00825b !important;
}
.pf-new-theme .background-light-green-7-focus.active-focus {
  background:  #00a870;
}
.pf-new-theme .background-light-green-7-important-focus.active-focus {
  background:  #00a870 !important;
}
.pf-new-theme .background-light-green-6-focus.active-focus {
  background:  #00cf83;
}
.pf-new-theme .background-light-green-6-important-focus.active-focus {
  background:  #00cf83 !important;
}
.pf-new-theme .background-light-green-5-focus.active-focus {
  background:  #23db92;
}
.pf-new-theme .background-light-green-5-important-focus.active-focus {
  background:  #23db92 !important;
}
.pf-new-theme .background-light-green-4-focus.active-focus {
  background:  #4ae8a4;
}
.pf-new-theme .background-light-green-4-important-focus.active-focus {
  background:  #4ae8a4 !important;
}
.pf-new-theme .background-light-green-3-focus.active-focus {
  background:  #76f5b9;
}
.pf-new-theme .background-light-green-3-important-focus.active-focus {
  background:  #76f5b9 !important;
}
.pf-new-theme .background-light-green-2-focus.active-focus {
  background:  #a3ffd1;
}
.pf-new-theme .background-light-green-2-important-focus.active-focus {
  background:  #a3ffd1 !important;
}
.pf-new-theme .background-light-green-1-focus.active-focus {
  background:  #e6fff1;
}
.pf-new-theme .background-light-green-1-important-focus.active-focus {
  background:  #e6fff1 !important;
}
.pf-new-theme .border-light-green-10 {
  border: 1px solid #003629;
}
.pf-new-theme .border-light-green-10-important {
  border: 1px solid #003629 !important;
}
.pf-new-theme .border-light-green-9 {
  border: 1px solid #005c43;
}
.pf-new-theme .border-light-green-9-important {
  border: 1px solid #005c43 !important;
}
.pf-new-theme .border-light-green-8 {
  border: 1px solid #00825b;
}
.pf-new-theme .border-light-green-8-important {
  border: 1px solid #00825b !important;
}
.pf-new-theme .border-light-green-7 {
  border: 1px solid #00a870;
}
.pf-new-theme .border-light-green-7-important {
  border: 1px solid #00a870 !important;
}
.pf-new-theme .border-light-green-6 {
  border: 1px solid #00cf83;
}
.pf-new-theme .border-light-green-6-important {
  border: 1px solid #00cf83 !important;
}
.pf-new-theme .border-light-green-5 {
  border: 1px solid #23db92;
}
.pf-new-theme .border-light-green-5-important {
  border: 1px solid #23db92 !important;
}
.pf-new-theme .border-light-green-4 {
  border: 1px solid #4ae8a4;
}
.pf-new-theme .border-light-green-4-important {
  border: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-light-green-3 {
  border: 1px solid #76f5b9;
}
.pf-new-theme .border-light-green-3-important {
  border: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-light-green-2 {
  border: 1px solid #a3ffd1;
}
.pf-new-theme .border-light-green-2-important {
  border: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-light-green-1 {
  border: 1px solid #e6fff1;
}
.pf-new-theme .border-light-green-1-important {
  border: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-light-green-10-hover:hover {
  border: 1px solid #003629;
}
.pf-new-theme .border-light-green-10-important-hover:hover {
  border: 1px solid #003629 !important;
}
.pf-new-theme .border-light-green-9-hover:hover {
  border: 1px solid #005c43;
}
.pf-new-theme .border-light-green-9-important-hover:hover {
  border: 1px solid #005c43 !important;
}
.pf-new-theme .border-light-green-8-hover:hover {
  border: 1px solid #00825b;
}
.pf-new-theme .border-light-green-8-important-hover:hover {
  border: 1px solid #00825b !important;
}
.pf-new-theme .border-light-green-7-hover:hover {
  border: 1px solid #00a870;
}
.pf-new-theme .border-light-green-7-important-hover:hover {
  border: 1px solid #00a870 !important;
}
.pf-new-theme .border-light-green-6-hover:hover {
  border: 1px solid #00cf83;
}
.pf-new-theme .border-light-green-6-important-hover:hover {
  border: 1px solid #00cf83 !important;
}
.pf-new-theme .border-light-green-5-hover:hover {
  border: 1px solid #23db92;
}
.pf-new-theme .border-light-green-5-important-hover:hover {
  border: 1px solid #23db92 !important;
}
.pf-new-theme .border-light-green-4-hover:hover {
  border: 1px solid #4ae8a4;
}
.pf-new-theme .border-light-green-4-important-hover:hover {
  border: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-light-green-3-hover:hover {
  border: 1px solid #76f5b9;
}
.pf-new-theme .border-light-green-3-important-hover:hover {
  border: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-light-green-2-hover:hover {
  border: 1px solid #a3ffd1;
}
.pf-new-theme .border-light-green-2-important-hover:hover {
  border: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-light-green-1-hover:hover {
  border: 1px solid #e6fff1;
}
.pf-new-theme .border-light-green-1-important-hover:hover {
  border: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-light-green-10-focus:focus {
  border: 1px solid #003629;
}
.pf-new-theme .border-light-green-10-important-focus:focus {
  border: 1px solid #003629 !important;
}
.pf-new-theme .border-light-green-9-focus:focus {
  border: 1px solid #005c43;
}
.pf-new-theme .border-light-green-9-important-focus:focus {
  border: 1px solid #005c43 !important;
}
.pf-new-theme .border-light-green-8-focus:focus {
  border: 1px solid #00825b;
}
.pf-new-theme .border-light-green-8-important-focus:focus {
  border: 1px solid #00825b !important;
}
.pf-new-theme .border-light-green-7-focus:focus {
  border: 1px solid #00a870;
}
.pf-new-theme .border-light-green-7-important-focus:focus {
  border: 1px solid #00a870 !important;
}
.pf-new-theme .border-light-green-6-focus:focus {
  border: 1px solid #00cf83;
}
.pf-new-theme .border-light-green-6-important-focus:focus {
  border: 1px solid #00cf83 !important;
}
.pf-new-theme .border-light-green-5-focus:focus {
  border: 1px solid #23db92;
}
.pf-new-theme .border-light-green-5-important-focus:focus {
  border: 1px solid #23db92 !important;
}
.pf-new-theme .border-light-green-4-focus:focus {
  border: 1px solid #4ae8a4;
}
.pf-new-theme .border-light-green-4-important-focus:focus {
  border: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-light-green-3-focus:focus {
  border: 1px solid #76f5b9;
}
.pf-new-theme .border-light-green-3-important-focus:focus {
  border: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-light-green-2-focus:focus {
  border: 1px solid #a3ffd1;
}
.pf-new-theme .border-light-green-2-important-focus:focus {
  border: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-light-green-1-focus:focus {
  border: 1px solid #e6fff1;
}
.pf-new-theme .border-light-green-1-important-focus:focus {
  border: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-top-light-green-10 {
  border-top: 1px solid #003629;
}
.pf-new-theme .border-top-light-green-10-important {
  border-top: 1px solid #003629 !important;
}
.pf-new-theme .border-top-light-green-9 {
  border-top: 1px solid #005c43;
}
.pf-new-theme .border-top-light-green-9-important {
  border-top: 1px solid #005c43 !important;
}
.pf-new-theme .border-top-light-green-8 {
  border-top: 1px solid #00825b;
}
.pf-new-theme .border-top-light-green-8-important {
  border-top: 1px solid #00825b !important;
}
.pf-new-theme .border-top-light-green-7 {
  border-top: 1px solid #00a870;
}
.pf-new-theme .border-top-light-green-7-important {
  border-top: 1px solid #00a870 !important;
}
.pf-new-theme .border-top-light-green-6 {
  border-top: 1px solid #00cf83;
}
.pf-new-theme .border-top-light-green-6-important {
  border-top: 1px solid #00cf83 !important;
}
.pf-new-theme .border-top-light-green-5 {
  border-top: 1px solid #23db92;
}
.pf-new-theme .border-top-light-green-5-important {
  border-top: 1px solid #23db92 !important;
}
.pf-new-theme .border-top-light-green-4 {
  border-top: 1px solid #4ae8a4;
}
.pf-new-theme .border-top-light-green-4-important {
  border-top: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-top-light-green-3 {
  border-top: 1px solid #76f5b9;
}
.pf-new-theme .border-top-light-green-3-important {
  border-top: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-top-light-green-2 {
  border-top: 1px solid #a3ffd1;
}
.pf-new-theme .border-top-light-green-2-important {
  border-top: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-top-light-green-1 {
  border-top: 1px solid #e6fff1;
}
.pf-new-theme .border-top-light-green-1-important {
  border-top: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-top-light-green-10-hover:hover {
  border-top: 1px solid #003629;
}
.pf-new-theme .border-top-light-green-10-important-hover:hover {
  border-top: 1px solid #003629 !important;
}
.pf-new-theme .border-top-light-green-9-hover:hover {
  border-top: 1px solid #005c43;
}
.pf-new-theme .border-top-light-green-9-important-hover:hover {
  border-top: 1px solid #005c43 !important;
}
.pf-new-theme .border-top-light-green-8-hover:hover {
  border-top: 1px solid #00825b;
}
.pf-new-theme .border-top-light-green-8-important-hover:hover {
  border-top: 1px solid #00825b !important;
}
.pf-new-theme .border-top-light-green-7-hover:hover {
  border-top: 1px solid #00a870;
}
.pf-new-theme .border-top-light-green-7-important-hover:hover {
  border-top: 1px solid #00a870 !important;
}
.pf-new-theme .border-top-light-green-6-hover:hover {
  border-top: 1px solid #00cf83;
}
.pf-new-theme .border-top-light-green-6-important-hover:hover {
  border-top: 1px solid #00cf83 !important;
}
.pf-new-theme .border-top-light-green-5-hover:hover {
  border-top: 1px solid #23db92;
}
.pf-new-theme .border-top-light-green-5-important-hover:hover {
  border-top: 1px solid #23db92 !important;
}
.pf-new-theme .border-top-light-green-4-hover:hover {
  border-top: 1px solid #4ae8a4;
}
.pf-new-theme .border-top-light-green-4-important-hover:hover {
  border-top: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-top-light-green-3-hover:hover {
  border-top: 1px solid #76f5b9;
}
.pf-new-theme .border-top-light-green-3-important-hover:hover {
  border-top: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-top-light-green-2-hover:hover {
  border-top: 1px solid #a3ffd1;
}
.pf-new-theme .border-top-light-green-2-important-hover:hover {
  border-top: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-top-light-green-1-hover:hover {
  border-top: 1px solid #e6fff1;
}
.pf-new-theme .border-top-light-green-1-important-hover:hover {
  border-top: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-right-light-green-10 {
  border-right: 1px solid #003629;
}
.pf-new-theme .border-right-light-green-10-important {
  border-right: 1px solid #003629 !important;
}
.pf-new-theme .border-right-light-green-9 {
  border-right: 1px solid #005c43;
}
.pf-new-theme .border-right-light-green-9-important {
  border-right: 1px solid #005c43 !important;
}
.pf-new-theme .border-right-light-green-8 {
  border-right: 1px solid #00825b;
}
.pf-new-theme .border-right-light-green-8-important {
  border-right: 1px solid #00825b !important;
}
.pf-new-theme .border-right-light-green-7 {
  border-right: 1px solid #00a870;
}
.pf-new-theme .border-right-light-green-7-important {
  border-right: 1px solid #00a870 !important;
}
.pf-new-theme .border-right-light-green-6 {
  border-right: 1px solid #00cf83;
}
.pf-new-theme .border-right-light-green-6-important {
  border-right: 1px solid #00cf83 !important;
}
.pf-new-theme .border-right-light-green-5 {
  border-right: 1px solid #23db92;
}
.pf-new-theme .border-right-light-green-5-important {
  border-right: 1px solid #23db92 !important;
}
.pf-new-theme .border-right-light-green-4 {
  border-right: 1px solid #4ae8a4;
}
.pf-new-theme .border-right-light-green-4-important {
  border-right: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-right-light-green-3 {
  border-right: 1px solid #76f5b9;
}
.pf-new-theme .border-right-light-green-3-important {
  border-right: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-right-light-green-2 {
  border-right: 1px solid #a3ffd1;
}
.pf-new-theme .border-right-light-green-2-important {
  border-right: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-right-light-green-1 {
  border-right: 1px solid #e6fff1;
}
.pf-new-theme .border-right-light-green-1-important {
  border-right: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-right-light-green-10-hover:hover {
  border-right: 1px solid #003629;
}
.pf-new-theme .border-right-light-green-10-important-hover:hover {
  border-right: 1px solid #003629 !important;
}
.pf-new-theme .border-right-light-green-9-hover:hover {
  border-right: 1px solid #005c43;
}
.pf-new-theme .border-right-light-green-9-important-hover:hover {
  border-right: 1px solid #005c43 !important;
}
.pf-new-theme .border-right-light-green-8-hover:hover {
  border-right: 1px solid #00825b;
}
.pf-new-theme .border-right-light-green-8-important-hover:hover {
  border-right: 1px solid #00825b !important;
}
.pf-new-theme .border-right-light-green-7-hover:hover {
  border-right: 1px solid #00a870;
}
.pf-new-theme .border-right-light-green-7-important-hover:hover {
  border-right: 1px solid #00a870 !important;
}
.pf-new-theme .border-right-light-green-6-hover:hover {
  border-right: 1px solid #00cf83;
}
.pf-new-theme .border-right-light-green-6-important-hover:hover {
  border-right: 1px solid #00cf83 !important;
}
.pf-new-theme .border-right-light-green-5-hover:hover {
  border-right: 1px solid #23db92;
}
.pf-new-theme .border-right-light-green-5-important-hover:hover {
  border-right: 1px solid #23db92 !important;
}
.pf-new-theme .border-right-light-green-4-hover:hover {
  border-right: 1px solid #4ae8a4;
}
.pf-new-theme .border-right-light-green-4-important-hover:hover {
  border-right: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-right-light-green-3-hover:hover {
  border-right: 1px solid #76f5b9;
}
.pf-new-theme .border-right-light-green-3-important-hover:hover {
  border-right: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-right-light-green-2-hover:hover {
  border-right: 1px solid #a3ffd1;
}
.pf-new-theme .border-right-light-green-2-important-hover:hover {
  border-right: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-right-light-green-1-hover:hover {
  border-right: 1px solid #e6fff1;
}
.pf-new-theme .border-right-light-green-1-important-hover:hover {
  border-right: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-bottom-light-green-10 {
  border-bottom: 1px solid #003629;
}
.pf-new-theme .border-bottom-light-green-10-important {
  border-bottom: 1px solid #003629 !important;
}
.pf-new-theme .border-bottom-light-green-9 {
  border-bottom: 1px solid #005c43;
}
.pf-new-theme .border-bottom-light-green-9-important {
  border-bottom: 1px solid #005c43 !important;
}
.pf-new-theme .border-bottom-light-green-8 {
  border-bottom: 1px solid #00825b;
}
.pf-new-theme .border-bottom-light-green-8-important {
  border-bottom: 1px solid #00825b !important;
}
.pf-new-theme .border-bottom-light-green-7 {
  border-bottom: 1px solid #00a870;
}
.pf-new-theme .border-bottom-light-green-7-important {
  border-bottom: 1px solid #00a870 !important;
}
.pf-new-theme .border-bottom-light-green-6 {
  border-bottom: 1px solid #00cf83;
}
.pf-new-theme .border-bottom-light-green-6-important {
  border-bottom: 1px solid #00cf83 !important;
}
.pf-new-theme .border-bottom-light-green-5 {
  border-bottom: 1px solid #23db92;
}
.pf-new-theme .border-bottom-light-green-5-important {
  border-bottom: 1px solid #23db92 !important;
}
.pf-new-theme .border-bottom-light-green-4 {
  border-bottom: 1px solid #4ae8a4;
}
.pf-new-theme .border-bottom-light-green-4-important {
  border-bottom: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-bottom-light-green-3 {
  border-bottom: 1px solid #76f5b9;
}
.pf-new-theme .border-bottom-light-green-3-important {
  border-bottom: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-bottom-light-green-2 {
  border-bottom: 1px solid #a3ffd1;
}
.pf-new-theme .border-bottom-light-green-2-important {
  border-bottom: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-bottom-light-green-1 {
  border-bottom: 1px solid #e6fff1;
}
.pf-new-theme .border-bottom-light-green-1-important {
  border-bottom: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-bottom-light-green-10-hover:hover {
  border-bottom: 1px solid #003629;
}
.pf-new-theme .border-bottom-light-green-10-important-hover:hover {
  border-bottom: 1px solid #003629 !important;
}
.pf-new-theme .border-bottom-light-green-9-hover:hover {
  border-bottom: 1px solid #005c43;
}
.pf-new-theme .border-bottom-light-green-9-important-hover:hover {
  border-bottom: 1px solid #005c43 !important;
}
.pf-new-theme .border-bottom-light-green-8-hover:hover {
  border-bottom: 1px solid #00825b;
}
.pf-new-theme .border-bottom-light-green-8-important-hover:hover {
  border-bottom: 1px solid #00825b !important;
}
.pf-new-theme .border-bottom-light-green-7-hover:hover {
  border-bottom: 1px solid #00a870;
}
.pf-new-theme .border-bottom-light-green-7-important-hover:hover {
  border-bottom: 1px solid #00a870 !important;
}
.pf-new-theme .border-bottom-light-green-6-hover:hover {
  border-bottom: 1px solid #00cf83;
}
.pf-new-theme .border-bottom-light-green-6-important-hover:hover {
  border-bottom: 1px solid #00cf83 !important;
}
.pf-new-theme .border-bottom-light-green-5-hover:hover {
  border-bottom: 1px solid #23db92;
}
.pf-new-theme .border-bottom-light-green-5-important-hover:hover {
  border-bottom: 1px solid #23db92 !important;
}
.pf-new-theme .border-bottom-light-green-4-hover:hover {
  border-bottom: 1px solid #4ae8a4;
}
.pf-new-theme .border-bottom-light-green-4-important-hover:hover {
  border-bottom: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-bottom-light-green-3-hover:hover {
  border-bottom: 1px solid #76f5b9;
}
.pf-new-theme .border-bottom-light-green-3-important-hover:hover {
  border-bottom: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-bottom-light-green-2-hover:hover {
  border-bottom: 1px solid #a3ffd1;
}
.pf-new-theme .border-bottom-light-green-2-important-hover:hover {
  border-bottom: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-bottom-light-green-1-hover:hover {
  border-bottom: 1px solid #e6fff1;
}
.pf-new-theme .border-bottom-light-green-1-important-hover:hover {
  border-bottom: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-left-light-green-10 {
  border-left: 1px solid #003629;
}
.pf-new-theme .border-left-light-green-10-important {
  border-left: 1px solid #003629 !important;
}
.pf-new-theme .border-left-light-green-9 {
  border-left: 1px solid #005c43;
}
.pf-new-theme .border-left-light-green-9-important {
  border-left: 1px solid #005c43 !important;
}
.pf-new-theme .border-left-light-green-8 {
  border-left: 1px solid #00825b;
}
.pf-new-theme .border-left-light-green-8-important {
  border-left: 1px solid #00825b !important;
}
.pf-new-theme .border-left-light-green-7 {
  border-left: 1px solid #00a870;
}
.pf-new-theme .border-left-light-green-7-important {
  border-left: 1px solid #00a870 !important;
}
.pf-new-theme .border-left-light-green-6 {
  border-left: 1px solid #00cf83;
}
.pf-new-theme .border-left-light-green-6-important {
  border-left: 1px solid #00cf83 !important;
}
.pf-new-theme .border-left-light-green-5 {
  border-left: 1px solid #23db92;
}
.pf-new-theme .border-left-light-green-5-important {
  border-left: 1px solid #23db92 !important;
}
.pf-new-theme .border-left-light-green-4 {
  border-left: 1px solid #4ae8a4;
}
.pf-new-theme .border-left-light-green-4-important {
  border-left: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-left-light-green-3 {
  border-left: 1px solid #76f5b9;
}
.pf-new-theme .border-left-light-green-3-important {
  border-left: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-left-light-green-2 {
  border-left: 1px solid #a3ffd1;
}
.pf-new-theme .border-left-light-green-2-important {
  border-left: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-left-light-green-1 {
  border-left: 1px solid #e6fff1;
}
.pf-new-theme .border-left-light-green-1-important {
  border-left: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-left-light-green-10-hover:hover {
  border-left: 1px solid #003629;
}
.pf-new-theme .border-left-light-green-10-important-hover:hover {
  border-left: 1px solid #003629 !important;
}
.pf-new-theme .border-left-light-green-9-hover:hover {
  border-left: 1px solid #005c43;
}
.pf-new-theme .border-left-light-green-9-important-hover:hover {
  border-left: 1px solid #005c43 !important;
}
.pf-new-theme .border-left-light-green-8-hover:hover {
  border-left: 1px solid #00825b;
}
.pf-new-theme .border-left-light-green-8-important-hover:hover {
  border-left: 1px solid #00825b !important;
}
.pf-new-theme .border-left-light-green-7-hover:hover {
  border-left: 1px solid #00a870;
}
.pf-new-theme .border-left-light-green-7-important-hover:hover {
  border-left: 1px solid #00a870 !important;
}
.pf-new-theme .border-left-light-green-6-hover:hover {
  border-left: 1px solid #00cf83;
}
.pf-new-theme .border-left-light-green-6-important-hover:hover {
  border-left: 1px solid #00cf83 !important;
}
.pf-new-theme .border-left-light-green-5-hover:hover {
  border-left: 1px solid #23db92;
}
.pf-new-theme .border-left-light-green-5-important-hover:hover {
  border-left: 1px solid #23db92 !important;
}
.pf-new-theme .border-left-light-green-4-hover:hover {
  border-left: 1px solid #4ae8a4;
}
.pf-new-theme .border-left-light-green-4-important-hover:hover {
  border-left: 1px solid #4ae8a4 !important;
}
.pf-new-theme .border-left-light-green-3-hover:hover {
  border-left: 1px solid #76f5b9;
}
.pf-new-theme .border-left-light-green-3-important-hover:hover {
  border-left: 1px solid #76f5b9 !important;
}
.pf-new-theme .border-left-light-green-2-hover:hover {
  border-left: 1px solid #a3ffd1;
}
.pf-new-theme .border-left-light-green-2-important-hover:hover {
  border-left: 1px solid #a3ffd1 !important;
}
.pf-new-theme .border-left-light-green-1-hover:hover {
  border-left: 1px solid #e6fff1;
}
.pf-new-theme .border-left-light-green-1-important-hover:hover {
  border-left: 1px solid #e6fff1 !important;
}
.pf-new-theme .border-color-light-green-10 {
  border-color:  #003629;
}
.pf-new-theme .border-color-light-green-10-important {
  border-color:  #003629 !important;
}
.pf-new-theme .border-color-light-green-9 {
  border-color:  #005c43;
}
.pf-new-theme .border-color-light-green-9-important {
  border-color:  #005c43 !important;
}
.pf-new-theme .border-color-light-green-8 {
  border-color:  #00825b;
}
.pf-new-theme .border-color-light-green-8-important {
  border-color:  #00825b !important;
}
.pf-new-theme .border-color-light-green-7 {
  border-color:  #00a870;
}
.pf-new-theme .border-color-light-green-7-important {
  border-color:  #00a870 !important;
}
.pf-new-theme .border-color-light-green-6 {
  border-color:  #00cf83;
}
.pf-new-theme .border-color-light-green-6-important {
  border-color:  #00cf83 !important;
}
.pf-new-theme .border-color-light-green-5 {
  border-color:  #23db92;
}
.pf-new-theme .border-color-light-green-5-important {
  border-color:  #23db92 !important;
}
.pf-new-theme .border-color-light-green-4 {
  border-color:  #4ae8a4;
}
.pf-new-theme .border-color-light-green-4-important {
  border-color:  #4ae8a4 !important;
}
.pf-new-theme .border-color-light-green-3 {
  border-color:  #76f5b9;
}
.pf-new-theme .border-color-light-green-3-important {
  border-color:  #76f5b9 !important;
}
.pf-new-theme .border-color-light-green-2 {
  border-color:  #a3ffd1;
}
.pf-new-theme .border-color-light-green-2-important {
  border-color:  #a3ffd1 !important;
}
.pf-new-theme .border-color-light-green-1 {
  border-color:  #e6fff1;
}
.pf-new-theme .border-color-light-green-1-important {
  border-color:  #e6fff1 !important;
}
.pf-new-theme .border-color-light-green-10-hover:hover {
  border-color:  #003629;
}
.pf-new-theme .border-color-light-green-10-important-hover:hover {
  border-color:  #003629 !important;
}
.pf-new-theme .border-color-light-green-9-hover:hover {
  border-color:  #005c43;
}
.pf-new-theme .border-color-light-green-9-important-hover:hover {
  border-color:  #005c43 !important;
}
.pf-new-theme .border-color-light-green-8-hover:hover {
  border-color:  #00825b;
}
.pf-new-theme .border-color-light-green-8-important-hover:hover {
  border-color:  #00825b !important;
}
.pf-new-theme .border-color-light-green-7-hover:hover {
  border-color:  #00a870;
}
.pf-new-theme .border-color-light-green-7-important-hover:hover {
  border-color:  #00a870 !important;
}
.pf-new-theme .border-color-light-green-6-hover:hover {
  border-color:  #00cf83;
}
.pf-new-theme .border-color-light-green-6-important-hover:hover {
  border-color:  #00cf83 !important;
}
.pf-new-theme .border-color-light-green-5-hover:hover {
  border-color:  #23db92;
}
.pf-new-theme .border-color-light-green-5-important-hover:hover {
  border-color:  #23db92 !important;
}
.pf-new-theme .border-color-light-green-4-hover:hover {
  border-color:  #4ae8a4;
}
.pf-new-theme .border-color-light-green-4-important-hover:hover {
  border-color:  #4ae8a4 !important;
}
.pf-new-theme .border-color-light-green-3-hover:hover {
  border-color:  #76f5b9;
}
.pf-new-theme .border-color-light-green-3-important-hover:hover {
  border-color:  #76f5b9 !important;
}
.pf-new-theme .border-color-light-green-2-hover:hover {
  border-color:  #a3ffd1;
}
.pf-new-theme .border-color-light-green-2-important-hover:hover {
  border-color:  #a3ffd1 !important;
}
.pf-new-theme .border-color-light-green-1-hover:hover {
  border-color:  #e6fff1;
}
.pf-new-theme .border-color-light-green-1-important-hover:hover {
  border-color:  #e6fff1 !important;
}
.pf-new-theme .color-magenta-10 {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9 {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8 {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7 {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6 {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5 {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4 {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3 {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2 {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1 {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-hover:hover {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-hover:hover {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-hover:hover {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-hover:hover {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-hover:hover {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-hover:hover {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-hover:hover {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-hover:hover {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-hover:hover {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-hover:hover {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-hover:hover {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-hover:hover {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-hover:hover {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-hover:hover {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-hover:hover {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-hover:hover {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-hover:hover {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-hover:hover {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-hover:hover {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-hover:hover {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-hover.active-hover {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-hover.active-hover {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-hover.active-hover {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-hover.active-hover {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-hover.active-hover {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-hover.active-hover {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-hover.active-hover {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-hover.active-hover {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-hover.active-hover {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-hover.active-hover {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-hover.active-hover {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-hover.active-hover {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-hover.active-hover {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-hover.active-hover {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-hover.active-hover {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-hover.active-hover {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-hover.active-hover {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-hover.active-hover {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-hover.active-hover {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-hover.active-hover {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-hover:focus {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-hover:focus {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-hover:focus {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-hover:focus {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-hover:focus {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-hover:focus {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-hover:focus {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-hover:focus {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-hover:focus {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-hover:focus {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-hover:focus {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-hover:focus {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-hover:focus {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-hover:focus {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-hover:focus {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-hover:focus {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-hover:focus {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-hover:focus {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-hover:focus {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-hover:focus {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-hover.active-focus {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-hover.active-focus {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-hover.active-focus {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-hover.active-focus {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-hover.active-focus {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-hover.active-focus {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-hover.active-focus {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-hover.active-focus {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-hover.active-focus {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-hover.active-focus {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-hover.active-focus {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-hover.active-focus {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-hover.active-focus {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-hover.active-focus {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-hover.active-focus {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-hover.active-focus {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-hover.active-focus {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-hover.active-focus {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-hover.active-focus {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-hover.active-focus {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-focus:focus {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-focus:focus {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-focus:focus {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-focus:focus {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-focus:focus {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-focus:focus {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-focus:focus {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-focus:focus {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-focus:focus {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-focus:focus {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-focus:focus {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-focus:focus {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-focus:focus {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-focus:focus {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-focus:focus {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-focus:focus {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-focus:focus {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-focus:focus {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-focus:focus {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-focus:focus {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-focus.active-focus {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-focus.active-focus {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-focus.active-focus {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-focus.active-focus {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-focus.active-focus {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-focus.active-focus {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-focus.active-focus {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-focus.active-focus {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-focus.active-focus {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-focus.active-focus {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-focus.active-focus {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-focus.active-focus {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-focus.active-focus {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-focus.active-focus {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-focus.active-focus {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-focus.active-focus {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-focus.active-focus {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-focus.active-focus {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-focus.active-focus {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-focus.active-focus {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-placeholder::placeholder {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-placeholder::placeholder {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-placeholder::placeholder {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-placeholder::placeholder {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-placeholder::placeholder {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-placeholder::placeholder {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-placeholder::placeholder {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-placeholder::placeholder {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-placeholder::placeholder {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-placeholder::placeholder {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-placeholder::placeholder {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-placeholder::placeholder {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-placeholder::placeholder {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-placeholder::placeholder {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-placeholder::placeholder {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-placeholder::placeholder {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-placeholder::placeholder {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-placeholder::placeholder {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-placeholder::placeholder {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-placeholder::placeholder {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-magenta-10-placeholder.active-placeholder {
  color:  #61082d;
}
.pf-new-theme .color-magenta-10-important-placeholder.active-placeholder {
  color:  #61082d !important;
}
.pf-new-theme .color-magenta-9-placeholder.active-placeholder {
  color:  #870c3b;
}
.pf-new-theme .color-magenta-9-important-placeholder.active-placeholder {
  color:  #870c3b !important;
}
.pf-new-theme .color-magenta-8-placeholder.active-placeholder {
  color:  #ad184c;
}
.pf-new-theme .color-magenta-8-important-placeholder.active-placeholder {
  color:  #ad184c !important;
}
.pf-new-theme .color-magenta-7-placeholder.active-placeholder {
  color:  #d4285f;
}
.pf-new-theme .color-magenta-7-important-placeholder.active-placeholder {
  color:  #d4285f !important;
}
.pf-new-theme .color-magenta-6-placeholder.active-placeholder {
  color:  #fb3b71;
}
.pf-new-theme .color-magenta-6-important-placeholder.active-placeholder {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-magenta-5-placeholder.active-placeholder {
  color:  #ff668c;
}
.pf-new-theme .color-magenta-5-important-placeholder.active-placeholder {
  color:  #ff668c !important;
}
.pf-new-theme .color-magenta-4-placeholder.active-placeholder {
  color:  #ff8fa7;
}
.pf-new-theme .color-magenta-4-important-placeholder.active-placeholder {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-magenta-3-placeholder.active-placeholder {
  color:  #ffb8c5;
}
.pf-new-theme .color-magenta-3-important-placeholder.active-placeholder {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-magenta-2-placeholder.active-placeholder {
  color:  #ffe0e5;
}
.pf-new-theme .color-magenta-2-important-placeholder.active-placeholder {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-magenta-1-placeholder.active-placeholder {
  color:  #fff0f1;
}
.pf-new-theme .color-magenta-1-important-placeholder.active-placeholder {
  color:  #fff0f1 !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-10-hover {
  color:  #61082d;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-10-important-hover {
  color:  #61082d !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-9-hover {
  color:  #870c3b;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-9-important-hover {
  color:  #870c3b !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-8-hover {
  color:  #ad184c;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-8-important-hover {
  color:  #ad184c !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-7-hover {
  color:  #d4285f;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-7-important-hover {
  color:  #d4285f !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-6-hover {
  color:  #fb3b71;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-6-important-hover {
  color:  #fb3b71 !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-5-hover {
  color:  #ff668c;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-5-important-hover {
  color:  #ff668c !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-4-hover {
  color:  #ff8fa7;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-4-important-hover {
  color:  #ff8fa7 !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-3-hover {
  color:  #ffb8c5;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-3-important-hover {
  color:  #ffb8c5 !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-2-hover {
  color:  #ffe0e5;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-2-important-hover {
  color:  #ffe0e5 !important;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-1-hover {
  color:  #fff0f1;
}
.pf-new-theme .color-hover-parent:hover .color-magenta-1-important-hover {
  color:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10 {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9 {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8 {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7 {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6 {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5 {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4 {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3 {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2 {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1 {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important {
  background:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10-hover:hover {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important-hover:hover {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9-hover:hover {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important-hover:hover {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8-hover:hover {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important-hover:hover {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7-hover:hover {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important-hover:hover {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6-hover:hover {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important-hover:hover {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5-hover:hover {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important-hover:hover {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4-hover:hover {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important-hover:hover {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3-hover:hover {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important-hover:hover {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2-hover:hover {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important-hover:hover {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1-hover:hover {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important-hover:hover {
  background:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10-hover.active-hover {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important-hover.active-hover {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9-hover.active-hover {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important-hover.active-hover {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8-hover.active-hover {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important-hover.active-hover {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7-hover.active-hover {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important-hover.active-hover {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6-hover.active-hover {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important-hover.active-hover {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5-hover.active-hover {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important-hover.active-hover {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4-hover.active-hover {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important-hover.active-hover {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3-hover.active-hover {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important-hover.active-hover {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2-hover.active-hover {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important-hover.active-hover {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1-hover.active-hover {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important-hover.active-hover {
  background:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10-hover:focus {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important-hover:focus {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9-hover:focus {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important-hover:focus {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8-hover:focus {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important-hover:focus {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7-hover:focus {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important-hover:focus {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6-hover:focus {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important-hover:focus {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5-hover:focus {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important-hover:focus {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4-hover:focus {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important-hover:focus {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3-hover:focus {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important-hover:focus {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2-hover:focus {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important-hover:focus {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1-hover:focus {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important-hover:focus {
  background:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10-hover.active-focus {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important-hover.active-focus {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9-hover.active-focus {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important-hover.active-focus {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8-hover.active-focus {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important-hover.active-focus {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7-hover.active-focus {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important-hover.active-focus {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6-hover.active-focus {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important-hover.active-focus {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5-hover.active-focus {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important-hover.active-focus {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4-hover.active-focus {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important-hover.active-focus {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3-hover.active-focus {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important-hover.active-focus {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2-hover.active-focus {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important-hover.active-focus {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1-hover.active-focus {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important-hover.active-focus {
  background:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10-focus:focus {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important-focus:focus {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9-focus:focus {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important-focus:focus {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8-focus:focus {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important-focus:focus {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7-focus:focus {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important-focus:focus {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6-focus:focus {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important-focus:focus {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5-focus:focus {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important-focus:focus {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4-focus:focus {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important-focus:focus {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3-focus:focus {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important-focus:focus {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2-focus:focus {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important-focus:focus {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1-focus:focus {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important-focus:focus {
  background:  #fff0f1 !important;
}
.pf-new-theme .background-magenta-10-focus.active-focus {
  background:  #61082d;
}
.pf-new-theme .background-magenta-10-important-focus.active-focus {
  background:  #61082d !important;
}
.pf-new-theme .background-magenta-9-focus.active-focus {
  background:  #870c3b;
}
.pf-new-theme .background-magenta-9-important-focus.active-focus {
  background:  #870c3b !important;
}
.pf-new-theme .background-magenta-8-focus.active-focus {
  background:  #ad184c;
}
.pf-new-theme .background-magenta-8-important-focus.active-focus {
  background:  #ad184c !important;
}
.pf-new-theme .background-magenta-7-focus.active-focus {
  background:  #d4285f;
}
.pf-new-theme .background-magenta-7-important-focus.active-focus {
  background:  #d4285f !important;
}
.pf-new-theme .background-magenta-6-focus.active-focus {
  background:  #fb3b71;
}
.pf-new-theme .background-magenta-6-important-focus.active-focus {
  background:  #fb3b71 !important;
}
.pf-new-theme .background-magenta-5-focus.active-focus {
  background:  #ff668c;
}
.pf-new-theme .background-magenta-5-important-focus.active-focus {
  background:  #ff668c !important;
}
.pf-new-theme .background-magenta-4-focus.active-focus {
  background:  #ff8fa7;
}
.pf-new-theme .background-magenta-4-important-focus.active-focus {
  background:  #ff8fa7 !important;
}
.pf-new-theme .background-magenta-3-focus.active-focus {
  background:  #ffb8c5;
}
.pf-new-theme .background-magenta-3-important-focus.active-focus {
  background:  #ffb8c5 !important;
}
.pf-new-theme .background-magenta-2-focus.active-focus {
  background:  #ffe0e5;
}
.pf-new-theme .background-magenta-2-important-focus.active-focus {
  background:  #ffe0e5 !important;
}
.pf-new-theme .background-magenta-1-focus.active-focus {
  background:  #fff0f1;
}
.pf-new-theme .background-magenta-1-important-focus.active-focus {
  background:  #fff0f1 !important;
}
.pf-new-theme .border-magenta-10 {
  border: 1px solid #61082d;
}
.pf-new-theme .border-magenta-10-important {
  border: 1px solid #61082d !important;
}
.pf-new-theme .border-magenta-9 {
  border: 1px solid #870c3b;
}
.pf-new-theme .border-magenta-9-important {
  border: 1px solid #870c3b !important;
}
.pf-new-theme .border-magenta-8 {
  border: 1px solid #ad184c;
}
.pf-new-theme .border-magenta-8-important {
  border: 1px solid #ad184c !important;
}
.pf-new-theme .border-magenta-7 {
  border: 1px solid #d4285f;
}
.pf-new-theme .border-magenta-7-important {
  border: 1px solid #d4285f !important;
}
.pf-new-theme .border-magenta-6 {
  border: 1px solid #fb3b71;
}
.pf-new-theme .border-magenta-6-important {
  border: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-magenta-5 {
  border: 1px solid #ff668c;
}
.pf-new-theme .border-magenta-5-important {
  border: 1px solid #ff668c !important;
}
.pf-new-theme .border-magenta-4 {
  border: 1px solid #ff8fa7;
}
.pf-new-theme .border-magenta-4-important {
  border: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-magenta-3 {
  border: 1px solid #ffb8c5;
}
.pf-new-theme .border-magenta-3-important {
  border: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-magenta-2 {
  border: 1px solid #ffe0e5;
}
.pf-new-theme .border-magenta-2-important {
  border: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-magenta-1 {
  border: 1px solid #fff0f1;
}
.pf-new-theme .border-magenta-1-important {
  border: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-magenta-10-hover:hover {
  border: 1px solid #61082d;
}
.pf-new-theme .border-magenta-10-important-hover:hover {
  border: 1px solid #61082d !important;
}
.pf-new-theme .border-magenta-9-hover:hover {
  border: 1px solid #870c3b;
}
.pf-new-theme .border-magenta-9-important-hover:hover {
  border: 1px solid #870c3b !important;
}
.pf-new-theme .border-magenta-8-hover:hover {
  border: 1px solid #ad184c;
}
.pf-new-theme .border-magenta-8-important-hover:hover {
  border: 1px solid #ad184c !important;
}
.pf-new-theme .border-magenta-7-hover:hover {
  border: 1px solid #d4285f;
}
.pf-new-theme .border-magenta-7-important-hover:hover {
  border: 1px solid #d4285f !important;
}
.pf-new-theme .border-magenta-6-hover:hover {
  border: 1px solid #fb3b71;
}
.pf-new-theme .border-magenta-6-important-hover:hover {
  border: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-magenta-5-hover:hover {
  border: 1px solid #ff668c;
}
.pf-new-theme .border-magenta-5-important-hover:hover {
  border: 1px solid #ff668c !important;
}
.pf-new-theme .border-magenta-4-hover:hover {
  border: 1px solid #ff8fa7;
}
.pf-new-theme .border-magenta-4-important-hover:hover {
  border: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-magenta-3-hover:hover {
  border: 1px solid #ffb8c5;
}
.pf-new-theme .border-magenta-3-important-hover:hover {
  border: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-magenta-2-hover:hover {
  border: 1px solid #ffe0e5;
}
.pf-new-theme .border-magenta-2-important-hover:hover {
  border: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-magenta-1-hover:hover {
  border: 1px solid #fff0f1;
}
.pf-new-theme .border-magenta-1-important-hover:hover {
  border: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-magenta-10-focus:focus {
  border: 1px solid #61082d;
}
.pf-new-theme .border-magenta-10-important-focus:focus {
  border: 1px solid #61082d !important;
}
.pf-new-theme .border-magenta-9-focus:focus {
  border: 1px solid #870c3b;
}
.pf-new-theme .border-magenta-9-important-focus:focus {
  border: 1px solid #870c3b !important;
}
.pf-new-theme .border-magenta-8-focus:focus {
  border: 1px solid #ad184c;
}
.pf-new-theme .border-magenta-8-important-focus:focus {
  border: 1px solid #ad184c !important;
}
.pf-new-theme .border-magenta-7-focus:focus {
  border: 1px solid #d4285f;
}
.pf-new-theme .border-magenta-7-important-focus:focus {
  border: 1px solid #d4285f !important;
}
.pf-new-theme .border-magenta-6-focus:focus {
  border: 1px solid #fb3b71;
}
.pf-new-theme .border-magenta-6-important-focus:focus {
  border: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-magenta-5-focus:focus {
  border: 1px solid #ff668c;
}
.pf-new-theme .border-magenta-5-important-focus:focus {
  border: 1px solid #ff668c !important;
}
.pf-new-theme .border-magenta-4-focus:focus {
  border: 1px solid #ff8fa7;
}
.pf-new-theme .border-magenta-4-important-focus:focus {
  border: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-magenta-3-focus:focus {
  border: 1px solid #ffb8c5;
}
.pf-new-theme .border-magenta-3-important-focus:focus {
  border: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-magenta-2-focus:focus {
  border: 1px solid #ffe0e5;
}
.pf-new-theme .border-magenta-2-important-focus:focus {
  border: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-magenta-1-focus:focus {
  border: 1px solid #fff0f1;
}
.pf-new-theme .border-magenta-1-important-focus:focus {
  border: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-top-magenta-10 {
  border-top: 1px solid #61082d;
}
.pf-new-theme .border-top-magenta-10-important {
  border-top: 1px solid #61082d !important;
}
.pf-new-theme .border-top-magenta-9 {
  border-top: 1px solid #870c3b;
}
.pf-new-theme .border-top-magenta-9-important {
  border-top: 1px solid #870c3b !important;
}
.pf-new-theme .border-top-magenta-8 {
  border-top: 1px solid #ad184c;
}
.pf-new-theme .border-top-magenta-8-important {
  border-top: 1px solid #ad184c !important;
}
.pf-new-theme .border-top-magenta-7 {
  border-top: 1px solid #d4285f;
}
.pf-new-theme .border-top-magenta-7-important {
  border-top: 1px solid #d4285f !important;
}
.pf-new-theme .border-top-magenta-6 {
  border-top: 1px solid #fb3b71;
}
.pf-new-theme .border-top-magenta-6-important {
  border-top: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-top-magenta-5 {
  border-top: 1px solid #ff668c;
}
.pf-new-theme .border-top-magenta-5-important {
  border-top: 1px solid #ff668c !important;
}
.pf-new-theme .border-top-magenta-4 {
  border-top: 1px solid #ff8fa7;
}
.pf-new-theme .border-top-magenta-4-important {
  border-top: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-top-magenta-3 {
  border-top: 1px solid #ffb8c5;
}
.pf-new-theme .border-top-magenta-3-important {
  border-top: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-top-magenta-2 {
  border-top: 1px solid #ffe0e5;
}
.pf-new-theme .border-top-magenta-2-important {
  border-top: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-top-magenta-1 {
  border-top: 1px solid #fff0f1;
}
.pf-new-theme .border-top-magenta-1-important {
  border-top: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-top-magenta-10-hover:hover {
  border-top: 1px solid #61082d;
}
.pf-new-theme .border-top-magenta-10-important-hover:hover {
  border-top: 1px solid #61082d !important;
}
.pf-new-theme .border-top-magenta-9-hover:hover {
  border-top: 1px solid #870c3b;
}
.pf-new-theme .border-top-magenta-9-important-hover:hover {
  border-top: 1px solid #870c3b !important;
}
.pf-new-theme .border-top-magenta-8-hover:hover {
  border-top: 1px solid #ad184c;
}
.pf-new-theme .border-top-magenta-8-important-hover:hover {
  border-top: 1px solid #ad184c !important;
}
.pf-new-theme .border-top-magenta-7-hover:hover {
  border-top: 1px solid #d4285f;
}
.pf-new-theme .border-top-magenta-7-important-hover:hover {
  border-top: 1px solid #d4285f !important;
}
.pf-new-theme .border-top-magenta-6-hover:hover {
  border-top: 1px solid #fb3b71;
}
.pf-new-theme .border-top-magenta-6-important-hover:hover {
  border-top: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-top-magenta-5-hover:hover {
  border-top: 1px solid #ff668c;
}
.pf-new-theme .border-top-magenta-5-important-hover:hover {
  border-top: 1px solid #ff668c !important;
}
.pf-new-theme .border-top-magenta-4-hover:hover {
  border-top: 1px solid #ff8fa7;
}
.pf-new-theme .border-top-magenta-4-important-hover:hover {
  border-top: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-top-magenta-3-hover:hover {
  border-top: 1px solid #ffb8c5;
}
.pf-new-theme .border-top-magenta-3-important-hover:hover {
  border-top: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-top-magenta-2-hover:hover {
  border-top: 1px solid #ffe0e5;
}
.pf-new-theme .border-top-magenta-2-important-hover:hover {
  border-top: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-top-magenta-1-hover:hover {
  border-top: 1px solid #fff0f1;
}
.pf-new-theme .border-top-magenta-1-important-hover:hover {
  border-top: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-right-magenta-10 {
  border-right: 1px solid #61082d;
}
.pf-new-theme .border-right-magenta-10-important {
  border-right: 1px solid #61082d !important;
}
.pf-new-theme .border-right-magenta-9 {
  border-right: 1px solid #870c3b;
}
.pf-new-theme .border-right-magenta-9-important {
  border-right: 1px solid #870c3b !important;
}
.pf-new-theme .border-right-magenta-8 {
  border-right: 1px solid #ad184c;
}
.pf-new-theme .border-right-magenta-8-important {
  border-right: 1px solid #ad184c !important;
}
.pf-new-theme .border-right-magenta-7 {
  border-right: 1px solid #d4285f;
}
.pf-new-theme .border-right-magenta-7-important {
  border-right: 1px solid #d4285f !important;
}
.pf-new-theme .border-right-magenta-6 {
  border-right: 1px solid #fb3b71;
}
.pf-new-theme .border-right-magenta-6-important {
  border-right: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-right-magenta-5 {
  border-right: 1px solid #ff668c;
}
.pf-new-theme .border-right-magenta-5-important {
  border-right: 1px solid #ff668c !important;
}
.pf-new-theme .border-right-magenta-4 {
  border-right: 1px solid #ff8fa7;
}
.pf-new-theme .border-right-magenta-4-important {
  border-right: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-right-magenta-3 {
  border-right: 1px solid #ffb8c5;
}
.pf-new-theme .border-right-magenta-3-important {
  border-right: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-right-magenta-2 {
  border-right: 1px solid #ffe0e5;
}
.pf-new-theme .border-right-magenta-2-important {
  border-right: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-right-magenta-1 {
  border-right: 1px solid #fff0f1;
}
.pf-new-theme .border-right-magenta-1-important {
  border-right: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-right-magenta-10-hover:hover {
  border-right: 1px solid #61082d;
}
.pf-new-theme .border-right-magenta-10-important-hover:hover {
  border-right: 1px solid #61082d !important;
}
.pf-new-theme .border-right-magenta-9-hover:hover {
  border-right: 1px solid #870c3b;
}
.pf-new-theme .border-right-magenta-9-important-hover:hover {
  border-right: 1px solid #870c3b !important;
}
.pf-new-theme .border-right-magenta-8-hover:hover {
  border-right: 1px solid #ad184c;
}
.pf-new-theme .border-right-magenta-8-important-hover:hover {
  border-right: 1px solid #ad184c !important;
}
.pf-new-theme .border-right-magenta-7-hover:hover {
  border-right: 1px solid #d4285f;
}
.pf-new-theme .border-right-magenta-7-important-hover:hover {
  border-right: 1px solid #d4285f !important;
}
.pf-new-theme .border-right-magenta-6-hover:hover {
  border-right: 1px solid #fb3b71;
}
.pf-new-theme .border-right-magenta-6-important-hover:hover {
  border-right: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-right-magenta-5-hover:hover {
  border-right: 1px solid #ff668c;
}
.pf-new-theme .border-right-magenta-5-important-hover:hover {
  border-right: 1px solid #ff668c !important;
}
.pf-new-theme .border-right-magenta-4-hover:hover {
  border-right: 1px solid #ff8fa7;
}
.pf-new-theme .border-right-magenta-4-important-hover:hover {
  border-right: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-right-magenta-3-hover:hover {
  border-right: 1px solid #ffb8c5;
}
.pf-new-theme .border-right-magenta-3-important-hover:hover {
  border-right: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-right-magenta-2-hover:hover {
  border-right: 1px solid #ffe0e5;
}
.pf-new-theme .border-right-magenta-2-important-hover:hover {
  border-right: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-right-magenta-1-hover:hover {
  border-right: 1px solid #fff0f1;
}
.pf-new-theme .border-right-magenta-1-important-hover:hover {
  border-right: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-bottom-magenta-10 {
  border-bottom: 1px solid #61082d;
}
.pf-new-theme .border-bottom-magenta-10-important {
  border-bottom: 1px solid #61082d !important;
}
.pf-new-theme .border-bottom-magenta-9 {
  border-bottom: 1px solid #870c3b;
}
.pf-new-theme .border-bottom-magenta-9-important {
  border-bottom: 1px solid #870c3b !important;
}
.pf-new-theme .border-bottom-magenta-8 {
  border-bottom: 1px solid #ad184c;
}
.pf-new-theme .border-bottom-magenta-8-important {
  border-bottom: 1px solid #ad184c !important;
}
.pf-new-theme .border-bottom-magenta-7 {
  border-bottom: 1px solid #d4285f;
}
.pf-new-theme .border-bottom-magenta-7-important {
  border-bottom: 1px solid #d4285f !important;
}
.pf-new-theme .border-bottom-magenta-6 {
  border-bottom: 1px solid #fb3b71;
}
.pf-new-theme .border-bottom-magenta-6-important {
  border-bottom: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-bottom-magenta-5 {
  border-bottom: 1px solid #ff668c;
}
.pf-new-theme .border-bottom-magenta-5-important {
  border-bottom: 1px solid #ff668c !important;
}
.pf-new-theme .border-bottom-magenta-4 {
  border-bottom: 1px solid #ff8fa7;
}
.pf-new-theme .border-bottom-magenta-4-important {
  border-bottom: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-bottom-magenta-3 {
  border-bottom: 1px solid #ffb8c5;
}
.pf-new-theme .border-bottom-magenta-3-important {
  border-bottom: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-bottom-magenta-2 {
  border-bottom: 1px solid #ffe0e5;
}
.pf-new-theme .border-bottom-magenta-2-important {
  border-bottom: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-bottom-magenta-1 {
  border-bottom: 1px solid #fff0f1;
}
.pf-new-theme .border-bottom-magenta-1-important {
  border-bottom: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-bottom-magenta-10-hover:hover {
  border-bottom: 1px solid #61082d;
}
.pf-new-theme .border-bottom-magenta-10-important-hover:hover {
  border-bottom: 1px solid #61082d !important;
}
.pf-new-theme .border-bottom-magenta-9-hover:hover {
  border-bottom: 1px solid #870c3b;
}
.pf-new-theme .border-bottom-magenta-9-important-hover:hover {
  border-bottom: 1px solid #870c3b !important;
}
.pf-new-theme .border-bottom-magenta-8-hover:hover {
  border-bottom: 1px solid #ad184c;
}
.pf-new-theme .border-bottom-magenta-8-important-hover:hover {
  border-bottom: 1px solid #ad184c !important;
}
.pf-new-theme .border-bottom-magenta-7-hover:hover {
  border-bottom: 1px solid #d4285f;
}
.pf-new-theme .border-bottom-magenta-7-important-hover:hover {
  border-bottom: 1px solid #d4285f !important;
}
.pf-new-theme .border-bottom-magenta-6-hover:hover {
  border-bottom: 1px solid #fb3b71;
}
.pf-new-theme .border-bottom-magenta-6-important-hover:hover {
  border-bottom: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-bottom-magenta-5-hover:hover {
  border-bottom: 1px solid #ff668c;
}
.pf-new-theme .border-bottom-magenta-5-important-hover:hover {
  border-bottom: 1px solid #ff668c !important;
}
.pf-new-theme .border-bottom-magenta-4-hover:hover {
  border-bottom: 1px solid #ff8fa7;
}
.pf-new-theme .border-bottom-magenta-4-important-hover:hover {
  border-bottom: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-bottom-magenta-3-hover:hover {
  border-bottom: 1px solid #ffb8c5;
}
.pf-new-theme .border-bottom-magenta-3-important-hover:hover {
  border-bottom: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-bottom-magenta-2-hover:hover {
  border-bottom: 1px solid #ffe0e5;
}
.pf-new-theme .border-bottom-magenta-2-important-hover:hover {
  border-bottom: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-bottom-magenta-1-hover:hover {
  border-bottom: 1px solid #fff0f1;
}
.pf-new-theme .border-bottom-magenta-1-important-hover:hover {
  border-bottom: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-left-magenta-10 {
  border-left: 1px solid #61082d;
}
.pf-new-theme .border-left-magenta-10-important {
  border-left: 1px solid #61082d !important;
}
.pf-new-theme .border-left-magenta-9 {
  border-left: 1px solid #870c3b;
}
.pf-new-theme .border-left-magenta-9-important {
  border-left: 1px solid #870c3b !important;
}
.pf-new-theme .border-left-magenta-8 {
  border-left: 1px solid #ad184c;
}
.pf-new-theme .border-left-magenta-8-important {
  border-left: 1px solid #ad184c !important;
}
.pf-new-theme .border-left-magenta-7 {
  border-left: 1px solid #d4285f;
}
.pf-new-theme .border-left-magenta-7-important {
  border-left: 1px solid #d4285f !important;
}
.pf-new-theme .border-left-magenta-6 {
  border-left: 1px solid #fb3b71;
}
.pf-new-theme .border-left-magenta-6-important {
  border-left: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-left-magenta-5 {
  border-left: 1px solid #ff668c;
}
.pf-new-theme .border-left-magenta-5-important {
  border-left: 1px solid #ff668c !important;
}
.pf-new-theme .border-left-magenta-4 {
  border-left: 1px solid #ff8fa7;
}
.pf-new-theme .border-left-magenta-4-important {
  border-left: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-left-magenta-3 {
  border-left: 1px solid #ffb8c5;
}
.pf-new-theme .border-left-magenta-3-important {
  border-left: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-left-magenta-2 {
  border-left: 1px solid #ffe0e5;
}
.pf-new-theme .border-left-magenta-2-important {
  border-left: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-left-magenta-1 {
  border-left: 1px solid #fff0f1;
}
.pf-new-theme .border-left-magenta-1-important {
  border-left: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-left-magenta-10-hover:hover {
  border-left: 1px solid #61082d;
}
.pf-new-theme .border-left-magenta-10-important-hover:hover {
  border-left: 1px solid #61082d !important;
}
.pf-new-theme .border-left-magenta-9-hover:hover {
  border-left: 1px solid #870c3b;
}
.pf-new-theme .border-left-magenta-9-important-hover:hover {
  border-left: 1px solid #870c3b !important;
}
.pf-new-theme .border-left-magenta-8-hover:hover {
  border-left: 1px solid #ad184c;
}
.pf-new-theme .border-left-magenta-8-important-hover:hover {
  border-left: 1px solid #ad184c !important;
}
.pf-new-theme .border-left-magenta-7-hover:hover {
  border-left: 1px solid #d4285f;
}
.pf-new-theme .border-left-magenta-7-important-hover:hover {
  border-left: 1px solid #d4285f !important;
}
.pf-new-theme .border-left-magenta-6-hover:hover {
  border-left: 1px solid #fb3b71;
}
.pf-new-theme .border-left-magenta-6-important-hover:hover {
  border-left: 1px solid #fb3b71 !important;
}
.pf-new-theme .border-left-magenta-5-hover:hover {
  border-left: 1px solid #ff668c;
}
.pf-new-theme .border-left-magenta-5-important-hover:hover {
  border-left: 1px solid #ff668c !important;
}
.pf-new-theme .border-left-magenta-4-hover:hover {
  border-left: 1px solid #ff8fa7;
}
.pf-new-theme .border-left-magenta-4-important-hover:hover {
  border-left: 1px solid #ff8fa7 !important;
}
.pf-new-theme .border-left-magenta-3-hover:hover {
  border-left: 1px solid #ffb8c5;
}
.pf-new-theme .border-left-magenta-3-important-hover:hover {
  border-left: 1px solid #ffb8c5 !important;
}
.pf-new-theme .border-left-magenta-2-hover:hover {
  border-left: 1px solid #ffe0e5;
}
.pf-new-theme .border-left-magenta-2-important-hover:hover {
  border-left: 1px solid #ffe0e5 !important;
}
.pf-new-theme .border-left-magenta-1-hover:hover {
  border-left: 1px solid #fff0f1;
}
.pf-new-theme .border-left-magenta-1-important-hover:hover {
  border-left: 1px solid #fff0f1 !important;
}
.pf-new-theme .border-color-magenta-10 {
  border-color:  #61082d;
}
.pf-new-theme .border-color-magenta-10-important {
  border-color:  #61082d !important;
}
.pf-new-theme .border-color-magenta-9 {
  border-color:  #870c3b;
}
.pf-new-theme .border-color-magenta-9-important {
  border-color:  #870c3b !important;
}
.pf-new-theme .border-color-magenta-8 {
  border-color:  #ad184c;
}
.pf-new-theme .border-color-magenta-8-important {
  border-color:  #ad184c !important;
}
.pf-new-theme .border-color-magenta-7 {
  border-color:  #d4285f;
}
.pf-new-theme .border-color-magenta-7-important {
  border-color:  #d4285f !important;
}
.pf-new-theme .border-color-magenta-6 {
  border-color:  #fb3b71;
}
.pf-new-theme .border-color-magenta-6-important {
  border-color:  #fb3b71 !important;
}
.pf-new-theme .border-color-magenta-5 {
  border-color:  #ff668c;
}
.pf-new-theme .border-color-magenta-5-important {
  border-color:  #ff668c !important;
}
.pf-new-theme .border-color-magenta-4 {
  border-color:  #ff8fa7;
}
.pf-new-theme .border-color-magenta-4-important {
  border-color:  #ff8fa7 !important;
}
.pf-new-theme .border-color-magenta-3 {
  border-color:  #ffb8c5;
}
.pf-new-theme .border-color-magenta-3-important {
  border-color:  #ffb8c5 !important;
}
.pf-new-theme .border-color-magenta-2 {
  border-color:  #ffe0e5;
}
.pf-new-theme .border-color-magenta-2-important {
  border-color:  #ffe0e5 !important;
}
.pf-new-theme .border-color-magenta-1 {
  border-color:  #fff0f1;
}
.pf-new-theme .border-color-magenta-1-important {
  border-color:  #fff0f1 !important;
}
.pf-new-theme .border-color-magenta-10-hover:hover {
  border-color:  #61082d;
}
.pf-new-theme .border-color-magenta-10-important-hover:hover {
  border-color:  #61082d !important;
}
.pf-new-theme .border-color-magenta-9-hover:hover {
  border-color:  #870c3b;
}
.pf-new-theme .border-color-magenta-9-important-hover:hover {
  border-color:  #870c3b !important;
}
.pf-new-theme .border-color-magenta-8-hover:hover {
  border-color:  #ad184c;
}
.pf-new-theme .border-color-magenta-8-important-hover:hover {
  border-color:  #ad184c !important;
}
.pf-new-theme .border-color-magenta-7-hover:hover {
  border-color:  #d4285f;
}
.pf-new-theme .border-color-magenta-7-important-hover:hover {
  border-color:  #d4285f !important;
}
.pf-new-theme .border-color-magenta-6-hover:hover {
  border-color:  #fb3b71;
}
.pf-new-theme .border-color-magenta-6-important-hover:hover {
  border-color:  #fb3b71 !important;
}
.pf-new-theme .border-color-magenta-5-hover:hover {
  border-color:  #ff668c;
}
.pf-new-theme .border-color-magenta-5-important-hover:hover {
  border-color:  #ff668c !important;
}
.pf-new-theme .border-color-magenta-4-hover:hover {
  border-color:  #ff8fa7;
}
.pf-new-theme .border-color-magenta-4-important-hover:hover {
  border-color:  #ff8fa7 !important;
}
.pf-new-theme .border-color-magenta-3-hover:hover {
  border-color:  #ffb8c5;
}
.pf-new-theme .border-color-magenta-3-important-hover:hover {
  border-color:  #ffb8c5 !important;
}
.pf-new-theme .border-color-magenta-2-hover:hover {
  border-color:  #ffe0e5;
}
.pf-new-theme .border-color-magenta-2-important-hover:hover {
  border-color:  #ffe0e5 !important;
}
.pf-new-theme .border-color-magenta-1-hover:hover {
  border-color:  #fff0f1;
}
.pf-new-theme .border-color-magenta-1-important-hover:hover {
  border-color:  #fff0f1 !important;
}
.pf-new-theme .color-red-10 {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9 {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8 {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7 {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6 {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5 {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4 {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3 {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2 {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1 {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-hover:hover {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-hover:hover {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-hover:hover {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-hover:hover {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-hover:hover {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-hover:hover {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-hover:hover {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-hover:hover {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-hover:hover {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-hover:hover {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-hover:hover {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-hover:hover {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-hover:hover {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-hover:hover {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-hover:hover {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-hover:hover {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-hover:hover {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-hover:hover {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-hover:hover {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-hover:hover {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-hover.active-hover {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-hover.active-hover {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-hover.active-hover {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-hover.active-hover {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-hover.active-hover {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-hover.active-hover {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-hover.active-hover {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-hover.active-hover {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-hover.active-hover {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-hover.active-hover {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-hover.active-hover {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-hover.active-hover {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-hover.active-hover {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-hover.active-hover {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-hover.active-hover {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-hover.active-hover {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-hover.active-hover {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-hover.active-hover {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-hover.active-hover {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-hover.active-hover {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-hover:focus {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-hover:focus {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-hover:focus {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-hover:focus {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-hover:focus {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-hover:focus {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-hover:focus {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-hover:focus {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-hover:focus {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-hover:focus {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-hover:focus {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-hover:focus {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-hover:focus {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-hover:focus {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-hover:focus {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-hover:focus {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-hover:focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-hover:focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-hover:focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-hover:focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-hover.active-focus {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-hover.active-focus {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-hover.active-focus {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-hover.active-focus {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-hover.active-focus {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-hover.active-focus {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-hover.active-focus {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-hover.active-focus {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-hover.active-focus {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-hover.active-focus {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-hover.active-focus {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-hover.active-focus {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-hover.active-focus {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-hover.active-focus {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-hover.active-focus {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-hover.active-focus {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-hover.active-focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-hover.active-focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-hover.active-focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-hover.active-focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-focus:focus {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-focus:focus {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-focus:focus {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-focus:focus {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-focus:focus {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-focus:focus {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-focus:focus {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-focus:focus {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-focus:focus {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-focus:focus {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-focus:focus {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-focus:focus {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-focus:focus {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-focus:focus {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-focus:focus {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-focus:focus {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-focus:focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-focus:focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-focus:focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-focus:focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-focus.active-focus {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-focus.active-focus {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-focus.active-focus {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-focus.active-focus {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-focus.active-focus {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-focus.active-focus {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-focus.active-focus {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-focus.active-focus {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-focus.active-focus {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-focus.active-focus {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-focus.active-focus {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-focus.active-focus {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-focus.active-focus {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-focus.active-focus {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-focus.active-focus {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-focus.active-focus {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-focus.active-focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-focus.active-focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-focus.active-focus {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-focus.active-focus {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-placeholder::placeholder {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-placeholder::placeholder {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-placeholder::placeholder {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-placeholder::placeholder {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-placeholder::placeholder {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-placeholder::placeholder {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-placeholder::placeholder {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-placeholder::placeholder {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-placeholder::placeholder {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-placeholder::placeholder {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-placeholder::placeholder {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-placeholder::placeholder {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-placeholder::placeholder {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-placeholder::placeholder {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-placeholder::placeholder {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-placeholder::placeholder {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-placeholder::placeholder {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-placeholder::placeholder {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-placeholder::placeholder {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-placeholder::placeholder {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-10-placeholder.active-placeholder {
  color:  #59121f;
}
.pf-new-theme .color-red-10-important-placeholder.active-placeholder {
  color:  #59121f !important;
}
.pf-new-theme .color-red-9-placeholder.active-placeholder {
  color:  #801b2a;
}
.pf-new-theme .color-red-9-important-placeholder.active-placeholder {
  color:  #801b2a !important;
}
.pf-new-theme .color-red-8-placeholder.active-placeholder {
  color:  #a62b39;
}
.pf-new-theme .color-red-8-important-placeholder.active-placeholder {
  color:  #a62b39 !important;
}
.pf-new-theme .color-red-7-placeholder.active-placeholder {
  color:  #cc3f4b;
}
.pf-new-theme .color-red-7-important-placeholder.active-placeholder {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-red-6-placeholder.active-placeholder {
  color:  #f1565d;
}
.pf-new-theme .color-red-6-important-placeholder.active-placeholder {
  color:  #f1565d !important;
}
.pf-new-theme .color-red-5-placeholder.active-placeholder {
  color:  #ff8587;
}
.pf-new-theme .color-red-5-important-placeholder.active-placeholder {
  color:  #ff8587 !important;
}
.pf-new-theme .color-red-4-placeholder.active-placeholder {
  color:  #ffafad;
}
.pf-new-theme .color-red-4-important-placeholder.active-placeholder {
  color:  #ffafad !important;
}
.pf-new-theme .color-red-3-placeholder.active-placeholder {
  color:  #ffd8d6;
}
.pf-new-theme .color-red-3-important-placeholder.active-placeholder {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-red-2-placeholder.active-placeholder {
  color:  #fff1f0;
}
.pf-new-theme .color-red-2-important-placeholder.active-placeholder {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-red-1-placeholder.active-placeholder {
  color:  #fff1f0;
}
.pf-new-theme .color-red-1-important-placeholder.active-placeholder {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-10-hover {
  color:  #59121f;
}
.pf-new-theme .color-hover-parent:hover .color-red-10-important-hover {
  color:  #59121f !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-9-hover {
  color:  #801b2a;
}
.pf-new-theme .color-hover-parent:hover .color-red-9-important-hover {
  color:  #801b2a !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-8-hover {
  color:  #a62b39;
}
.pf-new-theme .color-hover-parent:hover .color-red-8-important-hover {
  color:  #a62b39 !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-7-hover {
  color:  #cc3f4b;
}
.pf-new-theme .color-hover-parent:hover .color-red-7-important-hover {
  color:  #cc3f4b !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-6-hover {
  color:  #f1565d;
}
.pf-new-theme .color-hover-parent:hover .color-red-6-important-hover {
  color:  #f1565d !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-5-hover {
  color:  #ff8587;
}
.pf-new-theme .color-hover-parent:hover .color-red-5-important-hover {
  color:  #ff8587 !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-4-hover {
  color:  #ffafad;
}
.pf-new-theme .color-hover-parent:hover .color-red-4-important-hover {
  color:  #ffafad !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-3-hover {
  color:  #ffd8d6;
}
.pf-new-theme .color-hover-parent:hover .color-red-3-important-hover {
  color:  #ffd8d6 !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-2-hover {
  color:  #fff1f0;
}
.pf-new-theme .color-hover-parent:hover .color-red-2-important-hover {
  color:  #fff1f0 !important;
}
.pf-new-theme .color-hover-parent:hover .color-red-1-hover {
  color:  #fff1f0;
}
.pf-new-theme .color-hover-parent:hover .color-red-1-important-hover {
  color:  #fff1f0 !important;
}
.pf-new-theme .background-red-10 {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9 {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8 {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7 {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6 {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5 {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4 {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3 {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2 {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1 {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-10-hover:hover {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important-hover:hover {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9-hover:hover {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important-hover:hover {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8-hover:hover {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important-hover:hover {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7-hover:hover {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important-hover:hover {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6-hover:hover {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important-hover:hover {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5-hover:hover {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important-hover:hover {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4-hover:hover {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important-hover:hover {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3-hover:hover {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important-hover:hover {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2-hover:hover {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important-hover:hover {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1-hover:hover {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important-hover:hover {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-10-hover.active-hover {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important-hover.active-hover {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9-hover.active-hover {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important-hover.active-hover {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8-hover.active-hover {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important-hover.active-hover {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7-hover.active-hover {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important-hover.active-hover {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6-hover.active-hover {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important-hover.active-hover {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5-hover.active-hover {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important-hover.active-hover {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4-hover.active-hover {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important-hover.active-hover {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3-hover.active-hover {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important-hover.active-hover {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2-hover.active-hover {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important-hover.active-hover {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1-hover.active-hover {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important-hover.active-hover {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-10-hover:focus {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important-hover:focus {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9-hover:focus {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important-hover:focus {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8-hover:focus {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important-hover:focus {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7-hover:focus {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important-hover:focus {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6-hover:focus {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important-hover:focus {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5-hover:focus {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important-hover:focus {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4-hover:focus {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important-hover:focus {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3-hover:focus {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important-hover:focus {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2-hover:focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important-hover:focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1-hover:focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important-hover:focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-10-hover.active-focus {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important-hover.active-focus {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9-hover.active-focus {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important-hover.active-focus {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8-hover.active-focus {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important-hover.active-focus {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7-hover.active-focus {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important-hover.active-focus {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6-hover.active-focus {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important-hover.active-focus {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5-hover.active-focus {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important-hover.active-focus {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4-hover.active-focus {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important-hover.active-focus {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3-hover.active-focus {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important-hover.active-focus {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2-hover.active-focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important-hover.active-focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1-hover.active-focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important-hover.active-focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-10-focus:focus {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important-focus:focus {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9-focus:focus {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important-focus:focus {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8-focus:focus {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important-focus:focus {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7-focus:focus {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important-focus:focus {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6-focus:focus {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important-focus:focus {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5-focus:focus {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important-focus:focus {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4-focus:focus {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important-focus:focus {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3-focus:focus {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important-focus:focus {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2-focus:focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important-focus:focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1-focus:focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important-focus:focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-10-focus.active-focus {
  background:  #59121f;
}
.pf-new-theme .background-red-10-important-focus.active-focus {
  background:  #59121f !important;
}
.pf-new-theme .background-red-9-focus.active-focus {
  background:  #801b2a;
}
.pf-new-theme .background-red-9-important-focus.active-focus {
  background:  #801b2a !important;
}
.pf-new-theme .background-red-8-focus.active-focus {
  background:  #a62b39;
}
.pf-new-theme .background-red-8-important-focus.active-focus {
  background:  #a62b39 !important;
}
.pf-new-theme .background-red-7-focus.active-focus {
  background:  #cc3f4b;
}
.pf-new-theme .background-red-7-important-focus.active-focus {
  background:  #cc3f4b !important;
}
.pf-new-theme .background-red-6-focus.active-focus {
  background:  #f1565d;
}
.pf-new-theme .background-red-6-important-focus.active-focus {
  background:  #f1565d !important;
}
.pf-new-theme .background-red-5-focus.active-focus {
  background:  #ff8587;
}
.pf-new-theme .background-red-5-important-focus.active-focus {
  background:  #ff8587 !important;
}
.pf-new-theme .background-red-4-focus.active-focus {
  background:  #ffafad;
}
.pf-new-theme .background-red-4-important-focus.active-focus {
  background:  #ffafad !important;
}
.pf-new-theme .background-red-3-focus.active-focus {
  background:  #ffd8d6;
}
.pf-new-theme .background-red-3-important-focus.active-focus {
  background:  #ffd8d6 !important;
}
.pf-new-theme .background-red-2-focus.active-focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-2-important-focus.active-focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .background-red-1-focus.active-focus {
  background:  #fff1f0;
}
.pf-new-theme .background-red-1-important-focus.active-focus {
  background:  #fff1f0 !important;
}
.pf-new-theme .border-red-10 {
  border: 1px solid #59121f;
}
.pf-new-theme .border-red-10-important {
  border: 1px solid #59121f !important;
}
.pf-new-theme .border-red-9 {
  border: 1px solid #801b2a;
}
.pf-new-theme .border-red-9-important {
  border: 1px solid #801b2a !important;
}
.pf-new-theme .border-red-8 {
  border: 1px solid #a62b39;
}
.pf-new-theme .border-red-8-important {
  border: 1px solid #a62b39 !important;
}
.pf-new-theme .border-red-7 {
  border: 1px solid #cc3f4b;
}
.pf-new-theme .border-red-7-important {
  border: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-red-6 {
  border: 1px solid #f1565d;
}
.pf-new-theme .border-red-6-important {
  border: 1px solid #f1565d !important;
}
.pf-new-theme .border-red-5 {
  border: 1px solid #ff8587;
}
.pf-new-theme .border-red-5-important {
  border: 1px solid #ff8587 !important;
}
.pf-new-theme .border-red-4 {
  border: 1px solid #ffafad;
}
.pf-new-theme .border-red-4-important {
  border: 1px solid #ffafad !important;
}
.pf-new-theme .border-red-3 {
  border: 1px solid #ffd8d6;
}
.pf-new-theme .border-red-3-important {
  border: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-red-2 {
  border: 1px solid #fff1f0;
}
.pf-new-theme .border-red-2-important {
  border: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-red-1 {
  border: 1px solid #fff1f0;
}
.pf-new-theme .border-red-1-important {
  border: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-red-10-hover:hover {
  border: 1px solid #59121f;
}
.pf-new-theme .border-red-10-important-hover:hover {
  border: 1px solid #59121f !important;
}
.pf-new-theme .border-red-9-hover:hover {
  border: 1px solid #801b2a;
}
.pf-new-theme .border-red-9-important-hover:hover {
  border: 1px solid #801b2a !important;
}
.pf-new-theme .border-red-8-hover:hover {
  border: 1px solid #a62b39;
}
.pf-new-theme .border-red-8-important-hover:hover {
  border: 1px solid #a62b39 !important;
}
.pf-new-theme .border-red-7-hover:hover {
  border: 1px solid #cc3f4b;
}
.pf-new-theme .border-red-7-important-hover:hover {
  border: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-red-6-hover:hover {
  border: 1px solid #f1565d;
}
.pf-new-theme .border-red-6-important-hover:hover {
  border: 1px solid #f1565d !important;
}
.pf-new-theme .border-red-5-hover:hover {
  border: 1px solid #ff8587;
}
.pf-new-theme .border-red-5-important-hover:hover {
  border: 1px solid #ff8587 !important;
}
.pf-new-theme .border-red-4-hover:hover {
  border: 1px solid #ffafad;
}
.pf-new-theme .border-red-4-important-hover:hover {
  border: 1px solid #ffafad !important;
}
.pf-new-theme .border-red-3-hover:hover {
  border: 1px solid #ffd8d6;
}
.pf-new-theme .border-red-3-important-hover:hover {
  border: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-red-2-hover:hover {
  border: 1px solid #fff1f0;
}
.pf-new-theme .border-red-2-important-hover:hover {
  border: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-red-1-hover:hover {
  border: 1px solid #fff1f0;
}
.pf-new-theme .border-red-1-important-hover:hover {
  border: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-red-10-focus:focus {
  border: 1px solid #59121f;
}
.pf-new-theme .border-red-10-important-focus:focus {
  border: 1px solid #59121f !important;
}
.pf-new-theme .border-red-9-focus:focus {
  border: 1px solid #801b2a;
}
.pf-new-theme .border-red-9-important-focus:focus {
  border: 1px solid #801b2a !important;
}
.pf-new-theme .border-red-8-focus:focus {
  border: 1px solid #a62b39;
}
.pf-new-theme .border-red-8-important-focus:focus {
  border: 1px solid #a62b39 !important;
}
.pf-new-theme .border-red-7-focus:focus {
  border: 1px solid #cc3f4b;
}
.pf-new-theme .border-red-7-important-focus:focus {
  border: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-red-6-focus:focus {
  border: 1px solid #f1565d;
}
.pf-new-theme .border-red-6-important-focus:focus {
  border: 1px solid #f1565d !important;
}
.pf-new-theme .border-red-5-focus:focus {
  border: 1px solid #ff8587;
}
.pf-new-theme .border-red-5-important-focus:focus {
  border: 1px solid #ff8587 !important;
}
.pf-new-theme .border-red-4-focus:focus {
  border: 1px solid #ffafad;
}
.pf-new-theme .border-red-4-important-focus:focus {
  border: 1px solid #ffafad !important;
}
.pf-new-theme .border-red-3-focus:focus {
  border: 1px solid #ffd8d6;
}
.pf-new-theme .border-red-3-important-focus:focus {
  border: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-red-2-focus:focus {
  border: 1px solid #fff1f0;
}
.pf-new-theme .border-red-2-important-focus:focus {
  border: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-red-1-focus:focus {
  border: 1px solid #fff1f0;
}
.pf-new-theme .border-red-1-important-focus:focus {
  border: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-top-red-10 {
  border-top: 1px solid #59121f;
}
.pf-new-theme .border-top-red-10-important {
  border-top: 1px solid #59121f !important;
}
.pf-new-theme .border-top-red-9 {
  border-top: 1px solid #801b2a;
}
.pf-new-theme .border-top-red-9-important {
  border-top: 1px solid #801b2a !important;
}
.pf-new-theme .border-top-red-8 {
  border-top: 1px solid #a62b39;
}
.pf-new-theme .border-top-red-8-important {
  border-top: 1px solid #a62b39 !important;
}
.pf-new-theme .border-top-red-7 {
  border-top: 1px solid #cc3f4b;
}
.pf-new-theme .border-top-red-7-important {
  border-top: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-top-red-6 {
  border-top: 1px solid #f1565d;
}
.pf-new-theme .border-top-red-6-important {
  border-top: 1px solid #f1565d !important;
}
.pf-new-theme .border-top-red-5 {
  border-top: 1px solid #ff8587;
}
.pf-new-theme .border-top-red-5-important {
  border-top: 1px solid #ff8587 !important;
}
.pf-new-theme .border-top-red-4 {
  border-top: 1px solid #ffafad;
}
.pf-new-theme .border-top-red-4-important {
  border-top: 1px solid #ffafad !important;
}
.pf-new-theme .border-top-red-3 {
  border-top: 1px solid #ffd8d6;
}
.pf-new-theme .border-top-red-3-important {
  border-top: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-top-red-2 {
  border-top: 1px solid #fff1f0;
}
.pf-new-theme .border-top-red-2-important {
  border-top: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-top-red-1 {
  border-top: 1px solid #fff1f0;
}
.pf-new-theme .border-top-red-1-important {
  border-top: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-top-red-10-hover:hover {
  border-top: 1px solid #59121f;
}
.pf-new-theme .border-top-red-10-important-hover:hover {
  border-top: 1px solid #59121f !important;
}
.pf-new-theme .border-top-red-9-hover:hover {
  border-top: 1px solid #801b2a;
}
.pf-new-theme .border-top-red-9-important-hover:hover {
  border-top: 1px solid #801b2a !important;
}
.pf-new-theme .border-top-red-8-hover:hover {
  border-top: 1px solid #a62b39;
}
.pf-new-theme .border-top-red-8-important-hover:hover {
  border-top: 1px solid #a62b39 !important;
}
.pf-new-theme .border-top-red-7-hover:hover {
  border-top: 1px solid #cc3f4b;
}
.pf-new-theme .border-top-red-7-important-hover:hover {
  border-top: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-top-red-6-hover:hover {
  border-top: 1px solid #f1565d;
}
.pf-new-theme .border-top-red-6-important-hover:hover {
  border-top: 1px solid #f1565d !important;
}
.pf-new-theme .border-top-red-5-hover:hover {
  border-top: 1px solid #ff8587;
}
.pf-new-theme .border-top-red-5-important-hover:hover {
  border-top: 1px solid #ff8587 !important;
}
.pf-new-theme .border-top-red-4-hover:hover {
  border-top: 1px solid #ffafad;
}
.pf-new-theme .border-top-red-4-important-hover:hover {
  border-top: 1px solid #ffafad !important;
}
.pf-new-theme .border-top-red-3-hover:hover {
  border-top: 1px solid #ffd8d6;
}
.pf-new-theme .border-top-red-3-important-hover:hover {
  border-top: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-top-red-2-hover:hover {
  border-top: 1px solid #fff1f0;
}
.pf-new-theme .border-top-red-2-important-hover:hover {
  border-top: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-top-red-1-hover:hover {
  border-top: 1px solid #fff1f0;
}
.pf-new-theme .border-top-red-1-important-hover:hover {
  border-top: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-right-red-10 {
  border-right: 1px solid #59121f;
}
.pf-new-theme .border-right-red-10-important {
  border-right: 1px solid #59121f !important;
}
.pf-new-theme .border-right-red-9 {
  border-right: 1px solid #801b2a;
}
.pf-new-theme .border-right-red-9-important {
  border-right: 1px solid #801b2a !important;
}
.pf-new-theme .border-right-red-8 {
  border-right: 1px solid #a62b39;
}
.pf-new-theme .border-right-red-8-important {
  border-right: 1px solid #a62b39 !important;
}
.pf-new-theme .border-right-red-7 {
  border-right: 1px solid #cc3f4b;
}
.pf-new-theme .border-right-red-7-important {
  border-right: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-right-red-6 {
  border-right: 1px solid #f1565d;
}
.pf-new-theme .border-right-red-6-important {
  border-right: 1px solid #f1565d !important;
}
.pf-new-theme .border-right-red-5 {
  border-right: 1px solid #ff8587;
}
.pf-new-theme .border-right-red-5-important {
  border-right: 1px solid #ff8587 !important;
}
.pf-new-theme .border-right-red-4 {
  border-right: 1px solid #ffafad;
}
.pf-new-theme .border-right-red-4-important {
  border-right: 1px solid #ffafad !important;
}
.pf-new-theme .border-right-red-3 {
  border-right: 1px solid #ffd8d6;
}
.pf-new-theme .border-right-red-3-important {
  border-right: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-right-red-2 {
  border-right: 1px solid #fff1f0;
}
.pf-new-theme .border-right-red-2-important {
  border-right: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-right-red-1 {
  border-right: 1px solid #fff1f0;
}
.pf-new-theme .border-right-red-1-important {
  border-right: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-right-red-10-hover:hover {
  border-right: 1px solid #59121f;
}
.pf-new-theme .border-right-red-10-important-hover:hover {
  border-right: 1px solid #59121f !important;
}
.pf-new-theme .border-right-red-9-hover:hover {
  border-right: 1px solid #801b2a;
}
.pf-new-theme .border-right-red-9-important-hover:hover {
  border-right: 1px solid #801b2a !important;
}
.pf-new-theme .border-right-red-8-hover:hover {
  border-right: 1px solid #a62b39;
}
.pf-new-theme .border-right-red-8-important-hover:hover {
  border-right: 1px solid #a62b39 !important;
}
.pf-new-theme .border-right-red-7-hover:hover {
  border-right: 1px solid #cc3f4b;
}
.pf-new-theme .border-right-red-7-important-hover:hover {
  border-right: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-right-red-6-hover:hover {
  border-right: 1px solid #f1565d;
}
.pf-new-theme .border-right-red-6-important-hover:hover {
  border-right: 1px solid #f1565d !important;
}
.pf-new-theme .border-right-red-5-hover:hover {
  border-right: 1px solid #ff8587;
}
.pf-new-theme .border-right-red-5-important-hover:hover {
  border-right: 1px solid #ff8587 !important;
}
.pf-new-theme .border-right-red-4-hover:hover {
  border-right: 1px solid #ffafad;
}
.pf-new-theme .border-right-red-4-important-hover:hover {
  border-right: 1px solid #ffafad !important;
}
.pf-new-theme .border-right-red-3-hover:hover {
  border-right: 1px solid #ffd8d6;
}
.pf-new-theme .border-right-red-3-important-hover:hover {
  border-right: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-right-red-2-hover:hover {
  border-right: 1px solid #fff1f0;
}
.pf-new-theme .border-right-red-2-important-hover:hover {
  border-right: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-right-red-1-hover:hover {
  border-right: 1px solid #fff1f0;
}
.pf-new-theme .border-right-red-1-important-hover:hover {
  border-right: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-bottom-red-10 {
  border-bottom: 1px solid #59121f;
}
.pf-new-theme .border-bottom-red-10-important {
  border-bottom: 1px solid #59121f !important;
}
.pf-new-theme .border-bottom-red-9 {
  border-bottom: 1px solid #801b2a;
}
.pf-new-theme .border-bottom-red-9-important {
  border-bottom: 1px solid #801b2a !important;
}
.pf-new-theme .border-bottom-red-8 {
  border-bottom: 1px solid #a62b39;
}
.pf-new-theme .border-bottom-red-8-important {
  border-bottom: 1px solid #a62b39 !important;
}
.pf-new-theme .border-bottom-red-7 {
  border-bottom: 1px solid #cc3f4b;
}
.pf-new-theme .border-bottom-red-7-important {
  border-bottom: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-bottom-red-6 {
  border-bottom: 1px solid #f1565d;
}
.pf-new-theme .border-bottom-red-6-important {
  border-bottom: 1px solid #f1565d !important;
}
.pf-new-theme .border-bottom-red-5 {
  border-bottom: 1px solid #ff8587;
}
.pf-new-theme .border-bottom-red-5-important {
  border-bottom: 1px solid #ff8587 !important;
}
.pf-new-theme .border-bottom-red-4 {
  border-bottom: 1px solid #ffafad;
}
.pf-new-theme .border-bottom-red-4-important {
  border-bottom: 1px solid #ffafad !important;
}
.pf-new-theme .border-bottom-red-3 {
  border-bottom: 1px solid #ffd8d6;
}
.pf-new-theme .border-bottom-red-3-important {
  border-bottom: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-bottom-red-2 {
  border-bottom: 1px solid #fff1f0;
}
.pf-new-theme .border-bottom-red-2-important {
  border-bottom: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-bottom-red-1 {
  border-bottom: 1px solid #fff1f0;
}
.pf-new-theme .border-bottom-red-1-important {
  border-bottom: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-bottom-red-10-hover:hover {
  border-bottom: 1px solid #59121f;
}
.pf-new-theme .border-bottom-red-10-important-hover:hover {
  border-bottom: 1px solid #59121f !important;
}
.pf-new-theme .border-bottom-red-9-hover:hover {
  border-bottom: 1px solid #801b2a;
}
.pf-new-theme .border-bottom-red-9-important-hover:hover {
  border-bottom: 1px solid #801b2a !important;
}
.pf-new-theme .border-bottom-red-8-hover:hover {
  border-bottom: 1px solid #a62b39;
}
.pf-new-theme .border-bottom-red-8-important-hover:hover {
  border-bottom: 1px solid #a62b39 !important;
}
.pf-new-theme .border-bottom-red-7-hover:hover {
  border-bottom: 1px solid #cc3f4b;
}
.pf-new-theme .border-bottom-red-7-important-hover:hover {
  border-bottom: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-bottom-red-6-hover:hover {
  border-bottom: 1px solid #f1565d;
}
.pf-new-theme .border-bottom-red-6-important-hover:hover {
  border-bottom: 1px solid #f1565d !important;
}
.pf-new-theme .border-bottom-red-5-hover:hover {
  border-bottom: 1px solid #ff8587;
}
.pf-new-theme .border-bottom-red-5-important-hover:hover {
  border-bottom: 1px solid #ff8587 !important;
}
.pf-new-theme .border-bottom-red-4-hover:hover {
  border-bottom: 1px solid #ffafad;
}
.pf-new-theme .border-bottom-red-4-important-hover:hover {
  border-bottom: 1px solid #ffafad !important;
}
.pf-new-theme .border-bottom-red-3-hover:hover {
  border-bottom: 1px solid #ffd8d6;
}
.pf-new-theme .border-bottom-red-3-important-hover:hover {
  border-bottom: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-bottom-red-2-hover:hover {
  border-bottom: 1px solid #fff1f0;
}
.pf-new-theme .border-bottom-red-2-important-hover:hover {
  border-bottom: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-bottom-red-1-hover:hover {
  border-bottom: 1px solid #fff1f0;
}
.pf-new-theme .border-bottom-red-1-important-hover:hover {
  border-bottom: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-left-red-10 {
  border-left: 1px solid #59121f;
}
.pf-new-theme .border-left-red-10-important {
  border-left: 1px solid #59121f !important;
}
.pf-new-theme .border-left-red-9 {
  border-left: 1px solid #801b2a;
}
.pf-new-theme .border-left-red-9-important {
  border-left: 1px solid #801b2a !important;
}
.pf-new-theme .border-left-red-8 {
  border-left: 1px solid #a62b39;
}
.pf-new-theme .border-left-red-8-important {
  border-left: 1px solid #a62b39 !important;
}
.pf-new-theme .border-left-red-7 {
  border-left: 1px solid #cc3f4b;
}
.pf-new-theme .border-left-red-7-important {
  border-left: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-left-red-6 {
  border-left: 1px solid #f1565d;
}
.pf-new-theme .border-left-red-6-important {
  border-left: 1px solid #f1565d !important;
}
.pf-new-theme .border-left-red-5 {
  border-left: 1px solid #ff8587;
}
.pf-new-theme .border-left-red-5-important {
  border-left: 1px solid #ff8587 !important;
}
.pf-new-theme .border-left-red-4 {
  border-left: 1px solid #ffafad;
}
.pf-new-theme .border-left-red-4-important {
  border-left: 1px solid #ffafad !important;
}
.pf-new-theme .border-left-red-3 {
  border-left: 1px solid #ffd8d6;
}
.pf-new-theme .border-left-red-3-important {
  border-left: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-left-red-2 {
  border-left: 1px solid #fff1f0;
}
.pf-new-theme .border-left-red-2-important {
  border-left: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-left-red-1 {
  border-left: 1px solid #fff1f0;
}
.pf-new-theme .border-left-red-1-important {
  border-left: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-left-red-10-hover:hover {
  border-left: 1px solid #59121f;
}
.pf-new-theme .border-left-red-10-important-hover:hover {
  border-left: 1px solid #59121f !important;
}
.pf-new-theme .border-left-red-9-hover:hover {
  border-left: 1px solid #801b2a;
}
.pf-new-theme .border-left-red-9-important-hover:hover {
  border-left: 1px solid #801b2a !important;
}
.pf-new-theme .border-left-red-8-hover:hover {
  border-left: 1px solid #a62b39;
}
.pf-new-theme .border-left-red-8-important-hover:hover {
  border-left: 1px solid #a62b39 !important;
}
.pf-new-theme .border-left-red-7-hover:hover {
  border-left: 1px solid #cc3f4b;
}
.pf-new-theme .border-left-red-7-important-hover:hover {
  border-left: 1px solid #cc3f4b !important;
}
.pf-new-theme .border-left-red-6-hover:hover {
  border-left: 1px solid #f1565d;
}
.pf-new-theme .border-left-red-6-important-hover:hover {
  border-left: 1px solid #f1565d !important;
}
.pf-new-theme .border-left-red-5-hover:hover {
  border-left: 1px solid #ff8587;
}
.pf-new-theme .border-left-red-5-important-hover:hover {
  border-left: 1px solid #ff8587 !important;
}
.pf-new-theme .border-left-red-4-hover:hover {
  border-left: 1px solid #ffafad;
}
.pf-new-theme .border-left-red-4-important-hover:hover {
  border-left: 1px solid #ffafad !important;
}
.pf-new-theme .border-left-red-3-hover:hover {
  border-left: 1px solid #ffd8d6;
}
.pf-new-theme .border-left-red-3-important-hover:hover {
  border-left: 1px solid #ffd8d6 !important;
}
.pf-new-theme .border-left-red-2-hover:hover {
  border-left: 1px solid #fff1f0;
}
.pf-new-theme .border-left-red-2-important-hover:hover {
  border-left: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-left-red-1-hover:hover {
  border-left: 1px solid #fff1f0;
}
.pf-new-theme .border-left-red-1-important-hover:hover {
  border-left: 1px solid #fff1f0 !important;
}
.pf-new-theme .border-color-red-10 {
  border-color:  #59121f;
}
.pf-new-theme .border-color-red-10-important {
  border-color:  #59121f !important;
}
.pf-new-theme .border-color-red-9 {
  border-color:  #801b2a;
}
.pf-new-theme .border-color-red-9-important {
  border-color:  #801b2a !important;
}
.pf-new-theme .border-color-red-8 {
  border-color:  #a62b39;
}
.pf-new-theme .border-color-red-8-important {
  border-color:  #a62b39 !important;
}
.pf-new-theme .border-color-red-7 {
  border-color:  #cc3f4b;
}
.pf-new-theme .border-color-red-7-important {
  border-color:  #cc3f4b !important;
}
.pf-new-theme .border-color-red-6 {
  border-color:  #f1565d;
}
.pf-new-theme .border-color-red-6-important {
  border-color:  #f1565d !important;
}
.pf-new-theme .border-color-red-5 {
  border-color:  #ff8587;
}
.pf-new-theme .border-color-red-5-important {
  border-color:  #ff8587 !important;
}
.pf-new-theme .border-color-red-4 {
  border-color:  #ffafad;
}
.pf-new-theme .border-color-red-4-important {
  border-color:  #ffafad !important;
}
.pf-new-theme .border-color-red-3 {
  border-color:  #ffd8d6;
}
.pf-new-theme .border-color-red-3-important {
  border-color:  #ffd8d6 !important;
}
.pf-new-theme .border-color-red-2 {
  border-color:  #fff1f0;
}
.pf-new-theme .border-color-red-2-important {
  border-color:  #fff1f0 !important;
}
.pf-new-theme .border-color-red-1 {
  border-color:  #fff1f0;
}
.pf-new-theme .border-color-red-1-important {
  border-color:  #fff1f0 !important;
}
.pf-new-theme .border-color-red-10-hover:hover {
  border-color:  #59121f;
}
.pf-new-theme .border-color-red-10-important-hover:hover {
  border-color:  #59121f !important;
}
.pf-new-theme .border-color-red-9-hover:hover {
  border-color:  #801b2a;
}
.pf-new-theme .border-color-red-9-important-hover:hover {
  border-color:  #801b2a !important;
}
.pf-new-theme .border-color-red-8-hover:hover {
  border-color:  #a62b39;
}
.pf-new-theme .border-color-red-8-important-hover:hover {
  border-color:  #a62b39 !important;
}
.pf-new-theme .border-color-red-7-hover:hover {
  border-color:  #cc3f4b;
}
.pf-new-theme .border-color-red-7-important-hover:hover {
  border-color:  #cc3f4b !important;
}
.pf-new-theme .border-color-red-6-hover:hover {
  border-color:  #f1565d;
}
.pf-new-theme .border-color-red-6-important-hover:hover {
  border-color:  #f1565d !important;
}
.pf-new-theme .border-color-red-5-hover:hover {
  border-color:  #ff8587;
}
.pf-new-theme .border-color-red-5-important-hover:hover {
  border-color:  #ff8587 !important;
}
.pf-new-theme .border-color-red-4-hover:hover {
  border-color:  #ffafad;
}
.pf-new-theme .border-color-red-4-important-hover:hover {
  border-color:  #ffafad !important;
}
.pf-new-theme .border-color-red-3-hover:hover {
  border-color:  #ffd8d6;
}
.pf-new-theme .border-color-red-3-important-hover:hover {
  border-color:  #ffd8d6 !important;
}
.pf-new-theme .border-color-red-2-hover:hover {
  border-color:  #fff1f0;
}
.pf-new-theme .border-color-red-2-important-hover:hover {
  border-color:  #fff1f0 !important;
}
.pf-new-theme .border-color-red-1-hover:hover {
  border-color:  #fff1f0;
}
.pf-new-theme .border-color-red-1-important-hover:hover {
  border-color:  #fff1f0 !important;
}
.pf-new-theme .color-yellow-10 {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9 {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8 {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7 {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6 {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5 {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4 {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3 {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2 {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1 {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-hover:hover {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-hover:hover {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-hover:hover {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-hover:hover {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-hover:hover {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-hover:hover {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-hover:hover {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-hover:hover {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-hover:hover {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-hover:hover {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-hover:hover {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-hover:hover {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-hover:hover {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-hover:hover {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-hover:hover {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-hover:hover {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-hover:hover {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-hover:hover {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-hover:hover {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-hover:hover {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-hover.active-hover {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-hover.active-hover {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-hover.active-hover {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-hover.active-hover {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-hover.active-hover {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-hover.active-hover {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-hover.active-hover {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-hover.active-hover {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-hover.active-hover {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-hover.active-hover {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-hover.active-hover {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-hover.active-hover {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-hover.active-hover {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-hover.active-hover {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-hover.active-hover {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-hover.active-hover {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-hover.active-hover {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-hover.active-hover {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-hover.active-hover {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-hover.active-hover {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-hover:focus {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-hover:focus {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-hover:focus {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-hover:focus {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-hover:focus {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-hover:focus {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-hover:focus {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-hover:focus {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-hover:focus {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-hover:focus {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-hover:focus {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-hover:focus {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-hover:focus {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-hover:focus {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-hover:focus {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-hover:focus {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-hover:focus {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-hover:focus {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-hover:focus {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-hover:focus {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-hover.active-focus {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-hover.active-focus {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-hover.active-focus {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-hover.active-focus {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-hover.active-focus {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-hover.active-focus {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-hover.active-focus {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-hover.active-focus {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-hover.active-focus {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-hover.active-focus {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-hover.active-focus {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-hover.active-focus {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-hover.active-focus {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-hover.active-focus {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-hover.active-focus {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-hover.active-focus {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-hover.active-focus {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-hover.active-focus {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-hover.active-focus {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-hover.active-focus {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-focus:focus {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-focus:focus {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-focus:focus {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-focus:focus {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-focus:focus {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-focus:focus {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-focus:focus {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-focus:focus {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-focus:focus {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-focus:focus {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-focus:focus {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-focus:focus {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-focus:focus {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-focus:focus {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-focus:focus {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-focus:focus {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-focus:focus {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-focus:focus {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-focus:focus {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-focus:focus {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-focus.active-focus {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-focus.active-focus {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-focus.active-focus {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-focus.active-focus {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-focus.active-focus {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-focus.active-focus {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-focus.active-focus {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-focus.active-focus {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-focus.active-focus {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-focus.active-focus {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-focus.active-focus {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-focus.active-focus {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-focus.active-focus {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-focus.active-focus {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-focus.active-focus {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-focus.active-focus {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-focus.active-focus {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-focus.active-focus {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-focus.active-focus {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-focus.active-focus {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-placeholder::placeholder {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-placeholder::placeholder {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-placeholder::placeholder {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-placeholder::placeholder {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-placeholder::placeholder {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-placeholder::placeholder {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-placeholder::placeholder {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-placeholder::placeholder {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-placeholder::placeholder {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-placeholder::placeholder {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-placeholder::placeholder {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-placeholder::placeholder {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-placeholder::placeholder {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-placeholder::placeholder {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-placeholder::placeholder {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-placeholder::placeholder {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-placeholder::placeholder {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-placeholder::placeholder {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-placeholder::placeholder {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-placeholder::placeholder {
  color:  #fffde6 !important;
}
.pf-new-theme .color-yellow-10-placeholder.active-placeholder {
  color:  #663f00;
}
.pf-new-theme .color-yellow-10-important-placeholder.active-placeholder {
  color:  #663f00 !important;
}
.pf-new-theme .color-yellow-9-placeholder.active-placeholder {
  color:  #8c5b00;
}
.pf-new-theme .color-yellow-9-important-placeholder.active-placeholder {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-yellow-8-placeholder.active-placeholder {
  color:  #b37a00;
}
.pf-new-theme .color-yellow-8-important-placeholder.active-placeholder {
  color:  #b37a00 !important;
}
.pf-new-theme .color-yellow-7-placeholder.active-placeholder {
  color:  #d99b00;
}
.pf-new-theme .color-yellow-7-important-placeholder.active-placeholder {
  color:  #d99b00 !important;
}
.pf-new-theme .color-yellow-6-placeholder.active-placeholder {
  color:  #ffc000;
}
.pf-new-theme .color-yellow-6-important-placeholder.active-placeholder {
  color:  #ffc000 !important;
}
.pf-new-theme .color-yellow-5-placeholder.active-placeholder {
  color:  #ffd129;
}
.pf-new-theme .color-yellow-5-important-placeholder.active-placeholder {
  color:  #ffd129 !important;
}
.pf-new-theme .color-yellow-4-placeholder.active-placeholder {
  color:  #ffdf52;
}
.pf-new-theme .color-yellow-4-important-placeholder.active-placeholder {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-yellow-3-placeholder.active-placeholder {
  color:  #ffeb7a;
}
.pf-new-theme .color-yellow-3-important-placeholder.active-placeholder {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-yellow-2-placeholder.active-placeholder {
  color:  #fff4a3;
}
.pf-new-theme .color-yellow-2-important-placeholder.active-placeholder {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-yellow-1-placeholder.active-placeholder {
  color:  #fffde6;
}
.pf-new-theme .color-yellow-1-important-placeholder.active-placeholder {
  color:  #fffde6 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-10-hover {
  color:  #663f00;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-10-important-hover {
  color:  #663f00 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-9-hover {
  color:  #8c5b00;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-9-important-hover {
  color:  #8c5b00 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-8-hover {
  color:  #b37a00;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-8-important-hover {
  color:  #b37a00 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-7-hover {
  color:  #d99b00;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-7-important-hover {
  color:  #d99b00 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-6-hover {
  color:  #ffc000;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-6-important-hover {
  color:  #ffc000 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-5-hover {
  color:  #ffd129;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-5-important-hover {
  color:  #ffd129 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-4-hover {
  color:  #ffdf52;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-4-important-hover {
  color:  #ffdf52 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-3-hover {
  color:  #ffeb7a;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-3-important-hover {
  color:  #ffeb7a !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-2-hover {
  color:  #fff4a3;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-2-important-hover {
  color:  #fff4a3 !important;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-1-hover {
  color:  #fffde6;
}
.pf-new-theme .color-hover-parent:hover .color-yellow-1-important-hover {
  color:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10 {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9 {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8 {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7 {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6 {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5 {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4 {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3 {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2 {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1 {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important {
  background:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10-hover:hover {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important-hover:hover {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9-hover:hover {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important-hover:hover {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8-hover:hover {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important-hover:hover {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7-hover:hover {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important-hover:hover {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6-hover:hover {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important-hover:hover {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5-hover:hover {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important-hover:hover {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4-hover:hover {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important-hover:hover {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3-hover:hover {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important-hover:hover {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2-hover:hover {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important-hover:hover {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1-hover:hover {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important-hover:hover {
  background:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10-hover.active-hover {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important-hover.active-hover {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9-hover.active-hover {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important-hover.active-hover {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8-hover.active-hover {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important-hover.active-hover {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7-hover.active-hover {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important-hover.active-hover {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6-hover.active-hover {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important-hover.active-hover {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5-hover.active-hover {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important-hover.active-hover {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4-hover.active-hover {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important-hover.active-hover {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3-hover.active-hover {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important-hover.active-hover {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2-hover.active-hover {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important-hover.active-hover {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1-hover.active-hover {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important-hover.active-hover {
  background:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10-hover:focus {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important-hover:focus {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9-hover:focus {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important-hover:focus {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8-hover:focus {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important-hover:focus {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7-hover:focus {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important-hover:focus {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6-hover:focus {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important-hover:focus {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5-hover:focus {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important-hover:focus {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4-hover:focus {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important-hover:focus {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3-hover:focus {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important-hover:focus {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2-hover:focus {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important-hover:focus {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1-hover:focus {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important-hover:focus {
  background:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10-hover.active-focus {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important-hover.active-focus {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9-hover.active-focus {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important-hover.active-focus {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8-hover.active-focus {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important-hover.active-focus {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7-hover.active-focus {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important-hover.active-focus {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6-hover.active-focus {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important-hover.active-focus {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5-hover.active-focus {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important-hover.active-focus {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4-hover.active-focus {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important-hover.active-focus {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3-hover.active-focus {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important-hover.active-focus {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2-hover.active-focus {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important-hover.active-focus {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1-hover.active-focus {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important-hover.active-focus {
  background:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10-focus:focus {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important-focus:focus {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9-focus:focus {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important-focus:focus {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8-focus:focus {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important-focus:focus {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7-focus:focus {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important-focus:focus {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6-focus:focus {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important-focus:focus {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5-focus:focus {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important-focus:focus {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4-focus:focus {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important-focus:focus {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3-focus:focus {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important-focus:focus {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2-focus:focus {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important-focus:focus {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1-focus:focus {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important-focus:focus {
  background:  #fffde6 !important;
}
.pf-new-theme .background-yellow-10-focus.active-focus {
  background:  #663f00;
}
.pf-new-theme .background-yellow-10-important-focus.active-focus {
  background:  #663f00 !important;
}
.pf-new-theme .background-yellow-9-focus.active-focus {
  background:  #8c5b00;
}
.pf-new-theme .background-yellow-9-important-focus.active-focus {
  background:  #8c5b00 !important;
}
.pf-new-theme .background-yellow-8-focus.active-focus {
  background:  #b37a00;
}
.pf-new-theme .background-yellow-8-important-focus.active-focus {
  background:  #b37a00 !important;
}
.pf-new-theme .background-yellow-7-focus.active-focus {
  background:  #d99b00;
}
.pf-new-theme .background-yellow-7-important-focus.active-focus {
  background:  #d99b00 !important;
}
.pf-new-theme .background-yellow-6-focus.active-focus {
  background:  #ffc000;
}
.pf-new-theme .background-yellow-6-important-focus.active-focus {
  background:  #ffc000 !important;
}
.pf-new-theme .background-yellow-5-focus.active-focus {
  background:  #ffd129;
}
.pf-new-theme .background-yellow-5-important-focus.active-focus {
  background:  #ffd129 !important;
}
.pf-new-theme .background-yellow-4-focus.active-focus {
  background:  #ffdf52;
}
.pf-new-theme .background-yellow-4-important-focus.active-focus {
  background:  #ffdf52 !important;
}
.pf-new-theme .background-yellow-3-focus.active-focus {
  background:  #ffeb7a;
}
.pf-new-theme .background-yellow-3-important-focus.active-focus {
  background:  #ffeb7a !important;
}
.pf-new-theme .background-yellow-2-focus.active-focus {
  background:  #fff4a3;
}
.pf-new-theme .background-yellow-2-important-focus.active-focus {
  background:  #fff4a3 !important;
}
.pf-new-theme .background-yellow-1-focus.active-focus {
  background:  #fffde6;
}
.pf-new-theme .background-yellow-1-important-focus.active-focus {
  background:  #fffde6 !important;
}
.pf-new-theme .border-yellow-10 {
  border: 1px solid #663f00;
}
.pf-new-theme .border-yellow-10-important {
  border: 1px solid #663f00 !important;
}
.pf-new-theme .border-yellow-9 {
  border: 1px solid #8c5b00;
}
.pf-new-theme .border-yellow-9-important {
  border: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-yellow-8 {
  border: 1px solid #b37a00;
}
.pf-new-theme .border-yellow-8-important {
  border: 1px solid #b37a00 !important;
}
.pf-new-theme .border-yellow-7 {
  border: 1px solid #d99b00;
}
.pf-new-theme .border-yellow-7-important {
  border: 1px solid #d99b00 !important;
}
.pf-new-theme .border-yellow-6 {
  border: 1px solid #ffc000;
}
.pf-new-theme .border-yellow-6-important {
  border: 1px solid #ffc000 !important;
}
.pf-new-theme .border-yellow-5 {
  border: 1px solid #ffd129;
}
.pf-new-theme .border-yellow-5-important {
  border: 1px solid #ffd129 !important;
}
.pf-new-theme .border-yellow-4 {
  border: 1px solid #ffdf52;
}
.pf-new-theme .border-yellow-4-important {
  border: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-yellow-3 {
  border: 1px solid #ffeb7a;
}
.pf-new-theme .border-yellow-3-important {
  border: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-yellow-2 {
  border: 1px solid #fff4a3;
}
.pf-new-theme .border-yellow-2-important {
  border: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-yellow-1 {
  border: 1px solid #fffde6;
}
.pf-new-theme .border-yellow-1-important {
  border: 1px solid #fffde6 !important;
}
.pf-new-theme .border-yellow-10-hover:hover {
  border: 1px solid #663f00;
}
.pf-new-theme .border-yellow-10-important-hover:hover {
  border: 1px solid #663f00 !important;
}
.pf-new-theme .border-yellow-9-hover:hover {
  border: 1px solid #8c5b00;
}
.pf-new-theme .border-yellow-9-important-hover:hover {
  border: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-yellow-8-hover:hover {
  border: 1px solid #b37a00;
}
.pf-new-theme .border-yellow-8-important-hover:hover {
  border: 1px solid #b37a00 !important;
}
.pf-new-theme .border-yellow-7-hover:hover {
  border: 1px solid #d99b00;
}
.pf-new-theme .border-yellow-7-important-hover:hover {
  border: 1px solid #d99b00 !important;
}
.pf-new-theme .border-yellow-6-hover:hover {
  border: 1px solid #ffc000;
}
.pf-new-theme .border-yellow-6-important-hover:hover {
  border: 1px solid #ffc000 !important;
}
.pf-new-theme .border-yellow-5-hover:hover {
  border: 1px solid #ffd129;
}
.pf-new-theme .border-yellow-5-important-hover:hover {
  border: 1px solid #ffd129 !important;
}
.pf-new-theme .border-yellow-4-hover:hover {
  border: 1px solid #ffdf52;
}
.pf-new-theme .border-yellow-4-important-hover:hover {
  border: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-yellow-3-hover:hover {
  border: 1px solid #ffeb7a;
}
.pf-new-theme .border-yellow-3-important-hover:hover {
  border: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-yellow-2-hover:hover {
  border: 1px solid #fff4a3;
}
.pf-new-theme .border-yellow-2-important-hover:hover {
  border: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-yellow-1-hover:hover {
  border: 1px solid #fffde6;
}
.pf-new-theme .border-yellow-1-important-hover:hover {
  border: 1px solid #fffde6 !important;
}
.pf-new-theme .border-yellow-10-focus:focus {
  border: 1px solid #663f00;
}
.pf-new-theme .border-yellow-10-important-focus:focus {
  border: 1px solid #663f00 !important;
}
.pf-new-theme .border-yellow-9-focus:focus {
  border: 1px solid #8c5b00;
}
.pf-new-theme .border-yellow-9-important-focus:focus {
  border: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-yellow-8-focus:focus {
  border: 1px solid #b37a00;
}
.pf-new-theme .border-yellow-8-important-focus:focus {
  border: 1px solid #b37a00 !important;
}
.pf-new-theme .border-yellow-7-focus:focus {
  border: 1px solid #d99b00;
}
.pf-new-theme .border-yellow-7-important-focus:focus {
  border: 1px solid #d99b00 !important;
}
.pf-new-theme .border-yellow-6-focus:focus {
  border: 1px solid #ffc000;
}
.pf-new-theme .border-yellow-6-important-focus:focus {
  border: 1px solid #ffc000 !important;
}
.pf-new-theme .border-yellow-5-focus:focus {
  border: 1px solid #ffd129;
}
.pf-new-theme .border-yellow-5-important-focus:focus {
  border: 1px solid #ffd129 !important;
}
.pf-new-theme .border-yellow-4-focus:focus {
  border: 1px solid #ffdf52;
}
.pf-new-theme .border-yellow-4-important-focus:focus {
  border: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-yellow-3-focus:focus {
  border: 1px solid #ffeb7a;
}
.pf-new-theme .border-yellow-3-important-focus:focus {
  border: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-yellow-2-focus:focus {
  border: 1px solid #fff4a3;
}
.pf-new-theme .border-yellow-2-important-focus:focus {
  border: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-yellow-1-focus:focus {
  border: 1px solid #fffde6;
}
.pf-new-theme .border-yellow-1-important-focus:focus {
  border: 1px solid #fffde6 !important;
}
.pf-new-theme .border-top-yellow-10 {
  border-top: 1px solid #663f00;
}
.pf-new-theme .border-top-yellow-10-important {
  border-top: 1px solid #663f00 !important;
}
.pf-new-theme .border-top-yellow-9 {
  border-top: 1px solid #8c5b00;
}
.pf-new-theme .border-top-yellow-9-important {
  border-top: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-top-yellow-8 {
  border-top: 1px solid #b37a00;
}
.pf-new-theme .border-top-yellow-8-important {
  border-top: 1px solid #b37a00 !important;
}
.pf-new-theme .border-top-yellow-7 {
  border-top: 1px solid #d99b00;
}
.pf-new-theme .border-top-yellow-7-important {
  border-top: 1px solid #d99b00 !important;
}
.pf-new-theme .border-top-yellow-6 {
  border-top: 1px solid #ffc000;
}
.pf-new-theme .border-top-yellow-6-important {
  border-top: 1px solid #ffc000 !important;
}
.pf-new-theme .border-top-yellow-5 {
  border-top: 1px solid #ffd129;
}
.pf-new-theme .border-top-yellow-5-important {
  border-top: 1px solid #ffd129 !important;
}
.pf-new-theme .border-top-yellow-4 {
  border-top: 1px solid #ffdf52;
}
.pf-new-theme .border-top-yellow-4-important {
  border-top: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-top-yellow-3 {
  border-top: 1px solid #ffeb7a;
}
.pf-new-theme .border-top-yellow-3-important {
  border-top: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-top-yellow-2 {
  border-top: 1px solid #fff4a3;
}
.pf-new-theme .border-top-yellow-2-important {
  border-top: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-top-yellow-1 {
  border-top: 1px solid #fffde6;
}
.pf-new-theme .border-top-yellow-1-important {
  border-top: 1px solid #fffde6 !important;
}
.pf-new-theme .border-top-yellow-10-hover:hover {
  border-top: 1px solid #663f00;
}
.pf-new-theme .border-top-yellow-10-important-hover:hover {
  border-top: 1px solid #663f00 !important;
}
.pf-new-theme .border-top-yellow-9-hover:hover {
  border-top: 1px solid #8c5b00;
}
.pf-new-theme .border-top-yellow-9-important-hover:hover {
  border-top: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-top-yellow-8-hover:hover {
  border-top: 1px solid #b37a00;
}
.pf-new-theme .border-top-yellow-8-important-hover:hover {
  border-top: 1px solid #b37a00 !important;
}
.pf-new-theme .border-top-yellow-7-hover:hover {
  border-top: 1px solid #d99b00;
}
.pf-new-theme .border-top-yellow-7-important-hover:hover {
  border-top: 1px solid #d99b00 !important;
}
.pf-new-theme .border-top-yellow-6-hover:hover {
  border-top: 1px solid #ffc000;
}
.pf-new-theme .border-top-yellow-6-important-hover:hover {
  border-top: 1px solid #ffc000 !important;
}
.pf-new-theme .border-top-yellow-5-hover:hover {
  border-top: 1px solid #ffd129;
}
.pf-new-theme .border-top-yellow-5-important-hover:hover {
  border-top: 1px solid #ffd129 !important;
}
.pf-new-theme .border-top-yellow-4-hover:hover {
  border-top: 1px solid #ffdf52;
}
.pf-new-theme .border-top-yellow-4-important-hover:hover {
  border-top: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-top-yellow-3-hover:hover {
  border-top: 1px solid #ffeb7a;
}
.pf-new-theme .border-top-yellow-3-important-hover:hover {
  border-top: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-top-yellow-2-hover:hover {
  border-top: 1px solid #fff4a3;
}
.pf-new-theme .border-top-yellow-2-important-hover:hover {
  border-top: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-top-yellow-1-hover:hover {
  border-top: 1px solid #fffde6;
}
.pf-new-theme .border-top-yellow-1-important-hover:hover {
  border-top: 1px solid #fffde6 !important;
}
.pf-new-theme .border-right-yellow-10 {
  border-right: 1px solid #663f00;
}
.pf-new-theme .border-right-yellow-10-important {
  border-right: 1px solid #663f00 !important;
}
.pf-new-theme .border-right-yellow-9 {
  border-right: 1px solid #8c5b00;
}
.pf-new-theme .border-right-yellow-9-important {
  border-right: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-right-yellow-8 {
  border-right: 1px solid #b37a00;
}
.pf-new-theme .border-right-yellow-8-important {
  border-right: 1px solid #b37a00 !important;
}
.pf-new-theme .border-right-yellow-7 {
  border-right: 1px solid #d99b00;
}
.pf-new-theme .border-right-yellow-7-important {
  border-right: 1px solid #d99b00 !important;
}
.pf-new-theme .border-right-yellow-6 {
  border-right: 1px solid #ffc000;
}
.pf-new-theme .border-right-yellow-6-important {
  border-right: 1px solid #ffc000 !important;
}
.pf-new-theme .border-right-yellow-5 {
  border-right: 1px solid #ffd129;
}
.pf-new-theme .border-right-yellow-5-important {
  border-right: 1px solid #ffd129 !important;
}
.pf-new-theme .border-right-yellow-4 {
  border-right: 1px solid #ffdf52;
}
.pf-new-theme .border-right-yellow-4-important {
  border-right: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-right-yellow-3 {
  border-right: 1px solid #ffeb7a;
}
.pf-new-theme .border-right-yellow-3-important {
  border-right: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-right-yellow-2 {
  border-right: 1px solid #fff4a3;
}
.pf-new-theme .border-right-yellow-2-important {
  border-right: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-right-yellow-1 {
  border-right: 1px solid #fffde6;
}
.pf-new-theme .border-right-yellow-1-important {
  border-right: 1px solid #fffde6 !important;
}
.pf-new-theme .border-right-yellow-10-hover:hover {
  border-right: 1px solid #663f00;
}
.pf-new-theme .border-right-yellow-10-important-hover:hover {
  border-right: 1px solid #663f00 !important;
}
.pf-new-theme .border-right-yellow-9-hover:hover {
  border-right: 1px solid #8c5b00;
}
.pf-new-theme .border-right-yellow-9-important-hover:hover {
  border-right: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-right-yellow-8-hover:hover {
  border-right: 1px solid #b37a00;
}
.pf-new-theme .border-right-yellow-8-important-hover:hover {
  border-right: 1px solid #b37a00 !important;
}
.pf-new-theme .border-right-yellow-7-hover:hover {
  border-right: 1px solid #d99b00;
}
.pf-new-theme .border-right-yellow-7-important-hover:hover {
  border-right: 1px solid #d99b00 !important;
}
.pf-new-theme .border-right-yellow-6-hover:hover {
  border-right: 1px solid #ffc000;
}
.pf-new-theme .border-right-yellow-6-important-hover:hover {
  border-right: 1px solid #ffc000 !important;
}
.pf-new-theme .border-right-yellow-5-hover:hover {
  border-right: 1px solid #ffd129;
}
.pf-new-theme .border-right-yellow-5-important-hover:hover {
  border-right: 1px solid #ffd129 !important;
}
.pf-new-theme .border-right-yellow-4-hover:hover {
  border-right: 1px solid #ffdf52;
}
.pf-new-theme .border-right-yellow-4-important-hover:hover {
  border-right: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-right-yellow-3-hover:hover {
  border-right: 1px solid #ffeb7a;
}
.pf-new-theme .border-right-yellow-3-important-hover:hover {
  border-right: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-right-yellow-2-hover:hover {
  border-right: 1px solid #fff4a3;
}
.pf-new-theme .border-right-yellow-2-important-hover:hover {
  border-right: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-right-yellow-1-hover:hover {
  border-right: 1px solid #fffde6;
}
.pf-new-theme .border-right-yellow-1-important-hover:hover {
  border-right: 1px solid #fffde6 !important;
}
.pf-new-theme .border-bottom-yellow-10 {
  border-bottom: 1px solid #663f00;
}
.pf-new-theme .border-bottom-yellow-10-important {
  border-bottom: 1px solid #663f00 !important;
}
.pf-new-theme .border-bottom-yellow-9 {
  border-bottom: 1px solid #8c5b00;
}
.pf-new-theme .border-bottom-yellow-9-important {
  border-bottom: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-bottom-yellow-8 {
  border-bottom: 1px solid #b37a00;
}
.pf-new-theme .border-bottom-yellow-8-important {
  border-bottom: 1px solid #b37a00 !important;
}
.pf-new-theme .border-bottom-yellow-7 {
  border-bottom: 1px solid #d99b00;
}
.pf-new-theme .border-bottom-yellow-7-important {
  border-bottom: 1px solid #d99b00 !important;
}
.pf-new-theme .border-bottom-yellow-6 {
  border-bottom: 1px solid #ffc000;
}
.pf-new-theme .border-bottom-yellow-6-important {
  border-bottom: 1px solid #ffc000 !important;
}
.pf-new-theme .border-bottom-yellow-5 {
  border-bottom: 1px solid #ffd129;
}
.pf-new-theme .border-bottom-yellow-5-important {
  border-bottom: 1px solid #ffd129 !important;
}
.pf-new-theme .border-bottom-yellow-4 {
  border-bottom: 1px solid #ffdf52;
}
.pf-new-theme .border-bottom-yellow-4-important {
  border-bottom: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-bottom-yellow-3 {
  border-bottom: 1px solid #ffeb7a;
}
.pf-new-theme .border-bottom-yellow-3-important {
  border-bottom: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-bottom-yellow-2 {
  border-bottom: 1px solid #fff4a3;
}
.pf-new-theme .border-bottom-yellow-2-important {
  border-bottom: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-bottom-yellow-1 {
  border-bottom: 1px solid #fffde6;
}
.pf-new-theme .border-bottom-yellow-1-important {
  border-bottom: 1px solid #fffde6 !important;
}
.pf-new-theme .border-bottom-yellow-10-hover:hover {
  border-bottom: 1px solid #663f00;
}
.pf-new-theme .border-bottom-yellow-10-important-hover:hover {
  border-bottom: 1px solid #663f00 !important;
}
.pf-new-theme .border-bottom-yellow-9-hover:hover {
  border-bottom: 1px solid #8c5b00;
}
.pf-new-theme .border-bottom-yellow-9-important-hover:hover {
  border-bottom: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-bottom-yellow-8-hover:hover {
  border-bottom: 1px solid #b37a00;
}
.pf-new-theme .border-bottom-yellow-8-important-hover:hover {
  border-bottom: 1px solid #b37a00 !important;
}
.pf-new-theme .border-bottom-yellow-7-hover:hover {
  border-bottom: 1px solid #d99b00;
}
.pf-new-theme .border-bottom-yellow-7-important-hover:hover {
  border-bottom: 1px solid #d99b00 !important;
}
.pf-new-theme .border-bottom-yellow-6-hover:hover {
  border-bottom: 1px solid #ffc000;
}
.pf-new-theme .border-bottom-yellow-6-important-hover:hover {
  border-bottom: 1px solid #ffc000 !important;
}
.pf-new-theme .border-bottom-yellow-5-hover:hover {
  border-bottom: 1px solid #ffd129;
}
.pf-new-theme .border-bottom-yellow-5-important-hover:hover {
  border-bottom: 1px solid #ffd129 !important;
}
.pf-new-theme .border-bottom-yellow-4-hover:hover {
  border-bottom: 1px solid #ffdf52;
}
.pf-new-theme .border-bottom-yellow-4-important-hover:hover {
  border-bottom: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-bottom-yellow-3-hover:hover {
  border-bottom: 1px solid #ffeb7a;
}
.pf-new-theme .border-bottom-yellow-3-important-hover:hover {
  border-bottom: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-bottom-yellow-2-hover:hover {
  border-bottom: 1px solid #fff4a3;
}
.pf-new-theme .border-bottom-yellow-2-important-hover:hover {
  border-bottom: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-bottom-yellow-1-hover:hover {
  border-bottom: 1px solid #fffde6;
}
.pf-new-theme .border-bottom-yellow-1-important-hover:hover {
  border-bottom: 1px solid #fffde6 !important;
}
.pf-new-theme .border-left-yellow-10 {
  border-left: 1px solid #663f00;
}
.pf-new-theme .border-left-yellow-10-important {
  border-left: 1px solid #663f00 !important;
}
.pf-new-theme .border-left-yellow-9 {
  border-left: 1px solid #8c5b00;
}
.pf-new-theme .border-left-yellow-9-important {
  border-left: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-left-yellow-8 {
  border-left: 1px solid #b37a00;
}
.pf-new-theme .border-left-yellow-8-important {
  border-left: 1px solid #b37a00 !important;
}
.pf-new-theme .border-left-yellow-7 {
  border-left: 1px solid #d99b00;
}
.pf-new-theme .border-left-yellow-7-important {
  border-left: 1px solid #d99b00 !important;
}
.pf-new-theme .border-left-yellow-6 {
  border-left: 1px solid #ffc000;
}
.pf-new-theme .border-left-yellow-6-important {
  border-left: 1px solid #ffc000 !important;
}
.pf-new-theme .border-left-yellow-5 {
  border-left: 1px solid #ffd129;
}
.pf-new-theme .border-left-yellow-5-important {
  border-left: 1px solid #ffd129 !important;
}
.pf-new-theme .border-left-yellow-4 {
  border-left: 1px solid #ffdf52;
}
.pf-new-theme .border-left-yellow-4-important {
  border-left: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-left-yellow-3 {
  border-left: 1px solid #ffeb7a;
}
.pf-new-theme .border-left-yellow-3-important {
  border-left: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-left-yellow-2 {
  border-left: 1px solid #fff4a3;
}
.pf-new-theme .border-left-yellow-2-important {
  border-left: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-left-yellow-1 {
  border-left: 1px solid #fffde6;
}
.pf-new-theme .border-left-yellow-1-important {
  border-left: 1px solid #fffde6 !important;
}
.pf-new-theme .border-left-yellow-10-hover:hover {
  border-left: 1px solid #663f00;
}
.pf-new-theme .border-left-yellow-10-important-hover:hover {
  border-left: 1px solid #663f00 !important;
}
.pf-new-theme .border-left-yellow-9-hover:hover {
  border-left: 1px solid #8c5b00;
}
.pf-new-theme .border-left-yellow-9-important-hover:hover {
  border-left: 1px solid #8c5b00 !important;
}
.pf-new-theme .border-left-yellow-8-hover:hover {
  border-left: 1px solid #b37a00;
}
.pf-new-theme .border-left-yellow-8-important-hover:hover {
  border-left: 1px solid #b37a00 !important;
}
.pf-new-theme .border-left-yellow-7-hover:hover {
  border-left: 1px solid #d99b00;
}
.pf-new-theme .border-left-yellow-7-important-hover:hover {
  border-left: 1px solid #d99b00 !important;
}
.pf-new-theme .border-left-yellow-6-hover:hover {
  border-left: 1px solid #ffc000;
}
.pf-new-theme .border-left-yellow-6-important-hover:hover {
  border-left: 1px solid #ffc000 !important;
}
.pf-new-theme .border-left-yellow-5-hover:hover {
  border-left: 1px solid #ffd129;
}
.pf-new-theme .border-left-yellow-5-important-hover:hover {
  border-left: 1px solid #ffd129 !important;
}
.pf-new-theme .border-left-yellow-4-hover:hover {
  border-left: 1px solid #ffdf52;
}
.pf-new-theme .border-left-yellow-4-important-hover:hover {
  border-left: 1px solid #ffdf52 !important;
}
.pf-new-theme .border-left-yellow-3-hover:hover {
  border-left: 1px solid #ffeb7a;
}
.pf-new-theme .border-left-yellow-3-important-hover:hover {
  border-left: 1px solid #ffeb7a !important;
}
.pf-new-theme .border-left-yellow-2-hover:hover {
  border-left: 1px solid #fff4a3;
}
.pf-new-theme .border-left-yellow-2-important-hover:hover {
  border-left: 1px solid #fff4a3 !important;
}
.pf-new-theme .border-left-yellow-1-hover:hover {
  border-left: 1px solid #fffde6;
}
.pf-new-theme .border-left-yellow-1-important-hover:hover {
  border-left: 1px solid #fffde6 !important;
}
.pf-new-theme .border-color-yellow-10 {
  border-color:  #663f00;
}
.pf-new-theme .border-color-yellow-10-important {
  border-color:  #663f00 !important;
}
.pf-new-theme .border-color-yellow-9 {
  border-color:  #8c5b00;
}
.pf-new-theme .border-color-yellow-9-important {
  border-color:  #8c5b00 !important;
}
.pf-new-theme .border-color-yellow-8 {
  border-color:  #b37a00;
}
.pf-new-theme .border-color-yellow-8-important {
  border-color:  #b37a00 !important;
}
.pf-new-theme .border-color-yellow-7 {
  border-color:  #d99b00;
}
.pf-new-theme .border-color-yellow-7-important {
  border-color:  #d99b00 !important;
}
.pf-new-theme .border-color-yellow-6 {
  border-color:  #ffc000;
}
.pf-new-theme .border-color-yellow-6-important {
  border-color:  #ffc000 !important;
}
.pf-new-theme .border-color-yellow-5 {
  border-color:  #ffd129;
}
.pf-new-theme .border-color-yellow-5-important {
  border-color:  #ffd129 !important;
}
.pf-new-theme .border-color-yellow-4 {
  border-color:  #ffdf52;
}
.pf-new-theme .border-color-yellow-4-important {
  border-color:  #ffdf52 !important;
}
.pf-new-theme .border-color-yellow-3 {
  border-color:  #ffeb7a;
}
.pf-new-theme .border-color-yellow-3-important {
  border-color:  #ffeb7a !important;
}
.pf-new-theme .border-color-yellow-2 {
  border-color:  #fff4a3;
}
.pf-new-theme .border-color-yellow-2-important {
  border-color:  #fff4a3 !important;
}
.pf-new-theme .border-color-yellow-1 {
  border-color:  #fffde6;
}
.pf-new-theme .border-color-yellow-1-important {
  border-color:  #fffde6 !important;
}
.pf-new-theme .border-color-yellow-10-hover:hover {
  border-color:  #663f00;
}
.pf-new-theme .border-color-yellow-10-important-hover:hover {
  border-color:  #663f00 !important;
}
.pf-new-theme .border-color-yellow-9-hover:hover {
  border-color:  #8c5b00;
}
.pf-new-theme .border-color-yellow-9-important-hover:hover {
  border-color:  #8c5b00 !important;
}
.pf-new-theme .border-color-yellow-8-hover:hover {
  border-color:  #b37a00;
}
.pf-new-theme .border-color-yellow-8-important-hover:hover {
  border-color:  #b37a00 !important;
}
.pf-new-theme .border-color-yellow-7-hover:hover {
  border-color:  #d99b00;
}
.pf-new-theme .border-color-yellow-7-important-hover:hover {
  border-color:  #d99b00 !important;
}
.pf-new-theme .border-color-yellow-6-hover:hover {
  border-color:  #ffc000;
}
.pf-new-theme .border-color-yellow-6-important-hover:hover {
  border-color:  #ffc000 !important;
}
.pf-new-theme .border-color-yellow-5-hover:hover {
  border-color:  #ffd129;
}
.pf-new-theme .border-color-yellow-5-important-hover:hover {
  border-color:  #ffd129 !important;
}
.pf-new-theme .border-color-yellow-4-hover:hover {
  border-color:  #ffdf52;
}
.pf-new-theme .border-color-yellow-4-important-hover:hover {
  border-color:  #ffdf52 !important;
}
.pf-new-theme .border-color-yellow-3-hover:hover {
  border-color:  #ffeb7a;
}
.pf-new-theme .border-color-yellow-3-important-hover:hover {
  border-color:  #ffeb7a !important;
}
.pf-new-theme .border-color-yellow-2-hover:hover {
  border-color:  #fff4a3;
}
.pf-new-theme .border-color-yellow-2-important-hover:hover {
  border-color:  #fff4a3 !important;
}
.pf-new-theme .border-color-yellow-1-hover:hover {
  border-color:  #fffde6;
}
.pf-new-theme .border-color-yellow-1-important-hover:hover {
  border-color:  #fffde6 !important;
}
.pf-new-theme .color-orange-10 {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9 {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8 {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7 {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6 {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5 {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4 {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3 {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2 {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1 {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-hover:hover {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-hover:hover {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-hover:hover {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-hover:hover {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-hover:hover {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-hover:hover {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-hover:hover {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-hover:hover {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-hover:hover {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-hover:hover {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-hover:hover {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-hover:hover {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-hover:hover {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-hover:hover {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-hover:hover {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-hover:hover {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-hover:hover {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-hover:hover {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-hover:hover {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-hover:hover {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-hover.active-hover {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-hover.active-hover {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-hover.active-hover {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-hover.active-hover {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-hover.active-hover {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-hover.active-hover {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-hover.active-hover {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-hover.active-hover {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-hover.active-hover {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-hover.active-hover {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-hover.active-hover {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-hover.active-hover {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-hover.active-hover {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-hover.active-hover {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-hover.active-hover {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-hover.active-hover {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-hover.active-hover {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-hover.active-hover {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-hover.active-hover {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-hover.active-hover {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-hover:focus {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-hover:focus {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-hover:focus {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-hover:focus {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-hover:focus {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-hover:focus {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-hover:focus {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-hover:focus {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-hover:focus {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-hover:focus {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-hover:focus {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-hover:focus {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-hover:focus {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-hover:focus {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-hover:focus {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-hover:focus {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-hover:focus {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-hover:focus {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-hover:focus {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-hover:focus {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-hover.active-focus {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-hover.active-focus {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-hover.active-focus {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-hover.active-focus {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-hover.active-focus {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-hover.active-focus {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-hover.active-focus {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-hover.active-focus {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-hover.active-focus {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-hover.active-focus {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-hover.active-focus {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-hover.active-focus {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-hover.active-focus {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-hover.active-focus {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-hover.active-focus {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-hover.active-focus {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-hover.active-focus {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-hover.active-focus {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-hover.active-focus {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-hover.active-focus {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-focus:focus {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-focus:focus {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-focus:focus {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-focus:focus {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-focus:focus {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-focus:focus {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-focus:focus {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-focus:focus {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-focus:focus {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-focus:focus {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-focus:focus {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-focus:focus {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-focus:focus {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-focus:focus {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-focus:focus {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-focus:focus {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-focus:focus {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-focus:focus {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-focus:focus {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-focus:focus {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-focus.active-focus {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-focus.active-focus {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-focus.active-focus {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-focus.active-focus {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-focus.active-focus {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-focus.active-focus {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-focus.active-focus {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-focus.active-focus {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-focus.active-focus {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-focus.active-focus {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-focus.active-focus {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-focus.active-focus {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-focus.active-focus {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-focus.active-focus {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-focus.active-focus {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-focus.active-focus {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-focus.active-focus {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-focus.active-focus {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-focus.active-focus {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-focus.active-focus {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-placeholder::placeholder {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-placeholder::placeholder {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-placeholder::placeholder {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-placeholder::placeholder {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-placeholder::placeholder {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-placeholder::placeholder {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-placeholder::placeholder {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-placeholder::placeholder {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-placeholder::placeholder {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-placeholder::placeholder {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-placeholder::placeholder {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-placeholder::placeholder {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-placeholder::placeholder {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-placeholder::placeholder {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-placeholder::placeholder {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-placeholder::placeholder {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-placeholder::placeholder {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-placeholder::placeholder {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-placeholder::placeholder {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-placeholder::placeholder {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-orange-10-placeholder.active-placeholder {
  color:  #611800;
}
.pf-new-theme .color-orange-10-important-placeholder.active-placeholder {
  color:  #611800 !important;
}
.pf-new-theme .color-orange-9-placeholder.active-placeholder {
  color:  #872600;
}
.pf-new-theme .color-orange-9-important-placeholder.active-placeholder {
  color:  #872600 !important;
}
.pf-new-theme .color-orange-8-placeholder.active-placeholder {
  color:  #ad3700;
}
.pf-new-theme .color-orange-8-important-placeholder.active-placeholder {
  color:  #ad3700 !important;
}
.pf-new-theme .color-orange-7-placeholder.active-placeholder {
  color:  #d44b02;
}
.pf-new-theme .color-orange-7-important-placeholder.active-placeholder {
  color:  #d44b02 !important;
}
.pf-new-theme .color-orange-6-placeholder.active-placeholder {
  color:  #f9690e;
}
.pf-new-theme .color-orange-6-important-placeholder.active-placeholder {
  color:  #f9690e !important;
}
.pf-new-theme .color-orange-5-placeholder.active-placeholder {
  color:  #ff8b38;
}
.pf-new-theme .color-orange-5-important-placeholder.active-placeholder {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-orange-4-placeholder.active-placeholder {
  color:  #ffa861;
}
.pf-new-theme .color-orange-4-important-placeholder.active-placeholder {
  color:  #ffa861 !important;
}
.pf-new-theme .color-orange-3-placeholder.active-placeholder {
  color:  #ffc28a;
}
.pf-new-theme .color-orange-3-important-placeholder.active-placeholder {
  color:  #ffc28a !important;
}
.pf-new-theme .color-orange-2-placeholder.active-placeholder {
  color:  #ffdab3;
}
.pf-new-theme .color-orange-2-important-placeholder.active-placeholder {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-orange-1-placeholder.active-placeholder {
  color:  #fff4e6;
}
.pf-new-theme .color-orange-1-important-placeholder.active-placeholder {
  color:  #fff4e6 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-10-hover {
  color:  #611800;
}
.pf-new-theme .color-hover-parent:hover .color-orange-10-important-hover {
  color:  #611800 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-9-hover {
  color:  #872600;
}
.pf-new-theme .color-hover-parent:hover .color-orange-9-important-hover {
  color:  #872600 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-8-hover {
  color:  #ad3700;
}
.pf-new-theme .color-hover-parent:hover .color-orange-8-important-hover {
  color:  #ad3700 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-7-hover {
  color:  #d44b02;
}
.pf-new-theme .color-hover-parent:hover .color-orange-7-important-hover {
  color:  #d44b02 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-6-hover {
  color:  #f9690e;
}
.pf-new-theme .color-hover-parent:hover .color-orange-6-important-hover {
  color:  #f9690e !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-5-hover {
  color:  #ff8b38;
}
.pf-new-theme .color-hover-parent:hover .color-orange-5-important-hover {
  color:  #ff8b38 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-4-hover {
  color:  #ffa861;
}
.pf-new-theme .color-hover-parent:hover .color-orange-4-important-hover {
  color:  #ffa861 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-3-hover {
  color:  #ffc28a;
}
.pf-new-theme .color-hover-parent:hover .color-orange-3-important-hover {
  color:  #ffc28a !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-2-hover {
  color:  #ffdab3;
}
.pf-new-theme .color-hover-parent:hover .color-orange-2-important-hover {
  color:  #ffdab3 !important;
}
.pf-new-theme .color-hover-parent:hover .color-orange-1-hover {
  color:  #fff4e6;
}
.pf-new-theme .color-hover-parent:hover .color-orange-1-important-hover {
  color:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10 {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9 {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8 {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7 {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6 {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5 {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4 {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3 {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2 {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1 {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important {
  background:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10-hover:hover {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important-hover:hover {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9-hover:hover {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important-hover:hover {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8-hover:hover {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important-hover:hover {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7-hover:hover {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important-hover:hover {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6-hover:hover {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important-hover:hover {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5-hover:hover {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important-hover:hover {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4-hover:hover {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important-hover:hover {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3-hover:hover {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important-hover:hover {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2-hover:hover {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important-hover:hover {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1-hover:hover {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important-hover:hover {
  background:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10-hover.active-hover {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important-hover.active-hover {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9-hover.active-hover {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important-hover.active-hover {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8-hover.active-hover {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important-hover.active-hover {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7-hover.active-hover {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important-hover.active-hover {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6-hover.active-hover {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important-hover.active-hover {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5-hover.active-hover {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important-hover.active-hover {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4-hover.active-hover {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important-hover.active-hover {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3-hover.active-hover {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important-hover.active-hover {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2-hover.active-hover {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important-hover.active-hover {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1-hover.active-hover {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important-hover.active-hover {
  background:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10-hover:focus {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important-hover:focus {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9-hover:focus {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important-hover:focus {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8-hover:focus {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important-hover:focus {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7-hover:focus {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important-hover:focus {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6-hover:focus {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important-hover:focus {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5-hover:focus {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important-hover:focus {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4-hover:focus {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important-hover:focus {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3-hover:focus {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important-hover:focus {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2-hover:focus {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important-hover:focus {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1-hover:focus {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important-hover:focus {
  background:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10-hover.active-focus {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important-hover.active-focus {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9-hover.active-focus {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important-hover.active-focus {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8-hover.active-focus {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important-hover.active-focus {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7-hover.active-focus {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important-hover.active-focus {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6-hover.active-focus {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important-hover.active-focus {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5-hover.active-focus {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important-hover.active-focus {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4-hover.active-focus {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important-hover.active-focus {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3-hover.active-focus {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important-hover.active-focus {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2-hover.active-focus {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important-hover.active-focus {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1-hover.active-focus {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important-hover.active-focus {
  background:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10-focus:focus {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important-focus:focus {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9-focus:focus {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important-focus:focus {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8-focus:focus {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important-focus:focus {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7-focus:focus {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important-focus:focus {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6-focus:focus {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important-focus:focus {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5-focus:focus {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important-focus:focus {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4-focus:focus {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important-focus:focus {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3-focus:focus {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important-focus:focus {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2-focus:focus {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important-focus:focus {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1-focus:focus {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important-focus:focus {
  background:  #fff4e6 !important;
}
.pf-new-theme .background-orange-10-focus.active-focus {
  background:  #611800;
}
.pf-new-theme .background-orange-10-important-focus.active-focus {
  background:  #611800 !important;
}
.pf-new-theme .background-orange-9-focus.active-focus {
  background:  #872600;
}
.pf-new-theme .background-orange-9-important-focus.active-focus {
  background:  #872600 !important;
}
.pf-new-theme .background-orange-8-focus.active-focus {
  background:  #ad3700;
}
.pf-new-theme .background-orange-8-important-focus.active-focus {
  background:  #ad3700 !important;
}
.pf-new-theme .background-orange-7-focus.active-focus {
  background:  #d44b02;
}
.pf-new-theme .background-orange-7-important-focus.active-focus {
  background:  #d44b02 !important;
}
.pf-new-theme .background-orange-6-focus.active-focus {
  background:  #f9690e;
}
.pf-new-theme .background-orange-6-important-focus.active-focus {
  background:  #f9690e !important;
}
.pf-new-theme .background-orange-5-focus.active-focus {
  background:  #ff8b38;
}
.pf-new-theme .background-orange-5-important-focus.active-focus {
  background:  #ff8b38 !important;
}
.pf-new-theme .background-orange-4-focus.active-focus {
  background:  #ffa861;
}
.pf-new-theme .background-orange-4-important-focus.active-focus {
  background:  #ffa861 !important;
}
.pf-new-theme .background-orange-3-focus.active-focus {
  background:  #ffc28a;
}
.pf-new-theme .background-orange-3-important-focus.active-focus {
  background:  #ffc28a !important;
}
.pf-new-theme .background-orange-2-focus.active-focus {
  background:  #ffdab3;
}
.pf-new-theme .background-orange-2-important-focus.active-focus {
  background:  #ffdab3 !important;
}
.pf-new-theme .background-orange-1-focus.active-focus {
  background:  #fff4e6;
}
.pf-new-theme .background-orange-1-important-focus.active-focus {
  background:  #fff4e6 !important;
}
.pf-new-theme .border-orange-10 {
  border: 1px solid #611800;
}
.pf-new-theme .border-orange-10-important {
  border: 1px solid #611800 !important;
}
.pf-new-theme .border-orange-9 {
  border: 1px solid #872600;
}
.pf-new-theme .border-orange-9-important {
  border: 1px solid #872600 !important;
}
.pf-new-theme .border-orange-8 {
  border: 1px solid #ad3700;
}
.pf-new-theme .border-orange-8-important {
  border: 1px solid #ad3700 !important;
}
.pf-new-theme .border-orange-7 {
  border: 1px solid #d44b02;
}
.pf-new-theme .border-orange-7-important {
  border: 1px solid #d44b02 !important;
}
.pf-new-theme .border-orange-6 {
  border: 1px solid #f9690e;
}
.pf-new-theme .border-orange-6-important {
  border: 1px solid #f9690e !important;
}
.pf-new-theme .border-orange-5 {
  border: 1px solid #ff8b38;
}
.pf-new-theme .border-orange-5-important {
  border: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-orange-4 {
  border: 1px solid #ffa861;
}
.pf-new-theme .border-orange-4-important {
  border: 1px solid #ffa861 !important;
}
.pf-new-theme .border-orange-3 {
  border: 1px solid #ffc28a;
}
.pf-new-theme .border-orange-3-important {
  border: 1px solid #ffc28a !important;
}
.pf-new-theme .border-orange-2 {
  border: 1px solid #ffdab3;
}
.pf-new-theme .border-orange-2-important {
  border: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-orange-1 {
  border: 1px solid #fff4e6;
}
.pf-new-theme .border-orange-1-important {
  border: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-orange-10-hover:hover {
  border: 1px solid #611800;
}
.pf-new-theme .border-orange-10-important-hover:hover {
  border: 1px solid #611800 !important;
}
.pf-new-theme .border-orange-9-hover:hover {
  border: 1px solid #872600;
}
.pf-new-theme .border-orange-9-important-hover:hover {
  border: 1px solid #872600 !important;
}
.pf-new-theme .border-orange-8-hover:hover {
  border: 1px solid #ad3700;
}
.pf-new-theme .border-orange-8-important-hover:hover {
  border: 1px solid #ad3700 !important;
}
.pf-new-theme .border-orange-7-hover:hover {
  border: 1px solid #d44b02;
}
.pf-new-theme .border-orange-7-important-hover:hover {
  border: 1px solid #d44b02 !important;
}
.pf-new-theme .border-orange-6-hover:hover {
  border: 1px solid #f9690e;
}
.pf-new-theme .border-orange-6-important-hover:hover {
  border: 1px solid #f9690e !important;
}
.pf-new-theme .border-orange-5-hover:hover {
  border: 1px solid #ff8b38;
}
.pf-new-theme .border-orange-5-important-hover:hover {
  border: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-orange-4-hover:hover {
  border: 1px solid #ffa861;
}
.pf-new-theme .border-orange-4-important-hover:hover {
  border: 1px solid #ffa861 !important;
}
.pf-new-theme .border-orange-3-hover:hover {
  border: 1px solid #ffc28a;
}
.pf-new-theme .border-orange-3-important-hover:hover {
  border: 1px solid #ffc28a !important;
}
.pf-new-theme .border-orange-2-hover:hover {
  border: 1px solid #ffdab3;
}
.pf-new-theme .border-orange-2-important-hover:hover {
  border: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-orange-1-hover:hover {
  border: 1px solid #fff4e6;
}
.pf-new-theme .border-orange-1-important-hover:hover {
  border: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-orange-10-focus:focus {
  border: 1px solid #611800;
}
.pf-new-theme .border-orange-10-important-focus:focus {
  border: 1px solid #611800 !important;
}
.pf-new-theme .border-orange-9-focus:focus {
  border: 1px solid #872600;
}
.pf-new-theme .border-orange-9-important-focus:focus {
  border: 1px solid #872600 !important;
}
.pf-new-theme .border-orange-8-focus:focus {
  border: 1px solid #ad3700;
}
.pf-new-theme .border-orange-8-important-focus:focus {
  border: 1px solid #ad3700 !important;
}
.pf-new-theme .border-orange-7-focus:focus {
  border: 1px solid #d44b02;
}
.pf-new-theme .border-orange-7-important-focus:focus {
  border: 1px solid #d44b02 !important;
}
.pf-new-theme .border-orange-6-focus:focus {
  border: 1px solid #f9690e;
}
.pf-new-theme .border-orange-6-important-focus:focus {
  border: 1px solid #f9690e !important;
}
.pf-new-theme .border-orange-5-focus:focus {
  border: 1px solid #ff8b38;
}
.pf-new-theme .border-orange-5-important-focus:focus {
  border: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-orange-4-focus:focus {
  border: 1px solid #ffa861;
}
.pf-new-theme .border-orange-4-important-focus:focus {
  border: 1px solid #ffa861 !important;
}
.pf-new-theme .border-orange-3-focus:focus {
  border: 1px solid #ffc28a;
}
.pf-new-theme .border-orange-3-important-focus:focus {
  border: 1px solid #ffc28a !important;
}
.pf-new-theme .border-orange-2-focus:focus {
  border: 1px solid #ffdab3;
}
.pf-new-theme .border-orange-2-important-focus:focus {
  border: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-orange-1-focus:focus {
  border: 1px solid #fff4e6;
}
.pf-new-theme .border-orange-1-important-focus:focus {
  border: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-top-orange-10 {
  border-top: 1px solid #611800;
}
.pf-new-theme .border-top-orange-10-important {
  border-top: 1px solid #611800 !important;
}
.pf-new-theme .border-top-orange-9 {
  border-top: 1px solid #872600;
}
.pf-new-theme .border-top-orange-9-important {
  border-top: 1px solid #872600 !important;
}
.pf-new-theme .border-top-orange-8 {
  border-top: 1px solid #ad3700;
}
.pf-new-theme .border-top-orange-8-important {
  border-top: 1px solid #ad3700 !important;
}
.pf-new-theme .border-top-orange-7 {
  border-top: 1px solid #d44b02;
}
.pf-new-theme .border-top-orange-7-important {
  border-top: 1px solid #d44b02 !important;
}
.pf-new-theme .border-top-orange-6 {
  border-top: 1px solid #f9690e;
}
.pf-new-theme .border-top-orange-6-important {
  border-top: 1px solid #f9690e !important;
}
.pf-new-theme .border-top-orange-5 {
  border-top: 1px solid #ff8b38;
}
.pf-new-theme .border-top-orange-5-important {
  border-top: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-top-orange-4 {
  border-top: 1px solid #ffa861;
}
.pf-new-theme .border-top-orange-4-important {
  border-top: 1px solid #ffa861 !important;
}
.pf-new-theme .border-top-orange-3 {
  border-top: 1px solid #ffc28a;
}
.pf-new-theme .border-top-orange-3-important {
  border-top: 1px solid #ffc28a !important;
}
.pf-new-theme .border-top-orange-2 {
  border-top: 1px solid #ffdab3;
}
.pf-new-theme .border-top-orange-2-important {
  border-top: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-top-orange-1 {
  border-top: 1px solid #fff4e6;
}
.pf-new-theme .border-top-orange-1-important {
  border-top: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-top-orange-10-hover:hover {
  border-top: 1px solid #611800;
}
.pf-new-theme .border-top-orange-10-important-hover:hover {
  border-top: 1px solid #611800 !important;
}
.pf-new-theme .border-top-orange-9-hover:hover {
  border-top: 1px solid #872600;
}
.pf-new-theme .border-top-orange-9-important-hover:hover {
  border-top: 1px solid #872600 !important;
}
.pf-new-theme .border-top-orange-8-hover:hover {
  border-top: 1px solid #ad3700;
}
.pf-new-theme .border-top-orange-8-important-hover:hover {
  border-top: 1px solid #ad3700 !important;
}
.pf-new-theme .border-top-orange-7-hover:hover {
  border-top: 1px solid #d44b02;
}
.pf-new-theme .border-top-orange-7-important-hover:hover {
  border-top: 1px solid #d44b02 !important;
}
.pf-new-theme .border-top-orange-6-hover:hover {
  border-top: 1px solid #f9690e;
}
.pf-new-theme .border-top-orange-6-important-hover:hover {
  border-top: 1px solid #f9690e !important;
}
.pf-new-theme .border-top-orange-5-hover:hover {
  border-top: 1px solid #ff8b38;
}
.pf-new-theme .border-top-orange-5-important-hover:hover {
  border-top: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-top-orange-4-hover:hover {
  border-top: 1px solid #ffa861;
}
.pf-new-theme .border-top-orange-4-important-hover:hover {
  border-top: 1px solid #ffa861 !important;
}
.pf-new-theme .border-top-orange-3-hover:hover {
  border-top: 1px solid #ffc28a;
}
.pf-new-theme .border-top-orange-3-important-hover:hover {
  border-top: 1px solid #ffc28a !important;
}
.pf-new-theme .border-top-orange-2-hover:hover {
  border-top: 1px solid #ffdab3;
}
.pf-new-theme .border-top-orange-2-important-hover:hover {
  border-top: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-top-orange-1-hover:hover {
  border-top: 1px solid #fff4e6;
}
.pf-new-theme .border-top-orange-1-important-hover:hover {
  border-top: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-right-orange-10 {
  border-right: 1px solid #611800;
}
.pf-new-theme .border-right-orange-10-important {
  border-right: 1px solid #611800 !important;
}
.pf-new-theme .border-right-orange-9 {
  border-right: 1px solid #872600;
}
.pf-new-theme .border-right-orange-9-important {
  border-right: 1px solid #872600 !important;
}
.pf-new-theme .border-right-orange-8 {
  border-right: 1px solid #ad3700;
}
.pf-new-theme .border-right-orange-8-important {
  border-right: 1px solid #ad3700 !important;
}
.pf-new-theme .border-right-orange-7 {
  border-right: 1px solid #d44b02;
}
.pf-new-theme .border-right-orange-7-important {
  border-right: 1px solid #d44b02 !important;
}
.pf-new-theme .border-right-orange-6 {
  border-right: 1px solid #f9690e;
}
.pf-new-theme .border-right-orange-6-important {
  border-right: 1px solid #f9690e !important;
}
.pf-new-theme .border-right-orange-5 {
  border-right: 1px solid #ff8b38;
}
.pf-new-theme .border-right-orange-5-important {
  border-right: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-right-orange-4 {
  border-right: 1px solid #ffa861;
}
.pf-new-theme .border-right-orange-4-important {
  border-right: 1px solid #ffa861 !important;
}
.pf-new-theme .border-right-orange-3 {
  border-right: 1px solid #ffc28a;
}
.pf-new-theme .border-right-orange-3-important {
  border-right: 1px solid #ffc28a !important;
}
.pf-new-theme .border-right-orange-2 {
  border-right: 1px solid #ffdab3;
}
.pf-new-theme .border-right-orange-2-important {
  border-right: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-right-orange-1 {
  border-right: 1px solid #fff4e6;
}
.pf-new-theme .border-right-orange-1-important {
  border-right: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-right-orange-10-hover:hover {
  border-right: 1px solid #611800;
}
.pf-new-theme .border-right-orange-10-important-hover:hover {
  border-right: 1px solid #611800 !important;
}
.pf-new-theme .border-right-orange-9-hover:hover {
  border-right: 1px solid #872600;
}
.pf-new-theme .border-right-orange-9-important-hover:hover {
  border-right: 1px solid #872600 !important;
}
.pf-new-theme .border-right-orange-8-hover:hover {
  border-right: 1px solid #ad3700;
}
.pf-new-theme .border-right-orange-8-important-hover:hover {
  border-right: 1px solid #ad3700 !important;
}
.pf-new-theme .border-right-orange-7-hover:hover {
  border-right: 1px solid #d44b02;
}
.pf-new-theme .border-right-orange-7-important-hover:hover {
  border-right: 1px solid #d44b02 !important;
}
.pf-new-theme .border-right-orange-6-hover:hover {
  border-right: 1px solid #f9690e;
}
.pf-new-theme .border-right-orange-6-important-hover:hover {
  border-right: 1px solid #f9690e !important;
}
.pf-new-theme .border-right-orange-5-hover:hover {
  border-right: 1px solid #ff8b38;
}
.pf-new-theme .border-right-orange-5-important-hover:hover {
  border-right: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-right-orange-4-hover:hover {
  border-right: 1px solid #ffa861;
}
.pf-new-theme .border-right-orange-4-important-hover:hover {
  border-right: 1px solid #ffa861 !important;
}
.pf-new-theme .border-right-orange-3-hover:hover {
  border-right: 1px solid #ffc28a;
}
.pf-new-theme .border-right-orange-3-important-hover:hover {
  border-right: 1px solid #ffc28a !important;
}
.pf-new-theme .border-right-orange-2-hover:hover {
  border-right: 1px solid #ffdab3;
}
.pf-new-theme .border-right-orange-2-important-hover:hover {
  border-right: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-right-orange-1-hover:hover {
  border-right: 1px solid #fff4e6;
}
.pf-new-theme .border-right-orange-1-important-hover:hover {
  border-right: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-bottom-orange-10 {
  border-bottom: 1px solid #611800;
}
.pf-new-theme .border-bottom-orange-10-important {
  border-bottom: 1px solid #611800 !important;
}
.pf-new-theme .border-bottom-orange-9 {
  border-bottom: 1px solid #872600;
}
.pf-new-theme .border-bottom-orange-9-important {
  border-bottom: 1px solid #872600 !important;
}
.pf-new-theme .border-bottom-orange-8 {
  border-bottom: 1px solid #ad3700;
}
.pf-new-theme .border-bottom-orange-8-important {
  border-bottom: 1px solid #ad3700 !important;
}
.pf-new-theme .border-bottom-orange-7 {
  border-bottom: 1px solid #d44b02;
}
.pf-new-theme .border-bottom-orange-7-important {
  border-bottom: 1px solid #d44b02 !important;
}
.pf-new-theme .border-bottom-orange-6 {
  border-bottom: 1px solid #f9690e;
}
.pf-new-theme .border-bottom-orange-6-important {
  border-bottom: 1px solid #f9690e !important;
}
.pf-new-theme .border-bottom-orange-5 {
  border-bottom: 1px solid #ff8b38;
}
.pf-new-theme .border-bottom-orange-5-important {
  border-bottom: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-bottom-orange-4 {
  border-bottom: 1px solid #ffa861;
}
.pf-new-theme .border-bottom-orange-4-important {
  border-bottom: 1px solid #ffa861 !important;
}
.pf-new-theme .border-bottom-orange-3 {
  border-bottom: 1px solid #ffc28a;
}
.pf-new-theme .border-bottom-orange-3-important {
  border-bottom: 1px solid #ffc28a !important;
}
.pf-new-theme .border-bottom-orange-2 {
  border-bottom: 1px solid #ffdab3;
}
.pf-new-theme .border-bottom-orange-2-important {
  border-bottom: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-bottom-orange-1 {
  border-bottom: 1px solid #fff4e6;
}
.pf-new-theme .border-bottom-orange-1-important {
  border-bottom: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-bottom-orange-10-hover:hover {
  border-bottom: 1px solid #611800;
}
.pf-new-theme .border-bottom-orange-10-important-hover:hover {
  border-bottom: 1px solid #611800 !important;
}
.pf-new-theme .border-bottom-orange-9-hover:hover {
  border-bottom: 1px solid #872600;
}
.pf-new-theme .border-bottom-orange-9-important-hover:hover {
  border-bottom: 1px solid #872600 !important;
}
.pf-new-theme .border-bottom-orange-8-hover:hover {
  border-bottom: 1px solid #ad3700;
}
.pf-new-theme .border-bottom-orange-8-important-hover:hover {
  border-bottom: 1px solid #ad3700 !important;
}
.pf-new-theme .border-bottom-orange-7-hover:hover {
  border-bottom: 1px solid #d44b02;
}
.pf-new-theme .border-bottom-orange-7-important-hover:hover {
  border-bottom: 1px solid #d44b02 !important;
}
.pf-new-theme .border-bottom-orange-6-hover:hover {
  border-bottom: 1px solid #f9690e;
}
.pf-new-theme .border-bottom-orange-6-important-hover:hover {
  border-bottom: 1px solid #f9690e !important;
}
.pf-new-theme .border-bottom-orange-5-hover:hover {
  border-bottom: 1px solid #ff8b38;
}
.pf-new-theme .border-bottom-orange-5-important-hover:hover {
  border-bottom: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-bottom-orange-4-hover:hover {
  border-bottom: 1px solid #ffa861;
}
.pf-new-theme .border-bottom-orange-4-important-hover:hover {
  border-bottom: 1px solid #ffa861 !important;
}
.pf-new-theme .border-bottom-orange-3-hover:hover {
  border-bottom: 1px solid #ffc28a;
}
.pf-new-theme .border-bottom-orange-3-important-hover:hover {
  border-bottom: 1px solid #ffc28a !important;
}
.pf-new-theme .border-bottom-orange-2-hover:hover {
  border-bottom: 1px solid #ffdab3;
}
.pf-new-theme .border-bottom-orange-2-important-hover:hover {
  border-bottom: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-bottom-orange-1-hover:hover {
  border-bottom: 1px solid #fff4e6;
}
.pf-new-theme .border-bottom-orange-1-important-hover:hover {
  border-bottom: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-left-orange-10 {
  border-left: 1px solid #611800;
}
.pf-new-theme .border-left-orange-10-important {
  border-left: 1px solid #611800 !important;
}
.pf-new-theme .border-left-orange-9 {
  border-left: 1px solid #872600;
}
.pf-new-theme .border-left-orange-9-important {
  border-left: 1px solid #872600 !important;
}
.pf-new-theme .border-left-orange-8 {
  border-left: 1px solid #ad3700;
}
.pf-new-theme .border-left-orange-8-important {
  border-left: 1px solid #ad3700 !important;
}
.pf-new-theme .border-left-orange-7 {
  border-left: 1px solid #d44b02;
}
.pf-new-theme .border-left-orange-7-important {
  border-left: 1px solid #d44b02 !important;
}
.pf-new-theme .border-left-orange-6 {
  border-left: 1px solid #f9690e;
}
.pf-new-theme .border-left-orange-6-important {
  border-left: 1px solid #f9690e !important;
}
.pf-new-theme .border-left-orange-5 {
  border-left: 1px solid #ff8b38;
}
.pf-new-theme .border-left-orange-5-important {
  border-left: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-left-orange-4 {
  border-left: 1px solid #ffa861;
}
.pf-new-theme .border-left-orange-4-important {
  border-left: 1px solid #ffa861 !important;
}
.pf-new-theme .border-left-orange-3 {
  border-left: 1px solid #ffc28a;
}
.pf-new-theme .border-left-orange-3-important {
  border-left: 1px solid #ffc28a !important;
}
.pf-new-theme .border-left-orange-2 {
  border-left: 1px solid #ffdab3;
}
.pf-new-theme .border-left-orange-2-important {
  border-left: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-left-orange-1 {
  border-left: 1px solid #fff4e6;
}
.pf-new-theme .border-left-orange-1-important {
  border-left: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-left-orange-10-hover:hover {
  border-left: 1px solid #611800;
}
.pf-new-theme .border-left-orange-10-important-hover:hover {
  border-left: 1px solid #611800 !important;
}
.pf-new-theme .border-left-orange-9-hover:hover {
  border-left: 1px solid #872600;
}
.pf-new-theme .border-left-orange-9-important-hover:hover {
  border-left: 1px solid #872600 !important;
}
.pf-new-theme .border-left-orange-8-hover:hover {
  border-left: 1px solid #ad3700;
}
.pf-new-theme .border-left-orange-8-important-hover:hover {
  border-left: 1px solid #ad3700 !important;
}
.pf-new-theme .border-left-orange-7-hover:hover {
  border-left: 1px solid #d44b02;
}
.pf-new-theme .border-left-orange-7-important-hover:hover {
  border-left: 1px solid #d44b02 !important;
}
.pf-new-theme .border-left-orange-6-hover:hover {
  border-left: 1px solid #f9690e;
}
.pf-new-theme .border-left-orange-6-important-hover:hover {
  border-left: 1px solid #f9690e !important;
}
.pf-new-theme .border-left-orange-5-hover:hover {
  border-left: 1px solid #ff8b38;
}
.pf-new-theme .border-left-orange-5-important-hover:hover {
  border-left: 1px solid #ff8b38 !important;
}
.pf-new-theme .border-left-orange-4-hover:hover {
  border-left: 1px solid #ffa861;
}
.pf-new-theme .border-left-orange-4-important-hover:hover {
  border-left: 1px solid #ffa861 !important;
}
.pf-new-theme .border-left-orange-3-hover:hover {
  border-left: 1px solid #ffc28a;
}
.pf-new-theme .border-left-orange-3-important-hover:hover {
  border-left: 1px solid #ffc28a !important;
}
.pf-new-theme .border-left-orange-2-hover:hover {
  border-left: 1px solid #ffdab3;
}
.pf-new-theme .border-left-orange-2-important-hover:hover {
  border-left: 1px solid #ffdab3 !important;
}
.pf-new-theme .border-left-orange-1-hover:hover {
  border-left: 1px solid #fff4e6;
}
.pf-new-theme .border-left-orange-1-important-hover:hover {
  border-left: 1px solid #fff4e6 !important;
}
.pf-new-theme .border-color-orange-10 {
  border-color:  #611800;
}
.pf-new-theme .border-color-orange-10-important {
  border-color:  #611800 !important;
}
.pf-new-theme .border-color-orange-9 {
  border-color:  #872600;
}
.pf-new-theme .border-color-orange-9-important {
  border-color:  #872600 !important;
}
.pf-new-theme .border-color-orange-8 {
  border-color:  #ad3700;
}
.pf-new-theme .border-color-orange-8-important {
  border-color:  #ad3700 !important;
}
.pf-new-theme .border-color-orange-7 {
  border-color:  #d44b02;
}
.pf-new-theme .border-color-orange-7-important {
  border-color:  #d44b02 !important;
}
.pf-new-theme .border-color-orange-6 {
  border-color:  #f9690e;
}
.pf-new-theme .border-color-orange-6-important {
  border-color:  #f9690e !important;
}
.pf-new-theme .border-color-orange-5 {
  border-color:  #ff8b38;
}
.pf-new-theme .border-color-orange-5-important {
  border-color:  #ff8b38 !important;
}
.pf-new-theme .border-color-orange-4 {
  border-color:  #ffa861;
}
.pf-new-theme .border-color-orange-4-important {
  border-color:  #ffa861 !important;
}
.pf-new-theme .border-color-orange-3 {
  border-color:  #ffc28a;
}
.pf-new-theme .border-color-orange-3-important {
  border-color:  #ffc28a !important;
}
.pf-new-theme .border-color-orange-2 {
  border-color:  #ffdab3;
}
.pf-new-theme .border-color-orange-2-important {
  border-color:  #ffdab3 !important;
}
.pf-new-theme .border-color-orange-1 {
  border-color:  #fff4e6;
}
.pf-new-theme .border-color-orange-1-important {
  border-color:  #fff4e6 !important;
}
.pf-new-theme .border-color-orange-10-hover:hover {
  border-color:  #611800;
}
.pf-new-theme .border-color-orange-10-important-hover:hover {
  border-color:  #611800 !important;
}
.pf-new-theme .border-color-orange-9-hover:hover {
  border-color:  #872600;
}
.pf-new-theme .border-color-orange-9-important-hover:hover {
  border-color:  #872600 !important;
}
.pf-new-theme .border-color-orange-8-hover:hover {
  border-color:  #ad3700;
}
.pf-new-theme .border-color-orange-8-important-hover:hover {
  border-color:  #ad3700 !important;
}
.pf-new-theme .border-color-orange-7-hover:hover {
  border-color:  #d44b02;
}
.pf-new-theme .border-color-orange-7-important-hover:hover {
  border-color:  #d44b02 !important;
}
.pf-new-theme .border-color-orange-6-hover:hover {
  border-color:  #f9690e;
}
.pf-new-theme .border-color-orange-6-important-hover:hover {
  border-color:  #f9690e !important;
}
.pf-new-theme .border-color-orange-5-hover:hover {
  border-color:  #ff8b38;
}
.pf-new-theme .border-color-orange-5-important-hover:hover {
  border-color:  #ff8b38 !important;
}
.pf-new-theme .border-color-orange-4-hover:hover {
  border-color:  #ffa861;
}
.pf-new-theme .border-color-orange-4-important-hover:hover {
  border-color:  #ffa861 !important;
}
.pf-new-theme .border-color-orange-3-hover:hover {
  border-color:  #ffc28a;
}
.pf-new-theme .border-color-orange-3-important-hover:hover {
  border-color:  #ffc28a !important;
}
.pf-new-theme .border-color-orange-2-hover:hover {
  border-color:  #ffdab3;
}
.pf-new-theme .border-color-orange-2-important-hover:hover {
  border-color:  #ffdab3 !important;
}
.pf-new-theme .border-color-orange-1-hover:hover {
  border-color:  #fff4e6;
}
.pf-new-theme .border-color-orange-1-important-hover:hover {
  border-color:  #fff4e6 !important;
}
.pf-new-theme .opacity-100 {
  opacity: 1;
}
.pf-new-theme .opacity-100-hover:hover {
  opacity: 1;
}
.pf-new-theme .opacity-90 {
  opacity: 0.9;
}
.pf-new-theme .opacity-90-hover:hover {
  opacity: 0.9;
}
.pf-new-theme .opacity-80 {
  opacity: 0.8;
}
.pf-new-theme .opacity-80-hover:hover {
  opacity: 0.8;
}
.pf-new-theme .opacity-70 {
  opacity: 0.7;
}
.pf-new-theme .opacity-70-hover:hover {
  opacity: 0.7;
}
.pf-new-theme .opacity-60 {
  opacity: 0.6;
}
.pf-new-theme .opacity-60-hover:hover {
  opacity: 0.6;
}
.pf-new-theme .opacity-50 {
  opacity: 0.5;
}
.pf-new-theme .opacity-50-hover:hover {
  opacity: 0.5;
}
.pf-new-theme .opacity-40 {
  opacity: 0.4;
}
.pf-new-theme .opacity-40-hover:hover {
  opacity: 0.4;
}
.pf-new-theme .opacity-30 {
  opacity: 0.3;
}
.pf-new-theme .opacity-30-hover:hover {
  opacity: 0.3;
}
.pf-new-theme .opacity-20 {
  opacity: 0.2;
}
.pf-new-theme .opacity-20-hover:hover {
  opacity: 0.2;
}
.pf-new-theme .opacity-10 {
  opacity: 0.1;
}
.pf-new-theme .opacity-10-hover:hover {
  opacity: 0.1;
}
.pf-new-theme .opacity-0 {
  opacity: 0;
}
.pf-new-theme .opacity-0-hover:hover {
  opacity: 0;
}
.pf-new-theme .background-inherit {
  background: inherit;
}
.pf-new-theme .color-inherit {
  color: inherit;
}
.pf-new-theme .shadow-none,
.pf-new-theme .shadow-none-focus:focus,
.pf-new-theme .shadow-none-hover:hover {
  box-shadow: none;
}
.pf-new-theme .shadow-color-1-5-right-level-5 {
  box-shadow: 16px 0px 24px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-5 {
  box-shadow: 0px 16px 24px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-4 {
  box-shadow: 12px 0px 16px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-4 {
  box-shadow: 0px 12px 16px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-3 {
  box-shadow: 8px 0px 12px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-3 {
  box-shadow: 0px 8px 12px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-2 {
  box-shadow: 4px 0px 8px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-2 {
  box-shadow: 0px 4px 8px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-1 {
  box-shadow: 2px 0px 4px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-1 {
  box-shadow: 0px 2px 4px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-5-hover:hover {
  box-shadow: 16px 0px 24px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-5-hover:hover {
  box-shadow: 0px 16px 24px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-4-hover:hover {
  box-shadow: 12px 0px 16px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-4-hover:hover {
  box-shadow: 0px 12px 16px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-3-hover:hover {
  box-shadow: 8px 0px 12px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-3-hover:hover {
  box-shadow: 0px 8px 12px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-2-hover:hover {
  box-shadow: 4px 0px 8px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-2-hover:hover {
  box-shadow: 0px 4px 8px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-right-level-1-hover:hover {
  box-shadow: 2px 0px 4px 0px #eef3f7;
}
.pf-new-theme .shadow-color-1-5-level-1-hover:hover {
  box-shadow: 0px 2px 4px 0px #eef3f7;
}
.pf-new-theme .shadow-color-6-10-right-level-5 {
  box-shadow: 16px 0px 24px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-5 {
  box-shadow: 0px 16px 24px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-4 {
  box-shadow: 12px 0px 16px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-4 {
  box-shadow: 0px 12px 16px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-3 {
  box-shadow: 8px 0px 12px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-3 {
  box-shadow: 0px 8px 12px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-2 {
  box-shadow: 4px 0px 8px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-2 {
  box-shadow: 0px 4px 8px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-1 {
  box-shadow: 2px 0px 4px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-1 {
  box-shadow: 0px 2px 4px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-5-hover:hover {
  box-shadow: 16px 0px 24px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-5-hover:hover {
  box-shadow: 0px 16px 24px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-4-hover:hover {
  box-shadow: 12px 0px 16px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-4-hover:hover {
  box-shadow: 0px 12px 16px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-3-hover:hover {
  box-shadow: 8px 0px 12px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-3-hover:hover {
  box-shadow: 0px 8px 12px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-2-hover:hover {
  box-shadow: 4px 0px 8px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-2-hover:hover {
  box-shadow: 0px 4px 8px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-right-level-1-hover:hover {
  box-shadow: 2px 0px 4px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-color-6-10-level-1-hover:hover {
  box-shadow: 0px 2px 4px 0px rgba(92, 103, 118, 0.2);
}
.pf-new-theme .shadow-light-right-level-5 {
  box-shadow: 16px 0px 24px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-5 {
  box-shadow: 0px 16px 24px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-4 {
  box-shadow: 12px 0px 16px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-4 {
  box-shadow: 0px 12px 16px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-3 {
  box-shadow: 8px 0px 12px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-3 {
  box-shadow: 0px 8px 12px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-2 {
  box-shadow: 4px 0px 8px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-2 {
  box-shadow: 0px 4px 8px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-1 {
  box-shadow: 2px 0px 4px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-1 {
  box-shadow: 0px 2px 4px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-5-hover:hover {
  box-shadow: 16px 0px 24px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-5-hover:hover {
  box-shadow: 0px 16px 24px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-4-hover:hover {
  box-shadow: 12px 0px 16px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-4-hover:hover {
  box-shadow: 0px 12px 16px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-3-hover:hover {
  box-shadow: 8px 0px 12px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-3-hover:hover {
  box-shadow: 0px 8px 12px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-2-hover:hover {
  box-shadow: 4px 0px 8px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-2-hover:hover {
  box-shadow: 0px 4px 8px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-right-level-1-hover:hover {
  box-shadow: 2px 0px 4px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-level-1-hover:hover {
  box-shadow: 0px 2px 4px 0px rgba(200, 212, 216, 0.2);
}
.pf-new-theme .shadow-light-grey-hover:hover {
  box-shadow: 0 4px 6px 0 #e1e7eb;
}
.pf-new-theme .shadow-light-grey-2-hover:hover {
  box-shadow: 0 2px 16px 0 #e1e7ebc2;
}
.pf-new-theme .text-shadow-none {
  text-shadow: none;
}
.pf-new-theme .shadow-transition {
  transition: box-shadow 0.2s ease-in-out;
}
.pf-new-theme .transition-none {
  transition: none;
}
.pf-new-theme .transition-all-ease-out {
  transition: all 0.3s ease-out;
}
.pf-new-theme .ant-btn {
  font-weight: normal;
  padding-left: 16px;
  padding-right: 16px;
  font-size: 14px;
}
.pf-new-theme .ant-btn.ant-btn-primary {
  box-shadow: none;
}
.pf-new-theme .margin-none {
  margin: 0;
}
.pf-new-theme .margin-horizontal-none {
  margin-left: 0;
  margin-right: 0;
}
.pf-new-theme .margin-vertical-none {
  margin-top: 0;
  margin-bottom: 0;
}
.pf-new-theme .margin-top-none {
  margin-top: 0;
}
.pf-new-theme .margin-btm-none {
  margin-bottom: 0;
}
.pf-new-theme .margin-left-none {
  margin-left: 0;
}
.pf-new-theme .margin-right-none {
  margin-right: 0;
}
.pf-new-theme .margin-auto {
  margin: auto;
}
.pf-new-theme .margin-horizontal-auto {
  margin-left: auto;
  margin-right: auto;
}
.pf-new-theme .margin-vertical-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.pf-new-theme .margin-top-auto {
  margin-top: auto;
}
.pf-new-theme .margin-btm-auto {
  margin-bottom: auto;
}
.pf-new-theme .margin-left-auto {
  margin-left: auto;
}
.pf-new-theme .margin-right-auto {
  margin-right: auto;
}
.pf-new-theme .margin-tiny {
  margin: 3px;
}
.pf-new-theme .margin-horizontal-tiny {
  margin-left: 3px;
  margin-right: 3px;
}
.pf-new-theme .margin-vertical-tiny {
  margin-top: 3px;
  margin-bottom: 3px;
}
.pf-new-theme .margin-top-tiny {
  margin-top: 3px;
}
.pf-new-theme .margin-btm-tiny {
  margin-bottom: 3px;
}
.pf-new-theme .margin-left-tiny {
  margin-left: 3px;
}
.pf-new-theme .margin-right-tiny {
  margin-right: 3px;
}
.pf-new-theme .margin-xxs {
  margin: 5px;
}
.pf-new-theme .margin-horizontal-xxs {
  margin-left: 5px;
  margin-right: 5px;
}
.pf-new-theme .margin-vertical-xxs {
  margin-top: 5px;
  margin-bottom: 5px;
}
.pf-new-theme .margin-top-xxs {
  margin-top: 5px;
}
.pf-new-theme .margin-btm-xxs {
  margin-bottom: 5px;
}
.pf-new-theme .margin-left-xxs {
  margin-left: 5px;
}
.pf-new-theme .margin-right-xxs {
  margin-right: 5px;
}
.pf-new-theme .margin-xs {
  margin: 8px;
}
.pf-new-theme .margin-horizontal-xs {
  margin-left: 8px;
  margin-right: 8px;
}
.pf-new-theme .margin-vertical-xs {
  margin-top: 8px;
  margin-bottom: 8px;
}
.pf-new-theme .margin-top-xs {
  margin-top: 8px;
}
.pf-new-theme .margin-btm-xs {
  margin-bottom: 8px;
}
.pf-new-theme .margin-left-xs {
  margin-left: 8px;
}
.pf-new-theme .margin-right-xs {
  margin-right: 8px;
}
.pf-new-theme .margin-sm {
  margin: 12px;
}
.pf-new-theme .margin-horizontal-sm {
  margin-left: 12px;
  margin-right: 12px;
}
.pf-new-theme .margin-vertical-sm {
  margin-top: 12px;
  margin-bottom: 12px;
}
.pf-new-theme .margin-top-sm {
  margin-top: 12px;
}
.pf-new-theme .margin-btm-sm {
  margin-bottom: 12px;
}
.pf-new-theme .margin-left-sm {
  margin-left: 12px;
}
.pf-new-theme .margin-right-sm {
  margin-right: 12px;
}
.pf-new-theme .margin-md {
  margin: 16px;
}
.pf-new-theme .margin-horizontal-md {
  margin-left: 16px;
  margin-right: 16px;
}
.pf-new-theme .margin-vertical-md {
  margin-top: 16px;
  margin-bottom: 16px;
}
.pf-new-theme .margin-top-md {
  margin-top: 16px;
}
.pf-new-theme .margin-btm-md {
  margin-bottom: 16px;
}
.pf-new-theme .margin-left-md {
  margin-left: 16px;
}
.pf-new-theme .margin-right-md {
  margin-right: 16px;
}
.pf-new-theme .margin-lg {
  margin: 24px;
}
.pf-new-theme .margin-horizontal-lg {
  margin-left: 24px;
  margin-right: 24px;
}
.pf-new-theme .margin-vertical-lg {
  margin-top: 24px;
  margin-bottom: 24px;
}
.pf-new-theme .margin-top-lg {
  margin-top: 24px;
}
.pf-new-theme .margin-btm-lg {
  margin-bottom: 24px;
}
.pf-new-theme .margin-left-lg {
  margin-left: 24px;
}
.pf-new-theme .margin-right-lg {
  margin-right: 24px;
}
.pf-new-theme .margin-xl {
  margin: 36px;
}
.pf-new-theme .margin-horizontal-xl {
  margin-left: 36px;
  margin-right: 36px;
}
.pf-new-theme .margin-vertical-xl {
  margin-top: 36px;
  margin-bottom: 36px;
}
.pf-new-theme .margin-top-xl {
  margin-top: 36px;
}
.pf-new-theme .margin-btm-xl {
  margin-bottom: 36px;
}
.pf-new-theme .margin-left-xl {
  margin-left: 36px;
}
.pf-new-theme .margin-right-xl {
  margin-right: 36px;
}
.pf-new-theme .margin-xxl {
  margin: 44px;
}
.pf-new-theme .margin-horizontal-xxl {
  margin-left: 44px;
  margin-right: 44px;
}
.pf-new-theme .margin-vertical-xxl {
  margin-top: 44px;
  margin-bottom: 44px;
}
.pf-new-theme .margin-top-xxl {
  margin-top: 44px;
}
.pf-new-theme .margin-btm-xxl {
  margin-bottom: 44px;
}
.pf-new-theme .margin-left-xxl {
  margin-left: 44px;
}
.pf-new-theme .margin-right-xxl {
  margin-right: 44px;
}
.pf-new-theme .margin-negative-none {
  margin: 0;
}
.pf-new-theme .margin-horizontal-negative-none {
  margin-left: 0;
  margin-right: 0;
}
.pf-new-theme .margin-vertical-negative-none {
  margin-top: 0;
  margin-bottom: 0;
}
.pf-new-theme .margin-top-negative-none {
  margin-top: 0;
}
.pf-new-theme .margin-btm-negative-none {
  margin-bottom: 0;
}
.pf-new-theme .margin-left-negative-none {
  margin-left: 0;
}
.pf-new-theme .margin-right-negative-none {
  margin-right: 0;
}
.pf-new-theme .margin-negative-tiny {
  margin: -3px;
}
.pf-new-theme .margin-horizontal-negative-tiny {
  margin-left: -3px;
  margin-right: -3px;
}
.pf-new-theme .margin-vertical-negative-tiny {
  margin-top: -3px;
  margin-bottom: -3px;
}
.pf-new-theme .margin-top-negative-tiny {
  margin-top: -3px;
}
.pf-new-theme .margin-btm-negative-tiny {
  margin-bottom: -3px;
}
.pf-new-theme .margin-left-negative-tiny {
  margin-left: -3px;
}
.pf-new-theme .margin-right-negative-tiny {
  margin-right: -3px;
}
.pf-new-theme .margin-negative-xxs {
  margin: -5px;
}
.pf-new-theme .margin-horizontal-negative-xxs {
  margin-left: -5px;
  margin-right: -5px;
}
.pf-new-theme .margin-vertical-negative-xxs {
  margin-top: -5px;
  margin-bottom: -5px;
}
.pf-new-theme .margin-top-negative-xxs {
  margin-top: -5px;
}
.pf-new-theme .margin-btm-negative-xxs {
  margin-bottom: -5px;
}
.pf-new-theme .margin-left-negative-xxs {
  margin-left: -5px;
}
.pf-new-theme .margin-right-negative-xxs {
  margin-right: -5px;
}
.pf-new-theme .margin-negative-xs {
  margin: -8px;
}
.pf-new-theme .margin-horizontal-negative-xs {
  margin-left: -8px;
  margin-right: -8px;
}
.pf-new-theme .margin-vertical-negative-xs {
  margin-top: -8px;
  margin-bottom: -8px;
}
.pf-new-theme .margin-top-negative-xs {
  margin-top: -8px;
}
.pf-new-theme .margin-btm-negative-xs {
  margin-bottom: -8px;
}
.pf-new-theme .margin-left-negative-xs {
  margin-left: -8px;
}
.pf-new-theme .margin-right-negative-xs {
  margin-right: -8px;
}
.pf-new-theme .margin-negative-sm {
  margin: -12px;
}
.pf-new-theme .margin-horizontal-negative-sm {
  margin-left: -12px;
  margin-right: -12px;
}
.pf-new-theme .margin-vertical-negative-sm {
  margin-top: -12px;
  margin-bottom: -12px;
}
.pf-new-theme .margin-top-negative-sm {
  margin-top: -12px;
}
.pf-new-theme .margin-btm-negative-sm {
  margin-bottom: -12px;
}
.pf-new-theme .margin-left-negative-sm {
  margin-left: -12px;
}
.pf-new-theme .margin-right-negative-sm {
  margin-right: -12px;
}
.pf-new-theme .margin-negative-md {
  margin: -16px;
}
.pf-new-theme .margin-horizontal-negative-md {
  margin-left: -16px;
  margin-right: -16px;
}
.pf-new-theme .margin-vertical-negative-md {
  margin-top: -16px;
  margin-bottom: -16px;
}
.pf-new-theme .margin-top-negative-md {
  margin-top: -16px;
}
.pf-new-theme .margin-btm-negative-md {
  margin-bottom: -16px;
}
.pf-new-theme .margin-left-negative-md {
  margin-left: -16px;
}
.pf-new-theme .margin-right-negative-md {
  margin-right: -16px;
}
.pf-new-theme .margin-negative-lg {
  margin: -24px;
}
.pf-new-theme .margin-horizontal-negative-lg {
  margin-left: -24px;
  margin-right: -24px;
}
.pf-new-theme .margin-vertical-negative-lg {
  margin-top: -24px;
  margin-bottom: -24px;
}
.pf-new-theme .margin-top-negative-lg {
  margin-top: -24px;
}
.pf-new-theme .margin-btm-negative-lg {
  margin-bottom: -24px;
}
.pf-new-theme .margin-left-negative-lg {
  margin-left: -24px;
}
.pf-new-theme .margin-right-negative-lg {
  margin-right: -24px;
}
.pf-new-theme .margin-negative-xl {
  margin: -36px;
}
.pf-new-theme .margin-horizontal-negative-xl {
  margin-left: -36px;
  margin-right: -36px;
}
.pf-new-theme .margin-vertical-negative-xl {
  margin-top: -36px;
  margin-bottom: -36px;
}
.pf-new-theme .margin-top-negative-xl {
  margin-top: -36px;
}
.pf-new-theme .margin-btm-negative-xl {
  margin-bottom: -36px;
}
.pf-new-theme .margin-left-negative-xl {
  margin-left: -36px;
}
.pf-new-theme .margin-right-negative-xl {
  margin-right: -36px;
}
.pf-new-theme .margin-negative-xxl {
  margin: -44px;
}
.pf-new-theme .margin-horizontal-negative-xxl {
  margin-left: -44px;
  margin-right: -44px;
}
.pf-new-theme .margin-vertical-negative-xxl {
  margin-top: -44px;
  margin-bottom: -44px;
}
.pf-new-theme .margin-top-negative-xxl {
  margin-top: -44px;
}
.pf-new-theme .margin-btm-negative-xxl {
  margin-bottom: -44px;
}
.pf-new-theme .margin-left-negative-xxl {
  margin-left: -44px;
}
.pf-new-theme .margin-right-negative-xxl {
  margin-right: -44px;
}
.pf-new-theme .padding-none {
  padding: 0;
}
.pf-new-theme .padding-horizontal-none {
  padding-left: 0;
  padding-right: 0;
}
.pf-new-theme .padding-vertical-none {
  padding-top: 0;
  padding-bottom: 0;
}
.pf-new-theme .padding-top-none {
  padding-top: 0;
}
.pf-new-theme .padding-btm-none {
  padding-bottom: 0;
}
.pf-new-theme .padding-left-none {
  padding-left: 0;
}
.pf-new-theme .padding-right-none {
  padding-right: 0;
}
.pf-new-theme .padding-tiny {
  padding: 3px;
}
.pf-new-theme .padding-horizontal-tiny {
  padding-left: 3px;
  padding-right: 3px;
}
.pf-new-theme .padding-vertical-tiny {
  padding-top: 3px;
  padding-bottom: 3px;
}
.pf-new-theme .padding-top-tiny {
  padding-top: 3px;
}
.pf-new-theme .padding-btm-tiny {
  padding-bottom: 3px;
}
.pf-new-theme .padding-left-tiny {
  padding-left: 3px;
}
.pf-new-theme .padding-right-tiny {
  padding-right: 3px;
}
.pf-new-theme .padding-xxs {
  padding: 5px;
}
.pf-new-theme .padding-horizontal-xxs {
  padding-left: 5px;
  padding-right: 5px;
}
.pf-new-theme .padding-vertical-xxs {
  padding-top: 5px;
  padding-bottom: 5px;
}
.pf-new-theme .padding-top-xxs {
  padding-top: 5px;
}
.pf-new-theme .padding-btm-xxs {
  padding-bottom: 5px;
}
.pf-new-theme .padding-left-xxs {
  padding-left: 5px;
}
.pf-new-theme .padding-right-xxs {
  padding-right: 5px;
}
.pf-new-theme .padding-xs {
  padding: 8px;
}
.pf-new-theme .padding-horizontal-xs {
  padding-left: 8px;
  padding-right: 8px;
}
.pf-new-theme .padding-vertical-xs {
  padding-top: 8px;
  padding-bottom: 8px;
}
.pf-new-theme .padding-top-xs {
  padding-top: 8px;
}
.pf-new-theme .padding-btm-xs {
  padding-bottom: 8px;
}
.pf-new-theme .padding-left-xs {
  padding-left: 8px;
}
.pf-new-theme .padding-right-xs {
  padding-right: 8px;
}
.pf-new-theme .padding-sm {
  padding: 12px;
}
.pf-new-theme .padding-horizontal-sm {
  padding-left: 12px;
  padding-right: 12px;
}
.pf-new-theme .padding-vertical-sm {
  padding-top: 12px;
  padding-bottom: 12px;
}
.pf-new-theme .padding-top-sm {
  padding-top: 12px;
}
.pf-new-theme .padding-btm-sm {
  padding-bottom: 12px;
}
.pf-new-theme .padding-left-sm {
  padding-left: 12px;
}
.pf-new-theme .padding-right-sm {
  padding-right: 12px;
}
.pf-new-theme .padding-md {
  padding: 16px;
}
.pf-new-theme .padding-horizontal-md {
  padding-left: 16px;
  padding-right: 16px;
}
.pf-new-theme .padding-vertical-md {
  padding-top: 16px;
  padding-bottom: 16px;
}
.pf-new-theme .padding-top-md {
  padding-top: 16px;
}
.pf-new-theme .padding-btm-md {
  padding-bottom: 16px;
}
.pf-new-theme .padding-left-md {
  padding-left: 16px;
}
.pf-new-theme .padding-right-md {
  padding-right: 16px;
}
.pf-new-theme .padding-lg {
  padding: 24px;
}
.pf-new-theme .padding-horizontal-lg {
  padding-left: 24px;
  padding-right: 24px;
}
.pf-new-theme .padding-vertical-lg {
  padding-top: 24px;
  padding-bottom: 24px;
}
.pf-new-theme .padding-top-lg {
  padding-top: 24px;
}
.pf-new-theme .padding-btm-lg {
  padding-bottom: 24px;
}
.pf-new-theme .padding-left-lg {
  padding-left: 24px;
}
.pf-new-theme .padding-right-lg {
  padding-right: 24px;
}
.pf-new-theme .padding-xl {
  padding: 36px;
}
.pf-new-theme .padding-horizontal-xl {
  padding-left: 36px;
  padding-right: 36px;
}
.pf-new-theme .padding-vertical-xl {
  padding-top: 36px;
  padding-bottom: 36px;
}
.pf-new-theme .padding-top-xl {
  padding-top: 36px;
}
.pf-new-theme .padding-btm-xl {
  padding-bottom: 36px;
}
.pf-new-theme .padding-left-xl {
  padding-left: 36px;
}
.pf-new-theme .padding-right-xl {
  padding-right: 36px;
}
.pf-new-theme .padding-xxl {
  padding: 44px;
}
.pf-new-theme .padding-horizontal-xxl {
  padding-left: 44px;
  padding-right: 44px;
}
.pf-new-theme .padding-vertical-xxl {
  padding-top: 44px;
  padding-bottom: 44px;
}
.pf-new-theme .padding-top-xxl {
  padding-top: 44px;
}
.pf-new-theme .padding-btm-xxl {
  padding-bottom: 44px;
}
.pf-new-theme .padding-left-xxl {
  padding-left: 44px;
}
.pf-new-theme .padding-right-xxl {
  padding-right: 44px;
}
.pf-new-theme .gap-none {
  gap: 0;
}
.pf-new-theme .gap-tiny {
  gap: 3px;
}
.pf-new-theme .gap-xxs {
  gap: 5px;
}
.pf-new-theme .gap-xs {
  gap: 8px;
}
.pf-new-theme .gap-sm {
  gap: 12px;
}
.pf-new-theme .gap-md {
  gap: 16px;
}
.pf-new-theme .gap-lg {
  gap: 24px;
}
.pf-new-theme .gap-xl {
  gap: 36px;
}
.pf-new-theme .gap-xxl {
  gap: 44px;
}
.pf-new-theme .margin-none-important {
  margin: 0 !important;
}
.pf-new-theme .margin-horizontal-none-important {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.pf-new-theme .margin-vertical-none-important {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.pf-new-theme .margin-top-none-important {
  margin-top: 0 !important;
}
.pf-new-theme .margin-btm-none-important {
  margin-bottom: 0 !important;
}
.pf-new-theme .margin-left-none-important {
  margin-left: 0 !important;
}
.pf-new-theme .margin-right-none-important {
  margin-right: 0 !important;
}
.pf-new-theme .margin-auto-important {
  margin: auto !important;
}
.pf-new-theme .margin-horizontal-auto-important {
  margin-left: auto !important;
  margin-right: auto !important;
}
.pf-new-theme .margin-vertical-auto-important {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
.pf-new-theme .margin-top-auto-important {
  margin-top: auto !important;
}
.pf-new-theme .margin-btm-auto-important {
  margin-bottom: auto !important;
}
.pf-new-theme .margin-left-auto-important {
  margin-left: auto !important;
}
.pf-new-theme .margin-right-auto-important {
  margin-right: auto !important;
}
.pf-new-theme .margin-tiny-important {
  margin: 3px !important;
}
.pf-new-theme .margin-horizontal-tiny-important {
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.pf-new-theme .margin-vertical-tiny-important {
  margin-top: 3px !important;
  margin-bottom: 3px !important;
}
.pf-new-theme .margin-top-tiny-important {
  margin-top: 3px !important;
}
.pf-new-theme .margin-btm-tiny-important {
  margin-bottom: 3px !important;
}
.pf-new-theme .margin-left-tiny-important {
  margin-left: 3px !important;
}
.pf-new-theme .margin-right-tiny-important {
  margin-right: 3px !important;
}
.pf-new-theme .margin-xxs-important {
  margin: 5px !important;
}
.pf-new-theme .margin-horizontal-xxs-important {
  margin-left: 5px !important;
  margin-right: 5px !important;
}
.pf-new-theme .margin-vertical-xxs-important {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.pf-new-theme .margin-top-xxs-important {
  margin-top: 5px !important;
}
.pf-new-theme .margin-btm-xxs-important {
  margin-bottom: 5px !important;
}
.pf-new-theme .margin-left-xxs-important {
  margin-left: 5px !important;
}
.pf-new-theme .margin-right-xxs-important {
  margin-right: 5px !important;
}
.pf-new-theme .margin-xs-important {
  margin: 8px !important;
}
.pf-new-theme .margin-horizontal-xs-important {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.pf-new-theme .margin-vertical-xs-important {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.pf-new-theme .margin-top-xs-important {
  margin-top: 8px !important;
}
.pf-new-theme .margin-btm-xs-important {
  margin-bottom: 8px !important;
}
.pf-new-theme .margin-left-xs-important {
  margin-left: 8px !important;
}
.pf-new-theme .margin-right-xs-important {
  margin-right: 8px !important;
}
.pf-new-theme .margin-sm-important {
  margin: 12px !important;
}
.pf-new-theme .margin-horizontal-sm-important {
  margin-left: 12px !important;
  margin-right: 12px !important;
}
.pf-new-theme .margin-vertical-sm-important {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}
.pf-new-theme .margin-top-sm-important {
  margin-top: 12px !important;
}
.pf-new-theme .margin-btm-sm-important {
  margin-bottom: 12px !important;
}
.pf-new-theme .margin-left-sm-important {
  margin-left: 12px !important;
}
.pf-new-theme .margin-right-sm-important {
  margin-right: 12px !important;
}
.pf-new-theme .margin-md-important {
  margin: 16px !important;
}
.pf-new-theme .margin-horizontal-md-important {
  margin-left: 16px !important;
  margin-right: 16px !important;
}
.pf-new-theme .margin-vertical-md-important {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}
.pf-new-theme .margin-top-md-important {
  margin-top: 16px !important;
}
.pf-new-theme .margin-btm-md-important {
  margin-bottom: 16px !important;
}
.pf-new-theme .margin-left-md-important {
  margin-left: 16px !important;
}
.pf-new-theme .margin-right-md-important {
  margin-right: 16px !important;
}
.pf-new-theme .margin-lg-important {
  margin: 24px !important;
}
.pf-new-theme .margin-horizontal-lg-important {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.pf-new-theme .margin-vertical-lg-important {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}
.pf-new-theme .margin-top-lg-important {
  margin-top: 24px !important;
}
.pf-new-theme .margin-btm-lg-important {
  margin-bottom: 24px !important;
}
.pf-new-theme .margin-left-lg-important {
  margin-left: 24px !important;
}
.pf-new-theme .margin-right-lg-important {
  margin-right: 24px !important;
}
.pf-new-theme .margin-xl-important {
  margin: 36px !important;
}
.pf-new-theme .margin-horizontal-xl-important {
  margin-left: 36px !important;
  margin-right: 36px !important;
}
.pf-new-theme .margin-vertical-xl-important {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}
.pf-new-theme .margin-top-xl-important {
  margin-top: 36px !important;
}
.pf-new-theme .margin-btm-xl-important {
  margin-bottom: 36px !important;
}
.pf-new-theme .margin-left-xl-important {
  margin-left: 36px !important;
}
.pf-new-theme .margin-right-xl-important {
  margin-right: 36px !important;
}
.pf-new-theme .margin-xxl-important {
  margin: 44px !important;
}
.pf-new-theme .margin-horizontal-xxl-important {
  margin-left: 44px !important;
  margin-right: 44px !important;
}
.pf-new-theme .margin-vertical-xxl-important {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}
.pf-new-theme .margin-top-xxl-important {
  margin-top: 44px !important;
}
.pf-new-theme .margin-btm-xxl-important {
  margin-bottom: 44px !important;
}
.pf-new-theme .margin-left-xxl-important {
  margin-left: 44px !important;
}
.pf-new-theme .margin-right-xxl-important {
  margin-right: 44px !important;
}
.pf-new-theme .margin-negative-none-important {
  margin: 0 !important;
}
.pf-new-theme .margin-horizontal-negative-none-important {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.pf-new-theme .margin-vertical-negative-none-important {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.pf-new-theme .margin-top-negative-none-important {
  margin-top: 0 !important;
}
.pf-new-theme .margin-btm-negative-none-important {
  margin-bottom: 0 !important;
}
.pf-new-theme .margin-left-negative-none-important {
  margin-left: 0 !important;
}
.pf-new-theme .margin-right-negative-none-important {
  margin-right: 0 !important;
}
.pf-new-theme .margin-negative-tiny-important {
  margin: -3px !important;
}
.pf-new-theme .margin-horizontal-negative-tiny-important {
  margin-left: -3px !important;
  margin-right: -3px !important;
}
.pf-new-theme .margin-vertical-negative-tiny-important {
  margin-top: -3px !important;
  margin-bottom: -3px !important;
}
.pf-new-theme .margin-top-negative-tiny-important {
  margin-top: -3px !important;
}
.pf-new-theme .margin-btm-negative-tiny-important {
  margin-bottom: -3px !important;
}
.pf-new-theme .margin-left-negative-tiny-important {
  margin-left: -3px !important;
}
.pf-new-theme .margin-right-negative-tiny-important {
  margin-right: -3px !important;
}
.pf-new-theme .margin-negative-xxs-important {
  margin: -5px !important;
}
.pf-new-theme .margin-horizontal-negative-xxs-important {
  margin-left: -5px !important;
  margin-right: -5px !important;
}
.pf-new-theme .margin-vertical-negative-xxs-important {
  margin-top: -5px !important;
  margin-bottom: -5px !important;
}
.pf-new-theme .margin-top-negative-xxs-important {
  margin-top: -5px !important;
}
.pf-new-theme .margin-btm-negative-xxs-important {
  margin-bottom: -5px !important;
}
.pf-new-theme .margin-left-negative-xxs-important {
  margin-left: -5px !important;
}
.pf-new-theme .margin-right-negative-xxs-important {
  margin-right: -5px !important;
}
.pf-new-theme .margin-negative-xs-important {
  margin: -8px !important;
}
.pf-new-theme .margin-horizontal-negative-xs-important {
  margin-left: -8px !important;
  margin-right: -8px !important;
}
.pf-new-theme .margin-vertical-negative-xs-important {
  margin-top: -8px !important;
  margin-bottom: -8px !important;
}
.pf-new-theme .margin-top-negative-xs-important {
  margin-top: -8px !important;
}
.pf-new-theme .margin-btm-negative-xs-important {
  margin-bottom: -8px !important;
}
.pf-new-theme .margin-left-negative-xs-important {
  margin-left: -8px !important;
}
.pf-new-theme .margin-right-negative-xs-important {
  margin-right: -8px !important;
}
.pf-new-theme .margin-negative-sm-important {
  margin: -12px !important;
}
.pf-new-theme .margin-horizontal-negative-sm-important {
  margin-left: -12px !important;
  margin-right: -12px !important;
}
.pf-new-theme .margin-vertical-negative-sm-important {
  margin-top: -12px !important;
  margin-bottom: -12px !important;
}
.pf-new-theme .margin-top-negative-sm-important {
  margin-top: -12px !important;
}
.pf-new-theme .margin-btm-negative-sm-important {
  margin-bottom: -12px !important;
}
.pf-new-theme .margin-left-negative-sm-important {
  margin-left: -12px !important;
}
.pf-new-theme .margin-right-negative-sm-important {
  margin-right: -12px !important;
}
.pf-new-theme .margin-negative-md-important {
  margin: -16px !important;
}
.pf-new-theme .margin-horizontal-negative-md-important {
  margin-left: -16px !important;
  margin-right: -16px !important;
}
.pf-new-theme .margin-vertical-negative-md-important {
  margin-top: -16px !important;
  margin-bottom: -16px !important;
}
.pf-new-theme .margin-top-negative-md-important {
  margin-top: -16px !important;
}
.pf-new-theme .margin-btm-negative-md-important {
  margin-bottom: -16px !important;
}
.pf-new-theme .margin-left-negative-md-important {
  margin-left: -16px !important;
}
.pf-new-theme .margin-right-negative-md-important {
  margin-right: -16px !important;
}
.pf-new-theme .margin-negative-lg-important {
  margin: -24px !important;
}
.pf-new-theme .margin-horizontal-negative-lg-important {
  margin-left: -24px !important;
  margin-right: -24px !important;
}
.pf-new-theme .margin-vertical-negative-lg-important {
  margin-top: -24px !important;
  margin-bottom: -24px !important;
}
.pf-new-theme .margin-top-negative-lg-important {
  margin-top: -24px !important;
}
.pf-new-theme .margin-btm-negative-lg-important {
  margin-bottom: -24px !important;
}
.pf-new-theme .margin-left-negative-lg-important {
  margin-left: -24px !important;
}
.pf-new-theme .margin-right-negative-lg-important {
  margin-right: -24px !important;
}
.pf-new-theme .margin-negative-xl-important {
  margin: -36px !important;
}
.pf-new-theme .margin-horizontal-negative-xl-important {
  margin-left: -36px !important;
  margin-right: -36px !important;
}
.pf-new-theme .margin-vertical-negative-xl-important {
  margin-top: -36px !important;
  margin-bottom: -36px !important;
}
.pf-new-theme .margin-top-negative-xl-important {
  margin-top: -36px !important;
}
.pf-new-theme .margin-btm-negative-xl-important {
  margin-bottom: -36px !important;
}
.pf-new-theme .margin-left-negative-xl-important {
  margin-left: -36px !important;
}
.pf-new-theme .margin-right-negative-xl-important {
  margin-right: -36px !important;
}
.pf-new-theme .margin-negative-xxl-important {
  margin: -44px !important;
}
.pf-new-theme .margin-horizontal-negative-xxl-important {
  margin-left: -44px !important;
  margin-right: -44px !important;
}
.pf-new-theme .margin-vertical-negative-xxl-important {
  margin-top: -44px !important;
  margin-bottom: -44px !important;
}
.pf-new-theme .margin-top-negative-xxl-important {
  margin-top: -44px !important;
}
.pf-new-theme .margin-btm-negative-xxl-important {
  margin-bottom: -44px !important;
}
.pf-new-theme .margin-left-negative-xxl-important {
  margin-left: -44px !important;
}
.pf-new-theme .margin-right-negative-xxl-important {
  margin-right: -44px !important;
}
.pf-new-theme .padding-none-important {
  padding: 0 !important;
}
.pf-new-theme .padding-horizontal-none-important {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.pf-new-theme .padding-vertical-none-important {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.pf-new-theme .padding-top-none-important {
  padding-top: 0 !important;
}
.pf-new-theme .padding-btm-none-important {
  padding-bottom: 0 !important;
}
.pf-new-theme .padding-left-none-important {
  padding-left: 0 !important;
}
.pf-new-theme .padding-right-none-important {
  padding-right: 0 !important;
}
.pf-new-theme .padding-tiny-important {
  padding: 3px !important;
}
.pf-new-theme .padding-horizontal-tiny-important {
  padding-left: 3px !important;
  padding-right: 3px !important;
}
.pf-new-theme .padding-vertical-tiny-important {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}
.pf-new-theme .padding-top-tiny-important {
  padding-top: 3px !important;
}
.pf-new-theme .padding-btm-tiny-important {
  padding-bottom: 3px !important;
}
.pf-new-theme .padding-left-tiny-important {
  padding-left: 3px !important;
}
.pf-new-theme .padding-right-tiny-important {
  padding-right: 3px !important;
}
.pf-new-theme .padding-xxs-important {
  padding: 5px !important;
}
.pf-new-theme .padding-horizontal-xxs-important {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.pf-new-theme .padding-vertical-xxs-important {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.pf-new-theme .padding-top-xxs-important {
  padding-top: 5px !important;
}
.pf-new-theme .padding-btm-xxs-important {
  padding-bottom: 5px !important;
}
.pf-new-theme .padding-left-xxs-important {
  padding-left: 5px !important;
}
.pf-new-theme .padding-right-xxs-important {
  padding-right: 5px !important;
}
.pf-new-theme .padding-xs-important {
  padding: 8px !important;
}
.pf-new-theme .padding-horizontal-xs-important {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.pf-new-theme .padding-vertical-xs-important {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.pf-new-theme .padding-top-xs-important {
  padding-top: 8px !important;
}
.pf-new-theme .padding-btm-xs-important {
  padding-bottom: 8px !important;
}
.pf-new-theme .padding-left-xs-important {
  padding-left: 8px !important;
}
.pf-new-theme .padding-right-xs-important {
  padding-right: 8px !important;
}
.pf-new-theme .padding-sm-important {
  padding: 12px !important;
}
.pf-new-theme .padding-horizontal-sm-important {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.pf-new-theme .padding-vertical-sm-important {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.pf-new-theme .padding-top-sm-important {
  padding-top: 12px !important;
}
.pf-new-theme .padding-btm-sm-important {
  padding-bottom: 12px !important;
}
.pf-new-theme .padding-left-sm-important {
  padding-left: 12px !important;
}
.pf-new-theme .padding-right-sm-important {
  padding-right: 12px !important;
}
.pf-new-theme .padding-md-important {
  padding: 16px !important;
}
.pf-new-theme .padding-horizontal-md-important {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.pf-new-theme .padding-vertical-md-important {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.pf-new-theme .padding-top-md-important {
  padding-top: 16px !important;
}
.pf-new-theme .padding-btm-md-important {
  padding-bottom: 16px !important;
}
.pf-new-theme .padding-left-md-important {
  padding-left: 16px !important;
}
.pf-new-theme .padding-right-md-important {
  padding-right: 16px !important;
}
.pf-new-theme .padding-lg-important {
  padding: 24px !important;
}
.pf-new-theme .padding-horizontal-lg-important {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.pf-new-theme .padding-vertical-lg-important {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.pf-new-theme .padding-top-lg-important {
  padding-top: 24px !important;
}
.pf-new-theme .padding-btm-lg-important {
  padding-bottom: 24px !important;
}
.pf-new-theme .padding-left-lg-important {
  padding-left: 24px !important;
}
.pf-new-theme .padding-right-lg-important {
  padding-right: 24px !important;
}
.pf-new-theme .padding-xl-important {
  padding: 36px !important;
}
.pf-new-theme .padding-horizontal-xl-important {
  padding-left: 36px !important;
  padding-right: 36px !important;
}
.pf-new-theme .padding-vertical-xl-important {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}
.pf-new-theme .padding-top-xl-important {
  padding-top: 36px !important;
}
.pf-new-theme .padding-btm-xl-important {
  padding-bottom: 36px !important;
}
.pf-new-theme .padding-left-xl-important {
  padding-left: 36px !important;
}
.pf-new-theme .padding-right-xl-important {
  padding-right: 36px !important;
}
.pf-new-theme .padding-xxl-important {
  padding: 44px !important;
}
.pf-new-theme .padding-horizontal-xxl-important {
  padding-left: 44px !important;
  padding-right: 44px !important;
}
.pf-new-theme .padding-vertical-xxl-important {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}
.pf-new-theme .padding-top-xxl-important {
  padding-top: 44px !important;
}
.pf-new-theme .padding-btm-xxl-important {
  padding-bottom: 44px !important;
}
.pf-new-theme .padding-left-xxl-important {
  padding-left: 44px !important;
}
.pf-new-theme .padding-right-xxl-important {
  padding-right: 44px !important;
}
.pf-new-theme .width-none {
  width: 0;
}
.pf-new-theme .width-none-important {
  width: 0 !important;
}
.pf-new-theme .width-tiny {
  width: 3px;
}
.pf-new-theme .width-tiny-important {
  width: 3px !important;
}
.pf-new-theme .width-xxs {
  width: 5px;
}
.pf-new-theme .width-xxs-important {
  width: 5px !important;
}
.pf-new-theme .width-xs {
  width: 8px;
}
.pf-new-theme .width-xs-important {
  width: 8px !important;
}
.pf-new-theme .width-sm {
  width: 12px;
}
.pf-new-theme .width-sm-important {
  width: 12px !important;
}
.pf-new-theme .width-md {
  width: 16px;
}
.pf-new-theme .width-md-important {
  width: 16px !important;
}
.pf-new-theme .width-lg {
  width: 24px;
}
.pf-new-theme .width-lg-important {
  width: 24px !important;
}
.pf-new-theme .width-xl {
  width: 36px;
}
.pf-new-theme .width-xl-important {
  width: 36px !important;
}
.pf-new-theme .width-xxl {
  width: 44px;
}
.pf-new-theme .width-xxl-important {
  width: 44px !important;
}
.pf-new-theme .border-radius-none {
  border-radius: 0;
}
.pf-new-theme .border-radius-oval {
  border-radius: 50%;
}
.pf-new-theme .border-radius-level-1 {
  border-radius: 4px;
}
.pf-new-theme .border-radius-level-2 {
  border-radius: 8px;
}
.pf-new-theme .border-radius-level-3 {
  border-radius: 12px;
}
.pf-new-theme .border-radius-pill {
  border-radius: 9999em;
}
.pf-new-theme .border-radius-top-level-1 {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.pf-new-theme .border-radius-top-level-2 {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.pf-new-theme .border-radius-top-level-3 {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.pf-new-theme .border-radius-top-none {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.pf-new-theme .border-radius-top-none-important {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.pf-new-theme .border-radius-top-left-level-1 {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.pf-new-theme .border-radius-top-left-level-2 {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.pf-new-theme .border-radius-top-left-level-3 {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.pf-new-theme .border-radius-top-left-none {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.pf-new-theme .border-radius-top-left-none-important {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.pf-new-theme .border-radius-bottom-level-1 {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.pf-new-theme .border-radius-bottom-level-2 {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.pf-new-theme .border-radius-bottom-level-3 {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.pf-new-theme .border-radius-bottom-none {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.pf-new-theme .border-radius-bottom-none-important {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.pf-new-theme .border-radius-left-level-1 {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.pf-new-theme .border-radius-left-level-2 {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.pf-new-theme .border-radius-left-level-3 {
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.pf-new-theme .border-radius-left-none {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.pf-new-theme .border-radius-left-none-important {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.pf-new-theme .border-radius-right-level-1 {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.pf-new-theme .border-radius-right-level-2 {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.pf-new-theme .border-radius-right-level-3 {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
}
.pf-new-theme .border-radius-right-none {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.pf-new-theme .border-radius-right-none-important {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.pf-new-theme .border-horizontal-none {
  border-left: none;
  border-right: none;
}
.pf-new-theme .border-vertical-none {
  border-top: none;
  border-bottom: none;
}
.pf-new-theme .border-left-none {
  border-left: none;
}
.pf-new-theme .border-right-none {
  border-right: none;
}
.pf-new-theme .border-bottom-none {
  border-bottom: none;
}
.pf-new-theme .border-top-none {
  border-top: none;
}
.pf-new-theme .border-none {
  border: none;
}
.pf-new-theme .border-none-important {
  border: none !important;
}
.pf-new-theme .border-solid {
  border-style: solid;
}
.pf-new-theme .border-dashed {
  border-style: dashed;
}
.pf-new-theme .border-dashed-important {
  border-style: dashed !important;
}
.pf-new-theme .border-dotted {
  border-style: dotted;
}
.pf-new-theme .border-left-none {
  border-left: none;
}
.pf-new-theme .border-top-none {
  border-top: none;
}
.pf-new-theme .border-right-none {
  border-right: none;
}
.pf-new-theme .border-bottom-none {
  border-bottom: none;
}
.pf-new-theme .border-width-1 {
  border-width: 1px;
}
.pf-new-theme .border-width-4 {
  border-width: 4px;
}
.pf-new-theme .text-color-white {
  color:  #ffffff;
}
.pf-new-theme .text-color-dark {
  color:  #323945;
}
.pf-new-theme .text-color-medium {
  color:  #5c6776;
}
.pf-new-theme .text-color-low {
  color:  #8f98a9;
}
.pf-new-theme .text-color-disabled {
  color:  #bfc8d5;
}
.pf-new-theme .text-color-success {
  color:  #03dfb9;
}
.pf-new-theme .text-color-danger {
  color:  #f1565d;
}
.pf-new-theme .text-color-warning {
  color:  #ffc000;
}
.pf-new-theme .text-color-info {
  color:  #9c75f6;
}
.pf-new-theme .text-weight-regular {
  font-weight: normal;
}
.pf-new-theme .text-weight-100 {
  font-weight: 100;
}
.pf-new-theme .text-weight-500 {
  font-weight: 500;
}
.pf-new-theme .text-weight-600 {
  font-weight: 600;
}
.pf-new-theme .text-weight-bold {
  font-weight: bold;
}
.pf-new-theme .text-style-italics {
  font-style: italic;
}
.pf-new-theme .text-style-normal {
  font-style: normal;
}
.pf-new-theme .text-line-through {
  text-decoration: line-through;
}
.pf-new-theme .text-size-x-small {
  font-size: 8px;
  line-height: 10px;
}
.pf-new-theme .text-size-small {
  font-size: 9px;
  line-height: 10px;
}
.pf-new-theme .text-size-primary {
  font-size: 14px;
  line-height: 16px;
}
.pf-new-theme .text-size-secondary {
  font-size: 12px;
  line-height: 14px;
}
.pf-new-theme .text-size-h1 {
  font-size: 32px;
  line-height: 38px;
}
.pf-new-theme .text-size-h2 {
  font-size: 24px;
  line-height: 28px;
}
.pf-new-theme .text-size-h3 {
  font-size: 16px;
  line-height: 19px;
}
.pf-new-theme .text-size-h4 {
  font-size: 14px;
  line-height: 16px;
}
.pf-new-theme .text-size-h5 {
  font-size: 12px;
  line-height: 14px;
}
.pf-new-theme .text-size-h6 {
  font-size: 10px;
  line-height: 12px;
}
.pf-new-theme .text-size-inherit {
  font-size: inherit;
  line-height: inherit;
}
.pf-new-theme .text-size-18 {
  font-size: 18px;
  line-height: 21px;
}
.pf-new-theme .text-size-10 {
  font-size: 10px;
}
.pf-new-theme .text-size-8 {
  font-size: 8px;
}
.pf-new-theme .text-size-9 {
  font-size: 9px;
}
.pf-new-theme .text-size-11 {
  font-size: 11px;
}
.pf-new-theme .text-size-12 {
  font-size: 12px;
}
.pf-new-theme .text-size-16 {
  font-size: 16px;
}
.pf-new-theme .text-size-16-important {
  font-size: 16px !important;
}
.pf-new-theme .text-size-19 {
  font-size: 19px;
}
.pf-new-theme .text-size-20 {
  font-size: 20px;
}
.pf-new-theme .text-wrap-none {
  white-space: nowrap;
}
.pf-new-theme .text-wrap-pre {
  white-space: pre;
}
.pf-new-theme .text-wrap-pre-wrap {
  white-space: pre-wrap;
}
.pf-new-theme .text-wrap-normal {
  white-space: normal;
}
.pf-new-theme .text-wrap-normal > .ant-select-item-option-content {
  white-space: normal !important;
}
.pf-new-theme .text-uppercase {
  text-transform: uppercase;
}
.pf-new-theme .text-lowercase {
  text-transform: lowercase;
}
.pf-new-theme .text-align-center {
  text-align: center;
}
.pf-new-theme .text-align-right {
  text-align: right;
}
.pf-new-theme .text-align-left {
  text-align: left;
}
.pf-new-theme h1 {
  font-size: 32px;
  line-height: 38px;
}
.pf-new-theme h2 {
  font-size: 24px;
  line-height: 28px;
}
.pf-new-theme h3 {
  font-size: 16px;
  line-height: 19px;
}
.pf-new-theme a[href].alternate {
  color:  #fb3b71;
}
.pf-new-theme .break-normal {
  word-break: normal;
  overflow-wrap: normal;
}
.pf-new-theme .break-words {
  overflow-wrap: break-word;
}
.pf-new-theme .break-all {
  word-break: break-all;
}
.pf-new-theme .truncate,
.pf-new-theme .truncate-placeholder::placeholder {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pf-new-theme .outline-none {
  outline: none;
}
.pf-new-theme .position-relative {
  position: relative;
}
.pf-new-theme .position-relative-important {
  position: relative !important;
}
.pf-new-theme .position-absolute {
  position: absolute;
}
.pf-new-theme .position-absolute-important {
  position: absolute !important;
}
.pf-new-theme .position-static {
  position: static;
}
.pf-new-theme .position-static-important {
  position: static !important;
}
.pf-new-theme .position-fixed {
  position: fixed;
}
.pf-new-theme .position-fixed-important {
  position: fixed !important;
}
.pf-new-theme .position-sticky {
  position: sticky;
}
.pf-new-theme .position-sticky-important {
  position: sticky !important;
}
.pf-new-theme .position-right {
  right: 0;
}
.pf-new-theme .position-right-auto {
  right: auto;
}
.pf-new-theme .position-left {
  left: 0;
}
.pf-new-theme .position-left-auto {
  left: auto;
}
.pf-new-theme .position-top {
  top: 0;
}
.pf-new-theme .position-top-auto {
  top: auto;
}
.pf-new-theme .position-top-sm {
  top: 12px;
}
.pf-new-theme .position-top-tiny {
  top: 3px;
}
.pf-new-theme .position-bottom {
  bottom: 0;
}
.pf-new-theme .position-bottom-auto {
  bottom: auto;
}
.pf-new-theme .position-top-right {
  top: 0;
  right: 0;
}
.pf-new-theme .position-top-right-tiny {
  top: 3px;
  right: 3px;
}
.pf-new-theme .position-top-left {
  top: 0;
  left: 0;
}
.pf-new-theme .position-top-left-tiny {
  top: 3px;
  left: 3px;
}
.pf-new-theme .position-bottom-right {
  bottom: 0;
  right: 0;
}
.pf-new-theme .position-bottom-right-tiny {
  bottom: 3px;
  right: 3px;
}
.pf-new-theme .position-bottom-left {
  bottom: 0;
  left: 0;
}
.pf-new-theme .position-bottom-left-tiny {
  bottom: 3px;
  left: 3px;
}
.pf-new-theme .position-vertical-center {
  top: 50%;
  transform: translateY(-50%);
}
.pf-new-theme .position-horizontal-center {
  left: 50%;
  transform: translateX(-50%);
}
.pf-new-theme .position-center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pf-new-theme .height-none {
  height: auto;
}
.pf-new-theme .h-full {
  height: 100%;
}
.pf-new-theme .flex-wrap {
  flex-wrap: wrap;
}
.pf-new-theme .flex-wrap-none {
  flex-wrap: nowrap;
}
.pf-new-theme .table-layout-fixed {
  table-layout: fixed;
}
.pf-new-theme .table-layout-auto {
  table-layout: auto;
}
.pf-new-theme .outline-none {
  outline: none;
}
.pf-new-theme .overflow-visible {
  overflow: visible;
}
.pf-new-theme .overflow-hidden {
  overflow: hidden;
}
.pf-new-theme .overflow-auto {
  overflow: auto;
}
.pf-new-theme .overflow-vertical-hidden {
  overflow-y: hidden;
}
.pf-new-theme .overflow-vertical-auto {
  overflow-y: auto;
}
.pf-new-theme .overflow-horizontal-hidden {
  overflow-x: hidden;
}
.pf-new-theme .overflow-horizontal-auto {
  overflow-x: auto;
}
.pf-new-theme .overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}
.pf-new-theme .vertical-align-middle {
  vertical-align: middle;
}
.pf-new-theme .vertical-align-baseline {
  vertical-align: baseline;
}
.pf-new-theme .vertical-align-bottom {
  vertical-align: bottom;
}
.pf-new-theme .vertical-align-top {
  vertical-align: top;
}
.pf-new-theme .vertical-align-text-top {
  vertical-align: text-top;
}
.pf-new-theme .line-height-clear {
  line-height: 1;
}
.pf-new-theme .line-height-12 {
  line-height: 12px;
}
.pf-new-theme .line-height-14 {
  line-height: 14px;
}
.pf-new-theme .line-height-15 {
  line-height: 15px;
}
.pf-new-theme .line-height-16 {
  line-height: 16px;
}
.pf-new-theme .line-height-18 {
  line-height: 18px;
}
.pf-new-theme .line-height-20 {
  line-height: 20px;
}
.pf-new-theme .line-height-22 {
  line-height: 22px;
}
.pf-new-theme .line-height-24 {
  line-height: 24px;
}
.pf-new-theme .padding-vertical-6 {
  padding-top: 6px;
  padding-bottom: 6px;
}
.pf-new-theme .resize-none {
  resize: none;
}
.pf-new-theme .resize-horizontal {
  resize: horizontal;
}
.pf-new-theme .resize-vertical {
  resize: vertical;
}
.pf-new-theme .cursor-default {
  cursor: default;
}
.pf-new-theme .cursor-pointer {
  cursor: pointer;
}
.pf-new-theme .cursor-text {
  cursor: text;
}
.pf-new-theme .cursor-move {
  cursor: move;
}
.pf-new-theme .cursor-disabled,
.pf-new-theme .cursor-not-allowed {
  cursor: not-allowed;
}
.pf-new-theme .cursor-initial {
  cursor: initial;
}
.pf-new-theme .display-inline {
  display: inline;
}
.pf-new-theme .display-block {
  display: block;
}
.pf-new-theme .display-inline-block {
  display: inline-block;
}
.pf-new-theme .display-flex {
  display: flex;
}
.pf-new-theme .display-inline-flex {
  display: inline-flex;
}
.pf-new-theme .display-none {
  display: none;
}
.pf-new-theme .flex-row {
  flex-direction: row;
}
.pf-new-theme .flex-row-reverse {
  flex-direction: row-reverse;
}
.pf-new-theme .flex-col {
  flex-direction: column;
}
.pf-new-theme .flex-col-reverse {
  flex-direction: column-reverse;
}
.pf-new-theme .flex-content-start {
  align-content: flex-start;
}
.pf-new-theme .flex-content-center {
  align-content: center;
}
.pf-new-theme .flex-content-end {
  align-content: flex-end;
}
.pf-new-theme .flex-content-between {
  align-content: space-between;
}
.pf-new-theme .flex-content-around {
  align-content: space-around;
}
.pf-new-theme .flex-justify-start {
  justify-content: flex-start;
}
.pf-new-theme .flex-justify-center {
  justify-content: center;
}
.pf-new-theme .flex-justify-end {
  justify-content: flex-end;
}
.pf-new-theme .flex-justify-between {
  justify-content: space-between;
}
.pf-new-theme .flex-justify-around {
  justify-content: space-around;
}
.pf-new-theme .flex-items-stretch {
  align-items: stretch;
}
.pf-new-theme .flex-items-start {
  align-items: flex-start;
}
.pf-new-theme .flex-items-center {
  align-items: center;
}
.pf-new-theme .flex-items-end {
  align-items: flex-end;
}
.pf-new-theme .flex-items-baseline {
  align-items: baseline;
}
.pf-new-theme .flex-self-stretch {
  align-self: stretch;
}
.pf-new-theme .flex-self-start {
  align-self: start;
}
.pf-new-theme .flex-self-center {
  align-self: center;
}
.pf-new-theme .flex-self-end {
  align-self: end;
}
.pf-new-theme .flex-shrink-none {
  flex-shrink: 0;
}
.pf-new-theme .flex-grow-none {
  flex-grow: 0;
}
.pf-new-theme body {
  color:  #323945;
  background-color: #f5f6f8;
}
.pf-new-theme .ant-layout {
  background-color: #f5f6f8;
}
.pf-new-theme .pf-sider {
  min-height: calc(100vh - 68px);
}
.pf-new-theme .pf-sider--h-stretch {
  height: 100vh;
}
.pf-new-theme .pf-sider--between .ant-layout-sider-children {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.pf-new-theme .pseudo-after-none:after {
  content: none;
}
.pf-new-theme .pseudo-before-none:before {
  content: none;
}
.pf-new-theme .list-style-none {
  list-style: none;
}
.pf-new-theme .ant-layout-header .ant-tabs {
  height: 46px;
}
.pf-new-theme .ant-layout-header .ant-tabs-top > .ant-tabs-nav::before {
  border-color: #fafafa;
}
.pf-new-theme .ant-layout-header .ant-tabs-nav {
  margin: 0;
  padding-left: 24px;
  padding-right: 24px;
}
.pf-new-theme .ant-layout-header .ant-tabs--dark {
  color: #323945;
}
.pf-new-theme .ant-layout-header .ant-tabs-tab-active,
.pf-new-theme .ant-layout-header .ant-tabs-tab:hover {
  color: #0e68f9;
}
.pf-new-theme .ant-layout-header .ant-tabs-ink-bar {
  background-color: #0e68f9;
}
.pf-new-theme .ant-layout-header .ant-tabs-bar {
  height: 48px;
}
.pf-new-theme .ant-layout-header .ant-tabs-bar .ant-tabs-extra-content {
  line-height: 1.5;
}
.pf-new-theme .ant-layout-header .ant-tabs-bar .ant-tabs-nav > *:not(.ant-tabs-ink-bar) {
  height: 48px;
}
.pf-new-theme .ant-avatar-sm {
  height: 20px;
  line-height: 20px;
  width: 20px;
}
.pf-new-theme .ant-dropdown-placement-bottomRight,
.pf-new-theme .ant-dropdown-placement-topRight {
  left: auto;
}
.pf-new-theme .ant-dropdown-menu a {
  color: inherit;
}
.pf-new-theme .ant-dropdown-menu-item {
  color: #323945;
}
.pf-new-theme .ant-dropdown-menu-item-active {
  color: #0e68f9;
  background: #e6f4ff;
}
.pf-new-theme .ant-dropdown-menu-item-disabled {
  color: #bfc8d5;
}
.pf-new-theme .ant-modal-content {
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-top: 24px;
}
.pf-new-theme .ant-modal .ant-modal-header {
  padding: 0;
  padding-bottom: 16px;
  border: none;
}
.pf-new-theme .ant-modal-body {
  padding: 0;
  padding-top: 16px;
  padding-bottom: 16px;
}
.pf-new-theme .ant-modal-footer {
  padding: 0;
  padding-top: 16px;
}
.pf-new-theme .ant-modal-close-x {
  line-height: 1;
  padding-top: 16px;
}
.pf-new-theme .ant-select-dropdown .ant-select-item-option {
  color: #323945;
}
.pf-new-theme .ant-select-dropdown .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: red;
}
.pf-new-theme .ant-select-dropdown .ant-select-item-option-disabled:not(.ant-select-item-option-active) {
  color: #bfc8d5;
}
.pf-new-theme .ant-select .ant-select-arrow {
  color: #323945;
}
.pf-new-theme .ant-select.ant-select-single {
  height: 40px;
}
.pf-new-theme .ant-select .ant-select-selection-item {
  line-height: 38px;
}
.pf-new-theme .ant-select.ant-select-multiple .ant-select-selector {
  height: auto;
  min-height: 40px;
  border-color: #e7ebef;
}
.pf-new-theme .ant-select.ant-select-multiple .ant-select-selector .ant-select-selection-item {
  font-weight: normal;
  display: flex;
  align-items: center;
  padding: 16px 8px 16px 10px;
  background-color: #e6f4ff;
  border: none;
  border-radius: 4px;
}
.pf-new-theme .ant-select.ant-select-multiple .ant-select-selector .ant-select-selection-item-content {
  margin-right: 8px;
}
.pf-new-theme .ant-select.ant-select-multiple .ant-select-selector .ant-select-selection-item-remove {
  margin-top: -4px;
}
.pf-new-theme .ant-select.ant-select-multiple.ant-select-focused .ant-select-selector {
  border-color: #e7ebef;
  box-shadow: none;
}
.pf-new-theme .ant-select .ant-select-selector--multiple {
  height: auto;
  min-height: 40px;
}
.pf-new-theme .ant-select .ant-select-selector--multiple > ul > li,
.pf-new-theme .ant-select .ant-select-selector--multiple .ant-select-selection-item > ul > li {
  height: 32px;
  line-height: 30px;
}
.pf-new-theme .ant-select .ant-select-selector--multiple .ant-select-selection__choice {
  background-color: #e6f4ff;
  border: none;
  border-radius: 4px;
}
.pf-new-theme .ant-select.pf-select-small.ant-select-single {
  height: 32px;
}
.pf-new-theme .ant-select.pf-select-small .ant-select-selection-item {
  line-height: 30px;
}
.pf-new-theme .ant-select.pf-select-small .ant-select-selector--multiple {
  height: auto;
  min-height: 32px;
}
.pf-new-theme .ant-select.pf-select-small .ant-select-selector {
  height: 32px;
}
.pf-new-theme .ant-select.pf-select-small .ant-select-selection-item {
  line-height: 31px;
}
.pf-new-theme .ant-select.pf-select-small .ant-select-arrow {
  margin-top: -12px;
}
.pf-new-theme .ant-select.template-text-array.ant-select-multiple .ant-select-selector {
  height: auto;
  min-height: 48px;
}
.pf-new-theme .ant-select.template-text-array.ant-select-multiple .ant-select-selector .ant-select-selection-item {
  background-color: #d8e9fe;
}
.pf-new-theme .ant-select.template-text-array.ant-select-multiple .ant-select-selector .ant-select-selection-item-remove {
  color: #0e68f9;
}
.pf-new-theme .ant-select.template-text-array.ant-select-multiple.ant-select-focused .ant-select-selector {
  border-color: #0e68f9;
  box-shadow: none;
}
.pf-new-theme .ant-select-grey .ant-select-selector {
  background-color: #f3f6fb;
  border-color: transparent;
}
.pf-new-theme .ant-select-grey .ant-select-selector .ant-select-selector-placeholder {
  color: #5c6776;
}
.pf-new-theme .ant-select-grey .ant-select-clear {
  background: transparent;
}
.pf-new-theme .ant-select-grey:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: transparent;
}
.pf-new-theme .ant-select-grey .ant-select-selection-item {
  color: transparent;
}
.pf-new-theme .ant-select-grey.select-single-mode .ant-select-selection-item {
  color: inherit;
}
.pf-new-theme .ant-select-grey.select-single-mode.ant-select-focused .ant-select-selection-item {
  color: #bfc8d5;
}
.pf-new-theme .ant-switch {
  background-color: #bfc8d5;
}
.pf-new-theme .ant-switch-checked {
  background-color: #0e68f9;
}
.pf-new-theme .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background-color: #0e68f9;
  border-color: #0e68f9;
}
.pf-new-theme .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #8f98a9;
  border-color: #8f98a9 !important;
}
.pf-new-theme .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: #ffffff;
}
.pf-new-theme .ant-checkbox-checked.ant-checkbox-disabled + span {
  color: inherit;
}
.pf-new-theme .no-disabled-state .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #0e68f9;
  border-color: #0e68f9 !important;
}
.pf-new-theme .no-disabled-state .ant-checkbox-checked.ant-checkbox-disabled + span {
  border-color: #ffffff;
}
.pf-new-theme .disabled-dark .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #8f98a9;
  border-color: #8f98a9 !important;
}
.pf-new-theme .disabled-dark .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: #ffffff;
}
.pf-new-theme .disabled-dark .ant-checkbox-disabled + span {
  color: #323945;
}
.pf-new-theme .ant-tooltip-no-arrow .ant-tooltip-arrow {
  display: none;
}
.pf-new-theme .ant-tooltip-no-arrow.ant-tooltip-placement-right,
.pf-new-theme .ant-tooltip-no-arrow.ant-tooltip-placement-rightTop,
.pf-new-theme .ant-tooltip-no-arrow.ant-tooltip-placement-rightBottom {
  padding-left: 0;
}
.pf-new-theme .ant-tooltip .ant-tooltip-inner {
  background-color: #323945;
}
.pf-new-theme .ant-tooltip .ant-tooltip-placement-bottom .ant-tooltip-arrow,
.pf-new-theme .ant-tooltip .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
.pf-new-theme .ant-tooltip .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
  border-bottom-color: #323945;
}
.pf-new-theme .ant-tooltip .ant-tooltip-placement-top .ant-tooltip-arrow,
.pf-new-theme .ant-tooltip .ant-tooltip-placement-topLeft .ant-tooltip-arrow,
.pf-new-theme .ant-tooltip .ant-tooltip-placement-topRight .ant-tooltip-arrow {
  border-top-color: #323945;
}
.pf-new-theme .ant-tooltip-medium {
  max-width: 280px;
}
.pf-new-theme .ant-tooltip-small .ant-tooltip-inner {
  min-height: auto;
  padding: 0 5px;
}
.pf-new-theme .ant-tooltip-padding-none .ant-tooltip-inner {
  padding: 0;
}
.pf-new-theme .ant-tooltip-rounded .ant-tooltip-inner {
  border-radius: 12px;
}
.pf-new-theme .ant-tooltip-rounded-level-1 .ant-tooltip-inner {
  border-radius: 6px;
}
.pf-new-theme .ant-tooltip-shadow-none .ant-tooltip-inner {
  box-shadow: none;
}
.pf-new-theme .anticon {
  vertical-align: 0;
}
.pf-new-theme .ant-input-number.text-weight-bold input {
  font-weight: bold;
}
.pf-new-theme .editable-range .ant-input-number {
  width: 32px;
}
.pf-new-theme .editable-range .ant-input-number.ant-input-number-sm {
  height: 21px;
}
.pf-new-theme .editable-range .ant-input-number .ant-input-number-handler-wrap {
  opacity: 0;
  pointer-events: none;
}
.pf-new-theme .editable-range .ant-input-number .ant-input-number-input {
  text-align: center;
  height: 20px;
}
.pf-new-theme .editable-range.editing .ant-input-number {
  width: 55px;
}
.pf-new-theme .editable-range.editing .ant-input-number .ant-input-number-handler-wrap {
  opacity: 1;
  pointer-events: all;
}
.pf-new-theme .editable-range.editing .ant-input-number .ant-input-number-input {
  text-align: left;
}
.pf-new-theme .icon-32 {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  display: inline-block;
}
.pf-new-theme .icon-16 {
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  display: inline-block;
}
.pf-new-theme .tree-node-title:hover:not(.tree-node-disabled) {
  color:  #0e68f9;
  background:  #e6f4ff;
}
.pf-new-theme .tree-node-title:hover:not(.tree-node-disabled) .tree-node-actions {
  visibility: visible;
}
.pf-new-theme .tree-node-active {
  color:  #0e68f9;
}
.pf-new-theme .tree-node-disabled {
  color:  #bfc8d5;
}
.pf-new-theme .tree-node-actions {
  visibility: hidden;
}
.pf-new-theme .badge-3rd-party {
  position: relative;
  width: 24px;
  height: 24px;
  font-size: 7px;
  font-weight: bold;
  color:  #f1565d;
}
.pf-new-theme .badge-3rd-party:before {
  content: '3rd';
  position: absolute;
  padding: 2px;
  line-height: 8px;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.pf-new-theme .badge-3rd-party:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 12px solid transparent;
  border-top-color: #e7ebef;
  border-left-color: #e7ebef;
  border-top-left-radius: 4px;
}
.pf-new-theme .badge-distribution-link {
  position: relative;
  width: 16px;
  height: 16px;
  border-radius: 2px;
}
.pf-new-theme .badge-visualize-data {
  width: 16px;
  height: 16px;
  border-radius: 2px;
}
.pf-new-theme .badge-translations {
  width: 16px;
  height: 16px;
  border-radius: 2px;
}
.pf-new-theme .pf-select.ant-select:not(.ant-select-customize-input).pf-select-grey .ant-select-selector {
  background-color: #f9fafc;
  color: #323945;
  border: 1px solid #e7ebef;
  font-weight: bold;
}
.pf-new-theme .pf-select.ant-select:not(.ant-select-customize-input).pf-select-grey.pf-transparent-disable.ant-select-disabled .ant-select-selector,
.pf-new-theme .pf-select.ant-select:not(.ant-select-customize-input).pf-select-grey.pf-transparent-disable.ant-select-disabled:hover .ant-select-selector {
  color: #bfc8d5;
  background: transparent;
}
.pf-new-theme .pf-input-no-shadow:focus {
  box-shadow: none;
}
.pf-new-theme .pf-input-search {
  background: #f3f6fb;
  margin-top: 7px;
}
.pf-new-theme .pf-input-search .ant-input-group-addon {
  background: transparent;
  border-radius: 0 4px 4px 0;
}
.pf-new-theme .pf-input-search input {
  background-color: transparent;
  border: none;
  color: #323945;
  height: 34px;
}
.pf-new-theme .pf-input-search input:focus,
.pf-new-theme .pf-input-search input::placeholder {
  color: #323945;
}
.pf-new-theme .pf-input-search input:focus,
.pf-new-theme .pf-input-search input:hover {
  background: #f3f6fb;
  box-shadow: none;
}
.pf-new-theme .pf-input-search input:focus + .ant-input-group-addon,
.pf-new-theme .pf-input-search input:hover + .ant-input-group-addon {
  background: #f3f6fb;
}
.pf-new-theme .pf-input-search button {
  background: transparent;
  border: none;
  box-shadow: none;
}
.pf-new-theme .pf-input-search .anticon-search {
  color: black;
  font-size: 14px;
  position: relative;
  top: -1;
}
.pf-new-theme .full-size-link {
  position: relative;
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  margin: 3px 0;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.pf-new-theme .full-size-link a:before,
.pf-new-theme .full-size-link button:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.pf-new-theme .file-upload .file-upload-disabled a {
  cursor: not-allowed;
  color: #e0e6ed;
}
.pf-new-theme .file-upload .file-upload-disabled .ant-upload {
  color: #e0e6ed;
  background-color: #8f98a9;
}
.pf-new-theme .file-upload.file-upload--w-image {
  min-height: 40px;
  border: 1px dashed #e7ebef;
}
.pf-new-theme .file-upload .ant-upload.ant-upload-drag {
  padding: 0;
  background: #fff;
}
.pf-new-theme .file-upload .ant-upload.ant-upload-btn {
  padding: 30px;
}
.pf-new-theme .file-upload-preview {
  width: auto;
  height: auto;
  max-width: 300px;
  max-height: 300px;
}
.pf-new-theme .file-upload-preview.file-upload-preview--middle {
  max-width: 200px;
  max-height: 200px;
}
.pf-new-theme .file-upload-preview.file-upload-preview--small {
  max-width: 150px;
  max-height: 150px;
}
.pf-new-theme .file-upload-preview.file-upload-preview--min-sizes {
  min-height: 100px;
}
.pf-new-theme .was-scrolled-into-view {
  border-radius: 8px;
}
.pf-new-theme .bordered-arrow-left {
  border-style: solid;
  border-color: currentColor;
  position: relative;
  border-width: 0 0 0 2px;
}
.pf-new-theme .bordered-arrow-left:before {
  content: '';
  border: 4px solid transparent;
  border-left: 0;
  border-right-color: currentColor;
  position: absolute;
  top: 50%;
  left: -2px;
  transform: translate(-100%, -50%);
}
.pf-new-theme .formatted-editor {
  min-height: 16px;
  outline: none;
  cursor: text;
}
.pf-new-theme .formatted-editor.no-height {
  min-height: 1px;
}
.pf-new-theme .formatted-editor.conjoint-editor {
  min-height: 30px;
}
.pf-new-theme .formatted-editor.active-placeholder:before {
  content: attr(data-placeholder);
  position: absolute;
  line-height: 16px;
  pointer-events: none;
  color: #8f98a9;
}
.pf-new-theme .formatted-editor.terms-conditions-editor.active-placeholder:before {
  line-height: 42px;
}
.pf-new-theme .formatted-editor.color-placeholder-grey-8:before {
  color: #8f98a9;
}
.pf-new-theme .formatted-editor br {
  display: none;
}
.pf-new-theme .formatted-editor span {
  white-space: pre-wrap;
}
.pf-new-theme .formatted-editor.carried-forward-answer:not(.active-placeholder) div {
  display: inline-block;
}
.pf-new-theme .formatted-editor.cursor-disabled {
  cursor: not-allowed;
}
.pf-new-theme .terms-modal .formatted-editor.active-placeholder:before {
  color: #bfc8d5;
}
.pf-new-theme .stack-context {
  z-index: 1;
}
.pf-new-theme .stack-context-2 {
  z-index: 2;
}
.pf-new-theme .stack-context-3 {
  z-index: 3;
}
.pf-new-theme ::placeholder {
  opacity: 1;
}
.pf-new-theme .ant-select-item-option-active {
  background-color: #e6f4ff !important;
}
.reset-ant-collapse .ant-collapse-borderless > .ant-collapse-item {
  border: 0 !important;
}
.reset-ant-collapse .ant-collapse-borderless .ant-collapse-content-box {
  padding: 0 !important;
}
.reset-ant-collapse .ant-collapse-borderless .ant-collapse-header {
  padding: 0 !important;
}
.ant-divider-long {
  height: 28px !important;
}
.ant-progress-right .ant-progress-text {
  text-align: right;
}
.ant-progress-transparent .ant-progress-inner {
  background-color: transparent;
}
.ant-progress-text-dark .ant-progress-text {
  color: #323945;
}
.ant-progress-text-sm {
  font-size: 12px;
  font-weight: 400;
}
.ant-progress-status-success .ant-progress-text {
  color: #ffc069 !important;
}
.highcharts-legend-item,
.highcharts-axis-labels {
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
}
.text-capitalize {
  text-transform: capitalize;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.user-select-none {
  user-select: none;
}
.upgrade-plan-action {
  opacity: 0;
  top: 3px;
  left: 0;
  width: 100%;
  height: 26px;
  padding: 4px 15px;
  z-index: 10;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.upgrade-plan-action:active,
.upgrade-plan-action:focus,
.upgrade-plan-action:hover {
  opacity: 1;
}
.text-underline {
  text-decoration: underline;
}
.text-underline:active,
.text-underline:focus,
.text-underline:hover {
  text-decoration: underline;
}
.no-scrollbars {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.no-scrollbars::-webkit-scrollbar {
  display: none;
}
.img-thumb {
  width: auto;
  height: auto;
  max-height: 18px;
  max-width: 36px;
  object-fit: cover;
}
.pf-new-theme .targeting-peeq-card .select-dropdown-with-add-all .ant-select-item-option-active:first-of-type,
.pf-new-theme .targeting-card .select-dropdown-with-add-all .ant-select-item-option-active:first-of-type {
  background-color: transparent !important;
}
.pf-new-theme .targeting-card .select-dropdown-with-add-all .ant-select-item:first-of-type:active,
.pf-new-theme .targeting-card .select-dropdown-with-add-all .ant-select-item:first-of-type:focus,
.pf-new-theme .targeting-card .select-dropdown-with-add-all .ant-select-item:first-of-type:hover {
  color: #388bff !important;
}
.pf-new-theme .targeting-peeq-card .select-dropdown-with-add-all .ant-select-item:first-of-type:active,
.pf-new-theme .targeting-peeq-card .select-dropdown-with-add-all .ant-select-item:first-of-type:focus,
.pf-new-theme .targeting-peeq-card .select-dropdown-with-add-all .ant-select-item:first-of-type:hover {
  color: #381581 !important;
}
.select-dropdown-with-add-all .ant-select-item:first-of-type {
  font-weight: 500;
  background-color: transparent !important;
  border-bottom: 1px solid #e7ebef !important;
}
.pf-theme .ant-legacy-form-item-label,
.pf-theme .ant-tabs,
.pf-theme .ant-card,
.pf-theme .ant-input,
.pf-theme .ant-steps {
  font-family: 'Roboto', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
}
`, "",{"version":3,"sources":["webpack://./app/theme/index.less","webpack://./node_modules/antd/lib/style/core/base.less","webpack://./node_modules/antd/lib/style/core/global.less","webpack://./node_modules/antd/lib/style/mixins/size.less","webpack://./node_modules/antd/lib/style/mixins/clearfix.less","webpack://./node_modules/antd/lib/style/core/iconfont.less","webpack://./node_modules/antd/lib/style/mixins/iconfont.less","webpack://./node_modules/antd/lib/style/mixins/motion.less","webpack://./node_modules/antd/lib/style/core/motion/fade.less","webpack://./node_modules/antd/lib/style/core/motion/move.less","webpack://./node_modules/antd/lib/style/core/motion/other.less","webpack://./node_modules/antd/lib/style/core/motion/slide.less","webpack://./node_modules/antd/lib/style/core/motion/zoom.less","webpack://./node_modules/antd/lib/style/core/motion.less","webpack://./app/theme/base.less","webpack://./app/theme/re-theme/colors.less","webpack://./app/theme/helpers.less","webpack://./node_modules/antd/lib/button/style/index.less","webpack://./node_modules/antd/lib/button/style/mixin.less","webpack://./node_modules/antd/lib/button/style/rtl.less","webpack://./app/theme/button.less","webpack://./app/theme/form.less","webpack://./app/theme/input.less","webpack://./app/theme/card.less","webpack://./node_modules/antd/lib/alert/style/index.less","webpack://./node_modules/antd/lib/style/mixins/reset.less","webpack://./node_modules/antd/lib/alert/style/rtl.less","webpack://./app/theme/alert.less","webpack://./node_modules/antd/lib/pagination/style/index.less","webpack://./node_modules/antd/lib/input/style/mixin.less","webpack://./node_modules/antd/lib/style/mixins/compatibility.less","webpack://./node_modules/antd/lib/pagination/style/rtl.less","webpack://./app/theme/pagination.less","webpack://./node_modules/antd/lib/table/style/size.less","webpack://./node_modules/antd/lib/table/style/bordered.less","webpack://./node_modules/antd/lib/table/style/index.less","webpack://./node_modules/antd/lib/style/mixins/operation-unit.less","webpack://./node_modules/antd/lib/table/style/radius.less","webpack://./node_modules/antd/lib/table/style/rtl.less","webpack://./app/theme/table.less","webpack://./app/theme/select.less","webpack://./app/theme/modal.less","webpack://./node_modules/antd/lib/popover/style/index.less","webpack://./node_modules/antd/lib/popover/style/rtl.less","webpack://./app/theme/popover.less","webpack://./node_modules/antd/lib/spin/style/index.less","webpack://./node_modules/antd/lib/spin/style/rtl.less","webpack://./app/theme/spin.less","webpack://./app/theme/list.less","webpack://./node_modules/antd/lib/upload/style/index.less","webpack://./node_modules/antd/lib/upload/style/rtl.less","webpack://./app/theme/upload.less","webpack://./app/theme/subscription-plans.less","webpack://./app/theme/team-members.less","webpack://./app/theme/team-member-card.less","webpack://./app/theme/team-members-invite-form.less","webpack://./app/theme/account-card.less","webpack://./app/theme/modal-create-survey.less","webpack://./node_modules/antd/lib/menu/style/status.less","webpack://./node_modules/antd/lib/menu/style/index.less","webpack://./node_modules/antd/lib/menu/style/light.less","webpack://./node_modules/antd/lib/menu/style/dark.less","webpack://./node_modules/antd/lib/menu/style/rtl.less","webpack://./app/theme/menu.less","webpack://./app/theme/radius.less","webpack://./app/theme/advanced-logic.less","webpack://./app/theme/logic-path-preview.less","webpack://./app/theme/grouping.less","webpack://./app/theme/screening-details.less","webpack://./app/theme/tag.less","webpack://./app/theme/icons.less","webpack://./app/theme/audience-templates.less","webpack://./app/theme/re-theme/index.less","webpack://./app/theme/re-theme/layout.less","webpack://./app/theme/re-theme/integrations.less","webpack://./app/theme/re-theme/shame.less","webpack://./app/theme/re-theme/tabs.less","webpack://./app/theme/re-theme/animations.less","webpack://./app/theme/re-theme/survey-summary.less","webpack://./app/theme/re-theme/grid.less","webpack://./app/theme/re-theme/spacing.less","webpack://./app/theme/re-theme/peeq.less","webpack://./app/theme/re-theme/questionnaire-revisions.less","webpack://./app/theme/re-theme/ai-builder.less","webpack://./app/theme/re-theme/answer.less","webpack://./app/theme/re-theme/shadows.less"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;ACE3F;;;;;;EAGE,aAAA;ADGJ;AACA,yCAAyC;AEDxC;;ECPC,WAAA;EACA,YAAA;AHYF;AEAA;;EAEE,aAAA;AFEF;AEWA;;;EAGE,sBAAA;AFTF;AEYC;EACC,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6BAAA;EACA,6CAAA;AFVF;AEcA;EACE,mBAAA;AFZF;AEoBA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,+FAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;AFlBF;AE0BA;EACE,wBAAA;AFxBF;AEgCA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AF9BF;AEyCA;;;;;;EAME,aAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AFvCF;AE8CA;EACE,aAAA;EACA,kBAAA;AF5CF;AEsDA;;EAGE,0BAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;AFrDF;AEwDA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;AFtDF;AEyDA;;;;EAIE,wBAAA;AFvDF;AE0DA;;;EAGE,aAAA;EACA,kBAAA;AFxDF;AE2DA;;;;EAIE,gBAAA;AFzDF;AE4DA;EACE,gBAAA;AF1DF;AE6DA;EACE,oBAAA;EACA,cAAA;AF3DF;AE8DA;EACE,eAAA;AF5DF;AE+DA;EACE,kBAAA;AF7DF;AEgEA;;EAEE,mBAAA;AF9DF;AEiEA;EACE,cAAA;AF/DF;AEuEA;;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;AFrEF;AEwEA;EACE,eAAA;AFtEF;AEwEA;EACE,WAAA;AFtEF;AE6EA;EACE,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,qCAAA;AF3EF;AE6EE;EACE,cAAA;AF3EJ;AE8EE;EACE,cAAA;AF5EJ;AE+EE;;EAEE,qBAAA;EACA,UAAA;AF7EJ;AEiFE;EACE,qBAAA;EACA,UAAA;AF/EJ;AEkFE;EACE,0BAAA;EACA,mBAAA;AFhFJ;AEwFA;;;;EAIE,cAAA;EACA,qFAAA;AFtFF;AEyFA;EAEE,aAAA;EAEA,kBAAA;EAEA,cAAA;AF1FF;AEgGA;EAEE,eAAA;AF/FF;AEsGA;EACE,sBAAA;EACA,kBAAA;AFpGF;AEuGA;EACE,gBAAA;AFrGF;AEkHA;;;;;;;;;EASE,0BAAA;AFhHF;AEuHA;EACE,yBAAA;AFrHF;AEwHA;EACE,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;AFtHF;AE6HA;;;;;EAKE,SAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;AF3HF;AE8HA;;EAEE,iBAAA;AF5HF;AE+HA;;EAEE,oBAAA;AF7HF;AEmIC;;;;EAIC,0BAAA;AFjIF;AEqIA;;;;EAIE,UAAA;EACA,kBAAA;AFnIF;AEsIA;;EAEE,sBAAA;EACA,UAAA;AFpIF;AEuIA;;;;EASE,2BAAA;AF1IF;AE6IA;EACE,cAAA;EAEA,gBAAA;AF5IF;AE+IA;EAME,YAAA;EACA,SAAA;EAEA,UAAA;EACA,SAAA;AFnJF;AEwJA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AFtJF;AEyJA;EACE,wBAAA;AFvJF;AE2JA;;EAEE,YAAA;AFzJF;AE4JA;EAKE,oBAAA;EACA,wBAAA;AF9JF;AEqKA;;EAEE,wBAAA;AFnKF;AE2KA;EACE,aAAA;EACA,0BAAA;AFzKF;AEgLA;EACE,qBAAA;AF9KF;AEiLA;EACE,kBAAA;AF/KF;AEkLA;EACE,aAAA;AFhLF;AEqLA;EACE,wBAAA;AFnLF;AEsLA;EACE,cAAA;EACA,yBAAA;AFpLF;AEuLA;EACE,WAAA;EACA,mBAAA;AFrLF;AI9SE;EACE,cAAA;EACA,WAAA;AJgTJ;AI9SE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJ+SJ;AKxTC;ECFC,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;AN6TF;AKpUC;ECUG,cAAA;AN6TJ;AKvUC;ECcG,qBAAA;AN4TJ;AMzTE;EACE,aAAA;AN2TJ;AMxTE;EACE,cAAA;AN0TJ;AK7UE;EACE,eAAA;AL+UJ;AK3UC;EACC,qBAAA;EACA,2CAAA;AL6UF;AK3UC;EACC,qBAAA;EACA,2CAAA;AL6UF;AOjVG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APmVJ;AOjVG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APmVJ;AOjVG;;EAEC,yBAAA;EACA,6BAAA;APmVJ;AOjVG;EACC,0BAAA;EACA,6BAAA;EACA,oBAAA;APmVJ;AQhXG;;EAEC,UAAA;EACA,iCAAA;ARkXJ;AQhXG;EACC,iCAAA;ARkXJ;AQ5WA;EACE;IACE,UAAA;ER8WF;EQ5WA;IACE,UAAA;ER8WF;AACF;AQ3WA;EACE;IACE,UAAA;ER6WF;EQ3WA;IACE,UAAA;ER6WF;AACF;AO9XG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APgYJ;AO9XG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APgYJ;AO9XG;;EAEC,2BAAA;EACA,6BAAA;APgYJ;AO9XG;EACC,4BAAA;EACA,6BAAA;EACA,oBAAA;APgYJ;AS7ZG;;EAEC,UAAA;EACA,4DAAA;AT+ZJ;AS7ZG;EACC,8DAAA;AT+ZJ;AO3ZG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP6ZJ;AO3ZG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP6ZJ;AO3ZG;;EAEC,6BAAA;EACA,6BAAA;AP6ZJ;AO3ZG;EACC,8BAAA;EACA,6BAAA;EACA,oBAAA;AP6ZJ;AS1bG;;EAEC,UAAA;EACA,4DAAA;AT4bJ;AS1bG;EACC,8DAAA;AT4bJ;AOxbG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP0bJ;AOxbG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP0bJ;AOxbG;;EAEC,6BAAA;EACA,6BAAA;AP0bJ;AOxbG;EACC,8BAAA;EACA,6BAAA;EACA,oBAAA;AP0bJ;ASvdG;;EAEC,UAAA;EACA,4DAAA;ATydJ;ASvdG;EACC,8DAAA;ATydJ;AOrdG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APudJ;AOrdG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APudJ;AOrdG;;EAEC,8BAAA;EACA,6BAAA;APudJ;AOrdG;EACC,+BAAA;EACA,6BAAA;EACA,oBAAA;APudJ;ASpfG;;EAEC,UAAA;EACA,4DAAA;ATsfJ;ASpfG;EACC,8DAAA;ATsfJ;AS7eA;EACE;IACE,2BAAA;IACA,qBAAA;IACA,UAAA;ET+eF;ES7eA;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ET+eF;AACF;AS5eA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ET8eF;ES5eA;IACE,2BAAA;IACA,qBAAA;IACA,UAAA;ET8eF;AACF;AS3eA;EACE;IACE,4BAAA;IACA,qBAAA;IACA,UAAA;ET6eF;ES3eA;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ET6eF;AACF;AS1eA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ET4eF;ES1eA;IACE,4BAAA;IACA,qBAAA;IACA,UAAA;ET4eF;AACF;ASzeA;EACE;IACE,2BAAA;IACA,qBAAA;IACA,UAAA;ET2eF;ESzeA;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ET2eF;AACF;ASxeA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ET0eF;ESxeA;IACE,2BAAA;IACA,qBAAA;IACA,UAAA;ET0eF;AACF;ASveA;EACE;IACE,4BAAA;IACA,qBAAA;IACA,UAAA;ETyeF;ESveA;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ETyeF;AACF;ASteA;EACE;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;ETweF;ESteA;IACE,4BAAA;IACA,qBAAA;IACA,UAAA;ETweF;AACF;AU/lBA;EACE;IACE,yBAAA;EVimBF;AACF;AU3lBC;;EAEC,kBAAA;AV6lBF;AU1lBA;EACE,iCAAA;EACA,eAAA;AV4lBF;AUvlBC;;EAEC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,iDAAA;EACA,YAAA;EACA,6GAAA;EACA,6BAAA;EACA,WAAA;EACA,oBAAA;AVylBF;AUtlBA;EACE;IACE,yBAAA;IACA,mDAAA;EVwlBF;AACF;AUrlBA;EACE;IACE,UAAA;EVulBF;AACF;AO3nBG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP6nBJ;AO3nBG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP6nBJ;AO3nBG;;EAEC,4BAAA;EACA,6BAAA;AP6nBJ;AO3nBG;EACC,6BAAA;EACA,6BAAA;EACA,oBAAA;AP6nBJ;AW1pBG;;EAEC,UAAA;EACA,yDAAA;AX4pBJ;AW1pBG;EACC,iEAAA;AX4pBJ;AOxpBG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP0pBJ;AOxpBG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP0pBJ;AOxpBG;;EAEC,8BAAA;EACA,6BAAA;AP0pBJ;AOxpBG;EACC,+BAAA;EACA,6BAAA;EACA,oBAAA;AP0pBJ;AWvrBG;;EAEC,UAAA;EACA,yDAAA;AXyrBJ;AWvrBG;EACC,iEAAA;AXyrBJ;AOrrBG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APurBJ;AOrrBG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APurBJ;AOrrBG;;EAEC,8BAAA;EACA,6BAAA;APurBJ;AOrrBG;EACC,+BAAA;EACA,6BAAA;EACA,oBAAA;APurBJ;AWptBG;;EAEC,UAAA;EACA,yDAAA;AXstBJ;AWptBG;EACC,iEAAA;AXstBJ;AOltBG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APotBJ;AOltBG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APotBJ;AOltBG;;EAEC,+BAAA;EACA,6BAAA;APotBJ;AOltBG;EACC,gCAAA;EACA,6BAAA;EACA,oBAAA;APotBJ;AWjvBG;;EAEC,UAAA;EACA,yDAAA;AXmvBJ;AWjvBG;EACC,iEAAA;AXmvBJ;AW1uBA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,UAAA;EX4uBF;EW1uBA;IACE,oBAAA;IACA,uBAAA;IACA,UAAA;EX4uBF;AACF;AWzuBA;EACE;IACE,oBAAA;IACA,uBAAA;IACA,UAAA;EX2uBF;EWzuBA;IACE,sBAAA;IACA,uBAAA;IACA,UAAA;EX2uBF;AACF;AWxuBA;EACE;IACE,sBAAA;IACA,2BAAA;IACA,UAAA;EX0uBF;EWxuBA;IACE,oBAAA;IACA,2BAAA;IACA,UAAA;EX0uBF;AACF;AWvuBA;EACE;IACE,oBAAA;IACA,2BAAA;IACA,UAAA;EXyuBF;EWvuBA;IACE,sBAAA;IACA,2BAAA;IACA,UAAA;EXyuBF;AACF;AWtuBA;EACE;IACE,sBAAA;IACA,uBAAA;IACA,UAAA;EXwuBF;EWtuBA;IACE,oBAAA;IACA,uBAAA;IACA,UAAA;EXwuBF;AACF;AWruBA;EACE;IACE,oBAAA;IACA,uBAAA;IACA,UAAA;EXuuBF;EWruBA;IACE,sBAAA;IACA,uBAAA;IACA,UAAA;EXuuBF;AACF;AWpuBA;EACE;IACE,sBAAA;IACA,yBAAA;IACA,UAAA;EXsuBF;EWpuBA;IACE,oBAAA;IACA,yBAAA;IACA,UAAA;EXsuBF;AACF;AWnuBA;EACE;IACE,oBAAA;IACA,yBAAA;IACA,UAAA;EXquBF;EWnuBA;IACE,sBAAA;IACA,yBAAA;IACA,UAAA;EXquBF;AACF;AO/0BG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APi1BJ;AO/0BG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APi1BJ;AO/0BG;;EAEC,yBAAA;EACA,6BAAA;APi1BJ;AO/0BG;EACC,0BAAA;EACA,6BAAA;EACA,oBAAA;APi1BJ;AY92BG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZg3BJ;AY92BI;;EACE,eAAA;AZi3BN;AY92BG;EACC,+DAAA;AZg3BJ;AOj3BG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APm3BJ;AOj3BG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APm3BJ;AOj3BG;;EAEC,4BAAA;EACA,6BAAA;APm3BJ;AOj3BG;EACC,6BAAA;EACA,6BAAA;EACA,oBAAA;APm3BJ;AYh5BG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZk5BJ;AYh5BI;;EACE,eAAA;AZm5BN;AYh5BG;EACC,+DAAA;AZk5BJ;AOn5BG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APq5BJ;AOn5BG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APq5BJ;AOn5BG;;EAEC,4BAAA;EACA,6BAAA;APq5BJ;AOn5BG;EACC,6BAAA;EACA,6BAAA;EACA,oBAAA;APq5BJ;AYl7BG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZo7BJ;AYl7BI;;EACE,eAAA;AZq7BN;AYl7BG;EACC,+DAAA;AZo7BJ;AOr7BG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APu7BJ;AOr7BG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APu7BJ;AOr7BG;;EAEC,2BAAA;EACA,6BAAA;APu7BJ;AOr7BG;EACC,4BAAA;EACA,6BAAA;EACA,oBAAA;APu7BJ;AYp9BG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZs9BJ;AYp9BI;;EACE,eAAA;AZu9BN;AYp9BG;EACC,+DAAA;AZs9BJ;AOv9BG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APy9BJ;AOv9BG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;APy9BJ;AOv9BG;;EAEC,6BAAA;EACA,6BAAA;APy9BJ;AOv9BG;EACC,8BAAA;EACA,6BAAA;EACA,oBAAA;APy9BJ;AYt/BG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZw/BJ;AYt/BI;;EACE,eAAA;AZy/BN;AYt/BG;EACC,+DAAA;AZw/BJ;AOz/BG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP2/BJ;AOz/BG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP2/BJ;AOz/BG;;EAEC,6BAAA;EACA,6BAAA;AP2/BJ;AOz/BG;EACC,8BAAA;EACA,6BAAA;EACA,oBAAA;AP2/BJ;AYxhCG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZ0hCJ;AYxhCI;;EACE,eAAA;AZ2hCN;AYxhCG;EACC,+DAAA;AZ0hCJ;AO3hCG;;EAVD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP6hCJ;AO3hCG;EAXD,wBAAA;EACA,yBAAA;EAaE,4BAAA;AP6hCJ;AO3hCG;;EAEC,8BAAA;EACA,6BAAA;AP6hCJ;AO3hCG;EACC,+BAAA;EACA,6BAAA;EACA,oBAAA;AP6hCJ;AY1jCG;;EAEC,mBAAA;EACA,UAAA;EACA,4DAAA;AZ4jCJ;AY1jCI;;EACE,eAAA;AZ6jCN;AY1jCG;EACC,+DAAA;AZ4jCJ;AY5iCA;EACE;IACE,qBAAA;IACA,UAAA;EZ8iCF;EY5iCA;IACE,mBAAA;IACA,UAAA;EZ8iCF;AACF;AY3iCA;EACE;IACE,mBAAA;EZ6iCF;EY3iCA;IACE,qBAAA;IACA,UAAA;EZ6iCF;AACF;AY1iCA;EACE;IACE,qBAAA;IACA,UAAA;EZ4iCF;EY1iCA;IACE,mBAAA;IACA,UAAA;EZ4iCF;AACF;AYziCA;EACE;IACE,mBAAA;EZ2iCF;EYziCA;IACE,qBAAA;IACA,UAAA;EZ2iCF;AACF;AYxiCA;EACE;IACE,qBAAA;IACA,wBAAA;IACA,UAAA;EZ0iCF;EYxiCA;IACE,mBAAA;IACA,wBAAA;EZ0iCF;AACF;AYviCA;EACE;IACE,mBAAA;IACA,wBAAA;EZyiCF;EYviCA;IACE,qBAAA;IACA,wBAAA;IACA,UAAA;EZyiCF;AACF;AYtiCA;EACE;IACE,qBAAA;IACA,wBAAA;IACA,UAAA;EZwiCF;EYtiCA;IACE,mBAAA;IACA,wBAAA;EZwiCF;AACF;AYriCA;EACE;IACE,mBAAA;IACA,wBAAA;EZuiCF;EYriCA;IACE,qBAAA;IACA,wBAAA;IACA,UAAA;EZuiCF;AACF;AYpiCA;EACE;IACE,qBAAA;IACA,0BAAA;IACA,UAAA;EZsiCF;EYpiCA;IACE,mBAAA;IACA,0BAAA;EZsiCF;AACF;AYniCA;EACE;IACE,mBAAA;IACA,0BAAA;EZqiCF;EYniCA;IACE,qBAAA;IACA,0BAAA;IACA,UAAA;EZqiCF;AACF;AYliCA;EACE;IACE,qBAAA;IACA,0BAAA;IACA,UAAA;EZoiCF;EYliCA;IACE,mBAAA;IACA,0BAAA;EZoiCF;AACF;AYjiCA;EACE;IACE,mBAAA;IACA,0BAAA;EZmiCF;EYjiCA;IACE,qBAAA;IACA,0BAAA;IACA,UAAA;EZmiCF;AACF;AahsCA;EACE,gBAAA;AbksCF;AajsCE;EACE,0HAAA;AbmsCJ;Aa9rCA;EACE,gBAAA;EACA,0HAAA;AbgsCF;AACA,4FAA4F;AcntC5F;EAEI,cAAA;AdotCJ;AcltCI;;;EAGE,cAAA;AdotCN;Ac3tCA;EAYI,yBAAA;EACA,cAAA;AdktCJ;Ac/tCA;EAiBI,yBAAA;EACA,cAAA;AditCJ;Ac7sCA;EACE,qBAAA;Ad+sCF;Ac1sCA;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;Ad4sCF;Ac1sCE;EACE,iBAAA;Ad4sCJ;AcxsCA;EACE,eAAA;Ad0sCF;AcvsCA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AdysCF;AclsCA;;EAEE,wCAAA;EACA,iBAAA;AdosCF;AcvsCA;;EAKI,gBAAA;AdssCJ;AclsCA;EACE,iBAAA;EACA,cAAA;AdosCF;AcjsCA;EACE,eAAA;AdmsCF;Aen8BA;EACE,uBAAA;Afq8BF;Ael8BA;EACE,yBAAA;Afo8BF;Aej8BA;EACE,cAAA;Afm8BF;Aeh8BA;EACE,cAAA;Afk8BF;Aeh8BE;EACE,cAAA;Afk8BJ;Ae97BA;EACE,yBAAA;Afg8BF;Ae77BA;EACE,yBAAA;Af+7BF;Ae57BA;EACE,qBAAA;Af87BF;Ae37BA;EACE,cAAA;Af67BF;Ae17BA;EACE,yBAAA;Af47BF;Aez7BA;EACE,2CAAA;Af27BF;Aex7BA;EACE,yBAAA;Af07BF;Aev7BA;EACE,yBAAA;Afy7BF;Aet7BA;EACE,yBAAA;Afw7BF;Aer7BA;EACE,yBAAA;Afu7BF;Aep7BA;EACE,yBAAA;Afs7BF;Aep7BE;EACE,yBAAA;Afs7BJ;Ael7BA;EACE,yBAAA;Afo7BF;Ael7BI;EACE,yBAAA;Afo7BN;Ae/6BA;EACE,yBAAA;Afi7BF;Ae/6BA;EACE,yBAAA;Afi7BF;Ae/6BA;EACE,yBAAA;Afi7BF;Ae/6BA;EACE,yBAAA;Afi7BF;Ae76BE;EACE,cAAA;Af+6BJ;AgBlzCA;EACE,WAAA;AhBozCF;AgBjzCA;EACE,YAAA;AhBmzCF;AgB/yCE;EACE,sBAAA;AhBizCJ;AgB/yCE;EACE,wBAAA;AhBizCJ;AgB5yCE;EACE,aAAA;AhB8yCJ;AgB5yCE;EACE,gBAAA;AhB8yCJ;AgB1yCA;EACE,YAAA;AhB4yCF;AgBzyCA;EACE,gBAAA;AhB2yCF;AgB1yCE;EACE,2BAAA;AhB4yCJ;AgBxyCA;EACE,2BAAA;AhB0yCF;AgBz2CG;EACC,WAAA;AhB22CJ;AgBz2CG;EACC,gBAAA;EACA,iBAAA;AhB22CJ;AgBz2CG;EACC,eAAA;EACA,kBAAA;AhB22CJ;AgBz2CG;EACC,eAAA;AhB22CJ;AgBz2CG;EACC,kBAAA;AhB22CJ;AgBz2CG;EACC,gBAAA;AhB22CJ;AgBz2CG;EACC,iBAAA;AhB22CJ;AgBh4CG;EACC,WAAA;AhBk4CJ;AgBh4CG;EACC,gBAAA;EACA,iBAAA;AhBk4CJ;AgBh4CG;EACC,eAAA;EACA,kBAAA;AhBk4CJ;AgBh4CG;EACC,eAAA;AhBk4CJ;AgBh4CG;EACC,kBAAA;AhBk4CJ;AgBh4CG;EACC,gBAAA;AhBk4CJ;AgBh4CG;EACC,iBAAA;AhBk4CJ;AgBv5CG;EACC,YAAA;AhBy5CJ;AgBv5CG;EACC,iBAAA;EACA,kBAAA;AhBy5CJ;AgBv5CG;EACC,gBAAA;EACA,mBAAA;AhBy5CJ;AgBv5CG;EACC,gBAAA;AhBy5CJ;AgBv5CG;EACC,mBAAA;AhBy5CJ;AgBv5CG;EACC,iBAAA;AhBy5CJ;AgBv5CG;EACC,kBAAA;AhBy5CJ;AgB96CG;EACC,YAAA;AhBg7CJ;AgB96CG;EACC,iBAAA;EACA,kBAAA;AhBg7CJ;AgB96CG;EACC,gBAAA;EACA,mBAAA;AhBg7CJ;AgB96CG;EACC,gBAAA;AhBg7CJ;AgB96CG;EACC,mBAAA;AhBg7CJ;AgB96CG;EACC,iBAAA;AhBg7CJ;AgB96CG;EACC,kBAAA;AhBg7CJ;AgBr8CG;EACC,YAAA;AhBu8CJ;AgBr8CG;EACC,iBAAA;EACA,kBAAA;AhBu8CJ;AgBr8CG;EACC,gBAAA;EACA,mBAAA;AhBu8CJ;AgBr8CG;EACC,gBAAA;AhBu8CJ;AgBr8CG;EACC,mBAAA;AhBu8CJ;AgBr8CG;EACC,iBAAA;AhBu8CJ;AgBr8CG;EACC,kBAAA;AhBu8CJ;AgB59CG;EACC,YAAA;AhB89CJ;AgB59CG;EACC,iBAAA;EACA,kBAAA;AhB89CJ;AgB59CG;EACC,gBAAA;EACA,mBAAA;AhB89CJ;AgB59CG;EACC,gBAAA;AhB89CJ;AgB59CG;EACC,mBAAA;AhB89CJ;AgB59CG;EACC,iBAAA;AhB89CJ;AgB59CG;EACC,kBAAA;AhB89CJ;AgBn/CG;EACC,SAAA;AhBq/CJ;AgBn/CG;EACC,cAAA;EACA,eAAA;AhBq/CJ;AgBn/CG;EACC,aAAA;EACA,gBAAA;AhBq/CJ;AgBn/CG;EACC,aAAA;AhBq/CJ;AgBn/CG;EACC,gBAAA;AhBq/CJ;AgBn/CG;EACC,cAAA;AhBq/CJ;AgBn/CG;EACC,eAAA;AhBq/CJ;AgB1gDG;EACC,YAAA;AhB4gDJ;AgB1gDG;EACC,iBAAA;EACA,kBAAA;AhB4gDJ;AgB1gDG;EACC,gBAAA;EACA,mBAAA;AhB4gDJ;AgB1gDG;EACC,gBAAA;AhB4gDJ;AgB1gDG;EACC,mBAAA;AhB4gDJ;AgB1gDG;EACC,iBAAA;AhB4gDJ;AgB1gDG;EACC,kBAAA;AhB4gDJ;AgBjiDG;EACC,YAAA;AhBmiDJ;AgBjiDG;EACC,iBAAA;EACA,kBAAA;AhBmiDJ;AgBjiDG;EACC,gBAAA;EACA,mBAAA;AhBmiDJ;AgBjiDG;EACC,gBAAA;AhBmiDJ;AgBjiDG;EACC,mBAAA;AhBmiDJ;AgBjiDG;EACC,iBAAA;AhBmiDJ;AgBjiDG;EACC,kBAAA;AhBmiDJ;AgBxjDG;EACC,YAAA;AhB0jDJ;AgBxjDG;EACC,iBAAA;EACA,kBAAA;AhB0jDJ;AgBxjDG;EACC,gBAAA;EACA,mBAAA;AhB0jDJ;AgBxjDG;EACC,gBAAA;AhB0jDJ;AgBxjDG;EACC,mBAAA;AhB0jDJ;AgBxjDG;EACC,iBAAA;AhB0jDJ;AgBxjDG;EACC,kBAAA;AhB0jDJ;AgB/kDG;EACC,aAAA;AhBilDJ;AgB/kDG;EACC,kBAAA;EACA,mBAAA;AhBilDJ;AgB/kDG;EACC,iBAAA;EACA,oBAAA;AhBilDJ;AgB/kDG;EACC,iBAAA;AhBilDJ;AgB/kDG;EACC,oBAAA;AhBilDJ;AgB/kDG;EACC,kBAAA;AhBilDJ;AgB/kDG;EACC,mBAAA;AhBilDJ;AgBtmDG;EACC,aAAA;AhBwmDJ;AgBtmDG;EACC,kBAAA;EACA,mBAAA;AhBwmDJ;AgBtmDG;EACC,iBAAA;EACA,oBAAA;AhBwmDJ;AgBtmDG;EACC,iBAAA;AhBwmDJ;AgBtmDG;EACC,oBAAA;AhBwmDJ;AgBtmDG;EACC,kBAAA;AhBwmDJ;AgBtmDG;EACC,mBAAA;AhBwmDJ;AgB7nDG;EACC,aAAA;AhB+nDJ;AgB7nDG;EACC,kBAAA;EACA,mBAAA;AhB+nDJ;AgB7nDG;EACC,iBAAA;EACA,oBAAA;AhB+nDJ;AgB7nDG;EACC,iBAAA;AhB+nDJ;AgB7nDG;EACC,oBAAA;AhB+nDJ;AgB7nDG;EACC,kBAAA;AhB+nDJ;AgB7nDG;EACC,mBAAA;AhB+nDJ;AgBppDG;EACC,aAAA;AhBspDJ;AgBppDG;EACC,kBAAA;EACA,mBAAA;AhBspDJ;AgBppDG;EACC,iBAAA;EACA,oBAAA;AhBspDJ;AgBppDG;EACC,iBAAA;AhBspDJ;AgBppDG;EACC,oBAAA;AhBspDJ;AgBppDG;EACC,kBAAA;AhBspDJ;AgBppDG;EACC,mBAAA;AhBspDJ;AgB3qDG;EACC,UAAA;AhB6qDJ;AgB3qDG;EACC,eAAA;EACA,gBAAA;AhB6qDJ;AgB3qDG;EACC,cAAA;EACA,iBAAA;AhB6qDJ;AgB3qDG;EACC,cAAA;AhB6qDJ;AgB3qDG;EACC,iBAAA;AhB6qDJ;AgB3qDG;EACC,eAAA;AhB6qDJ;AgB3qDG;EACC,gBAAA;AhB6qDJ;AgB/mDA;EACE,yBAAA;AhBinDF;AgB7mDE;EACE,mBAAA;AhB+mDJ;AgB5mDE;EACE,mBAAA;AhB8mDJ;AgB1mDA;EAEI,mBAAA;AhB2mDJ;AgB7mDA;EAMI,mBAAA;AhB0mDJ;AgBrmDE;EACE,eAAA;AhBumDJ;AgBpmDE;EACE,kBAAA;AhBsmDJ;AgBlmDA;EACE,cAAA;AhBomDF;AgBjmDA;EACE,eAAA;AhBmmDF;AgBhmDA;EACE,+FAAA;AhBkmDF;AgB/lDA;EACE,iBAAA;AhBimDF;AgB9lDA;EACE,kBAAA;AhBgmDF;AgB7lDA;EACE,gBAAA;AhB+lDF;AgB5lDA;EACE,gBAAA;AhB8lDF;AgB3lDA;EACE,gBAAA;AhB6lDF;AgB1lDA;EACE,0BAAA;AhB4lDF;AgBzlDA;EACE,YAAA;AhB2lDF;AgBxlDA;EACE,wBAAA;EACA,2BAAA;AhB0lDF;AgBvlDA;EACE,2BAAA;AhBylDF;AgBtlDA;EACE,uBAAA;AhBwlDF;AgBrlDA;EACE,gBAAA;AhBulDF;AgBplDA;EACE,WAAA;AhBslDF;AgBnlDA;EACE,UAAA;AhBqlDF;AgBllDA;EACE,eAAA;AhBolDF;AgBjlDA;EACE,WAAA;AhBmlDF;AgBjlDA;EACE,eAAA;AhBmlDF;AgBjlDA;EACE,YAAA;AhBmlDF;AgBhlDA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;AhBklDF;AgB/kDA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AhBilDF;AgB9kDA;EACE,aAAA;AhBglDF;AgB9kDA;EACE,aAAA;AhBglDF;AgB9kDA;EACE,aAAA;AhBglDF;AgB9kDA;EACE,aAAA;AhBglDF;AgB9kDA;EACE,aAAA;AhBglDF;AgB7kDA;EACE,eAAA;AhB+kDF;AgB5kDA;EACE,mBAAA;AhB8kDF;AgB3kDA;EACE,qBAAA;AhB6kDF;AgB1kDA;EACE,eAAA;AhB4kDF;AgBzkDA;EAEI,YAAA;AhB0kDJ;AgB5kDA;EAOI,eAAA;AhBwkDJ;AgB/kDA;EAYI,aAAA;AhBskDJ;AgBllDA;EAgBI,oBAAA;AhBqkDJ;AgBrlDA;EAoBI,OAAA;AhBokDJ;AgBxlDA;EAwBI,YAAA;AhBmkDJ;AgB3lDA;EA4BI,YAAA;AhBkkDJ;AgB9lDA;EAgCI,8BAAA;AhBikDJ;AgBjmDA;EAoCI,uBAAA;AhBgkDJ;AgBpmDA;EAwCI,yBAAA;AhB+jDJ;AgBvmDA;EA4CI,mBAAA;AhB8jDJ;AgB1mDA;EAgDI,uBAAA;AhB6jDJ;AgB7mDA;EAoDI,qBAAA;AhB4jDJ;AgBhnDA;EAwDI,sBAAA;AhB2jDJ;AgBnnDA;EA6DI,aAAA;AhByjDJ;AgBtnDA;EAkEI,cAAA;AhBujDJ;AgBznDA;EAsEI,eAAA;AhBsjDJ;AgB5nDA;EA0EI,eAAA;AhBqjDJ;AgB/nDA;EA8EI,eAAA;AhBojDJ;AgBloDA;EAkFI,eAAA;AhBmjDJ;AgBroDA;EAsFI,eAAA;AhBkjDJ;AgBxoDA;EA0FI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AhBijDJ;AgB9oDA;EAiGI,eAAA;AhBgjDJ;AgBjpDA;EAqGI,aAAA;AhB+iDJ;AgBppDA;EAyGI,cAAA;AhB8iDJ;AgBvpDA;EA6GI,cAAA;AhB6iDJ;AgB1pDA;EAiHI,cAAA;AhB4iDJ;AgB7pDA;EAqHI,cAAA;AhB2iDJ;AgBhqDA;EAyHI,yBAAA;AhB0iDJ;AgBnqDA;;EA8HI,cAAA;AhByiDJ;AgBvqDA;EAkII,yBAAA;AhBwiDJ;AgB1qDA;EAqII,sBAAA;AhBwiDJ;AgB7qDA;EAyII,cAAA;AhBuiDJ;AgBniDA;EACE,kBAAA;AhBqiDF;AgBliDA;EACE,gBAAA;AhBoiDF;AgBjiDA;EACE,kBAAA;AhBmiDF;AgBhiDA;EACE,cAAA;AhBkiDF;AgB/hDA;EACE,iBAAA;AhBiiDF;AgB7hDE;EACE,kBAAA;AhB+hDJ;AgB3hDA;EACE,iBAAA;AhB6hDF;AgB1hDA;EACE,kBAAA;AhB4hDF;AgBzhDA;EACE,mBAAA;AhB2hDF;AiBl7DC;EAQC,gBAAA;ECwLA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,wCAAA;EACA,eAAA;EACA,yDAAA;EACA,iBAAA;EACA,0BAAA;EAjNA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EAoIA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBo0DJ;AiBx8DC;ECgNG,cAAA;AlB2vDJ;AkBzvDE;;;EAGE,UAAA;AlB2vDJ;AkBzvDE;EACE,qBAAA;AlB2vDJ;AkBzvDE;EACE,UAAA;EACA,gBAAA;AlB2vDJ;AkBzvDE;EACE,mBAAA;AlB2vDJ;AkB5vDE;EAGI,oBAAA;AlB4vDN;AkBzvDE;EA1OA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AlBs+DF;AkB1vDE;EA/OA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AlB4+DF;AiBz+DC;ECwIG,mBAAA;AlBo2DJ;AkBn2DI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBq2DN;AkBh8DE;;EA4EA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBu3DJ;AkBt8DE;;EAmFE,mBAAA;AlBu3DJ;AkBt3DI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBy3DN;AkBx8DE;EAgEA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlB04DJ;AkB78DE;EAuEE,mBAAA;AlBy4DJ;AkBx4DI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB04DN;AkBxhEI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlB2hEN;AkBliEI;;;;EAsIA,mBAAA;AlBk6DJ;AkBj6DI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBs6DN;AkBh0DE;;;EAGE,qBAAA;EACA,gBAAA;AlBk0DJ;AiB5jEC;EAeG,qBAAA;AjBgjEJ;AiB7iEE;EC+GA,WAAA;EACA,qBAAA;EAEE,mBAAA;EAnHF,yCAAA;EACA,wCAAA;AlBojEF;AiBpjEE;ECsHE,mBAAA;AlBi8DJ;AkBh8DI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBk8DN;AkB9jEE;;EA6GA,WAAA;EACA,qBAAA;EAEE,mBAAA;AlBo9DJ;AkBpkEE;;EAoHE,mBAAA;AlBo9DJ;AkBn9DI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBs9DN;AkBpkEE;EA+FA,WAAA;EACA,qBAAA;EAEE,mBAAA;AlBu+DJ;AkBzkEE;EAsGE,mBAAA;AlBs+DJ;AkBr+DI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBu+DN;AkBrnEI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBwnEN;AkB/nEI;;;;EAsIA,mBAAA;AlB+/DJ;AkB9/DI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBmgEN;AiB9nEK;EACC,2BAAA;EACA,0BAAA;AjBgoEN;AiB9nEM;EACE,qBAAA;AjBgoER;AiB3nEM;EACE,2BAAA;AjB6nER;AiB3nEQ;EACE,2BAAA;AjB6nEV;AiBxnEK;;EAEC,0BAAA;AjB0nEN;AiBxnEM;;EACE,0BAAA;AjB2nER;AiBtnEE;EC+EA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlByiEJ;AiB3nEE;ECsFE,mBAAA;AlBwiEJ;AkBviEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlByiEN;AkBpoEE;;EA4EA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlB2jEJ;AkB1oEE;;EAmFE,mBAAA;AlB2jEJ;AkB1jEI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB6jEN;AkB5oEE;EAgEA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlB8kEJ;AkBjpEE;EAuEE,mBAAA;AlB6kEJ;AkB5kEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB8kEN;AkB5tEI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlB+tEN;AkBtuEI;;;;EAsIA,mBAAA;AlBsmEJ;AkBrmEI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB0mEN;AiBpsEE;EC2EA,cAAA;EACA,qBAAA;EAEE,gBAAA;EAgIF,oBAAA;AlB4/DF;AiB1sEE;ECkFE,mBAAA;AlB2nEJ;AkB1nEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB4nEN;AkBvtEE;;EA4EA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlB8oEJ;AkB7tEE;;EAmFE,mBAAA;AlB8oEJ;AkB7oEI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBgpEN;AkB/tEE;EAgEA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBiqEJ;AkBpuEE;EAuEE,mBAAA;AlBgqEJ;AkB/pEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBiqEN;AkB/yEI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBkzEN;AkBzzEI;;;;EAsIA,mBAAA;AlByrEJ;AkBxrEI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB6rEN;AiBjxEE;ECqEA,cAAA;EACA,qBAAA;EAEE,mBAAA;EAnHF,yCAAA;EACA,wCAAA;AlBk0EF;AiBxxEE;EC4EE,mBAAA;AlB+sEJ;AkB9sEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBgtEN;AkB50EE;;EA6GA,cAAA;EACA,qBAAA;EAEE,mBAAA;AlBkuEJ;AkBl1EE;;EAoHE,mBAAA;AlBkuEJ;AkBjuEI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBouEN;AkBl1EE;EA+FA,cAAA;EACA,qBAAA;EAEE,mBAAA;AlBqvEJ;AkBv1EE;EAsGE,mBAAA;AlBovEJ;AkBnvEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBqvEN;AkBn4EI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBs4EN;AkB74EI;;;;EAsIA,mBAAA;AlB6wEJ;AkB5wEI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBixEN;AiBj2EE;ECiEA,cAAA;EACA,yBAAA;EAEE,uBAAA;EAkMF,gBAAA;AlBimEF;AiBv2EE;ECwEE,mBAAA;AlBkyEJ;AkBjyEI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBmyEN;AkB93EE;;EA4EA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlBqzEJ;AkBp4EE;;EAmFE,mBAAA;AlBqzEJ;AkBpzEI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBuzEN;AkBt4EE;EAgEA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlBw0EJ;AkB34EE;EAuEE,mBAAA;AlBu0EJ;AkBt0EI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBw0EN;AkBt9EI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBy9EN;AkBh+EI;;;;EAsIA,mBAAA;AlBg2EJ;AkB/1EI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBo2EN;AkB7qEE;EACE,uBAAA;AlB+qEJ;AkB7qEE;;;EAGE,yBAAA;AlB+qEJ;AkB1/EI;;;;EA+HF,0BAAA;EACA,yBAAA;EAEE,uBAAA;EA5HE,iBAAA;EACA,gBAAA;AlB6/EN;AkBpgFI;;;;EAsIA,mBAAA;AlBo4EJ;AkBn4EI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBw4EN;AiBp9EE;EC6DA,cAAA;EACA,yBAAA;EAEE,uBAAA;EAgNF,gBAAA;AlB0sEF;AiB19EE;ECoEE,mBAAA;AlBy5EJ;AkBx5EI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB05EN;AkBr/EE;;EA4EA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlB46EJ;AkB3/EE;;EAmFE,mBAAA;AlB46EJ;AkB36EI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB86EN;AkB7/EE;EAgEA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlB+7EJ;AkBlgFE;EAuEE,mBAAA;AlB87EJ;AkB77EI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB+7EN;AkB7kFI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBglFN;AkBvlFI;;;;EAsIA,mBAAA;AlBu9EJ;AkBt9EI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB29EN;AkBtxEE;;EAEE,cAAA;EACA,gCAAA;EACA,yBAAA;AlBwxEJ;AkBrxEE;EACE,cAAA;EACA,gCAAA;EACA,yBAAA;AlBuxEJ;AkBpnFI;;;;EA+HF,0BAAA;EACA,yBAAA;EAEE,uBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBunFN;AkB9nFI;;;;EAsIA,mBAAA;AlB8/EJ;AkB7/EI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBkgFN;AiB1kFE;ECyDA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBmhFJ;AiB/kFE;ECgEE,mBAAA;AlBkhFJ;AkBjhFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBmhFN;AkBt5EE;;EA5IA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBqiFJ;AkB55EE;;EArIE,mBAAA;AlBqiFJ;AkBpiFI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBuiFN;AkB35EE;EA3JA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBwjFJ;AkBh6EE;EApJE,mBAAA;AlBujFJ;AkBtjFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBwjFN;AkBtsFI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBysFN;AkBhtFI;;;;EAsIA,mBAAA;AlBglFJ;AkB/kFI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBolFN;AiBxpFE;ECqDA,cAAA;EACA,qBAAA;EAEE,mBAAA;EAnHF,yCAAA;EACA,wCAAA;AlBytFF;AiB/pFE;EC4DE,mBAAA;AlBsmFJ;AkBrmFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBumFN;AkBnuFE;;EA6GA,cAAA;EACA,qBAAA;EAEE,mBAAA;AlBynFJ;AkBzuFE;;EAoHE,mBAAA;AlBynFJ;AkBxnFI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB2nFN;AkBzuFE;EA+FA,cAAA;EACA,qBAAA;EAEE,mBAAA;AlB4oFJ;AkB9uFE;EAsGE,mBAAA;AlB2oFJ;AkB1oFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB4oFN;AkB1xFI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlB6xFN;AkBpyFI;;;;EAsIA,mBAAA;AlBoqFJ;AkBnqFI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBwqFN;AiBxuFE;ECiDA,cAAA;EACA,yBAAA;EAEE,uBAAA;EA2KF,gBAAA;AlB+gFF;AiB9uFE;ECwDE,mBAAA;AlByrFJ;AkBxrFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB0rFN;AkBrxFE;;EA4EA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlB4sFJ;AkB3xFE;;EAmFE,mBAAA;AlB4sFJ;AkB3sFI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB8sFN;AkB7xFE;EAgEA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlB+tFJ;AkBlyFE;EAuEE,mBAAA;AlB8tFJ;AkB7tFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB+tFN;AkB72FI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBg3FN;AkBv3FI;;;;EAsIA,mBAAA;AlBuvFJ;AkBtvFI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB2vFN;AkB3lFE;;EA/KA,cAAA;EACA,yBAAA;EAEE,uBAAA;AlB6wFJ;AkBjmFE;;EAxKE,mBAAA;AlB6wFJ;AkB5wFI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB+wFN;AkBtmFE;EAxLA,cAAA;EACA,yBAAA;EAEE,uBAAA;AlBgyFJ;AkB3mFE;EAjLE,mBAAA;AlB+xFJ;AkB9xFI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBgyFN;AkB96FI;;;;EA+HF,0BAAA;EACA,yBAAA;EAEE,uBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBi7FN;AkBx7FI;;;;EAsIA,mBAAA;AlBwzFJ;AkBvzFI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB4zFN;AiBx3FE;EC6CA,cAAA;EACA,yBAAA;EAEE,uBAAA;EAkOF,gBAAA;AlB4mFF;AiB93FE;ECoDE,mBAAA;AlB60FJ;AkB50FI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB80FN;AkBz6FE;;EA4EA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlBg2FJ;AkB/6FE;;EAmFE,mBAAA;AlBg2FJ;AkB/1FI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBk2FN;AkBj7FE;EAgEA,cAAA;EACA,qBAAA;EAEE,uBAAA;AlBm3FJ;AkBt7FE;EAuEE,mBAAA;AlBk3FJ;AkBj3FI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBm3FN;AkBjgGI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBogGN;AkB3gGI;;;;EAsIA,mBAAA;AlB24FJ;AkB14FI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB+4FN;AkBxrFE;;EAtOA,cAAA;EACA,yBAAA;EAEE,gCAAA;AlBi6FJ;AkB9rFE;;EA/NE,mBAAA;AlBi6FJ;AkBh6FI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBm6FN;AkBlsFE;EAhPA,cAAA;EACA,yBAAA;EAEE,gCAAA;AlBo7FJ;AkBvsFE;EAzOE,mBAAA;AlBm7FJ;AkBl7FI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBo7FN;AkBlkGI;;;;EA+HF,0BAAA;EACA,yBAAA;EAEE,uBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBqkGN;AkB5kGI;;;;EAsIA,mBAAA;AlB48FJ;AkB38FI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBg9FN;AiBxgGE;EdlGA,WAAA;EeIA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;ED6FE,oBAAA;AjB8gGJ;AkB3tFE;EACE,eAAA;AlB6tFJ;AkB3tFG;Ef1ZD,WAAA;EeIA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AlBqnGF;AkB/tFI;EACE,eAAA;AlBiuFN;AkB9tFG;EfjaD,WAAA;EeIA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AlB+nGF;AkBluFI;EACE,eAAA;AlBouFN;AiBviGE;EAKI,aAAA;EACA,uBAAA;AjBqiGN;AiBjiGE;ECxGA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AlB4oGF;AkB3wFG;EApYD,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AlBkpGF;AkB5wFG;EAzYD,YAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AlBwpGF;AiBjjGK;EACC,WAAA;AjBmjGN;AiB/iGE;ECwTA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AlB0vFF;AkBzvFG;EACC,eAAA;EACA,kBAAA;AlB2vFJ;AkBzvFG;EACC,eAAA;EACA,kBAAA;AlB2vFJ;AiB1jGE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AjB4jGJ;AiBtrGC;EA8HG,iEAAA;AjB2jGJ;AiBvjGK;;EAGG,8BAAA;AjBwjGR;AiBnjGE;EACE,kBAAA;AjBqjGJ;AiBpjGI;EACE,oBAAA;AjBsjGN;AiBnjGI;EACE,cAAA;AjBqjGN;AiBjjGE;EACE,yDAAA;AjBmjGJ;AiBpjGE;EAII,kBAAA;EACA,eAAA;AjBmjGN;AiBxjGE;EAQM,2CAAA;AjBmjGR;AiB/iGI;EAEI,gBAAA;AjBgjGR;AiB3iGE;ECnBA,kBAAA;EACA,oBAAA;AlBikGF;AiB/iGE;;ECfE,kBAAA;AlBkkGJ;AkBjkGI;;;;;;EAGE,UAAA;AlBskGN;AkBpkGI;;EACE,UAAA;AlBukGN;AiB/jGE;ECJE,eAAA;AlBskGJ;AkBnkGG;;EA7KD,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AlBovGF;AkBtkGG;EfrLD,WAAA;EACA,YAAA;EesLE,gBAAA;EACA,eAAA;AlBykGJ;AkBvkGG;;EAtLD,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AlBiwGF;AkB9kGG;;EAIG,eAAA;AlB8kGN;AkB3kGG;EfjMD,WAAA;EACA,YAAA;EekME,gBAAA;EACA,eAAA;AlB8kGJ;AiBhmGE;;;;;;;ECkRE,iBAAA;AlBu1FJ;AiBzmGE;ECqRE,8BAAA;AlBu1FJ;AiB5mGE;ECwRE,gBAAA;AlBu1FJ;AiB/mGE;;EC4RE,cAAA;AlBu1FJ;AiBnnGE;EC+RE,kBAAA;AlBu1FJ;AiBtnGE;ECkSE,kBAAA;AlBu1FJ;AiBznGE;;ECsSE,2BAAA;EACA,8BAAA;AlBu1FJ;AiB9nGE;;EC2SE,4BAAA;EACA,+BAAA;AlBu1FJ;AkBr1FE;EAEI,kBAAA;AlBs1FN;AkBx1FE;EAKI,kBAAA;AlBs1FN;AkB31FE;;EASI,2BAAA;EACA,8BAAA;AlBs1FN;AkBh2FE;;EAcI,4BAAA;EACA,+BAAA;AlBs1FN;AkBn1FE;EACE,WAAA;AlBq1FJ;AkBn1FG;EACC,gBAAA;AlBq1FJ;AkBn1FE;EAEI,kBAAA;EACA,0BAAA;EACA,6BAAA;AlBo1FN;AkBj1FG;EACC,iBAAA;EACA,yBAAA;EACA,4BAAA;AlBm1FJ;AmBjyGK;;;;;;;;;;;;;;EAEC,kBAAA;EACA,iBAAA;AnB+yGN;AmB3yGG;EACC,cAAA;AnB6yGJ;AmBxyGK;;EACC,yBAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;AnB2yGN;AmBryGK;;EACC,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;AnBwyGN;AmBjyGO;;EACC,yBAAA;EACA,4BAAA;EACA,+BAAA;EACA,4BAAA;AnBoyGR;AmB9xGO;;EACC,2BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;AnBiyGR;AiB9sGE;;EAEE,kBAAA;AjBgtGJ;AiB/3GC;;EAqLG,gBAAA;AjB8sGJ;AiB3sGE;EACE,WAAA;EACA,kBAAA;AjB6sGJ;AiB5sGI;;;;EAIE,uBAAA;AjB8sGN;AiB1sGE;EClEA,cAAA;EACA,qBAAA;EAlDA,iBAAA;AlBk0GF;AiB/sGE;EC3DE,mBAAA;AlB6wGJ;AkB5wGI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB8wGN;AkB70GE;;EAgDA,cAAA;EACA,qBAAA;AlBiyGF;AkBl1GE;;EAuDE,mBAAA;AlB+xGJ;AkB9xGI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBiyGN;AkBz0GE;EAyBA,cAAA;EACA,qBAAA;AlBmzGF;AkB70GE;EAgCE,mBAAA;AlBgzGJ;AkB/yGI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBizGN;AkB/7GI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBk8GN;AkBz8GI;;;;EAsIA,mBAAA;AlBy0GJ;AkBx0GI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB60GN;AiBtxGE;ECtEA,cAAA;EACA,qBAAA;EAlDA,iBAAA;AlBk5GF;AiB3xGE;EC/DE,mBAAA;AlB61GJ;AkB51GI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB81GN;AkB75GE;;EAgDA,cAAA;EACA,qBAAA;AlBi3GF;AkBl6GE;;EAuDE,mBAAA;AlB+2GJ;AkB92GI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBi3GN;AkBz5GE;EAyBA,cAAA;EACA,qBAAA;AlBm4GF;AkB75GE;EAgCE,mBAAA;AlBg4GJ;AkB/3GI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBi4GN;AkB/gHI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBkhHN;AkBzhHI;;;;EAsIA,mBAAA;AlBy5GJ;AkBx5GI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB65GN;AiBl2GE;EC1EA,cAAA;EACA,qBAAA;EAlDA,iBAAA;AlBk+GF;AiBv2GE;ECnEE,mBAAA;AlB66GJ;AkB56GI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB86GN;AkB7+GE;;EAgDA,cAAA;EACA,qBAAA;AlBi8GF;AkBl/GE;;EAuDE,mBAAA;AlB+7GJ;AkB97GI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBi8GN;AkBz+GE;EAyBA,cAAA;EACA,qBAAA;AlBm9GF;AkB7+GE;EAgCE,mBAAA;AlBg9GJ;AkB/8GI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBi9GN;AkB/lHI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBkmHN;AkBzmHI;;;;EAsIA,mBAAA;AlBy+GJ;AkBx+GI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB6+GN;AiB96GE;EC9EA,cAAA;EACA,yBAAA;EAlDA,iBAAA;AlBkjHF;AiBn7GE;ECvEE,mBAAA;AlB6/GJ;AkB5/GI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB8/GN;AkB7jHE;;EAgDA,cAAA;EACA,yBAAA;AlBihHF;AkBlkHE;;EAuDE,mBAAA;AlB+gHJ;AkB9gHI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBihHN;AkBzjHE;EAyBA,cAAA;EACA,yBAAA;AlBmiHF;AkB7jHE;EAgCE,mBAAA;AlBgiHJ;AkB/hHI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBiiHN;AkB/qHI;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBkrHN;AkBzrHI;;;;EAsIA,mBAAA;AlByjHJ;AkBxjHI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB6jHN;AiB1/GE;EACE,sBAAA;AjB4/GJ;AiBz/GE;EACE,qBAAA;EACA,sBAAA;AjB2/GJ;AiBx/GE;EACE,WAAA;AjB0/GJ;AiBr/GE;EACE,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;AjBu/GJ;AiBn/GC;EAKC,8BAAA;EACA,iBAAA;AjBi/GF;AiB/+GE;EACE,iBAAA;AjBi/GJ;AiB/+GE;EACE,iBAAA;AjBi/GJ;AmBnvHE;EACE,cAAA;AnBqvHJ;AmB/uHO;;EACC,2BAAA;EACA,0BAAA;AnBkvHR;AmB/uHS;;EACC,2BAAA;EACA,0BAAA;AnBkvHV;AmB1uHO;EACC,gBAAA;EACA,iBAAA;AnB4uHR;AmBxuHI;EAEI,gBAAA;EACA,eAAA;AnByuHR;AmBluHK;;EACC,iBAAA;EACA,cAAA;AnBquHN;AoBxwHA;EAEI,eAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;ApBywHJ;AoBvwHI;EACE,wBAAA;ApBywHN;AoBtwHI;EACE,0BAAA;ApBwwHN;AoBrwHI;EACE,WAAA;ApBuwHN;AoBpwHI;EACE,gDAAA;ApBswHN;AoB9vHM;;;;;;;;;;EAUE,gBAAA;ApBgwHR;AoB5vHI;;;EAGE,2EAAA;EAEA,iBAAA;ApB6vHN;AoB3vHM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAUE,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;ApBixHR;AoB7wHI;EACE,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,eAAA;ApB+wHN;AoB5wHI;EACE,cAAA;EACA,yBAAA;EACA,0BAAA;EACA,gBAAA;ApB8wHN;AoB5wHM;;;EAGE,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,mDAAA;EACA,qDAAA;EACA,wDAAA;EACA,gDAAA;ApB8wHR;AoB1wHI;EACE,cAAA;EACA,uBAAA;EACA,yBAAA;ApB4wHN;AoBzwHI;EACE,uBAAA;EACA,yBAAA;EACA,yBAAA;ApB2wHN;AoBzwHM;;;EAGE,YAAA;EACA,yBAAA;ApB2wHR;AoBvwHI;;EAEE,uBAAA;EACA,yBAAA;EACA,yBAAA;ApBywHN;AoBvwHM;;;;;;EAGE,YAAA;EACA,yBAAA;ApB4wHR;AoBzwHM;;;;EAEE,yBAAA;ApB6wHR;AoBzwHI;EACE,eAAA;ApB2wHN;AoBxwHI;EACE,cAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;ApB0wHN;AoBxwHM;;;EAGE,yBAAA;ApB0wHR;AoBtwHI;EACE,iBAAA;ApBwwHN;AoBrwHI;EACE,cAAA;EACA,uBAAA;ApBuwHN;AoBtwHM;;EAEE,yBAAA;ApBwwHR;AoBtwHM;;EAEE,yBAAA;ApBwwHR;AoBpwHI;EACE,YAAA;ApBswHN;AoBnwHI;EACE,YAAA;ApBqwHN;AoBlwHI;EACE,2BAAA;EACA,wBAAA;EACA,mBAAA;ApBowHN;AoBjwHI;EACE,UAAA;ApBmwHN;AoBhwHI;EACE,gBAAA;ApBkwHN;AoBh8HA;EAmMI,wDAAA;EACA,qDAAA;EACA,gDAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;ApBgwHJ;AoBx8HA;EA2MM,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;ApBgwHN;AoB9vHM;EACE,yBAAA;ApBgwHR;AoBn9HA;EAwNM,oCAAA;EACA,UAAA;ApB8vHN;AoBv9HA;EA6NM,iBAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;ApB6vHN;AoBvvHE;;EF9FA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlBw1HJ;AoB7vHE;;EFvFE,mBAAA;AlBw1HJ;AkBv1HI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB01HN;AoBtwHE;;EFnGA,cAAA;EACA,qBAAA;EAEE,gBAAA;AlB42HJ;AoB5wHE;;EF5FE,mBAAA;AlB42HJ;AkB32HI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlB82HN;AoB3wHE;EFlHA,YAAA;EACA,qBAAA;EAEE,mBAAA;EAnHF,yCAAA;EACA,wCAAA;EEmOE,gDAAA;ApBixHJ;AoBnxHE;EF3GE,mBAAA;AlBi4HJ;AkBh4HI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBk4HN;AkB9/HE;;EA6GA,YAAA;EACA,qBAAA;EAEE,mBAAA;AlBo5HJ;AkBpgIE;;EAoHE,mBAAA;AlBo5HJ;AkBn5HI;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBs5HN;AkBpgIE;EA+FA,YAAA;EACA,qBAAA;EAEE,mBAAA;AlBu6HJ;AkBzgIE;EAsGE,mBAAA;AlBs6HJ;AkBr6HI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBu6HN;AkBrjII;;;;EA+HF,0BAAA;EACA,qBAAA;EAEE,mBAAA;EA5HE,iBAAA;EACA,gBAAA;AlBwjIN;AkB/jII;;;;EAsIA,mBAAA;AlB+7HJ;AkB97HI;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,uBAAA;EACA,WAAA;AlBm8HN;AoBr1HE;EACE,qBAAA;ApBu1HJ;AoBn1HA;EACE,YAAA;EACA,SAAA;ApBq1HF;AoBp1HE;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;ApBs1HJ;AoBn1HE;EACE,qBAAA;EACA,kBAAA;ApBq1HJ;AoBl1HE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EAUA,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,gCAAA;ApB20HJ;AoBz1HI;EACE,UAAA;ApB21HN;AoBx1HI;EACE,cAAA;ApB01HN;AoB90HE;EACE,0BAAA;EACA,2BAAA;EA4BA,uBAAA;EACA,cAAA;EACA,gBAAA;ApBqzHJ;AoBj1HI;;;EAGE,+BAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,aAAA;ApBm1HN;AoBh1HI;EACE,uBAAA;EACA,oCAAA;ApBk1HN;AoB/0HI;EACE,uCAAA;EACA,0CAAA;ApBi1HN;AoB90HI;EACE,wCAAA;EACA,2CAAA;ApBg1HN;AoBv0HA;EAEI,SAAA;ApBw0HJ;AoBp0HA;EACE,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2BAAA;ApBs0HF;AoBp0HE;EACE,YAAA;EACA,yBAAA;ApBs0HJ;AqB3qIA;EACE,6BAAA;EACA,iBAAA;EACA,iBAAA;ArB6qIF;AqB1qIA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;ArB4qIF;AqBzqIA;EAEI,cAAA;ArB0qIJ;AqBnqIE;;;EAEI,iBAAA;ArBsqIN;AqB3qIA;;;EAUI,mBAAA;ArBsqIJ;AqBhrIA;;;EAcI,cAAA;EACA,mBAAA;ArBuqIJ;AqBtrIA;;;EAmBI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;ArBwqIJ;AqBtqII;;;;;;;;;EAGE,gCAAA;EACA,2BAAA;ArB8qIN;AqB3qII;;;EACE,cAAA;EACA,mBAAA;ArB+qIN;AqB1qIA;EAEI,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;ArB2qIJ;AsBpvIA;EAEI,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AtBqvIJ;AsB1vIA;EAQM,kCAAA;AtBqvIN;AsB7vIA;EAYM,wCAAA;EACA,QAAA;AtBovIN;AsBjwIA;EAiBM,oBAAA;EACA,yBAAA;EACA,YAAA;AtBmvIN;AsBjvIM;;;EAGE,2BAAA;AtBmvIR;AsB3wIA;EA6BM,cAAA;AtBivIN;AsB9wIA;EAiCM,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;AtBgvIN;AsBxxIA;EA4CM,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AtB+uIN;AsBhyIA;EAqDM,aAAA;AtB8uIN;AsBnyIA;EAgEI,gBAAA;EACA,kBAAA;AtBsuIJ;AsB7uII;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;AtB+uIN;AsBzuII;;EAEE,cAAA;EACA,qBAAA;EACA,UAAA;EACA,wDAAA;AtB2uIN;AsBvuII;EAME,6BAAA;AtBouIN;AsBvuIM;EACE,6BAAA;AtByuIR;AsBpuII;;EAEE,mBAAA;EACA,cAAA;AtBsuIN;AsBnuII;;EAEE,qBAAA;AtBquIN;AsBl0IA;EAkGM,qBAAA;EACA,UAAA;EACA,8CAAA;AtBmuIN;AsBjuIM;;EAEE,qBAAA;EACA,UAAA;EACA,8CAAA;AtBmuIR;AsB70IA;EAiHI,kBAAA;EACA,qBAAA;AtB+tIJ;AsBj1IA;EAsHI,cAAA;AtB8tIJ;AsBp1IA;EA0HI,qBAAA;AtB6tIJ;AsBv1IA;EA8HI,aAAA;AtB4tIJ;AsB11IA;EAkII,qBAAA;AtB2tIJ;AsB71IA;EAsII,qBAAA;AtB0tIJ;AsBxtII;EACE,yBAAA;AtB0tIN;AsBn2IA;EA8II,mCAAA;EACA,gCAAA;EACA,2BAAA;AtBwtIJ;AsBx2IA;EAoJI,yBAAA;EACA,eAAA;EACA,gBAAA;AtButIJ;AsB72IA;;EA2JI,+FAAA;EACA,cAAA;AtBstIJ;AsBltII;EACE,kBAAA;EACA,kBAAA;AtBotIN;AsBltIM;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AtBotIR;AsBhtII;EAEI,wBAAA;AtBitIR;AsB3sIA;;EAEE,YAAA;AtB6sIF;AsB5sIE;;EACE,cAAA;AtB+sIJ;AsBzsIA;EACE,cAAA;AtB2sIF;AsBzsIA;EACE,gBAAA;AtB2sIF;AsBxsIA;EACE,kCAAA;AtB0sIF;AsBvsIA;EACE,uBAAA;AtBysIF;AsBvsIA;EACE,kBAAA;AtBysIF;AsBvsIA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AtBysIF;AsBvsIE;EACE,yBAAA;AtBysIJ;AsBvsII;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;AtBysIN;AsBnsIE;EACE,cAAA;AtBqsIJ;AsBhsIE;EACE,cAAA;AtBksIJ;AuBn7IA;EAEI,6CAAA;EACA,kBAAA;EACA,gBAAA;AvBo7IJ;AuBl7II;EACE,yBAAA;AvBo7IN;AuBl7IM;EACE,SAAA;AvBo7IR;AuBx7II;EAQI,eAAA;AvBm7IR;AuB37II;EAYI,UAAA;AvBk7IR;AuB96II;EAEI,UAAA;AvB+6IR;AuB36II;EAEI,aAAA;AvB46IR;AuB18IA;EAmCM,eAAA;EACA,gBAAA;EACA,cAAA;AvB06IN;AuB/8IA;EAyCM,gBAAA;EACA,SAAA;AvBy6IN;AuBn9IA;EA8CM,kBAAA;AvBw6IN;AuBv6IM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,4BAAA;AvBy6IR;AuBt6IM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AvBw6IR;AuBp6II;EACE,iBAAA;EACA,oBAAA;AvBs6IN;AuBp6II;EACE,4BAAA;AvBs6IN;AuBp6II;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AvBs6IN;AuBp/IA;EAmFI,mBAAA;AvBo6IJ;AuBv/IA;EAuFI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AvBm6IJ;AuB9/IA;EA+FI,eAAA;EACA,gBAAA;AvBk6IJ;AuBlgJA;EAoGI,aAAA;AvBi6IJ;AuBrgJA;EAwGI,iBAAA;AvBg6IJ;AuBxgJA;EA4GI,6BAAA;EACA,eAAA;EACA,yBAAA;AvB+5IJ;AuB7gJA;EAkHI,mBAAA;AvB85IJ;AuBhhJA;EAsHI,eAAA;AvB65IJ;AuBnhJA;EA0HI,oBAAA;AvB45IJ;AuBthJA;EA8HI,eAAA;EACA,eAAA;EACA,eAAA;AvB25IJ;AuB3hJA;EAoII,eAAA;AvB05IJ;AuB9hJA;EAwII,eAAA;EACA,cAAA;AvBy5IJ;AuBliJA;EA6II,aAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AvBw5IJ;AuBxiJA;EAoJI,cAAA;AvBu5IJ;AuB3iJA;EAwJI,qBAAA;AvBs5IJ;AuB9iJA;EA4JI,cAAA;AvBq5IJ;AuBjjJA;EAgKI,aAAA;AvBo5IJ;AuBpjJA;EAoKI,yBAAA;AvBm5IJ;AuBvjJA;EAwKI,oCAAA;AvBk5IJ;AuB1jJA;EA4KI,qBAAA;EACA,kBAAA;EACA,aAAA;AvBi5IJ;AuB74IA;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;AvB+4IF;AuB74IE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AvB+4IJ;AuB34IA;EACE,oBAAA;AvB64IF;AuB14IA;EAEE,qBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AvB24IF;AuBx4IA;EACE,oBAAA;AvB04IF;AuBv4IA;EAME,SAAA;AvBo4IF;AuBj4IA;EACE,yBAAA;AvBm4IF;AuBh4IA;EAME,4BAAA;EACA,+BAAA;AvB63IF;AuB13IA;EACE,kBAAA;AvB43IF;AuBz3IA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;AvB23IF;AuBx3IA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;AvB03IF;AuBv3IA;EACE,kBAAA;AvBy3IF;AuBt3IA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;AvBw3IF;AwBjpJC;ECFC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EDHA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AxB0pJF;AwBxpJE;EACE,OAAA;EACA,YAAA;AxB0pJJ;AwBvpJE;EACE,iBAAA;AxBypJJ;AwBtpJE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AxBwpJJ;AwBrpJE;EACE,yBAAA;EACA,yBAAA;AxBupJJ;AwBzpJE;EAII,cAAA;AxBwpJN;AwBppJE;EACE,yBAAA;EACA,yBAAA;AxBspJJ;AwBxpJE;EAII,cAAA;AxBupJN;AwBnpJE;EACE,yBAAA;EACA,yBAAA;AxBqpJJ;AwBvpJE;EAII,cAAA;AxBspJN;AwBlpJE;EACE,yBAAA;EACA,yBAAA;AxBopJJ;AwBtpJE;EAKI,cAAA;AxBopJN;AwBzpJE;EASI,SAAA;EACA,UAAA;AxBmpJN;AwB/oJE;EACE,gBAAA;AxBipJJ;AwB9oJE;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AxBgpJJ;AwBzpJE;EAYI,0BAAA;EACA,sBAAA;AxBgpJN;AwB/oJM;EACE,0BAAA;AxBipJR;AwB5oJE;EACE,0BAAA;EACA,sBAAA;AxB8oJJ;AwB7oJI;EACE,0BAAA;AxB+oJN;AwB3oJE;EACE,uBAAA;EACA,4BAAA;AxB6oJJ;AwB1oJE;EACE,kBAAA;AxB4oJJ;AwBzoJE;EACE,kBAAA;EACA,eAAA;AxB2oJJ;AwBzoJE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AxB2oJJ;AwBxoJE;EACE,cAAA;AxB0oJJ;AwBvoJE;EACE,cAAA;AxByoJJ;AwBtoJE;EACE,gBAAA;EACA,UAAA;EACA,6RAAA;AxBwoJJ;AwBnoJE;EACE,aAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AxBqoJJ;AwBloJE;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;AxBooJJ;A0BtxJE;EACE,cAAA;A1BwxJJ;A0BpxJK;EACC,iBAAA;A1BsxJN;A0BjxJK;EACC,kBAAA;EACA,gBAAA;A1BmxJN;A0B9wJK;EACC,iBAAA;EACA,iBAAA;A1BgxJN;A0B3wJK;EACC,iBAAA;EACA,iBAAA;A1B6wJN;A0BxwJK;EACC,kBAAA;EACA,iBAAA;A1B0wJN;A2B3yJA;EAEI,yBAAA;EACA,mBAAA;A3B4yJJ;A2BzyJI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;A3B2yJN;A2BxyJI;EACE,yBAAA;A3B0yJN;A2B3yJI;;EAII,cAAA;A3B2yJR;A2BzyJM;EACE,yBAAA;A3B2yJR;A2BvyJI;EACE,yBAAA;EACA,yBAAA;A3ByyJN;A2B3yJI;;;EAMI,cAAA;A3B0yJR;A2BxyJM;EACE,yBAAA;A3B0yJR;A2BtyJI;EACE,yBAAA;EACA,yBAAA;A3BwyJN;A2B1yJI;;;EAMI,cAAA;A3ByyJR;A2BvyJM;EACE,yBAAA;A3ByyJR;A2BryJI;EACE,yBAAA;EACA,yBAAA;A3BuyJN;A2BzyJI;;;EAMI,cAAA;A3BwyJR;A2BtyJM;EACE,yBAAA;A3BwyJR;A2BpyJI;EACE,yBAAA;EACA,yBAAA;A3BsyJN;A2BxyJI;;;EAMI,cAAA;A3BuyJR;A2BryJM;EACE,yBAAA;A3BuyJR;A2BnyJI;EAEI,cAAA;EACA,iBAAA;A3BoyJR;A2BhyJI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A3BkyJN;A2BhyJI;EACE,gBAAA;A3BkyJN;A2BhyJI;EACE,aAAA;A3BkyJN;A2B/xJM;EACE,aAAA;A3BiyJR;A2B7xJI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;A3B+xJN;A2BpyJI;EAQI,iBAAA;A3B+xJR;A2BvyJI;EAYI,eAAA;EACA,iBAAA;A3B8xJR;A2B1xJI;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;A3B4xJN;A2BnyJI;EAUI,iBAAA;EACA,cAAA;EACA,eAAA;A3B4xJR;A2Bj6JA;EA2II,gBAAA;EACA,SAAA;EACA,gBAAA;A3ByxJJ;A2BxxJI;EACE,aAAA;A3B0xJN;A4Br6JC;EHHC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AzB26JF;A4Bh7JC;;EAKG,SAAA;EACA,UAAA;EACA,gBAAA;A5B+6JJ;A4B56JE;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;A5B86JJ;A4B36JE;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;A5B66JJ;A4B16JE;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,+FAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A5B46JJ;A4B37JE;EAkBI,cAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;A5B46JN;A4B16JM;EACE,qBAAA;A5B46JR;A4Bx6JI;;EAEE,qBAAA;EACA,oBAAA;A5B06JN;A4B76JI;;EAKI,cAAA;A5B46JR;A4Bx6JI;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;A5B06JN;A4B76JI;EAMI,cAAA;A5B06JR;A4Bv6JM;;EAEE,qBAAA;A5By6JR;A4Bt6JM;;EAEE,cAAA;A5Bw6JR;A4Bn6JE;;EAEE,UAAA;A5Bq6JJ;A4Bv6JE;;EAII,kBAAA;A5Bu6JN;A4B36JE;;EAOM,cAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;EACA,oBAAA;A5Bw6JR;A4Bv6JQ;;EACE,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;A5B06JV;A4B37JE;;EAsBM,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,YAAA;EACA,0BAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;A5By6JR;A4Br6JI;;;;EAGI,UAAA;A5Bw6JR;A4B36JI;;;;EAMI,UAAA;A5B26JR;A4Bt6JE;;;EAGE,iBAAA;A5Bw6JJ;A4Bt6JE;;;;EAIE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,+FAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;A5Bw6JJ;A4Br6JE;;EAEE,yCAAA;EACA,UAAA;A5Bu6JJ;A4B16JE;;EAMI,cAAA;EACA,eAAA;EACA,iBAAA;A5Bw6JN;A4Br6JI;;EACE,qBAAA;A5Bw6JN;A4Bp7JE;;EAgBI,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;A5Bw6JN;A4Br6JK;;;;EAEC,cAAA;EACA,qBAAA;A5By6JN;A4Bp6JI;;;EAGE,mBAAA;A5Bs6JN;A4Bz6JI;;;EAKI,0BAAA;EACA,qBAAA;EACA,mBAAA;A5By6JR;A4Bp6JE;EACE,oBAAA;A5Bs6JJ;A4Bn6JE;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;A5Bq6JJ;A4Bl6JI;EAAA;;IAGI,mBAAA;E5Bo6JN;AACF;A4Bj6JK;EACC,qBAAA;EACA,WAAA;A5Bm6JN;A4Bh6JI;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;A5Bk6JN;A4Bv6JI;ECzLF,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;EDuLM,WAAA;EACA,YAAA;EACA,aAAA;A5B66JR;A8B/pKE;EACE,UAAA;A9BiqKJ;A8B9pKE;EACE,cAAA;A9BgqKJ;A8B7pKE;EACE,uBAAA;A9B+pKJ;A6B5mKE;EAlCA,qBAAA;EACA,kCAAA;A7BipKF;A6B5mKE;;EA/CE,qBAAA;EAEF,kCAAA;EACA,UAAA;EACA,6CAAA;A7B8pKF;A6B9mKE;EAtCA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;A7BupKF;A6BrpKE;EAZA,qBAAA;EACA,kCAAA;A7BoqKF;A6BtnKE;EA1CA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;A7BmqKF;A6BjqKE;EAZA,qBAAA;EACA,kCAAA;A7BgrKF;A6B7nKI;;;;;;EAME,6BAAA;EACA,YAAA;EACA,gBAAA;A7B+nKN;A6B1nKE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;A7B4nKJ;A6BxnKE;EAnGA,iBAAA;EACA,eAAA;A7B8tKF;A6BxnKE;EAlGA,gBAAA;A7B6tKF;A4B7+JE;;EAEE,YAAA;EACA,iBAAA;EACA,mBAAA;A5B++JJ;A4Bn/JE;;EAMI,YAAA;EACA,6BAAA;EACA,SAAA;A5Bi/JN;A4Bh/JM;;EACE,YAAA;EACA,iBAAA;A5Bm/JR;A4B9+JE;EACE,qBAAA;EACA,YAAA;EACA,iBAAA;A5Bg/JJ;A4Bn/JE;EAMI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;A5Bg/JN;A4B9+JM;EACE,qBAAA;A5Bg/JR;A4B7+JM;EACE,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;A5B++JR;A4B1+JE;;EAEE,YAAA;EACA,iBAAA;A5B4+JJ;A4Bz+JE;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;A5B2+JJ;A4Bx+JE;EACE,uBAAA;EACA,yBAAA;A5B0+JJ;A4Bv+JE;;EAEE,eAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;A5By+JJ;A4Bt+JE;;EAEE,uBAAA;EACA,yBAAA;A5Bw+JJ;A4Bv+JI;;EACE,YAAA;EACA,iBAAA;A5B0+JN;A4Bt+JE;;EAEE,YAAA;EACA,eAAA;EACA,iBAAA;A5Bw+JJ;A4Br+JE;EACE,gBAAA;A5Bu+JJ;A4Br+JI;EACE,QAAA;A5Bu+JN;A4Bp+JI;EACE,YAAA;EACA,iBAAA;A5Bs+JN;A4Bx+JI;EChVF,gBAAA;EDuVM,WAAA;EACA,YAAA;A5Bq+JR;A4B/9JE;EACE,mBAAA;A5Bi+JJ;A4Bl+JE;EAII,mBAAA;EACA,qBAAA;EACA,mBAAA;A5Bi+JN;A4Bv+JE;EASM,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;A5Bi+JR;A4B99JM;EACE,mBAAA;A5Bg+JR;A4Bj+JM;EAGI,0BAAA;A5Bi+JV;A4Bn/JE;EAwBI,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;A5B89JN;A4B79JO;EACC,uBAAA;A5B+9JR;A4B5/JE;EAkCI,UAAA;A5B69JN;A4B//JE;EAsCI,UAAA;A5B49JN;A4BlgKE;EA0CI,0BAAA;A5B29JN;A4Bt9JA;EAEI;;IAEE,aAAA;E5Bu9JJ;AACF;A4Bn9JA;EACG;IACC,aAAA;E5Bq9JF;AACF;A+Bp3KC;EAEG,eAAA;EACA,gBAAA;A/Bq3KJ;A+Bx3KC;;;;EAUG,eAAA;EACA,gBAAA;A/Bo3KJ;A+B/3KC;EAeG,oBAAA;A/Bm3KJ;A+Bl4KC;EAmBG,kBAAA;EACA,cAAA;A/Bk3KJ;A+Bt4KC;EAuBK,eAAA;EACA,gBAAA;A/Bk3KN;A+B14KC;EA4BK,cAAA;A/Bi3KN;A+B72KG;EAEG,eAAA;EACA,gBAAA;A/B82KN;A+Bj3KG;EAMK,eAAA;EACA,gBAAA;A/B82KR;A+Bz2KG;EACC,iBAAA;EACA,cAAA;A/B22KJ;AgC15KI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AhC45KN;AgCx5KM;EACE,yBAAA;AhC05KR;AgC35KM;EAII,cAAA;AhC05KV;AgCv5KQ;;EAGI,cAAA;AhCw5KZ;AgC76KA;EA4BM,kBAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;AhCo5KN;AiCn7KG;EACC,eAAA;AjCq7KJ;AiCt7KG;;;;;;EASG,iBAAA;AjCq7KN;AiC97KG;EAaG,kBAAA;AjCo7KN;AiCj8KG;EAiBG,kBAAA;AjCm7KN;AiCp8KG;EAwBO,6BAAA;AjC+6KV;AiCv8KG;EACC,eAAA;AjCy8KJ;AiC18KG;;;;;;EASG,gBAAA;AjCy8KN;AiCl9KG;EAaG,kBAAA;AjCw8KN;AiCr9KG;EAiBG,iBAAA;AjCu8KN;AiCx9KG;EAwBO,2BAAA;AjCm8KV;AiCj7KC;EAEG,yBAAA;AjCk7KJ;AiCp7KC;EAKG,WAAA;EACA,eAAA;AjCk7KJ;AkCh+KC;EAGG,yBAAA;EACA,gBAAA;AlCg+KJ;AkCp+KC;EASG,8BAAA;AlC89KJ;AkCv+KC;;;;;;;;;;;;;;;;EAqBS,+BAAA;AlCo+KV;AkCz/KC;;;;EA0BW,gCAAA;AlCq+KZ;AkCj+KY;;;;EACE,wCAAA;AlCs+Kd;AkCrgLC;;;;;;;;;;;;EAyCW,+BAAA;AlC0+KZ;AkCnhLC;;;;EAiDS,mBAAA;AlCw+KV;AkCt+KU;;;;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,+BAAA;EACA,WAAA;AlC2+KZ;AkCpiLC;;EAkEO,6BAAA;AlCs+KR;AkCj+KG;;EAMS,eAAA;AlC+9KZ;AkCv9KG;;EAMS,kBAAA;AlCq9KZ;AkC98KG;;EAMS,iBAAA;AlC48KZ;AkCpjLC;EAiHG,yBAAA;EACA,aAAA;AlCs8KJ;AkCl8KC;EAIG,aAAA;AlCi8KJ;AkC97KE;EACE,+BAAA;AlCg8KJ;AmCtjLC;EACC,WAAA;EACA,eAAA;AnCwjLF;AInkLE;EACE,cAAA;EACA,WAAA;AJqkLJ;AInkLE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJokLJ;AI5kLE;EACE,cAAA;EACA,WAAA;AJ8kLJ;AI5kLE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJ6kLJ;AmCtkLC;EVhBC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EAEA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EUUA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AnC+kLF;AmCplLC;EASG,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;AnC8kLJ;AmC1kLE;;;;EAIE,kBAAA;EACA,kBAAA;EACA,yBAAA;AnC4kLJ;AmCzkLE;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AnC2kLJ;AmCxkLK;;EAEC,iBAAA;AnC0kLN;AmC5kLK;;EAKG,cAAA;EACA,gBAAA;EACA,uBAAA;AnC2kLR;AmCzlLE;EAmBI,gBAAA;EACA,uBAAA;EACA,oBAAA;AnCykLN;AmCpkLE;EACE,kBAAA;AnCskLJ;AmClkLE;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AnCokLJ;AmChkLE;EAGM,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gCAAA;AnCgkLR;AmC9jLQ;EACE,kBAAA;AnCgkLV;AmC7jLQ;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,qCAAA;EACA,2BAAA;EACA,iCAAA;EACA,WAAA;AnC+jLV;AmCzjLM;EACE,gBAAA;AnC2jLR;AmCrjLE;EAGM,gCAAA;EACA,2BAAA;AnCqjLR;AmCzjLE;;EAUU,8BAAA;AnCmjLZ;AmChjLY;;EACE,gBAAA;AnCmjLd;AmCjjLc;;;;EAEE,gBAAA;AnCqjLhB;AmC9iLO;EAEG,mBAAA;AnC+iLV;AmC3iLO;EAEG,mBAAA;EACA,iCAAA;AnC4iLV;AmCziLQ;EAEI,mBAAA;AnC0iLZ;AmCliLE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AnCoiLJ;AmCliLI;EACE,4BAAA;AnCoiLN;AmC1iLE;;EAYM,gCAAA;AnCkiLR;AmC5hLG;EACC,cAAA;AnC8hLJ;AmC3hLE;EACE,aAAA;EACA,eAAA;EACA,YAAA;AnC6hLJ;AmChiLE;EAMI,UAAA;AnC6hLN;AmC1hLI;EACE,2BAAA;AnC4hLN;AmCzhLI;EACE,uBAAA;AnC2hLN;AmCxhLI;EACE,yBAAA;AnC0hLN;AmCjhLG;EACC,eAAA;EACA,oBAAA;AnCmhLJ;AmCjhLI;EACE,+BAAA;AnCmhLN;AmCjhLM;EACE,wCAAA;AnCmhLR;AmC9gLK;;EAEC,mBAAA;AnCghLN;AmC5gLG;EACC,mBAAA;AnC8gLJ;AmC5gLI;EACE,wCAAA;AnC8gLN;AmC1gLE;EACE,mBAAA;AnC4gLJ;AmCzgLE;EACE,kBAAA;EACA,UAAA;EACA,OAAA;AnC2gLJ;AmCxgLE;EACE,aAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;AnC0gLJ;AmCxgLI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AnC0gLN;AmCtgLE;EACE,cAAA;EACA,YAAA;EACA,sBAAA;AnCwgLJ;AmCtgLI;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;AnCwgLN;AmCrgLI;;EAEE,eAAA;AnCugLN;AmCrgLM;;EACE,cAAA;AnCwgLR;AmCpgLI;EACE,kBAAA;AnCsgLN;AmClgLE;EACE,cAAA;AnCogLJ;AmChgLE;EACE,aAAA;EACA,8BAAA;AnCkgLJ;AmC//KE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AnCigLJ;AmC//KI;EACE,0BAAA;EACA,+BAAA;AnCigLN;AmC9/KI;EACE,cAAA;AnCggLN;AmC3/KE;EVtUA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EU2UE,gBAAA;EACA,sBAAA;EAEA,kBAAA;EACA,oHAAA;AnCy/KJ;AmC1gLE;EAOI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AnCsgLN;AmC7/KI;EACE,+BAAA;EACA,kBAAA;EACA,gBAAA;AnC+/KN;AmC3/KI;;EAGI,iBAAA;AnC4/KR;AmCv/KI;EACE,aAAA;EACA,8BAAA;EACA,wBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;AnCy/KN;AmCp/KE;EACE,WAAA;AnCs/KJ;AmCn/KE;EACE,WAAA;AnCq/KJ;AmCl/KE;;EAEE,kBAAA;EACA,iBAAA;EACA,kBAAA;AnCo/KJ;AmCx/KE;;EAOI,eAAA;AnCq/KN;AmCj/KE;EACE,wCAAA;AnCm/KJ;AmCh/KE;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCk/KJ;AmCh/KI;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,yBAAA;AnCk/KN;AmCz/KI;EAUI,cAAA;EACA,eAAA;AnCk/KR;AmCh/KQ;EACE,cAAA;AnCk/KV;AmC3+KE;EACE,WAAA;AnC6+KJ;AmC1+KE;EACE,kBAAA;AnC4+KJ;AmCz+KE;EACE,WAAA;EACA,WAAA;AnC2+KJ;AmCx+KE;ECjbA,cAAA;EACA,qBAAA;EAEA,eAAA;EACA,sBAAA;ED+aE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;EACA,oBAAA;EACA,iBAAA;AnC4+KJ;AoCz6LE;;EAEE,cAAA;ApC26LJ;AoCx6LE;EACE,cAAA;ApC06LJ;AmC/+KI;;;EAGE,0BAAA;AnCi/KN;AmC9+KI;;EAEE,kBAAA;EACA,wBAAA;EACA,mCAAA;EACA,WAAA;AnCg/KN;AmC7+KI;EACE,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AnC++KN;AmC5+KI;EACE,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;AnC8+KN;AmC1+KI;EACE,0BAAA;AnC4+KN;AmC1+KI;EACE,uBAAA;AnC4+KN;AmCz+KI;EAME,uBAAA;EACA,SAAA;EACA,kBAAA;AnCs+KN;AmC7+KM;;EAEE,aAAA;EACA,aAAA;AnC++KR;AmCx+KK;EACC,kBAAA;EAEA,iBAAA;AnCy+KN;AmCp+KI;;EAGI,mBAAA;AnCq+KR;AmCz+KE;EAUI,aAAA;AnCk+KN;AmC5+KE;EAaM,UAAA;EACA,WAAA;AnCk+KR;AmC99LC;EAmgBG,kBAAA;EACA,mBAAA;EACA,kBAAA;AnC89KJ;AmC19KE;EACE,kBAAA;AnC49KJ;AmC39KK;EACC,0BAAA;AnC69KN;AmC39KI;EAEI,gBAAA;AnC49KR;AmCt9KE;;EAEE,mCAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;AnCw9KJ;AmCr9KE;;EAEE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AnCu9KJ;AmCp9KE;;EAEE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AnCs9KJ;AmCl9KI;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AnCo9KN;AmCj9KI;EACE,OAAA;AnCm9KN;AmCj9KI;EACE,QAAA;AnCm9KN;AmC98KK;EACC,kBAAA;AnCg9KN;AmC98KM;EACE,qDAAA;AnCg9KR;AmCr9KE;;EAWI,qDAAA;AnC88KN;AmCz9KE;EAeI,wCAAA;AnC68KN;AmCx8KK;EACC,kBAAA;AnC08KN;AmCx8KM;EACE,sDAAA;AnC08KR;AmC/8KE;;EAWI,sDAAA;AnCw8KN;AmCp8KI;EACE,gBAAA;EACA,UAAA;EACA,gBAAA;AnCs8KN;AmCn8KI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AnCq8KN;AmCp8KM;EACE,+BAAA;AnCs8KR;AmCp8KM;EACE,WAAA;EACA,qCAAA;EACA,kBAAA;AnCs8KR;AmCr8KQ;EACE,oCAAA;AnCu8KV;AmCr8KQ;EACE,oCAAA;AnCu8KV;AmCh8KA;EAEI;IAEI,2BAAA;EnCg8KN;EmC77KE;IAEI,2BAAA;EnC87KN;AACF;AqCxmMC;ErC0mMC,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AqC3mME;EACE,0BAAA;ArC6mMJ;AqC1mME;EACE,yBAAA;EACA,0BAAA;ArC4mMJ;AqC9mME;EAMM,gBAAA;ArC2mMR;AqCjnME;EAUM,gBAAA;ArC0mMR;AqCpmME;EACE,2BAAA;EACA,4BAAA;ArCsmMJ;AqCxmME;EAMM,2BAAA;ArCqmMR;AqC3mME;EAUM,4BAAA;ArComMR;AqC9lME;EACE,0BAAA;ArCgmMJ;AsCloME;EACE,cAAA;AtCooMJ;AsC/nME;EACE,cAAA;AtCioMJ;AsC7nMK;EACC,iBAAA;AtC+nMN;AsCtnMW;EACC,kBAAA;AtCwnMZ;AsCpnMS;EACC,iBAAA;AtCsnMV;AsC/mME;EAKQ,8BAAA;AtC6mMV;AsCpmMO;EACC,yBAAA;AtCsmMR;AsCjmMO;EACC,2BAAA;AtCmmMR;AsCxlMK;EACC,iBAAA;EACA,cAAA;AtC0lMN;AsCplMK;EACC,6BAAA;AtCslMN;AsChlMO;EACC,oBAAA;AtCklMR;AsC5kMK;EACC,WAAA;EACA,OAAA;AtC8kMN;AsCpkMS;;;;EAEC,kBAAA;EACA,eAAA;AtCwkMV;AsChkMK;EACC,kBAAA;AtCkkMN;AsC5jMK;EACC,YAAA;AtC8jMN;AsCzjMK;EACC,YAAA;AtC2jMN;AsCvjMO;EACC,eAAA;EACA,gBAAA;AtCyjMR;AsCpjMO;EACC,yBAAA;AtCsjMR;AsCjjMO;EACC,yBAAA;AtCmjMR;AsC9iMO;EACC,uBAAA;AtCgjMR;AuCzsMA;EAGM,oBAAA;AvCysMN;AuC5sMA;;EAUM,0BAAA;AvCssMN;AuChtMA;EAeM,iBAAA;AvCosMN;AuCntMA;EAkBM,cAAA;AvCosMN;AuCjsMI;EACE,8BAAA;AvCmsMN;AuCjsMI;EACE,8BAAA;AvCmsMN;AuC5tMA;EA8BI,kCAAA;AvCisMJ;AuC7rMI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AvC+rMN;AuC7rMM;EACE,+BAAA;AvC+rMR;AuCvrMQ;;;;EACE,kCAAA;AvC4rMV;AuCvrMQ;;EACE,mBAAA;AvC0rMV;AuCzrMU;;EACE,0BAAA;AvC4rMZ;AuCtrMQ;;EACE,8BAAA;AvCyrMV;AuCprMQ;;EACE,mBAAA;AvCurMV;AuCtrMU;;EACE,0BAAA;EACA,gBAAA;AvCyrMZ;AuCnrMY;;EACE,0BAAA;AvCsrMd;AuCvwMA;EA0FI,eAAA;AvCgrMJ;AuC1wMA;EA+FM,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;AvC8qMN;AuCrxMA;EA2GM,iBAAA;EACA,oBAAA;AvC6qMN;AuCzxMA;EAgHM,wCAAA;AvC4qMN;AuC1qMM;;EAEE,oCAAA;AvC4qMR;AuChyMA;EAyHM,kBAAA;AvC0qMN;AuCnyMA;EA6HM,8BAAA;AvCyqMN;AuCtyMA;EAiIM,+BAAA;AvCwqMN;AuCjqMQ;;EAEE,oCAAA;AvCmqMV;AuC5pMA;EACE,yBAAA;AvC8pMF;AuC/pMA;;;;EAeI,iBAAA;EACA,cAAA;AvCspMJ;AuCtqMA;EAoBI,+BAAA;AvCqpMJ;AuCzqMA;EAwBI,uBAAA;AvCopMJ;AuC5qMA;EA2BI,cAAA;EACA,gBAAA;AvCopMJ;AuChpMA;EAEI,oCAAA;AvCipMJ;AuC9oME;EACE,kCAAA;AvCgpMJ;AuCtpMA;EAUI,kCAAA;AvC+oMJ;AuC3oMA;EACE,UAAA;EACA,oBAAA;AvC6oMF;AuC1oMA;EACE,UAAA;EACA,oBAAA;AvC4oMF;AuCzoMA;EACE,4BAAA;AvC2oMF;AuCxoMA;;EAGE,qBAAA;AvCyoMF;AuCtoMA;;EAKI,oBAAA;AvCqoMJ;AuCjoMA;EACE,iBAAA;AvCmoMF;AwCp2MA;EAGM,cAAA;AxCo2MN;AwCh2MA;EAEI,cAAA;AxCi2MJ;AwC71MA;EAEI,qBAAA;AxC81MJ;AwCh2MA;EAMI,yBAAA;AxC61MJ;AwCn2MA;EAQM,YAAA;EACA,gBAAA;AxC81MN;AwCx1ME;EAEI,kBAAA;AxCy1MN;AwCr1MM;EAEI,qBAAA;AxCs1MV;AwC/0MA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AxCi1MF;AwC90MA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,OAAA;EACA,eAAA;EACA,YAAA;EAEA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;AxC+0MF;AwC50MA;EAGM,gBAAA;EACA,kBAAA;AxC40MN;AwCx0MI;EACE,aAAA;AxC00MN;AwCt0ME;EAEI,sBAAA;AxCu0MN;AwCl0MI;EAGM,gBAAA;EACA,cAAA;AxCk0MV;AwCvzMI;EAEI,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,yDAAA;EACA,iBAAA;AxCwzMR;AwCpzMI;EAEI,yBAAA;EACA,cAAA;EACA,YAAA;AxCqzMR;AwChzMM;EAEI,YAAA;EAEA,mCAAA;EACA,gCAAA;EACA,2BAAA;EACA,qBAAA;AxCgzMV;AwC5yMM;EACE,uBAAA;AxC8yMR;AwC/yMM;;EAKI,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AxC8yMV;AwCtzMM;EAYI,mBAAA;AxC6yMV;AwC1yMM;EACE,uBAAA;AxC4yMR;AwC7yMM;;EAKI,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AxC4yMV;AwCpzMM;EAYI,mBAAA;AxC2yMV;AwCtyMQ;EACE,yBAAA;EACA,SAAA;AxCwyMV;AwC3yMM;EAOI,uBAAA;EACA,iBAAA;AxCuyMV;AwC/yMM;;EAaI,uBAAA;AxCsyMV;AwCjyMI;;EAGI,qBAAA;EACA,6BAAA;AxCkyMR;AwCtyMI;;;;EAQM,yBAAA;AxCoyMV;AwC5yMI;;EAaI,yBAAA;AxCmyMR;AwC9xMM;;EAGI,gCAAA;EACA,oCAAA;AxC+xMV;AwCzxME;EAGE,cAAA;AxCyxMJ;AwCtxME;EAGE,cAAA;AxCsxMJ;AwCnxME;EAGE,yBAAA;AxCmxMJ;AwChxME;EACE,wBAAA;AxCkxMJ;AwC/wME;EAEI,gBAAA;AxCgxMN;AwClxME;EAMI,aAAA;AxC+wMN;AwC1wMI;EACE,kCAAA;AxC4wMN;AwCvwMI;EACE,gCAAA;AxCywMN;AwC1wMI;EAGI,yBAAA;AxC0wMR;AwC7wMI;EAOI,yBAAA;AxCywMR;AwCjxME;EAaI,yBAAA;EACA,8BAAA;EACA,oBAAA;AxCuwMN;AwCtxME;EAmBI,yBAAA;AxCswMN;AwCzxME;EAuBI,oCAAA;AxCqwMN;AwC5xME;EA2BI,yBAAA;AxCowMN;AwChwME;EAEI,yBAAA;EACA,gBAAA;EACA,gBAAA;AxCiwMN;AwC77MA;EAiMI,iBAAA;EACA,mBAAA;EACA,iBAAA;AxC+vMJ;AwCl8MA;EAuMI,mBAAA;EACA,iBAAA;AxC8vMJ;AwCt8MA;EA2MM,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AxC8vMN;AwCzvMI;EAEI,cAAA;AxC0vMR;AwCrvME;EACE,gBAAA;AxCuvMJ;AwCpvME;EACE,YAAA;EACA,eAAA;AxCsvMJ;AwCxvME;;;EAOI,uBAAA;EACA,4BAAA;AxCsvMN;AwC9vME;EAYI,mBAAA;AxCqvMN;AwCjwME;EAgBI,eAAA;EACA,gBAAA;AxCovMN;AwCn+MA;EAoPI,eAAA;EACA,gBAAA;EACA,cAAA;AxCkvMJ;AwCx+MA;EA0PI,wBAAA;EACA,mBAAA;AxCivMJ;AwC9uME;EAEI,yBAAA;AxC+uMN;AwC3uME;EAEI,yBAAA;AxC4uMN;AwCxuME;EAEI,yBAAA;AxCyuMN;AwCruME;EAEI,yBAAA;AxCsuMN;AwCx/MA;EAuRI,yBAAA;AxCouMJ;AwCjuME;EAGI,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;AxCiuMN;AwCxuME;EAWI,mBAAA;EACA,gBAAA;EACA,mBAAA;AxCguMN;AwC5tME;EAEI,cAAA;AxC6tMN;AwC/tME;EAMI,yBAAA;AxC4tMN;AwCxtME;EAEI,wBAAA;EACA,8BAAA;AxCytMN;AwCptMA;EAEI,qBAAA;AxCqtMJ;AwCjtMA;EACE,oCAAA;AxCmtMF;AwChtMA;EAEI,yBAAA;EACA,cAAA;EACA,YAAA;AxCitMJ;AwC7sMA;EAEI,uBAAA;EACA,2BAAA;AxC8sMJ;AwCjtMA;EAMI,4BAAA;EACA,cAAA;AxC8sMJ;AwCrtMA;EAUI,WAAA;AxC8sMJ;AwC1sMA;EAEI,mBAAA;AxC2sMJ;AwCtsME;EACE,YAAA;AxCwsMJ;AwCzsME;EAII,uBAAA;EACA,uBAAA;AxCwsMN;AwC9sMA;EAWI,WAAA;EACA,SAAA;AxCssMJ;AwCltMA;EAgBI,cAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;AxCqsMJ;AwC/rME;;EAEI,yBAAA;AxCisMN;AwC5rMA;EACE,gCAAA;AxC8rMF;AwC/rMA;EAGI,yBAAA;AxC+rMJ;AwClsMA;EAOI,yBAAA;AxC8rMJ;AwC1rMA;EAEI,qBAAA;EACA,oBAAA;AxC2rMJ;AwC9rMA;EAOI,kBAAA;EACA,oBAAA;AxC0rMJ;AwClsMA;EAYI,UAAA;AxCyrMJ;AwCrrMA;EAEI,uBAAA;EACA,4BAAA;AxCsrMJ;AwClrMA;EACE,mBAAA;AxCorMF;AwCjrMA;EACE,gBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;AxCmrMF;AwChrMA;EACE,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AxCkrMF;AwC/qMA;EACE,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;AxCirMF;AwC9qMA;;EAGI,cAAA;EACA,uBAAA;AxC+qMJ;AwC3qMA;EACE,gCAAA;EACA,qCAAA;EACA,kCAAA;EACA,6BAAA;EACA,mCAAA;EACA,gCAAA;EACA,2BAAA;AxC6qMF;AwCprMA;EAUI,uBAAA;EACA,gCAAA;AxC6qMJ;AwCzqMA;EACE,qCAAA;EACA,kCAAA;EACA,6BAAA;EACA,gCAAA;EACA,mCAAA;EACA,gCAAA;EACA,2BAAA;AxC2qMF;AwClrMA;EAUI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;AxC2qMJ;AwCzqMI;EACE,cAAA;EACA,mBAAA;AxC2qMN;AwCxqMI;EACE,gCAAA;AxC0qMN;AwCtqME;EAEI,yBAAA;AxCuqMN;AwCzqME;EAMI,YAAA;AxCsqMN;AwC5qME;EAUI,cAAA;EACA,6BAAA;EACA,qBAAA;AxCqqMN;AwCjqMA;EACE,wCAAA;AxCmqMF;AwChqMA;EACE,wBAAA;AxCkqMF;AwC/pMA;EACE,YAAA;AxCiqMF;AwClqMA;EAII,uBAAA;EACA,6BAAA;AxCiqMJ;AwCtqMA;EASI,6BAAA;AxCgqMJ;AwCzqMA;;;EAeI,sBAAA;AxC+pMJ;AwC3pMA;EACE,WAAA;AxC6pMF;AwC9pMA;EAGI,wBAAA;AxC8pMJ;AwCjqMA;;;;;;EAYI,WAAA;AxC6pMJ;AwCzpMA;EAEI,oCAAA;EACA,kBAAA;EACA,mBAAA;AxC0pMJ;AwC9pMA;;EASI,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;AxCypMJ;AwCrqMA;EAgBI,yBAAA;AxCwpMJ;AwCxqMA;EAoBI,yBAAA;EACA,0BAAA;EACA,kBAAA;AxCupMJ;AwC7qMA;EA0BI,2BAAA;EACA,cAAA;AxCspMJ;AwCjrMA;EAgCI,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;AxCopMJ;AwCvrMA;EAuCI,2BAAA;AxCmpMJ;AwC1rMA;EA2CI,WAAA;EACA,YAAA;AxCkpMJ;AwC9rMA;EA+CM,aAAA;AxCkpMN;AwCjsMA;EAmDI,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AxCipMJ;AwC7oMA;EAEI,6BAAA;EACA,oBAAA;AxC8oMJ;AwCzoME;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AxC2oMJ;AwC/oMA;EAQI,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AxC0oMJ;AwCrpMA;EAiBI,iBAAA;EACA,gBAAA;AxCuoMJ;AwCzpMA;EAsBI,YAAA;AxCsoMJ;AwC5pMA;EA2BM,wCAAA;EACA,4BAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;AxCooMN;AwCnqMA;EAmCM,cAAA;AxCmoMN;AwCtqMA;EAuCM,YAAA;AxCkoMN;AwCzqMA;EA0CM,YAAA;AxCkoMN;AyC33NA;EAGM,aAAA;AzC23NN;AyC93NA;EAOM,aAAA;AzC03NN;AyCj4NA;EAWM,eAAA;AzCy3NN;AyCp4NA;EAiBM,kBAAA;EACA,aAAA;AzCs3NN;AyCx4NA;EAsBM,gBAAA;EACA,UAAA;AzCq3NN;AyC54NA;EA2BM,UAAA;AzCo3NN;AyC/4NA;EA+BM,aAAA;EACA,UAAA;AzCm3NN;AyCn5NA;EAoCM,iBAAA;EACA,eAAA;AzCk3NN;AyCv5NA;EAyCM,gBAAA;AzCi3NN;AyC72NE;EAAA;IAEI,sBAAA;IACA,uBAAA;EzC+2NJ;EyCl3NA;IAMI,oCAAA;IACA,uBAAA;EzC+2NJ;AACF;AyCp6NA;EA0DM,SAAA;AzC62NN;AyCv6NA;EA+DI,cAAA;EACA,qBAAA;AzC22NJ;AyCz2NI;EACE,yBAAA;EACA,gCAAA;AzC22NN;AyC/6NA;EAyEI,sBAAA;EACA,2BAAA;EACA,uBAAA;AzCy2NJ;AyCr2NI;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,MAAA;AzCu2NN;AyC52NI;EAQI,WAAA;EACA,YAAA;EACA,UAAA;AzCu2NR;AyCj3NI;EAaI,UAAA;AzCu2NR;AyCn8NA;EAkGI,mBAAA;EACA,gBAAA;AzCo2NJ;AyCv8NA;EAsGM,mBAAA;EACA,gBAAA;AzCo2NN;AyC38NA;EA6GM,UAAA;AzCi2NN;AyC51NA;EAEI,6BAAA;EACA,kBAAA;AzC61NJ;AyCh2NA;EAOI,kBAAA;EACA,WAAA;EACA,SAAA;AzC41NJ;A0C98NC;EjBPC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EiBEA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;A1Cu9NF;A0Cr9NE;EACE,kBAAA;EACA,qCAAA;EACA,WAAA;A1Cu9NJ;A0Cp9NE;EACE,aAAA;A1Cs9NJ;A0Cl9NE;;;EAGE,oBAAA;A1Co9NJ;A0Cj9NE;;;EAGE,kBAAA;A1Cm9NJ;A0Ch9NE;;;EAGE,iBAAA;A1Ck9NJ;A0C/8NE;;;EAGE,mBAAA;A1Ci9NJ;A0C98NE;EACE,sBAAA;EACA,4BAAA;EACA,kBAAA;EACA,oHAAA;EACA,0CAAA;A1Cg9NJ;A0C78NE;EAAA;I1Cg9NE,UAAU;EACZ;E0C/8NE;IACE,oHAAA;E1Ci9NJ;AACF;A0C98NE;EACE,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;A1Cg9NJ;A0C78NE;EACE,kBAAA;EACA,cAAA;A1C+8NJ;A0C58NE;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;A1C88NJ;A0Cl9NE;EAMI,kBAAA;EACA,WAAA;EAGA,cAAA;EACA,eAAA;A1C68NN;A0C38NI;EACE,kBAAA;A1C68NN;A0Cz8NE;EACE,kBAAA;EACA,iBAAA;A1C28NJ;A0C78NE;EAKI,gBAAA;A1C28NN;A0Ct8NE;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;A1Cw8NJ;A0Ct8NI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;A1Cw8NN;A0Cp8NE;;;EAGE,oBAAA;A1Cs8NJ;A0Cp8NI;;;EACE,2CAAA;EACA,kDAAA;A1Cw8NN;A0Cr8NE;EACE,SAAA;EACA,2BAAA;A1Cu8NJ;A0Cp8NE;EACE,UAAA;A1Cs8NJ;A0Cn8NE;EACE,WAAA;A1Cq8NJ;A0Cl8NE;;;EAGE,kBAAA;A1Co8NJ;A0Cl8NI;;;EACE,4CAAA;EACA,iDAAA;A1Cs8NN;A0Cn8NE;EACE,QAAA;EACA,2BAAA;A1Cq8NJ;A0Cn8NE;EACE,SAAA;A1Cq8NJ;A0Cn8NE;EACE,YAAA;A1Cq8NJ;A0Cl8NE;;;EAGE,iBAAA;A1Co8NJ;A0Cl8NI;;;EACE,6CAAA;EACA,iDAAA;A1Cs8NN;A0Cl8NE;EACE,SAAA;EACA,2BAAA;A1Co8NJ;A0Cj8NE;EACE,UAAA;A1Cm8NJ;A0Ch8NE;EACE,WAAA;A1Ck8NJ;A0C/7NE;;;EAGE,mBAAA;A1Ci8NJ;A0C/7NI;;;EACE,4CAAA;EACA,kDAAA;A1Cm8NN;A0C/7NE;EACE,QAAA;EACA,2BAAA;A1Ci8NJ;A0C97NE;EACE,SAAA;A1Cg8NJ;A0C77NE;EACE,YAAA;A1C+7NJ;A0Cv7NG;EAEG,yBAAA;A1Cw7NN;A0Cr7NM;EACE,yBAAA;A1Cu7NR;A0C77NG;EAEG,yBAAA;A1C87NN;A0C37NM;EACE,yBAAA;A1C67NR;A0Cn8NG;EAEG,yBAAA;A1Co8NN;A0Cj8NM;EACE,yBAAA;A1Cm8NR;A0Cz8NG;EAEG,yBAAA;A1C08NN;A0Cv8NM;EACE,yBAAA;A1Cy8NR;A0C/8NG;EAEG,yBAAA;A1Cg9NN;A0C78NM;EACE,yBAAA;A1C+8NR;A0Cr9NG;EAEG,yBAAA;A1Cs9NN;A0Cn9NM;EACE,yBAAA;A1Cq9NR;A0C39NG;EAEG,yBAAA;A1C49NN;A0Cz9NM;EACE,yBAAA;A1C29NR;A0Cj+NG;EAEG,yBAAA;A1Ck+NN;A0C/9NM;EACE,yBAAA;A1Ci+NR;A0Cv+NG;EAEG,yBAAA;A1Cw+NN;A0Cr+NM;EACE,yBAAA;A1Cu+NR;A0C7+NG;EAEG,yBAAA;A1C8+NN;A0C3+NM;EACE,yBAAA;A1C6+NR;A0Cn/NG;EAEG,yBAAA;A1Co/NN;A0Cj/NM;EACE,yBAAA;A1Cm/NR;A0Cz/NG;EAEG,yBAAA;A1C0/NN;A0Cv/NM;EACE,yBAAA;A1Cy/NR;A0C//NG;EAEG,yBAAA;A1CggON;A0C7/NM;EACE,yBAAA;A1C+/NR;A2C7uOE;EACE,cAAA;EACA,iBAAA;A3C+uOJ;A2C1uOO;EACC,mBAAA;EACA,kBAAA;A3C4uOR;A2CtuOK;EACC,gBAAA;A3CwuON;A2CpuOO;EACC,iBAAA;EACA,cAAA;A3CsuOR;A4C/vOA;EAGI,gBAAA;A5C+vOJ;A4C3vOI;EACE,cAAA;EACA,eAAA;A5C6vON;A4CzvOM;EACE,eAAA;A5C2vOR;A4C7vOI;EAMI,aAAA;A5C0vOR;A4C5wOA;EAyBM,kBAAA;A5CsvON;A4C/wOA;EA8BI,mBAAA;A5CovOJ;A4ClxOA;EAgCM,UAAA;EACA,qBAAA;A5CqvON;A4CtxOA;EAuCM,kBAAA;EACA,cAAA;A5CkvON;A4C7uOA;EAGI,WAAA;EACA,YAAA;A5C6uOJ;A4CjvOA;EAQI,WAAA;EACA,YAAA;EACA,kBAAA;A5C4uOJ;A4CxuOA;EAGI,YAAA;A5CwuOJ;A4CruOE;EACE,sBAAA;A5CuuOJ;A4C9uOA;EAWI,gBAAA;A5CsuOJ;A6CzyOC;EpBHC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EoBFA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,+DAAA;A7CkzOF;A6ChzOE;EACE,gBAAA;EACA,qBAAA;EACA,UAAA;A7CkzOJ;A6C/yOE;EACE,kBAAA;A7CizOJ;A6ClzOE;EAGI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;A7CkzON;A6C5zOE;EAYM,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;A7CmzOR;A6Cl0OE;EAkBM,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;A7CmzOR;A6CjzOO;EACC,iBAAA;A7CmzOR;A6C50OE;EA+BM,YAAA;A7CgzOR;A6C/0OE;EAkCM,kBAAA;A7CgzOR;A6C9yOO;EACC,iBAAA;A7CgzOR;A6Cr1OE;EA2CM,aAAA;A7C6yOR;A6Cx1OE;EA8CM,mBAAA;A7C6yOR;A6C3yOO;EACC,iBAAA;A7C6yOR;A6CxyOE;EACE,kBAAA;EACA,wBAAA;A7C0yOJ;A6CxyOI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;EACA,oBAAA;A7C0yON;A6CtyOE;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;A7CwyOJ;A6CtyOI;EACE,YAAA;EACA,oBAAA;A7CwyON;A6ClyOE;EACE,0BAAA;A7CoyOJ;A6C9xOE;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;E1CzHF,UAAA;EACA,WAAA;AH05OF;A6C9xOI;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,mDAAA;A7CgyON;A6C9xOM;EACE,MAAA;EACA,OAAA;A7CgyOR;A6C9xOM;EACE,MAAA;EACA,QAAA;EACA,qBAAA;A7CgyOR;A6C9xOM;EACE,QAAA;EACA,SAAA;EACA,qBAAA;A7CgyOR;A6C9xOM;EACE,SAAA;EACA,OAAA;EACA,qBAAA;A7CgyOR;A6C5xOI;EACE,wBAAA;EACA,yCAAA;A7C8xON;A6CtxOE;EACE,eAAA;A7CwxOJ;A6CzxOE;EAII,UAAA;EACA,WAAA;A7CwxON;A6CnxOE;EACE,eAAA;A7CqxOJ;A6CtxOE;EAII,WAAA;EACA,YAAA;A7CqxON;A6CjxOE;EACE,cAAA;A7CmxOJ;A6C/wOA;E7CixOE,UAAU;E6C/wOT;IACC,gBAAA;IACA,YAAA;E7CixOF;AACF;A6C9wOA;EACE;IACE,UAAA;E7CgxOF;AACF;A6C7wOA;EACE;IACE,yBAAA;E7C+wOF;AACF;A8Cl+OE;EACE,cAAA;A9Co+OJ;A8C/9OO;EACC,yBAAA;EACA,4BAAA;A9Ci+OR;A8C39OA;EACE;IACE,0BAAA;E9C69OF;AACF;A+Cr+OA;EANE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;A/C8+OF;A+Cz+OI;EACE,YAAA;A/C2+ON;A+C/+OA;EANE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;A/Cw/OF;A+Ct+OA;EACE,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,iCAAA;A/Cw+OF;A+Cr+OA;EACE;IACI,uBAAA;E/Cu+OJ;E+Cr+OA;IACI,yBAAA;E/Cu+OJ;AACF;AgD9gPA;EAEI,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AhD+gPJ;AgD7gPI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;AhD+gPN;AgD5gPI;EACE,eAAA;AhD8gPN;AgD3gPI;EACE,UAAA;AhD6gPN;AgDzgPM;EACE,yBAAA;AhD2gPR;AgD1gPQ;EACE,yBAAA;AhD4gPV;AgDvgPI;EACE,WAAA;EACA,gDAAA;EAOA,yBAAA;EACA,qBAAA;AhDmgPN;AgDlgPM;EACE,yBAAA;AhDogPR;AgDhgPI;EACE,yBAAA;AhDkgPN;AgD1jPA;;EA+DM,iBAAA;AhD+/ON;AgD9jPA;EAqEM,qBAAA;AhD4/ON;AiDzjPC;ExBLC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EwBAA,UAAA;AjDkkPF;AiDrkPC;EAMG,SAAA;AjDkkPJ;AiD/jPE;EACE,cAAA;EACA,WAAA;EACA,aAAA;AjDikPJ;AiD7kPC;EAgBG,eAAA;AjDgkPJ;AiD7jPE;EACE,qBAAA;AjD+jPJ;AiD5jPE;EACE,mBAAA;AjD8jPJ;AiD3jPE;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AjD6jPJ;AiDxkPE;EAcI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AjD6jPN;AiD1jPI;EACE,qBAAA;AjD4jPN;AiD3jPO;EACC,qBAAA;AjD6jPR;AiDxjPE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AjD0jPJ;AiDnkPE;EAYI,eAAA;AjD0jPN;AiDvjPK;EACC,qBAAA;AjDyjPN;AiDtjPK;EACC,mBAAA;AjDwjPN;AiD5kPE;EAwBI,cAAA;EACA,YAAA;AjDujPN;AiDhlPE;EA6BI,mBAAA;EACA,sBAAA;AjDsjPN;AiDnjPI;EACE,qBAAA;AjDqjPN;AiDvlPE;EA2CI,mBAAA;AjD+iPN;AiD1lPE;EAuCM,cAAA;EACA,eAAA;AjDsjPR;AiD9lPE;EA8CI,eAAA;EACA,cAAA;EACA,eAAA;AjDmjPN;AiDnmPE;EAmDI,0BAAA;EACA,eAAA;AjDmjPN;AiDvmPE;EAwDI,0BAAA;EACA,eAAA;EACA,oBAAA;AjDkjPN;AiDjjPM;EACE,0BAAA;AjDmjPR;AiDhjPK;EACC,0BAAA;AjDkjPN;AiD9iPE;EAGE,qBAAA;EACA,WAAA;AjD8iPJ;AIlrPE;EACE,cAAA;EACA,WAAA;AJorPJ;AIlrPE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJmrPJ;AI3rPE;EACE,cAAA;EACA,WAAA;AJ6rPJ;AI3rPE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJ4rPJ;AiD5jPC;ExBzIC,sBAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EAEA,gBAAA;EACA,6BAAA;EwBoIA,gBAAA;AjDokPF;AI/sPE;EACE,cAAA;EACA,WAAA;AJitPJ;AI/sPE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJgtPJ;AIxtPE;EACE,cAAA;EACA,WAAA;AJ0tPJ;AIxtPE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJytPJ;AiDnlPE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AjDqlPJ;AiDplPI;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AjDslPN;AiDnlPI;EACE,kBAAA;EACA,QAAA;AjDqlPN;AiDnlPM;EACE,UAAA;AjDqlPR;AiDnlPO;EACC,YAAA;EACA,cAAA;AjDqlPR;AiDllPM;EACE,SAAA;EACA,cAAA;AjDolPR;AiDjlPM;;EAEE,UAAA;AjDmlPR;AiDtmPI;EAuBI,0BAAA;AjDklPR;AiD9kPI;EACE,YAAA;EACA,cAAA;EACA,iCAAA;AjDglPN;AiDnlPI;EAMI,cAAA;EACA,WAAA;EACA,YAAA;AjDglPR;AiDxlPI;;EAcM,kBAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;AjD8kPV;AiDzoPE;EAiEI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;AjD2kPN;AiDzkPM;EACE,cAAA;AjD2kPR;AiDvkPI;EACE,yBAAA;AjDykPN;AiDtkPK;EACC,UAAA;AjDwkPN;AiDrkPI;EACE,UAAA;AjDukPN;AiDpkPK;;;EAGC,cAAA;AjDskPN;AiDnkPI;EAEI,cAAA;AjDokPR;AiDlkPM;EACE,UAAA;AjDokPR;AiDhkPI;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AjDkkPN;AiD7jPE;;EAGI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AjD8jPN;AiD5jPM;;EACE,uBAAA;AjD+jPR;AiD5jPM;;EACE,qBAAA;AjD+jPR;AiD7kPE;;EAmBI,UAAA;AjD8jPN;AiDjlPE;;EAuBI,uBAAA;AjD8jPN;AiDrlPE;;EA2BI,oBAAA;AjD8jPN;AiDzlPE;;EA+BI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AjD8jPN;AiDjmPE;;EAsCM,eAAA;AjD+jPR;AiDvjPU;;EACE,aAAA;AjD0jPZ;AiDvjPU;;EACE,aAAA;AjD0jPZ;AiD7mPE;;EA0DI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AjDujPN;AiDrnPE;;EAiEM,eAAA;AjDwjPR;AiDznPE;;EAsEI,eAAA;AjDujPN;AiD7nPE;;EA0EI,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjDujPN;AiDpoPE;;EAiFI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AjDujPN;AiDlpPE;;EA+FI,iBAAA;AjDujPN;AiDtpPE;;EAmGI,YAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;AjDujPN;AiD7pPE;;EA0GI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;AjDujPN;AiDjjPI;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AjDmjPN;AiDhjPK;EACC,aAAA;AjDkjPN;AiD5jPE;EAcI,YAAA;EACA,SAAA;AjDijPN;AiDhkPE;EAmBI,kBAAA;EACA,YAAA;EACA,gBAAA;AjDgjPN;AiD9iPM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;AjDgjPR;AiD/kPE;EAoCI,UAAA;AjD8iPN;AiDllPE;EAwCI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,UAAA;EACA,oBAAA;AjD6iPN;AiD5lPE;;;EAoDM,WAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AjD6iPR;AiD3iPQ;;;EACE,WAAA;AjD+iPV;AiD5mPE;;EAoEI,UAAA;AjD4iPN;AiDhnPE;;EAyEI,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AjD2iPN;AiDxnPE;EAiFI,aAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AjD0iPN;AiD/nPE;EAyFI,kBAAA;EACA,YAAA;EACA,cAAA;AjDyiPN;AiDriPO;EACC,yBAAA;AjDuiPR;AiDvoPE;EAoGM,YAAA;AjDsiPR;AiDpiPS;;;EAGC,aAAA;AjDsiPV;AiD/oPE;EA+GI,YAAA;EACA,wBAAA;EACA,eAAA;AjDmiPN;AiD5hPI;;EACE,qCAAA;AjD+hPN;AiD7hPM;;EACE,cAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AjDgiPR;AiDviPI;;EAYI,cAAA;EACA,UAAA;AjD+hPR;AiD9iPE;;EAsBI,aAAA;EACA,mBAAA;AjD4hPN;AiDnjPE;;EA0BM,UAAA;AjD6hPR;AiDvjPE;;EA+BI,UAAA;EACA,cAAA;AjD4hPN;AiD5jPE;;EAoCI,gBAAA;AjD4hPN;AiDvhPE;EAGM,gBAAA;AjDuhPR;AiDx6PC;;;EA0ZG,wBAAA;EACA,yDAAA;AjDmhPJ;AiD96PC;;EAgaG,qCAAA;AjDkhPJ;AiDl7PC;EAoaG,sCAAA;AjDihPJ;AiD7gPA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,UAAA;EjD+gPF;AACF;AiD5gPA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,UAAA;EjD8gPF;AACF;AkD5kQE;EACE,cAAA;AlD8kQJ;AkD1kQK;EACC,kBAAA;EACA,gBAAA;AlD4kQN;AkDtkQE;EACE,cAAA;AlDwkQJ;AkDnkQS;EACC,mBAAA;EACA,kBAAA;AlDqkQV;AkDjkQS;EACC,mBAAA;EACA,kBAAA;AlDmkQV;AkD5jQO;EACC,mBAAA;EACA,eAAA;AlD8jQR;AkDzjQO;EACC,kBAAA;AlD2jQR;AkDtjQO;EACC,WAAA;EACA,OAAA;AlDwjQR;AkDrjQS;EACC,gBAAA;EACA,iBAAA;AlDujQV;AkDjjQO;EACC,qBAAA;AlDmjQR;AkD9iQO;EACC,WAAA;EACA,SAAA;AlDgjQR;AkD1iQS;EACC,gBAAA;EACA,iBAAA;AlD4iQV;AkDtiQO;EACC,mBAAA;EACA,eAAA;AlDwiQR;AkDniQE;;EAGI,UAAA;AlDoiQN;AkDhiQO;;EACC,UAAA;EACA,UAAA;AlDmiQR;AkD9hQO;;EACC,UAAA;EACA,UAAA;EACA,+BAAA;AlDiiQR;AkD5hQO;;EACC,iBAAA;EACA,mBAAA;EACA,iBAAA;AlD+hQR;AkD1hQO;;EACC,mBAAA;EACA,kBAAA;AlD6hQR;AkDxhQO;;EACC,mBAAA;EACA,kBAAA;AlD2hQR;AkDthQO;;EACC,gBAAA;EACA,eAAA;AlDyhQR;AkDphQO;;EACC,WAAA;EACA,SAAA;AlDuhQR;AkDhhQO;EACC,mBAAA;AlDkhQR;AkD7gQO;EACC,UAAA;EACA,UAAA;EACA,+BAAA;AlD+gQR;AkD1gQO;EACC,eAAA;EACA,UAAA;AlD4gQR;AmDnrQI;EACE,UAAA;EACA,0BAAA;EACA,mBAAA;EACA,UAAA;AnDqrQN;AmDzrQI;EAOI,kBAAA;AnDqrQR;AmDlrQM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AnDorQR;AmDjrQM;EACE,0BAAA;AnDmrQR;AmDlrQQ;EACE,YAAA;AnDorQV;AmDhrQM;EACE,0BAAA;AnDkrQR;AmDltQI;EAwCI,kBAAA;AnD6qQR;AmDrtQI;EAqCM,eAAA;EACA,cAAA;AnDmrQV;AmDztQI;EA2CI,eAAA;EACA,gBAAA;EACA,cAAA;AnDirQR;AmD9tQI;EAgDI,eAAA;EACA,cAAA;AnDirQR;AmDluQI;EAoDI,eAAA;EACA,oBAAA;EACA,0BAAA;AnDirQR;AmDhrQQ;EACE,0BAAA;AnDkrQV;AmD/qQO;EACC,0BAAA;AnDirQR;AmD/qQM;EACE,YAAA;AnDirQR;AoDrvQA;EACE,gFAAA;EAKA,aAAA;EACA,uBAAA;EACA,mBAAA;ApDmvQF;AoDjvQE;EAAA;IACE,cAAA;EpDovQF;AACF;AoDjvQA;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,uCAAA;ApDmvQF;AoDjvQE;EAAA;IACE,kBAAA;EpDovQF;AACF;AoD5vQA;EAWI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;ApDovQJ;AoDpwQA;EAmBM,cAAA;ApDovQN;AoDvwQA;EAuBI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ApDmvQJ;AoD/wQA;EA8BM,gBAAA;ApDovQN;AoDlxQA;EAkCI,kBAAA;EACA,mBAAA;ApDmvQJ;AoDtxQA;EAqCM,kBAAA;EACA,uBAAA;EACA,aAAA;ApDovQN;AoD3xQA;EA2CI,gBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;ApDmvQJ;AoDryQA;EAqDM,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;ApDmvQN;AoD7yQA;EA8DI,oBAAA;EACA,gBAAA;ApDkvQJ;AoDjzQA;EAkEI,yBAAA;ApDkvQJ;AoDjvQI;EACE,yBAAA;ApDmvQN;AoD9uQA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;ApDgvQF;AoDvvQA;EAUI,gBAAA;EACA,mBAAA;ApDgvQJ;AoD3vQA;EAcM,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;ApDgvQN;AoDnwQA;EAuBM,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;ApD+uQN;AoD3wQA;EAgCI,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ApD8uQJ;AoDxxQA;EA6CM,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;ApD8uQN;AoD5uQM;EACE,aAAA;ApD8uQR;AoDpyQA;EA0DQ,eAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;ApD6uQR;AoD1yQA;EAgEQ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ApD6uQR;AoDhzQA;EAsEQ,eAAA;EACA,gBAAA;EACA,cAAA;ApD6uQR;AoD1uQM;EACE,kBAAA;ApD4uQR;AoD7uQM;EAGI,yBAAA;EACA,yBAAA;ApD6uQV;AoDjvQM;EAOI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;ApD6uQV;AoD1uQM;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;ApD4uQR;AoD1uQQ;EACE,oBAAA;ApD4uQV;AoDnvQM;EAUI,kBAAA;EACA,eAAA;ApD4uQV;AoDvvQM;EAaM,kBAAA;EACA,iCAAA;ApD6uQZ;AoD3vQM;EAkBI,eAAA;ApD4uQV;AoD9vQM;EAqBI,eAAA;ApD4uQV;AoDjwQM;EAyBI,2BAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;ApD2uQV;AoDp2QA;EA6HQ,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;ApD0uQR;AoDt3QA;EAiJI,oBAAA;EACA,gBAAA;ApDwuQJ;AoD13QA;EAqJI,yBAAA;ApDwuQJ;AoDvuQI;EACE,yBAAA;ApDyuQN;AqDt9QA;EAEI,aAAA;EACA,mBAAA;EACA,0CAAA;ArDu9QJ;AqD39QA;EAOM,yBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;ArDu9QN;AqDp9QI;EACE,YAAA;ArDs9QN;AqD1+QA;EAyBI,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ArDo9QJ;AqDl9QI;EACE,YAAA;ArDo9QN;AqDr9QI;EAGI,mBAAA;ArDq9QR;AqDv/QA;EAuCM,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;ArDm9QN;AqDpgRA;EAqDM,WAAA;EACA,YAAA;EACA,mBAAA;ArDk9QN;AqDzgRA;EA2DM,iBAAA;ArDi9QN;AqD5gRA;EA+DM,iBAAA;ArDg9QN;AqD/gRA;EAmEM,oBAAA;ArD+8QN;AqDlhRA;EAuEM,kBAAA;ArD88QN;AqDrhRA;EA2EM,SAAA;ArD68QN;AqDxhRA;EA+EM,eAAA;EACA,cAAA;ArD48QN;AqD5hRA;EAoFM,eAAA;EACA,cAAA;ArD28QN;AqDhiRA;EAyFM,cAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;ArD08QN;AsDziRA;EAEI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AtD0iRJ;AsDxiRI;EACE,oBAAA;EACA,YAAA;AtD0iRN;AsDtiRY;EACE,mBAAA;EACA,cAAA;AtDwiRd;AsDpiRQ;EACE,mBAAA;AtDsiRV;AsD1jRA;EA0BM,WAAA;EACA,YAAA;EACA,mBAAA;AtDmiRN;AsD/jRA;EAgCM,iBAAA;AtDkiRN;AsDlkRA;EAoCM,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AtDiiRN;AsD/hRM;EACE,eAAA;AtDiiRR;AsD5kRA;EAgDM,oBAAA;AtD+hRN;AsD/kRA;EAoDM,kBAAA;AtD8hRN;AsDllRA;EAwDM,SAAA;AtD6hRN;AsDrlRA;EA4DM,iBAAA;AtD4hRN;AsDxlRA;EAgEM,eAAA;EACA,cAAA;AtD2hRN;AsD5lRA;EAqEM,eAAA;EACA,cAAA;AtD0hRN;AsDhmRA;EA0EM,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AtDyhRN;AsDxhRM;EACE,eAAA;AtD0hRR;AsDzmRA;EAmFQ,cAAA;EACA,SAAA;AtDyhRR;AsDvhRQ;EACE,qBAAA;AtDyhRV;AsDhnRA;EA6FM,iBAAA;AtDshRN;AsDnhRI;EAEE,eAAA;AtDohRN;AuDtnRA;EAKI,kBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AvDonRJ;AuD9nRA;EAcI,cAAA;EACA,YAAA;AvDmnRJ;AuDloRA;EAmBI,cAAA;EACA,YAAA;AvDknRJ;AuDhnRI;EACE,UAAA;EACA,cAAA;AvDknRN;AwD1oRA;EAEI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AxD2oRJ;AwDzoRI;EACE,qCAAA;EACA,oBAAA;AxD2oRN;AwD7oRI;EAII,yBAAA;AxD4oRR;AwDhpRI;EAQQ,cAAA;AxD2oRZ;AwDtoRI;EACE,YAAA;AxDwoRN;AwDpoRY;EACE,mBAAA;EACA,cAAA;AxDsoRd;AwDloRQ;EACE,mBAAA;AxDooRV;AwD/nRI;EACE,aAAA;AxDioRN;AwDloRI;EAII,iBAAA;AxDioRR;AwD5qRA;EAgDM,WAAA;EACA,YAAA;EACA,kBAAA;AxD+nRN;AwDjrRA;EAsDM,iBAAA;AxD8nRN;AwDprRA;EA0DM,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AxD6nRN;AwD3nRM;EACE,eAAA;AxD6nRR;AwD9rRA;EAsEM,oBAAA;AxD2nRN;AwDjsRA;EA0EM,uBAAA;AxD0nRN;AwDpsRA;EA8EM,SAAA;AxDynRN;AwDvsRA;EAkFM,iBAAA;AxDwnRN;AwD1sRA;EAsFM,eAAA;AxDunRN;AwD7sRA;EA0FM,eAAA;EACA,cAAA;AxDsnRN;AwDjtRA;EA+FM,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;AxDqnRN;AwDnnRM;EACE,eAAA;AxDqnRR;AwD5tRA;EA2GQ,SAAA;EACA,cAAA;AxDonRR;AwDhuRA;EA+GU,gBAAA;AxDonRV;AwDnuRA;EAqHM,qBAAA;EACA,iBAAA;AxDinRN;AwD9mRI;EACE,6CAAA;EACA,eAAA;AxDgnRN;AwD3uRA;EA+HM,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AxD+mRN;AwDjvRA;EAsIM,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yBAAA;AxD8mRN;AwD7mRM;EACE,kBAAA;AxD+mRR;AwD5vRA;EAgJQ,iBAAA;AxD+mRR;AwD/vRA;EAqJM,eAAA;EACA,eAAA;EACA,cAAA;AxD6mRN;AyDtwRA;EAEI,kBAAA;EACA,0BAAA;AzDuwRJ;AyD1wRA;EAOI,+BAAA;AzDswRJ;AyDnwRE;EACE,yBAAA;AzDqwRJ;AyDtwRE;EAII,uBAAA;EACA,kCAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,0CAAA;AzDqwRN;AyDjxRE;EAgBI,SAAA;EACA,2BAAA;AzDowRN;AyD/xRA;EAgCI,4BAAA;AzDkwRJ;AyD9vRA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AzDgwRF;AyD7vRA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,OAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,+BAAA;EACA,gCAAA;AzD+vRF;AyD5vRA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,6BAAA;AzD8vRF;AyDlwRA;EAMI,aAAA;EACA,sBAAA;EACA,YAAA;AzD+vRJ;AyD5vRE;EACE,uBAAA;EACA,qBAAA;AzD8vRJ;AyD1vRA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AzD4vRF;AyDzvRA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AzD2vRF;AyDxvRA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;AzD0vRF;AyDvvRA;EACE,aAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AzDyvRF;AyDtvRA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,+BAAA;EACA,4BAAA;EACA,uBAAA;AzDwvRF;AyDrvRA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mCAAA;EACA,gCAAA;EACA,2BAAA;AzDuvRF;AyDpvRA;EACE,eAAA;AzDsvRF;AyDnvRA;EACE,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AzDqvRF;AyDlvRA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AzDovRF;AyDjvRA;;;EAII,kCAAA;AzDkvRJ;AyD9uRA;EAGE,2IAAA;AzD8uRF;AyDruRA;EAEE,4IAAA;AzDsuRF;AyD7tRA;EAEE,kFAAA;AzD8tRF;AyDvtRA;EACE,qCAAA;EAGA,6CAAA;EACA,0CAAA;EACA,wCAAA;EACA,qCAAA;AzDutRF;AyDptRA;EACE,0CAAA;AzDstRF;AyDntRA;EACE,0CAAA;EACA,wCAAA;AzDqtRF;AyDntRE;EACE,uBAAA;AzDqtRJ;AyDltRE;EACE,uBAAA;AzDotRJ;AyDhtRA;EACE;IACE,yBAAA;EzDktRF;EyD/sRA;IACE,6BAAA;EzDitRF;EyD9sRA;IACE,yBAAA;EzDgtRF;AACF;AyD7sRA;EACE,4BAAA;AzD+sRF;AyD5sRA;EACE,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;AzD8sRF;AyDltRA;;EAQI,+BAAA;AzD8sRJ;AyD1sRA;EAEI,qBAAA;AzD2sRJ;AyD7sRA;EAMI,8BAAA;EACA,qBAAA;AzD0sRJ;AyDjtRA;;EAWM,8BAAA;AzD0sRN;A0D/8RE;EACE,cAAA;A1Di9RJ;A0D/8RI;;EAEE,cAAA;A1Di9RN;A0D98RI;EACE,mBAAA;A1Dg9RN;A0D78RI;EACE,cAAA;A1D+8RN;A0Dh9RI;;EAII,cAAA;A1Dg9RR;A0D58RK;EACC,yBAAA;A1D88RN;A0D38RK;EACC,2BAAA;A1D68RN;A0Dv8RI;;;EAGE,cAAA;A1Dy8RN;A0Dr8RE;EACE,WAAA;EACA,yBAAA;A1Du8RJ;A2Dr+RC;ElCXC,sBAAA;EACA,SAAA;EACA,UAAA;EAGA,0BAAA;EACA,gBAAA;EAEA,6BAAA;EkCMA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oHAAA;EACA,qEAAA;A3D2+RF;AIlgSE;EACE,cAAA;EACA,WAAA;AJogSJ;AIlgSE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJmgSJ;AI3gSE;EACE,cAAA;EACA,WAAA;AJ6gSJ;AI3gSE;EAEE,cAAA;EACA,WAAA;EACA,WAAA;AJ4gSJ;A2Dz/RE;EAvBA,6CAAA;A3DmhSF;A2D7gSC;;EAuBG,SAAA;EACA,UAAA;EACA,gBAAA;A3D0/RJ;A2Dt/RE;EACE,aAAA;A3Dw/RJ;A2Dt/RI;EACE,UAAA;A3Dw/RN;A2Dp/RE;;EAEE,aAAA;A3Ds/RJ;A2Dn/RE;EACE,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;A3Dq/RJ;A2Dl/RE;EACE,wHAAA;A3Do/RJ;A2Dj/RE;;EAEE,4KAAA;A3Dm/RJ;A2D9+RE;EACE,cAAA;A3Dg/RJ;A2D7+RE;;EAEE,mBAAA;A3D++RJ;A2D5+RE;EACE,eAAA;EACA,mHAAA;A3D8+RJ;A2D1+RE;EACE,sBAAA;A3D4+RJ;A2Dz+RE;EACE,cAAA;A3D2+RJ;A2D1+RI;EACE,cAAA;A3D4+RN;A2D1+RI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;EACA,WAAA;A3D4+RN;A2Dv+RG;EACC,cAAA;A3Dy+RJ;A2Dx+RI;EACE,cAAA;A3D0+RN;A2Dt+RE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;A3Dw+RJ;A2Dr+RE;;EAEE,gBAAA;A3Du+RJ;A2Dp+RE;;;EAGE,6BAAA;A3Ds+RJ;A2Dn+RE;EACE,cAAA;A3Dq+RJ;A2Dt+RE;;EAII,cAAA;A3Ds+RN;A2Dl+RE;EACE,yBAAA;A3Do+RJ;A2Dj+RE;;;EAGE,+BAAA;A3Dm+RJ;A2Dh+RE;EACE,8BAAA;A3Dk+RJ;A2D/9RE;;;EAGE,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;A3Di+RJ;A2D79RI;;;EACE,kBAAA;EACA,gBAAA;A3Di+RN;A2D9+RE;;;EAiBI,OAAA;EACA,cAAA;EACA,eAAA;A3Dk+RN;A2Dj+RM;;;EACE,eAAA;A3Dq+RR;A2D1/RE;;;;;;EA0BI,qBAAA;A3Dw+RN;A2Dp+RE;EACE,gBAAA;A3Ds+RJ;A2Dn+RE;;EAEE,8CAAA;A3Dq+RJ;A2Dl+RE;;EAEE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iGAAA;A3Do+RJ;A2D5+RE;;;;EAaI,eAAA;EACA,eAAA;EACA,6HAAA;A3Dq+RN;A2Dp/RE;;;;EAkBM,iBAAA;EACA,UAAA;EACA,sFAAA;A3Dw+RR;A2D5/RE;;EA0BI,wBAAA;A3Ds+RN;A2Dn+RK;;;;EAGG,eAAA;A3Ds+RR;A2Dl+RI;;EAlOF,6CAAA;A3DwsSF;A2Dj+RE;EACE,WAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;A3Dm+RJ;A2D/9RI;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;A3Di+RN;A2D99RM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;A3Dg+RR;A2D39RI;EACE,MAAA;EACA,UAAA;A3D69RN;A2Dx/RE;EA+BI,sBAAA;EACA,kBAAA;A3D49RN;A2D39RM;EACE,+DAAA;A3D69RR;A2Dz9RK;EACC,sBAAA;A3D29RN;A2Dx9RI;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,2BAAA;EACA,+DAAA;A3D09RN;A2Dr9RM;;EAEE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,qNAAA;EAGA,WAAA;A3Dq9RR;A2Dn9RM;EACE,2CAAA;A3Dq9RR;A2Dn9RM;EACE,2CAAA;A3Dq9RR;A2Dj9RI;;EAEE,cAAA;A3Dm9RN;A2D78RM;;EACE,2CAAA;A3Dg9RR;A2D98RM;;EACE,2CAAA;A3Di9RR;A2D78RI;EACE,aAAA;A3D+8RN;A2D58RI;EAEE,2BAAA;A3D68RN;A2D58RM;EACE,4CAAA;A3D88RR;A2D58RM;EACE,0CAAA;A3D88RR;A2Dz8RE;;;EAGE,cAAA;A3D28RJ;A2Dx8RE;EACE,iBAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;A3D08RJ;A2Dx8RI;;EAGI,gBAAA;EACA,gBAAA;EACA,eAAA;A3Dy8RR;A2Dv8RQ;;;;;;;;EAIE,cAAA;A3D68RV;A2D38RU;;;;;;;;EACE,gCAAA;A3Do9RZ;A2Dx+RE;;EA4BI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,sBAAA;A3Dg9RN;A2D98RM;;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,kEAAA;EACA,WAAA;A3Di9RR;A2Dz/RE;EA6CI,UAAA;A3D+8RN;A2D5/RE;EAkDM,cAAA;A3D68RR;A2D58RQ;EACE,cAAA;A3D88RV;A2D58RQ;EACE,YAAA;A3D88RV;A2D38RM;EACE,cAAA;A3D68RR;A2Dz8RI;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;A3D28RN;A2Dv8RE;;;;EAKI,kBAAA;A3Dw8RN;A2Dv8RM;;;;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,yBAAA;EACA,UAAA;EACA,kHAAA;EAEA,WAAA;A3D28RR;A2D39RE;;;;;;;;EAsBI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;A3D+8RN;A2D3+RE;;;;EAiCI,sBAAA;A3Dg9RN;A2Dj/RE;;;;EAqCI,kBAAA;A3Dk9RN;A2Dv/RE;;;;;;;;EA0CI,YAAA;EACA,iBAAA;A3Du9RN;A2Dn9RE;;EAGI,mBAAA;A3Do9RN;A2Dh9RE;EACE,WAAA;A3Dk9RJ;A2D/8RM;;EACE,oBAAA;EACA,UAAA;EACA,oHAAA;A3Dk9RR;A2Dz9RE;;EAcI,uBAAA;A3D+8RN;A2D79RE;;EAmBI,mBAAA;A3D88RN;A2D18RK;;EAGG,aAAA;EACA,mBAAA;EACA,gGAAA;A3D28RR;A2Dh9RK;;EASK,UAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;A3D28RV;A2Dv9RK;;EAgBK,UAAA;A3D28RV;A2Dr8RE;EACE,WAAA;A3Du8RJ;A2Dx8RE;;;;EAYI,OAAA;EACA,+BAAA;EACA,mBAAA;A3Dk8RN;A2Dh9RE;;;;EAiBM,UAAA;A3Dq8RR;A2Dt9RE;;;;;;;;EAsBM,SAAA;EACA,eAAA;EACA,iBAAA;A3D08RR;A2Dl+RE;;;;;;;;EA0BQ,qBAAA;EACA,UAAA;A3Dk9RV;A2D7+RE;;EAkCI,qBAAA;A3D+8RN;A2D58RI;EACE,oBAAA;A3D88RN;A2D/8RI;;EAKI,aAAA;A3D88RR;A2Dn9RI;EAQI,gCAAA;A3D88RR;A2D3/RE;EAkDI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;A3D48RN;A2Dx8RE;EACE,SAAA;EACA,UAAA;A3D08RJ;A2D58RE;;EAKI,sBAAA;A3D28RN;A2Dv8RE;;;;EAIE,gBAAA;A3Dy8RJ;A2Dt8RE;;EAIM,eAAA;EACA,kBAAA;A3Ds8RR;A2Dj8RE;EACE,UAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;A3Dm8RJ;A2Dl8RK;;EAEC,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;A3Do8RN;A2Dj8RK;EACC,kBAAA;A3Dm8RN;A2D97RE;;EAEE,qCAAA;EACA,gBAAA;EACA,mBAAA;A3Dg8RJ;A2D97RI;;EACE,oCAAA;A3Di8RN;A2Dx8RE;;EAWI,qCAAA;EACA,oBAAA;A3Di8RN;A2D78RE;;EAeI,qCAAA;EACA,mBAAA;A3Dk8RN;A2Dh8RQ;;;;EAEE,0CAAA;A3Do8RV;A2D57RC;EAEG,oBAAA;A3D67RJ;A4DplTE;;;;;EAMI,cAAA;A5DqlTN;A6D3lTE;;;EAGE,gCAAA;EACA,mBAAA;A7D6lTJ;A6DjmTE;;;EAMI,aAAA;EACA,oBAAA;A7DgmTN;A6D/lTM;;;;;;EAEE,gBAAA;A7DqmTR;A6DhmTE;EACE,uBAAA;A7DkmTJ;A6D/lTE;EACE,mBAAA;A7DimTJ;A6D9lTE;EACE,gBAAA;A7DgmTJ;A6D7lTE;;EAEE,MAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;A7D+lTJ;A6D5lTE;EACE,yBAAA;A7D8lTJ;A6D3lTE;EACE,SAAA;A7D6lTJ;A6D1lTE;;;;EAIE,gCAAA;A7D4lTJ;A6DzlTE;;;;EAIE,eAAA;A7D2lTJ;A6DxlTE;;;;EAIE,OAAA;EACA,cAAA;EACA,eAAA;A7D0lTJ;A6DzlTI;;;;EACE,eAAA;A7D8lTN;A6D1lTE;;EAEE,WAAA;A7D4lTJ;A6DzlTE;;;;;;EAME,WAAA;EACA,6BAAA;A7D2lTJ;A6DlmTE;;;;;;;;;;;;EAUI,WAAA;A7DsmTN;A6DhnTE;;;;;;EAcM,UAAA;A7D0mTR;A6DzmTQ;;;;;;;;;;;;EAEE,gBAAA;A7DqnTV;A6DhnTE;EACE,6BAAA;A7DknTJ;A6D/mTE;EACE,yBAAA;A7DinTJ;A6D9mTE;EACE,WAAA;EACA,eAAA;A7DgnTJ;A6D/mTI;EACE,eAAA;A7DinTN;A6DrnTE;;;;EAUI,WAAA;A7DinTN;A6D3nTE;;EAeI,WAAA;A7DgnTN;A6D/nTE;;EAkBM,WAAA;A7DinTR;A6D5mTE;;EAEE,yBAAA;A7D8mTJ;A6DxmTI;;;;;;EAGE,2CAAA;EACA,YAAA;A7D6mTN;A6DnnTE;;EASI,2CAAA;A7D8mTN;A6D5mTQ;;;;EAEE,gDAAA;A7DgnTV;A8D/vTE;EACE,cAAA;EACA,iBAAA;A9DiwTJ;A8D7vTK;EACC,iBAAA;A9D+vTN;A8DzvTK;;EACC,kBAAA;EACA,8BAAA;A9D4vTN;A8DtvTK;;EACC,iBAAA;A9DyvTN;A8DhvTO;;;;;;EACC,2BAAA;A9DuvTR;A8D9uTO;;;;EACC,kBAAA;EACA,iBAAA;A9DmvTR;A8D5uTS;;;;EACC,cAAA;A9DivTV;A8D1uTK;EACC,wBAAA;A9D4uTN;A8DpuTS;;;;EACC,WAAA;EACA,UAAA;A9DyuTV;A8D/tTW;;;EACC,0CAAA;A9DmuTZ;A8D/tTW;;;EACC,wCAAA;A9DmuTZ;A8DttTS;;;;EACC,WAAA;EACA,OAAA;A9D2tTV;A8DptTO;;;;;;;;EACC,iBAAA;A9D6tTR;A8DttTO;EACC,gBAAA;EACA,kBAAA;A9DwtTR;A8DjtTO;EACC,mBAAA;EACA,kBAAA;A9DmtTR;A8D5sTO;EACC,+BAAA;A9D8sTR;A8DtsTO;;EACC,sBAAA;A9DysTR;A8DpsTE;EACE,SAAA;A9DssTJ;A8DpsTO;EACC,mBAAA;EACA,eAAA;A9DssTR;A+D71TE;EACE,+CAAA;EACA,0BAAA;A/D+1TJ;A+D51TE;EACE,kCAAA;EACA,gBAAA;A/D81TJ;A+D31TE;;;;;;;;EAMI,aAAA;EACA,gBAAA;A/D+1TN;A+Dt2TE;;;;EAWI,gBAAA;A/Di2TN;A+D71TE;EACE,SAAA;A/D+1TJ;A+D31TA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EAMA,wHAAA;EACA,qHAAA;EACA,gHAAA;A/Dw1TF;A+Dr1TA;EAGM,YAAA;EACA,gBAAA;EACA,YAAA;A/Dq1TN;A+Dn1TM;EACE,0BAAA;EACA,uBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;A/Dq1TR;A+D51TM;EAUI,cAAA;EACA,gBAAA;A/Dq1TV;A+Dl1TQ;EACE,uBAAA;A/Do1TV;A+Dj1TQ;;;EAGE,oCAAA;A/Dm1TV;A+Dt1TQ;;;EAMI,yBAAA;A/Dq1TZ;A+Dh1TM;EACE,6BAAA;A/Dk1TR;A+Dv3TA;EA0CM,uBAAA;EACA,4BAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;A/Dg1TN;A+D/3TA;EAqDM,gBAAA;EACA,iBAAA;EACA,cAAA;A/D60TN;A+Dp4TA;EA2DM,gBAAA;EACA,uBAAA;A/D40TN;A+Dx4TA;EAkEM,gBAAA;A/Dy0TN;A+D34TA;EAwEM,gBAAA;EACA,iBAAA;A/Ds0TN;A+D/4TA;EA+EM,oCAAA;EACA,yBAAA;A/Dm0TN;A+Dn5TA;EAoFM,oCAAA;A/Dk0TN;A+D7zTA;;EAGI,2BAAA;A/D8zTJ;A+D1zTA;EACE,cAAA;A/D4zTF;A+D1zTE;;;;EAKI,cAAA;A/D2zTN;A+DvzTE;;;;EAKI,cAAA;A/DwzTN;A+DnzTA;EAEI,2BAAA;A/DozTJ;A+DhzTA;;EAGI,uBAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,8BAAA;A/DizTJ;A+D/yTI;;;;;;EAGE,yBAAA;A/DozTN;A+Dh0TA;;EAiBI,4BAAA;EACA,uBAAA;A/DmzTJ;AgEr/TA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AhEu/TF;AgEp/TA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AhEs/TF;AgEz/TA;EAMI,oCAAA;EACA,2BAAA;EACA,oBAAA;AhEs/TJ;AgE9/TA;EAYI,oCAAA;AhEq/TJ;AgEjgUA;EAgBI,oCAAA;AhEo/TJ;AgEpgUA;;EAqBI,WAAA;AhEm/TJ;AgE/+TA;EACE,OAAA;EACA,sBAAA;AhEi/TF;AgE9+TA;EACE,sBAAA;EACA,oBAAA;AhEg/TF;AgE7+TA;EACE,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uBAAA;EAEA,mCAAA;EACA,gCAAA;EACA,2BAAA;AhE8+TF;AgE7+TE;EACE,yBAAA;AhE++TJ;AgE7+TE;;EAEE,qBAAA;EACA,UAAA;EACA,wDAAA;AhE++TJ;AiE9iUA;EACE,cAAA;EACA,gBAAA;AjEgjUF;AiEljUA;EAKI,qBAAA;AjEgjUJ;AiErjUA;EASI,cAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AjE+iUJ;AkEtjUA;EACE,2BAAA;EACA,mCAAA;AlEwjUF;AkE1jUA;;;;EASM,aAAA;EACA,eAAA;EACA,iBAAA;AlEujUN;AkElkUA;EAeM,aAAA;EACA,iBAAA;AlEsjUN;AkEtkUA;EAoBM,eAAA;EACA,iBAAA;AlEqjUN;AkE1kUA;EAyBM,eAAA;EACA,gBAAA;AlEojUN;AkEjjUI;;;;EAKI,aAAA;EACA,eAAA;EACA,iBAAA;AlEkjUR;AkEzjUI;EAWI,aAAA;EACA,iBAAA;AlEijUR;AkE7iUI;;;;EAKI,sBAAA;AlE8iUR;AkE1iUI;;;;EAKI,eAAA;AlE2iUR;AkEhjUI;;EASI,eAAA;EACA,iBAAA;AlE2iUR;AkEziUM;;;;EAKI,iBAAA;AlE0iUV;AkEjnUA;;EA8EM,aAAA;AlEuiUN;AkErnUA;EAkFM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AlEsiUN;AkEpiUM;EACE,yBAAA;AlEsiUR;AkEpiUQ;EACE,yBAAA;AlEsiUV;AkEpoUA;EAsGM,eAAA;EACA,aAAA;EACA,iBAAA;AlEiiUN;AkE9hUI;EACE,sBAAA;AlEgiUN;AkE5oUA;EAiHI,eAAA;EACA,aAAA;EACA,mBAAA;AlE8hUJ;AkEjpUA;EAuHI,aAAA;EACA,kBAAA;AlE6hUJ;AkEzhUA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AlE2hUF;AkE/hUA;EAOI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;AlE2hUJ;AkE1hUI;;;EAGE,qBAAA;AlE4hUN;AkEzhUI;EACE,YAAA;AlE2hUN;AkEvhUE;EAEI,cAAA;EACA,eAAA;AlEwhUN;AkEnhUA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AlEqhUF;AkEnhUE;EACE,yBAAA;EACA,mBAAA;AlEqhUJ;AmE7rUA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;AnE+rUF;AmExsUA;EAYI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AnE+rUJ;AmExrUI;;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AnE2rUN;AmEvrUE;EACE,YAAA;EACA,0BAAA;AnEyrUJ;AmEvrUE;EACE,SAAA;EACA,2BAAA;AnEyrUJ;AmEtrUE;EACE,gCAAA;AnEwrUJ;AmErrUE;EAEI,QAAA;EACA,WAAA;AnEsrUN;AmElrUE;;;EAGE,oBAAA;AnEorUJ;AmEvrUE;;;EAKI,QAAA;EACA,OAAA;AnEurUN;AmE7rUE;;;EAUI,wBAAA;EACA,kBAAA;AnEwrUN;AmEprUE;EAEI,SAAA;AnEqrUN;AmEjrUE;;EAGI,QAAA;EACA,WAAA;AnEkrUN;AmE9qUE;EAEI,SAAA;EACA,WAAA;AnE+qUN;AmE3qUE;EAGM,WAAA;AnE2qUR;AmEtqUE;EAEI,SAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AnEuqUN;AmErqUM;EACE,oBAAA;AnEuqUR;AmE/qUE;;;EAkBI,UAAA;AnEkqUN;AmE5pUE;EAEI,QAAA;EACA,WAAA;EACA,UAAA;EACA,8BAAA;AnE6pUN;AmE3pUM;EACE,oBAAA;AnE6pUR;AmErqUE;EAYM,YAAA;EACA,WAAA;EACA,sBAAA;AnE4pUR;AmE1qUE;;;EAqBI,UAAA;AnE0pUN;AmEppUE;EAEI,yBAAA;AnEqpUN;AmExpUA;EAQI,yBAAA;AnEmpUJ;AmE/oUA;EACE,yBAAA;AnEipUF;AmE9oUA;EACE,mDAAA;AnEgpUF;AmE3oUI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,UAAA;EACA,sBAAA;AnE6oUN;AmEppUE;EAWI,kBAAA;AnE4oUN;AmE5pUA;;EAsBI,kBAAA;EACA,UAAA;AnE0oUJ;AmEtoUA;EACE,mDAAA;AnEwoUF;AmEzoUA;EAMI,wCAAA;AnEsoUJ;AmE5oUA;EAUI,eAAA;AnEqoUJ;AmEloUE;EAII,iBAAA;AnEioUN;AmElpUA;EAsBI,iBAAA;AnE+nUJ;AmE5nUE;EAEI,yBAAA;AnE6nUN;AmE1nUI;EACE,YAAA;AnE4nUN;AmEloUE;EAWM,YAAA;AnE0nUR;AmEroUE;EAiBM,sBAAA;AnEunUR;AmEjnUI;EACE,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,UAAA;EACA,WAAA;AnEmnUN;AmE/mUM;EACE,WAAA;AnEinUR;AmE9nUE;EAkBI,kBAAA;AnE+mUN;AmEhrUA;;EAuEI,kBAAA;EACA,UAAA;AnE6mUJ;AmErrUA;;EA8EM,UAAA;AnE2mUN;AmErmUE;EACE,kBAAA;AnEumUJ;AmEnmUA;EAEI,qBAAA;AnEomUJ;AmEtmUA;EAMI,yBAAA;AnEmmUJ;AmE/lUI;EACE,yBAAA;AnEimUN;AmE5mUA;EAgBI,yBAAA;AnE+lUJ;AmE5lUE;EAEI,UAAA;AnE6lUN;AmEvlUE;EAEI,UAAA;AnEwlUN;AmE1lUE;EAMI,aAAA;AnEulUN;AmEplUI;EAEI,mBAAA;AnEqlUR;AmEjmUA;;EAmBI,qBAAA;EACA,gBAAA;AnEklUJ;AmE1kUE;;;;EAEI,uBAAA;EACA,yBAAA;AnE8kUN;AmEjlUE;;;;EAOI,yBAAA;AnEglUN;AmEvlUE;;;;EAWI,yBAAA;AnEklUN;AmE7kUA;EAIM,UAAA;AnE4kUN;AmEvkUI;EACE,YAAA;AnEykUN;AmE1kUI;EAII,YAAA;AnEykUR;AmE7kUI;EAQI,iBAAA;AnEwkUR;AmEhkUI;EAEI,YAAA;AnEikUR;AmEnkUI;EAIM,cAAA;EACA,gBAAA;AnEkkUV;AmE3jUA;EAGM,uBAAA;EACA,yBAAA;AnE2jUN;AmE/jUA;EAQM,yBAAA;AnE0jUN;AmElkUA;EAYM,yBAAA;AnEyjUN;AmEpjUA;EAKE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AnEkjUF;AmE3jUA;EAYI,WAAA;EACA,YAAA;AnEkjUJ;AmE9iUA;EACE,cAAA;AnEgjUF;AmE3iUI;EACE,oCAAA;EACA,8BAAA;AnE6iUN;AmE1iUI;EACE,oCAAA;EACA,8BAAA;AnE4iUN;AmEziUI;EACE,wCAAA;EACA,kCAAA;AnE2iUN;AmEriUM;EACE,8BAAA;AnEuiUR;AmEniUI;EACE,gBAAA;AnEqiUN;AmEliUI;EACE,gBAAA;AnEoiUN;AmE9hUM;EACE,0CAAA;AnEgiUR;AmE9hUM;EACE,0CAAA;AnEgiUR;AmE7hUM;EACE,4BAAA;AnE+hUR;AmE1hUM;EACE,2CAAA;AnE4hUR;AmEzhUM;EACE,+CAAA;AnE2hUR;AmErhUA;EACE,iBAAA;AnEuhUF;AmErhUA;EAIE,uBAAA;AnEohUF;AmEjhUA;EAEI,WAAA;AnEkhUJ;AmEphUA;EAKI,aAAA;AnEkhUJ;AmEjhUI;EACE,gBAAA;AnEmhUN;AmE1hUA;;;EAeI,QAAA;AnEghUJ;AmE3gUE;EAEI,2BAAA;AnE4gUN;AmEvgUA;;;EAKE,uBAAA;AnEugUF;AmEpgUA;EACE,oBAAA;EACA,eAAA;AnEsgUF;AmEpgUE;;EAEE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AnEsgUJ;AmEngUE;EACE,6BAAA;EACA,kBAAA;EACA,qBAAA;AnEqgUJ;AmEhgUE;EACE,2BAAA;EACA,oBAAA;AnEkgUJ;AmE//TE;EACE,yBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AnEigUJ;AmE//TI;EACE,UAAA;AnEigUN;AmE7/TE;EAEI,oBAAA;AnE8/TN;AmEx/TE;EACE,yBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AnE0/TJ;AmEx/TI;EACE,UAAA;AnE0/TN;AmEt/TE;EAEI,oBAAA;AnEu/TN;AoEtkVA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,uDAAA;EACA,oDAAA;EACA,+CAAA;ApEwkVF;AoErkVA;EACE,gBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;ApEukVF;AoEpkVA;EACE,aAAA;ApEskVF;AoEnkVA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;ApEqkVF;AoElkVA;EACE,kBAAA;ApEokVF;AoEjkVA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;ApEmkVF;AoEjkVE;EACE,YAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;ApEmkVJ;AoEhkVE;EACE,yBAAA;ApEkkVJ;AoE9jVA;EACE,aAAA;ApEgkVF;AoE7jVA;EACE,WAAA;ApE+jVF;AoE7jVE;EACE,cAAA;ApE+jVJ;AoEnkVA;EAQI,yBAAA;ApE8jVJ;AoE3jVE;EAEI,yBAAA;ApE4jVN;AoEzjVE;EAEI,yBAAA;ApE0jVN;AoErjVA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;ApEujVF;AoErjVE;EACE,SAAA;EACA,cAAA;ApEujVJ;AoEnjVA;EACE,cAAA;ApEqjVF;AoEljVA;EACE,WAAA;ApEojVF;AqEtqVA;EACE,oBAAA;ArEwqVF;AsExqVE;EACE,cAAA;AtE0qVJ;AsEvqVE;EACE,cAAA;AtEyqVJ;AsEtqVE;EACE,cAAA;AtEwqVJ;AsErqVE;EACE,cAAA;AtEuqVJ;AsEpqVE;EACE,cAAA;AtEsqVJ;AsEnqVE;;EAEE,cAAA;AtEqqVJ;AsElqVE;EACE,cAAA;AtEoqVJ;AsEjqVE;;;;;EAKE,cAAA;AtEmqVJ;AsEhqVE;EACE,yBAAA;EACA,kBAAA;AtEkqVJ;AsE/pVE;EACE,yBAAA;EACA,kBAAA;AtEiqVJ;AsE9pVE;EACE,yBAAA;EACA,kBAAA;AtEgqVJ;AuEjtVE;EAEI,aAAA;AvEktVN;AuEptVE;EAMI,aAAA;EACA,sBAAA;EACA,YAAA;AvEitVN;AuEztVE;EAWM,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AvEitVR;AuEnuVA;EAwBI,aAAA;AvE8sVJ;AwEtuVA;ExEwuVE,YAAY;AACd;AwEzuVA;ECGE,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,QAAA;EACA,6BAAA;EACA,gBAAA;AzEyuVF;AyEtuVE;EACE,YAAA;AzEwuVJ;AwEtvVA;ECmBE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;AzEsuVF;AyEjuVE;EAAA;IACE,YAAA;EzEouVF;AACF;AwEpwVA;ECmCqC,aAAA;AzEouVrC;AwEvwVA;ECsCE,0BAAA;EACA,uBAAA;EACA,kBAAA;AzEouVF;AwE5wVA;;EC6CI,0BAAA;EACA,mBAAA;AzEmuVJ;AwEjxVA;EEGM,gBAAA;A1EixVN;AwEpxVA;EEOI,iBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EC6zBF,4BAAA;EACA,6BAAA;ED5zBE,gBAAA;A1EixVJ;AwE7xVA;EEeM,aAAA;A1EixVN;AwEhyVA;EGu0BE,4BAAA;EACA,6BAAA;A3E49TF;AwEpyVA;EIEI,WAAA;A5EqyVJ;AwEvyVA;EIKM,OAAA;EACA,uBAAA;EACA,cAAA;A5EqyVN;A4EpyVM;EACE,cAAA;A5EsyVR;AwE/yVA;EIaM,cAAA;A5EqyVN;AwElzVA;EIgBM,yBAAA;A5EqyVN;AwErzVA;EImBM,cAAA;A5EqyVN;AwExzVA;EKCE,kBAAA;EACA,qBAAA;EACA,kLAAA;EAcA,mGAAA;EAGA,kCAAA;EACA,4BAAA;EAEA,qCAAA;A7E0yVF;A6EzyVE;EACE;IACE,qBAAA;E7E2yVJ;AACF;A6EnyVA;EACE,iBAAA;EACA,cAAA;EACA,oBAAA;A7EqyVF;AwE30VA;EK0CE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7EoyVF;AwEj1VA;EKiDE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A7EmyVF;AwEx1VA;EKyDE,QAAA;EACA,OAAA;EACA,wCAAA;EACA,gCAAA;A7EkyVF;AwE91VA;EKgEE,SAAA;EACA,OAAA;EACA,wCAAA;EACA,+BAAA;A7EiyVF;AwEp2VA;EKuEE,SAAA;EACA,UAAA;EACA,0CAAA;EACA,6BAAA;A7EgyVF;A6E7xVA;EACE;IACE,uDAAA;E7E+xVF;E6E7xVA;IACE,yDAAA;E7E+xVF;AACF;A6E5xVA;EACE;IACE,sDAAA;E7E8xVF;E6E5xVA;IACE,wDAAA;E7E8xVF;AACF;A6E3xVA;EACE;IACE,sDAAA;E7E6xVF;E6E3xVA;IACE,wDAAA;E7E6xVF;AACF;AwEl4VA;EK2GE,6CAAA;EACA,qCAAA;EACA,sEAAA;EAYA,sCAAA;EACA,sCAAA;EACA,mCAAA;EACA,iCAAA;EACA,8BAAA;A7E+wVF;AwE54VA;EMCE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;A9E84VF;AwEl5VA;EMOI,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;A9E84VJ;AwEz5VA;EMeI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;A9E64VJ;AwEp6VA;EM2BI,wBAAA;A9E44VJ;AwEv6VA;EM+BI,aAAA;A9E24VJ;AwE16VA;EMmCI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,iCAAA;EACA,oCAAA;A9E04VJ;AwEv7VA;EMiDI,YAAA;A9Ey4VJ;AwE17VA;EMqDI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,iCAAA;EACA,oCAAA;A9Ew4VJ;AwEv8VA;EMmEI,aAAA;A9Eu4VJ;AwE18VA;EMuEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,iCAAA;EACA,oCAAA;A9Es4VJ;AwEv9VA;EMqFI,aAAA;A9Eq4VJ;AwE19VA;EMyFI,YAAA;A9Eo4VJ;AwE79VA;EM6FI,aAAA;A9Em4VJ;AwEh+VA;EMkGE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;A9Ei4VF;AwEz+VA;EM4GE,mBAAA;A9Eg4VF;A8E93VE;EACE,wFAAA;A9Eg4VJ;A8E13VE;EACE,wFAAA;A9E43VJ;AwEl/VA;EM+HE,aAAA;A9Es3VF;AwEr/VA;EMmIE,aAAA;EACA,sBAAA;A9Eq3VF;AwEz/VA;EMwIE,kBAAA;A9Eo3VF;AwE5/VA;EM4IE,WAAA;A9Em3VF;AwE//VA;EM8II,WAAA;A9Eo3VJ;AwElgWA;EMoJI,qBAAA;A9Ei3VJ;AwErgWA;EMwJI,oCAAA;A9Eg3VJ;AwExgWA;EM6JE,gBAAA;A9E82VF;A8E52VE;EACE,iBAAA;EAWA,6DAAA;EACA,4BAAA;EACA,kCAAA;EACA,sCAAA;A9Eo2VJ;A8Eh3VI;EACE,gBAAA;A9Ek3VN;A8E/2VI;EACE,mBAAA;A9Ei3VN;A8Ev2VE;EACE,kBAAA;A9Ey2VJ;A8Et2VE;EACE,qBAAA;A9Ew2VJ;A8Er2VE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;A9Eu2VJ;A8Ep2VE;EACE,cAAA;EACA,eAAA;A9Es2VJ;A8El2VA;EAAA;IAEI,wBAAA;E9Eo2VF;E8Et2VF;IAMI,sBAAA;E9Em2VF;E8Ez2VF;IASM,0BAAA;E9Em2VJ;E8E52VF;IAcI,gBAAA;E9Ei2VF;E8E/2VF;IAkBI,mBAAA;IACA,8BAAA;IACA,mBAAA;E9Eg2VF;E8Ep3VF;IAwBI,qBAAA;E9E+1VF;E8Ev3VF;IA4BM,sBAAA;E9E81VJ;E8E13VF;IAgCM,sBAAA;IACA,0BAAA;IACA,6BAAA;IACA,yBAAA;IACA,4BAAA;IACA,8BAAA;E9E61VJ;E8El4VF;IAyCM,sBAAA;E9E41VJ;AACF;AwE7kWA;EOCE,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;A/E+kWF;AwEplWA;EOUE,eAAA;EACA,iBAAA;A/E6kWF;AwExlWA;EOeE,WAAA;EACA,YAAA;A/E4kWF;A+EzkWA;EAAA;IAEI,aAAA;E/E2kWF;AACF;A+ExkWA;EAAA;IAEI,aAAA;IACA,qCAAA;IACA,qBAAA;IACA,kBAAA;IACA,iBAAA;E/E0kWF;E+EhlWF;IAUI,eAAA;IACA,iBAAA;E/EykWF;E+EplWF;IAeI,WAAA;IACA,aAAA;E/EwkWF;AACF;A+ErkWA;EAAA;IAEI,aAAA;E/EukWF;AACF;AwEvnWA;EGEI,6BAAA;A3EwnWJ;A2EnnWE;EACE,oBAAA;A3EqnWJ;AwE7nWA;EGaE,UAAA;A3EmnWF;AwEhoWA;EGiBE,oCAAA;A3EknWF;AwEnoWA;EGqBE,iBAAA;A3EinWF;AwEtoWA;EGyBE,wCAAA;A3EgnWF;AwEzoWA;EG6BE,aAAA;EACA,8BAAA;A3E+mWF;AwE7oWA;EGmCI,UAAA;A3E6mWJ;AwEhpWA;EGyCI,WAAA;EACA,YAAA;A3E0mWJ;A2EvmWI;EACE,eAAA;A3EymWN;A2EvmWI;EAEI,iBAAA;EACA,gBAAA;EACA,eAAA;A3EwmWR;A2EtmWQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;A3EwmWV;AwElqWA;EG+DM,gBAAA;EACA,eAAA;A3EsmWN;AwEtqWA;EGuEI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;A3EkmWJ;A2EhmWI;EACE,aAAA;A3EkmWN;AwE/qWA;EGkFI,4BAAA;A3EgmWJ;AwElrWA;EGsFI,gBAAA;A3E+lWJ;AwErrWA;EG0FI,qBAAA;A3E8lWJ;A2E5lWI;EACE,yBAAA;A3E8lWN;AwE3rWA;EGkGI,YAAA;A3E4lWJ;A2E1lWI;EACE,cAAA;A3E4lWN;AwEjsWA;;EG2GI,YAAA;EACA,uBAAA;A3E0lWJ;AwEtsWA;EGgHI,mBAAA;EACA,eAAA;A3EylWJ;AwE1sWA;EGqHI,eAAA;A3EwlWJ;AwE7sWA;EGyHI,gBAAA;A3EulWJ;AwEhtWA;;EG8HI,uBAAA;A3EslWJ;AwEptWA;EGkII,yBAAA;EACA,4BAAA;A3EqlWJ;AwExtWA;EGuII,2BAAA;A3EolWJ;AwE3tWA;EG6II,qBAAA;A3EilWJ;AwE9tWA;;;;EGoJI,8BAAA;A3EglWJ;AwEpuWA;;EGyJI,qBAAA;A3E+kWJ;AwExuWA;EG6JI,yBAAA;EACA,+BAAA;A3E8kWJ;AwE5uWA;;EGmKI,aAAA;A3E6kWJ;AwEhvWA;EGuKI,iBAAA;A3E4kWJ;AwEnvWA;EG4KE,eAAA;A3E0kWF;AwEtvWA;EG8KI,eAAA;EACA,iBAAA;A3E2kWJ;AwE1vWA;EGiLM,mBAAA;A3E4kWN;AwE7vWA;;EGsLI,oBAAA;A3E2kWJ;AwEjwWA;EG0LI,kCAAA;A3E0kWJ;AwEpwWA;;EGiMI,gBAAA;A3EukWJ;AwExwWA;EGqMI,qBAAA;A3EskWJ;AwE3wWA;;EG0MI,qBAAA;EACA,YAAA;A3EqkWJ;AwEhxWA;EG+MI,yBAAA;EACA,+BAAA;EACA,mBAAA;A3EokWJ;AwErxWA;;;EGyNM,6BAAA;A3EikWN;AwE1xWA;EG8NI,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,yBAAA;A3E8jWJ;AwElyWA;EGwOI,8BAAA;A3E6jWJ;AwEryWA;;EG4OI,mBAAA;A3E6jWJ;A2EvjWI;EACE,YAAA;A3EyjWN;A2E1jWI;EAGI,YAAA;A3E0jWR;AwE/yWA;EG6PI,iBAAA;A3EqjWJ;AwElzWA;EGkQE,sBAAA;A3EmjWF;AwErzWA;EGsQE,0BAAA;A3EkjWF;AwExzWA;EG0QE,iCAAA;A3EijWF;AwE3zWA;EG+QE,2BAAA;A3E+iWF;AwE9zWA;EGkRE,kCAAA;A3E+iWF;AwEj0WA;EGsRE,2BAAA;A3E8iWF;AwEp0WA;EGyRE,kCAAA;A3E8iWF;AwEv0WA;EG4RE,+BAAA;A3E8iWF;AwE10WA;EG+RE,kCAAA;A3E8iWF;AwE70WA;EGmSE,6BAAA;A3E6iWF;AwEh1WA;EGuSE,2BAAA;A3E4iWF;AwEn1WA;EG2SE,kCAAA;A3E2iWF;AwEt1WA;EG+SE,gBAAA;A3E0iWF;AwEz1WA;EGoTI,uBAAA;A3EwiWJ;AwE51WA;EGsTM,kBAAA;EACA,wBAAA;A3EyiWN;AwEh2WA;EG4TI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;A3EuiWJ;AwEt2WA;EGkUM,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;A3EuiWN;A2EpiWI;EAEI,4BAAA;A3EqiWR;AwE/2WA;EGiVE,iBAAA;EACA,oBAAA;A3EiiWF;AwEn3WA;EGuVI,iBAAA;A3E+hWJ;AwEt3WA;EG0VM,iBAAA;A3E+hWN;AwEz3WA;EG+VI,4BAAA;EACA,+BAAA;A3E6hWJ;AwE73WA;EGsWI,cAAA;EACA,mBAAA;A3E0hWJ;AwEj4WA;;EG2WI,YAAA;A3E0hWJ;AwEr4WA;EGkXM,iBAAA;A3EshWN;AwEx4WA;EGyXI,YAAA;A3EkhWJ;A2E/gWE;EAGE,mBAAA;A3E+gWJ;A2ElhWE;EAMI,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;A3E+gWN;AwEp5WA;EG0YI,UAAA;A3E6gWJ;A2E1gWE;EACE,SAAA;EACA,6BAAA;A3E4gWJ;A2E9gWE;EAKI,iBAAA;EACA,wBAAA;A3E4gWN;A2ElhWE;;EAWI,iBAAA;A3E2gWN;A2EthWE;EAeI,UAAA;EACA,SAAA;A3E0gWN;A2E1hWE;EAoBI,SAAA;A3EygWN;A2ErgWE;;EAGI,6BAAA;A3EsgWN;AwE96WA;EG8aE,uBAAA;A3EmgWF;A2E5/VQ;E5D7QJ,6BAAA;E4DgRQ,gBAAA;A3E6/VZ;AwEr7WA;EzDwKI,6BAAA;E4DwRE,gBAAA;EAEA,kBAAA;A3Ew/VN;AwE17WA;EGqcQ,iBAAA;EACA,gBAAA;EACA,iBAAA;A3Ew/VR;AwE/7WA;EG2cQ,SAAA;EACA,WAAA;A3Eu/VR;A2En/VI;EACE,YAAA;A3Eq/VN;A2Et/VI;;EAKI,uBAAA;EACA,YAAA;A3Eq/VR;A2El/VM;EAEI,cAAA;A3Em/VV;AwE98WA;EzDmJI,yBAAA;Af8zWJ;AwEj9WA;EGqeI,mBAAA;A3E++VJ;AwEp9WA;EQwBI,iBAAA;EACA,kBAAA;AhF+7WJ;AwEx9WA;EG2eI,cAAA;A3Eg/VJ;A2E/+VI;EACE,iBAAA;A3Ei/VN;AwE99WA;;;EGsfE,qBAAA;A3E6+VF;AwEn+WA;EG0fE,WAAA;EACA,gBAAA;EACA,MAAA;A3E4+VF;AwEx+WA;EGggBE,mBAAA;A3E2+VF;AwE3+WA;EGogBE,UAAA;EACA,aAAA;EACA,cAAA;A3E0+VF;AwEh/WA;EG0gBE,0BAAA;A3Ey+VF;AwEn/WA;EG8gBE,aAAA;EACA,2BAAA;A3Ew+VF;A2Et+VE;;EAEE,qBAAA;A3Ew+VJ;AwE3/WA;EGyhBI,qBAAA;A3Eq+VJ;AwE9/WA;EGiiBE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;A3Eg+VF;AwErgXA;EGwiBI,oBAAA;A3Eg+VJ;AwExgXA;EG4iBI,aAAA;EACA,SAAA;EACA,eAAA;A3E+9VJ;AwE7gXA;EGmjBE,UAAA;A3E69VF;AwEhhXA;EGujBE,UAAA;A3E49VF;AwEnhXA;EG4jBE,gBAAA;A3E09VF;AwEthXA;EGikBE,kBAAA;A3Ew9VF;AwEzhXA;;;EG2kBE,UAAA;A3Em9VF;AwE9hXA;EG+kBE,kBAAA;A3Ek9VF;AwEjiXA;EGmlBE,iBAAA;A3Ei9VF;AwEpiXA;EGwlBI,yBAAA;A3E+8VJ;AwEviXA;EG6lBE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;A3E68VF;AwE/iXA;EGsmBE,aAAA;A3E48VF;AwEljXA;EG0mBE,oBAAA;EACA,mBAAA;A3E28VF;AwEtjXA;EG+mBE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;A3E08VF;AwE7jXA;EGsnBI,WAAA;EACA,YAAA;EACA,mBAAA;A3E08VJ;AwElkXA;EG8nBI,kBAAA;A3Eu8VJ;AwErkXA;EGioBI,kBAAA;EACA,iEAAA;EAGA,eAAA;A3Eq8VJ;A2E/7VI;EACE,uBAAA;A3Ei8VN;AwE7kXA;EG+oBM,uBAAA;A3Ei8VN;AwEhlXA;EGmpBI,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,yBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,iEAAA;EAGA,eAAA;A3E67VJ;A2E17VE;EAEI,aAAA;A3E27VN;A2Er7VM;EACE,yBAAA;A3Eu7VR;A2E17VE;EAMM,yBAAA;A3Eu7VR;A2E77VE;EAUI,oCAAA;A3Es7VN;A2Eh7VE;EACE,YAAA;EACA,UAAA;A3Ek7VJ;AwE1mXA;EG2rBI,gBAAA;A3Ek7VJ;AwE7mXA;EG+rBI,QAAA;EACA,UAAA;EACA,cAAA;A3Ei7VJ;AwElnXA;EGosBM,eAAA;A3Ei7VN;AwErnXA;;;;EG+sBI,cAAA;A3E46VJ;AwE3nXA;EGotBE,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,uBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,eAAA;EACA,UAAA;A3E06VF;AwE1oXA;EGmuBI,iBAAA;A3E06VJ;AwE7oXA;EGwuBE,kBAAA;A3Ew6VF;AwEhpXA;EG0uBI,eAAA;A3Ey6VJ;AwEnpXA;EG6uBI,mBAAA;A3Ey6VJ;AwEtpXA;EGmvBI,cAAA;EACA,gBAAA;A3Es6VJ;AwE1pXA;;EG0vBE,uBAAA;A3Eo6VF;AwE9pXA;;EG4vBI,SAAA;EACA,kBAAA;EACA,YAAA;A3Es6VJ;AwEpqXA;;;;;;EGowBI,cAAA;A3Ew6VJ;AwE5qXA;;EGwwBI,cAAA;EACA,kBAAA;A3Ew6VJ;AwEjrXA;;EG8wBM,cAAA;EACA,iBAAA;A3Eu6VN;AwEtrXA;;EGoxBI,uBAAA;A3Es6VJ;AwE1rXA;;EGwxBI,yBAAA;A3Es6VJ;AwE9rXA;EG8xBI,YAAA;EACA,gBAAA;A3Em6VJ;A2El6VI;EACE,qBAAA;A3Eo6VN;AwErsXA;;EG6yBE,4HAAA;EAOA,0BAAA;A3Es5VF;AwE1sXA;EG0zBE,aAAA;EACA,YAAA;EAEA,0FAAA;EAMA,0BAAA;A3E64VF;AwEhtXA;EGu0BE,4BAAA;EACA,6BAAA;A3E44VF;AwEptXA;EG40BE,gDAAA;A3E24VF;AwEvtXA;EGg1BE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;A3E04VF;AwE7tXA;EGu1BE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,4BAAA;A3Ey4VF;A2Ev4VE;EACE,mCAAA;A3Ey4VJ;AwEtuXA;EGg2BI,yBAAA;EACA,kBAAA;A3Ey4VJ;A2Et4VE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;A3Ew4VJ;AwEtvXA;EGk3BI,UAAA;A3Eu4VJ;A2Ep4VE;EACE,eAAA;EACA,cAAA;A3Es4VJ;A2Ep4VI;EAEI,qBAAA;EACA,gBAAA;A3Eq4VR;A2Ej4VI;EACE,YAAA;A3Em4VN;A2Eh4VI;EACE,YAAA;A3Ek4VN;A2El5VE;EAoBI,iBAAA;A3Ei4VN;AwE1wXA;EG84BI,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;A3E+3VJ;AwEjxXA;EGs5BI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,gBAAA;A3E83VJ;AwExxXA;EG65BM,eAAA;A3E83VN;AwE3xXA;EGi6BI,SAAA;EACA,cAAA;A3E63VJ;AwE/xXA;EGs6BI,iBAAA;A3E43VJ;A2Ez3VE;EAEI,sBAAA;EACA,sBAAA;EACA,YAAA;A3E03VN;A2E93VE;EAQI,UAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;A3Ey3VN;A2Er4VE;EAgBI,SAAA;EACA,SAAA;A3Ew3VN;A2Ez4VE;EAqBI,iBAAA;A3Eu3VN;A2En3VE;EAEI,kBAAA;A3Eo3VN;AwExzXA;EGy8BI,eAAA;A3Ek3VJ;A2E/2VE;EACE,aAAA;A3Ei3VJ;AwE9zXA;EGi9BI,4DAAA;EACA,gBAAA;A3Eg3VJ;AwEl0XA;EGu9BE,gBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mCAAA;A3E82VF;AwEx0XA;EG69BI,iBAAA;A3E82VJ;AwE30XA;EGi+BI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;A3E62VJ;A2E52VI;EACE,cAAA;A3E82VN;AwEx1XA;EG8+BI,YAAA;A3E62VJ;AwE31XA;EGo/BI,oBAAA;EACA,oBAAA;A3E02VJ;AwE/1XA;EGy/BI,uBAAA;A3Ey2VJ;AwEl2XA;EG6/BI,wCAAA;EACA,gBAAA;A3Ew2VJ;AwEt2XA;EGogCI,uBAAA;A3Eq2VJ;AwEz2XA;EGwgCI,aAAA;A3Eo2VJ;AwE52XA;EG2gCI,wCAAA;EACA,gBAAA;A3Eo2VJ;AwEh3XA;EGkhCI,uBAAA;A3Ei2VJ;AwEn3XA;EGshCI,aAAA;A3Eg2VJ;AwEt3XA;EGyhCI,wCAAA;EACA,gBAAA;A3Eg2VJ;AwE13XA;EGgiCI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;A3E61VJ;A2E31VI;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A3E61VN;A2Ev1VE;EACE,yBAAA;EACA,cAAA;A3Ey1VJ;AwE54XA;EGyjCI,wBAAA;A3Es1VJ;A2En1VE;EACE,YAAA;EACA,SAAA;EACA,SAAA;A3Eq1VJ;AwEp5XA;EGokCI,UAAA;A3Em1VJ;AwEv5XA;EGukCM,2BAAA;EACA,8BAAA;A3Em1VN;AwE35XA;EG4kCM,4BAAA;EACA,+BAAA;A3Ek1VN;AwE/5XA;EGklCI,kBAAA;A3Eg1VJ;A2E50VI;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,WAAA;A3E80VN;A2E30VI;EACE,gBAAA;A3E60VN;AwE/6XA;EGumCI,UAAA;EACA,gBAAA;EACA,SAAA;A3E20VJ;A2Ez0VI;EACE,aAAA;A3E20VN;AwEv7XA;;EGknCI,YAAA;A3Ey0VJ;AwE37XA;;EGunCI,cAAA;EACA,WAAA;EACA,YAAA;A3Ew0VJ;AwEj8XA;;EGgoCI,QAAA;A3Eq0VJ;A2Eh0VE;;;;;EAKE,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,yCAAA;EACA,wCAAA;A3Ek0VJ;AwEp9XA;EGupCE,0BAAA;EACA,UAAA;A3Eg0VF;AwEx9XA;EG6pCI,aAAA;A3E8zVJ;A2E5zVE;EACE,cAAA;A3E8zVJ;A2EzzVI;;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,+BAAA;EACA,8BAAA;EACA,mBAAA;A3E4zVN;A2ExzVE;EACE,YAAA;EACA,0BAAA;A3E0zVJ;A2ExzVE;EACE,SAAA;EACA,2BAAA;A3E0zVJ;AwEj/XA;EG4rCE,WAAA;EACA,WAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;A3EwzVF;AwE5/XA;EGusCE,2BAAA;A3EwzVF;A2EpzVE;EAEI,UAAA;A3EqzVN;A2ElzVE;EAEI,oBAAA;A3EmzVN;AwErgYA;EGutCE,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;A3EizVF;AwE5gYA;EGguCI,0BAAA;A3E+yVJ;AwE/gYA;EGouCI,eAAA;A3E8yVJ;AwElhYA;EGyuCE,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;A3E4yVF;AwEhiYA;EGwvCE,YAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;A3E2yVF;AwExiYA;EGiwCI,kBAAA;A3E0yVJ;AwE3iYA;EQqBI,YAAA;AhFyhYJ;AwE9iYA;EQwBI,iBAAA;EACA,kBAAA;AhFyhYJ;AwEljYA;EQ4BI,gBAAA;EACA,mBAAA;AhFyhYJ;AwEtjYA;EQgCI,gBAAA;AhFyhYJ;AwEzjYA;EQmCI,mBAAA;AhFyhYJ;AwE5jYA;EQsCI,iBAAA;AhFyhYJ;AwE/jYA;EQyCI,kBAAA;AhFyhYJ;AwElkYA;EQwEI,aAAA;AhF6/XJ;AwErkYA;EQ2EI,kBAAA;EACA,mBAAA;AhF6/XJ;AwEzkYA;EQ+EI,iBAAA;EACA,oBAAA;AhF6/XJ;AwE7kYA;EQmFI,iBAAA;AhF6/XJ;AwEhlYA;EQsFI,oBAAA;AhF6/XJ;AwEnlYA;EQyFI,kBAAA;AhF6/XJ;AwEtlYA;EQ4FI,mBAAA;AhF6/XJ;AwEzlYA;EQqBI,aAAA;AhFukYJ;AwE5lYA;EQwBI,kBAAA;EACA,mBAAA;AhFukYJ;AwEhmYA;EQ4BI,iBAAA;EACA,oBAAA;AhFukYJ;AwEpmYA;EQgCI,iBAAA;AhFukYJ;AwEvmYA;EQmCI,oBAAA;AhFukYJ;AwE1mYA;EQsCI,kBAAA;AhFukYJ;AwE7mYA;EQyCI,mBAAA;AhFukYJ;AwEhnYA;EQ+CI,uBAAA;AhFokYJ;AwEnnYA;EQkDI,4BAAA;EACA,6BAAA;AhFokYJ;AwEvnYA;EQsDI,2BAAA;EACA,8BAAA;AhFokYJ;AwE3nYA;EQ0DI,2BAAA;AhFokYJ;AwE9nYA;EQ6DI,8BAAA;AhFokYJ;AwEjoYA;EQgEI,4BAAA;AhFokYJ;AwEpoYA;EQmEI,6BAAA;AhFokYJ;AwEvoYA;EQkGI,wBAAA;AhFwiYJ;AwE1oYA;EQqGI,6BAAA;EACA,8BAAA;AhFwiYJ;AwE9oYA;EQyGI,4BAAA;EACA,+BAAA;AhFwiYJ;AwElpYA;EQ6GI,4BAAA;AhFwiYJ;AwErpYA;EQgHI,+BAAA;AhFwiYJ;AwExpYA;EQmHI,6BAAA;AhFwiYJ;AwE3pYA;EQsHI,8BAAA;AhFwiYJ;AwE9pYA;EQ+CI,wBAAA;AhFknYJ;AwEjqYA;EQkDI,6BAAA;EACA,8BAAA;AhFknYJ;AwErqYA;EQsDI,4BAAA;EACA,+BAAA;AhFknYJ;AwEzqYA;EQ0DI,4BAAA;AhFknYJ;AwE5qYA;EQ6DI,+BAAA;AhFknYJ;AwE/qYA;EQgEI,6BAAA;AhFknYJ;AwElrYA;EQmEI,8BAAA;AhFknYJ;AwErrYA;EG8wCE,gBAAA;EACA,kBAAA;A3E06VF;AwEzrYA;EGmxCE,gBAAA;EACA,iBAAA;A3Ey6VF;AwE7rYA;EGwxCE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;A3Ew6VF;AwE9sYA;EG0yCE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;A3Eu6VF;AwEvtYA;EGozCE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,2BAAA;A3Es6VF;AwEtuYA;EGo0CE,yBAAA;A3Eq6VF;AwEzuYA;EGw0CE,cAAA;A3Eo6VF;AwE5uYA;EG60CI,kBAAA;A3Ek6VJ;A2Eh6VE;EACE,cAAA;A3Ek6VJ;AwElvYA;EGo1CE,aAAA;A3Ei6VF;AwErvYA;EGu1CI,aAAA;A3Ei6VJ;AwExvYA;EG61CI,kBAAA;EACA,iBAAA;EACA,oBAAA;A3E85VJ;AwE7vYA;EGm2CI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,kCAAA;A3E65VJ;AwEpwYA;EG82CM,kBAAA;A3Ey5VN;A2En5VE;EACE,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A3Eq5VJ;A2Eh5VE;EAEI,cAAA;EACA,qBAAA;A3Ei5VN;AwEpxYA;EGy4CE,YAAA;EACA,gDAAA;EACA,kBAAA;A3E84VF;AwEzxYA;EG84CI,kBAAA;EACA,yBAAA;EACA,cAAA;A3E84VJ;AwE9xYA;EGs5CI,gBAAA;EK93CA,kBAAA;EACA,mBAAA;AhF0wYJ;A2Ez4VM;EACE,uBAAA;A3E24VR;A2Ev4VI;;EAEE,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;A3Ey4VN;A2Ej5VI;;EAWI,cAAA;EACA,gBAAA;A3E04VR;AwErzYA;;EGm7CE,wBAAA;EACA,SAAA;A3Es4VF;AwE1zYA;EGy7CE,0BAAA;A3Eo4VF;AwE7zYA;EG67CE,gBAAA;A3Em4VF;A2Eh4VA;EACE;IACE,8BAAA;E3Ek4VF;AACF;A2Eh4VA;EACE;IACE,iCAAA;E3Ek4VF;AACF;A2Eh4VA;EACE;IACE,yBAAA;E3Ek4VF;AACF;A2Eh4VA;EACE;IACE,yBAAA;E3Ek4VF;AACF;AwEp1YA;EGs9CE,+CAAA;EACA,4CAAA;EACA,2CAAA;EACA,uCAAA;A3Ei4VF;AwE11YA;EG89CI,YAAA;EACA,eAAA;A3E+3VJ;AwE91YA;EGm+CI,aAAA;A3E83VJ;AwEj2YA;EGy+CI,YAAA;EACA,wBAAA;A3E23VJ;AwEr2YA;EG++CE,uBAAA;EACA,iBAAA;EACA,gBAAA;A3Ey3VF;AwE12YA;EGo/CI,iBAAA;A3Ey3VJ;AwE72YA;;EGy/CI,uBAAA;EACA,oCAAA;A3Ew3VJ;A2Er3VE;EACE,oCAAA;A3Eu3VJ;A2El3VE;EACE,oCAAA;EACA,gBAAA;A3Eo3VJ;AwEz3YA;EG0gDE,iBAAA;A3Ek3VF;AwE53YA;EG8gDE,aAAA;A3Ei3VF;AwE/3YA;EGmhDI,kBAAA;A3E+2VJ;A2E12VE;EAAA;IACE,yBAAA;E3E62VF;AACF;AwEv4YA;EG8hDE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;A3E42VF;AwE94YA;;EGuiDE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mCAAA;A3E22VF;AwE55YA;EGqjDE,mBAAA;A3E02VF;AwE/5YA;EGyjDE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;A3Ey2VF;AwEt6YA;;EGkkDE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mCAAA;A3Ew2VF;AwEp7YA;EGglDE,mBAAA;A3Eu2VF;A2Ep2VA;EACE;IACE,mBAAA;IACA,UAAA;IACA,mBAAA;E3Es2VF;E2Ep2VA;IACE,qBAAA;IACA,UAAA;E3Es2VF;AACF;AwEl8YA;EGkmDM,cAAA;A3Em2VN;AwEr8YA;EG0mDM,cAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;A3E81VN;AwE78YA;EGsnDI,YAAA;EACA,UAAA;A3E01VJ;AwEj9YA;EG6nDI,YAAA;EACA,UAAA;A3Eu1VJ;A2Ep1VE;EACE,eAAA;A3Es1VJ;A2Ej1VE;EAAA;IACE,mBAAA;IACA,YAAA;E3Eo1VF;AACF;AwE99YA;EG8oDE,8BAAA;A3Em1VF;A2El1VE;EAAA;IACE,0BAAA;E3Eq1VF;AACF;AwEt+YA;EGopDE,qCAAA;A3Eq1VF;A2Ep1VE;EAAA;IACE,iCAAA;E3Eu1VF;AACF;AwE9+YA;EG2pDE,2BAAA;A3Es1VF;AwEj/YA;EG+pDI,YAAA;A3Eq1VJ;AwEp/YA;EGqqDI,aAAA;EACA,8BAAA;A3Ek1VJ;AwEx/YA;EG2qDE,gBAAA;A3Eg1VF;AwE3/YA;EG6qDI,mBAAA;EACA,YAAA;A3Ei1VJ;AwE//YA;EGirDI,aAAA;EACA,yBAAA;A3Ei1VJ;AwEngZA;EGurDE,gBAAA;A3E+0VF;A2E30VE;EAEI,UAAA;A3E40VN;AwEzgZA;EGmsDE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,iDAAA;A3Ey0VF;AwE/gZA;;EG4sDI,aAAA;A3Eu0VJ;AwEnhZA;;EGgtDI,QAAA;EACA,UAAA;A3Eu0VJ;AwExhZA;;EGqtDI,cAAA;EACA,iBAAA;A3Eu0VJ;AwE7hZA;;EG0tDI,iBAAA;EACA,gBAAA;A3Eu0VJ;AwEliZA;EGiuDI,UAAA;EACA,gBAAA;A3Eo0VJ;AwEtiZA;;EGwuDE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;A3Ek0VF;AwE7iZA;;EGgvDE,yBAAA;A3Ei0VF;AwEjjZA;;;;EGuvDE,yBAAA;EACA,uBAAA;EACA,mBAAA;A3Eg0VF;AwEzjZA;EG6vDE,iBAAA;EACA,gBAAA;A3E+zVF;AwE7jZA;;EGmwDE,yBAAA;A3E8zVF;AwEjkZA;;EGwwDE,qBAAA;A3E6zVF;AwErkZA;EG4wDE,cAAA;A3E4zVF;AwExkZA;EGgxDE,yBAAA;A3E2zVF;AwE3kZA;ESCE,2BAAA;AjF6kZF;AwE9kZA;ESII,qBAAA;AjF6kZJ;AwEjlZA;ESQI,gBAAA;AjF4kZJ;AwEplZA;ESaM,YAAA;AjF0kZN;AwEvlZA;ESiBM,QAAA;AjFykZN;AwE1lZA;ESwBI,sBAAA;EACA,qBAAA;EACA,mBAAA;AjFqkZJ;AwE/lZA;ES+BM,YAAA;AjFmkZN;AwElmZA;ESoCI,SAAA;AjFikZJ;AwErmZA;ES0CI,gBAAA;AjF8jZJ;AwExmZA;ES8CI,yBAAA;AjF6jZJ;AiF3jZI;EACE,8CAAA;AjF6jZN;AwE9mZA;;;ESyDI,+CAAA;AjF0jZJ;AwEnnZA;ES6DI,8CAAA;AjFyjZJ;AwEtnZA;ESiEI,oCAAA;AjFwjZJ;AwEznZA;ESuEI,UAAA;AjFqjZJ;AwE5nZA;ES2EI,cAAA;EACA,iBAAA;AjFojZJ;AwEhoZA;ES+EM,kBAAA;AjFojZN;AwEnoZA;ESoFI,QAAA;EACA,UAAA;AjFkjZJ;AwEvoZA;ES2FI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AjF+iZJ;AiF7iZI;EACE,0BAAA;AjF+iZN;AiF7iZI;EACE,0BAAA;AjF+iZN;AwEnpZA;ESyGI,yBAAA;EACA,WAAA;EACA,qBAAA;AjF6iZJ;AiF3iZI;EACE,yBAAA;AjF6iZN;AiFviZE;EACE,yBAAA;AjFyiZJ;AiFtiZM;EACE,yBAAA;AjFwiZR;AiFpiZE;EACE,yBAAA;AjFsiZJ;AiFpiZI;;EAEE,yBAAA;AjFsiZN;AiFhiZE;EACE,cAAA;AjFkiZJ;AiF/hZM;EACE,cAAA;AjFiiZR;AiF7hZE;EACE,cAAA;AjF+hZJ;AiF5hZM;EACE,cAAA;AjF8hZR;AiF1hZE;EACE,cAAA;AjF4hZJ;AiFvhZE;EACE,yBAAA;AjFyhZJ;AiFthZE;EACE,yBAAA;AjFwhZJ;AiFrhZM;EACE,yBAAA;AjFuhZR;AiFlhZM;EACE,yBAAA;AjFohZR;AiF/gZM;EACE,yBAAA;AjFihZR;AiF7gZI;EACE,oCAAA;AjF+gZN;AiF5gZI;EACE,0BAAA;AjF8gZN;AiF1gZE;EACE,yCAAA;AjF4gZJ;AiFvgZE;EACE,qBAAA;AjFygZJ;AwEltZA;ES6MI,qBAAA;AjFwgZJ;AwErtZA;ESiNI,qBAAA;AjFugZJ;AiFngZI;EAEI,yBAAA;EACA,qBAAA;AjFogZR;AiFhgZI;EACE,yBAAA;AjFkgZN;AwE/tZA;ESoOI,qBAAA;AjF8/YJ;AiF5/YI;EACE,yBAAA;AjF8/YN;AiFz/YI;EACE,qBAAA;AjF2/YN;AiFr/YE;EACE,yBAAA;AjFu/YJ;AiFt/YI;EACE,8CAAA;AjFw/YN;AwE9uZA;ES6PI,mBAAA;AjFo/YJ;AwEjvZA;ESiQI,mBAAA;AjFm/YJ;AiFj/YI;EACE,cAAA;AjFm/YN;AiFh/YI;EACE,iBAAA;AjFk/YN;AiF7+YI;;EAEE,cAAA;AjF++YN;AwE9vZA;ESqRM,cAAA;AjF4+YN;AwEjwZA;ES4RI,UAAA;AjFw+YJ;AwEpwZA;ESgSI,cAAA;EACA,iBAAA;AjFu+YJ;AwExwZA;ESqSI,eAAA;AjFs+YJ;AwE3wZA;ESwSM,cAAA;EACA,UAAA;AjFs+YN;AwE/wZA;ES4SQ,UAAA;AjFs+YR;AwElxZA;ESiTM,cAAA;AjFo+YN;AwErxZA;;;;ES2TI,aAAA;AjFg+YJ;AwE3xZA;;;;ES+TI,QAAA;EACA,UAAA;AjFk+YJ;AwElyZA;;;;ESoUI,cAAA;EACA,iBAAA;AjFo+YJ;AwEzyZA;;;;ESyUI,iBAAA;EACA,gBAAA;AjFs+YJ;AwEhzZA;ES+UE,QAAA;AjFo+YF;AwEnzZA;EUCI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AlFqzZJ;AwE7zZA;EUcQ,aAAA;AlFkzZR;AwEh0ZA;EUkBQ,2BAAA;AlFizZR;AwEn0ZA;EUsBQ,cAAA;AlFgzZR;AwEt0ZA;;EU0BQ,eAAA;EACA,yBAAA;AlFgzZR;AwE30ZA;EU+BQ,gBAAA;AlF+yZR;AwE90ZA;EUmCQ,aAAA;AlF8yZR;AwEj1ZA;EUuCQ,0BAAA;AlF6yZR;AwEp1ZA;;EU2CQ,oCAAA;AlF6yZR;AwEx1ZA;;EUgDQ,eAAA;EACA,oBAAA;EACA,yBAAA;AlF4yZR;AwE91ZA;;;;;EU0DQ,yBAAA;AlF2yZR;AwEr2ZA;EU+DQ,uCAAA;AlFyyZR;AwEx2ZA;EUoEQ,kBAAA;AlFuyZR;AkFryZQ;EArEJ,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EAgEQ,QAAA;EACA,kCAAA;EACA,UAAA;AlF8yZZ;AkF3yZQ;EACI,yBAAA;AlF6yZZ;AwE33ZA;EUmFQ,kBAAA;EACA,4BAAA;AlF2yZR;AkFzyZQ;EArFJ,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EAgFQ,QAAA;EACA,kCAAA;EACA,UAAA;AlFkzZZ;AwE54ZA;EUiGI,kBAAA;AlF8yZJ;AkF3yZQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;AlF6yZZ;AwE15ZA;EUmHI,kBAAA;AlF0yZJ;AkFxyZI;EApHA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EA+GI,SAAA;EACA,UAAA;EACA,yBAAA;AlFizZR;AwE16ZA;EU8HI,gBAAA;EACA,UAAA;EACA,WAAA;EACA,OAAA;EACA,yBAAA;AlF+yZJ;AkF9yZI;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AlFgzZR;AmF57ZA;EACE;IACE,kCAAA;EnF87ZF;EmF57ZA;IACE,iCAAA;EnF87ZF;EmF37ZA;IACE,kCAAA;EnF67ZF;EmF37ZA;IACE,iCAAA;EnF67ZF;EmF17ZA;IACE,oCAAA;EnF47ZF;EmF17ZA;IACE,mCAAA;EnF47ZF;AACF;AmFz7ZA;EACE;IACE,UAAA;EnF27ZF;EmFx7ZA;IACE,YAAA;EnF07ZF;EmFx7ZA;IACE,UAAA;EnF07ZF;AACF;AmFv7ZA;EACE;IACE,mDAAA;EnFy7ZF;EmFv7ZA;IACE,mDAAA;EnFy7ZF;EmFt7ZA;IACE,mDAAA;EnFw7ZF;EmFt7ZA;IACE,mDAAA;EnFw7ZF;EmFt7ZA;IACE,mDAAA;EnFw7ZF;EmFt7ZA;IACE,mDAAA;EnFw7ZF;EmFr7ZA;IACE,mDAAA;EnFu7ZF;EmFr7ZA;IACE,mDAAA;EnFu7ZF;AACF;AmFr7ZA;EACE;IACE,mDAAA;EnFu7ZF;EmFr7ZA;IACE,mDAAA;EnFu7ZF;EmFp7ZA;IACE,mDAAA;EnFs7ZF;EmFp7ZA;IACE,mDAAA;EnFs7ZF;EmFp7ZA;IACE,mDAAA;EnFs7ZF;EmFp7ZA;IACE,mDAAA;EnFs7ZF;EmFn7ZA;IACE,mDAAA;EnFq7ZF;EmFn7ZA;IACE,mDAAA;EnFq7ZF;AACF;AmFl7ZA;EACE;IACE,mDAAA;EnFo7ZF;EmFl7ZA;IACE,mDAAA;EnFo7ZF;EmFj7ZA;IACE,mDAAA;EnFm7ZF;EmFj7ZA;IACE,mDAAA;EnFm7ZF;EmFj7ZA;IACE,mDAAA;EnFm7ZF;EmFj7ZA;IACE,mDAAA;EnFm7ZF;EmFh7ZA;IACE,mDAAA;EnFk7ZF;EmFh7ZA;IACE,mDAAA;EnFk7ZF;AACF;AmF/6ZA;EACE;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,4BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,4BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;AACF;AmF/6ZA;EACE;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,4BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,4BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;AACF;AmF/6ZA;EACE;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,4BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;EmF/6ZA;IACE,4BAAA;EnFi7ZF;EmF/6ZA;IACE,2BAAA;EnFi7ZF;AACF;AmF96ZA;EACE;IACE,2BAAA;EnFg7ZF;EmF96ZA;IACE,6BAAA;EnFg7ZF;EmF96ZA;IACE,2BAAA;EnFg7ZF;EmF96ZA;IACE,2BAAA;EnFg7ZF;EmF96ZA;IACE,6BAAA;EnFg7ZF;EmF96ZA;IACE,2BAAA;EnFg7ZF;AACF;AmF76ZA;EACE;IACE,4BAAA;EnF+6ZF;EmF76ZA;IACE,6BAAA;EnF+6ZF;EmF76ZA;IACE,2BAAA;EnF+6ZF;EmF76ZA;IACE,4BAAA;EnF+6ZF;EmF76ZA;IACE,6BAAA;EnF+6ZF;EmF76ZA;IACE,2BAAA;EnF+6ZF;AACF;AwE7oaA;EWmOI,WAAA;EACA,eAAA;AnF66ZJ;AwEjpaA;EWuOM,WAAA;EACA,eAAA;AnF66ZN;AwErpaA;EW4OM,eAAA;EACA,WAAA;EACA,kBAAA;AnF46ZN;AwE1paA;EWoPI,4BAAA;AnFy6ZJ;AwE7paA;EWwPI,aAAA;EACA,mBAAA;EACA,mBAAA;AnFw6ZJ;AmFr6ZE;EACE,2BAAA;EACA,wBAAA;EACA,iHAAA;AnFu6ZJ;AwEvqaA;EW2QI,uBAAA;EACA,cAAA;AnF+5ZJ;AwE3qaA;EW+QI,aAAA;EACA,mBAAA;EACA,mBAAA;AnF+5ZJ;AmF55ZE;EACE,2BAAA;EACA,wBAAA;EACA,iHAAA;AnF85ZJ;AwErraA;EWmSE,2BAAA;EACA,0BAAA;AnFq5ZF;AwEzraA;EWuSI,eAAA;EACA,iBAAA;AnFq5ZJ;AwE7raA;EW4SI,gBAAA;AnFo5ZJ;AwEhsaA;EWkTE,eAAA;AnFi5ZF;AwEnsaA;;EW8TE,iQAAA;AnFy4ZF;AwEvsaA;EWwUE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,8JAAA;EAQA,kEAAA;AnF23ZF;AmFz3ZE;EACE;IACE,2BAAA;IACA,2BAAA;IACA,2BAAA;IACA,2BAAA;IACA,2BAAA;EnF23ZJ;AACF;AmFx3ZE;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AnF03ZJ;AmFx3ZE;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AnF03ZJ;AmFx3ZE;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AnF03ZJ;AmFx3ZE;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AnF03ZJ;AmFx3ZE;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;AnF03ZJ;AwEhvaA;EW2XE,WAAA;EACA,YAAA;EACA,mDAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;AnFw3ZF;AmFt3ZE;EACE,mDAAA;AnFw3ZJ;AmFp3ZA;EACE;IACE,qCAAA;EnFs3ZF;AACF;AmFp3ZA;EACE;IACE,0CAAA;EnFs3ZF;EmFp3ZA;IACE,4CAAA;EnFs3ZF;EmFp3ZA;IACE,6CAAA;EnFs3ZF;EmFp3ZA;IACE,iDAAA;EnFs3ZF;EmFn3ZA;IACE,0CAAA;EnFq3ZF;AACF;AwEpxaA;EWmaE,6BAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AnFo3ZF;AwE/xaA;EW8aI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;AnFo3ZJ;AwEryaA;EWqbI,WAAA;EACA,UAAA;EAEA,yBAAA;EACA,SAAA;EACA,MAAA;AnFk3ZJ;AwE5yaA;EW8bI,WAAA;EACA,UAAA;EACA,yBAAA;EAEA,SAAA;EACA,OAAA;EACA,mBAAA;AnFg3ZJ;AwEpzaA;EWwcI,WAAA;EACA,UAAA;EAEA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AnF82ZJ;AwE5zaA;EWkdI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AnF62ZJ;AwEp0aA;EW4dE,6BAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AnF22ZF;AwE/0aA;EWueI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;AnF22ZJ;AwEr1aA;EW8eI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,MAAA;AnF02ZJ;AwE51aA;EWsfI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;AnFy2ZJ;AwEp2aA;EW+fI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AnFw2ZJ;AwE52aA;EWwgBI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AnFu2ZJ;AwEp3aA;EWkhBE,6BAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;AnFq2ZF;AwE/3aA;EW6hBI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,qCAAA;AnFq2ZJ;AwEr4aA;EWoiBI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,MAAA;AnFo2ZJ;AwE54aA;EW4iBI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;AnFm2ZJ;AwEp5aA;EWqjBI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AnFk2ZJ;AwE55aA;EW8jBI,WAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AnFi2ZJ;AwEp6aA;EWwkBE,wCAAA;EACA,iLAAA;EASA,mDAAA;EACA,qDAAA;EACA,wDAAA;AnFu1ZF;AmFr1ZE;EACE;IACE,oBAAA;EnFu1ZJ;EmFr1ZE;IACE,sBAAA;EnFu1ZJ;AACF;AmFp1ZE;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;AnFs1ZJ;AwEx7aA;EWumBE,mBAAA;EACA,mGAAA;AnFo1ZF;AwE57aA;EWmnBE,iDAAA;AnF40ZF;AwE/7aA;EWunBE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AnF20ZF;AwEt8aA;EWgoBI,wBAAA;AnFy0ZJ;AwEz8aA;EWmoBI,aAAA;AnFy0ZJ;AwE58aA;EWuoBI,kBAAA;EACA,QAAA;AnFw0ZJ;AwEh9aA;EW6oBE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,mDAAA;AnFs0ZF;AwEx9aA;EWqpBI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qCAAA;AnFs0ZJ;AwE99aA;EW8pBI,aAAA;EACA,YAAA;AnFm0ZJ;AwEl+aA;EWkqBI,QAAA;EACA,UAAA;AnFm0ZJ;AwEt+aA;EYCE,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;ApFw+aF;AwE9+aA;EYUE,qBAAA;EACA,oBAAA;ApFu+aF;AwEl/aA;;EYiBE,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ApFq+aF;AwE3/aA;EY0BE,YAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;ApFo+aF;AwEjgbA;EYoCE,YAAA;EACA,YAAA;EACA,sBAAA;ApFg+aF;AwEtgbA;EYyCI,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;ApFg+aJ;AwE7gbA;EYgDM,WAAA;EACA,YAAA;ApFg+aN;AwEjhbA;EYqDM,WAAA;EACA,uBAAA;EACA,eAAA;ApF+9aN;AwEthbA;EY6DE,cAAA;EACA,mBAAA;ApF49aF;AwE1hbA;EYkEE,UAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;ApF29aF;AwE1ibA;EYmFE,UAAA;EACA,oBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;ApF09aF;AwEljbA;;EYiGE,yBAAA;EACA,kBAAA;ApFq9aF;AwEvjbA;;;EY8GE,wCAAA;ApF88aF;AwE5jbA;;;;;;EY6HE,yBAAA;ApFu8aF;AwEpkbA;EYiIE,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;ApFs8aF;AoFp8aE;;;EAGE,kCAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;ApFs8aJ;AoFn8aE;;;EAGE,yBAAA;ApFq8aJ;AoFl8aE;;;;EAIE,yBAAA;EACA,kCAAA;EACA,wCAAA;ApFo8aJ;AwE/lbA;;EYgKI,yBAAA;ApFm8aJ;AwEnmbA;EYqKE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;ApFi8aF;AwEhnbA;EYmLE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;ApFg8aF;AwEvnbA;EY+LE,UAAA;EACA,YAAA;EACA,gBAAA;ApF27aF;AwE5nbA;EYqME,WAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;ApF07aF;AwEnobA;EY6ME,QAAA;EACA,WAAA;ApFy7aF;AwEvobA;EYkNE,WAAA;ApFw7aF;AwE1obA;EYsNE,yBAAA;ApFu7aF;AwE7obA;EY2NE,SAAA;EACA,SAAA;EACA,kBAAA;ApFq7aF;AwElpbA;EYkOE,SAAA;ApFm7aF;AwErpbA;EYsOE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ApFk7aF;AwE5pbA;EY8OE,yBAAA;ApFi7aF;AwE/pbA;EYiPI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApFi7aJ;AwEvqbA;;;;;;EY+PI,eAAA;EACA,gBAAA;ApFg7aJ;AwEhrbA;EYqQI,6BAAA;ApF86aJ;AwEnrbA;;EY0QI,4BAAA;ApF66aJ;AwEvrbA;EY8QI,aAAA;ApF46aJ;AwE1rbA;EYkRI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;ApF26aJ;AwEjsbA;;EY2RI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApF06aJ;AwE1sbA;;;;EYoSM,aAAA;EACA,mBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;ApF46aN;AwE1tbA;;;;EYiTQ,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;ApF+6aR;AwErubA;;;;EY0TQ,aAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;ApFi7aR;AoF76aI;;;;EAEE,mBAAA;ApFi7aN;AoF/6aM;;;;EACE,wCAAA;ApFo7aR;AoFj7aM;;;;EACE,0BAAA;ApFs7aR;AoF/6aI;EACE,wCAAA;ApFi7aN;AoF96aI;EAEI,cAAA;ApF+6aR;AoFj7aI;;EAUI,cAAA;ApF26aR;AoFt6aM;;EAEE,wCAAA;ApFw6aR;AoFn6aE;EAEI,gBAAA;ApFo6aN;AwElxbA;EYqXI,oHAAA;ApFg6aJ;AwErxbA;EY4XM,4BAAA;ApF45aN;AwExxbA;EYiYI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oHAAA;ApF05aJ;AwE/xbA;EY8YI,yBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ApFo5aJ;AwEvybA;EYuZI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApFm5aJ;AwE/ybA;EYgaI,6BAAA;ApFk5aJ;AwElzbA;EYsaI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ApF+4aJ;AwExzbA;EY6aI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApF84aJ;AwEh0bA;EYsbI,6BAAA;ApF64aJ;AwEn0bA;EY2bE,cAAA;EACA,iBAAA;EACA,kBAAA;ApF24aF;AwEx0bA;EYicE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;ApF04aF;AwE90bA;EYucI,eAAA;EACA,gBAAA;ApF04aJ;AwEl1bA;EY4cI,mBAAA;ApFy4aJ;AwEr1bA;EYgdI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;ApFw4aJ;AwE91bA;EY2dE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;ApFs4aF;AwEr2bA;EYkeI,eAAA;EACA,gBAAA;ApFs4aJ;AwEz2bA;EYueI,mBAAA;ApFq4aJ;AwE52bA;EY2eI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;ApFo4aJ;AwEr3bA;EYsfE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,2BAAA;ApFk4aF;AwEh4bA;EYigBI,UAAA;ApFk4aJ;AwEn4bA;EYqgBI,mBAAA;ApFi4aJ;AwEt4bA;EYygBI,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;ApFg4aJ;AwEj5bA;EYqhBI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;ApF+3aJ;AwE15bA;EYgiBE,qBAAA;EACA,mBAAA;EACA,sBAAA;ApF63aF;AwE/5bA;EYsiBE,iCAAA;ApF43aF;AwEl6bA;EY0iBE,yBAAA;ApF23aF;AwEr6bA;EY+iBE,uDAAA;EACA,2DAAA;EACA,2DAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;ApFy3aF;AwEj7bA;;;EY6jBI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;ApFy3aJ;AwEz7bA;EYokBI,cAAA;EACA,eAAA;ApFw3aJ;AwE77bA;EYykBI,eAAA;EACA,gBAAA;ApFu3aJ;AwEj8bA;EY8kBI,mBAAA;ApFs3aJ;AwEp8bA;EYmlBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,QAAA;ApFo3aF;AwE38bA;EY2lBE,sCAAA;EACA,sBAAA;ApFm3aF;AwE/8bA;EYgmBE,qBAAA;EACA,sBAAA;ApFk3aF;AwEn9bA;EYqmBE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;ApFi3aF;AwE59bA;EY8mBI,iBAAA;ApFi3aJ;AwE/9bA;;EYqnBE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;ApF82aF;AwEv+bA;;EY4nBI,iBAAA;ApF+2aJ;AwE3+bA;EYioBE,6BAAA;ApF62aF;AwE9+bA;;;EYwoBI,gCAAA;ApF22aJ;AwEn/bA;EY4oBI,qBAAA;ApF02aJ;AwEt/bA;EYipBE,sBAAA;EACA,eAAA;ApFw2aF;AwE1/bA;EYspBE,cAAA;EACA,eAAA;EACA,gBAAA;ApFu2aF;AwE//bA;EY4pBE,iBAAA;EACA,cAAA;EACA,kBAAA;ApFs2aF;AwEpgcA;EYmqBI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;ApFo2aJ;AwErhcA;EYorBM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ApFo2aN;AoFh2aE;;EAEE,UAAA;EACA,oBAAA;ApFk2aJ;AwElicA;EYosBI,YAAA;ApFi2aJ;AwEricA;EYysBE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;ApF+1aF;AwEhjcA;EYstBI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;ApF61aJ;AwEjkcA;EYuuBM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ApF61aN;AoFz1aE;;EAEE,UAAA;EACA,oBAAA;ApF21aJ;AwE9kcA;EYuvBI,YAAA;ApF01aJ;AwEjlcA;EY6vBI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;ApFu1aJ;AwElmcA;EY8wBM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;ApFu1aN;AoFn1aE;;EAEE,UAAA;EACA,oBAAA;ApFq1aJ;AwEhncA;EY+xBI,YAAA;EACA,eAAA;ApFo1aJ;AoF70aI;;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EAGA,UAAA;EACA,oBAAA;ApF80aN;AoF10aE;EACE,OAAA;ApF40aJ;AoFz0aE;EACE,QAAA;ApF20aJ;AwErocA;EAkBI,mCAAA;AxEsncJ;AwExocA;EzDwKI,eAAA;Afm+bJ;AwE3ocA;EzD2KI,0BAAA;Afm+bJ;AwE9ocA;EzDwKI,eAAA;Afy+bJ;AwEjpcA;EzD2KI,0BAAA;Afy+bJ;AwEppcA;EzDwKI,eAAA;Af++bJ;AwEvpcA;EzD2KI,0BAAA;Af++bJ;AwE1pcA;EzDwKI,eAAA;Afq/bJ;AwE7pcA;EzD2KI,0BAAA;Afq/bJ;AwEhqcA;EzDwKI,eAAA;Af2/bJ;AwEnqcA;EzD2KI,0BAAA;Af2/bJ;AwEtqcA;EzDwKI,eAAA;AfigcJ;AwEzqcA;EzD2KI,0BAAA;AfigcJ;AwE5qcA;EzDwKI,eAAA;AfugcJ;AwE/qcA;EzD2KI,0BAAA;AfugcJ;AwElrcA;EzDwKI,eAAA;Af6gcJ;AwErrcA;EzD2KI,0BAAA;Af6gcJ;AwExrcA;EzDwKI,eAAA;AfmhcJ;AwE3rcA;EzD2KI,0BAAA;AfmhcJ;AwE9rcA;EzDwKI,eAAA;AfyhcJ;AwEjscA;EzD2KI,0BAAA;AfyhcJ;AwEpscA;EzDwKI,oBAAA;Af+hcJ;AwEvscA;EzD2KI,+BAAA;Af+hcJ;AwE1scA;EzDwKI,oBAAA;AfqicJ;AwE7scA;EzD2KI,+BAAA;AfqicJ;AwEhtcA;EzDwKI,oBAAA;Af2icJ;AwEntcA;EzD2KI,+BAAA;Af2icJ;AwEttcA;EzDwKI,oBAAA;AfijcJ;AwEztcA;EzD2KI,+BAAA;AfijcJ;AwE5tcA;EzDwKI,oBAAA;AfujcJ;AwE/tcA;EzD2KI,+BAAA;AfujcJ;AwElucA;EzDwKI,oBAAA;Af6jcJ;AwErucA;EzD2KI,+BAAA;Af6jcJ;AwExucA;EzDwKI,oBAAA;AfmkcJ;AwE3ucA;EzD2KI,+BAAA;AfmkcJ;AwE9ucA;EzDwKI,yBAAA;AfykcJ;AwEjvcA;EzD2KI,oCAAA;AfykcJ;AwEpvcA;EzDwKI,yBAAA;Af+kcJ;AwEvvcA;EzD2KI,oCAAA;Af+kcJ;AwE1vcA;EzDwKI,yBAAA;AfqlcJ;AwE7vcA;EzD2KI,oCAAA;AfqlcJ;AwEhwcA;EzDwKI,6BAAA;Af2lcJ;AwEnwcA;EzD2KI,wCAAA;Af2lcJ;AwEtwcA;EzDwKI,6BAAA;AfimcJ;AwEzwcA;EzD2KI,wCAAA;AfimcJ;AwE5wcA;EzDwKI,+BAAA;AfumcJ;AwE/wcA;EzD2KI,0CAAA;AfumcJ;AwElxcA;EzDwKI,+BAAA;Af6mcJ;AwErxcA;EzD2KI,0CAAA;Af6mcJ;AwExxcA;EzDwKI,gCAAA;AfmncJ;AwE3xcA;EzD2KI,2CAAA;AfmncJ;AwE9xcA;EzDwKI,gCAAA;AfyncJ;AwEjycA;EzD2KI,2CAAA;AfyncJ;AwEpycA;EzDwKI,8BAAA;Af+ncJ;AwEvycA;EzD2KI,yCAAA;Af+ncJ;AwE1ycA;EzDwKI,8BAAA;AfqocJ;AwE7ycA;EzD2KI,yCAAA;AfqocJ;AwEhzcA;EzDwKI,sBAAA;Af2ocJ;AwEnzcA;EzD2KI,iCAAA;Af2ocJ;AwEtzcA;EzDwKI,sBAAA;AfipcJ;AwEzzcA;EzD2KI,iCAAA;AfipcJ;AwE5zcA;EzDwKI,mBAAA;AfupcJ;AwE/zcA;EzD2KI,8BAAA;AfupcJ;AwEl0cA;EzDwKI,mBAAA;Af6pcJ;AwEr0cA;EzD2KI,8BAAA;Af6pcJ;AwEx0cA;EzDwKI,mBAAA;AfmqcJ;AwE30cA;EzD2KI,8BAAA;AfmqcJ;AwE90cA;EzDwKI,mBAAA;AfyqcJ;AwEj1cA;EzD2KI,8BAAA;AfyqcJ;AwEp1cA;EzDwKI,mBAAA;Af+qcJ;AwEv1cA;EzD2KI,8BAAA;Af+qcJ;AwE11cA;EzDwKI,mBAAA;AfqrcJ;AwE71cA;EzD2KI,8BAAA;AfqrcJ;AwEh2cA;EzDwKI,mBAAA;Af2rcJ;AwEn2cA;EzD2KI,8BAAA;Af2rcJ;AwEt2cA;EzDwKI,mBAAA;AfiscJ;AwEz2cA;EzD2KI,8BAAA;AfiscJ;AwE52cA;EzDwKI,mBAAA;AfuscJ;AwE/2cA;EzD2KI,8BAAA;AfuscJ;AwEl3cA;EzDwKI,mBAAA;Af6scJ;AwEr3cA;EzD2KI,8BAAA;Af6scJ;AwEx3cA;EzDwKI,wBAAA;AfmtcJ;AwE33cA;EzD2KI,mCAAA;AfmtcJ;AwE93cA;EzDwKI,wBAAA;AfytcJ;AwEj4cA;EzD2KI,mCAAA;AfytcJ;AwEp4cA;EzDwKI,wBAAA;Af+tcJ;AwEv4cA;EzD2KI,mCAAA;Af+tcJ;AwE14cA;EzDwKI,wBAAA;AfqucJ;AwE74cA;EzD2KI,mCAAA;AfqucJ;AwEh5cA;EzDwKI,wBAAA;Af2ucJ;AwEn5cA;EzD2KI,mCAAA;Af2ucJ;AwEt5cA;EzDwKI,wBAAA;AfivcJ;AwEz5cA;EzD2KI,mCAAA;AfivcJ;AwE55cA;EzDwKI,wBAAA;AfuvcJ;AwE/5cA;EzD2KI,mCAAA;AfuvcJ;AwEl6cA;EzDwKI,6BAAA;Af6vcJ;AwEr6cA;EzD2KI,wCAAA;Af6vcJ;AwEx6cA;EzDwKI,6BAAA;AfmwcJ;AwE36cA;EzD2KI,wCAAA;AfmwcJ;AwE96cA;EzDwKI,6BAAA;AfywcJ;AwEj7cA;EzD2KI,wCAAA;AfywcJ;AwEp7cA;EzDwKI,iCAAA;Af+wcJ;AwEv7cA;EzD2KI,4CAAA;Af+wcJ;AwE17cA;EzDwKI,iCAAA;AfqxcJ;AwE77cA;EzD2KI,4CAAA;AfqxcJ;AwEh8cA;EzDwKI,mCAAA;Af2xcJ;AwEn8cA;EzD2KI,8CAAA;Af2xcJ;AwEt8cA;EzDwKI,mCAAA;AfiycJ;AwEz8cA;EzD2KI,8CAAA;AfiycJ;AwE58cA;EzDwKI,oCAAA;AfuycJ;AwE/8cA;EzD2KI,+CAAA;AfuycJ;AwEl9cA;EzDwKI,oCAAA;Af6ycJ;AwEr9cA;EzD2KI,+CAAA;Af6ycJ;AwEx9cA;EzDwKI,kCAAA;AfmzcJ;AwE39cA;EzD2KI,6CAAA;AfmzcJ;AwE99cA;EzDwKI,kCAAA;AfyzcJ;AwEj+cA;EzD2KI,6CAAA;AfyzcJ;AwEp+cA;EzDwKI,0BAAA;Af+zcJ;AwEv+cA;EzD2KI,qCAAA;Af+zcJ;AwE1+cA;EzDwKI,0BAAA;Afq0cJ;AwE7+cA;EzD2KI,qCAAA;Afq0cJ;AwEh/cA;EzDwKI,eAAA;Af20cJ;AwEn/cA;EzD2KI,0BAAA;Af20cJ;AwEt/cA;EzDwKI,eAAA;Afi1cJ;AwEz/cA;EzD2KI,0BAAA;Afi1cJ;AwE5/cA;EzDwKI,eAAA;Afu1cJ;AwE//cA;EzD2KI,0BAAA;Afu1cJ;AwElgdA;EzDwKI,eAAA;Af61cJ;AwErgdA;EzD2KI,0BAAA;Af61cJ;AwExgdA;EzDwKI,eAAA;Afm2cJ;AwE3gdA;EzD2KI,0BAAA;Afm2cJ;AwE9gdA;EzDwKI,eAAA;Afy2cJ;AwEjhdA;EzD2KI,0BAAA;Afy2cJ;AwEphdA;EzDwKI,eAAA;Af+2cJ;AwEvhdA;EzD2KI,0BAAA;Af+2cJ;AwE1hdA;EzDwKI,eAAA;Afq3cJ;AwE7hdA;EzD2KI,0BAAA;Afq3cJ;AwEhidA;EzDwKI,eAAA;Af23cJ;AwEnidA;EzD2KI,0BAAA;Af23cJ;AwEtidA;EzDwKI,eAAA;Afi4cJ;AwEzidA;EzD2KI,0BAAA;Afi4cJ;AwE5idA;EzDwKI,oBAAA;Afu4cJ;AwE/idA;EzD2KI,+BAAA;Afu4cJ;AwEljdA;EzDwKI,oBAAA;Af64cJ;AwErjdA;EzD2KI,+BAAA;Af64cJ;AwExjdA;EzDwKI,oBAAA;Afm5cJ;AwE3jdA;EzD2KI,+BAAA;Afm5cJ;AwE9jdA;EzDwKI,oBAAA;Afy5cJ;AwEjkdA;EzD2KI,+BAAA;Afy5cJ;AwEpkdA;EzDwKI,oBAAA;Af+5cJ;AwEvkdA;EzD2KI,+BAAA;Af+5cJ;AwE1kdA;EzDwKI,oBAAA;Afq6cJ;AwE7kdA;EzD2KI,+BAAA;Afq6cJ;AwEhldA;EzDwKI,oBAAA;Af26cJ;AwEnldA;EzD2KI,+BAAA;Af26cJ;AwEtldA;EzDwKI,yBAAA;Afi7cJ;AwEzldA;EzD2KI,oCAAA;Afi7cJ;AwE5ldA;EzDwKI,yBAAA;Afu7cJ;AwE/ldA;EzD2KI,oCAAA;Afu7cJ;AwElmdA;EzDwKI,yBAAA;Af67cJ;AwErmdA;EzD2KI,oCAAA;Af67cJ;AwExmdA;EzDwKI,6BAAA;Afm8cJ;AwE3mdA;EzD2KI,wCAAA;Afm8cJ;AwE9mdA;EzDwKI,6BAAA;Afy8cJ;AwEjndA;EzD2KI,wCAAA;Afy8cJ;AwEpndA;EzDwKI,+BAAA;Af+8cJ;AwEvndA;EzD2KI,0CAAA;Af+8cJ;AwE1ndA;EzDwKI,+BAAA;Afq9cJ;AwE7ndA;EzD2KI,0CAAA;Afq9cJ;AwEhodA;EzDwKI,gCAAA;Af29cJ;AwEnodA;EzD2KI,2CAAA;Af29cJ;AwEtodA;EzDwKI,gCAAA;Afi+cJ;AwEzodA;EzD2KI,2CAAA;Afi+cJ;AwE5odA;EzDwKI,8BAAA;Afu+cJ;AwE/odA;EzD2KI,yCAAA;Afu+cJ;AwElpdA;EzDwKI,8BAAA;Af6+cJ;AwErpdA;EzD2KI,yCAAA;Af6+cJ;AwExpdA;EzDwKI,sBAAA;Afm/cJ;AwE3pdA;EzD2KI,iCAAA;Afm/cJ;AwE9pdA;EzDwKI,sBAAA;Afy/cJ;AwEjqdA;EzD2KI,iCAAA;Afy/cJ;AwEpqdA;EzDwKI,eAAA;Af+/cJ;AwEvqdA;EzD2KI,0BAAA;Af+/cJ;AwE1qdA;EzDwKI,eAAA;AfqgdJ;AwE7qdA;EzD2KI,0BAAA;AfqgdJ;AwEhrdA;EzDwKI,eAAA;Af2gdJ;AwEnrdA;EzD2KI,0BAAA;Af2gdJ;AwEtrdA;EzDwKI,eAAA;AfihdJ;AwEzrdA;EzD2KI,0BAAA;AfihdJ;AwE5rdA;EzDwKI,eAAA;AfuhdJ;AwE/rdA;EzD2KI,0BAAA;AfuhdJ;AwElsdA;EzDwKI,eAAA;Af6hdJ;AwErsdA;EzD2KI,0BAAA;Af6hdJ;AwExsdA;EzDwKI,eAAA;AfmidJ;AwE3sdA;EzD2KI,0BAAA;AfmidJ;AwE9sdA;EzDwKI,eAAA;AfyidJ;AwEjtdA;EzD2KI,0BAAA;AfyidJ;AwEptdA;EzDwKI,eAAA;Af+idJ;AwEvtdA;EzD2KI,0BAAA;Af+idJ;AwE1tdA;EzDwKI,eAAA;AfqjdJ;AwE7tdA;EzD2KI,0BAAA;AfqjdJ;AwEhudA;EzDwKI,oBAAA;Af2jdJ;AwEnudA;EzD2KI,+BAAA;Af2jdJ;AwEtudA;EzDwKI,oBAAA;AfikdJ;AwEzudA;EzD2KI,+BAAA;AfikdJ;AwE5udA;EzDwKI,oBAAA;AfukdJ;AwE/udA;EzD2KI,+BAAA;AfukdJ;AwElvdA;EzDwKI,oBAAA;Af6kdJ;AwErvdA;EzD2KI,+BAAA;Af6kdJ;AwExvdA;EzDwKI,oBAAA;AfmldJ;AwE3vdA;EzD2KI,+BAAA;AfmldJ;AwE9vdA;EzDwKI,oBAAA;AfyldJ;AwEjwdA;EzD2KI,+BAAA;AfyldJ;AwEpwdA;EzDwKI,oBAAA;Af+ldJ;AwEvwdA;EzD2KI,+BAAA;Af+ldJ;AwE1wdA;EzDwKI,yBAAA;AfqmdJ;AwE7wdA;EzD2KI,oCAAA;AfqmdJ;AwEhxdA;EzDwKI,yBAAA;Af2mdJ;AwEnxdA;EzD2KI,oCAAA;Af2mdJ;AwEtxdA;EzDwKI,yBAAA;AfindJ;AwEzxdA;EzD2KI,oCAAA;AfindJ;AwE5xdA;EzDwKI,6BAAA;AfundJ;AwE/xdA;EzD2KI,wCAAA;AfundJ;AwElydA;EzDwKI,6BAAA;Af6ndJ;AwErydA;EzD2KI,wCAAA;Af6ndJ;AwExydA;EzDwKI,+BAAA;AfmodJ;AwE3ydA;EzD2KI,0CAAA;AfmodJ;AwE9ydA;EzDwKI,+BAAA;AfyodJ;AwEjzdA;EzD2KI,0CAAA;AfyodJ;AwEpzdA;EzDwKI,gCAAA;Af+odJ;AwEvzdA;EzD2KI,2CAAA;Af+odJ;AwE1zdA;EzDwKI,gCAAA;AfqpdJ;AwE7zdA;EzD2KI,2CAAA;AfqpdJ;AwEh0dA;EzDwKI,8BAAA;Af2pdJ;AwEn0dA;EzD2KI,yCAAA;Af2pdJ;AwEt0dA;EzDwKI,8BAAA;AfiqdJ;AwEz0dA;EzD2KI,yCAAA;AfiqdJ;AwE50dA;EzDwKI,sBAAA;AfuqdJ;AwE/0dA;EzD2KI,iCAAA;AfuqdJ;AwEl1dA;EzDwKI,sBAAA;Af6qdJ;AwEr1dA;EzD2KI,iCAAA;Af6qdJ;AwEx1dA;EzDwKI,eAAA;AfmrdJ;AwE31dA;EzD2KI,0BAAA;AfmrdJ;AwE91dA;EzDwKI,eAAA;AfyrdJ;AwEj2dA;EzD2KI,0BAAA;AfyrdJ;AwEp2dA;EzDwKI,eAAA;Af+rdJ;AwEv2dA;EzD2KI,0BAAA;Af+rdJ;AwE12dA;EzDwKI,eAAA;AfqsdJ;AwE72dA;EzD2KI,0BAAA;AfqsdJ;AwEh3dA;EzDwKI,eAAA;Af2sdJ;AwEn3dA;EzD2KI,0BAAA;Af2sdJ;AwEt3dA;EzDwKI,eAAA;AfitdJ;AwEz3dA;EzD2KI,0BAAA;AfitdJ;AwE53dA;EzDwKI,eAAA;AfutdJ;AwE/3dA;EzD2KI,0BAAA;AfutdJ;AwEl4dA;EzDwKI,eAAA;Af6tdJ;AwEr4dA;EzD2KI,0BAAA;Af6tdJ;AwEx4dA;EzDwKI,eAAA;AfmudJ;AwE34dA;EzD2KI,0BAAA;AfmudJ;AwE94dA;EzDwKI,eAAA;AfyudJ;AwEj5dA;EzD2KI,0BAAA;AfyudJ;AwEp5dA;EzDwKI,oBAAA;Af+udJ;AwEv5dA;EzD2KI,+BAAA;Af+udJ;AwE15dA;EzDwKI,oBAAA;AfqvdJ;AwE75dA;EzD2KI,+BAAA;AfqvdJ;AwEh6dA;EzDwKI,oBAAA;Af2vdJ;AwEn6dA;EzD2KI,+BAAA;Af2vdJ;AwEt6dA;EzDwKI,oBAAA;AfiwdJ;AwEz6dA;EzD2KI,+BAAA;AfiwdJ;AwE56dA;EzDwKI,oBAAA;AfuwdJ;AwE/6dA;EzD2KI,+BAAA;AfuwdJ;AwEl7dA;EzDwKI,oBAAA;Af6wdJ;AwEr7dA;EzD2KI,+BAAA;Af6wdJ;AwEx7dA;EzDwKI,oBAAA;AfmxdJ;AwE37dA;EzD2KI,+BAAA;AfmxdJ;AwE97dA;EzDwKI,yBAAA;AfyxdJ;AwEj8dA;EzD2KI,oCAAA;AfyxdJ;AwEp8dA;EzDwKI,yBAAA;Af+xdJ;AwEv8dA;EzD2KI,oCAAA;Af+xdJ;AwE18dA;EzDwKI,yBAAA;AfqydJ;AwE78dA;EzD2KI,oCAAA;AfqydJ;AwEh9dA;EzDwKI,6BAAA;Af2ydJ;AwEn9dA;EzD2KI,wCAAA;Af2ydJ;AwEt9dA;EzDwKI,6BAAA;AfizdJ;AwEz9dA;EzD2KI,wCAAA;AfizdJ;AwE59dA;EzDwKI,+BAAA;AfuzdJ;AwE/9dA;EzD2KI,0CAAA;AfuzdJ;AwEl+dA;EzDwKI,+BAAA;Af6zdJ;AwEr+dA;EzD2KI,0CAAA;Af6zdJ;AwEx+dA;EzDwKI,gCAAA;Afm0dJ;AwE3+dA;EzD2KI,2CAAA;Afm0dJ;AwE9+dA;EzDwKI,gCAAA;Afy0dJ;AwEj/dA;EzD2KI,2CAAA;Afy0dJ;AwEp/dA;EzDwKI,8BAAA;Af+0dJ;AwEv/dA;EzD2KI,yCAAA;Af+0dJ;AwE1/dA;EzDwKI,8BAAA;Afq1dJ;AwE7/dA;EzD2KI,yCAAA;Afq1dJ;AwEhgeA;EzDwKI,sBAAA;Af21dJ;AwEngeA;EzD2KI,iCAAA;Af21dJ;AwEtgeA;EzDwKI,sBAAA;Afi2dJ;AwEzgeA;EzD2KI,iCAAA;Afi2dJ;AwE5geA;EzDmJI,eAAA;Af43dJ;AwE/geA;EzDsJI,0BAAA;Af43dJ;AwElheA;EzDmJI,eAAA;Afk4dJ;AwErheA;EzDsJI,0BAAA;Afk4dJ;AwExheA;EzDmJI,eAAA;Afw4dJ;AwE3heA;EzDsJI,0BAAA;Afw4dJ;AwE9heA;EzDmJI,eAAA;Af84dJ;AwEjieA;EzDsJI,0BAAA;Af84dJ;AwEpieA;EzDmJI,eAAA;Afo5dJ;AwEvieA;EzDsJI,0BAAA;Afo5dJ;AwE1ieA;EzDmJI,eAAA;Af05dJ;AwE7ieA;EzDsJI,0BAAA;Af05dJ;AwEhjeA;EzDmJI,eAAA;Afg6dJ;AwEnjeA;EzDsJI,0BAAA;Afg6dJ;AwEtjeA;EzDmJI,eAAA;Afs6dJ;AwEzjeA;EzDsJI,0BAAA;Afs6dJ;AwE5jeA;EzDmJI,eAAA;Af46dJ;AwE/jeA;EzDsJI,0BAAA;Af46dJ;AwElkeA;EzDmJI,eAAA;Afk7dJ;AwErkeA;EzDsJI,0BAAA;Afk7dJ;AwExkeA;EzDmJI,eAAA;Afw7dJ;AwE3keA;EzDsJI,0BAAA;Afw7dJ;AwE9keA;EzDmJI,eAAA;Af87dJ;AwEjleA;EzDsJI,0BAAA;Af87dJ;AwEpleA;EzDmJI,eAAA;Afo8dJ;AwEvleA;EzDsJI,0BAAA;Afo8dJ;AwE1leA;EzDmJI,eAAA;Af08dJ;AwE7leA;EzDsJI,0BAAA;Af08dJ;AwEhmeA;EzDmJI,eAAA;Afg9dJ;AwEnmeA;EzDsJI,0BAAA;Afg9dJ;AwEtmeA;EzDmJI,eAAA;Afs9dJ;AwEzmeA;EzDsJI,0BAAA;Afs9dJ;AwE5meA;EzDmJI,eAAA;Af49dJ;AwE/meA;EzDsJI,0BAAA;Af49dJ;AwElneA;EzDmJI,eAAA;Afk+dJ;AwErneA;EzDsJI,0BAAA;Afk+dJ;AwExneA;EzDmJI,eAAA;Afw+dJ;AwE3neA;EzDsJI,0BAAA;Afw+dJ;AwE9neA;EzDmJI,eAAA;Af8+dJ;AwEjoeA;EzDsJI,0BAAA;Af8+dJ;AwEpoeA;EzDmJI,eAAA;Afo/dJ;AwEvoeA;EzDsJI,0BAAA;Afo/dJ;AwE1oeA;EzDmJI,eAAA;Af0/dJ;AwE7oeA;EzDsJI,0BAAA;Af0/dJ;AwEhpeA;EzDmJI,eAAA;AfggeJ;AwEnpeA;EzDsJI,0BAAA;AfggeJ;AwEtpeA;EzDmJI,eAAA;AfsgeJ;AwEzpeA;EzDsJI,0BAAA;AfsgeJ;AwE5peA;EzDmJI,eAAA;Af4geJ;AwE/peA;EzDsJI,0BAAA;Af4geJ;AwElqeA;EzDmJI,eAAA;AfkheJ;AwErqeA;EzDsJI,0BAAA;AfkheJ;AwExqeA;EzDmJI,eAAA;AfwheJ;AwE3qeA;EzDsJI,0BAAA;AfwheJ;AwE9qeA;EzDmJI,eAAA;Af8heJ;AwEjreA;EzDsJI,0BAAA;Af8heJ;AwEpreA;EzDmJI,eAAA;AfoieJ;AwEvreA;EzDsJI,0BAAA;AfoieJ;AwE1reA;EzDmJI,eAAA;Af0ieJ;AwE7reA;EzDsJI,0BAAA;Af0ieJ;AwEhseA;EzDmJI,eAAA;AfgjeJ;AwEnseA;EzDsJI,0BAAA;AfgjeJ;AwEtseA;EzDmJI,eAAA;AfsjeJ;AwEzseA;EzDsJI,0BAAA;AfsjeJ;AwE5seA;EzDmJI,eAAA;Af4jeJ;AwE/seA;EzDsJI,0BAAA;Af4jeJ;AwElteA;EzDmJI,eAAA;AfkkeJ;AwErteA;EzDsJI,0BAAA;AfkkeJ;AwExteA;EzDmJI,eAAA;AfwkeJ;AwE3teA;EzDsJI,0BAAA;AfwkeJ;AwE9teA;EzDmJI,eAAA;Af8keJ;AwEjueA;EzDsJI,0BAAA;Af8keJ;AwEpueA;EzDmJI,eAAA;AfoleJ;AwEvueA;EzDsJI,0BAAA;AfoleJ;AwE1ueA;EzDmJI,eAAA;Af0leJ;AwE7ueA;EzDsJI,0BAAA;Af0leJ;AwEhveA;EzDmJI,eAAA;AfgmeJ;AwEnveA;EzDsJI,0BAAA;AfgmeJ;AwEtveA;EzDmJI,eAAA;AfsmeJ;AwEzveA;EzDsJI,0BAAA;AfsmeJ;AwE5veA;EzDmJI,eAAA;Af4meJ;AwE/veA;EzDsJI,0BAAA;Af4meJ;AwElweA;EzDmJI,eAAA;AfkneJ;AwErweA;EzDsJI,0BAAA;AfkneJ;AwExweA;EzDmJI,eAAA;AfwneJ;AwE3weA;EzDsJI,0BAAA;AfwneJ;AwE9weA;EzDmJI,eAAA;Af8neJ;AwEjxeA;EzDsJI,0BAAA;Af8neJ;AwEpxeA;EzDmJI,eAAA;AfooeJ;AwEvxeA;EzDsJI,0BAAA;AfooeJ;AwE1xeA;EzDmJI,eAAA;Af0oeJ;AwE7xeA;EzDsJI,0BAAA;Af0oeJ;AwEhyeA;EzDmJI,eAAA;AfgpeJ;AwEnyeA;EzDsJI,0BAAA;AfgpeJ;AwEtyeA;EzDmJI,eAAA;AfspeJ;AwEzyeA;EzDsJI,0BAAA;AfspeJ;AwE5yeA;EzDmJI,eAAA;Af4peJ;AwE/yeA;EzDsJI,0BAAA;Af4peJ;AwElzeA;EzDmJI,eAAA;AfkqeJ;AwErzeA;EzDsJI,0BAAA;AfkqeJ;AwExzeA;EzDmJI,eAAA;AfwqeJ;AwE3zeA;EzDsJI,0BAAA;AfwqeJ;AwE9zeA;EzDmJI,eAAA;Af8qeJ;AwEj0eA;EzDsJI,0BAAA;Af8qeJ;AwEp0eA;EzDmJI,eAAA;AforeJ;AwEv0eA;EzDsJI,0BAAA;AforeJ;AwE10eA;EzDmJI,eAAA;Af0reJ;AwE70eA;EzDsJI,0BAAA;Af0reJ;AwEh1eA;EzDmJI,eAAA;AfgseJ;AwEn1eA;EzDsJI,0BAAA;AfgseJ;AwEt1eA;EzDmJI,eAAA;AfsseJ;AwEz1eA;EzDsJI,0BAAA;AfsseJ;AwE51eA;EzDmJI,eAAA;Af4seJ;AwE/1eA;EzDsJI,0BAAA;Af4seJ;AwEl2eA;EzDmJI,eAAA;AfkteJ;AwEr2eA;EzDsJI,0BAAA;AfkteJ;AwEx2eA;EzDmJI,eAAA;AfwteJ;AwE32eA;EzDsJI,0BAAA;AfwteJ;AwE92eA;EzDmJI,eAAA;Af8teJ;AwEj3eA;EzDsJI,0BAAA;Af8teJ;AwEp3eA;EzDmJI,eAAA;AfoueJ;AwEv3eA;EzDsJI,0BAAA;AfoueJ;AwE13eA;EzDmJI,eAAA;Af0ueJ;AwE73eA;EzDsJI,0BAAA;Af0ueJ;AwEh4eA;EzDmJI,eAAA;AfgveJ;AwEn4eA;EzDsJI,0BAAA;AfgveJ;AwEt4eA;EzDmJI,eAAA;AfsveJ;AwEz4eA;EzDsJI,0BAAA;AfsveJ;AwE54eA;EzDmJI,eAAA;Af4veJ;AwE/4eA;EzDsJI,0BAAA;Af4veJ;AwEl5eA;EzDmJI,eAAA;AfkweJ;AwEr5eA;EzDsJI,0BAAA;AfkweJ;AwEx5eA;EzDmJI,eAAA;AfwweJ;AwE35eA;EzDsJI,0BAAA;AfwweJ;AwE95eA;EzDmJI,eAAA;Af8weJ;AwEj6eA;EzDsJI,0BAAA;Af8weJ;AwEp6eA;EzDmJI,eAAA;AfoxeJ;AwEv6eA;EzDsJI,0BAAA;AfoxeJ;AwE16eA;EzDmJI,eAAA;Af0xeJ;AwE76eA;EzDsJI,0BAAA;Af0xeJ;AwEh7eA;EzDmJI,eAAA;AfgyeJ;AwEn7eA;EzDsJI,0BAAA;AfgyeJ;AwEt7eA;EzDmJI,eAAA;AfsyeJ;AwEz7eA;EzDsJI,0BAAA;AfsyeJ;AwE57eA;EzDmJI,eAAA;Af4yeJ;AwE/7eA;EzDsJI,0BAAA;Af4yeJ;AwEl8eA;EzDmJI,eAAA;AfkzeJ;AwEr8eA;EzDsJI,0BAAA;AfkzeJ;AwEx8eA;EzDmJI,eAAA;AfwzeJ;AwE38eA;EzDsJI,0BAAA;AfwzeJ;AwE98eA;EzDmJI,eAAA;Af8zeJ;AwEj9eA;EzDsJI,0BAAA;Af8zeJ;AwEp9eA;EzDmJI,eAAA;Afo0eJ;AwEv9eA;EzDsJI,0BAAA;Afo0eJ;AwE19eA;EzDmJI,eAAA;Af00eJ;AwE79eA;EzDsJI,0BAAA;Af00eJ;AwEh+eA;EzDmJI,eAAA;Afg1eJ;AwEn+eA;EzDsJI,0BAAA;Afg1eJ;AwEt+eA;EzDmJI,eAAA;Afs1eJ;AwEz+eA;EzDsJI,0BAAA;Afs1eJ;AwE5+eA;EzDmJI,eAAA;Af41eJ;AwE/+eA;EzDsJI,0BAAA;Af41eJ;AwEl/eA;EzDmJI,eAAA;Afk2eJ;AwEr/eA;EzDsJI,0BAAA;Afk2eJ;AwEx/eA;EzDmJI,eAAA;Afw2eJ;AwE3/eA;EzDsJI,0BAAA;Afw2eJ;AwE9/eA;EzDmJI,eAAA;Af82eJ;AwEjgfA;EzDsJI,0BAAA;Af82eJ;AwEpgfA;EzDmJI,eAAA;Afo3eJ;AwEvgfA;EzDsJI,0BAAA;Afo3eJ;AwE1gfA;EzDmJI,eAAA;Af03eJ;AwE7gfA;EzDsJI,0BAAA;Af03eJ;AwEhhfA;EzDmJI,eAAA;Afg4eJ;AwEnhfA;EzDsJI,0BAAA;Afg4eJ;AwEthfA;EzDmJI,eAAA;Afs4eJ;AwEzhfA;EzDsJI,0BAAA;Afs4eJ;AwE5hfA;EzDmJI,eAAA;Af44eJ;AwE/hfA;EzDsJI,0BAAA;Af44eJ;AwElifA;EzDmJI,eAAA;Afk5eJ;AwErifA;EzDsJI,0BAAA;Afk5eJ;AwExifA;EzDmJI,eAAA;Afw5eJ;AwE3ifA;EzDsJI,0BAAA;Afw5eJ;AwE9ifA;EzDmJI,eAAA;Af85eJ;AwEjjfA;EzDsJI,0BAAA;Af85eJ;AwEpjfA;EzDmJI,eAAA;Afo6eJ;AwEvjfA;EzDsJI,0BAAA;Afo6eJ;AwE1jfA;EzDmJI,eAAA;Af06eJ;AwE7jfA;EzDsJI,0BAAA;Af06eJ;AwEhkfA;EzDmJI,eAAA;Afg7eJ;AwEnkfA;EzDsJI,0BAAA;Afg7eJ;AwEtkfA;EzDmJI,eAAA;Afs7eJ;AwEzkfA;EzDsJI,0BAAA;Afs7eJ;AwE5kfA;EzDmJI,eAAA;Af47eJ;AwE/kfA;EzDsJI,0BAAA;Af47eJ;AwEllfA;EzDmJI,eAAA;Afk8eJ;AwErlfA;EzDsJI,0BAAA;Afk8eJ;AwExlfA;EzDmJI,eAAA;Afw8eJ;AwE3lfA;EzDsJI,0BAAA;Afw8eJ;AwE9lfA;EzDmJI,eAAA;Af88eJ;AwEjmfA;EzDsJI,0BAAA;Af88eJ;AwEpmfA;EzDmJI,oBAAA;Afo9eJ;AwEvmfA;EzDsJI,+BAAA;Afo9eJ;AwE1mfA;EzDmJI,oBAAA;Af09eJ;AwE7mfA;EzDsJI,+BAAA;Af09eJ;AwEhnfA;EzDmJI,oBAAA;Afg+eJ;AwEnnfA;EzDsJI,+BAAA;Afg+eJ;AwEtnfA;EzDmJI,oBAAA;Afs+eJ;AwEznfA;EzDsJI,+BAAA;Afs+eJ;AwE5nfA;EzDmJI,oBAAA;Af4+eJ;AwE/nfA;EzDsJI,+BAAA;Af4+eJ;AwElofA;EzDmJI,oBAAA;Afk/eJ;AwErofA;EzDsJI,+BAAA;Afk/eJ;AwExofA;EzDmJI,oBAAA;Afw/eJ;AwE3ofA;EzDsJI,+BAAA;Afw/eJ;AwE9ofA;EzDmJI,oBAAA;Af8/eJ;AwEjpfA;EzDsJI,+BAAA;Af8/eJ;AwEppfA;EzDmJI,oBAAA;AfogfJ;AwEvpfA;EzDsJI,+BAAA;AfogfJ;AwE1pfA;EzDmJI,oBAAA;Af0gfJ;AwE7pfA;EzDsJI,+BAAA;Af0gfJ;AwEhqfA;EzDmJI,oBAAA;AfghfJ;AwEnqfA;EzDsJI,+BAAA;AfghfJ;AwEtqfA;EzDmJI,oBAAA;AfshfJ;AwEzqfA;EzDsJI,+BAAA;AfshfJ;AwE5qfA;EzDmJI,oBAAA;Af4hfJ;AwE/qfA;EzDsJI,+BAAA;Af4hfJ;AwElrfA;EzDmJI,oBAAA;AfkifJ;AwErrfA;EzDsJI,+BAAA;AfkifJ;AwExrfA;EzDmJI,oBAAA;AfwifJ;AwE3rfA;EzDsJI,+BAAA;AfwifJ;AwE9rfA;EzDmJI,oBAAA;Af8ifJ;AwEjsfA;EzDsJI,+BAAA;Af8ifJ;AwEpsfA;EzDmJI,oBAAA;AfojfJ;AwEvsfA;EzDsJI,+BAAA;AfojfJ;AwE1sfA;EzDmJI,oBAAA;Af0jfJ;AwE7sfA;EzDsJI,+BAAA;Af0jfJ;AwEhtfA;EzDmJI,oBAAA;AfgkfJ;AwEntfA;EzDsJI,+BAAA;AfgkfJ;AwEttfA;EzDmJI,oBAAA;AfskfJ;AwEztfA;EzDsJI,+BAAA;AfskfJ;AwE5tfA;EzDmJI,oBAAA;Af4kfJ;AwE/tfA;EzDsJI,+BAAA;Af4kfJ;AwElufA;EzDmJI,oBAAA;AfklfJ;AwErufA;EzDsJI,+BAAA;AfklfJ;AwExufA;EzDmJI,oBAAA;AfwlfJ;AwE3ufA;EzDsJI,+BAAA;AfwlfJ;AwE9ufA;EzDmJI,oBAAA;Af8lfJ;AwEjvfA;EzDsJI,+BAAA;Af8lfJ;AwEpvfA;EzDmJI,oBAAA;AfomfJ;AwEvvfA;EzDsJI,+BAAA;AfomfJ;AwE1vfA;EzDmJI,oBAAA;Af0mfJ;AwE7vfA;EzDsJI,+BAAA;Af0mfJ;AwEhwfA;EzDmJI,oBAAA;AfgnfJ;AwEnwfA;EzDsJI,+BAAA;AfgnfJ;AwEtwfA;EzDmJI,oBAAA;AfsnfJ;AwEzwfA;EzDsJI,+BAAA;AfsnfJ;AwE5wfA;EzDmJI,oBAAA;Af4nfJ;AwE/wfA;EzDsJI,+BAAA;Af4nfJ;AwElxfA;EzDmJI,oBAAA;AfkofJ;AwErxfA;EzDsJI,+BAAA;AfkofJ;AwExxfA;EzDmJI,oBAAA;AfwofJ;AwE3xfA;EzDsJI,+BAAA;AfwofJ;AwE9xfA;EzDmJI,oBAAA;Af8ofJ;AwEjyfA;EzDsJI,+BAAA;Af8ofJ;AwEpyfA;EzDmJI,oBAAA;AfopfJ;AwEvyfA;EzDsJI,+BAAA;AfopfJ;AwE1yfA;EzDmJI,oBAAA;Af0pfJ;AwE7yfA;EzDsJI,+BAAA;Af0pfJ;AwEhzfA;EzDmJI,oBAAA;AfgqfJ;AwEnzfA;EzDsJI,+BAAA;AfgqfJ;AwEtzfA;EzDmJI,oBAAA;AfsqfJ;AwEzzfA;EzDsJI,+BAAA;AfsqfJ;AwE5zfA;EzDmJI,oBAAA;Af4qfJ;AwE/zfA;EzDsJI,+BAAA;Af4qfJ;AwEl0fA;EzDmJI,oBAAA;AfkrfJ;AwEr0fA;EzDsJI,+BAAA;AfkrfJ;AwEx0fA;EzDmJI,oBAAA;AfwrfJ;AwE30fA;EzDsJI,+BAAA;AfwrfJ;AwE90fA;EzDmJI,oBAAA;Af8rfJ;AwEj1fA;EzDsJI,+BAAA;Af8rfJ;AwEp1fA;EzDmJI,oBAAA;AfosfJ;AwEv1fA;EzDsJI,+BAAA;AfosfJ;AwE11fA;EzDmJI,oBAAA;Af0sfJ;AwE71fA;EzDsJI,+BAAA;Af0sfJ;AwEh2fA;EzDmJI,oBAAA;AfgtfJ;AwEn2fA;EzDsJI,+BAAA;AfgtfJ;AwEt2fA;EzDmJI,oBAAA;AfstfJ;AwEz2fA;EzDsJI,+BAAA;AfstfJ;AwE52fA;EzDmJI,oBAAA;Af4tfJ;AwE/2fA;EzDsJI,+BAAA;Af4tfJ;AwEl3fA;EzDmJI,oBAAA;AfkufJ;AwEr3fA;EzDsJI,+BAAA;AfkufJ;AwEx3fA;EzDmJI,oBAAA;AfwufJ;AwE33fA;EzDsJI,+BAAA;AfwufJ;AwE93fA;EzDmJI,oBAAA;Af8ufJ;AwEj4fA;EzDsJI,+BAAA;Af8ufJ;AwEp4fA;EzDmJI,oBAAA;AfovfJ;AwEv4fA;EzDsJI,+BAAA;AfovfJ;AwE14fA;EzDmJI,oBAAA;Af0vfJ;AwE74fA;EzDsJI,+BAAA;Af0vfJ;AwEh5fA;EzDmJI,oBAAA;AfgwfJ;AwEn5fA;EzDsJI,+BAAA;AfgwfJ;AwEt5fA;EzDmJI,oBAAA;AfswfJ;AwEz5fA;EzDsJI,+BAAA;AfswfJ;AwE55fA;EzDmJI,oBAAA;Af4wfJ;AwE/5fA;EzDsJI,+BAAA;Af4wfJ;AwEl6fA;EzDmJI,oBAAA;AfkxfJ;AwEr6fA;EzDsJI,+BAAA;AfkxfJ;AwEx6fA;EzDmJI,oBAAA;AfwxfJ;AwE36fA;EzDsJI,+BAAA;AfwxfJ;AwE96fA;EzDmJI,oBAAA;Af8xfJ;AwEj7fA;EzDsJI,+BAAA;Af8xfJ;AwEp7fA;EzDmJI,oBAAA;AfoyfJ;AwEv7fA;EzDsJI,+BAAA;AfoyfJ;AwE17fA;EzDmJI,oBAAA;Af0yfJ;AwE77fA;EzDsJI,+BAAA;Af0yfJ;AwEh8fA;EzDmJI,oBAAA;AfgzfJ;AwEn8fA;EzDsJI,+BAAA;AfgzfJ;AwEt8fA;EzDmJI,oBAAA;AfszfJ;AwEz8fA;EzDsJI,+BAAA;AfszfJ;AwE58fA;EzDmJI,oBAAA;Af4zfJ;AwE/8fA;EzDsJI,+BAAA;Af4zfJ;AwEl9fA;EzDmJI,oBAAA;Afk0fJ;AwEr9fA;EzDsJI,+BAAA;Afk0fJ;AwEx9fA;EzDmJI,oBAAA;Afw0fJ;AwE39fA;EzDsJI,+BAAA;Afw0fJ;AwE99fA;EzDmJI,oBAAA;Af80fJ;AwEj+fA;EzDsJI,+BAAA;Af80fJ;AwEp+fA;EzDmJI,oBAAA;Afo1fJ;AwEv+fA;EzDsJI,+BAAA;Afo1fJ;AwE1+fA;EzDmJI,oBAAA;Af01fJ;AwE7+fA;EzDsJI,+BAAA;Af01fJ;AwEh/fA;EzDmJI,oBAAA;Afg2fJ;AwEn/fA;EzDsJI,+BAAA;Afg2fJ;AwEt/fA;EzDmJI,oBAAA;Afs2fJ;AwEz/fA;EzDsJI,+BAAA;Afs2fJ;AwE5/fA;EzDmJI,oBAAA;Af42fJ;AwE//fA;EzDsJI,+BAAA;Af42fJ;AwElggBA;EzDmJI,oBAAA;Afk3fJ;AwErggBA;EzDsJI,+BAAA;Afk3fJ;AwExggBA;EzDmJI,yBAAA;Afw3fJ;AwE3ggBA;EzDsJI,oCAAA;Afw3fJ;AwE9ggBA;EzDmJI,yBAAA;Af83fJ;AwEjhgBA;EzDsJI,oCAAA;Af83fJ;AwEphgBA;EzDmJI,yBAAA;Afo4fJ;AwEvhgBA;EzDsJI,oCAAA;Afo4fJ;AwE1hgBA;EzDmJI,yBAAA;Af04fJ;AwE7hgBA;EzDsJI,oCAAA;Af04fJ;AwEhigBA;EzDmJI,yBAAA;Afg5fJ;AwEnigBA;EzDsJI,oCAAA;Afg5fJ;AwEtigBA;EzDmJI,yBAAA;Afs5fJ;AwEzigBA;EzDsJI,oCAAA;Afs5fJ;AwE5igBA;EzDmJI,yBAAA;Af45fJ;AwE/igBA;EzDsJI,oCAAA;Af45fJ;AwEljgBA;EzDmJI,yBAAA;Afk6fJ;AwErjgBA;EzDsJI,oCAAA;Afk6fJ;AwExjgBA;EzDmJI,yBAAA;Afw6fJ;AwE3jgBA;EzDsJI,oCAAA;Afw6fJ;AwE9jgBA;EzDmJI,yBAAA;Af86fJ;AwEjkgBA;EzDsJI,oCAAA;Af86fJ;AwEpkgBA;EzDmJI,yBAAA;Afo7fJ;AwEvkgBA;EzDsJI,oCAAA;Afo7fJ;AwE1kgBA;EzDmJI,yBAAA;Af07fJ;AwE7kgBA;EzDsJI,oCAAA;Af07fJ;AwEhlgBA;EzDmJI,yBAAA;Afg8fJ;AwEnlgBA;EzDsJI,oCAAA;Afg8fJ;AwEtlgBA;EzDmJI,yBAAA;Afs8fJ;AwEzlgBA;EzDsJI,oCAAA;Afs8fJ;AwE5lgBA;EzDmJI,yBAAA;Af48fJ;AwE/lgBA;EzDsJI,oCAAA;Af48fJ;AwElmgBA;EzDmJI,yBAAA;Afk9fJ;AwErmgBA;EzDsJI,oCAAA;Afk9fJ;AwExmgBA;EzDmJI,yBAAA;Afw9fJ;AwE3mgBA;EzDsJI,oCAAA;Afw9fJ;AwE9mgBA;EzDmJI,yBAAA;Af89fJ;AwEjngBA;EzDsJI,oCAAA;Af89fJ;AwEpngBA;EzDmJI,yBAAA;Afo+fJ;AwEvngBA;EzDsJI,oCAAA;Afo+fJ;AwE1ngBA;EzDmJI,yBAAA;Af0+fJ;AwE7ngBA;EzDsJI,oCAAA;Af0+fJ;AwEhogBA;EzDmJI,yBAAA;Afg/fJ;AwEnogBA;EzDsJI,oCAAA;Afg/fJ;AwEtogBA;EzDmJI,yBAAA;Afs/fJ;AwEzogBA;EzDsJI,oCAAA;Afs/fJ;AwE5ogBA;EzDmJI,yBAAA;Af4/fJ;AwE/ogBA;EzDsJI,oCAAA;Af4/fJ;AwElpgBA;EzDmJI,yBAAA;AfkggBJ;AwErpgBA;EzDsJI,oCAAA;AfkggBJ;AwExpgBA;EzDmJI,yBAAA;AfwggBJ;AwE3pgBA;EzDsJI,oCAAA;AfwggBJ;AwE9pgBA;EzDmJI,yBAAA;Af8ggBJ;AwEjqgBA;EzDsJI,oCAAA;Af8ggBJ;AwEpqgBA;EzDmJI,yBAAA;AfohgBJ;AwEvqgBA;EzDsJI,oCAAA;AfohgBJ;AwE1qgBA;EzDmJI,yBAAA;Af0hgBJ;AwE7qgBA;EzDsJI,oCAAA;Af0hgBJ;AwEhrgBA;EzDmJI,yBAAA;AfgigBJ;AwEnrgBA;EzDsJI,oCAAA;AfgigBJ;AwEtrgBA;EzDmJI,yBAAA;AfsigBJ;AwEzrgBA;EzDsJI,oCAAA;AfsigBJ;AwE5rgBA;EzDmJI,6BAAA;Af4igBJ;AwE/rgBA;EzDsJI,wCAAA;Af4igBJ;AwElsgBA;EzDmJI,6BAAA;AfkjgBJ;AwErsgBA;EzDsJI,wCAAA;AfkjgBJ;AwExsgBA;EzDmJI,6BAAA;AfwjgBJ;AwE3sgBA;EzDsJI,wCAAA;AfwjgBJ;AwE9sgBA;EzDmJI,6BAAA;Af8jgBJ;AwEjtgBA;EzDsJI,wCAAA;Af8jgBJ;AwEptgBA;EzDmJI,6BAAA;AfokgBJ;AwEvtgBA;EzDsJI,wCAAA;AfokgBJ;AwE1tgBA;EzDmJI,6BAAA;Af0kgBJ;AwE7tgBA;EzDsJI,wCAAA;Af0kgBJ;AwEhugBA;EzDmJI,6BAAA;AfglgBJ;AwEnugBA;EzDsJI,wCAAA;AfglgBJ;AwEtugBA;EzDmJI,6BAAA;AfslgBJ;AwEzugBA;EzDsJI,wCAAA;AfslgBJ;AwE5ugBA;EzDmJI,6BAAA;Af4lgBJ;AwE/ugBA;EzDsJI,wCAAA;Af4lgBJ;AwElvgBA;EzDmJI,6BAAA;AfkmgBJ;AwErvgBA;EzDsJI,wCAAA;AfkmgBJ;AwExvgBA;EzDmJI,6BAAA;AfwmgBJ;AwE3vgBA;EzDsJI,wCAAA;AfwmgBJ;AwE9vgBA;EzDmJI,6BAAA;Af8mgBJ;AwEjwgBA;EzDsJI,wCAAA;Af8mgBJ;AwEpwgBA;EzDmJI,6BAAA;AfongBJ;AwEvwgBA;EzDsJI,wCAAA;AfongBJ;AwE1wgBA;EzDmJI,6BAAA;Af0ngBJ;AwE7wgBA;EzDsJI,wCAAA;Af0ngBJ;AwEhxgBA;EzDmJI,6BAAA;AfgogBJ;AwEnxgBA;EzDsJI,wCAAA;AfgogBJ;AwEtxgBA;EzDmJI,6BAAA;AfsogBJ;AwEzxgBA;EzDsJI,wCAAA;AfsogBJ;AwE5xgBA;EzDmJI,6BAAA;Af4ogBJ;AwE/xgBA;EzDsJI,wCAAA;Af4ogBJ;AwElygBA;EzDmJI,6BAAA;AfkpgBJ;AwErygBA;EzDsJI,wCAAA;AfkpgBJ;AwExygBA;EzDmJI,6BAAA;AfwpgBJ;AwE3ygBA;EzDsJI,wCAAA;AfwpgBJ;AwE9ygBA;EzDmJI,6BAAA;Af8pgBJ;AwEjzgBA;EzDsJI,wCAAA;Af8pgBJ;AwEpzgBA;EzDmJI,+BAAA;AfoqgBJ;AwEvzgBA;EzDsJI,0CAAA;AfoqgBJ;AwE1zgBA;EzDmJI,+BAAA;Af0qgBJ;AwE7zgBA;EzDsJI,0CAAA;Af0qgBJ;AwEh0gBA;EzDmJI,+BAAA;AfgrgBJ;AwEn0gBA;EzDsJI,0CAAA;AfgrgBJ;AwEt0gBA;EzDmJI,+BAAA;AfsrgBJ;AwEz0gBA;EzDsJI,0CAAA;AfsrgBJ;AwE50gBA;EzDmJI,+BAAA;Af4rgBJ;AwE/0gBA;EzDsJI,0CAAA;Af4rgBJ;AwEl1gBA;EzDmJI,+BAAA;AfksgBJ;AwEr1gBA;EzDsJI,0CAAA;AfksgBJ;AwEx1gBA;EzDmJI,+BAAA;AfwsgBJ;AwE31gBA;EzDsJI,0CAAA;AfwsgBJ;AwE91gBA;EzDmJI,+BAAA;Af8sgBJ;AwEj2gBA;EzDsJI,0CAAA;Af8sgBJ;AwEp2gBA;EzDmJI,+BAAA;AfotgBJ;AwEv2gBA;EzDsJI,0CAAA;AfotgBJ;AwE12gBA;EzDmJI,+BAAA;Af0tgBJ;AwE72gBA;EzDsJI,0CAAA;Af0tgBJ;AwEh3gBA;EzDmJI,+BAAA;AfgugBJ;AwEn3gBA;EzDsJI,0CAAA;AfgugBJ;AwEt3gBA;EzDmJI,+BAAA;AfsugBJ;AwEz3gBA;EzDsJI,0CAAA;AfsugBJ;AwE53gBA;EzDmJI,+BAAA;Af4ugBJ;AwE/3gBA;EzDsJI,0CAAA;Af4ugBJ;AwEl4gBA;EzDmJI,+BAAA;AfkvgBJ;AwEr4gBA;EzDsJI,0CAAA;AfkvgBJ;AwEx4gBA;EzDmJI,+BAAA;AfwvgBJ;AwE34gBA;EzDsJI,0CAAA;AfwvgBJ;AwE94gBA;EzDmJI,+BAAA;Af8vgBJ;AwEj5gBA;EzDsJI,0CAAA;Af8vgBJ;AwEp5gBA;EzDmJI,+BAAA;AfowgBJ;AwEv5gBA;EzDsJI,0CAAA;AfowgBJ;AwE15gBA;EzDmJI,+BAAA;Af0wgBJ;AwE75gBA;EzDsJI,0CAAA;Af0wgBJ;AwEh6gBA;EzDmJI,+BAAA;AfgxgBJ;AwEn6gBA;EzDsJI,0CAAA;AfgxgBJ;AwEt6gBA;EzDmJI,+BAAA;AfsxgBJ;AwEz6gBA;EzDsJI,0CAAA;AfsxgBJ;AwE56gBA;EzDmJI,gCAAA;Af4xgBJ;AwE/6gBA;EzDsJI,2CAAA;Af4xgBJ;AwEl7gBA;EzDmJI,gCAAA;AfkygBJ;AwEr7gBA;EzDsJI,2CAAA;AfkygBJ;AwEx7gBA;EzDmJI,gCAAA;AfwygBJ;AwE37gBA;EzDsJI,2CAAA;AfwygBJ;AwE97gBA;EzDmJI,gCAAA;Af8ygBJ;AwEj8gBA;EzDsJI,2CAAA;Af8ygBJ;AwEp8gBA;EzDmJI,gCAAA;AfozgBJ;AwEv8gBA;EzDsJI,2CAAA;AfozgBJ;AwE18gBA;EzDmJI,gCAAA;Af0zgBJ;AwE78gBA;EzDsJI,2CAAA;Af0zgBJ;AwEh9gBA;EzDmJI,gCAAA;Afg0gBJ;AwEn9gBA;EzDsJI,2CAAA;Afg0gBJ;AwEt9gBA;EzDmJI,gCAAA;Afs0gBJ;AwEz9gBA;EzDsJI,2CAAA;Afs0gBJ;AwE59gBA;EzDmJI,gCAAA;Af40gBJ;AwE/9gBA;EzDsJI,2CAAA;Af40gBJ;AwEl+gBA;EzDmJI,gCAAA;Afk1gBJ;AwEr+gBA;EzDsJI,2CAAA;Afk1gBJ;AwEx+gBA;EzDmJI,gCAAA;Afw1gBJ;AwE3+gBA;EzDsJI,2CAAA;Afw1gBJ;AwE9+gBA;EzDmJI,gCAAA;Af81gBJ;AwEj/gBA;EzDsJI,2CAAA;Af81gBJ;AwEp/gBA;EzDmJI,gCAAA;Afo2gBJ;AwEv/gBA;EzDsJI,2CAAA;Afo2gBJ;AwE1/gBA;EzDmJI,gCAAA;Af02gBJ;AwE7/gBA;EzDsJI,2CAAA;Af02gBJ;AwEhghBA;EzDmJI,gCAAA;Afg3gBJ;AwEnghBA;EzDsJI,2CAAA;Afg3gBJ;AwEtghBA;EzDmJI,gCAAA;Afs3gBJ;AwEzghBA;EzDsJI,2CAAA;Afs3gBJ;AwE5ghBA;EzDmJI,gCAAA;Af43gBJ;AwE/ghBA;EzDsJI,2CAAA;Af43gBJ;AwElhhBA;EzDmJI,gCAAA;Afk4gBJ;AwErhhBA;EzDsJI,2CAAA;Afk4gBJ;AwExhhBA;EzDmJI,gCAAA;Afw4gBJ;AwE3hhBA;EzDsJI,2CAAA;Afw4gBJ;AwE9hhBA;EzDmJI,gCAAA;Af84gBJ;AwEjihBA;EzDsJI,2CAAA;Af84gBJ;AwEpihBA;EzDmJI,8BAAA;Afo5gBJ;AwEvihBA;EzDsJI,yCAAA;Afo5gBJ;AwE1ihBA;EzDmJI,8BAAA;Af05gBJ;AwE7ihBA;EzDsJI,yCAAA;Af05gBJ;AwEhjhBA;EzDmJI,8BAAA;Afg6gBJ;AwEnjhBA;EzDsJI,yCAAA;Afg6gBJ;AwEtjhBA;EzDmJI,8BAAA;Afs6gBJ;AwEzjhBA;EzDsJI,yCAAA;Afs6gBJ;AwE5jhBA;EzDmJI,8BAAA;Af46gBJ;AwE/jhBA;EzDsJI,yCAAA;Af46gBJ;AwElkhBA;EzDmJI,8BAAA;Afk7gBJ;AwErkhBA;EzDsJI,yCAAA;Afk7gBJ;AwExkhBA;EzDmJI,8BAAA;Afw7gBJ;AwE3khBA;EzDsJI,yCAAA;Afw7gBJ;AwE9khBA;EzDmJI,8BAAA;Af87gBJ;AwEjlhBA;EzDsJI,yCAAA;Af87gBJ;AwEplhBA;EzDmJI,8BAAA;Afo8gBJ;AwEvlhBA;EzDsJI,yCAAA;Afo8gBJ;AwE1lhBA;EzDmJI,8BAAA;Af08gBJ;AwE7lhBA;EzDsJI,yCAAA;Af08gBJ;AwEhmhBA;EzDmJI,8BAAA;Afg9gBJ;AwEnmhBA;EzDsJI,yCAAA;Afg9gBJ;AwEtmhBA;EzDmJI,8BAAA;Afs9gBJ;AwEzmhBA;EzDsJI,yCAAA;Afs9gBJ;AwE5mhBA;EzDmJI,8BAAA;Af49gBJ;AwE/mhBA;EzDsJI,yCAAA;Af49gBJ;AwElnhBA;EzDmJI,8BAAA;Afk+gBJ;AwErnhBA;EzDsJI,yCAAA;Afk+gBJ;AwExnhBA;EzDmJI,8BAAA;Afw+gBJ;AwE3nhBA;EzDsJI,yCAAA;Afw+gBJ;AwE9nhBA;EzDmJI,8BAAA;Af8+gBJ;AwEjohBA;EzDsJI,yCAAA;Af8+gBJ;AwEpohBA;EzDmJI,8BAAA;Afo/gBJ;AwEvohBA;EzDsJI,yCAAA;Afo/gBJ;AwE1ohBA;EzDmJI,8BAAA;Af0/gBJ;AwE7ohBA;EzDsJI,yCAAA;Af0/gBJ;AwEhphBA;EzDmJI,8BAAA;AfgghBJ;AwEnphBA;EzDsJI,yCAAA;AfgghBJ;AwEtphBA;EzDmJI,8BAAA;AfsghBJ;AwEzphBA;EzDsJI,yCAAA;AfsghBJ;AwE5phBA;EzDmJI,sBAAA;Af4ghBJ;AwE/phBA;EzDsJI,iCAAA;Af4ghBJ;AwElqhBA;EzDmJI,sBAAA;AfkhhBJ;AwErqhBA;EzDsJI,iCAAA;AfkhhBJ;AwExqhBA;EzDmJI,sBAAA;AfwhhBJ;AwE3qhBA;EzDsJI,iCAAA;AfwhhBJ;AwE9qhBA;EzDmJI,sBAAA;Af8hhBJ;AwEjrhBA;EzDsJI,iCAAA;Af8hhBJ;AwEprhBA;EzDmJI,sBAAA;AfoihBJ;AwEvrhBA;EzDsJI,iCAAA;AfoihBJ;AwE1rhBA;EzDmJI,sBAAA;Af0ihBJ;AwE7rhBA;EzDsJI,iCAAA;Af0ihBJ;AwEhshBA;EzDmJI,sBAAA;AfgjhBJ;AwEnshBA;EzDsJI,iCAAA;AfgjhBJ;AwEtshBA;EzDmJI,sBAAA;AfsjhBJ;AwEzshBA;EzDsJI,iCAAA;AfsjhBJ;AwE5shBA;EzDmJI,sBAAA;Af4jhBJ;AwE/shBA;EzDsJI,iCAAA;Af4jhBJ;AwElthBA;EzDmJI,sBAAA;AfkkhBJ;AwErthBA;EzDsJI,iCAAA;AfkkhBJ;AwExthBA;EzDmJI,sBAAA;AfwkhBJ;AwE3thBA;EzDsJI,iCAAA;AfwkhBJ;AwE9thBA;EzDmJI,sBAAA;Af8khBJ;AwEjuhBA;EzDsJI,iCAAA;Af8khBJ;AwEpuhBA;EzDmJI,sBAAA;AfolhBJ;AwEvuhBA;EzDsJI,iCAAA;AfolhBJ;AwE1uhBA;EzDmJI,sBAAA;Af0lhBJ;AwE7uhBA;EzDsJI,iCAAA;Af0lhBJ;AwEhvhBA;EzDmJI,sBAAA;AfgmhBJ;AwEnvhBA;EzDsJI,iCAAA;AfgmhBJ;AwEtvhBA;EzDmJI,sBAAA;AfsmhBJ;AwEzvhBA;EzDsJI,iCAAA;AfsmhBJ;AwE5vhBA;EzDmJI,sBAAA;Af4mhBJ;AwE/vhBA;EzDsJI,iCAAA;Af4mhBJ;AwElwhBA;EzDmJI,sBAAA;AfknhBJ;AwErwhBA;EzDsJI,iCAAA;AfknhBJ;AwExwhBA;EzDmJI,sBAAA;AfwnhBJ;AwE3whBA;EzDsJI,iCAAA;AfwnhBJ;AwE9whBA;EzDmJI,sBAAA;Af8nhBJ;AwEjxhBA;EzDsJI,iCAAA;Af8nhBJ;AwEpxhBA;EzDmJI,eAAA;AfoohBJ;AwEvxhBA;EzDsJI,0BAAA;AfoohBJ;AwE1xhBA;EzDmJI,eAAA;Af0ohBJ;AwE7xhBA;EzDsJI,0BAAA;Af0ohBJ;AwEhyhBA;EzDmJI,eAAA;AfgphBJ;AwEnyhBA;EzDsJI,0BAAA;AfgphBJ;AwEtyhBA;EzDmJI,eAAA;AfsphBJ;AwEzyhBA;EzDsJI,0BAAA;AfsphBJ;AwE5yhBA;EzDmJI,eAAA;Af4phBJ;AwE/yhBA;EzDsJI,0BAAA;Af4phBJ;AwElzhBA;EzDmJI,eAAA;AfkqhBJ;AwErzhBA;EzDsJI,0BAAA;AfkqhBJ;AwExzhBA;EzDmJI,eAAA;AfwqhBJ;AwE3zhBA;EzDsJI,0BAAA;AfwqhBJ;AwE9zhBA;EzDmJI,eAAA;Af8qhBJ;AwEj0hBA;EzDsJI,0BAAA;Af8qhBJ;AwEp0hBA;EzDmJI,eAAA;AforhBJ;AwEv0hBA;EzDsJI,0BAAA;AforhBJ;AwE10hBA;EzDmJI,eAAA;Af0rhBJ;AwE70hBA;EzDsJI,0BAAA;Af0rhBJ;AwEh1hBA;EzDmJI,eAAA;AfgshBJ;AwEn1hBA;EzDsJI,0BAAA;AfgshBJ;AwEt1hBA;EzDmJI,eAAA;AfsshBJ;AwEz1hBA;EzDsJI,0BAAA;AfsshBJ;AwE51hBA;EzDmJI,eAAA;Af4shBJ;AwE/1hBA;EzDsJI,0BAAA;Af4shBJ;AwEl2hBA;EzDmJI,eAAA;AfkthBJ;AwEr2hBA;EzDsJI,0BAAA;AfkthBJ;AwEx2hBA;EzDmJI,eAAA;AfwthBJ;AwE32hBA;EzDsJI,0BAAA;AfwthBJ;AwE92hBA;EzDmJI,eAAA;Af8thBJ;AwEj3hBA;EzDsJI,0BAAA;Af8thBJ;AwEp3hBA;EzDmJI,eAAA;AfouhBJ;AwEv3hBA;EzDsJI,0BAAA;AfouhBJ;AwE13hBA;EzDmJI,eAAA;Af0uhBJ;AwE73hBA;EzDsJI,0BAAA;Af0uhBJ;AwEh4hBA;EzDmJI,eAAA;AfgvhBJ;AwEn4hBA;EzDsJI,0BAAA;AfgvhBJ;AwEt4hBA;EzDmJI,eAAA;AfsvhBJ;AwEz4hBA;EzDsJI,0BAAA;AfsvhBJ;AwE54hBA;EzDmJI,eAAA;Af4vhBJ;AwE/4hBA;EzDsJI,0BAAA;Af4vhBJ;AwEl5hBA;EzDmJI,eAAA;AfkwhBJ;AwEr5hBA;EzDsJI,0BAAA;AfkwhBJ;AwEx5hBA;EzDmJI,eAAA;AfwwhBJ;AwE35hBA;EzDsJI,0BAAA;AfwwhBJ;AwE95hBA;EzDmJI,eAAA;Af8whBJ;AwEj6hBA;EzDsJI,0BAAA;Af8whBJ;AwEp6hBA;EzDmJI,eAAA;AfoxhBJ;AwEv6hBA;EzDsJI,0BAAA;AfoxhBJ;AwE16hBA;EzDmJI,eAAA;Af0xhBJ;AwE76hBA;EzDsJI,0BAAA;Af0xhBJ;AwEh7hBA;EzDmJI,eAAA;AfgyhBJ;AwEn7hBA;EzDsJI,0BAAA;AfgyhBJ;AwEt7hBA;EzDmJI,eAAA;AfsyhBJ;AwEz7hBA;EzDsJI,0BAAA;AfsyhBJ;AwE57hBA;EzDmJI,eAAA;Af4yhBJ;AwE/7hBA;EzDsJI,0BAAA;Af4yhBJ;AwEl8hBA;EzDmJI,eAAA;AfkzhBJ;AwEr8hBA;EzDsJI,0BAAA;AfkzhBJ;AwEx8hBA;EzDmJI,eAAA;AfwzhBJ;AwE38hBA;EzDsJI,0BAAA;AfwzhBJ;AwE98hBA;EzDmJI,eAAA;Af8zhBJ;AwEj9hBA;EzDsJI,0BAAA;Af8zhBJ;AwEp9hBA;EzDmJI,eAAA;Afo0hBJ;AwEv9hBA;EzDsJI,0BAAA;Afo0hBJ;AwE19hBA;EzDmJI,eAAA;Af00hBJ;AwE79hBA;EzDsJI,0BAAA;Af00hBJ;AwEh+hBA;EzDmJI,eAAA;Afg1hBJ;AwEn+hBA;EzDsJI,0BAAA;Afg1hBJ;AwEt+hBA;EzDmJI,eAAA;Afs1hBJ;AwEz+hBA;EzDsJI,0BAAA;Afs1hBJ;AwE5+hBA;EzDmJI,eAAA;Af41hBJ;AwE/+hBA;EzDsJI,0BAAA;Af41hBJ;AwEl/hBA;EzDmJI,eAAA;Afk2hBJ;AwEr/hBA;EzDsJI,0BAAA;Afk2hBJ;AwEx/hBA;EzDmJI,eAAA;Afw2hBJ;AwE3/hBA;EzDsJI,0BAAA;Afw2hBJ;AwE9/hBA;EzDmJI,eAAA;Af82hBJ;AwEjgiBA;EzDsJI,0BAAA;Af82hBJ;AwEpgiBA;EzDmJI,eAAA;Afo3hBJ;AwEvgiBA;EzDsJI,0BAAA;Afo3hBJ;AwE1giBA;EzDmJI,eAAA;Af03hBJ;AwE7giBA;EzDsJI,0BAAA;Af03hBJ;AwEhhiBA;EzDmJI,eAAA;Afg4hBJ;AwEnhiBA;EzDsJI,0BAAA;Afg4hBJ;AwEthiBA;EzDmJI,eAAA;Afs4hBJ;AwEzhiBA;EzDsJI,0BAAA;Afs4hBJ;AwE5hiBA;EzDmJI,eAAA;Af44hBJ;AwE/hiBA;EzDsJI,0BAAA;Af44hBJ;AwEliiBA;EzDmJI,eAAA;Afk5hBJ;AwEriiBA;EzDsJI,0BAAA;Afk5hBJ;AwExiiBA;EzDmJI,eAAA;Afw5hBJ;AwE3iiBA;EzDsJI,0BAAA;Afw5hBJ;AwE9iiBA;EzDmJI,eAAA;Af85hBJ;AwEjjiBA;EzDsJI,0BAAA;Af85hBJ;AwEpjiBA;EzDmJI,eAAA;Afo6hBJ;AwEvjiBA;EzDsJI,0BAAA;Afo6hBJ;AwE1jiBA;EzDmJI,eAAA;Af06hBJ;AwE7jiBA;EzDsJI,0BAAA;Af06hBJ;AwEhkiBA;EzDmJI,eAAA;Afg7hBJ;AwEnkiBA;EzDsJI,0BAAA;Afg7hBJ;AwEtkiBA;EzDmJI,eAAA;Afs7hBJ;AwEzkiBA;EzDsJI,0BAAA;Afs7hBJ;AwE5kiBA;EzDmJI,eAAA;Af47hBJ;AwE/kiBA;EzDsJI,0BAAA;Af47hBJ;AwElliBA;EzDmJI,eAAA;Afk8hBJ;AwErliBA;EzDsJI,0BAAA;Afk8hBJ;AwExliBA;EzDmJI,eAAA;Afw8hBJ;AwE3liBA;EzDsJI,0BAAA;Afw8hBJ;AwE9liBA;EzDmJI,eAAA;Af88hBJ;AwEjmiBA;EzDsJI,0BAAA;Af88hBJ;AwEpmiBA;EzDmJI,eAAA;Afo9hBJ;AwEvmiBA;EzDsJI,0BAAA;Afo9hBJ;AwE1miBA;EzDmJI,eAAA;Af09hBJ;AwE7miBA;EzDsJI,0BAAA;Af09hBJ;AwEhniBA;EzDmJI,eAAA;Afg+hBJ;AwEnniBA;EzDsJI,0BAAA;Afg+hBJ;AwEtniBA;EzDmJI,eAAA;Afs+hBJ;AwEzniBA;EzDsJI,0BAAA;Afs+hBJ;AwE5niBA;EzDmJI,eAAA;Af4+hBJ;AwE/niBA;EzDsJI,0BAAA;Af4+hBJ;AwEloiBA;EzDmJI,eAAA;Afk/hBJ;AwEroiBA;EzDsJI,0BAAA;Afk/hBJ;AwExoiBA;EzDmJI,eAAA;Afw/hBJ;AwE3oiBA;EzDsJI,0BAAA;Afw/hBJ;AwE9oiBA;EzDmJI,eAAA;Af8/hBJ;AwEjpiBA;EzDsJI,0BAAA;Af8/hBJ;AwEppiBA;EzDmJI,eAAA;AfogiBJ;AwEvpiBA;EzDsJI,0BAAA;AfogiBJ;AwE1piBA;EzDmJI,eAAA;Af0giBJ;AwE7piBA;EzDsJI,0BAAA;Af0giBJ;AwEhqiBA;EzDmJI,eAAA;AfghiBJ;AwEnqiBA;EzDsJI,0BAAA;AfghiBJ;AwEtqiBA;EzDmJI,eAAA;AfshiBJ;AwEzqiBA;EzDsJI,0BAAA;AfshiBJ;AwE5qiBA;EzDmJI,eAAA;Af4hiBJ;AwE/qiBA;EzDsJI,0BAAA;Af4hiBJ;AwElriBA;EzDmJI,eAAA;AfkiiBJ;AwErriBA;EzDsJI,0BAAA;AfkiiBJ;AwExriBA;EzDmJI,eAAA;AfwiiBJ;AwE3riBA;EzDsJI,0BAAA;AfwiiBJ;AwE9riBA;EzDmJI,eAAA;Af8iiBJ;AwEjsiBA;EzDsJI,0BAAA;Af8iiBJ;AwEpsiBA;EzDmJI,eAAA;AfojiBJ;AwEvsiBA;EzDsJI,0BAAA;AfojiBJ;AwE1siBA;EzDmJI,eAAA;Af0jiBJ;AwE7siBA;EzDsJI,0BAAA;Af0jiBJ;AwEhtiBA;EzDmJI,eAAA;AfgkiBJ;AwEntiBA;EzDsJI,0BAAA;AfgkiBJ;AwEttiBA;EzDmJI,eAAA;AfskiBJ;AwEztiBA;EzDsJI,0BAAA;AfskiBJ;AwE5tiBA;EzDmJI,eAAA;Af4kiBJ;AwE/tiBA;EzDsJI,0BAAA;Af4kiBJ;AwEluiBA;EzDmJI,eAAA;AfkliBJ;AwEruiBA;EzDsJI,0BAAA;AfkliBJ;AwExuiBA;EzDmJI,eAAA;AfwliBJ;AwE3uiBA;EzDsJI,0BAAA;AfwliBJ;AwE9uiBA;EzDmJI,eAAA;Af8liBJ;AwEjviBA;EzDsJI,0BAAA;Af8liBJ;AwEpviBA;EzDmJI,eAAA;AfomiBJ;AwEvviBA;EzDsJI,0BAAA;AfomiBJ;AwE1viBA;EzDmJI,eAAA;Af0miBJ;AwE7viBA;EzDsJI,0BAAA;Af0miBJ;AwEhwiBA;EzDmJI,eAAA;AfgniBJ;AwEnwiBA;EzDsJI,0BAAA;AfgniBJ;AwEtwiBA;EzDmJI,eAAA;AfsniBJ;AwEzwiBA;EzDsJI,0BAAA;AfsniBJ;AwE5wiBA;EzDmJI,eAAA;Af4niBJ;AwE/wiBA;EzDsJI,0BAAA;Af4niBJ;AwElxiBA;EzDmJI,eAAA;AfkoiBJ;AwErxiBA;EzDsJI,0BAAA;AfkoiBJ;AwExxiBA;EzDmJI,eAAA;AfwoiBJ;AwE3xiBA;EzDsJI,0BAAA;AfwoiBJ;AwE9xiBA;EzDmJI,eAAA;Af8oiBJ;AwEjyiBA;EzDsJI,0BAAA;Af8oiBJ;AwEpyiBA;EzDmJI,eAAA;AfopiBJ;AwEvyiBA;EzDsJI,0BAAA;AfopiBJ;AwE1yiBA;EzDmJI,eAAA;Af0piBJ;AwE7yiBA;EzDsJI,0BAAA;Af0piBJ;AwEhziBA;EzDmJI,eAAA;AfgqiBJ;AwEnziBA;EzDsJI,0BAAA;AfgqiBJ;AwEtziBA;EzDmJI,eAAA;AfsqiBJ;AwEzziBA;EzDsJI,0BAAA;AfsqiBJ;AwE5ziBA;EzDmJI,eAAA;Af4qiBJ;AwE/ziBA;EzDsJI,0BAAA;Af4qiBJ;AwEl0iBA;EzDmJI,eAAA;AfkriBJ;AwEr0iBA;EzDsJI,0BAAA;AfkriBJ;AwEx0iBA;EzDmJI,eAAA;AfwriBJ;AwE30iBA;EzDsJI,0BAAA;AfwriBJ;AwE90iBA;EzDmJI,eAAA;Af8riBJ;AwEj1iBA;EzDsJI,0BAAA;Af8riBJ;AwEp1iBA;EzDmJI,eAAA;AfosiBJ;AwEv1iBA;EzDsJI,0BAAA;AfosiBJ;AwE11iBA;EzDmJI,eAAA;Af0siBJ;AwE71iBA;EzDsJI,0BAAA;Af0siBJ;AwEh2iBA;EzDmJI,eAAA;AfgtiBJ;AwEn2iBA;EzDsJI,0BAAA;AfgtiBJ;AwEt2iBA;EzDmJI,eAAA;AfstiBJ;AwEz2iBA;EzDsJI,0BAAA;AfstiBJ;AwE52iBA;EzDmJI,oBAAA;Af4tiBJ;AwE/2iBA;EzDsJI,+BAAA;Af4tiBJ;AwEl3iBA;EzDmJI,oBAAA;AfkuiBJ;AwEr3iBA;EzDsJI,+BAAA;AfkuiBJ;AwEx3iBA;EzDmJI,oBAAA;AfwuiBJ;AwE33iBA;EzDsJI,+BAAA;AfwuiBJ;AwE93iBA;EzDmJI,oBAAA;Af8uiBJ;AwEj4iBA;EzDsJI,+BAAA;Af8uiBJ;AwEp4iBA;EzDmJI,oBAAA;AfoviBJ;AwEv4iBA;EzDsJI,+BAAA;AfoviBJ;AwE14iBA;EzDmJI,oBAAA;Af0viBJ;AwE74iBA;EzDsJI,+BAAA;Af0viBJ;AwEh5iBA;EzDmJI,oBAAA;AfgwiBJ;AwEn5iBA;EzDsJI,+BAAA;AfgwiBJ;AwEt5iBA;EzDmJI,oBAAA;AfswiBJ;AwEz5iBA;EzDsJI,+BAAA;AfswiBJ;AwE55iBA;EzDmJI,oBAAA;Af4wiBJ;AwE/5iBA;EzDsJI,+BAAA;Af4wiBJ;AwEl6iBA;EzDmJI,oBAAA;AfkxiBJ;AwEr6iBA;EzDsJI,+BAAA;AfkxiBJ;AwEx6iBA;EzDmJI,oBAAA;AfwxiBJ;AwE36iBA;EzDsJI,+BAAA;AfwxiBJ;AwE96iBA;EzDmJI,oBAAA;Af8xiBJ;AwEj7iBA;EzDsJI,+BAAA;Af8xiBJ;AwEp7iBA;EzDmJI,oBAAA;AfoyiBJ;AwEv7iBA;EzDsJI,+BAAA;AfoyiBJ;AwE17iBA;EzDmJI,oBAAA;Af0yiBJ;AwE77iBA;EzDsJI,+BAAA;Af0yiBJ;AwEh8iBA;EzDmJI,oBAAA;AfgziBJ;AwEn8iBA;EzDsJI,+BAAA;AfgziBJ;AwEt8iBA;EzDmJI,oBAAA;AfsziBJ;AwEz8iBA;EzDsJI,+BAAA;AfsziBJ;AwE58iBA;EzDmJI,oBAAA;Af4ziBJ;AwE/8iBA;EzDsJI,+BAAA;Af4ziBJ;AwEl9iBA;EzDmJI,oBAAA;Afk0iBJ;AwEr9iBA;EzDsJI,+BAAA;Afk0iBJ;AwEx9iBA;EzDmJI,oBAAA;Afw0iBJ;AwE39iBA;EzDsJI,+BAAA;Afw0iBJ;AwE99iBA;EzDmJI,oBAAA;Af80iBJ;AwEj+iBA;EzDsJI,+BAAA;Af80iBJ;AwEp+iBA;EzDmJI,oBAAA;Afo1iBJ;AwEv+iBA;EzDsJI,+BAAA;Afo1iBJ;AwE1+iBA;EzDmJI,oBAAA;Af01iBJ;AwE7+iBA;EzDsJI,+BAAA;Af01iBJ;AwEh/iBA;EzDmJI,oBAAA;Afg2iBJ;AwEn/iBA;EzDsJI,+BAAA;Afg2iBJ;AwEt/iBA;EzDmJI,oBAAA;Afs2iBJ;AwEz/iBA;EzDsJI,+BAAA;Afs2iBJ;AwE5/iBA;EzDmJI,oBAAA;Af42iBJ;AwE//iBA;EzDsJI,+BAAA;Af42iBJ;AwElgjBA;EzDmJI,oBAAA;Afk3iBJ;AwErgjBA;EzDsJI,+BAAA;Afk3iBJ;AwExgjBA;EzDmJI,oBAAA;Afw3iBJ;AwE3gjBA;EzDsJI,+BAAA;Afw3iBJ;AwE9gjBA;EzDmJI,oBAAA;Af83iBJ;AwEjhjBA;EzDsJI,+BAAA;Af83iBJ;AwEphjBA;EzDmJI,oBAAA;Afo4iBJ;AwEvhjBA;EzDsJI,+BAAA;Afo4iBJ;AwE1hjBA;EzDmJI,oBAAA;Af04iBJ;AwE7hjBA;EzDsJI,+BAAA;Af04iBJ;AwEhijBA;EzDmJI,oBAAA;Afg5iBJ;AwEnijBA;EzDsJI,+BAAA;Afg5iBJ;AwEtijBA;EzDmJI,oBAAA;Afs5iBJ;AwEzijBA;EzDsJI,+BAAA;Afs5iBJ;AwE5ijBA;EzDmJI,oBAAA;Af45iBJ;AwE/ijBA;EzDsJI,+BAAA;Af45iBJ;AwEljjBA;EzDmJI,oBAAA;Afk6iBJ;AwErjjBA;EzDsJI,+BAAA;Afk6iBJ;AwExjjBA;EzDmJI,oBAAA;Afw6iBJ;AwE3jjBA;EzDsJI,+BAAA;Afw6iBJ;AwE9jjBA;EzDmJI,oBAAA;Af86iBJ;AwEjkjBA;EzDsJI,+BAAA;Af86iBJ;AwEpkjBA;EzDmJI,oBAAA;Afo7iBJ;AwEvkjBA;EzDsJI,+BAAA;Afo7iBJ;AwE1kjBA;EzDmJI,oBAAA;Af07iBJ;AwE7kjBA;EzDsJI,+BAAA;Af07iBJ;AwEhljBA;EzDmJI,oBAAA;Afg8iBJ;AwEnljBA;EzDsJI,+BAAA;Afg8iBJ;AwEtljBA;EzDmJI,oBAAA;Afs8iBJ;AwEzljBA;EzDsJI,+BAAA;Afs8iBJ;AwE5ljBA;EzDmJI,oBAAA;Af48iBJ;AwE/ljBA;EzDsJI,+BAAA;Af48iBJ;AwElmjBA;EzDmJI,oBAAA;Afk9iBJ;AwErmjBA;EzDsJI,+BAAA;Afk9iBJ;AwExmjBA;EzDmJI,oBAAA;Afw9iBJ;AwE3mjBA;EzDsJI,+BAAA;Afw9iBJ;AwE9mjBA;EzDmJI,oBAAA;Af89iBJ;AwEjnjBA;EzDsJI,+BAAA;Af89iBJ;AwEpnjBA;EzDmJI,oBAAA;Afo+iBJ;AwEvnjBA;EzDsJI,+BAAA;Afo+iBJ;AwE1njBA;EzDmJI,oBAAA;Af0+iBJ;AwE7njBA;EzDsJI,+BAAA;Af0+iBJ;AwEhojBA;EzDmJI,oBAAA;Afg/iBJ;AwEnojBA;EzDsJI,+BAAA;Afg/iBJ;AwEtojBA;EzDmJI,oBAAA;Afs/iBJ;AwEzojBA;EzDsJI,+BAAA;Afs/iBJ;AwE5ojBA;EzDmJI,oBAAA;Af4/iBJ;AwE/ojBA;EzDsJI,+BAAA;Af4/iBJ;AwElpjBA;EzDmJI,oBAAA;AfkgjBJ;AwErpjBA;EzDsJI,+BAAA;AfkgjBJ;AwExpjBA;EzDmJI,oBAAA;AfwgjBJ;AwE3pjBA;EzDsJI,+BAAA;AfwgjBJ;AwE9pjBA;EzDmJI,oBAAA;Af8gjBJ;AwEjqjBA;EzDsJI,+BAAA;Af8gjBJ;AwEpqjBA;EzDmJI,oBAAA;AfohjBJ;AwEvqjBA;EzDsJI,+BAAA;AfohjBJ;AwE1qjBA;EzDmJI,oBAAA;Af0hjBJ;AwE7qjBA;EzDsJI,+BAAA;Af0hjBJ;AwEhrjBA;EzDmJI,oBAAA;AfgijBJ;AwEnrjBA;EzDsJI,+BAAA;AfgijBJ;AwEtrjBA;EzDmJI,oBAAA;AfsijBJ;AwEzrjBA;EzDsJI,+BAAA;AfsijBJ;AwE5rjBA;EzDmJI,oBAAA;Af4ijBJ;AwE/rjBA;EzDsJI,+BAAA;Af4ijBJ;AwElsjBA;EzDmJI,oBAAA;AfkjjBJ;AwErsjBA;EzDsJI,+BAAA;AfkjjBJ;AwExsjBA;EzDmJI,oBAAA;AfwjjBJ;AwE3sjBA;EzDsJI,+BAAA;AfwjjBJ;AwE9sjBA;EzDmJI,oBAAA;Af8jjBJ;AwEjtjBA;EzDsJI,+BAAA;Af8jjBJ;AwEptjBA;EzDmJI,oBAAA;AfokjBJ;AwEvtjBA;EzDsJI,+BAAA;AfokjBJ;AwE1tjBA;EzDmJI,oBAAA;Af0kjBJ;AwE7tjBA;EzDsJI,+BAAA;Af0kjBJ;AwEhujBA;EzDmJI,oBAAA;AfgljBJ;AwEnujBA;EzDsJI,+BAAA;AfgljBJ;AwEtujBA;EzDmJI,oBAAA;AfsljBJ;AwEzujBA;EzDsJI,+BAAA;AfsljBJ;AwE5ujBA;EzDmJI,oBAAA;Af4ljBJ;AwE/ujBA;EzDsJI,+BAAA;Af4ljBJ;AwElvjBA;EzDmJI,oBAAA;AfkmjBJ;AwErvjBA;EzDsJI,+BAAA;AfkmjBJ;AwExvjBA;EzDmJI,oBAAA;AfwmjBJ;AwE3vjBA;EzDsJI,+BAAA;AfwmjBJ;AwE9vjBA;EzDmJI,oBAAA;Af8mjBJ;AwEjwjBA;EzDsJI,+BAAA;Af8mjBJ;AwEpwjBA;EzDmJI,oBAAA;AfonjBJ;AwEvwjBA;EzDsJI,+BAAA;AfonjBJ;AwE1wjBA;EzDmJI,oBAAA;Af0njBJ;AwE7wjBA;EzDsJI,+BAAA;Af0njBJ;AwEhxjBA;EzDmJI,yBAAA;AfgojBJ;AwEnxjBA;EzDsJI,oCAAA;AfgojBJ;AwEtxjBA;EzDmJI,yBAAA;AfsojBJ;AwEzxjBA;EzDsJI,oCAAA;AfsojBJ;AwE5xjBA;EzDmJI,yBAAA;Af4ojBJ;AwE/xjBA;EzDsJI,oCAAA;Af4ojBJ;AwElyjBA;EzDmJI,yBAAA;AfkpjBJ;AwEryjBA;EzDsJI,oCAAA;AfkpjBJ;AwExyjBA;EzDmJI,yBAAA;AfwpjBJ;AwE3yjBA;EzDsJI,oCAAA;AfwpjBJ;AwE9yjBA;EzDmJI,yBAAA;Af8pjBJ;AwEjzjBA;EzDsJI,oCAAA;Af8pjBJ;AwEpzjBA;EzDmJI,yBAAA;AfoqjBJ;AwEvzjBA;EzDsJI,oCAAA;AfoqjBJ;AwE1zjBA;EzDmJI,yBAAA;Af0qjBJ;AwE7zjBA;EzDsJI,oCAAA;Af0qjBJ;AwEh0jBA;EzDmJI,yBAAA;AfgrjBJ;AwEn0jBA;EzDsJI,oCAAA;AfgrjBJ;AwEt0jBA;EzDmJI,yBAAA;AfsrjBJ;AwEz0jBA;EzDsJI,oCAAA;AfsrjBJ;AwE50jBA;EzDmJI,yBAAA;Af4rjBJ;AwE/0jBA;EzDsJI,oCAAA;Af4rjBJ;AwEl1jBA;EzDmJI,yBAAA;AfksjBJ;AwEr1jBA;EzDsJI,oCAAA;AfksjBJ;AwEx1jBA;EzDmJI,yBAAA;AfwsjBJ;AwE31jBA;EzDsJI,oCAAA;AfwsjBJ;AwE91jBA;EzDmJI,yBAAA;Af8sjBJ;AwEj2jBA;EzDsJI,oCAAA;Af8sjBJ;AwEp2jBA;EzDmJI,yBAAA;AfotjBJ;AwEv2jBA;EzDsJI,oCAAA;AfotjBJ;AwE12jBA;EzDmJI,yBAAA;Af0tjBJ;AwE72jBA;EzDsJI,oCAAA;Af0tjBJ;AwEh3jBA;EzDmJI,yBAAA;AfgujBJ;AwEn3jBA;EzDsJI,oCAAA;AfgujBJ;AwEt3jBA;EzDmJI,yBAAA;AfsujBJ;AwEz3jBA;EzDsJI,oCAAA;AfsujBJ;AwE53jBA;EzDmJI,yBAAA;Af4ujBJ;AwE/3jBA;EzDsJI,oCAAA;Af4ujBJ;AwEl4jBA;EzDmJI,yBAAA;AfkvjBJ;AwEr4jBA;EzDsJI,oCAAA;AfkvjBJ;AwEx4jBA;EzDmJI,yBAAA;AfwvjBJ;AwE34jBA;EzDsJI,oCAAA;AfwvjBJ;AwE94jBA;EzDmJI,yBAAA;Af8vjBJ;AwEj5jBA;EzDsJI,oCAAA;Af8vjBJ;AwEp5jBA;EzDmJI,yBAAA;AfowjBJ;AwEv5jBA;EzDsJI,oCAAA;AfowjBJ;AwE15jBA;EzDmJI,yBAAA;Af0wjBJ;AwE75jBA;EzDsJI,oCAAA;Af0wjBJ;AwEh6jBA;EzDmJI,yBAAA;AfgxjBJ;AwEn6jBA;EzDsJI,oCAAA;AfgxjBJ;AwEt6jBA;EzDmJI,yBAAA;AfsxjBJ;AwEz6jBA;EzDsJI,oCAAA;AfsxjBJ;AwE56jBA;EzDmJI,yBAAA;Af4xjBJ;AwE/6jBA;EzDsJI,oCAAA;Af4xjBJ;AwEl7jBA;EzDmJI,yBAAA;AfkyjBJ;AwEr7jBA;EzDsJI,oCAAA;AfkyjBJ;AwEx7jBA;EzDmJI,yBAAA;AfwyjBJ;AwE37jBA;EzDsJI,oCAAA;AfwyjBJ;AwE97jBA;EzDmJI,yBAAA;Af8yjBJ;AwEj8jBA;EzDsJI,oCAAA;Af8yjBJ;AwEp8jBA;EzDmJI,6BAAA;AfozjBJ;AwEv8jBA;EzDsJI,wCAAA;AfozjBJ;AwE18jBA;EzDmJI,6BAAA;Af0zjBJ;AwE78jBA;EzDsJI,wCAAA;Af0zjBJ;AwEh9jBA;EzDmJI,6BAAA;Afg0jBJ;AwEn9jBA;EzDsJI,wCAAA;Afg0jBJ;AwEt9jBA;EzDmJI,6BAAA;Afs0jBJ;AwEz9jBA;EzDsJI,wCAAA;Afs0jBJ;AwE59jBA;EzDmJI,6BAAA;Af40jBJ;AwE/9jBA;EzDsJI,wCAAA;Af40jBJ;AwEl+jBA;EzDmJI,6BAAA;Afk1jBJ;AwEr+jBA;EzDsJI,wCAAA;Afk1jBJ;AwEx+jBA;EzDmJI,6BAAA;Afw1jBJ;AwE3+jBA;EzDsJI,wCAAA;Afw1jBJ;AwE9+jBA;EzDmJI,6BAAA;Af81jBJ;AwEj/jBA;EzDsJI,wCAAA;Af81jBJ;AwEp/jBA;EzDmJI,6BAAA;Afo2jBJ;AwEv/jBA;EzDsJI,wCAAA;Afo2jBJ;AwE1/jBA;EzDmJI,6BAAA;Af02jBJ;AwE7/jBA;EzDsJI,wCAAA;Af02jBJ;AwEhgkBA;EzDmJI,6BAAA;Afg3jBJ;AwEngkBA;EzDsJI,wCAAA;Afg3jBJ;AwEtgkBA;EzDmJI,6BAAA;Afs3jBJ;AwEzgkBA;EzDsJI,wCAAA;Afs3jBJ;AwE5gkBA;EzDmJI,6BAAA;Af43jBJ;AwE/gkBA;EzDsJI,wCAAA;Af43jBJ;AwElhkBA;EzDmJI,6BAAA;Afk4jBJ;AwErhkBA;EzDsJI,wCAAA;Afk4jBJ;AwExhkBA;EzDmJI,6BAAA;Afw4jBJ;AwE3hkBA;EzDsJI,wCAAA;Afw4jBJ;AwE9hkBA;EzDmJI,6BAAA;Af84jBJ;AwEjikBA;EzDsJI,wCAAA;Af84jBJ;AwEpikBA;EzDmJI,6BAAA;Afo5jBJ;AwEvikBA;EzDsJI,wCAAA;Afo5jBJ;AwE1ikBA;EzDmJI,6BAAA;Af05jBJ;AwE7ikBA;EzDsJI,wCAAA;Af05jBJ;AwEhjkBA;EzDmJI,6BAAA;Afg6jBJ;AwEnjkBA;EzDsJI,wCAAA;Afg6jBJ;AwEtjkBA;EzDmJI,6BAAA;Afs6jBJ;AwEzjkBA;EzDsJI,wCAAA;Afs6jBJ;AwE5jkBA;EzDmJI,+BAAA;Af46jBJ;AwE/jkBA;EzDsJI,0CAAA;Af46jBJ;AwElkkBA;EzDmJI,+BAAA;Afk7jBJ;AwErkkBA;EzDsJI,0CAAA;Afk7jBJ;AwExkkBA;EzDmJI,+BAAA;Afw7jBJ;AwE3kkBA;EzDsJI,0CAAA;Afw7jBJ;AwE9kkBA;EzDmJI,+BAAA;Af87jBJ;AwEjlkBA;EzDsJI,0CAAA;Af87jBJ;AwEplkBA;EzDmJI,+BAAA;Afo8jBJ;AwEvlkBA;EzDsJI,0CAAA;Afo8jBJ;AwE1lkBA;EzDmJI,+BAAA;Af08jBJ;AwE7lkBA;EzDsJI,0CAAA;Af08jBJ;AwEhmkBA;EzDmJI,+BAAA;Afg9jBJ;AwEnmkBA;EzDsJI,0CAAA;Afg9jBJ;AwEtmkBA;EzDmJI,+BAAA;Afs9jBJ;AwEzmkBA;EzDsJI,0CAAA;Afs9jBJ;AwE5mkBA;EzDmJI,+BAAA;Af49jBJ;AwE/mkBA;EzDsJI,0CAAA;Af49jBJ;AwElnkBA;EzDmJI,+BAAA;Afk+jBJ;AwErnkBA;EzDsJI,0CAAA;Afk+jBJ;AwExnkBA;EzDmJI,+BAAA;Afw+jBJ;AwE3nkBA;EzDsJI,0CAAA;Afw+jBJ;AwE9nkBA;EzDmJI,+BAAA;Af8+jBJ;AwEjokBA;EzDsJI,0CAAA;Af8+jBJ;AwEpokBA;EzDmJI,+BAAA;Afo/jBJ;AwEvokBA;EzDsJI,0CAAA;Afo/jBJ;AwE1okBA;EzDmJI,+BAAA;Af0/jBJ;AwE7okBA;EzDsJI,0CAAA;Af0/jBJ;AwEhpkBA;EzDmJI,+BAAA;AfggkBJ;AwEnpkBA;EzDsJI,0CAAA;AfggkBJ;AwEtpkBA;EzDmJI,+BAAA;AfsgkBJ;AwEzpkBA;EzDsJI,0CAAA;AfsgkBJ;AwE5pkBA;EzDmJI,+BAAA;Af4gkBJ;AwE/pkBA;EzDsJI,0CAAA;Af4gkBJ;AwElqkBA;EzDmJI,+BAAA;AfkhkBJ;AwErqkBA;EzDsJI,0CAAA;AfkhkBJ;AwExqkBA;EzDmJI,+BAAA;AfwhkBJ;AwE3qkBA;EzDsJI,0CAAA;AfwhkBJ;AwE9qkBA;EzDmJI,+BAAA;Af8hkBJ;AwEjrkBA;EzDsJI,0CAAA;Af8hkBJ;AwEprkBA;EzDmJI,gCAAA;AfoikBJ;AwEvrkBA;EzDsJI,2CAAA;AfoikBJ;AwE1rkBA;EzDmJI,gCAAA;Af0ikBJ;AwE7rkBA;EzDsJI,2CAAA;Af0ikBJ;AwEhskBA;EzDmJI,gCAAA;AfgjkBJ;AwEnskBA;EzDsJI,2CAAA;AfgjkBJ;AwEtskBA;EzDmJI,gCAAA;AfsjkBJ;AwEzskBA;EzDsJI,2CAAA;AfsjkBJ;AwE5skBA;EzDmJI,gCAAA;Af4jkBJ;AwE/skBA;EzDsJI,2CAAA;Af4jkBJ;AwEltkBA;EzDmJI,gCAAA;AfkkkBJ;AwErtkBA;EzDsJI,2CAAA;AfkkkBJ;AwExtkBA;EzDmJI,gCAAA;AfwkkBJ;AwE3tkBA;EzDsJI,2CAAA;AfwkkBJ;AwE9tkBA;EzDmJI,gCAAA;Af8kkBJ;AwEjukBA;EzDsJI,2CAAA;Af8kkBJ;AwEpukBA;EzDmJI,gCAAA;AfolkBJ;AwEvukBA;EzDsJI,2CAAA;AfolkBJ;AwE1ukBA;EzDmJI,gCAAA;Af0lkBJ;AwE7ukBA;EzDsJI,2CAAA;Af0lkBJ;AwEhvkBA;EzDmJI,gCAAA;AfgmkBJ;AwEnvkBA;EzDsJI,2CAAA;AfgmkBJ;AwEtvkBA;EzDmJI,gCAAA;AfsmkBJ;AwEzvkBA;EzDsJI,2CAAA;AfsmkBJ;AwE5vkBA;EzDmJI,gCAAA;Af4mkBJ;AwE/vkBA;EzDsJI,2CAAA;Af4mkBJ;AwElwkBA;EzDmJI,gCAAA;AfknkBJ;AwErwkBA;EzDsJI,2CAAA;AfknkBJ;AwExwkBA;EzDmJI,gCAAA;AfwnkBJ;AwE3wkBA;EzDsJI,2CAAA;AfwnkBJ;AwE9wkBA;EzDmJI,gCAAA;Af8nkBJ;AwEjxkBA;EzDsJI,2CAAA;Af8nkBJ;AwEpxkBA;EzDmJI,gCAAA;AfookBJ;AwEvxkBA;EzDsJI,2CAAA;AfookBJ;AwE1xkBA;EzDmJI,gCAAA;Af0okBJ;AwE7xkBA;EzDsJI,2CAAA;Af0okBJ;AwEhykBA;EzDmJI,gCAAA;AfgpkBJ;AwEnykBA;EzDsJI,2CAAA;AfgpkBJ;AwEtykBA;EzDmJI,gCAAA;AfspkBJ;AwEzykBA;EzDsJI,2CAAA;AfspkBJ;AwE5ykBA;EzDmJI,8BAAA;Af4pkBJ;AwE/ykBA;EzDsJI,yCAAA;Af4pkBJ;AwElzkBA;EzDmJI,8BAAA;AfkqkBJ;AwErzkBA;EzDsJI,yCAAA;AfkqkBJ;AwExzkBA;EzDmJI,8BAAA;AfwqkBJ;AwE3zkBA;EzDsJI,yCAAA;AfwqkBJ;AwE9zkBA;EzDmJI,8BAAA;Af8qkBJ;AwEj0kBA;EzDsJI,yCAAA;Af8qkBJ;AwEp0kBA;EzDmJI,8BAAA;AforkBJ;AwEv0kBA;EzDsJI,yCAAA;AforkBJ;AwE10kBA;EzDmJI,8BAAA;Af0rkBJ;AwE70kBA;EzDsJI,yCAAA;Af0rkBJ;AwEh1kBA;EzDmJI,8BAAA;AfgskBJ;AwEn1kBA;EzDsJI,yCAAA;AfgskBJ;AwEt1kBA;EzDmJI,8BAAA;AfsskBJ;AwEz1kBA;EzDsJI,yCAAA;AfsskBJ;AwE51kBA;EzDmJI,8BAAA;Af4skBJ;AwE/1kBA;EzDsJI,yCAAA;Af4skBJ;AwEl2kBA;EzDmJI,8BAAA;AfktkBJ;AwEr2kBA;EzDsJI,yCAAA;AfktkBJ;AwEx2kBA;EzDmJI,8BAAA;AfwtkBJ;AwE32kBA;EzDsJI,yCAAA;AfwtkBJ;AwE92kBA;EzDmJI,8BAAA;Af8tkBJ;AwEj3kBA;EzDsJI,yCAAA;Af8tkBJ;AwEp3kBA;EzDmJI,8BAAA;AfoukBJ;AwEv3kBA;EzDsJI,yCAAA;AfoukBJ;AwE13kBA;EzDmJI,8BAAA;Af0ukBJ;AwE73kBA;EzDsJI,yCAAA;Af0ukBJ;AwEh4kBA;EzDmJI,8BAAA;AfgvkBJ;AwEn4kBA;EzDsJI,yCAAA;AfgvkBJ;AwEt4kBA;EzDmJI,8BAAA;AfsvkBJ;AwEz4kBA;EzDsJI,yCAAA;AfsvkBJ;AwE54kBA;EzDmJI,8BAAA;Af4vkBJ;AwE/4kBA;EzDsJI,yCAAA;Af4vkBJ;AwEl5kBA;EzDmJI,8BAAA;AfkwkBJ;AwEr5kBA;EzDsJI,yCAAA;AfkwkBJ;AwEx5kBA;EzDmJI,8BAAA;AfwwkBJ;AwE35kBA;EzDsJI,yCAAA;AfwwkBJ;AwE95kBA;EzDmJI,8BAAA;Af8wkBJ;AwEj6kBA;EzDsJI,yCAAA;Af8wkBJ;AwEp6kBA;EzDmJI,sBAAA;AfoxkBJ;AwEv6kBA;EzDsJI,iCAAA;AfoxkBJ;AwE16kBA;EzDmJI,sBAAA;Af0xkBJ;AwE76kBA;EzDsJI,iCAAA;Af0xkBJ;AwEh7kBA;EzDmJI,sBAAA;AfgykBJ;AwEn7kBA;EzDsJI,iCAAA;AfgykBJ;AwEt7kBA;EzDmJI,sBAAA;AfsykBJ;AwEz7kBA;EzDsJI,iCAAA;AfsykBJ;AwE57kBA;EzDmJI,sBAAA;Af4ykBJ;AwE/7kBA;EzDsJI,iCAAA;Af4ykBJ;AwEl8kBA;EzDmJI,sBAAA;AfkzkBJ;AwEr8kBA;EzDsJI,iCAAA;AfkzkBJ;AwEx8kBA;EzDmJI,sBAAA;AfwzkBJ;AwE38kBA;EzDsJI,iCAAA;AfwzkBJ;AwE98kBA;EzDmJI,sBAAA;Af8zkBJ;AwEj9kBA;EzDsJI,iCAAA;Af8zkBJ;AwEp9kBA;EzDmJI,sBAAA;Afo0kBJ;AwEv9kBA;EzDsJI,iCAAA;Afo0kBJ;AwE19kBA;EzDmJI,sBAAA;Af00kBJ;AwE79kBA;EzDsJI,iCAAA;Af00kBJ;AwEh+kBA;EzDmJI,sBAAA;Afg1kBJ;AwEn+kBA;EzDsJI,iCAAA;Afg1kBJ;AwEt+kBA;EzDmJI,sBAAA;Afs1kBJ;AwEz+kBA;EzDsJI,iCAAA;Afs1kBJ;AwE5+kBA;EzDmJI,sBAAA;Af41kBJ;AwE/+kBA;EzDsJI,iCAAA;Af41kBJ;AwEl/kBA;EzDmJI,sBAAA;Afk2kBJ;AwEr/kBA;EzDsJI,iCAAA;Afk2kBJ;AwEx/kBA;EzDmJI,sBAAA;Afw2kBJ;AwE3/kBA;EzDsJI,iCAAA;Afw2kBJ;AwE9/kBA;EzDmJI,sBAAA;Af82kBJ;AwEjglBA;EzDsJI,iCAAA;Af82kBJ;AwEpglBA;EzDmJI,sBAAA;Afo3kBJ;AwEvglBA;EzDsJI,iCAAA;Afo3kBJ;AwE1glBA;EzDmJI,sBAAA;Af03kBJ;AwE7glBA;EzDsJI,iCAAA;Af03kBJ;AwEhhlBA;EzDmJI,sBAAA;Afg4kBJ;AwEnhlBA;EzDsJI,iCAAA;Afg4kBJ;AwEthlBA;EzDmJI,sBAAA;Afs4kBJ;AwEzhlBA;EzDsJI,iCAAA;Afs4kBJ;AwE5hlBA;EzDmJI,eAAA;Af44kBJ;AwE/hlBA;EzDsJI,0BAAA;Af44kBJ;AwElilBA;EzDmJI,eAAA;Afk5kBJ;AwErilBA;EzDsJI,0BAAA;Afk5kBJ;AwExilBA;EzDmJI,eAAA;Afw5kBJ;AwE3ilBA;EzDsJI,0BAAA;Afw5kBJ;AwE9ilBA;EzDmJI,eAAA;Af85kBJ;AwEjjlBA;EzDsJI,0BAAA;Af85kBJ;AwEpjlBA;EzDmJI,eAAA;Afo6kBJ;AwEvjlBA;EzDsJI,0BAAA;Afo6kBJ;AwE1jlBA;EzDmJI,eAAA;Af06kBJ;AwE7jlBA;EzDsJI,0BAAA;Af06kBJ;AwEhklBA;EzDmJI,eAAA;Afg7kBJ;AwEnklBA;EzDsJI,0BAAA;Afg7kBJ;AwEtklBA;EzDmJI,eAAA;Afs7kBJ;AwEzklBA;EzDsJI,0BAAA;Afs7kBJ;AwE5klBA;EzDmJI,eAAA;Af47kBJ;AwE/klBA;EzDsJI,0BAAA;Af47kBJ;AwElllBA;EzDmJI,eAAA;Afk8kBJ;AwErllBA;EzDsJI,0BAAA;Afk8kBJ;AwExllBA;EzDmJI,eAAA;Afw8kBJ;AwE3llBA;EzDsJI,0BAAA;Afw8kBJ;AwE9llBA;EzDmJI,eAAA;Af88kBJ;AwEjmlBA;EzDsJI,0BAAA;Af88kBJ;AwEpmlBA;EzDmJI,eAAA;Afo9kBJ;AwEvmlBA;EzDsJI,0BAAA;Afo9kBJ;AwE1mlBA;EzDmJI,eAAA;Af09kBJ;AwE7mlBA;EzDsJI,0BAAA;Af09kBJ;AwEhnlBA;EzDmJI,eAAA;Afg+kBJ;AwEnnlBA;EzDsJI,0BAAA;Afg+kBJ;AwEtnlBA;EzDmJI,eAAA;Afs+kBJ;AwEznlBA;EzDsJI,0BAAA;Afs+kBJ;AwE5nlBA;EzDmJI,eAAA;Af4+kBJ;AwE/nlBA;EzDsJI,0BAAA;Af4+kBJ;AwElolBA;EzDmJI,eAAA;Afk/kBJ;AwErolBA;EzDsJI,0BAAA;Afk/kBJ;AwExolBA;EzDmJI,eAAA;Afw/kBJ;AwE3olBA;EzDsJI,0BAAA;Afw/kBJ;AwE9olBA;EzDmJI,eAAA;Af8/kBJ;AwEjplBA;EzDsJI,0BAAA;Af8/kBJ;AwEpplBA;EzDmJI,eAAA;AfoglBJ;AwEvplBA;EzDsJI,0BAAA;AfoglBJ;AwE1plBA;EzDmJI,eAAA;Af0glBJ;AwE7plBA;EzDsJI,0BAAA;Af0glBJ;AwEhqlBA;EzDmJI,eAAA;AfghlBJ;AwEnqlBA;EzDsJI,0BAAA;AfghlBJ;AwEtqlBA;EzDmJI,eAAA;AfshlBJ;AwEzqlBA;EzDsJI,0BAAA;AfshlBJ;AwE5qlBA;EzDmJI,eAAA;Af4hlBJ;AwE/qlBA;EzDsJI,0BAAA;Af4hlBJ;AwElrlBA;EzDmJI,eAAA;AfkilBJ;AwErrlBA;EzDsJI,0BAAA;AfkilBJ;AwExrlBA;EzDmJI,eAAA;AfwilBJ;AwE3rlBA;EzDsJI,0BAAA;AfwilBJ;AwE9rlBA;EzDmJI,eAAA;Af8ilBJ;AwEjslBA;EzDsJI,0BAAA;Af8ilBJ;AwEpslBA;EzDmJI,eAAA;AfojlBJ;AwEvslBA;EzDsJI,0BAAA;AfojlBJ;AwE1slBA;EzDmJI,eAAA;Af0jlBJ;AwE7slBA;EzDsJI,0BAAA;Af0jlBJ;AwEhtlBA;EzDmJI,eAAA;AfgklBJ;AwEntlBA;EzDsJI,0BAAA;AfgklBJ;AwEttlBA;EzDmJI,eAAA;AfsklBJ;AwEztlBA;EzDsJI,0BAAA;AfsklBJ;AwE5tlBA;EzDmJI,eAAA;Af4klBJ;AwE/tlBA;EzDsJI,0BAAA;Af4klBJ;AwElulBA;EzDmJI,eAAA;AfkllBJ;AwErulBA;EzDsJI,0BAAA;AfkllBJ;AwExulBA;EzDmJI,eAAA;AfwllBJ;AwE3ulBA;EzDsJI,0BAAA;AfwllBJ;AwE9ulBA;EzDmJI,eAAA;Af8llBJ;AwEjvlBA;EzDsJI,0BAAA;Af8llBJ;AwEpvlBA;EzDmJI,eAAA;AfomlBJ;AwEvvlBA;EzDsJI,0BAAA;AfomlBJ;AwE1vlBA;EzDmJI,eAAA;Af0mlBJ;AwE7vlBA;EzDsJI,0BAAA;Af0mlBJ;AwEhwlBA;EzDmJI,eAAA;AfgnlBJ;AwEnwlBA;EzDsJI,0BAAA;AfgnlBJ;AwEtwlBA;EzDmJI,eAAA;AfsnlBJ;AwEzwlBA;EzDsJI,0BAAA;AfsnlBJ;AwE5wlBA;EzDmJI,eAAA;Af4nlBJ;AwE/wlBA;EzDsJI,0BAAA;Af4nlBJ;AwElxlBA;EzDmJI,eAAA;AfkolBJ;AwErxlBA;EzDsJI,0BAAA;AfkolBJ;AwExxlBA;EzDmJI,eAAA;AfwolBJ;AwE3xlBA;EzDsJI,0BAAA;AfwolBJ;AwE9xlBA;EzDmJI,eAAA;Af8olBJ;AwEjylBA;EzDsJI,0BAAA;Af8olBJ;AwEpylBA;EzDmJI,eAAA;AfoplBJ;AwEvylBA;EzDsJI,0BAAA;AfoplBJ;AwE1ylBA;EzDmJI,eAAA;Af0plBJ;AwE7ylBA;EzDsJI,0BAAA;Af0plBJ;AwEhzlBA;EzDmJI,eAAA;AfgqlBJ;AwEnzlBA;EzDsJI,0BAAA;AfgqlBJ;AwEtzlBA;EzDmJI,eAAA;AfsqlBJ;AwEzzlBA;EzDsJI,0BAAA;AfsqlBJ;AwE5zlBA;EzDmJI,eAAA;Af4qlBJ;AwE/zlBA;EzDsJI,0BAAA;Af4qlBJ;AwEl0lBA;EzDmJI,eAAA;AfkrlBJ;AwEr0lBA;EzDsJI,0BAAA;AfkrlBJ;AwEx0lBA;EzDmJI,eAAA;AfwrlBJ;AwE30lBA;EzDsJI,0BAAA;AfwrlBJ;AwE90lBA;EzDmJI,eAAA;Af8rlBJ;AwEj1lBA;EzDsJI,0BAAA;Af8rlBJ;AwEp1lBA;EzDmJI,eAAA;AfoslBJ;AwEv1lBA;EzDsJI,0BAAA;AfoslBJ;AwE11lBA;EzDmJI,eAAA;Af0slBJ;AwE71lBA;EzDsJI,0BAAA;Af0slBJ;AwEh2lBA;EzDmJI,eAAA;AfgtlBJ;AwEn2lBA;EzDsJI,0BAAA;AfgtlBJ;AwEt2lBA;EzDmJI,eAAA;AfstlBJ;AwEz2lBA;EzDsJI,0BAAA;AfstlBJ;AwE52lBA;EzDmJI,eAAA;Af4tlBJ;AwE/2lBA;EzDsJI,0BAAA;Af4tlBJ;AwEl3lBA;EzDmJI,eAAA;AfkulBJ;AwEr3lBA;EzDsJI,0BAAA;AfkulBJ;AwEx3lBA;EzDmJI,eAAA;AfwulBJ;AwE33lBA;EzDsJI,0BAAA;AfwulBJ;AwE93lBA;EzDmJI,eAAA;Af8ulBJ;AwEj4lBA;EzDsJI,0BAAA;Af8ulBJ;AwEp4lBA;EzDmJI,eAAA;AfovlBJ;AwEv4lBA;EzDsJI,0BAAA;AfovlBJ;AwE14lBA;EzDmJI,eAAA;Af0vlBJ;AwE74lBA;EzDsJI,0BAAA;Af0vlBJ;AwEh5lBA;EzDmJI,eAAA;AfgwlBJ;AwEn5lBA;EzDsJI,0BAAA;AfgwlBJ;AwEt5lBA;EzDmJI,eAAA;AfswlBJ;AwEz5lBA;EzDsJI,0BAAA;AfswlBJ;AwE55lBA;EzDmJI,eAAA;Af4wlBJ;AwE/5lBA;EzDsJI,0BAAA;Af4wlBJ;AwEl6lBA;EzDmJI,eAAA;AfkxlBJ;AwEr6lBA;EzDsJI,0BAAA;AfkxlBJ;AwEx6lBA;EzDmJI,eAAA;AfwxlBJ;AwE36lBA;EzDsJI,0BAAA;AfwxlBJ;AwE96lBA;EzDmJI,eAAA;Af8xlBJ;AwEj7lBA;EzDsJI,0BAAA;Af8xlBJ;AwEp7lBA;EzDmJI,eAAA;AfoylBJ;AwEv7lBA;EzDsJI,0BAAA;AfoylBJ;AwE17lBA;EzDmJI,eAAA;Af0ylBJ;AwE77lBA;EzDsJI,0BAAA;Af0ylBJ;AwEh8lBA;EzDmJI,eAAA;AfgzlBJ;AwEn8lBA;EzDsJI,0BAAA;AfgzlBJ;AwEt8lBA;EzDmJI,eAAA;AfszlBJ;AwEz8lBA;EzDsJI,0BAAA;AfszlBJ;AwE58lBA;EzDmJI,eAAA;Af4zlBJ;AwE/8lBA;EzDsJI,0BAAA;Af4zlBJ;AwEl9lBA;EzDmJI,eAAA;Afk0lBJ;AwEr9lBA;EzDsJI,0BAAA;Afk0lBJ;AwEx9lBA;EzDmJI,eAAA;Afw0lBJ;AwE39lBA;EzDsJI,0BAAA;Afw0lBJ;AwE99lBA;EzDmJI,eAAA;Af80lBJ;AwEj+lBA;EzDsJI,0BAAA;Af80lBJ;AwEp+lBA;EzDmJI,eAAA;Afo1lBJ;AwEv+lBA;EzDsJI,0BAAA;Afo1lBJ;AwE1+lBA;EzDmJI,eAAA;Af01lBJ;AwE7+lBA;EzDsJI,0BAAA;Af01lBJ;AwEh/lBA;EzDmJI,eAAA;Afg2lBJ;AwEn/lBA;EzDsJI,0BAAA;Afg2lBJ;AwEt/lBA;EzDmJI,eAAA;Afs2lBJ;AwEz/lBA;EzDsJI,0BAAA;Afs2lBJ;AwE5/lBA;EzDmJI,eAAA;Af42lBJ;AwE//lBA;EzDsJI,0BAAA;Af42lBJ;AwElgmBA;EzDmJI,eAAA;Afk3lBJ;AwErgmBA;EzDsJI,0BAAA;Afk3lBJ;AwExgmBA;EzDmJI,eAAA;Afw3lBJ;AwE3gmBA;EzDsJI,0BAAA;Afw3lBJ;AwE9gmBA;EzDmJI,eAAA;Af83lBJ;AwEjhmBA;EzDsJI,0BAAA;Af83lBJ;AwEphmBA;EzDmJI,eAAA;Afo4lBJ;AwEvhmBA;EzDsJI,0BAAA;Afo4lBJ;AwE1hmBA;EzDmJI,eAAA;Af04lBJ;AwE7hmBA;EzDsJI,0BAAA;Af04lBJ;AwEhimBA;EzDmJI,eAAA;Afg5lBJ;AwEnimBA;EzDsJI,0BAAA;Afg5lBJ;AwEtimBA;EzDmJI,eAAA;Afs5lBJ;AwEzimBA;EzDsJI,0BAAA;Afs5lBJ;AwE5imBA;EzDmJI,eAAA;Af45lBJ;AwE/imBA;EzDsJI,0BAAA;Af45lBJ;AwEljmBA;EzDmJI,eAAA;Afk6lBJ;AwErjmBA;EzDsJI,0BAAA;Afk6lBJ;AwExjmBA;EzDmJI,eAAA;Afw6lBJ;AwE3jmBA;EzDsJI,0BAAA;Afw6lBJ;AwE9jmBA;EzDmJI,eAAA;Af86lBJ;AwEjkmBA;EzDsJI,0BAAA;Af86lBJ;AwEpkmBA;EzDmJI,eAAA;Afo7lBJ;AwEvkmBA;EzDsJI,0BAAA;Afo7lBJ;AwE1kmBA;EzDmJI,eAAA;Af07lBJ;AwE7kmBA;EzDsJI,0BAAA;Af07lBJ;AwEhlmBA;EzDmJI,eAAA;Afg8lBJ;AwEnlmBA;EzDsJI,0BAAA;Afg8lBJ;AwEtlmBA;EzDmJI,eAAA;Afs8lBJ;AwEzlmBA;EzDsJI,0BAAA;Afs8lBJ;AwE5lmBA;EzDmJI,eAAA;Af48lBJ;AwE/lmBA;EzDsJI,0BAAA;Af48lBJ;AwElmmBA;EzDmJI,eAAA;Afk9lBJ;AwErmmBA;EzDsJI,0BAAA;Afk9lBJ;AwExmmBA;EzDmJI,eAAA;Afw9lBJ;AwE3mmBA;EzDsJI,0BAAA;Afw9lBJ;AwE9mmBA;EzDmJI,eAAA;Af89lBJ;AwEjnmBA;EzDsJI,0BAAA;Af89lBJ;AwEpnmBA;EzDmJI,oBAAA;Afo+lBJ;AwEvnmBA;EzDsJI,+BAAA;Afo+lBJ;AwE1nmBA;EzDmJI,oBAAA;Af0+lBJ;AwE7nmBA;EzDsJI,+BAAA;Af0+lBJ;AwEhomBA;EzDmJI,oBAAA;Afg/lBJ;AwEnomBA;EzDsJI,+BAAA;Afg/lBJ;AwEtomBA;EzDmJI,oBAAA;Afs/lBJ;AwEzomBA;EzDsJI,+BAAA;Afs/lBJ;AwE5omBA;EzDmJI,oBAAA;Af4/lBJ;AwE/omBA;EzDsJI,+BAAA;Af4/lBJ;AwElpmBA;EzDmJI,oBAAA;AfkgmBJ;AwErpmBA;EzDsJI,+BAAA;AfkgmBJ;AwExpmBA;EzDmJI,oBAAA;AfwgmBJ;AwE3pmBA;EzDsJI,+BAAA;AfwgmBJ;AwE9pmBA;EzDmJI,oBAAA;Af8gmBJ;AwEjqmBA;EzDsJI,+BAAA;Af8gmBJ;AwEpqmBA;EzDmJI,oBAAA;AfohmBJ;AwEvqmBA;EzDsJI,+BAAA;AfohmBJ;AwE1qmBA;EzDmJI,oBAAA;Af0hmBJ;AwE7qmBA;EzDsJI,+BAAA;Af0hmBJ;AwEhrmBA;EzDmJI,oBAAA;AfgimBJ;AwEnrmBA;EzDsJI,+BAAA;AfgimBJ;AwEtrmBA;EzDmJI,oBAAA;AfsimBJ;AwEzrmBA;EzDsJI,+BAAA;AfsimBJ;AwE5rmBA;EzDmJI,oBAAA;Af4imBJ;AwE/rmBA;EzDsJI,+BAAA;Af4imBJ;AwElsmBA;EzDmJI,oBAAA;AfkjmBJ;AwErsmBA;EzDsJI,+BAAA;AfkjmBJ;AwExsmBA;EzDmJI,oBAAA;AfwjmBJ;AwE3smBA;EzDsJI,+BAAA;AfwjmBJ;AwE9smBA;EzDmJI,oBAAA;Af8jmBJ;AwEjtmBA;EzDsJI,+BAAA;Af8jmBJ;AwEptmBA;EzDmJI,oBAAA;AfokmBJ;AwEvtmBA;EzDsJI,+BAAA;AfokmBJ;AwE1tmBA;EzDmJI,oBAAA;Af0kmBJ;AwE7tmBA;EzDsJI,+BAAA;Af0kmBJ;AwEhumBA;EzDmJI,oBAAA;AfglmBJ;AwEnumBA;EzDsJI,+BAAA;AfglmBJ;AwEtumBA;EzDmJI,oBAAA;AfslmBJ;AwEzumBA;EzDsJI,+BAAA;AfslmBJ;AwE5umBA;EzDmJI,oBAAA;Af4lmBJ;AwE/umBA;EzDsJI,+BAAA;Af4lmBJ;AwElvmBA;EzDmJI,oBAAA;AfkmmBJ;AwErvmBA;EzDsJI,+BAAA;AfkmmBJ;AwExvmBA;EzDmJI,oBAAA;AfwmmBJ;AwE3vmBA;EzDsJI,+BAAA;AfwmmBJ;AwE9vmBA;EzDmJI,oBAAA;Af8mmBJ;AwEjwmBA;EzDsJI,+BAAA;Af8mmBJ;AwEpwmBA;EzDmJI,oBAAA;AfonmBJ;AwEvwmBA;EzDsJI,+BAAA;AfonmBJ;AwE1wmBA;EzDmJI,oBAAA;Af0nmBJ;AwE7wmBA;EzDsJI,+BAAA;Af0nmBJ;AwEhxmBA;EzDmJI,oBAAA;AfgomBJ;AwEnxmBA;EzDsJI,+BAAA;AfgomBJ;AwEtxmBA;EzDmJI,oBAAA;AfsomBJ;AwEzxmBA;EzDsJI,+BAAA;AfsomBJ;AwE5xmBA;EzDmJI,oBAAA;Af4omBJ;AwE/xmBA;EzDsJI,+BAAA;Af4omBJ;AwElymBA;EzDmJI,oBAAA;AfkpmBJ;AwErymBA;EzDsJI,+BAAA;AfkpmBJ;AwExymBA;EzDmJI,oBAAA;AfwpmBJ;AwE3ymBA;EzDsJI,+BAAA;AfwpmBJ;AwE9ymBA;EzDmJI,oBAAA;Af8pmBJ;AwEjzmBA;EzDsJI,+BAAA;Af8pmBJ;AwEpzmBA;EzDmJI,oBAAA;AfoqmBJ;AwEvzmBA;EzDsJI,+BAAA;AfoqmBJ;AwE1zmBA;EzDmJI,oBAAA;Af0qmBJ;AwE7zmBA;EzDsJI,+BAAA;Af0qmBJ;AwEh0mBA;EzDmJI,oBAAA;AfgrmBJ;AwEn0mBA;EzDsJI,+BAAA;AfgrmBJ;AwEt0mBA;EzDmJI,oBAAA;AfsrmBJ;AwEz0mBA;EzDsJI,+BAAA;AfsrmBJ;AwE50mBA;EzDmJI,oBAAA;Af4rmBJ;AwE/0mBA;EzDsJI,+BAAA;Af4rmBJ;AwEl1mBA;EzDmJI,oBAAA;AfksmBJ;AwEr1mBA;EzDsJI,+BAAA;AfksmBJ;AwEx1mBA;EzDmJI,oBAAA;AfwsmBJ;AwE31mBA;EzDsJI,+BAAA;AfwsmBJ;AwE91mBA;EzDmJI,oBAAA;Af8smBJ;AwEj2mBA;EzDsJI,+BAAA;Af8smBJ;AwEp2mBA;EzDmJI,oBAAA;AfotmBJ;AwEv2mBA;EzDsJI,+BAAA;AfotmBJ;AwE12mBA;EzDmJI,oBAAA;Af0tmBJ;AwE72mBA;EzDsJI,+BAAA;Af0tmBJ;AwEh3mBA;EzDmJI,oBAAA;AfgumBJ;AwEn3mBA;EzDsJI,+BAAA;AfgumBJ;AwEt3mBA;EzDmJI,oBAAA;AfsumBJ;AwEz3mBA;EzDsJI,+BAAA;AfsumBJ;AwE53mBA;EzDmJI,oBAAA;Af4umBJ;AwE/3mBA;EzDsJI,+BAAA;Af4umBJ;AwEl4mBA;EzDmJI,oBAAA;AfkvmBJ;AwEr4mBA;EzDsJI,+BAAA;AfkvmBJ;AwEx4mBA;EzDmJI,oBAAA;AfwvmBJ;AwE34mBA;EzDsJI,+BAAA;AfwvmBJ;AwE94mBA;EzDmJI,oBAAA;Af8vmBJ;AwEj5mBA;EzDsJI,+BAAA;Af8vmBJ;AwEp5mBA;EzDmJI,oBAAA;AfowmBJ;AwEv5mBA;EzDsJI,+BAAA;AfowmBJ;AwE15mBA;EzDmJI,oBAAA;Af0wmBJ;AwE75mBA;EzDsJI,+BAAA;Af0wmBJ;AwEh6mBA;EzDmJI,oBAAA;AfgxmBJ;AwEn6mBA;EzDsJI,+BAAA;AfgxmBJ;AwEt6mBA;EzDmJI,oBAAA;AfsxmBJ;AwEz6mBA;EzDsJI,+BAAA;AfsxmBJ;AwE56mBA;EzDmJI,oBAAA;Af4xmBJ;AwE/6mBA;EzDsJI,+BAAA;Af4xmBJ;AwEl7mBA;EzDmJI,oBAAA;AfkymBJ;AwEr7mBA;EzDsJI,+BAAA;AfkymBJ;AwEx7mBA;EzDmJI,oBAAA;AfwymBJ;AwE37mBA;EzDsJI,+BAAA;AfwymBJ;AwE97mBA;EzDmJI,oBAAA;Af8ymBJ;AwEj8mBA;EzDsJI,+BAAA;Af8ymBJ;AwEp8mBA;EzDmJI,oBAAA;AfozmBJ;AwEv8mBA;EzDsJI,+BAAA;AfozmBJ;AwE18mBA;EzDmJI,oBAAA;Af0zmBJ;AwE78mBA;EzDsJI,+BAAA;Af0zmBJ;AwEh9mBA;EzDmJI,oBAAA;Afg0mBJ;AwEn9mBA;EzDsJI,+BAAA;Afg0mBJ;AwEt9mBA;EzDmJI,oBAAA;Afs0mBJ;AwEz9mBA;EzDsJI,+BAAA;Afs0mBJ;AwE59mBA;EzDmJI,oBAAA;Af40mBJ;AwE/9mBA;EzDsJI,+BAAA;Af40mBJ;AwEl+mBA;EzDmJI,oBAAA;Afk1mBJ;AwEr+mBA;EzDsJI,+BAAA;Afk1mBJ;AwEx+mBA;EzDmJI,oBAAA;Afw1mBJ;AwE3+mBA;EzDsJI,+BAAA;Afw1mBJ;AwE9+mBA;EzDmJI,oBAAA;Af81mBJ;AwEj/mBA;EzDsJI,+BAAA;Af81mBJ;AwEp/mBA;EzDmJI,oBAAA;Afo2mBJ;AwEv/mBA;EzDsJI,+BAAA;Afo2mBJ;AwE1/mBA;EzDmJI,oBAAA;Af02mBJ;AwE7/mBA;EzDsJI,+BAAA;Af02mBJ;AwEhgnBA;EzDmJI,oBAAA;Afg3mBJ;AwEngnBA;EzDsJI,+BAAA;Afg3mBJ;AwEtgnBA;EzDmJI,oBAAA;Afs3mBJ;AwEzgnBA;EzDsJI,+BAAA;Afs3mBJ;AwE5gnBA;EzDmJI,oBAAA;Af43mBJ;AwE/gnBA;EzDsJI,+BAAA;Af43mBJ;AwElhnBA;EzDmJI,oBAAA;Afk4mBJ;AwErhnBA;EzDsJI,+BAAA;Afk4mBJ;AwExhnBA;EzDmJI,yBAAA;Afw4mBJ;AwE3hnBA;EzDsJI,oCAAA;Afw4mBJ;AwE9hnBA;EzDmJI,yBAAA;Af84mBJ;AwEjinBA;EzDsJI,oCAAA;Af84mBJ;AwEpinBA;EzDmJI,yBAAA;Afo5mBJ;AwEvinBA;EzDsJI,oCAAA;Afo5mBJ;AwE1inBA;EzDmJI,yBAAA;Af05mBJ;AwE7inBA;EzDsJI,oCAAA;Af05mBJ;AwEhjnBA;EzDmJI,yBAAA;Afg6mBJ;AwEnjnBA;EzDsJI,oCAAA;Afg6mBJ;AwEtjnBA;EzDmJI,yBAAA;Afs6mBJ;AwEzjnBA;EzDsJI,oCAAA;Afs6mBJ;AwE5jnBA;EzDmJI,yBAAA;Af46mBJ;AwE/jnBA;EzDsJI,oCAAA;Af46mBJ;AwElknBA;EzDmJI,yBAAA;Afk7mBJ;AwErknBA;EzDsJI,oCAAA;Afk7mBJ;AwExknBA;EzDmJI,yBAAA;Afw7mBJ;AwE3knBA;EzDsJI,oCAAA;Afw7mBJ;AwE9knBA;EzDmJI,yBAAA;Af87mBJ;AwEjlnBA;EzDsJI,oCAAA;Af87mBJ;AwEplnBA;EzDmJI,yBAAA;Afo8mBJ;AwEvlnBA;EzDsJI,oCAAA;Afo8mBJ;AwE1lnBA;EzDmJI,yBAAA;Af08mBJ;AwE7lnBA;EzDsJI,oCAAA;Af08mBJ;AwEhmnBA;EzDmJI,yBAAA;Afg9mBJ;AwEnmnBA;EzDsJI,oCAAA;Afg9mBJ;AwEtmnBA;EzDmJI,yBAAA;Afs9mBJ;AwEzmnBA;EzDsJI,oCAAA;Afs9mBJ;AwE5mnBA;EzDmJI,yBAAA;Af49mBJ;AwE/mnBA;EzDsJI,oCAAA;Af49mBJ;AwElnnBA;EzDmJI,yBAAA;Afk+mBJ;AwErnnBA;EzDsJI,oCAAA;Afk+mBJ;AwExnnBA;EzDmJI,yBAAA;Afw+mBJ;AwE3nnBA;EzDsJI,oCAAA;Afw+mBJ;AwE9nnBA;EzDmJI,yBAAA;Af8+mBJ;AwEjonBA;EzDsJI,oCAAA;Af8+mBJ;AwEponBA;EzDmJI,yBAAA;Afo/mBJ;AwEvonBA;EzDsJI,oCAAA;Afo/mBJ;AwE1onBA;EzDmJI,yBAAA;Af0/mBJ;AwE7onBA;EzDsJI,oCAAA;Af0/mBJ;AwEhpnBA;EzDmJI,yBAAA;AfggnBJ;AwEnpnBA;EzDsJI,oCAAA;AfggnBJ;AwEtpnBA;EzDmJI,yBAAA;AfsgnBJ;AwEzpnBA;EzDsJI,oCAAA;AfsgnBJ;AwE5pnBA;EzDmJI,yBAAA;Af4gnBJ;AwE/pnBA;EzDsJI,oCAAA;Af4gnBJ;AwElqnBA;EzDmJI,yBAAA;AfkhnBJ;AwErqnBA;EzDsJI,oCAAA;AfkhnBJ;AwExqnBA;EzDmJI,yBAAA;AfwhnBJ;AwE3qnBA;EzDsJI,oCAAA;AfwhnBJ;AwE9qnBA;EzDmJI,yBAAA;Af8hnBJ;AwEjrnBA;EzDsJI,oCAAA;Af8hnBJ;AwEprnBA;EzDmJI,yBAAA;AfoinBJ;AwEvrnBA;EzDsJI,oCAAA;AfoinBJ;AwE1rnBA;EzDmJI,yBAAA;Af0inBJ;AwE7rnBA;EzDsJI,oCAAA;Af0inBJ;AwEhsnBA;EzDmJI,yBAAA;AfgjnBJ;AwEnsnBA;EzDsJI,oCAAA;AfgjnBJ;AwEtsnBA;EzDmJI,yBAAA;AfsjnBJ;AwEzsnBA;EzDsJI,oCAAA;AfsjnBJ;AwE5snBA;EzDmJI,6BAAA;Af4jnBJ;AwE/snBA;EzDsJI,wCAAA;Af4jnBJ;AwEltnBA;EzDmJI,6BAAA;AfkknBJ;AwErtnBA;EzDsJI,wCAAA;AfkknBJ;AwExtnBA;EzDmJI,6BAAA;AfwknBJ;AwE3tnBA;EzDsJI,wCAAA;AfwknBJ;AwE9tnBA;EzDmJI,6BAAA;Af8knBJ;AwEjunBA;EzDsJI,wCAAA;Af8knBJ;AwEpunBA;EzDmJI,6BAAA;AfolnBJ;AwEvunBA;EzDsJI,wCAAA;AfolnBJ;AwE1unBA;EzDmJI,6BAAA;Af0lnBJ;AwE7unBA;EzDsJI,wCAAA;Af0lnBJ;AwEhvnBA;EzDmJI,6BAAA;AfgmnBJ;AwEnvnBA;EzDsJI,wCAAA;AfgmnBJ;AwEtvnBA;EzDmJI,6BAAA;AfsmnBJ;AwEzvnBA;EzDsJI,wCAAA;AfsmnBJ;AwE5vnBA;EzDmJI,6BAAA;Af4mnBJ;AwE/vnBA;EzDsJI,wCAAA;Af4mnBJ;AwElwnBA;EzDmJI,6BAAA;AfknnBJ;AwErwnBA;EzDsJI,wCAAA;AfknnBJ;AwExwnBA;EzDmJI,6BAAA;AfwnnBJ;AwE3wnBA;EzDsJI,wCAAA;AfwnnBJ;AwE9wnBA;EzDmJI,6BAAA;Af8nnBJ;AwEjxnBA;EzDsJI,wCAAA;Af8nnBJ;AwEpxnBA;EzDmJI,6BAAA;AfoonBJ;AwEvxnBA;EzDsJI,wCAAA;AfoonBJ;AwE1xnBA;EzDmJI,6BAAA;Af0onBJ;AwE7xnBA;EzDsJI,wCAAA;Af0onBJ;AwEhynBA;EzDmJI,6BAAA;AfgpnBJ;AwEnynBA;EzDsJI,wCAAA;AfgpnBJ;AwEtynBA;EzDmJI,6BAAA;AfspnBJ;AwEzynBA;EzDsJI,wCAAA;AfspnBJ;AwE5ynBA;EzDmJI,6BAAA;Af4pnBJ;AwE/ynBA;EzDsJI,wCAAA;Af4pnBJ;AwElznBA;EzDmJI,6BAAA;AfkqnBJ;AwErznBA;EzDsJI,wCAAA;AfkqnBJ;AwExznBA;EzDmJI,6BAAA;AfwqnBJ;AwE3znBA;EzDsJI,wCAAA;AfwqnBJ;AwE9znBA;EzDmJI,6BAAA;Af8qnBJ;AwEj0nBA;EzDsJI,wCAAA;Af8qnBJ;AwEp0nBA;EzDmJI,+BAAA;AfornBJ;AwEv0nBA;EzDsJI,0CAAA;AfornBJ;AwE10nBA;EzDmJI,+BAAA;Af0rnBJ;AwE70nBA;EzDsJI,0CAAA;Af0rnBJ;AwEh1nBA;EzDmJI,+BAAA;AfgsnBJ;AwEn1nBA;EzDsJI,0CAAA;AfgsnBJ;AwEt1nBA;EzDmJI,+BAAA;AfssnBJ;AwEz1nBA;EzDsJI,0CAAA;AfssnBJ;AwE51nBA;EzDmJI,+BAAA;Af4snBJ;AwE/1nBA;EzDsJI,0CAAA;Af4snBJ;AwEl2nBA;EzDmJI,+BAAA;AfktnBJ;AwEr2nBA;EzDsJI,0CAAA;AfktnBJ;AwEx2nBA;EzDmJI,+BAAA;AfwtnBJ;AwE32nBA;EzDsJI,0CAAA;AfwtnBJ;AwE92nBA;EzDmJI,+BAAA;Af8tnBJ;AwEj3nBA;EzDsJI,0CAAA;Af8tnBJ;AwEp3nBA;EzDmJI,+BAAA;AfounBJ;AwEv3nBA;EzDsJI,0CAAA;AfounBJ;AwE13nBA;EzDmJI,+BAAA;Af0unBJ;AwE73nBA;EzDsJI,0CAAA;Af0unBJ;AwEh4nBA;EzDmJI,+BAAA;AfgvnBJ;AwEn4nBA;EzDsJI,0CAAA;AfgvnBJ;AwEt4nBA;EzDmJI,+BAAA;AfsvnBJ;AwEz4nBA;EzDsJI,0CAAA;AfsvnBJ;AwE54nBA;EzDmJI,+BAAA;Af4vnBJ;AwE/4nBA;EzDsJI,0CAAA;Af4vnBJ;AwEl5nBA;EzDmJI,+BAAA;AfkwnBJ;AwEr5nBA;EzDsJI,0CAAA;AfkwnBJ;AwEx5nBA;EzDmJI,+BAAA;AfwwnBJ;AwE35nBA;EzDsJI,0CAAA;AfwwnBJ;AwE95nBA;EzDmJI,+BAAA;Af8wnBJ;AwEj6nBA;EzDsJI,0CAAA;Af8wnBJ;AwEp6nBA;EzDmJI,+BAAA;AfoxnBJ;AwEv6nBA;EzDsJI,0CAAA;AfoxnBJ;AwE16nBA;EzDmJI,+BAAA;Af0xnBJ;AwE76nBA;EzDsJI,0CAAA;Af0xnBJ;AwEh7nBA;EzDmJI,+BAAA;AfgynBJ;AwEn7nBA;EzDsJI,0CAAA;AfgynBJ;AwEt7nBA;EzDmJI,+BAAA;AfsynBJ;AwEz7nBA;EzDsJI,0CAAA;AfsynBJ;AwE57nBA;EzDmJI,gCAAA;Af4ynBJ;AwE/7nBA;EzDsJI,2CAAA;Af4ynBJ;AwEl8nBA;EzDmJI,gCAAA;AfkznBJ;AwEr8nBA;EzDsJI,2CAAA;AfkznBJ;AwEx8nBA;EzDmJI,gCAAA;AfwznBJ;AwE38nBA;EzDsJI,2CAAA;AfwznBJ;AwE98nBA;EzDmJI,gCAAA;Af8znBJ;AwEj9nBA;EzDsJI,2CAAA;Af8znBJ;AwEp9nBA;EzDmJI,gCAAA;Afo0nBJ;AwEv9nBA;EzDsJI,2CAAA;Afo0nBJ;AwE19nBA;EzDmJI,gCAAA;Af00nBJ;AwE79nBA;EzDsJI,2CAAA;Af00nBJ;AwEh+nBA;EzDmJI,gCAAA;Afg1nBJ;AwEn+nBA;EzDsJI,2CAAA;Afg1nBJ;AwEt+nBA;EzDmJI,gCAAA;Afs1nBJ;AwEz+nBA;EzDsJI,2CAAA;Afs1nBJ;AwE5+nBA;EzDmJI,gCAAA;Af41nBJ;AwE/+nBA;EzDsJI,2CAAA;Af41nBJ;AwEl/nBA;EzDmJI,gCAAA;Afk2nBJ;AwEr/nBA;EzDsJI,2CAAA;Afk2nBJ;AwEx/nBA;EzDmJI,gCAAA;Afw2nBJ;AwE3/nBA;EzDsJI,2CAAA;Afw2nBJ;AwE9/nBA;EzDmJI,gCAAA;Af82nBJ;AwEjgoBA;EzDsJI,2CAAA;Af82nBJ;AwEpgoBA;EzDmJI,gCAAA;Afo3nBJ;AwEvgoBA;EzDsJI,2CAAA;Afo3nBJ;AwE1goBA;EzDmJI,gCAAA;Af03nBJ;AwE7goBA;EzDsJI,2CAAA;Af03nBJ;AwEhhoBA;EzDmJI,gCAAA;Afg4nBJ;AwEnhoBA;EzDsJI,2CAAA;Afg4nBJ;AwEthoBA;EzDmJI,gCAAA;Afs4nBJ;AwEzhoBA;EzDsJI,2CAAA;Afs4nBJ;AwE5hoBA;EzDmJI,gCAAA;Af44nBJ;AwE/hoBA;EzDsJI,2CAAA;Af44nBJ;AwElioBA;EzDmJI,gCAAA;Afk5nBJ;AwErioBA;EzDsJI,2CAAA;Afk5nBJ;AwExioBA;EzDmJI,gCAAA;Afw5nBJ;AwE3ioBA;EzDsJI,2CAAA;Afw5nBJ;AwE9ioBA;EzDmJI,gCAAA;Af85nBJ;AwEjjoBA;EzDsJI,2CAAA;Af85nBJ;AwEpjoBA;EzDmJI,8BAAA;Afo6nBJ;AwEvjoBA;EzDsJI,yCAAA;Afo6nBJ;AwE1joBA;EzDmJI,8BAAA;Af06nBJ;AwE7joBA;EzDsJI,yCAAA;Af06nBJ;AwEhkoBA;EzDmJI,8BAAA;Afg7nBJ;AwEnkoBA;EzDsJI,yCAAA;Afg7nBJ;AwEtkoBA;EzDmJI,8BAAA;Afs7nBJ;AwEzkoBA;EzDsJI,yCAAA;Afs7nBJ;AwE5koBA;EzDmJI,8BAAA;Af47nBJ;AwE/koBA;EzDsJI,yCAAA;Af47nBJ;AwElloBA;EzDmJI,8BAAA;Afk8nBJ;AwErloBA;EzDsJI,yCAAA;Afk8nBJ;AwExloBA;EzDmJI,8BAAA;Afw8nBJ;AwE3loBA;EzDsJI,yCAAA;Afw8nBJ;AwE9loBA;EzDmJI,8BAAA;Af88nBJ;AwEjmoBA;EzDsJI,yCAAA;Af88nBJ;AwEpmoBA;EzDmJI,8BAAA;Afo9nBJ;AwEvmoBA;EzDsJI,yCAAA;Afo9nBJ;AwE1moBA;EzDmJI,8BAAA;Af09nBJ;AwE7moBA;EzDsJI,yCAAA;Af09nBJ;AwEhnoBA;EzDmJI,8BAAA;Afg+nBJ;AwEnnoBA;EzDsJI,yCAAA;Afg+nBJ;AwEtnoBA;EzDmJI,8BAAA;Afs+nBJ;AwEznoBA;EzDsJI,yCAAA;Afs+nBJ;AwE5noBA;EzDmJI,8BAAA;Af4+nBJ;AwE/noBA;EzDsJI,yCAAA;Af4+nBJ;AwElooBA;EzDmJI,8BAAA;Afk/nBJ;AwErooBA;EzDsJI,yCAAA;Afk/nBJ;AwExooBA;EzDmJI,8BAAA;Afw/nBJ;AwE3ooBA;EzDsJI,yCAAA;Afw/nBJ;AwE9ooBA;EzDmJI,8BAAA;Af8/nBJ;AwEjpoBA;EzDsJI,yCAAA;Af8/nBJ;AwEppoBA;EzDmJI,8BAAA;AfogoBJ;AwEvpoBA;EzDsJI,yCAAA;AfogoBJ;AwE1poBA;EzDmJI,8BAAA;Af0goBJ;AwE7poBA;EzDsJI,yCAAA;Af0goBJ;AwEhqoBA;EzDmJI,8BAAA;AfghoBJ;AwEnqoBA;EzDsJI,yCAAA;AfghoBJ;AwEtqoBA;EzDmJI,8BAAA;AfshoBJ;AwEzqoBA;EzDsJI,yCAAA;AfshoBJ;AwE5qoBA;EzDmJI,sBAAA;Af4hoBJ;AwE/qoBA;EzDsJI,iCAAA;Af4hoBJ;AwElroBA;EzDmJI,sBAAA;AfkioBJ;AwErroBA;EzDsJI,iCAAA;AfkioBJ;AwExroBA;EzDmJI,sBAAA;AfwioBJ;AwE3roBA;EzDsJI,iCAAA;AfwioBJ;AwE9roBA;EzDmJI,sBAAA;Af8ioBJ;AwEjsoBA;EzDsJI,iCAAA;Af8ioBJ;AwEpsoBA;EzDmJI,sBAAA;AfojoBJ;AwEvsoBA;EzDsJI,iCAAA;AfojoBJ;AwE1soBA;EzDmJI,sBAAA;Af0joBJ;AwE7soBA;EzDsJI,iCAAA;Af0joBJ;AwEhtoBA;EzDmJI,sBAAA;AfgkoBJ;AwEntoBA;EzDsJI,iCAAA;AfgkoBJ;AwEttoBA;EzDmJI,sBAAA;AfskoBJ;AwEztoBA;EzDsJI,iCAAA;AfskoBJ;AwE5toBA;EzDmJI,sBAAA;Af4koBJ;AwE/toBA;EzDsJI,iCAAA;Af4koBJ;AwEluoBA;EzDmJI,sBAAA;AfkloBJ;AwEruoBA;EzDsJI,iCAAA;AfkloBJ;AwExuoBA;EzDmJI,sBAAA;AfwloBJ;AwE3uoBA;EzDsJI,iCAAA;AfwloBJ;AwE9uoBA;EzDmJI,sBAAA;Af8loBJ;AwEjvoBA;EzDsJI,iCAAA;Af8loBJ;AwEpvoBA;EzDmJI,sBAAA;AfomoBJ;AwEvvoBA;EzDsJI,iCAAA;AfomoBJ;AwE1voBA;EzDmJI,sBAAA;Af0moBJ;AwE7voBA;EzDsJI,iCAAA;Af0moBJ;AwEhwoBA;EzDmJI,sBAAA;AfgnoBJ;AwEnwoBA;EzDsJI,iCAAA;AfgnoBJ;AwEtwoBA;EzDmJI,sBAAA;AfsnoBJ;AwEzwoBA;EzDsJI,iCAAA;AfsnoBJ;AwE5woBA;EzDmJI,sBAAA;Af4noBJ;AwE/woBA;EzDsJI,iCAAA;Af4noBJ;AwElxoBA;EzDmJI,sBAAA;AfkooBJ;AwErxoBA;EzDsJI,iCAAA;AfkooBJ;AwExxoBA;EzDmJI,sBAAA;AfwooBJ;AwE3xoBA;EzDsJI,iCAAA;AfwooBJ;AwE9xoBA;EzDmJI,sBAAA;Af8ooBJ;AwEjyoBA;EzDsJI,iCAAA;Af8ooBJ;AwEpyoBA;EzDmJI,eAAA;AfopoBJ;AwEvyoBA;EzDsJI,0BAAA;AfopoBJ;AwE1yoBA;EzDmJI,eAAA;Af0poBJ;AwE7yoBA;EzDsJI,0BAAA;Af0poBJ;AwEhzoBA;EzDmJI,eAAA;AfgqoBJ;AwEnzoBA;EzDsJI,0BAAA;AfgqoBJ;AwEtzoBA;EzDmJI,eAAA;AfsqoBJ;AwEzzoBA;EzDsJI,0BAAA;AfsqoBJ;AwE5zoBA;EzDmJI,eAAA;Af4qoBJ;AwE/zoBA;EzDsJI,0BAAA;Af4qoBJ;AwEl0oBA;EzDmJI,eAAA;AfkroBJ;AwEr0oBA;EzDsJI,0BAAA;AfkroBJ;AwEx0oBA;EzDmJI,eAAA;AfwroBJ;AwE30oBA;EzDsJI,0BAAA;AfwroBJ;AwE90oBA;EzDmJI,eAAA;Af8roBJ;AwEj1oBA;EzDsJI,0BAAA;Af8roBJ;AwEp1oBA;EzDmJI,eAAA;AfosoBJ;AwEv1oBA;EzDsJI,0BAAA;AfosoBJ;AwE11oBA;EzDmJI,eAAA;Af0soBJ;AwE71oBA;EzDsJI,0BAAA;Af0soBJ;AwEh2oBA;EzDmJI,eAAA;AfgtoBJ;AwEn2oBA;EzDsJI,0BAAA;AfgtoBJ;AwEt2oBA;EzDmJI,eAAA;AfstoBJ;AwEz2oBA;EzDsJI,0BAAA;AfstoBJ;AwE52oBA;EzDmJI,eAAA;Af4toBJ;AwE/2oBA;EzDsJI,0BAAA;Af4toBJ;AwEl3oBA;EzDmJI,eAAA;AfkuoBJ;AwEr3oBA;EzDsJI,0BAAA;AfkuoBJ;AwEx3oBA;EzDmJI,eAAA;AfwuoBJ;AwE33oBA;EzDsJI,0BAAA;AfwuoBJ;AwE93oBA;EzDmJI,eAAA;Af8uoBJ;AwEj4oBA;EzDsJI,0BAAA;Af8uoBJ;AwEp4oBA;EzDmJI,eAAA;AfovoBJ;AwEv4oBA;EzDsJI,0BAAA;AfovoBJ;AwE14oBA;EzDmJI,eAAA;Af0voBJ;AwE74oBA;EzDsJI,0BAAA;Af0voBJ;AwEh5oBA;EzDmJI,eAAA;AfgwoBJ;AwEn5oBA;EzDsJI,0BAAA;AfgwoBJ;AwEt5oBA;EzDmJI,eAAA;AfswoBJ;AwEz5oBA;EzDsJI,0BAAA;AfswoBJ;AwE55oBA;EzDmJI,eAAA;Af4woBJ;AwE/5oBA;EzDsJI,0BAAA;Af4woBJ;AwEl6oBA;EzDmJI,eAAA;AfkxoBJ;AwEr6oBA;EzDsJI,0BAAA;AfkxoBJ;AwEx6oBA;EzDmJI,eAAA;AfwxoBJ;AwE36oBA;EzDsJI,0BAAA;AfwxoBJ;AwE96oBA;EzDmJI,eAAA;Af8xoBJ;AwEj7oBA;EzDsJI,0BAAA;Af8xoBJ;AwEp7oBA;EzDmJI,eAAA;AfoyoBJ;AwEv7oBA;EzDsJI,0BAAA;AfoyoBJ;AwE17oBA;EzDmJI,eAAA;Af0yoBJ;AwE77oBA;EzDsJI,0BAAA;Af0yoBJ;AwEh8oBA;EzDmJI,eAAA;AfgzoBJ;AwEn8oBA;EzDsJI,0BAAA;AfgzoBJ;AwEt8oBA;EzDmJI,eAAA;AfszoBJ;AwEz8oBA;EzDsJI,0BAAA;AfszoBJ;AwE58oBA;EzDmJI,eAAA;Af4zoBJ;AwE/8oBA;EzDsJI,0BAAA;Af4zoBJ;AwEl9oBA;EzDmJI,eAAA;Afk0oBJ;AwEr9oBA;EzDsJI,0BAAA;Afk0oBJ;AwEx9oBA;EzDmJI,eAAA;Afw0oBJ;AwE39oBA;EzDsJI,0BAAA;Afw0oBJ;AwE99oBA;EzDmJI,eAAA;Af80oBJ;AwEj+oBA;EzDsJI,0BAAA;Af80oBJ;AwEp+oBA;EzDmJI,eAAA;Afo1oBJ;AwEv+oBA;EzDsJI,0BAAA;Afo1oBJ;AwE1+oBA;EzDmJI,eAAA;Af01oBJ;AwE7+oBA;EzDsJI,0BAAA;Af01oBJ;AwEh/oBA;EzDmJI,eAAA;Afg2oBJ;AwEn/oBA;EzDsJI,0BAAA;Afg2oBJ;AwEt/oBA;EzDmJI,eAAA;Afs2oBJ;AwEz/oBA;EzDsJI,0BAAA;Afs2oBJ;AwE5/oBA;EzDmJI,eAAA;Af42oBJ;AwE//oBA;EzDsJI,0BAAA;Af42oBJ;AwElgpBA;EzDmJI,eAAA;Afk3oBJ;AwErgpBA;EzDsJI,0BAAA;Afk3oBJ;AwExgpBA;EzDmJI,eAAA;Afw3oBJ;AwE3gpBA;EzDsJI,0BAAA;Afw3oBJ;AwE9gpBA;EzDmJI,eAAA;Af83oBJ;AwEjhpBA;EzDsJI,0BAAA;Af83oBJ;AwEphpBA;EzDmJI,eAAA;Afo4oBJ;AwEvhpBA;EzDsJI,0BAAA;Afo4oBJ;AwE1hpBA;EzDmJI,eAAA;Af04oBJ;AwE7hpBA;EzDsJI,0BAAA;Af04oBJ;AwEhipBA;EzDmJI,eAAA;Afg5oBJ;AwEnipBA;EzDsJI,0BAAA;Afg5oBJ;AwEtipBA;EzDmJI,eAAA;Afs5oBJ;AwEzipBA;EzDsJI,0BAAA;Afs5oBJ;AwE5ipBA;EzDmJI,eAAA;Af45oBJ;AwE/ipBA;EzDsJI,0BAAA;Af45oBJ;AwEljpBA;EzDmJI,eAAA;Afk6oBJ;AwErjpBA;EzDsJI,0BAAA;Afk6oBJ;AwExjpBA;EzDmJI,eAAA;Afw6oBJ;AwE3jpBA;EzDsJI,0BAAA;Afw6oBJ;AwE9jpBA;EzDmJI,eAAA;Af86oBJ;AwEjkpBA;EzDsJI,0BAAA;Af86oBJ;AwEpkpBA;EzDmJI,eAAA;Afo7oBJ;AwEvkpBA;EzDsJI,0BAAA;Afo7oBJ;AwE1kpBA;EzDmJI,eAAA;Af07oBJ;AwE7kpBA;EzDsJI,0BAAA;Af07oBJ;AwEhlpBA;EzDmJI,eAAA;Afg8oBJ;AwEnlpBA;EzDsJI,0BAAA;Afg8oBJ;AwEtlpBA;EzDmJI,eAAA;Afs8oBJ;AwEzlpBA;EzDsJI,0BAAA;Afs8oBJ;AwE5lpBA;EzDmJI,eAAA;Af48oBJ;AwE/lpBA;EzDsJI,0BAAA;Af48oBJ;AwElmpBA;EzDmJI,eAAA;Afk9oBJ;AwErmpBA;EzDsJI,0BAAA;Afk9oBJ;AwExmpBA;EzDmJI,eAAA;Afw9oBJ;AwE3mpBA;EzDsJI,0BAAA;Afw9oBJ;AwE9mpBA;EzDmJI,eAAA;Af89oBJ;AwEjnpBA;EzDsJI,0BAAA;Af89oBJ;AwEpnpBA;EzDmJI,eAAA;Afo+oBJ;AwEvnpBA;EzDsJI,0BAAA;Afo+oBJ;AwE1npBA;EzDmJI,eAAA;Af0+oBJ;AwE7npBA;EzDsJI,0BAAA;Af0+oBJ;AwEhopBA;EzDmJI,eAAA;Afg/oBJ;AwEnopBA;EzDsJI,0BAAA;Afg/oBJ;AwEtopBA;EzDmJI,eAAA;Afs/oBJ;AwEzopBA;EzDsJI,0BAAA;Afs/oBJ;AwE5opBA;EzDmJI,eAAA;Af4/oBJ;AwE/opBA;EzDsJI,0BAAA;Af4/oBJ;AwElppBA;EzDmJI,eAAA;AfkgpBJ;AwErppBA;EzDsJI,0BAAA;AfkgpBJ;AwExppBA;EzDmJI,eAAA;AfwgpBJ;AwE3ppBA;EzDsJI,0BAAA;AfwgpBJ;AwE9ppBA;EzDmJI,eAAA;Af8gpBJ;AwEjqpBA;EzDsJI,0BAAA;Af8gpBJ;AwEpqpBA;EzDmJI,eAAA;AfohpBJ;AwEvqpBA;EzDsJI,0BAAA;AfohpBJ;AwE1qpBA;EzDmJI,eAAA;Af0hpBJ;AwE7qpBA;EzDsJI,0BAAA;Af0hpBJ;AwEhrpBA;EzDmJI,eAAA;AfgipBJ;AwEnrpBA;EzDsJI,0BAAA;AfgipBJ;AwEtrpBA;EzDmJI,eAAA;AfsipBJ;AwEzrpBA;EzDsJI,0BAAA;AfsipBJ;AwE5rpBA;EzDmJI,eAAA;Af4ipBJ;AwE/rpBA;EzDsJI,0BAAA;Af4ipBJ;AwElspBA;EzDmJI,eAAA;AfkjpBJ;AwErspBA;EzDsJI,0BAAA;AfkjpBJ;AwExspBA;EzDmJI,eAAA;AfwjpBJ;AwE3spBA;EzDsJI,0BAAA;AfwjpBJ;AwE9spBA;EzDmJI,eAAA;Af8jpBJ;AwEjtpBA;EzDsJI,0BAAA;Af8jpBJ;AwEptpBA;EzDmJI,eAAA;AfokpBJ;AwEvtpBA;EzDsJI,0BAAA;AfokpBJ;AwE1tpBA;EzDmJI,eAAA;Af0kpBJ;AwE7tpBA;EzDsJI,0BAAA;Af0kpBJ;AwEhupBA;EzDmJI,eAAA;AfglpBJ;AwEnupBA;EzDsJI,0BAAA;AfglpBJ;AwEtupBA;EzDmJI,eAAA;AfslpBJ;AwEzupBA;EzDsJI,0BAAA;AfslpBJ;AwE5upBA;EzDmJI,eAAA;Af4lpBJ;AwE/upBA;EzDsJI,0BAAA;Af4lpBJ;AwElvpBA;EzDmJI,eAAA;AfkmpBJ;AwErvpBA;EzDsJI,0BAAA;AfkmpBJ;AwExvpBA;EzDmJI,eAAA;AfwmpBJ;AwE3vpBA;EzDsJI,0BAAA;AfwmpBJ;AwE9vpBA;EzDmJI,eAAA;Af8mpBJ;AwEjwpBA;EzDsJI,0BAAA;Af8mpBJ;AwEpwpBA;EzDmJI,eAAA;AfonpBJ;AwEvwpBA;EzDsJI,0BAAA;AfonpBJ;AwE1wpBA;EzDmJI,eAAA;Af0npBJ;AwE7wpBA;EzDsJI,0BAAA;Af0npBJ;AwEhxpBA;EzDmJI,eAAA;AfgopBJ;AwEnxpBA;EzDsJI,0BAAA;AfgopBJ;AwEtxpBA;EzDmJI,eAAA;AfsopBJ;AwEzxpBA;EzDsJI,0BAAA;AfsopBJ;AwE5xpBA;EzDmJI,eAAA;Af4opBJ;AwE/xpBA;EzDsJI,0BAAA;Af4opBJ;AwElypBA;EzDmJI,eAAA;AfkppBJ;AwErypBA;EzDsJI,0BAAA;AfkppBJ;AwExypBA;EzDmJI,eAAA;AfwppBJ;AwE3ypBA;EzDsJI,0BAAA;AfwppBJ;AwE9ypBA;EzDmJI,eAAA;Af8ppBJ;AwEjzpBA;EzDsJI,0BAAA;Af8ppBJ;AwEpzpBA;EzDmJI,eAAA;AfoqpBJ;AwEvzpBA;EzDsJI,0BAAA;AfoqpBJ;AwE1zpBA;EzDmJI,eAAA;Af0qpBJ;AwE7zpBA;EzDsJI,0BAAA;Af0qpBJ;AwEh0pBA;EzDmJI,eAAA;AfgrpBJ;AwEn0pBA;EzDsJI,0BAAA;AfgrpBJ;AwEt0pBA;EzDmJI,eAAA;AfsrpBJ;AwEz0pBA;EzDsJI,0BAAA;AfsrpBJ;AwE50pBA;EzDmJI,eAAA;Af4rpBJ;AwE/0pBA;EzDsJI,0BAAA;Af4rpBJ;AwEl1pBA;EzDmJI,eAAA;AfkspBJ;AwEr1pBA;EzDsJI,0BAAA;AfkspBJ;AwEx1pBA;EzDmJI,eAAA;AfwspBJ;AwE31pBA;EzDsJI,0BAAA;AfwspBJ;AwE91pBA;EzDmJI,eAAA;Af8spBJ;AwEj2pBA;EzDsJI,0BAAA;Af8spBJ;AwEp2pBA;EzDmJI,eAAA;AfotpBJ;AwEv2pBA;EzDsJI,0BAAA;AfotpBJ;AwE12pBA;EzDmJI,eAAA;Af0tpBJ;AwE72pBA;EzDsJI,0BAAA;Af0tpBJ;AwEh3pBA;EzDmJI,eAAA;AfgupBJ;AwEn3pBA;EzDsJI,0BAAA;AfgupBJ;AwEt3pBA;EzDmJI,eAAA;AfsupBJ;AwEz3pBA;EzDsJI,0BAAA;AfsupBJ;AwE53pBA;EzDmJI,oBAAA;Af4upBJ;AwE/3pBA;EzDsJI,+BAAA;Af4upBJ;AwEl4pBA;EzDmJI,oBAAA;AfkvpBJ;AwEr4pBA;EzDsJI,+BAAA;AfkvpBJ;AwEx4pBA;EzDmJI,oBAAA;AfwvpBJ;AwE34pBA;EzDsJI,+BAAA;AfwvpBJ;AwE94pBA;EzDmJI,oBAAA;Af8vpBJ;AwEj5pBA;EzDsJI,+BAAA;Af8vpBJ;AwEp5pBA;EzDmJI,oBAAA;AfowpBJ;AwEv5pBA;EzDsJI,+BAAA;AfowpBJ;AwE15pBA;EzDmJI,oBAAA;Af0wpBJ;AwE75pBA;EzDsJI,+BAAA;Af0wpBJ;AwEh6pBA;EzDmJI,oBAAA;AfgxpBJ;AwEn6pBA;EzDsJI,+BAAA;AfgxpBJ;AwEt6pBA;EzDmJI,oBAAA;AfsxpBJ;AwEz6pBA;EzDsJI,+BAAA;AfsxpBJ;AwE56pBA;EzDmJI,oBAAA;Af4xpBJ;AwE/6pBA;EzDsJI,+BAAA;Af4xpBJ;AwEl7pBA;EzDmJI,oBAAA;AfkypBJ;AwEr7pBA;EzDsJI,+BAAA;AfkypBJ;AwEx7pBA;EzDmJI,oBAAA;AfwypBJ;AwE37pBA;EzDsJI,+BAAA;AfwypBJ;AwE97pBA;EzDmJI,oBAAA;Af8ypBJ;AwEj8pBA;EzDsJI,+BAAA;Af8ypBJ;AwEp8pBA;EzDmJI,oBAAA;AfozpBJ;AwEv8pBA;EzDsJI,+BAAA;AfozpBJ;AwE18pBA;EzDmJI,oBAAA;Af0zpBJ;AwE78pBA;EzDsJI,+BAAA;Af0zpBJ;AwEh9pBA;EzDmJI,oBAAA;Afg0pBJ;AwEn9pBA;EzDsJI,+BAAA;Afg0pBJ;AwEt9pBA;EzDmJI,oBAAA;Afs0pBJ;AwEz9pBA;EzDsJI,+BAAA;Afs0pBJ;AwE59pBA;EzDmJI,oBAAA;Af40pBJ;AwE/9pBA;EzDsJI,+BAAA;Af40pBJ;AwEl+pBA;EzDmJI,oBAAA;Afk1pBJ;AwEr+pBA;EzDsJI,+BAAA;Afk1pBJ;AwEx+pBA;EzDmJI,oBAAA;Afw1pBJ;AwE3+pBA;EzDsJI,+BAAA;Afw1pBJ;AwE9+pBA;EzDmJI,oBAAA;Af81pBJ;AwEj/pBA;EzDsJI,+BAAA;Af81pBJ;AwEp/pBA;EzDmJI,oBAAA;Afo2pBJ;AwEv/pBA;EzDsJI,+BAAA;Afo2pBJ;AwE1/pBA;EzDmJI,oBAAA;Af02pBJ;AwE7/pBA;EzDsJI,+BAAA;Af02pBJ;AwEhgqBA;EzDmJI,oBAAA;Afg3pBJ;AwEngqBA;EzDsJI,+BAAA;Afg3pBJ;AwEtgqBA;EzDmJI,oBAAA;Afs3pBJ;AwEzgqBA;EzDsJI,+BAAA;Afs3pBJ;AwE5gqBA;EzDmJI,oBAAA;Af43pBJ;AwE/gqBA;EzDsJI,+BAAA;Af43pBJ;AwElhqBA;EzDmJI,oBAAA;Afk4pBJ;AwErhqBA;EzDsJI,+BAAA;Afk4pBJ;AwExhqBA;EzDmJI,oBAAA;Afw4pBJ;AwE3hqBA;EzDsJI,+BAAA;Afw4pBJ;AwE9hqBA;EzDmJI,oBAAA;Af84pBJ;AwEjiqBA;EzDsJI,+BAAA;Af84pBJ;AwEpiqBA;EzDmJI,oBAAA;Afo5pBJ;AwEviqBA;EzDsJI,+BAAA;Afo5pBJ;AwE1iqBA;EzDmJI,oBAAA;Af05pBJ;AwE7iqBA;EzDsJI,+BAAA;Af05pBJ;AwEhjqBA;EzDmJI,oBAAA;Afg6pBJ;AwEnjqBA;EzDsJI,+BAAA;Afg6pBJ;AwEtjqBA;EzDmJI,oBAAA;Afs6pBJ;AwEzjqBA;EzDsJI,+BAAA;Afs6pBJ;AwE5jqBA;EzDmJI,oBAAA;Af46pBJ;AwE/jqBA;EzDsJI,+BAAA;Af46pBJ;AwElkqBA;EzDmJI,oBAAA;Afk7pBJ;AwErkqBA;EzDsJI,+BAAA;Afk7pBJ;AwExkqBA;EzDmJI,oBAAA;Afw7pBJ;AwE3kqBA;EzDsJI,+BAAA;Afw7pBJ;AwE9kqBA;EzDmJI,oBAAA;Af87pBJ;AwEjlqBA;EzDsJI,+BAAA;Af87pBJ;AwEplqBA;EzDmJI,oBAAA;Afo8pBJ;AwEvlqBA;EzDsJI,+BAAA;Afo8pBJ;AwE1lqBA;EzDmJI,oBAAA;Af08pBJ;AwE7lqBA;EzDsJI,+BAAA;Af08pBJ;AwEhmqBA;EzDmJI,oBAAA;Afg9pBJ;AwEnmqBA;EzDsJI,+BAAA;Afg9pBJ;AwEtmqBA;EzDmJI,oBAAA;Afs9pBJ;AwEzmqBA;EzDsJI,+BAAA;Afs9pBJ;AwE5mqBA;EzDmJI,oBAAA;Af49pBJ;AwE/mqBA;EzDsJI,+BAAA;Af49pBJ;AwElnqBA;EzDmJI,oBAAA;Afk+pBJ;AwErnqBA;EzDsJI,+BAAA;Afk+pBJ;AwExnqBA;EzDmJI,oBAAA;Afw+pBJ;AwE3nqBA;EzDsJI,+BAAA;Afw+pBJ;AwE9nqBA;EzDmJI,oBAAA;Af8+pBJ;AwEjoqBA;EzDsJI,+BAAA;Af8+pBJ;AwEpoqBA;EzDmJI,oBAAA;Afo/pBJ;AwEvoqBA;EzDsJI,+BAAA;Afo/pBJ;AwE1oqBA;EzDmJI,oBAAA;Af0/pBJ;AwE7oqBA;EzDsJI,+BAAA;Af0/pBJ;AwEhpqBA;EzDmJI,oBAAA;AfggqBJ;AwEnpqBA;EzDsJI,+BAAA;AfggqBJ;AwEtpqBA;EzDmJI,oBAAA;AfsgqBJ;AwEzpqBA;EzDsJI,+BAAA;AfsgqBJ;AwE5pqBA;EzDmJI,oBAAA;Af4gqBJ;AwE/pqBA;EzDsJI,+BAAA;Af4gqBJ;AwElqqBA;EzDmJI,oBAAA;AfkhqBJ;AwErqqBA;EzDsJI,+BAAA;AfkhqBJ;AwExqqBA;EzDmJI,oBAAA;AfwhqBJ;AwE3qqBA;EzDsJI,+BAAA;AfwhqBJ;AwE9qqBA;EzDmJI,oBAAA;Af8hqBJ;AwEjrqBA;EzDsJI,+BAAA;Af8hqBJ;AwEprqBA;EzDmJI,oBAAA;AfoiqBJ;AwEvrqBA;EzDsJI,+BAAA;AfoiqBJ;AwE1rqBA;EzDmJI,oBAAA;Af0iqBJ;AwE7rqBA;EzDsJI,+BAAA;Af0iqBJ;AwEhsqBA;EzDmJI,oBAAA;AfgjqBJ;AwEnsqBA;EzDsJI,+BAAA;AfgjqBJ;AwEtsqBA;EzDmJI,oBAAA;AfsjqBJ;AwEzsqBA;EzDsJI,+BAAA;AfsjqBJ;AwE5sqBA;EzDmJI,oBAAA;Af4jqBJ;AwE/sqBA;EzDsJI,+BAAA;Af4jqBJ;AwEltqBA;EzDmJI,oBAAA;AfkkqBJ;AwErtqBA;EzDsJI,+BAAA;AfkkqBJ;AwExtqBA;EzDmJI,oBAAA;AfwkqBJ;AwE3tqBA;EzDsJI,+BAAA;AfwkqBJ;AwE9tqBA;EzDmJI,oBAAA;Af8kqBJ;AwEjuqBA;EzDsJI,+BAAA;Af8kqBJ;AwEpuqBA;EzDmJI,oBAAA;AfolqBJ;AwEvuqBA;EzDsJI,+BAAA;AfolqBJ;AwE1uqBA;EzDmJI,oBAAA;Af0lqBJ;AwE7uqBA;EzDsJI,+BAAA;Af0lqBJ;AwEhvqBA;EzDmJI,oBAAA;AfgmqBJ;AwEnvqBA;EzDsJI,+BAAA;AfgmqBJ;AwEtvqBA;EzDmJI,oBAAA;AfsmqBJ;AwEzvqBA;EzDsJI,+BAAA;AfsmqBJ;AwE5vqBA;EzDmJI,oBAAA;Af4mqBJ;AwE/vqBA;EzDsJI,+BAAA;Af4mqBJ;AwElwqBA;EzDmJI,oBAAA;AfknqBJ;AwErwqBA;EzDsJI,+BAAA;AfknqBJ;AwExwqBA;EzDmJI,oBAAA;AfwnqBJ;AwE3wqBA;EzDsJI,+BAAA;AfwnqBJ;AwE9wqBA;EzDmJI,oBAAA;Af8nqBJ;AwEjxqBA;EzDsJI,+BAAA;Af8nqBJ;AwEpxqBA;EzDmJI,oBAAA;AfooqBJ;AwEvxqBA;EzDsJI,+BAAA;AfooqBJ;AwE1xqBA;EzDmJI,oBAAA;Af0oqBJ;AwE7xqBA;EzDsJI,+BAAA;Af0oqBJ;AwEhyqBA;EzDmJI,yBAAA;AfgpqBJ;AwEnyqBA;EzDsJI,oCAAA;AfgpqBJ;AwEtyqBA;EzDmJI,yBAAA;AfspqBJ;AwEzyqBA;EzDsJI,oCAAA;AfspqBJ;AwE5yqBA;EzDmJI,yBAAA;Af4pqBJ;AwE/yqBA;EzDsJI,oCAAA;Af4pqBJ;AwElzqBA;EzDmJI,yBAAA;AfkqqBJ;AwErzqBA;EzDsJI,oCAAA;AfkqqBJ;AwExzqBA;EzDmJI,yBAAA;AfwqqBJ;AwE3zqBA;EzDsJI,oCAAA;AfwqqBJ;AwE9zqBA;EzDmJI,yBAAA;Af8qqBJ;AwEj0qBA;EzDsJI,oCAAA;Af8qqBJ;AwEp0qBA;EzDmJI,yBAAA;AforqBJ;AwEv0qBA;EzDsJI,oCAAA;AforqBJ;AwE10qBA;EzDmJI,yBAAA;Af0rqBJ;AwE70qBA;EzDsJI,oCAAA;Af0rqBJ;AwEh1qBA;EzDmJI,yBAAA;AfgsqBJ;AwEn1qBA;EzDsJI,oCAAA;AfgsqBJ;AwEt1qBA;EzDmJI,yBAAA;AfssqBJ;AwEz1qBA;EzDsJI,oCAAA;AfssqBJ;AwE51qBA;EzDmJI,yBAAA;Af4sqBJ;AwE/1qBA;EzDsJI,oCAAA;Af4sqBJ;AwEl2qBA;EzDmJI,yBAAA;AfktqBJ;AwEr2qBA;EzDsJI,oCAAA;AfktqBJ;AwEx2qBA;EzDmJI,yBAAA;AfwtqBJ;AwE32qBA;EzDsJI,oCAAA;AfwtqBJ;AwE92qBA;EzDmJI,yBAAA;Af8tqBJ;AwEj3qBA;EzDsJI,oCAAA;Af8tqBJ;AwEp3qBA;EzDmJI,yBAAA;AfouqBJ;AwEv3qBA;EzDsJI,oCAAA;AfouqBJ;AwE13qBA;EzDmJI,yBAAA;Af0uqBJ;AwE73qBA;EzDsJI,oCAAA;Af0uqBJ;AwEh4qBA;EzDmJI,yBAAA;AfgvqBJ;AwEn4qBA;EzDsJI,oCAAA;AfgvqBJ;AwEt4qBA;EzDmJI,yBAAA;AfsvqBJ;AwEz4qBA;EzDsJI,oCAAA;AfsvqBJ;AwE54qBA;EzDmJI,yBAAA;Af4vqBJ;AwE/4qBA;EzDsJI,oCAAA;Af4vqBJ;AwEl5qBA;EzDmJI,yBAAA;AfkwqBJ;AwEr5qBA;EzDsJI,oCAAA;AfkwqBJ;AwEx5qBA;EzDmJI,yBAAA;AfwwqBJ;AwE35qBA;EzDsJI,oCAAA;AfwwqBJ;AwE95qBA;EzDmJI,yBAAA;Af8wqBJ;AwEj6qBA;EzDsJI,oCAAA;Af8wqBJ;AwEp6qBA;EzDmJI,yBAAA;AfoxqBJ;AwEv6qBA;EzDsJI,oCAAA;AfoxqBJ;AwE16qBA;EzDmJI,yBAAA;Af0xqBJ;AwE76qBA;EzDsJI,oCAAA;Af0xqBJ;AwEh7qBA;EzDmJI,yBAAA;AfgyqBJ;AwEn7qBA;EzDsJI,oCAAA;AfgyqBJ;AwEt7qBA;EzDmJI,yBAAA;AfsyqBJ;AwEz7qBA;EzDsJI,oCAAA;AfsyqBJ;AwE57qBA;EzDmJI,yBAAA;Af4yqBJ;AwE/7qBA;EzDsJI,oCAAA;Af4yqBJ;AwEl8qBA;EzDmJI,yBAAA;AfkzqBJ;AwEr8qBA;EzDsJI,oCAAA;AfkzqBJ;AwEx8qBA;EzDmJI,yBAAA;AfwzqBJ;AwE38qBA;EzDsJI,oCAAA;AfwzqBJ;AwE98qBA;EzDmJI,yBAAA;Af8zqBJ;AwEj9qBA;EzDsJI,oCAAA;Af8zqBJ;AwEp9qBA;EzDmJI,6BAAA;Afo0qBJ;AwEv9qBA;EzDsJI,wCAAA;Afo0qBJ;AwE19qBA;EzDmJI,6BAAA;Af00qBJ;AwE79qBA;EzDsJI,wCAAA;Af00qBJ;AwEh+qBA;EzDmJI,6BAAA;Afg1qBJ;AwEn+qBA;EzDsJI,wCAAA;Afg1qBJ;AwEt+qBA;EzDmJI,6BAAA;Afs1qBJ;AwEz+qBA;EzDsJI,wCAAA;Afs1qBJ;AwE5+qBA;EzDmJI,6BAAA;Af41qBJ;AwE/+qBA;EzDsJI,wCAAA;Af41qBJ;AwEl/qBA;EzDmJI,6BAAA;Afk2qBJ;AwEr/qBA;EzDsJI,wCAAA;Afk2qBJ;AwEx/qBA;EzDmJI,6BAAA;Afw2qBJ;AwE3/qBA;EzDsJI,wCAAA;Afw2qBJ;AwE9/qBA;EzDmJI,6BAAA;Af82qBJ;AwEjgrBA;EzDsJI,wCAAA;Af82qBJ;AwEpgrBA;EzDmJI,6BAAA;Afo3qBJ;AwEvgrBA;EzDsJI,wCAAA;Afo3qBJ;AwE1grBA;EzDmJI,6BAAA;Af03qBJ;AwE7grBA;EzDsJI,wCAAA;Af03qBJ;AwEhhrBA;EzDmJI,6BAAA;Afg4qBJ;AwEnhrBA;EzDsJI,wCAAA;Afg4qBJ;AwEthrBA;EzDmJI,6BAAA;Afs4qBJ;AwEzhrBA;EzDsJI,wCAAA;Afs4qBJ;AwE5hrBA;EzDmJI,6BAAA;Af44qBJ;AwE/hrBA;EzDsJI,wCAAA;Af44qBJ;AwElirBA;EzDmJI,6BAAA;Afk5qBJ;AwErirBA;EzDsJI,wCAAA;Afk5qBJ;AwExirBA;EzDmJI,6BAAA;Afw5qBJ;AwE3irBA;EzDsJI,wCAAA;Afw5qBJ;AwE9irBA;EzDmJI,6BAAA;Af85qBJ;AwEjjrBA;EzDsJI,wCAAA;Af85qBJ;AwEpjrBA;EzDmJI,6BAAA;Afo6qBJ;AwEvjrBA;EzDsJI,wCAAA;Afo6qBJ;AwE1jrBA;EzDmJI,6BAAA;Af06qBJ;AwE7jrBA;EzDsJI,wCAAA;Af06qBJ;AwEhkrBA;EzDmJI,6BAAA;Afg7qBJ;AwEnkrBA;EzDsJI,wCAAA;Afg7qBJ;AwEtkrBA;EzDmJI,6BAAA;Afs7qBJ;AwEzkrBA;EzDsJI,wCAAA;Afs7qBJ;AwE5krBA;EzDmJI,+BAAA;Af47qBJ;AwE/krBA;EzDsJI,0CAAA;Af47qBJ;AwEllrBA;EzDmJI,+BAAA;Afk8qBJ;AwErlrBA;EzDsJI,0CAAA;Afk8qBJ;AwExlrBA;EzDmJI,+BAAA;Afw8qBJ;AwE3lrBA;EzDsJI,0CAAA;Afw8qBJ;AwE9lrBA;EzDmJI,+BAAA;Af88qBJ;AwEjmrBA;EzDsJI,0CAAA;Af88qBJ;AwEpmrBA;EzDmJI,+BAAA;Afo9qBJ;AwEvmrBA;EzDsJI,0CAAA;Afo9qBJ;AwE1mrBA;EzDmJI,+BAAA;Af09qBJ;AwE7mrBA;EzDsJI,0CAAA;Af09qBJ;AwEhnrBA;EzDmJI,+BAAA;Afg+qBJ;AwEnnrBA;EzDsJI,0CAAA;Afg+qBJ;AwEtnrBA;EzDmJI,+BAAA;Afs+qBJ;AwEznrBA;EzDsJI,0CAAA;Afs+qBJ;AwE5nrBA;EzDmJI,+BAAA;Af4+qBJ;AwE/nrBA;EzDsJI,0CAAA;Af4+qBJ;AwElorBA;EzDmJI,+BAAA;Afk/qBJ;AwErorBA;EzDsJI,0CAAA;Afk/qBJ;AwExorBA;EzDmJI,+BAAA;Afw/qBJ;AwE3orBA;EzDsJI,0CAAA;Afw/qBJ;AwE9orBA;EzDmJI,+BAAA;Af8/qBJ;AwEjprBA;EzDsJI,0CAAA;Af8/qBJ;AwEpprBA;EzDmJI,+BAAA;AfogrBJ;AwEvprBA;EzDsJI,0CAAA;AfogrBJ;AwE1prBA;EzDmJI,+BAAA;Af0grBJ;AwE7prBA;EzDsJI,0CAAA;Af0grBJ;AwEhqrBA;EzDmJI,+BAAA;AfghrBJ;AwEnqrBA;EzDsJI,0CAAA;AfghrBJ;AwEtqrBA;EzDmJI,+BAAA;AfshrBJ;AwEzqrBA;EzDsJI,0CAAA;AfshrBJ;AwE5qrBA;EzDmJI,+BAAA;Af4hrBJ;AwE/qrBA;EzDsJI,0CAAA;Af4hrBJ;AwElrrBA;EzDmJI,+BAAA;AfkirBJ;AwErrrBA;EzDsJI,0CAAA;AfkirBJ;AwExrrBA;EzDmJI,+BAAA;AfwirBJ;AwE3rrBA;EzDsJI,0CAAA;AfwirBJ;AwE9rrBA;EzDmJI,+BAAA;Af8irBJ;AwEjsrBA;EzDsJI,0CAAA;Af8irBJ;AwEpsrBA;EzDmJI,gCAAA;AfojrBJ;AwEvsrBA;EzDsJI,2CAAA;AfojrBJ;AwE1srBA;EzDmJI,gCAAA;Af0jrBJ;AwE7srBA;EzDsJI,2CAAA;Af0jrBJ;AwEhtrBA;EzDmJI,gCAAA;AfgkrBJ;AwEntrBA;EzDsJI,2CAAA;AfgkrBJ;AwEttrBA;EzDmJI,gCAAA;AfskrBJ;AwEztrBA;EzDsJI,2CAAA;AfskrBJ;AwE5trBA;EzDmJI,gCAAA;Af4krBJ;AwE/trBA;EzDsJI,2CAAA;Af4krBJ;AwElurBA;EzDmJI,gCAAA;AfklrBJ;AwErurBA;EzDsJI,2CAAA;AfklrBJ;AwExurBA;EzDmJI,gCAAA;AfwlrBJ;AwE3urBA;EzDsJI,2CAAA;AfwlrBJ;AwE9urBA;EzDmJI,gCAAA;Af8lrBJ;AwEjvrBA;EzDsJI,2CAAA;Af8lrBJ;AwEpvrBA;EzDmJI,gCAAA;AfomrBJ;AwEvvrBA;EzDsJI,2CAAA;AfomrBJ;AwE1vrBA;EzDmJI,gCAAA;Af0mrBJ;AwE7vrBA;EzDsJI,2CAAA;Af0mrBJ;AwEhwrBA;EzDmJI,gCAAA;AfgnrBJ;AwEnwrBA;EzDsJI,2CAAA;AfgnrBJ;AwEtwrBA;EzDmJI,gCAAA;AfsnrBJ;AwEzwrBA;EzDsJI,2CAAA;AfsnrBJ;AwE5wrBA;EzDmJI,gCAAA;Af4nrBJ;AwE/wrBA;EzDsJI,2CAAA;Af4nrBJ;AwElxrBA;EzDmJI,gCAAA;AfkorBJ;AwErxrBA;EzDsJI,2CAAA;AfkorBJ;AwExxrBA;EzDmJI,gCAAA;AfworBJ;AwE3xrBA;EzDsJI,2CAAA;AfworBJ;AwE9xrBA;EzDmJI,gCAAA;Af8orBJ;AwEjyrBA;EzDsJI,2CAAA;Af8orBJ;AwEpyrBA;EzDmJI,gCAAA;AfoprBJ;AwEvyrBA;EzDsJI,2CAAA;AfoprBJ;AwE1yrBA;EzDmJI,gCAAA;Af0prBJ;AwE7yrBA;EzDsJI,2CAAA;Af0prBJ;AwEhzrBA;EzDmJI,gCAAA;AfgqrBJ;AwEnzrBA;EzDsJI,2CAAA;AfgqrBJ;AwEtzrBA;EzDmJI,gCAAA;AfsqrBJ;AwEzzrBA;EzDsJI,2CAAA;AfsqrBJ;AwE5zrBA;EzDmJI,8BAAA;Af4qrBJ;AwE/zrBA;EzDsJI,yCAAA;Af4qrBJ;AwEl0rBA;EzDmJI,8BAAA;AfkrrBJ;AwEr0rBA;EzDsJI,yCAAA;AfkrrBJ;AwEx0rBA;EzDmJI,8BAAA;AfwrrBJ;AwE30rBA;EzDsJI,yCAAA;AfwrrBJ;AwE90rBA;EzDmJI,8BAAA;Af8rrBJ;AwEj1rBA;EzDsJI,yCAAA;Af8rrBJ;AwEp1rBA;EzDmJI,8BAAA;AfosrBJ;AwEv1rBA;EzDsJI,yCAAA;AfosrBJ;AwE11rBA;EzDmJI,8BAAA;Af0srBJ;AwE71rBA;EzDsJI,yCAAA;Af0srBJ;AwEh2rBA;EzDmJI,8BAAA;AfgtrBJ;AwEn2rBA;EzDsJI,yCAAA;AfgtrBJ;AwEt2rBA;EzDmJI,8BAAA;AfstrBJ;AwEz2rBA;EzDsJI,yCAAA;AfstrBJ;AwE52rBA;EzDmJI,8BAAA;Af4trBJ;AwE/2rBA;EzDsJI,yCAAA;Af4trBJ;AwEl3rBA;EzDmJI,8BAAA;AfkurBJ;AwEr3rBA;EzDsJI,yCAAA;AfkurBJ;AwEx3rBA;EzDmJI,8BAAA;AfwurBJ;AwE33rBA;EzDsJI,yCAAA;AfwurBJ;AwE93rBA;EzDmJI,8BAAA;Af8urBJ;AwEj4rBA;EzDsJI,yCAAA;Af8urBJ;AwEp4rBA;EzDmJI,8BAAA;AfovrBJ;AwEv4rBA;EzDsJI,yCAAA;AfovrBJ;AwE14rBA;EzDmJI,8BAAA;Af0vrBJ;AwE74rBA;EzDsJI,yCAAA;Af0vrBJ;AwEh5rBA;EzDmJI,8BAAA;AfgwrBJ;AwEn5rBA;EzDsJI,yCAAA;AfgwrBJ;AwEt5rBA;EzDmJI,8BAAA;AfswrBJ;AwEz5rBA;EzDsJI,yCAAA;AfswrBJ;AwE55rBA;EzDmJI,8BAAA;Af4wrBJ;AwE/5rBA;EzDsJI,yCAAA;Af4wrBJ;AwEl6rBA;EzDmJI,8BAAA;AfkxrBJ;AwEr6rBA;EzDsJI,yCAAA;AfkxrBJ;AwEx6rBA;EzDmJI,8BAAA;AfwxrBJ;AwE36rBA;EzDsJI,yCAAA;AfwxrBJ;AwE96rBA;EzDmJI,8BAAA;Af8xrBJ;AwEj7rBA;EzDsJI,yCAAA;Af8xrBJ;AwEp7rBA;EzDmJI,sBAAA;AfoyrBJ;AwEv7rBA;EzDsJI,iCAAA;AfoyrBJ;AwE17rBA;EzDmJI,sBAAA;Af0yrBJ;AwE77rBA;EzDsJI,iCAAA;Af0yrBJ;AwEh8rBA;EzDmJI,sBAAA;AfgzrBJ;AwEn8rBA;EzDsJI,iCAAA;AfgzrBJ;AwEt8rBA;EzDmJI,sBAAA;AfszrBJ;AwEz8rBA;EzDsJI,iCAAA;AfszrBJ;AwE58rBA;EzDmJI,sBAAA;Af4zrBJ;AwE/8rBA;EzDsJI,iCAAA;Af4zrBJ;AwEl9rBA;EzDmJI,sBAAA;Afk0rBJ;AwEr9rBA;EzDsJI,iCAAA;Afk0rBJ;AwEx9rBA;EzDmJI,sBAAA;Afw0rBJ;AwE39rBA;EzDsJI,iCAAA;Afw0rBJ;AwE99rBA;EzDmJI,sBAAA;Af80rBJ;AwEj+rBA;EzDsJI,iCAAA;Af80rBJ;AwEp+rBA;EzDmJI,sBAAA;Afo1rBJ;AwEv+rBA;EzDsJI,iCAAA;Afo1rBJ;AwE1+rBA;EzDmJI,sBAAA;Af01rBJ;AwE7+rBA;EzDsJI,iCAAA;Af01rBJ;AwEh/rBA;EzDmJI,sBAAA;Afg2rBJ;AwEn/rBA;EzDsJI,iCAAA;Afg2rBJ;AwEt/rBA;EzDmJI,sBAAA;Afs2rBJ;AwEz/rBA;EzDsJI,iCAAA;Afs2rBJ;AwE5/rBA;EzDmJI,sBAAA;Af42rBJ;AwE//rBA;EzDsJI,iCAAA;Af42rBJ;AwElgsBA;EzDmJI,sBAAA;Afk3rBJ;AwErgsBA;EzDsJI,iCAAA;Afk3rBJ;AwExgsBA;EzDmJI,sBAAA;Afw3rBJ;AwE3gsBA;EzDsJI,iCAAA;Afw3rBJ;AwE9gsBA;EzDmJI,sBAAA;Af83rBJ;AwEjhsBA;EzDsJI,iCAAA;Af83rBJ;AwEphsBA;EzDmJI,sBAAA;Afo4rBJ;AwEvhsBA;EzDsJI,iCAAA;Afo4rBJ;AwE1hsBA;EzDmJI,sBAAA;Af04rBJ;AwE7hsBA;EzDsJI,iCAAA;Af04rBJ;AwEhisBA;EzDmJI,sBAAA;Afg5rBJ;AwEnisBA;EzDsJI,iCAAA;Afg5rBJ;AwEtisBA;EzDmJI,sBAAA;Afs5rBJ;AwEzisBA;EzDsJI,iCAAA;Afs5rBJ;AwE5isBA;EzDmJI,eAAA;Af45rBJ;AwE/isBA;EzDsJI,0BAAA;Af45rBJ;AwEljsBA;EzDmJI,eAAA;Afk6rBJ;AwErjsBA;EzDsJI,0BAAA;Afk6rBJ;AwExjsBA;EzDmJI,eAAA;Afw6rBJ;AwE3jsBA;EzDsJI,0BAAA;Afw6rBJ;AwE9jsBA;EzDmJI,eAAA;Af86rBJ;AwEjksBA;EzDsJI,0BAAA;Af86rBJ;AwEpksBA;EzDmJI,eAAA;Afo7rBJ;AwEvksBA;EzDsJI,0BAAA;Afo7rBJ;AwE1ksBA;EzDmJI,eAAA;Af07rBJ;AwE7ksBA;EzDsJI,0BAAA;Af07rBJ;AwEhlsBA;EzDmJI,eAAA;Afg8rBJ;AwEnlsBA;EzDsJI,0BAAA;Afg8rBJ;AwEtlsBA;EzDmJI,eAAA;Afs8rBJ;AwEzlsBA;EzDsJI,0BAAA;Afs8rBJ;AwE5lsBA;EzDmJI,eAAA;Af48rBJ;AwE/lsBA;EzDsJI,0BAAA;Af48rBJ;AwElmsBA;EzDmJI,eAAA;Afk9rBJ;AwErmsBA;EzDsJI,0BAAA;Afk9rBJ;AwExmsBA;EzDmJI,eAAA;Afw9rBJ;AwE3msBA;EzDsJI,0BAAA;Afw9rBJ;AwE9msBA;EzDmJI,eAAA;Af89rBJ;AwEjnsBA;EzDsJI,0BAAA;Af89rBJ;AwEpnsBA;EzDmJI,eAAA;Afo+rBJ;AwEvnsBA;EzDsJI,0BAAA;Afo+rBJ;AwE1nsBA;EzDmJI,eAAA;Af0+rBJ;AwE7nsBA;EzDsJI,0BAAA;Af0+rBJ;AwEhosBA;EzDmJI,eAAA;Afg/rBJ;AwEnosBA;EzDsJI,0BAAA;Afg/rBJ;AwEtosBA;EzDmJI,eAAA;Afs/rBJ;AwEzosBA;EzDsJI,0BAAA;Afs/rBJ;AwE5osBA;EzDmJI,eAAA;Af4/rBJ;AwE/osBA;EzDsJI,0BAAA;Af4/rBJ;AwElpsBA;EzDmJI,eAAA;AfkgsBJ;AwErpsBA;EzDsJI,0BAAA;AfkgsBJ;AwExpsBA;EzDmJI,eAAA;AfwgsBJ;AwE3psBA;EzDsJI,0BAAA;AfwgsBJ;AwE9psBA;EzDmJI,eAAA;Af8gsBJ;AwEjqsBA;EzDsJI,0BAAA;Af8gsBJ;AwEpqsBA;EzDmJI,eAAA;AfohsBJ;AwEvqsBA;EzDsJI,0BAAA;AfohsBJ;AwE1qsBA;EzDmJI,eAAA;Af0hsBJ;AwE7qsBA;EzDsJI,0BAAA;Af0hsBJ;AwEhrsBA;EzDmJI,eAAA;AfgisBJ;AwEnrsBA;EzDsJI,0BAAA;AfgisBJ;AwEtrsBA;EzDmJI,eAAA;AfsisBJ;AwEzrsBA;EzDsJI,0BAAA;AfsisBJ;AwE5rsBA;EzDmJI,eAAA;Af4isBJ;AwE/rsBA;EzDsJI,0BAAA;Af4isBJ;AwElssBA;EzDmJI,eAAA;AfkjsBJ;AwErssBA;EzDsJI,0BAAA;AfkjsBJ;AwExssBA;EzDmJI,eAAA;AfwjsBJ;AwE3ssBA;EzDsJI,0BAAA;AfwjsBJ;AwE9ssBA;EzDmJI,eAAA;Af8jsBJ;AwEjtsBA;EzDsJI,0BAAA;Af8jsBJ;AwEptsBA;EzDmJI,eAAA;AfoksBJ;AwEvtsBA;EzDsJI,0BAAA;AfoksBJ;AwE1tsBA;EzDmJI,eAAA;Af0ksBJ;AwE7tsBA;EzDsJI,0BAAA;Af0ksBJ;AwEhusBA;EzDmJI,eAAA;AfglsBJ;AwEnusBA;EzDsJI,0BAAA;AfglsBJ;AwEtusBA;EzDmJI,eAAA;AfslsBJ;AwEzusBA;EzDsJI,0BAAA;AfslsBJ;AwE5usBA;EzDmJI,eAAA;Af4lsBJ;AwE/usBA;EzDsJI,0BAAA;Af4lsBJ;AwElvsBA;EzDmJI,eAAA;AfkmsBJ;AwErvsBA;EzDsJI,0BAAA;AfkmsBJ;AwExvsBA;EzDmJI,eAAA;AfwmsBJ;AwE3vsBA;EzDsJI,0BAAA;AfwmsBJ;AwE9vsBA;EzDmJI,eAAA;Af8msBJ;AwEjwsBA;EzDsJI,0BAAA;Af8msBJ;AwEpwsBA;EzDmJI,eAAA;AfonsBJ;AwEvwsBA;EzDsJI,0BAAA;AfonsBJ;AwE1wsBA;EzDmJI,eAAA;Af0nsBJ;AwE7wsBA;EzDsJI,0BAAA;Af0nsBJ;AwEhxsBA;EzDmJI,eAAA;AfgosBJ;AwEnxsBA;EzDsJI,0BAAA;AfgosBJ;AwEtxsBA;EzDmJI,eAAA;AfsosBJ;AwEzxsBA;EzDsJI,0BAAA;AfsosBJ;AwE5xsBA;EzDmJI,eAAA;Af4osBJ;AwE/xsBA;EzDsJI,0BAAA;Af4osBJ;AwElysBA;EzDmJI,eAAA;AfkpsBJ;AwErysBA;EzDsJI,0BAAA;AfkpsBJ;AwExysBA;EzDmJI,eAAA;AfwpsBJ;AwE3ysBA;EzDsJI,0BAAA;AfwpsBJ;AwE9ysBA;EzDmJI,eAAA;Af8psBJ;AwEjzsBA;EzDsJI,0BAAA;Af8psBJ;AwEpzsBA;EzDmJI,eAAA;AfoqsBJ;AwEvzsBA;EzDsJI,0BAAA;AfoqsBJ;AwE1zsBA;EzDmJI,eAAA;Af0qsBJ;AwE7zsBA;EzDsJI,0BAAA;Af0qsBJ;AwEh0sBA;EzDmJI,eAAA;AfgrsBJ;AwEn0sBA;EzDsJI,0BAAA;AfgrsBJ;AwEt0sBA;EzDmJI,eAAA;AfsrsBJ;AwEz0sBA;EzDsJI,0BAAA;AfsrsBJ;AwE50sBA;EzDmJI,eAAA;Af4rsBJ;AwE/0sBA;EzDsJI,0BAAA;Af4rsBJ;AwEl1sBA;EzDmJI,eAAA;AfkssBJ;AwEr1sBA;EzDsJI,0BAAA;AfkssBJ;AwEx1sBA;EzDmJI,eAAA;AfwssBJ;AwE31sBA;EzDsJI,0BAAA;AfwssBJ;AwE91sBA;EzDmJI,eAAA;Af8ssBJ;AwEj2sBA;EzDsJI,0BAAA;Af8ssBJ;AwEp2sBA;EzDmJI,eAAA;AfotsBJ;AwEv2sBA;EzDsJI,0BAAA;AfotsBJ;AwE12sBA;EzDmJI,eAAA;Af0tsBJ;AwE72sBA;EzDsJI,0BAAA;Af0tsBJ;AwEh3sBA;EzDmJI,eAAA;AfgusBJ;AwEn3sBA;EzDsJI,0BAAA;AfgusBJ;AwEt3sBA;EzDmJI,eAAA;AfsusBJ;AwEz3sBA;EzDsJI,0BAAA;AfsusBJ;AwE53sBA;EzDmJI,eAAA;Af4usBJ;AwE/3sBA;EzDsJI,0BAAA;Af4usBJ;AwEl4sBA;EzDmJI,eAAA;AfkvsBJ;AwEr4sBA;EzDsJI,0BAAA;AfkvsBJ;AwEx4sBA;EzDmJI,eAAA;AfwvsBJ;AwE34sBA;EzDsJI,0BAAA;AfwvsBJ;AwE94sBA;EzDmJI,eAAA;Af8vsBJ;AwEj5sBA;EzDsJI,0BAAA;Af8vsBJ;AwEp5sBA;EzDmJI,eAAA;AfowsBJ;AwEv5sBA;EzDsJI,0BAAA;AfowsBJ;AwE15sBA;EzDmJI,eAAA;Af0wsBJ;AwE75sBA;EzDsJI,0BAAA;Af0wsBJ;AwEh6sBA;EzDmJI,eAAA;AfgxsBJ;AwEn6sBA;EzDsJI,0BAAA;AfgxsBJ;AwEt6sBA;EzDmJI,eAAA;AfsxsBJ;AwEz6sBA;EzDsJI,0BAAA;AfsxsBJ;AwE56sBA;EzDmJI,eAAA;Af4xsBJ;AwE/6sBA;EzDsJI,0BAAA;Af4xsBJ;AwEl7sBA;EzDmJI,eAAA;AfkysBJ;AwEr7sBA;EzDsJI,0BAAA;AfkysBJ;AwEx7sBA;EzDmJI,eAAA;AfwysBJ;AwE37sBA;EzDsJI,0BAAA;AfwysBJ;AwE97sBA;EzDmJI,eAAA;Af8ysBJ;AwEj8sBA;EzDsJI,0BAAA;Af8ysBJ;AwEp8sBA;EzDmJI,eAAA;AfozsBJ;AwEv8sBA;EzDsJI,0BAAA;AfozsBJ;AwE18sBA;EzDmJI,eAAA;Af0zsBJ;AwE78sBA;EzDsJI,0BAAA;Af0zsBJ;AwEh9sBA;EzDmJI,eAAA;Afg0sBJ;AwEn9sBA;EzDsJI,0BAAA;Afg0sBJ;AwEt9sBA;EzDmJI,eAAA;Afs0sBJ;AwEz9sBA;EzDsJI,0BAAA;Afs0sBJ;AwE59sBA;EzDmJI,eAAA;Af40sBJ;AwE/9sBA;EzDsJI,0BAAA;Af40sBJ;AwEl+sBA;EzDmJI,eAAA;Afk1sBJ;AwEr+sBA;EzDsJI,0BAAA;Afk1sBJ;AwEx+sBA;EzDmJI,eAAA;Afw1sBJ;AwE3+sBA;EzDsJI,0BAAA;Afw1sBJ;AwE9+sBA;EzDmJI,eAAA;Af81sBJ;AwEj/sBA;EzDsJI,0BAAA;Af81sBJ;AwEp/sBA;EzDmJI,eAAA;Afo2sBJ;AwEv/sBA;EzDsJI,0BAAA;Afo2sBJ;AwE1/sBA;EzDmJI,eAAA;Af02sBJ;AwE7/sBA;EzDsJI,0BAAA;Af02sBJ;AwEhgtBA;EzDmJI,eAAA;Afg3sBJ;AwEngtBA;EzDsJI,0BAAA;Afg3sBJ;AwEtgtBA;EzDmJI,eAAA;Afs3sBJ;AwEzgtBA;EzDsJI,0BAAA;Afs3sBJ;AwE5gtBA;EzDmJI,eAAA;Af43sBJ;AwE/gtBA;EzDsJI,0BAAA;Af43sBJ;AwElhtBA;EzDmJI,eAAA;Afk4sBJ;AwErhtBA;EzDsJI,0BAAA;Afk4sBJ;AwExhtBA;EzDmJI,eAAA;Afw4sBJ;AwE3htBA;EzDsJI,0BAAA;Afw4sBJ;AwE9htBA;EzDmJI,eAAA;Af84sBJ;AwEjitBA;EzDsJI,0BAAA;Af84sBJ;AwEpitBA;EzDmJI,eAAA;Afo5sBJ;AwEvitBA;EzDsJI,0BAAA;Afo5sBJ;AwE1itBA;EzDmJI,eAAA;Af05sBJ;AwE7itBA;EzDsJI,0BAAA;Af05sBJ;AwEhjtBA;EzDmJI,eAAA;Afg6sBJ;AwEnjtBA;EzDsJI,0BAAA;Afg6sBJ;AwEtjtBA;EzDmJI,eAAA;Afs6sBJ;AwEzjtBA;EzDsJI,0BAAA;Afs6sBJ;AwE5jtBA;EzDmJI,eAAA;Af46sBJ;AwE/jtBA;EzDsJI,0BAAA;Af46sBJ;AwElktBA;EzDmJI,eAAA;Afk7sBJ;AwErktBA;EzDsJI,0BAAA;Afk7sBJ;AwExktBA;EzDmJI,eAAA;Afw7sBJ;AwE3ktBA;EzDsJI,0BAAA;Afw7sBJ;AwE9ktBA;EzDmJI,eAAA;Af87sBJ;AwEjltBA;EzDsJI,0BAAA;Af87sBJ;AwEpltBA;EzDmJI,eAAA;Afo8sBJ;AwEvltBA;EzDsJI,0BAAA;Afo8sBJ;AwE1ltBA;EzDmJI,eAAA;Af08sBJ;AwE7ltBA;EzDsJI,0BAAA;Af08sBJ;AwEhmtBA;EzDmJI,eAAA;Afg9sBJ;AwEnmtBA;EzDsJI,0BAAA;Afg9sBJ;AwEtmtBA;EzDmJI,eAAA;Afs9sBJ;AwEzmtBA;EzDsJI,0BAAA;Afs9sBJ;AwE5mtBA;EzDmJI,eAAA;Af49sBJ;AwE/mtBA;EzDsJI,0BAAA;Af49sBJ;AwElntBA;EzDmJI,eAAA;Afk+sBJ;AwErntBA;EzDsJI,0BAAA;Afk+sBJ;AwExntBA;EzDmJI,eAAA;Afw+sBJ;AwE3ntBA;EzDsJI,0BAAA;Afw+sBJ;AwE9ntBA;EzDmJI,eAAA;Af8+sBJ;AwEjotBA;EzDsJI,0BAAA;Af8+sBJ;AwEpotBA;EzDmJI,oBAAA;Afo/sBJ;AwEvotBA;EzDsJI,+BAAA;Afo/sBJ;AwE1otBA;EzDmJI,oBAAA;Af0/sBJ;AwE7otBA;EzDsJI,+BAAA;Af0/sBJ;AwEhptBA;EzDmJI,oBAAA;AfggtBJ;AwEnptBA;EzDsJI,+BAAA;AfggtBJ;AwEtptBA;EzDmJI,oBAAA;AfsgtBJ;AwEzptBA;EzDsJI,+BAAA;AfsgtBJ;AwE5ptBA;EzDmJI,oBAAA;Af4gtBJ;AwE/ptBA;EzDsJI,+BAAA;Af4gtBJ;AwElqtBA;EzDmJI,oBAAA;AfkhtBJ;AwErqtBA;EzDsJI,+BAAA;AfkhtBJ;AwExqtBA;EzDmJI,oBAAA;AfwhtBJ;AwE3qtBA;EzDsJI,+BAAA;AfwhtBJ;AwE9qtBA;EzDmJI,oBAAA;Af8htBJ;AwEjrtBA;EzDsJI,+BAAA;Af8htBJ;AwEprtBA;EzDmJI,oBAAA;AfoitBJ;AwEvrtBA;EzDsJI,+BAAA;AfoitBJ;AwE1rtBA;EzDmJI,oBAAA;Af0itBJ;AwE7rtBA;EzDsJI,+BAAA;Af0itBJ;AwEhstBA;EzDmJI,oBAAA;AfgjtBJ;AwEnstBA;EzDsJI,+BAAA;AfgjtBJ;AwEtstBA;EzDmJI,oBAAA;AfsjtBJ;AwEzstBA;EzDsJI,+BAAA;AfsjtBJ;AwE5stBA;EzDmJI,oBAAA;Af4jtBJ;AwE/stBA;EzDsJI,+BAAA;Af4jtBJ;AwElttBA;EzDmJI,oBAAA;AfkktBJ;AwErttBA;EzDsJI,+BAAA;AfkktBJ;AwExttBA;EzDmJI,oBAAA;AfwktBJ;AwE3ttBA;EzDsJI,+BAAA;AfwktBJ;AwE9ttBA;EzDmJI,oBAAA;Af8ktBJ;AwEjutBA;EzDsJI,+BAAA;Af8ktBJ;AwEputBA;EzDmJI,oBAAA;AfoltBJ;AwEvutBA;EzDsJI,+BAAA;AfoltBJ;AwE1utBA;EzDmJI,oBAAA;Af0ltBJ;AwE7utBA;EzDsJI,+BAAA;Af0ltBJ;AwEhvtBA;EzDmJI,oBAAA;AfgmtBJ;AwEnvtBA;EzDsJI,+BAAA;AfgmtBJ;AwEtvtBA;EzDmJI,oBAAA;AfsmtBJ;AwEzvtBA;EzDsJI,+BAAA;AfsmtBJ;AwE5vtBA;EzDmJI,oBAAA;Af4mtBJ;AwE/vtBA;EzDsJI,+BAAA;Af4mtBJ;AwElwtBA;EzDmJI,oBAAA;AfkntBJ;AwErwtBA;EzDsJI,+BAAA;AfkntBJ;AwExwtBA;EzDmJI,oBAAA;AfwntBJ;AwE3wtBA;EzDsJI,+BAAA;AfwntBJ;AwE9wtBA;EzDmJI,oBAAA;Af8ntBJ;AwEjxtBA;EzDsJI,+BAAA;Af8ntBJ;AwEpxtBA;EzDmJI,oBAAA;AfootBJ;AwEvxtBA;EzDsJI,+BAAA;AfootBJ;AwE1xtBA;EzDmJI,oBAAA;Af0otBJ;AwE7xtBA;EzDsJI,+BAAA;Af0otBJ;AwEhytBA;EzDmJI,oBAAA;AfgptBJ;AwEnytBA;EzDsJI,+BAAA;AfgptBJ;AwEtytBA;EzDmJI,oBAAA;AfsptBJ;AwEzytBA;EzDsJI,+BAAA;AfsptBJ;AwE5ytBA;EzDmJI,oBAAA;Af4ptBJ;AwE/ytBA;EzDsJI,+BAAA;Af4ptBJ;AwElztBA;EzDmJI,oBAAA;AfkqtBJ;AwErztBA;EzDsJI,+BAAA;AfkqtBJ;AwExztBA;EzDmJI,oBAAA;AfwqtBJ;AwE3ztBA;EzDsJI,+BAAA;AfwqtBJ;AwE9ztBA;EzDmJI,oBAAA;Af8qtBJ;AwEj0tBA;EzDsJI,+BAAA;Af8qtBJ;AwEp0tBA;EzDmJI,oBAAA;AfortBJ;AwEv0tBA;EzDsJI,+BAAA;AfortBJ;AwE10tBA;EzDmJI,oBAAA;Af0rtBJ;AwE70tBA;EzDsJI,+BAAA;Af0rtBJ;AwEh1tBA;EzDmJI,oBAAA;AfgstBJ;AwEn1tBA;EzDsJI,+BAAA;AfgstBJ;AwEt1tBA;EzDmJI,oBAAA;AfsstBJ;AwEz1tBA;EzDsJI,+BAAA;AfsstBJ;AwE51tBA;EzDmJI,oBAAA;Af4stBJ;AwE/1tBA;EzDsJI,+BAAA;Af4stBJ;AwEl2tBA;EzDmJI,oBAAA;AfkttBJ;AwEr2tBA;EzDsJI,+BAAA;AfkttBJ;AwEx2tBA;EzDmJI,oBAAA;AfwttBJ;AwE32tBA;EzDsJI,+BAAA;AfwttBJ;AwE92tBA;EzDmJI,oBAAA;Af8ttBJ;AwEj3tBA;EzDsJI,+BAAA;Af8ttBJ;AwEp3tBA;EzDmJI,oBAAA;AfoutBJ;AwEv3tBA;EzDsJI,+BAAA;AfoutBJ;AwE13tBA;EzDmJI,oBAAA;Af0utBJ;AwE73tBA;EzDsJI,+BAAA;Af0utBJ;AwEh4tBA;EzDmJI,oBAAA;AfgvtBJ;AwEn4tBA;EzDsJI,+BAAA;AfgvtBJ;AwEt4tBA;EzDmJI,oBAAA;AfsvtBJ;AwEz4tBA;EzDsJI,+BAAA;AfsvtBJ;AwE54tBA;EzDmJI,oBAAA;Af4vtBJ;AwE/4tBA;EzDsJI,+BAAA;Af4vtBJ;AwEl5tBA;EzDmJI,oBAAA;AfkwtBJ;AwEr5tBA;EzDsJI,+BAAA;AfkwtBJ;AwEx5tBA;EzDmJI,oBAAA;AfwwtBJ;AwE35tBA;EzDsJI,+BAAA;AfwwtBJ;AwE95tBA;EzDmJI,oBAAA;Af8wtBJ;AwEj6tBA;EzDsJI,+BAAA;Af8wtBJ;AwEp6tBA;EzDmJI,oBAAA;AfoxtBJ;AwEv6tBA;EzDsJI,+BAAA;AfoxtBJ;AwE16tBA;EzDmJI,oBAAA;Af0xtBJ;AwE76tBA;EzDsJI,+BAAA;Af0xtBJ;AwEh7tBA;EzDmJI,oBAAA;AfgytBJ;AwEn7tBA;EzDsJI,+BAAA;AfgytBJ;AwEt7tBA;EzDmJI,oBAAA;AfsytBJ;AwEz7tBA;EzDsJI,+BAAA;AfsytBJ;AwE57tBA;EzDmJI,oBAAA;Af4ytBJ;AwE/7tBA;EzDsJI,+BAAA;Af4ytBJ;AwEl8tBA;EzDmJI,oBAAA;AfkztBJ;AwEr8tBA;EzDsJI,+BAAA;AfkztBJ;AwEx8tBA;EzDmJI,oBAAA;AfwztBJ;AwE38tBA;EzDsJI,+BAAA;AfwztBJ;AwE98tBA;EzDmJI,oBAAA;Af8ztBJ;AwEj9tBA;EzDsJI,+BAAA;Af8ztBJ;AwEp9tBA;EzDmJI,oBAAA;Afo0tBJ;AwEv9tBA;EzDsJI,+BAAA;Afo0tBJ;AwE19tBA;EzDmJI,oBAAA;Af00tBJ;AwE79tBA;EzDsJI,+BAAA;Af00tBJ;AwEh+tBA;EzDmJI,oBAAA;Afg1tBJ;AwEn+tBA;EzDsJI,+BAAA;Afg1tBJ;AwEt+tBA;EzDmJI,oBAAA;Afs1tBJ;AwEz+tBA;EzDsJI,+BAAA;Afs1tBJ;AwE5+tBA;EzDmJI,oBAAA;Af41tBJ;AwE/+tBA;EzDsJI,+BAAA;Af41tBJ;AwEl/tBA;EzDmJI,oBAAA;Afk2tBJ;AwEr/tBA;EzDsJI,+BAAA;Afk2tBJ;AwEx/tBA;EzDmJI,oBAAA;Afw2tBJ;AwE3/tBA;EzDsJI,+BAAA;Afw2tBJ;AwE9/tBA;EzDmJI,oBAAA;Af82tBJ;AwEjguBA;EzDsJI,+BAAA;Af82tBJ;AwEpguBA;EzDmJI,oBAAA;Afo3tBJ;AwEvguBA;EzDsJI,+BAAA;Afo3tBJ;AwE1guBA;EzDmJI,oBAAA;Af03tBJ;AwE7guBA;EzDsJI,+BAAA;Af03tBJ;AwEhhuBA;EzDmJI,oBAAA;Afg4tBJ;AwEnhuBA;EzDsJI,+BAAA;Afg4tBJ;AwEthuBA;EzDmJI,oBAAA;Afs4tBJ;AwEzhuBA;EzDsJI,+BAAA;Afs4tBJ;AwE5huBA;EzDmJI,oBAAA;Af44tBJ;AwE/huBA;EzDsJI,+BAAA;Af44tBJ;AwEliuBA;EzDmJI,oBAAA;Afk5tBJ;AwEriuBA;EzDsJI,+BAAA;Afk5tBJ;AwExiuBA;EzDmJI,yBAAA;Afw5tBJ;AwE3iuBA;EzDsJI,oCAAA;Afw5tBJ;AwE9iuBA;EzDmJI,yBAAA;Af85tBJ;AwEjjuBA;EzDsJI,oCAAA;Af85tBJ;AwEpjuBA;EzDmJI,yBAAA;Afo6tBJ;AwEvjuBA;EzDsJI,oCAAA;Afo6tBJ;AwE1juBA;EzDmJI,yBAAA;Af06tBJ;AwE7juBA;EzDsJI,oCAAA;Af06tBJ;AwEhkuBA;EzDmJI,yBAAA;Afg7tBJ;AwEnkuBA;EzDsJI,oCAAA;Afg7tBJ;AwEtkuBA;EzDmJI,yBAAA;Afs7tBJ;AwEzkuBA;EzDsJI,oCAAA;Afs7tBJ;AwE5kuBA;EzDmJI,yBAAA;Af47tBJ;AwE/kuBA;EzDsJI,oCAAA;Af47tBJ;AwElluBA;EzDmJI,yBAAA;Afk8tBJ;AwErluBA;EzDsJI,oCAAA;Afk8tBJ;AwExluBA;EzDmJI,yBAAA;Afw8tBJ;AwE3luBA;EzDsJI,oCAAA;Afw8tBJ;AwE9luBA;EzDmJI,yBAAA;Af88tBJ;AwEjmuBA;EzDsJI,oCAAA;Af88tBJ;AwEpmuBA;EzDmJI,yBAAA;Afo9tBJ;AwEvmuBA;EzDsJI,oCAAA;Afo9tBJ;AwE1muBA;EzDmJI,yBAAA;Af09tBJ;AwE7muBA;EzDsJI,oCAAA;Af09tBJ;AwEhnuBA;EzDmJI,yBAAA;Afg+tBJ;AwEnnuBA;EzDsJI,oCAAA;Afg+tBJ;AwEtnuBA;EzDmJI,yBAAA;Afs+tBJ;AwEznuBA;EzDsJI,oCAAA;Afs+tBJ;AwE5nuBA;EzDmJI,yBAAA;Af4+tBJ;AwE/nuBA;EzDsJI,oCAAA;Af4+tBJ;AwElouBA;EzDmJI,yBAAA;Afk/tBJ;AwErouBA;EzDsJI,oCAAA;Afk/tBJ;AwExouBA;EzDmJI,yBAAA;Afw/tBJ;AwE3ouBA;EzDsJI,oCAAA;Afw/tBJ;AwE9ouBA;EzDmJI,yBAAA;Af8/tBJ;AwEjpuBA;EzDsJI,oCAAA;Af8/tBJ;AwEppuBA;EzDmJI,yBAAA;AfoguBJ;AwEvpuBA;EzDsJI,oCAAA;AfoguBJ;AwE1puBA;EzDmJI,yBAAA;Af0guBJ;AwE7puBA;EzDsJI,oCAAA;Af0guBJ;AwEhquBA;EzDmJI,yBAAA;AfghuBJ;AwEnquBA;EzDsJI,oCAAA;AfghuBJ;AwEtquBA;EzDmJI,yBAAA;AfshuBJ;AwEzquBA;EzDsJI,oCAAA;AfshuBJ;AwE5quBA;EzDmJI,yBAAA;Af4huBJ;AwE/quBA;EzDsJI,oCAAA;Af4huBJ;AwElruBA;EzDmJI,yBAAA;AfkiuBJ;AwErruBA;EzDsJI,oCAAA;AfkiuBJ;AwExruBA;EzDmJI,yBAAA;AfwiuBJ;AwE3ruBA;EzDsJI,oCAAA;AfwiuBJ;AwE9ruBA;EzDmJI,yBAAA;Af8iuBJ;AwEjsuBA;EzDsJI,oCAAA;Af8iuBJ;AwEpsuBA;EzDmJI,yBAAA;AfojuBJ;AwEvsuBA;EzDsJI,oCAAA;AfojuBJ;AwE1suBA;EzDmJI,yBAAA;Af0juBJ;AwE7suBA;EzDsJI,oCAAA;Af0juBJ;AwEhtuBA;EzDmJI,yBAAA;AfgkuBJ;AwEntuBA;EzDsJI,oCAAA;AfgkuBJ;AwEttuBA;EzDmJI,yBAAA;AfskuBJ;AwEztuBA;EzDsJI,oCAAA;AfskuBJ;AwE5tuBA;EzDmJI,6BAAA;Af4kuBJ;AwE/tuBA;EzDsJI,wCAAA;Af4kuBJ;AwEluuBA;EzDmJI,6BAAA;AfkluBJ;AwEruuBA;EzDsJI,wCAAA;AfkluBJ;AwExuuBA;EzDmJI,6BAAA;AfwluBJ;AwE3uuBA;EzDsJI,wCAAA;AfwluBJ;AwE9uuBA;EzDmJI,6BAAA;Af8luBJ;AwEjvuBA;EzDsJI,wCAAA;Af8luBJ;AwEpvuBA;EzDmJI,6BAAA;AfomuBJ;AwEvvuBA;EzDsJI,wCAAA;AfomuBJ;AwE1vuBA;EzDmJI,6BAAA;Af0muBJ;AwE7vuBA;EzDsJI,wCAAA;Af0muBJ;AwEhwuBA;EzDmJI,6BAAA;AfgnuBJ;AwEnwuBA;EzDsJI,wCAAA;AfgnuBJ;AwEtwuBA;EzDmJI,6BAAA;AfsnuBJ;AwEzwuBA;EzDsJI,wCAAA;AfsnuBJ;AwE5wuBA;EzDmJI,6BAAA;Af4nuBJ;AwE/wuBA;EzDsJI,wCAAA;Af4nuBJ;AwElxuBA;EzDmJI,6BAAA;AfkouBJ;AwErxuBA;EzDsJI,wCAAA;AfkouBJ;AwExxuBA;EzDmJI,6BAAA;AfwouBJ;AwE3xuBA;EzDsJI,wCAAA;AfwouBJ;AwE9xuBA;EzDmJI,6BAAA;Af8ouBJ;AwEjyuBA;EzDsJI,wCAAA;Af8ouBJ;AwEpyuBA;EzDmJI,6BAAA;AfopuBJ;AwEvyuBA;EzDsJI,wCAAA;AfopuBJ;AwE1yuBA;EzDmJI,6BAAA;Af0puBJ;AwE7yuBA;EzDsJI,wCAAA;Af0puBJ;AwEhzuBA;EzDmJI,6BAAA;AfgquBJ;AwEnzuBA;EzDsJI,wCAAA;AfgquBJ;AwEtzuBA;EzDmJI,6BAAA;AfsquBJ;AwEzzuBA;EzDsJI,wCAAA;AfsquBJ;AwE5zuBA;EzDmJI,6BAAA;Af4quBJ;AwE/zuBA;EzDsJI,wCAAA;Af4quBJ;AwEl0uBA;EzDmJI,6BAAA;AfkruBJ;AwEr0uBA;EzDsJI,wCAAA;AfkruBJ;AwEx0uBA;EzDmJI,6BAAA;AfwruBJ;AwE30uBA;EzDsJI,wCAAA;AfwruBJ;AwE90uBA;EzDmJI,6BAAA;Af8ruBJ;AwEj1uBA;EzDsJI,wCAAA;Af8ruBJ;AwEp1uBA;EzDmJI,+BAAA;AfosuBJ;AwEv1uBA;EzDsJI,0CAAA;AfosuBJ;AwE11uBA;EzDmJI,+BAAA;Af0suBJ;AwE71uBA;EzDsJI,0CAAA;Af0suBJ;AwEh2uBA;EzDmJI,+BAAA;AfgtuBJ;AwEn2uBA;EzDsJI,0CAAA;AfgtuBJ;AwEt2uBA;EzDmJI,+BAAA;AfstuBJ;AwEz2uBA;EzDsJI,0CAAA;AfstuBJ;AwE52uBA;EzDmJI,+BAAA;Af4tuBJ;AwE/2uBA;EzDsJI,0CAAA;Af4tuBJ;AwEl3uBA;EzDmJI,+BAAA;AfkuuBJ;AwEr3uBA;EzDsJI,0CAAA;AfkuuBJ;AwEx3uBA;EzDmJI,+BAAA;AfwuuBJ;AwE33uBA;EzDsJI,0CAAA;AfwuuBJ;AwE93uBA;EzDmJI,+BAAA;Af8uuBJ;AwEj4uBA;EzDsJI,0CAAA;Af8uuBJ;AwEp4uBA;EzDmJI,+BAAA;AfovuBJ;AwEv4uBA;EzDsJI,0CAAA;AfovuBJ;AwE14uBA;EzDmJI,+BAAA;Af0vuBJ;AwE74uBA;EzDsJI,0CAAA;Af0vuBJ;AwEh5uBA;EzDmJI,+BAAA;AfgwuBJ;AwEn5uBA;EzDsJI,0CAAA;AfgwuBJ;AwEt5uBA;EzDmJI,+BAAA;AfswuBJ;AwEz5uBA;EzDsJI,0CAAA;AfswuBJ;AwE55uBA;EzDmJI,+BAAA;Af4wuBJ;AwE/5uBA;EzDsJI,0CAAA;Af4wuBJ;AwEl6uBA;EzDmJI,+BAAA;AfkxuBJ;AwEr6uBA;EzDsJI,0CAAA;AfkxuBJ;AwEx6uBA;EzDmJI,+BAAA;AfwxuBJ;AwE36uBA;EzDsJI,0CAAA;AfwxuBJ;AwE96uBA;EzDmJI,+BAAA;Af8xuBJ;AwEj7uBA;EzDsJI,0CAAA;Af8xuBJ;AwEp7uBA;EzDmJI,+BAAA;AfoyuBJ;AwEv7uBA;EzDsJI,0CAAA;AfoyuBJ;AwE17uBA;EzDmJI,+BAAA;Af0yuBJ;AwE77uBA;EzDsJI,0CAAA;Af0yuBJ;AwEh8uBA;EzDmJI,+BAAA;AfgzuBJ;AwEn8uBA;EzDsJI,0CAAA;AfgzuBJ;AwEt8uBA;EzDmJI,+BAAA;AfszuBJ;AwEz8uBA;EzDsJI,0CAAA;AfszuBJ;AwE58uBA;EzDmJI,gCAAA;Af4zuBJ;AwE/8uBA;EzDsJI,2CAAA;Af4zuBJ;AwEl9uBA;EzDmJI,gCAAA;Afk0uBJ;AwEr9uBA;EzDsJI,2CAAA;Afk0uBJ;AwEx9uBA;EzDmJI,gCAAA;Afw0uBJ;AwE39uBA;EzDsJI,2CAAA;Afw0uBJ;AwE99uBA;EzDmJI,gCAAA;Af80uBJ;AwEj+uBA;EzDsJI,2CAAA;Af80uBJ;AwEp+uBA;EzDmJI,gCAAA;Afo1uBJ;AwEv+uBA;EzDsJI,2CAAA;Afo1uBJ;AwE1+uBA;EzDmJI,gCAAA;Af01uBJ;AwE7+uBA;EzDsJI,2CAAA;Af01uBJ;AwEh/uBA;EzDmJI,gCAAA;Afg2uBJ;AwEn/uBA;EzDsJI,2CAAA;Afg2uBJ;AwEt/uBA;EzDmJI,gCAAA;Afs2uBJ;AwEz/uBA;EzDsJI,2CAAA;Afs2uBJ;AwE5/uBA;EzDmJI,gCAAA;Af42uBJ;AwE//uBA;EzDsJI,2CAAA;Af42uBJ;AwElgvBA;EzDmJI,gCAAA;Afk3uBJ;AwErgvBA;EzDsJI,2CAAA;Afk3uBJ;AwExgvBA;EzDmJI,gCAAA;Afw3uBJ;AwE3gvBA;EzDsJI,2CAAA;Afw3uBJ;AwE9gvBA;EzDmJI,gCAAA;Af83uBJ;AwEjhvBA;EzDsJI,2CAAA;Af83uBJ;AwEphvBA;EzDmJI,gCAAA;Afo4uBJ;AwEvhvBA;EzDsJI,2CAAA;Afo4uBJ;AwE1hvBA;EzDmJI,gCAAA;Af04uBJ;AwE7hvBA;EzDsJI,2CAAA;Af04uBJ;AwEhivBA;EzDmJI,gCAAA;Afg5uBJ;AwEnivBA;EzDsJI,2CAAA;Afg5uBJ;AwEtivBA;EzDmJI,gCAAA;Afs5uBJ;AwEzivBA;EzDsJI,2CAAA;Afs5uBJ;AwE5ivBA;EzDmJI,gCAAA;Af45uBJ;AwE/ivBA;EzDsJI,2CAAA;Af45uBJ;AwEljvBA;EzDmJI,gCAAA;Afk6uBJ;AwErjvBA;EzDsJI,2CAAA;Afk6uBJ;AwExjvBA;EzDmJI,gCAAA;Afw6uBJ;AwE3jvBA;EzDsJI,2CAAA;Afw6uBJ;AwE9jvBA;EzDmJI,gCAAA;Af86uBJ;AwEjkvBA;EzDsJI,2CAAA;Af86uBJ;AwEpkvBA;EzDmJI,8BAAA;Afo7uBJ;AwEvkvBA;EzDsJI,yCAAA;Afo7uBJ;AwE1kvBA;EzDmJI,8BAAA;Af07uBJ;AwE7kvBA;EzDsJI,yCAAA;Af07uBJ;AwEhlvBA;EzDmJI,8BAAA;Afg8uBJ;AwEnlvBA;EzDsJI,yCAAA;Afg8uBJ;AwEtlvBA;EzDmJI,8BAAA;Afs8uBJ;AwEzlvBA;EzDsJI,yCAAA;Afs8uBJ;AwE5lvBA;EzDmJI,8BAAA;Af48uBJ;AwE/lvBA;EzDsJI,yCAAA;Af48uBJ;AwElmvBA;EzDmJI,8BAAA;Afk9uBJ;AwErmvBA;EzDsJI,yCAAA;Afk9uBJ;AwExmvBA;EzDmJI,8BAAA;Afw9uBJ;AwE3mvBA;EzDsJI,yCAAA;Afw9uBJ;AwE9mvBA;EzDmJI,8BAAA;Af89uBJ;AwEjnvBA;EzDsJI,yCAAA;Af89uBJ;AwEpnvBA;EzDmJI,8BAAA;Afo+uBJ;AwEvnvBA;EzDsJI,yCAAA;Afo+uBJ;AwE1nvBA;EzDmJI,8BAAA;Af0+uBJ;AwE7nvBA;EzDsJI,yCAAA;Af0+uBJ;AwEhovBA;EzDmJI,8BAAA;Afg/uBJ;AwEnovBA;EzDsJI,yCAAA;Afg/uBJ;AwEtovBA;EzDmJI,8BAAA;Afs/uBJ;AwEzovBA;EzDsJI,yCAAA;Afs/uBJ;AwE5ovBA;EzDmJI,8BAAA;Af4/uBJ;AwE/ovBA;EzDsJI,yCAAA;Af4/uBJ;AwElpvBA;EzDmJI,8BAAA;AfkgvBJ;AwErpvBA;EzDsJI,yCAAA;AfkgvBJ;AwExpvBA;EzDmJI,8BAAA;AfwgvBJ;AwE3pvBA;EzDsJI,yCAAA;AfwgvBJ;AwE9pvBA;EzDmJI,8BAAA;Af8gvBJ;AwEjqvBA;EzDsJI,yCAAA;Af8gvBJ;AwEpqvBA;EzDmJI,8BAAA;AfohvBJ;AwEvqvBA;EzDsJI,yCAAA;AfohvBJ;AwE1qvBA;EzDmJI,8BAAA;Af0hvBJ;AwE7qvBA;EzDsJI,yCAAA;Af0hvBJ;AwEhrvBA;EzDmJI,8BAAA;AfgivBJ;AwEnrvBA;EzDsJI,yCAAA;AfgivBJ;AwEtrvBA;EzDmJI,8BAAA;AfsivBJ;AwEzrvBA;EzDsJI,yCAAA;AfsivBJ;AwE5rvBA;EzDmJI,sBAAA;Af4ivBJ;AwE/rvBA;EzDsJI,iCAAA;Af4ivBJ;AwElsvBA;EzDmJI,sBAAA;AfkjvBJ;AwErsvBA;EzDsJI,iCAAA;AfkjvBJ;AwExsvBA;EzDmJI,sBAAA;AfwjvBJ;AwE3svBA;EzDsJI,iCAAA;AfwjvBJ;AwE9svBA;EzDmJI,sBAAA;Af8jvBJ;AwEjtvBA;EzDsJI,iCAAA;Af8jvBJ;AwEptvBA;EzDmJI,sBAAA;AfokvBJ;AwEvtvBA;EzDsJI,iCAAA;AfokvBJ;AwE1tvBA;EzDmJI,sBAAA;Af0kvBJ;AwE7tvBA;EzDsJI,iCAAA;Af0kvBJ;AwEhuvBA;EzDmJI,sBAAA;AfglvBJ;AwEnuvBA;EzDsJI,iCAAA;AfglvBJ;AwEtuvBA;EzDmJI,sBAAA;AfslvBJ;AwEzuvBA;EzDsJI,iCAAA;AfslvBJ;AwE5uvBA;EzDmJI,sBAAA;Af4lvBJ;AwE/uvBA;EzDsJI,iCAAA;Af4lvBJ;AwElvvBA;EzDmJI,sBAAA;AfkmvBJ;AwErvvBA;EzDsJI,iCAAA;AfkmvBJ;AwExvvBA;EzDmJI,sBAAA;AfwmvBJ;AwE3vvBA;EzDsJI,iCAAA;AfwmvBJ;AwE9vvBA;EzDmJI,sBAAA;Af8mvBJ;AwEjwvBA;EzDsJI,iCAAA;Af8mvBJ;AwEpwvBA;EzDmJI,sBAAA;AfonvBJ;AwEvwvBA;EzDsJI,iCAAA;AfonvBJ;AwE1wvBA;EzDmJI,sBAAA;Af0nvBJ;AwE7wvBA;EzDsJI,iCAAA;Af0nvBJ;AwEhxvBA;EzDmJI,sBAAA;AfgovBJ;AwEnxvBA;EzDsJI,iCAAA;AfgovBJ;AwEtxvBA;EzDmJI,sBAAA;AfsovBJ;AwEzxvBA;EzDsJI,iCAAA;AfsovBJ;AwE5xvBA;EzDmJI,sBAAA;Af4ovBJ;AwE/xvBA;EzDsJI,iCAAA;Af4ovBJ;AwElyvBA;EzDmJI,sBAAA;AfkpvBJ;AwEryvBA;EzDsJI,iCAAA;AfkpvBJ;AwExyvBA;EzDmJI,sBAAA;AfwpvBJ;AwE3yvBA;EzDsJI,iCAAA;AfwpvBJ;AwE9yvBA;EzDmJI,sBAAA;Af8pvBJ;AwEjzvBA;EzDsJI,iCAAA;Af8pvBJ;AwEpzvBA;EzDmJI,eAAA;AfoqvBJ;AwEvzvBA;EzDsJI,0BAAA;AfoqvBJ;AwE1zvBA;EzDmJI,eAAA;Af0qvBJ;AwE7zvBA;EzDsJI,0BAAA;Af0qvBJ;AwEh0vBA;EzDmJI,eAAA;AfgrvBJ;AwEn0vBA;EzDsJI,0BAAA;AfgrvBJ;AwEt0vBA;EzDmJI,eAAA;AfsrvBJ;AwEz0vBA;EzDsJI,0BAAA;AfsrvBJ;AwE50vBA;EzDmJI,eAAA;Af4rvBJ;AwE/0vBA;EzDsJI,0BAAA;Af4rvBJ;AwEl1vBA;EzDmJI,eAAA;AfksvBJ;AwEr1vBA;EzDsJI,0BAAA;AfksvBJ;AwEx1vBA;EzDmJI,eAAA;AfwsvBJ;AwE31vBA;EzDsJI,0BAAA;AfwsvBJ;AwE91vBA;EzDmJI,eAAA;Af8svBJ;AwEj2vBA;EzDsJI,0BAAA;Af8svBJ;AwEp2vBA;EzDmJI,eAAA;AfotvBJ;AwEv2vBA;EzDsJI,0BAAA;AfotvBJ;AwE12vBA;EzDmJI,eAAA;Af0tvBJ;AwE72vBA;EzDsJI,0BAAA;Af0tvBJ;AwEh3vBA;EzDmJI,eAAA;AfguvBJ;AwEn3vBA;EzDsJI,0BAAA;AfguvBJ;AwEt3vBA;EzDmJI,eAAA;AfsuvBJ;AwEz3vBA;EzDsJI,0BAAA;AfsuvBJ;AwE53vBA;EzDmJI,eAAA;Af4uvBJ;AwE/3vBA;EzDsJI,0BAAA;Af4uvBJ;AwEl4vBA;EzDmJI,eAAA;AfkvvBJ;AwEr4vBA;EzDsJI,0BAAA;AfkvvBJ;AwEx4vBA;EzDmJI,eAAA;AfwvvBJ;AwE34vBA;EzDsJI,0BAAA;AfwvvBJ;AwE94vBA;EzDmJI,eAAA;Af8vvBJ;AwEj5vBA;EzDsJI,0BAAA;Af8vvBJ;AwEp5vBA;EzDmJI,eAAA;AfowvBJ;AwEv5vBA;EzDsJI,0BAAA;AfowvBJ;AwE15vBA;EzDmJI,eAAA;Af0wvBJ;AwE75vBA;EzDsJI,0BAAA;Af0wvBJ;AwEh6vBA;EzDmJI,eAAA;AfgxvBJ;AwEn6vBA;EzDsJI,0BAAA;AfgxvBJ;AwEt6vBA;EzDmJI,eAAA;AfsxvBJ;AwEz6vBA;EzDsJI,0BAAA;AfsxvBJ;AwE56vBA;EzDmJI,eAAA;Af4xvBJ;AwE/6vBA;EzDsJI,0BAAA;Af4xvBJ;AwEl7vBA;EzDmJI,eAAA;AfkyvBJ;AwEr7vBA;EzDsJI,0BAAA;AfkyvBJ;AwEx7vBA;EzDmJI,eAAA;AfwyvBJ;AwE37vBA;EzDsJI,0BAAA;AfwyvBJ;AwE97vBA;EzDmJI,eAAA;Af8yvBJ;AwEj8vBA;EzDsJI,0BAAA;Af8yvBJ;AwEp8vBA;EzDmJI,eAAA;AfozvBJ;AwEv8vBA;EzDsJI,0BAAA;AfozvBJ;AwE18vBA;EzDmJI,eAAA;Af0zvBJ;AwE78vBA;EzDsJI,0BAAA;Af0zvBJ;AwEh9vBA;EzDmJI,eAAA;Afg0vBJ;AwEn9vBA;EzDsJI,0BAAA;Afg0vBJ;AwEt9vBA;EzDmJI,eAAA;Afs0vBJ;AwEz9vBA;EzDsJI,0BAAA;Afs0vBJ;AwE59vBA;EzDmJI,eAAA;Af40vBJ;AwE/9vBA;EzDsJI,0BAAA;Af40vBJ;AwEl+vBA;EzDmJI,eAAA;Afk1vBJ;AwEr+vBA;EzDsJI,0BAAA;Afk1vBJ;AwEx+vBA;EzDmJI,eAAA;Afw1vBJ;AwE3+vBA;EzDsJI,0BAAA;Afw1vBJ;AwE9+vBA;EzDmJI,eAAA;Af81vBJ;AwEj/vBA;EzDsJI,0BAAA;Af81vBJ;AwEp/vBA;EzDmJI,eAAA;Afo2vBJ;AwEv/vBA;EzDsJI,0BAAA;Afo2vBJ;AwE1/vBA;EzDmJI,eAAA;Af02vBJ;AwE7/vBA;EzDsJI,0BAAA;Af02vBJ;AwEhgwBA;EzDmJI,eAAA;Afg3vBJ;AwEngwBA;EzDsJI,0BAAA;Afg3vBJ;AwEtgwBA;EzDmJI,eAAA;Afs3vBJ;AwEzgwBA;EzDsJI,0BAAA;Afs3vBJ;AwE5gwBA;EzDmJI,eAAA;Af43vBJ;AwE/gwBA;EzDsJI,0BAAA;Af43vBJ;AwElhwBA;EzDmJI,eAAA;Afk4vBJ;AwErhwBA;EzDsJI,0BAAA;Afk4vBJ;AwExhwBA;EzDmJI,eAAA;Afw4vBJ;AwE3hwBA;EzDsJI,0BAAA;Afw4vBJ;AwE9hwBA;EzDmJI,eAAA;Af84vBJ;AwEjiwBA;EzDsJI,0BAAA;Af84vBJ;AwEpiwBA;EzDmJI,eAAA;Afo5vBJ;AwEviwBA;EzDsJI,0BAAA;Afo5vBJ;AwE1iwBA;EzDmJI,eAAA;Af05vBJ;AwE7iwBA;EzDsJI,0BAAA;Af05vBJ;AwEhjwBA;EzDmJI,eAAA;Afg6vBJ;AwEnjwBA;EzDsJI,0BAAA;Afg6vBJ;AwEtjwBA;EzDmJI,eAAA;Afs6vBJ;AwEzjwBA;EzDsJI,0BAAA;Afs6vBJ;AwE5jwBA;EzDmJI,eAAA;Af46vBJ;AwE/jwBA;EzDsJI,0BAAA;Af46vBJ;AwElkwBA;EzDmJI,eAAA;Afk7vBJ;AwErkwBA;EzDsJI,0BAAA;Afk7vBJ;AwExkwBA;EzDmJI,eAAA;Afw7vBJ;AwE3kwBA;EzDsJI,0BAAA;Afw7vBJ;AwE9kwBA;EzDmJI,eAAA;Af87vBJ;AwEjlwBA;EzDsJI,0BAAA;Af87vBJ;AwEplwBA;EzDmJI,eAAA;Afo8vBJ;AwEvlwBA;EzDsJI,0BAAA;Afo8vBJ;AwE1lwBA;EzDmJI,eAAA;Af08vBJ;AwE7lwBA;EzDsJI,0BAAA;Af08vBJ;AwEhmwBA;EzDmJI,eAAA;Afg9vBJ;AwEnmwBA;EzDsJI,0BAAA;Afg9vBJ;AwEtmwBA;EzDmJI,eAAA;Afs9vBJ;AwEzmwBA;EzDsJI,0BAAA;Afs9vBJ;AwE5mwBA;EzDmJI,eAAA;Af49vBJ;AwE/mwBA;EzDsJI,0BAAA;Af49vBJ;AwElnwBA;EzDmJI,eAAA;Afk+vBJ;AwErnwBA;EzDsJI,0BAAA;Afk+vBJ;AwExnwBA;EzDmJI,eAAA;Afw+vBJ;AwE3nwBA;EzDsJI,0BAAA;Afw+vBJ;AwE9nwBA;EzDmJI,eAAA;Af8+vBJ;AwEjowBA;EzDsJI,0BAAA;Af8+vBJ;AwEpowBA;EzDmJI,eAAA;Afo/vBJ;AwEvowBA;EzDsJI,0BAAA;Afo/vBJ;AwE1owBA;EzDmJI,eAAA;Af0/vBJ;AwE7owBA;EzDsJI,0BAAA;Af0/vBJ;AwEhpwBA;EzDmJI,eAAA;AfggwBJ;AwEnpwBA;EzDsJI,0BAAA;AfggwBJ;AwEtpwBA;EzDmJI,eAAA;AfsgwBJ;AwEzpwBA;EzDsJI,0BAAA;AfsgwBJ;AwE5pwBA;EzDmJI,eAAA;Af4gwBJ;AwE/pwBA;EzDsJI,0BAAA;Af4gwBJ;AwElqwBA;EzDmJI,eAAA;AfkhwBJ;AwErqwBA;EzDsJI,0BAAA;AfkhwBJ;AwExqwBA;EzDmJI,eAAA;AfwhwBJ;AwE3qwBA;EzDsJI,0BAAA;AfwhwBJ;AwE9qwBA;EzDmJI,eAAA;Af8hwBJ;AwEjrwBA;EzDsJI,0BAAA;Af8hwBJ;AwEprwBA;EzDmJI,eAAA;AfoiwBJ;AwEvrwBA;EzDsJI,0BAAA;AfoiwBJ;AwE1rwBA;EzDmJI,eAAA;Af0iwBJ;AwE7rwBA;EzDsJI,0BAAA;Af0iwBJ;AwEhswBA;EzDmJI,eAAA;AfgjwBJ;AwEnswBA;EzDsJI,0BAAA;AfgjwBJ;AwEtswBA;EzDmJI,eAAA;AfsjwBJ;AwEzswBA;EzDsJI,0BAAA;AfsjwBJ;AwE5swBA;EzDmJI,eAAA;Af4jwBJ;AwE/swBA;EzDsJI,0BAAA;Af4jwBJ;AwEltwBA;EzDmJI,eAAA;AfkkwBJ;AwErtwBA;EzDsJI,0BAAA;AfkkwBJ;AwExtwBA;EzDmJI,eAAA;AfwkwBJ;AwE3twBA;EzDsJI,0BAAA;AfwkwBJ;AwE9twBA;EzDmJI,eAAA;Af8kwBJ;AwEjuwBA;EzDsJI,0BAAA;Af8kwBJ;AwEpuwBA;EzDmJI,eAAA;AfolwBJ;AwEvuwBA;EzDsJI,0BAAA;AfolwBJ;AwE1uwBA;EzDmJI,eAAA;Af0lwBJ;AwE7uwBA;EzDsJI,0BAAA;Af0lwBJ;AwEhvwBA;EzDmJI,eAAA;AfgmwBJ;AwEnvwBA;EzDsJI,0BAAA;AfgmwBJ;AwEtvwBA;EzDmJI,eAAA;AfsmwBJ;AwEzvwBA;EzDsJI,0BAAA;AfsmwBJ;AwE5vwBA;EzDmJI,eAAA;Af4mwBJ;AwE/vwBA;EzDsJI,0BAAA;Af4mwBJ;AwElwwBA;EzDmJI,eAAA;AfknwBJ;AwErwwBA;EzDsJI,0BAAA;AfknwBJ;AwExwwBA;EzDmJI,eAAA;AfwnwBJ;AwE3wwBA;EzDsJI,0BAAA;AfwnwBJ;AwE9wwBA;EzDmJI,eAAA;Af8nwBJ;AwEjxwBA;EzDsJI,0BAAA;Af8nwBJ;AwEpxwBA;EzDmJI,eAAA;AfoowBJ;AwEvxwBA;EzDsJI,0BAAA;AfoowBJ;AwE1xwBA;EzDmJI,eAAA;Af0owBJ;AwE7xwBA;EzDsJI,0BAAA;Af0owBJ;AwEhywBA;EzDmJI,eAAA;AfgpwBJ;AwEnywBA;EzDsJI,0BAAA;AfgpwBJ;AwEtywBA;EzDmJI,eAAA;AfspwBJ;AwEzywBA;EzDsJI,0BAAA;AfspwBJ;AwE5ywBA;EzDmJI,eAAA;Af4pwBJ;AwE/ywBA;EzDsJI,0BAAA;Af4pwBJ;AwElzwBA;EzDmJI,eAAA;AfkqwBJ;AwErzwBA;EzDsJI,0BAAA;AfkqwBJ;AwExzwBA;EzDmJI,eAAA;AfwqwBJ;AwE3zwBA;EzDsJI,0BAAA;AfwqwBJ;AwE9zwBA;EzDmJI,eAAA;Af8qwBJ;AwEj0wBA;EzDsJI,0BAAA;Af8qwBJ;AwEp0wBA;EzDmJI,eAAA;AforwBJ;AwEv0wBA;EzDsJI,0BAAA;AforwBJ;AwE10wBA;EzDmJI,eAAA;Af0rwBJ;AwE70wBA;EzDsJI,0BAAA;Af0rwBJ;AwEh1wBA;EzDmJI,eAAA;AfgswBJ;AwEn1wBA;EzDsJI,0BAAA;AfgswBJ;AwEt1wBA;EzDmJI,eAAA;AfsswBJ;AwEz1wBA;EzDsJI,0BAAA;AfsswBJ;AwE51wBA;EzDmJI,eAAA;Af4swBJ;AwE/1wBA;EzDsJI,0BAAA;Af4swBJ;AwEl2wBA;EzDmJI,eAAA;AfktwBJ;AwEr2wBA;EzDsJI,0BAAA;AfktwBJ;AwEx2wBA;EzDmJI,eAAA;AfwtwBJ;AwE32wBA;EzDsJI,0BAAA;AfwtwBJ;AwE92wBA;EzDmJI,eAAA;Af8twBJ;AwEj3wBA;EzDsJI,0BAAA;Af8twBJ;AwEp3wBA;EzDmJI,eAAA;AfouwBJ;AwEv3wBA;EzDsJI,0BAAA;AfouwBJ;AwE13wBA;EzDmJI,eAAA;Af0uwBJ;AwE73wBA;EzDsJI,0BAAA;Af0uwBJ;AwEh4wBA;EzDmJI,eAAA;AfgvwBJ;AwEn4wBA;EzDsJI,0BAAA;AfgvwBJ;AwEt4wBA;EzDmJI,eAAA;AfsvwBJ;AwEz4wBA;EzDsJI,0BAAA;AfsvwBJ;AwE54wBA;EzDmJI,oBAAA;Af4vwBJ;AwE/4wBA;EzDsJI,+BAAA;Af4vwBJ;AwEl5wBA;EzDmJI,oBAAA;AfkwwBJ;AwEr5wBA;EzDsJI,+BAAA;AfkwwBJ;AwEx5wBA;EzDmJI,oBAAA;AfwwwBJ;AwE35wBA;EzDsJI,+BAAA;AfwwwBJ;AwE95wBA;EzDmJI,oBAAA;Af8wwBJ;AwEj6wBA;EzDsJI,+BAAA;Af8wwBJ;AwEp6wBA;EzDmJI,oBAAA;AfoxwBJ;AwEv6wBA;EzDsJI,+BAAA;AfoxwBJ;AwE16wBA;EzDmJI,oBAAA;Af0xwBJ;AwE76wBA;EzDsJI,+BAAA;Af0xwBJ;AwEh7wBA;EzDmJI,oBAAA;AfgywBJ;AwEn7wBA;EzDsJI,+BAAA;AfgywBJ;AwEt7wBA;EzDmJI,oBAAA;AfsywBJ;AwEz7wBA;EzDsJI,+BAAA;AfsywBJ;AwE57wBA;EzDmJI,oBAAA;Af4ywBJ;AwE/7wBA;EzDsJI,+BAAA;Af4ywBJ;AwEl8wBA;EzDmJI,oBAAA;AfkzwBJ;AwEr8wBA;EzDsJI,+BAAA;AfkzwBJ;AwEx8wBA;EzDmJI,oBAAA;AfwzwBJ;AwE38wBA;EzDsJI,+BAAA;AfwzwBJ;AwE98wBA;EzDmJI,oBAAA;Af8zwBJ;AwEj9wBA;EzDsJI,+BAAA;Af8zwBJ;AwEp9wBA;EzDmJI,oBAAA;Afo0wBJ;AwEv9wBA;EzDsJI,+BAAA;Afo0wBJ;AwE19wBA;EzDmJI,oBAAA;Af00wBJ;AwE79wBA;EzDsJI,+BAAA;Af00wBJ;AwEh+wBA;EzDmJI,oBAAA;Afg1wBJ;AwEn+wBA;EzDsJI,+BAAA;Afg1wBJ;AwEt+wBA;EzDmJI,oBAAA;Afs1wBJ;AwEz+wBA;EzDsJI,+BAAA;Afs1wBJ;AwE5+wBA;EzDmJI,oBAAA;Af41wBJ;AwE/+wBA;EzDsJI,+BAAA;Af41wBJ;AwEl/wBA;EzDmJI,oBAAA;Afk2wBJ;AwEr/wBA;EzDsJI,+BAAA;Afk2wBJ;AwEx/wBA;EzDmJI,oBAAA;Afw2wBJ;AwE3/wBA;EzDsJI,+BAAA;Afw2wBJ;AwE9/wBA;EzDmJI,oBAAA;Af82wBJ;AwEjgxBA;EzDsJI,+BAAA;Af82wBJ;AwEpgxBA;EzDmJI,oBAAA;Afo3wBJ;AwEvgxBA;EzDsJI,+BAAA;Afo3wBJ;AwE1gxBA;EzDmJI,oBAAA;Af03wBJ;AwE7gxBA;EzDsJI,+BAAA;Af03wBJ;AwEhhxBA;EzDmJI,oBAAA;Afg4wBJ;AwEnhxBA;EzDsJI,+BAAA;Afg4wBJ;AwEthxBA;EzDmJI,oBAAA;Afs4wBJ;AwEzhxBA;EzDsJI,+BAAA;Afs4wBJ;AwE5hxBA;EzDmJI,oBAAA;Af44wBJ;AwE/hxBA;EzDsJI,+BAAA;Af44wBJ;AwElixBA;EzDmJI,oBAAA;Afk5wBJ;AwErixBA;EzDsJI,+BAAA;Afk5wBJ;AwExixBA;EzDmJI,oBAAA;Afw5wBJ;AwE3ixBA;EzDsJI,+BAAA;Afw5wBJ;AwE9ixBA;EzDmJI,oBAAA;Af85wBJ;AwEjjxBA;EzDsJI,+BAAA;Af85wBJ;AwEpjxBA;EzDmJI,oBAAA;Afo6wBJ;AwEvjxBA;EzDsJI,+BAAA;Afo6wBJ;AwE1jxBA;EzDmJI,oBAAA;Af06wBJ;AwE7jxBA;EzDsJI,+BAAA;Af06wBJ;AwEhkxBA;EzDmJI,oBAAA;Afg7wBJ;AwEnkxBA;EzDsJI,+BAAA;Afg7wBJ;AwEtkxBA;EzDmJI,oBAAA;Afs7wBJ;AwEzkxBA;EzDsJI,+BAAA;Afs7wBJ;AwE5kxBA;EzDmJI,oBAAA;Af47wBJ;AwE/kxBA;EzDsJI,+BAAA;Af47wBJ;AwEllxBA;EzDmJI,oBAAA;Afk8wBJ;AwErlxBA;EzDsJI,+BAAA;Afk8wBJ;AwExlxBA;EzDmJI,oBAAA;Afw8wBJ;AwE3lxBA;EzDsJI,+BAAA;Afw8wBJ;AwE9lxBA;EzDmJI,oBAAA;Af88wBJ;AwEjmxBA;EzDsJI,+BAAA;Af88wBJ;AwEpmxBA;EzDmJI,oBAAA;Afo9wBJ;AwEvmxBA;EzDsJI,+BAAA;Afo9wBJ;AwE1mxBA;EzDmJI,oBAAA;Af09wBJ;AwE7mxBA;EzDsJI,+BAAA;Af09wBJ;AwEhnxBA;EzDmJI,oBAAA;Afg+wBJ;AwEnnxBA;EzDsJI,+BAAA;Afg+wBJ;AwEtnxBA;EzDmJI,oBAAA;Afs+wBJ;AwEznxBA;EzDsJI,+BAAA;Afs+wBJ;AwE5nxBA;EzDmJI,oBAAA;Af4+wBJ;AwE/nxBA;EzDsJI,+BAAA;Af4+wBJ;AwEloxBA;EzDmJI,oBAAA;Afk/wBJ;AwEroxBA;EzDsJI,+BAAA;Afk/wBJ;AwExoxBA;EzDmJI,oBAAA;Afw/wBJ;AwE3oxBA;EzDsJI,+BAAA;Afw/wBJ;AwE9oxBA;EzDmJI,oBAAA;Af8/wBJ;AwEjpxBA;EzDsJI,+BAAA;Af8/wBJ;AwEppxBA;EzDmJI,oBAAA;AfogxBJ;AwEvpxBA;EzDsJI,+BAAA;AfogxBJ;AwE1pxBA;EzDmJI,oBAAA;Af0gxBJ;AwE7pxBA;EzDsJI,+BAAA;Af0gxBJ;AwEhqxBA;EzDmJI,oBAAA;AfghxBJ;AwEnqxBA;EzDsJI,+BAAA;AfghxBJ;AwEtqxBA;EzDmJI,oBAAA;AfshxBJ;AwEzqxBA;EzDsJI,+BAAA;AfshxBJ;AwE5qxBA;EzDmJI,oBAAA;Af4hxBJ;AwE/qxBA;EzDsJI,+BAAA;Af4hxBJ;AwElrxBA;EzDmJI,oBAAA;AfkixBJ;AwErrxBA;EzDsJI,+BAAA;AfkixBJ;AwExrxBA;EzDmJI,oBAAA;AfwixBJ;AwE3rxBA;EzDsJI,+BAAA;AfwixBJ;AwE9rxBA;EzDmJI,oBAAA;Af8ixBJ;AwEjsxBA;EzDsJI,+BAAA;Af8ixBJ;AwEpsxBA;EzDmJI,oBAAA;AfojxBJ;AwEvsxBA;EzDsJI,+BAAA;AfojxBJ;AwE1sxBA;EzDmJI,oBAAA;Af0jxBJ;AwE7sxBA;EzDsJI,+BAAA;Af0jxBJ;AwEhtxBA;EzDmJI,oBAAA;AfgkxBJ;AwEntxBA;EzDsJI,+BAAA;AfgkxBJ;AwEttxBA;EzDmJI,oBAAA;AfskxBJ;AwEztxBA;EzDsJI,+BAAA;AfskxBJ;AwE5txBA;EzDmJI,oBAAA;Af4kxBJ;AwE/txBA;EzDsJI,+BAAA;Af4kxBJ;AwEluxBA;EzDmJI,oBAAA;AfklxBJ;AwEruxBA;EzDsJI,+BAAA;AfklxBJ;AwExuxBA;EzDmJI,oBAAA;AfwlxBJ;AwE3uxBA;EzDsJI,+BAAA;AfwlxBJ;AwE9uxBA;EzDmJI,oBAAA;Af8lxBJ;AwEjvxBA;EzDsJI,+BAAA;Af8lxBJ;AwEpvxBA;EzDmJI,oBAAA;AfomxBJ;AwEvvxBA;EzDsJI,+BAAA;AfomxBJ;AwE1vxBA;EzDmJI,oBAAA;Af0mxBJ;AwE7vxBA;EzDsJI,+BAAA;Af0mxBJ;AwEhwxBA;EzDmJI,oBAAA;AfgnxBJ;AwEnwxBA;EzDsJI,+BAAA;AfgnxBJ;AwEtwxBA;EzDmJI,oBAAA;AfsnxBJ;AwEzwxBA;EzDsJI,+BAAA;AfsnxBJ;AwE5wxBA;EzDmJI,oBAAA;Af4nxBJ;AwE/wxBA;EzDsJI,+BAAA;Af4nxBJ;AwElxxBA;EzDmJI,oBAAA;AfkoxBJ;AwErxxBA;EzDsJI,+BAAA;AfkoxBJ;AwExxxBA;EzDmJI,oBAAA;AfwoxBJ;AwE3xxBA;EzDsJI,+BAAA;AfwoxBJ;AwE9xxBA;EzDmJI,oBAAA;Af8oxBJ;AwEjyxBA;EzDsJI,+BAAA;Af8oxBJ;AwEpyxBA;EzDmJI,oBAAA;AfopxBJ;AwEvyxBA;EzDsJI,+BAAA;AfopxBJ;AwE1yxBA;EzDmJI,oBAAA;Af0pxBJ;AwE7yxBA;EzDsJI,+BAAA;Af0pxBJ;AwEhzxBA;EzDmJI,yBAAA;AfgqxBJ;AwEnzxBA;EzDsJI,oCAAA;AfgqxBJ;AwEtzxBA;EzDmJI,yBAAA;AfsqxBJ;AwEzzxBA;EzDsJI,oCAAA;AfsqxBJ;AwE5zxBA;EzDmJI,yBAAA;Af4qxBJ;AwE/zxBA;EzDsJI,oCAAA;Af4qxBJ;AwEl0xBA;EzDmJI,yBAAA;AfkrxBJ;AwEr0xBA;EzDsJI,oCAAA;AfkrxBJ;AwEx0xBA;EzDmJI,yBAAA;AfwrxBJ;AwE30xBA;EzDsJI,oCAAA;AfwrxBJ;AwE90xBA;EzDmJI,yBAAA;Af8rxBJ;AwEj1xBA;EzDsJI,oCAAA;Af8rxBJ;AwEp1xBA;EzDmJI,yBAAA;AfosxBJ;AwEv1xBA;EzDsJI,oCAAA;AfosxBJ;AwE11xBA;EzDmJI,yBAAA;Af0sxBJ;AwE71xBA;EzDsJI,oCAAA;Af0sxBJ;AwEh2xBA;EzDmJI,yBAAA;AfgtxBJ;AwEn2xBA;EzDsJI,oCAAA;AfgtxBJ;AwEt2xBA;EzDmJI,yBAAA;AfstxBJ;AwEz2xBA;EzDsJI,oCAAA;AfstxBJ;AwE52xBA;EzDmJI,yBAAA;Af4txBJ;AwE/2xBA;EzDsJI,oCAAA;Af4txBJ;AwEl3xBA;EzDmJI,yBAAA;AfkuxBJ;AwEr3xBA;EzDsJI,oCAAA;AfkuxBJ;AwEx3xBA;EzDmJI,yBAAA;AfwuxBJ;AwE33xBA;EzDsJI,oCAAA;AfwuxBJ;AwE93xBA;EzDmJI,yBAAA;Af8uxBJ;AwEj4xBA;EzDsJI,oCAAA;Af8uxBJ;AwEp4xBA;EzDmJI,yBAAA;AfovxBJ;AwEv4xBA;EzDsJI,oCAAA;AfovxBJ;AwE14xBA;EzDmJI,yBAAA;Af0vxBJ;AwE74xBA;EzDsJI,oCAAA;Af0vxBJ;AwEh5xBA;EzDmJI,yBAAA;AfgwxBJ;AwEn5xBA;EzDsJI,oCAAA;AfgwxBJ;AwEt5xBA;EzDmJI,yBAAA;AfswxBJ;AwEz5xBA;EzDsJI,oCAAA;AfswxBJ;AwE55xBA;EzDmJI,yBAAA;Af4wxBJ;AwE/5xBA;EzDsJI,oCAAA;Af4wxBJ;AwEl6xBA;EzDmJI,yBAAA;AfkxxBJ;AwEr6xBA;EzDsJI,oCAAA;AfkxxBJ;AwEx6xBA;EzDmJI,yBAAA;AfwxxBJ;AwE36xBA;EzDsJI,oCAAA;AfwxxBJ;AwE96xBA;EzDmJI,yBAAA;Af8xxBJ;AwEj7xBA;EzDsJI,oCAAA;Af8xxBJ;AwEp7xBA;EzDmJI,yBAAA;AfoyxBJ;AwEv7xBA;EzDsJI,oCAAA;AfoyxBJ;AwE17xBA;EzDmJI,yBAAA;Af0yxBJ;AwE77xBA;EzDsJI,oCAAA;Af0yxBJ;AwEh8xBA;EzDmJI,yBAAA;AfgzxBJ;AwEn8xBA;EzDsJI,oCAAA;AfgzxBJ;AwEt8xBA;EzDmJI,yBAAA;AfszxBJ;AwEz8xBA;EzDsJI,oCAAA;AfszxBJ;AwE58xBA;EzDmJI,yBAAA;Af4zxBJ;AwE/8xBA;EzDsJI,oCAAA;Af4zxBJ;AwEl9xBA;EzDmJI,yBAAA;Afk0xBJ;AwEr9xBA;EzDsJI,oCAAA;Afk0xBJ;AwEx9xBA;EzDmJI,yBAAA;Afw0xBJ;AwE39xBA;EzDsJI,oCAAA;Afw0xBJ;AwE99xBA;EzDmJI,yBAAA;Af80xBJ;AwEj+xBA;EzDsJI,oCAAA;Af80xBJ;AwEp+xBA;EzDmJI,6BAAA;Afo1xBJ;AwEv+xBA;EzDsJI,wCAAA;Afo1xBJ;AwE1+xBA;EzDmJI,6BAAA;Af01xBJ;AwE7+xBA;EzDsJI,wCAAA;Af01xBJ;AwEh/xBA;EzDmJI,6BAAA;Afg2xBJ;AwEn/xBA;EzDsJI,wCAAA;Afg2xBJ;AwEt/xBA;EzDmJI,6BAAA;Afs2xBJ;AwEz/xBA;EzDsJI,wCAAA;Afs2xBJ;AwE5/xBA;EzDmJI,6BAAA;Af42xBJ;AwE//xBA;EzDsJI,wCAAA;Af42xBJ;AwElgyBA;EzDmJI,6BAAA;Afk3xBJ;AwErgyBA;EzDsJI,wCAAA;Afk3xBJ;AwExgyBA;EzDmJI,6BAAA;Afw3xBJ;AwE3gyBA;EzDsJI,wCAAA;Afw3xBJ;AwE9gyBA;EzDmJI,6BAAA;Af83xBJ;AwEjhyBA;EzDsJI,wCAAA;Af83xBJ;AwEphyBA;EzDmJI,6BAAA;Afo4xBJ;AwEvhyBA;EzDsJI,wCAAA;Afo4xBJ;AwE1hyBA;EzDmJI,6BAAA;Af04xBJ;AwE7hyBA;EzDsJI,wCAAA;Af04xBJ;AwEhiyBA;EzDmJI,6BAAA;Afg5xBJ;AwEniyBA;EzDsJI,wCAAA;Afg5xBJ;AwEtiyBA;EzDmJI,6BAAA;Afs5xBJ;AwEziyBA;EzDsJI,wCAAA;Afs5xBJ;AwE5iyBA;EzDmJI,6BAAA;Af45xBJ;AwE/iyBA;EzDsJI,wCAAA;Af45xBJ;AwEljyBA;EzDmJI,6BAAA;Afk6xBJ;AwErjyBA;EzDsJI,wCAAA;Afk6xBJ;AwExjyBA;EzDmJI,6BAAA;Afw6xBJ;AwE3jyBA;EzDsJI,wCAAA;Afw6xBJ;AwE9jyBA;EzDmJI,6BAAA;Af86xBJ;AwEjkyBA;EzDsJI,wCAAA;Af86xBJ;AwEpkyBA;EzDmJI,6BAAA;Afo7xBJ;AwEvkyBA;EzDsJI,wCAAA;Afo7xBJ;AwE1kyBA;EzDmJI,6BAAA;Af07xBJ;AwE7kyBA;EzDsJI,wCAAA;Af07xBJ;AwEhlyBA;EzDmJI,6BAAA;Afg8xBJ;AwEnlyBA;EzDsJI,wCAAA;Afg8xBJ;AwEtlyBA;EzDmJI,6BAAA;Afs8xBJ;AwEzlyBA;EzDsJI,wCAAA;Afs8xBJ;AwE5lyBA;EzDmJI,+BAAA;Af48xBJ;AwE/lyBA;EzDsJI,0CAAA;Af48xBJ;AwElmyBA;EzDmJI,+BAAA;Afk9xBJ;AwErmyBA;EzDsJI,0CAAA;Afk9xBJ;AwExmyBA;EzDmJI,+BAAA;Afw9xBJ;AwE3myBA;EzDsJI,0CAAA;Afw9xBJ;AwE9myBA;EzDmJI,+BAAA;Af89xBJ;AwEjnyBA;EzDsJI,0CAAA;Af89xBJ;AwEpnyBA;EzDmJI,+BAAA;Afo+xBJ;AwEvnyBA;EzDsJI,0CAAA;Afo+xBJ;AwE1nyBA;EzDmJI,+BAAA;Af0+xBJ;AwE7nyBA;EzDsJI,0CAAA;Af0+xBJ;AwEhoyBA;EzDmJI,+BAAA;Afg/xBJ;AwEnoyBA;EzDsJI,0CAAA;Afg/xBJ;AwEtoyBA;EzDmJI,+BAAA;Afs/xBJ;AwEzoyBA;EzDsJI,0CAAA;Afs/xBJ;AwE5oyBA;EzDmJI,+BAAA;Af4/xBJ;AwE/oyBA;EzDsJI,0CAAA;Af4/xBJ;AwElpyBA;EzDmJI,+BAAA;AfkgyBJ;AwErpyBA;EzDsJI,0CAAA;AfkgyBJ;AwExpyBA;EzDmJI,+BAAA;AfwgyBJ;AwE3pyBA;EzDsJI,0CAAA;AfwgyBJ;AwE9pyBA;EzDmJI,+BAAA;Af8gyBJ;AwEjqyBA;EzDsJI,0CAAA;Af8gyBJ;AwEpqyBA;EzDmJI,+BAAA;AfohyBJ;AwEvqyBA;EzDsJI,0CAAA;AfohyBJ;AwE1qyBA;EzDmJI,+BAAA;Af0hyBJ;AwE7qyBA;EzDsJI,0CAAA;Af0hyBJ;AwEhryBA;EzDmJI,+BAAA;AfgiyBJ;AwEnryBA;EzDsJI,0CAAA;AfgiyBJ;AwEtryBA;EzDmJI,+BAAA;AfsiyBJ;AwEzryBA;EzDsJI,0CAAA;AfsiyBJ;AwE5ryBA;EzDmJI,+BAAA;Af4iyBJ;AwE/ryBA;EzDsJI,0CAAA;Af4iyBJ;AwElsyBA;EzDmJI,+BAAA;AfkjyBJ;AwErsyBA;EzDsJI,0CAAA;AfkjyBJ;AwExsyBA;EzDmJI,+BAAA;AfwjyBJ;AwE3syBA;EzDsJI,0CAAA;AfwjyBJ;AwE9syBA;EzDmJI,+BAAA;Af8jyBJ;AwEjtyBA;EzDsJI,0CAAA;Af8jyBJ;AwEptyBA;EzDmJI,gCAAA;AfokyBJ;AwEvtyBA;EzDsJI,2CAAA;AfokyBJ;AwE1tyBA;EzDmJI,gCAAA;Af0kyBJ;AwE7tyBA;EzDsJI,2CAAA;Af0kyBJ;AwEhuyBA;EzDmJI,gCAAA;AfglyBJ;AwEnuyBA;EzDsJI,2CAAA;AfglyBJ;AwEtuyBA;EzDmJI,gCAAA;AfslyBJ;AwEzuyBA;EzDsJI,2CAAA;AfslyBJ;AwE5uyBA;EzDmJI,gCAAA;Af4lyBJ;AwE/uyBA;EzDsJI,2CAAA;Af4lyBJ;AwElvyBA;EzDmJI,gCAAA;AfkmyBJ;AwErvyBA;EzDsJI,2CAAA;AfkmyBJ;AwExvyBA;EzDmJI,gCAAA;AfwmyBJ;AwE3vyBA;EzDsJI,2CAAA;AfwmyBJ;AwE9vyBA;EzDmJI,gCAAA;Af8myBJ;AwEjwyBA;EzDsJI,2CAAA;Af8myBJ;AwEpwyBA;EzDmJI,gCAAA;AfonyBJ;AwEvwyBA;EzDsJI,2CAAA;AfonyBJ;AwE1wyBA;EzDmJI,gCAAA;Af0nyBJ;AwE7wyBA;EzDsJI,2CAAA;Af0nyBJ;AwEhxyBA;EzDmJI,gCAAA;AfgoyBJ;AwEnxyBA;EzDsJI,2CAAA;AfgoyBJ;AwEtxyBA;EzDmJI,gCAAA;AfsoyBJ;AwEzxyBA;EzDsJI,2CAAA;AfsoyBJ;AwE5xyBA;EzDmJI,gCAAA;Af4oyBJ;AwE/xyBA;EzDsJI,2CAAA;Af4oyBJ;AwElyyBA;EzDmJI,gCAAA;AfkpyBJ;AwEryyBA;EzDsJI,2CAAA;AfkpyBJ;AwExyyBA;EzDmJI,gCAAA;AfwpyBJ;AwE3yyBA;EzDsJI,2CAAA;AfwpyBJ;AwE9yyBA;EzDmJI,gCAAA;Af8pyBJ;AwEjzyBA;EzDsJI,2CAAA;Af8pyBJ;AwEpzyBA;EzDmJI,gCAAA;AfoqyBJ;AwEvzyBA;EzDsJI,2CAAA;AfoqyBJ;AwE1zyBA;EzDmJI,gCAAA;Af0qyBJ;AwE7zyBA;EzDsJI,2CAAA;Af0qyBJ;AwEh0yBA;EzDmJI,gCAAA;AfgryBJ;AwEn0yBA;EzDsJI,2CAAA;AfgryBJ;AwEt0yBA;EzDmJI,gCAAA;AfsryBJ;AwEz0yBA;EzDsJI,2CAAA;AfsryBJ;AwE50yBA;EzDmJI,8BAAA;Af4ryBJ;AwE/0yBA;EzDsJI,yCAAA;Af4ryBJ;AwEl1yBA;EzDmJI,8BAAA;AfksyBJ;AwEr1yBA;EzDsJI,yCAAA;AfksyBJ;AwEx1yBA;EzDmJI,8BAAA;AfwsyBJ;AwE31yBA;EzDsJI,yCAAA;AfwsyBJ;AwE91yBA;EzDmJI,8BAAA;Af8syBJ;AwEj2yBA;EzDsJI,yCAAA;Af8syBJ;AwEp2yBA;EzDmJI,8BAAA;AfotyBJ;AwEv2yBA;EzDsJI,yCAAA;AfotyBJ;AwE12yBA;EzDmJI,8BAAA;Af0tyBJ;AwE72yBA;EzDsJI,yCAAA;Af0tyBJ;AwEh3yBA;EzDmJI,8BAAA;AfguyBJ;AwEn3yBA;EzDsJI,yCAAA;AfguyBJ;AwEt3yBA;EzDmJI,8BAAA;AfsuyBJ;AwEz3yBA;EzDsJI,yCAAA;AfsuyBJ;AwE53yBA;EzDmJI,8BAAA;Af4uyBJ;AwE/3yBA;EzDsJI,yCAAA;Af4uyBJ;AwEl4yBA;EzDmJI,8BAAA;AfkvyBJ;AwEr4yBA;EzDsJI,yCAAA;AfkvyBJ;AwEx4yBA;EzDmJI,8BAAA;AfwvyBJ;AwE34yBA;EzDsJI,yCAAA;AfwvyBJ;AwE94yBA;EzDmJI,8BAAA;Af8vyBJ;AwEj5yBA;EzDsJI,yCAAA;Af8vyBJ;AwEp5yBA;EzDmJI,8BAAA;AfowyBJ;AwEv5yBA;EzDsJI,yCAAA;AfowyBJ;AwE15yBA;EzDmJI,8BAAA;Af0wyBJ;AwE75yBA;EzDsJI,yCAAA;Af0wyBJ;AwEh6yBA;EzDmJI,8BAAA;AfgxyBJ;AwEn6yBA;EzDsJI,yCAAA;AfgxyBJ;AwEt6yBA;EzDmJI,8BAAA;AfsxyBJ;AwEz6yBA;EzDsJI,yCAAA;AfsxyBJ;AwE56yBA;EzDmJI,8BAAA;Af4xyBJ;AwE/6yBA;EzDsJI,yCAAA;Af4xyBJ;AwEl7yBA;EzDmJI,8BAAA;AfkyyBJ;AwEr7yBA;EzDsJI,yCAAA;AfkyyBJ;AwEx7yBA;EzDmJI,8BAAA;AfwyyBJ;AwE37yBA;EzDsJI,yCAAA;AfwyyBJ;AwE97yBA;EzDmJI,8BAAA;Af8yyBJ;AwEj8yBA;EzDsJI,yCAAA;Af8yyBJ;AwEp8yBA;EzDmJI,sBAAA;AfozyBJ;AwEv8yBA;EzDsJI,iCAAA;AfozyBJ;AwE18yBA;EzDmJI,sBAAA;Af0zyBJ;AwE78yBA;EzDsJI,iCAAA;Af0zyBJ;AwEh9yBA;EzDmJI,sBAAA;Afg0yBJ;AwEn9yBA;EzDsJI,iCAAA;Afg0yBJ;AwEt9yBA;EzDmJI,sBAAA;Afs0yBJ;AwEz9yBA;EzDsJI,iCAAA;Afs0yBJ;AwE59yBA;EzDmJI,sBAAA;Af40yBJ;AwE/9yBA;EzDsJI,iCAAA;Af40yBJ;AwEl+yBA;EzDmJI,sBAAA;Afk1yBJ;AwEr+yBA;EzDsJI,iCAAA;Afk1yBJ;AwEx+yBA;EzDmJI,sBAAA;Afw1yBJ;AwE3+yBA;EzDsJI,iCAAA;Afw1yBJ;AwE9+yBA;EzDmJI,sBAAA;Af81yBJ;AwEj/yBA;EzDsJI,iCAAA;Af81yBJ;AwEp/yBA;EzDmJI,sBAAA;Afo2yBJ;AwEv/yBA;EzDsJI,iCAAA;Afo2yBJ;AwE1/yBA;EzDmJI,sBAAA;Af02yBJ;AwE7/yBA;EzDsJI,iCAAA;Af02yBJ;AwEhgzBA;EzDmJI,sBAAA;Afg3yBJ;AwEngzBA;EzDsJI,iCAAA;Afg3yBJ;AwEtgzBA;EzDmJI,sBAAA;Afs3yBJ;AwEzgzBA;EzDsJI,iCAAA;Afs3yBJ;AwE5gzBA;EzDmJI,sBAAA;Af43yBJ;AwE/gzBA;EzDsJI,iCAAA;Af43yBJ;AwElhzBA;EzDmJI,sBAAA;Afk4yBJ;AwErhzBA;EzDsJI,iCAAA;Afk4yBJ;AwExhzBA;EzDmJI,sBAAA;Afw4yBJ;AwE3hzBA;EzDsJI,iCAAA;Afw4yBJ;AwE9hzBA;EzDmJI,sBAAA;Af84yBJ;AwEjizBA;EzDsJI,iCAAA;Af84yBJ;AwEpizBA;EzDmJI,sBAAA;Afo5yBJ;AwEvizBA;EzDsJI,iCAAA;Afo5yBJ;AwE1izBA;EzDmJI,sBAAA;Af05yBJ;AwE7izBA;EzDsJI,iCAAA;Af05yBJ;AwEhjzBA;EzDmJI,sBAAA;Afg6yBJ;AwEnjzBA;EzDsJI,iCAAA;Afg6yBJ;AwEtjzBA;EzDmJI,sBAAA;Afs6yBJ;AwEzjzBA;EzDsJI,iCAAA;Afs6yBJ;AwE5jzBA;EzDmJI,eAAA;Af46yBJ;AwE/jzBA;EzDsJI,0BAAA;Af46yBJ;AwElkzBA;EzDmJI,eAAA;Afk7yBJ;AwErkzBA;EzDsJI,0BAAA;Afk7yBJ;AwExkzBA;EzDmJI,eAAA;Afw7yBJ;AwE3kzBA;EzDsJI,0BAAA;Afw7yBJ;AwE9kzBA;EzDmJI,eAAA;Af87yBJ;AwEjlzBA;EzDsJI,0BAAA;Af87yBJ;AwEplzBA;EzDmJI,eAAA;Afo8yBJ;AwEvlzBA;EzDsJI,0BAAA;Afo8yBJ;AwE1lzBA;EzDmJI,eAAA;Af08yBJ;AwE7lzBA;EzDsJI,0BAAA;Af08yBJ;AwEhmzBA;EzDmJI,eAAA;Afg9yBJ;AwEnmzBA;EzDsJI,0BAAA;Afg9yBJ;AwEtmzBA;EzDmJI,eAAA;Afs9yBJ;AwEzmzBA;EzDsJI,0BAAA;Afs9yBJ;AwE5mzBA;EzDmJI,eAAA;Af49yBJ;AwE/mzBA;EzDsJI,0BAAA;Af49yBJ;AwElnzBA;EzDmJI,eAAA;Afk+yBJ;AwErnzBA;EzDsJI,0BAAA;Afk+yBJ;AwExnzBA;EzDmJI,eAAA;Afw+yBJ;AwE3nzBA;EzDsJI,0BAAA;Afw+yBJ;AwE9nzBA;EzDmJI,eAAA;Af8+yBJ;AwEjozBA;EzDsJI,0BAAA;Af8+yBJ;AwEpozBA;EzDmJI,eAAA;Afo/yBJ;AwEvozBA;EzDsJI,0BAAA;Afo/yBJ;AwE1ozBA;EzDmJI,eAAA;Af0/yBJ;AwE7ozBA;EzDsJI,0BAAA;Af0/yBJ;AwEhpzBA;EzDmJI,eAAA;AfggzBJ;AwEnpzBA;EzDsJI,0BAAA;AfggzBJ;AwEtpzBA;EzDmJI,eAAA;AfsgzBJ;AwEzpzBA;EzDsJI,0BAAA;AfsgzBJ;AwE5pzBA;EzDmJI,eAAA;Af4gzBJ;AwE/pzBA;EzDsJI,0BAAA;Af4gzBJ;AwElqzBA;EzDmJI,eAAA;AfkhzBJ;AwErqzBA;EzDsJI,0BAAA;AfkhzBJ;AwExqzBA;EzDmJI,eAAA;AfwhzBJ;AwE3qzBA;EzDsJI,0BAAA;AfwhzBJ;AwE9qzBA;EzDmJI,eAAA;Af8hzBJ;AwEjrzBA;EzDsJI,0BAAA;Af8hzBJ;AwEprzBA;EzDmJI,eAAA;AfoizBJ;AwEvrzBA;EzDsJI,0BAAA;AfoizBJ;AwE1rzBA;EzDmJI,eAAA;Af0izBJ;AwE7rzBA;EzDsJI,0BAAA;Af0izBJ;AwEhszBA;EzDmJI,eAAA;AfgjzBJ;AwEnszBA;EzDsJI,0BAAA;AfgjzBJ;AwEtszBA;EzDmJI,eAAA;AfsjzBJ;AwEzszBA;EzDsJI,0BAAA;AfsjzBJ;AwE5szBA;EzDmJI,eAAA;Af4jzBJ;AwE/szBA;EzDsJI,0BAAA;Af4jzBJ;AwEltzBA;EzDmJI,eAAA;AfkkzBJ;AwErtzBA;EzDsJI,0BAAA;AfkkzBJ;AwExtzBA;EzDmJI,eAAA;AfwkzBJ;AwE3tzBA;EzDsJI,0BAAA;AfwkzBJ;AwE9tzBA;EzDmJI,eAAA;Af8kzBJ;AwEjuzBA;EzDsJI,0BAAA;Af8kzBJ;AwEpuzBA;EzDmJI,eAAA;AfolzBJ;AwEvuzBA;EzDsJI,0BAAA;AfolzBJ;AwE1uzBA;EzDmJI,eAAA;Af0lzBJ;AwE7uzBA;EzDsJI,0BAAA;Af0lzBJ;AwEhvzBA;EzDmJI,eAAA;AfgmzBJ;AwEnvzBA;EzDsJI,0BAAA;AfgmzBJ;AwEtvzBA;EzDmJI,eAAA;AfsmzBJ;AwEzvzBA;EzDsJI,0BAAA;AfsmzBJ;AwE5vzBA;EzDmJI,eAAA;Af4mzBJ;AwE/vzBA;EzDsJI,0BAAA;Af4mzBJ;AwElwzBA;EzDmJI,eAAA;AfknzBJ;AwErwzBA;EzDsJI,0BAAA;AfknzBJ;AwExwzBA;EzDmJI,eAAA;AfwnzBJ;AwE3wzBA;EzDsJI,0BAAA;AfwnzBJ;AwE9wzBA;EzDmJI,eAAA;Af8nzBJ;AwEjxzBA;EzDsJI,0BAAA;Af8nzBJ;AwEpxzBA;EzDmJI,eAAA;AfoozBJ;AwEvxzBA;EzDsJI,0BAAA;AfoozBJ;AwE1xzBA;EzDmJI,eAAA;Af0ozBJ;AwE7xzBA;EzDsJI,0BAAA;Af0ozBJ;AwEhyzBA;EzDmJI,eAAA;AfgpzBJ;AwEnyzBA;EzDsJI,0BAAA;AfgpzBJ;AwEtyzBA;EzDmJI,eAAA;AfspzBJ;AwEzyzBA;EzDsJI,0BAAA;AfspzBJ;AwE5yzBA;EzDmJI,eAAA;Af4pzBJ;AwE/yzBA;EzDsJI,0BAAA;Af4pzBJ;AwElzzBA;EzDmJI,eAAA;AfkqzBJ;AwErzzBA;EzDsJI,0BAAA;AfkqzBJ;AwExzzBA;EzDmJI,eAAA;AfwqzBJ;AwE3zzBA;EzDsJI,0BAAA;AfwqzBJ;AwE9zzBA;EzDmJI,eAAA;Af8qzBJ;AwEj0zBA;EzDsJI,0BAAA;Af8qzBJ;AwEp0zBA;EzDmJI,eAAA;AforzBJ;AwEv0zBA;EzDsJI,0BAAA;AforzBJ;AwE10zBA;EzDmJI,eAAA;Af0rzBJ;AwE70zBA;EzDsJI,0BAAA;Af0rzBJ;AwEh1zBA;EzDmJI,eAAA;AfgszBJ;AwEn1zBA;EzDsJI,0BAAA;AfgszBJ;AwEt1zBA;EzDmJI,eAAA;AfsszBJ;AwEz1zBA;EzDsJI,0BAAA;AfsszBJ;AwE51zBA;EzDmJI,eAAA;Af4szBJ;AwE/1zBA;EzDsJI,0BAAA;Af4szBJ;AwEl2zBA;EzDmJI,eAAA;AfktzBJ;AwEr2zBA;EzDsJI,0BAAA;AfktzBJ;AwEx2zBA;EzDmJI,eAAA;AfwtzBJ;AwE32zBA;EzDsJI,0BAAA;AfwtzBJ;AwE92zBA;EzDmJI,eAAA;Af8tzBJ;AwEj3zBA;EzDsJI,0BAAA;Af8tzBJ;AwEp3zBA;EzDmJI,eAAA;AfouzBJ;AwEv3zBA;EzDsJI,0BAAA;AfouzBJ;AwE13zBA;EzDmJI,eAAA;Af0uzBJ;AwE73zBA;EzDsJI,0BAAA;Af0uzBJ;AwEh4zBA;EzDmJI,eAAA;AfgvzBJ;AwEn4zBA;EzDsJI,0BAAA;AfgvzBJ;AwEt4zBA;EzDmJI,eAAA;AfsvzBJ;AwEz4zBA;EzDsJI,0BAAA;AfsvzBJ;AwE54zBA;EzDmJI,eAAA;Af4vzBJ;AwE/4zBA;EzDsJI,0BAAA;Af4vzBJ;AwEl5zBA;EzDmJI,eAAA;AfkwzBJ;AwEr5zBA;EzDsJI,0BAAA;AfkwzBJ;AwEx5zBA;EzDmJI,eAAA;AfwwzBJ;AwE35zBA;EzDsJI,0BAAA;AfwwzBJ;AwE95zBA;EzDmJI,eAAA;Af8wzBJ;AwEj6zBA;EzDsJI,0BAAA;Af8wzBJ;AwEp6zBA;EzDmJI,eAAA;AfoxzBJ;AwEv6zBA;EzDsJI,0BAAA;AfoxzBJ;AwE16zBA;EzDmJI,eAAA;Af0xzBJ;AwE76zBA;EzDsJI,0BAAA;Af0xzBJ;AwEh7zBA;EzDmJI,eAAA;AfgyzBJ;AwEn7zBA;EzDsJI,0BAAA;AfgyzBJ;AwEt7zBA;EzDmJI,eAAA;AfsyzBJ;AwEz7zBA;EzDsJI,0BAAA;AfsyzBJ;AwE57zBA;EzDmJI,eAAA;Af4yzBJ;AwE/7zBA;EzDsJI,0BAAA;Af4yzBJ;AwEl8zBA;EzDmJI,eAAA;AfkzzBJ;AwEr8zBA;EzDsJI,0BAAA;AfkzzBJ;AwEx8zBA;EzDmJI,eAAA;AfwzzBJ;AwE38zBA;EzDsJI,0BAAA;AfwzzBJ;AwE98zBA;EzDmJI,eAAA;Af8zzBJ;AwEj9zBA;EzDsJI,0BAAA;Af8zzBJ;AwEp9zBA;EzDmJI,eAAA;Afo0zBJ;AwEv9zBA;EzDsJI,0BAAA;Afo0zBJ;AwE19zBA;EzDmJI,eAAA;Af00zBJ;AwE79zBA;EzDsJI,0BAAA;Af00zBJ;AwEh+zBA;EzDmJI,eAAA;Afg1zBJ;AwEn+zBA;EzDsJI,0BAAA;Afg1zBJ;AwEt+zBA;EzDmJI,eAAA;Afs1zBJ;AwEz+zBA;EzDsJI,0BAAA;Afs1zBJ;AwE5+zBA;EzDmJI,eAAA;Af41zBJ;AwE/+zBA;EzDsJI,0BAAA;Af41zBJ;AwEl/zBA;EzDmJI,eAAA;Afk2zBJ;AwEr/zBA;EzDsJI,0BAAA;Afk2zBJ;AwEx/zBA;EzDmJI,eAAA;Afw2zBJ;AwE3/zBA;EzDsJI,0BAAA;Afw2zBJ;AwE9/zBA;EzDmJI,eAAA;Af82zBJ;AwEjg0BA;EzDsJI,0BAAA;Af82zBJ;AwEpg0BA;EzDmJI,eAAA;Afo3zBJ;AwEvg0BA;EzDsJI,0BAAA;Afo3zBJ;AwE1g0BA;EzDmJI,eAAA;Af03zBJ;AwE7g0BA;EzDsJI,0BAAA;Af03zBJ;AwEhh0BA;EzDmJI,eAAA;Afg4zBJ;AwEnh0BA;EzDsJI,0BAAA;Afg4zBJ;AwEth0BA;EzDmJI,eAAA;Afs4zBJ;AwEzh0BA;EzDsJI,0BAAA;Afs4zBJ;AwE5h0BA;EzDmJI,eAAA;Af44zBJ;AwE/h0BA;EzDsJI,0BAAA;Af44zBJ;AwEli0BA;EzDmJI,eAAA;Afk5zBJ;AwEri0BA;EzDsJI,0BAAA;Afk5zBJ;AwExi0BA;EzDmJI,eAAA;Afw5zBJ;AwE3i0BA;EzDsJI,0BAAA;Afw5zBJ;AwE9i0BA;EzDmJI,eAAA;Af85zBJ;AwEjj0BA;EzDsJI,0BAAA;Af85zBJ;AwEpj0BA;EzDmJI,eAAA;Afo6zBJ;AwEvj0BA;EzDsJI,0BAAA;Afo6zBJ;AwE1j0BA;EzDmJI,eAAA;Af06zBJ;AwE7j0BA;EzDsJI,0BAAA;Af06zBJ;AwEhk0BA;EzDmJI,eAAA;Afg7zBJ;AwEnk0BA;EzDsJI,0BAAA;Afg7zBJ;AwEtk0BA;EzDmJI,eAAA;Afs7zBJ;AwEzk0BA;EzDsJI,0BAAA;Afs7zBJ;AwE5k0BA;EzDmJI,eAAA;Af47zBJ;AwE/k0BA;EzDsJI,0BAAA;Af47zBJ;AwEll0BA;EzDmJI,eAAA;Afk8zBJ;AwErl0BA;EzDsJI,0BAAA;Afk8zBJ;AwExl0BA;EzDmJI,eAAA;Afw8zBJ;AwE3l0BA;EzDsJI,0BAAA;Afw8zBJ;AwE9l0BA;EzDmJI,eAAA;Af88zBJ;AwEjm0BA;EzDsJI,0BAAA;Af88zBJ;AwEpm0BA;EzDmJI,eAAA;Afo9zBJ;AwEvm0BA;EzDsJI,0BAAA;Afo9zBJ;AwE1m0BA;EzDmJI,eAAA;Af09zBJ;AwE7m0BA;EzDsJI,0BAAA;Af09zBJ;AwEhn0BA;EzDmJI,eAAA;Afg+zBJ;AwEnn0BA;EzDsJI,0BAAA;Afg+zBJ;AwEtn0BA;EzDmJI,eAAA;Afs+zBJ;AwEzn0BA;EzDsJI,0BAAA;Afs+zBJ;AwE5n0BA;EzDmJI,eAAA;Af4+zBJ;AwE/n0BA;EzDsJI,0BAAA;Af4+zBJ;AwElo0BA;EzDmJI,eAAA;Afk/zBJ;AwEro0BA;EzDsJI,0BAAA;Afk/zBJ;AwExo0BA;EzDmJI,eAAA;Afw/zBJ;AwE3o0BA;EzDsJI,0BAAA;Afw/zBJ;AwE9o0BA;EzDmJI,eAAA;Af8/zBJ;AwEjp0BA;EzDsJI,0BAAA;Af8/zBJ;AwEpp0BA;EzDmJI,oBAAA;Afog0BJ;AwEvp0BA;EzDsJI,+BAAA;Afog0BJ;AwE1p0BA;EzDmJI,oBAAA;Af0g0BJ;AwE7p0BA;EzDsJI,+BAAA;Af0g0BJ;AwEhq0BA;EzDmJI,oBAAA;Afgh0BJ;AwEnq0BA;EzDsJI,+BAAA;Afgh0BJ;AwEtq0BA;EzDmJI,oBAAA;Afsh0BJ;AwEzq0BA;EzDsJI,+BAAA;Afsh0BJ;AwE5q0BA;EzDmJI,oBAAA;Af4h0BJ;AwE/q0BA;EzDsJI,+BAAA;Af4h0BJ;AwElr0BA;EzDmJI,oBAAA;Afki0BJ;AwErr0BA;EzDsJI,+BAAA;Afki0BJ;AwExr0BA;EzDmJI,oBAAA;Afwi0BJ;AwE3r0BA;EzDsJI,+BAAA;Afwi0BJ;AwE9r0BA;EzDmJI,oBAAA;Af8i0BJ;AwEjs0BA;EzDsJI,+BAAA;Af8i0BJ;AwEps0BA;EzDmJI,oBAAA;Afoj0BJ;AwEvs0BA;EzDsJI,+BAAA;Afoj0BJ;AwE1s0BA;EzDmJI,oBAAA;Af0j0BJ;AwE7s0BA;EzDsJI,+BAAA;Af0j0BJ;AwEht0BA;EzDmJI,oBAAA;Afgk0BJ;AwEnt0BA;EzDsJI,+BAAA;Afgk0BJ;AwEtt0BA;EzDmJI,oBAAA;Afsk0BJ;AwEzt0BA;EzDsJI,+BAAA;Afsk0BJ;AwE5t0BA;EzDmJI,oBAAA;Af4k0BJ;AwE/t0BA;EzDsJI,+BAAA;Af4k0BJ;AwElu0BA;EzDmJI,oBAAA;Afkl0BJ;AwEru0BA;EzDsJI,+BAAA;Afkl0BJ;AwExu0BA;EzDmJI,oBAAA;Afwl0BJ;AwE3u0BA;EzDsJI,+BAAA;Afwl0BJ;AwE9u0BA;EzDmJI,oBAAA;Af8l0BJ;AwEjv0BA;EzDsJI,+BAAA;Af8l0BJ;AwEpv0BA;EzDmJI,oBAAA;Afom0BJ;AwEvv0BA;EzDsJI,+BAAA;Afom0BJ;AwE1v0BA;EzDmJI,oBAAA;Af0m0BJ;AwE7v0BA;EzDsJI,+BAAA;Af0m0BJ;AwEhw0BA;EzDmJI,oBAAA;Afgn0BJ;AwEnw0BA;EzDsJI,+BAAA;Afgn0BJ;AwEtw0BA;EzDmJI,oBAAA;Afsn0BJ;AwEzw0BA;EzDsJI,+BAAA;Afsn0BJ;AwE5w0BA;EzDmJI,oBAAA;Af4n0BJ;AwE/w0BA;EzDsJI,+BAAA;Af4n0BJ;AwElx0BA;EzDmJI,oBAAA;Afko0BJ;AwErx0BA;EzDsJI,+BAAA;Afko0BJ;AwExx0BA;EzDmJI,oBAAA;Afwo0BJ;AwE3x0BA;EzDsJI,+BAAA;Afwo0BJ;AwE9x0BA;EzDmJI,oBAAA;Af8o0BJ;AwEjy0BA;EzDsJI,+BAAA;Af8o0BJ;AwEpy0BA;EzDmJI,oBAAA;Afop0BJ;AwEvy0BA;EzDsJI,+BAAA;Afop0BJ;AwE1y0BA;EzDmJI,oBAAA;Af0p0BJ;AwE7y0BA;EzDsJI,+BAAA;Af0p0BJ;AwEhz0BA;EzDmJI,oBAAA;Afgq0BJ;AwEnz0BA;EzDsJI,+BAAA;Afgq0BJ;AwEtz0BA;EzDmJI,oBAAA;Afsq0BJ;AwEzz0BA;EzDsJI,+BAAA;Afsq0BJ;AwE5z0BA;EzDmJI,oBAAA;Af4q0BJ;AwE/z0BA;EzDsJI,+BAAA;Af4q0BJ;AwEl00BA;EzDmJI,oBAAA;Afkr0BJ;AwEr00BA;EzDsJI,+BAAA;Afkr0BJ;AwEx00BA;EzDmJI,oBAAA;Afwr0BJ;AwE300BA;EzDsJI,+BAAA;Afwr0BJ;AwE900BA;EzDmJI,oBAAA;Af8r0BJ;AwEj10BA;EzDsJI,+BAAA;Af8r0BJ;AwEp10BA;EzDmJI,oBAAA;Afos0BJ;AwEv10BA;EzDsJI,+BAAA;Afos0BJ;AwE110BA;EzDmJI,oBAAA;Af0s0BJ;AwE710BA;EzDsJI,+BAAA;Af0s0BJ;AwEh20BA;EzDmJI,oBAAA;Afgt0BJ;AwEn20BA;EzDsJI,+BAAA;Afgt0BJ;AwEt20BA;EzDmJI,oBAAA;Afst0BJ;AwEz20BA;EzDsJI,+BAAA;Afst0BJ;AwE520BA;EzDmJI,oBAAA;Af4t0BJ;AwE/20BA;EzDsJI,+BAAA;Af4t0BJ;AwEl30BA;EzDmJI,oBAAA;Afku0BJ;AwEr30BA;EzDsJI,+BAAA;Afku0BJ;AwEx30BA;EzDmJI,oBAAA;Afwu0BJ;AwE330BA;EzDsJI,+BAAA;Afwu0BJ;AwE930BA;EzDmJI,oBAAA;Af8u0BJ;AwEj40BA;EzDsJI,+BAAA;Af8u0BJ;AwEp40BA;EzDmJI,oBAAA;Afov0BJ;AwEv40BA;EzDsJI,+BAAA;Afov0BJ;AwE140BA;EzDmJI,oBAAA;Af0v0BJ;AwE740BA;EzDsJI,+BAAA;Af0v0BJ;AwEh50BA;EzDmJI,oBAAA;Afgw0BJ;AwEn50BA;EzDsJI,+BAAA;Afgw0BJ;AwEt50BA;EzDmJI,oBAAA;Afsw0BJ;AwEz50BA;EzDsJI,+BAAA;Afsw0BJ;AwE550BA;EzDmJI,oBAAA;Af4w0BJ;AwE/50BA;EzDsJI,+BAAA;Af4w0BJ;AwEl60BA;EzDmJI,oBAAA;Afkx0BJ;AwEr60BA;EzDsJI,+BAAA;Afkx0BJ;AwEx60BA;EzDmJI,oBAAA;Afwx0BJ;AwE360BA;EzDsJI,+BAAA;Afwx0BJ;AwE960BA;EzDmJI,oBAAA;Af8x0BJ;AwEj70BA;EzDsJI,+BAAA;Af8x0BJ;AwEp70BA;EzDmJI,oBAAA;Afoy0BJ;AwEv70BA;EzDsJI,+BAAA;Afoy0BJ;AwE170BA;EzDmJI,oBAAA;Af0y0BJ;AwE770BA;EzDsJI,+BAAA;Af0y0BJ;AwEh80BA;EzDmJI,oBAAA;Afgz0BJ;AwEn80BA;EzDsJI,+BAAA;Afgz0BJ;AwEt80BA;EzDmJI,oBAAA;Afsz0BJ;AwEz80BA;EzDsJI,+BAAA;Afsz0BJ;AwE580BA;EzDmJI,oBAAA;Af4z0BJ;AwE/80BA;EzDsJI,+BAAA;Af4z0BJ;AwEl90BA;EzDmJI,oBAAA;Afk00BJ;AwEr90BA;EzDsJI,+BAAA;Afk00BJ;AwEx90BA;EzDmJI,oBAAA;Afw00BJ;AwE390BA;EzDsJI,+BAAA;Afw00BJ;AwE990BA;EzDmJI,oBAAA;Af800BJ;AwEj+0BA;EzDsJI,+BAAA;Af800BJ;AwEp+0BA;EzDmJI,oBAAA;Afo10BJ;AwEv+0BA;EzDsJI,+BAAA;Afo10BJ;AwE1+0BA;EzDmJI,oBAAA;Af010BJ;AwE7+0BA;EzDsJI,+BAAA;Af010BJ;AwEh/0BA;EzDmJI,oBAAA;Afg20BJ;AwEn/0BA;EzDsJI,+BAAA;Afg20BJ;AwEt/0BA;EzDmJI,oBAAA;Afs20BJ;AwEz/0BA;EzDsJI,+BAAA;Afs20BJ;AwE5/0BA;EzDmJI,oBAAA;Af420BJ;AwE//0BA;EzDsJI,+BAAA;Af420BJ;AwElg1BA;EzDmJI,oBAAA;Afk30BJ;AwErg1BA;EzDsJI,+BAAA;Afk30BJ;AwExg1BA;EzDmJI,oBAAA;Afw30BJ;AwE3g1BA;EzDsJI,+BAAA;Afw30BJ;AwE9g1BA;EzDmJI,oBAAA;Af830BJ;AwEjh1BA;EzDsJI,+BAAA;Af830BJ;AwEph1BA;EzDmJI,oBAAA;Afo40BJ;AwEvh1BA;EzDsJI,+BAAA;Afo40BJ;AwE1h1BA;EzDmJI,oBAAA;Af040BJ;AwE7h1BA;EzDsJI,+BAAA;Af040BJ;AwEhi1BA;EzDmJI,oBAAA;Afg50BJ;AwEni1BA;EzDsJI,+BAAA;Afg50BJ;AwEti1BA;EzDmJI,oBAAA;Afs50BJ;AwEzi1BA;EzDsJI,+BAAA;Afs50BJ;AwE5i1BA;EzDmJI,oBAAA;Af450BJ;AwE/i1BA;EzDsJI,+BAAA;Af450BJ;AwElj1BA;EzDmJI,oBAAA;Afk60BJ;AwErj1BA;EzDsJI,+BAAA;Afk60BJ;AwExj1BA;EzDmJI,yBAAA;Afw60BJ;AwE3j1BA;EzDsJI,oCAAA;Afw60BJ;AwE9j1BA;EzDmJI,yBAAA;Af860BJ;AwEjk1BA;EzDsJI,oCAAA;Af860BJ;AwEpk1BA;EzDmJI,yBAAA;Afo70BJ;AwEvk1BA;EzDsJI,oCAAA;Afo70BJ;AwE1k1BA;EzDmJI,yBAAA;Af070BJ;AwE7k1BA;EzDsJI,oCAAA;Af070BJ;AwEhl1BA;EzDmJI,yBAAA;Afg80BJ;AwEnl1BA;EzDsJI,oCAAA;Afg80BJ;AwEtl1BA;EzDmJI,yBAAA;Afs80BJ;AwEzl1BA;EzDsJI,oCAAA;Afs80BJ;AwE5l1BA;EzDmJI,yBAAA;Af480BJ;AwE/l1BA;EzDsJI,oCAAA;Af480BJ;AwElm1BA;EzDmJI,yBAAA;Afk90BJ;AwErm1BA;EzDsJI,oCAAA;Afk90BJ;AwExm1BA;EzDmJI,yBAAA;Afw90BJ;AwE3m1BA;EzDsJI,oCAAA;Afw90BJ;AwE9m1BA;EzDmJI,yBAAA;Af890BJ;AwEjn1BA;EzDsJI,oCAAA;Af890BJ;AwEpn1BA;EzDmJI,yBAAA;Afo+0BJ;AwEvn1BA;EzDsJI,oCAAA;Afo+0BJ;AwE1n1BA;EzDmJI,yBAAA;Af0+0BJ;AwE7n1BA;EzDsJI,oCAAA;Af0+0BJ;AwEho1BA;EzDmJI,yBAAA;Afg/0BJ;AwEno1BA;EzDsJI,oCAAA;Afg/0BJ;AwEto1BA;EzDmJI,yBAAA;Afs/0BJ;AwEzo1BA;EzDsJI,oCAAA;Afs/0BJ;AwE5o1BA;EzDmJI,yBAAA;Af4/0BJ;AwE/o1BA;EzDsJI,oCAAA;Af4/0BJ;AwElp1BA;EzDmJI,yBAAA;Afkg1BJ;AwErp1BA;EzDsJI,oCAAA;Afkg1BJ;AwExp1BA;EzDmJI,yBAAA;Afwg1BJ;AwE3p1BA;EzDsJI,oCAAA;Afwg1BJ;AwE9p1BA;EzDmJI,yBAAA;Af8g1BJ;AwEjq1BA;EzDsJI,oCAAA;Af8g1BJ;AwEpq1BA;EzDmJI,yBAAA;Afoh1BJ;AwEvq1BA;EzDsJI,oCAAA;Afoh1BJ;AwE1q1BA;EzDmJI,yBAAA;Af0h1BJ;AwE7q1BA;EzDsJI,oCAAA;Af0h1BJ;AwEhr1BA;EzDmJI,yBAAA;Afgi1BJ;AwEnr1BA;EzDsJI,oCAAA;Afgi1BJ;AwEtr1BA;EzDmJI,yBAAA;Afsi1BJ;AwEzr1BA;EzDsJI,oCAAA;Afsi1BJ;AwE5r1BA;EzDmJI,yBAAA;Af4i1BJ;AwE/r1BA;EzDsJI,oCAAA;Af4i1BJ;AwEls1BA;EzDmJI,yBAAA;Afkj1BJ;AwErs1BA;EzDsJI,oCAAA;Afkj1BJ;AwExs1BA;EzDmJI,yBAAA;Afwj1BJ;AwE3s1BA;EzDsJI,oCAAA;Afwj1BJ;AwE9s1BA;EzDmJI,yBAAA;Af8j1BJ;AwEjt1BA;EzDsJI,oCAAA;Af8j1BJ;AwEpt1BA;EzDmJI,yBAAA;Afok1BJ;AwEvt1BA;EzDsJI,oCAAA;Afok1BJ;AwE1t1BA;EzDmJI,yBAAA;Af0k1BJ;AwE7t1BA;EzDsJI,oCAAA;Af0k1BJ;AwEhu1BA;EzDmJI,yBAAA;Afgl1BJ;AwEnu1BA;EzDsJI,oCAAA;Afgl1BJ;AwEtu1BA;EzDmJI,yBAAA;Afsl1BJ;AwEzu1BA;EzDsJI,oCAAA;Afsl1BJ;AwE5u1BA;EzDmJI,6BAAA;Af4l1BJ;AwE/u1BA;EzDsJI,wCAAA;Af4l1BJ;AwElv1BA;EzDmJI,6BAAA;Afkm1BJ;AwErv1BA;EzDsJI,wCAAA;Afkm1BJ;AwExv1BA;EzDmJI,6BAAA;Afwm1BJ;AwE3v1BA;EzDsJI,wCAAA;Afwm1BJ;AwE9v1BA;EzDmJI,6BAAA;Af8m1BJ;AwEjw1BA;EzDsJI,wCAAA;Af8m1BJ;AwEpw1BA;EzDmJI,6BAAA;Afon1BJ;AwEvw1BA;EzDsJI,wCAAA;Afon1BJ;AwE1w1BA;EzDmJI,6BAAA;Af0n1BJ;AwE7w1BA;EzDsJI,wCAAA;Af0n1BJ;AwEhx1BA;EzDmJI,6BAAA;Afgo1BJ;AwEnx1BA;EzDsJI,wCAAA;Afgo1BJ;AwEtx1BA;EzDmJI,6BAAA;Afso1BJ;AwEzx1BA;EzDsJI,wCAAA;Afso1BJ;AwE5x1BA;EzDmJI,6BAAA;Af4o1BJ;AwE/x1BA;EzDsJI,wCAAA;Af4o1BJ;AwEly1BA;EzDmJI,6BAAA;Afkp1BJ;AwEry1BA;EzDsJI,wCAAA;Afkp1BJ;AwExy1BA;EzDmJI,6BAAA;Afwp1BJ;AwE3y1BA;EzDsJI,wCAAA;Afwp1BJ;AwE9y1BA;EzDmJI,6BAAA;Af8p1BJ;AwEjz1BA;EzDsJI,wCAAA;Af8p1BJ;AwEpz1BA;EzDmJI,6BAAA;Afoq1BJ;AwEvz1BA;EzDsJI,wCAAA;Afoq1BJ;AwE1z1BA;EzDmJI,6BAAA;Af0q1BJ;AwE7z1BA;EzDsJI,wCAAA;Af0q1BJ;AwEh01BA;EzDmJI,6BAAA;Afgr1BJ;AwEn01BA;EzDsJI,wCAAA;Afgr1BJ;AwEt01BA;EzDmJI,6BAAA;Afsr1BJ;AwEz01BA;EzDsJI,wCAAA;Afsr1BJ;AwE501BA;EzDmJI,6BAAA;Af4r1BJ;AwE/01BA;EzDsJI,wCAAA;Af4r1BJ;AwEl11BA;EzDmJI,6BAAA;Afks1BJ;AwEr11BA;EzDsJI,wCAAA;Afks1BJ;AwEx11BA;EzDmJI,6BAAA;Afws1BJ;AwE311BA;EzDsJI,wCAAA;Afws1BJ;AwE911BA;EzDmJI,6BAAA;Af8s1BJ;AwEj21BA;EzDsJI,wCAAA;Af8s1BJ;AwEp21BA;EzDmJI,+BAAA;Afot1BJ;AwEv21BA;EzDsJI,0CAAA;Afot1BJ;AwE121BA;EzDmJI,+BAAA;Af0t1BJ;AwE721BA;EzDsJI,0CAAA;Af0t1BJ;AwEh31BA;EzDmJI,+BAAA;Afgu1BJ;AwEn31BA;EzDsJI,0CAAA;Afgu1BJ;AwEt31BA;EzDmJI,+BAAA;Afsu1BJ;AwEz31BA;EzDsJI,0CAAA;Afsu1BJ;AwE531BA;EzDmJI,+BAAA;Af4u1BJ;AwE/31BA;EzDsJI,0CAAA;Af4u1BJ;AwEl41BA;EzDmJI,+BAAA;Afkv1BJ;AwEr41BA;EzDsJI,0CAAA;Afkv1BJ;AwEx41BA;EzDmJI,+BAAA;Afwv1BJ;AwE341BA;EzDsJI,0CAAA;Afwv1BJ;AwE941BA;EzDmJI,+BAAA;Af8v1BJ;AwEj51BA;EzDsJI,0CAAA;Af8v1BJ;AwEp51BA;EzDmJI,+BAAA;Afow1BJ;AwEv51BA;EzDsJI,0CAAA;Afow1BJ;AwE151BA;EzDmJI,+BAAA;Af0w1BJ;AwE751BA;EzDsJI,0CAAA;Af0w1BJ;AwEh61BA;EzDmJI,+BAAA;Afgx1BJ;AwEn61BA;EzDsJI,0CAAA;Afgx1BJ;AwEt61BA;EzDmJI,+BAAA;Afsx1BJ;AwEz61BA;EzDsJI,0CAAA;Afsx1BJ;AwE561BA;EzDmJI,+BAAA;Af4x1BJ;AwE/61BA;EzDsJI,0CAAA;Af4x1BJ;AwEl71BA;EzDmJI,+BAAA;Afky1BJ;AwEr71BA;EzDsJI,0CAAA;Afky1BJ;AwEx71BA;EzDmJI,+BAAA;Afwy1BJ;AwE371BA;EzDsJI,0CAAA;Afwy1BJ;AwE971BA;EzDmJI,+BAAA;Af8y1BJ;AwEj81BA;EzDsJI,0CAAA;Af8y1BJ;AwEp81BA;EzDmJI,+BAAA;Afoz1BJ;AwEv81BA;EzDsJI,0CAAA;Afoz1BJ;AwE181BA;EzDmJI,+BAAA;Af0z1BJ;AwE781BA;EzDsJI,0CAAA;Af0z1BJ;AwEh91BA;EzDmJI,+BAAA;Afg01BJ;AwEn91BA;EzDsJI,0CAAA;Afg01BJ;AwEt91BA;EzDmJI,+BAAA;Afs01BJ;AwEz91BA;EzDsJI,0CAAA;Afs01BJ;AwE591BA;EzDmJI,gCAAA;Af401BJ;AwE/91BA;EzDsJI,2CAAA;Af401BJ;AwEl+1BA;EzDmJI,gCAAA;Afk11BJ;AwEr+1BA;EzDsJI,2CAAA;Afk11BJ;AwEx+1BA;EzDmJI,gCAAA;Afw11BJ;AwE3+1BA;EzDsJI,2CAAA;Afw11BJ;AwE9+1BA;EzDmJI,gCAAA;Af811BJ;AwEj/1BA;EzDsJI,2CAAA;Af811BJ;AwEp/1BA;EzDmJI,gCAAA;Afo21BJ;AwEv/1BA;EzDsJI,2CAAA;Afo21BJ;AwE1/1BA;EzDmJI,gCAAA;Af021BJ;AwE7/1BA;EzDsJI,2CAAA;Af021BJ;AwEhg2BA;EzDmJI,gCAAA;Afg31BJ;AwEng2BA;EzDsJI,2CAAA;Afg31BJ;AwEtg2BA;EzDmJI,gCAAA;Afs31BJ;AwEzg2BA;EzDsJI,2CAAA;Afs31BJ;AwE5g2BA;EzDmJI,gCAAA;Af431BJ;AwE/g2BA;EzDsJI,2CAAA;Af431BJ;AwElh2BA;EzDmJI,gCAAA;Afk41BJ;AwErh2BA;EzDsJI,2CAAA;Afk41BJ;AwExh2BA;EzDmJI,gCAAA;Afw41BJ;AwE3h2BA;EzDsJI,2CAAA;Afw41BJ;AwE9h2BA;EzDmJI,gCAAA;Af841BJ;AwEji2BA;EzDsJI,2CAAA;Af841BJ;AwEpi2BA;EzDmJI,gCAAA;Afo51BJ;AwEvi2BA;EzDsJI,2CAAA;Afo51BJ;AwE1i2BA;EzDmJI,gCAAA;Af051BJ;AwE7i2BA;EzDsJI,2CAAA;Af051BJ;AwEhj2BA;EzDmJI,gCAAA;Afg61BJ;AwEnj2BA;EzDsJI,2CAAA;Afg61BJ;AwEtj2BA;EzDmJI,gCAAA;Afs61BJ;AwEzj2BA;EzDsJI,2CAAA;Afs61BJ;AwE5j2BA;EzDmJI,gCAAA;Af461BJ;AwE/j2BA;EzDsJI,2CAAA;Af461BJ;AwElk2BA;EzDmJI,gCAAA;Afk71BJ;AwErk2BA;EzDsJI,2CAAA;Afk71BJ;AwExk2BA;EzDmJI,gCAAA;Afw71BJ;AwE3k2BA;EzDsJI,2CAAA;Afw71BJ;AwE9k2BA;EzDmJI,gCAAA;Af871BJ;AwEjl2BA;EzDsJI,2CAAA;Af871BJ;AwEpl2BA;EzDmJI,8BAAA;Afo81BJ;AwEvl2BA;EzDsJI,yCAAA;Afo81BJ;AwE1l2BA;EzDmJI,8BAAA;Af081BJ;AwE7l2BA;EzDsJI,yCAAA;Af081BJ;AwEhm2BA;EzDmJI,8BAAA;Afg91BJ;AwEnm2BA;EzDsJI,yCAAA;Afg91BJ;AwEtm2BA;EzDmJI,8BAAA;Afs91BJ;AwEzm2BA;EzDsJI,yCAAA;Afs91BJ;AwE5m2BA;EzDmJI,8BAAA;Af491BJ;AwE/m2BA;EzDsJI,yCAAA;Af491BJ;AwEln2BA;EzDmJI,8BAAA;Afk+1BJ;AwErn2BA;EzDsJI,yCAAA;Afk+1BJ;AwExn2BA;EzDmJI,8BAAA;Afw+1BJ;AwE3n2BA;EzDsJI,yCAAA;Afw+1BJ;AwE9n2BA;EzDmJI,8BAAA;Af8+1BJ;AwEjo2BA;EzDsJI,yCAAA;Af8+1BJ;AwEpo2BA;EzDmJI,8BAAA;Afo/1BJ;AwEvo2BA;EzDsJI,yCAAA;Afo/1BJ;AwE1o2BA;EzDmJI,8BAAA;Af0/1BJ;AwE7o2BA;EzDsJI,yCAAA;Af0/1BJ;AwEhp2BA;EzDmJI,8BAAA;Afgg2BJ;AwEnp2BA;EzDsJI,yCAAA;Afgg2BJ;AwEtp2BA;EzDmJI,8BAAA;Afsg2BJ;AwEzp2BA;EzDsJI,yCAAA;Afsg2BJ;AwE5p2BA;EzDmJI,8BAAA;Af4g2BJ;AwE/p2BA;EzDsJI,yCAAA;Af4g2BJ;AwElq2BA;EzDmJI,8BAAA;Afkh2BJ;AwErq2BA;EzDsJI,yCAAA;Afkh2BJ;AwExq2BA;EzDmJI,8BAAA;Afwh2BJ;AwE3q2BA;EzDsJI,yCAAA;Afwh2BJ;AwE9q2BA;EzDmJI,8BAAA;Af8h2BJ;AwEjr2BA;EzDsJI,yCAAA;Af8h2BJ;AwEpr2BA;EzDmJI,8BAAA;Afoi2BJ;AwEvr2BA;EzDsJI,yCAAA;Afoi2BJ;AwE1r2BA;EzDmJI,8BAAA;Af0i2BJ;AwE7r2BA;EzDsJI,yCAAA;Af0i2BJ;AwEhs2BA;EzDmJI,8BAAA;Afgj2BJ;AwEns2BA;EzDsJI,yCAAA;Afgj2BJ;AwEts2BA;EzDmJI,8BAAA;Afsj2BJ;AwEzs2BA;EzDsJI,yCAAA;Afsj2BJ;AwE5s2BA;EzDmJI,sBAAA;Af4j2BJ;AwE/s2BA;EzDsJI,iCAAA;Af4j2BJ;AwElt2BA;EzDmJI,sBAAA;Afkk2BJ;AwErt2BA;EzDsJI,iCAAA;Afkk2BJ;AwExt2BA;EzDmJI,sBAAA;Afwk2BJ;AwE3t2BA;EzDsJI,iCAAA;Afwk2BJ;AwE9t2BA;EzDmJI,sBAAA;Af8k2BJ;AwEju2BA;EzDsJI,iCAAA;Af8k2BJ;AwEpu2BA;EzDmJI,sBAAA;Afol2BJ;AwEvu2BA;EzDsJI,iCAAA;Afol2BJ;AwE1u2BA;EzDmJI,sBAAA;Af0l2BJ;AwE7u2BA;EzDsJI,iCAAA;Af0l2BJ;AwEhv2BA;EzDmJI,sBAAA;Afgm2BJ;AwEnv2BA;EzDsJI,iCAAA;Afgm2BJ;AwEtv2BA;EzDmJI,sBAAA;Afsm2BJ;AwEzv2BA;EzDsJI,iCAAA;Afsm2BJ;AwE5v2BA;EzDmJI,sBAAA;Af4m2BJ;AwE/v2BA;EzDsJI,iCAAA;Af4m2BJ;AwElw2BA;EzDmJI,sBAAA;Afkn2BJ;AwErw2BA;EzDsJI,iCAAA;Afkn2BJ;AwExw2BA;EzDmJI,sBAAA;Afwn2BJ;AwE3w2BA;EzDsJI,iCAAA;Afwn2BJ;AwE9w2BA;EzDmJI,sBAAA;Af8n2BJ;AwEjx2BA;EzDsJI,iCAAA;Af8n2BJ;AwEpx2BA;EzDmJI,sBAAA;Afoo2BJ;AwEvx2BA;EzDsJI,iCAAA;Afoo2BJ;AwE1x2BA;EzDmJI,sBAAA;Af0o2BJ;AwE7x2BA;EzDsJI,iCAAA;Af0o2BJ;AwEhy2BA;EzDmJI,sBAAA;Afgp2BJ;AwEny2BA;EzDsJI,iCAAA;Afgp2BJ;AwEty2BA;EzDmJI,sBAAA;Afsp2BJ;AwEzy2BA;EzDsJI,iCAAA;Afsp2BJ;AwE5y2BA;EzDmJI,sBAAA;Af4p2BJ;AwE/y2BA;EzDsJI,iCAAA;Af4p2BJ;AwElz2BA;EzDmJI,sBAAA;Afkq2BJ;AwErz2BA;EzDsJI,iCAAA;Afkq2BJ;AwExz2BA;EzDmJI,sBAAA;Afwq2BJ;AwE3z2BA;EzDsJI,iCAAA;Afwq2BJ;AwE9z2BA;EzDmJI,sBAAA;Af8q2BJ;AwEj02BA;EzDsJI,iCAAA;Af8q2BJ;AwEp02BA;EzDmJI,eAAA;Afor2BJ;AwEv02BA;EzDsJI,0BAAA;Afor2BJ;AwE102BA;EzDmJI,eAAA;Af0r2BJ;AwE702BA;EzDsJI,0BAAA;Af0r2BJ;AwEh12BA;EzDmJI,eAAA;Afgs2BJ;AwEn12BA;EzDsJI,0BAAA;Afgs2BJ;AwEt12BA;EzDmJI,eAAA;Afss2BJ;AwEz12BA;EzDsJI,0BAAA;Afss2BJ;AwE512BA;EzDmJI,eAAA;Af4s2BJ;AwE/12BA;EzDsJI,0BAAA;Af4s2BJ;AwEl22BA;EzDmJI,eAAA;Afkt2BJ;AwEr22BA;EzDsJI,0BAAA;Afkt2BJ;AwEx22BA;EzDmJI,eAAA;Afwt2BJ;AwE322BA;EzDsJI,0BAAA;Afwt2BJ;AwE922BA;EzDmJI,eAAA;Af8t2BJ;AwEj32BA;EzDsJI,0BAAA;Af8t2BJ;AwEp32BA;EzDmJI,eAAA;Afou2BJ;AwEv32BA;EzDsJI,0BAAA;Afou2BJ;AwE132BA;EzDmJI,eAAA;Af0u2BJ;AwE732BA;EzDsJI,0BAAA;Af0u2BJ;AwEh42BA;EzDmJI,eAAA;Afgv2BJ;AwEn42BA;EzDsJI,0BAAA;Afgv2BJ;AwEt42BA;EzDmJI,eAAA;Afsv2BJ;AwEz42BA;EzDsJI,0BAAA;Afsv2BJ;AwE542BA;EzDmJI,eAAA;Af4v2BJ;AwE/42BA;EzDsJI,0BAAA;Af4v2BJ;AwEl52BA;EzDmJI,eAAA;Afkw2BJ;AwEr52BA;EzDsJI,0BAAA;Afkw2BJ;AwEx52BA;EzDmJI,eAAA;Afww2BJ;AwE352BA;EzDsJI,0BAAA;Afww2BJ;AwE952BA;EzDmJI,eAAA;Af8w2BJ;AwEj62BA;EzDsJI,0BAAA;Af8w2BJ;AwEp62BA;EzDmJI,eAAA;Afox2BJ;AwEv62BA;EzDsJI,0BAAA;Afox2BJ;AwE162BA;EzDmJI,eAAA;Af0x2BJ;AwE762BA;EzDsJI,0BAAA;Af0x2BJ;AwEh72BA;EzDmJI,eAAA;Afgy2BJ;AwEn72BA;EzDsJI,0BAAA;Afgy2BJ;AwEt72BA;EzDmJI,eAAA;Afsy2BJ;AwEz72BA;EzDsJI,0BAAA;Afsy2BJ;AwE572BA;EzDmJI,eAAA;Af4y2BJ;AwE/72BA;EzDsJI,0BAAA;Af4y2BJ;AwEl82BA;EzDmJI,eAAA;Afkz2BJ;AwEr82BA;EzDsJI,0BAAA;Afkz2BJ;AwEx82BA;EzDmJI,eAAA;Afwz2BJ;AwE382BA;EzDsJI,0BAAA;Afwz2BJ;AwE982BA;EzDmJI,eAAA;Af8z2BJ;AwEj92BA;EzDsJI,0BAAA;Af8z2BJ;AwEp92BA;EzDmJI,eAAA;Afo02BJ;AwEv92BA;EzDsJI,0BAAA;Afo02BJ;AwE192BA;EzDmJI,eAAA;Af002BJ;AwE792BA;EzDsJI,0BAAA;Af002BJ;AwEh+2BA;EzDmJI,eAAA;Afg12BJ;AwEn+2BA;EzDsJI,0BAAA;Afg12BJ;AwEt+2BA;EzDmJI,eAAA;Afs12BJ;AwEz+2BA;EzDsJI,0BAAA;Afs12BJ;AwE5+2BA;EzDmJI,eAAA;Af412BJ;AwE/+2BA;EzDsJI,0BAAA;Af412BJ;AwEl/2BA;EzDmJI,eAAA;Afk22BJ;AwEr/2BA;EzDsJI,0BAAA;Afk22BJ;AwEx/2BA;EzDmJI,eAAA;Afw22BJ;AwE3/2BA;EzDsJI,0BAAA;Afw22BJ;AwE9/2BA;EzDmJI,eAAA;Af822BJ;AwEjg3BA;EzDsJI,0BAAA;Af822BJ;AwEpg3BA;EzDmJI,eAAA;Afo32BJ;AwEvg3BA;EzDsJI,0BAAA;Afo32BJ;AwE1g3BA;EzDmJI,eAAA;Af032BJ;AwE7g3BA;EzDsJI,0BAAA;Af032BJ;AwEhh3BA;EzDmJI,eAAA;Afg42BJ;AwEnh3BA;EzDsJI,0BAAA;Afg42BJ;AwEth3BA;EzDmJI,eAAA;Afs42BJ;AwEzh3BA;EzDsJI,0BAAA;Afs42BJ;AwE5h3BA;EzDmJI,eAAA;Af442BJ;AwE/h3BA;EzDsJI,0BAAA;Af442BJ;AwEli3BA;EzDmJI,eAAA;Afk52BJ;AwEri3BA;EzDsJI,0BAAA;Afk52BJ;AwExi3BA;EzDmJI,eAAA;Afw52BJ;AwE3i3BA;EzDsJI,0BAAA;Afw52BJ;AwE9i3BA;EzDmJI,eAAA;Af852BJ;AwEjj3BA;EzDsJI,0BAAA;Af852BJ;AwEpj3BA;EzDmJI,eAAA;Afo62BJ;AwEvj3BA;EzDsJI,0BAAA;Afo62BJ;AwE1j3BA;EzDmJI,eAAA;Af062BJ;AwE7j3BA;EzDsJI,0BAAA;Af062BJ;AwEhk3BA;EzDmJI,eAAA;Afg72BJ;AwEnk3BA;EzDsJI,0BAAA;Afg72BJ;AwEtk3BA;EzDmJI,eAAA;Afs72BJ;AwEzk3BA;EzDsJI,0BAAA;Afs72BJ;AwE5k3BA;EzDmJI,eAAA;Af472BJ;AwE/k3BA;EzDsJI,0BAAA;Af472BJ;AwEll3BA;EzDmJI,eAAA;Afk82BJ;AwErl3BA;EzDsJI,0BAAA;Afk82BJ;AwExl3BA;EzDmJI,eAAA;Afw82BJ;AwE3l3BA;EzDsJI,0BAAA;Afw82BJ;AwE9l3BA;EzDmJI,eAAA;Af882BJ;AwEjm3BA;EzDsJI,0BAAA;Af882BJ;AwEpm3BA;EzDmJI,eAAA;Afo92BJ;AwEvm3BA;EzDsJI,0BAAA;Afo92BJ;AwE1m3BA;EzDmJI,eAAA;Af092BJ;AwE7m3BA;EzDsJI,0BAAA;Af092BJ;AwEhn3BA;EzDmJI,eAAA;Afg+2BJ;AwEnn3BA;EzDsJI,0BAAA;Afg+2BJ;AwEtn3BA;EzDmJI,eAAA;Afs+2BJ;AwEzn3BA;EzDsJI,0BAAA;Afs+2BJ;AwE5n3BA;EzDmJI,eAAA;Af4+2BJ;AwE/n3BA;EzDsJI,0BAAA;Af4+2BJ;AwElo3BA;EzDmJI,eAAA;Afk/2BJ;AwEro3BA;EzDsJI,0BAAA;Afk/2BJ;AwExo3BA;EzDmJI,eAAA;Afw/2BJ;AwE3o3BA;EzDsJI,0BAAA;Afw/2BJ;AwE9o3BA;EzDmJI,eAAA;Af8/2BJ;AwEjp3BA;EzDsJI,0BAAA;Af8/2BJ;AwEpp3BA;EzDmJI,eAAA;Afog3BJ;AwEvp3BA;EzDsJI,0BAAA;Afog3BJ;AwE1p3BA;EzDmJI,eAAA;Af0g3BJ;AwE7p3BA;EzDsJI,0BAAA;Af0g3BJ;AwEhq3BA;EzDmJI,eAAA;Afgh3BJ;AwEnq3BA;EzDsJI,0BAAA;Afgh3BJ;AwEtq3BA;EzDmJI,eAAA;Afsh3BJ;AwEzq3BA;EzDsJI,0BAAA;Afsh3BJ;AwE5q3BA;EzDmJI,eAAA;Af4h3BJ;AwE/q3BA;EzDsJI,0BAAA;Af4h3BJ;AwElr3BA;EzDmJI,eAAA;Afki3BJ;AwErr3BA;EzDsJI,0BAAA;Afki3BJ;AwExr3BA;EzDmJI,eAAA;Afwi3BJ;AwE3r3BA;EzDsJI,0BAAA;Afwi3BJ;AwE9r3BA;EzDmJI,eAAA;Af8i3BJ;AwEjs3BA;EzDsJI,0BAAA;Af8i3BJ;AwEps3BA;EzDmJI,eAAA;Afoj3BJ;AwEvs3BA;EzDsJI,0BAAA;Afoj3BJ;AwE1s3BA;EzDmJI,eAAA;Af0j3BJ;AwE7s3BA;EzDsJI,0BAAA;Af0j3BJ;AwEht3BA;EzDmJI,eAAA;Afgk3BJ;AwEnt3BA;EzDsJI,0BAAA;Afgk3BJ;AwEtt3BA;EzDmJI,eAAA;Afsk3BJ;AwEzt3BA;EzDsJI,0BAAA;Afsk3BJ;AwE5t3BA;EzDmJI,eAAA;Af4k3BJ;AwE/t3BA;EzDsJI,0BAAA;Af4k3BJ;AwElu3BA;EzDmJI,eAAA;Afkl3BJ;AwEru3BA;EzDsJI,0BAAA;Afkl3BJ;AwExu3BA;EzDmJI,eAAA;Afwl3BJ;AwE3u3BA;EzDsJI,0BAAA;Afwl3BJ;AwE9u3BA;EzDmJI,eAAA;Af8l3BJ;AwEjv3BA;EzDsJI,0BAAA;Af8l3BJ;AwEpv3BA;EzDmJI,eAAA;Afom3BJ;AwEvv3BA;EzDsJI,0BAAA;Afom3BJ;AwE1v3BA;EzDmJI,eAAA;Af0m3BJ;AwE7v3BA;EzDsJI,0BAAA;Af0m3BJ;AwEhw3BA;EzDmJI,eAAA;Afgn3BJ;AwEnw3BA;EzDsJI,0BAAA;Afgn3BJ;AwEtw3BA;EzDmJI,eAAA;Afsn3BJ;AwEzw3BA;EzDsJI,0BAAA;Afsn3BJ;AwE5w3BA;EzDmJI,eAAA;Af4n3BJ;AwE/w3BA;EzDsJI,0BAAA;Af4n3BJ;AwElx3BA;EzDmJI,eAAA;Afko3BJ;AwErx3BA;EzDsJI,0BAAA;Afko3BJ;AwExx3BA;EzDmJI,eAAA;Afwo3BJ;AwE3x3BA;EzDsJI,0BAAA;Afwo3BJ;AwE9x3BA;EzDmJI,eAAA;Af8o3BJ;AwEjy3BA;EzDsJI,0BAAA;Af8o3BJ;AwEpy3BA;EzDmJI,eAAA;Afop3BJ;AwEvy3BA;EzDsJI,0BAAA;Afop3BJ;AwE1y3BA;EzDmJI,eAAA;Af0p3BJ;AwE7y3BA;EzDsJI,0BAAA;Af0p3BJ;AwEhz3BA;EzDmJI,eAAA;Afgq3BJ;AwEnz3BA;EzDsJI,0BAAA;Afgq3BJ;AwEtz3BA;EzDmJI,eAAA;Afsq3BJ;AwEzz3BA;EzDsJI,0BAAA;Afsq3BJ;AwE5z3BA;EzDmJI,eAAA;Af4q3BJ;AwE/z3BA;EzDsJI,0BAAA;Af4q3BJ;AwEl03BA;EzDmJI,eAAA;Afkr3BJ;AwEr03BA;EzDsJI,0BAAA;Afkr3BJ;AwEx03BA;EzDmJI,eAAA;Afwr3BJ;AwE303BA;EzDsJI,0BAAA;Afwr3BJ;AwE903BA;EzDmJI,eAAA;Af8r3BJ;AwEj13BA;EzDsJI,0BAAA;Af8r3BJ;AwEp13BA;EzDmJI,eAAA;Afos3BJ;AwEv13BA;EzDsJI,0BAAA;Afos3BJ;AwE113BA;EzDmJI,eAAA;Af0s3BJ;AwE713BA;EzDsJI,0BAAA;Af0s3BJ;AwEh23BA;EzDmJI,eAAA;Afgt3BJ;AwEn23BA;EzDsJI,0BAAA;Afgt3BJ;AwEt23BA;EzDmJI,eAAA;Afst3BJ;AwEz23BA;EzDsJI,0BAAA;Afst3BJ;AwE523BA;EzDmJI,eAAA;Af4t3BJ;AwE/23BA;EzDsJI,0BAAA;Af4t3BJ;AwEl33BA;EzDmJI,eAAA;Afku3BJ;AwEr33BA;EzDsJI,0BAAA;Afku3BJ;AwEx33BA;EzDmJI,eAAA;Afwu3BJ;AwE333BA;EzDsJI,0BAAA;Afwu3BJ;AwE933BA;EzDmJI,eAAA;Af8u3BJ;AwEj43BA;EzDsJI,0BAAA;Af8u3BJ;AwEp43BA;EzDmJI,eAAA;Afov3BJ;AwEv43BA;EzDsJI,0BAAA;Afov3BJ;AwE143BA;EzDmJI,eAAA;Af0v3BJ;AwE743BA;EzDsJI,0BAAA;Af0v3BJ;AwEh53BA;EzDmJI,eAAA;Afgw3BJ;AwEn53BA;EzDsJI,0BAAA;Afgw3BJ;AwEt53BA;EzDmJI,eAAA;Afsw3BJ;AwEz53BA;EzDsJI,0BAAA;Afsw3BJ;AwE553BA;EzDmJI,oBAAA;Af4w3BJ;AwE/53BA;EzDsJI,+BAAA;Af4w3BJ;AwEl63BA;EzDmJI,oBAAA;Afkx3BJ;AwEr63BA;EzDsJI,+BAAA;Afkx3BJ;AwEx63BA;EzDmJI,oBAAA;Afwx3BJ;AwE363BA;EzDsJI,+BAAA;Afwx3BJ;AwE963BA;EzDmJI,oBAAA;Af8x3BJ;AwEj73BA;EzDsJI,+BAAA;Af8x3BJ;AwEp73BA;EzDmJI,oBAAA;Afoy3BJ;AwEv73BA;EzDsJI,+BAAA;Afoy3BJ;AwE173BA;EzDmJI,oBAAA;Af0y3BJ;AwE773BA;EzDsJI,+BAAA;Af0y3BJ;AwEh83BA;EzDmJI,oBAAA;Afgz3BJ;AwEn83BA;EzDsJI,+BAAA;Afgz3BJ;AwEt83BA;EzDmJI,oBAAA;Afsz3BJ;AwEz83BA;EzDsJI,+BAAA;Afsz3BJ;AwE583BA;EzDmJI,oBAAA;Af4z3BJ;AwE/83BA;EzDsJI,+BAAA;Af4z3BJ;AwEl93BA;EzDmJI,oBAAA;Afk03BJ;AwEr93BA;EzDsJI,+BAAA;Afk03BJ;AwEx93BA;EzDmJI,oBAAA;Afw03BJ;AwE393BA;EzDsJI,+BAAA;Afw03BJ;AwE993BA;EzDmJI,oBAAA;Af803BJ;AwEj+3BA;EzDsJI,+BAAA;Af803BJ;AwEp+3BA;EzDmJI,oBAAA;Afo13BJ;AwEv+3BA;EzDsJI,+BAAA;Afo13BJ;AwE1+3BA;EzDmJI,oBAAA;Af013BJ;AwE7+3BA;EzDsJI,+BAAA;Af013BJ;AwEh/3BA;EzDmJI,oBAAA;Afg23BJ;AwEn/3BA;EzDsJI,+BAAA;Afg23BJ;AwEt/3BA;EzDmJI,oBAAA;Afs23BJ;AwEz/3BA;EzDsJI,+BAAA;Afs23BJ;AwE5/3BA;EzDmJI,oBAAA;Af423BJ;AwE//3BA;EzDsJI,+BAAA;Af423BJ;AwElg4BA;EzDmJI,oBAAA;Afk33BJ;AwErg4BA;EzDsJI,+BAAA;Afk33BJ;AwExg4BA;EzDmJI,oBAAA;Afw33BJ;AwE3g4BA;EzDsJI,+BAAA;Afw33BJ;AwE9g4BA;EzDmJI,oBAAA;Af833BJ;AwEjh4BA;EzDsJI,+BAAA;Af833BJ;AwEph4BA;EzDmJI,oBAAA;Afo43BJ;AwEvh4BA;EzDsJI,+BAAA;Afo43BJ;AwE1h4BA;EzDmJI,oBAAA;Af043BJ;AwE7h4BA;EzDsJI,+BAAA;Af043BJ;AwEhi4BA;EzDmJI,oBAAA;Afg53BJ;AwEni4BA;EzDsJI,+BAAA;Afg53BJ;AwEti4BA;EzDmJI,oBAAA;Afs53BJ;AwEzi4BA;EzDsJI,+BAAA;Afs53BJ;AwE5i4BA;EzDmJI,oBAAA;Af453BJ;AwE/i4BA;EzDsJI,+BAAA;Af453BJ;AwElj4BA;EzDmJI,oBAAA;Afk63BJ;AwErj4BA;EzDsJI,+BAAA;Afk63BJ;AwExj4BA;EzDmJI,oBAAA;Afw63BJ;AwE3j4BA;EzDsJI,+BAAA;Afw63BJ;AwE9j4BA;EzDmJI,oBAAA;Af863BJ;AwEjk4BA;EzDsJI,+BAAA;Af863BJ;AwEpk4BA;EzDmJI,oBAAA;Afo73BJ;AwEvk4BA;EzDsJI,+BAAA;Afo73BJ;AwE1k4BA;EzDmJI,oBAAA;Af073BJ;AwE7k4BA;EzDsJI,+BAAA;Af073BJ;AwEhl4BA;EzDmJI,oBAAA;Afg83BJ;AwEnl4BA;EzDsJI,+BAAA;Afg83BJ;AwEtl4BA;EzDmJI,oBAAA;Afs83BJ;AwEzl4BA;EzDsJI,+BAAA;Afs83BJ;AwE5l4BA;EzDmJI,oBAAA;Af483BJ;AwE/l4BA;EzDsJI,+BAAA;Af483BJ;AwElm4BA;EzDmJI,oBAAA;Afk93BJ;AwErm4BA;EzDsJI,+BAAA;Afk93BJ;AwExm4BA;EzDmJI,oBAAA;Afw93BJ;AwE3m4BA;EzDsJI,+BAAA;Afw93BJ;AwE9m4BA;EzDmJI,oBAAA;Af893BJ;AwEjn4BA;EzDsJI,+BAAA;Af893BJ;AwEpn4BA;EzDmJI,oBAAA;Afo+3BJ;AwEvn4BA;EzDsJI,+BAAA;Afo+3BJ;AwE1n4BA;EzDmJI,oBAAA;Af0+3BJ;AwE7n4BA;EzDsJI,+BAAA;Af0+3BJ;AwEho4BA;EzDmJI,oBAAA;Afg/3BJ;AwEno4BA;EzDsJI,+BAAA;Afg/3BJ;AwEto4BA;EzDmJI,oBAAA;Afs/3BJ;AwEzo4BA;EzDsJI,+BAAA;Afs/3BJ;AwE5o4BA;EzDmJI,oBAAA;Af4/3BJ;AwE/o4BA;EzDsJI,+BAAA;Af4/3BJ;AwElp4BA;EzDmJI,oBAAA;Afkg4BJ;AwErp4BA;EzDsJI,+BAAA;Afkg4BJ;AwExp4BA;EzDmJI,oBAAA;Afwg4BJ;AwE3p4BA;EzDsJI,+BAAA;Afwg4BJ;AwE9p4BA;EzDmJI,oBAAA;Af8g4BJ;AwEjq4BA;EzDsJI,+BAAA;Af8g4BJ;AwEpq4BA;EzDmJI,oBAAA;Afoh4BJ;AwEvq4BA;EzDsJI,+BAAA;Afoh4BJ;AwE1q4BA;EzDmJI,oBAAA;Af0h4BJ;AwE7q4BA;EzDsJI,+BAAA;Af0h4BJ;AwEhr4BA;EzDmJI,oBAAA;Afgi4BJ;AwEnr4BA;EzDsJI,+BAAA;Afgi4BJ;AwEtr4BA;EzDmJI,oBAAA;Afsi4BJ;AwEzr4BA;EzDsJI,+BAAA;Afsi4BJ;AwE5r4BA;EzDmJI,oBAAA;Af4i4BJ;AwE/r4BA;EzDsJI,+BAAA;Af4i4BJ;AwEls4BA;EzDmJI,oBAAA;Afkj4BJ;AwErs4BA;EzDsJI,+BAAA;Afkj4BJ;AwExs4BA;EzDmJI,oBAAA;Afwj4BJ;AwE3s4BA;EzDsJI,+BAAA;Afwj4BJ;AwE9s4BA;EzDmJI,oBAAA;Af8j4BJ;AwEjt4BA;EzDsJI,+BAAA;Af8j4BJ;AwEpt4BA;EzDmJI,oBAAA;Afok4BJ;AwEvt4BA;EzDsJI,+BAAA;Afok4BJ;AwE1t4BA;EzDmJI,oBAAA;Af0k4BJ;AwE7t4BA;EzDsJI,+BAAA;Af0k4BJ;AwEhu4BA;EzDmJI,oBAAA;Afgl4BJ;AwEnu4BA;EzDsJI,+BAAA;Afgl4BJ;AwEtu4BA;EzDmJI,oBAAA;Afsl4BJ;AwEzu4BA;EzDsJI,+BAAA;Afsl4BJ;AwE5u4BA;EzDmJI,oBAAA;Af4l4BJ;AwE/u4BA;EzDsJI,+BAAA;Af4l4BJ;AwElv4BA;EzDmJI,oBAAA;Afkm4BJ;AwErv4BA;EzDsJI,+BAAA;Afkm4BJ;AwExv4BA;EzDmJI,oBAAA;Afwm4BJ;AwE3v4BA;EzDsJI,+BAAA;Afwm4BJ;AwE9v4BA;EzDmJI,oBAAA;Af8m4BJ;AwEjw4BA;EzDsJI,+BAAA;Af8m4BJ;AwEpw4BA;EzDmJI,oBAAA;Afon4BJ;AwEvw4BA;EzDsJI,+BAAA;Afon4BJ;AwE1w4BA;EzDmJI,oBAAA;Af0n4BJ;AwE7w4BA;EzDsJI,+BAAA;Af0n4BJ;AwEhx4BA;EzDmJI,oBAAA;Afgo4BJ;AwEnx4BA;EzDsJI,+BAAA;Afgo4BJ;AwEtx4BA;EzDmJI,oBAAA;Afso4BJ;AwEzx4BA;EzDsJI,+BAAA;Afso4BJ;AwE5x4BA;EzDmJI,oBAAA;Af4o4BJ;AwE/x4BA;EzDsJI,+BAAA;Af4o4BJ;AwEly4BA;EzDmJI,oBAAA;Afkp4BJ;AwEry4BA;EzDsJI,+BAAA;Afkp4BJ;AwExy4BA;EzDmJI,oBAAA;Afwp4BJ;AwE3y4BA;EzDsJI,+BAAA;Afwp4BJ;AwE9y4BA;EzDmJI,oBAAA;Af8p4BJ;AwEjz4BA;EzDsJI,+BAAA;Af8p4BJ;AwEpz4BA;EzDmJI,oBAAA;Afoq4BJ;AwEvz4BA;EzDsJI,+BAAA;Afoq4BJ;AwE1z4BA;EzDmJI,oBAAA;Af0q4BJ;AwE7z4BA;EzDsJI,+BAAA;Af0q4BJ;AwEh04BA;EzDmJI,yBAAA;Afgr4BJ;AwEn04BA;EzDsJI,oCAAA;Afgr4BJ;AwEt04BA;EzDmJI,yBAAA;Afsr4BJ;AwEz04BA;EzDsJI,oCAAA;Afsr4BJ;AwE504BA;EzDmJI,yBAAA;Af4r4BJ;AwE/04BA;EzDsJI,oCAAA;Af4r4BJ;AwEl14BA;EzDmJI,yBAAA;Afks4BJ;AwEr14BA;EzDsJI,oCAAA;Afks4BJ;AwEx14BA;EzDmJI,yBAAA;Afws4BJ;AwE314BA;EzDsJI,oCAAA;Afws4BJ;AwE914BA;EzDmJI,yBAAA;Af8s4BJ;AwEj24BA;EzDsJI,oCAAA;Af8s4BJ;AwEp24BA;EzDmJI,yBAAA;Afot4BJ;AwEv24BA;EzDsJI,oCAAA;Afot4BJ;AwE124BA;EzDmJI,yBAAA;Af0t4BJ;AwE724BA;EzDsJI,oCAAA;Af0t4BJ;AwEh34BA;EzDmJI,yBAAA;Afgu4BJ;AwEn34BA;EzDsJI,oCAAA;Afgu4BJ;AwEt34BA;EzDmJI,yBAAA;Afsu4BJ;AwEz34BA;EzDsJI,oCAAA;Afsu4BJ;AwE534BA;EzDmJI,yBAAA;Af4u4BJ;AwE/34BA;EzDsJI,oCAAA;Af4u4BJ;AwEl44BA;EzDmJI,yBAAA;Afkv4BJ;AwEr44BA;EzDsJI,oCAAA;Afkv4BJ;AwEx44BA;EzDmJI,yBAAA;Afwv4BJ;AwE344BA;EzDsJI,oCAAA;Afwv4BJ;AwE944BA;EzDmJI,yBAAA;Af8v4BJ;AwEj54BA;EzDsJI,oCAAA;Af8v4BJ;AwEp54BA;EzDmJI,yBAAA;Afow4BJ;AwEv54BA;EzDsJI,oCAAA;Afow4BJ;AwE154BA;EzDmJI,yBAAA;Af0w4BJ;AwE754BA;EzDsJI,oCAAA;Af0w4BJ;AwEh64BA;EzDmJI,yBAAA;Afgx4BJ;AwEn64BA;EzDsJI,oCAAA;Afgx4BJ;AwEt64BA;EzDmJI,yBAAA;Afsx4BJ;AwEz64BA;EzDsJI,oCAAA;Afsx4BJ;AwE564BA;EzDmJI,yBAAA;Af4x4BJ;AwE/64BA;EzDsJI,oCAAA;Af4x4BJ;AwEl74BA;EzDmJI,yBAAA;Afky4BJ;AwEr74BA;EzDsJI,oCAAA;Afky4BJ;AwEx74BA;EzDmJI,yBAAA;Afwy4BJ;AwE374BA;EzDsJI,oCAAA;Afwy4BJ;AwE974BA;EzDmJI,yBAAA;Af8y4BJ;AwEj84BA;EzDsJI,oCAAA;Af8y4BJ;AwEp84BA;EzDmJI,yBAAA;Afoz4BJ;AwEv84BA;EzDsJI,oCAAA;Afoz4BJ;AwE184BA;EzDmJI,yBAAA;Af0z4BJ;AwE784BA;EzDsJI,oCAAA;Af0z4BJ;AwEh94BA;EzDmJI,yBAAA;Afg04BJ;AwEn94BA;EzDsJI,oCAAA;Afg04BJ;AwEt94BA;EzDmJI,yBAAA;Afs04BJ;AwEz94BA;EzDsJI,oCAAA;Afs04BJ;AwE594BA;EzDmJI,yBAAA;Af404BJ;AwE/94BA;EzDsJI,oCAAA;Af404BJ;AwEl+4BA;EzDmJI,yBAAA;Afk14BJ;AwEr+4BA;EzDsJI,oCAAA;Afk14BJ;AwEx+4BA;EzDmJI,yBAAA;Afw14BJ;AwE3+4BA;EzDsJI,oCAAA;Afw14BJ;AwE9+4BA;EzDmJI,yBAAA;Af814BJ;AwEj/4BA;EzDsJI,oCAAA;Af814BJ;AwEp/4BA;EzDmJI,6BAAA;Afo24BJ;AwEv/4BA;EzDsJI,wCAAA;Afo24BJ;AwE1/4BA;EzDmJI,6BAAA;Af024BJ;AwE7/4BA;EzDsJI,wCAAA;Af024BJ;AwEhg5BA;EzDmJI,6BAAA;Afg34BJ;AwEng5BA;EzDsJI,wCAAA;Afg34BJ;AwEtg5BA;EzDmJI,6BAAA;Afs34BJ;AwEzg5BA;EzDsJI,wCAAA;Afs34BJ;AwE5g5BA;EzDmJI,6BAAA;Af434BJ;AwE/g5BA;EzDsJI,wCAAA;Af434BJ;AwElh5BA;EzDmJI,6BAAA;Afk44BJ;AwErh5BA;EzDsJI,wCAAA;Afk44BJ;AwExh5BA;EzDmJI,6BAAA;Afw44BJ;AwE3h5BA;EzDsJI,wCAAA;Afw44BJ;AwE9h5BA;EzDmJI,6BAAA;Af844BJ;AwEji5BA;EzDsJI,wCAAA;Af844BJ;AwEpi5BA;EzDmJI,6BAAA;Afo54BJ;AwEvi5BA;EzDsJI,wCAAA;Afo54BJ;AwE1i5BA;EzDmJI,6BAAA;Af054BJ;AwE7i5BA;EzDsJI,wCAAA;Af054BJ;AwEhj5BA;EzDmJI,6BAAA;Afg64BJ;AwEnj5BA;EzDsJI,wCAAA;Afg64BJ;AwEtj5BA;EzDmJI,6BAAA;Afs64BJ;AwEzj5BA;EzDsJI,wCAAA;Afs64BJ;AwE5j5BA;EzDmJI,6BAAA;Af464BJ;AwE/j5BA;EzDsJI,wCAAA;Af464BJ;AwElk5BA;EzDmJI,6BAAA;Afk74BJ;AwErk5BA;EzDsJI,wCAAA;Afk74BJ;AwExk5BA;EzDmJI,6BAAA;Afw74BJ;AwE3k5BA;EzDsJI,wCAAA;Afw74BJ;AwE9k5BA;EzDmJI,6BAAA;Af874BJ;AwEjl5BA;EzDsJI,wCAAA;Af874BJ;AwEpl5BA;EzDmJI,6BAAA;Afo84BJ;AwEvl5BA;EzDsJI,wCAAA;Afo84BJ;AwE1l5BA;EzDmJI,6BAAA;Af084BJ;AwE7l5BA;EzDsJI,wCAAA;Af084BJ;AwEhm5BA;EzDmJI,6BAAA;Afg94BJ;AwEnm5BA;EzDsJI,wCAAA;Afg94BJ;AwEtm5BA;EzDmJI,6BAAA;Afs94BJ;AwEzm5BA;EzDsJI,wCAAA;Afs94BJ;AwE5m5BA;EzDmJI,+BAAA;Af494BJ;AwE/m5BA;EzDsJI,0CAAA;Af494BJ;AwEln5BA;EzDmJI,+BAAA;Afk+4BJ;AwErn5BA;EzDsJI,0CAAA;Afk+4BJ;AwExn5BA;EzDmJI,+BAAA;Afw+4BJ;AwE3n5BA;EzDsJI,0CAAA;Afw+4BJ;AwE9n5BA;EzDmJI,+BAAA;Af8+4BJ;AwEjo5BA;EzDsJI,0CAAA;Af8+4BJ;AwEpo5BA;EzDmJI,+BAAA;Afo/4BJ;AwEvo5BA;EzDsJI,0CAAA;Afo/4BJ;AwE1o5BA;EzDmJI,+BAAA;Af0/4BJ;AwE7o5BA;EzDsJI,0CAAA;Af0/4BJ;AwEhp5BA;EzDmJI,+BAAA;Afgg5BJ;AwEnp5BA;EzDsJI,0CAAA;Afgg5BJ;AwEtp5BA;EzDmJI,+BAAA;Afsg5BJ;AwEzp5BA;EzDsJI,0CAAA;Afsg5BJ;AwE5p5BA;EzDmJI,+BAAA;Af4g5BJ;AwE/p5BA;EzDsJI,0CAAA;Af4g5BJ;AwElq5BA;EzDmJI,+BAAA;Afkh5BJ;AwErq5BA;EzDsJI,0CAAA;Afkh5BJ;AwExq5BA;EzDmJI,+BAAA;Afwh5BJ;AwE3q5BA;EzDsJI,0CAAA;Afwh5BJ;AwE9q5BA;EzDmJI,+BAAA;Af8h5BJ;AwEjr5BA;EzDsJI,0CAAA;Af8h5BJ;AwEpr5BA;EzDmJI,+BAAA;Afoi5BJ;AwEvr5BA;EzDsJI,0CAAA;Afoi5BJ;AwE1r5BA;EzDmJI,+BAAA;Af0i5BJ;AwE7r5BA;EzDsJI,0CAAA;Af0i5BJ;AwEhs5BA;EzDmJI,+BAAA;Afgj5BJ;AwEns5BA;EzDsJI,0CAAA;Afgj5BJ;AwEts5BA;EzDmJI,+BAAA;Afsj5BJ;AwEzs5BA;EzDsJI,0CAAA;Afsj5BJ;AwE5s5BA;EzDmJI,+BAAA;Af4j5BJ;AwE/s5BA;EzDsJI,0CAAA;Af4j5BJ;AwElt5BA;EzDmJI,+BAAA;Afkk5BJ;AwErt5BA;EzDsJI,0CAAA;Afkk5BJ;AwExt5BA;EzDmJI,+BAAA;Afwk5BJ;AwE3t5BA;EzDsJI,0CAAA;Afwk5BJ;AwE9t5BA;EzDmJI,+BAAA;Af8k5BJ;AwEju5BA;EzDsJI,0CAAA;Af8k5BJ;AwEpu5BA;EzDmJI,gCAAA;Afol5BJ;AwEvu5BA;EzDsJI,2CAAA;Afol5BJ;AwE1u5BA;EzDmJI,gCAAA;Af0l5BJ;AwE7u5BA;EzDsJI,2CAAA;Af0l5BJ;AwEhv5BA;EzDmJI,gCAAA;Afgm5BJ;AwEnv5BA;EzDsJI,2CAAA;Afgm5BJ;AwEtv5BA;EzDmJI,gCAAA;Afsm5BJ;AwEzv5BA;EzDsJI,2CAAA;Afsm5BJ;AwE5v5BA;EzDmJI,gCAAA;Af4m5BJ;AwE/v5BA;EzDsJI,2CAAA;Af4m5BJ;AwElw5BA;EzDmJI,gCAAA;Afkn5BJ;AwErw5BA;EzDsJI,2CAAA;Afkn5BJ;AwExw5BA;EzDmJI,gCAAA;Afwn5BJ;AwE3w5BA;EzDsJI,2CAAA;Afwn5BJ;AwE9w5BA;EzDmJI,gCAAA;Af8n5BJ;AwEjx5BA;EzDsJI,2CAAA;Af8n5BJ;AwEpx5BA;EzDmJI,gCAAA;Afoo5BJ;AwEvx5BA;EzDsJI,2CAAA;Afoo5BJ;AwE1x5BA;EzDmJI,gCAAA;Af0o5BJ;AwE7x5BA;EzDsJI,2CAAA;Af0o5BJ;AwEhy5BA;EzDmJI,gCAAA;Afgp5BJ;AwEny5BA;EzDsJI,2CAAA;Afgp5BJ;AwEty5BA;EzDmJI,gCAAA;Afsp5BJ;AwEzy5BA;EzDsJI,2CAAA;Afsp5BJ;AwE5y5BA;EzDmJI,gCAAA;Af4p5BJ;AwE/y5BA;EzDsJI,2CAAA;Af4p5BJ;AwElz5BA;EzDmJI,gCAAA;Afkq5BJ;AwErz5BA;EzDsJI,2CAAA;Afkq5BJ;AwExz5BA;EzDmJI,gCAAA;Afwq5BJ;AwE3z5BA;EzDsJI,2CAAA;Afwq5BJ;AwE9z5BA;EzDmJI,gCAAA;Af8q5BJ;AwEj05BA;EzDsJI,2CAAA;Af8q5BJ;AwEp05BA;EzDmJI,gCAAA;Afor5BJ;AwEv05BA;EzDsJI,2CAAA;Afor5BJ;AwE105BA;EzDmJI,gCAAA;Af0r5BJ;AwE705BA;EzDsJI,2CAAA;Af0r5BJ;AwEh15BA;EzDmJI,gCAAA;Afgs5BJ;AwEn15BA;EzDsJI,2CAAA;Afgs5BJ;AwEt15BA;EzDmJI,gCAAA;Afss5BJ;AwEz15BA;EzDsJI,2CAAA;Afss5BJ;AwE515BA;EzDmJI,8BAAA;Af4s5BJ;AwE/15BA;EzDsJI,yCAAA;Af4s5BJ;AwEl25BA;EzDmJI,8BAAA;Afkt5BJ;AwEr25BA;EzDsJI,yCAAA;Afkt5BJ;AwEx25BA;EzDmJI,8BAAA;Afwt5BJ;AwE325BA;EzDsJI,yCAAA;Afwt5BJ;AwE925BA;EzDmJI,8BAAA;Af8t5BJ;AwEj35BA;EzDsJI,yCAAA;Af8t5BJ;AwEp35BA;EzDmJI,8BAAA;Afou5BJ;AwEv35BA;EzDsJI,yCAAA;Afou5BJ;AwE135BA;EzDmJI,8BAAA;Af0u5BJ;AwE735BA;EzDsJI,yCAAA;Af0u5BJ;AwEh45BA;EzDmJI,8BAAA;Afgv5BJ;AwEn45BA;EzDsJI,yCAAA;Afgv5BJ;AwEt45BA;EzDmJI,8BAAA;Afsv5BJ;AwEz45BA;EzDsJI,yCAAA;Afsv5BJ;AwE545BA;EzDmJI,8BAAA;Af4v5BJ;AwE/45BA;EzDsJI,yCAAA;Af4v5BJ;AwEl55BA;EzDmJI,8BAAA;Afkw5BJ;AwEr55BA;EzDsJI,yCAAA;Afkw5BJ;AwEx55BA;EzDmJI,8BAAA;Afww5BJ;AwE355BA;EzDsJI,yCAAA;Afww5BJ;AwE955BA;EzDmJI,8BAAA;Af8w5BJ;AwEj65BA;EzDsJI,yCAAA;Af8w5BJ;AwEp65BA;EzDmJI,8BAAA;Afox5BJ;AwEv65BA;EzDsJI,yCAAA;Afox5BJ;AwE165BA;EzDmJI,8BAAA;Af0x5BJ;AwE765BA;EzDsJI,yCAAA;Af0x5BJ;AwEh75BA;EzDmJI,8BAAA;Afgy5BJ;AwEn75BA;EzDsJI,yCAAA;Afgy5BJ;AwEt75BA;EzDmJI,8BAAA;Afsy5BJ;AwEz75BA;EzDsJI,yCAAA;Afsy5BJ;AwE575BA;EzDmJI,8BAAA;Af4y5BJ;AwE/75BA;EzDsJI,yCAAA;Af4y5BJ;AwEl85BA;EzDmJI,8BAAA;Afkz5BJ;AwEr85BA;EzDsJI,yCAAA;Afkz5BJ;AwEx85BA;EzDmJI,8BAAA;Afwz5BJ;AwE385BA;EzDsJI,yCAAA;Afwz5BJ;AwE985BA;EzDmJI,8BAAA;Af8z5BJ;AwEj95BA;EzDsJI,yCAAA;Af8z5BJ;AwEp95BA;EzDmJI,sBAAA;Afo05BJ;AwEv95BA;EzDsJI,iCAAA;Afo05BJ;AwE195BA;EzDmJI,sBAAA;Af005BJ;AwE795BA;EzDsJI,iCAAA;Af005BJ;AwEh+5BA;EzDmJI,sBAAA;Afg15BJ;AwEn+5BA;EzDsJI,iCAAA;Afg15BJ;AwEt+5BA;EzDmJI,sBAAA;Afs15BJ;AwEz+5BA;EzDsJI,iCAAA;Afs15BJ;AwE5+5BA;EzDmJI,sBAAA;Af415BJ;AwE/+5BA;EzDsJI,iCAAA;Af415BJ;AwEl/5BA;EzDmJI,sBAAA;Afk25BJ;AwEr/5BA;EzDsJI,iCAAA;Afk25BJ;AwEx/5BA;EzDmJI,sBAAA;Afw25BJ;AwE3/5BA;EzDsJI,iCAAA;Afw25BJ;AwE9/5BA;EzDmJI,sBAAA;Af825BJ;AwEjg6BA;EzDsJI,iCAAA;Af825BJ;AwEpg6BA;EzDmJI,sBAAA;Afo35BJ;AwEvg6BA;EzDsJI,iCAAA;Afo35BJ;AwE1g6BA;EzDmJI,sBAAA;Af035BJ;AwE7g6BA;EzDsJI,iCAAA;Af035BJ;AwEhh6BA;EzDmJI,sBAAA;Afg45BJ;AwEnh6BA;EzDsJI,iCAAA;Afg45BJ;AwEth6BA;EzDmJI,sBAAA;Afs45BJ;AwEzh6BA;EzDsJI,iCAAA;Afs45BJ;AwE5h6BA;EzDmJI,sBAAA;Af445BJ;AwE/h6BA;EzDsJI,iCAAA;Af445BJ;AwEli6BA;EzDmJI,sBAAA;Afk55BJ;AwEri6BA;EzDsJI,iCAAA;Afk55BJ;AwExi6BA;EzDmJI,sBAAA;Afw55BJ;AwE3i6BA;EzDsJI,iCAAA;Afw55BJ;AwE9i6BA;EzDmJI,sBAAA;Af855BJ;AwEjj6BA;EzDsJI,iCAAA;Af855BJ;AwEpj6BA;EzDmJI,sBAAA;Afo65BJ;AwEvj6BA;EzDsJI,iCAAA;Afo65BJ;AwE1j6BA;EzDmJI,sBAAA;Af065BJ;AwE7j6BA;EzDsJI,iCAAA;Af065BJ;AwEhk6BA;EzDmJI,sBAAA;Afg75BJ;AwEnk6BA;EzDsJI,iCAAA;Afg75BJ;AwEtk6BA;EzDmJI,sBAAA;Afs75BJ;AwEzk6BA;EzDsJI,iCAAA;Afs75BJ;AwE5k6BA;EzDmJI,eAAA;Af475BJ;AwE/k6BA;EzDsJI,0BAAA;Af475BJ;AwEll6BA;EzDmJI,eAAA;Afk85BJ;AwErl6BA;EzDsJI,0BAAA;Afk85BJ;AwExl6BA;EzDmJI,eAAA;Afw85BJ;AwE3l6BA;EzDsJI,0BAAA;Afw85BJ;AwE9l6BA;EzDmJI,eAAA;Af885BJ;AwEjm6BA;EzDsJI,0BAAA;Af885BJ;AwEpm6BA;EzDmJI,eAAA;Afo95BJ;AwEvm6BA;EzDsJI,0BAAA;Afo95BJ;AwE1m6BA;EzDmJI,eAAA;Af095BJ;AwE7m6BA;EzDsJI,0BAAA;Af095BJ;AwEhn6BA;EzDmJI,eAAA;Afg+5BJ;AwEnn6BA;EzDsJI,0BAAA;Afg+5BJ;AwEtn6BA;EzDmJI,eAAA;Afs+5BJ;AwEzn6BA;EzDsJI,0BAAA;Afs+5BJ;AwE5n6BA;EzDmJI,eAAA;Af4+5BJ;AwE/n6BA;EzDsJI,0BAAA;Af4+5BJ;AwElo6BA;EzDmJI,eAAA;Afk/5BJ;AwEro6BA;EzDsJI,0BAAA;Afk/5BJ;AwExo6BA;EzDmJI,eAAA;Afw/5BJ;AwE3o6BA;EzDsJI,0BAAA;Afw/5BJ;AwE9o6BA;EzDmJI,eAAA;Af8/5BJ;AwEjp6BA;EzDsJI,0BAAA;Af8/5BJ;AwEpp6BA;EzDmJI,eAAA;Afog6BJ;AwEvp6BA;EzDsJI,0BAAA;Afog6BJ;AwE1p6BA;EzDmJI,eAAA;Af0g6BJ;AwE7p6BA;EzDsJI,0BAAA;Af0g6BJ;AwEhq6BA;EzDmJI,eAAA;Afgh6BJ;AwEnq6BA;EzDsJI,0BAAA;Afgh6BJ;AwEtq6BA;EzDmJI,eAAA;Afsh6BJ;AwEzq6BA;EzDsJI,0BAAA;Afsh6BJ;AwE5q6BA;EzDmJI,eAAA;Af4h6BJ;AwE/q6BA;EzDsJI,0BAAA;Af4h6BJ;AwElr6BA;EzDmJI,eAAA;Afki6BJ;AwErr6BA;EzDsJI,0BAAA;Afki6BJ;AwExr6BA;EzDmJI,eAAA;Afwi6BJ;AwE3r6BA;EzDsJI,0BAAA;Afwi6BJ;AwE9r6BA;EzDmJI,eAAA;Af8i6BJ;AwEjs6BA;EzDsJI,0BAAA;Af8i6BJ;AwEps6BA;EzDmJI,eAAA;Afoj6BJ;AwEvs6BA;EzDsJI,0BAAA;Afoj6BJ;AwE1s6BA;EzDmJI,eAAA;Af0j6BJ;AwE7s6BA;EzDsJI,0BAAA;Af0j6BJ;AwEht6BA;EzDmJI,eAAA;Afgk6BJ;AwEnt6BA;EzDsJI,0BAAA;Afgk6BJ;AwEtt6BA;EzDmJI,eAAA;Afsk6BJ;AwEzt6BA;EzDsJI,0BAAA;Afsk6BJ;AwE5t6BA;EzDmJI,eAAA;Af4k6BJ;AwE/t6BA;EzDsJI,0BAAA;Af4k6BJ;AwElu6BA;EzDmJI,eAAA;Afkl6BJ;AwEru6BA;EzDsJI,0BAAA;Afkl6BJ;AwExu6BA;EzDmJI,eAAA;Afwl6BJ;AwE3u6BA;EzDsJI,0BAAA;Afwl6BJ;AwE9u6BA;EzDmJI,eAAA;Af8l6BJ;AwEjv6BA;EzDsJI,0BAAA;Af8l6BJ;AwEpv6BA;EzDmJI,eAAA;Afom6BJ;AwEvv6BA;EzDsJI,0BAAA;Afom6BJ;AwE1v6BA;EzDmJI,eAAA;Af0m6BJ;AwE7v6BA;EzDsJI,0BAAA;Af0m6BJ;AwEhw6BA;EzDmJI,eAAA;Afgn6BJ;AwEnw6BA;EzDsJI,0BAAA;Afgn6BJ;AwEtw6BA;EzDmJI,eAAA;Afsn6BJ;AwEzw6BA;EzDsJI,0BAAA;Afsn6BJ;AwE5w6BA;EzDmJI,eAAA;Af4n6BJ;AwE/w6BA;EzDsJI,0BAAA;Af4n6BJ;AwElx6BA;EzDmJI,eAAA;Afko6BJ;AwErx6BA;EzDsJI,0BAAA;Afko6BJ;AwExx6BA;EzDmJI,eAAA;Afwo6BJ;AwE3x6BA;EzDsJI,0BAAA;Afwo6BJ;AwE9x6BA;EzDmJI,eAAA;Af8o6BJ;AwEjy6BA;EzDsJI,0BAAA;Af8o6BJ;AwEpy6BA;EzDmJI,eAAA;Afop6BJ;AwEvy6BA;EzDsJI,0BAAA;Afop6BJ;AwE1y6BA;EzDmJI,eAAA;Af0p6BJ;AwE7y6BA;EzDsJI,0BAAA;Af0p6BJ;AwEhz6BA;EzDmJI,eAAA;Afgq6BJ;AwEnz6BA;EzDsJI,0BAAA;Afgq6BJ;AwEtz6BA;EzDmJI,eAAA;Afsq6BJ;AwEzz6BA;EzDsJI,0BAAA;Afsq6BJ;AwE5z6BA;EzDmJI,eAAA;Af4q6BJ;AwE/z6BA;EzDsJI,0BAAA;Af4q6BJ;AwEl06BA;EzDmJI,eAAA;Afkr6BJ;AwEr06BA;EzDsJI,0BAAA;Afkr6BJ;AwEx06BA;EzDmJI,eAAA;Afwr6BJ;AwE306BA;EzDsJI,0BAAA;Afwr6BJ;AwE906BA;EzDmJI,eAAA;Af8r6BJ;AwEj16BA;EzDsJI,0BAAA;Af8r6BJ;AwEp16BA;EzDmJI,eAAA;Afos6BJ;AwEv16BA;EzDsJI,0BAAA;Afos6BJ;AwE116BA;EzDmJI,eAAA;Af0s6BJ;AwE716BA;EzDsJI,0BAAA;Af0s6BJ;AwEh26BA;EzDmJI,eAAA;Afgt6BJ;AwEn26BA;EzDsJI,0BAAA;Afgt6BJ;AwEt26BA;EzDmJI,eAAA;Afst6BJ;AwEz26BA;EzDsJI,0BAAA;Afst6BJ;AwE526BA;EzDmJI,eAAA;Af4t6BJ;AwE/26BA;EzDsJI,0BAAA;Af4t6BJ;AwEl36BA;EzDmJI,eAAA;Afku6BJ;AwEr36BA;EzDsJI,0BAAA;Afku6BJ;AwEx36BA;EzDmJI,eAAA;Afwu6BJ;AwE336BA;EzDsJI,0BAAA;Afwu6BJ;AwE936BA;EzDmJI,eAAA;Af8u6BJ;AwEj46BA;EzDsJI,0BAAA;Af8u6BJ;AwEp46BA;EzDmJI,eAAA;Afov6BJ;AwEv46BA;EzDsJI,0BAAA;Afov6BJ;AwE146BA;EzDmJI,eAAA;Af0v6BJ;AwE746BA;EzDsJI,0BAAA;Af0v6BJ;AwEh56BA;EzDmJI,eAAA;Afgw6BJ;AwEn56BA;EzDsJI,0BAAA;Afgw6BJ;AwEt56BA;EzDmJI,eAAA;Afsw6BJ;AwEz56BA;EzDsJI,0BAAA;Afsw6BJ;AwE556BA;EzDmJI,eAAA;Af4w6BJ;AwE/56BA;EzDsJI,0BAAA;Af4w6BJ;AwEl66BA;EzDmJI,eAAA;Afkx6BJ;AwEr66BA;EzDsJI,0BAAA;Afkx6BJ;AwEx66BA;EzDmJI,eAAA;Afwx6BJ;AwE366BA;EzDsJI,0BAAA;Afwx6BJ;AwE966BA;EzDmJI,eAAA;Af8x6BJ;AwEj76BA;EzDsJI,0BAAA;Af8x6BJ;AwEp76BA;EzDmJI,eAAA;Afoy6BJ;AwEv76BA;EzDsJI,0BAAA;Afoy6BJ;AwE176BA;EzDmJI,eAAA;Af0y6BJ;AwE776BA;EzDsJI,0BAAA;Af0y6BJ;AwEh86BA;EzDmJI,eAAA;Afgz6BJ;AwEn86BA;EzDsJI,0BAAA;Afgz6BJ;AwEt86BA;EzDmJI,eAAA;Afsz6BJ;AwEz86BA;EzDsJI,0BAAA;Afsz6BJ;AwE586BA;EzDmJI,eAAA;Af4z6BJ;AwE/86BA;EzDsJI,0BAAA;Af4z6BJ;AwEl96BA;EzDmJI,eAAA;Afk06BJ;AwEr96BA;EzDsJI,0BAAA;Afk06BJ;AwEx96BA;EzDmJI,eAAA;Afw06BJ;AwE396BA;EzDsJI,0BAAA;Afw06BJ;AwE996BA;EzDmJI,eAAA;Af806BJ;AwEj+6BA;EzDsJI,0BAAA;Af806BJ;AwEp+6BA;EzDmJI,eAAA;Afo16BJ;AwEv+6BA;EzDsJI,0BAAA;Afo16BJ;AwE1+6BA;EzDmJI,eAAA;Af016BJ;AwE7+6BA;EzDsJI,0BAAA;Af016BJ;AwEh/6BA;EzDmJI,eAAA;Afg26BJ;AwEn/6BA;EzDsJI,0BAAA;Afg26BJ;AwEt/6BA;EzDmJI,eAAA;Afs26BJ;AwEz/6BA;EzDsJI,0BAAA;Afs26BJ;AwE5/6BA;EzDmJI,eAAA;Af426BJ;AwE//6BA;EzDsJI,0BAAA;Af426BJ;AwElg7BA;EzDmJI,eAAA;Afk36BJ;AwErg7BA;EzDsJI,0BAAA;Afk36BJ;AwExg7BA;EzDmJI,eAAA;Afw36BJ;AwE3g7BA;EzDsJI,0BAAA;Afw36BJ;AwE9g7BA;EzDmJI,eAAA;Af836BJ;AwEjh7BA;EzDsJI,0BAAA;Af836BJ;AwEph7BA;EzDmJI,eAAA;Afo46BJ;AwEvh7BA;EzDsJI,0BAAA;Afo46BJ;AwE1h7BA;EzDmJI,eAAA;Af046BJ;AwE7h7BA;EzDsJI,0BAAA;Af046BJ;AwEhi7BA;EzDmJI,eAAA;Afg56BJ;AwEni7BA;EzDsJI,0BAAA;Afg56BJ;AwEti7BA;EzDmJI,eAAA;Afs56BJ;AwEzi7BA;EzDsJI,0BAAA;Afs56BJ;AwE5i7BA;EzDmJI,eAAA;Af456BJ;AwE/i7BA;EzDsJI,0BAAA;Af456BJ;AwElj7BA;EzDmJI,eAAA;Afk66BJ;AwErj7BA;EzDsJI,0BAAA;Afk66BJ;AwExj7BA;EzDmJI,eAAA;Afw66BJ;AwE3j7BA;EzDsJI,0BAAA;Afw66BJ;AwE9j7BA;EzDmJI,eAAA;Af866BJ;AwEjk7BA;EzDsJI,0BAAA;Af866BJ;AwEpk7BA;EzDmJI,eAAA;Afo76BJ;AwEvk7BA;EzDsJI,0BAAA;Afo76BJ;AwE1k7BA;EzDmJI,eAAA;Af076BJ;AwE7k7BA;EzDsJI,0BAAA;Af076BJ;AwEhl7BA;EzDmJI,eAAA;Afg86BJ;AwEnl7BA;EzDsJI,0BAAA;Afg86BJ;AwEtl7BA;EzDmJI,eAAA;Afs86BJ;AwEzl7BA;EzDsJI,0BAAA;Afs86BJ;AwE5l7BA;EzDmJI,eAAA;Af486BJ;AwE/l7BA;EzDsJI,0BAAA;Af486BJ;AwElm7BA;EzDmJI,eAAA;Afk96BJ;AwErm7BA;EzDsJI,0BAAA;Afk96BJ;AwExm7BA;EzDmJI,eAAA;Afw96BJ;AwE3m7BA;EzDsJI,0BAAA;Afw96BJ;AwE9m7BA;EzDmJI,eAAA;Af896BJ;AwEjn7BA;EzDsJI,0BAAA;Af896BJ;AwEpn7BA;EzDmJI,eAAA;Afo+6BJ;AwEvn7BA;EzDsJI,0BAAA;Afo+6BJ;AwE1n7BA;EzDmJI,eAAA;Af0+6BJ;AwE7n7BA;EzDsJI,0BAAA;Af0+6BJ;AwEho7BA;EzDmJI,eAAA;Afg/6BJ;AwEno7BA;EzDsJI,0BAAA;Afg/6BJ;AwEto7BA;EzDmJI,eAAA;Afs/6BJ;AwEzo7BA;EzDsJI,0BAAA;Afs/6BJ;AwE5o7BA;EzDmJI,eAAA;Af4/6BJ;AwE/o7BA;EzDsJI,0BAAA;Af4/6BJ;AwElp7BA;EzDmJI,eAAA;Afkg7BJ;AwErp7BA;EzDsJI,0BAAA;Afkg7BJ;AwExp7BA;EzDmJI,eAAA;Afwg7BJ;AwE3p7BA;EzDsJI,0BAAA;Afwg7BJ;AwE9p7BA;EzDmJI,eAAA;Af8g7BJ;AwEjq7BA;EzDsJI,0BAAA;Af8g7BJ;AwEpq7BA;EzDmJI,oBAAA;Afoh7BJ;AwEvq7BA;EzDsJI,+BAAA;Afoh7BJ;AwE1q7BA;EzDmJI,oBAAA;Af0h7BJ;AwE7q7BA;EzDsJI,+BAAA;Af0h7BJ;AwEhr7BA;EzDmJI,oBAAA;Afgi7BJ;AwEnr7BA;EzDsJI,+BAAA;Afgi7BJ;AwEtr7BA;EzDmJI,oBAAA;Afsi7BJ;AwEzr7BA;EzDsJI,+BAAA;Afsi7BJ;AwE5r7BA;EzDmJI,oBAAA;Af4i7BJ;AwE/r7BA;EzDsJI,+BAAA;Af4i7BJ;AwEls7BA;EzDmJI,oBAAA;Afkj7BJ;AwErs7BA;EzDsJI,+BAAA;Afkj7BJ;AwExs7BA;EzDmJI,oBAAA;Afwj7BJ;AwE3s7BA;EzDsJI,+BAAA;Afwj7BJ;AwE9s7BA;EzDmJI,oBAAA;Af8j7BJ;AwEjt7BA;EzDsJI,+BAAA;Af8j7BJ;AwEpt7BA;EzDmJI,oBAAA;Afok7BJ;AwEvt7BA;EzDsJI,+BAAA;Afok7BJ;AwE1t7BA;EzDmJI,oBAAA;Af0k7BJ;AwE7t7BA;EzDsJI,+BAAA;Af0k7BJ;AwEhu7BA;EzDmJI,oBAAA;Afgl7BJ;AwEnu7BA;EzDsJI,+BAAA;Afgl7BJ;AwEtu7BA;EzDmJI,oBAAA;Afsl7BJ;AwEzu7BA;EzDsJI,+BAAA;Afsl7BJ;AwE5u7BA;EzDmJI,oBAAA;Af4l7BJ;AwE/u7BA;EzDsJI,+BAAA;Af4l7BJ;AwElv7BA;EzDmJI,oBAAA;Afkm7BJ;AwErv7BA;EzDsJI,+BAAA;Afkm7BJ;AwExv7BA;EzDmJI,oBAAA;Afwm7BJ;AwE3v7BA;EzDsJI,+BAAA;Afwm7BJ;AwE9v7BA;EzDmJI,oBAAA;Af8m7BJ;AwEjw7BA;EzDsJI,+BAAA;Af8m7BJ;AwEpw7BA;EzDmJI,oBAAA;Afon7BJ;AwEvw7BA;EzDsJI,+BAAA;Afon7BJ;AwE1w7BA;EzDmJI,oBAAA;Af0n7BJ;AwE7w7BA;EzDsJI,+BAAA;Af0n7BJ;AwEhx7BA;EzDmJI,oBAAA;Afgo7BJ;AwEnx7BA;EzDsJI,+BAAA;Afgo7BJ;AwEtx7BA;EzDmJI,oBAAA;Afso7BJ;AwEzx7BA;EzDsJI,+BAAA;Afso7BJ;AwE5x7BA;EzDmJI,oBAAA;Af4o7BJ;AwE/x7BA;EzDsJI,+BAAA;Af4o7BJ;AwEly7BA;EzDmJI,oBAAA;Afkp7BJ;AwEry7BA;EzDsJI,+BAAA;Afkp7BJ;AwExy7BA;EzDmJI,oBAAA;Afwp7BJ;AwE3y7BA;EzDsJI,+BAAA;Afwp7BJ;AwE9y7BA;EzDmJI,oBAAA;Af8p7BJ;AwEjz7BA;EzDsJI,+BAAA;Af8p7BJ;AwEpz7BA;EzDmJI,oBAAA;Afoq7BJ;AwEvz7BA;EzDsJI,+BAAA;Afoq7BJ;AwE1z7BA;EzDmJI,oBAAA;Af0q7BJ;AwE7z7BA;EzDsJI,+BAAA;Af0q7BJ;AwEh07BA;EzDmJI,oBAAA;Afgr7BJ;AwEn07BA;EzDsJI,+BAAA;Afgr7BJ;AwEt07BA;EzDmJI,oBAAA;Afsr7BJ;AwEz07BA;EzDsJI,+BAAA;Afsr7BJ;AwE507BA;EzDmJI,oBAAA;Af4r7BJ;AwE/07BA;EzDsJI,+BAAA;Af4r7BJ;AwEl17BA;EzDmJI,oBAAA;Afks7BJ;AwEr17BA;EzDsJI,+BAAA;Afks7BJ;AwEx17BA;EzDmJI,oBAAA;Afws7BJ;AwE317BA;EzDsJI,+BAAA;Afws7BJ;AwE917BA;EzDmJI,oBAAA;Af8s7BJ;AwEj27BA;EzDsJI,+BAAA;Af8s7BJ;AwEp27BA;EzDmJI,oBAAA;Afot7BJ;AwEv27BA;EzDsJI,+BAAA;Afot7BJ;AwE127BA;EzDmJI,oBAAA;Af0t7BJ;AwE727BA;EzDsJI,+BAAA;Af0t7BJ;AwEh37BA;EzDmJI,oBAAA;Afgu7BJ;AwEn37BA;EzDsJI,+BAAA;Afgu7BJ;AwEt37BA;EzDmJI,oBAAA;Afsu7BJ;AwEz37BA;EzDsJI,+BAAA;Afsu7BJ;AwE537BA;EzDmJI,oBAAA;Af4u7BJ;AwE/37BA;EzDsJI,+BAAA;Af4u7BJ;AwEl47BA;EzDmJI,oBAAA;Afkv7BJ;AwEr47BA;EzDsJI,+BAAA;Afkv7BJ;AwEx47BA;EzDmJI,oBAAA;Afwv7BJ;AwE347BA;EzDsJI,+BAAA;Afwv7BJ;AwE947BA;EzDmJI,oBAAA;Af8v7BJ;AwEj57BA;EzDsJI,+BAAA;Af8v7BJ;AwEp57BA;EzDmJI,oBAAA;Afow7BJ;AwEv57BA;EzDsJI,+BAAA;Afow7BJ;AwE157BA;EzDmJI,oBAAA;Af0w7BJ;AwE757BA;EzDsJI,+BAAA;Af0w7BJ;AwEh67BA;EzDmJI,oBAAA;Afgx7BJ;AwEn67BA;EzDsJI,+BAAA;Afgx7BJ;AwEt67BA;EzDmJI,oBAAA;Afsx7BJ;AwEz67BA;EzDsJI,+BAAA;Afsx7BJ;AwE567BA;EzDmJI,oBAAA;Af4x7BJ;AwE/67BA;EzDsJI,+BAAA;Af4x7BJ;AwEl77BA;EzDmJI,oBAAA;Afky7BJ;AwEr77BA;EzDsJI,+BAAA;Afky7BJ;AwEx77BA;EzDmJI,oBAAA;Afwy7BJ;AwE377BA;EzDsJI,+BAAA;Afwy7BJ;AwE977BA;EzDmJI,oBAAA;Af8y7BJ;AwEj87BA;EzDsJI,+BAAA;Af8y7BJ;AwEp87BA;EzDmJI,oBAAA;Afoz7BJ;AwEv87BA;EzDsJI,+BAAA;Afoz7BJ;AwE187BA;EzDmJI,oBAAA;Af0z7BJ;AwE787BA;EzDsJI,+BAAA;Af0z7BJ;AwEh97BA;EzDmJI,oBAAA;Afg07BJ;AwEn97BA;EzDsJI,+BAAA;Afg07BJ;AwEt97BA;EzDmJI,oBAAA;Afs07BJ;AwEz97BA;EzDsJI,+BAAA;Afs07BJ;AwE597BA;EzDmJI,oBAAA;Af407BJ;AwE/97BA;EzDsJI,+BAAA;Af407BJ;AwEl+7BA;EzDmJI,oBAAA;Afk17BJ;AwEr+7BA;EzDsJI,+BAAA;Afk17BJ;AwEx+7BA;EzDmJI,oBAAA;Afw17BJ;AwE3+7BA;EzDsJI,+BAAA;Afw17BJ;AwE9+7BA;EzDmJI,oBAAA;Af817BJ;AwEj/7BA;EzDsJI,+BAAA;Af817BJ;AwEp/7BA;EzDmJI,oBAAA;Afo27BJ;AwEv/7BA;EzDsJI,+BAAA;Afo27BJ;AwE1/7BA;EzDmJI,oBAAA;Af027BJ;AwE7/7BA;EzDsJI,+BAAA;Af027BJ;AwEhg8BA;EzDmJI,oBAAA;Afg37BJ;AwEng8BA;EzDsJI,+BAAA;Afg37BJ;AwEtg8BA;EzDmJI,oBAAA;Afs37BJ;AwEzg8BA;EzDsJI,+BAAA;Afs37BJ;AwE5g8BA;EzDmJI,oBAAA;Af437BJ;AwE/g8BA;EzDsJI,+BAAA;Af437BJ;AwElh8BA;EzDmJI,oBAAA;Afk47BJ;AwErh8BA;EzDsJI,+BAAA;Afk47BJ;AwExh8BA;EzDmJI,oBAAA;Afw47BJ;AwE3h8BA;EzDsJI,+BAAA;Afw47BJ;AwE9h8BA;EzDmJI,oBAAA;Af847BJ;AwEji8BA;EzDsJI,+BAAA;Af847BJ;AwEpi8BA;EzDmJI,oBAAA;Afo57BJ;AwEvi8BA;EzDsJI,+BAAA;Afo57BJ;AwE1i8BA;EzDmJI,oBAAA;Af057BJ;AwE7i8BA;EzDsJI,+BAAA;Af057BJ;AwEhj8BA;EzDmJI,oBAAA;Afg67BJ;AwEnj8BA;EzDsJI,+BAAA;Afg67BJ;AwEtj8BA;EzDmJI,oBAAA;Afs67BJ;AwEzj8BA;EzDsJI,+BAAA;Afs67BJ;AwE5j8BA;EzDmJI,oBAAA;Af467BJ;AwE/j8BA;EzDsJI,+BAAA;Af467BJ;AwElk8BA;EzDmJI,oBAAA;Afk77BJ;AwErk8BA;EzDsJI,+BAAA;Afk77BJ;AwExk8BA;EzDmJI,yBAAA;Afw77BJ;AwE3k8BA;EzDsJI,oCAAA;Afw77BJ;AwE9k8BA;EzDmJI,yBAAA;Af877BJ;AwEjl8BA;EzDsJI,oCAAA;Af877BJ;AwEpl8BA;EzDmJI,yBAAA;Afo87BJ;AwEvl8BA;EzDsJI,oCAAA;Afo87BJ;AwE1l8BA;EzDmJI,yBAAA;Af087BJ;AwE7l8BA;EzDsJI,oCAAA;Af087BJ;AwEhm8BA;EzDmJI,yBAAA;Afg97BJ;AwEnm8BA;EzDsJI,oCAAA;Afg97BJ;AwEtm8BA;EzDmJI,yBAAA;Afs97BJ;AwEzm8BA;EzDsJI,oCAAA;Afs97BJ;AwE5m8BA;EzDmJI,yBAAA;Af497BJ;AwE/m8BA;EzDsJI,oCAAA;Af497BJ;AwEln8BA;EzDmJI,yBAAA;Afk+7BJ;AwErn8BA;EzDsJI,oCAAA;Afk+7BJ;AwExn8BA;EzDmJI,yBAAA;Afw+7BJ;AwE3n8BA;EzDsJI,oCAAA;Afw+7BJ;AwE9n8BA;EzDmJI,yBAAA;Af8+7BJ;AwEjo8BA;EzDsJI,oCAAA;Af8+7BJ;AwEpo8BA;EzDmJI,yBAAA;Afo/7BJ;AwEvo8BA;EzDsJI,oCAAA;Afo/7BJ;AwE1o8BA;EzDmJI,yBAAA;Af0/7BJ;AwE7o8BA;EzDsJI,oCAAA;Af0/7BJ;AwEhp8BA;EzDmJI,yBAAA;Afgg8BJ;AwEnp8BA;EzDsJI,oCAAA;Afgg8BJ;AwEtp8BA;EzDmJI,yBAAA;Afsg8BJ;AwEzp8BA;EzDsJI,oCAAA;Afsg8BJ;AwE5p8BA;EzDmJI,yBAAA;Af4g8BJ;AwE/p8BA;EzDsJI,oCAAA;Af4g8BJ;AwElq8BA;EzDmJI,yBAAA;Afkh8BJ;AwErq8BA;EzDsJI,oCAAA;Afkh8BJ;AwExq8BA;EzDmJI,yBAAA;Afwh8BJ;AwE3q8BA;EzDsJI,oCAAA;Afwh8BJ;AwE9q8BA;EzDmJI,yBAAA;Af8h8BJ;AwEjr8BA;EzDsJI,oCAAA;Af8h8BJ;AwEpr8BA;EzDmJI,yBAAA;Afoi8BJ;AwEvr8BA;EzDsJI,oCAAA;Afoi8BJ;AwE1r8BA;EzDmJI,yBAAA;Af0i8BJ;AwE7r8BA;EzDsJI,oCAAA;Af0i8BJ;AwEhs8BA;EzDmJI,yBAAA;Afgj8BJ;AwEns8BA;EzDsJI,oCAAA;Afgj8BJ;AwEts8BA;EzDmJI,yBAAA;Afsj8BJ;AwEzs8BA;EzDsJI,oCAAA;Afsj8BJ;AwE5s8BA;EzDmJI,yBAAA;Af4j8BJ;AwE/s8BA;EzDsJI,oCAAA;Af4j8BJ;AwElt8BA;EzDmJI,yBAAA;Afkk8BJ;AwErt8BA;EzDsJI,oCAAA;Afkk8BJ;AwExt8BA;EzDmJI,yBAAA;Afwk8BJ;AwE3t8BA;EzDsJI,oCAAA;Afwk8BJ;AwE9t8BA;EzDmJI,yBAAA;Af8k8BJ;AwEju8BA;EzDsJI,oCAAA;Af8k8BJ;AwEpu8BA;EzDmJI,yBAAA;Afol8BJ;AwEvu8BA;EzDsJI,oCAAA;Afol8BJ;AwE1u8BA;EzDmJI,yBAAA;Af0l8BJ;AwE7u8BA;EzDsJI,oCAAA;Af0l8BJ;AwEhv8BA;EzDmJI,yBAAA;Afgm8BJ;AwEnv8BA;EzDsJI,oCAAA;Afgm8BJ;AwEtv8BA;EzDmJI,yBAAA;Afsm8BJ;AwEzv8BA;EzDsJI,oCAAA;Afsm8BJ;AwE5v8BA;EzDmJI,6BAAA;Af4m8BJ;AwE/v8BA;EzDsJI,wCAAA;Af4m8BJ;AwElw8BA;EzDmJI,6BAAA;Afkn8BJ;AwErw8BA;EzDsJI,wCAAA;Afkn8BJ;AwExw8BA;EzDmJI,6BAAA;Afwn8BJ;AwE3w8BA;EzDsJI,wCAAA;Afwn8BJ;AwE9w8BA;EzDmJI,6BAAA;Af8n8BJ;AwEjx8BA;EzDsJI,wCAAA;Af8n8BJ;AwEpx8BA;EzDmJI,6BAAA;Afoo8BJ;AwEvx8BA;EzDsJI,wCAAA;Afoo8BJ;AwE1x8BA;EzDmJI,6BAAA;Af0o8BJ;AwE7x8BA;EzDsJI,wCAAA;Af0o8BJ;AwEhy8BA;EzDmJI,6BAAA;Afgp8BJ;AwEny8BA;EzDsJI,wCAAA;Afgp8BJ;AwEty8BA;EzDmJI,6BAAA;Afsp8BJ;AwEzy8BA;EzDsJI,wCAAA;Afsp8BJ;AwE5y8BA;EzDmJI,6BAAA;Af4p8BJ;AwE/y8BA;EzDsJI,wCAAA;Af4p8BJ;AwElz8BA;EzDmJI,6BAAA;Afkq8BJ;AwErz8BA;EzDsJI,wCAAA;Afkq8BJ;AwExz8BA;EzDmJI,6BAAA;Afwq8BJ;AwE3z8BA;EzDsJI,wCAAA;Afwq8BJ;AwE9z8BA;EzDmJI,6BAAA;Af8q8BJ;AwEj08BA;EzDsJI,wCAAA;Af8q8BJ;AwEp08BA;EzDmJI,6BAAA;Afor8BJ;AwEv08BA;EzDsJI,wCAAA;Afor8BJ;AwE108BA;EzDmJI,6BAAA;Af0r8BJ;AwE708BA;EzDsJI,wCAAA;Af0r8BJ;AwEh18BA;EzDmJI,6BAAA;Afgs8BJ;AwEn18BA;EzDsJI,wCAAA;Afgs8BJ;AwEt18BA;EzDmJI,6BAAA;Afss8BJ;AwEz18BA;EzDsJI,wCAAA;Afss8BJ;AwE518BA;EzDmJI,6BAAA;Af4s8BJ;AwE/18BA;EzDsJI,wCAAA;Af4s8BJ;AwEl28BA;EzDmJI,6BAAA;Afkt8BJ;AwEr28BA;EzDsJI,wCAAA;Afkt8BJ;AwEx28BA;EzDmJI,6BAAA;Afwt8BJ;AwE328BA;EzDsJI,wCAAA;Afwt8BJ;AwE928BA;EzDmJI,6BAAA;Af8t8BJ;AwEj38BA;EzDsJI,wCAAA;Af8t8BJ;AwEp38BA;EzDmJI,+BAAA;Afou8BJ;AwEv38BA;EzDsJI,0CAAA;Afou8BJ;AwE138BA;EzDmJI,+BAAA;Af0u8BJ;AwE738BA;EzDsJI,0CAAA;Af0u8BJ;AwEh48BA;EzDmJI,+BAAA;Afgv8BJ;AwEn48BA;EzDsJI,0CAAA;Afgv8BJ;AwEt48BA;EzDmJI,+BAAA;Afsv8BJ;AwEz48BA;EzDsJI,0CAAA;Afsv8BJ;AwE548BA;EzDmJI,+BAAA;Af4v8BJ;AwE/48BA;EzDsJI,0CAAA;Af4v8BJ;AwEl58BA;EzDmJI,+BAAA;Afkw8BJ;AwEr58BA;EzDsJI,0CAAA;Afkw8BJ;AwEx58BA;EzDmJI,+BAAA;Afww8BJ;AwE358BA;EzDsJI,0CAAA;Afww8BJ;AwE958BA;EzDmJI,+BAAA;Af8w8BJ;AwEj68BA;EzDsJI,0CAAA;Af8w8BJ;AwEp68BA;EzDmJI,+BAAA;Afox8BJ;AwEv68BA;EzDsJI,0CAAA;Afox8BJ;AwE168BA;EzDmJI,+BAAA;Af0x8BJ;AwE768BA;EzDsJI,0CAAA;Af0x8BJ;AwEh78BA;EzDmJI,+BAAA;Afgy8BJ;AwEn78BA;EzDsJI,0CAAA;Afgy8BJ;AwEt78BA;EzDmJI,+BAAA;Afsy8BJ;AwEz78BA;EzDsJI,0CAAA;Afsy8BJ;AwE578BA;EzDmJI,+BAAA;Af4y8BJ;AwE/78BA;EzDsJI,0CAAA;Af4y8BJ;AwEl88BA;EzDmJI,+BAAA;Afkz8BJ;AwEr88BA;EzDsJI,0CAAA;Afkz8BJ;AwEx88BA;EzDmJI,+BAAA;Afwz8BJ;AwE388BA;EzDsJI,0CAAA;Afwz8BJ;AwE988BA;EzDmJI,+BAAA;Af8z8BJ;AwEj98BA;EzDsJI,0CAAA;Af8z8BJ;AwEp98BA;EzDmJI,+BAAA;Afo08BJ;AwEv98BA;EzDsJI,0CAAA;Afo08BJ;AwE198BA;EzDmJI,+BAAA;Af008BJ;AwE798BA;EzDsJI,0CAAA;Af008BJ;AwEh+8BA;EzDmJI,+BAAA;Afg18BJ;AwEn+8BA;EzDsJI,0CAAA;Afg18BJ;AwEt+8BA;EzDmJI,+BAAA;Afs18BJ;AwEz+8BA;EzDsJI,0CAAA;Afs18BJ;AwE5+8BA;EzDmJI,gCAAA;Af418BJ;AwE/+8BA;EzDsJI,2CAAA;Af418BJ;AwEl/8BA;EzDmJI,gCAAA;Afk28BJ;AwEr/8BA;EzDsJI,2CAAA;Afk28BJ;AwEx/8BA;EzDmJI,gCAAA;Afw28BJ;AwE3/8BA;EzDsJI,2CAAA;Afw28BJ;AwE9/8BA;EzDmJI,gCAAA;Af828BJ;AwEjg9BA;EzDsJI,2CAAA;Af828BJ;AwEpg9BA;EzDmJI,gCAAA;Afo38BJ;AwEvg9BA;EzDsJI,2CAAA;Afo38BJ;AwE1g9BA;EzDmJI,gCAAA;Af038BJ;AwE7g9BA;EzDsJI,2CAAA;Af038BJ;AwEhh9BA;EzDmJI,gCAAA;Afg48BJ;AwEnh9BA;EzDsJI,2CAAA;Afg48BJ;AwEth9BA;EzDmJI,gCAAA;Afs48BJ;AwEzh9BA;EzDsJI,2CAAA;Afs48BJ;AwE5h9BA;EzDmJI,gCAAA;Af448BJ;AwE/h9BA;EzDsJI,2CAAA;Af448BJ;AwEli9BA;EzDmJI,gCAAA;Afk58BJ;AwEri9BA;EzDsJI,2CAAA;Afk58BJ;AwExi9BA;EzDmJI,gCAAA;Afw58BJ;AwE3i9BA;EzDsJI,2CAAA;Afw58BJ;AwE9i9BA;EzDmJI,gCAAA;Af858BJ;AwEjj9BA;EzDsJI,2CAAA;Af858BJ;AwEpj9BA;EzDmJI,gCAAA;Afo68BJ;AwEvj9BA;EzDsJI,2CAAA;Afo68BJ;AwE1j9BA;EzDmJI,gCAAA;Af068BJ;AwE7j9BA;EzDsJI,2CAAA;Af068BJ;AwEhk9BA;EzDmJI,gCAAA;Afg78BJ;AwEnk9BA;EzDsJI,2CAAA;Afg78BJ;AwEtk9BA;EzDmJI,gCAAA;Afs78BJ;AwEzk9BA;EzDsJI,2CAAA;Afs78BJ;AwE5k9BA;EzDmJI,gCAAA;Af478BJ;AwE/k9BA;EzDsJI,2CAAA;Af478BJ;AwEll9BA;EzDmJI,gCAAA;Afk88BJ;AwErl9BA;EzDsJI,2CAAA;Afk88BJ;AwExl9BA;EzDmJI,gCAAA;Afw88BJ;AwE3l9BA;EzDsJI,2CAAA;Afw88BJ;AwE9l9BA;EzDmJI,gCAAA;Af888BJ;AwEjm9BA;EzDsJI,2CAAA;Af888BJ;AwEpm9BA;EzDmJI,8BAAA;Afo98BJ;AwEvm9BA;EzDsJI,yCAAA;Afo98BJ;AwE1m9BA;EzDmJI,8BAAA;Af098BJ;AwE7m9BA;EzDsJI,yCAAA;Af098BJ;AwEhn9BA;EzDmJI,8BAAA;Afg+8BJ;AwEnn9BA;EzDsJI,yCAAA;Afg+8BJ;AwEtn9BA;EzDmJI,8BAAA;Afs+8BJ;AwEzn9BA;EzDsJI,yCAAA;Afs+8BJ;AwE5n9BA;EzDmJI,8BAAA;Af4+8BJ;AwE/n9BA;EzDsJI,yCAAA;Af4+8BJ;AwElo9BA;EzDmJI,8BAAA;Afk/8BJ;AwEro9BA;EzDsJI,yCAAA;Afk/8BJ;AwExo9BA;EzDmJI,8BAAA;Afw/8BJ;AwE3o9BA;EzDsJI,yCAAA;Afw/8BJ;AwE9o9BA;EzDmJI,8BAAA;Af8/8BJ;AwEjp9BA;EzDsJI,yCAAA;Af8/8BJ;AwEpp9BA;EzDmJI,8BAAA;Afog9BJ;AwEvp9BA;EzDsJI,yCAAA;Afog9BJ;AwE1p9BA;EzDmJI,8BAAA;Af0g9BJ;AwE7p9BA;EzDsJI,yCAAA;Af0g9BJ;AwEhq9BA;EzDmJI,8BAAA;Afgh9BJ;AwEnq9BA;EzDsJI,yCAAA;Afgh9BJ;AwEtq9BA;EzDmJI,8BAAA;Afsh9BJ;AwEzq9BA;EzDsJI,yCAAA;Afsh9BJ;AwE5q9BA;EzDmJI,8BAAA;Af4h9BJ;AwE/q9BA;EzDsJI,yCAAA;Af4h9BJ;AwElr9BA;EzDmJI,8BAAA;Afki9BJ;AwErr9BA;EzDsJI,yCAAA;Afki9BJ;AwExr9BA;EzDmJI,8BAAA;Afwi9BJ;AwE3r9BA;EzDsJI,yCAAA;Afwi9BJ;AwE9r9BA;EzDmJI,8BAAA;Af8i9BJ;AwEjs9BA;EzDsJI,yCAAA;Af8i9BJ;AwEps9BA;EzDmJI,8BAAA;Afoj9BJ;AwEvs9BA;EzDsJI,yCAAA;Afoj9BJ;AwE1s9BA;EzDmJI,8BAAA;Af0j9BJ;AwE7s9BA;EzDsJI,yCAAA;Af0j9BJ;AwEht9BA;EzDmJI,8BAAA;Afgk9BJ;AwEnt9BA;EzDsJI,yCAAA;Afgk9BJ;AwEtt9BA;EzDmJI,8BAAA;Afsk9BJ;AwEzt9BA;EzDsJI,yCAAA;Afsk9BJ;AwE5t9BA;EzDmJI,sBAAA;Af4k9BJ;AwE/t9BA;EzDsJI,iCAAA;Af4k9BJ;AwElu9BA;EzDmJI,sBAAA;Afkl9BJ;AwEru9BA;EzDsJI,iCAAA;Afkl9BJ;AwExu9BA;EzDmJI,sBAAA;Afwl9BJ;AwE3u9BA;EzDsJI,iCAAA;Afwl9BJ;AwE9u9BA;EzDmJI,sBAAA;Af8l9BJ;AwEjv9BA;EzDsJI,iCAAA;Af8l9BJ;AwEpv9BA;EzDmJI,sBAAA;Afom9BJ;AwEvv9BA;EzDsJI,iCAAA;Afom9BJ;AwE1v9BA;EzDmJI,sBAAA;Af0m9BJ;AwE7v9BA;EzDsJI,iCAAA;Af0m9BJ;AwEhw9BA;EzDmJI,sBAAA;Afgn9BJ;AwEnw9BA;EzDsJI,iCAAA;Afgn9BJ;AwEtw9BA;EzDmJI,sBAAA;Afsn9BJ;AwEzw9BA;EzDsJI,iCAAA;Afsn9BJ;AwE5w9BA;EzDmJI,sBAAA;Af4n9BJ;AwE/w9BA;EzDsJI,iCAAA;Af4n9BJ;AwElx9BA;EzDmJI,sBAAA;Afko9BJ;AwErx9BA;EzDsJI,iCAAA;Afko9BJ;AwExx9BA;EzDmJI,sBAAA;Afwo9BJ;AwE3x9BA;EzDsJI,iCAAA;Afwo9BJ;AwE9x9BA;EzDmJI,sBAAA;Af8o9BJ;AwEjy9BA;EzDsJI,iCAAA;Af8o9BJ;AwEpy9BA;EzDmJI,sBAAA;Afop9BJ;AwEvy9BA;EzDsJI,iCAAA;Afop9BJ;AwE1y9BA;EzDmJI,sBAAA;Af0p9BJ;AwE7y9BA;EzDsJI,iCAAA;Af0p9BJ;AwEhz9BA;EzDmJI,sBAAA;Afgq9BJ;AwEnz9BA;EzDsJI,iCAAA;Afgq9BJ;AwEtz9BA;EzDmJI,sBAAA;Afsq9BJ;AwEzz9BA;EzDsJI,iCAAA;Afsq9BJ;AwE5z9BA;EzDmJI,sBAAA;Af4q9BJ;AwE/z9BA;EzDsJI,iCAAA;Af4q9BJ;AwEl09BA;EzDmJI,sBAAA;Afkr9BJ;AwEr09BA;EzDsJI,iCAAA;Afkr9BJ;AwEx09BA;EzDmJI,sBAAA;Afwr9BJ;AwE309BA;EzDsJI,iCAAA;Afwr9BJ;AwE909BA;EzDmJI,sBAAA;Af8r9BJ;AwEj19BA;EzDsJI,iCAAA;Af8r9BJ;AwEp19BA;EzDkII,UAAA;Afqt9BJ;AwEv19BA;EzDqII,UAAA;Afqt9BJ;AwE119BA;EzDkII,YAAA;Af2t9BJ;AwE719BA;EzDqII,YAAA;Af2t9BJ;AwEh29BA;EzDkII,YAAA;Afiu9BJ;AwEn29BA;EzDqII,YAAA;Afiu9BJ;AwEt29BA;EzDkII,YAAA;Afuu9BJ;AwEz29BA;EzDqII,YAAA;Afuu9BJ;AwE529BA;EzDkII,YAAA;Af6u9BJ;AwE/29BA;EzDqII,YAAA;Af6u9BJ;AwEl39BA;EzDkII,YAAA;Afmv9BJ;AwEr39BA;EzDqII,YAAA;Afmv9BJ;AwEx39BA;EzDkII,YAAA;Afyv9BJ;AwE339BA;EzDqII,YAAA;Afyv9BJ;AwE939BA;EzDkII,YAAA;Af+v9BJ;AwEj49BA;EzDqII,YAAA;Af+v9BJ;AwEp49BA;EzDkII,YAAA;Afqw9BJ;AwEv49BA;EzDqII,YAAA;Afqw9BJ;AwE149BA;EzDkII,YAAA;Af2w9BJ;AwE749BA;EzDqII,YAAA;Af2w9BJ;AwEh59BA;EzDkII,UAAA;Afix9BJ;AwEn59BA;EzDqII,UAAA;Afix9BJ;AwEt59BA;EAgDI,mBAAA;AxEy29BJ;AwEz59BA;EAmDI,cAAA;AxEy29BJ;AwE319BI;;;EAGE,gBAAA;AxE619BN;AqF349BG;EACC,qCAAA;ArF649BJ;AqF349BG;EACC,qCAAA;ArF649BJ;AqFj59BG;EACC,qCAAA;ArFm59BJ;AqFj59BG;EACC,qCAAA;ArFm59BJ;AqFv59BG;EACC,oCAAA;ArFy59BJ;AqFv59BG;EACC,oCAAA;ArFy59BJ;AqF759BG;EACC,mCAAA;ArF+59BJ;AqF759BG;EACC,mCAAA;ArF+59BJ;AqFn69BG;EACC,mCAAA;ArFq69BJ;AqFn69BG;EACC,mCAAA;ArFq69BJ;AqFz69BG;EACC,qCAAA;ArF269BJ;AqFz69BG;EACC,qCAAA;ArF269BJ;AqF/69BG;EACC,qCAAA;ArFi79BJ;AqF/69BG;EACC,qCAAA;ArFi79BJ;AqFr79BG;EACC,oCAAA;ArFu79BJ;AqFr79BG;EACC,oCAAA;ArFu79BJ;AqF379BG;EACC,mCAAA;ArF679BJ;AqF379BG;EACC,mCAAA;ArF679BJ;AqFj89BG;EACC,mCAAA;ArFm89BJ;AqFj89BG;EACC,mCAAA;ArFm89BJ;AqFv89BG;EACC,qDAAA;ArFy89BJ;AqFv89BG;EACC,qDAAA;ArFy89BJ;AqF789BG;EACC,qDAAA;ArF+89BJ;AqF789BG;EACC,qDAAA;ArF+89BJ;AqFn99BG;EACC,oDAAA;ArFq99BJ;AqFn99BG;EACC,oDAAA;ArFq99BJ;AqFz99BG;EACC,mDAAA;ArF299BJ;AqFz99BG;EACC,mDAAA;ArF299BJ;AqF/99BG;EACC,mDAAA;ArFi+9BJ;AqF/99BG;EACC,mDAAA;ArFi+9BJ;AqFr+9BG;EACC,qDAAA;ArFu+9BJ;AqFr+9BG;EACC,qDAAA;ArFu+9BJ;AqF3+9BG;EACC,qDAAA;ArF6+9BJ;AqF3+9BG;EACC,qDAAA;ArF6+9BJ;AqFj/9BG;EACC,oDAAA;ArFm/9BJ;AqFj/9BG;EACC,oDAAA;ArFm/9BJ;AqFv/9BG;EACC,mDAAA;ArFy/9BJ;AqFv/9BG;EACC,mDAAA;ArFy/9BJ;AqF7/9BG;EACC,mDAAA;ArF+/9BJ;AqF7/9BG;EACC,mDAAA;ArF+/9BJ;AqFng+BG;EACC,sDAAA;ArFqg+BJ;AqFng+BG;EACC,sDAAA;ArFqg+BJ;AqFzg+BG;EACC,sDAAA;ArF2g+BJ;AqFzg+BG;EACC,sDAAA;ArF2g+BJ;AqF/g+BG;EACC,qDAAA;ArFih+BJ;AqF/g+BG;EACC,qDAAA;ArFih+BJ;AqFrh+BG;EACC,oDAAA;ArFuh+BJ;AqFrh+BG;EACC,oDAAA;ArFuh+BJ;AqF3h+BG;EACC,oDAAA;ArF6h+BJ;AqF3h+BG;EACC,oDAAA;ArF6h+BJ;AqFji+BG;EACC,sDAAA;ArFmi+BJ;AqFji+BG;EACC,sDAAA;ArFmi+BJ;AqFvi+BG;EACC,sDAAA;ArFyi+BJ;AqFvi+BG;EACC,sDAAA;ArFyi+BJ;AqF7i+BG;EACC,qDAAA;ArF+i+BJ;AqF7i+BG;EACC,qDAAA;ArF+i+BJ;AqFnj+BG;EACC,oDAAA;ArFqj+BJ;AqFnj+BG;EACC,oDAAA;ArFqj+BJ;AqFzj+BG;EACC,oDAAA;ArF2j+BJ;AqFzj+BG;EACC,oDAAA;ArF2j+BJ;AwEhg+BI;EACE,+BAAA;AxEkg+BN;AwE//9BI;EACE,kCAAA;AxEig+BN;AwE3l+BA;EA+FI,iBAAA;AxE+/9BJ;AwE9l+BA;EAmGI,uCAAA;AxE8/9BJ;AwEjm+BA;EAuGI,gBAAA;AxE6/9BJ;AwEpm+BA;EA2GI,6BAAA;AxE4/9BJ;AwEvm+BA;EAgHI,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AxE0/9BJ;AwEx/9BI;EACE,gBAAA;AxE0/9BN;AwEhn+BA;EQqBI,SAAA;AhF8l+BJ;AwEnn+BA;EQwBI,cAAA;EACA,eAAA;AhF8l+BJ;AwEvn+BA;EQ4BI,aAAA;EACA,gBAAA;AhF8l+BJ;AwE3n+BA;EQgCI,aAAA;AhF8l+BJ;AwE9n+BA;EQmCI,gBAAA;AhF8l+BJ;AwEjo+BA;EQsCI,cAAA;AhF8l+BJ;AwEpo+BA;EQyCI,eAAA;AhF8l+BJ;AwEvo+BA;EQqBI,YAAA;AhFqn+BJ;AwE1o+BA;EQwBI,iBAAA;EACA,kBAAA;AhFqn+BJ;AwE9o+BA;EQ4BI,gBAAA;EACA,mBAAA;AhFqn+BJ;AwElp+BA;EQgCI,gBAAA;AhFqn+BJ;AwErp+BA;EQmCI,mBAAA;AhFqn+BJ;AwExp+BA;EQsCI,iBAAA;AhFqn+BJ;AwE3p+BA;EQyCI,kBAAA;AhFqn+BJ;AwE9p+BA;EQqBI,WAAA;AhF4o+BJ;AwEjq+BA;EQwBI,gBAAA;EACA,iBAAA;AhF4o+BJ;AwErq+BA;EQ4BI,eAAA;EACA,kBAAA;AhF4o+BJ;AwEzq+BA;EQgCI,eAAA;AhF4o+BJ;AwE5q+BA;EQmCI,kBAAA;AhF4o+BJ;AwE/q+BA;EQsCI,gBAAA;AhF4o+BJ;AwElr+BA;EQyCI,iBAAA;AhF4o+BJ;AwErr+BA;EQqBI,WAAA;AhFmq+BJ;AwExr+BA;EQwBI,gBAAA;EACA,iBAAA;AhFmq+BJ;AwE5r+BA;EQ4BI,eAAA;EACA,kBAAA;AhFmq+BJ;AwEhs+BA;EQgCI,eAAA;AhFmq+BJ;AwEns+BA;EQmCI,kBAAA;AhFmq+BJ;AwEts+BA;EQsCI,gBAAA;AhFmq+BJ;AwEzs+BA;EQyCI,iBAAA;AhFmq+BJ;AwE5s+BA;EQqBI,WAAA;AhF0r+BJ;AwE/s+BA;EQwBI,gBAAA;EACA,iBAAA;AhF0r+BJ;AwEnt+BA;EQ4BI,eAAA;EACA,kBAAA;AhF0r+BJ;AwEvt+BA;EQgCI,eAAA;AhF0r+BJ;AwE1t+BA;EQmCI,kBAAA;AhF0r+BJ;AwE7t+BA;EQsCI,gBAAA;AhF0r+BJ;AwEhu+BA;EQyCI,iBAAA;AhF0r+BJ;AwEnu+BA;EQqBI,YAAA;AhFit+BJ;AwEtu+BA;EQwBI,iBAAA;EACA,kBAAA;AhFit+BJ;AwE1u+BA;EQ4BI,gBAAA;EACA,mBAAA;AhFit+BJ;AwE9u+BA;EQgCI,gBAAA;AhFit+BJ;AwEjv+BA;EQmCI,mBAAA;AhFit+BJ;AwEpv+BA;EQsCI,iBAAA;AhFit+BJ;AwEvv+BA;EQyCI,kBAAA;AhFit+BJ;AwE1v+BA;EQqBI,YAAA;AhFwu+BJ;AwE7v+BA;EQwBI,iBAAA;EACA,kBAAA;AhFwu+BJ;AwEjw+BA;EQ4BI,gBAAA;EACA,mBAAA;AhFwu+BJ;AwErw+BA;EQgCI,gBAAA;AhFwu+BJ;AwExw+BA;EQmCI,mBAAA;AhFwu+BJ;AwE3w+BA;EQsCI,iBAAA;AhFwu+BJ;AwE9w+BA;EQyCI,kBAAA;AhFwu+BJ;AwEjx+BA;EQqBI,YAAA;AhF+v+BJ;AwEpx+BA;EQwBI,iBAAA;EACA,kBAAA;AhF+v+BJ;AwExx+BA;EQ4BI,gBAAA;EACA,mBAAA;AhF+v+BJ;AwE5x+BA;EQgCI,gBAAA;AhF+v+BJ;AwE/x+BA;EQmCI,mBAAA;AhF+v+BJ;AwEly+BA;EQsCI,iBAAA;AhF+v+BJ;AwEry+BA;EQyCI,kBAAA;AhF+v+BJ;AwExy+BA;EQqBI,YAAA;AhFsx+BJ;AwE3y+BA;EQwBI,iBAAA;EACA,kBAAA;AhFsx+BJ;AwE/y+BA;EQ4BI,gBAAA;EACA,mBAAA;AhFsx+BJ;AwEnz+BA;EQgCI,gBAAA;AhFsx+BJ;AwEtz+BA;EQmCI,mBAAA;AhFsx+BJ;AwEzz+BA;EQsCI,iBAAA;AhFsx+BJ;AwE5z+BA;EQyCI,kBAAA;AhFsx+BJ;AwE/z+BA;EQqBI,YAAA;AhF6y+BJ;AwEl0+BA;EQwBI,iBAAA;EACA,kBAAA;AhF6y+BJ;AwEt0+BA;EQ4BI,gBAAA;EACA,mBAAA;AhF6y+BJ;AwE10+BA;EQgCI,gBAAA;AhF6y+BJ;AwE70+BA;EQmCI,mBAAA;AhF6y+BJ;AwEh1+BA;EQsCI,iBAAA;AhF6y+BJ;AwEn1+BA;EQyCI,kBAAA;AhF6y+BJ;AwEt1+BA;EQwEI,SAAA;AhFix+BJ;AwEz1+BA;EQ2EI,cAAA;EACA,eAAA;AhFix+BJ;AwE71+BA;EQ+EI,aAAA;EACA,gBAAA;AhFix+BJ;AwEj2+BA;EQmFI,aAAA;AhFix+BJ;AwEp2+BA;EQsFI,gBAAA;AhFix+BJ;AwEv2+BA;EQyFI,cAAA;AhFix+BJ;AwE12+BA;EQ4FI,eAAA;AhFix+BJ;AwE72+BA;EQwEI,YAAA;AhFwy+BJ;AwEh3+BA;EQ2EI,iBAAA;EACA,kBAAA;AhFwy+BJ;AwEp3+BA;EQ+EI,gBAAA;EACA,mBAAA;AhFwy+BJ;AwEx3+BA;EQmFI,gBAAA;AhFwy+BJ;AwE33+BA;EQsFI,mBAAA;AhFwy+BJ;AwE93+BA;EQyFI,iBAAA;AhFwy+BJ;AwEj4+BA;EQ4FI,kBAAA;AhFwy+BJ;AwEp4+BA;EQwEI,YAAA;AhF+z+BJ;AwEv4+BA;EQ2EI,iBAAA;EACA,kBAAA;AhF+z+BJ;AwE34+BA;EQ+EI,gBAAA;EACA,mBAAA;AhF+z+BJ;AwE/4+BA;EQmFI,gBAAA;AhF+z+BJ;AwEl5+BA;EQsFI,mBAAA;AhF+z+BJ;AwEr5+BA;EQyFI,iBAAA;AhF+z+BJ;AwEx5+BA;EQ4FI,kBAAA;AhF+z+BJ;AwE35+BA;EQwEI,YAAA;AhFs1+BJ;AwE95+BA;EQ2EI,iBAAA;EACA,kBAAA;AhFs1+BJ;AwEl6+BA;EQ+EI,gBAAA;EACA,mBAAA;AhFs1+BJ;AwEt6+BA;EQmFI,gBAAA;AhFs1+BJ;AwEz6+BA;EQsFI,mBAAA;AhFs1+BJ;AwE56+BA;EQyFI,iBAAA;AhFs1+BJ;AwE/6+BA;EQ4FI,kBAAA;AhFs1+BJ;AwEl7+BA;EQwEI,aAAA;AhF62+BJ;AwEr7+BA;EQ2EI,kBAAA;EACA,mBAAA;AhF62+BJ;AwEz7+BA;EQ+EI,iBAAA;EACA,oBAAA;AhF62+BJ;AwE77+BA;EQmFI,iBAAA;AhF62+BJ;AwEh8+BA;EQsFI,oBAAA;AhF62+BJ;AwEn8+BA;EQyFI,kBAAA;AhF62+BJ;AwEt8+BA;EQ4FI,mBAAA;AhF62+BJ;AwEz8+BA;EQwEI,aAAA;AhFo4+BJ;AwE58+BA;EQ2EI,kBAAA;EACA,mBAAA;AhFo4+BJ;AwEh9+BA;EQ+EI,iBAAA;EACA,oBAAA;AhFo4+BJ;AwEp9+BA;EQmFI,iBAAA;AhFo4+BJ;AwEv9+BA;EQsFI,oBAAA;AhFo4+BJ;AwE19+BA;EQyFI,kBAAA;AhFo4+BJ;AwE79+BA;EQ4FI,mBAAA;AhFo4+BJ;AwEh++BA;EQwEI,aAAA;AhF25+BJ;AwEn++BA;EQ2EI,kBAAA;EACA,mBAAA;AhF25+BJ;AwEv++BA;EQ+EI,iBAAA;EACA,oBAAA;AhF25+BJ;AwE3++BA;EQmFI,iBAAA;AhF25+BJ;AwE9++BA;EQsFI,oBAAA;AhF25+BJ;AwEj/+BA;EQyFI,kBAAA;AhF25+BJ;AwEp/+BA;EQ4FI,mBAAA;AhF25+BJ;AwEv/+BA;EQwEI,aAAA;AhFk7+BJ;AwE1/+BA;EQ2EI,kBAAA;EACA,mBAAA;AhFk7+BJ;AwE9/+BA;EQ+EI,iBAAA;EACA,oBAAA;AhFk7+BJ;AwElg/BA;EQmFI,iBAAA;AhFk7+BJ;AwErg/BA;EQsFI,oBAAA;AhFk7+BJ;AwExg/BA;EQyFI,kBAAA;AhFk7+BJ;AwE3g/BA;EQ4FI,mBAAA;AhFk7+BJ;AwE9g/BA;EQwEI,aAAA;AhFy8+BJ;AwEjh/BA;EQ2EI,kBAAA;EACA,mBAAA;AhFy8+BJ;AwErh/BA;EQ+EI,iBAAA;EACA,oBAAA;AhFy8+BJ;AwEzh/BA;EQmFI,iBAAA;AhFy8+BJ;AwE5h/BA;EQsFI,oBAAA;AhFy8+BJ;AwE/h/BA;EQyFI,kBAAA;AhFy8+BJ;AwEli/BA;EQ4FI,mBAAA;AhFy8+BJ;AwEri/BA;EQqBI,UAAA;AhFmh/BJ;AwExi/BA;EQwBI,eAAA;EACA,gBAAA;AhFmh/BJ;AwE5i/BA;EQ4BI,cAAA;EACA,iBAAA;AhFmh/BJ;AwEhj/BA;EQgCI,cAAA;AhFmh/BJ;AwEnj/BA;EQmCI,iBAAA;AhFmh/BJ;AwEtj/BA;EQsCI,eAAA;AhFmh/BJ;AwEzj/BA;EQyCI,gBAAA;AhFmh/BJ;AwE5j/BA;EQqBI,YAAA;AhF0i/BJ;AwE/j/BA;EQwBI,iBAAA;EACA,kBAAA;AhF0i/BJ;AwEnk/BA;EQ4BI,gBAAA;EACA,mBAAA;AhF0i/BJ;AwEvk/BA;EQgCI,gBAAA;AhF0i/BJ;AwE1k/BA;EQmCI,mBAAA;AhF0i/BJ;AwE7k/BA;EQsCI,iBAAA;AhF0i/BJ;AwEhl/BA;EQyCI,kBAAA;AhF0i/BJ;AwEnl/BA;EQqBI,YAAA;AhFik/BJ;AwEtl/BA;EQwBI,iBAAA;EACA,kBAAA;AhFik/BJ;AwE1l/BA;EQ4BI,gBAAA;EACA,mBAAA;AhFik/BJ;AwE9l/BA;EQgCI,gBAAA;AhFik/BJ;AwEjm/BA;EQmCI,mBAAA;AhFik/BJ;AwEpm/BA;EQsCI,iBAAA;AhFik/BJ;AwEvm/BA;EQyCI,kBAAA;AhFik/BJ;AwE1m/BA;EQqBI,YAAA;AhFwl/BJ;AwE7m/BA;EQwBI,iBAAA;EACA,kBAAA;AhFwl/BJ;AwEjn/BA;EQ4BI,gBAAA;EACA,mBAAA;AhFwl/BJ;AwErn/BA;EQgCI,gBAAA;AhFwl/BJ;AwExn/BA;EQmCI,mBAAA;AhFwl/BJ;AwE3n/BA;EQsCI,iBAAA;AhFwl/BJ;AwE9n/BA;EQyCI,kBAAA;AhFwl/BJ;AwEjo/BA;EQqBI,aAAA;AhF+m/BJ;AwEpo/BA;EQwBI,kBAAA;EACA,mBAAA;AhF+m/BJ;AwExo/BA;EQ4BI,iBAAA;EACA,oBAAA;AhF+m/BJ;AwE5o/BA;EQgCI,iBAAA;AhF+m/BJ;AwE/o/BA;EQmCI,oBAAA;AhF+m/BJ;AwElp/BA;EQsCI,kBAAA;AhF+m/BJ;AwErp/BA;EQyCI,mBAAA;AhF+m/BJ;AwExp/BA;EQqBI,aAAA;AhFso/BJ;AwE3p/BA;EQwBI,kBAAA;EACA,mBAAA;AhFso/BJ;AwE/p/BA;EQ4BI,iBAAA;EACA,oBAAA;AhFso/BJ;AwEnq/BA;EQgCI,iBAAA;AhFso/BJ;AwEtq/BA;EQmCI,oBAAA;AhFso/BJ;AwEzq/BA;EQsCI,kBAAA;AhFso/BJ;AwE5q/BA;EQyCI,mBAAA;AhFso/BJ;AwE/q/BA;EQqBI,aAAA;AhF6p/BJ;AwElr/BA;EQwBI,kBAAA;EACA,mBAAA;AhF6p/BJ;AwEtr/BA;EQ4BI,iBAAA;EACA,oBAAA;AhF6p/BJ;AwE1r/BA;EQgCI,iBAAA;AhF6p/BJ;AwE7r/BA;EQmCI,oBAAA;AhF6p/BJ;AwEhs/BA;EQsCI,kBAAA;AhF6p/BJ;AwEns/BA;EQyCI,mBAAA;AhF6p/BJ;AwEts/BA;EQqBI,aAAA;AhFor/BJ;AwEzs/BA;EQwBI,kBAAA;EACA,mBAAA;AhFor/BJ;AwE7s/BA;EQ4BI,iBAAA;EACA,oBAAA;AhFor/BJ;AwEjt/BA;EQgCI,iBAAA;AhFor/BJ;AwEpt/BA;EQmCI,oBAAA;AhFor/BJ;AwEvt/BA;EQsCI,kBAAA;AhFor/BJ;AwE1t/BA;EQyCI,mBAAA;AhFor/BJ;AwE7t/BA;EQqBI,aAAA;AhF2s/BJ;AwEhu/BA;EQwBI,kBAAA;EACA,mBAAA;AhF2s/BJ;AwEpu/BA;EQ4BI,iBAAA;EACA,oBAAA;AhF2s/BJ;AwExu/BA;EQgCI,iBAAA;AhF2s/BJ;AwE3u/BA;EQmCI,oBAAA;AhF2s/BJ;AwE9u/BA;EQsCI,kBAAA;AhF2s/BJ;AwEjv/BA;EQyCI,mBAAA;AhF2s/BJ;AwEpv/BA;EQ4HI,MAAA;AhF2n/BJ;AwEvv/BA;EQ4HI,QAAA;AhF8n/BJ;AwE1v/BA;EQ4HI,QAAA;AhFio/BJ;AwE7v/BA;EQ4HI,QAAA;AhFoo/BJ;AwEhw/BA;EQ4HI,SAAA;AhFuo/BJ;AwEnw/BA;EQ4HI,SAAA;AhF0o/BJ;AwEtw/BA;EQ4HI,SAAA;AhF6o/BJ;AwEzw/BA;EQ4HI,SAAA;AhFgp/BJ;AwE5w/BA;EQ4HI,SAAA;AhFmp/BJ;AwE/w/BA;EQ+CI,oBAAA;AhFmu/BJ;AwElx/BA;EQkDI,yBAAA;EACA,0BAAA;AhFmu/BJ;AwEtx/BA;EQsDI,wBAAA;EACA,2BAAA;AhFmu/BJ;AwE1x/BA;EQ0DI,wBAAA;AhFmu/BJ;AwE7x/BA;EQ6DI,2BAAA;AhFmu/BJ;AwEhy/BA;EQgEI,yBAAA;AhFmu/BJ;AwEny/BA;EQmEI,0BAAA;AhFmu/BJ;AwEty/BA;EQ+CI,uBAAA;AhF0v/BJ;AwEzy/BA;EQkDI,4BAAA;EACA,6BAAA;AhF0v/BJ;AwE7y/BA;EQsDI,2BAAA;EACA,8BAAA;AhF0v/BJ;AwEjz/BA;EQ0DI,2BAAA;AhF0v/BJ;AwEpz/BA;EQ6DI,8BAAA;AhF0v/BJ;AwEvz/BA;EQgEI,4BAAA;AhF0v/BJ;AwE1z/BA;EQmEI,6BAAA;AhF0v/BJ;AwE7z/BA;EQ+CI,sBAAA;AhFix/BJ;AwEh0/BA;EQkDI,2BAAA;EACA,4BAAA;AhFix/BJ;AwEp0/BA;EQsDI,0BAAA;EACA,6BAAA;AhFix/BJ;AwEx0/BA;EQ0DI,0BAAA;AhFix/BJ;AwE30/BA;EQ6DI,6BAAA;AhFix/BJ;AwE90/BA;EQgEI,2BAAA;AhFix/BJ;AwEj1/BA;EQmEI,4BAAA;AhFix/BJ;AwEp1/BA;EQ+CI,sBAAA;AhFwy/BJ;AwEv1/BA;EQkDI,2BAAA;EACA,4BAAA;AhFwy/BJ;AwE31/BA;EQsDI,0BAAA;EACA,6BAAA;AhFwy/BJ;AwE/1/BA;EQ0DI,0BAAA;AhFwy/BJ;AwEl2/BA;EQ6DI,6BAAA;AhFwy/BJ;AwEr2/BA;EQgEI,2BAAA;AhFwy/BJ;AwEx2/BA;EQmEI,4BAAA;AhFwy/BJ;AwE32/BA;EQ+CI,sBAAA;AhF+z/BJ;AwE92/BA;EQkDI,2BAAA;EACA,4BAAA;AhF+z/BJ;AwEl3/BA;EQsDI,0BAAA;EACA,6BAAA;AhF+z/BJ;AwEt3/BA;EQ0DI,0BAAA;AhF+z/BJ;AwEz3/BA;EQ6DI,6BAAA;AhF+z/BJ;AwE53/BA;EQgEI,2BAAA;AhF+z/BJ;AwE/3/BA;EQmEI,4BAAA;AhF+z/BJ;AwEl4/BA;EQ+CI,uBAAA;AhFs1/BJ;AwEr4/BA;EQkDI,4BAAA;EACA,6BAAA;AhFs1/BJ;AwEz4/BA;EQsDI,2BAAA;EACA,8BAAA;AhFs1/BJ;AwE74/BA;EQ0DI,2BAAA;AhFs1/BJ;AwEh5/BA;EQ6DI,8BAAA;AhFs1/BJ;AwEn5/BA;EQgEI,4BAAA;AhFs1/BJ;AwEt5/BA;EQmEI,6BAAA;AhFs1/BJ;AwEz5/BA;EQ+CI,uBAAA;AhF62/BJ;AwE55/BA;EQkDI,4BAAA;EACA,6BAAA;AhF62/BJ;AwEh6/BA;EQsDI,2BAAA;EACA,8BAAA;AhF62/BJ;AwEp6/BA;EQ0DI,2BAAA;AhF62/BJ;AwEv6/BA;EQ6DI,8BAAA;AhF62/BJ;AwE16/BA;EQgEI,4BAAA;AhF62/BJ;AwE76/BA;EQmEI,6BAAA;AhF62/BJ;AwEh7/BA;EQ+CI,uBAAA;AhFo4/BJ;AwEn7/BA;EQkDI,4BAAA;EACA,6BAAA;AhFo4/BJ;AwEv7/BA;EQsDI,2BAAA;EACA,8BAAA;AhFo4/BJ;AwE37/BA;EQ0DI,2BAAA;AhFo4/BJ;AwE97/BA;EQ6DI,8BAAA;AhFo4/BJ;AwEj8/BA;EQgEI,4BAAA;AhFo4/BJ;AwEp8/BA;EQmEI,6BAAA;AhFo4/BJ;AwEv8/BA;EQ+CI,uBAAA;AhF25/BJ;AwE18/BA;EQkDI,4BAAA;EACA,6BAAA;AhF25/BJ;AwE98/BA;EQsDI,2BAAA;EACA,8BAAA;AhF25/BJ;AwEl9/BA;EQ0DI,2BAAA;AhF25/BJ;AwEr9/BA;EQ6DI,8BAAA;AhF25/BJ;AwEx9/BA;EQgEI,4BAAA;AhF25/BJ;AwE39/BA;EQmEI,6BAAA;AhF25/BJ;AwE99/BA;EQ+CI,uBAAA;AhFk7/BJ;AwEj+/BA;EQkDI,4BAAA;EACA,6BAAA;AhFk7/BJ;AwEr+/BA;EQsDI,2BAAA;EACA,8BAAA;AhFk7/BJ;AwEz+/BA;EQ0DI,2BAAA;AhFk7/BJ;AwE5+/BA;EQ6DI,8BAAA;AhFk7/BJ;AwE/+/BA;EQgEI,4BAAA;AhFk7/BJ;AwEl//BA;EQmEI,6BAAA;AhFk7/BJ;AwEr//BA;EQkGI,oBAAA;AhFs5/BJ;AwEx//BA;EQqGI,yBAAA;EACA,0BAAA;AhFs5/BJ;AwE5//BA;EQyGI,wBAAA;EACA,2BAAA;AhFs5/BJ;AwEhggCA;EQ6GI,wBAAA;AhFs5/BJ;AwEnggCA;EQgHI,2BAAA;AhFs5/BJ;AwEtggCA;EQmHI,yBAAA;AhFs5/BJ;AwEzggCA;EQsHI,0BAAA;AhFs5/BJ;AwE5ggCA;EQkGI,uBAAA;AhF66/BJ;AwE/ggCA;EQqGI,4BAAA;EACA,6BAAA;AhF66/BJ;AwEnhgCA;EQyGI,2BAAA;EACA,8BAAA;AhF66/BJ;AwEvhgCA;EQ6GI,2BAAA;AhF66/BJ;AwE1hgCA;EQgHI,8BAAA;AhF66/BJ;AwE7hgCA;EQmHI,4BAAA;AhF66/BJ;AwEhigCA;EQsHI,6BAAA;AhF66/BJ;AwEnigCA;EQkGI,uBAAA;AhFo8/BJ;AwEtigCA;EQqGI,4BAAA;EACA,6BAAA;AhFo8/BJ;AwE1igCA;EQyGI,2BAAA;EACA,8BAAA;AhFo8/BJ;AwE9igCA;EQ6GI,2BAAA;AhFo8/BJ;AwEjjgCA;EQgHI,8BAAA;AhFo8/BJ;AwEpjgCA;EQmHI,4BAAA;AhFo8/BJ;AwEvjgCA;EQsHI,6BAAA;AhFo8/BJ;AwE1jgCA;EQkGI,uBAAA;AhF29/BJ;AwE7jgCA;EQqGI,4BAAA;EACA,6BAAA;AhF29/BJ;AwEjkgCA;EQyGI,2BAAA;EACA,8BAAA;AhF29/BJ;AwErkgCA;EQ6GI,2BAAA;AhF29/BJ;AwExkgCA;EQgHI,8BAAA;AhF29/BJ;AwE3kgCA;EQmHI,4BAAA;AhF29/BJ;AwE9kgCA;EQsHI,6BAAA;AhF29/BJ;AwEjlgCA;EQkGI,wBAAA;AhFk//BJ;AwEplgCA;EQqGI,6BAAA;EACA,8BAAA;AhFk//BJ;AwExlgCA;EQyGI,4BAAA;EACA,+BAAA;AhFk//BJ;AwE5lgCA;EQ6GI,4BAAA;AhFk//BJ;AwE/lgCA;EQgHI,+BAAA;AhFk//BJ;AwElmgCA;EQmHI,6BAAA;AhFk//BJ;AwErmgCA;EQsHI,8BAAA;AhFk//BJ;AwExmgCA;EQkGI,wBAAA;AhFyggCJ;AwE3mgCA;EQqGI,6BAAA;EACA,8BAAA;AhFyggCJ;AwE/mgCA;EQyGI,4BAAA;EACA,+BAAA;AhFyggCJ;AwEnngCA;EQ6GI,4BAAA;AhFyggCJ;AwEtngCA;EQgHI,+BAAA;AhFyggCJ;AwEzngCA;EQmHI,6BAAA;AhFyggCJ;AwE5ngCA;EQsHI,8BAAA;AhFyggCJ;AwE/ngCA;EQkGI,wBAAA;AhFgigCJ;AwElogCA;EQqGI,6BAAA;EACA,8BAAA;AhFgigCJ;AwEtogCA;EQyGI,4BAAA;EACA,+BAAA;AhFgigCJ;AwE1ogCA;EQ6GI,4BAAA;AhFgigCJ;AwE7ogCA;EQgHI,+BAAA;AhFgigCJ;AwEhpgCA;EQmHI,6BAAA;AhFgigCJ;AwEnpgCA;EQsHI,8BAAA;AhFgigCJ;AwEtpgCA;EQkGI,wBAAA;AhFujgCJ;AwEzpgCA;EQqGI,6BAAA;EACA,8BAAA;AhFujgCJ;AwE7pgCA;EQyGI,4BAAA;EACA,+BAAA;AhFujgCJ;AwEjqgCA;EQ6GI,4BAAA;AhFujgCJ;AwEpqgCA;EQgHI,+BAAA;AhFujgCJ;AwEvqgCA;EQmHI,6BAAA;AhFujgCJ;AwE1qgCA;EQsHI,8BAAA;AhFujgCJ;AwE7qgCA;EQkGI,wBAAA;AhF8kgCJ;AwEhrgCA;EQqGI,6BAAA;EACA,8BAAA;AhF8kgCJ;AwEprgCA;EQyGI,4BAAA;EACA,+BAAA;AhF8kgCJ;AwExrgCA;EQ6GI,4BAAA;AhF8kgCJ;AwE3rgCA;EQgHI,+BAAA;AhF8kgCJ;AwE9rgCA;EQmHI,6BAAA;AhF8kgCJ;AwEjsgCA;EQsHI,8BAAA;AhF8kgCJ;AwEpsgCA;EQ+CI,qBAAA;AhFwpgCJ;AwEvsgCA;EQkDI,0BAAA;EACA,2BAAA;AhFwpgCJ;AwE3sgCA;EQsDI,yBAAA;EACA,4BAAA;AhFwpgCJ;AwE/sgCA;EQ0DI,yBAAA;AhFwpgCJ;AwEltgCA;EQ6DI,4BAAA;AhFwpgCJ;AwErtgCA;EQgEI,0BAAA;AhFwpgCJ;AwExtgCA;EQmEI,2BAAA;AhFwpgCJ;AwE3tgCA;EQ+CI,uBAAA;AhF+qgCJ;AwE9tgCA;EQkDI,4BAAA;EACA,6BAAA;AhF+qgCJ;AwElugCA;EQsDI,2BAAA;EACA,8BAAA;AhF+qgCJ;AwEtugCA;EQ0DI,2BAAA;AhF+qgCJ;AwEzugCA;EQ6DI,8BAAA;AhF+qgCJ;AwE5ugCA;EQgEI,4BAAA;AhF+qgCJ;AwE/ugCA;EQmEI,6BAAA;AhF+qgCJ;AwElvgCA;EQ+CI,uBAAA;AhFssgCJ;AwErvgCA;EQkDI,4BAAA;EACA,6BAAA;AhFssgCJ;AwEzvgCA;EQsDI,2BAAA;EACA,8BAAA;AhFssgCJ;AwE7vgCA;EQ0DI,2BAAA;AhFssgCJ;AwEhwgCA;EQ6DI,8BAAA;AhFssgCJ;AwEnwgCA;EQgEI,4BAAA;AhFssgCJ;AwEtwgCA;EQmEI,6BAAA;AhFssgCJ;AwEzwgCA;EQ+CI,uBAAA;AhF6tgCJ;AwE5wgCA;EQkDI,4BAAA;EACA,6BAAA;AhF6tgCJ;AwEhxgCA;EQsDI,2BAAA;EACA,8BAAA;AhF6tgCJ;AwEpxgCA;EQ0DI,2BAAA;AhF6tgCJ;AwEvxgCA;EQ6DI,8BAAA;AhF6tgCJ;AwE1xgCA;EQgEI,4BAAA;AhF6tgCJ;AwE7xgCA;EQmEI,6BAAA;AhF6tgCJ;AwEhygCA;EQ+CI,wBAAA;AhFovgCJ;AwEnygCA;EQkDI,6BAAA;EACA,8BAAA;AhFovgCJ;AwEvygCA;EQsDI,4BAAA;EACA,+BAAA;AhFovgCJ;AwE3ygCA;EQ0DI,4BAAA;AhFovgCJ;AwE9ygCA;EQ6DI,+BAAA;AhFovgCJ;AwEjzgCA;EQgEI,6BAAA;AhFovgCJ;AwEpzgCA;EQmEI,8BAAA;AhFovgCJ;AwEvzgCA;EQ+CI,wBAAA;AhF2wgCJ;AwE1zgCA;EQkDI,6BAAA;EACA,8BAAA;AhF2wgCJ;AwE9zgCA;EQsDI,4BAAA;EACA,+BAAA;AhF2wgCJ;AwEl0gCA;EQ0DI,4BAAA;AhF2wgCJ;AwEr0gCA;EQ6DI,+BAAA;AhF2wgCJ;AwEx0gCA;EQgEI,6BAAA;AhF2wgCJ;AwE30gCA;EQmEI,8BAAA;AhF2wgCJ;AwE90gCA;EQ+CI,wBAAA;AhFkygCJ;AwEj1gCA;EQkDI,6BAAA;EACA,8BAAA;AhFkygCJ;AwEr1gCA;EQsDI,4BAAA;EACA,+BAAA;AhFkygCJ;AwEz1gCA;EQ0DI,4BAAA;AhFkygCJ;AwE51gCA;EQ6DI,+BAAA;AhFkygCJ;AwE/1gCA;EQgEI,6BAAA;AhFkygCJ;AwEl2gCA;EQmEI,8BAAA;AhFkygCJ;AwEr2gCA;EQ+CI,wBAAA;AhFyzgCJ;AwEx2gCA;EQkDI,6BAAA;EACA,8BAAA;AhFyzgCJ;AwE52gCA;EQsDI,4BAAA;EACA,+BAAA;AhFyzgCJ;AwEh3gCA;EQ0DI,4BAAA;AhFyzgCJ;AwEn3gCA;EQ6DI,+BAAA;AhFyzgCJ;AwEt3gCA;EQgEI,6BAAA;AhFyzgCJ;AwEz3gCA;EQmEI,8BAAA;AhFyzgCJ;AwE53gCA;EQ+CI,wBAAA;AhFg1gCJ;AwE/3gCA;EQkDI,6BAAA;EACA,8BAAA;AhFg1gCJ;AwEn4gCA;EQsDI,4BAAA;EACA,+BAAA;AhFg1gCJ;AwEv4gCA;EQ0DI,4BAAA;AhFg1gCJ;AwE14gCA;EQ6DI,+BAAA;AhFg1gCJ;AwE74gCA;EQgEI,6BAAA;AhFg1gCJ;AwEh5gCA;EQmEI,8BAAA;AhFg1gCJ;AwEn5gCA;EQYI,QAAA;AhF04gCJ;AwEt5gCA;EQeI,mBAAA;AhF04gCJ;AwEz5gCA;EQYI,UAAA;AhFg5gCJ;AwE55gCA;EQeI,qBAAA;AhFg5gCJ;AwE/5gCA;EQYI,UAAA;AhFs5gCJ;AwEl6gCA;EQeI,qBAAA;AhFs5gCJ;AwEr6gCA;EQYI,UAAA;AhF45gCJ;AwEx6gCA;EQeI,qBAAA;AhF45gCJ;AwE36gCA;EQYI,WAAA;AhFk6gCJ;AwE96gCA;EQeI,sBAAA;AhFk6gCJ;AwEj7gCA;EQYI,WAAA;AhFw6gCJ;AwEp7gCA;EQeI,sBAAA;AhFw6gCJ;AwEv7gCA;EQYI,WAAA;AhF86gCJ;AwE17gCA;EQeI,sBAAA;AhF86gCJ;AwE77gCA;EQYI,WAAA;AhFo7gCJ;AwEh8gCA;EQeI,sBAAA;AhFo7gCJ;AwEn8gCA;EQYI,WAAA;AhF07gCJ;AwEt8gCA;EQeI,sBAAA;AhF07gCJ;AwEpvgCM;EACE,gBAAA;AxEsvgCR;AwEpvgCM;EACE,kBAAA;AxEsvgCR;AwEpvgCM;EACE,kBAAA;AxEsvgCR;AwEpvgCM;EACE,kBAAA;AxEsvgCR;AwEpvgCM;EACE,mBAAA;AxEsvgCR;AwEpvgCM;EACE,qBAAA;AxEsvgCR;AwEnvgCQ;EACE,2BAAA;EACA,4BAAA;AxEqvgCV;AwEnvgCQ;EACE,2BAAA;EACA,4BAAA;AxEqvgCV;AwEnvgCQ;EACE,4BAAA;EACA,6BAAA;AxEqvgCV;AwEnvgCQ;EACE,yBAAA;EACA,0BAAA;AxEqvgCV;AwEnvgCQ;EACE,oCAAA;EACA,qCAAA;AxEqvgCV;AwElvgCU;EACE,2BAAA;EACA,8BAAA;AxEovgCZ;AwElvgCU;EACE,2BAAA;EACA,8BAAA;AxEovgCZ;AwElvgCU;EACE,4BAAA;EACA,+BAAA;AxEovgCZ;AwElvgCU;EACE,yBAAA;EACA,4BAAA;AxEovgCZ;AwElvgCU;EACE,oCAAA;EACA,uCAAA;AxEovgCZ;AwE/ugCQ;EACE,8BAAA;EACA,+BAAA;AxEivgCV;AwE/ugCQ;EACE,8BAAA;EACA,+BAAA;AxEivgCV;AwE/ugCQ;EACE,+BAAA;EACA,gCAAA;AxEivgCV;AwE/ugCQ;EACE,4BAAA;EACA,6BAAA;AxEivgCV;AwE/ugCQ;EACE,uCAAA;EACA,wCAAA;AxEivgCV;AwE7ugCQ;EACE,2BAAA;EACA,8BAAA;AxE+ugCV;AwE7ugCQ;EACE,2BAAA;EACA,8BAAA;AxE+ugCV;AwE7ugCQ;EACE,4BAAA;EACA,+BAAA;AxE+ugCV;AwE7ugCQ;EACE,yBAAA;EACA,4BAAA;AxE+ugCV;AwE7ugCQ;EACE,oCAAA;EACA,uCAAA;AxE+ugCV;AwE3ugCQ;EACE,4BAAA;EACA,+BAAA;AxE6ugCV;AwE3ugCQ;EACE,4BAAA;EACA,+BAAA;AxE6ugCV;AwE3ugCQ;EACE,6BAAA;EACA,gCAAA;AxE6ugCV;AwE3ugCQ;EACE,0BAAA;EACA,6BAAA;AxE6ugCV;AwE3ugCQ;EACE,qCAAA;EACA,wCAAA;AxE6ugCV;AwExugCI;EACE,iBAAA;EACA,kBAAA;AxE0ugCN;AwExugCI;EACE,gBAAA;EACA,mBAAA;AxE0ugCN;AwExugCI;EACE,iBAAA;AxE0ugCN;AwExugCI;EACE,kBAAA;AxE0ugCN;AwExugCI;EACE,mBAAA;AxE0ugCN;AwExugCI;EACE,gBAAA;AxE0ugCN;AwExugCI;EACE,YAAA;AxE0ugCN;AwEzugCM;EACE,uBAAA;AxE2ugCR;AwExugCI;EACE,mBAAA;AxE0ugCN;AwExugCI;EACE,oBAAA;AxE0ugCN;AwEzugCM;EACE,+BAAA;AxE2ugCR;AwExugCI;EACE,oBAAA;AxE0ugCN;AwExugCI;EACE,iBAAA;AxE0ugCN;AwExugCI;EACE,gBAAA;AxE0ugCN;AwExugCI;EACE,kBAAA;AxE0ugCN;AwExugCI;EACE,mBAAA;AxE0ugCN;AwExugCI;EACE,iBAAA;AxE0ugCN;AwExugCI;EACE,iBAAA;AxE0ugCN;AwEnugCM;EzDjQF,eAAA;Afu+gCJ;AwEnugCM;EzDpQF,eAAA;Af0+gCJ;AwEnugCM;EzDvQF,eAAA;Af6+gCJ;AwEnugCM;EzD1QF,eAAA;Afg/gCJ;AwEnugCM;EzD7QF,eAAA;Afm/gCJ;AwElugCM;EzDjRF,eAAA;Afs/gCJ;AwElugCM;EzDpRF,eAAA;Afy/gCJ;AwElugCM;EzDvRF,eAAA;Af4/gCJ;AwElugCM;EzD1RF,eAAA;Af+/gCJ;AwEhugCM;EACE,mBAAA;AxEkugCR;AwE/tgCM;EACE,gBAAA;AxEiugCR;AwE9tgCM;EACE,gBAAA;AxEgugCR;AwE7tgCM;EACE,gBAAA;AxE+tgCR;AwE5tgCM;EACE,iBAAA;AxE8tgCR;AwEztgCM;EACE,kBAAA;AxE2tgCR;AwEztgCM;EACE,kBAAA;AxE2tgCR;AwEvtgCI;EACE,6BAAA;AxEytgCN;AwErtgCM;EACE,cAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,cAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwErtgCM;EACE,eAAA;EACA,iBAAA;AxEutgCR;AwEptgCM;EACE,kBAAA;EACA,oBAAA;AxEstgCR;AwEntgCM;EACE,eAAA;EACA,iBAAA;AxEqtgCR;AwEltgCM;EACE,eAAA;AxEotgCR;AwEjtgCM;EACE,cAAA;AxEmtgCR;AwEhtgCM;EACE,cAAA;AxEktgCR;AwE/sgCM;EACE,eAAA;AxEitgCR;AwE9sgCM;EACE,eAAA;AxEgtgCR;AwE7sgCM;EACE,eAAA;AxE+sgCR;AwE9sgCQ;EACE,0BAAA;AxEgtgCV;AwE7sgCM;EACE,eAAA;AxE+sgCR;AwE7sgCM;EACE,eAAA;AxE+sgCR;AwE3sgCM;EACE,mBAAA;AxE6sgCR;AwE3sgCM;EACE,gBAAA;AxE6sgCR;AwE3sgCM;EACE,qBAAA;AxE6sgCR;AwE3sgCM;EACE,mBAAA;AxE6sgCR;AwE9sgCM;EAII,8BAAA;AxE6sgCV;AwEzsgCI;EACE,yBAAA;AxE2sgCN;AwEzsgCI;EACE,yBAAA;AxE2sgCN;AwExsgCM;EACE,kBAAA;AxE0sgCR;AwEvsgCM;EACE,iBAAA;AxEysgCR;AwEtsgCM;EACE,gBAAA;AxEwsgCR;AwEnxhCA;EAilBI,eAAA;EACA,iBAAA;AxEqsgCJ;AwEvxhCA;EAqlBI,eAAA;EACA,iBAAA;AxEqsgCJ;AwE3xhCA;EAylBI,eAAA;EACA,iBAAA;AxEqsgCJ;AwE/xhCA;EzDmJI,eAAA;Af+ohCJ;AwElyhCA;EAkmBI,kBAAA;EACA,qBAAA;AxEmsgCJ;AwEtyhCA;EAumBI,yBAAA;AxEksgCJ;AwEzyhCA;EA2mBI,qBAAA;AxEisgCJ;AwE5yhCA;;EAgnBI,gBAAA;EACA,uBAAA;EACA,mBAAA;AxEgsgCJ;AwE5rgCI;EACE,aAAA;AxE8rgCN;AwExrgCI;EACE,kBAAA;AxE0rgCN;AwEzrgCM;EACE,6BAAA;AxE2rgCR;AwExrgCI;EACE,kBAAA;AxE0rgCN;AwEzrgCM;EACE,6BAAA;AxE2rgCR;AwExrgCI;EACE,gBAAA;AxE0rgCN;AwEzrgCM;EACE,2BAAA;AxE2rgCR;AwExrgCI;EACE,eAAA;AxE0rgCN;AwEzrgCM;EACE,0BAAA;AxE2rgCR;AwExrgCI;EACE,gBAAA;AxE0rgCN;AwEzrgCM;EACE,2BAAA;AxE2rgCR;AwExrgCI;EACE,QAAA;AxE0rgCN;AwEzrgCM;EACE,WAAA;AxE2rgCR;AwExrgCI;EACE,OAAA;AxE0rgCN;AwEzrgCM;EACE,UAAA;AxE2rgCR;AwExrgCI;EACE,MAAA;AxE0rgCN;AwEzrgCM;EACE,SAAA;AxE2rgCR;AwEzrgCM;EACE,SAAA;AxE2rgCR;AwEzrgCM;EACE,QAAA;AxE2rgCR;AwExrgCI;EACE,SAAA;AxE0rgCN;AwEzrgCM;EACE,YAAA;AxE2rgCR;AwExrgCI;EACE,MAAA;EACA,QAAA;AxE0rgCN;AwEzrgCM;EACE,QAAA;EACA,UAAA;AxE2rgCR;AwExrgCI;EACE,MAAA;EACA,OAAA;AxE0rgCN;AwEzrgCM;EACE,QAAA;EACA,SAAA;AxE2rgCR;AwExrgCI;EACE,SAAA;EACA,QAAA;AxE0rgCN;AwEzrgCM;EACE,WAAA;EACA,UAAA;AxE2rgCR;AwExrgCI;EACE,SAAA;EACA,OAAA;AxE0rgCN;AwEzrgCM;EACE,WAAA;EACA,SAAA;AxE2rgCR;AwExrgCI;EACE,QAAA;EACA,2BAAA;AxE0rgCN;AwExrgCI;EACE,SAAA;EACA,2BAAA;AxE0rgCN;AwExrgCI;EACE,QAAA;EACA,SAAA;EACA,gCAAA;AxE0rgCN;AwErrgCI;EACE,YAAA;AxEurgCN;AwEj6hCA;EA8uBI,YAAA;AxEsrgCJ;AwEp6hCA;EAivBI,eAAA;AxEsrgCJ;AwErrgCI;EACE,iBAAA;AxEurgCN;AwE16hCA;EAwvBI,mBAAA;AxEqrgCJ;AwE76hCA;EA4vBI,kBAAA;AxEorgCJ;AwEjrgCI;EACE,aAAA;AxEmrgCN;AwE/qgCI;EACE,iBAAA;AxEirgCN;AwE/qgCI;EACE,gBAAA;AxEirgCN;AwE/qgCI;EACE,cAAA;AxEirgCN;AwE9qgCM;EACE,kBAAA;AxEgrgCR;AwE9qgCM;EACE,gBAAA;AxEgrgCR;AwE5qgCM;EACE,kBAAA;AxE8qgCR;AwE5qgCM;EACE,gBAAA;AxE8qgCR;AwE3qgCI;EACE,gBAAA;EACA,uBAAA;AxE6qgCN;AwExqgCI;EACE,sBAAA;AxE0qgCN;AwExqgCI;EACE,wBAAA;AxE0qgCN;AwExqgCI;EACE,sBAAA;AxE0qgCN;AwExqgCI;EACE,mBAAA;AxE0qgCN;AwExqgCI;EACE,wBAAA;AxE0qgCN;AwE39hCA;EAqzBI,cAAA;AxEyqgCJ;AwE99hCA;EAyzBI,iBAAA;AxEwqgCJ;AwEj+hCA;EA6zBI,iBAAA;AxEuqgCJ;AwEp+hCA;EAi0BI,iBAAA;AxEsqgCJ;AwEv+hCA;EAq0BI,iBAAA;AxEqqgCJ;AwE1+hCA;EAy0BI,iBAAA;AxEoqgCJ;AwE7+hCA;EA60BI,iBAAA;AxEmqgCJ;AwEh/hCA;EAi1BI,iBAAA;AxEkqgCJ;AwEn/hCA;EAq1BI,iBAAA;AxEiqgCJ;AwEt/hCA;EAy1BI,gBAAA;EACA,mBAAA;AxEgqgCJ;AwE5pgCI;EACE,YAAA;AxE8pgCN;AwE5pgCI;EACE,kBAAA;AxE8pgCN;AwE5pgCI;EACE,gBAAA;AxE8pgCN;AwE1pgCI;EACE,eAAA;AxE4pgCN;AwE1pgCI;EACE,eAAA;AxE4pgCN;AwE1pgCI;EACE,YAAA;AxE4pgCN;AwE1pgCI;EACE,YAAA;AxE4pgCN;AwE1pgCI;;EAEE,mBAAA;AxE4pgCN;AwE1pgCI;EACE,eAAA;AxE4pgCN;AwExpgCI;EACE,eAAA;AxE0pgCN;AwExpgCI;EACE,cAAA;AxE0pgCN;AwExpgCI;EACE,qBAAA;AxE0pgCN;AwExpgCI;EACE,aAAA;AxE0pgCN;AwExpgCI;EACE,oBAAA;AxE0pgCN;AwExpgCI;EACE,aAAA;AxE0pgCN;AwEtpgCI;EACE,mBAAA;AxEwpgCN;AwEtpgCI;EACE,2BAAA;AxEwpgCN;AwEtpgCI;EACE,sBAAA;AxEwpgCN;AwEtpgCI;EACE,8BAAA;AxEwpgCN;AwEppgCM;EACE,yBAAA;AxEspgCR;AwEppgCM;EACE,qBAAA;AxEspgCR;AwEppgCM;EACE,uBAAA;AxEspgCR;AwEppgCM;EACE,4BAAA;AxEspgCR;AwEppgCM;EACE,2BAAA;AxEspgCR;AwEjpgCM;EACE,2BAAA;AxEmpgCR;AwEjpgCM;EACE,uBAAA;AxEmpgCR;AwEjpgCM;EACE,yBAAA;AxEmpgCR;AwEjpgCM;EACE,8BAAA;AxEmpgCR;AwEjpgCM;EACE,6BAAA;AxEmpgCR;AwE9ogCM;EACE,oBAAA;AxEgpgCR;AwE9ogCM;EACE,uBAAA;AxEgpgCR;AwE9ogCM;EACE,mBAAA;AxEgpgCR;AwE9ogCM;EACE,qBAAA;AxEgpgCR;AwE9ogCM;EACE,qBAAA;AxEgpgCR;AwE3ogCM;EACE,mBAAA;AxE6ogCR;AwE3ogCM;EACE,iBAAA;AxE6ogCR;AwE3ogCM;EACE,kBAAA;AxE6ogCR;AwE3ogCM;EACE,eAAA;AxE6ogCR;AwEzogCI;EACE,cAAA;AxE2ogCN;AwEzogCI;EACE,YAAA;AxE2ogCN;AwEnniCA;EzDmJI,eAAA;EAkOF,yBAAA;AfkwhCF;AwEvniCA;EzDqXE,yBAAA;AfqwhCF;AwE1niCA;EAs/BI,8BAAA;AxEuogCJ;AwE7niCA;EA0/BI,aAAA;AxEsogCJ;AwEhoiCA;EA8/BI,aAAA;EACA,8BAAA;EACA,sBAAA;AxEqogCJ;AwE/ngCQ;EACE,aAAA;AxEiogCV;AwE3ngCQ;EACE,aAAA;AxE6ngCV;AwE3oiCA;EAqhCI,gBAAA;AxEyngCJ;AwEpngCI;EAEI,YAAA;AxEqngCR;AwEnngCQ;EAEI,qBAAA;AxEongCZ;AwEhngCQ;EACE,SAAA;EQ7gCN,kBAAA;EACA,mBAAA;AhFgoiCJ;AwEjngCQ;EACE,cAAA;AxEmngCV;AwEhngCQ;;EAEE,cAAA;AxEkngCV;AwE/mgCQ;EACE,yBAAA;AxEingCV;AwE9mgCQ;EACE,YAAA;AxEgngCV;AwEjngCQ;EAII,gBAAA;AxEgngCZ;AwEpngCQ;EAOI,YAAA;AxEgngCZ;AwExmgCM;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AxE0mgCR;AwErmgCM;;EAEE,UAAA;AxEumgCR;AwEpmgCI;EAEI,cAAA;AxEqmgCR;AwEnmgCM;EACE,cAAA;AxEqmgCR;AwEpmgCQ;EACE,cAAA;EACA,mBAAA;AxEsmgCV;AwEpmgCQ;EACE,cAAA;AxEsmgCV;AwE/lgCM;EQ3kCF,kBAAA;EACA,mBAAA;EAUA,oBAAA;EAHA,iBAAA;AhFwqiCJ;AwEtmgCI;EQ7kCA,UAAA;EAcA,oBAAA;EhEqBF,YAAA;AhBqpiCF;AwEhmgCM;EQxlCF,UAAA;EAOA,iBAAA;EACA,oBAAA;AhFqriCJ;AwEjmgCM;EQ5lCF,UAAA;EAWA,iBAAA;AhFsriCJ;AwEjmgCM;EAhUF,cAAA;EQrxBA,iBAAA;AhF0riCJ;AwE1tiCA;EA8nCM,cAAA;AxE+lgCN;AwE7tiCA;EAkoCM,qBAAA;AxE8lgCN;AwEhuiCA;EAqoCM,cAAA;AxE8lgCN;AwEnuiCA;EA4oCM,cAAA;AxE0lgCN;AwExlgCI;EACE,YAAA;AxE0lgCN;AwEzuiCA;EAkpCM,iBAAA;AxE0lgCN;AwEvlgCI;EAEI,YAAA;EACA,gBAAA;EACA,qBAAA;AxEwlgCR;AwE5lgCI;EAOM,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AxEwlgCV;AwErmgCI;EAiBM,iBAAA;AxEulgCV;AwExmgCI;EAqBM,gBAAA;AxEslgCV;AwEllgCM;EAEI,qBAAA;EACA,gBAAA;AxEmlgCV;AwEpwiCA;EAurCM,YAAA;EACA,gBAAA;AxEglgCN;AwE/kgCM;;EAEE,YAAA;EACA,iBAAA;AxEilgCR;AwE7wiCA;EA+rCQ,yBAAA;EACA,YAAA;EACA,kBAAA;AxEilgCR;AwE1kgCI;EACE,YAAA;AxE4kgCN;AwErxiCA;EA4sCM,iBAAA;AxE4kgCN;AwExxiCA;EA+sCM,YAAA;EACA,gBAAA;AxE4kgCN;AwE5xiCA;EAotCM,YAAA;AxE2kgCN;AwE/xiCA;EAwtCM,iBAAA;AxE0kgCN;AwElyiCA;EA4tCM,iBAAA;AxEykgCN;AwEnkgCI;EAEI,YAAA;EACA,gBAAA;AxEokgCR;AwEvkgCI;EAKM,yBAAA;AxEqkgCV;AwE1kgCI;EAQM,cAAA;AxEqkgCV;AwEjkgCM;EAEI,qBAAA;EACA,gBAAA;AxEkkgCV;AwEnziCA;EAwvCM,yBAAA;EACA,yBAAA;AxE8jgCN;AwEvziCA;EA4vCQ,cAAA;AxE8jgCR;AwE1ziCA;EAiwCM,uBAAA;AxE4jgCN;AwExjgCM;EAEI,yBAAA;AxEyjgCV;AwEh0iCA;EA6wCM,kBAAA;AxEsjgCN;AwEnjgCI;EAEI,cAAA;AxEojgCR;AwEjjgCM;EAEI,cAAA;AxEkjgCV;AwEz0iCA;EA8xCI,yBAAA;AxE8igCJ;AwE7igCI;EACE,yBAAA;AxE+igCN;AwE1igCI;EAEI,yBAAA;EACA,qBAAA;AxE2igCR;AwExigCI;EAEI,yBAAA;EACA,gCAAA;AxEyigCR;AwE5igCI;EAMI,qBAAA;AxEyigCR;AwE/igCI;EASI,cAAA;AxEyigCR;AwEligCM;EAEI,yBAAA;EACA,gCAAA;AxEmigCV;AwEtigCM;EAOI,qBAAA;AxEkigCV;AwEp2iCA;EA20CQ,yBAAA;EACA,gCAAA;AxE4hgCR;AwEx2iCA;EA+0CQ,qBAAA;AxE4hgCR;AwE32iCA;EAm1CM,cAAA;AxE2hgCN;AwE92iCA;EAy1CM,aAAA;AxEwhgCN;AwEthgCI;;;EAGE,eAAA;AxEwhgCN;AwEt3iCA;EAm2CM,yBAAA;AxEshgCN;AwEz3iCA;;;EAy2CM,4BAAA;AxEqhgCN;AwE93iCA;;;EA82CM,yBAAA;AxEqhgCN;AwEn4iCA;EAm3CI,gBAAA;AxEmhgCJ;AwEt4iCA;EAw3CM,gBAAA;EACA,cAAA;AxEihgCN;AwE14iCA;EA+3CM,UAAA;AxE8ggCN;AwE74iCA;EAq4CM,mBAAA;AxE2ggCN;AwEh5iCA;EA24CM,kBAAA;AxEwggCN;AwEn5iCA;EAi5CM,gBAAA;AxEqggCN;AwEt5iCA;EAs5CI,iBAAA;AxEmggCJ;AwEz5iCA;EA25CI,iBAAA;AxEiggCJ;AwE55iCA;EAk6CM,WAAA;AxE6//BN;AwE5//BM;EACE,YAAA;AxE8//BR;AwEl6iCA;EAu6CQ,UAAA;EACA,oBAAA;AxE8//BR;AwEt6iCA;EA26CQ,kBAAA;EACA,YAAA;AxE8//BR;AwE3//BI;EAEI,WAAA;AxE4//BR;AwE9//BI;EAIM,UAAA;EACA,mBAAA;AxE6//BV;AwElggCI;EAQM,gBAAA;AxE6//BV;AwEp7iCA;EAg8CI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AxEu//BJ;AwE37iCA;EAu8CI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AxEu//BJ;AwEl//BQ;EzD7zCJ,eAAA;EAAA,oBAAA;AfmziCJ;AwEt//BQ;EAII,mBAAA;AxEq//BZ;AwEj//BM;EzDr0CF,eAAA;AfyziCJ;AwEj//BM;EzDx0CF,eAAA;Af4ziCJ;AwEj//BM;EACE,kBAAA;AxEm//BR;AwEl9iCA;EAq+CI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EzDt1CA,eAAA;Afu0iCJ;AwE/+/BI;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AxEi//BN;AwE/+/BI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AxEi//BN;AwEj/iCA;EAogDI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AxEg//BJ;AwEv/iCA;EA2gDI,WAAA;EACA,YAAA;EACA,kBAAA;AxE++/BJ;AwE5/iCA;EAihDI,WAAA;EACA,YAAA;EACA,kBAAA;AxE8+/BJ;AwEz+/BM;EAEI,yBAAA;EACA,cAAA;EzDx4CN,yBAAA;EyD04CM,iBAAA;AxE0+/BV;AwEv+/BQ;;EAGI,cAAA;EACA,uBAAA;AxEw+/BZ;AwE5gjCA;EA4iDI,gBAAA;AxEm+/BJ;AwE/gjCA;EAgjDI,mBAAA;EACA,eAAA;AxEk+/BJ;AwEnhjCA;EAojDM,uBAAA;EACA,0BAAA;AxEk+/BN;AwEvhjCA;EAyjDM,6BAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AxEi+/BN;AwE/9/BM;;EAEE,cAAA;AxEi+/BR;AwE99/BM;;EAEE,mBAAA;EACA,gBAAA;AxEg+/BR;AwEn+/BM;;EAMI,mBAAA;AxEi+/BV;AwE1ijCA;EA+kDM,uBAAA;EACA,YAAA;EACA,gBAAA;AxE89/BN;AwE/ijCA;EAqlDM,YAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;AxE69/BN;AwErjjCA;EA6lDI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;AxE29/BJ;AwEhkjCA;;EAymDM,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AxE29/BN;AwEzkjCA;EAqnDQ,mBAAA;EACA,cAAA;AxEu9/BR;AwE7kjCA;EAynDQ,cAAA;EACA,yBAAA;AxEu9/BR;AwEn9/BI;EACE,gBAAA;EACA,0BAAA;AxEq9/BN;AwErljCA;EAooDM,UAAA;EACA,gBAAA;AxEo9/BN;AwEzljCA;EAyoDM,aAAA;AxEm9/BN;AwE5ljCA;EA8oDI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AxEi9/BJ;AwE/8/BI;EACE,gBAAA;EACA,iBAAA;AxEi9/BN;AwE98/BI;EACE,gBAAA;EACA,iBAAA;AxEg9/BN;AwE78/BI;EACE,iBAAA;AxE+8/BN;AwE7mjCA;EAmqDI,kBAAA;AxE68/BJ;AwEz8/BI;EACE,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;AxE28/BN;AwE18/BM;EACE,WAAA;EACA,6BAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iCAAA;AxE48/BR;AwEhojCA;EAyrDI,gBAAA;EACA,aAAA;EACA,YAAA;AxE08/BJ;AwEz8/BI;EACE,eAAA;AxE28/BN;AwEz8/BI;EACE,gBAAA;AxE28/BN;AwEx8/BI;EACE,+BAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;AxE08/BN;AwEt8/BM;EACE,iBAAA;AxEw8/BR;AwEp8/BI;EACE,cAAA;AxEs8/BN;AwExpjCA;EAstDM,aAAA;AxEq8/BN;AwE3pjCA;EAytDM,qBAAA;AxEq8/BN;AwEn8/BI;EAEI,qBAAA;AxEo8/BR;AwEh8/BI;EACE,mBAAA;AxEk8/BN;AwE57/BM;EACE,cAAA;AxE87/BR;AwEvqjCA;EA+uDI,UAAA;AxE27/BJ;AwE17/BI;EACE,UAAA;AxE47/BN;AwE17/BI;EACE,UAAA;AxE47/BN;AwEhrjCA;EAyvDI,UAAA;AxE07/BJ;AwEnrjCA;EA6vDI,oCAAA;AxEy7/BJ;AwEr7/BA;EAEI,oBAAA;AxEs7/BJ;AwEx7/BA;EAMI,qBAAA;AxEq7/BJ;AwE37/BA;EAUI,qBAAA;AxEo7/BJ;AwEh7/BA;EACE,uBAAA;AxEk7/BF;AwE/6/BA;EAEI,iBAAA;AxEg7/BJ;AwE56/BA;EAEI,6BAAA;AxE66/BJ;AwEz6/BA;EACE,cAAA;AxE26/BF;AwEx6/BA;EACE,eAAA;EACA,gBAAA;AxE06/BF;AwEv6/BA;EACE,yBAAA;AxEy6/BF;AwEt6/BA;;EAEE,+FAAA;AxEw6/BF;AwEr6/BA;EACE,0BAAA;AxEu6/BF;AwEn6/BE;EACE,oBAAA;AxEq6/BJ;AwEl6/BE;EACE,oBAAA;AxEo6/BJ;AwEh6/BA;EACE,iBAAA;AxEk6/BF;AwE/5/BA;EACE,UAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,uBAAA;EACA,kBAAA;AxEi6/BF;AwE/5/BE;;;EAGE,UAAA;AxEi6/BJ;AwE75/BA;EACE,0BAAA;AxE+5/BF;AwE75/BE;;;EAGE,0BAAA;AxE+5/BJ;AwE35/BA;EACE,wBAAA;EACA,qBAAA;AxE65/BF;AwE35/BE;EACE,aAAA;AxE65/BJ;AwEz5/BA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AxE25/BF;AwEx5/BA;;EAGI,wCAAA;AxEy5/BJ;AwEl5/BM;;;EAGE,yBAAA;AxEo5/BR;AwE34/BM;;;EAGE,yBAAA;AxE64/BR;AwEv4/BA;EAEI,gBAAA;EACA,wCAAA;EACA,2CAAA;AxEw4/BJ;AAzvjCA;;;;;EAMI,+FAAA;AA0vjCJ","sourcesContent":["@import \"~antd/lib/style/color/colorPalette.less\";\n@import './antd';\n@import './base';\n@import './helpers';\n@import './button';\n@import './form';\n@import './input';\n@import './card';\n@import './alert';\n@import './pagination';\n@import './table';\n@import './select';\n@import './modal';\n@import './popover';\n@import './spin';\n@import './list';\n@import './upload';\n@import './subscription-plans';\n@import './team-members';\n@import './team-member-card';\n@import './team-members-invite-form';\n@import './account-card';\n@import './modal-create-survey';\n@import './menu';\n@import './radius';\n@import './advanced-logic';\n@import './logic-path-preview';\n@import './grouping';\n@import './screening-details';\n@import './tag';\n@import './icons';\n@import './audience-templates';\n\n@import './re-theme/index';\n\n.pf-theme {\n  .ant-legacy-form-item-label,\n  .ant-tabs,\n  .ant-card,\n  .ant-input,\n  .ant-steps {\n    font-family: @font-family;\n  }\n}\n","// Config global less under antd\n[class^=~'@{ant-prefix}-'],\n[class*=~' @{ant-prefix}-'] {\n  // remove the clear button of a text input control in IE10+\n  &::-ms-clear,\n  input::-ms-clear,\n  input::-ms-reveal {\n    display: none;\n  }\n}\n","/* stylelint-disable at-rule-no-unknown */\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n// HTML & Body reset\n@{html-selector},\nbody {\n  .square(100%);\n}\n\n// remove the clear button of a text input control in IE10+\ninput::-ms-clear,\ninput::-ms-reveal {\n  display: none;\n}\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Setting @viewport causes scrollbars to overlap content in IE11 and Edge, so\n//    we force a non-overlapping, non-auto-hiding scrollbar to counteract.\n// 6. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\n@{html-selector} {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -ms-text-size-adjust: 100%; // 4\n  -ms-overflow-style: scrollbar; // 5\n  -webkit-tap-highlight-color: fade(@black, 0%); // 6\n}\n\n// IE10+ doesn't honor `<meta name=\"viewport\">` in some cases.\n@-ms-viewport {\n  width: device-width;\n}\n\n// Body\n//\n// 1. remove the margin in all browsers.\n// 2. As a best practice, apply a default `body-background`.\n\nbody {\n  margin: 0; // 1\n  color: @text-color;\n  font-size: @font-size-base;\n  font-family: @font-family;\n  font-variant: @font-variant-base;\n  line-height: @line-height-base;\n  background-color: @body-background; // 2\n  font-feature-settings: @font-feature-settings-base;\n}\n\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\n// This prevents an unwanted focus outline from appearing around elements that\n// might still respond to pointer events.\n//\n// Credit: https://github.com/suitcss/base\n[tabindex='-1']:focus {\n  outline: none !important;\n}\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n//\n// Typography\n//\n\n// remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5em;\n  color: @heading-color;\n  font-weight: 500;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `em` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\n\n// Abbreviations\n//\n// 1. remove the bottom border in Firefox 39-.\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Duplicate behavior to the data-* attribute for our tooltip plugin\n\nabbr[title],\nabbr[data-original-title] {\n  // 4\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  border-bottom: 0; // 1\n  cursor: help; // 3\n}\n\naddress {\n  margin-bottom: 1em;\n  font-style: normal;\n  line-height: inherit;\n}\n\ninput[type='text'],\ninput[type='password'],\ninput[type='number'],\ntextarea {\n  -webkit-appearance: none;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 500;\n}\n\ndd {\n  margin-bottom: 0.5em;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1em;\n}\n\ndfn {\n  font-style: italic; // Add the correct font style in Android 4.3-\n}\n\nb,\nstrong {\n  font-weight: bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  font-size: 80%; // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\n\n//\n// Links\n//\n\na {\n  color: @link-color;\n  text-decoration: @link-decoration;\n  background-color: transparent; // remove the gray background on active links in IE 10.\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects; // remove gaps in links underline in iOS 8+ and Safari 8+.\n\n  &:hover {\n    color: @link-hover-color;\n  }\n\n  &:active {\n    color: @link-active-color;\n  }\n\n  &:active,\n  &:hover {\n    text-decoration: @link-hover-decoration;\n    outline: 0;\n  }\n\n  // https://github.com/ant-design/ant-design/issues/22503\n  &:focus {\n    text-decoration: @link-focus-decoration;\n    outline: @link-focus-outline;\n  }\n\n  &[disabled] {\n    color: @disabled-color;\n    cursor: not-allowed;\n  }\n}\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-size: 1em; // Correct the odd `em` font sizing in all browsers.\n  font-family: @code-family;\n}\n\npre {\n  // remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `em`s\n  margin-bottom: 1em;\n  // Don't allow content to break outside\n  overflow: auto;\n}\n\n//\n// Figures\n//\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1em;\n}\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // remove the border on images inside links in IE 10-.\n}\n\nsvg:not(:root) {\n  overflow: hidden; // Hide the overflow in IE\n}\n\n// Avoid 300ms click delay on touch devices that support the `touch-action` CSS property.\n//\n// In particular, unlike most other browsers, IE11+Edge on Windows 10 on touch devices and IE Mobile 10-11\n// DON'T remove the click delay when `<meta name=\"viewport\" content=\"width=device-width\">` is present.\n// However, they DO support emoving the click delay via `touch-action: manipulation`.\n// See:\n// * https://getbootstrap.com/docs/4.0/content/reboot/#click-delay-optimization-for-touch\n// * http://caniuse.com/#feat=css-touch-action\n// * https://patrickhlauke.github.io/touch/tests/results/#suppressing-300ms-delay\n\na,\narea,\nbutton,\n[role='button'],\ninput:not([type='range']),\nlabel,\nselect,\nsummary,\ntextarea {\n  touch-action: manipulation;\n}\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: 0.75em;\n  padding-bottom: 0.3em;\n  color: @text-color-secondary;\n  text-align: left;\n  caption-side: bottom;\n}\n\n//\n// Forms\n//\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // remove the margin in Firefox and Safari\n  color: inherit;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // remove the inheritance of text transform in Firefox\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n@{html-selector} [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type='radio'],\ninput[type='checkbox'] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. remove the padding in IE 10-\n}\n\ninput[type='date'],\ninput[type='time'],\ninput[type='datetime-local'],\ninput[type='month'] {\n  // remove the default appearance of temporal inputs to avoid a Mobile Safari\n  // bug where setting a custom line-height prevents text from being vertically\n  // centered within the input.\n  // See https://bugs.webkit.org/show_bug.cgi?id=139848\n  // and https://github.com/twbs/bootstrap/issues/11266\n  -webkit-appearance: listbox;\n}\n\ntextarea {\n  overflow: auto; // remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  margin: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  margin-bottom: 0.5em;\n  padding: 0;\n  color: inherit; // 2\n  font-size: 1.5em;\n  line-height: inherit;\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of incement and decement buttons in Chrome.\n[type='number']::-webkit-inner-spin-button,\n[type='number']::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type='search'] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n//\n\n[type='search']::-webkit-search-cancel-button,\n[type='search']::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n\nmark {\n  padding: 0.2em;\n  background-color: @yellow-1;\n}\n\n::selection {\n  color: @text-color-inverse;\n  background: @text-selection-bg;\n}\n\n// Utility classes\n.clearfix {\n  .clearfix();\n}\n","// Sizing shortcuts\n\n.size(@width; @height) {\n  width: @width;\n  height: @height;\n}\n\n.square(@size) {\n  .size(@size; @size);\n}\n","// mixins for clearfix\n// ------------------------\n.clearfix() {\n  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229\n  &::before {\n    display: table;\n    content: '';\n  }\n  &::after {\n    // https://github.com/ant-design/ant-design/issues/21864\n    display: table;\n    clear: both;\n    content: '';\n  }\n}\n","@import '../themes/index';\n@import '../mixins/iconfont';\n\n.@{iconfont-css-prefix} {\n  .iconfont-mixin();\n\n  &[tabindex] {\n    cursor: pointer;\n  }\n}\n\n.@{iconfont-css-prefix}-spin::before {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n.@{iconfont-css-prefix}-spin {\n  display: inline-block;\n  animation: loadingCircle 1s infinite linear;\n}\n",".iconfont-mixin() {\n  display: inline-block;\n  color: @icon-color;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em; // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  > * {\n    line-height: 1;\n  }\n\n  svg {\n    display: inline-block;\n  }\n\n  &::before {\n    display: none; // dont display old icon.\n  }\n\n  & &-icon {\n    display: block;\n  }\n}\n","@import '../themes/index';\n\n.motion-common(@duration: @animation-duration-base) {\n  animation-duration: @duration;\n  animation-fill-mode: both;\n}\n\n.motion-common-leave(@duration: @animation-duration-base) {\n  animation-duration: @duration;\n  animation-fill-mode: both;\n}\n\n.make-motion(@className, @keyframeName, @duration: @animation-duration-base) {\n  .@{className}-enter,\n  .@{className}-appear {\n    .motion-common(@duration);\n\n    animation-play-state: paused;\n  }\n  .@{className}-leave {\n    .motion-common-leave(@duration);\n\n    animation-play-state: paused;\n  }\n  .@{className}-enter.@{className}-enter-active,\n  .@{className}-appear.@{className}-appear-active {\n    animation-name: ~'@{keyframeName}In';\n    animation-play-state: running;\n  }\n  .@{className}-leave.@{className}-leave-active {\n    animation-name: ~'@{keyframeName}Out';\n    animation-play-state: running;\n    pointer-events: none;\n  }\n}\n",".fade-motion(@className, @keyframeName) {\n  @name: ~'@{ant-prefix}-@{className}';\n  .make-motion(@name, @keyframeName);\n  .@{name}-enter,\n  .@{name}-appear {\n    opacity: 0;\n    animation-timing-function: linear;\n  }\n  .@{name}-leave {\n    animation-timing-function: linear;\n  }\n}\n\n.fade-motion(fade, antFade);\n\n@keyframes antFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes antFadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n",".move-motion(@className, @keyframeName) {\n  @name: ~'@{ant-prefix}-@{className}';\n  .make-motion(@name, @keyframeName);\n  .@{name}-enter,\n  .@{name}-appear {\n    opacity: 0;\n    animation-timing-function: @ease-out-circ;\n  }\n  .@{name}-leave {\n    animation-timing-function: @ease-in-circ;\n  }\n}\n\n.move-motion(move-up, antMoveUp);\n.move-motion(move-down, antMoveDown);\n.move-motion(move-left, antMoveLeft);\n.move-motion(move-right, antMoveRight);\n\n@keyframes antMoveDownIn {\n  0% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n\n@keyframes antMoveDownOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n\n@keyframes antMoveLeftIn {\n  0% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n\n@keyframes antMoveLeftOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n\n@keyframes antMoveRightIn {\n  0% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n\n@keyframes antMoveRightOut {\n  0% {\n    transform: translateX(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n\n@keyframes antMoveUpIn {\n  0% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n}\n\n@keyframes antMoveUpOut {\n  0% {\n    transform: translateY(0%);\n    transform-origin: 0 0;\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(-100%);\n    transform-origin: 0 0;\n    opacity: 0;\n  }\n}\n","@keyframes loadingCircle {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@click-animating-true: ~\"[@{ant-prefix}-click-animating='true']\";\n@click-animating-with-extra-node-true: ~\"[@{ant-prefix}-click-animating-without-extra-node='true']\";\n\n@{click-animating-true},\n@{click-animating-with-extra-node-true} {\n  position: relative;\n}\n\nhtml {\n  --antd-wave-shadow-color: @primary-color;\n  --scroll-bar: 0;\n}\n\n@click-animating-with-extra-node-true-after: ~'@{click-animating-with-extra-node-true}::after';\n\n@{click-animating-with-extra-node-true-after},\n.@{ant-prefix}-click-animating-node {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 @primary-color;\n  box-shadow: 0 0 0 0 var(--antd-wave-shadow-color);\n  opacity: 0.2;\n  animation: fadeEffect 2s @ease-out-circ, waveEffect 0.4s @ease-out-circ;\n  animation-fill-mode: forwards;\n  content: '';\n  pointer-events: none;\n}\n\n@keyframes waveEffect {\n  100% {\n    box-shadow: 0 0 0 @primary-color;\n    box-shadow: 0 0 0 @wave-animation-width var(--antd-wave-shadow-color);\n  }\n}\n\n@keyframes fadeEffect {\n  100% {\n    opacity: 0;\n  }\n}\n",".slide-motion(@className, @keyframeName) {\n  @name: ~'@{ant-prefix}-@{className}';\n  .make-motion(@name, @keyframeName);\n  .@{name}-enter,\n  .@{name}-appear {\n    opacity: 0;\n    animation-timing-function: @ease-out-quint;\n  }\n  .@{name}-leave {\n    animation-timing-function: @ease-in-quint;\n  }\n}\n\n.slide-motion(slide-up, antSlideUp);\n.slide-motion(slide-down, antSlideDown);\n.slide-motion(slide-left, antSlideLeft);\n.slide-motion(slide-right, antSlideRight);\n\n@keyframes antSlideUpIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n\n@keyframes antSlideUpOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n\n@keyframes antSlideDownIn {\n  0% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n@keyframes antSlideDownOut {\n  0% {\n    transform: scaleY(1);\n    transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleY(0.8);\n    transform-origin: 100% 100%;\n    opacity: 0;\n  }\n}\n\n@keyframes antSlideLeftIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n}\n\n@keyframes antSlideLeftOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 0% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 0% 0%;\n    opacity: 0;\n  }\n}\n\n@keyframes antSlideRightIn {\n  0% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n}\n\n@keyframes antSlideRightOut {\n  0% {\n    transform: scaleX(1);\n    transform-origin: 100% 0%;\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0.8);\n    transform-origin: 100% 0%;\n    opacity: 0;\n  }\n}\n",".zoom-motion(@className, @keyframeName, @duration: @animation-duration-base) {\n  @name: ~'@{ant-prefix}-@{className}';\n  .make-motion(@name, @keyframeName, @duration);\n  .@{name}-enter,\n  .@{name}-appear {\n    transform: scale(0); // need this by yiminghe\n    opacity: 0;\n    animation-timing-function: @ease-out-circ;\n\n    &-prepare {\n      transform: none;\n    }\n  }\n  .@{name}-leave {\n    animation-timing-function: @ease-in-out-circ;\n  }\n}\n\n// For Modal, Select choosen item\n.zoom-motion(zoom, antZoom);\n// For Popover, Popconfirm, Dropdown\n.zoom-motion(zoom-big, antZoomBig);\n// For Tooltip\n.zoom-motion(zoom-big-fast, antZoomBig, @animation-duration-fast);\n\n.zoom-motion(zoom-up, antZoomUp);\n.zoom-motion(zoom-down, antZoomDown);\n.zoom-motion(zoom-left, antZoomLeft);\n.zoom-motion(zoom-right, antZoomRight);\n\n@keyframes antZoomIn {\n  0% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes antZoomOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.2);\n    opacity: 0;\n  }\n}\n\n@keyframes antZoomBigIn {\n  0% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes antZoomBigOut {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0.8);\n    opacity: 0;\n  }\n}\n\n@keyframes antZoomUpIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n}\n\n@keyframes antZoomUpOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 0%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 0%;\n    opacity: 0;\n  }\n}\n\n@keyframes antZoomLeftIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n}\n\n@keyframes antZoomLeftOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 0% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 0% 50%;\n    opacity: 0;\n  }\n}\n\n@keyframes antZoomRightIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n}\n\n@keyframes antZoomRightOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 100% 50%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 100% 50%;\n    opacity: 0;\n  }\n}\n\n@keyframes antZoomDownIn {\n  0% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n}\n\n@keyframes antZoomDownOut {\n  0% {\n    transform: scale(1);\n    transform-origin: 50% 100%;\n  }\n  100% {\n    transform: scale(0.8);\n    transform-origin: 50% 100%;\n    opacity: 0;\n  }\n}\n","@import '../mixins/motion';\n@import 'motion/fade';\n@import 'motion/move';\n@import 'motion/other';\n@import 'motion/slide';\n@import 'motion/zoom';\n\n// For common/openAnimation\n.ant-motion-collapse-legacy {\n  overflow: hidden;\n  &-active {\n    transition: height @animation-duration-base @ease-in-out,\n      opacity @animation-duration-base @ease-in-out !important;\n  }\n}\n\n.ant-motion-collapse {\n  overflow: hidden;\n  transition: height @animation-duration-base @ease-in-out,\n    opacity @animation-duration-base @ease-in-out !important;\n}\n",".pf-theme {\n  a {\n    color: @blue-ribbone-color;\n\n    &:active,\n    &:focus,\n    &:hover {\n      color: #6ea6ff;\n    }\n  }\n\n  *::selection {\n    background-color: @color-blue-2;\n    color: inherit;\n  }\n\n  *::-moz-selection {\n    background-color: @color-blue-2;\n    color: inherit;\n  }\n}\n\na:focus {\n  text-decoration: none;\n}\n\n@containerWidth: 991px;\n@containerXlWidth: 1600px;\n.pf-content {\n  width: calc(~'100% - 48px');\n  max-width: @containerWidth;\n  margin: @space-lg;\n\n  .screen-xl & {\n    margin: @space-lg auto;\n  }\n}\n\n.pf-content--full-width {\n  max-width: 100%;\n}\n\n.pf-layout-without-sidebar {\n  width: 100%;\n  max-width: @containerXlWidth;\n  padding: @space-lg @space-lg;\n  margin: 0 auto;\n\n  //.screen-lg &, .screen-xl & {\n  //  max-width: @containerWidth;\n  //}\n}\n\n.pf-content,\n.accounts-layout {\n  container: accounts-layout / inline-size;\n  max-width: @containerXlWidth;\n  .ant-card {\n    box-shadow: none;\n  }\n}\n\n.container {\n  max-width: 1278px;\n  margin: 0 auto;\n}\n\n.highcharts-xaxis .highcharts-axis-line {\n  stroke: @color-grey-4;\n}\n","// colors\n@basic-grey: rgb(224, 230, 237);\n@basic-blue: rgb(14, 104, 249);\n@basic-purple: rgb(156, 117, 246);\n@basic-green: rgb(3, 223, 185);\n@basic-magenta: rgb(251, 59, 113);\n@basic-red: rgb(241, 86, 93);\n@basic-yellow: rgb(255, 192, 0);\n@basic-orange: rgb(249, 105, 14);\n\n@color-brand: rgb(228, 64, 68);\n@color-light-green: rgb(0, 207, 131);\n\n@color-purple-light: #f0eafd;\n@color-purple-light-hover: #ded5f0;\n@color-purple-dark: #381581;\n@color-pink: #d830d0;\n\n// required to generate classes using transparent as the class name\n// useful for overrides\n@color-transparent: transparent;\n\n@color-modal-item: #ebf3ff;\n\n@color-grey-1: #ffffff;\n@color-grey-2: #fafafa;\n@color-grey-3: #f9fafc;\n@color-grey-4: #f3f6fb;\n@color-grey-5: #e7ebef;\n@color-grey-6: #e0e6ed;\n@color-grey-7: #bfc8d5;\n@color-grey-8: #8f98a9;\n@color-grey-9: #5c6776;\n@color-grey-10: #323945;\n\n@color-blue-1: color(~`colorPalette('@{basic-blue}', 1) `);\n@color-blue-2: color(~`colorPalette('@{basic-blue}', 2) `);\n@color-blue-3: color(~`colorPalette('@{basic-blue}', 3) `);\n@color-blue-4: color(~`colorPalette('@{basic-blue}', 4) `);\n@color-blue-5: color(~`colorPalette('@{basic-blue}', 5) `);\n@color-blue-6: @basic-blue;\n@color-blue-7: color(~`colorPalette('@{basic-blue}', 7) `);\n@color-blue-8: color(~`colorPalette('@{basic-blue}', 8) `);\n@color-blue-9: color(~`colorPalette('@{basic-blue}', 9) `);\n@color-blue-10: color(~`colorPalette('@{basic-blue}', 10) `);\n\n@color-purple-1: color(~`colorPalette('@{basic-purple}', 1) `);\n@color-purple-2: color(~`colorPalette('@{basic-purple}', 2) `);\n@color-purple-3: color(~`colorPalette('@{basic-purple}', 3) `);\n@color-purple-4: color(~`colorPalette('@{basic-purple}', 4) `);\n@color-purple-5: color(~`colorPalette('@{basic-purple}', 5) `);\n@color-purple-6: @basic-purple;\n@color-purple-7: color(~`colorPalette('@{basic-purple}', 7) `);\n@color-purple-8: color(~`colorPalette('@{basic-purple}', 8) `);\n@color-purple-9: color(~`colorPalette('@{basic-purple}', 9) `);\n@color-purple-10: color(~`colorPalette('@{basic-purple}', 10) `);\n\n@color-green-1: color(~`colorPalette('@{basic-green}', 1) `);\n@color-green-2: color(~`colorPalette('@{basic-green}', 2) `);\n@color-green-3: color(~`colorPalette('@{basic-green}', 3) `);\n@color-green-4: color(~`colorPalette('@{basic-green}', 4) `);\n@color-green-5: color(~`colorPalette('@{basic-green}', 5) `);\n@color-green-6: @basic-green;\n@color-green-7: color(~`colorPalette('@{basic-green}', 7) `);\n@color-green-8: color(~`colorPalette('@{basic-green}', 8) `);\n@color-green-9: color(~`colorPalette('@{basic-green}', 9) `);\n@color-green-10: color(~`colorPalette('@{basic-green}', 10) `);\n@color-green-1b: #d0fef0;\n\n@color-new-green-7: #4ca55e;\n\n@color-light-green-1: color(~`colorPalette('@{color-light-green}', 1) `);\n@color-light-green-2: color(~`colorPalette('@{color-light-green}', 2) `);\n@color-light-green-3: color(~`colorPalette('@{color-light-green}', 3) `);\n@color-light-green-4: color(~`colorPalette('@{color-light-green}', 4) `);\n@color-light-green-5: color(~`colorPalette('@{color-light-green}', 5) `);\n@color-light-green-6: @color-light-green;\n@color-light-green-7: color(~`colorPalette('@{color-light-green}', 7) `);\n@color-light-green-8: color(~`colorPalette('@{color-light-green}', 8) `);\n@color-light-green-9: color(~`colorPalette('@{color-light-green}', 9) `);\n@color-light-green-10: color(~`colorPalette('@{color-light-green}', 10) `);\n\n@color-magenta-1: color(~`colorPalette('@{basic-magenta}', 1) `);\n@color-magenta-2: color(~`colorPalette('@{basic-magenta}', 2) `);\n@color-magenta-3: color(~`colorPalette('@{basic-magenta}', 3) `);\n@color-magenta-4: color(~`colorPalette('@{basic-magenta}', 4) `);\n@color-magenta-5: color(~`colorPalette('@{basic-magenta}', 5) `);\n@color-magenta-6: @basic-magenta;\n@color-magenta-7: color(~`colorPalette('@{basic-magenta}', 7) `);\n@color-magenta-8: color(~`colorPalette('@{basic-magenta}', 8) `);\n@color-magenta-9: color(~`colorPalette('@{basic-magenta}', 9) `);\n@color-magenta-10: color(~`colorPalette('@{basic-magenta}', 10) `);\n\n@color-red-1: color(~`colorPalette('@{basic-red}', 1) `);\n@color-red-2: color(~`colorPalette('@{basic-red}', 2) `);\n@color-red-3: color(~`colorPalette('@{basic-red}', 3) `);\n@color-red-4: color(~`colorPalette('@{basic-red}', 4) `);\n@color-red-5: color(~`colorPalette('@{basic-red}', 5) `);\n@color-red-6: @basic-red;\n@color-red-7: color(~`colorPalette('@{basic-red}', 7) `);\n@color-red-8: color(~`colorPalette('@{basic-red}', 8) `);\n@color-red-9: color(~`colorPalette('@{basic-red}', 9) `);\n@color-red-10: color(~`colorPalette('@{basic-red}', 10) `);\n\n@color-yellow-1: color(~`colorPalette('@{basic-yellow}', 1) `);\n@color-yellow-2: color(~`colorPalette('@{basic-yellow}', 2) `);\n@color-yellow-3: color(~`colorPalette('@{basic-yellow}', 3) `);\n@color-yellow-4: color(~`colorPalette('@{basic-yellow}', 4) `);\n@color-yellow-5: color(~`colorPalette('@{basic-yellow}', 5) `);\n@color-yellow-6: @basic-yellow;\n@color-yellow-7: color(~`colorPalette('@{basic-yellow}', 7) `);\n@color-yellow-8: color(~`colorPalette('@{basic-yellow}', 8) `);\n@color-yellow-9: color(~`colorPalette('@{basic-yellow}', 9) `);\n@color-yellow-10: color(~`colorPalette('@{basic-yellow}', 10) `);\n\n@color-orange-1: color(~`colorPalette('@{basic-orange}', 1) `);\n@color-orange-2: color(~`colorPalette('@{basic-orange}', 2) `);\n@color-orange-3: color(~`colorPalette('@{basic-orange}', 3) `);\n@color-orange-4: color(~`colorPalette('@{basic-orange}', 4) `);\n@color-orange-5: color(~`colorPalette('@{basic-orange}', 5) `);\n@color-orange-6: @basic-orange;\n@color-orange-7: color(~`colorPalette('@{basic-orange}', 7) `);\n@color-orange-8: color(~`colorPalette('@{basic-orange}', 8) `);\n@color-orange-9: color(~`colorPalette('@{basic-orange}', 9) `);\n@color-orange-10: color(~`colorPalette('@{basic-orange}', 10) `);\n\n@color-guest: #e5fcf1;\n\n.opacityLoop(@count, @step, @stop) when (@count >= @stop) {\n  .opacity-@{count} {\n    opacity: (@count / 100);\n  }\n  .opacity-@{count}-hover:hover {\n    opacity: (@count / 100);\n  }\n  .opacityLoop(@count - @step, @step, @stop);\n}\n\n.opacityLoop(@count, @step, @stop) when (@count < @stop) {\n}\n\n.generateColorProperty(@property, @prevalue: ~'', @valuevariable, @count, @suffix:~'', @prefix:~'')\n  when\n  (@count > 0) {\n  @var: 'color-@{valuevariable}-@{count}';\n  @value: @@var;\n  @{prefix}.@{property}-@{valuevariable}-@{count}@{suffix} {\n    @{property}: @prevalue @value;\n  }\n  @{prefix}.@{property}-@{valuevariable}-@{count}-important@{suffix} {\n    @{property}: @prevalue @value !important;\n  }\n  .generateColorProperty(\n    @property,\n    @prevalue,\n    @valuevariable,\n    @count - 1,\n    @suffix,\n    @prefix\n  );\n}\n\n.generateColorProperty(@property, @prevalue: ~'', @valuevariable, @count, @suffix, @prefix)\n  when\n  (@count = -1) {\n  @var: 'color-@{valuevariable}';\n  @value: @@var;\n  @{prefix}.@{property}-@{valuevariable}@{suffix} {\n    @{property}: @prevalue @value;\n  }\n  @{prefix}.@{property}-@{valuevariable}-important@{suffix} {\n    @{property}: @prevalue @value !important;\n  }\n}\n\n.generateColor(@color, @count) {\n  .generateColorProperty(color, ~'', @color, @count, ~'', ~'');\n  .generateColorProperty(color, ~'', @color, @count, ~'-hover:hover', ~'');\n  .generateColorProperty(\n    color,\n    ~'',\n    @color,\n    @count,\n    ~'-hover.active-hover',\n    ~''\n  );\n  .generateColorProperty(color, ~'', @color, @count, ~'-hover:focus', ~'');\n  .generateColorProperty(\n    color,\n    ~'',\n    @color,\n    @count,\n    ~'-hover.active-focus',\n    ~''\n  );\n  .generateColorProperty(color, ~'', @color, @count, ~'-focus:focus', ~'');\n  .generateColorProperty(\n    color,\n    ~'',\n    @color,\n    @count,\n    ~'-focus.active-focus',\n    ~''\n  );\n  .generateColorProperty(\n    color,\n    ~'',\n    @color,\n    @count,\n    ~'-placeholder::placeholder',\n    ~''\n  );\n  .generateColorProperty(\n    color,\n    ~'',\n    @color,\n    @count,\n    ~'-placeholder.active-placeholder',\n    ~''\n  );\n  .generateColorProperty(\n    color,\n    ~'',\n    @color,\n    @count,\n    ~'-hover',\n    ~'.color-hover-parent:hover '\n  );\n  .generateColorProperty(background, ~'', @color, @count, ~'', ~'');\n  .generateColorProperty(background, ~'', @color, @count, ~'-hover:hover', ~'');\n  .generateColorProperty(\n    background,\n    ~'',\n    @color,\n    @count,\n    ~'-hover.active-hover',\n    ~''\n  );\n  .generateColorProperty(background, ~'', @color, @count, ~'-hover:focus', ~'');\n  .generateColorProperty(\n    background,\n    ~'',\n    @color,\n    @count,\n    ~'-hover.active-focus',\n    ~''\n  );\n  .generateColorProperty(background, ~'', @color, @count, ~'-focus:focus', ~'');\n  .generateColorProperty(\n    background,\n    ~'',\n    @color,\n    @count,\n    ~'-focus.active-focus',\n    ~''\n  );\n  .generateColorProperty(border, 1px solid, @color, @count, ~'', ~'');\n  .generateColorProperty(\n    border,\n    1px solid,\n    @color,\n    @count,\n    ~'-hover:hover',\n    ~''\n  );\n  .generateColorProperty(\n    border,\n    1px solid,\n    @color,\n    @count,\n    ~'-focus:focus',\n    ~''\n  );\n  .generateColorProperty(border-top, 1px solid, @color, @count, ~'', ~'');\n  .generateColorProperty(\n    border-top,\n    1px solid,\n    @color,\n    @count,\n    ~'-hover:hover',\n    ~''\n  );\n  .generateColorProperty(border-right, 1px solid, @color, @count, ~'', ~'');\n  .generateColorProperty(\n    border-right,\n    1px solid,\n    @color,\n    @count,\n    ~'-hover:hover',\n    ~''\n  );\n  .generateColorProperty(border-bottom, 1px solid, @color, @count, ~'', ~'');\n  .generateColorProperty(\n    border-bottom,\n    1px solid,\n    @color,\n    @count,\n    ~'-hover:hover',\n    ~''\n  );\n  .generateColorProperty(border-left, 1px solid, @color, @count, ~'', ~'');\n  .generateColorProperty(\n    border-left,\n    1px solid,\n    @color,\n    @count,\n    ~'-hover:hover',\n    ~''\n  );\n  .generateColorProperty(border-color, ~'', @color, @count, ~'', ~'');\n  .generateColorProperty(\n    border-color,\n    ~'',\n    @color,\n    @count,\n    ~'-hover:hover',\n    ~''\n  );\n}\n\n.generateSingleColor(@color) {\n  .generateColor(@color, -1);\n}\n\n.background-white {\n  background-color: white;\n}\n\n.background-purple {\n  background-color: #e8e5ff;\n}\n\n.color-purple {\n  color: #9c75f6;\n}\n\n.color-pink {\n  color: @color-pink;\n\n  &-hover:hover {\n    color: @color-pink;\n  }\n}\n\n.background-orange {\n  background-color: #ffc82c;\n}\n\n.background-orange-hover:hover {\n  background-color: #ffc82c;\n}\n\n.border-orange {\n  border-color: #f5c12d;\n}\n\n.color-light-green {\n  color: @color-light-green;\n}\n\n.background-light-green {\n  background-color: @color-light-green;\n}\n\n.background-grey-3b {\n  background-color: rgba(@color-grey-3, 0.58);\n}\n\n.background-grey-4 {\n  background-color: #f4f7fc;\n}\n\n.background-grey-4b {\n  background-color: #f5f6f8;\n}\n\n.background-grey-4c {\n  background-color: #eef3f7;\n}\n\n.background-grey-4d {\n  background-color: #eff3f7;\n}\n\n.background-grey-6a {\n  background-color: #d5dbe4;\n\n  &-hover:hover {\n    background-color: #d5dbe4;\n  }\n}\n\n.background-light-blue {\n  background-color: @color-modal-item;\n  &-hover {\n    &:hover {\n      background-color: @color-modal-item;\n    }\n  }\n}\n\n.background-projects-ab {\n  background-color: #e3efed;\n}\n.background-projects-conjoint {\n  background-color: #f7ecde;\n}\n.background-projects-maxdiff {\n  background-color: #c9e6f1;\n}\n.background-projects-vw {\n  background-color: #e7e1f3;\n}\n\n.color-placeholder {\n  &-grey-7::placeholder {\n    color: @color-grey-7;\n  }\n}\n","@import './antd';\n@import './re-theme/colors';\n\n.create-spacing (@property, @name, @value) {\n  .@{property}-@{name} {\n    @{property}: @value;\n  }\n  .@{property}-horizontal-@{name} {\n    @{property}-left: @value;\n    @{property}-right: @value;\n  }\n  .@{property}-vertical-@{name} {\n    @{property}-top: @value;\n    @{property}-bottom: @value;\n  }\n  .@{property}-top-@{name} {\n    @{property}-top: @value;\n  }\n  .@{property}-btm-@{name} {\n    @{property}-bottom: @value;\n  }\n  .@{property}-left-@{name} {\n    @{property}-left: @value;\n  }\n  .@{property}-right-@{name} {\n    @{property}-right: @value;\n  }\n}\n\n.float-left {\n  float: left;\n}\n\n.float-right {\n  float: right;\n}\n\n.vertical-align {\n  &-middle {\n    vertical-align: middle;\n  }\n  &-baseline {\n    vertical-align: baseline;\n  }\n}\n\n.margin {\n  &-no-top {\n    margin-top: 0;\n  }\n  &-no-bottom {\n    margin-bottom: 0;\n  }\n}\n\n.border-none {\n  border: none;\n}\n\n.box-shadow-none {\n  box-shadow: none;\n  &-important {\n    box-shadow: none !important;\n  }\n}\n\n.box-shadow-none--override {\n  box-shadow: none !important;\n}\n\n.create-spacing(margin, xxs, @space-xxs);\n.create-spacing(margin, xs, @space-xs);\n.create-spacing(margin, sm, @space-sm);\n.create-spacing(margin, md, @space-md);\n.create-spacing(margin, lg, @space-lg);\n.create-spacing(margin, xl, @space-xl);\n.create-spacing(margin, none, 0);\n.create-spacing(margin, auto, auto);\n\n.create-spacing(padding, xxs, @space-xxs);\n.create-spacing(padding, xs, @space-xs);\n.create-spacing(padding, sm, @space-sm);\n.create-spacing(padding, md, @space-md);\n.create-spacing(padding, lg, @space-lg);\n.create-spacing(padding, xl, @space-xl);\n.create-spacing(padding, none, 0);\n\n.background-primary-1 {\n  background-color: @primary-1;\n}\n\n.ant-alert {\n  &.margin-md {\n    margin-bottom: @space-md;\n  }\n\n  &.margin-lg {\n    margin-bottom: @space-lg;\n  }\n}\n\n.screen-xl {\n  .margin-md-btm--xl {\n    margin-bottom: @space-md;\n  }\n\n  .margin-lg-btm--xl {\n    margin-bottom: @space-lg;\n  }\n}\n\n.btn-container {\n  &--lg {\n    padding: @space-lg 0;\n  }\n\n  &--center {\n    text-align: center;\n  }\n}\n\n.primary-text-color {\n  color: @primary-color;\n}\n\n.fs-16 {\n  font-size: 16px;\n}\n\n.font-roboto {\n  font-family: @font-family;\n}\n\n.font-bold {\n  font-weight: bold;\n}\n\n.font-italic {\n  font-style: italic;\n}\n\n.fw-300 {\n  font-weight: @fw-300;\n}\n\n.fw-400 {\n  font-weight: @fw-400;\n}\n\n.fw-700 {\n  font-weight: @fw-700;\n}\n\n.tt-cap {\n  text-transform: capitalize;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-full--2-headers {\n  min-height: 0 !important;\n  height: calc(~'100vh - 153px');\n}\n\n.pf-announcement-visible .h-full--2-headers {\n  height: calc(~'100vh - 183px');\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-max-full {\n  max-height: 100%;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-half {\n  width: 50%;\n}\n\n.w-max-full {\n  max-width: 100%;\n}\n\n.w-auto {\n  width: auto;\n}\n.w-min-auto {\n  min-width: auto;\n}\n.w-min-none {\n  min-width: 0;\n}\n\n.discount-coupon__link {\n  display: inline-block;\n  font-size: 13px;\n  margin-bottom: @space-xs;\n}\n\n.pf-subheading {\n  font-size: @pf-font-size-lg;\n  font-weight: 700;\n  margin-bottom: @space-lg;\n}\n\n.screen-xs .hide-xs {\n  display: none;\n}\n.screen-sm .hide-sm {\n  display: none;\n}\n.screen-md .hide-md {\n  display: none;\n}\n.screen-lg .hide-lg {\n  display: none;\n}\n.screen-xl .hide-xl {\n  display: none;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.inline {\n  display: inline;\n}\n\n.pf-theme {\n  .is-disabled--low-opacity {\n    opacity: 0.3;\n  }\n\n  // TEXT HELPERS\n  .text-xs {\n    font-size: @pf-font-size-xs;\n  }\n\n  // FLEX HELPERS\n  .flex {\n    display: flex;\n  }\n\n  .inline-flex {\n    display: inline-flex;\n  }\n\n  .flex-1 {\n    flex: 1;\n  }\n\n  .flex-grow-1 {\n    flex-grow: 1;\n  }\n\n  .flex-grow-2 {\n    flex-grow: 2;\n  }\n\n  .flex-justify--space-between {\n    justify-content: space-between;\n  }\n\n  .flex-justify--center {\n    justify-content: center;\n  }\n\n  .flex-justify--end {\n    justify-content: flex-end;\n  }\n\n  .flex-align-items--center {\n    align-items: center;\n  }\n\n  .flex-align-items--start {\n    align-items: flex-start;\n  }\n\n  .flex-align-items--end {\n    align-items: flex-end;\n  }\n\n  .flex-direction--column {\n    flex-direction: column;\n  }\n\n  // GRID HELPERS\n  .grid {\n    display: grid;\n  }\n\n  // TITLE HELPERS\n  .text-xxs {\n    font-size: @pf-font-size-xxs;\n  }\n\n  .text-xs {\n    font-size: @pf-font-size-xs;\n  }\n\n  .text-sm {\n    font-size: @pf-font-size-sm;\n  }\n\n  .text-sm-2 {\n    font-size: 14px;\n  }\n\n  .text-base {\n    font-size: @pf-font-size-base;\n  }\n\n  .title--md {\n    font-size: @pf-font-size-md;\n  }\n\n  .title--lg {\n    font-size: @pf-font-size-lg;\n    font-weight: @fw-700;\n    margin-bottom: @space-md;\n    line-height: 1;\n  }\n\n  .title--xl {\n    font-size: @pf-font-size-xl;\n  }\n\n  .isHidden {\n    display: none;\n  }\n\n  .isVisible {\n    display: block;\n  }\n\n  .color-radical-red {\n    color: @radical-red;\n  }\n\n  .color-white {\n    color: #ffffff;\n  }\n\n  .color-green-1b {\n    color: @color-green-1b;\n  }\n\n  .background-green-1b {\n    background-color: @color-green-1b;\n  }\n\n  .color-white-hover:hover,\n  .color-white-hover:focus {\n    color: #ffffff;\n  }\n\n  .background-color-grey {\n    background-color: #747b8c;\n  }\n  .background-color-white {\n    background-color: #fff;\n  }\n\n  .leading-none {\n    line-height: 1;\n  }\n}\n\n.placeholder-style-italics::placeholder {\n  font-style: italic;\n}\n\n.list-style-none {\n  list-style: none;\n}\n\n.relative {\n  position: relative;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-visible {\n  overflow: visible;\n}\n\n.content {\n  &-fit {\n    width: fit-content;\n  }\n}\n\n.line-height-26 {\n  line-height: 26px;\n}\n\n.visibility-hidden {\n  visibility: hidden;\n}\n\n.visibility-visible {\n  visibility: visible;\n}","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n@import './mixin';\n\n@btn-prefix-cls: ~'@{ant-prefix}-btn';\n\n// for compatible\n@btn-ghost-color: @text-color;\n@btn-ghost-bg: transparent;\n@btn-ghost-border: @border-color-base;\n\n// Button styles\n// -----------------------------\n.@{btn-prefix-cls} {\n  // Fixing https://github.com/ant-design/ant-design/issues/12978\n  // Fixing https://github.com/ant-design/ant-design/issues/20058\n  // Fixing https://github.com/ant-design/ant-design/issues/19972\n  // Fixing https://github.com/ant-design/ant-design/issues/18107\n  // Fixing https://github.com/ant-design/ant-design/issues/13214\n  // It is a render problem of chrome, which is only happened in the codesandbox demo\n  // 0.001px solution works and I don't why\n  line-height: @btn-line-height;\n  .btn();\n  .btn-default();\n\n  // Fix loading button animation\n  // https://github.com/ant-design/ant-design/issues/24323\n  > span {\n    display: inline-block;\n  }\n\n  &-primary {\n    .btn-primary();\n\n    .@{btn-prefix-cls}-group &:not(:first-child):not(:last-child) {\n      border-right-color: @btn-group-border;\n      border-left-color: @btn-group-border;\n\n      &:disabled {\n        border-color: @btn-default-border;\n      }\n    }\n\n    .@{btn-prefix-cls}-group &:first-child {\n      &:not(:last-child) {\n        border-right-color: @btn-group-border;\n\n        &[disabled] {\n          border-right-color: @btn-default-border;\n        }\n      }\n    }\n\n    .@{btn-prefix-cls}-group &:last-child:not(:first-child),\n    .@{btn-prefix-cls}-group & + & {\n      border-left-color: @btn-group-border;\n\n      &[disabled] {\n        border-left-color: @btn-default-border;\n      }\n    }\n  }\n\n  &-ghost {\n    .btn-ghost();\n  }\n\n  &-dashed {\n    .btn-dashed();\n  }\n\n  // type=\"danger\" will deprecated\n  // use danger instead\n  &-danger {\n    .btn-danger();\n  }\n\n  &-link {\n    .btn-link();\n  }\n\n  &-text {\n    .btn-text();\n  }\n\n  &-dangerous {\n    .btn-danger-default();\n  }\n\n  &-dangerous&-primary {\n    .btn-danger();\n  }\n\n  &-dangerous&-link {\n    .btn-danger-link();\n  }\n\n  &-dangerous&-text {\n    .btn-danger-text();\n  }\n\n  &-icon-only {\n    .btn-square(@btn-prefix-cls);\n    vertical-align: -3px;\n\n    > .@{iconfont-css-prefix} {\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n  &-round {\n    .btn-round(@btn-prefix-cls);\n    &.@{btn-prefix-cls}-icon-only {\n      width: auto;\n    }\n  }\n\n  &-circle {\n    .btn-circle(@btn-prefix-cls);\n  }\n\n  &::before {\n    position: absolute;\n    top: -@btn-border-width;\n    right: -@btn-border-width;\n    bottom: -@btn-border-width;\n    left: -@btn-border-width;\n    z-index: 1;\n    display: none;\n    background: @component-background;\n    border-radius: inherit;\n    opacity: 0.35;\n    transition: opacity 0.2s;\n    content: '';\n    pointer-events: none;\n  }\n\n  .@{iconfont-css-prefix} {\n    transition: margin-left 0.3s @ease-in-out;\n\n    // Follow icon blur under windows. Change the render.\n    // https://github.com/ant-design/ant-design/issues/13924\n    &.@{iconfont-css-prefix}-plus,\n    &.@{iconfont-css-prefix}-minus {\n      > svg {\n        shape-rendering: optimizeSpeed;\n      }\n    }\n  }\n\n  &&-loading {\n    position: relative;\n    &:not([disabled]) {\n      pointer-events: none;\n    }\n\n    &::before {\n      display: block;\n    }\n  }\n\n  & > &-loading-icon {\n    transition: all 0.3s @ease-in-out;\n\n    .@{iconfont-css-prefix} {\n      padding-right: @padding-xs;\n      animation: none;\n      // for smooth button padding transition\n      svg {\n        animation: loadingCircle 1s infinite linear;\n      }\n    }\n\n    &:only-child {\n      .@{iconfont-css-prefix} {\n        padding-right: 0;\n      }\n    }\n  }\n\n  &-group {\n    .btn-group(@btn-prefix-cls);\n  }\n\n  // http://stackoverflow.com/a/21281554/3040605\n  &:focus > span,\n  &:active > span {\n    position: relative;\n  }\n\n  // To ensure that a space will be placed between character and `Icon`.\n  > .@{iconfont-css-prefix} + span,\n  > span + .@{iconfont-css-prefix} {\n    margin-left: @margin-xs;\n  }\n\n  &&-background-ghost {\n    color: @btn-default-ghost-color;\n    border-color: @btn-default-ghost-border;\n    &,\n    &:hover,\n    &:active,\n    &:focus {\n      background: @btn-default-ghost-bg;\n    }\n  }\n\n  &-background-ghost&-primary {\n    .button-variant-ghost(@btn-primary-bg);\n  }\n\n  &-background-ghost&-danger {\n    .button-variant-ghost(@btn-danger-border);\n  }\n\n  &-background-ghost&-dangerous {\n    .button-variant-ghost(@btn-danger-border);\n  }\n\n  &-background-ghost&-dangerous&-link {\n    .button-variant-ghost(@btn-danger-border, transparent);\n  }\n\n  &-two-chinese-chars::first-letter {\n    letter-spacing: 0.34em;\n  }\n\n  &-two-chinese-chars > *:not(.@{iconfont-css-prefix}) {\n    margin-right: -0.34em;\n    letter-spacing: 0.34em;\n  }\n\n  &-block {\n    width: 100%;\n  }\n\n  // https://github.com/ant-design/ant-design/issues/12681\n  // same method as Select\n  &:empty {\n    display: inline-block;\n    width: 0;\n    visibility: hidden;\n    content: '\\a0';\n  }\n}\n\na.@{btn-prefix-cls} {\n  // Fixing https://github.com/ant-design/ant-design/issues/12978\n  // https://github.com/ant-design/ant-design/issues/29978\n  // It is a render problem of chrome, which is only happened in the codesandbox demo\n  // 0.1px for padding-top solution works and I don't why\n  padding-top: 0.01px !important;\n  line-height: @btn-height-base - 2px;\n\n  &-lg {\n    line-height: @btn-height-lg - 2px;\n  }\n  &-sm {\n    line-height: @btn-height-sm - 2px;\n  }\n}\n\n@import './rtl';\n","// mixins for button\n// ------------------------\n.button-size(@height; @padding-horizontal; @font-size; @border-radius) {\n  @padding-vertical: max(\n    (round(((@height - @font-size * @line-height-base) / 2) * 10) / 10) - @border-width-base,\n    0\n  );\n  height: @height;\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  border-radius: @border-radius;\n}\n\n.button-disabled(@color: @btn-disable-color; @background: @btn-disable-bg; @border: @btn-disable-border) {\n  &[disabled] {\n    &,\n    &:hover,\n    &:focus,\n    &:active {\n      .button-color(@color; @background; @border);\n\n      text-shadow: none;\n      box-shadow: none;\n    }\n  }\n}\n\n.button-variant-primary(@color; @background) {\n  .button-color(@color; @background; @background);\n\n  text-shadow: @btn-text-shadow;\n  box-shadow: @btn-primary-shadow;\n\n  &:hover,\n  &:focus {\n    & when (@theme = dark) {\n      .button-color(\n        @color; ~`colorPalette('@{background}', 7) `; ~`colorPalette('@{background}', 7) `\n      );\n    }\n    & when not (@theme = dark) {\n      .button-color(\n        @color; ~`colorPalette('@{background}', 5) `; ~`colorPalette('@{background}', 5) `\n      );\n    }\n  }\n\n  &:active {\n    & when (@theme = dark) {\n      .button-color(\n        @color; ~`colorPalette('@{background}', 5) `; ~`colorPalette('@{background}', 5) `\n      );\n    }\n    & when not (@theme = dark) {\n      .button-color(\n        @color; ~`colorPalette('@{background}', 7) `; ~`colorPalette('@{background}', 7) `\n      );\n    }\n  }\n\n  .button-disabled();\n}\n\n.button-variant-other(@color; @background; @border) {\n  .button-color(@color; @background; @border);\n\n  &:hover,\n  &:focus {\n    & when (@theme = dark) {\n      .button-color(@primary-5; @background; @primary-5);\n    }\n    & when not (@theme = dark) {\n      .button-color(\n        ~`colorPalette('@{btn-primary-bg}', 5) `; @background;\n          ~`colorPalette('@{btn-primary-bg}', 5) `\n      );\n    }\n  }\n  &:active {\n    & when (@theme = dark) {\n      .button-color(@primary-7; @background; @primary-7);\n    }\n    & when not (@theme = dark) {\n      .button-color(\n        ~`colorPalette('@{btn-primary-bg}', 7) `; @background;\n          ~`colorPalette('@{btn-primary-bg}', 7) `\n      );\n    }\n  }\n  .button-disabled();\n}\n.button-variant-ghost(@color; @border: @color) {\n  .button-color(@color; null; @border);\n  text-shadow: none;\n  &:hover,\n  &:focus {\n    & when (@border = transparent) {\n      & when (@theme = dark) {\n        .button-color(~`colorPalette('@{color}', 7) `; null; transparent);\n      }\n      & when not (@theme = dark) {\n        .button-color(~`colorPalette('@{color}', 5) `; null; transparent);\n      }\n    }\n    & when not (@border = transparent) {\n      & when (@theme = dark) {\n        .button-color(\n          ~`colorPalette('@{color}', 7) `; null; ~`colorPalette('@{color}', 7) `\n        );\n      }\n      & when not (@theme = dark) {\n        .button-color(\n          ~`colorPalette('@{color}', 5) `; null; ~`colorPalette('@{color}', 5) `\n        );\n      }\n    }\n  }\n  &:active {\n    & when (@border = transparent) {\n      & when (@theme = dark) {\n        .button-color(~`colorPalette('@{color}', 5) `; null; transparent);\n      }\n      & when not (@theme = dark) {\n        .button-color(~`colorPalette('@{color}', 7) `; null; transparent);\n      }\n    }\n    & when not (@border = transparent) {\n      & when (@theme = dark) {\n        .button-color(\n          ~`colorPalette('@{color}', 5) `; null; ~`colorPalette('@{color}', 5) `\n        );\n      }\n      & when not (@theme = dark) {\n        .button-color(\n          ~`colorPalette('@{color}', 7) `; null; ~`colorPalette('@{color}', 7) `\n        );\n      }\n    }\n  }\n  .button-disabled();\n}\n.button-color(@color; @background; @border) {\n  color: @color;\n  border-color: @border; // a inside Button which only work in Chrome\n  & when not(@background = null) {\n    background: @background;\n  }\n  // http://stackoverflow.com/a/17253457\n  > a:only-child {\n    color: currentColor;\n    &::after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      background: transparent;\n      content: '';\n    }\n  }\n}\n.button-group-base(@btnClassName) {\n  position: relative;\n  display: inline-flex;\n  > .@{btnClassName},\n  > span > .@{btnClassName} {\n    position: relative;\n    &:hover,\n    &:focus,\n    &:active {\n      z-index: 2;\n    }\n    &[disabled] {\n      z-index: 0;\n    }\n  }\n  .@{btnClassName}-icon-only {\n    font-size: @font-size-base;\n  }\n  // size\n  &-lg > .@{btnClassName},\n  &-lg > span > .@{btnClassName} {\n    .button-size(@btn-height-lg; @btn-padding-horizontal-lg; @btn-font-size-lg; 0);\n  }\n  &-lg .@{btnClassName}.@{btnClassName}-icon-only {\n    .square(@btn-height-lg);\n    padding-right: 0;\n    padding-left: 0;\n  }\n  &-sm > .@{btnClassName},\n  &-sm > span > .@{btnClassName} {\n    .button-size(@btn-height-sm; @btn-padding-horizontal-sm; @font-size-base; 0);\n    > .@{iconfont-css-prefix} {\n      font-size: @font-size-base;\n    }\n  }\n  &-sm .@{btnClassName}.@{btnClassName}-icon-only {\n    .square(@btn-height-sm);\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n// Base styles of buttons\n// --------------------------------------------------\n.btn() {\n  position: relative;\n  display: inline-block;\n  font-weight: @btn-font-weight;\n  white-space: nowrap;\n  text-align: center;\n  background-image: none;\n  border: @btn-border-width @btn-border-style transparent;\n  box-shadow: @btn-shadow;\n  cursor: pointer;\n  transition: all 0.3s @ease-in-out;\n  user-select: none;\n  touch-action: manipulation;\n  .button-size(\n    @btn-height-base; @btn-padding-horizontal-base; @font-size-base; @btn-border-radius-base\n  );\n  > .@{iconfont-css-prefix} {\n    line-height: 1;\n  }\n  &,\n  &:active,\n  &:focus {\n    outline: 0;\n  }\n  &:not([disabled]):hover {\n    text-decoration: none;\n  }\n  &:not([disabled]):active {\n    outline: 0;\n    box-shadow: none;\n  }\n  &[disabled] {\n    cursor: not-allowed;\n    > * {\n      pointer-events: none;\n    }\n  }\n  &-lg {\n    .button-size(\n      @btn-height-lg; @btn-padding-horizontal-lg; @btn-font-size-lg; @btn-border-radius-base\n    );\n  }\n  &-sm {\n    .button-size(\n      @btn-height-sm; @btn-padding-horizontal-sm; @btn-font-size-sm; @btn-border-radius-sm\n    );\n  }\n}\n// primary button style\n.btn-primary() {\n  .button-variant-primary(@btn-primary-color; @btn-primary-bg);\n}\n// default button style\n.btn-default() {\n  .button-variant-other(@btn-default-color; @btn-default-bg; @btn-default-border);\n  &:hover,\n  &:focus,\n  &:active {\n    text-decoration: none;\n    background: @btn-default-bg;\n  }\n}\n// ghost button style\n.btn-ghost() {\n  .button-variant-other(@btn-ghost-color, @btn-ghost-bg, @btn-ghost-border);\n}\n// dashed button style\n.btn-dashed() {\n  .button-variant-other(@btn-default-color, @btn-default-bg, @btn-default-border);\n  border-style: dashed;\n}\n// danger button style\n.btn-danger() {\n  .button-variant-primary(@btn-danger-color, @btn-danger-bg);\n}\n// danger default button style\n.btn-danger-default() {\n  .button-color(@error-color, @btn-default-bg, @error-color);\n  &:hover,\n  &:focus {\n    & when (@theme = dark) {\n      .button-color(\n        ~`colorPalette('@{error-color}', 7) `; @btn-default-bg; ~`colorPalette('@{error-color}', 7)\n          `\n      );\n    }\n    & when not (@theme = dark) {\n      .button-color(\n        ~`colorPalette('@{error-color}', 5) `; @btn-default-bg; ~`colorPalette('@{error-color}', 5)\n          `\n      );\n    }\n  }\n  &:active {\n    & when (@theme = dark) {\n      .button-color(\n        ~`colorPalette('@{error-color}', 5) `; @btn-default-bg; ~`colorPalette('@{error-color}', 5)\n          `\n      );\n    }\n    & when not (@theme = dark) {\n      .button-color(\n        ~`colorPalette('@{error-color}', 7) `; @btn-default-bg; ~`colorPalette('@{error-color}', 7)\n          `\n      );\n    }\n  }\n  .button-disabled();\n}\n// danger link button style\n.btn-danger-link() {\n  .button-variant-other(@error-color, transparent, transparent);\n  box-shadow: none;\n  &:hover,\n  &:focus {\n    & when (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 7) `; transparent; transparent);\n    }\n    & when not (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 5) `; transparent; transparent);\n    }\n  }\n  &:active {\n    & when (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 5) `; transparent; transparent);\n    }\n    & when not (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 7) `; transparent; transparent);\n    }\n  }\n  .button-disabled(@disabled-color; transparent; transparent);\n}\n// link button style\n.btn-link() {\n  .button-variant-other(@link-color, transparent, transparent);\n  box-shadow: none;\n  &:hover {\n    background: @btn-link-hover-bg;\n  }\n  &:hover,\n  &:focus,\n  &:active {\n    border-color: transparent;\n  }\n  .button-disabled(@disabled-color; transparent; transparent);\n}\n// text button style\n.btn-text() {\n  .button-variant-other(@text-color, transparent, transparent);\n  box-shadow: none;\n  &:hover,\n  &:focus {\n    color: @text-color;\n    background: @btn-text-hover-bg;\n    border-color: transparent;\n  }\n\n  &:active {\n    color: @text-color;\n    background: fadein(@btn-text-hover-bg, 1%);\n    border-color: transparent;\n  }\n\n  .button-disabled(@disabled-color; transparent; transparent);\n}\n.btn-danger-text() {\n  .button-variant-other(@error-color, transparent, transparent);\n  box-shadow: none;\n  &:hover,\n  &:focus {\n    & when (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 7) `; @btn-text-hover-bg; transparent);\n    }\n    & when not (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 5) `; @btn-text-hover-bg; transparent);\n    }\n  }\n\n  &:active {\n    & when (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 5) `; fadein(@btn-text-hover-bg, 1%); transparent);\n    }\n    & when not (@theme = dark) {\n      .button-color(~`colorPalette('@{error-color}', 7) `; fadein(@btn-text-hover-bg, 1%); transparent);\n    }\n  }\n  .button-disabled(@disabled-color; transparent; transparent);\n}\n// round button\n.btn-round(@btnClassName: btn) {\n  .button-size(@btn-circle-size; (@btn-circle-size / 2); @font-size-base; @btn-circle-size);\n  &.@{btnClassName}-lg {\n    .button-size(\n      @btn-circle-size-lg; (@btn-circle-size-lg / 2); @btn-font-size-lg; @btn-circle-size-lg\n    );\n  }\n  &.@{btnClassName}-sm {\n    .button-size(\n      @btn-circle-size-sm; (@btn-circle-size-sm / 2); @font-size-base; @btn-circle-size-sm\n    );\n  }\n}\n// square button: the content only contains icon\n.btn-square(@btnClassName: btn) {\n  .square(@btn-square-size);\n  .button-size(@btn-square-size; 0; @btn-square-only-icon-size; @btn-border-radius-base);\n  & > * {\n    font-size: @btn-square-only-icon-size;\n  }\n  &.@{btnClassName}-lg {\n    .square(@btn-square-size-lg);\n    .button-size(@btn-square-size-lg; 0; @btn-square-only-icon-size-lg; @btn-border-radius-base);\n    & > * {\n      font-size: @btn-square-only-icon-size-lg;\n    }\n  }\n  &.@{btnClassName}-sm {\n    .square(@btn-square-size-sm);\n    .button-size(@btn-square-size-sm; 0; @btn-square-only-icon-size-sm; @btn-border-radius-base);\n    & > * {\n      font-size: @btn-square-only-icon-size-sm;\n    }\n  }\n}\n// circle button: the content only contains icon\n.btn-circle(@btnClassName: btn) {\n  min-width: @btn-height-base;\n  padding-right: 0;\n  padding-left: 0;\n  text-align: center;\n  border-radius: 50%;\n  &.@{btnClassName}-lg {\n    min-width: @btn-height-lg;\n    border-radius: 50%;\n  }\n  &.@{btnClassName}-sm {\n    min-width: @btn-height-sm;\n    border-radius: 50%;\n  }\n}\n// Horizontal button groups style\n// --------------------------------------------------\n.btn-group(@btnClassName: btn) {\n  .button-group-base(@btnClassName);\n  .@{btnClassName} + .@{btnClassName},\n  .@{btnClassName} + &,\n  span + .@{btnClassName},\n  .@{btnClassName} + span,\n  > span + span,\n  & + .@{btnClassName},\n  & + & {\n    margin-left: -1px;\n  }\n  .@{btnClassName}-primary + .@{btnClassName}:not(.@{btnClassName}-primary):not([disabled]) {\n    border-left-color: transparent;\n  }\n  .@{btnClassName} {\n    border-radius: 0;\n  }\n  > .@{btnClassName}:first-child,\n  > span:first-child > .@{btnClassName} {\n    margin-left: 0;\n  }\n  > .@{btnClassName}:only-child {\n    border-radius: @btn-border-radius-base;\n  }\n  > span:only-child > .@{btnClassName} {\n    border-radius: @btn-border-radius-base;\n  }\n  > .@{btnClassName}:first-child:not(:last-child),\n  > span:first-child:not(:last-child) > .@{btnClassName} {\n    border-top-left-radius: @btn-border-radius-base;\n    border-bottom-left-radius: @btn-border-radius-base;\n  }\n  > .@{btnClassName}:last-child:not(:first-child),\n  > span:last-child:not(:first-child) > .@{btnClassName} {\n    border-top-right-radius: @btn-border-radius-base;\n    border-bottom-right-radius: @btn-border-radius-base;\n  }\n  &-sm {\n    > .@{btnClassName}:only-child {\n      border-radius: @btn-border-radius-sm;\n    }\n    > span:only-child > .@{btnClassName} {\n      border-radius: @btn-border-radius-sm;\n    }\n    > .@{btnClassName}:first-child:not(:last-child),\n    > span:first-child:not(:last-child) > .@{btnClassName} {\n      border-top-left-radius: @btn-border-radius-sm;\n      border-bottom-left-radius: @btn-border-radius-sm;\n    }\n    > .@{btnClassName}:last-child:not(:first-child),\n    > span:last-child:not(:first-child) > .@{btnClassName} {\n      border-top-right-radius: @btn-border-radius-sm;\n      border-bottom-right-radius: @btn-border-radius-sm;\n    }\n  }\n  & > & {\n    float: left;\n  }\n  & > &:not(:first-child):not(:last-child) > .@{btnClassName} {\n    border-radius: 0;\n  }\n  & > &:first-child:not(:last-child) {\n    > .@{btnClassName}:last-child {\n      padding-right: 8px;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n  & > &:last-child:not(:first-child) > .@{btnClassName}:first-child {\n    padding-left: 8px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n",".@{btn-prefix-cls} {\n  &-rtl {\n    direction: rtl;\n  }\n\n  &-primary {\n    .@{btn-prefix-cls}-group &:last-child:not(:first-child),\n    .@{btn-prefix-cls}-group & + & {\n      .@{btn-prefix-cls}-group-rtl& {\n        border-right-color: @btn-group-border;\n        border-left-color: @btn-default-border;\n      }\n      &[disabled] {\n        .@{btn-prefix-cls}-group-rtl& {\n          border-right-color: @btn-default-border;\n          border-left-color: @btn-group-border;\n        }\n      }\n    }\n  }\n\n  & > &-loading-icon {\n    .@{iconfont-css-prefix} {\n      .@{btn-prefix-cls}-rtl& {\n        padding-right: 0;\n        padding-left: @margin-xs;\n      }\n    }\n\n    &:only-child {\n      .@{iconfont-css-prefix} {\n        padding-right: 0;\n        padding-left: 0;\n      }\n    }\n  }\n\n  > .@{iconfont-css-prefix} + span,\n  > span + .@{iconfont-css-prefix} {\n    .@{btn-prefix-cls}-rtl& {\n      margin-right: 8px;\n      margin-left: 0;\n    }\n  }\n}\n\n// mixin\n.btn-group(@btnClassName: btn) {\n  .@{btnClassName} + .@{btnClassName},\n  .@{btnClassName} + &,\n  span + .@{btnClassName},\n  .@{btnClassName} + span,\n  > span + span,\n  & + .@{btnClassName},\n  & + & {\n    .@{btnClassName}-rtl&,\n    .@{btnClassName}-group-rtl& {\n      margin-right: -1px;\n      margin-left: auto;\n    }\n  }\n\n  &.@{btnClassName}-group-rtl {\n    direction: rtl;\n  }\n\n  > .@{btnClassName}:first-child:not(:last-child),\n  > span:first-child:not(:last-child) > .@{btnClassName} {\n    .@{btnClassName}-group-rtl& {\n      border-top-left-radius: 0;\n      border-top-right-radius: @btn-border-radius-base;\n      border-bottom-right-radius: @btn-border-radius-base;\n      border-bottom-left-radius: 0;\n    }\n  }\n\n  > .@{btnClassName}:last-child:not(:first-child),\n  > span:last-child:not(:first-child) > .@{btnClassName} {\n    .@{btnClassName}-group-rtl& {\n      border-top-left-radius: @btn-border-radius-base;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: @btn-border-radius-base;\n    }\n  }\n\n  &-sm {\n    > .@{btnClassName}:first-child:not(:last-child),\n    > span:first-child:not(:last-child) > .@{btnClassName} {\n      .@{btnClassName}-group-rtl& {\n        border-top-left-radius: 0;\n        border-top-right-radius: @btn-border-radius-sm;\n        border-bottom-right-radius: @btn-border-radius-sm;\n        border-bottom-left-radius: 0;\n      }\n    }\n\n    > .@{btnClassName}:last-child:not(:first-child),\n    > span:last-child:not(:first-child) > .@{btnClassName} {\n      .@{btnClassName}-group-rtl& {\n        border-top-left-radius: @btn-border-radius-sm;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: @btn-border-radius-sm;\n      }\n    }\n  }\n}\n","@import '../../node_modules/antd/lib/button/style/index.less';\n@import './re-theme/colors.less';\n\n// Button overrides\n@btn-padding-lg: 0 @padding-lg - 1px;\n\n.pf-theme {\n  .ant-btn {\n    font-size: @btn-font-size;\n    text-shadow: none !important;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n\n    &:after {\n      content: none !important; //to disable wave effect on click\n    }\n\n    &:first-letter {\n      text-transform: capitalize;\n    }\n\n    &.full-width {\n      width: 100%;\n    }\n\n    &-primary:not(.ant-btn-background-ghost) {\n      box-shadow: 0 5px 10px 0\n        rgba(\n          red(@primary-color),\n          green(@primary-color),\n          blue(@primary-color),\n          0.3\n        );\n\n      &.disabled,\n      &[disabled],\n      &.disabled:hover,\n      &[disabled]:hover,\n      &.disabled:focus,\n      &[disabled]:focus,\n      &.disabled:active,\n      &[disabled]:active,\n      &.disabled.active,\n      &[disabled].active {\n        box-shadow: none;\n      }\n    }\n\n    &-basic,\n    &-business,\n    &-enterprise {\n      box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),\n        0 1px 3px rgba(0, 0, 0, 0.08);\n      transition: 150ms;\n\n      &.disabled,\n      &[disabled],\n      &.disabled:hover,\n      &[disabled]:hover,\n      &.disabled:focus,\n      &[disabled]:focus,\n      &.disabled:active,\n      &[disabled]:active,\n      &.disabled.active,\n      &[disabled].active {\n        box-shadow: none;\n        color: rgba(0, 0, 0, 0.25);\n        background-color: #f5f5f5;\n        border-color: #d9d9d9;\n      }\n    }\n\n    &-upgrade {\n      color: @pf-color-pricing-upgrade;\n      background-color: white;\n      text-transform: uppercase;\n      height: 36px;\n      line-height: 35px;\n      border-color: transparent !important;\n      box-shadow: none !important;\n      font-weight: bold !important;\n      padding: 8px 0 !important;\n      font-size: 14px;\n    }\n\n    &-surveys-link {\n      color: @pf-color-survey-link;\n      border: 1px solid @pf-color-survey-link;\n      font-size: 14px !important;\n      font-weight: 500;\n\n      &:active,\n      &:focus,\n      &:hover {\n        background-color: @pf-color-pricing-upgrade;\n        border-color: @pf-color-pricing-upgrade;\n        color: white;\n        -o-box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);\n        -moz-box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);\n        -webkit-box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);\n        box-shadow: 0 5px 10px 0 rgba(251, 59, 113, 0.3);\n      }\n    }\n\n    &-basic {\n      color: @pf-color-pricing-professional;\n      background-color: white;\n      border-color: transparent;\n    }\n\n    &-business {\n      color: white !important;\n      background-color: @pf-color-pricing-business;\n      border-color: transparent;\n\n      &:active,\n      &:focus,\n      &:hover {\n        color: white;\n        background-color: @pf-color-pricing-business;\n      }\n    }\n\n    &-enterprise,\n    &-elite {\n      color: white !important;\n      background-color: @pf-color-pricing-enterprise;\n      border-color: transparent;\n\n      &:active,\n      &:focus,\n      &:hover {\n        color: white;\n        background-color: @pf-color-pricing-enterprise;\n      }\n\n      &.ant-btn-enterprise--active,\n      &.ant-btn-elite--active {\n        background-color: @basic-red;\n      }\n    }\n\n    &-sm {\n      font-size: @btn-font-size-sm;\n    }\n\n    &.ant-btn-link {\n      color: @blue-6;\n      border: 0;\n      font-weight: 400;\n      padding: 0;\n\n      &:active,\n      &:focus,\n      &:hover {\n        color: @pf-color-link-hover!important;\n      }\n    }\n\n    & .anticon {\n      vertical-align: 0;\n    }\n\n    &-white {\n      color: @color-blue-5;\n      background-color: white;\n      &:hover,\n      &:focus {\n        background-color: @color-blue-1;\n      }\n      &:active,\n      &.active {\n        background-color: @color-blue-1;\n      }\n    }\n\n    &-no-border {\n      border: none;\n    }\n\n    &.ant-btn-auto {\n      height: auto;\n    }\n\n    &.ant-btn-round {\n      -webkit-border-radius: 16px;\n      -moz-border-radius: 16px;\n      border-radius: 16px;\n    }\n\n    &.ant-btn.ant-btn-icon-only {\n      padding: 0;\n    }\n\n    &.ant-btn-no-radius {\n      border-radius: 0;\n    }\n  }\n\n  .ant-button-group {\n    -webkit-box-shadow: 0 2px 10px 0 rgba(48, 48, 146, 0.13);\n    -moz-box-shadow: 0 2px 10px 0 rgba(48, 48, 146, 0.13);\n    box-shadow: 0 2px 10px 0 rgba(48, 48, 146, 0.13);\n    -webkit-border-radius: 6px; //to hide small corners that are visible with shadow.\n    -moz-border-radius: 6px;\n    border-radius: 6px;\n\n    > .ant-radio-button-wrapper {\n      height: 42px;\n      line-height: 42px;\n      border-color: @color-grey-4;\n      -webkit-box-shadow: none;\n      -moz-box-shadow: none;\n      box-shadow: none;\n\n      &:before {\n        background-color: @color-grey-4;\n      }\n    }\n\n    .ant-radio-button-wrapper-checked.ant-radio-button-wrapper:before {\n      background-color: @color-blue-2!important;\n      opacity: 1;\n    }\n\n    .ant-radio-button-wrapper-checked {\n      font-weight: bold;\n      color: @color-blue-6!important;\n      background-color: @color-blue-1!important;\n      border-color: @color-blue-2!important;\n    }\n  }\n}\n\n.btn-secondary-default() {\n  &:hover,\n  &:focus {\n    .button-color(@secondary-5; #fff; @secondary-5);\n  }\n\n  &:active,\n  &.active {\n    .button-color(@secondary-7; #fff; @secondary-7);\n  }\n}\n\n.btn-secondary-primary() {\n  .button-variant-primary(white; @secondary-color);\n}\n\n// Button styles\n// -----------------------------\n.pf-btn-secondary {\n  .btn-secondary-default;\n\n  &.ant-btn-primary {\n    .btn-secondary-primary;\n    box-shadow: 0 5px 10px 0\n      rgba(\n        red(@secondary-color),\n        green(@secondary-color),\n        blue(@secondary-color),\n        0.3\n      );\n  }\n\n  &.ant-btn-clicked:after {\n    border-color: @secondary-5;\n  }\n}\n\n.pf-btn {\n  height: 36px;\n  border: 0;\n  &-group {\n    display: block;\n    margin: 40px auto 70px;\n    text-align: center;\n  }\n\n  &-group__btn-wrapper {\n    display: inline-block;\n    position: relative;\n  }\n\n  &-group__bonus-label {\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    color: white;\n    padding: 4px;\n    font-size: @pf-font-size-sm;\n    background-color: @pf-color-pricing-enterprise-bg;\n    display: none;\n    font-weight: 100;\n\n    &--short {\n      width: 90%;\n    }\n\n    &--active {\n      display: block;\n    }\n\n    -webkit-transform: translateY(100%);\n    -moz-transform: translateY(100%);\n    -ms-transform: translateY(100%);\n    -o-transform: translateY(100%);\n    transform: translateY(100%);\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n  }\n\n  &--group-btn {\n    text-transform: capitalize;\n    border-radius: 0 !important;\n\n    &:active,\n    &:focus,\n    &:hover {\n      -webkit-transform: translate(0);\n      -moz-transform: translate(0);\n      -ms-transform: translate(0);\n      -o-transform: translate(0);\n      transform: translate(0);\n      outline: none;\n    }\n\n    &-active {\n      color: white !important;\n      background-color: @magenta-6!important;\n    }\n\n    &-first {\n      border-top-left-radius: 30px !important;\n      border-bottom-left-radius: 30px !important;\n    }\n\n    &-last {\n      border-top-right-radius: 30px !important;\n      border-bottom-right-radius: 30px !important;\n    }\n\n    background-color: white;\n    color: @pf-color-pricing-elite;\n    border-radius: 0;\n  }\n}\n\n.ant-radio-button-wrapper-border-none {\n  .ant-radio-button-wrapper {\n    border: 0;\n  }\n}\n\n.service-card-btn {\n  color: @color-blue-6;\n  background-color: white;\n  padding: 6px 14px;\n  border-radius: 4px;\n  transition: all 0.3s linear;\n\n  &.service-card-btn-hover {\n    color: white;\n    background-color: @color-blue-6;\n  }\n}\n","// Form\n// ---\n@label-required-color : @highlight-color;\n@label-color : @heading-color;\n@form-item-margin-bottom : 24px;\n@form-item-trailing-colon : true;\n@form-vertical-label-padding : 0 0 8px;\n@form-vertical-label-margin : 0;\n\n.form-actions-container {\n  border-top: 1px solid #eef1f4;\n  padding-top: 24px;\n  margin-top: -24px;\n}\n\n.field-explain-label {\n  font-size: 12px;\n  position: relative;\n  top: -14px;\n}\n\n.ant-form-item-line-height-clear {\n  .ant-legacy-form-item-control {\n    line-height: 1;\n  }\n}\n\n.team-information-form,\n.personal-information-form,\n.password-form {\n  &.ant-legacy-form-vertical {\n    .ant-legacy-form-item {\n      padding-bottom: 0;\n    }\n  }\n\n  .ant-legacy-form-item {\n    margin-bottom: 18px;\n  }\n\n  .ant-legacy-form-item-label {\n    line-height: 1;\n    padding-bottom: 6px;\n  }\n\n  .ant-input {\n    font-size: 14px;\n    height: 40px;\n    font-weight: bold;\n    border-color: @color-grey-5;\n\n    &:hover,\n    &:focus,\n    &:active {\n      border-color: @color-grey-6 !important;\n      box-shadow: none !important;\n    }\n\n    &::placeholder {\n      color: @color-grey-7;\n      font-weight: normal;\n    }\n  }\n}\n\n.password-form {\n  .ant-legacy-form-item-required span::after {\n    display: inline-block;\n    margin-right: 4px;\n    color: @color-grey-10;\n    font-size: 14px;\n    font-family: SimSun, sans-serif;\n    line-height: 1;\n    content: '*';\n  }\n}\n",".pf-theme {\n  .ant-input-search {\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    overflow: hidden;\n\n    .ant-input-wrapper {\n      background: transparent !important;\n    }\n\n    .ant-input-group-addon {\n      background-color: transparent !important;\n      width: 0;\n    }\n\n    .ant-input {\n      border: 0 !important;\n      background-color: @color-grey-3;\n      height: 38px;\n\n      &:active,\n      &:focus,\n      &:hover {\n        box-shadow: none !important;\n      }\n    }\n\n    .ant-input::placeholder {\n      color: @color-grey-10;\n    }\n\n    .ant-input-search-button {\n      background: transparent;\n      border: none;\n      box-shadow: none !important;\n      position: absolute;\n      right: 0;\n      top: 0;\n      height: 100%;\n      z-index: 100;\n    }\n\n    .anticon-search::before {\n      font-family: 'icomoon';\n      content: '\\E670'; //search1\n      display: block;\n      font-size: 14px;\n      font-weight: bold;\n      color: @color-grey-10;\n    }\n\n    .anticon-search svg {\n      display: none;\n    }\n  }\n\n  .ant-input {\n    &.ant-input-sm {\n      padding-top: 1px;\n      padding-bottom: 1px;\n      height: 24px;\n    }\n\n    line-height: 1.5;\n    border-radius: 4px;\n\n    &.StripeElement--focus,\n    &:focus {\n      color: @color-grey-10;\n      border-color: @color-blue-6;\n      outline: 0;\n      box-shadow: 1px 1px @outline-blur-size @outline-width\n        fade(@input-border-color, 80%) inset;\n    }\n\n    &-shadow-none {\n      @noShadow: 0 0 0 transparent;\n\n      &:focus {\n        box-shadow: @noShadow;\n      }\n      box-shadow: @noShadow;\n    }\n\n    &-question::placeholder,\n    &-answer::placeholder {\n      font-weight: normal;\n      color: @color-grey-9;\n    }\n\n    &.StripeElement--focus,\n    &:hover {\n      border-color: @input-hover-border-color;\n    }\n  }\n  .has-error {\n    .ant-input {\n      border-color: @error-color;\n      outline: 0;\n      box-shadow: 0 0 @outline-blur-size @outline-width\n        fade(@input-border-color, 20%);\n      &.StripeElement--focus,\n      &:focus {\n        border-color: @error-color;\n        outline: 0;\n        box-shadow: 0 0 @outline-blur-size @outline-width\n          fade(@input-border-color, 20%);\n      }\n    }\n  }\n\n  .ant-checkbox-inner {\n    border-radius: 4px;\n    border-color: @color-grey-5;\n  }\n\n  .ant-checkbox-dark {\n    color: @color-grey-10;\n  }\n\n  .ant-checkbox-dark .ant-checkbox-inner {\n    border-color: @color-grey-10;\n  }\n\n  .ant-checkbox-indeterminate .ant-checkbox-inner::after {\n    height: 2.5px;\n  }\n\n  .ant-radio .ant-radio-inner {\n    border-color: @color-grey-10;\n  }\n\n  .ant-radio-checked .ant-radio-inner {\n    border-color: @color-blue-6;\n\n    &:after {\n      background-color: @color-blue-6;\n    }\n  }\n\n  .ant-radio-inner {\n    -webkit-box-shadow: none !important;\n    -moz-box-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  .ant-time-picker-clock-icon {\n    color: @color-grey-10!important;\n    font-size: 16px;\n    margin-top: -2px;\n  }\n\n  .ant-calendar-picker-container,\n  .ant-time-picker-panel {\n    font-family: @font-family;\n    color: @color-grey-10;\n  }\n\n  .ant-input-number {\n    &.ant-input-dollar-decoration {\n      padding-left: 12px;\n      position: relative;\n\n      &:before {\n        content: '$';\n        position: absolute;\n        left: 11px;\n        top: 8px;\n        z-index: 1;\n      }\n    }\n\n    &.ant-input-number-hide-arrows {\n      .ant-input-number-handler-wrap {\n        display: none !important;\n      }\n    }\n  }\n}\n\n.link-settings-input input,\ninput.link-settings-input {\n  height: 40px;\n  &::placeholder {\n    color: @color-grey-7;\n  }\n}\n\n// we need to force left to right because rtl only on the input is wrong\n// and it won't work as expected. More info on the ticket https://pollfish.atlassian.net/browse/RES-6599\n[data-slate-node='element'][dir='rtl'] {\n  direction: ltr;\n}\np[data-slate-node='element'] {\n  margin-bottom: 0;\n}\n\n.ant-input-search-white .ant-input {\n  background-color: white !important;\n}\n\n.pf-radio-btn {\n  outline-offset: 0.15rem;\n}\n.pf-radio-btn-input {\n  visibility: hidden;\n}\n.pf-radio-btn-input-wrapper {\n  background-color: white;\n  border: 1px solid @color-grey-10;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  position: relative;\n\n  &.pf-radio-btn-input-wrapper-checked {\n    border: 2px solid @color-blue-6;\n\n    &:after {\n      position: absolute;\n      top: 3px;\n      left: 3px;\n      width: 10px;\n      height: 10px;\n      background: @color-blue-6;\n      border-radius: 50%;\n      z-index: 10;\n      animation-fill-mode: both;\n      content: '';\n    }\n  }\n}\n\n.placeholder-grey-7 {\n  &::placeholder {\n    color: @color-grey-7;\n  }\n}\n\n.placeholder-grey-8 {\n  &::placeholder {\n    color: @color-grey-8;\n  }\n}\n\n//@input-height-base           : 32px;\n//@input-height-lg             : 40px;\n//@input-height-sm             : 24px;\n//@input-padding-horizontal    : @control-padding-horizontal - 1px;\n//@input-padding-horizontal-base: @input-padding-horizontal;\n//@input-padding-horizontal-sm : @control-padding-horizontal-sm - 1px;\n//@input-padding-horizontal-lg : @input-padding-horizontal;\n//@input-padding-vertical-base : 4px;\n//@input-padding-vertical-sm   : 1px;\n//@input-padding-vertical-lg   : 6px;\n//@input-placeholder-color     : hsv(0, 0, 75%);\n//@input-border-color          : @border-color-base;\n//@input-bg                    : #fff;\n//@input-addon-bg              : @background-color-light;\n//@input-hover-border-color    : @primary-color;\n//@input-disabled-bg           : @disabled-bg;\n","@import './re-theme/colors';\n\n.pf-theme {\n  .ant-card {\n    box-shadow: @card-box-shadow;\n    border-radius: @card-border-radius;\n    overflow: hidden;\n\n    &.inner-card {\n      border: 1px solid #f5f7f9;\n\n      &:before {\n        height: 0;\n      }\n\n      .ant-card-head-title {\n        font-size: @pf-font-size-xl;\n      }\n\n      .ant-card-wider-padding {\n        padding: 0;\n      }\n    }\n\n    &-padding-none {\n      .ant-card-body {\n        padding: 0;\n      }\n    }\n\n    &-padding-sm {\n      .ant-card-body {\n        padding: 12px;\n      }\n    }\n\n    .inner-card__label {\n      font-size: 18px;\n      font-weight: 500;\n      color: #6b7179;\n    }\n\n    .inner-card__footer {\n      margin-top: @space-sm;\n      border: 0;\n    }\n\n    .inner-card--with-icon {\n      position: relative;\n      &:before {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 0;\n        height: 0;\n        border-top: 36px solid @primary-color;\n        border-left: 36px solid #fff;\n      }\n\n      &:after {\n        position: absolute;\n        top: 3px;\n        right: 4px;\n        font-size: 12px;\n        font-family: 'anticon';\n        content: '\\e660';\n        color: #fff;\n      }\n    }\n\n    &.questionnaire-card .ant-card-body {\n      padding-top: 14px;\n      padding-bottom: 14px;\n    }\n    &.questionnaire-card.ant-card-padding-none .ant-card-body {\n      padding-bottom: 0 !important;\n    }\n    &.crosstab-card .ant-card-body {\n      padding-top: 8px;\n      padding-bottom: 8px;\n      min-height: 42px;\n    }\n  }\n\n  .ant-card-head-wrapper {\n    align-items: center;\n  }\n\n  .ant-card-head-title {\n    color: @card-head-color;\n    font-weight: 400;\n    font-size: @pf-font-size-xl;\n    line-height: 1;\n    padding: @space-lg 0;\n  }\n\n  .ant-card-head {\n    padding: 0 @space-lg;\n    border-bottom: 0;\n  }\n\n  .ant-card-body {\n    padding: @space-lg;\n  }\n\n  .ant-card__main-alert {\n    margin-top: -1 * @card-padding-base;\n  }\n\n  .ant-card-footer {\n    border-top: 1px solid @pale-grey-two;\n    margin: 0 -1 * @card-padding-base;\n    padding: @card-padding-footer;\n  }\n\n  .card-payment-method {\n    margin: @space-sm 0 @space-lg;\n  }\n\n  .card-payment-method .ant-card-head {\n    padding: 0 @space-md;\n  }\n\n  .card-payment-method .ant-card-body {\n    padding: 0 @space-md @space-md;\n  }\n\n  .card-payment-method .ant-card-head-title {\n    font-size: @font-size-base;\n    cursor: pointer;\n    padding: @space-md 0;\n  }\n\n  .card-payment-method .ant-card-head-title span {\n    font-size: @font-size-base;\n  }\n\n  .card-payment-method .ant-card-extra {\n    font-size: @pf-font-size-xs;\n    color: @primary-color;\n  }\n\n  .card-payment-method__flex-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: @pf-font-size-sm;\n    margin-bottom: @space-sm;\n  }\n\n  .card-payment-method--is-active .ant-card-head-title {\n    color: @primary-color;\n  }\n\n  .card-payment-method--is-active.ant-card {\n    border-color: @primary-color;\n  }\n\n  .card-payment-method--is-active .ant-card-body {\n    display: block;\n  }\n\n  .card-payment-method--is-hidden .ant-card-body {\n    display: none;\n  }\n\n  .ant-card-grey {\n    background-color: @color-grey-2;\n  }\n\n  .ant-card-resizable {\n    height: calc(100% - 24px) !important;\n  }\n\n  .ant-card-no-shadow {\n    -webkit-box-shadow: 0;\n    -moz-box-shadow: 0;\n    box-shadow: 0;\n  }\n}\n\n.piped-attribute-wrapper {\n  display: inline-block;\n  position: relative;\n  height: 16px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -2px;\n    right: 0;\n    height: 1px;\n    z-index: 0;\n    border: 1px solid #e7ebef;\n    background-color: #f9fafc;\n    padding: 2px 6px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    height: 20px;\n  }\n}\n\n.piped-attribute-wrapper {\n  display: inline-flex;\n}\n\n.piped-attribute {\n  position: relative;\n  display: inline-block;\n  color: @color-grey-9;\n  z-index: 2;\n  font-weight: 400;\n  margin: 0 4px;\n  max-width: 100px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  position: relative;\n}\n\n.piped-attribute-normal-text {\n  display: inline-flex;\n}\n\n.pf-new-theme\n  .crosstabs-page\n  .ant-collapse\n  > .ant-collapse-item\n  > .ant-collapse-header\n  .ant-collapse-arrow {\n  top: 10px;\n}\n\n.crosstabs-page .ant-collapse-header {\n  margin-left: 0 !important;\n}\n\n.pf-new-theme\n  .crosstabs-page\n  .ant-card.ant-card-padding-none.questionnaire-card\n  .ant-card-body {\n  // padding-top: 8px !important;\n  // padding-bottom: 10px !important;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n\n.question-answers-divider {\n  position: relative;\n}\n\n.question-answers-divider::before {\n  content: '';\n  position: absolute;\n  top: -30px;\n  left: -42px;\n  width: calc(100% + 42px);\n  height: 1px;\n  background-color: @color-grey-4;\n  z-index: 1;\n}\n\n.question-answers-divider::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -42px;\n  width: calc(100% + 42px);\n  height: 1px;\n  background-color: @color-grey-4;\n  z-index: 1;\n}\n\n.answer-divider-btm {\n  position: relative;\n}\n\n.answer-divider-btm::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: -82px;\n  width: calc(100% + 107px);\n  height: 1px;\n  background-color: @color-grey-4;\n  z-index: 1;\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@alert-prefix-cls: ~'@{ant-prefix}-alert';\n\n.@{alert-prefix-cls} {\n  .reset-component();\n\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 8px 15px;\n  word-wrap: break-word;\n  border-radius: @border-radius-base;\n\n  &-content {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &-icon {\n    margin-right: @margin-xs;\n  }\n\n  &-description {\n    display: none;\n    font-size: @font-size-base;\n    line-height: @font-size-base + 8px;\n  }\n\n  &-success {\n    background-color: @alert-success-bg-color;\n    border: @border-width-base @border-style-base @alert-success-border-color;\n    .@{alert-prefix-cls}-icon {\n      color: @alert-success-icon-color;\n    }\n  }\n\n  &-info {\n    background-color: @alert-info-bg-color;\n    border: @border-width-base @border-style-base @alert-info-border-color;\n    .@{alert-prefix-cls}-icon {\n      color: @alert-info-icon-color;\n    }\n  }\n\n  &-warning {\n    background-color: @alert-warning-bg-color;\n    border: @border-width-base @border-style-base @alert-warning-border-color;\n    .@{alert-prefix-cls}-icon {\n      color: @alert-warning-icon-color;\n    }\n  }\n\n  &-error {\n    background-color: @alert-error-bg-color;\n    border: @border-width-base @border-style-base @alert-error-border-color;\n\n    .@{alert-prefix-cls}-icon {\n      color: @alert-error-icon-color;\n    }\n\n    .@{alert-prefix-cls}-description > pre {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  &-action {\n    margin-left: @margin-xs;\n  }\n\n  &-close-icon {\n    margin-left: @margin-xs;\n    padding: 0;\n    overflow: hidden;\n    font-size: @font-size-sm;\n    line-height: @font-size-sm;\n    background-color: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n\n    .@{iconfont-css-prefix}-close {\n      color: @alert-close-color;\n      transition: color 0.3s;\n      &:hover {\n        color: @alert-close-hover-color;\n      }\n    }\n  }\n\n  &-close-text {\n    color: @alert-close-color;\n    transition: color 0.3s;\n    &:hover {\n      color: @alert-close-hover-color;\n    }\n  }\n\n  &-with-description {\n    align-items: flex-start;\n    padding: @alert-with-description-padding;\n  }\n\n  &-with-description&-no-icon {\n    padding: @alert-with-description-no-icon-padding-vertical 15px;\n  }\n\n  &-with-description &-icon {\n    margin-right: @alert-with-description-padding-vertical;\n    font-size: @alert-with-description-icon-size;\n  }\n  &-with-description &-message {\n    display: block;\n    margin-bottom: 4px;\n    color: @alert-message-color;\n    font-size: @font-size-lg;\n  }\n\n  &-message {\n    color: @alert-message-color;\n  }\n\n  &-with-description &-description {\n    display: block;\n  }\n\n  &&-motion-leave {\n    overflow: hidden;\n    opacity: 1;\n    transition: max-height 0.3s @ease-in-out-circ, opacity 0.3s @ease-in-out-circ,\n      padding-top 0.3s @ease-in-out-circ, padding-bottom 0.3s @ease-in-out-circ,\n      margin-bottom 0.3s @ease-in-out-circ;\n  }\n\n  &&-motion-leave-active {\n    max-height: 0;\n    margin-bottom: 0 !important;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: 0;\n  }\n\n  &-banner {\n    margin-bottom: 0;\n    border: 0;\n    border-radius: 0;\n  }\n}\n\n@import './rtl';\n","@import '../themes/index';\n\n.reset-component() {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: @text-color;\n  font-size: @font-size-base;\n  font-variant: @font-variant-base;\n  line-height: @line-height-base;\n  list-style: none;\n  font-feature-settings: @font-feature-settings-base;\n}\n",".@{alert-prefix-cls} {\n  &&-rtl {\n    direction: rtl;\n  }\n\n  &&-no-icon {\n    .@{alert-prefix-cls}-rtl& {\n      padding: @alert-no-icon-padding-vertical 15px;\n    }\n  }\n\n  &-icon {\n    .@{alert-prefix-cls}-rtl & {\n      margin-right: auto;\n      margin-left: @margin-xs;\n    }\n  }\n\n  &-action {\n    .@{alert-prefix-cls}-rtl & {\n      margin-right: @margin-xs;\n      margin-left: auto;\n    }\n  }\n\n  &-close-icon {\n    .@{alert-prefix-cls}-rtl & {\n      margin-right: @margin-xs;\n      margin-left: auto;\n    }\n  }\n\n  &-with-description &-icon {\n    .@{alert-prefix-cls}-rtl& {\n      margin-right: auto;\n      margin-left: @alert-with-description-padding-vertical;\n    }\n  }\n}\n","@import '../../node_modules/antd/lib/alert/style/index.less';\n\n.pf-theme {\n  .ant-alert:not(.default-alert) {\n    background-color: @alert-background-color;\n    padding-right: 32px;\n  }\n  .ant-alert {\n    &:not(.default-alert):before {\n      position: absolute;\n      left: 0;\n      top: 0;\n      content: '';\n      display: block;\n      width: 5px;\n      background-color: @alert-left-border-default;\n      height: 100%;\n    }\n\n    &-default:not(.default-alert) {\n      border: @border-width-base @border-style-base @alert-border-color-default;\n      .@{alert-prefix-cls}-message,\n      .@{alert-prefix-cls}-icon {\n        color: @alert-color-default;\n      }\n      &:before {\n        background-color: @text-color;\n      }\n    }\n\n    &-success:not(.default-alert) {\n      border: @border-width-base @border-style-base @success-color;\n      background-color: @alert-background-color;\n      .@{alert-prefix-cls}-message,\n      .@{alert-prefix-cls}-icon,\n      a {\n        color: @success-color;\n      }\n      &:before {\n        background-color: @success-color;\n      }\n    }\n\n    &-info:not(.default-alert) {\n      border: @border-width-base @border-style-base @info-color;\n      background-color: @alert-background-color;\n      .@{alert-prefix-cls}-message,\n      .@{alert-prefix-cls}-icon,\n      a {\n        color: @info-color;\n      }\n      &:before {\n        background-color: @info-color;\n      }\n    }\n\n    &-warning:not(.default-alert) {\n      border: @border-width-base @border-style-base @warning-color;\n      background-color: @alert-background-color;\n      .@{alert-prefix-cls}-message,\n      .@{alert-prefix-cls}-icon,\n      a {\n        color: @warning-color;\n      }\n      &:before {\n        background-color: @warning-color;\n      }\n    }\n\n    &-error:not(.default-alert) {\n      border: @border-width-base @border-style-base @error-color;\n      background-color: @alert-background-color;\n      .@{alert-prefix-cls}-message,\n      .@{alert-prefix-cls}-icon,\n      a {\n        color: @error-color;\n      }\n      &:before {\n        background-color: @error-color;\n      }\n    }\n\n    &-with-description {\n      .@{alert-prefix-cls}-description {\n        color: @alert-description-color;\n        line-height: @alert-description-line-height;\n      }\n    }\n\n    &.no-side-border {\n      border-left: 0;\n      border-right: 0;\n      border-radius: 0;\n    }\n    &.no-border-bottom {\n      border-bottom: 0;\n    }\n    &.no-border-top {\n      border-top: 0;\n    }\n    &.no-indicator {\n      &:before {\n        display: none;\n      }\n    }\n\n    &.warning-batch-text {\n      border: none;\n      font-size: 12px;\n      line-height: 14px;\n      padding: 8px;\n      background-color: #fef9d3;\n\n      .ant-alert-icon {\n        margin-right: 4px;\n      }\n\n      .ant-alert-close-icon {\n        font-size: 10px;\n        line-height: 10px;\n      }\n    }\n\n    &.info-checkout-peeq-message{\n      border: none;\n      border-radius: 4px;\n      font-size: 12px;\n      line-height: 16px;\n      padding: 8px;\n      background-color: #ECF3FE;\n      align-items: flex-start;\n\n      .ant-alert-icon {\n        margin-right: 8px;\n        color: @primary-color;\n        margin-top: 1px\n      }\n    }\n  }\n\n  .ant-alert-banner {\n    border-radius: 0;\n    border: 0;\n    margin-bottom: 0;\n    &:before {\n      display: none;\n    }\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n@import '../../input/style/mixin';\n\n@pagination-prefix-cls: ~'@{ant-prefix}-pagination';\n\n.@{pagination-prefix-cls} {\n  .reset-component();\n\n  ul,\n  ol {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  &::after {\n    display: block;\n    clear: both;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n    content: ' ';\n  }\n\n  &-total-text {\n    display: inline-block;\n    height: @pagination-item-size;\n    margin-right: 8px;\n    line-height: @pagination-item-size - 2px;\n    vertical-align: middle;\n  }\n\n  &-item {\n    display: inline-block;\n    min-width: @pagination-item-size;\n    height: @pagination-item-size;\n    margin-right: 8px;\n    font-family: @pagination-font-family;\n    line-height: @pagination-item-size - 2px;\n    text-align: center;\n    vertical-align: middle;\n    list-style: none;\n    background-color: @pagination-item-bg;\n    border: @border-width-base @border-style-base @border-color-base;\n    border-radius: @border-radius-base;\n    outline: 0;\n    cursor: pointer;\n    user-select: none;\n\n    a {\n      display: block;\n      padding: 0 6px;\n      color: @text-color;\n      transition: none;\n\n      &:hover {\n        text-decoration: none;\n      }\n    }\n\n    &:focus-visible,\n    &:hover {\n      border-color: @primary-color;\n      transition: all 0.3s;\n      a {\n        color: @primary-color;\n      }\n    }\n\n    &-active {\n      font-weight: @pagination-font-weight-active;\n      background: @pagination-item-bg-active;\n      border-color: @primary-color;\n\n      a {\n        color: @primary-color;\n      }\n\n      &:focus-visible,\n      &:hover {\n        border-color: @primary-5;\n      }\n\n      &:focus-visible a,\n      &:hover a {\n        color: @primary-5;\n      }\n    }\n  }\n\n  &-jump-prev,\n  &-jump-next {\n    outline: 0;\n    .@{pagination-prefix-cls}-item-container {\n      position: relative;\n\n      .@{pagination-prefix-cls}-item-link-icon {\n        color: @primary-color;\n        font-size: @font-size-sm;\n        letter-spacing: -1px;\n        opacity: 0;\n        transition: all 0.2s;\n        &-svg {\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          margin: auto;\n        }\n      }\n\n      .@{pagination-prefix-cls}-item-ellipsis {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        margin: auto;\n        color: @disabled-color;\n        font-family: Arial, Helvetica, sans-serif;\n        letter-spacing: 2px;\n        text-align: center;\n        text-indent: 0.13em;\n        opacity: 1;\n        transition: all 0.2s;\n      }\n    }\n\n    &:focus-visible,\n    &:hover {\n      .@{pagination-prefix-cls}-item-link-icon {\n        opacity: 1;\n      }\n      .@{pagination-prefix-cls}-item-ellipsis {\n        opacity: 0;\n      }\n    }\n  }\n\n  &-prev,\n  &-jump-prev,\n  &-jump-next {\n    margin-right: 8px;\n  }\n  &-prev,\n  &-next,\n  &-jump-prev,\n  &-jump-next {\n    display: inline-block;\n    min-width: @pagination-item-size;\n    height: @pagination-item-size;\n    color: @text-color;\n    font-family: @pagination-font-family;\n    line-height: @pagination-item-size;\n    text-align: center;\n    vertical-align: middle;\n    list-style: none;\n    border-radius: @border-radius-base;\n    cursor: pointer;\n    transition: all 0.3s;\n  }\n\n  &-prev,\n  &-next {\n    font-family: Arial, Helvetica, sans-serif;\n    outline: 0;\n\n    button {\n      color: @text-color;\n      cursor: pointer;\n      user-select: none;\n    }\n\n    &:hover button {\n      border-color: @primary-5;\n    }\n\n    .@{pagination-prefix-cls}-item-link {\n      display: block;\n      width: 100%;\n      height: 100%;\n      padding: 0;\n      font-size: 12px;\n      text-align: center;\n      background-color: @pagination-item-link-bg;\n      border: @border-width-base @border-style-base @border-color-base;\n      border-radius: @border-radius-base;\n      outline: none;\n      transition: all 0.3s;\n    }\n\n    &:focus-visible .@{pagination-prefix-cls}-item-link,\n    &:hover .@{pagination-prefix-cls}-item-link {\n      color: @primary-color;\n      border-color: @primary-color;\n    }\n  }\n\n  &-disabled {\n    &,\n    &:hover,\n    &:focus-visible {\n      cursor: not-allowed;\n      .@{pagination-prefix-cls}-item-link {\n        color: @disabled-color;\n        border-color: @border-color-base;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &-slash {\n    margin: 0 10px 0 5px;\n  }\n\n  &-options {\n    display: inline-block;\n    margin-left: 16px;\n    vertical-align: middle;\n\n    // IE11 css hack. `*::-ms-backdrop,` is a must have\n    @media all and (-ms-high-contrast: none) {\n      *::-ms-backdrop,\n      & {\n        vertical-align: top;\n      }\n    }\n\n    &-size-changer.@{ant-prefix}-select {\n      display: inline-block;\n      width: auto;\n    }\n\n    &-quick-jumper {\n      display: inline-block;\n      height: @input-height-base;\n      margin-left: @margin-xs;\n      line-height: @input-height-base;\n      vertical-align: top;\n\n      input {\n        .input();\n\n        width: 50px;\n        height: @input-height-base;\n        margin: 0 8px;\n      }\n    }\n  }\n\n  &-simple &-prev,\n  &-simple &-next {\n    height: @pagination-item-size-sm;\n    line-height: @pagination-item-size-sm;\n    vertical-align: top;\n    .@{pagination-prefix-cls}-item-link {\n      height: @pagination-item-size-sm;\n      background-color: transparent;\n      border: 0;\n      &::after {\n        height: @pagination-item-size-sm;\n        line-height: @pagination-item-size-sm;\n      }\n    }\n  }\n\n  &-simple &-simple-pager {\n    display: inline-block;\n    height: @pagination-item-size-sm;\n    margin-right: 8px;\n\n    input {\n      box-sizing: border-box;\n      height: 100%;\n      margin-right: 8px;\n      padding: 0 6px;\n      text-align: center;\n      background-color: @pagination-item-input-bg;\n      border: @border-width-base @border-style-base @border-color-base;\n      border-radius: @border-radius-base;\n      outline: none;\n      transition: border-color 0.3s;\n\n      &:hover {\n        border-color: @primary-color;\n      }\n\n      &[disabled] {\n        color: @disabled-color;\n        background: @disabled-bg;\n        border-color: @border-color-base;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  &.mini &-total-text,\n  &.mini &-simple-pager {\n    height: @pagination-item-size-sm;\n    line-height: @pagination-item-size-sm;\n  }\n\n  &.mini &-item {\n    min-width: @pagination-item-size-sm;\n    height: @pagination-item-size-sm;\n    margin: 0;\n    line-height: @pagination-item-size-sm - 2px;\n  }\n\n  &.mini &-item:not(&-item-active) {\n    background: transparent;\n    border-color: transparent;\n  }\n\n  &.mini &-prev,\n  &.mini &-next {\n    min-width: @pagination-item-size-sm;\n    height: @pagination-item-size-sm;\n    margin: 0;\n    line-height: @pagination-item-size-sm;\n  }\n\n  &.mini &-prev &-item-link,\n  &.mini &-next &-item-link {\n    background: transparent;\n    border-color: transparent;\n    &::after {\n      height: @pagination-item-size-sm;\n      line-height: @pagination-item-size-sm;\n    }\n  }\n\n  &.mini &-jump-prev,\n  &.mini &-jump-next {\n    height: @pagination-item-size-sm;\n    margin-right: 0;\n    line-height: @pagination-item-size-sm;\n  }\n\n  &.mini &-options {\n    margin-left: 2px;\n\n    &-size-changer {\n      top: @pagination-mini-options-size-changer-top;\n    }\n\n    &-quick-jumper {\n      height: @pagination-item-size-sm;\n      line-height: @pagination-item-size-sm;\n\n      input {\n        .input-sm();\n\n        width: 44px;\n        height: @input-height-sm;\n      }\n    }\n  }\n\n  // ============================ Disabled ============================\n  &&-disabled {\n    cursor: not-allowed;\n\n    .@{pagination-prefix-cls}-item {\n      background: @disabled-bg;\n      border-color: @border-color-base;\n      cursor: not-allowed;\n\n      a {\n        color: @disabled-color;\n        background: transparent;\n        border: none;\n        cursor: not-allowed;\n      }\n\n      &-active {\n        background: @pagination-item-disabled-bg-active;\n        a {\n          color: @pagination-item-disabled-color-active;\n        }\n      }\n    }\n\n    .@{pagination-prefix-cls}-item-link {\n      color: @disabled-color;\n      background: @disabled-bg;\n      border-color: @border-color-base;\n      cursor: not-allowed;\n      .@{pagination-prefix-cls}-simple& {\n        background: transparent;\n      }\n    }\n\n    .@{pagination-prefix-cls}-item-link-icon {\n      opacity: 0;\n    }\n\n    .@{pagination-prefix-cls}-item-ellipsis {\n      opacity: 1;\n    }\n\n    .@{pagination-prefix-cls}-simple-pager {\n      color: @disabled-color;\n    }\n  }\n}\n\n@media only screen and (max-width: @screen-lg) {\n  .@{pagination-prefix-cls}-item {\n    &-after-jump-prev,\n    &-before-jump-next {\n      display: none;\n    }\n  }\n}\n\n@media only screen and (max-width: @screen-sm) {\n  .@{pagination-prefix-cls}-options {\n    display: none;\n  }\n}\n\n@import './rtl';\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@input-affix-with-clear-btn-width: 38px;\n\n// size mixins for input\n.input-lg() {\n  padding: @input-padding-vertical-lg @input-padding-horizontal-lg;\n  font-size: @font-size-lg;\n}\n\n.input-sm() {\n  padding: @input-padding-vertical-sm @input-padding-horizontal-sm;\n}\n\n// input status\n// == when focus or actived\n.active(@color: @outline-color) {\n  & when (@theme = dark) {\n    border-color: @color;\n  }\n  & when not (@theme = dark) {\n    border-color: ~`colorPalette('@{color}', 5) `;\n  }\n  border-right-width: @border-width-base !important;\n  outline: 0;\n  box-shadow: @input-outline-offset @outline-blur-size @outline-width fade(@color, @outline-fade);\n}\n\n// == when hoverd\n.hover(@color: @input-hover-border-color) {\n  border-color: @color;\n  border-right-width: @border-width-base !important;\n}\n\n.disabled() {\n  color: @input-disabled-color;\n  background-color: @input-disabled-bg;\n  border-color: @input-border-color;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 1;\n\n  &:hover {\n    .hover(@input-border-color);\n  }\n}\n\n// Basic style for input\n.input() {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-width: 0;\n  padding: @input-padding-vertical-base @input-padding-horizontal-base;\n  color: @input-color;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  background-color: @input-bg;\n  background-image: none;\n  border: @border-width-base @border-style-base @input-border-color;\n  border-radius: @border-radius-base;\n  transition: all 0.3s;\n  .placeholder(); // Reset placeholder\n\n  &:hover {\n    .hover();\n  }\n\n  &:focus,\n  &-focused {\n    .active();\n  }\n\n  &-disabled {\n    .disabled();\n  }\n\n  &[disabled] {\n    .disabled();\n  }\n\n  &-borderless {\n    &,\n    &:hover,\n    &:focus,\n    &-focused,\n    &-disabled,\n    &[disabled] {\n      background-color: transparent;\n      border: none;\n      box-shadow: none;\n    }\n  }\n\n  // Reset height for `textarea`s\n  textarea& {\n    max-width: 100%; // prevent textearea resize from coming out of its container\n    height: auto;\n    min-height: @input-height-base;\n    line-height: @line-height-base;\n    vertical-align: bottom;\n    transition: all 0.3s, height 0s;\n  }\n\n  // Size\n  &-lg {\n    .input-lg();\n  }\n\n  &-sm {\n    .input-sm();\n  }\n}\n\n// label input\n.input-group(@inputClass) {\n  position: relative;\n  display: table;\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n\n  // Undo padding and float of grid classes\n  &[class*='col-'] {\n    float: none;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  > [class*='col-'] {\n    padding-right: 8px;\n\n    &:last-child {\n      padding-right: 0;\n    }\n  }\n\n  &-addon,\n  &-wrap,\n  > .@{inputClass} {\n    display: table-cell;\n\n    &:not(:first-child):not(:last-child) {\n      border-radius: 0;\n    }\n  }\n\n  &-addon,\n  &-wrap {\n    width: 1px; // To make addon/wrap as small as possible\n    white-space: nowrap;\n    vertical-align: middle;\n  }\n\n  &-wrap > * {\n    display: block !important;\n  }\n\n  .@{inputClass} {\n    float: left;\n    width: 100%;\n    margin-bottom: 0;\n    text-align: inherit;\n\n    &:focus {\n      z-index: 1; // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png\n      border-right-width: 1px;\n    }\n\n    &:hover {\n      z-index: 1;\n      border-right-width: 1px;\n      .@{ant-prefix}-input-search-with-button & {\n        z-index: 0;\n      }\n    }\n  }\n\n  &-addon {\n    position: relative;\n    padding: 0 @input-padding-horizontal-base;\n    color: @input-color;\n    font-weight: normal;\n    font-size: @font-size-base;\n    text-align: center;\n    background-color: @input-addon-bg;\n    border: @border-width-base @border-style-base @input-border-color;\n    border-radius: @border-radius-base;\n    transition: all 0.3s;\n\n    // Reset Select's style in addon\n    .@{ant-prefix}-select {\n      margin: -(@input-padding-vertical-base + 1px) (-@input-padding-horizontal-base);\n\n      &.@{ant-prefix}-select-single:not(.@{ant-prefix}-select-customize-input)\n        .@{ant-prefix}-select-selector {\n        background-color: inherit;\n        border: @border-width-base @border-style-base transparent;\n        box-shadow: none;\n      }\n\n      &-open,\n      &-focused {\n        .@{ant-prefix}-select-selector {\n          color: @primary-color;\n        }\n      }\n    }\n\n    // https://github.com/ant-design/ant-design/issues/31333\n    .@{ant-prefix}-cascader-picker {\n      margin: -9px (-@control-padding-horizontal);\n      background-color: transparent;\n      .@{ant-prefix}-cascader-input {\n        text-align: left;\n        border: 0;\n        box-shadow: none;\n      }\n    }\n  }\n\n  // Reset rounded corners\n  > .@{inputClass}:first-child,\n  &-addon:first-child {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n\n    // Reset Select's style in addon\n    .@{ant-prefix}-select .@{ant-prefix}-select-selector {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n\n  > .@{inputClass}-affix-wrapper {\n    &:not(:first-child) .@{inputClass} {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    &:not(:last-child) .@{inputClass} {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n\n  &-addon:first-child {\n    border-right: 0;\n  }\n\n  &-addon:last-child {\n    border-left: 0;\n  }\n\n  > .@{inputClass}:last-child,\n  &-addon:last-child {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n\n    // Reset Select's style in addon\n    .@{ant-prefix}-select .@{ant-prefix}-select-selector {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  }\n\n  // Sizing options\n  &-lg .@{inputClass},\n  &-lg > &-addon {\n    .input-lg();\n  }\n\n  &-sm .@{inputClass},\n  &-sm > &-addon {\n    .input-sm();\n  }\n\n  // Fix https://github.com/ant-design/ant-design/issues/5754\n  &-lg .@{ant-prefix}-select-single .@{ant-prefix}-select-selector {\n    height: @input-height-lg;\n  }\n\n  &-sm .@{ant-prefix}-select-single .@{ant-prefix}-select-selector {\n    height: @input-height-sm;\n  }\n\n  .@{inputClass}-affix-wrapper {\n    &:not(:first-child) {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    &:not(:last-child) {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n      .@{ant-prefix}-input-search & {\n        border-top-left-radius: @border-radius-base;\n        border-bottom-left-radius: @border-radius-base;\n      }\n    }\n  }\n\n  &&-compact {\n    display: block;\n    .clearfix();\n\n    &-addon,\n    &-wrap,\n    > .@{inputClass} {\n      &:not(:first-child):not(:last-child) {\n        border-right-width: @border-width-base;\n\n        &:hover {\n          z-index: 1;\n        }\n\n        &:focus {\n          z-index: 1;\n        }\n      }\n    }\n\n    & > * {\n      display: inline-block;\n      float: none;\n      vertical-align: top; // https://github.com/ant-design/ant-design-pro/issues/139\n      border-radius: 0;\n    }\n\n    & > .@{inputClass}-affix-wrapper {\n      display: inline-flex;\n    }\n\n    & > .@{ant-prefix}-picker-range {\n      display: inline-flex;\n    }\n\n    & > *:not(:last-child) {\n      margin-right: -@border-width-base;\n      border-right-width: @border-width-base;\n    }\n\n    // Undo float for .ant-input-group .ant-input\n    .@{inputClass} {\n      float: none;\n    }\n\n    // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input\n    & > .@{ant-prefix}-select > .@{ant-prefix}-select-selector,\n    & > .@{ant-prefix}-select-auto-complete .@{ant-prefix}-input,\n    & > .@{ant-prefix}-cascader-picker .@{ant-prefix}-input,\n    & > .@{ant-prefix}-input-group-wrapper .@{ant-prefix}-input {\n      border-right-width: @border-width-base;\n      border-radius: 0;\n\n      &:hover {\n        z-index: 1;\n      }\n\n      &:focus {\n        z-index: 1;\n      }\n    }\n\n    & > .@{ant-prefix}-select-focused {\n      z-index: 1;\n    }\n\n    // update z-index for arrow icon\n    & > .@{ant-prefix}-select > .@{ant-prefix}-select-arrow {\n      z-index: 1; // https://github.com/ant-design/ant-design/issues/20371\n    }\n\n    & > *:first-child,\n    & > .@{ant-prefix}-select:first-child > .@{ant-prefix}-select-selector,\n    & > .@{ant-prefix}-select-auto-complete:first-child .@{ant-prefix}-input,\n    & > .@{ant-prefix}-cascader-picker:first-child .@{ant-prefix}-input {\n      border-top-left-radius: @border-radius-base;\n      border-bottom-left-radius: @border-radius-base;\n    }\n\n    & > *:last-child,\n    & > .@{ant-prefix}-select:last-child > .@{ant-prefix}-select-selector,\n    & > .@{ant-prefix}-cascader-picker:last-child .@{ant-prefix}-input,\n    & > .@{ant-prefix}-cascader-picker-focused:last-child .@{ant-prefix}-input {\n      border-right-width: @border-width-base;\n      border-top-right-radius: @border-radius-base;\n      border-bottom-right-radius: @border-radius-base;\n    }\n\n    // https://github.com/ant-design/ant-design/issues/12493\n    & > .@{ant-prefix}-select-auto-complete .@{ant-prefix}-input {\n      vertical-align: top;\n    }\n\n    .@{ant-prefix}-input-group-wrapper + .@{ant-prefix}-input-group-wrapper {\n      margin-left: -1px;\n      .@{ant-prefix}-input-affix-wrapper {\n        border-radius: 0;\n      }\n    }\n\n    .@{ant-prefix}-input-group-wrapper:not(:last-child) {\n      &.@{ant-prefix}-input-search > .@{ant-prefix}-input-group {\n        & > .@{ant-prefix}-input-group-addon > .@{ant-prefix}-input-search-button {\n          border-radius: 0;\n        }\n\n        & > .@{ant-prefix}-input {\n          border-radius: @border-radius-base 0 0 @border-radius-base;\n        }\n      }\n    }\n  }\n}\n","// Compatibility for browsers.\n\n// Placeholder text\n.placeholder(@color: @input-placeholder-color) {\n  // Firefox\n  &::-moz-placeholder {\n    opacity: 1; // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526\n  }\n\n  &::placeholder {\n    color: @color;\n  }\n\n  &:placeholder-shown {\n    text-overflow: ellipsis;\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n@import '../../input/style/mixin';\n\n@pagination-prefix-cls: ~'@{ant-prefix}-pagination';\n\n.@{pagination-prefix-cls}-rtl {\n  .@{pagination-prefix-cls}-total-text {\n    margin-right: 0;\n    margin-left: 8px;\n  }\n\n  .@{pagination-prefix-cls}-item,\n  .@{pagination-prefix-cls}-prev,\n  .@{pagination-prefix-cls}-jump-prev,\n  .@{pagination-prefix-cls}-jump-next {\n    margin-right: 0;\n    margin-left: 8px;\n  }\n\n  .@{pagination-prefix-cls}-slash {\n    margin: 0 5px 0 10px;\n  }\n\n  .@{pagination-prefix-cls}-options {\n    margin-right: 16px;\n    margin-left: 0;\n\n    .@{pagination-prefix-cls}-options-size-changer.@{ant-prefix}-select {\n      margin-right: 0;\n      margin-left: 8px;\n    }\n\n    .@{pagination-prefix-cls}-options-quick-jumper {\n      margin-left: 0;\n    }\n  }\n\n  &.@{pagination-prefix-cls}-simple {\n    .@{pagination-prefix-cls}-simple-pager {\n      margin-right: 0;\n      margin-left: 8px;\n\n      input {\n        margin-right: 0;\n        margin-left: 8px;\n      }\n    }\n  }\n\n  &.@{pagination-prefix-cls}.mini .@{pagination-prefix-cls}-options {\n    margin-right: 2px;\n    margin-left: 0;\n  }\n}\n","@import './antd';\n@import '../../node_modules/antd/lib/pagination/style/index.less';\n\n.pf-theme {\n  .ant-pagination {\n    &.ant-table-pagination {\n      float: none;\n      display: flex;\n      justify-content: center;\n      min-height: 44px;\n      padding: @space-xl @space-lg;\n    }\n\n    &-item {\n      &-active {\n        background-color: @primary-color;\n\n        a {\n          color: #ffffff;\n        }\n\n        &:focus,\n        &:hover {\n          a {\n            color: #ffffff;\n          }\n        }\n      }\n    }\n\n    .ant-pagination-total-text {\n      position: absolute;\n      bottom: 0;\n      font-size: @pf-font-size-sm;\n      margin: 0;\n    }\n  }\n}\n","@import './index';\n\n.table-size(@size, @padding-vertical, @padding-horizontal, @font-size) {\n  .@{table-prefix-cls}.@{table-prefix-cls}-@{size} {\n    font-size: @font-size;\n\n    .@{table-prefix-cls}-title,\n    .@{table-prefix-cls}-footer,\n    .@{table-prefix-cls}-thead > tr > th,\n    .@{table-prefix-cls}-tbody > tr > td,\n    tfoot > tr > th,\n    tfoot > tr > td {\n      padding: @padding-vertical @padding-horizontal;\n    }\n\n    .@{table-prefix-cls}-filter-trigger {\n      margin-right: -(@padding-horizontal / 2);\n    }\n\n    .@{table-prefix-cls}-expanded-row-fixed {\n      margin: -@padding-vertical -@padding-horizontal;\n    }\n\n    .@{table-prefix-cls}-tbody {\n      // ========================= Nest Table ===========================\n      .@{table-prefix-cls}-wrapper:only-child {\n        .@{table-prefix-cls} {\n          margin: -@padding-vertical -@padding-horizontal -@padding-vertical (@padding-horizontal +\n                ceil((@font-size-sm * 1.4)));\n        }\n      }\n    }\n  }\n}\n\n// ================================================================\n// =                            Middle                            =\n// ================================================================\n.table-size(~'middle', @table-padding-vertical-md, @table-padding-horizontal-md, @table-font-size-md);\n\n// ================================================================\n// =                            Small                             =\n// ================================================================\n.table-size(~'small', @table-padding-vertical-sm, @table-padding-horizontal-sm, @table-font-size-sm);\n\n.@{table-prefix-cls}-small {\n  .@{table-prefix-cls}-thead > tr > th {\n    background-color: @table-header-bg-sm;\n  }\n  .@{table-prefix-cls}-selection-column {\n    width: 46px;\n    min-width: 46px;\n  }\n}\n","@import './index';\n@import './size';\n\n@table-border: @border-width-base @border-style-base @table-border-color;\n\n.@{table-prefix-cls}.@{table-prefix-cls}-bordered {\n  // ============================ Title =============================\n  > .@{table-prefix-cls}-title {\n    border: @table-border;\n    border-bottom: 0;\n  }\n\n  > .@{table-prefix-cls}-container {\n    // ============================ Content ============================\n    border-left: @table-border;\n\n    > .@{table-prefix-cls}-content,\n    > .@{table-prefix-cls}-header,\n    > .@{table-prefix-cls}-body,\n    > .@{table-prefix-cls}-summary {\n      > table {\n        // ============================= Cell =============================\n        > thead > tr > th,\n        > tbody > tr > td,\n        > tfoot > tr > th,\n        > tfoot > tr > td {\n          border-right: @table-border;\n        }\n        // ============================ Header ============================\n        > thead {\n          > tr:not(:last-child) > th {\n            border-bottom: @border-width-base @border-style-base @table-border-color;\n          }\n\n          > tr > th {\n            &::before {\n              background-color: transparent !important;\n            }\n          }\n        }\n\n        // Fixed right should provides additional border\n        > thead > tr,\n        > tbody > tr,\n        > tfoot > tr {\n          > .@{table-prefix-cls}-cell-fix-right-first::after {\n            border-right: @table-border;\n          }\n        }\n      }\n\n      // ========================== Expandable ==========================\n      > table > tbody > tr > td {\n        > .@{table-prefix-cls}-expanded-row-fixed {\n          margin: -@table-padding-vertical (-@table-padding-horizontal - @border-width-base);\n\n          &::after {\n            position: absolute;\n            top: 0;\n            right: @border-width-base;\n            bottom: 0;\n            border-right: @table-border;\n            content: '';\n          }\n        }\n      }\n    }\n\n    > .@{table-prefix-cls}-content,\n    > .@{table-prefix-cls}-header {\n      > table {\n        border-top: @table-border;\n      }\n    }\n  }\n\n  &.@{table-prefix-cls}-scroll-horizontal {\n    > .@{table-prefix-cls}-container > .@{table-prefix-cls}-body {\n      > table > tbody {\n        > tr.@{table-prefix-cls}-expanded-row,\n        > tr.@{table-prefix-cls}-placeholder {\n          > td {\n            border-right: 0;\n          }\n        }\n      }\n    }\n  }\n\n  // Size related\n  &.@{table-prefix-cls}-middle {\n    > .@{table-prefix-cls}-container {\n      > .@{table-prefix-cls}-content,\n      > .@{table-prefix-cls}-body {\n        > table > tbody > tr > td {\n          > .@{table-prefix-cls}-expanded-row-fixed {\n            margin: -@table-padding-vertical-md (-@table-padding-horizontal-md - @border-width-base);\n          }\n        }\n      }\n    }\n  }\n\n  &.@{table-prefix-cls}-small {\n    > .@{table-prefix-cls}-container {\n      > .@{table-prefix-cls}-content,\n      > .@{table-prefix-cls}-body {\n        > table > tbody > tr > td {\n          > .@{table-prefix-cls}-expanded-row-fixed {\n            margin: -@table-padding-vertical-sm (-@table-padding-horizontal-sm - @border-width-base);\n          }\n        }\n      }\n    }\n  }\n\n  // ============================ Footer ============================\n  > .@{table-prefix-cls}-footer {\n    border: @table-border;\n    border-top: 0;\n  }\n}\n\n.@{table-prefix-cls}-cell {\n  // ============================ Nested ============================\n  .@{table-prefix-cls}-container:first-child {\n    // :first-child to avoid the case when bordered and title is set\n    border-top: 0;\n  }\n\n  &-scrollbar {\n    box-shadow: 0 @border-width-base 0 @border-width-base @table-header-bg;\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n@import './size';\n@import './bordered';\n\n@table-prefix-cls: ~'@{ant-prefix}-table';\n@dropdown-prefix-cls: ~'@{ant-prefix}-dropdown';\n@descriptions-prefix-cls: ~'@{ant-prefix}-descriptions';\n@table-header-icon-color: #bfbfbf;\n@table-header-icon-color-hover: darken(@table-header-icon-color, 10%);\n@table-sticky-zindex: (@zindex-table-fixed + 1);\n@table-sticky-scroll-bar-active-bg: fade(@table-sticky-scroll-bar-bg, 80%);\n\n.@{table-prefix-cls}-wrapper {\n  clear: both;\n  max-width: 100%;\n  .clearfix();\n}\n\n.@{table-prefix-cls} {\n  .reset-component();\n  position: relative;\n  font-size: @table-font-size;\n  background: @table-bg;\n  border-radius: @table-border-radius-base;\n\n  // https://github.com/ant-design/ant-design/issues/17611\n  table {\n    width: 100%;\n    text-align: left;\n    border-radius: @table-border-radius-base @table-border-radius-base 0 0;\n    border-collapse: separate;\n    border-spacing: 0;\n  }\n\n  // ============================= Cell =============================\n  &-thead > tr > th,\n  &-tbody > tr > td,\n  tfoot > tr > th,\n  tfoot > tr > td {\n    position: relative;\n    padding: @table-padding-vertical @table-padding-horizontal;\n    overflow-wrap: break-word;\n  }\n\n  &-cell-ellipsis {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    word-break: keep-all;\n\n    // Fixed first or last should special process\n    &.@{table-prefix-cls}-cell-fix-left-last,\n    &.@{table-prefix-cls}-cell-fix-right-first {\n      overflow: visible;\n\n      .@{table-prefix-cls}-cell-content {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n\n    .@{table-prefix-cls}-column-title {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n    }\n  }\n\n  // ============================ Title =============================\n  &-title {\n    padding: @table-padding-vertical @table-padding-horizontal;\n  }\n\n  // ============================ Footer ============================\n  &-footer {\n    padding: @table-padding-vertical @table-padding-horizontal;\n    color: @table-footer-color;\n    background: @table-footer-bg;\n  }\n\n  // ============================ Header ============================\n  &-thead {\n    > tr {\n      > th {\n        position: relative;\n        color: @table-header-color;\n        font-weight: 500;\n        text-align: left;\n        background: @table-header-bg;\n        border-bottom: @border-width-base @border-style-base @table-border-color;\n        transition: background 0.3s ease;\n\n        &[colspan]:not([colspan='1']) {\n          text-align: center;\n        }\n\n        &:not(:last-child):not(.@{table-prefix-cls}-selection-column):not(.@{table-prefix-cls}-row-expand-icon-cell):not([colspan])::before {\n          position: absolute;\n          top: 50%;\n          right: 0;\n          width: 1px;\n          height: 1.6em;\n          background-color: @table-header-cell-split-color;\n          transform: translateY(-50%);\n          transition: background-color 0.3s;\n          content: '';\n        }\n      }\n    }\n\n    > tr:not(:last-child) > th {\n      &[colspan] {\n        border-bottom: 0;\n      }\n    }\n  }\n\n  // ============================= Body =============================\n  &-tbody {\n    > tr {\n      > td {\n        border-bottom: @border-width-base @border-style-base @table-border-color;\n        transition: background 0.3s;\n\n        // ========================= Nest Table ===========================\n        > .@{table-prefix-cls}-wrapper:only-child,\n        > .@{table-prefix-cls}-expanded-row-fixed > .@{table-prefix-cls}-wrapper:only-child {\n          .@{table-prefix-cls} {\n            margin: -@table-padding-vertical -@table-padding-horizontal -@table-padding-vertical (@table-padding-horizontal +\n                  ceil(@font-size-sm * 1.4));\n\n            &-tbody > tr:last-child > td {\n              border-bottom: 0;\n\n              &:first-child,\n              &:last-child {\n                border-radius: 0;\n              }\n            }\n          }\n        }\n      }\n\n      &.@{table-prefix-cls}-row:hover {\n        > td {\n          background: @table-row-hover-bg;\n        }\n      }\n\n      &.@{table-prefix-cls}-row-selected {\n        > td {\n          background: @table-selected-row-bg;\n          border-color: rgba(0, 0, 0, 0.03);\n        }\n\n        &:hover {\n          > td {\n            background: @table-selected-row-hover-bg;\n          }\n        }\n      }\n    }\n  }\n\n  // =========================== Summary ============================\n  &-summary {\n    position: relative;\n    z-index: @zindex-table-fixed;\n    background: @table-bg;\n\n    div& {\n      box-shadow: 0 -@border-width-base 0 @table-border-color;\n    }\n\n    > tr {\n      > th,\n      > td {\n        border-bottom: @border-width-base @border-style-base @table-border-color;\n      }\n    }\n  }\n\n  // ========================== Pagination ==========================\n  &-pagination.@{ant-prefix}-pagination {\n    margin: 16px 0;\n  }\n\n  &-pagination {\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: @padding-xs;\n\n    > * {\n      flex: none;\n    }\n\n    &-left {\n      justify-content: flex-start;\n    }\n\n    &-center {\n      justify-content: center;\n    }\n\n    &-right {\n      justify-content: flex-end;\n    }\n  }\n\n  // ================================================================\n  // =                           Function                           =\n  // ================================================================\n\n  // ============================ Sorter ============================\n  &-thead th.@{table-prefix-cls}-column-has-sorters {\n    cursor: pointer;\n    transition: all 0.3s;\n\n    &:hover {\n      background: @table-header-sort-active-bg;\n\n      &::before {\n        background-color: transparent !important;\n      }\n    }\n\n    // https://github.com/ant-design/ant-design/issues/30969\n    &.@{table-prefix-cls}-cell-fix-left:hover,\n    &.@{table-prefix-cls}-cell-fix-right:hover {\n      background: @table-fixed-header-sort-active-bg;\n    }\n  }\n\n  &-thead th.@{table-prefix-cls}-column-sort {\n    background: @table-header-sort-bg;\n\n    &::before {\n      background-color: transparent !important;\n    }\n  }\n\n  td&-column-sort {\n    background: @table-body-sort-bg;\n  }\n\n  &-column-title {\n    position: relative;\n    z-index: 1;\n    flex: 1;\n  }\n\n  &-column-sorters {\n    display: flex;\n    flex: auto;\n    align-items: center;\n    justify-content: space-between;\n\n    &::after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      content: '';\n    }\n  }\n\n  &-column-sorter {\n    color: @table-header-icon-color;\n    font-size: 0;\n    transition: color 0.3s;\n\n    &-inner {\n      display: inline-flex;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    &-up,\n    &-down {\n      font-size: 11px;\n\n      &.active {\n        color: @primary-color;\n      }\n    }\n\n    &-up + &-down {\n      margin-top: -0.3em;\n    }\n  }\n\n  &-column-sorters:hover &-column-sorter {\n    color: darken(@table-header-icon-color, 10%);\n  }\n\n  // ============================ Filter ============================\n  &-filter-column {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &-filter-trigger {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin: -4px (-@table-padding-horizontal / 2) -4px 4px;\n    padding: 0 4px;\n    color: @table-header-icon-color;\n    font-size: @font-size-sm;\n    border-radius: @border-radius-base;\n    cursor: pointer;\n    transition: all 0.3s;\n\n    &:hover {\n      color: @text-color-secondary;\n      background: @table-header-filter-active-bg;\n    }\n\n    &.active {\n      color: @primary-color;\n    }\n  }\n\n  // Dropdown\n  &-filter-dropdown {\n    .reset-component();\n\n    // Reset menu\n    .@{dropdown-prefix-cls}-menu {\n      // https://github.com/ant-design/ant-design/issues/4916\n      // https://github.com/ant-design/ant-design/issues/19542\n      max-height: 264px;\n      overflow-x: hidden;\n      border: 0;\n      box-shadow: none;\n    }\n\n    min-width: 120px;\n    background-color: @table-filter-dropdown-bg;\n\n    border-radius: @border-radius-base;\n    box-shadow: @box-shadow-base;\n\n    &-submenu > ul {\n      max-height: calc(100vh - 130px);\n      overflow-x: hidden;\n      overflow-y: auto;\n    }\n\n    // Checkbox\n    &,\n    &-submenu {\n      .@{ant-prefix}-checkbox-wrapper + span {\n        padding-left: 8px;\n      }\n    }\n\n    // Operation\n    &-btns {\n      display: flex;\n      justify-content: space-between;\n      padding: 7px 8px 7px 3px;\n      overflow: hidden;\n      background-color: @table-filter-btns-bg;\n      border-top: @border-width-base @border-style-base @table-border-color;\n    }\n  }\n\n  // ========================== Selections ==========================\n  &-selection-col {\n    width: @table-selection-column-width;\n  }\n\n  &-bordered &-selection-col {\n    width: @table-selection-column-width + 18px;\n  }\n\n  table tr th&-selection-column,\n  table tr td&-selection-column {\n    padding-right: @padding-xs;\n    padding-left: @padding-xs;\n    text-align: center;\n\n    .@{ant-prefix}-radio-wrapper {\n      margin-right: 0;\n    }\n  }\n\n  table tr th&-selection-column::after {\n    background-color: transparent !important;\n  }\n\n  &-selection {\n    position: relative;\n    display: inline-flex;\n    flex-direction: column;\n\n    &-extra {\n      position: absolute;\n      top: 0;\n      z-index: 1;\n      cursor: pointer;\n      transition: all 0.3s;\n      margin-inline-start: 100%;\n      padding-inline-start: @padding-xss;\n\n      .@{iconfont-css-prefix} {\n        color: @table-header-icon-color;\n        font-size: 10px;\n\n        &:hover {\n          color: @table-header-icon-color-hover;\n        }\n      }\n    }\n  }\n\n  // ========================== Expandable ==========================\n  &-expand-icon-col {\n    width: 48px;\n  }\n\n  &-row-expand-icon-cell {\n    text-align: center;\n  }\n\n  &-row-indent {\n    float: left;\n    height: 1px;\n  }\n\n  &-row-expand-icon {\n    .operation-unit();\n    position: relative;\n    display: inline-flex;\n    float: left;\n    box-sizing: border-box;\n    width: @expand-icon-size;\n    height: @expand-icon-size;\n    padding: 0;\n    color: inherit;\n    line-height: ceil(((@font-size-sm * 1.4 - @border-width-base * 3) / 2)) * 2 + @border-width-base *\n      3;\n    background: @table-expand-icon-bg;\n    border: @border-width-base @border-style-base @table-border-color;\n    border-radius: @border-radius-base;\n    outline: none;\n    transform: scale((unit(@checkbox-size) / unit(@expand-icon-size)));\n    transition: all 0.3s;\n    user-select: none;\n    @expand-icon-size: ceil(((@font-size-sm * 1.4 - @border-width-base * 3) / 2)) * 2 +\n      @border-width-base * 3;\n\n    &:focus,\n    &:hover,\n    &:active {\n      border-color: currentColor;\n    }\n\n    &::before,\n    &::after {\n      position: absolute;\n      background: currentColor;\n      transition: transform 0.3s ease-out;\n      content: '';\n    }\n\n    &::before {\n      top: ceil(((@font-size-sm * 1.4 - @border-width-base * 3) / 2));\n      right: 3px;\n      left: 3px;\n      height: @border-width-base;\n    }\n\n    &::after {\n      top: 3px;\n      bottom: 3px;\n      left: ceil(((@font-size-sm * 1.4 - @border-width-base * 3) / 2));\n      width: @border-width-base;\n      transform: rotate(90deg);\n    }\n\n    // Motion effect\n    &-collapsed::before {\n      transform: rotate(-180deg);\n    }\n    &-collapsed::after {\n      transform: rotate(0deg);\n    }\n\n    &-spaced {\n      &::before,\n      &::after {\n        display: none;\n        content: none;\n      }\n      background: transparent;\n      border: 0;\n      visibility: hidden;\n    }\n\n    .@{table-prefix-cls}-row-indent + & {\n      margin-top: ((@font-size-base * @line-height-base - @border-width-base * 3) / 2) -\n        ceil(((@font-size-sm * 1.4 - @border-width-base * 3) / 2));\n      margin-right: @padding-xs;\n    }\n  }\n\n  tr&-expanded-row {\n    &,\n    &:hover {\n      > td {\n        background: @table-expanded-row-bg;\n      }\n    }\n\n    // https://github.com/ant-design/ant-design/issues/25573\n    .@{descriptions-prefix-cls}-view {\n      display: flex;\n\n      table {\n        flex: auto;\n        width: auto;\n      }\n    }\n  }\n\n  // With fixed\n  .@{table-prefix-cls}-expanded-row-fixed {\n    position: relative;\n    margin: -@table-padding-vertical -@table-padding-horizontal;\n    padding: @table-padding-vertical @table-padding-horizontal;\n  }\n\n  // ========================= Placeholder ==========================\n  &-tbody > tr&-placeholder {\n    text-align: center;\n    .@{table-prefix-cls}-empty & {\n      color: @disabled-color;\n    }\n    &:hover {\n      > td {\n        background: @component-background;\n      }\n    }\n  }\n\n  // ============================ Fixed =============================\n  &-cell-fix-left,\n  &-cell-fix-right {\n    position: -webkit-sticky !important;\n    position: sticky !important;\n    z-index: @zindex-table-fixed;\n    background: @table-bg;\n  }\n\n  &-cell-fix-left-first::after,\n  &-cell-fix-left-last::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: -1px;\n    width: 30px;\n    transform: translateX(100%);\n    transition: box-shadow 0.3s;\n    content: '';\n    pointer-events: none;\n  }\n\n  &-cell-fix-right-first::after,\n  &-cell-fix-right-last::after {\n    position: absolute;\n    top: 0;\n    bottom: -1px;\n    left: 0;\n    width: 30px;\n    transform: translateX(-100%);\n    transition: box-shadow 0.3s;\n    content: '';\n    pointer-events: none;\n  }\n\n  .@{table-prefix-cls}-container {\n    &::before,\n    &::after {\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      z-index: 1;\n      width: 30px;\n      transition: box-shadow 0.3s;\n      content: '';\n      pointer-events: none;\n    }\n\n    &::before {\n      left: 0;\n    }\n    &::after {\n      right: 0;\n    }\n  }\n\n  &-ping-left {\n    &:not(.@{table-prefix-cls}-has-fix-left) .@{table-prefix-cls}-container {\n      position: relative;\n\n      &::before {\n        box-shadow: inset 10px 0 8px -8px darken(@shadow-color, 5%);\n      }\n    }\n\n    .@{table-prefix-cls}-cell-fix-left-first::after,\n    .@{table-prefix-cls}-cell-fix-left-last::after {\n      box-shadow: inset 10px 0 8px -8px darken(@shadow-color, 5%);\n    }\n\n    .@{table-prefix-cls}-cell-fix-left-last::before {\n      background-color: transparent !important;\n    }\n  }\n\n  &-ping-right {\n    &:not(.@{table-prefix-cls}-has-fix-right) .@{table-prefix-cls}-container {\n      position: relative;\n\n      &::after {\n        box-shadow: inset -10px 0 8px -8px darken(@shadow-color, 5%);\n      }\n    }\n\n    .@{table-prefix-cls}-cell-fix-right-first::after,\n    .@{table-prefix-cls}-cell-fix-right-last::after {\n      box-shadow: inset -10px 0 8px -8px darken(@shadow-color, 5%);\n    }\n  }\n  &-sticky {\n    &-holder {\n      position: sticky;\n      z-index: @table-sticky-zindex;\n      background: @component-background;\n    }\n\n    &-scroll {\n      position: sticky;\n      bottom: 0;\n      z-index: @table-sticky-zindex;\n      display: flex;\n      align-items: center;\n      background: lighten(@table-border-color, 80%);\n      border-top: 1px solid @table-border-color;\n      opacity: 0.6;\n      &:hover {\n        transform-origin: center bottom;\n      }\n      &-bar {\n        height: 8px;\n        background-color: @table-sticky-scroll-bar-bg;\n        border-radius: @table-sticky-scroll-bar-radius;\n        &:hover {\n          background-color: @table-sticky-scroll-bar-active-bg;\n        }\n        &-active {\n          background-color: @table-sticky-scroll-bar-active-bg;\n        }\n      }\n    }\n  }\n}\n\n@media all and (-ms-high-contrast: none) {\n  .@{table-prefix-cls} {\n    &-ping-left {\n      .@{table-prefix-cls}-cell-fix-left-last::after {\n        box-shadow: none !important;\n      }\n    }\n    &-ping-right {\n      .@{table-prefix-cls}-cell-fix-right-first::after {\n        box-shadow: none !important;\n      }\n    }\n  }\n}\n\n@import './radius';\n@import './rtl';\n","@import '../../style/themes/default';\n\n.operation-unit() {\n  color: @link-color;\n  text-decoration: none;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n\n  &:focus,\n  &:hover {\n    color: @link-hover-color;\n  }\n\n  &:active {\n    color: @link-active-color;\n  }\n}\n","// ================================================================\n// =                         Border Radio                         =\n// ================================================================\n.@{table-prefix-cls} {\n  /* title + table */\n  &-title {\n    border-radius: @table-border-radius-base @table-border-radius-base 0 0;\n  }\n\n  &-title + &-container {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n\n    table > thead > tr:first-child {\n      th:first-child {\n        border-radius: 0;\n      }\n\n      th:last-child {\n        border-radius: 0;\n      }\n    }\n  }\n\n  /* table */\n  &-container {\n    border-top-left-radius: @table-border-radius-base;\n    border-top-right-radius: @table-border-radius-base;\n\n    table > thead > tr:first-child {\n      th:first-child {\n        border-top-left-radius: @table-border-radius-base;\n      }\n\n      th:last-child {\n        border-top-right-radius: @table-border-radius-base;\n      }\n    }\n  }\n\n  /* table + footer */\n  &-footer {\n    border-radius: 0 0 @table-border-radius-base @table-border-radius-base;\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@table-prefix-cls: ~'@{ant-prefix}-table';\n@table-wrapepr-cls: ~'@{table-prefix-cls}-wrapper';\n@table-wrapepr-rtl-cls: ~'@{table-prefix-cls}-wrapper-rtl';\n\n.@{table-prefix-cls}-wrapper {\n  &-rtl {\n    direction: rtl;\n  }\n}\n\n.@{table-prefix-cls} {\n  &-rtl {\n    direction: rtl;\n  }\n\n  table {\n    .@{table-wrapepr-rtl-cls} & {\n      text-align: right;\n    }\n  }\n\n  // ============================ Header ============================\n  &-thead {\n    > tr {\n      > th {\n        &[colspan]:not([colspan='1']) {\n          .@{table-wrapepr-rtl-cls} & {\n            text-align: center;\n          }\n        }\n\n        .@{table-wrapepr-rtl-cls} & {\n          text-align: right;\n        }\n      }\n    }\n  }\n\n  // ============================= Body =============================\n  &-tbody {\n    > tr {\n      // ========================= Nest Table ===========================\n      .@{table-prefix-cls}-wrapper:only-child {\n        .@{table-prefix-cls}.@{table-prefix-cls}-rtl {\n          margin: -@table-padding-vertical (@table-padding-horizontal + ceil(@font-size-sm * 1.4)) -@table-padding-vertical -@table-padding-horizontal;\n        }\n      }\n    }\n  }\n\n  // ========================== Pagination ==========================\n  &-pagination {\n    &-left {\n      .@{table-wrapepr-cls}.@{table-wrapepr-rtl-cls} & {\n        justify-content: flex-end;\n      }\n    }\n\n    &-right {\n      .@{table-wrapepr-cls}.@{table-wrapepr-rtl-cls} & {\n        justify-content: flex-start;\n      }\n    }\n  }\n\n  // ================================================================\n  // =                           Function                           =\n  // ================================================================\n\n  // ============================ Sorter ============================\n  &-column-sorter {\n    .@{table-wrapepr-rtl-cls} & {\n      margin-right: @padding-xs;\n      margin-left: 0;\n    }\n  }\n\n  // ============================ Filter ============================\n  &-filter-column-title {\n    .@{table-wrapepr-rtl-cls} & {\n      padding: @table-padding-vertical @table-padding-horizontal @table-padding-vertical 2.3em;\n    }\n  }\n\n  &-thead tr th.@{table-prefix-cls}-column-has-sorters {\n    .@{table-prefix-cls}-filter-column-title {\n      .@{table-prefix-cls}-rtl & {\n        padding: 0 0 0 2.3em;\n      }\n    }\n  }\n\n  &-filter-trigger-container {\n    .@{table-wrapepr-rtl-cls} & {\n      right: auto;\n      left: 0;\n    }\n  }\n\n  // Dropdown\n  &-filter-dropdown {\n    // Checkbox\n    &,\n    &-submenu {\n      .@{ant-prefix}-checkbox-wrapper + span {\n        .@{ant-prefix}-dropdown-rtl &,\n        .@{ant-prefix}-dropdown-menu-submenu-rtl& {\n          padding-right: 8px;\n          padding-left: 0;\n        }\n      }\n    }\n  }\n\n  // ========================== Selections ==========================\n  &-selection {\n    .@{table-wrapepr-rtl-cls} & {\n      text-align: center;\n    }\n  }\n\n  // ========================== Expandable ==========================\n  &-row-indent {\n    .@{table-wrapepr-rtl-cls} & {\n      float: right;\n    }\n  }\n\n  &-row-expand-icon {\n    .@{table-wrapepr-rtl-cls} & {\n      float: right;\n    }\n\n    .@{table-prefix-cls}-row-indent + & {\n      .@{table-wrapepr-rtl-cls} & {\n        margin-right: 0;\n        margin-left: @padding-xs;\n      }\n    }\n\n    &::after {\n      .@{table-wrapepr-rtl-cls} & {\n        transform: rotate(-90deg);\n      }\n    }\n\n    &-collapsed::before {\n      .@{table-wrapepr-rtl-cls} & {\n        transform: rotate(180deg);\n      }\n    }\n\n    &-collapsed::after {\n      .@{table-wrapepr-rtl-cls} & {\n        transform: rotate(0deg);\n      }\n    }\n  }\n}\n","@import './antd';\n@import './re-theme/typography';\n@import '../../node_modules/antd/lib/table/style/index.less';\n\n.pf-theme {\n  .ant-table-body-w-full {\n    .ant-table-body {\n      margin: 0 !important;\n    }\n  }\n\n  .ant-table-small-text {\n    td,\n    th {\n      font-size: @font-size-h5!important;\n    }\n  }\n  .ant-table-wrapper.without-hover .ant-table {\n    tr.ant-table-row > td {\n      background: unset;\n    }\n    tr.ant-table-row > td {\n      border-left: 0;\n    }\n\n    &:not(.ant-table-bordered) tr.ant-table-row > td {\n      border-left: 1px solid @gallery;\n    }\n    &:not(.ant-table-bordered) tr.ant-table-row:hover > td {\n      border-left: 1px solid @gallery;\n    }\n  }\n\n  .force-background-transparent .ant-table {\n    background: transparent !important;\n  }\n\n  .ant-table {\n    &-thead > tr > th {\n      border-right: 0;\n      font-weight: 700;\n      color: @table-header-color;\n      background-color: #eef3f7;\n\n      &:last-child {\n        border-right: 1px solid @gallery;\n      }\n    }\n\n    &-thead > tr,\n    &-tbody > tr {\n      &.@{table-prefix-cls}-row-hover,\n      & > td {\n        &:first-child {\n          border-left: 3px solid transparent;\n        }\n      }\n\n      &:hover {\n        & > td {\n          background: #ffffff;\n          &:first-child {\n            border-left-color: @primary-color;\n          }\n        }\n      }\n\n      &.no-hover-effects:hover {\n        & > td:first-child {\n          border-left-color: transparent;\n        }\n      }\n\n      &.active-row {\n        & > td {\n          background: lighten(@success-color, 40);\n          &:first-child {\n            border-left-color: @success-color;\n            font-weight: 700;\n          }\n        }\n\n        &:hover {\n          & > td {\n            &:first-child {\n              border-left-color: darken(@success-color, 10);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .ant-table-small {\n    font-size: @pf-font-size-sm;\n  }\n\n  .ant-loop-merge-table {\n    [data-testid='dropdown-actions'] {\n      display: flex !important;\n      align-items: center;\n      justify-content: center;\n      width: 16px;\n      min-width: 16px;\n      height: 16px;\n      line-height: 1;\n      padding: 0;\n      vertical-align: middle;\n    }\n\n    .ant-table-thead .ant-table-cell {\n      padding-top: 10px;\n      padding-bottom: 10px;\n    }\n\n    .ant-table-cell {\n      background-color: transparent !important;\n\n      &.ant-table-cell-fix-left,\n      &.ant-table-cell-fix-right {\n        background-color: @color-grey-3 !important;\n      }\n    }\n\n    .ant-table-bordered .ant-table-container {\n      border-radius: 8px;\n    }\n\n    .ant-table-bordered tbody tr:last-child td:first-child {\n      border-bottom-left-radius: 8px;\n    }\n\n    .ant-table-bordered tbody tr:last-child td:last-child {\n      border-bottom-right-radius: 8px;\n    }\n  }\n\n  .questionnaire-group.background-grey-1 {\n    .ant-loop-merge-table {\n      .ant-table-cell {\n        &.ant-table-cell-fix-left,\n        &.ant-table-cell-fix-right {\n          background-color: @color-grey-1 !important;\n        }\n      }\n    }\n  }\n}\n\n.results-question-table {\n  background-color: @color-grey-3;\n\n  .ant-table-thead\n    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)\n    > td,\n  .ant-table-tbody\n    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)\n    > td,\n  .ant-table-thead\n    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)\n    > td,\n  .ant-table-tbody\n    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)\n    > td {\n    background: unset;\n    border-left: 0;\n  }\n\n  tr > td:first-child {\n    border-right: 1px solid @color-grey-5;\n  }\n\n  .ant-table-thead {\n    background-color: white;\n  }\n  .ant-table-column-title {\n    color: @color-grey-8;\n    font-weight: 500;\n  }\n}\n\n.questionnaire-card {\n  .matrix-table-cells {\n    background-color: @color-grey-3!important;\n  }\n\n  &:hover .matrix-table-cells {\n    background-color: white !important;\n  }\n\n  .matrix-table-cells--active {\n    background-color: white !important;\n  }\n}\n\n.matrix-reorder-arrows {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.matrix-reorder-container:hover > .matrix-reorder-arrows {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.matrix-table-header-cell {\n  overflow: visible !important;\n}\n\n.matrix-table-header-cell:has(.drag-guide-left),\n.matrix-table-header-cell:has(.drag-guide-right) {\n  // Paint the drop line above adjacent sticky statement/actions columns.\n  z-index: 5 !important;\n}\n\nbody.is-dragging-matrix-column {\n  .ant-table-cell-fix-left,\n  .ant-table-cell-fix-right {\n    // Fixed columns sit over scale-point headers when the table is flush with\n    // the card. Let HTML5 DnD hit the droppable column underneath.\n    pointer-events: none;\n  }\n}\n\n.matrix-reorder-container {\n  overflow: visible;\n}\n",".ant-select:not(.ant-select-disabled) {\n  .ant-select-selector:focus {\n    .ant-select-selector-selected-value {\n      color: @select-selected-value-color;\n    }\n  }\n}\n.ant-select-search--inline {\n  .ant-select-search__field {\n    color: @color-grey-10;\n  }\n}\n\n.pf-theme {\n  .ant-dropdown-trigger {\n    border-color: @pf-color-dropdown-border;\n  }\n\n  .ant-dropdown-menu-item-active {\n    background-color: @radical-red;\n    a {\n      color: white;\n      transition: none;\n    }\n  }\n}\n\n.ant-select {\n  &:not(.ant-select-customize-input) {\n    .ant-select-selector {\n      border-radius: 4px;\n    }\n\n    &.ant-select-focused {\n      &:not(.ant-select-disabled) {\n        .ant-select-selector {\n          border-color: @color-grey-5;\n        }\n      }\n    }\n  }\n}\n\n.ant-select-arrow {\n  width: auto;\n  height: auto;\n  margin-top: -10px;\n}\n\n.ant-select-selection-placeholder {\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  left: 0;\n  max-width: 100%;\n  height: 20px;\n  // margin-top: -10px;\n  overflow: hidden;\n  color: #bfbfbf;\n  line-height: 20px;\n  white-space: nowrap;\n  text-align: left;\n  text-overflow: ellipsis;\n  transform: translateY(-50%);\n}\n\n.ant-select-single {\n  .ant-select-selector {\n    .ant-select-selection-placeholder {\n      line-height: 1.5;\n      padding-left: 11px;\n      // .ant-select-selection-item {\n    }\n\n    &::after {\n      content: none;\n    }\n  }\n\n  &:not(.ant-select-customize-input) {\n    .ant-select-selector {\n      padding: 0 20px 0 11px;\n    }\n  }\n\n  &.ant-select-lg {\n    &:not(.ant-select-customize-input) {\n      .ant-select-selector {\n        .ant-select-selection-placeholder {\n          line-height: 1.5;\n          color: @color-grey-9;\n        }\n      }\n    }\n  }\n}\n\n.pf-select {\n  @selectHeight: 40px;\n\n  &.ant-select {\n    &:not(.ant-select-customize-input) {\n      .ant-select-selector {\n        display: block;\n        box-sizing: border-box;\n        background-color: #fff;\n        border: 1px solid #d9d9d9;\n        border-top-width: 1.02px;\n        border-radius: 4px;\n        outline: none;\n        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n        user-select: none;\n      }\n    }\n\n    &.pf-select-grey-dark {\n      .ant-select-selector {\n        background-color: @color-grey-4;\n        color: @color-grey-9;\n        border: none;\n      }\n    }\n\n    &.ant-select-single {\n      &:not(.ant-select-customize-input) {\n        .ant-select-selector {\n          height: @selectHeight;\n          @boxShadow: none;\n          -webkit-box-shadow: @boxShadow !important;\n          -moz-box-shadow: @boxShadow!important;\n          box-shadow: @boxShadow!important;\n          border-color: @color-grey-5;\n        }\n      }\n\n      &.pf-select--short {\n        height: 32px !important;\n\n        .ant-select-selector,\n        .ant-select-selection-item {\n          padding: 0 5px 0 0;\n          height: 32px !important;\n          line-height: 32px !important;\n          color: @color-grey-10;\n        }\n\n        .ant-select-selector-selected-value {\n          padding-right: 10px;\n        }\n      }\n      &.pf-select--height-20 {\n        height: 20px !important;\n\n        .ant-select-selector,\n        .ant-select-selection-item {\n          padding: 0 5px 0 0;\n          height: 20px !important;\n          line-height: 20px !important;\n          color: @color-grey-10;\n        }\n\n        .ant-select-selector-selected-value {\n          padding-right: 10px;\n        }\n      }\n\n      &.pf-select-button-dropdown {\n        &:not(.ant-select-customize-input) .ant-select-selector {\n          background-color: @color-blue-6;\n          border: 0;\n        }\n\n        .ant-select-selection-placeholder {\n          color: white !important;\n          font-weight: bold;\n        }\n\n        .ant-select-selector-selected-value,\n        .ant-select-arrow {\n          color: white !important;\n        }\n      }\n    }\n\n    &.ant-select-disabled.ant-select-single,\n    &.ant-select-disabled {\n      .ant-select-selector {\n        border-color: @color-grey-5;\n        background-color: transparent;\n\n        .ant-select-selector-selected-value,\n        .ant-select-selection-item {\n          color: @color-grey-7 !important;\n        }\n      }\n\n      .ant-select-arrow {\n        color: @color-grey-7 !important;\n      }\n    }\n\n    #carry-forward-panel & {\n      &.ant-select-disabled.ant-select-single,\n      &.ant-select-disabled {\n        .ant-select-selector {\n          border-color: @color-grey-5 !important;\n          background-color: @color-grey-1 !important;\n        }\n      }\n    }\n  }\n\n  &:not(.pf-select-rule-operator)\n    .ant-select-selector\n    .ant-select-selector-selected-value {\n    color: @color-grey-10;\n  }\n\n  &:not(.ant-select-disabled)\n    .ant-select-selector:focus\n    .ant-select-selector-selected-value {\n    color: @color-grey-10;\n  }\n\n  &.pf-select--no-placeholder.ant-select-open\n    .ant-select-selector\n    .ant-select-selector-selected-value {\n    color: @color-grey-1!important;\n  }\n\n  &.pf-select--no-padded-arrow .ant-select-selection-item {\n    width: calc(100% - 45px);\n  }\n\n  &.pf-select--no-arrow {\n    .ant-select-selection-placeholder {\n      padding-right: 0;\n    }\n\n    .ant-select-arrow {\n      display: none;\n    }\n  }\n\n  &.pf-select--transparent {\n    &.ant-select-disabled .ant-select-selector {\n      background: transparent !important;\n    }\n  }\n\n  &.pf-select--green {\n    &.pf-select--highlighted.ant-select {\n      border-color: @color-grey-10 !important;\n      .ant-select-selection-item {\n        color: @color-grey-10 !important;\n      }\n\n      .ant-select-arrow {\n        color: @color-grey-10 !important;\n      }\n    }\n\n    .ant-select-selector {\n      color: @color-grey-10 !important;\n      background: @color-green-1b !important;\n      border: 0 !important;\n    }\n\n    .ant-select-selection-placeholder {\n      color: @color-grey-10!important;\n    }\n\n    ~ div .ant-select-item-option.ant-select-item-option-active {\n      background-color: @color-green-1!important;\n    }\n\n    .ant-select-selection-placeholder {\n      color: @color-grey-7!important;\n    }\n  }\n\n  &.pf-select--flex-dropdown + div {\n    .ant-select-dropdown {\n      width: initial !important;\n      max-width: 320px;\n      min-width: 120px;\n    }\n  }\n\n  .ant-select-selection-item {\n    line-height: @selectHeight;\n    padding-right: 30px;\n    font-weight: bold;\n  }\n\n  .ant-select-selector-selected-value {\n    padding-right: 30px;\n    font-weight: bold;\n\n    .pf-select--ellipsis-content {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  &.ant-select-single {\n    &.ant-select-open {\n      .ant-select-selection-item {\n        color: @color-grey-10;\n      }\n    }\n  }\n\n  &.pf-select--max-width {\n    max-width: 220px;\n  }\n\n  &.pf-select--small {\n    height: 30px;\n    font-size: 12px;\n\n    .ant-select-selection-item,\n    &.ant-select-single,\n    .ant-select-selector {\n      height: 30px !important;\n      line-height: 30px !important;\n    }\n\n    .ant-select-selector-selected-value {\n      padding-right: 10px;\n    }\n\n    .ant-select-arrow {\n      font-size: 16px;\n      margin-top: -7px;\n    }\n  }\n\n  .ant-select-arrow {\n    font-size: 18px;\n    margin-top: -9px;\n    color: @color-grey-10;\n  }\n\n  .ant-select-selection-item {\n    display: flex !important;\n    align-items: center;\n  }\n\n  &.selected-item-block {\n    .ant-select-selector-selected-value {\n      display: block !important;\n    }\n  }\n\n  &.pf-select--placeholder-grey-8 {\n    .ant-select-selection-placeholder {\n      color: @color-grey-8 !important;\n    }\n  }\n\n  &.pf-select--placeholder-grey-10 {\n    .ant-select-selection-placeholder {\n      color: @color-grey-10 !important;\n    }\n  }\n\n  &.pf-select--placeholder-grey-7 {\n    .ant-select-selection-placeholder {\n      color: @color-grey-7 !important;\n    }\n  }\n\n  .ant-select-selection-placeholder {\n    color: @color-grey-7!important;\n  }\n\n  &.pf-select--highlight-options {\n    .ant-select-dropdown\n      .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n      background: #ecf3fe !important;\n      border-radius: 4px;\n      margin: 0 4px;\n      padding-left: 8px; //to avoid text shift on hover\n      color: @color-blue-6;\n    }\n\n    .ant-select-dropdown {\n      border-radius: 12px;\n      padding-top: 8px;\n      padding-bottom: 8px;\n    }\n  }\n\n  &.pf-select--highlight-selected {\n    .ant-select-selection-item {\n      color: @color-blue-6;\n    }\n\n    .ant-select-arrow {\n      color: @color-blue-6!important;\n    }\n  }\n\n  &.pf-select-question-type {\n    .ant-select-item-option-content {\n      display: flex !important;\n      align-items: center !important;\n    }\n  }\n}\n\n.pf-select-border-grey-4 {\n  .ant-select-selector {\n    border-color: @color-grey-4;\n  }\n}\n\n.ant-select-item-option.ant-select-item-option-active {\n  background-color: @blue-1!important;\n}\n\n.pf-select-grey {\n  .ant-select-selector {\n    background-color: @color-grey-3;\n    color: @color-grey-9;\n    border: none;\n  }\n}\n\n.pf-select--borderless {\n  .ant-select-selector {\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .ant-select-selection-item {\n    margin-right: 8px !important;\n    margin-left: 0;\n  }\n  .ant-select-arrow {\n    right: -4px;\n  }\n}\n\n.pf-select--text-normal {\n  .ant-select-selector-selected-value {\n    font-weight: normal;\n  }\n}\n\n.pf-select-rule-operator {\n  &.pf-select.ant-select.ant-select-single.pf-select--short {\n    height: 34px;\n\n    .ant-select-selector {\n      background: transparent;\n      border: none !important;\n    }\n  }\n\n  .ant-select-arrow {\n    right: -1px;\n    top: 16px;\n  }\n\n  .ant-select-selection-item {\n    color: @color-grey-10;\n    font-weight: bold;\n    padding-right: 4px !important;\n    text-align: center;\n    display: block !important;\n    width: 100%;\n  }\n}\n\n.ant-select.pf-select-rule-operator:not(.ant-select-disabled),\n.ant-select.pf-select-inline-rule-operator:not(.ant-select-disabled) {\n  &:not(.pf-select--green) {\n    .ant-select-selector:focus .ant-select-selection-item {\n      color: @color-purple-6 !important;\n    }\n  }\n}\n\n.pf-select--highlighted.ant-select {\n  border-color: @color-purple-6 !important;\n  .ant-select-selection-item {\n    color: @color-purple-6 !important;\n  }\n\n  .ant-select-arrow {\n    color: @color-purple-6 !important;\n  }\n}\n\n.pf-select.ant-select-single.pf-select--short.pf-select-inline-rule-operator {\n  .ant-select-selector {\n    border-color: @color-grey-6;\n    padding: 0 5px 0 3px;\n  }\n\n  .ant-select-selection-item {\n    margin-right: 11px;\n    padding: 0 5px 0 3px;\n  }\n\n  .ant-select-arrow {\n    right: 3px;\n  }\n}\n\n.pf-select-button-dropdown-menu {\n  li {\n    height: 40px !important;\n    line-height: 32px !important;\n  }\n}\n\n.pf-select-option {\n  white-space: normal;\n}\n\n.pf-select-text-wrapper {\n  overflow: hidden;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ant-select-item-option-content {\n  flex: auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.pf-select-text {\n  white-space: nowrap;\n  overflow: hidden;\n  -ms-text-overflow: ellipsis;\n  text-overflow: ellipsis;\n}\n\n.ant-select.transparent-disable.ant-select-disabled,\n.ant-select.transparent-disable.ant-select-disabled:hover {\n  .ant-select-selector {\n    color: @color-grey-7;\n    background: transparent;\n  }\n}\n\n.pf-timepicker {\n  border-color: @color-grey-5!important;\n  -webkit-border-radius: 4px !important;\n  -moz-border-radius: 4px !important;\n  border-radius: 4px !important;\n  -webkit-box-shadow: none !important;\n  -moz-box-shadow: none !important;\n  box-shadow: none !important;\n\n  input {\n    height: 30px !important;\n    border-color: @color-grey-5!important;\n  }\n}\n\n.pf-datetimepicker {\n  -webkit-border-radius: 4px !important;\n  -moz-border-radius: 4px !important;\n  border-radius: 4px !important;\n  border-color: @color-grey-5!important;\n  -webkit-box-shadow: none !important;\n  -moz-box-shadow: none !important;\n  box-shadow: none !important;\n\n  input {\n    color: @color-grey-10;\n    font-weight: bold;\n    height: 40px;\n    line-height: 40px;\n    border-color: @color-grey-5;\n\n    &::placeholder {\n      color: @color-grey-7;\n      font-weight: normal;\n    }\n\n    &:hover {\n      border-color: @color-grey-5!important;\n    }\n  }\n\n  &.pf-datetimepicker-disabled {\n    .icon {\n      color: @color-grey-7!important;\n    }\n\n    .ant-time-picker-icon svg {\n      opacity: 0.2;\n    }\n\n    input {\n      color: @color-grey-7;\n      background-color: transparent;\n      border-color: @color-grey-3;\n    }\n  }\n}\n.ant-select-item-option.ant-select-item-option-selected {\n  background-color: transparent !important;\n}\n\n.ant-select-dropdown-menu--hidden {\n  display: none !important;\n}\n\n.link-settings-timepicker {\n  width: 120px;\n\n  .ant-time-picker-panel-input-wrap {\n    width: 120px !important;\n    max-width: initial !important;\n  }\n\n  .ant-time-picker-panel-select li {\n    padding-left: 20px !important;\n  }\n\n  .ant-time-picker-panel-select,\n  .ant-time-picker-panel-select ul,\n  .ant-time-picker-panel-select li {\n    width: 60px !important;\n  }\n}\n\n.link-settings-datepicker {\n  width: 100%;\n  .ant-picker-panel-container {\n    width: calc(100% - 48px);\n  }\n\n  .ant-picker-panel,\n  .ant-picker-date-panel,\n  .ant-picker-year-panel,\n  .ant-picker-month-panel,\n  .ant-picker-decade-panel,\n  .ant-picker-date-panel .ant-picker-content {\n    width: 100%;\n  }\n}\n\n.pf-select--tags {\n  .ant-select-selection__choice {\n    background-color: #d8e8fe !important;\n    padding-left: 16px;\n    padding-right: 32px;\n  }\n\n  .ant-select-selector,\n  .ant-select-open .ant-select-selector {\n    border-color: @color-grey-5;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n  }\n\n  .ant-select-selection__choice__content {\n    color: @color-grey-10!important;\n  }\n\n  .ant-select-selection__choice__remove {\n    color: @color-blue-6!important;\n    font-size: 14px !important;\n    padding-right: 5px;\n  }\n\n  .ant-select-selection-placeholder {\n    margin-left: 2px !important;\n    color: @color-grey-8;\n    // transform: none !important;\n  }\n\n  .ant-select-search__field {\n    color: @color-grey-10;\n    padding-left: 0 !important;\n    text-indent: 2px !important;\n    min-width: 25px !important;\n  }\n\n  .ant-select-selector--multiple .ant-select-selection-item {\n    margin-left: 8px !important;\n  }\n\n  .ant-select-selection__choice__remove {\n    width: 20px;\n    height: 100%;\n\n    i {\n      display: none;\n    }\n  }\n  .ant-select-selection__choice__remove:after {\n    content: '\\e5cd';\n    font-family: 'icomoon';\n    font-size: 18px;\n    display: block;\n    position: relative;\n    font-weight: normal;\n  }\n}\n\n.pf-range-datepicker {\n  .ant-picker-range {\n    visibility: hidden !important;\n    pointer-events: none;\n  }\n}\n\n.pf-select--multiple-values {\n  &.ant-select {\n    line-height: 27px;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  .ant-select-selector {\n    width: 100%;\n    height: 32px !important;\n    min-height: 32px !important;\n    overflow: hidden;\n  }\n\n  // keep the selected values on a single line and let them ellipsize\n  // instead of widening the select and scrolling the logic rule\n  .ant-select-selection-overflow {\n    flex-wrap: nowrap;\n    overflow: hidden;\n  }\n\n  .ant-select-selection-overflow-item {\n    min-width: 0;\n  }\n\n  .ant-select-selection-overflow-item-rest {\n    .ant-select-selection-item {\n      background-color: transparent !important;\n      line-height: 27px !important;\n      padding: 0px !important;\n      height: auto !important;\n      margin-left: 5px;\n    }\n\n    .ant-select-selection-item-content {\n      color: @color-grey-8;\n    }\n\n    .ant-select-selection-item-content::before {\n      content: '(';\n    }\n    .ant-select-selection-item-content::after {\n      content: ')';\n    }\n  }\n}\n","@import './antd';\n.pf-theme {\n  .ant-modal {\n    .ant-alert-default {\n      border-top: 0;\n    }\n\n    .ant-modal-header {\n      padding: @space-lg;\n    }\n\n    .ant-modal-title {\n      font-size: 24px;\n    }\n  }\n\n  .confirm-modal {\n    .ant-modal-content {\n      border-radius: 4px;\n      padding: 16px;\n    }\n\n    .ant-modal-header {\n      border-bottom: 0;\n      padding: 0;\n    }\n\n    .ant-modal-body {\n      padding: 0;\n    }\n\n    .ant-modal-footer {\n      border-top: 0;\n      padding: 0;\n    }\n\n    .ant-modal-close {\n      margin-right: 8px;\n      margin-top: 4px;\n    }\n\n    .ant-modal-footer {\n      margin-top: 24px;\n    }\n  }\n\n  @media only screen and (max-width: 992px) {\n    .ant-modal {\n      width: auto !important;\n      margin: 10px !important;\n    }\n    .ant-modal.terms-modal {\n      width: calc(100vw - 20px) !important;\n      margin: 10px !important;\n    }\n  }\n\n  .modal-no-footer-border {\n    .ant-modal-footer {\n      border: 0;\n    }\n  }\n\n  .modal-cancel-btn {\n    color: @color-grey-10;\n    border-color: @color-grey-6;\n\n    &:hover {\n      color: @color-grey-10!important;\n      border-color: @color-grey-6!important;\n    }\n  }\n\n  .ant-modal-close-x {\n    width: 30px !important;\n    padding-top: 8px !important;\n    height: 30px !important;\n  }\n\n  .ant-modal {\n    &.fullscreen {\n      width: 100vw;\n      height: 100vh;\n      padding: 0;\n      margin: 0;\n      top: 0;\n\n      .ant-modal-content {\n        width: 100%;\n        height: 100%;\n        padding: 0;\n      }\n      .ant-modal-body {\n        padding: 0;\n      }\n    }\n  }\n\n  .ant-modal-border-radius-level-3 {\n    border-radius: 12px;\n    overflow: hidden;\n\n    .ant-modal-body {\n      border-radius: 12px;\n      overflow: hidden;\n    }\n  }\n\n  .ant-modal-no-padding {\n    .ant-modal-content {\n      padding: 0;\n    }\n  }\n}\n\n.add-question-modal {\n  .ant-modal-content {\n    padding: 20px 16px !important;\n    border-radius: 8px;\n  }\n\n  .ant-modal-close {\n    position: absolute;\n    right: 14px;\n    top: 13px;\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@popover-prefix-cls: ~'@{ant-prefix}-popover';\n\n@popover-arrow-rotate-width: sqrt(@popover-arrow-width * @popover-arrow-width * 2);\n\n@popover-arrow-offset-vertical: 12px;\n@popover-arrow-offset-horizontal: 16px;\n\n.@{popover-prefix-cls} {\n  .reset-component();\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: @zindex-popover;\n  font-weight: normal;\n  white-space: normal;\n  text-align: left;\n  cursor: auto;\n  user-select: text;\n\n  &::after {\n    position: absolute;\n    background: fade(@white, 1%);\n    content: '';\n  }\n\n  &-hidden {\n    display: none;\n  }\n\n  // Offset the popover to account for the popover arrow\n  &-placement-top,\n  &-placement-topLeft,\n  &-placement-topRight {\n    padding-bottom: @popover-distance;\n  }\n\n  &-placement-right,\n  &-placement-rightTop,\n  &-placement-rightBottom {\n    padding-left: @popover-distance;\n  }\n\n  &-placement-bottom,\n  &-placement-bottomLeft,\n  &-placement-bottomRight {\n    padding-top: @popover-distance;\n  }\n\n  &-placement-left,\n  &-placement-leftTop,\n  &-placement-leftBottom {\n    padding-right: @popover-distance;\n  }\n\n  &-inner {\n    background-color: @popover-bg;\n    background-clip: padding-box;\n    border-radius: @border-radius-base;\n    box-shadow: @box-shadow-base;\n    box-shadow: ~'0 0 8px @{shadow-color} \\9';\n  }\n\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    /* IE10+ */\n    &-inner {\n      box-shadow: @box-shadow-base;\n    }\n  }\n\n  &-title {\n    min-width: @popover-min-width;\n    min-height: @popover-min-height;\n    margin: 0; // reset heading margin\n    padding: 5px @popover-padding-horizontal 4px;\n    color: @heading-color;\n    font-weight: 500;\n    border-bottom: 1px solid @border-color-split;\n  }\n\n  &-inner-content {\n    padding: @padding-sm @popover-padding-horizontal;\n    color: @popover-color;\n  }\n\n  &-message {\n    position: relative;\n    padding: 4px 0 12px;\n    color: @popover-color;\n    font-size: @font-size-base;\n    > .@{iconfont-css-prefix} {\n      position: absolute;\n      top: (\n        4px + ((@line-height-base * @font-size-base - @font-size-base) / 2)\n      ); // 4px for padding-top, 4px for vertical middle\n      color: @warning-color;\n      font-size: @font-size-base;\n    }\n    &-title {\n      padding-left: @font-size-base + 8px;\n    }\n  }\n\n  &-buttons {\n    margin-bottom: 4px;\n    text-align: right;\n\n    button {\n      margin-left: 8px;\n    }\n  }\n\n  // Arrows\n  &-arrow {\n    position: absolute;\n    display: block;\n    width: @popover-arrow-rotate-width;\n    height: @popover-arrow-rotate-width;\n    overflow: hidden;\n    background: transparent;\n    pointer-events: none;\n\n    &-content {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      width: @popover-arrow-width;\n      height: @popover-arrow-width;\n      margin: auto;\n      background-color: @popover-bg;\n      content: '';\n      pointer-events: auto;\n    }\n  }\n\n  &-placement-top &-arrow,\n  &-placement-topLeft &-arrow,\n  &-placement-topRight &-arrow {\n    bottom: @popover-distance - @popover-arrow-rotate-width;\n\n    &-content {\n      box-shadow: 3px 3px 7px fade(@black, 7%);\n      transform: translateY((-@popover-arrow-rotate-width / 2)) rotate(45deg);\n    }\n  }\n  &-placement-top &-arrow {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &-placement-topLeft &-arrow {\n    left: @popover-arrow-offset-horizontal;\n  }\n\n  &-placement-topRight &-arrow {\n    right: @popover-arrow-offset-horizontal;\n  }\n\n  &-placement-right &-arrow,\n  &-placement-rightTop &-arrow,\n  &-placement-rightBottom &-arrow {\n    left: @popover-distance - @popover-arrow-rotate-width;\n\n    &-content {\n      box-shadow: -3px 3px 7px fade(@black, 7%);\n      transform: translateX((@popover-arrow-rotate-width / 2)) rotate(45deg);\n    }\n  }\n  &-placement-right &-arrow {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  &-placement-rightTop &-arrow {\n    top: @popover-arrow-offset-vertical;\n  }\n  &-placement-rightBottom &-arrow {\n    bottom: @popover-arrow-offset-vertical;\n  }\n\n  &-placement-bottom &-arrow,\n  &-placement-bottomLeft &-arrow,\n  &-placement-bottomRight &-arrow {\n    top: @popover-distance - @popover-arrow-rotate-width;\n\n    &-content {\n      box-shadow: -2px -2px 5px fade(@black, 6%);\n      transform: translateY((@popover-arrow-rotate-width / 2)) rotate(45deg);\n    }\n  }\n\n  &-placement-bottom &-arrow {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &-placement-bottomLeft &-arrow {\n    left: @popover-arrow-offset-horizontal;\n  }\n\n  &-placement-bottomRight &-arrow {\n    right: @popover-arrow-offset-horizontal;\n  }\n\n  &-placement-left &-arrow,\n  &-placement-leftTop &-arrow,\n  &-placement-leftBottom &-arrow {\n    right: @popover-distance - @popover-arrow-rotate-width;\n\n    &-content {\n      box-shadow: 3px -3px 7px fade(@black, 7%);\n      transform: translateX((-@popover-arrow-rotate-width / 2)) rotate(45deg);\n    }\n  }\n\n  &-placement-left &-arrow {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &-placement-leftTop &-arrow {\n    top: @popover-arrow-offset-vertical;\n  }\n\n  &-placement-leftBottom &-arrow {\n    bottom: @popover-arrow-offset-vertical;\n  }\n}\n\n.generator-popover-preset-color(@i: length(@preset-colors)) when (@i > 0) {\n  .generator-popover-preset-color(@i - 1);\n  @color: extract(@preset-colors, @i);\n  @lightColor: '@{color}-6';\n  .@{popover-prefix-cls}-@{color} {\n    .@{popover-prefix-cls}-inner {\n      background-color: @@lightColor;\n    }\n    .@{popover-prefix-cls}-arrow {\n      &-content {\n        background-color: @@lightColor;\n      }\n    }\n  }\n}\n.generator-popover-preset-color();\n\n@import './rtl';\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@popover-prefix-cls: ~'@{ant-prefix}-popover';\n\n.@{popover-prefix-cls} {\n  &-rtl {\n    direction: rtl;\n    text-align: right;\n  }\n\n  &-message {\n    &-title {\n      .@{popover-prefix-cls}-rtl & {\n        padding-right: @font-size-base + 8px;\n        padding-left: @padding-md;\n      }\n    }\n  }\n\n  &-buttons {\n    .@{popover-prefix-cls}-rtl & {\n      text-align: left;\n    }\n\n    button {\n      .@{popover-prefix-cls}-rtl & {\n        margin-right: 8px;\n        margin-left: 0;\n      }\n    }\n  }\n}\n","@import './antd';\n@import '../../node_modules/antd/lib/popover/style/index.less';\n\n.pf-theme {\n\n  .ant-tooltip {\n    max-width: 300px;\n  }\n\n  .ant-popover {\n    &-inner-content {\n      color: @popover-color;\n      font-size: @popover-inner-content-font-size;\n    }\n\n    &-message {\n      &-title {\n        padding-left: 0;\n      }\n\n      > .anticon {\n        display: none;\n      }\n    }\n  }\n\n  .ant-popover:not(.original-padding) {\n    .ant-popover-inner-content {\n      padding: @popover-inner-content-padding;\n    }\n  }\n\n  .ant-popover-buttons {\n    text-align: justify;\n    .ant-btn {\n      width: 45%;\n      display: inline-block;\n    }\n  }\n\n  .overlay-sm.ant-popover {\n    .ant-popover-inner-content {\n      padding: @space-sm @space-sm;\n      line-height: 1;\n    }\n  }\n}\n\n.tooltip-with-big-arrow {\n\n  .ant-tooltip-arrow {\n    width: 17px;\n    height: 22px;\n  }\n\n  .ant-tooltip-arrow-content {\n    width: 22px;\n    height: 22px;\n    border-radius: 3px;\n  }\n}\n\n.tooltip-translations-upgrade {\n\n  .ant-tooltip-arrow {\n    z-index: 100;\n  }\n\n  &.ant-tooltip-placement-right .ant-tooltip-arrow {\n    left: -16px!important;\n  }\n\n  .ant-tooltip-arrow-content {\n    box-shadow: none;\n  }\n\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@spin-prefix-cls: ~'@{ant-prefix}-spin';\n@spin-dot-default: @text-color-secondary;\n\n.@{spin-prefix-cls} {\n  .reset-component();\n\n  position: absolute;\n  display: none;\n  color: @primary-color;\n  text-align: center;\n  vertical-align: middle;\n  opacity: 0;\n  transition: transform 0.3s @ease-in-out-circ;\n\n  &-spinning {\n    position: static;\n    display: inline-block;\n    opacity: 1;\n  }\n\n  &-nested-loading {\n    position: relative;\n    > div > .@{spin-prefix-cls} {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 4;\n      display: block;\n      width: 100%;\n      height: 100%;\n      max-height: 400px;\n      .@{spin-prefix-cls}-dot {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin: -(@spin-dot-size / 2);\n      }\n      .@{spin-prefix-cls}-text {\n        position: absolute;\n        top: 50%;\n        width: 100%;\n        padding-top: ((@spin-dot-size - @font-size-base) / 2) + 2px;\n        text-shadow: 0 1px 2px @shadow-color-inverse;\n      }\n      &.@{spin-prefix-cls}-show-text .@{spin-prefix-cls}-dot {\n        margin-top: -(@spin-dot-size / 2) - 10px;\n      }\n    }\n\n    > div > .@{spin-prefix-cls}-sm {\n      .@{spin-prefix-cls}-dot {\n        margin: -(@spin-dot-size-sm / 2);\n      }\n      .@{spin-prefix-cls}-text {\n        padding-top: ((@spin-dot-size-sm - @font-size-base) / 2) + 2px;\n      }\n      &.@{spin-prefix-cls}-show-text .@{spin-prefix-cls}-dot {\n        margin-top: -(@spin-dot-size-sm / 2) - 10px;\n      }\n    }\n\n    > div > .@{spin-prefix-cls}-lg {\n      .@{spin-prefix-cls}-dot {\n        margin: -(@spin-dot-size-lg / 2);\n      }\n      .@{spin-prefix-cls}-text {\n        padding-top: ((@spin-dot-size-lg - @font-size-base) / 2) + 2px;\n      }\n      &.@{spin-prefix-cls}-show-text .@{spin-prefix-cls}-dot {\n        margin-top: -(@spin-dot-size-lg / 2) - 10px;\n      }\n    }\n  }\n\n  &-container {\n    position: relative;\n    transition: opacity 0.3s;\n\n    &::after {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 10;\n      display: ~'none \\9';\n      width: 100%;\n      height: 100%;\n      background: @component-background;\n      opacity: 0;\n      transition: all 0.3s;\n      content: '';\n      pointer-events: none;\n    }\n  }\n\n  &-blur {\n    clear: both;\n    overflow: hidden;\n    opacity: 0.5;\n    user-select: none;\n    pointer-events: none;\n\n    &::after {\n      opacity: 0.4;\n      pointer-events: auto;\n    }\n  }\n\n  // tip\n  // ------------------------------\n  &-tip {\n    color: @spin-dot-default;\n  }\n\n  // dots\n  // ------------------------------\n\n  &-dot {\n    position: relative;\n    display: inline-block;\n    font-size: @spin-dot-size;\n\n    .square(1em);\n\n    &-item {\n      position: absolute;\n      display: block;\n      width: 9px;\n      height: 9px;\n      background-color: @primary-color;\n      border-radius: 100%;\n      transform: scale(0.75);\n      transform-origin: 50% 50%;\n      opacity: 0.3;\n      animation: antSpinMove 1s infinite linear alternate;\n\n      &:nth-child(1) {\n        top: 0;\n        left: 0;\n      }\n      &:nth-child(2) {\n        top: 0;\n        right: 0;\n        animation-delay: 0.4s;\n      }\n      &:nth-child(3) {\n        right: 0;\n        bottom: 0;\n        animation-delay: 0.8s;\n      }\n      &:nth-child(4) {\n        bottom: 0;\n        left: 0;\n        animation-delay: 1.2s;\n      }\n    }\n\n    &-spin {\n      transform: rotate(45deg);\n      animation: antRotate 1.2s infinite linear;\n    }\n  }\n\n  // Sizes\n  // ------------------------------\n\n  // small\n  &-sm &-dot {\n    font-size: @spin-dot-size-sm;\n\n    i {\n      width: 6px;\n      height: 6px;\n    }\n  }\n\n  // large\n  &-lg &-dot {\n    font-size: @spin-dot-size-lg;\n\n    i {\n      width: 14px;\n      height: 14px;\n    }\n  }\n\n  &&-show-text &-text {\n    display: block;\n  }\n}\n\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /* IE10+ */\n  .@{spin-prefix-cls}-blur {\n    background: @component-background;\n    opacity: 0.5;\n  }\n}\n\n@keyframes antSpinMove {\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes antRotate {\n  to {\n    transform: rotate(405deg);\n  }\n}\n\n@import './rtl';\n",".@{spin-prefix-cls} {\n  &-rtl {\n    direction: rtl;\n  }\n\n  &-dot {\n    &-spin {\n      .@{spin-prefix-cls}-rtl & {\n        transform: rotate(-45deg);\n        animation-name: antRotateRtl;\n      }\n    }\n  }\n}\n\n@keyframes antRotateRtl {\n  to {\n    transform: rotate(-405deg);\n  }\n}\n","@import './antd';\n@import '../../node_modules/antd/lib/spin/style/index.less';\n\n.ant-spin-mixin() {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height: auto;\n}\n.pf-theme {\n  .ant-spin.center {\n    .ant-spin-mixin;\n    &-blur {\n      opacity: @spin-blur-opacity;\n    }\n  }\n\n  .ant-spin-nested-loading {\n    .ant-spin {\n      .ant-spin-mixin;\n    }\n  }\n}\n\n\n.pficon-spin {\n  animation-name: spin;\n  animation-duration: 1250ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n\n@keyframes spin {\n  from {\n      transform:rotate(0deg);\n  }\n  to {\n      transform:rotate(360deg);\n  }\n}\n",".pf-theme {\n  .list-item {\n    transition: 300ms;\n    position: relative;\n    border-radius: 4px;\n    border: 1px solid @athens-gray;\n    padding: @space-lg;\n    overflow: hidden;\n    opacity: 0.7;\n\n    &:before {\n      position: absolute;\n      left: 0;\n      top: 0;\n      content: '';\n      display: block;\n      width: @border-width-list-item;\n      height: 100%;\n      background-color: @athens-gray;\n      transition: 300ms;\n    }\n\n    &.list-item--selectable {\n      cursor: pointer;\n    }\n\n    &.list-item--active {\n      opacity: 1;\n    }\n\n    &.list-item--active:not(.list-item--selected) {\n      &:hover {\n        border: 1px solid @primary-color;\n        &:before {\n          background-color: @primary-color;\n        }\n      }\n    }\n\n    &.list-item--selected.list-item--selectable {\n      color: #fff;\n      box-shadow: 0 5px 10px 0\n        rgba(\n          red(@primary-color),\n          green(@primary-color),\n          blue(@primary-color),\n          0.3\n        );\n      background-color: @primary-color;\n      border-color: @primary-color;\n      &:before {\n        background-color: @primary-color;\n      }\n    }\n\n    &.list-item--disabled {\n      background-color: @gallery;\n    }\n  }\n\n  .narrow-table {\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      padding: 4px 16px;\n    }\n  }\n\n  .border-grey-4 {\n    .ant-list-item {\n      border-color: @color-grey-4;\n    }\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@upload-prefix-cls: ~'@{ant-prefix}-upload';\n@upload-item: ~'@{ant-prefix}-upload-list-item';\n@upload-picture-card-size: 104px;\n@upload-picture-card-border-style: @border-style-base;\n\n.@{upload-prefix-cls} {\n  .reset-component();\n\n  outline: 0;\n\n  p {\n    margin: 0;\n  }\n\n  &-btn {\n    display: block;\n    width: 100%;\n    outline: none;\n  }\n\n  input[type='file'] {\n    cursor: pointer;\n  }\n\n  &&-select {\n    display: inline-block;\n  }\n\n  &&-disabled {\n    cursor: not-allowed;\n  }\n\n  &&-select-picture-card {\n    width: @upload-picture-card-size;\n    height: @upload-picture-card-size;\n    margin-right: 8px;\n    margin-bottom: 8px;\n    text-align: center;\n    vertical-align: top;\n    background-color: @background-color-light;\n    border: @border-width-base dashed @border-color-base;\n    border-radius: @border-radius-base;\n    cursor: pointer;\n    transition: border-color 0.3s;\n\n    > .@{upload-prefix-cls} {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 100%;\n      text-align: center;\n    }\n\n    &:hover {\n      border-color: @primary-color;\n      .@{upload-prefix-cls}-disabled& {\n        border-color: @border-color-base;\n      }\n    }\n  }\n\n  &&-drag {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    background: @background-color-light;\n    border: @border-width-base dashed @border-color-base;\n    border-radius: @border-radius-base;\n    cursor: pointer;\n    transition: border-color 0.3s;\n\n    .@{upload-prefix-cls} {\n      padding: @padding-md 0;\n    }\n\n    &.@{upload-prefix-cls}-drag-hover:not(.@{upload-prefix-cls}-disabled) {\n      border-color: @primary-7;\n    }\n\n    &.@{upload-prefix-cls}-disabled {\n      cursor: not-allowed;\n    }\n\n    .@{upload-prefix-cls}-btn {\n      display: table;\n      height: 100%;\n    }\n\n    .@{upload-prefix-cls}-drag-container {\n      display: table-cell;\n      vertical-align: middle;\n    }\n\n    &:not(.@{upload-prefix-cls}-disabled):hover {\n      border-color: @primary-5;\n    }\n\n    p.@{upload-prefix-cls}-drag-icon {\n      .@{iconfont-css-prefix} {\n        color: @primary-5;\n        font-size: 48px;\n      }\n\n      margin-bottom: 20px;\n    }\n    p.@{upload-prefix-cls}-text {\n      margin: 0 0 4px;\n      color: @heading-color;\n      font-size: @font-size-lg;\n    }\n    p.@{upload-prefix-cls}-hint {\n      color: @text-color-secondary;\n      font-size: @font-size-base;\n    }\n\n    .@{iconfont-css-prefix}-plus {\n      color: @disabled-color;\n      font-size: 30px;\n      transition: all 0.3s;\n      &:hover {\n        color: @text-color-secondary;\n      }\n    }\n    &:hover .@{iconfont-css-prefix}-plus {\n      color: @text-color-secondary;\n    }\n  }\n\n  &-picture-card-wrapper {\n    .clearfix();\n\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.@{upload-prefix-cls}-list {\n  .reset-component();\n  .clearfix();\n  line-height: @line-height-base;\n\n  // ============================ Item ============================\n  &-item {\n    position: relative;\n    height: @line-height-base * @font-size-base;\n    margin-top: @margin-xs;\n    font-size: @font-size-base;\n    &-name {\n      display: inline-block;\n      width: 100%;\n      padding-left: @font-size-base + 8px;\n      overflow: hidden;\n      line-height: @line-height-base;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    &-card-actions {\n      position: absolute;\n      right: 0;\n\n      &-btn {\n        opacity: 0;\n      }\n      &-btn.@{ant-prefix}-btn-sm {\n        height: 20px;\n        line-height: 1;\n      }\n\n      &.picture {\n        top: 22px;\n        line-height: 0;\n      }\n\n      &-btn:focus,\n      &.picture &-btn {\n        opacity: 1;\n      }\n\n      .@{iconfont-css-prefix} {\n        color: @upload-actions-color;\n      }\n    }\n\n    &-info {\n      height: 100%;\n      padding: 0 4px;\n      transition: background-color 0.3s;\n\n      > span {\n        display: block;\n        width: 100%;\n        height: 100%;\n      }\n\n      .@{iconfont-css-prefix}-loading,\n      .@{upload-prefix-cls}-text-icon {\n        .@{iconfont-css-prefix} {\n          position: absolute;\n          top: (@font-size-base / 2) - 2px;\n          color: @text-color-secondary;\n          font-size: @font-size-base;\n        }\n      }\n    }\n\n    .@{iconfont-css-prefix}-close {\n      position: absolute;\n      top: 6px;\n      right: 4px;\n      color: @text-color-secondary;\n      font-size: 10px;\n      line-height: 0;\n      cursor: pointer;\n      opacity: 0;\n      transition: all 0.3s;\n\n      &:hover {\n        color: @text-color;\n      }\n    }\n\n    &:hover &-info {\n      background-color: @item-hover-bg;\n    }\n\n    &:hover .@{iconfont-css-prefix}-close {\n      opacity: 1;\n    }\n\n    &:hover &-card-actions-btn {\n      opacity: 1;\n    }\n\n    &-error,\n    &-error .@{upload-prefix-cls}-text-icon > .@{iconfont-css-prefix},\n    &-error &-name {\n      color: @error-color;\n    }\n\n    &-error &-card-actions {\n      .@{iconfont-css-prefix} {\n        color: @error-color;\n      }\n      &-btn {\n        opacity: 1;\n      }\n    }\n\n    &-progress {\n      position: absolute;\n      bottom: -12px;\n      width: 100%;\n      padding-left: @font-size-base + 12px;\n      font-size: @font-size-base;\n      line-height: 0;\n    }\n  }\n\n  // =================== Picture & Picture Card ===================\n  &-picture,\n  &-picture-card {\n    .@{upload-item} {\n      position: relative;\n      height: 66px;\n      padding: @padding-xs;\n      border: @border-width-base @upload-picture-card-border-style @border-color-base;\n      border-radius: @border-radius-base;\n\n      &:hover {\n        background: transparent;\n      }\n\n      &-error {\n        border-color: @error-color;\n      }\n    }\n\n    .@{upload-item}-info {\n      padding: 0;\n    }\n\n    .@{upload-item}:hover .@{upload-item}-info {\n      background: transparent;\n    }\n\n    .@{upload-item}-uploading {\n      border-style: dashed;\n    }\n\n    .@{upload-item}-thumbnail {\n      width: 48px;\n      height: 48px;\n      line-height: 54px;\n      text-align: center;\n      opacity: 0.8;\n\n      .@{iconfont-css-prefix} {\n        font-size: 26px;\n      }\n    }\n\n    // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160\n    .@{upload-item}-error .@{upload-item}-thumbnail {\n      .@{iconfont-css-prefix} {\n        svg path {\n          &[fill='#e6f7ff'] {\n            fill: color(~`colorPalette('@{error-color}', 1) `);\n          }\n\n          &[fill='#1890ff'] {\n            fill: @error-color;\n          }\n        }\n      }\n    }\n\n    .@{upload-item}-icon {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      font-size: 26px;\n      transform: translate(-50%, -50%);\n\n      .@{iconfont-css-prefix} {\n        font-size: 26px;\n      }\n    }\n\n    .@{upload-item}-image {\n      max-width: 100%;\n    }\n\n    .@{upload-item}-thumbnail img {\n      display: block;\n      width: 48px;\n      height: 48px;\n      overflow: hidden;\n    }\n\n    .@{upload-item}-name {\n      display: inline-block;\n      box-sizing: border-box;\n      max-width: 100%;\n      margin: 0 0 0 8px;\n      padding-right: 8px;\n      padding-left: 48px;\n      overflow: hidden;\n      line-height: 44px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      transition: all 0.3s;\n    }\n\n    .@{upload-item}-uploading .@{upload-item}-name {\n      line-height: 28px;\n    }\n\n    .@{upload-item}-progress {\n      bottom: 14px;\n      width: ~'calc(100% - 24px)';\n      margin-top: 0;\n      padding-left: 56px;\n    }\n\n    .@{iconfont-css-prefix}-close {\n      position: absolute;\n      top: 8px;\n      right: 8px;\n      line-height: 1;\n      opacity: 1;\n    }\n  }\n\n  // ======================== Picture Card ========================\n  &-picture-card {\n    &-container {\n      display: inline-block;\n      width: @upload-picture-card-size;\n      height: @upload-picture-card-size;\n      margin: 0 @margin-xs @margin-xs 0;\n      vertical-align: top;\n    }\n\n    &.@{upload-prefix-cls}-list::after {\n      display: none;\n    }\n\n    .@{upload-item} {\n      height: 100%;\n      margin: 0;\n    }\n\n    .@{upload-item}-info {\n      position: relative;\n      height: 100%;\n      overflow: hidden;\n\n      &::before {\n        position: absolute;\n        z-index: 1;\n        width: 100%;\n        height: 100%;\n        background-color: fade(@black, 50%);\n        opacity: 0;\n        transition: all 0.3s;\n        content: ' ';\n      }\n    }\n\n    .@{upload-item}:hover .@{upload-item}-info::before {\n      opacity: 1;\n    }\n\n    .@{upload-item}-actions {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 10;\n      white-space: nowrap;\n      transform: translate(-50%, -50%);\n      opacity: 0;\n      transition: all 0.3s;\n\n      .@{iconfont-css-prefix}-eye,\n      .@{iconfont-css-prefix}-download,\n      .@{iconfont-css-prefix}-delete {\n        z-index: 10;\n        width: 16px;\n        margin: 0 4px;\n        color: @text-color-dark;\n        font-size: 16px;\n        cursor: pointer;\n        transition: all 0.3s;\n\n        &:hover {\n          color: @text-color-inverse;\n        }\n      }\n    }\n\n    .@{upload-item}-info:hover + .@{upload-item}-actions,\n    .@{upload-item}-actions:hover {\n      opacity: 1;\n    }\n\n    .@{upload-item}-thumbnail,\n    .@{upload-item}-thumbnail img {\n      position: static;\n      display: block;\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n\n    .@{upload-item}-name {\n      display: none;\n      margin: 8px 0 0;\n      padding: 0;\n      line-height: @line-height-base;\n      text-align: center;\n    }\n\n    .@{upload-item}-file + .@{upload-item}-name {\n      position: absolute;\n      bottom: 10px;\n      display: block;\n    }\n\n    .@{upload-item}-uploading {\n      &.@{upload-item} {\n        background-color: @background-color-light;\n      }\n\n      .@{upload-item}-info {\n        height: auto;\n\n        &::before,\n        .@{iconfont-css-prefix}-eye,\n        .@{iconfont-css-prefix}-delete {\n          display: none;\n        }\n      }\n    }\n\n    .@{upload-item}-progress {\n      bottom: 32px;\n      width: calc(100% - 14px);\n      padding-left: 0;\n    }\n  }\n\n  // ======================= Picture & Text =======================\n  &-text,\n  &-picture {\n    &-container {\n      transition: opacity @animation-duration-slow, height @animation-duration-slow;\n\n      &::before {\n        display: table;\n        width: 0;\n        height: 0;\n        content: '';\n      }\n\n      // Don't know why span here, just stretch it\n      .@{upload-prefix-cls}-span {\n        display: block;\n        flex: auto;\n      }\n    }\n\n    // text & picture no need this additional element.\n    // But it used for picture-card, let's keep it.\n    .@{upload-prefix-cls}-span {\n      display: flex;\n      align-items: center;\n\n      > * {\n        flex: none;\n      }\n    }\n\n    .@{upload-item}-name {\n      flex: auto;\n      padding: 0 @padding-xs;\n    }\n\n    .@{upload-item}-card-actions {\n      position: static;\n    }\n  }\n\n  // ============================ Text ============================\n  &-text {\n    .@{upload-prefix-cls}-text-icon {\n      .@{iconfont-css-prefix} {\n        position: static;\n      }\n    }\n  }\n\n  // =========================== Motion ===========================\n  .@{upload-prefix-cls}-animate-inline-appear,\n  .@{upload-prefix-cls}-animate-inline-enter,\n  .@{upload-prefix-cls}-animate-inline-leave {\n    animation-duration: @animation-duration-slow;\n    animation-fill-mode: @ease-in-out-circ;\n  }\n\n  .@{upload-prefix-cls}-animate-inline-appear,\n  .@{upload-prefix-cls}-animate-inline-enter {\n    animation-name: uploadAnimateInlineIn;\n  }\n\n  .@{upload-prefix-cls}-animate-inline-leave {\n    animation-name: uploadAnimateInlineOut;\n  }\n}\n\n@keyframes uploadAnimateInlineIn {\n  from {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n\n@keyframes uploadAnimateInlineOut {\n  to {\n    width: 0;\n    height: 0;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n  }\n}\n\n@import './rtl';\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@upload-prefix-cls: ~'@{ant-prefix}-upload';\n@upload-item: ~'@{ant-prefix}-upload-list-item';\n\n.@{upload-prefix-cls} {\n  &-rtl {\n    direction: rtl;\n  }\n\n  &&-select-picture-card {\n    .@{upload-prefix-cls}-rtl& {\n      margin-right: auto;\n      margin-left: 8px;\n    }\n  }\n}\n\n.@{upload-prefix-cls}-list {\n  &-rtl {\n    direction: rtl;\n  }\n  &-item-list-type-text {\n    &:hover {\n      .@{upload-prefix-cls}-list-item-name-icon-count-1 {\n        .@{upload-prefix-cls}-list-rtl & {\n          padding-right: 22px;\n          padding-left: 14px;\n        }\n      }\n      .@{upload-prefix-cls}-list-item-name-icon-count-2 {\n        .@{upload-prefix-cls}-list-rtl & {\n          padding-right: 22px;\n          padding-left: 28px;\n        }\n      }\n    }\n  }\n  &-item {\n    &-name {\n      .@{upload-prefix-cls}-list-rtl & {\n        padding-right: @font-size-base + 8px;\n        padding-left: 0;\n      }\n    }\n\n    &-name-icon-count-1 {\n      .@{upload-prefix-cls}-list-rtl & {\n        padding-left: 14px;\n      }\n    }\n\n    &-card-actions {\n      .@{upload-prefix-cls}-list-rtl & {\n        right: auto;\n        left: 0;\n      }\n      .@{iconfont-css-prefix} {\n        .@{upload-prefix-cls}-list-rtl & {\n          padding-right: 0;\n          padding-left: 5px;\n        }\n      }\n    }\n\n    &-info {\n      .@{upload-prefix-cls}-list-rtl & {\n        padding: 0 4px 0 12px;\n      }\n    }\n\n    .@{iconfont-css-prefix}-close {\n      .@{upload-prefix-cls}-list-rtl & {\n        right: auto;\n        left: 4px;\n      }\n    }\n\n    &-error &-card-actions {\n      .@{iconfont-css-prefix} {\n        .@{upload-prefix-cls}-list-rtl & {\n          padding-right: 0;\n          padding-left: 5px;\n        }\n      }\n    }\n\n    &-progress {\n      .@{upload-prefix-cls}-list-rtl & {\n        padding-right: @font-size-base + 12px;\n        padding-left: 0;\n      }\n    }\n  }\n\n  &-picture,\n  &-picture-card {\n    .@{upload-item}-info {\n      padding: 0;\n    }\n\n    .@{upload-item}-thumbnail {\n      .@{upload-prefix-cls}-list-rtl& {\n        right: 8px;\n        left: auto;\n      }\n    }\n\n    .@{upload-item}-icon {\n      .@{upload-prefix-cls}-list-rtl& {\n        right: 50%;\n        left: auto;\n        transform: translate(50%, -50%);\n      }\n    }\n\n    .@{upload-item}-name {\n      .@{upload-prefix-cls}-list-rtl& {\n        margin: 0 8px 0 0;\n        padding-right: 48px;\n        padding-left: 8px;\n      }\n    }\n\n    .@{upload-item}-name-icon-count-1 {\n      .@{upload-prefix-cls}-list-rtl& {\n        padding-right: 48px;\n        padding-left: 18px;\n      }\n    }\n\n    .@{upload-item}-name-icon-count-2 {\n      .@{upload-prefix-cls}-list-rtl& {\n        padding-right: 48px;\n        padding-left: 36px;\n      }\n    }\n\n    .@{upload-item}-progress {\n      .@{upload-prefix-cls}-list-rtl& {\n        padding-right: 0;\n        padding-left: 0;\n      }\n    }\n\n    .@{iconfont-css-prefix}-close {\n      .@{upload-prefix-cls}-list-rtl& {\n        right: auto;\n        left: 8px;\n      }\n    }\n  }\n\n  &-picture-card {\n    &-container {\n      .@{upload-prefix-cls}-list-rtl & {\n        margin: 0 0 @margin-xs @margin-xs;\n      }\n    }\n\n    .@{upload-item}-actions {\n      .@{upload-prefix-cls}-list-rtl& {\n        right: 50%;\n        left: auto;\n        transform: translate(50%, -50%);\n      }\n    }\n\n    .@{upload-item}-file + .@{upload-item}-name {\n      .@{upload-prefix-cls}-list-rtl& {\n        margin: 8px 0 0;\n        padding: 0;\n      }\n    }\n  }\n}\n","@import './antd';\n@import '../../node_modules/antd/lib/upload/style/index.less';\n\n.pf-theme {\n  .ant-upload {\n    &.ant-upload-drag {\n      padding: 0;\n      border: @upload-drag-border;\n      background: #f9fafc;\n      opacity: 1;\n\n      .ant-upload-btn {\n        padding: @upload-drag-padding;\n      }\n\n      &:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        opacity: 0;\n        pointer-events: none;\n        background: @upload-drag-hover-bg-color;\n        transition: 300ms;\n      }\n\n      &.ant-upload-drag-hover:not(.ant-upload-disabled) {\n        border: @upload-drag-hover-not-disabled-border;\n        &:after {\n          opacity: 0.4;\n        }\n      }\n\n      &:not(.ant-upload-disabled):hover {\n        border: @upload-drag-hover-not-disabled-border;\n      }\n\n      p.ant-upload-drag-icon {\n        .@{iconfont-css-prefix} {\n          font-size: 48px;\n          color: @upload-drag-icon-color;\n        }\n        margin-bottom: 0px;\n      }\n      p.ant-upload-text {\n        font-size: @upload-drag-text-font-size;\n        margin: 0 0 10px;\n        color: @upload-drag-text-color;\n      }\n      p.ant-upload-hint {\n        font-size: @upload-drag-hint-font-size;\n        color: @upload-drag-hint-color;\n      }\n      .@{iconfont-css-prefix}-plus {\n        font-size: 30px;\n        transition: all 0.3s;\n        color: @disabled-color;\n        &:hover {\n          color: @text-color-secondary;\n        }\n      }\n      &:hover .@{iconfont-css-prefix}-plus {\n        color: @text-color-secondary;\n      }\n      &.ant-upload-disabled {\n        opacity: 0.7;\n      }\n    }\n  }\n}\n",".pricing-plans-wrapper {\n  background: linear-gradient(\n    176.41deg,\n    #f9f9f9 5.69%,\n    #f5fff7 96.39%\n  ) !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @container accounts-layout (width < 625px) {\n    display: block;\n  }\n}\n\n.no-plan-container {\n  max-width: 625px;\n  padding: 56px 74px;\n  border: 1px solid #03dfb91a;\n  box-shadow: 0px 14px 24px 0px #20e3c21a;\n\n  @container accounts-layout (width < 625px) {\n    padding: 28px 37px;\n  }\n\n  .heading {\n    font-family: Poppins;\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 36px;\n    letter-spacing: 0%;\n    margin: 0;\n\n    .discount {\n      color: #22a875;\n    }\n  }\n  .description {\n    font-family: Poppins;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 23px;\n    letter-spacing: 0%;\n    margin: 24px 0 32px;\n    strong {\n      font-weight: 700;\n    }\n  }\n  .underline {\n    position: relative;\n    white-space: nowrap;\n    svg {\n      position: absolute;\n      top: calc(100% - 0.1em);\n      left: -0.25em;\n    }\n  }\n  .benefits-grid {\n    list-style: none;\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: space-around;\n    gap: 15px;\n    margin: 24px 0 32px;\n\n    li {\n      width: 148px;\n      height: 138px;\n      border-radius: 4px;\n      padding: 24px;\n      margin: 0;\n      background: #b0b0b017;\n    }\n  }\n  a {\n    font-family: Poppins;\n    font-weight: 600;\n  }\n  .contact-sales {\n    background-color: #03dfb9;\n    &:hover {\n      background-color: #07f8cf;\n    }\n  }\n}\n\n.plan-container {\n  align-self: flex-start;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  text-align: center;\n  width: 100%;\n\n  header {\n    max-width: 524px;\n    margin: 65px 0 50px;\n\n    h3 {\n      font-family: Poppins;\n      font-weight: 700;\n      font-size: 24px;\n      line-height: 30px;\n      letter-spacing: 0;\n      margin: 16px;\n    }\n\n    .description {\n      font-family: Poppins;\n      font-size: 14px;\n      line-height: 20px;\n      letter-spacing: 0;\n      margin: 0;\n      padding: 0;\n    }\n  }\n  .plans-grid {\n    font-family: Poppins;\n    list-style: none;\n    padding: 1em 0 0;\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    max-width: 100%;\n    min-height: 450px;\n    overflow-x: auto;\n\n    .plans-grid-item {\n      flex: 0 0 251px;\n      border-radius: 4px;\n      padding: 40px 24px;\n      margin: 0;\n      background: #fff;\n      font-size: 13px;\n      border: 1px solid #eff3f7;\n\n      &:not(:hover) a {\n        display: none;\n      }\n\n      .discount-rate {\n        font-size: 40px;\n        line-height: 1;\n        display: block;\n        letter-spacing: 0;\n      }\n      .discount-label {\n        font-size: 21px;\n        font-weight: 600;\n        line-height: 1;\n        letter-spacing: 0;\n      }\n      .credits-amount {\n        font-size: 25px;\n        font-weight: 600;\n        display: block;\n      }\n\n      &.current-plan {\n        position: relative;\n        .badge {\n          border: 1px solid #b3f0e5;\n          background-color: #ebfbf8;\n        }\n        .expiration-note {\n          position: absolute;\n          left: 0;\n          right: 0;\n          top: 100%;\n          color: #5e6775;\n          font-size: 12px;\n          line-height: 16px;\n          font-family: Roboto;\n          margin-top: 8px;\n        }\n      }\n      &.next-plan {\n        border-color: #b3f0e5;\n        position: relative;\n        flex-basis: 286px;\n        padding: 45px 30px 55px;\n\n        &:hover {\n          padding-bottom: 30px;\n        }\n        .discount-rate {\n          position: relative;\n          font-size: 45px;\n          svg {\n            position: absolute;\n            transform: translate(-140%, -50%);\n          }\n        }\n        .discount-label {\n          font-size: 24px;\n        }\n        .credits-amount {\n          font-size: 28px;\n        }\n\n        .badge {\n          border: 1px solid #ffc00033;\n          background-color: #fff;\n          box-shadow: 0px 4px 4px 0px #ffc0001a;\n          padding: 0 8px;\n        }\n      }\n      .badge {\n        font-family: Roboto;\n        font-size: 14px;\n        line-height: 1;\n        letter-spacing: 0;\n        position: absolute;\n        margin: 0 auto;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 0 12px;\n        height: 24px;\n        top: -12px;\n        left: 50%;\n        transform: translateX(-50%);\n        border-radius: 12px;\n        white-space: nowrap;\n      }\n    }\n  }\n  a {\n    font-family: Poppins;\n    font-weight: 600;\n  }\n  .contact-sales {\n    background-color: #03dfb9;\n    &:hover {\n      background-color: #07f8cf;\n    }\n  }\n}\n","@import './antd';\n\n.pf-theme {\n  .invite-member-card {\n    height: 200px;\n    margin-bottom: 24px;\n    border: 1px dashed rgba(34, 168, 117, 0.4);\n\n    .invite-members-btn-circle {\n      background-color: #d5ffe8;\n      color: #22a875;\n      width: 46px;\n      height: 46px;\n      border-radius: 46px;\n      display: block;\n      margin: 0 auto;\n      border: none;\n      font-size: 20px;\n      margin-bottom: 12px;\n    }\n\n    &.invite-card-disabled {\n      opacity: 0.4;\n    }\n  }\n\n  .pending-member-card {\n    border-color: transparent;\n    height: 200px;\n    text-align: center;\n    margin-bottom: @space-lg;\n    box-shadow: none;\n\n    &.pending-member-card-disabled {\n      opacity: 0.4;\n      .remove-invitation {\n        cursor: not-allowed;\n      }\n    }\n\n    .label {\n      line-height: 1;\n      width: 150px;\n      height: 48px;\n      font-size: 16px;\n      font-weight: bold;\n      text-align: center;\n      color: #22a875;\n      position: absolute;\n      top: 32%;\n      left: 50%;\n      transform: translate(-50%, 0);\n    }\n\n    .ant-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 20px;\n    }\n\n    .ant-avatar-string {\n      line-height: 40px;\n    }\n\n    .ant-card-cover {\n      padding-top: 22px;\n    }\n\n    .ant-card-meta {\n      padding-bottom: 10px;\n    }\n\n    .ant-card-body {\n      padding: 24px 16px;\n    }\n\n    .ant-card-meta-detail > div:not(:last-child) {\n      margin: 0;\n    }\n\n    .ant-card-meta-title {\n      font-size: 14px;\n      color: @color-grey-1;\n    }\n\n    .ant-card-meta-description {\n      font-size: 11px;\n      color: @pf-color-pricing-credits;\n    }\n\n    .remove-invitation {\n      display: block;\n      cursor: pointer;\n      width: 100px;\n      height: 32px;\n      font-size: 11px;\n      color: @blue-6;\n      padding: 8px 10px;\n    }\n  }\n}\n","@import './antd';\n\n.pf-theme {\n  .team-member-card {\n    height: 200px;\n    text-align: center;\n    margin-bottom: @space-lg;\n    box-shadow: none;\n\n    &.team-member-card-disabled {\n      pointer-events: none;\n      opacity: 0.4;\n      .ant-card-actions {\n        li {\n          span {\n            &:hover {\n              cursor: not-allowed;\n              color: inherit;\n            }\n          }\n        }\n        &:hover {\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    .ant-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 20px;\n    }\n\n    .ant-card-cover {\n      padding-top: 22px;\n    }\n\n    .ant-tag {\n      min-width: 102px;\n      border: none;\n      background-color: transparent;\n      color: @color-grey-10;\n      font-size: 10px;\n\n      &:hover {\n        cursor: default;\n      }\n    }\n\n    .ant-card-meta {\n      padding-bottom: 10px;\n    }\n\n    .ant-card-body {\n      padding: 11px 16px;\n    }\n\n    .ant-card-meta-detail > div:not(:last-child) {\n      margin: 0;\n    }\n\n    .ant-avatar-string {\n      line-height: 40px;\n    }\n\n    .ant-card-meta-title {\n      font-size: 14px;\n      color: @color-grey-10;\n    }\n\n    .ant-card-meta-description {\n      font-size: 11px;\n      color: @color-grey-8;\n    }\n\n    .ant-card-actions {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      background-color: @color-grey-4;\n      &:hover {\n        cursor: pointer;\n      }\n\n      > li {\n        padding: 7px 0;\n        margin: 0;\n\n        &:not(:last-child) {\n          border-color: @color-grey-6;\n        }\n      }\n    }\n\n    .team-members-card__link {\n      padding-left: 5px;\n    }\n\n    &:hover {\n      // box-shadow: @card-box-shadow;\n      cursor: default;\n    }\n  }\n}\n","@import './antd';\n\n.pf-theme {\n  .team-members-invite-form {\n  }\n\n  .team-members-invite-form-icon {\n    position: relative;\n    top: 7px;\n    font-size: 28px;\n    color: @team-members-invite-form-delete-icon-color-hover;\n    transition: 300ms;\n    cursor: pointer;\n  }\n\n  .team-members-invite-form-icon--disabled {\n    color: @team-members-invite-form-delete-icon-color;\n    opacity: 0.7;\n  }\n\n  .team-members-invite-form-icon--delete-icon {\n    color: @team-members-invite-form-delete-icon-color;\n    opacity: 0.7;\n\n    &:hover {\n      opacity: 1;\n      color: @team-members-invite-form-delete-icon-color-hover;\n    }\n  }\n}\n","@import './antd';\n\n.pf-theme {\n  .account-card {\n    height: 418px;\n    text-align: center;\n    margin-bottom: @space-lg;\n    box-shadow: none;\n    border-radius: 10px;\n    overflow: hidden;\n\n    &.account-selected {\n      border-color: rgba(34, 168, 117, 0.4);\n      pointer-events: none;\n      .ant-card-actions {\n        background-color: #d5ffe8;\n\n        li {\n          span {\n            color: #22a875;\n          }\n        }\n      }\n    }\n    &.account-card-disabled {\n      opacity: 0.4;\n      .ant-card-actions {\n        li {\n          span {\n            &:hover {\n              cursor: not-allowed;\n              color: inherit;\n            }\n          }\n        }\n        &:hover {\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    &.account-card-condensed {\n      height: 200px;\n\n      .ant-card-cover {\n        padding-top: @space-lg;\n      }\n    }\n\n    .ant-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n    }\n\n    .ant-card-cover {\n      padding-top: 44px;\n    }\n\n    .ant-tag {\n      min-width: 102px;\n      border: none;\n      background-color: transparent;\n      color: @purple-5;\n      font-size: 11px;\n\n      &:hover {\n        cursor: default;\n      }\n    }\n\n    .ant-card-meta {\n      padding-bottom: 10px;\n    }\n\n    .ant-card-body {\n      padding: 10px 24px 24px;\n    }\n\n    .ant-card-meta-detail > div:not(:last-child) {\n      margin: 0;\n    }\n\n    .ant-avatar-string {\n      line-height: 90px;\n    }\n\n    .ant-card-meta-title {\n      font-size: 14px;\n    }\n\n    .ant-card-meta-description {\n      font-size: 12px;\n      color: @color-grey-7;\n    }\n\n    .ant-card-actions {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      background-color: #ebf1f6;\n      border: none;\n      border-radius: 0px 0px 9px 9px;\n\n      &:hover {\n        cursor: pointer;\n      }\n\n      > li {\n        margin: 0;\n        padding: 7px 0;\n\n        span {\n          font-weight: 500;\n        }\n      }\n    }\n\n    .ant-card-actions span {\n      display: inline-block;\n      padding-left: 5px;\n    }\n\n    &:hover {\n      box-shadow: @card-box-shadow;\n      cursor: default;\n    }\n\n    .list-members {\n      padding-top: 28px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .members {\n      width: 44px;\n      height: 44px;\n      border-radius: 50%;\n      display: inline-block;\n      margin: 0;\n      background-color: @upload-drag-hint-color;\n      & + .members {\n        margin-left: -20px;\n      }\n      .ant-avatar-string {\n        line-height: 44px;\n      }\n    }\n\n    .label {\n      cursor: pointer;\n      font-size: 13px;\n      color: @blue-5;\n    }\n  }\n}\n",".modal-create-survey {\n  .ant-modal-title {\n    text-align: center;\n    font-size: @pf-font-size-md!important;\n  }\n\n  .ant-modal-content {\n    padding-bottom: 12px !important;\n  }\n\n  &.modal-create-survey-researcher {\n    margin: 0 auto !important;\n\n    .ant-modal-content {\n      border: 1px solid white;\n      padding: 52px 72px 72px !important;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      border-radius: 8px;\n      -webkit-box-shadow: none;\n      -moz-box-shadow: none;\n      box-shadow: none;\n      background-color: rgba(white, 0.3);\n    }\n\n    .ant-modal-footer {\n      border: 0;\n      padding-top: 8px !important;\n    }\n  }\n\n  .ant-modal-footer {\n    padding-top: 12px !important;\n  }\n}\n\n.modal-create-survey__item-img {\n  width: auto;\n  height: 120px;\n  display: block;\n  margin: 0 auto;\n}\n\n.modal-create-survey__selection {\n  height: 60px;\n  display: flex;\n  flex-direction: column;\n  background-color: transparent;\n  flex: 1;\n  justify-self: flex-end;\n  justify-content: flex-end;\n  text-align: center;\n  padding: 10px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.modal-create-survey__card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  border: 1px solid transparent;\n  .ant-card-body {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n  }\n\n  &:hover {\n    background-color: white;\n    border-color: @basic-blue;\n  }\n}\n\n.modal-create-survey__tutorial {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n\n.modal-create-survey__tutorial-item {\n  width: 30%;\n  height: auto;\n  background-color: @color-grey-3;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.modal-create-survey__tutorial-item-img-wrapper {\n  position: relative;\n  background-color: @color-modal-item;\n  padding: 8px;\n}\n\n.modal-create-survey__tutorial-item-img {\n  height: 120px;\n  width: auto;\n  display: block;\n  margin: 0 auto;\n}\n\n.modal-create-survey__tutorial-step-number {\n  width: 12px;\n  height: 12px;\n  line-height: 12px;\n  border: 6px solid @color-grey-3;\n  background-color: @color-blue-6;\n  color: white;\n  padding: 4px;\n  display: block;\n  text-align: center;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  border-radius: 50%;\n  position: absolute;\n  bottom: -16px;\n  left: 10px;\n  font-size: 12px;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.modal-create-survey__back-button {\n  position: absolute;\n  left: 24px;\n  top: 7px;\n  -webkit-box-shadow: none !important;\n  -moz-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.modal-create-survey__back-button-icon {\n  font-size: @pf-font-size-sm;\n}\n\n.create-survey-button__img {\n  width: 154px;\n  height: auto;\n  display: block;\n  position: relative;\n  left: 50%;\n  margin-left: -91px;\n}\n\n.modal-create-survey-backdrop-btn {\n  position: fixed;\n  top: 14px;\n  right: 18px;\n  z-index: 1100;\n}\n\n.create-survey-modal-open.create-survey-modal-open-regular,\n.create-survey-modal-open.create-survey-modal-open-distribution,\n.create-survey-modal-open.create-survey-modal-open-peeq {\n  .ant-modal-mask {\n    background-color: white !important;\n  }\n}\n\n.create-survey-modal-open.create-survey-modal-open-regular\n  .create-survey-wrap.ant-modal-wrap {\n  //background: linear-gradient(45deg, rgba(73, 127, 228, 0.5), rgba(227, 176, 255, 0.2),rgba(233, 241, 255, 0.95),rgba(118,127, 247, 0.5));\n  background: linear-gradient(\n    132deg,\n    rgba(#c2d5f8, 0.3),\n    rgba(#d1dbf4, 0.3),\n    rgba(#bac8ff, 0.3),\n    rgba(#83acf8, 0.3)\n  );\n}\n\n.create-survey-modal-open.create-survey-modal-open-distribution\n  .create-survey-wrap.ant-modal-wrap {\n  background: linear-gradient(\n    45deg,\n    rgba(143, 145, 247, 0.58),\n    rgba(216, 241, 245, 0.5),\n    rgba(190, 234, 233, 0.43),\n    rgba(122, 212, 199, 0.5)\n  );\n}\n\n.create-survey-modal-open.create-survey-modal-open-peeq\n  .create-survey-wrap.ant-modal-wrap {\n  background: linear-gradient(\n    45deg,\n    rgba(87, 35, 98, 0.1),\n    rgba(136, 59, 149, 0.1)\n  );\n}\n\n.create-survey-modal-open .create-survey-wrap.ant-modal-wrap {\n  background-size: 800% 800% !important;\n  //background-size: 400% 400%!important;\n\n  -webkit-animation: gradient 30s ease infinite;\n  -moz-animation: gradient 30s ease infinite;\n  -o-animation: gradient 30s ease infinite;\n  animation: gradient 30s ease infinite;\n  //animation: gradient 12s cubic-bezier(0.4, 0, 1, 1) infinite;\n}\n.create-survey-modal-open .upload-modal-wrap.ant-modal-wrap {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.create-survey-card {\n  background-color: rgba(255, 255, 255, 0.4);\n  transition: background-color 0.3s linear;\n\n  &:hover {\n    background-color: white;\n  }\n\n  &.create-survey-card-selected {\n    background-color: white;\n  }\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0 7%;\n  }\n\n  50% {\n    background-position: 100% 94%;\n  }\n\n  100% {\n    background-position: 0 7%;\n  }\n}\n\n.ant-modal-mask {\n  transition: all 0.15s linear;\n}\n\n.create-survey-wrap {\n  display: block !important;\n  pointer-events: none !important;\n  opacity: 0 !important;\n  transition: all 0.1s linear;\n\n  .ant-modal,\n  .ant-modal-content {\n    pointer-events: none !important;\n  }\n}\n\n.create-survey-modal-open {\n  .ant-modal-mask {\n    opacity: 1 !important;\n  }\n\n  .create-survey-wrap {\n    pointer-events: all !important;\n    opacity: 1 !important;\n\n    .ant-modal,\n    .ant-modal-content {\n      pointer-events: all !important;\n    }\n  }\n}\n","@import './index';\n\n.@{menu-prefix-cls} {\n  // Danger\n  &-item-danger&-item {\n    color: @menu-highlight-danger-color;\n\n    &:hover,\n    &-active {\n      color: @menu-highlight-danger-color;\n    }\n\n    &:active {\n      background: @menu-item-active-danger-bg;\n    }\n\n    &-selected {\n      color: @menu-highlight-danger-color;\n      > a,\n      > a:hover {\n        color: @menu-highlight-danger-color;\n      }\n    }\n\n    .@{menu-prefix-cls}:not(.@{menu-prefix-cls}-horizontal) &-selected {\n      background-color: @menu-item-active-danger-bg;\n    }\n\n    .@{menu-prefix-cls}-inline &::after {\n      border-right-color: @menu-highlight-danger-color;\n    }\n  }\n\n  // ==================== Dark ====================\n  &-dark &-item-danger&-item {\n    &,\n    &:hover,\n    & > a {\n      color: @menu-dark-danger-color;\n    }\n  }\n\n  &-dark&-dark:not(&-horizontal) &-item-danger&-item-selected {\n    color: @menu-dark-highlight-color;\n    background-color: @menu-dark-item-active-danger-bg;\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n@import './status';\n\n@menu-prefix-cls: ~'@{ant-prefix}-menu';\n@menu-animation-duration-normal: 0.15s;\n\n.accessibility-focus() {\n  box-shadow: 0 0 0 2px fade(@primary-color, 20%);\n}\n\n// TODO: Should remove icon style compatible in v5\n\n// default theme\n.@{menu-prefix-cls} {\n  .reset-component();\n\n  margin-bottom: 0;\n  padding-left: 0; // Override default ul/ol\n  color: @menu-item-color;\n  font-size: @menu-item-font-size;\n  line-height: 0; // Fix display inline-block gap\n  text-align: left;\n  list-style: none;\n  background: @menu-bg;\n  outline: none;\n  box-shadow: @box-shadow-base;\n  transition: background @animation-duration-slow,\n    width @animation-duration-slow cubic-bezier(0.2, 0, 0, 1) 0s;\n  .clearfix();\n\n  &&-root:focus-visible {\n    .accessibility-focus();\n  }\n\n  ul,\n  ol {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n\n  // Overflow ellipsis\n  &-overflow {\n    display: flex;\n\n    &-item {\n      flex: none;\n    }\n  }\n\n  &-hidden,\n  &-submenu-hidden {\n    display: none;\n  }\n\n  &-item-group-title {\n    height: @menu-item-group-height;\n    padding: 8px 16px;\n    color: @menu-item-group-title-color;\n    font-size: @menu-item-group-title-font-size;\n    line-height: @menu-item-group-height;\n    transition: all @animation-duration-slow;\n  }\n\n  &-horizontal &-submenu {\n    transition: border-color @animation-duration-slow @ease-in-out,\n      background @animation-duration-slow @ease-in-out;\n  }\n  &-submenu,\n  &-submenu-inline {\n    transition: border-color @animation-duration-slow @ease-in-out,\n      background @animation-duration-slow @ease-in-out,\n      padding @menu-animation-duration-normal @ease-in-out;\n  }\n\n  &-submenu-selected {\n    color: @menu-highlight-color;\n  }\n\n  &-item:active,\n  &-submenu-title:active {\n    background: @menu-item-active-bg;\n  }\n\n  &-submenu &-sub {\n    cursor: initial;\n    transition: background @animation-duration-slow @ease-in-out,\n      padding @animation-duration-slow @ease-in-out;\n  }\n\n  &-title-content {\n    transition: color @animation-duration-slow;\n  }\n\n  &-item a {\n    color: @menu-item-color;\n    &:hover {\n      color: @menu-highlight-color;\n    }\n    &::before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      background-color: transparent;\n      content: '';\n    }\n  }\n\n  // https://github.com/ant-design/ant-design/issues/19809\n  &-item > .@{ant-prefix}-badge a {\n    color: @menu-item-color;\n    &:hover {\n      color: @menu-highlight-color;\n    }\n  }\n\n  &-item-divider {\n    height: 1px;\n    overflow: hidden;\n    line-height: 0;\n    background-color: @border-color-split;\n  }\n\n  &-horizontal &-item,\n  &-horizontal &-submenu {\n    margin-top: -1px;\n  }\n\n  &-horizontal > &-item:hover,\n  &-horizontal > &-item-active,\n  &-horizontal > &-submenu &-submenu-title:hover {\n    background-color: transparent;\n  }\n\n  &-item-selected {\n    color: @menu-highlight-color;\n    a,\n    a:hover {\n      color: @menu-highlight-color;\n    }\n  }\n\n  &:not(&-horizontal) &-item-selected {\n    background-color: @menu-item-active-bg;\n  }\n\n  &-inline,\n  &-vertical,\n  &-vertical-left {\n    border-right: @border-width-base @border-style-base @border-color-split;\n  }\n\n  &-vertical-right {\n    border-left: @border-width-base @border-style-base @border-color-split;\n  }\n\n  &-vertical&-sub,\n  &-vertical-left&-sub,\n  &-vertical-right&-sub {\n    min-width: 160px;\n    max-height: calc(100vh - 100px);\n    padding: 0;\n    overflow: hidden;\n    border-right: 0;\n\n    // https://github.com/ant-design/ant-design/issues/22244\n    // https://github.com/ant-design/ant-design/issues/26812\n    &:not([class*='-active']) {\n      overflow-x: hidden;\n      overflow-y: auto;\n    }\n\n    .@{menu-prefix-cls}-item {\n      left: 0;\n      margin-left: 0;\n      border-right: 0;\n      &::after {\n        border-right: 0;\n      }\n    }\n    > .@{menu-prefix-cls}-item,\n    > .@{menu-prefix-cls}-submenu {\n      transform-origin: 0 0;\n    }\n  }\n\n  &-horizontal&-sub {\n    min-width: 114px; // in case of submenu width is too big: https://codesandbox.io/s/qvpwm6mk66\n  }\n\n  &-horizontal &-item,\n  &-horizontal &-submenu-title {\n    transition: border-color @animation-duration-slow, background @animation-duration-slow;\n  }\n\n  &-item,\n  &-submenu-title {\n    position: relative;\n    display: block;\n    margin: 0;\n    padding: @menu-item-padding;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: border-color @animation-duration-slow, background @animation-duration-slow,\n      padding @animation-duration-slow @ease-in-out;\n\n    .@{menu-prefix-cls}-item-icon,\n    .@{iconfont-css-prefix} {\n      min-width: 14px;\n      font-size: @menu-icon-size;\n      transition: font-size @menu-animation-duration-normal @ease-out,\n        margin @animation-duration-slow @ease-in-out, color @animation-duration-slow;\n      + span {\n        margin-left: @menu-icon-margin-right;\n        opacity: 1;\n        transition: opacity @animation-duration-slow @ease-in-out, margin @animation-duration-slow,\n          color @animation-duration-slow;\n      }\n    }\n\n    .@{menu-prefix-cls}-item-icon.svg {\n      vertical-align: -0.125em;\n    }\n\n    &.@{menu-prefix-cls}-item-only-child {\n      > .@{iconfont-css-prefix},\n      > .@{menu-prefix-cls}-item-icon {\n        margin-right: 0;\n      }\n    }\n\n    &:focus-visible {\n      .accessibility-focus();\n    }\n  }\n\n  & > &-item-divider {\n    height: 1px;\n    margin: 1px 0;\n    padding: 0;\n    overflow: hidden;\n    line-height: 0;\n    background-color: @border-color-split;\n  }\n\n  &-submenu {\n    &-popup {\n      position: absolute;\n      z-index: @zindex-dropdown;\n      background: transparent;\n      border-radius: @border-radius-base;\n      box-shadow: none;\n      transform-origin: 0 0;\n\n      // https://github.com/ant-design/ant-design/issues/13955\n      &::before {\n        position: absolute;\n        top: -7px;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: -1;\n        width: 100%;\n        height: 100%;\n        opacity: 0.0001;\n        content: ' ';\n      }\n    }\n\n    // https://github.com/ant-design/ant-design/issues/13955\n    &-placement-rightTop::before {\n      top: 0;\n      left: -7px;\n    }\n\n    > .@{menu-prefix-cls} {\n      background-color: @menu-bg;\n      border-radius: @border-radius-base;\n      &-submenu-title::after {\n        transition: transform @animation-duration-slow @ease-in-out;\n      }\n    }\n\n    &-popup > .@{menu-prefix-cls} {\n      background-color: @menu-popup-bg;\n    }\n\n    &-expand-icon,\n    &-arrow {\n      position: absolute;\n      top: 50%;\n      right: 16px;\n      width: 10px;\n      color: @menu-item-color;\n      transform: translateY(-50%);\n      transition: transform @animation-duration-slow @ease-in-out;\n    }\n\n    &-arrow {\n      // →\n      &::before,\n      &::after {\n        position: absolute;\n        width: 6px;\n        height: 1.5px;\n        background-color: currentColor;\n        border-radius: 2px;\n        transition: background @animation-duration-slow @ease-in-out,\n          transform @animation-duration-slow @ease-in-out, top @animation-duration-slow @ease-in-out,\n          color @animation-duration-slow @ease-in-out;\n        content: '';\n      }\n      &::before {\n        transform: rotate(45deg) translateY(-2.5px);\n      }\n      &::after {\n        transform: rotate(-45deg) translateY(2.5px);\n      }\n    }\n\n    &:hover > &-title > &-expand-icon,\n    &:hover > &-title > &-arrow {\n      color: @menu-highlight-color;\n    }\n\n    .@{menu-prefix-cls}-inline-collapsed &-arrow,\n    &-inline &-arrow {\n      // ↓\n      &::before {\n        transform: rotate(-45deg) translateX(2.5px);\n      }\n      &::after {\n        transform: rotate(45deg) translateX(-2.5px);\n      }\n    }\n\n    &-horizontal &-arrow {\n      display: none;\n    }\n\n    &-open&-inline > &-title > &-arrow {\n      // ↑\n      transform: translateY(-2px);\n      &::after {\n        transform: rotate(-45deg) translateX(-2.5px);\n      }\n      &::before {\n        transform: rotate(45deg) translateX(2.5px);\n      }\n    }\n  }\n\n  &-vertical &-submenu-selected,\n  &-vertical-left &-submenu-selected,\n  &-vertical-right &-submenu-selected {\n    color: @menu-highlight-color;\n  }\n\n  &-horizontal {\n    line-height: @menu-horizontal-line-height;\n    border: 0;\n    border-bottom: @border-width-base @border-style-base @border-color-split;\n    box-shadow: none;\n\n    &:not(.@{menu-prefix-cls}-dark) {\n      > .@{menu-prefix-cls}-item,\n      > .@{menu-prefix-cls}-submenu {\n        margin-top: -1px;\n        margin-bottom: 0;\n        padding: @menu-item-padding;\n\n        &:hover,\n        &-active,\n        &-open,\n        &-selected {\n          color: @menu-highlight-color;\n\n          &::after {\n            border-bottom: 2px solid @menu-highlight-color;\n          }\n        }\n      }\n    }\n\n    > .@{menu-prefix-cls}-item,\n    > .@{menu-prefix-cls}-submenu {\n      position: relative;\n      top: 1px;\n      display: inline-block;\n      vertical-align: bottom;\n\n      &::after {\n        position: absolute;\n        right: @menu-item-padding-horizontal;\n        bottom: 0;\n        left: @menu-item-padding-horizontal;\n        border-bottom: 2px solid transparent;\n        transition: border-color @animation-duration-slow @ease-in-out;\n        content: '';\n      }\n    }\n\n    > .@{menu-prefix-cls}-submenu > .@{menu-prefix-cls}-submenu-title {\n      padding: 0;\n    }\n\n    > .@{menu-prefix-cls}-item {\n      a {\n        color: @menu-item-color;\n        &:hover {\n          color: @menu-highlight-color;\n        }\n        &::before {\n          bottom: -2px;\n        }\n      }\n      &-selected a {\n        color: @menu-highlight-color;\n      }\n    }\n\n    &::after {\n      display: block;\n      clear: both;\n      height: 0;\n      content: '\\20';\n    }\n  }\n\n  &-vertical,\n  &-vertical-left,\n  &-vertical-right,\n  &-inline {\n    .@{menu-prefix-cls}-item {\n      position: relative;\n      &::after {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        border-right: @menu-item-active-border-width solid @menu-highlight-color;\n        transform: scaleY(0.0001);\n        opacity: 0;\n        transition: transform @menu-animation-duration-normal @ease-out,\n          opacity @menu-animation-duration-normal @ease-out;\n        content: '';\n      }\n    }\n\n    .@{menu-prefix-cls}-item,\n    .@{menu-prefix-cls}-submenu-title {\n      height: @menu-item-height;\n      margin-top: @menu-item-vertical-margin;\n      margin-bottom: @menu-item-vertical-margin;\n      padding: 0 16px;\n      overflow: hidden;\n      line-height: @menu-item-height;\n      text-overflow: ellipsis;\n    }\n\n    // disable margin collapsed\n    .@{menu-prefix-cls}-submenu {\n      padding-bottom: 0.02px;\n    }\n\n    .@{menu-prefix-cls}-item:not(:last-child) {\n      margin-bottom: @menu-item-boundary-margin;\n    }\n\n    > .@{menu-prefix-cls}-item,\n    > .@{menu-prefix-cls}-submenu > .@{menu-prefix-cls}-submenu-title {\n      height: @menu-inline-toplevel-item-height;\n      line-height: @menu-inline-toplevel-item-height;\n    }\n  }\n\n  &-vertical {\n    .@{menu-prefix-cls}-item-group-list .@{menu-prefix-cls}-submenu-title,\n    .@{menu-prefix-cls}-submenu-title {\n      padding-right: 34px;\n    }\n  }\n\n  &-inline {\n    width: 100%;\n    .@{menu-prefix-cls}-selected,\n    .@{menu-prefix-cls}-item-selected {\n      &::after {\n        transform: scaleY(1);\n        opacity: 1;\n        transition: transform @menu-animation-duration-normal @ease-in-out,\n          opacity @menu-animation-duration-normal @ease-in-out;\n      }\n    }\n\n    .@{menu-prefix-cls}-item,\n    .@{menu-prefix-cls}-submenu-title {\n      width: ~'calc(100% + 1px)';\n    }\n\n    .@{menu-prefix-cls}-item-group-list .@{menu-prefix-cls}-submenu-title,\n    .@{menu-prefix-cls}-submenu-title {\n      padding-right: 34px;\n    }\n\n    // Motion enhance for first level\n    &.@{menu-prefix-cls}-root {\n      .@{menu-prefix-cls}-item,\n      .@{menu-prefix-cls}-submenu-title {\n        display: flex;\n        align-items: center;\n        transition: border-color @animation-duration-slow, background @animation-duration-slow,\n          padding 0.1s @ease-out;\n\n        > .@{menu-prefix-cls}-title-content {\n          flex: auto;\n          min-width: 0;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        > * {\n          flex: none;\n        }\n      }\n    }\n  }\n\n  &&-inline-collapsed {\n    width: @menu-collapsed-width;\n\n    > .@{menu-prefix-cls}-item,\n    > .@{menu-prefix-cls}-item-group\n      > .@{menu-prefix-cls}-item-group-list\n      > .@{menu-prefix-cls}-item,\n    > .@{menu-prefix-cls}-item-group\n      > .@{menu-prefix-cls}-item-group-list\n      > .@{menu-prefix-cls}-submenu\n      > .@{menu-prefix-cls}-submenu-title,\n    > .@{menu-prefix-cls}-submenu > .@{menu-prefix-cls}-submenu-title {\n      left: 0;\n      padding: 0 ~'calc(50% - @{menu-icon-size-lg} / 2)';\n      text-overflow: clip;\n\n      .@{menu-prefix-cls}-submenu-arrow {\n        opacity: 0;\n      }\n\n      .@{menu-prefix-cls}-item-icon,\n      .@{iconfont-css-prefix} {\n        margin: 0;\n        font-size: @menu-icon-size-lg;\n        line-height: @menu-item-height;\n        + span {\n          display: inline-block;\n          opacity: 0;\n        }\n      }\n    }\n\n    .@{menu-prefix-cls}-item-icon,\n    .@{iconfont-css-prefix} {\n      display: inline-block;\n    }\n\n    &-tooltip {\n      pointer-events: none;\n\n      .@{menu-prefix-cls}-item-icon,\n      .@{iconfont-css-prefix} {\n        display: none;\n      }\n      a {\n        color: @text-color-dark;\n      }\n    }\n\n    .@{menu-prefix-cls}-item-group-title {\n      padding-right: 4px;\n      padding-left: 4px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n  }\n\n  &-item-group-list {\n    margin: 0;\n    padding: 0;\n    .@{menu-prefix-cls}-item,\n    .@{menu-prefix-cls}-submenu-title {\n      padding: 0 16px 0 28px;\n    }\n  }\n\n  &-root&-vertical,\n  &-root&-vertical-left,\n  &-root&-vertical-right,\n  &-root&-inline {\n    box-shadow: none;\n  }\n\n  &-root&-inline-collapsed {\n    .@{menu-prefix-cls}-item,\n    .@{menu-prefix-cls}-submenu .@{menu-prefix-cls}-submenu-title {\n      > .@{menu-prefix-cls}-inline-collapsed-noicon {\n        font-size: @menu-icon-size-lg;\n        text-align: center;\n      }\n    }\n  }\n\n  &-sub&-inline {\n    padding: 0;\n    background: @menu-inline-submenu-bg;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n    & > .@{menu-prefix-cls}-item,\n    & > .@{menu-prefix-cls}-submenu > .@{menu-prefix-cls}-submenu-title {\n      height: @menu-item-height;\n      line-height: @menu-item-height;\n      list-style-position: inside;\n      list-style-type: disc;\n    }\n\n    & .@{menu-prefix-cls}-item-group-title {\n      padding-left: 32px;\n    }\n  }\n\n  // Disabled state sets text to gray and nukes hover/tab effects\n  &-item-disabled,\n  &-submenu-disabled {\n    color: @disabled-color !important;\n    background: none;\n    cursor: not-allowed;\n\n    &::after {\n      border-color: transparent !important;\n    }\n\n    a {\n      color: @disabled-color !important;\n      pointer-events: none;\n    }\n    > .@{menu-prefix-cls}-submenu-title {\n      color: @disabled-color !important;\n      cursor: not-allowed;\n      > .@{menu-prefix-cls}-submenu-arrow {\n        &::before,\n        &::after {\n          background: @disabled-color !important;\n        }\n      }\n    }\n  }\n}\n\n// Integration with header element so menu items have the same height\n.@{ant-prefix}-layout-header {\n  .@{menu-prefix-cls} {\n    line-height: inherit;\n  }\n}\n\n@import './light';\n@import './dark';\n@import './rtl';\n",".@{menu-prefix-cls} {\n  // light theme\n  &-light {\n    .@{menu-prefix-cls}-item:hover,\n    .@{menu-prefix-cls}-item-active,\n    .@{menu-prefix-cls}:not(.@{menu-prefix-cls}-inline) .@{menu-prefix-cls}-submenu-open,\n    .@{menu-prefix-cls}-submenu-active,\n    .@{menu-prefix-cls}-submenu-title:hover {\n      color: @menu-highlight-color;\n    }\n  }\n}\n",".@{menu-prefix-cls} {\n  // dark theme\n  &&-dark,\n  &-dark &-sub,\n  &&-dark &-sub {\n    color: @menu-dark-color;\n    background: @menu-dark-bg;\n    .@{menu-prefix-cls}-submenu-title .@{menu-prefix-cls}-submenu-arrow {\n      opacity: 0.45;\n      transition: all 0.3s;\n      &::after,\n      &::before {\n        background: @menu-dark-arrow-color;\n      }\n    }\n  }\n\n  &-dark&-submenu-popup {\n    background: transparent;\n  }\n\n  &-dark &-inline&-sub {\n    background: @menu-dark-inline-submenu-bg;\n  }\n\n  &-dark&-horizontal {\n    border-bottom: 0;\n  }\n\n  &-dark&-horizontal > &-item,\n  &-dark&-horizontal > &-submenu {\n    top: 0;\n    margin-top: 0;\n    padding: @menu-item-padding;\n    border-color: @menu-dark-bg;\n    border-bottom: 0;\n  }\n\n  &-dark&-horizontal > &-item:hover {\n    background-color: @menu-dark-item-active-bg;\n  }\n\n  &-dark&-horizontal > &-item > a::before {\n    bottom: 0;\n  }\n\n  &-dark &-item,\n  &-dark &-item-group-title,\n  &-dark &-item > a,\n  &-dark &-item > span > a {\n    color: @menu-dark-color;\n  }\n\n  &-dark&-inline,\n  &-dark&-vertical,\n  &-dark&-vertical-left,\n  &-dark&-vertical-right {\n    border-right: 0;\n  }\n\n  &-dark&-inline &-item,\n  &-dark&-vertical &-item,\n  &-dark&-vertical-left &-item,\n  &-dark&-vertical-right &-item {\n    left: 0;\n    margin-left: 0;\n    border-right: 0;\n    &::after {\n      border-right: 0;\n    }\n  }\n\n  &-dark&-inline &-item,\n  &-dark&-inline &-submenu-title {\n    width: 100%;\n  }\n\n  &-dark &-item:hover,\n  &-dark &-item-active,\n  &-dark &-submenu-active,\n  &-dark &-submenu-open,\n  &-dark &-submenu-selected,\n  &-dark &-submenu-title:hover {\n    color: @menu-dark-highlight-color;\n    background-color: transparent;\n    > a,\n    > span > a {\n      color: @menu-dark-highlight-color;\n    }\n    > .@{menu-prefix-cls}-submenu-title {\n      > .@{menu-prefix-cls}-submenu-arrow {\n        opacity: 1;\n        &::after,\n        &::before {\n          background: @menu-dark-highlight-color;\n        }\n      }\n    }\n  }\n  &-dark &-item:hover {\n    background-color: @menu-dark-item-hover-bg;\n  }\n\n  &-dark&-dark:not(&-horizontal) &-item-selected {\n    background-color: @menu-dark-item-active-bg;\n  }\n\n  &-dark &-item-selected {\n    color: @menu-dark-highlight-color;\n    border-right: 0;\n    &::after {\n      border-right: 0;\n    }\n    > a,\n    > span > a,\n    > a:hover,\n    > span > a:hover {\n      color: @menu-dark-highlight-color;\n    }\n\n    .@{menu-prefix-cls}-item-icon,\n    .@{iconfont-css-prefix} {\n      color: @menu-dark-selected-item-icon-color;\n\n      + span {\n        color: @menu-dark-selected-item-text-color;\n      }\n    }\n  }\n\n  &&-dark &-item-selected,\n  &-submenu-popup&-dark &-item-selected {\n    background-color: @menu-dark-item-active-bg;\n  }\n\n  // Disabled state sets text to dark gray and nukes hover/tab effects\n  &-dark &-item-disabled,\n  &-dark &-submenu-disabled {\n    &,\n    > a,\n    > span > a {\n      color: @disabled-color-dark !important;\n      opacity: 0.8;\n    }\n    > .@{menu-prefix-cls}-submenu-title {\n      color: @disabled-color-dark !important;\n      > .@{menu-prefix-cls}-submenu-arrow {\n        &::before,\n        &::after {\n          background: @disabled-color-dark !important;\n        }\n      }\n    }\n  }\n}\n","@import '../../style/themes/index';\n@import '../../style/mixins/index';\n\n@menu-prefix-cls: ~'@{ant-prefix}-menu';\n\n.@{menu-prefix-cls} {\n  &&-rtl {\n    direction: rtl;\n    text-align: right;\n  }\n\n  &-item-group-title {\n    .@{menu-prefix-cls}-rtl & {\n      text-align: right;\n    }\n  }\n\n  &-inline,\n  &-vertical {\n    .@{menu-prefix-cls}-rtl& {\n      border-right: none;\n      border-left: @border-width-base @border-style-base @border-color-split;\n    }\n  }\n\n  &-dark&-inline,\n  &-dark&-vertical {\n    .@{menu-prefix-cls}-rtl& {\n      border-left: none;\n    }\n  }\n\n  &-vertical&-sub,\n  &-vertical-left&-sub,\n  &-vertical-right&-sub {\n    > .@{menu-prefix-cls}-item,\n    > .@{menu-prefix-cls}-submenu {\n      .@{menu-prefix-cls}-rtl& {\n        transform-origin: top right;\n      }\n    }\n  }\n\n  &-item,\n  &-submenu-title {\n    .@{menu-prefix-cls}-item-icon,\n    .@{iconfont-css-prefix} {\n      .@{menu-prefix-cls}-rtl & {\n        margin-right: auto;\n        margin-left: @menu-icon-margin-right;\n      }\n    }\n\n    &.@{menu-prefix-cls}-item-only-child {\n      > .@{menu-prefix-cls}-item-icon,\n      > .@{iconfont-css-prefix} {\n        .@{menu-prefix-cls}-rtl & {\n          margin-left: 0;\n        }\n      }\n    }\n  }\n\n  &-submenu {\n    &-rtl.@{menu-prefix-cls}-submenu-popup {\n      transform-origin: 100% 0;\n    }\n\n    &-vertical,\n    &-vertical-left,\n    &-vertical-right,\n    &-inline {\n      > .@{menu-prefix-cls}-submenu-title .@{menu-prefix-cls}-submenu-arrow {\n        .@{menu-prefix-cls}-rtl & {\n          right: auto;\n          left: 16px;\n        }\n      }\n    }\n\n    &-vertical,\n    &-vertical-left,\n    &-vertical-right {\n      > .@{menu-prefix-cls}-submenu-title .@{menu-prefix-cls}-submenu-arrow {\n        &::before {\n          .@{menu-prefix-cls}-rtl & {\n            transform: rotate(-45deg) translateY(-2px);\n          }\n        }\n        &::after {\n          .@{menu-prefix-cls}-rtl & {\n            transform: rotate(45deg) translateY(2px);\n          }\n        }\n      }\n    }\n  }\n\n  &-vertical,\n  &-vertical-left,\n  &-vertical-right,\n  &-inline {\n    .@{menu-prefix-cls}-item {\n      &::after {\n        .@{menu-prefix-cls}-rtl& {\n          right: auto;\n          left: 0;\n        }\n      }\n    }\n\n    .@{menu-prefix-cls}-item,\n    .@{menu-prefix-cls}-submenu-title {\n      .@{menu-prefix-cls}-rtl& {\n        text-align: right;\n      }\n    }\n  }\n\n  &-inline {\n    .@{menu-prefix-cls}-submenu-title {\n      .@{menu-prefix-cls}-rtl& {\n        padding-right: 0;\n        padding-left: 34px;\n      }\n    }\n  }\n\n  &-vertical {\n    .@{menu-prefix-cls}-submenu-title {\n      .@{menu-prefix-cls}-rtl& {\n        padding-right: 16px;\n        padding-left: 34px;\n      }\n    }\n  }\n\n  &-inline-collapsed&-vertical {\n    .@{menu-prefix-cls}-submenu-title {\n      .@{menu-prefix-cls}-rtl& {\n        padding: 0 ~'calc(50% - @{menu-icon-size-lg} / 2)';\n      }\n    }\n  }\n\n  &-item-group-list {\n    .@{menu-prefix-cls}-item,\n    .@{menu-prefix-cls}-submenu-title {\n      .@{menu-prefix-cls}-rtl & {\n        padding: 0 28px 0 16px;\n      }\n    }\n  }\n\n  &-sub&-inline {\n    border: 0;\n    & .@{menu-prefix-cls}-item-group-title {\n      .@{menu-prefix-cls}-rtl& {\n        padding-right: 32px;\n        padding-left: 0;\n      }\n    }\n  }\n}\n","@import './antd';\n@import './re-theme/colors';\n@import '../../node_modules/antd/lib/menu/style/index.less';\n@menu-inline-toplevel-item-height: 70px;\n@menu-item-height: 70px;\n@visibility-submenu-max-width: 285px;\n\n.ant-menu {\n  &-item {\n    border-bottom: 1px solid rgba(34, 38, 60, 0.08);\n    padding: 0 12px !important;\n  }\n\n  &-item-selected {\n    background: transparent !important;\n    font-weight: 700;\n  }\n\n  &-vertical,\n  &-vertical-left,\n  &-vertical-right,\n  &-inline {\n    .ant-menu-item,\n    .ant-menu-submenu-title {\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n\n    .ant-menu-item:not(:last-child) {\n      margin-bottom: 0;\n    }\n  }\n\n  &.ant-menu-vertical {\n    border: 0;\n  }\n}\n\n.menu {\n  width: 226px;\n  border-radius: 10px;\n  overflow: hidden;\n\n  @dropdownMenuShadow:\n    0 2px 4px -1px rgba(0, 0, 0, 0.2),\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12);\n  -webkit-box-shadow: @dropdownMenuShadow;\n  -moz-box-shadow: @dropdownMenuShadow;\n  box-shadow: @dropdownMenuShadow;\n}\n\n.pf-theme {\n  .ant-dropdown {\n    .ant-menu {\n      width: 226px;\n      overflow: hidden;\n      border: none;\n\n      &-item {\n        padding: 0 12px !important;\n        height: 36px !important;\n        line-height: 36px !important;\n        border: 0;\n        transition: none;\n        margin: 0;\n        font-size: @pf-font-size-base;\n\n        a {\n          color: @color-grey-10;\n          transition: none;\n        }\n\n        &:hover {\n          color: white !important;\n        }\n\n        &:active,\n        &:focus,\n        &:hover {\n          background-color: @color-blue-1 !important;\n\n          a {\n            color: @color-blue-6 !important;\n          }\n        }\n      }\n\n      &-item:last-child {\n        border-top: 1px solid #e1e6ec;\n      }\n    }\n\n    .ant-dropdown-menu-item-short {\n      height: @menu-link-height!important;\n      line-height: @menu-link-height!important;\n      margin: 3px 0;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n    }\n  }\n\n  .rule-submenu-list.ant-dropdown-menu-submenu {\n    ul {\n      max-width: 320px;\n      max-height: 326px;\n      overflow: auto;\n    }\n\n    li {\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .rule-submenu-list-visibility.ant-dropdown-menu-submenu {\n    ul {\n      max-width: @visibility-submenu-max-width;\n    }\n  }\n\n  .rule-submenu-list-grouped.ant-dropdown-menu-submenu {\n    ul {\n      min-width: 280px;\n      max-height: 426px;\n    }\n  }\n\n  .ant-dropdown-menu-green {\n    .ant-dropdown-menu-item-active {\n      background-color: @color-green-1b!important;\n      color: @color-grey-10!important;\n    }\n    .ant-dropdown-menu-submenu-active:hover\n      .ant-dropdown-menu-submenu-title:hover {\n      background-color: @color-green-1b!important;\n    }\n  }\n}\n\nmain,\naside {\n  .ant-dropdown-menu {\n    padding: 6px 8px !important;\n  }\n}\n\n.account-settings__item {\n  color: @color-grey-10;\n\n  &.ant-menu-item-active,\n  &.ant-menu-item-active:active,\n  &.ant-menu-item-active:focus,\n  &.ant-menu-item-active:hover {\n    a {\n      color: @color-blue-6;\n    }\n  }\n\n  &.ant-menu-item-selected,\n  .ant-menu-item-selected:active,\n  &.ant-menu-item-selected:focus,\n  &.ant-menu-item-selected:hover {\n    a {\n      color: @color-blue-6;\n    }\n  }\n}\n\n.pf-new-theme {\n  .recall-container .ant-menu {\n    padding-right: 0 !important;\n  }\n}\n\n.ant-menu-sub[id*='loop-merge-popup'],\n.ant-menu-sub[id*='recall-questions'] {\n  li {\n    height: auto !important;\n    overflow: visible !important;\n    border: 0 !important;\n    padding: 2px 8px !important;\n    font-weight: normal !important;\n\n    &:active,\n    &:focus,\n    &:hover {\n      color: inherit !important;\n    }\n  }\n\n  .ant-menu-vertical > .ant-menu-item {\n    line-height: 30px !important;\n    height: 32px !important;\n  }\n}\n",".radius-label {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.radius-slider-wrapper {\n  display: inline-flex;\n  flex-direction: row;\n  width: 150px;\n\n  .ant-slider-handle {\n    background-color: @blue-6!important;\n    margin-top: -6px !important;\n    border: 0 !important;\n  }\n\n  .ant-slider-rail {\n    background-color: @color-grey-7!important;\n  }\n\n  .ant-slider-track {\n    background-color: @blue-6!important;\n  }\n\n  .ant-slider-track,\n  .ant-slider-rail {\n    height: 2px;\n  }\n}\n\n.radius-slider {\n  flex: 1;\n  height: 8px !important;\n}\n\n.radius-slider-input.ant-input-number {\n  width: 50px !important;\n  border: 0 !important;\n}\n\n.radius-map-search {\n  text-indent: 10px;\n  z-index: 50;\n  width: 100% !important;\n  margin-left: 0 !important;\n  margin-bottom: 12px;\n  left: initial !important;\n  background-color: @color-grey-4!important;\n  position: relative !important;\n  height: 38px !important;\n  @boxShadow: none !important;\n  -webkit-box-shadow: @boxShadow;\n  -moz-box-shadow: @boxShadow;\n  box-shadow: @boxShadow;\n  &::placeholder {\n    color: @color-grey-9 !important;\n  }\n  &:focus,\n  &:active {\n    border-color: #40a9ff;\n    outline: 0;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;\n  }\n}\n",".logic-tooltip {\n  padding-top: 0;\n  max-width: unset;\n\n  .ant-tooltip-arrow {\n    top: -12px !important;\n  }\n\n  .ant-tooltip-inner {\n    line-height: 1;\n    padding-top: 0;\n    padding-bottom: 0;\n    min-height: initial;\n    font-size: 12px;\n    border-radius: 4px;\n  }\n}\n","@node-color: #ececff;\n@node-border-color: #9370db;\n@node-text: #323945;\n@node-hidden-color: #f3f6fb;\n@node-hidden-border-color: #e0e6ed;\n@node-hidden-text: #bfc8d5;\n\n.logic-path-preview {\n  backface-visibility: hidden;\n  -webkit-backface-visibility: hidden;\n\n  .node {\n    rect,\n    polygon,\n    circle,\n    ellipse {\n      fill: @node-color;\n      stroke: @node-border-color;\n      stroke-width: 1px;\n    }\n\n    text {\n      fill: @node-text;\n      font-weight: bold;\n    }\n\n    .question-index {\n      font-size: 12px;\n      font-weight: bold;\n    }\n\n    .question-text {\n      font-size: 12px;\n      font-weight: 400;\n    }\n\n    &.node-hidden {\n      rect,\n      polygon,\n      circle,\n      ellipse {\n        fill: @node-hidden-color;\n        stroke: @node-hidden-border-color;\n        stroke-width: 1px;\n      }\n\n      text {\n        fill: @node-hidden-text;\n        font-weight: bold;\n      }\n    }\n\n    &.node-display-logic {\n      rect,\n      polygon,\n      circle,\n      ellipse {\n        stroke-dasharray: 3, 3;\n      }\n    }\n\n    &.clickable {\n      rect,\n      polygon,\n      circle,\n      ellipse {\n        cursor: pointer;\n      }\n      text,\n      div {\n        cursor: pointer;\n        user-select: none;\n      }\n      &:hover:not(.node-logic-icon-hover) {\n        rect,\n        polygon,\n        circle,\n        ellipse {\n          stroke-width: 2px;\n        }\n      }\n    }\n\n    .display-logic-action,\n    .hidden-logic-action {\n      display: flex;\n    }\n\n    .node-logic-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      width: 16px;\n      height: 16px;\n      border-radius: 50%;\n\n      &-purple {\n        background-color: #dedeff;\n\n        &:hover {\n          background-color: #d6d6fb;\n        }\n      }\n    }\n  }\n\n  .edgePath {\n    path.path {\n      stroke: @node-border-color;\n      fill: @node-border-color;\n      stroke-width: 1px;\n    }\n\n    &.dashed {\n      stroke-dasharray: 5, 5;\n    }\n  }\n\n  .arrowhead {\n    stroke: @node-border-color;\n    fill: @node-border-color;\n    stroke-width: 1.5px;\n  }\n\n  .node-label {\n    padding: 10px;\n    position: relative;\n  }\n}\n\n.logic-path-actions {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  width: 24px;\n\n  button {\n    width: 24px;\n    height: 24px;\n    border: 1px solid @node-border-color;\n    opacity: 1;\n    &:active,\n    &:focus,\n    &:hover {\n      border-color: @node-border-color;\n    }\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  .pf-new-theme & {\n    .ant-btn {\n      color: @node-border-color;\n      font-size: 12px;\n    }\n  }\n}\n\n.logic-path-info {\n  position: absolute;\n  top: 5px;\n  left: 10px;\n\n  &-item {\n    background-color: #eff3f7;\n    border-radius: 36px;\n  }\n}\n",".grippy {\n  position: relative;\n  height: 0px;\n  font-size: 12px;\n  color: @node-text;\n  cursor: move;\n  z-index: 2;\n  top: 7px;\n  left: 8px;\n  transition: left 0.25s;\n\n  div {\n    display: flex;\n    align-items: center;\n    height: 52px;\n    width: 35px;\n    padding: 0 10px 0 18px;\n  }\n}\n\n.drag-card {\n  &.drag-guide-bottom,\n  &.drag-guide-top {\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      right: 0;\n      height: 2px;\n      background: @color-grey-10;\n    }\n  }\n\n  &.drag-guide-bottom:after {\n    bottom: -1px;\n    transform: translateY(50%);\n  }\n  &.drag-guide-top:after {\n    top: -1px;\n    transform: translateY(-50%);\n  }\n\n  &:hover + .add-question__button-wrapper .add-question__button {\n    display: inline-block !important;\n  }\n\n  &.group-active.drag-type-group:not(.reset-grippy) {\n    > .grippy {\n      top: 7px;\n      left: -10px;\n    }\n  }\n\n  &.drag-type-question,\n  &.drag-type-screening-question,\n  &.drag-type-question-group-only {\n    transition: all 0.3s;\n    .grippy {\n      top: 3px;\n      left: 0;\n    }\n\n    .ant-collapse-content-box > .ant-divider-horizontal {\n      width: calc(100% + 24px);\n      margin-left: -24px;\n    }\n  }\n\n  &.drag-type-screening-question {\n    .grippy {\n      top: 16px;\n    }\n  }\n\n  &.group-active.drag-type-question:not(.reset-grippy),\n  &.group-active.drag-type-question-group-only:not(.reset-grippy) {\n    .grippy {\n      top: 3px;\n      left: -20px;\n    }\n  }\n\n  &.group-active.drag-type-screening-question:not(.reset-grippy) {\n    .grippy {\n      top: 16px;\n      left: -20px;\n    }\n  }\n\n  &.drag-type-group {\n    .drag-type-question.group-active {\n      .grippy {\n        left: -28px;\n      }\n    }\n  }\n\n  &.drag-type-group-property {\n    > .grippy {\n      top: 18px;\n      left: 8px;\n      opacity: 0;\n      transition: opacity 0.15s ease;\n\n      &.cursor-disabled {\n        pointer-events: none;\n      }\n    }\n\n    // Keep pointer-events on the handle so its overflow hit target can be hovered.\n    // Direct-child only: nested level handles must not light up with the attribute.\n    > .grippy:not(.cursor-disabled):hover,\n    &:hover:not(:has(.drag-card:hover)) > .grippy:not(.cursor-disabled),\n    &:focus-within:not(:has(.drag-card:focus-within))\n      > .grippy:not(.cursor-disabled) {\n      opacity: 1;\n    }\n  }\n\n  // Align with attribute grippy (left: 8px on .drag-type-group-property).\n  // Level rows sit inside collapse paddingLeft 32 + content margin-left 18.\n  &.drag-type-attribute-level {\n    > .grippy {\n      top: 4px;\n      left: -42px;\n      opacity: 0;\n      transition: opacity 0.15s ease;\n\n      &.cursor-disabled {\n        pointer-events: none;\n      }\n\n      div {\n        height: 30px;\n        width: 35px;\n        padding: 0 10px 0 18px;\n      }\n    }\n\n    > .grippy:not(.cursor-disabled):hover,\n    &:hover > .grippy:not(.cursor-disabled),\n    &:focus-within > .grippy:not(.cursor-disabled) {\n      opacity: 1;\n    }\n  }\n}\n\n.is-drop-active {\n  &.group-active {\n    .drop-box {\n      background-color: @color-grey-2;\n    }\n  }\n\n  .drop-box {\n    background-color: @color-grey-4;\n  }\n}\n\n.ant-collapse-inactive-arrow .ant-collapse-arrow {\n  color: @color-grey-7!important;\n}\n\n.questionnaire-card {\n  transition:\n    margin-left 0.3s,\n    background-color 0.2s;\n\n  &.questionnaire-card-hidden {\n    &:before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 3;\n      border-radius: inherit;\n    }\n\n    > * {\n      position: relative;\n    }\n  }\n\n  .ant-collapse-arrow,\n  .keep-opaque-element {\n    position: relative;\n    z-index: 4;\n  }\n}\n\n.questionnaire-group {\n  transition:\n    margin-left 0.3s,\n    background-color 0.3s;\n\n  .ant-collapse-borderless {\n    background-color: transparent !important;\n  }\n\n  .ant-collapse > .ant-collapse-item > .ant-collapse-header {\n    cursor: default;\n  }\n\n  .group-active & {\n    //slate ui is cropped inside overflow hidden\n    // for the first question\n    .ant-collapse-content {\n      overflow: visible;\n    }\n  }\n\n  .ant-collapse-content {\n    overflow: visible;\n  }\n\n  .pf-new-theme & {\n    .questionnnaire-card {\n      background-color: #f5f7fa;\n    }\n\n    &.dragging {\n      opacity: 0.2;\n    }\n\n    .dragging {\n      .questionnaire-card {\n        opacity: 0.2;\n      }\n    }\n\n    .group-active {\n      .questionnnaire-card {\n        background-color: #fff;\n      }\n    }\n  }\n\n  &.questionnaire-group-hidden {\n    &:before {\n      transition: all 0.3s;\n      content: '';\n      position: absolute;\n      inset: 0;\n      background: rgba(255, 255, 255, 0.8);\n      z-index: 4;\n      bottom: 8px;\n    }\n\n    &.margin-left-negative-md {\n      &:before {\n        left: -16px;\n      }\n    }\n\n    > * {\n      position: relative;\n    }\n  }\n\n  .ant-collapse-arrow,\n  .keep-opaque-element {\n    position: relative;\n    z-index: 4;\n  }\n\n  .questionnaire-card,\n  .attribute-group-card {\n    .ant-collapse-arrow {\n      z-index: 3;\n    }\n  }\n}\n\n.pf-ant-collapse {\n  &.ant-collapse-question {\n    padding-left: 24px;\n  }\n}\n\n.move-questions-modal {\n  .ant-checkbox {\n    display: inline-block;\n  }\n\n  .checked {\n    background-color: @color-modal-item;\n  }\n\n  .ant-checkbox-wrapper {\n    &.checked {\n      background-color: @color-modal-item;\n    }\n  }\n\n  .pf-select .ant-select-selector-placeholder {\n    color: @color-grey-10 !important;\n  }\n\n  .pf-new-theme & {\n    .ant-modal-body {\n      padding: 0;\n    }\n  }\n}\n\n.drilldown-manually-modal {\n  .pf-new-theme & {\n    .ant-modal-body {\n      padding: 0;\n    }\n\n    .ant-modal-content {\n      padding: 16px;\n    }\n\n    &.ant-modal {\n      .ant-modal-header {\n        padding-bottom: 8px;\n      }\n    }\n  }\n\n  .ant-input:hover,\n  .ant-input:focus {\n    border-color: @color-grey-5;\n    box-shadow: none;\n  }\n}\n\n.node-type-select,\n.conjoint-select,\n.matrix-select,\n.abType-select {\n  &.ant-select-disabled {\n    .ant-select-selector {\n      background-color: white;\n      border: 1px solid @color-grey-5;\n    }\n\n    .ant-select-selector-selected-value {\n      color: @color-grey-7 !important;\n    }\n\n    .ant-select-arrow {\n      color: @color-grey-7 !important;\n    }\n  }\n}\n\n.node-type-select {\n  // override opacity on selected\n  .ant-select-selection-item {\n    .opacity-40 {\n      opacity: 1;\n    }\n  }\n\n  &.custom-question-select {\n    &.ant-select.ant-select-single {\n      height: 32px;\n\n      .ant-select-selector {\n        height: 32px;\n      }\n\n      .ant-select-selection-item {\n        line-height: 30px;\n      }\n    }\n  }\n}\n\n.conjoint-select {\n  &.ant-select.ant-select-single {\n    &:not(.ant-select-customize-input) {\n      .ant-select-selector {\n        height: 30px;\n        .ant-select-selection-item {\n          color: @color-grey-10;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n}\n\n.questions-setting-shuffling {\n  .ant-select-disabled {\n    .ant-select-selector {\n      background-color: white;\n      border: 1px solid @color-grey-5;\n    }\n\n    .ant-select-selector-selected-value {\n      color: @color-grey-7 !important;\n    }\n\n    .ant-select-arrow {\n      color: @color-grey-7 !important;\n    }\n  }\n}\n\n.add-question-img-wrapper {\n  // width: 305px;\n  // the width of image has increased from 305\n  // real image size 482 x 518\n  // height 366, so width should be 340.56\n  width: 341px;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.pf-theme .color-light-green:focus {\n  color: @color-light-green;\n}\n\n.force {\n  &-background {\n    &-grey-1 {\n      background-color: @color-grey-1 !important;\n      background: @color-grey-1 !important;\n    }\n\n    &-grey-2 {\n      background-color: @color-grey-2 !important;\n      background: @color-grey-2 !important;\n    }\n\n    &-transparent {\n      background-color: transparent !important;\n      background: transparent !important;\n    }\n  }\n\n  &-text {\n    &-weight {\n      &-regular {\n        font-weight: @font-weight-regular !important;\n      }\n    }\n\n    &-weight-500 {\n      font-weight: 500;\n    }\n\n    &-weight-700 {\n      font-weight: 700;\n    }\n  }\n\n  &-border {\n    &-right {\n      &-grey-4 {\n        border-right: 1px solid @color-grey-4 !important;\n      }\n      &-grey-6 {\n        border-right: 1px solid @color-grey-6 !important;\n      }\n\n      &-none {\n        border-right: 0px !important;\n      }\n    }\n\n    &-bottom {\n      &-grey-4 {\n        border-bottom: 1px solid @color-grey-4 !important;\n      }\n\n      &-transparent {\n        border-bottom: 1px solid transparent !important;\n      }\n    }\n  }\n}\n\n.pf-theme .table-node .ant-table-tbody > tr > td:first-child {\n  border-left: none;\n}\n.table-node\n  .ant-table-tbody\n  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)\n  > td {\n  background: transparent;\n}\n\n.table-node {\n  .ant-table-header-column {\n    width: 100%;\n  }\n  textarea.ant-input {\n    min-height: 0;\n    &:focus {\n      box-shadow: none;\n    }\n  }\n  .ant-table-thead\n    > tr\n    > th:not(:last-child):not(.ant-table-selection-column):not(\n      .ant-table-row-expand-icon-cell\n    ):not([colspan])::before {\n    width: 0;\n    //TODO: if we want to style border from this css class\n    // height: 100%;\n  }\n\n  &.table-node--hide {\n    .ant-table-content {\n      overflow: hidden !important;\n    }\n  }\n}\n\n.ant-table-tbody\n  > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(\n    .ant-table-row-selected\n  )\n  > td {\n  background: transparent;\n}\n\n.input-auto-sizer {\n  display: inline-grid;\n  font-size: 12px;\n\n  &::after,\n  input {\n    width: auto;\n    min-width: 1em;\n    grid-area: ~' 1 / 2';\n    font: inherit;\n    padding: 0;\n    margin: 0;\n    resize: none;\n    background: none;\n    appearance: none;\n    border: none;\n    outline: none;\n  }\n\n  &::after {\n    content: attr(data-value) ' ';\n    visibility: hidden;\n    white-space: pre-wrap;\n  }\n}\n\n.group-same-page {\n  &-border {\n    border: 1px solid #2e69f080;\n    border-style: dashed;\n  }\n\n  &-label {\n    background-color: #2e69f0;\n    width: 117px;\n    left: 25px;\n    position: relative;\n\n    .group-active & {\n      left: 23px;\n    }\n  }\n\n  &.drag-type-group:not(.reset-grippy) {\n    > .grippy {\n      top: 27px !important;\n    }\n  }\n}\n\n.group-loop-and-merge {\n  &-label {\n    background-color: @color-grey-4;\n    width: 105px;\n    left: 25px;\n    position: relative;\n\n    .group-active & {\n      left: 23px;\n    }\n  }\n\n  &.drag-type-group:not(.reset-grippy) {\n    > .grippy {\n      top: 27px !important;\n    }\n  }\n}\n","@import './antd';\n\n.screening-details {\n  position: absolute;\n  z-index: 5;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 200px;\n  max-width: 390px;\n  height: auto;\n  overflow: auto;\n  background-color: white;\n  color: @color-grey-10;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 4px 8px 0 rgba(92, 103, 118, 0.2);\n  -moz-box-shadow: 0 4px 8px 0 rgba(92, 103, 118, 0.2);\n  box-shadow: 0 4px 8px 0 rgba(92, 103, 118, 0.2);\n}\n\n.screening-details-header {\n  position: sticky;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 32px;\n  background-color: @color-grey-5;\n  padding: 0 16px;\n  z-index: 1000;\n  text-indent: -1px;\n}\n\n.screening-details-content {\n  padding: 16px;\n}\n\n.screening-details-close {\n  border: 0;\n  padding: 0;\n  margin-right: -3px;\n}\n\n.screening-details-row {\n  margin-bottom: 7px;\n}\n\n.screening-details-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  &:before {\n    content: ' ';\n    display: block;\n    width: 8px;\n    height: 8px;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    border-radius: 50%;\n    background-color: #61a8ff;\n    margin-right: 8px;\n  }\n\n  &.screening-details-item--no:before {\n    background-color: @color-orange-3;\n  }\n}\n\n.screening-details-bar-wrapper {\n  margin: 0 4px;\n}\n\n.screening-details-bar {\n  width: 100%;\n\n  &.screening-details-bar--reverse {\n    direction: rtl;\n  }\n\n  .ant-progress-bg {\n    background-color: #eef3f7;\n  }\n\n  &.screening-details-bar--orange {\n    .ant-progress-bg {\n      background-color: @color-orange-3;\n    }\n  }\n  &.screening-details-bar--blue {\n    .ant-progress-bg {\n      background-color: #61a8ff;\n    }\n  }\n}\n\n.screening-details-bar-number {\n  position: absolute;\n  z-index: 1;\n  top: -10px;\n  right: 0;\n\n  &.screening-details-bar-number--reverse {\n    left: 2px;\n    right: initial;\n  }\n}\n\n.screening-details-secondary {\n  color: @color-grey-7;\n}\n\n.screening-details-answer-index {\n  width: 30px;\n}\n",".ant-tag-no-hover {\n  opacity: 1!important;\n}\n",".icon-disabled {\n  &.icon-ab-group .path1::before {\n    color: @color-grey-5;\n  }\n\n  &.icon-ab-group .path2::before {\n    color: @color-grey-8;\n  }\n\n  &.icon-conjoint .path1::before {\n    color: @color-grey-5;\n  }\n\n  &.icon-conjoint .path2::before {\n    color: @color-grey-8;\n  }\n\n  &.icon-maxdiff-group .path1::before {\n    color: @color-grey-5;\n  }\n\n  &.icon-maxdiff-group .path2::before,\n  &.icon-maxdiff-group .path3::before {\n    color: @color-grey-8;\n  }\n\n  &.icon-van-westendorp-group .path1::before {\n    color: @color-grey-5;\n  }\n\n  &.icon-van-westendorp-group .path2::before,\n  &.icon-van-westendorp-group .path3::before,\n  &.icon-van-westendorp-group .path4::before,\n  &.icon-van-westendorp-group .path5::before,\n  &.icon-van-westendorp-group .path6::before {\n    color: @color-grey-8;\n  }\n\n  &.icon-screening::before {\n    background-color: @color-grey-7;\n    border-radius: 4px;\n  }\n\n  &.icon-question-group::before {\n    background-color: @color-grey-7;\n    border-radius: 4px;\n  }\n\n  &.icon-loop-merge-boxed::before {\n    background-color: @color-grey-7;\n    border-radius: 4px;\n  }\n}\n",".audience-template-card {\n  &:hover {\n    .display-container {\n      display: none;\n    }\n\n    .hover-container {\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n\n      .template-description {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        line-height: 1.2em;\n        max-height: 2.4em;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .hover-container {\n    display: none;\n  }\n}\n",".pf-new-theme {\n  @import './typography';\n  @import './colors';\n  @import './shadows';\n  @import './spacing';\n  @import './layout';\n  @import './integrations';\n  @import './tabs';\n  @import './animations';\n  @import './survey-summary';\n  @import './grid';\n  @import './shame';\n  @import './peeq';\n  @import './questionnaire-revisions';\n  @import './ai-builder';\n  @import './answer';\n\n  * {\n    -webkit-font-smoothing: antialiased;\n  }\n  // generate relevent color classes for each color (1-10)\n  // .background-<color>-<number>\n  // .border-<color>-<number>\n  // .color-<color>-<number>\n  //\n  // resulting in\n  // .background-blue-1{ background-color: @blue-1}\n  // .border-blue-1{ border: 1px solid @blue-1}\n  // etc...\n  .generateSingleColor(brand);\n  .generateSingleColor(transparent);\n  .generateSingleColor(malachite);\n  .generateSingleColor(guest);\n  .generateSingleColor(purple-dark);\n\n  .generateColor(grey, 10);\n  .generateColor(blue, 10);\n  .generateColor(purple, 10);\n  .generateColor(green, 10);\n  .generateColor(light-green, 10);\n  .generateColor(magenta, 10);\n  .generateColor(red, 10);\n  .generateColor(yellow, 10);\n  .generateColor(orange, 10);\n\n  .opacityLoop(100, 10, 0);\n\n  .background-inherit {\n    background: inherit;\n  }\n  .color-inherit {\n    color: inherit;\n  }\n\n  // generate shadow levels per color\n  // .shadow-<colorgroup>-level-<number>\n  //\n  // resulting in\n  // .shadow-color-1-5-level-1{}\n  // .shadow-color-1-5-level-1-hover:hover{}\n  // .shadow-color-6-10-level-3{}\n  // .shadow-color-6-10-level-3-hover:hover{}\n  // .shadow-light-level-5{}\n  // .shadow-light-level-5-hover:hover{}\n  .shadow {\n    &-none,\n    &-none-focus:focus,\n    &-none-hover:hover {\n      box-shadow: none;\n    }\n    &-color {\n      &-1-5 {\n        .generateShadowLevels(@shadow-color-1-5, 5);\n        .generateShadowLevels(@shadow-color-1-5, 5, ~'-hover:hover');\n      }\n      &-6-10 {\n        .generateShadowLevels(@shadow-color-6-10, 5);\n        .generateShadowLevels(@shadow-color-6-10, 5, ~'-hover:hover');\n      }\n    }\n    &-light {\n      .generateShadowLevels(@shadow-color-light, 5);\n      .generateShadowLevels(@shadow-color-light, 5, ~'-hover:hover');\n    }\n\n    &-light-grey-hover:hover {\n      box-shadow: 0 4px 6px 0 #e1e7eb;\n    }\n\n    &-light-grey-2-hover:hover {\n      box-shadow: 0 2px 16px 0 #e1e7ebc2;\n    }\n  }\n\n  .text-shadow-none {\n    text-shadow: none;\n  }\n\n  .shadow-transition {\n    transition: box-shadow 0.2s ease-in-out;\n  }\n\n  .transition-none {\n    transition: none;\n  }\n\n  .transition-all-ease-out {\n    transition: all 0.3s ease-out;\n  }\n\n  // Warning: Overrides text-font-weight if applied later into the file\n  .ant-btn {\n    font-weight: normal;\n    padding-left: @space-md;\n    padding-right: @space-md;\n    font-size: 14px;\n\n    &.ant-btn-primary {\n      box-shadow: none;\n    }\n  }\n\n  // generating spacing classes\n  .create-spacing(margin, none, 0);\n  .create-spacing(margin, auto, auto);\n  .create-spacing(margin, tiny, @space-tiny);\n  .create-spacing(margin, xxs, @space-xxs);\n  .create-spacing(margin, xs, @space-xs);\n  .create-spacing(margin, sm, @space-sm);\n  .create-spacing(margin, md, @space-md);\n  .create-spacing(margin, lg, @space-lg);\n  .create-spacing(margin, xl, @space-xl);\n  .create-spacing(margin, xxl, @space-xxl);\n\n  .create-negative-spacing(margin, none, 0);\n  .create-negative-spacing(margin, tiny, @space-tiny);\n  .create-negative-spacing(margin, xxs, @space-xxs);\n  .create-negative-spacing(margin, xs, @space-xs);\n  .create-negative-spacing(margin, sm, @space-sm);\n  .create-negative-spacing(margin, md, @space-md);\n  .create-negative-spacing(margin, lg, @space-lg);\n  .create-negative-spacing(margin, xl, @space-xl);\n  .create-negative-spacing(margin, xxl, @space-xxl);\n\n  .create-spacing(padding, none, 0);\n  .create-spacing(padding, tiny, @space-tiny);\n  .create-spacing(padding, xxs, @space-xxs);\n  .create-spacing(padding, xs, @space-xs);\n  .create-spacing(padding, sm, @space-sm);\n  .create-spacing(padding, md, @space-md);\n  .create-spacing(padding, lg, @space-lg);\n  .create-spacing(padding, xl, @space-xl);\n  .create-spacing(padding, xxl, @space-xxl);\n\n  .create-gap(none, 0);\n  .create-gap(tiny, @space-tiny);\n  .create-gap(xxs, @space-xxs);\n  .create-gap(xs, @space-xs);\n  .create-gap(sm, @space-sm);\n  .create-gap(md, @space-md);\n  .create-gap(lg, @space-lg);\n  .create-gap(xl, @space-xl);\n  .create-gap(xxl, @space-xxl);\n\n  .create-spacing-important(margin, none, 0);\n  .create-spacing-important(margin, auto, auto);\n  .create-spacing-important(margin, tiny, @space-tiny);\n  .create-spacing-important(margin, xxs, @space-xxs);\n  .create-spacing-important(margin, xs, @space-xs);\n  .create-spacing-important(margin, sm, @space-sm);\n  .create-spacing-important(margin, md, @space-md);\n  .create-spacing-important(margin, lg, @space-lg);\n  .create-spacing-important(margin, xl, @space-xl);\n  .create-spacing-important(margin, xxl, @space-xxl);\n\n  .create-negative-spacing-important(margin, none, 0);\n  .create-negative-spacing-important(margin, tiny, @space-tiny);\n  .create-negative-spacing-important(margin, xxs, @space-xxs);\n  .create-negative-spacing-important(margin, xs, @space-xs);\n  .create-negative-spacing-important(margin, sm, @space-sm);\n  .create-negative-spacing-important(margin, md, @space-md);\n  .create-negative-spacing-important(margin, lg, @space-lg);\n  .create-negative-spacing-important(margin, xl, @space-xl);\n  .create-negative-spacing-important(margin, xxl, @space-xxl);\n\n  .create-spacing-important(padding, none, 0);\n  .create-spacing-important(padding, tiny, @space-tiny);\n  .create-spacing-important(padding, xxs, @space-xxs);\n  .create-spacing-important(padding, xs, @space-xs);\n  .create-spacing-important(padding, sm, @space-sm);\n  .create-spacing-important(padding, md, @space-md);\n  .create-spacing-important(padding, lg, @space-lg);\n  .create-spacing-important(padding, xl, @space-xl);\n  .create-spacing-important(padding, xxl, @space-xxl);\n\n  .create-width(none, 0);\n  .create-width(tiny, @space-tiny);\n  .create-width(xxs, @space-xxs);\n  .create-width(xs, @space-xs);\n  .create-width(sm, @space-sm);\n  .create-width(md, @space-md);\n  .create-width(lg, @space-lg);\n  .create-width(xl, @space-xl);\n  .create-width(xxl, @space-xxl);\n\n  // generate border radius levels\n  // .border-radius-<level>\n  //\n  // resulting in\n  // .border-radius-oval{}\n  // .border-radius-level-1{}\n  .border {\n    &-radius {\n      &-none {\n        border-radius: 0;\n      }\n      &-oval {\n        border-radius: 50%;\n      }\n      &-level-1 {\n        border-radius: 4px;\n      }\n      &-level-2 {\n        border-radius: 8px;\n      }\n      &-level-3 {\n        border-radius: 12px;\n      }\n      &-pill {\n        border-radius: 9999em;\n      }\n      &-top {\n        &-level-1 {\n          border-top-left-radius: 4px;\n          border-top-right-radius: 4px;\n        }\n        &-level-2 {\n          border-top-left-radius: 8px;\n          border-top-right-radius: 8px;\n        }\n        &-level-3 {\n          border-top-left-radius: 12px;\n          border-top-right-radius: 12px;\n        }\n        &-none {\n          border-top-left-radius: 0;\n          border-top-right-radius: 0;\n        }\n        &-none-important {\n          border-top-left-radius: 0 !important;\n          border-top-right-radius: 0 !important;\n        }\n        &-left {\n          &-level-1 {\n            border-top-left-radius: 4px;\n            border-bottom-left-radius: 4px;\n          }\n          &-level-2 {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n          }\n          &-level-3 {\n            border-top-left-radius: 12px;\n            border-bottom-left-radius: 12px;\n          }\n          &-none {\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n          }\n          &-none-important {\n            border-top-left-radius: 0 !important;\n            border-bottom-left-radius: 0 !important;\n          }\n        }\n      }\n      &-bottom {\n        &-level-1 {\n          border-bottom-left-radius: 4px;\n          border-bottom-right-radius: 4px;\n        }\n        &-level-2 {\n          border-bottom-left-radius: 8px;\n          border-bottom-right-radius: 8px;\n        }\n        &-level-3 {\n          border-bottom-left-radius: 12px;\n          border-bottom-right-radius: 12px;\n        }\n        &-none {\n          border-bottom-left-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n        &-none-important {\n          border-bottom-left-radius: 0 !important;\n          border-bottom-right-radius: 0 !important;\n        }\n      }\n      &-left {\n        &-level-1 {\n          border-top-left-radius: 4px;\n          border-bottom-left-radius: 4px;\n        }\n        &-level-2 {\n          border-top-left-radius: 8px;\n          border-bottom-left-radius: 8px;\n        }\n        &-level-3 {\n          border-top-left-radius: 12px;\n          border-bottom-left-radius: 12px;\n        }\n        &-none {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n        &-none-important {\n          border-top-left-radius: 0 !important;\n          border-bottom-left-radius: 0 !important;\n        }\n      }\n      &-right {\n        &-level-1 {\n          border-top-right-radius: 4px;\n          border-bottom-right-radius: 4px;\n        }\n        &-level-2 {\n          border-top-right-radius: 8px;\n          border-bottom-right-radius: 8px;\n        }\n        &-level-3 {\n          border-top-right-radius: 12px;\n          border-bottom-right-radius: 12px;\n        }\n        &-none {\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n        &-none-important {\n          border-top-right-radius: 0 !important;\n          border-bottom-right-radius: 0 !important;\n        }\n      }\n    }\n\n    &-horizontal-none {\n      border-left: none;\n      border-right: none;\n    }\n    &-vertical-none {\n      border-top: none;\n      border-bottom: none;\n    }\n    &-left-none {\n      border-left: none;\n    }\n    &-right-none {\n      border-right: none;\n    }\n    &-bottom-none {\n      border-bottom: none;\n    }\n    &-top-none {\n      border-top: none;\n    }\n    &-none {\n      border: none;\n      &-important {\n        border: none !important;\n      }\n    }\n    &-solid {\n      border-style: solid;\n    }\n    &-dashed {\n      border-style: dashed;\n      &-important {\n        border-style: dashed !important;\n      }\n    }\n    &-dotted {\n      border-style: dotted;\n    }\n    &-left-none {\n      border-left: none;\n    }\n    &-top-none {\n      border-top: none;\n    }\n    &-right-none {\n      border-right: none;\n    }\n    &-bottom-none {\n      border-bottom: none;\n    }\n    &-width-1 {\n      border-width: 1px;\n    }\n    &-width-4 {\n      border-width: 4px;\n    }\n  }\n\n  // Typography classes\n  .text {\n    &-color {\n      &-white {\n        .color-grey-1;\n      }\n      &-dark {\n        .color-grey-10;\n      }\n      &-medium {\n        .color-grey-9;\n      }\n      &-low {\n        .color-grey-8;\n      }\n      &-disabled {\n        .color-grey-7;\n      }\n\n      &-success {\n        .color-green-6;\n      }\n      &-danger {\n        .color-red-6;\n      }\n      &-warning {\n        .color-yellow-6;\n      }\n      &-info {\n        .color-purple-6;\n      }\n    }\n    &-weight {\n      &-regular {\n        font-weight: @font-weight-regular;\n      }\n\n      &-100 {\n        font-weight: 100;\n      }\n\n      &-500 {\n        font-weight: 500;\n      }\n\n      &-600 {\n        font-weight: 600;\n      }\n\n      &-bold {\n        font-weight: @font-weight-bold;\n      }\n    }\n\n    &-style {\n      &-italics {\n        font-style: italic;\n      }\n      &-normal {\n        font-style: normal;\n      }\n    }\n\n    &-line-through {\n      text-decoration: line-through;\n    }\n\n    &-size {\n      &-x-small {\n        font-size: @font-size-x-small;\n        line-height: @font-size-x-small-height;\n      }\n      &-small {\n        font-size: @font-size-small;\n        line-height: @font-size-small-height;\n      }\n      &-primary {\n        font-size: @font-size-primary;\n        line-height: @font-size-primary-height;\n      }\n      &-secondary {\n        font-size: @font-size-secondary;\n        line-height: @font-size-secondary-height;\n      }\n      &-h1 {\n        font-size: @font-size-h1;\n        line-height: @font-size-h1-height;\n      }\n      &-h2 {\n        font-size: @font-size-h2;\n        line-height: @font-size-h2-height;\n      }\n      &-h3 {\n        font-size: @font-size-h3;\n        line-height: @font-size-h3-height;\n      }\n      &-h4 {\n        font-size: @font-size-h4;\n        line-height: @font-size-h4-height;\n      }\n      &-h5 {\n        font-size: @font-size-h5;\n        line-height: @font-size-h5-height;\n      }\n      &-h6 {\n        font-size: @font-size-h6;\n        line-height: @font-size-h6-height;\n      }\n\n      &-inherit {\n        font-size: inherit;\n        line-height: inherit;\n      }\n\n      &-18 {\n        font-size: @font-size-18;\n        line-height: @font-size-18-height;\n      }\n\n      &-10 {\n        font-size: 10px;\n      }\n\n      &-8 {\n        font-size: 8px;\n      }\n\n      &-9 {\n        font-size: 9px;\n      }\n\n      &-11 {\n        font-size: 11px;\n      }\n\n      &-12 {\n        font-size: 12px;\n      }\n\n      &-16 {\n        font-size: 16px;\n        &-important {\n          font-size: 16px !important;\n        }\n      }\n      &-19 {\n        font-size: 19px;\n      }\n      &-20 {\n        font-size: 20px;\n      }\n    }\n    &-wrap {\n      &-none {\n        white-space: nowrap;\n      }\n      &-pre {\n        white-space: pre;\n      }\n      &-pre-wrap {\n        white-space: pre-wrap;\n      }\n      &-normal {\n        white-space: normal;\n\n        > .ant-select-item-option-content {\n          white-space: normal !important;\n        }\n      }\n    }\n    &-uppercase {\n      text-transform: uppercase;\n    }\n    &-lowercase {\n      text-transform: lowercase;\n    }\n    &-align {\n      &-center {\n        text-align: center;\n      }\n\n      &-right {\n        text-align: right;\n      }\n\n      &-left {\n        text-align: left;\n      }\n    }\n  }\n\n  h1 {\n    font-size: @font-size-h1;\n    line-height: @font-size-h1-height;\n  }\n  h2 {\n    font-size: @font-size-h2;\n    line-height: @font-size-h2-height;\n  }\n  h3 {\n    font-size: @font-size-h3;\n    line-height: @font-size-h3-height;\n  }\n\n  a[href].alternate {\n    .color-magenta-6;\n  }\n\n  .break-normal {\n    word-break: normal;\n    overflow-wrap: normal;\n  }\n\n  .break-words {\n    overflow-wrap: break-word;\n  }\n\n  .break-all {\n    word-break: break-all;\n  }\n\n  .truncate,\n  .truncate-placeholder::placeholder {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .outline {\n    &-none {\n      outline: none;\n    }\n  }\n\n  // helpers\n  .position {\n    &-relative {\n      position: relative;\n      &-important {\n        position: relative !important;\n      }\n    }\n    &-absolute {\n      position: absolute;\n      &-important {\n        position: absolute !important;\n      }\n    }\n    &-static {\n      position: static;\n      &-important {\n        position: static !important;\n      }\n    }\n    &-fixed {\n      position: fixed;\n      &-important {\n        position: fixed !important;\n      }\n    }\n    &-sticky {\n      position: sticky;\n      &-important {\n        position: sticky !important;\n      }\n    }\n    &-right {\n      right: 0;\n      &-auto {\n        right: auto;\n      }\n    }\n    &-left {\n      left: 0;\n      &-auto {\n        left: auto;\n      }\n    }\n    &-top {\n      top: 0;\n      &-auto {\n        top: auto;\n      }\n      &-sm {\n        top: @space-sm;\n      }\n      &-tiny {\n        top: @space-tiny;\n      }\n    }\n    &-bottom {\n      bottom: 0;\n      &-auto {\n        bottom: auto;\n      }\n    }\n    &-top-right {\n      top: 0;\n      right: 0;\n      &-tiny {\n        top: @space-tiny;\n        right: @space-tiny;\n      }\n    }\n    &-top-left {\n      top: 0;\n      left: 0;\n      &-tiny {\n        top: @space-tiny;\n        left: @space-tiny;\n      }\n    }\n    &-bottom-right {\n      bottom: 0;\n      right: 0;\n      &-tiny {\n        bottom: @space-tiny;\n        right: @space-tiny;\n      }\n    }\n    &-bottom-left {\n      bottom: 0;\n      left: 0;\n      &-tiny {\n        bottom: @space-tiny;\n        left: @space-tiny;\n      }\n    }\n    &-vertical-center {\n      top: 50%;\n      transform: translateY(-50%);\n    }\n    &-horizontal-center {\n      left: 50%;\n      transform: translateX(-50%);\n    }\n    &-center {\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n  }\n\n  .height {\n    &-none {\n      height: auto;\n    }\n  }\n  .h-full {\n    height: 100%;\n  }\n  .flex-wrap {\n    flex-wrap: wrap;\n    &-none {\n      flex-wrap: nowrap;\n    }\n  }\n\n  .table-layout-fixed {\n    table-layout: fixed;\n  }\n\n  .table-layout-auto {\n    table-layout: auto;\n  }\n  .outline {\n    &-none {\n      outline: none;\n    }\n  }\n  .overflow {\n    &-visible {\n      overflow: visible;\n    }\n    &-hidden {\n      overflow: hidden;\n    }\n    &-auto {\n      overflow: auto;\n    }\n    &-vertical {\n      &-hidden {\n        overflow-y: hidden;\n      }\n      &-auto {\n        overflow-y: auto;\n      }\n    }\n    &-horizontal {\n      &-hidden {\n        overflow-x: hidden;\n      }\n      &-auto {\n        overflow-x: auto;\n      }\n    }\n    &-ellipsis {\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .vertical-align {\n    &-middle {\n      vertical-align: middle;\n    }\n    &-baseline {\n      vertical-align: baseline;\n    }\n    &-bottom {\n      vertical-align: bottom;\n    }\n    &-top {\n      vertical-align: top;\n    }\n    &-text-top {\n      vertical-align: text-top;\n    }\n  }\n  .line-height-clear {\n    line-height: 1;\n  }\n\n  .line-height-12 {\n    line-height: 12px;\n  }\n\n  .line-height-14 {\n    line-height: 14px;\n  }\n\n  .line-height-15 {\n    line-height: 15px;\n  }\n\n  .line-height-16 {\n    line-height: 16px;\n  }\n\n  .line-height-18 {\n    line-height: 18px;\n  }\n\n  .line-height-20 {\n    line-height: 20px;\n  }\n\n  .line-height-22 {\n    line-height: 22px;\n  }\n\n  .line-height-24 {\n    line-height: 24px;\n  }\n\n  .padding-vertical-6 {\n    padding-top: 6px;\n    padding-bottom: 6px;\n  }\n\n  .resize {\n    &-none {\n      resize: none;\n    }\n    &-horizontal {\n      resize: horizontal;\n    }\n    &-vertical {\n      resize: vertical;\n    }\n  }\n  .cursor {\n    &-default {\n      cursor: default;\n    }\n    &-pointer {\n      cursor: pointer;\n    }\n    &-text {\n      cursor: text;\n    }\n    &-move {\n      cursor: move;\n    }\n    &-disabled,\n    &-not-allowed {\n      cursor: not-allowed;\n    }\n    &-initial {\n      cursor: initial;\n    }\n  }\n  .display {\n    &-inline {\n      display: inline;\n    }\n    &-block {\n      display: block;\n    }\n    &-inline-block {\n      display: inline-block;\n    }\n    &-flex {\n      display: flex;\n    }\n    &-inline-flex {\n      display: inline-flex;\n    }\n    &-none {\n      display: none;\n    }\n  }\n  .flex {\n    &-row {\n      flex-direction: row;\n    }\n    &-row-reverse {\n      flex-direction: row-reverse;\n    }\n    &-col {\n      flex-direction: column;\n    }\n    &-col-reverse {\n      flex-direction: column-reverse;\n    }\n\n    &-content {\n      &-start {\n        align-content: flex-start;\n      }\n      &-center {\n        align-content: center;\n      }\n      &-end {\n        align-content: flex-end;\n      }\n      &-between {\n        align-content: space-between;\n      }\n      &-around {\n        align-content: space-around;\n      }\n    }\n\n    &-justify {\n      &-start {\n        justify-content: flex-start;\n      }\n      &-center {\n        justify-content: center;\n      }\n      &-end {\n        justify-content: flex-end;\n      }\n      &-between {\n        justify-content: space-between;\n      }\n      &-around {\n        justify-content: space-around;\n      }\n    }\n\n    &-items {\n      &-stretch {\n        align-items: stretch;\n      }\n      &-start {\n        align-items: flex-start;\n      }\n      &-center {\n        align-items: center;\n      }\n      &-end {\n        align-items: flex-end;\n      }\n      &-baseline {\n        align-items: baseline;\n      }\n    }\n\n    &-self {\n      &-stretch {\n        align-self: stretch;\n      }\n      &-start {\n        align-self: start;\n      }\n      &-center {\n        align-self: center;\n      }\n      &-end {\n        align-self: end;\n      }\n    }\n\n    &-shrink-none {\n      flex-shrink: 0;\n    }\n    &-grow-none {\n      flex-grow: 0;\n    }\n  }\n\n  //Override ant-design defaults\n  body {\n    .color-grey-10;\n    .background-grey-4b;\n  }\n  .ant-layout {\n    .background-grey-4b;\n  }\n\n  .pf-sider {\n    min-height: calc(~'100vh - 68px');\n  }\n\n  .pf-sider--h-stretch {\n    height: 100vh;\n  }\n\n  .pf-sider--between .ant-layout-sider-children {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n\n  .pseudo {\n    &-after {\n      &-none {\n        &:after {\n          content: none;\n        }\n      }\n    }\n    &-before {\n      &-none {\n        &:before {\n          content: none;\n        }\n      }\n    }\n  }\n\n  .list-style-none {\n    list-style: none;\n  }\n\n  .ant {\n    // tabs in header\n    &-layout-header {\n      .ant-tabs {\n        height: 46px;\n\n        &-top {\n          > .ant-tabs-nav::before {\n            border-color: @color-grey-2;\n          }\n        }\n\n        &-nav {\n          margin: 0;\n          .padding-horizontal-lg;\n        }\n        &--dark {\n          color: @color-grey-10;\n        }\n\n        &-tab-active,\n        &-tab:hover {\n          color: @color-blue-6;\n        }\n\n        &-ink-bar {\n          background-color: @color-blue-6;\n        }\n\n        &-bar {\n          height: 48px;\n\n          .ant-tabs-extra-content {\n            line-height: 1.5;\n          }\n          .ant-tabs-nav > *:not(.ant-tabs-ink-bar) {\n            height: 48px;\n          }\n        }\n      }\n    }\n\n    // avatars\n    &-avatar {\n      &-sm {\n        height: 20px;\n        line-height: 20px;\n        width: 20px;\n      }\n    }\n    // drop down menu specifics\n    &-dropdown {\n      &-placement-bottomRight,\n      &-placement-topRight {\n        left: auto;\n      }\n    }\n    &-dropdown-menu {\n      a {\n        color: inherit;\n      }\n      &-item {\n        color: @color-grey-10;\n        &-active {\n          color: @color-blue-6;\n          background: @color-blue-1;\n        }\n        &-disabled {\n          color: @color-grey-7;\n        }\n      }\n    }\n\n    // modal specifics\n    &-modal {\n      &-content {\n        .padding-horizontal-lg;\n        .padding-btm-md;\n        .padding-top-lg;\n      }\n      .ant-modal-header {\n        .padding-none;\n        .padding-btm-md;\n        .border-none;\n      }\n      &-body {\n        .padding-none;\n        .padding-vertical-md;\n      }\n      &-footer {\n        .padding-none;\n        .padding-top-md;\n      }\n      &-close-x {\n        .line-height-clear;\n        .padding-top-md;\n      }\n    }\n  }\n\n  .ant-select-dropdown {\n    .ant-select-item-option {\n      color: @color-grey-10;\n    }\n    .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n      // background-color: @color-blue-1;\n      background-color: red;\n    }\n    .ant-select-item-option-disabled:not(.ant-select-item-option-active) {\n      color: @color-grey-7;\n    }\n  }\n\n  .ant-select {\n    @select-height: 40px;\n    .ant-select-arrow {\n      color: @color-grey-10;\n    }\n    &.ant-select-single {\n      height: @select-height;\n    }\n    .ant-select-selection-item {\n      line-height: @select-height - 2;\n    }\n\n    &.ant-select-multiple {\n      .ant-select-selector {\n        height: auto;\n        min-height: @select-height;\n        border-color: @color-grey-5;\n\n        .ant-select-selection-item {\n          font-weight: normal;\n          display: flex;\n          align-items: center;\n          padding: 16px 8px 16px 10px;\n          background-color: @color-blue-1;\n          border: none;\n          border-radius: 4px;\n        }\n\n        .ant-select-selection-item-content {\n          margin-right: 8px;\n        }\n\n        .ant-select-selection-item-remove {\n          margin-top: -4px;\n        }\n      }\n\n      &.ant-select-focused {\n        .ant-select-selector {\n          border-color: @color-grey-5;\n          box-shadow: none;\n        }\n      }\n    }\n\n    .ant-select-selector--multiple {\n      height: auto;\n      min-height: @select-height;\n      & > ul > li,\n      & .ant-select-selection-item > ul > li {\n        height: 32px;\n        line-height: 30px;\n      }\n      .ant-select-selection__choice {\n        background-color: @color-blue-1;\n        border: none;\n        border-radius: 4px;\n      }\n    }\n  }\n\n  .ant-select.pf-select-small {\n    @select-height: 32px;\n    &.ant-select-single {\n      height: @select-height;\n    }\n    .ant-select-selection-item {\n      line-height: @select-height - 2;\n    }\n    .ant-select-selector--multiple {\n      height: auto;\n      min-height: @select-height;\n    }\n\n    .ant-select-selector {\n      height: @select-height;\n    }\n\n    .ant-select-selection-item {\n      line-height: 31px;\n    }\n\n    .ant-select-arrow {\n      margin-top: -12px;\n    }\n  }\n\n  .ant-select.template-text-array {\n    @select-height: 48px;\n    &.ant-select-multiple {\n      .ant-select-selector {\n        height: auto;\n        min-height: @select-height;\n        .ant-select-selection-item {\n          background-color: #d8e9fe;\n        }\n        .ant-select-selection-item-remove {\n          color: @color-blue-6;\n        }\n      }\n\n      &.ant-select-focused {\n        .ant-select-selector {\n          border-color: @color-blue-6;\n          box-shadow: none;\n        }\n      }\n    }\n  }\n  .ant-select-grey {\n    .ant-select-selector {\n      background-color: @color-grey-4;\n      border-color: transparent;\n\n      .ant-select-selector-placeholder {\n        color: @color-grey-9;\n      }\n    }\n\n    .ant-select-clear {\n      background: transparent;\n    }\n\n    &:not(.ant-select-disabled) {\n      &:hover {\n        .ant-select-selector {\n          border-color: transparent;\n        }\n      }\n    }\n\n    .ant-select-selection-item {\n      color: transparent;\n    }\n\n    &.select-single-mode {\n      .ant-select-selection-item {\n        color: inherit;\n      }\n\n      &.ant-select-focused {\n        .ant-select-selection-item {\n          color: @color-grey-7;\n        }\n      }\n    }\n  }\n\n  .ant-switch {\n    background-color: @color-grey-7;\n    &-checked {\n      background-color: @color-blue-6;\n    }\n  }\n\n  .ant-checkbox-checked {\n    &:not(.ant-checkbox-disabled) {\n      .ant-checkbox-inner {\n        background-color: @color-blue-6;\n        border-color: @color-blue-6;\n      }\n    }\n    &.ant-checkbox-disabled {\n      .ant-checkbox-inner {\n        background-color: @color-grey-8;\n        border-color: @color-grey-8!important;\n      }\n      .ant-checkbox-inner:after {\n        border-color: @color-grey-1;\n      }\n      + span {\n        color: inherit;\n      }\n    }\n  }\n\n  .no-disabled-state {\n    .ant-checkbox-checked {\n      &.ant-checkbox-disabled {\n        .ant-checkbox-inner {\n          background-color: @color-blue-6;\n          border-color: @color-blue-6!important;\n        }\n\n        + span {\n          border-color: @color-grey-1;\n        }\n      }\n    }\n  }\n\n  .disabled-dark {\n    .ant-checkbox-checked.ant-checkbox-disabled {\n      .ant-checkbox-inner {\n        background-color: @color-grey-8;\n        border-color: @color-grey-8!important;\n      }\n      .ant-checkbox-inner:after {\n        border-color: @color-grey-1;\n      }\n    }\n    .ant-checkbox-disabled + span {\n      color: @color-grey-10;\n    }\n  }\n\n  .ant-tooltip-no-arrow {\n    .ant-tooltip-arrow {\n      display: none;\n    }\n    &.ant-tooltip-placement-right,\n    &.ant-tooltip-placement-rightTop,\n    &.ant-tooltip-placement-rightBottom {\n      padding-left: 0;\n    }\n  }\n  .ant-tooltip {\n    .ant-tooltip-inner {\n      background-color: @color-grey-10;\n    }\n\n    .ant-tooltip-placement-bottom .ant-tooltip-arrow,\n    .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,\n    .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {\n      border-bottom-color: @color-grey-10;\n    }\n    .ant-tooltip-placement-top .ant-tooltip-arrow,\n    .ant-tooltip-placement-topLeft .ant-tooltip-arrow,\n    .ant-tooltip-placement-topRight .ant-tooltip-arrow {\n      border-top-color: @color-grey-10;\n    }\n  }\n\n  .ant-tooltip-medium {\n    max-width: 280px;\n  }\n\n  .ant-tooltip-small {\n    .ant-tooltip-inner {\n      min-height: auto;\n      padding: 0 @space-xxs;\n    }\n  }\n\n  .ant-tooltip-padding-none {\n    .ant-tooltip-inner {\n      padding: 0;\n    }\n  }\n\n  .ant-tooltip-rounded {\n    .ant-tooltip-inner {\n      border-radius: 12px;\n    }\n  }\n\n  .ant-tooltip-rounded-level-1 {\n    .ant-tooltip-inner {\n      border-radius: 6px;\n    }\n  }\n\n  .ant-tooltip-shadow-none {\n    .ant-tooltip-inner {\n      box-shadow: none;\n    }\n  }\n\n  .anticon {\n    vertical-align: 0;\n  }\n\n  // This is kind of a hack but will work for now\n  .ant-input-number.text-weight-bold input {\n    font-weight: bold;\n  }\n\n  // override antd defaults inside\n  // editable-range component\n  .editable-range {\n    .ant-input-number {\n      width: 32px;\n      &.ant-input-number-sm {\n        height: 21px;\n      }\n      .ant-input-number-handler-wrap {\n        opacity: 0;\n        pointer-events: none;\n      }\n      .ant-input-number-input {\n        text-align: center;\n        height: 20px;\n      }\n    }\n    &.editing {\n      .ant-input-number {\n        width: 55px;\n        .ant-input-number-handler-wrap {\n          opacity: 1;\n          pointer-events: all;\n        }\n        .ant-input-number-input {\n          text-align: left;\n        }\n      }\n    }\n  }\n\n  // custom components\n  // Tree & TreeNode\n  .icon-32 {\n    width: 32px;\n    height: 32px;\n    line-height: 32px;\n    text-align: center;\n    display: inline-block;\n  }\n  .icon-16 {\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    display: inline-block;\n  }\n  .tree {\n    &-node {\n      &-title {\n        &:hover:not(.tree-node-disabled) {\n          .color-blue-6;\n          .background-blue-1;\n          .tree-node-actions {\n            visibility: visible;\n          }\n        }\n      }\n      &-active {\n        .color-blue-6;\n      }\n      &-disabled {\n        .color-grey-7;\n      }\n      &-actions {\n        visibility: hidden;\n      }\n    }\n  }\n\n  .badge-3rd-party {\n    position: relative;\n    width: 24px;\n    height: 24px;\n    font-size: 7px;\n    font-weight: bold;\n    .color-red-6;\n    &:before {\n      content: '3rd';\n      position: absolute;\n      padding: 2px;\n      line-height: 8px;\n      z-index: 1;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n    }\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      border: 12px solid transparent;\n      border-top-color: @color-grey-5;\n      border-left-color: @color-grey-5;\n      border-top-left-radius: 4px;\n    }\n  }\n  .badge-distribution-link {\n    position: relative;\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n  }\n\n  .badge-visualize-data {\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n  }\n\n  .badge-translations {\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n  }\n\n  .pf-select.ant-select {\n    &:not(.ant-select-customize-input) {\n      &.pf-select-grey {\n        .ant-select-selector {\n          background-color: @color-grey-3;\n          color: @color-grey-10;\n          .border-grey-5;\n          font-weight: @font-weight-bold;\n        }\n\n        &.pf-transparent-disable.ant-select-disabled,\n        &.pf-transparent-disable.ant-select-disabled:hover {\n          .ant-select-selector {\n            color: @color-grey-7;\n            background: transparent;\n          }\n        }\n      }\n    }\n  }\n\n  .pf-input-no-shadow:focus {\n    box-shadow: none;\n  }\n\n  .pf-input-search {\n    background: @color-grey-4;\n    margin-top: 7px;\n\n    .ant-input-group-addon {\n      background: transparent;\n      border-radius: 0 4px 4px 0;\n    }\n\n    input {\n      background-color: transparent;\n      border: none;\n      color: @color-grey-10;\n      height: 34px;\n\n      &:focus,\n      &::placeholder {\n        color: @color-grey-10;\n      }\n\n      &:focus,\n      &:hover {\n        background: @color-grey-4;\n        box-shadow: none;\n\n        + .ant-input-group-addon {\n          background: @color-grey-4;\n        }\n      }\n    }\n\n    button {\n      background: transparent;\n      border: none;\n      box-shadow: none;\n    }\n\n    .anticon-search {\n      color: black;\n      font-size: 14px;\n      position: relative;\n      top: -1;\n    }\n  }\n\n  .full-size-link {\n    position: relative;\n    height: @menu-link-height;\n    line-height: @menu-link-height;\n    display: flex;\n    align-items: center;\n    margin: 3px 0;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n\n    a:before,\n    button:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n    }\n  }\n\n  .file-upload {\n    .file-upload-disabled {\n      a {\n        cursor: not-allowed;\n        color: @color-grey-6;\n      }\n      .ant-upload {\n        color: @color-grey-6;\n        background-color: @color-grey-8;\n      }\n    }\n\n    &.file-upload--w-image {\n      min-height: 40px;\n      border: 1px dashed @color-grey-5;\n    }\n\n    .ant-upload.ant-upload-drag {\n      padding: 0;\n      background: #fff;\n    }\n\n    .ant-upload.ant-upload-btn {\n      padding: 30px;\n    }\n  }\n\n  .file-upload-preview {\n    width: auto;\n    height: auto;\n    max-width: 300px;\n    max-height: 300px;\n\n    &.file-upload-preview--middle {\n      max-width: 200px;\n      max-height: 200px;\n    }\n\n    &.file-upload-preview--small {\n      max-width: 150px;\n      max-height: 150px;\n    }\n\n    &.file-upload-preview--min-sizes {\n      min-height: 100px;\n    }\n  }\n\n  .was-scrolled-into-view {\n    border-radius: 8px;\n  }\n\n  .bordered-arrow {\n    &-left {\n      border-style: solid;\n      border-color: currentColor;\n      position: relative;\n      border-width: 0 0 0 2px;\n      &:before {\n        content: '';\n        border: 4px solid transparent;\n        border-left: 0;\n        border-right-color: currentColor;\n        position: absolute;\n        top: 50%;\n        left: -2px;\n        transform: translate(-100%, -50%);\n      }\n    }\n  }\n  .formatted-editor {\n    min-height: 16px;\n    outline: none;\n    cursor: text;\n    &.no-height {\n      min-height: 1px;\n    }\n    &.conjoint-editor {\n      min-height: 30px;\n    }\n\n    &.active-placeholder:before {\n      content: attr(data-placeholder);\n      position: absolute;\n      line-height: 16px;\n      pointer-events: none;\n      color: @color-grey-8;\n    }\n\n    &.terms-conditions-editor {\n      &.active-placeholder:before {\n        line-height: 42px;\n      }\n    }\n\n    &.color-placeholder-grey-8:before {\n      color: @color-grey-8;\n    }\n\n    br {\n      display: none;\n    }\n    span {\n      white-space: pre-wrap;\n    }\n    &.carried-forward-answer:not(.active-placeholder) {\n      div {\n        display: inline-block;\n      }\n    }\n\n    &.cursor-disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  .terms-modal {\n    .formatted-editor {\n      &.active-placeholder:before {\n        color: @color-grey-7;\n      }\n    }\n  }\n\n  .stack-context {\n    z-index: 1;\n    &-2 {\n      z-index: 2;\n    }\n    &-3 {\n      z-index: 3;\n    }\n  }\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  .ant-select-item-option-active {\n    background-color: @color-blue-1!important;\n  }\n}\n\n.reset-ant-collapse .ant-collapse-borderless {\n  > .ant-collapse-item {\n    border: 0 !important;\n  }\n\n  .ant-collapse-content-box {\n    padding: 0 !important;\n  }\n\n  .ant-collapse-header {\n    padding: 0 !important;\n  }\n}\n\n.ant-divider-long {\n  height: 28px !important;\n}\n\n.ant-progress-right {\n  .ant-progress-text {\n    text-align: right;\n  }\n}\n\n.ant-progress-transparent {\n  .ant-progress-inner {\n    background-color: transparent;\n  }\n}\n\n.ant-progress-text-dark .ant-progress-text {\n  color: @color-grey-10;\n}\n\n.ant-progress-text-sm {\n  font-size: @font-size-h5;\n  font-weight: 400;\n}\n\n.ant-progress-status-success .ant-progress-text {\n  color: @orange-4!important;\n}\n\n.highcharts-legend-item,\n.highcharts-axis-labels {\n  font-family: @font-family;\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.pointer-events {\n  &-none {\n    pointer-events: none;\n  }\n\n  &-auto {\n    pointer-events: auto;\n  }\n}\n\n.user-select-none {\n  user-select: none;\n}\n\n.upgrade-plan-action {\n  opacity: 0;\n  top: ((@menu-link-height - 26px)/2);\n  left: 0;\n  width: 100%;\n  height: 26px;\n  padding: 4px 15px;\n  z-index: 10;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n\n  &:active,\n  &:focus,\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.text-underline {\n  text-decoration: underline;\n\n  &:active,\n  &:focus,\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.no-scrollbars {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.img-thumb {\n  width: auto;\n  height: auto;\n  max-height: 18px;\n  max-width: 36px;\n  object-fit: cover;\n}\n\n.pf-new-theme .targeting-peeq-card,\n.pf-new-theme .targeting-card {\n  .select-dropdown-with-add-all .ant-select-item-option-active:first-of-type {\n    background-color: transparent !important;\n  }\n}\n\n.pf-new-theme .targeting-card {\n  .select-dropdown-with-add-all {\n    .ant-select-item:first-of-type {\n      &:active,\n      &:focus,\n      &:hover {\n        color: @color-blue-5 !important;\n      }\n    }\n  }\n}\n\n.pf-new-theme .targeting-peeq-card {\n  .select-dropdown-with-add-all {\n    .ant-select-item:first-of-type {\n      &:active,\n      &:focus,\n      &:hover {\n        color: #381581 !important;\n      }\n    }\n  }\n}\n\n.select-dropdown-with-add-all {\n  .ant-select-item:first-of-type {\n    font-weight: 500;\n    background-color: transparent !important;\n    border-bottom: 1px solid @color-grey-5!important;\n  }\n}\n","\n@wrapperWidth: 262px;\n.surveys-filters-sider-mobile-wrapper {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100vh;\n  z-index: 1000;\n  width: 0;\n  transition: width 0.3s linear;\n  overflow: hidden;\n\n\n  &.surveys-filters-sider-mobile-wrapper--open {\n    width: @wrapperWidth;\n  }\n}\n\n.surveys-filters-sider-mobile {\n  background-color: white;\n  position: absolute;\n  width: @wrapperWidth;\n  height: 100%;\n  overflow: auto;\n  left: 0;\n  top: 0;\n}\n\n.survey-name-title {\n\n  @media (max-width: 470px) {\n    width: 100px;\n  }\n}\n\n.ant-menu-inline-collapsed-tooltip { display: none; }\n\n.ant-modal-close {\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n\nbody.accessible-on {\n  .outline-blue:focus, .ant-modal-close:focus {\n    outline: #175aa5 solid 2px;\n    outline-offset: 1px;\n  }\n}",".integration-help {\n  .ant-collapse-item {\n    .ant-collapse-content {\n      border-radius: 0;\n    }\n  }\n  .ant-collapse-content-box {\n    padding: @space-xs @space-md;\n    background-color: @color-grey-3;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    .border-radius-no-bottom;\n    line-height: 1.5;\n\n    li {\n      margin: @space-xxs 0;\n    }\n  }\n  .integration-form {\n    .border-radius-no-bottom;\n  }\n}\n",".new-folder-input {\n  input {\n    background-color: transparent;\n  }\n}\n\n.transition {\n  &-normal {\n    transition: all 0.2s;\n  }\n}\n\n.fade-out {\n  opacity: 0;\n}\n\n.pf-header {\n  transition: margin 0.25s ease-in-out;\n}\n\n.hide-header .pf-header {\n  margin-top: -56px;\n}\n\n.h-full--2-headers {\n  transition: max-height 0.25s ease-in-out;\n}\n\n.hide-header .h-full--2-headers {\n  height: 100vh;\n  max-height: calc(~'100vh - 98px');\n}\n\n.ant-card-padding-none {\n  .ant-card-body {\n    padding: 0;\n  }\n}\n\n.radio-button-big {\n  .ant-radio-inner {\n    width: 20px;\n    height: 20px;\n  }\n  .ant-radio {\n    &::after {\n      animation: none;\n    }\n    &.ant-radio-checked {\n      .ant-radio-inner {\n        border-width: 2px;\n        transition: none;\n        animation: none;\n\n        &::after {\n          width: 10px;\n          height: 10px;\n          transition: none;\n          animation: none;\n        }\n      }\n    }\n    .ant-radio-inner::after {\n      transition: none;\n      animation: none;\n    }\n  }\n}\n\n.budget-form {\n  .ant-legacy-form-item-label {\n    line-height: 1.1; // not 1 because there is some text overflow that is hidden due to text overflow\n    display: flex;\n    align-items: center;\n    height: 40px;\n\n    & label:after {\n      display: none;\n    }\n  }\n\n  span.ant-radio + span {\n    padding-left: 6px !important;\n  }\n\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n\n  .ant-radio-checked .ant-radio-inner {\n    border-color: @color-blue-6;\n\n    &:after {\n      background-color: @color-blue-6;\n    }\n  }\n\n  .ant-calendar-picker-input {\n    border: none;\n\n    &::placeholder {\n      color: @color-grey-10;\n    }\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 8px;\n    background-color: white;\n  }\n\n  .ant-table-column-title {\n    font-weight: normal;\n    font-size: @font-size-primary;\n  }\n\n  .ant-table-thead > tr > th:last-child {\n    border-right: 0;\n  }\n\n  .ant-table-tbody > tr > td {\n    border-bottom: 0;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 8px !important;\n  }\n\n  .ant-table-tbody > tr > td.padding-none {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .ant-table-tbody > tr:first-child > td.padding-none {\n    padding-top: 4px !important;\n  }\n}\n\n.budget-table {\n  .ant-table-body > table {\n    border-color: @color-grey-6;\n  }\n\n  .ant-table-thead > tr > th:first-child,\n  .ant-table-tbody > tr > td:first-child,\n  .ant-table-thead > tr:hover > td:first-child,\n  .ant-table-tbody > tr:hover > td:first-child {\n    border-left: 1px solid @color-grey-6;\n  }\n\n  .ant-table-tbody > tr > td,\n  .ant-table-thead > tr > th {\n    border-color: @color-grey-6;\n  }\n\n  .ant-table-thead > tr > th {\n    background-color: @color-grey-3;\n    border-right: 1px solid @color-grey-6;\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 14px;\n  }\n\n  .ant-table.ant-table-bordered > .ant-table-container {\n    border-left: none;\n  }\n}\n\n.crosstab-preview-table {\n  max-width: 100%;\n  .ant-table {\n    font-size: @font-size-secondary;\n    line-height: @font-size-secondary-height;\n    .ant-table-header {\n      background: #ffffff;\n    }\n  }\n  tr,\n  td {\n    pointer-events: none;\n  }\n\n  td {\n    background-color: white !important;\n  }\n\n  .ant-table-row > td:not(.crosstab-row-header):not(.border-cross-header-inner),\n  .ant-table-thead\n    > tr\n    > th:not(.crosstab-row-header):not(.border-cross-header-inner) {\n    min-width: 200px;\n  }\n\n  .ant-table-body > table {\n    border-color: @color-grey-6;\n  }\n\n  .ant-table-tbody > tr > td,\n  .ant-table-thead > tr > th {\n    border-color: @color-grey-6;\n    padding: @space-xs;\n  }\n\n  .ant-table-thead > tr > th {\n    background-color: @color-grey-3;\n    border-right: 1px solid @color-grey-6;\n    vertical-align: top;\n  }\n\n  .ant-table-thead {\n    tr\n      > th.border-cross-header-inner:not(\n        .border-cross-header-inner-last-child\n      ) {\n      border-right: none !important;\n    }\n  }\n\n  .crosstab-row-header {\n    color: @color-grey-10;\n    background-color: @color-grey-3;\n    font-weight: @font-weight-bold;\n    vertical-align: top;\n\n    word-break: break-word;\n    overflow-wrap: break-word;\n  }\n\n  tr > th.border-cross-header-outer {\n    border-bottom: none !important;\n  }\n  tr > th.border-cross-header-outer,\n  tr > th.border-cross-header-inner {\n    background: @color-grey-3;\n  }\n}\n\n.ant-select {\n  &.ant-select-single {\n    &.crosstabs-select-language {\n      height: 24px;\n      .ant-select-selector {\n        height: 24px;\n      }\n    }\n  }\n}\n\n.ant-input-number.text-weight-bold {\n  input {\n    font-weight: bold;\n  }\n}\n\n.ant-input-number.w-full {\n  width: 100% !important;\n}\n// used for the new targetting page\n.h-full--3-headers {\n  height: calc(~'100vh - 98px');\n}\n\n.pf-announcement-visible .h-full--3-headers {\n  height: calc(~'100vh - 98px - 30px');\n}\n\n// used for the new targetting page (when paused for editing)\n.h-full--4-headers {\n  height: calc(~'100vh - 140px');\n}\n.pf-announcement-visible .h-full--4-headers {\n  height: calc(~'100vh - 140px - 30px');\n}\n\n.h-full--4-headers-AI {\n  height: calc(~'100vh - 147px');\n}\n.pf-announcement-visible .h-full--4-headers-AI {\n  height: calc(~'100vh - 147px - 30px');\n}\n.h-full--5-headers {\n  min-height: calc(~'100vh - 107px');\n}\n.pf-announcement-visible .h-full--5-headers {\n  height: calc(~'100vh - 107px - 30px');\n}\n\n.h-full--6-headers {\n  max-width: calc(~'100% - 385px');\n}\n\n.h-full--crosstab-headers {\n  height: calc(~'100vh - 113px');\n}\n\n.pf-announcement-visible .h-full--crosstab-headers {\n  height: calc(~'100vh - 113px - 30px');\n}\n\n.border-radius-pill .ant-form-item-control {\n  line-height: 1.5;\n}\n\n.targeting-card {\n  .ant-card-body {\n    padding: 16px 16px 12px;\n    .ant-divider-horizontal.w-full {\n      margin-left: -16px;\n      width: calc(100% + 32px);\n    }\n  }\n\n  .ant-switch-small {\n    min-width: 20px;\n    width: 20px;\n    height: 10px;\n    line-height: 10px;\n\n    .ant-switch-handle {\n      top: 1px;\n      left: 1px;\n      width: 8px;\n      height: 8px;\n    }\n\n    &.ant-switch-checked {\n      .ant-switch-handle {\n        left: calc(100% - 8px - 1px);\n      }\n    }\n  }\n}\n\n.targeting-card-slim .ant-card-body {\n  padding-top: @space-md;\n  padding-bottom: @space-md;\n}\n\n.ant-card.ant-card-padding-none.questionnaire-card {\n  .ant-collapse-content.ant-collapse-content-active {\n    overflow: visible;\n\n    .ant-collapse-content-box {\n      overflow: visible;\n    }\n  }\n\n  .ant-card-body {\n    padding-top: 12px !important;\n    padding-bottom: 16px !important;\n  }\n}\n\n.pf-custom-list {\n  .ant-list-header {\n    padding-top: 0;\n    padding-bottom: 8px;\n  }\n  .ant-list-header,\n  .ant-list-item {\n    border: none;\n  }\n}\n\n.terms-modal {\n  .ant-collapse {\n    .ant-collapse-content {\n      overflow: visible;\n    }\n  }\n}\n\n.pf-ant-collapse {\n  .ant-collapse-item {\n    border: none;\n  }\n\n  &.ant-collapse-icon-position-right\n    > .ant-collapse-item\n    > .ant-collapse-header {\n    padding: 0 18px 0 0;\n\n    .ant-collapse-arrow {\n      right: 0;\n      font-size: 10px;\n      color: @color-grey-10;\n      margin-top: 1px;\n    }\n  }\n\n  .ant-collapse-content-box {\n    padding: 0;\n  }\n\n  &.ant-collapse-question {\n    border: 0;\n    background-color: transparent;\n\n    .ant-collapse-header {\n      margin-left: 18px;\n      cursor: unset !important;\n    }\n\n    .ant-collapse-content-box > footer > section,\n    .ant-collapse-content-box > div:not(.ant-divider-horizontal) {\n      margin-left: 18px;\n    }\n\n    .ant-collapse-arrow {\n      left: -5px;\n      top: 15px;\n    }\n\n    .ant-collapse-content {\n      border: 0;\n    }\n  }\n\n  &.ant-collapse-header-padding-lg {\n    .ant-collapse-arrow,\n    .ant-collapse-header {\n      padding-left: @padding-lg!important;\n    }\n  }\n}\n\n.select-language-dropdown {\n  width: 144px !important;\n}\n\n.survey-header {\n  .ant-select {\n    &:not(.ant-select-customize-input) {\n      &.ant-select-focused {\n        &:not(.ant-select-disabled) {\n          .ant-select-selector {\n            .border-transparent;\n            box-shadow: none;\n          }\n        }\n      }\n    }\n\n    .ant-select-selector {\n      .border-transparent;\n      box-shadow: none;\n\n      padding: 0 3px 0 0;\n\n      .ant-select-selection-item {\n        margin-right: 0px;\n        margin-left: 3px;\n        line-height: 24px;\n      }\n\n      .ant-select-selection-search {\n        left: 3px;\n        right: 15px;\n      }\n    }\n\n    &.ant-select-single {\n      height: 26px;\n\n      .ant-select-selection-search-input,\n      .ant-select-selector {\n        background: transparent;\n        height: 26px;\n      }\n\n      &.ant-select-open {\n        .ant-select-selection-item {\n          color: @color-grey-7;\n        }\n      }\n    }\n\n    .ant-select-open .ant-select-selector {\n      .border-grey-7;\n    }\n  }\n  .ant-input-number-focused {\n    background: @color-grey-5;\n  }\n  .ant-input-number-input {\n    .padding-horizontal-xxs;\n  }\n  .ant-legacy-form-item-label > label {\n    color: @color-grey-9;\n    &::after {\n      margin-right: 4px;\n    }\n  }\n}\n\n.checkbox-border-inherit:not(:hover):not(:focus):not(\n    .ant-checkbox-wrapper-checked\n  )\n  .ant-checkbox-inner {\n  border-color: inherit;\n}\n\n.ant-divider-horizontal {\n  height: 1px;\n  border-top: none;\n  top: 0;\n}\n\n.ant-divider {\n  background: #e8e8e8;\n}\n\n.ant-divider-vertical {\n  width: 1px;\n  border-top: 0;\n  border-left: 0;\n}\n\n.ant-legacy-form-item-label > label {\n  color: rgba(0, 0, 0, 0.85);\n}\n\n.add-question__button {\n  display: none;\n  padding: 2px 3px !important;\n\n  &.add-question__button--active,\n  &:hover {\n    display: inline-block;\n  }\n}\n\n.active-menu-on-question {\n  .add-question__button {\n    display: inline-block;\n  }\n}\n\n// Reserve a fixed strip between cards for the (+). Previously height:0 + negative\n// offsets floated the control over the next card; in narrower columns (ADL/Display)\n// that reads as collapsed spacing. Keeping the strip in normal flow maintains gap.\n.add-question__button-wrapper {\n  position: relative;\n  top: -12px;\n  height: 12px;\n  pointer-events: none;\n  z-index: 3;\n\n  > * {\n    pointer-events: auto;\n  }\n\n  .add-question__button {\n    margin-top: 0;\n    top: auto;\n    transform: none;\n  }\n}\n\n.questionnaire-node--group .add-question__button-wrapper {\n  top: -21px;\n}\n\n.questionnaire-node--group .questionnaire-node .add-question__button-wrapper {\n  top: -12px;\n}\n\n// Avoid card margin-btm-xs + reserved strip stacking into an oversized gap.\n.drag-card:has(+ .add-question__button-wrapper) .questionnaire-card {\n  margin-bottom: 0;\n}\n\n// Node wrapper is the stacking unit for card + add button + overlays (e.g. QA dropdown).\n.questionnaire-node {\n  position: relative;\n}\n\n// Elevate the whole question node so its add button / menus render above the next\n// question card. The card lives inside .drag-card, not as a sibling of the\n// add-button wrapper, so z-index on .questionnaire-card alone is not enough.\n// Active-only elevation is omitted so an active next card cannot cover the gap (+).\n.questionnaire-node:has(> .drag-card:hover),\n.questionnaire-node:has(.add-question__button:hover),\n.questionnaire-node:has(.active-menu-on-question) {\n  z-index: 2;\n}\n\n.questionnaire-card {\n  position: relative;\n}\n\n.survey-preview {\n  min-height: 500px;\n}\n\n.survey-preview__copy-clipboard:hover {\n  .survey-preview__clipboard-tooltip--hidden {\n    display: block !important;\n  }\n}\n\n.survey-preview__clipboard-tooltip {\n  position: absolute;\n  top: -20px;\n  left: 0;\n  width: auto;\n  border: 1px solid;\n  z-index: 5;\n}\n\n.survey-preview__clipboard-tooltip--hidden {\n  display: none;\n}\n\na.disabled-link {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n\n.add-question-img-wrapper {\n  width: 397px;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.ant-popconfirm {\n  .ant-popover-inner {\n    border-radius: 8px;\n  }\n  .ant-popover-inner-content {\n    border-radius: 8px;\n    box-shadow:\n      0px 4px 12px 0px #5c677614,\n      0px 2px 6px 0px #87919e33;\n    font-size: 12px;\n  }\n}\n\n.tooltip-light {\n  .ant-tooltip-arrow {\n    &:before {\n      background-color: white;\n    }\n    .ant-tooltip-arrow-content {\n      background-color: white;\n    }\n  }\n  .ant-tooltip-inner {\n    line-height: 16px;\n    min-height: initial;\n    background-color: white !important;\n    color: @color-grey-10 !important;\n    padding: 8px 12px;\n\n    border-radius: 4px;\n    box-shadow:\n      0px 4px 12px 0px #5c677614,\n      0px 2px 6px 0px #87919e33;\n    font-size: 12px;\n  }\n\n  &.tooltip-padding-sm {\n    .ant-tooltip-inner {\n      padding: 12px;\n    }\n  }\n\n  &.tooltip-light--green {\n    .ant-tooltip-arrow {\n      &:before {\n        background-color: #dbf8f0;\n      }\n      .ant-tooltip-arrow-content {\n        background-color: #dbf8f0;\n      }\n    }\n    .ant-tooltip-inner {\n      background-color: #dbf8f0 !important;\n    }\n  }\n}\n\n.notification-light {\n  &.ant-notification-notice {\n    width: 433px;\n    padding: 0;\n  }\n  .ant-notification-notice-message {\n    margin-bottom: 0;\n  }\n\n  .ant-notification-notice-close {\n    top: 4px;\n    right: 7px;\n    color: @color-grey-10;\n\n    .icon {\n      font-size: 12px;\n    }\n  }\n}\n\n// Beats `.pf-theme a` (and its hover), which otherwise paints the close link blue.\n.ant-notification-notice.notification-close-dark {\n  .ant-notification-notice-close,\n  .ant-notification-notice-close:hover,\n  .ant-notification-notice-close:focus,\n  .ant-notification-notice-close:active {\n    color: @color-grey-10;\n  }\n}\n\n.ant-layout-sider-zero-width-trigger {\n  text-decoration: none;\n  outline: none;\n  position: absolute;\n  left: -34px;\n  top: 0;\n  background-color: white;\n  border-radius: 3px 0 0 3px;\n  width: 34px;\n  height: 62px;\n  line-height: 62px;\n  box-shadow: -2px 1px 3px 0px #ebedf1;\n  font-size: 18px;\n  padding: 0;\n\n  span {\n    line-height: 62px;\n  }\n}\n\n.ant-tabs-tab {\n  padding: 12px 16px;\n  [aria-disabled='false'] {\n    cursor: pointer;\n  }\n  [aria-disabled='true'] {\n    cursor: not-allowed;\n  }\n}\n\n.ant-tabs-tab-active {\n  .ant-tabs-tab-btn {\n    color: @color-blue-6;\n    font-weight: 500;\n  }\n}\n\n.logic-tab-bar,\n.crosstabs-tab-bar {\n  background-color: white;\n  .ant-tabs-top-bar {\n    margin: 0;\n    text-align: center;\n    height: 49px;\n  }\n\n  .ant-tabs-tab:hover,\n  .ant-tabs-tab:focus,\n  .ant-tabs-tab:active {\n    color: @color-blue-6;\n  }\n\n  .ant-tabs-tab {\n    color: @color-grey-10;\n    padding: 14px 16px;\n  }\n\n  .ant-tabs-tab-active {\n    .ant-tabs-tab-btn {\n      color: @color-blue-6;\n      font-weight: bold;\n    }\n  }\n\n  > .ant-tabs-nav .ant-tabs-nav-wrap {\n    justify-content: center;\n  }\n\n  .ant-tabs-ink-bar {\n    background-color: @color-blue-6;\n  }\n}\n\n.logic-tab-bar {\n  .ant-tabs-nav {\n    height: 49px;\n    margin-bottom: 0;\n    &::before {\n      border-color: @color-grey-4;\n    }\n  }\n}\n\n.pf-skeleton.ant-skeleton.ant-skeleton-active\n  .ant-skeleton-content\n  .ant-skeleton-title,\n.pf-skeleton.ant-skeleton.ant-skeleton-active\n  .ant-skeleton-content\n  .ant-skeleton-paragraph\n  > li {\n  background: linear-gradient(\n    90deg,\n    rgba(207, 216, 220, 0.2) 25%,\n    rgba(207, 216, 220, 0.4) 37%,\n    rgba(207, 216, 220, 0.2) 63%\n  );\n\n  background-size: 400% 100%;\n}\n\n.pf-skeleton-theme-list.ant-skeleton.ant-skeleton-active\n  .ant-skeleton-content\n  .ant-skeleton-title {\n  margin: 4px 0;\n  height: 40px;\n\n  background: linear-gradient(\n    90deg,\n    rgba(249, 250, 252, 1) 25%,\n    rgba(207, 216, 220, 0.4) 37%,\n    rgba(249, 250, 252, 1) 63%\n  );\n  background-size: 400% 100%;\n}\n\n.border-radius-no-bottom {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.border-left-purple-6-opacity {\n  border-left: 1px solid fade(@color-purple-6, 14%);\n}\n\n.add-language-menu {\n  width: 227px;\n  max-height: 187px;\n  overflow: hidden;\n  overflow-y: scroll;\n}\n\n.add-language-search {\n  position: relative;\n  background: #fff;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n\n  &.ant-select-open {\n    box-shadow: 0px 4px 8px 0px #eef3f7;\n  }\n  .ant-select-selection-search {\n    background-color: #eef3f7;\n    border-radius: 4px;\n  }\n\n  &.ant-select-open:after {\n    background: #fff;\n    display: block;\n    content: '';\n    font-size: 0;\n    height: 12px;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: -12px;\n    z-index: 10;\n  }\n\n  input {\n    padding: 0;\n  }\n\n  &.ant-select {\n    font-size: 12px;\n    color: @color-grey-10;\n\n    &.ant-select-focused {\n      .ant-select-selector {\n        border-color: @color-grey-5;\n        box-shadow: none;\n      }\n    }\n\n    &.ant-select-single {\n      height: auto;\n    }\n\n    &.ant-select-open.ant-select-single {\n      height: 45px;\n    }\n\n    .ant-select-selection-item {\n      line-height: 30px;\n    }\n  }\n\n  .ant-select-selector {\n    background-color: #eef3f7;\n    border: none;\n    box-shadow: none;\n    position: relative;\n    height: 40px;\n  }\n\n  .ant-select-selection-search {\n    border-radius: 4px;\n    left: 0;\n    right: 0;\n    background-color: transparent;\n    box-shadow: none;\n\n    input {\n      margin-top: 5px;\n    }\n  }\n  .ant-select-selection-placeholder {\n    top: 21px;\n    color: @color-grey-8;\n  }\n\n  .ant-select-selection-search-input {\n    padding-left: 8px;\n  }\n\n  &.ant-select-open {\n    .ant-select-selector {\n      background-color: #fff;\n      padding: 12px 6px 12px;\n      height: 42px;\n    }\n\n    .ant-select-selection-search {\n      right: 6px;\n      left: 6px;\n      top: 12px;\n      bottom: 0px;\n      background-color: #eef3f7;\n    }\n\n    .ant-select-selection-placeholder {\n      top: 28px;\n      left: 3px;\n    }\n\n    .ant-select-selection-search-input {\n      padding-left: 8px;\n    }\n  }\n\n  &.ant-select-single {\n    .ant-select-selection-item {\n      margin-right: 11px;\n    }\n  }\n\n  [aria-controls] {\n    cursor: default;\n  }\n\n  &.ant-select-open .ant-select-arrow {\n    margin-top: 0;\n  }\n\n  .ant-select-arrow {\n    transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    margin-top: -5px;\n  }\n}\n\n.add-language-select-menu {\n  padding: 8px 4px;\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  box-shadow: 0px 4px 8px 0px #eef3f7;\n\n  .ant-select-dropdown-menu {\n    max-height: 238px;\n  }\n\n  .ant-select-item-option {\n    height: 30px;\n    font-size: 12px;\n    line-height: 14px;\n    border-bottom: 0;\n    padding: 8px 12px !important;\n    border-radius: 2px;\n    text-align: left;\n    color: @color-grey-10;\n    &.ant-select-item-option-active {\n      color: @color-grey-10;\n    }\n  }\n  .ant-select-item-option-disabled {\n    height: auto;\n  }\n}\n\n.add-language-pop-over {\n  .ant-select-dropdown {\n    left: 0px !important;\n    top: 54px !important;\n  }\n\n  .ant-popover-inner-content {\n    padding: 0px !important;\n  }\n\n  .ant-popover-inner {\n    background-color: transparent !important;\n    box-shadow: none;\n  }\n}\n\n.format-tooltip-pop-over {\n  .ant-popover-inner-content {\n    padding: 0px !important;\n  }\n\n  .ant-popover-arrow {\n    display: none;\n  }\n  .ant-popover-inner {\n    background-color: transparent !important;\n    box-shadow: none;\n  }\n}\n\n.color-picker-pop-over {\n  .ant-popover-inner-content {\n    padding: 0px !important;\n  }\n\n  .ant-popover-arrow {\n    display: none;\n  }\n  .ant-popover-inner {\n    background-color: transparent !important;\n    box-shadow: none;\n  }\n}\n\n.questionnaire-card {\n  .icon-google-translate {\n    width: 14px;\n    height: 14px;\n    font-size: 14px;\n    position: relative;\n\n    &:before {\n      background-color: #4a8af4;\n      border-radius: 26px;\n      color: @color-grey-6;\n      position: absolute;\n      width: 13px;\n      height: 13px;\n    }\n  }\n}\n\n.icon-google-translate-disabled {\n  &:before {\n    background-color: @color-grey-6;\n    color: @color-grey-7;\n  }\n}\n\n.ant-tabs-languages {\n  .ant-tabs-ink-bar {\n    display: none !important;\n  }\n\n  &.ant-tabs {\n    height: 32px;\n    margin: 0;\n    border: 0;\n  }\n\n  .ant-tabs-nav {\n    // important for the box-shadows to work as expected with the z-index: -1;\n    z-index: 0;\n\n    .ant-tabs-tab:first-child .language-tab:before {\n      border-top-left-radius: 4px;\n      border-bottom-left-radius: 4px;\n    }\n\n    .ant-tabs-tab:last-child .language-tab:before {\n      border-top-right-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n  }\n\n  .language-tab {\n    position: relative;\n\n    // box shadow needs to exist behind elements so that it\n    // doesnt overflow\n    &:before {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      content: '';\n      box-shadow: 0px 2px 4px 0px #eef3f7;\n      z-index: -1;\n    }\n\n    &.language-tab--selected:before {\n      box-shadow: none;\n    }\n  }\n\n  .ant-tabs-tab {\n    padding: 0;\n    transition: none;\n    margin: 0;\n\n    &:before {\n      display: none;\n    }\n  }\n\n  .ant-tabs-nav-container,\n  .ant-tabs-nav-scroll {\n    height: 36px;\n  }\n\n  .ant-tabs-tab-prev,\n  .ant-tabs-tab-next {\n    line-height: 0;\n    width: 28px;\n    height: 34px;\n  }\n}\n\n.translate-openEnded-checkbox,\n.nested-quotas-checkbox {\n  .ant-checkbox {\n    top: 0px;\n  }\n}\n\n.save-translations-btn {\n  &.ant-btn-primary[disabled],\n  &.ant-btn-primary[disabled]:hover,\n  &.ant-btn-primary[disabled]:focus,\n  &.ant-btn-primary[disabled]:active,\n  &.ant-btn-primary[disabled].active {\n    color: #fff;\n    background-color: #0e68f9;\n    border-color: #0e68f9;\n    border-top-color: rgb(14, 104, 249);\n    border-right-color: rgb(14, 104, 249);\n    border-bottom-color: rgb(14, 104, 249);\n    border-left-color: rgb(14, 104, 249);\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);\n    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);\n  }\n}\n\n.questionnaire-card .crosstab-add-actions {\n  transition: opacity 1350ms;\n  opacity: 1;\n}\n\n.questionnaire-card-container {\n  .crosstabs-add-buttons {\n    display: none;\n  }\n  &:hover .crosstabs-add-buttons {\n    display: block;\n  }\n\n  &.crosstab-guide-bottom,\n  &.crosstab-guide-top {\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      right: 0;\n      height: 3px;\n      border-right: 4px solid @color-grey-1;\n      border-left: 4px solid @color-grey-1;\n      background: @color-purple-5;\n    }\n  }\n\n  &.crosstab-guide-bottom:after {\n    bottom: -1px;\n    transform: translateY(50%);\n  }\n  &.crosstab-guide-top:after {\n    top: -1px;\n    transform: translateY(-50%);\n  }\n}\n\n.resize-handle {\n  width: 40px;\n  height: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  cursor: grab;\n  background-color: @color-grey-7;\n  padding: 20px auto;\n  margin: 10px auto;\n}\n.react-draggable-transparent-selection {\n  cursor: grabbing !important;\n}\n\n.ant-modal {\n  &.no-body-padding {\n    .ant-modal-body {\n      padding: 0;\n    }\n  }\n  &.equal-paddings {\n    .ant-modal-content {\n      padding-bottom: 24px;\n    }\n  }\n}\n.elite-form-frame {\n  width: 100%;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  height: calc(100vh - 62px);\n}\n\n.template-preview-questions {\n  .ant-collapse-header {\n    padding-left: 0 !important;\n  }\n\n  [data-slate-editor] {\n    cursor: default;\n  }\n}\n\n.piped-question {\n  position: relative;\n  display: inline-block;\n  color: @color-purple-6;\n  z-index: 5;\n  border: 1px solid @color-grey-5;\n  background-color: @color-grey-3;\n  font-size: 12px;\n  padding: 0 6px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  top: -2px;\n}\n\n.help-tooltip {\n  width: 230px;\n  z-index: 1100;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  border-radius: 8px;\n  padding: 14px;\n\n  //arrow\n  svg {\n    margin-right: -2px;\n  }\n}\n\n@space-2lg: 28px;\n.create-spacing(margin, 2lg, @space-2lg);\n.create-negative-spacing(margin, 2lg, @space-2lg);\n.create-spacing(padding, 2lg, @space-2lg);\n.create-spacing-important(margin, 2lg, @space-2lg);\n.create-negative-spacing-important(margin, 2lg, @space-2lg);\n.create-spacing-important(padding, 2lg, @space-2lg);\n\n.ant-collapse {\n  line-height: 1.5;\n  border-radius: 4px;\n}\n\n.ant-card {\n  line-height: 1.5;\n  overflow: visible;\n}\n\n.ant-collapse-arrow {\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  top: 50%;\n  left: 16px;\n  display: inline-block;\n  font-size: 12px;\n  transform: translateY(-50%);\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header {\n  position: relative;\n  padding: 12px 16px;\n  padding-left: 40px;\n  color: rgba(0, 0, 0, 0.85);\n  line-height: 22px;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  position: absolute;\n  display: inline-block;\n  font-size: 12px;\n  transform: translateY(-50%);\n}\n\n.ant-collapse-borderless {\n  background-color: @color-grey-1;\n}\n\n.ant-badge {\n  color: inherit;\n}\n\n.preview-item {\n  .preview-arrow {\n    color: transparent;\n  }\n  &:hover .preview-arrow {\n    color: inherit;\n  }\n}\n.ant-breadcrumb-flex-spans {\n  display: flex;\n\n  > span {\n    display: flex;\n  }\n}\n\n.pf-modal-alert-wrapper {\n  .ant-modal-content {\n    border-radius: 4px;\n    padding-top: 18px;\n    padding-bottom: 14px;\n  }\n\n  .ant-modal-close {\n    position: absolute;\n    z-index: 2;\n    top: 50%;\n    right: 8px;\n    transform: translate3d(0, -50%, 0);\n  }\n}\n\n.ant-checkbox-custom-padding {\n  .ant-checkbox {\n    + span {\n      padding: 0 0 0 5px;\n    }\n  }\n}\n\n.button-disabled-with-tooltip {\n  &.ant-tooltip-disabled-compatible-wrapper {\n    display: flex !important;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    position: relative;\n    top: 1px;\n    left: -6px;\n  }\n}\n\n.import-from-library-menu-item {\n  &.ant-dropdown-menu-item-active {\n    button {\n      color: @color-blue-6;\n      border-color: @color-blue-6;\n    }\n  }\n}\n\n.pf-dropdown-select-menu.ant-dropdown-menu {\n  padding: 8px;\n  box-shadow: 0px 4px 8px rgba(238, 243, 247, 0.4);\n  border-radius: 4px;\n\n  .ant-dropdown-menu-item-active {\n    border-radius: 4px;\n    background-color: @color-blue-1;\n    color: @color-blue-6;\n  }\n}\n\n.recall-container {\n  .ant-menu {\n    overflow: hidden;\n    .padding-horizontal-md;\n\n    &-sub {\n      &.ant-menu-inline {\n        background: transparent;\n      }\n    }\n\n    &-item,\n    [role='menuitem'] {\n      padding: 6px 0 !important;\n      border: 0;\n      transition: none;\n      margin: 0 !important;\n      font-size: @pf-font-size-base;\n      line-height: 1.4;\n      height: auto;\n\n      a {\n        color: @color-grey-10;\n        transition: none;\n      }\n    }\n  }\n}\n\ninput.hide-number-arrows::-webkit-outer-spin-button,\ninput.hide-number-arrows::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput.hide-number-arrows[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.dropdown-menu-grouped-actions-divider {\n  margin: 4px -8px;\n}\n\n@-moz-keyframes rotate360 {\n  to {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes rotate360 {\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes rotate360 {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes rotate360 {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.visualize-data-spinner {\n  -webkit-animation: 1s rotate360 infinite linear;\n  -moz-animation: 1s rotate360 infinite linear;\n  -ms-animation: 1s rotate360 infinite linear;\n  animation: 1s rotate360 infinite linear;\n}\n\n.dropdown-menu-pop-over {\n  .ant-popover-inner-content {\n    width: 240px;\n    font-size: 12px;\n  }\n\n  .ant-popover-arrow {\n    display: none;\n  }\n}\n\n.popover-300-width {\n  .ant-popover-inner-content {\n    width: 300px;\n    padding: 12px !important;\n  }\n}\n\n.pf-wizard-select {\n  height: 48px !important;\n  line-height: 48px;\n  box-shadow: none;\n\n  .ant-select-selection-search-input {\n    font-weight: bold;\n  }\n\n  .ant-select-selector,\n  .ant-select-selection-item {\n    height: 46px !important;\n    border-color: transparent !important;\n  }\n\n  &.ant-select-open {\n    border: 1px solid #0e68f9 !important;\n  }\n}\n\n.pf-wizard-input-number {\n  &.ant-input-number-focused {\n    border: 1px solid #0e68f9 !important;\n    box-shadow: none;\n  }\n}\n\n#create-survey-terms-body::before {\n  line-height: 42px;\n}\n\n.highcharts-credits {\n  display: none;\n}\n\n.integration-form-dataset-location {\n  .ant-select-selection-item {\n    align-self: center;\n  }\n}\n\n.ant-col-offset-4-xl {\n  @media (min-width: 1600px) {\n    margin-left: 16.66666667%;\n  }\n}\n\n.purple-indicator {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n\n.purple-indicator::after,\n.purple-indicator::before {\n  content: '';\n  visibility: hidden;\n  box-sizing: border-box;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #9679ee;\n  position: absolute;\n  left: 0;\n  top: 0;\n  animation: pulse 2s linear infinite;\n}\n\n.purple-indicator::after {\n  animation-delay: 1s;\n}\n\n.orange-indicator {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.orange-indicator::after,\n.orange-indicator::before {\n  content: '';\n  visibility: hidden;\n  box-sizing: border-box;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: rgb(205 136 49);\n  position: absolute;\n  left: 0;\n  top: 0;\n  animation: pulse 2s linear infinite;\n}\n\n.orange-indicator::after {\n  animation-delay: 1s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n    visibility: visible;\n  }\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n.ant-tooltip-no-arrow {\n  .peeq-price-calculator {\n    .ant-tooltip-arrow {\n      display: block;\n    }\n  }\n}\n\n.ant-tooltip-rounded {\n  .peeq-price-calculator {\n    .ant-tooltip-inner {\n      line-height: 1;\n      min-height: initial;\n      background-color: @color-grey-10 !important;\n      color: @color-grey-1 !important;\n      border-radius: 4px;\n      padding: 6px 8px;\n    }\n  }\n}\n\n.feasibility-button-peeq-ir-input {\n  .ant-input-number-input {\n    height: 28px;\n    padding: 0;\n  }\n}\n\n.peeq-price-calculator {\n  .ant-input-number-input {\n    height: 28px;\n    padding: 0;\n  }\n\n  &.ant-collapse-item > .ant-collapse-header {\n    cursor: default;\n  }\n}\n\n.ant-btn.mobile-button-wrap {\n  @media (max-width: 1000px) {\n    white-space: normal;\n    height: auto;\n  }\n}\n\n.page-content-vertical-size {\n  min-height: calc(100vh - 52px);\n  @media (min-width: 800px) {\n    height: calc(100vh - 52px);\n  }\n}\n.pf-announcement-visible .page-content-vertical-size {\n  min-height: calc(100vh - 52px - 30px);\n  @media (min-width: 800px) {\n    height: calc(100vh - 52px - 30px);\n  }\n}\n\n.page-content-vertical-size-3rd-party-results {\n  height: calc(100vh - 104px);\n}\n.peeq-total-responses {\n  .ant-input-number-input {\n    height: 26px;\n  }\n}\n\n.audience-rename-modal {\n  .ant-modal-footer {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n\n.audience-template-modal {\n  max-width: 360px;\n  input {\n    background: #eff3f7;\n    border: none;\n  }\n  .ant-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.ant-input-number-focused.ant-input-number-focused-no-shadow {\n  box-shadow: none;\n}\n\n.ant-input-number-sm {\n  &.padding-none {\n    input {\n      padding: 0;\n    }\n  }\n}\n\n.card-nesting-quotas:hover {\n  cursor: pointer;\n  border-radius: 3px;\n  border: 1px solid #eff3f7;\n  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.102);\n}\n\n.pause-edit-modal,\n.edit-survey-adl-modal {\n  .ant-modal-content {\n    padding: 16px;\n  }\n\n  .ant-modal-close {\n    top: 7px;\n    right: 9px;\n  }\n\n  .ant-modal-body {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .ant-modal-footer {\n    padding-top: 40px;\n    border-top: none;\n  }\n}\n\n.add-rule-button-with-tooltip {\n  button {\n    padding: 0;\n    font-weight: 600;\n  }\n}\n\n.loop-and-merge-submenu-list .ant-dropdown-menu-submenu-title,\n.loop-and-merge-submenu-list-item {\n  color: @color-grey-10 !important;\n  border-radius: 4px;\n  margin: 4px;\n  padding-left: 6px;\n}\n\n.loop-and-merge-submenu-list .ant-dropdown-menu-submenu-title:hover,\n.loop-and-merge-submenu-list-item:hover {\n  background-color: @color-blue-1;\n}\n\n.loop-and-merge-submenu-list-disabled .ant-dropdown-menu-submenu-title,\n.loop-and-merge-submenu-list-disabled .ant-dropdown-menu-submenu-title:hover,\n.loop-and-merge-submenu-list-disabled-item,\n.loop-and-merge-submenu-list-disabled-item:hover {\n  color: @color-grey-8 !important;\n  background-color: white;\n  cursor: not-allowed;\n}\n\n.loop-and-merge-submenu-list-popup-container ul {\n  max-height: 326px;\n  overflow-y: auto;\n}\n\n.background-new-yellow-4,\n.background-new-yellow-4-hover:hover {\n  background-color: #fbe58c;\n}\n\n.border-new-yellow-4,\n.border-new-yellow-4-hover:hover {\n  border-color: #fbe58c;\n}\n\n.color-new-green-7 {\n  color: @color-new-green-7;\n}\n\n.background-new-green-7 {\n  background-color: @color-new-green-7;\n}\n",".pf-tabs {\n  .ant-tabs-nav-list {\n    width: 100%;\n\n    .ant-tabs-tab {\n      flex: 1;\n      justify-content: center;\n      color: @color-grey-10;\n      &:hover {\n        color: inherit;\n      }\n    }\n    .ant-tabs-tab-active .ant-tabs-tab-btn {\n      color: @color-blue-6;\n    }\n    .ant-tabs-ink-bar {\n      background-color: @color-blue-6;\n    }\n    .ant-tabs-tab + .ant-tabs-tab {\n      margin-left: 0;\n    }\n  }\n}\n\n",".animated-box {\n  --border-size: 2px;\n  --border-angle: 0turn;\n  background-image: conic-gradient(\n      from var(--border-angle),\n      white,\n      white 50%,\n      white\n    ),\n    conic-gradient(\n      from var(--border-angle),\n      transparent 10%,\n      #eff5ff,\n      #c9deff,\n      #17dcff,\n      #0e68f9\n    ); //#08f\n  background-size: calc(100% - (var(--border-size) * 2))\n      calc(100% - (var(--border-size) * 2)),\n    cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  animation: bg-spin 4s linear infinite;\n  @keyframes bg-spin {\n    to {\n      --border-angle: 1turn;\n    }\n  }\n\n  //&:hover {\n  //  animation-play-state: paused;\n  //}\n}\n\n@property --border-angle {\n  syntax: '<angle>';\n  inherits: true;\n  initial-value: 0turn;\n}\n\n.pf-line-loader {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  perspective: 800px;\n}\n\n.pf-line-loader-inner {\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}\n\n.pf-line-loader-inner.one {\n  left: 0%;\n  top: 0%;\n  animation: rotate-one 1s linear infinite;\n  border-bottom: 3px solid #8f98a9;\n}\n\n.pf-line-loader-inner.two {\n  right: 0%;\n  top: 0%;\n  animation: rotate-two 1s linear infinite;\n  border-right: 3px solid #8f98a9;\n}\n\n.pf-line-loader-inner.three {\n  right: 0%;\n  bottom: 0%;\n  animation: rotate-three 1s linear infinite;\n  border-top: 3px solid #8f98a9;\n}\n\n@keyframes rotate-one {\n  0% {\n    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);\n  }\n  100% {\n    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);\n  }\n}\n\n@keyframes rotate-two {\n  0% {\n    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);\n  }\n  100% {\n    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);\n  }\n}\n\n@keyframes rotate-three {\n  0% {\n    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);\n  }\n  100% {\n    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);\n  }\n}\n\n.pf-ai-prompt-area {\n  // -webkit-background-size: 800% 800% !important;\n  // background-size: 800% 800% !important;\n  -webkit-background-size: 400% 400% !important;\n  background-size: 400% 400% !important;\n  background: linear-gradient(\n    68deg,\n    rgba(244, 226, 253, 1),\n    rgba(225, 232, 254, 1),\n    rgba(244, 226, 253, 1),\n    rgba(225, 232, 254, 1)\n  );\n\n  // rgba(244, 226, 253, 1),\n  // rgba(241, 245, 254, 0.8),\n  // rgba(241, 245, 254, 0.8),\n  // rgba(225, 232, 254, 1)\n  animation: gradient 8s linear infinite;\n  -webkit-animation-direction: alternate;\n  -moz-animation-direction: alternate;\n  -o-animation-direction: alternate;\n  animation-direction: alternate;\n}\n",".bar-chart {\n  height: 100px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n\n  > div {\n    background-color: #509ee3;\n    box-sizing: border-box;\n    position: relative;\n    color: transparent;\n    z-index: 10;\n  }\n\n  > div::before {\n    content: ' ';\n    display: block;\n    position: absolute;\n    z-index: 10;\n    left: 0;\n    bottom: 0;\n    height: 166px;\n    width: 1px;\n    background-color: @color-grey-5;\n  }\n\n  > div:after {\n    display: none !important;\n  }\n\n  > div:first-child {\n    opacity: 0.25;\n  }\n\n  > div:first-child:after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    background-color: white;\n    left: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n    background-color: #fff;\n    border-bottom: 40px solid #509ee3;\n    border-right: 70px solid transparent;\n  }\n\n  > div:nth-child(2) {\n    opacity: 0.2;\n  }\n\n  > div:nth-child(2):after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    background-color: white;\n    left: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n    background-color: #fff;\n    border-bottom: 60px solid #509ee3;\n    border-right: 70px solid transparent;\n  }\n\n  > div:nth-child(3) {\n    opacity: 0.17;\n  }\n\n  > div:nth-child(3):after {\n    content: '';\n    display: inline-block;\n    position: absolute;\n    background-color: white;\n    left: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n    background-color: #fff;\n    border-bottom: 40px solid #509ee3;\n    border-right: 70px solid transparent;\n  }\n\n  > div:nth-child(4) {\n    opacity: 0.14;\n  }\n\n  > div:nth-child(5) {\n    opacity: 0.1;\n  }\n\n  > div:nth-child(6) {\n    opacity: 0.05;\n  }\n}\n\n.survey-summary-stats {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  background-color: white;\n}\n\n.survey-summary-stats-bg {\n  background: #e4eafd;\n\n  &.survey-summary-stats-bg--dlink {\n    background: linear-gradient(\n      323.86deg,\n      #ffffff 15.95%,\n      rgba(216, 238, 215, 0.26) 91.98%\n    );\n  }\n  &.survey-summary-stats-bg--peeq {\n    background: linear-gradient(\n      323.86deg,\n      #ffffff 15.95%,\n      rgba(210, 202, 241, 0.16) 91.98%\n    );\n  }\n}\n\n.survey-summary-stats-hide-desktop {\n  display: none;\n}\n\n.survey-summary-stats__entry {\n  display: flex;\n  flex-direction: column;\n}\n\n.survey-summary-stats__entry-title {\n  margin-bottom: 5px;\n}\n\n.survey-summary-stats__stat-linkShare {\n  width: 100%;\n  .survey-social-share {\n    width: 100%;\n  }\n}\n\n.survey-end-page-urls-tooltip {\n  .ant-tooltip-inner {\n    padding: 0 !important;\n  }\n\n  .ant-tooltip-arrow-content {\n    background-color: #eff3f7 !important;\n  }\n}\n\n.survey-end-page-urls-tooltip {\n  text-align: left;\n\n  &__section {\n    padding: 12px 8px;\n\n    &:first-child {\n      padding-top: 8px;\n    }\n\n    &:not(:has(~ .survey-end-page-urls-tooltip__section)) {\n      padding-bottom: 8px;\n    }\n\n    // All the lines below are for the divider line\n    background-image: linear-gradient(to right, #eff3f7, #eff3f7);\n    background-repeat: no-repeat;\n    background-position: bottom center;\n    background-size: calc(100% - 16px) 1px;\n  }\n\n  &__label {\n    margin-bottom: 4px;\n  }\n\n  &__url {\n    word-break: break-all;\n  }\n\n  &__footer {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n    padding: 8px;\n    background-color: #eff3f7;\n  }\n\n  &__footer-icon {\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n}\n\n@media (max-width: 992px) {\n  .survey-summary-stats__stat-surveyLink {\n    width: calc(100% - 88px);\n  }\n\n  .survey-summary-stats__cards-row {\n    flex-direction: column;\n\n    .ant-col {\n      max-width: 100% !important;\n    }\n  }\n\n  .survey-summary-stats__entry-title {\n    margin-bottom: 0;\n  }\n\n  .survey-summary-stats__entry {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .survey-summary-stats-hide-desktop {\n    display: inline-block;\n  }\n  .survey-summary-stats {\n    .ant-layout-content {\n      width: 100% !important;\n    }\n\n    .ant-layout-sider {\n      width: 100% !important;\n      max-width: 100% !important;\n      min-width: initial !important;\n      flex: 0 0 100% !important;\n      padding-bottom: 0 !important;\n      min-height: initial !important;\n    }\n\n    .ant-layout.ant-layout-has-sider {\n      flex-direction: column;\n    }\n  }\n}\n",".services-grid {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  grid-column-gap: 0;\n  grid-row-gap: 16px;\n  width: 100%;\n\n}\n\n.services-grid-card-title {\n  font-size: 18px;\n  line-height: 20px;\n}\n\n.services-grid-img {\n  width: auto;\n  height: 90px;\n}\n\n@media (min-width: 400px) {\n  .services-grid-img {\n    height: 130px;\n  }\n}\n\n@media (min-width: 768px) {\n  .services-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    max-width: 1000px;\n  }\n\n  .services-grid-card-title {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  .services-grid-img {\n    width: auto;\n    height: 150px;\n  }\n}\n\n@media (min-width: 1000px) {\n  .services-grid-img {\n    height: 220px;\n  }\n}\n","// -------- Spacing -----------\n@space-tiny: 3px;\n@space-xxs: 5px;\n@space-xs: 8px;\n@space-sm: 12px;\n@space-md: 16px;\n@space-lg: 24px;\n@space-xl: 36px;\n@space-xxl: 44px;\n\n.create-width (@name, @value) {\n  .width-@{name} {\n    width: @value;\n  }\n  .width-@{name}-important {\n    width: @value !important;\n  }\n}\n\n.create-spacing (@property, @name, @value) {\n  .@{property}-@{name} {\n    @{property}: @value;\n  }\n  .@{property}-horizontal-@{name} {\n    @{property}-left: @value;\n    @{property}-right: @value;\n  }\n  .@{property}-vertical-@{name} {\n    @{property}-top: @value;\n    @{property}-bottom: @value;\n  }\n  .@{property}-top-@{name} {\n    @{property}-top: @value;\n  }\n  .@{property}-btm-@{name} {\n    @{property}-bottom: @value;\n  }\n  .@{property}-left-@{name} {\n    @{property}-left: @value;\n  }\n  .@{property}-right-@{name} {\n    @{property}-right: @value;\n  }\n}\n\n.create-spacing-important (@property, @name, @value) {\n  .@{property}-@{name}-important {\n    @{property}: @value !important;\n  }\n  .@{property}-horizontal-@{name}-important {\n    @{property}-left: @value !important;\n    @{property}-right: @value !important;\n  }\n  .@{property}-vertical-@{name}-important {\n    @{property}-top: @value !important;\n    @{property}-bottom: @value !important;\n  }\n  .@{property}-top-@{name}-important {\n    @{property}-top: @value !important;\n  }\n  .@{property}-btm-@{name}-important {\n    @{property}-bottom: @value !important;\n  }\n  .@{property}-left-@{name}-important {\n    @{property}-left: @value !important;\n  }\n  .@{property}-right-@{name}-important {\n    @{property}-right: @value !important;\n  }\n}\n.create-negative-spacing (@property, @name, @value) {\n  .@{property}-negative-@{name} {\n    @{property}: -@value;\n  }\n  .@{property}-horizontal-negative-@{name} {\n    @{property}-left: -@value;\n    @{property}-right: -@value;\n  }\n  .@{property}-vertical-negative-@{name} {\n    @{property}-top: -@value;\n    @{property}-bottom: -@value;\n  }\n  .@{property}-top-negative-@{name} {\n    @{property}-top: -@value;\n  }\n  .@{property}-btm-negative-@{name} {\n    @{property}-bottom: -@value;\n  }\n  .@{property}-left-negative-@{name} {\n    @{property}-left: -@value;\n  }\n  .@{property}-right-negative-@{name} {\n    @{property}-right: -@value;\n  }\n}\n\n.create-negative-spacing-important (@property, @name, @value) {\n  .@{property}-negative-@{name}-important {\n    @{property}: -@value !important;\n  }\n  .@{property}-horizontal-negative-@{name}-important {\n    @{property}-left: -@value !important;\n    @{property}-right: -@value !important;\n  }\n  .@{property}-vertical-negative-@{name}-important {\n    @{property}-top: -@value !important;\n    @{property}-bottom: -@value !important;\n  }\n  .@{property}-top-negative-@{name}-important {\n    @{property}-top: -@value !important;\n  }\n  .@{property}-btm-negative-@{name}-important {\n    @{property}-bottom: -@value !important;\n  }\n  .@{property}-left-negative-@{name}-important {\n    @{property}-left: -@value !important;\n  }\n  .@{property}-right-negative-@{name}-important {\n    @{property}-right: -@value !important;\n  }\n}\n\n.create-gap (@name, @value) {\n  .gap-@{name} {\n    gap: @value;\n  }\n}\n",".peeq-criteria-collapse {\n  height: calc(100vh - 200px);\n\n  .ant-collapse-item {\n    border-color: @color-grey-4;\n  }\n\n  .ant-checkbox-wrapper + .ant-checkbox-wrapper {\n    margin-left: 0px;\n  }\n\n  .ant-collapse-content-box {\n    label:last-child {\n      border: none;\n    }\n\n    .ant-checkbox {\n      top: 4px;\n    }\n  }\n}\n\n.peeq-criteria-main-list {\n  .ant-collapse-item {\n    background-color: #fff;\n    border-color: @color-grey-4;\n    margin-bottom: 24px;\n  }\n\n  .ant-collapse-content-box {\n    label:last-child {\n      border: none;\n    }\n  }\n\n  .ant-collapse-arrow {\n    top: 22px;\n  }\n}\n\n.targeting-peeq-card {\n  .ant-checkbox-wrapper + .ant-checkbox-wrapper {\n    margin-left: 0px;\n  }\n\n  .ant-switch-checked {\n    background-color: @color-purple-dark;\n\n    &:focus {\n      box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.8);\n    }\n  }\n\n  .ant-select-focused:not(.ant-select-disabled).ant-select:not(\n      .ant-select-customize-input\n    )\n    .ant-select-selector {\n    box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.55);\n  }\n\n  .ant-input-number-focused {\n    box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.8);\n  }\n\n  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n    background-color: @color-purple-1 !important;\n  }\n}\n\n.peeq-criteria-modal {\n  .ant-modal-content {\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding-top: 0;\n    padding-bottom: 0;\n\n    .items-list {\n      overflow-y: scroll;\n    }\n  }\n\n  .ant-modal-close {\n    top: 7px;\n    right: 6px;\n  }\n}\n\n.peeq-radio-include-exclude {\n  .ant-radio-button-wrapper {\n    font-size: 10px;\n    text-transform: uppercase;\n    color: @color-grey-10;\n    box-shadow: none;\n\n    &:first-child {\n      border-radius: 4px 0 0 4px;\n    }\n    &:last-child {\n      border-radius: 0 4px 4px 0;\n    }\n  }\n\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    background-color: @color-blue-6;\n    color: #fff;\n    border-color: @color-blue-6;\n\n    &:before {\n      background-color: @color-blue-6;\n    }\n  }\n}\n\n.background-purple {\n  &-light {\n    background-color: @color-purple-light;\n\n    &-hover {\n      &:hover {\n        background-color: @color-purple-light-hover;\n      }\n    }\n  }\n  &-dark {\n    background-color: @color-purple-dark;\n\n    &-important,\n    &-important:hover {\n      background-color: @color-purple-dark;\n    }\n  }\n}\n\n.color-purple {\n  &-light {\n    color: @color-purple-light;\n\n    &-hover {\n      &:hover {\n        color: @color-purple-light;\n      }\n    }\n  }\n  &-dark {\n    color: @color-purple-dark;\n\n    &-hover {\n      &:hover {\n        color: @color-purple-dark;\n      }\n    }\n  }\n  &-sq {\n    color: #6e3ae6;\n  }\n}\n\n.border {\n  &-purple-light {\n    border: 1px solid @color-purple-light;\n  }\n\n  &-purple-dark {\n    border: 1px solid @color-purple-dark;\n\n    &-hover {\n      &:hover {\n        border: 1px solid @color-purple-dark;\n      }\n    }\n\n    &-active {\n      &:active {\n        border: 1px solid @color-purple-dark;\n      }\n    }\n\n    &-focus {\n      &:focus {\n        border: 1px solid @color-purple-dark;\n      }\n    }\n\n    &-important {\n      border: 1px solid @color-purple-dark !important;\n    }\n\n    &-dashed {\n      border: 1px dashed @color-purple-dark;\n    }\n  }\n\n  &-left-purple-dark {\n    border-left: 5px solid @color-purple-dark !important;\n  }\n}\n\n.ant-checkbox-purple-dark {\n  &.ant-checkbox-wrapper:hover .ant-checkbox-inner {\n    border-color: @color-purple-5;\n  }\n\n  .ant-checkbox:hover .ant-checkbox-inner {\n    border-color: @color-purple-5;\n  }\n\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: @color-grey-6;\n  }\n\n  .ant-checkbox-checked {\n    &:not(.ant-checkbox-disabled) {\n      .ant-checkbox-inner {\n        background-color: @color-purple-9;\n        border-color: @color-purple-9;\n      }\n    }\n\n    &::after {\n      border: 1px solid @color-purple-10;\n    }\n  }\n}\n\n.ant-radio-purple-dark {\n  .ant-radio-inner {\n    border-color: @color-purple-dark;\n\n    &:after {\n      background-color: @color-purple-dark;\n    }\n  }\n\n  .ant-radio-checked {\n    &:after {\n      border-color: @color-purple-dark;\n    }\n  }\n}\n\n.ant-switch-purple-dark {\n  &.ant-switch-checked {\n    background-color: @color-purple-dark;\n    &:focus {\n      box-shadow: 0 0 0 2px rgba(240, 234, 253, 0.8);\n    }\n  }\n}\n\n.ant-tabs-purple-dark {\n  .ant-tabs-ink-bar {\n    background: @color-purple-dark;\n  }\n\n  .ant-tabs-tab {\n    padding: 8px 0 12px;\n\n    &:hover {\n      color: @color-purple-8;\n    }\n\n    &:first-child {\n      padding-left: 0px;\n    }\n  }\n\n  .ant-tabs-tab-btn {\n    &:focus,\n    &:active {\n      color: @color-purple-8;\n    }\n  }\n\n  .ant-tabs-tab-active {\n    .ant-tabs-tab-btn {\n      color: @color-purple-dark;\n    }\n  }\n}\n\n.peeq-custom-question-modal {\n  .ant-modal-content {\n    padding: 0;\n  }\n\n  .ant-modal-body {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .ant-collapse-question {\n    padding-left: 0;\n\n    .ant-collapse-header {\n      margin-left: 0;\n      padding: 0;\n\n      .padding-horizontal-md {\n        padding: 0;\n      }\n    }\n\n    .ant-collapse-content-box > div:not(.ant-divider-horizontal) {\n      margin-left: 0;\n    }\n  }\n}\n\n.audience-remove-criterion-modal,\n.clear-revision-modal,\n.peeq-pause-edit-modal,\n.peeq-remove-criterion-modal {\n  .ant-modal-content {\n    padding: 16px;\n  }\n\n  .ant-modal-close {\n    top: 7px;\n    right: 9px;\n  }\n\n  .ant-modal-body {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .ant-modal-footer {\n    padding-top: 40px;\n    border-top: none;\n  }\n}\n\n.select-country-templates .ant-select-selection-search {\n  top: 3px;\n}\n",".dot {\n    content: \" \";\n    display: block;\n    position: absolute;\n    width: 5px;\n    height: 5px;\n    background-color: @color-grey-10;\n    border-radius: 4px;\n    z-index: 100;\n}\n\n.questionnaire-revisions {\n\n    .empty-menu .ant-menu-submenu-arrow {\n        display: none;\n    }\n\n    .ant-menu-item {\n        overflow: visible!important;\n    }\n\n    .ant-layout-sider-children {\n        overflow: auto;\n    }\n\n    .ant-menu-title-content, .ant-menu-submenu-arrow {\n        font-size: 12px;\n        color: @color-grey-10!important;\n    }\n    \n    .ant-menu-submenu {\n        margin-top: 10px;\n    }\n\n    .ant-menu-item::after {\n        content: none;\n    }\n\n    .ant-menu-item-selected {\n        font-weight: 500!important;\n    }\n\n    .ant-menu-item-active, .is-revision-in-preview .revision-selected {\n        background-color: @color-grey-6!important;\n    }\n    \n    .ant-menu-sub.ant-menu-inline > .ant-menu-item,\n    .ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n        height: initial;\n        line-height: initial;\n        color: @color-grey-10!important;\n    }\n    \n    .ant-menu-light .ant-menu-item:hover,\n    .ant-menu-light .ant-menu-item-active,\n    .ant-menu-light .ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,\n    .ant-menu-light .ant-menu-submenu-active,\n    .ant-menu-light .ant-menu-submenu-title:hover {\n        color: @color-grey-10!important;\n    }\n\n\n    .ant-menu-sub.ant-menu-inline {\n        background-color: transparent!important;\n    }\n\n\n    .milestone-dot {\n        position: relative;\n\n        &::before {\n            .dot();\n            top: 49%;\n            transform: translate3d(0, -25%, 0);\n            left: 13px;\n        }\n\n        &.milestione-dot--inactive::before {\n            background-color: @color-grey-7;\n        }\n    }\n\n    .ant-menu-submenu-title {\n        position: relative;\n        padding-left: 32px!important;\n\n        &::before {\n            .dot();\n            top: 50%;\n            transform: translate3d(0, -25%, 0);\n            left: 13px;\n        }\n    }\n    \n}\n\n.questionnaire-revisions-inner {\n    position: relative;\n\n    &.questionnaire-revisions-inner--loaded {\n        &::before {\n            content: \" \";\n            display: block;\n            position: absolute;\n            top: 66px;\n            left: 15px;\n            z-index: 10;\n            background-color: @color-grey-7;\n            width: 1px;\n            height: calc(100% - 95px);\n        }\n    }\n}\n\n.revision-item {\n    padding-left: 20px;\n\n    &::before {\n        .dot();\n        top: 21px;\n        left: 13px;\n        background-color: @color-grey-7;\n    }\n}\n\n.survey-special-actions {\n    position: sticky;\n    top: -16px;\n    z-index: 50;\n    left: 0;\n    background-color: @color-grey-4;\n    &::before {\n        content: \" \";\n        position: absolute;\n        display: block;\n        top: 0;\n        left: -20px;\n        width: 20px;\n        height: 100%;\n        z-index: inherit;\n        background-color: @color-grey-4;\n    }\n}","@keyframes move {\n  0% {\n    transform: translate3d(-20%, 0, 0);\n  }\n  30% {\n    transform: translate3d(0, 40%, 0);\n  }\n\n  50% {\n    transform: translate3d(0, -40%, 0);\n  }\n  60% {\n    transform: translate3d(20%, 0, 0);\n  }\n\n  80% {\n    transform: translate3d(20%, -20%, 0);\n  }\n  100% {\n    transform: translate3d(30%, 50%, 0);\n  }\n}\n\n@keyframes glow {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes aiBuilderColor {\n  0% {\n    background: linear-gradient(0deg, #fb60c6, #8618ca);\n  }\n  50% {\n    background: linear-gradient(0deg, #81267e, #1a2769);\n  }\n\n  75% {\n    background: linear-gradient(0deg, #ce1d1d, #fb60c6);\n  }\n  100% {\n    background: linear-gradient(0deg, #8618ca, #ce1d1d);\n  }\n  0% {\n    background: linear-gradient(0deg, #fb60c6, #8618ca);\n  }\n  50% {\n    background: linear-gradient(0deg, #81267e, #1a2769);\n  }\n\n  75% {\n    background: linear-gradient(0deg, #ce1d1d, #fb60c6);\n  }\n  100% {\n    background: linear-gradient(0deg, #8618ca, #ce1d1d);\n  }\n}\n@-moz-keyframes aiBuilderColor {\n  0% {\n    background: linear-gradient(0deg, #fb60c6, #8618ca);\n  }\n  50% {\n    background: linear-gradient(0deg, #81267e, #1a2769);\n  }\n\n  75% {\n    background: linear-gradient(0deg, #ce1d1d, #fb60c6);\n  }\n  100% {\n    background: linear-gradient(0deg, #8618ca, #ce1d1d);\n  }\n  0% {\n    background: linear-gradient(0deg, #fb60c6, #8618ca);\n  }\n  50% {\n    background: linear-gradient(0deg, #81267e, #1a2769);\n  }\n\n  75% {\n    background: linear-gradient(0deg, #ce1d1d, #fb60c6);\n  }\n  100% {\n    background: linear-gradient(0deg, #8618ca, #ce1d1d);\n  }\n}\n\n@keyframes aiBuilderColor {\n  0% {\n    background: linear-gradient(0deg, #fb60c6, #8618ca);\n  }\n  50% {\n    background: linear-gradient(0deg, #81267e, #1a2769);\n  }\n\n  75% {\n    background: linear-gradient(0deg, #ce1d1d, #fb60c6);\n  }\n  100% {\n    background: linear-gradient(0deg, #8618ca, #ce1d1d);\n  }\n  0% {\n    background: linear-gradient(0deg, #fb60c6, #8618ca);\n  }\n  50% {\n    background: linear-gradient(0deg, #81267e, #1a2769);\n  }\n\n  75% {\n    background: linear-gradient(0deg, #ce1d1d, #fb60c6);\n  }\n  100% {\n    background: linear-gradient(0deg, #8618ca, #ce1d1d);\n  }\n}\n\n@-webkit-keyframes aiBuilderColor {\n  0% {\n    background-position: 92% 0%;\n  }\n  50% {\n    background-position: 9% 100%;\n  }\n  100% {\n    background-position: 92% 0%;\n  }\n  0% {\n    background-position: 92% 0%;\n  }\n  50% {\n    background-position: 9% 100%;\n  }\n  100% {\n    background-position: 92% 0%;\n  }\n}\n@-moz-keyframes aiBuilderColor {\n  0% {\n    background-position: 92% 0%;\n  }\n  50% {\n    background-position: 9% 100%;\n  }\n  100% {\n    background-position: 92% 0%;\n  }\n  0% {\n    background-position: 92% 0%;\n  }\n  50% {\n    background-position: 9% 100%;\n  }\n  100% {\n    background-position: 92% 0%;\n  }\n}\n@keyframes aiBuilderColor {\n  0% {\n    background-position: 92% 0%;\n  }\n  50% {\n    background-position: 9% 100%;\n  }\n  100% {\n    background-position: 92% 0%;\n  }\n  0% {\n    background-position: 92% 0%;\n  }\n  50% {\n    background-position: 9% 100%;\n  }\n  100% {\n    background-position: 92% 0%;\n  }\n}\n\n@keyframes gradientLeft {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes gradientRight {\n  0% {\n    background-position: 50% 00%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n  0% {\n    background-position: 50% 00%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n\n.pf-ai-actions-dropdown {\n  .ant-dropdown-menu-item {\n    width: 100%;\n    font-size: 14px;\n\n    .ant-dropdown-menu-title-content {\n      width: 100%;\n      font-size: 14px;\n    }\n\n    .icon {\n      font-size: 16px;\n      width: 16px;\n      text-align: center;\n    }\n  }\n\n  // 8px between action icon and label text\n  .margin-right-xxs {\n    margin-right: 8px !important;\n  }\n\n  .ant-dropdown-menu-title-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  &.ant-dropdown-menu {\n    border: 1px solid #bb43b50f;\n    padding: 12px !important;\n    background: linear-gradient(\n      90deg,\n      #f2f5fe 3.61%,\n      #f9f4fd 38.2%,\n      #fafbfd 54.38%,\n      #f8fafc 74.27%,\n      #f9f2fc 102.96%\n    );\n  }\n\n  .ant-dropdown-menu-item-active {\n    background-color: white;\n    color: @color-pink;\n  }\n  .ant-dropdown-menu-title-content {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  &.ant-dropdown-menu {\n    border: 1px solid #bb43b50f;\n    padding: 12px !important;\n    background: linear-gradient(\n      90deg,\n      #f2f5fe 3.61%,\n      #f9f4fd 38.2%,\n      #fafbfd 54.38%,\n      #f8fafc 74.27%,\n      #f9f2fc 102.96%\n    );\n  }\n}\n\n.AI-builder {\n  max-width: 460px !important;\n  min-width: auto !important;\n\n  .ai-chat .message {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .user-message {\n    max-width: 360px;\n  }\n}\n\n.ai-icon {\n  font-size: 16px;\n  font-size: 16px;\n}\n\n.ask-ai-button,\n.ask-ai-button:hover {\n  background: linear-gradient(\n      0deg,\n      rgba(93, 39, 126, 0.5),\n      rgba(93, 39, 126, 0.5)\n    ),\n    radial-gradient(119.92% 499.26% at 8.17% 126.47%, #fb60c6 0%, #8618ca 87%)\n      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n  background: linear-gradient(\n      0deg,\n      rgba(93, 39, 126, 0.5),\n      rgba(93, 39, 126, 0.5)\n    ),\n    radial-gradient(119.92% 499.26% at 8.17% 126.47%, #fb60c6 0%, #8618ca 87%)\n      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n}\n\n.ai-message-loader {\n  border: 3px solid white;\n  height: 15px;\n  border-radius: 6px;\n  background-image: linear-gradient(\n    0.25turn,\n    var(--loader-color-1),\n    var(--loader-color-2),\n    var(--loader-color-3),\n    var(--loader-color-4),\n    var(--loader-color-5)\n  );\n  animation: ai-gradient-color-rotation 1s linear infinite alternate;\n\n  @keyframes ai-gradient-color-rotation {\n    to {\n      --loader-color-1: #1e0564b2;\n      --loader-color-2: #840db1b2;\n      --loader-color-3: #ef2789b2;\n      --loader-color-4: #f1f4ffb2;\n      --loader-color-5: #7496fcb2;\n    }\n  }\n\n  @property --loader-color-1 {\n    syntax: '<color>';\n    inherits: false;\n    initial-value: #7496fcb2;\n  }\n  @property --loader-color-2 {\n    syntax: '<color>';\n    inherits: false;\n    initial-value: #f1f4ffb2;\n  }\n  @property --loader-color-3 {\n    syntax: '<color>';\n    inherits: false;\n    initial-value: #ef2789b2;\n  }\n  @property --loader-color-4 {\n    syntax: '<color>';\n    inherits: false;\n    initial-value: #840db1b2;\n  }\n  @property --loader-color-5 {\n    syntax: '<color>';\n    inherits: false;\n    initial-value: #1e0564b2;\n  }\n}\n\n.ai-builder-anim-bg-wrapper {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(0deg, rgba(53, 19, 86, 1), rgba(43, 19, 86, 1));\n  overflow: hidden;\n  position: absolute !important;\n  z-index: 0;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n\n  &.ai-builder-anim-bg-wrapper--bright {\n    background: linear-gradient(0deg, #b735ad, #8623bd);\n  }\n}\n\n@keyframes gradientScale {\n  70% {\n    transform: scale(1.2) translate(50px);\n  }\n}\n@keyframes gradientScale2 {\n  0% {\n    transform: scale(1) translate3d(0, 30%, 0);\n  }\n  30% {\n    transform: scale(1.3) translate3d(20%, 0, 0);\n  }\n  60% {\n    transform: scale(1.1) translate3d(0, -30%, 0);\n  }\n  80% {\n    transform: scale(1.2) translate3d(-20px, -10%, 0);\n  }\n\n  100% {\n    transform: scale(1) translate3d(0, 30%, 0);\n  }\n}\n\n.ai-builder-anim-bg-btn-bright {\n  position: absolute !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n  filter: blur(20px);\n\n  span {\n    position: absolute;\n    z-index: 0;\n    border-radius: 50%;\n    animation: gradientScale 2s infinite;\n  }\n\n  span:nth-child(1) {\n    height: 90%;\n    width: 80%;\n    // background-color: #b735ad;\n    background-color: #ff00eb;\n    left: -5%;\n    top: 0;\n  }\n\n  span:nth-child(2) {\n    height: 80%;\n    width: 70%;\n    background-color: #8623bd;\n    // background-color: #8623bd;\n    left: 48%;\n    top: 8%;\n    animation-delay: 4s;\n  }\n\n  span:nth-child(3) {\n    height: 65%;\n    width: 80%;\n    // background-color: #1619b9;\n    background-color: #ac5050;\n    left: 25%;\n    top: 30%;\n    animation-delay: 0.3s;\n  }\n\n  span:nth-child(4) {\n    height: 50%;\n    width: 75%;\n    background-color: #1ba8e9;\n    left: 20%;\n    top: 20%;\n    animation-delay: 1.2s;\n  }\n}\n\n.ai-builder-anim-bg-btn {\n  position: absolute !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n  filter: blur(20px);\n\n  span {\n    position: absolute;\n    z-index: 0;\n    border-radius: 50%;\n    animation: gradientScale 2s infinite;\n  }\n\n  span:nth-child(1) {\n    height: 90%;\n    width: 80%;\n    background-color: #ff057c;\n    left: -5%;\n    top: 0;\n  }\n\n  span:nth-child(2) {\n    height: 80%;\n    width: 70%;\n    background-color: #ff057c;\n    left: 48%;\n    top: 8%;\n    animation-delay: 4s;\n  }\n\n  span:nth-child(3) {\n    height: 65%;\n    width: 80%;\n    background-color: #1619b9;\n    left: 25%;\n    top: 30%;\n    animation-delay: 0.3s;\n  }\n\n  span:nth-child(4) {\n    height: 50%;\n    width: 75%;\n    background-color: #1ba8e9;\n    left: 20%;\n    top: 20%;\n    animation-delay: 1.2s;\n  }\n}\n\n.ai-builder-anim-bg-header {\n  position: absolute !important;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n  filter: blur(20px);\n\n  span {\n    position: absolute;\n    z-index: 0;\n    border-radius: 50%;\n    animation: gradientScale2 8s infinite;\n  }\n\n  span:nth-child(1) {\n    height: 90%;\n    width: 30%;\n    background-color: #8433de;\n    left: 15%;\n    top: 0;\n  }\n\n  span:nth-child(2) {\n    height: 80%;\n    width: 50%;\n    background-color: #8a22da;\n    left: 48%;\n    top: 8%;\n    animation-delay: 4s;\n  }\n\n  span:nth-child(3) {\n    height: 65%;\n    width: 50%;\n    background-color: #ff057c;\n    left: 25%;\n    top: 30%;\n    animation-delay: 0.3s;\n  }\n\n  span:nth-child(4) {\n    height: 50%;\n    width: 50%;\n    background-color: #180b34;\n    left: 20%;\n    top: 20%;\n    animation-delay: 1.2s;\n  }\n}\n\n.ai-button-border-animation {\n  border: 2px solid transparent !important;\n  background-image: linear-gradient(white, white),\n    conic-gradient(\n      from var(--border-angle),\n      transparent,\n      transparent,\n      rgba(216, 48, 208, 0.4),\n      transparent,\n      transparent\n    ) !important;\n  background-clip: padding-box, border-box !important;\n  background-origin: padding-box, border-box !important;\n  animation: border-rotation 2s linear infinite !important;\n\n  @keyframes border-rotation {\n    from {\n      --border-angle: 0deg;\n    }\n    to {\n      --border-angle: 360deg;\n    }\n  }\n\n  @property --border-angle {\n    syntax: '<angle>';\n    inherits: false;\n    initial-value: 0deg;\n  }\n}\n\n.questionaire-card-conversational {\n  background: rgb(238, 242, 255);\n  background: linear-gradient(\n    90deg,\n    rgba(238, 242, 255, 1) 0%,\n    rgba(248, 239, 253, 1) 31%,\n    rgba(236, 241, 252, 1) 78%,\n    rgba(248, 249, 252, 1) 93%,\n    rgba(247, 238, 250, 1) 100%\n  );\n}\n\n.questionnaire-card-modified {\n  border-inline-start: 2px solid #ffa257 !important;\n}\n\n.questionnaire-card-modified-icon {\n  top: 0.4rem;\n  left: 0.4rem;\n  position: absolute;\n  font-size: 0.5rem;\n  color: #ffa257;\n}\n\n.ant-collapse-conversational {\n  .ant-collapse-content-box {\n    margin: 16px 16px 20px 0;\n  }\n  .ant-collapse-header {\n    display: flex;\n  }\n\n  .ant-collapse-header > span {\n    position: relative;\n    top: 4px;\n  }\n}\n\n.conversational-icon-wrapper {\n  position: relative;\n  width: 15px;\n  height: 15px;\n  border-radius: 4px;\n  display: inline-block;\n  background: linear-gradient(0deg, #b735ad, #8623bd);\n\n  > span {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate3d(-50%, -50%, 0);\n  }\n}\n\n.feedback-modal {\n  .ant-modal-content {\n    padding: 16px;\n    width: 370px;\n  }\n  .ant-modal-close {\n    top: 9px;\n    right: 9px;\n  }\n}\n",".hover-actions-overlay {\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 5;\n}\n\n.hover-actions-field--visible .hover-actions-overlay {\n  opacity: 1 !important;\n  pointer-events: auto;\n}\n\n// Center hover actions vertically within the answer input anchor\n.question-answer .position-relative > .hover-actions-overlay,\n.question-answer .hover-actions-input-group__input > .hover-actions-overlay {\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  right: 14px;\n}\n\n.hover-actions-input-group {\n  min-width: 0;\n  flex: 1 1 0%;\n  width: 100%;\n  align-items: stretch;\n}\n\n@hover-actions-side-action-button-width: 24px;\n@hover-actions-side-action-gap: 4px;\n\n.hover-actions-input-group__input {\n  min-width: 0;\n  flex: 1 1 0%;\n  box-sizing: border-box;\n\n  > .question-answer-input {\n    width: 100%;\n    min-width: 0 !important;\n    max-width: 100%;\n    min-height: 32px;\n    box-sizing: border-box;\n\n    > div {\n      width: 100%;\n      min-width: 0;\n    }\n\n    .formatted-editor {\n      width: 100%;\n      min-width: 0 !important;\n      max-width: 100%;\n    }\n  }\n}\n\n.hover-actions-input-group--has-side-action > .hover-actions-side-overlay {\n  flex-shrink: 0;\n  align-self: stretch;\n}\n\n.hover-actions-side-overlay {\n  opacity: 0;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  align-self: stretch;\n  width: 0;\n  min-width: 0;\n  max-width: 0;\n  margin-left: 0;\n  overflow: hidden;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.hover-actions-side-overlay--visible {\n  opacity: 1;\n  pointer-events: auto;\n  width: @hover-actions-side-action-button-width;\n  min-width: @hover-actions-side-action-button-width;\n  max-width: @hover-actions-side-action-button-width;\n  margin-left: @hover-actions-side-action-gap;\n}\n\n// Paint hover fill on the flex-1 input anchor so read-only hidden answers do\n// not shrink-wrap the highlight to their text width. The side action keeps its\n// own fill with the reserved margin-left gap between them.\n.question-answer:hover .hover-actions-input-group__input--answer-hover,\n.question-answer.hover-actions-field--visible\n  .hover-actions-input-group__input--answer-hover {\n  background-color: #f4f7fc;\n  border-radius: 4px;\n}\n\n.question-answer\n  .hover-actions-input-group__input--answer-hover\n  > .question-answer-input.background-grey-4-hover,\n.question-answer:hover\n  .hover-actions-input-group__input--answer-hover\n  > .question-answer-input.background-grey-4-hover,\n.question-answer.hover-actions-field--visible\n  .hover-actions-input-group__input--answer-hover\n  > .question-answer-input.background-grey-4-hover {\n  background-color: transparent !important;\n}\n\n.question-answer .question-answer-input.background-grey-4-hover:hover,\n.question-answer:hover\n  :not(.hover-actions-input-group__input--answer-hover)\n  > .question-answer-input.background-grey-4-hover,\n.question-answer.hover-actions-field--visible\n  :not(.hover-actions-input-group__input--answer-hover)\n  > .question-answer-input.background-grey-4-hover,\n.question-answer:hover\n  .hover-actions-side-overlay.hover-actions-side-overlay--visible,\n.question-answer.hover-actions-field--visible\n  .hover-actions-side-overlay.hover-actions-side-overlay--visible,\n.hover-actions-side-overlay.hover-actions-side-overlay--visible:hover {\n  background-color: #f4f7fc;\n}\n\n.hover-actions-side-overlay .ant-btn {\n  background: transparent !important;\n  background-color: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: transparent !important;\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  &.color-blue-6-hover:hover:not([disabled]),\n  &.color-blue-6-hover:focus:not([disabled]),\n  &.color-blue-6-hover:active:not([disabled]) {\n    color: @color-grey-10 !important;\n  }\n\n  &[disabled],\n  &[disabled]:hover,\n  &[disabled]:focus,\n  &[disabled]:active {\n    color: @color-grey-7 !important;\n    background: transparent !important;\n    background-color: transparent !important;\n  }\n\n  .icon,\n  .anticon {\n    color: inherit !important;\n  }\n}\n\n.hover-actions-side-overlay .question-answer-delete-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  width: 24px;\n  height: auto;\n  min-height: 32px;\n  padding-left: 4px;\n  padding-right: 4px;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.hover-actions-side-overlay .hover-actions-restore-icon {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n// Tooltip moves className onto a span when wrapping a disabled Button; kill the\n// child's default .ant-btn padding so width matches the enabled state.\n.hover-actions-side-overlay\n  .ant-tooltip-disabled-compatible-wrapper.question-answer-delete-btn\n  > .ant-btn {\n  padding: 0;\n  height: auto;\n  min-height: 32px;\n}\n\n.hover-actions-overlay--empty-answer {\n  right: 16px;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n}\n\n.hover-actions-overlay--prompt {\n  top: 4px;\n  right: 10px;\n}\n\n.hover-actions-field--visible .hover-actions-overlay--prompt {\n  z-index: 20;\n}\n\n.hover-actions-field--visible .question-prompt-input {\n  background-color: #f4f7fc;\n}\n\n// Spacing between enabled-setting indicators (media, visibility, exclusive, etc.)\n.question-answer-actions {\n  gap: @space-sm;\n  top: -2px;\n  position: relative;\n}\n\n// Gap between the indicator group and the dropdown trigger.\n.question-answer-dropdown-actions {\n  gap: 10px;\n}\n\n.question-answer-action-indicator-slot {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n}\n\n.qa-dropdown-menu.ant-dropdown-menu {\n  padding: 6px 0 !important;\n\n  .ant-dropdown-menu-item.full-size-link {\n    margin-left: 8px;\n    margin-right: 8px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .ant-dropdown-menu-item button.ant-btn,\n  .ant-dropdown-menu-item .ant-btn,\n  .ant-dropdown-menu-item .padding-horizontal-xxs,\n  .ant-dropdown-menu-submenu-title button.ant-btn,\n  .ant-dropdown-menu-submenu-title .ant-btn,\n  .ant-dropdown-menu-submenu-title .padding-horizontal-xxs {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  // 12px between action icon and label text\n  .margin-right-xxs {\n    margin-right: 12px !important;\n  }\n\n  .icon + .margin-left-xxs,\n  .anticon + .margin-left-xxs {\n    margin-left: 12px !important;\n  }\n\n  .dropdown-menu-grouped-actions-divider {\n    margin: 6px 0;\n  }\n\n  .ant-dropdown-menu-submenu-expand-icon {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    padding-left: 8px;\n    flex-shrink: 0;\n  }\n\n  .ant-dropdown-menu-submenu.qa-dropdown-submenu-trigger.full-size-link,\n  .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item.full-size-link {\n    margin-left: 8px;\n    margin-right: 8px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 8px;\n    padding-right: 8px;\n\n    > .ant-dropdown-menu-submenu-title,\n    > .qa-dropdown-submenu-trigger-inner {\n      display: flex;\n      align-items: center;\n      flex: 1;\n      width: 100%;\n      height: @menu-link-height;\n      min-height: @menu-link-height;\n      margin: 0;\n      padding: 0 !important;\n      background-color: transparent !important;\n      border-radius: 4px;\n      transition: none;\n\n      .ant-btn {\n        flex: 1;\n        min-width: 0;\n        width: auto;\n        height: @menu-link-height;\n        line-height: @menu-link-height;\n        pointer-events: none;\n      }\n\n      .qa-dropdown-submenu-title-content {\n        display: flex;\n        align-items: center;\n        flex: 1;\n        min-width: 0;\n        height: 100%;\n      }\n    }\n\n    &.ant-dropdown-menu-submenu-disabled > .ant-dropdown-menu-submenu-title,\n    > .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-disabled {\n      cursor: not-allowed;\n\n      &:hover {\n        background-color: transparent !important;\n      }\n\n      &:hover .ant-dropdown-menu-submenu-arrow-icon {\n        color: rgba(0, 0, 0, 0.25);\n      }\n    }\n  }\n\n  .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item {\n    // antd keeps `active` after mouseenter; only clear bg when not hovered.\n    &.ant-dropdown-menu-item-active:not(:hover) {\n      background-color: transparent !important;\n    }\n\n    &:hover:not(.ant-dropdown-menu-item-disabled) {\n      > .qa-dropdown-submenu-trigger-inner .ant-btn:not([disabled]) {\n        color: @color-blue-6;\n      }\n\n      > .qa-dropdown-submenu-trigger-inner\n        .ant-dropdown-menu-submenu-expand-icon,\n      > .qa-dropdown-submenu-trigger-inner\n        .ant-dropdown-menu-submenu-expand-icon\n        .icon {\n        color: @color-blue-6;\n      }\n    }\n\n    &.ant-dropdown-menu-item-disabled {\n      &.ant-dropdown-menu-item-active,\n      &:hover {\n        background-color: transparent !important;\n      }\n    }\n  }\n\n  &.qa-dropdown-menu--single-item {\n    .ant-dropdown-menu-item.qa-dropdown-submenu-trigger-item {\n      min-width: 168px;\n    }\n  }\n}\n\n.qa-dropdown-submenu-popup-panel {\n  .pf-ai-actions-dropdown.ant-dropdown-menu {\n    box-shadow:\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05);\n\n    // AI actions submenu: 8px between icon and text\n    .margin-right-xxs {\n      margin-right: 8px !important;\n    }\n  }\n\n  .qa-dropdown-submenu.ant-dropdown-menu {\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left: 0;\n    padding-right: 0;\n    box-shadow:\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 6px 16px 0 rgba(0, 0, 0, 0.08),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.qa-dropdown-submenu.ant-dropdown-menu-submenu-popup {\n  ul.ant-dropdown-menu {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .ant-dropdown-menu-item.full-size-link {\n    margin-left: 8px;\n    margin-right: 8px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .margin-right-xxs {\n    margin-right: 12px !important;\n  }\n}\n\n.qa-dropdown-submenu.ant-dropdown-menu-submenu {\n  ul.ant-dropdown-menu {\n    padding-top: 6px;\n    padding-bottom: 6px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .ant-dropdown-menu-item.full-size-link {\n    margin-left: 8px;\n    margin-right: 8px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .margin-right-xxs {\n    margin-right: 12px !important;\n  }\n}\n\n.matrix-cell-actions {\n  flex-shrink: 0;\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.matrix-cell-actions-row {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  margin-left: auto;\n\n  .matrix-cell-actions {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .question-answer-actions {\n    align-items: center;\n  }\n\n  > .ant-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 14px;\n    height: 20px;\n    padding: 0;\n    line-height: 1;\n  }\n}\n\n.matrix-row-actions-group {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n\n  .matrix-cell-actions {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .question-answer-actions {\n    align-items: center;\n  }\n\n  > .ant-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 14px;\n    height: 20px;\n    padding: 0;\n    line-height: 1;\n  }\n}\n\n.matrix-column-actions-group {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 2px;\n  min-width: 0;\n  padding: 0;\n  box-sizing: border-box;\n  margin-left: 7px !important;\n\n  .matrix-cell-actions {\n    padding: 0;\n  }\n\n  .question-answer-actions {\n    align-items: center;\n  }\n\n  [data-testid='dropdown-actions'] {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    min-width: 16px;\n    height: 16px;\n    line-height: 1;\n    padding: 0;\n    vertical-align: middle;\n  }\n\n  > .ant-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 14px;\n    height: 20px;\n    padding: 0;\n    line-height: 1;\n  }\n}\n\n.matrix-corner-required-toggle {\n  align-items: flex-end;\n  padding-bottom: 6px;\n  box-sizing: border-box;\n}\n\n.matrix-table-corner-header-cell {\n  vertical-align: bottom !important;\n}\n\n.question-answer-actions {\n  justify-content: flex-end;\n}\n\n.matrix-bipolar-row-actions-cell {\n  // Lock width when rc-table stretches via min-width:100%.\n  width: var(--matrix-row-actions-width, 34px) !important;\n  min-width: var(--matrix-row-actions-width, 34px) !important;\n  max-width: var(--matrix-row-actions-width, 34px) !important;\n  white-space: nowrap;\n  padding: 4px @space-xs !important;\n  border-left: 1px solid @color-grey-4;\n  overflow: visible;\n  text-align: center;\n  vertical-align: middle;\n  box-sizing: border-box;\n\n  .matrix-bipolar-row-actions-content,\n  .matrix-row-actions-group,\n  .matrix-cell-actions-row {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .ant-btn.margin-horizontal-xs {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .matrix-cell-actions {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .question-answer-actions {\n    align-items: center;\n  }\n}\n\n.matrix-bipolar-row-actions-content {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap: 2px;\n}\n\n.matrix-table-row-label-cell {\n  padding: 12px 12px 12px 6px !important;\n  box-sizing: border-box;\n}\n\n.matrix-table-column-header-cell {\n  padding: 0 !important;\n  box-sizing: border-box;\n}\n\n.matrix-column-header-content {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding-left: 12px;\n  padding-right: 7px;\n\n  > * + * {\n    margin-left: 12px;\n  }\n}\n\n// Row/body matrix cells: 12px between siblings only (cell supplies edge insets).\n.matrix-header-content,\n.matrix-table-body-cell-content {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n\n  > * + * {\n    margin-left: @space-sm;\n  }\n}\n\n.matrix-adjacent-required-toggle {\n  padding: 2px 0 0 0 !important;\n}\n\n.table-node {\n  .matrix-table-cells.ant-table-cell,\n  .ant-table-thead > tr > th.matrix-table-cells,\n  .ant-table-tbody > tr > td.matrix-table-cells {\n    border-color: @color-grey-4 !important;\n  }\n\n  .ant-table-thead > tr > th.matrix-table-column-header-cell {\n    padding: 0 !important;\n  }\n}\n\n.matrix-reorder-container {\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.matrix-reorder-container--column {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.question-answer-actions-column {\n  margin-left: @space-sm;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.drag-card.drag-type-answer {\n  .grippy.answer-grippy {\n    position: static;\n    top: auto;\n    left: auto;\n    height: auto;\n    width: 24px;\n    flex-shrink: 0;\n    transform: none;\n    margin-right: 4px;\n    transition: opacity 0.15s ease;\n    border: none;\n    background: transparent;\n    padding: 0;\n    cursor: grab;\n    opacity: 0;\n    pointer-events: none;\n\n    div {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 24px;\n      width: 24px;\n      padding: 0;\n    }\n  }\n\n  &:hover .grippy.answer-grippy:not(.cursor-disabled),\n  &:focus-within .grippy.answer-grippy:not(.cursor-disabled) {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .answer-drag-content {\n    min-width: 0;\n  }\n}\n\n.answer-grippy--hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  opacity: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.drag-card.drag-type-matrix-row {\n  .matrix-row-grippy {\n    position: static;\n    top: auto;\n    left: auto;\n    height: auto;\n    width: 24px;\n    flex-shrink: 0;\n    transform: none;\n    margin-right: 4px;\n    transition: opacity 0.15s ease;\n    border: none;\n    background: transparent;\n    padding: 0;\n    cursor: grab;\n    opacity: 0;\n    pointer-events: none;\n\n    div {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 24px;\n      width: 24px;\n      padding: 0;\n    }\n  }\n\n  &:hover .matrix-row-grippy:not(.cursor-disabled),\n  &:focus-within .matrix-row-grippy:not(.cursor-disabled) {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .matrix-option-drag-content {\n    min-width: 0;\n  }\n}\n\n.drag-card.drag-type-matrix-column {\n  .matrix-column-grippy {\n    position: static;\n    top: auto;\n    left: auto;\n    height: auto;\n    width: 24px;\n    flex-shrink: 0;\n    transform: none;\n    margin-bottom: 4px;\n    transition: opacity 0.15s ease;\n    border: none;\n    background: transparent;\n    padding: 0;\n    cursor: grab;\n    opacity: 0;\n    pointer-events: none;\n\n    div {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 24px;\n      width: 24px;\n      padding: 0;\n      transform: rotate(90deg);\n    }\n  }\n\n  &:hover .matrix-column-grippy:not(.cursor-disabled),\n  &:focus-within .matrix-column-grippy:not(.cursor-disabled) {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .matrix-option-drag-content {\n    min-width: 0;\n    max-width: 100%;\n  }\n}\n\n.drag-card {\n  &.drag-guide-left,\n  &.drag-guide-right {\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      width: 2px;\n      background: @color-grey-10;\n      // Stay inside the cell so sticky left/right columns cannot cover the line\n      // when the table fits without horizontal overflow.\n      z-index: 1;\n      pointer-events: none;\n    }\n  }\n\n  &.drag-guide-left:after {\n    left: 0;\n  }\n\n  &.drag-guide-right:after {\n    right: 0;\n  }\n}\n","@shadow-color-1-5: rgb(238, 243, 247);\n@shadow-color-6-10: rgba(92, 103, 118, 0.2);\n@shadow-color-light: rgba(200, 212, 216, 0.2);\n\n@shadow-size-bottom-1: 0px 2px 4px 0px;\n@shadow-size-bottom-2: 0px 4px 8px 0px;\n@shadow-size-bottom-3: 0px 8px 12px 0px;\n@shadow-size-bottom-4: 0px 12px 16px 0px;\n@shadow-size-bottom-5: 0px 16px 24px 0px;\n\n@shadow-size-right-1: 2px 0px 4px 0px;\n@shadow-size-right-2: 4px 0px 8px 0px;\n@shadow-size-right-3: 8px 0px 12px 0px;\n@shadow-size-right-4: 12px 0px 16px 0px;\n@shadow-size-right-5: 16px 0px 24px 0px;\n\n.generateShadowLevels(@color, @count, @suffix:~'') when (@count > 0) {\n  @right: 'shadow-size-right-@{count}';\n  @bottom: 'shadow-size-bottom-@{count}';\n  @size-right: @@right;\n  @size-bottom: @@bottom;\n\n  &-right-level-@{count}@{suffix} {\n    box-shadow: @size-right @color;\n  }\n  &-level-@{count}@{suffix} {\n    box-shadow: @size-bottom @color;\n  }\n\n  .generateShadowLevels(@color, @count - 1, @suffix);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
